webpackJsonp([1],{

/***/ "+BiP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__ = __webpack_require__("diQi");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("vaPR");
function injectStyle (ssrContext) {
  __webpack_require__("aAJt")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_streetViewPanoramaImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_5f5650e6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0hj2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "42S1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "4Teq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__ = __webpack_require__("kXiA");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("0hj2");
function injectStyle (ssrContext) {
  __webpack_require__("EbSk")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_mapImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_fb581256_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__ = __webpack_require__("Vj7G");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("Nk69");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_infoWindowImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_b1ade17a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6R3c":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "6uOo":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7bqf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7zck":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "985/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "9B1n":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "BdYg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "CyYx":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DLXV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EbSk":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Em0s":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EuQE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "H7H4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ILYb":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Jjvt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KLnE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LLJJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/vue/dist/vue.esm.js
var vue_esm = __webpack_require__("7+uW");

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.js
var vuetify = __webpack_require__("3EgV");
var vuetify_default = /*#__PURE__*/__webpack_require__.n(vuetify);

// EXTERNAL MODULE: ./node_modules/vuetify/dist/vuetify.min.css
var vuetify_min = __webpack_require__("7zck");
var vuetify_min_default = /*#__PURE__*/__webpack_require__.n(vuetify_min);

// EXTERNAL MODULE: ./node_modules/vuebar/vuebar.js
var vuebar = __webpack_require__("CoJ8");
var vuebar_default = /*#__PURE__*/__webpack_require__.n(vuebar);

// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__("M4fF");
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);

// EXTERNAL MODULE: ./node_modules/vue-i18n/dist/vue-i18n.esm.js
var vue_i18n_esm = __webpack_require__("TXmL");

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__("PJh5");
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/promise.js
var promise = __webpack_require__("//Fk");
var promise_default = /*#__PURE__*/__webpack_require__.n(promise);

// EXTERNAL MODULE: ./node_modules/vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("NYxO");

// EXTERNAL MODULE: ./node_modules/vue-router/dist/vue-router.esm.js
var vue_router_esm = __webpack_require__("/ocq");

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/math/sign.js
var sign = __webpack_require__("2QDH");
var sign_default = /*#__PURE__*/__webpack_require__.n(sign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/math/trunc.js
var trunc = __webpack_require__("INCx");
var trunc_default = /*#__PURE__*/__webpack_require__.n(trunc);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/json/stringify.js
var stringify = __webpack_require__("mvHQ");
var stringify_default = /*#__PURE__*/__webpack_require__.n(stringify);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/extends.js
var helpers_extends = __webpack_require__("Dd8w");
var extends_default = /*#__PURE__*/__webpack_require__.n(helpers_extends);

// EXTERNAL MODULE: ./node_modules/push.js/bin/push.min.js
var push_min = __webpack_require__("Q+y4");
var push_min_default = /*#__PURE__*/__webpack_require__.n(push_min);

// EXTERNAL MODULE: ./node_modules/vue-socket.io/dist/build.js
var build = __webpack_require__("hMcO");
var build_default = /*#__PURE__*/__webpack_require__.n(build);

// EXTERNAL MODULE: ./node_modules/socket.io-client/lib/index.js
var lib = __webpack_require__("DmT9");
var lib_default = /*#__PURE__*/__webpack_require__.n(lib);

// EXTERNAL MODULE: ./node_modules/axios/index.js
var axios = __webpack_require__("mtWM");
var axios_default = /*#__PURE__*/__webpack_require__.n(axios);

// CONCATENATED MODULE: ./src/components/watcheebox/watcheebox.js






var watcheebox = {
  vue: new vue_esm["default"](),

  connexionAgent: function connexionAgent(data) {
    var datasAgent = lodash_default.a.cloneDeep(data.datasAgent);
    var phpSession = data.sessionPHP.slice(0, 10);
    datasAgent.licAllKeys = datasAgent.licAllKeys.join('|');

    if (!datasAgent.status) {
      datasAgent.status = 'online';
    }
    new vue_esm["default"]().$socket.emit('addAgent', {
      'roomName': datasAgent.entKey,
      'agentConversation': 0,
      'agentEtat': datasAgent.status,
      'agentConnexionMobile': 0,
      'agentDevice': 0,
      'agentName': data.agentName,
      'agentID': datasAgent.id,
      'geteLang': datasAgent.licLang,
      'agentJob': datasAgent.job,
      'agentAvatar': datasAgent.avatar,
      'WZAgentId': datasAgent.id,
      'entrepriseId': datasAgent.entId,
      'listLicKeysForThisAgent': datasAgent.licAllKeys,
      'listOpened': '',
      'tokenFB': datasAgent.facebookToken,
      'nameAppFB': datasAgent.facebookPage,
      'priority': datasAgent.priority,
      'keywords': datasAgent.keywords,
      'user_sites': datasAgent.user_sites,
      'sessionPHP': phpSession,
      'sid': data.sid,
      'keyWebPush': JSON.parse(data.keyWebPush),
      'subscriptionWebPush': JSON.parse(data.subscriptionWebPush)
    });
  },

  firstLoadHistoChat: function firstLoadHistoChat(data) {
    var histoChat = void 0;
    return new promise_default.a(function (resolve, reject) {
      axios_default.a.get('get/histoChat.php?entrepriseID=' + data.entrepriseId + '&chatSession=' + data.chatSession + '&chatMax=30').then(function (response) {
        if (!lodash_default.a.isNil(response.data) && lodash_default.a.isArray(response.data)) {
          histoChat = response.data.reverse();

          var optionsDate = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
          var premiereDate = new Date();
          if (histoChat.length !== 0) {
            premiereDate = new Date(histoChat[0].timestamp * 1000);
          }
          var dateReference = premiereDate.toLocaleDateString(translation.locale, optionsDate);

          if (histoChat.length > 0) {
            var firstDate = {
              'dateMessage': true,
              'visitorId': histoChat[0].visitorId,
              'timeStamp': dateReference,
              'indexMessage': 0
            };
            histoChat.splice(0, 0, firstDate);
          }
          for (var i = 0; i < histoChat.length; i++) {
            if (histoChat[i].type === '1') {
              var dateNow = new Date(histoChat[i].timestamp * 1000);
              if (dateReference !== dateNow.toLocaleDateString(translation.locale, optionsDate)) {
                dateReference = dateNow.toLocaleDateString(translation.locale, optionsDate);
                var newDate = {
                  'dateMessage': true,
                  'dateId': histoChat[i].visitorId + '_' + i,
                  'timeStamp': dateReference,
                  'indexMessage': i
                };
                histoChat.splice(i, 0, newDate);
              }
            }
          }
          resolve(histoChat);
        }
        resolve([]);
      }).catch(function (e) {
        reject(e);
      });
    });
  },

  forceOuvertureModule: function forceOuvertureModule(data) {
    if (data.datasVisiteur.socketID !== '0') {
      new vue_esm["default"]().$socket.emit('forceAppear', {
        'auteur': 'Agent',
        'nameAuteur': data.agentName,
        'agentSocketID': data.agentSocketID,
        'clientSocketID': data.datasVisiteur.socketID,
        'chatSession': data.datasVisiteur.visiteurID,
        'WZAgentId': data.datasAgent.id,
        'siteId': data.datasVisiteur.siteID,
        'entrepriseId': data.datasAgent.entId
      });
    }
  },

  envoisFacebook: function envoisFacebook(data) {
    new vue_esm["default"]().$socket.emit('sendChatMessenger', {
      'auteur': 'Agent',
      'nameAuteur': data.agentName,
      'message': data.message,
      'attachments': data.attachments,
      'clientMessengerID': data.datasVisiteur.visiteurID,
      'chatSession': data.datasVisiteur.visiteurID,
      'WZAgentId': data.datasAgent.id,
      'messageType': data.messageType,
      'nameVisiteur': data.datasVisiteur.nameVisiteur,
      'tokenMessenger': data.datasAgent.facebookToken
    });
  },

  saveDataWebPush: function saveDataWebPush(data) {
    new vue_esm["default"]().$socket.emit('saveTokenWebPush', data);
  },

  sendWebPush: function sendWebPush(data) {
    new vue_esm["default"]().$socket.emit('sendWebPush', data);
  },

  envoisMessage: function envoisMessage(data) {
    if (data.datasVisiteur.socketID) {
      new vue_esm["default"]().$socket.emit('stop-typing-targetFirst', {
        'auteur': 'Agent',
        'nameAuteur': data.agentName,
        'senderSocketID': data.agentSocketID,
        'cibleSocketID': data.datasVisiteur.socketID,
        'etat': 0
      });

      new vue_esm["default"]().$socket.emit('sendChat-targetFirst', {
        'auteur': 'Agent',
        'nameAuteur': data.agentName,
        'message': data.message,
        'attachments': data.attachments,
        'agentSocketID': data.agentSocketID,
        'clientSocketID': data.datasVisiteur.socketID,
        'chatSession': data.datasVisiteur.visiteurID,
        'WZAgentId': data.datasAgent.id,
        'messageType': data.messageType,
        'siteId': data.datasVisiteur.siteID,
        'entrepriseId': data.datasAgent.entId,
        'filterId': data.filterId,
        'nameVisiteur': data.datasVisiteur.visiteurID });
    } else {
      if (data.messageType === 1) {
        new vue_esm["default"]().$socket.emit('sendChat-targetFirst', {
          'auteur': 'Agent',
          'nameAuteur': data.agentName,
          'message': data.message,
          'attachments': data.attachments,
          'agentSocketID': data.agentSocketID,
          'clientSocketID': data.datasVisiteur.socketID,
          'chatSession': data.datasVisiteur.visiteurID,
          'WZAgentId': data.datasAgent.id,
          'messageType': data.messageType,
          'siteId': data.datasVisiteur.siteID,
          'entrepriseId': data.datasAgent.entId,
          'filterId': data.filterId,
          'nameVisiteur': data.datasVisiteur.visiteurID,
          'lu': '0'
        });
      }
    }
  },

  startIsTyping: function startIsTyping(data) {
    new vue_esm["default"]().$socket.emit('start-typing-targetFirst', {
      'auteur': 'Agent',
      'nameAuteur': data.agentName,
      'senderSocketID': data.agentSocketID,
      'cibleSocketID': data.datasVisiteur.socketID,
      'WZAgentId': data.datasAgent.id,
      'chatSession': data.datasVisiteur.visiteurID,
      'etat': 1
    });
  },

  stopIsTyping: function stopIsTyping(data) {
    new vue_esm["default"]().$socket.emit('stop-typing-targetFirst', {
      'auteur': 'Agent',
      'nameAuteur': data.agentName,
      'senderSocketID': data.agentSocketID,
      'cibleSocketID': data.datasVisiteur.socketID,
      'WZAgentId': data.datasAgent.id,
      'chatSession': data.datasVisiteur.visiteurID,
      'etat': 0
    });
  },

  sendFormSatisfaction: function sendFormSatisfaction(data) {
    new vue_esm["default"]().$socket.emit('sendFormSatisfaction', {
      'auteur': 'Agent',
      'nameAuteur': data.agentName,
      'message': 'Would you like to evaluate our performance? ',
      'agentSocketID': data.agentSocketID,
      'clientSocketID': data.datasVisiteur.socketID,
      'chatSession': data.datasVisiteur.visiteurID,
      'WZAgentId': data.datasAgent.id,
      'messageType': data.messageType,
      'siteId': data.datasVisiteur.siteID,
      'entrepriseId': data.datasAgent.entId
    });
  },

  SendTransfertVisitor: function SendTransfertVisitor(data) {
    var agentSelect;
    for (var a = 0; a < data.agentsArray.length; a++) {
      if (data.agentsArray[a][2] === data.selectedAgent.id) {
        agentSelect = data.agentsArray[a];
      }
    }
    var msg = data.agentSenderName + ' vous propose de prendre en charge ce visiteur (' + data.datasSelectedVisiteur.visiteurID + ') ?';
    this.transfertDatasVisitor({
      'socket': data.socket,
      'agentSocketID': agentSelect[4],
      'datasAgent': agentSelect,
      'datasVisiteur': data.datasSelectedVisiteur,
      'message': msg,
      'messageType': 1,
      'senderSocketID': data.mySocketID,
      'senderAgentID': data.myAgentID,
      'automatique': data.automatique
    });
  },

  transfertDatasVisitor: function transfertDatasVisitor(data) {
    new vue_esm["default"]().$socket.emit('transfertVisitor', {
      'auteur': 'Agent',
      'agentName': data.datasAgent[1],
      'msg': data.message,
      'destAgentSocket': data.agentSocketID,
      'clientSocketID': data.senderSocketID,
      'senderID': data.senderAgentID,
      'chatSession': data.datasVisiteur.visiteurID,
      'WZAgentId': data.datasAgent[2],
      'messageType': data.messageType,
      'siteId': data.datasVisiteur.siteID,
      'visKey': data.datasVisiteur.visiteurKey,
      'entrepriseId': data.datasAgent[10],
      'automatique': data.automatique
    });
  },

  rejetTransfert: function rejetTransfert(data) {
    new vue_esm["default"]().$socket.emit('transfertVisitorRefuse', {
      'WZAgentId': data.datasTransfere.WZAgentId,
      'agentSocket': data.datasTransfere.clientSocketID,
      'destAgentSocket': data.datasTransfere.destAgentSocket,
      'chatSession': data.datasTransfere.chatSession
    });
  },

  acceptTransfert: function acceptTransfert(data) {
    new vue_esm["default"]().$socket.emit('transfertVisitorAccept', {
      'WZAgentId': data.datasTransfere.WZAgentId,
      'agentSocket': data.datasTransfere.clientSocketID,
      'destAgentSocket': data.datasTransfere.destAgentSocket,
      'chatSession': data.datasTransfere.chatSession
    });
  },

  AnnulTransfertVisitor: function AnnulTransfertVisitor(data) {
    var msg = data.agentSenderName + ' a annulé la prise en charge du visiteur';
    new vue_esm["default"]().$socket.emit('transfertVisitorAnnuler', {
      'senderAgentSocket': data.mySocketID,
      'agentSocket': data.selectedAgent.socketID,
      'message': msg
    });
  },

  changeStatusAgent: function changeStatusAgent(data) {
    new vue_esm["default"]().$socket.emit('changeStatutAgent', {
      'roomName': data.roomName,
      'idAgent': data.agentID,
      'statut': data.statut,
      'listOpened': data.sessionsPrivees
    });
  },

  changeFocusAgent: function changeFocusAgent(data) {
    new vue_esm["default"]().$socket.emit('focus-agent', {
      'roomName': data.datasAgent.entKey,
      'agentID': data.datasAgent.id,
      'focusAgent': data.focusAgent,
      'focusSessionID': data.focusSessionID
    });
  },

  clientRetourRoom: function clientRetourRoom(data) {
    var phpSession = data.sessionPHP.slice(0, 10);
    new vue_esm["default"]().$socket.emit('rejoinRoom', {
      'roomName': data.datasAgent.entKey,
      'agentID': data.datasAgent.id,
      'sessionPHP': phpSession
    });
  },

  clientConnectRoom: function clientConnectRoom(data) {
    new vue_esm["default"]().$socket.emit('connectRoom', {
      'roomName': data.roomName
    });
  },

  clientQuitRoom: function clientQuitRoom(data) {
    new vue_esm["default"]().$socket.emit('quitRoom', {
      'roomName': data.roomName
    });
  },

  deconnexionSession: function deconnexionSession(data) {
    new vue_esm["default"]().$socket.emit('logoutAgent', {
      'agentID': data.datasAgent.id
    });
  },

  deconnexionClient: function deconnexionClient(data) {
    new vue_esm["default"]().$socket.emit('DeconnexionClient', {
      'roomName': data.datasAgent.entKey
    });
  },

  debloqueSession: function debloqueSession(data) {
    new vue_esm["default"]().$socket.emit('DebloqueMultisession', {
      'roomName': data.datasAgent.entKey,
      'agentID': data.datasAgent.id
    });
  },

  totalConversations: function totalConversations(data) {
    new vue_esm["default"]().$socket.emit('total-conversation', {
      'roomName': data.datasAgent.entKey,
      'agentID': data.datasAgent.id,
      'agentSocketID': data.agentSocketID,
      'statut': data.status,
      'chatSession': data.arrayVisiteur.visiteurID,
      'sessionsPrivees': data.sessionsPrivees
    });
  },

  updateSessionsChats: function updateSessionsChats(data) {
    new vue_esm["default"]().$socket.emit('update-sessionsChats', {
      'roomName': data.datasAgent.entKey,
      'agentID': data.datasAgent.id,
      'sessionsPrivees': data.sessionsPrivees
    });
  },

  receptionMessage: function receptionMessage(data) {
    new vue_esm["default"]().$socket.emit('accuseReceptionMessage', {
      'visiteurID': data.datasVisiteur.visiteurID,
      'siteID': data.siteID,
      'agentID': data.datasAgent.id,
      'agentSocketID': data.agentSocketID,
      'clientSocketID': data.datasVisiteur.socketID,
      'ARType': data.ARType,
      'messageID': data.messageID
    });
  },

  compteElementChat: function compteElementChat(parentWatchBoxMessage) {
    var data = 0;
    if (parentWatchBoxMessage) {
      var nbElement = parentWatchBoxMessage.childNodes[0].childNodes[1];

      var numChild = nbElement.childNodes.length;
      var dateVis;
      for (var a = 0; a < nbElement.childNodes.length; a++) {
        if (nbElement.childNodes[a].classList.contains('WZ-MessageAuto') || nbElement.childNodes[a].classList.contains('dates-messages_BO') || nbElement.childNodes[a].classList.contains('dates-messages-2') || nbElement.childNodes[a].classList.contains('dates-marqueur') || nbElement.childNodes[a].classList.contains('statusMessageVisiteur')) {
          numChild--;
        }
        if (nbElement.childNodes[a].classList.contains('bulle_Visiteur_BO')) {
          if (nbElement.childNodes[a].childNodes[0].children[1].getAttribute('data-timestamp')) {
            dateVis = nbElement.childNodes[a].childNodes[0].children[1].getAttribute('data-timestamp');
          }
        }
      }

      data = { 'numChild': numChild, 'dateMessage': dateVis };
      return data;
    } else {
      return data;
    }
  },

  demandeGeoloc: function demandeGeoloc(data) {
    new vue_esm["default"]().$socket.emit('askGeoloc', {
      'clientSocketID': data.datasVisiteur.socketID,
      'visiteurID': data.datasVisiteur.visiteurID,
      'agentSocketID': data.mySocketID
    });
  },

  AgentStatut: function AgentStatut(data) {},
  AgentLogout: function AgentLogout(data) {}
};

/* harmony default export */ var watcheebox_watcheebox = (watcheebox);
// CONCATENATED MODULE: ./src/constants.js

var NO_PEONS = ['agent', 'admin', 'super', 'adminTF'];
var NO_AGENTS = ['admin', 'super', 'adminTF'];
var NO_ADMINS = ['peon', 'agent', 'super', 'adminTF'];
var NO_PEONS_NOR_AGENTS = ['admin', 'super', 'adminTF'];
var LEVEL = {
  HS: 0,
  ESSAI: 1,
  CHAT: 10,
  START: 5,
  PRO: 6,
  ENTREPRISE: 7
};

var AWSS3_STATIC = 'https://s3-eu-west-1.amazonaws.com/targetfirst';
var AWSS3_PUBLIC = 'https://s3-eu-west-1.amazonaws.com/box-targetfirst';
var constants_DOMAINE = window.location.origin;
var HOTESSES_DIR = constants_DOMAINE + ( true ? '/' : '/dev/') + 'fo/img/hotesses/';
var RECALL_DIR = constants_DOMAINE + ( true ? '/' : '/dev/') + 'fo/img/icones/';

var FORM_LAYOUT = [{ show: true, title: 'currentPage', icon: 'http' }, { show: true, title: 'lastLoadingDate', icon: 'history' }, { show: true, title: 'autochatTitle', icon: 'beenhere' }, { show: true, title: 'comment', icon: 'comment' }, { show: true, title: 'identity', icon: 'perm_identity' }, { show: true, title: 'email', icon: 'mail' }, { show: true, title: 'phone', icon: 'phone' }, { show: true, title: 'location', icon: 'room' }, { show: true, title: 'browser', icon: 'devices' }, { show: true, title: 'language', icon: 'language' }, { show: true, title: 'IP', icon: 'device_hub' }, { show: true, title: 'leadHeat', icon: 'whatshot' }, { show: true, title: 'alertCart', icon: 'add_shopping_cart' }, { show: true, title: 'lastInvitAuto', icon: 'local_offer' }, { show: true, title: 'beginningChat', icon: 'textsms' }, { show: true, title: 'navigationHistory', icon: 'list' }, { show: true, title: 'purchases', icon: 'shopping_cart' }, { show: true, title: 'lastKnownBasket', icon: 'credit_card' }, { show: true, title: 'motif', icon: 'contact_support' }];

var MOTIFS_ORPI = [{ text: 'A. Infos biens', value: 'A' }, { text: 'B. LEAD - RDV Tel (1 agence)', value: 'B' }, { text: 'C. LEAD - RDV Tel (2 agence)', value: 'C' }, { text: 'D. LEAD - Mail (1 agence)', value: 'D' }, { text: 'E. LEAD - Mail (2 agence)', value: 'E' }, { text: 'F. LEAD - Visite (1 agence)', value: 'F' }, { text: 'G. LEAD - Visite (2 agence)', value: 'G' }, { text: 'H. LEAD - Projet de vente (1 agence)', value: 'H' }, { text: 'I. LEAD - Projet de vente (2 agence)', value: 'I' }, { text: 'J. LEAD - Projet de vente et RDV Tel', value: 'J' }, { text: 'K. LEAD - Projet de vente et Visite', value: 'K' }, { text: 'L. LEAD AUTRE (Mandat en cours, Syndic, Gestion locative...SA...', value: 'L' }, { text: 'M. LEAD KO - Mail non renseigné', value: 'M' }, { text: 'N. Réclamation', value: 'N' }, { text: 'O. Dysfonctionnement site/outils', value: 'O' }, { text: 'P. Autres (A UTILISER EXCEPTIONNELLEMENT)', value: 'P' }];

var MOTIFS_NUXE = [{ text: 'Informations produits', value: '2' }, { text: 'Diagnostic', value: '128' }, { text: 'Informations soins SPA', value: '172' }, { text: 'Aide à la commande SPA', value: '50' }, { text: 'Informations Offres commerciales', value: '33' }, { text: 'Informations Livraison', value: '32' }, { text: 'Aide à la commande e commerce produits', value: '4' }, { text: 'Suivi de commande e commerce', value: '31' }, { text: 'Réclamations E commerce', value: '36' }, { text: 'Informations Programme de fidélité', value: '6' }, { text: 'Réclamations Programme de fidélité', value: '29' }, { text: 'Demande d\'échantillons', value: '9' }, { text: 'Autres', value: '8' }];
var MOTIFS_INOYA = [{ text: 'Informations sur la marque et les produits', value: '1' }, { text: 'Informations Commandes', value: '2' }, { text: 'Demande d\'échantillons', value: '3' }, { text: 'Programme Fidélité', value: '4' }, { text: 'Réclamations', value: '5' }, { text: 'Demandes Marketing', value: '6' }, { text: 'Demandes RH', value: '7' }, { text: 'Ou trouver vos produits', value: '8' }, { text: 'Suivi de ma commande', value: '14' }, { text: 'Convertir Points Oya', value: '22' }, { text: 'Efficacité du protocole de soins', value: '28' }, { text: 'Partenariat Blog ou Réseaux Sociaux', value: '34' }, { text: 'Protocole de soins', value: '10' }, { text: 'Difficulté à passer ma commande', value: '15' }, { text: 'Envoi récompense carte de fidélité', value: '23' }, { text: 'Problèmes sur mon colis commandé', value: '33' }, { text: 'Demande de distribution commerciale', value: '35' }, { text: 'Questions sur les prix', value: '11' }, { text: 'Délais de livraison', value: '16' }, { text: 'Demande de carte de fidélité', value: '24' }, { text: 'Réclamations Aspect, texture et odeur', value: '29' }, { text: 'Jeux concours', value: '36' }, { text: 'Composition et Conservation des Produits', value: '12' }, { text: 'Fidélité Mixte : Points OYA et Carte de fidélité', value: '26' }, { text: 'Réaction allergique', value: '30' }, { text: 'Sollicitations Commerciales Extérieures', value: '37' }, { text: 'Conseils sur des produits non vendus par IN\'OYA', value: '13' }, { text: 'Informations Paiement', value: '21' }, { text: 'Suggestions et Axes d\'amélioration', value: '27' }, { text: 'Demande de remboursement', value: '31' }, { text: 'Distributeurs IN\'OYA', value: '38' }, { text: 'Codes Promo et Avantages particuliers', value: '25' }, { text: 'Désinscription Bases de données IN\'OYA', value: '32' }, { text: 'Changement statut commande dans le Back Office', value: '39' }];

var PERIODS = [1, 2, 3, 4];
var PERIODS_START = [1, 2];
var PERIODS_PRO = [1, 2, 3];
var PERIODS_ENTREPRISE = [1, 2, 3, 4];
// EXTERNAL MODULE: ./node_modules/html2canvas/dist/npm/index.js
var npm = __webpack_require__("2Pnh");
var npm_default = /*#__PURE__*/__webpack_require__.n(npm);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Dash.vue

















/* harmony default export */ var Dash = ({
  data: function data() {
    return {
      messageBug: '',
      sendingReport: false,
      delaiExpireCB: '',
      expireCB: false,
      cbExpirebientot: false,
      activeDialogCB: false,

      drawer: true,

      helper: false,

      showSatisfactionAgent: false,

      mini: true,
      intervalCheckFocus: null,
      idInterval: null,
      dialogTransfere: false,
      dialogReconnexion: false,
      dialogMultiConnexion: false,
      dialogBugScreenshot: false,
      dialogVisiteurOffline: false,
      visiteurChangePage: false,

      dialogTooMuchAgents: false,
      countdown: 30,
      intervalTooMuchAgents: null,
      renouvellementDay: null,

      dialogScript: false,
      isChecking: false,
      activeDialogPagesVues: false,
      fullQuotaPagesVues: false,
      quotaPages: 0,
      memoDialogQuota: '0',
      memoDialogC2C: '0',
      memoDialogExpireCB: '0',
      expireLicence: false,
      sursisLicence: false,
      LicenceOUT: false,
      usrBoNotif: '0',
      activeDialogc2c: false,
      depassementF: 0,
      depassementM: 0,
      C2CoffF: false,
      C2CnearF: false,
      C2CoffM: false,
      C2CnearM: false,
      c2cAverageF: 0,
      c2cAverageM: 0,
      resteEstimedF: 0,
      resteEstimedM: 0,
      visiteurSelectedTransfere: [],
      datasTransfere: {},
      navStatus: true,
      navConnexion: true,
      btConnexion: false,
      addVisiteur: false,

      audioOffline: document.createElement('audio'),
      audios: [{ src_mp3: AWSS3_STATIC + '/sounds/offline.mp3' }, { src_mp3: AWSS3_STATIC + '/sounds/ouverture1.mp3' }],
      imageUrl: '',
      mySocket_ID: 0,
      dateOptions: { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' },
      dateExpire: '',
      dateExpireLicence: '',
      installProgress: false,
      progress: this.$store.state._User.installProgress
    };
  },


  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])('_StoreWatcheeBox', ['SOCKET_DISCONNECT_CLIENT', 'SET_STATUS', 'SET_STATUS_MANUALLY', 'SET_TOO_MUCH_AGENTS_CHECKED', 'CHANGE_VIEW_PUPITRE']), Object(vuex_esm["d" /* mapMutations */])(['SET_REASON_UNLOAD', 'SET_REASON_DECO']), {
    bugReport: function bugReport() {
      this.dialogBugScreenshot = true;
      this.takeScreenshot();
    },
    logout: function logout() {
      var _this = this;

      this.axios.post('post/logout.php').then(function (response) {
        _this.$store.dispatch('logout', _this.$socket);
      }).catch();
    },
    reconnexionAgent: function reconnexionAgent() {
      watcheebox_watcheebox.deconnexionSession({
        datasAgent: this.user
      });
    },
    debloqueMultiSession: function debloqueMultiSession() {
      watcheebox_watcheebox.debloqueSession({
        datasAgent: this.user
      });
    },
    isLeapYear: function isLeapYear(year) {
      return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    },
    getDaysInMonth: function getDaysInMonth(year, month) {
      return [31, this.isLeapYear(year) ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31][month];
    },
    addMonths: function addMonths(value, jour) {
      var n = new Date();

      if (jour > 28) {
        n.setDate(Math.min(jour, this.getDaysInMonth(n.getFullYear(), n.getMonth())));
      } else {
        n.setDate(Math.min(jour, this.getDaysInMonth(n.getFullYear(), n.getMonth())));
        if (value) {
          n.setMonth(n.getMonth() + value);
        }
      }

      return n;
    },
    diffDate: function diffDate(d1, d2) {
      var WNbJours = d2.getTime() - d1.getTime();
      return Math.ceil(WNbJours / (1000 * 60 * 60 * 24));
    },
    rechargePages: function rechargePages() {
      this.activeDialogPagesVues = false;
      this.activeDialogc2c = false;
      this.activeDialogCB = false;
    },
    checkRefFacturation: function checkRefFacturation(data) {
      var url = void 0;

      if (this.$store.state._User.entRefFacturation) {
        if (this.$store.state._User.entRefFacturation === this.$store.state._User.mail) {
          url = 'https://admin.targetfirst.com/subscription/subscriptions_fr.php';
        } else {
          if (data.type === 'quotaPages') {
            url = 'https://support.targetfirst.com/2019/10/25/comment-souscrire-a-100-000-pages-trackees-supplementaires/';
          } else if (data.type === 'quotaC2C') {
            url = 'https://support.targetfirst.com/2019/10/25/comment-souscrire-a-un-credit-dheures-de-call-back-supplementaire/';
          } else if (data.type === 'expireCB') {
            url = 'https://support.targetfirst.com/2019/10/25/comment-mettre-a-jour-mes-coordonnees-de-carte-bancaire/';
          } else if (data.type === 'expireLicence') {
            url = 'https://support.targetfirst.com/2019/10/23/comment-renouveler-ma-licence/';
          } else if (data.type === 'expireCB') {
            url = 'https://support.targetfirst.com/2019/10/25/comment-mettre-a-jour-mes-coordonnees-de-carte-bancaire/';
          }
        }
      } else {
        url = 'https://support.targetfirst.com/2019/10/25/comment-creer-editer-mon-compte-de-facturation/';
      }
      return url;
    },
    souscrire: function souscrire() {
      this.activeDialogPagesVues = false;
      window.open(this.checkRefFacturation({ 'type': 'quotaPages' }), 'souscription');
    },
    continuer: function continuer() {
      this.activeDialogPagesVues = false;

      this.SET_REASON_UNLOAD('L\'agent a vue le message d\'alert Quota et a fermer la fenetre');

      this.$cookie.set('memoDialogQuota', '1', { expires: '10h' });
    },
    souscrireC2C: function souscrireC2C() {
      this.activeDialogc2c = false;
      window.open(this.checkRefFacturation({ 'type': 'quotaC2C' }), 'souscription');
    },
    continuerC2C: function continuerC2C() {
      this.activeDialogc2c = false;
      this.SET_REASON_UNLOAD('L\'agent a vue le message d\'alert Click to Call');

      this.$cookie.set('memoDialogC2C', '1', { expires: '10h' });
    },
    majCB: function majCB() {
      this.activeDialogCB = false;
      window.open(this.checkRefFacturation({ 'type': 'expireCB' }), 'souscription');
    },
    continuerExpireCB: function continuerExpireCB() {
      this.activeDialogCB = false;
      this.SET_REASON_UNLOAD('L\'agent a vue le message d\'alert de l\'expiration de la carte de crédit');

      this.$cookie.set('memoDialogExpireCB', '1', { expires: '10h' });
    },
    checkScript: function checkScript() {
      var _this2 = this;

      this.isChecking = true;
      this.axios.get('get/check_script.php?key=' + this.$store.state._User.entKey).then(function (res) {
        _this2.dialogScript = false;
        _this2.$store.commit('_User/setEntNbPageTotal', 1);
        _this2.reconnexionBO('Ligne de script pas installée');
      }).catch(function () {
        _this2.SET_STATUS('offline');
      }).then(function () {
        _this2.isChecking = false;
      });
    },
    initSounds: function initSounds() {
      this.audioOffline.setAttribute('src', this.audios[0].src_mp3);
      this.audioOffline.load();
    },
    isOnline: function isOnline() {
      this.btConnexion = true;

      if (this.navConnexion) {}
    },
    isOffline: function isOffline() {
      var _this3 = this;

      this.navStatus = false;
      this.btConnexion = false;

      setTimeout(function () {
        window.addEventListener('online', _this3.isOnline, false);
        if (!_this3.navStatus) {
          _this3.navConnexion = false;

          _this3.dialogReconnexion = true;
        }
      }, 10000);
    },
    reconnexionBO: function reconnexionBO(reason) {
      this.SET_REASON_UNLOAD('Dash: ' + reason);
      window.location.reload();
    },
    toggleMini: function toggleMini() {
      this.mini = !this.mini;
      this.$cookie.set('wz-mini', this.mini, { expires: '1Y' });
    },
    checkFocus: function checkFocus() {
      if (this.mySocketID && this.$socket) {
        if (document.hasFocus() === window.lastFocusStatus) return;
        window.lastFocusStatus = !window.lastFocusStatus;
        watcheebox_watcheebox.changeFocusAgent({
          datasAgent: this.user,
          focusSessionID: this.WATCHEEBOX_STATE.focusPupitre.focusSessionID,
          focusAgent: window.lastFocusStatus
        });
        this.$store.commit('_StoreWatcheeBox/AGENT_FOCUS', {
          myFocus: window.lastFocusStatus
        });
      }
    },
    connectAgent: function connectAgent(data) {
      if (!this.$socket.connected) {
        var user = lodash_default.a.cloneDeep(this.user);
        console.log('login user', user);
        user.status = this.status;
        var storageKeyWebPush = window.localStorage.getItem('server-keys');
        var storageSubscriptionWebPush = window.localStorage.getItem('server-subscription');
        watcheebox_watcheebox.connexionAgent({
          agentStatus: user.status,
          datasAgent: user,
          agentName: this.fullName,
          sessionPHP: this.$cookie.get('PHPSESSID'),
          sid: data.sid,
          keyWebPush: storageKeyWebPush,
          subscriptionWebPush: storageSubscriptionWebPush
        });
      } else {
        watcheebox_watcheebox.clientRetourRoom({
          datasAgent: this.user,
          sessionPHP: this.$cookie.get('PHPSESSID') });
        watcheebox_watcheebox.changeStatusAgent({
          statut: this.status,
          agentID: this.user.id,
          sessionsPrivees: this.sessionsPrivees,
          roomName: this.user.entKey
        });
      }
    },

    rechargeLoadBalancer: lodash_default.a.debounce(function () {
      var _this4 = this;

      this.$store.commit('_StoreWatcheeBox/RECONNEXION_AUTO', { status: false });
      this.dialogMultiConnexion = false;
      var sid = this.$cookie.get('NODE-SID');
      var loadBalancer =  false ? 'https://node-dev.watcheebox.net/getnode' : 'https://prod-nlb.watcheebox.net/getnode';
      if (this.$store.state._User.entBeta || window.location.origin.indexOf('beta.targetfirst.com') > -1) {
        loadBalancer = 'https://preprod-nlb.watcheebox.net/getnode';
      }

      if (sid) {
        loadBalancer += '?sid=' + sid;
      }

      this.axios.get(loadBalancer, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        if (_this4.$socket) {
          _this4.$socket.close();
          _this4.$socket.io.uri = 'https://' + response.data.host;
          _this4.$socket.io.opts.transports = ['websocket', 'polling'];
        } else {
          vue_esm["default"].use(build_default.a, lib_default()('https://' + response.data.host, {
            secure: true,
            transports: ['websocket', 'polling'],
            autoConnect: false,
            timeout: 25000,
            reconnection: true,
            reconnectionDelayMax: 8000,
            reconnectionDelay: 5000,

            reconnectionAttempts: 1000
          }), _this4.$store);
        }

        _this4.$socket.open();
        _this4.$store.commit('_StoreWatcheeBox/PLAY_SOUND_OPEN_BO');
        _this4.SET_STATUS(_this4.statusManually);
        _this4.connectAgent({ nodeReload: true, sid: response.data.sid });

        if (response.data.sid) {
          _this4.$cookie.set('NODE-SID', response.data.sid, { expires: '6h' });
        }
      }).catch(function (errors) {});
    }, 1000),

    reconnectMirroring: function reconnectMirroring() {
      var index = lodash_default.a.findIndex(this.agentsArray, { 2: this.user.id });
      if (index !== -1) {}
    },
    closeDialogVisiteurChangePage: function closeDialogVisiteurChangePage() {
      this.dialogVisiteurOffline = false;
      this.visiteurChangePage = false;
    },
    closeTransfertClient: function closeTransfertClient() {
      this.closeDialogVisiteurChangePage();
      this.dialogTransfere = false;
      watcheebox_watcheebox.rejetTransfert({
        datasTransfere: this.datasTransfere
      });

      this.$store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
        status: 'NO',
        emission: false,
        messageDatas: ''
      });
    },
    rejetTransfertClient: function rejetTransfertClient() {
      this.dialogTransfere = false;
      watcheebox_watcheebox.rejetTransfert({
        datasTransfere: this.datasTransfere
      });

      this.$store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
        status: 'NO',
        emission: false,
        messageDatas: ''
      });
    },
    acceptTransfertClient: function acceptTransfertClient() {
      var _this5 = this;

      var visiteurTransfert = this.listeAllVisiteurs.filter(function (visiteur) {
        return visiteur.visiteurID === _this5.datasTransfere.chatSession;
      });

      if (visiteurTransfert.length) {
        if (visiteurTransfert[0].connexion) {
          this.dialogTransfere = false;

          var indexVisiteur = lodash_default.a.findIndex(this.WATCHEEBOX_STATE.agentsArray, { 2: this.$store.state._StoreWatcheeBox.transfertStatusReception.datas.senderID });

          if (indexVisiteur !== -1) {
            this.datasTransfere.clientSocketID = this.WATCHEEBOX_STATE.agentsArray[indexVisiteur][4];
          }
          watcheebox_watcheebox.acceptTransfert({
            datasTransfere: this.datasTransfere
          });

          this.visiteurSelectedTransfere.histoChat = [];

          var placeOccupe = [];

          lodash_default.a.forEach(this.WATCHEEBOX_STATE.listeAllVisiteurs, function (allVisiteurs, key) {
            if (allVisiteurs.placePupitre) {
              placeOccupe.push(allVisiteurs.placePupitre);
            }
          });

          if (placeOccupe.length > 3) {
            this.visiteurSelectedTransfere.timeStampArrive = Date.now();
            this.visiteurSelectedTransfere.fileAttente = this.user.id;
            this.visiteurSelectedTransfere.placePupitre = null;
          } else {
            var placePupitre = [1, 2, 3, 4];
            var placesDispo = lodash_default.a.difference(placePupitre, placeOccupe);
            this.visiteurSelectedTransfere.fileAttente = null;
            this.visiteurSelectedTransfere.placePupitre = placesDispo[0];
          }
          this.$store.commit('_StoreWatcheeBox/SET_VISITEURS', this.visiteurSelectedTransfere);
          var dataSession = [this.visiteurSelectedTransfere.socketID, this.visiteurSelectedTransfere.visiteurID, this.user.id, this.visiteurSelectedTransfere.visiteurID];
          this.$store.commit('_StoreWatcheeBox/ADD_PRIVATE_SESSION_CHAT', {
            session: dataSession,
            visiteur: this.visiteurSelectedTransfere
          });
          this.$router.push({ path: '/trafic/chatting' });

          watcheebox_watcheebox.clientConnectRoom({
            roomName: 'chat_' + this.visiteurSelectedTransfere.visiteurID
          });

          this.$store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
            status: 'OK',
            emission: false,
            messageDatas: ''
          });
        } else {
          console.log('le visiteur n\'est plus connecté ou il change de page');
          this.dialogVisiteurOffline = true;
          this.visiteurChangePage = true;
        }
      } else {
        console.log('le visiteur n\'est plus la');
        this.dialogVisiteurOffline = true;
      }
    },
    takeScreenshot: function takeScreenshot() {
      var _this6 = this;

      npm_default()(document.querySelector('body')).then(function (canvas) {
        var croppedCanvas = document.createElement('canvas');
        var croppedCanvasContext = croppedCanvas.getContext('2d');
        croppedCanvas.width = window.innerWidth;
        croppedCanvas.height = window.innerHeight;
        croppedCanvasContext.drawImage(canvas, 0, 0, croppedCanvas.width, croppedCanvas.height, 0, 0, croppedCanvas.width, croppedCanvas.height);
        _this6.imageUrl = croppedCanvas.toDataURL();
      }).catch(function (e) {
        console.error('e', e);
      });
    },
    envoiBug: function envoiBug() {
      var _this7 = this;

      var dataToPost = new window.FormData();
      dataToPost.append('to', 'support@targetfirst.com');
      dataToPost.append('ReplyTo', this.user.mailContact);
      dataToPost.append('fullName', this.fullName);
      dataToPost.append('siteSelected', this.$store.state._Sites.sites[0].LIC_URL);
      dataToPost.append('subject', 'Envoi de screenshot');
      dataToPost.append('title', 'Demande de support');
      dataToPost.append('message', this.messageBug);
      dataToPost.append('image', this.imageUrl);
      dataToPost.append('url', this.$route.fullPath);
      this.sendingReport = true;
      this.axios.post('post/email_support.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (res) {
        _this7.emailSupportSend = true;
        _this7.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this7.$t('emailSent'),
          context: 'success'
        });
        _this7.dialogBugScreenshot = false;
      }).catch(function () {
        _this7.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this7.$t('emailFailure'),
          context: 'error'
        });
      }).then(function () {
        _this7.sendingReport = false;
        _this7.messageBug = '';
      });
    },
    checkAgentsMaxOnline: function checkAgentsMaxOnline() {
      var _this8 = this;

      if (this.user.connectFromAdmin) {
        return;
      }

      var agentsConnected = this.agentsArray.filter(function (agent) {
        return agent[4] !== '0' && agent[2] !== _this8.user.id;
      });
      if (agentsConnected.length >= this.user.entNbAgent) {
        this.dialogTooMuchAgents = true;
        this.SET_STATUS('offline');
        if (!this.intervalTooMuchAgents) {
          this.intervalTooMuchAgents = setInterval(function () {
            _this8.countdown--;
            if (_this8.countdown === 0) {
              _this8.logout();
            }
            _this8.checkAgentsMaxOnline();
          }, 1000);

          var params = new window.FormData();
          params.append('id', this.user.entId);
          this.axios.post('post/account.php', params, {
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
          }).then(function (res) {
            var addresses = res.data.licences.map(function (licence) {
              return licence.email;
            });
            addresses = lodash_default.a.uniq(addresses);
            var dataToPost = new window.FormData();
            var body = _this8.$tc('tooMuchAgentsConnected', 1, {
              count: _this8.user.entNbAgent
            });
            var agentsConnectedString = agentsConnected.map(function (agent) {
              return '<li>' + agent[2] + ' ' + agent[1] + '</li>';
            }).join('');

            body += '<br>';
            body += _this8.$t('error') + ' <br>';
            body += _this8.$tc('agents', 1, { count: '' }) + ' : <b>' + _this8.user.id + '</b> ' + _this8.fullName + ' (' + _this8.user.mail + ' )<br>';
            body += '<h3>' + _this8.$t('connectedAgents') + '</h3>';
            body += '<ul>' + agentsConnectedString + '</ul>';
            dataToPost.append('subject', '[Target First] ' + _this8.$t('limitSimultaneousAgentsReached'));
            dataToPost.append('body', body);
            dataToPost.append('sender', 'admin@targetfirst.com');
            dataToPost.append('addresses', stringify_default()(addresses));
            _this8.axios.post('post/notify_by_email.php', dataToPost, {
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            });
          });
        }
      } else {
        if (this.intervalTooMuchAgents) {
          window.clearInterval(this.intervalTooMuchAgents);
        }
        this.dialogTooMuchAgents = false;
        this.countdown = 30;
        this.SET_TOO_MUCH_AGENTS_CHECKED(true);
      }
    },
    leaving: function leaving() {
      this.$store.commit('_StoreWatcheeBox/AGENT_RELOAD', {});

      push_min_default.a.clear();

      if (!this.reasonUnload) {
        this.SET_REASON_UNLOAD('F5 / close tab');
      }
      var params = new window.FormData();
      params.append('user', this.fullName);
      params.append('userId', this.user.id);
      params.append('reason', this.reasonUnload);
    },
    startTuto: function startTuto() {
      this.installProgress = false;

      this.$store.commit('_User/ONGOING_TUTO', {
        ongoingTuto: true
      });
      this.$cookie.delete('blockInstallProgress');
      if (this.$router.currentRoute.fullPath !== '/settings/preview') {
        this.$router.push({ path: '/settings/preview' });
      } else {
        this.$router.go(this.$router.currentRoute);
      }
      return false;
    },
    nextStep: function nextStep() {
      var _this9 = this;

      this.installProgress = false;

      this.$store.commit('_User/ONGOING_TUTO', {
        ongoingTuto: false
      });

      var steps = JSON.parse(this.$store.state._User.remainingSteps);

      if (steps.length === 0) {
        alert('Vous avez exploré toutes les sections clés de votre Backoffice. Vous pouvez refaire un tour, ou mettre à jours vos règles de ciblage comportemental.');

        this.$store.commit('_User/ONGOING_TUTO', {
          ongoingTuto: false
        });
      }
      lodash_default.a.forEach(steps, function (key, val) {
        if (key === 'INS_SETTINGS_PREVIEW') {
          _this9.$router.push({ path: '/settings/preview' });
          return false;
        } else if (key === 'INS_SETTINGS_HORSLIGNE') {
          _this9.$router.push({ path: '/settings/absence' });
          return false;
        } else if (key === 'INS_SETTINGS_CHAT') {
          _this9.$router.push({ path: '/settings/chat' });
          return false;
        } else if (key === 'INS_MANAGEMENT_SITES') {
          _this9.$router.push({ path: '/management/sites' });
          return false;
        } else if (key === 'INS_MANAGEMENT_CONSEILLERS') {
          _this9.$router.push({ path: '/management/agents' });
          return false;
        } else if (key === 'INS_PROFILE') {
          _this9.$router.push({ path: '/profile' });
          return false;
        } else if (key === 'INS_TARGET_FILTERS') {
          _this9.$router.push({ path: '/target/filters' });
          return false;
        } else if (key === 'INS_ACCOUNT') {
          _this9.$router.push({ path: '/account' });
          return false;
        } else if (key === 'INS_MEDIA_BIBLIOS') {
          _this9.$router.push({ path: '/media/biblios' });
          return false;
        } else if (key === 'INS_FO_INSTALLED') {
          _this9.$router.push({ path: '/stats/audience' });
          return false;
        }
      });
    },
    blockTuto: function blockTuto() {
      this.installProgress = false;

      this.$store.commit('_User/ONGOING_TUTO', {
        ongoingTuto: false
      });
      this.$cookie.set('blockInstallProgress', '1', { expires: '100000h' });
    },
    skipTuto: function skipTuto() {
      this.installProgress = false;

      this.$store.commit('_User/ONGOING_TUTO', {
        ongoingTuto: false
      });
    },
    resetTuto: function resetTuto() {
      var _this10 = this;

      this.installProgress = true;
      this.$cookie.delete('blockInstallProgress');

      this.$store.commit('_User/ONGOING_TUTO', {
        ongoingTuto: false
      });

      var dataToPost = new window.FormData();
      dataToPost.append('ENT_ID', this.$store.state._User.entId);

      this.axios.post('post/resetTuto.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this10.$store.state._User.remainingSteps = '["INS_SETTINGS_PREVIEW","INS_SETTINGS_HORSLIGNE","INS_SETTINGS_CHAT","INS_MANAGEMENT_SITES","INS_MANAGEMENT_CONSEILLERS","INS_PROFILE","INS_TARGET_FILTERS","INS_ACCOUNT","INS_MEDIA_BIBLIOS","INS_FO_INSTALLED"]';
        _this10.$store.state._User.installProgress = 0;
        _this10.progress = 0;
        _this10.startTuto().catch();
      }).catch(function (_) {}).then(function (_) {});
    },
    showHideMydesk: function showHideMydesk() {
      if (typeof openPanel === 'function') {
        openPanel();
      }
    }
  }),

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_Toolbar', ['back', 'tabs', 'title', 'subTitle']), Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['listeAllVisiteurs', 'transfertStatusReception', 'newMessage', 'lastMessage', 'reconnexionSocket', 'isConnected', 'sessionsPrivees', 'mySocketID', 'listeChatAgent', 'agentsArray', 'status', 'statusManually', 'visiteurChatSelected', 'tooMuchAgentsChecked', 'sessionDejaActive', 'sessionPhpActive', 'delogOldSession', 'autoDelogMySession']), Object(vuex_esm["e" /* mapState */])(['reasonUnload']), Object(vuex_esm["c" /* mapGetters */])('_StoreWatcheeBox', ['WATCHEEBOX_STATE']), Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'fullName']), Object(vuex_esm["c" /* mapGetters */])(['logged']), {
    myFocus: function myFocus() {
      var myStatusFocus = lodash_default.a.find(this.agentsArray, [2, this.user.id]);
      if (myStatusFocus && myStatusFocus[16] && myStatusFocus[16] === 'true') {
        return true;
      } else {
        return false;
      }
    },
    Domaine: function Domaine() {
      return constants_DOMAINE + '/subscription/subscriptions_fr.php';
    },
    Support: function Support() {
      return 'https://support.targetfirst.com/';
    },
    activeDialogMultiSession: function activeDialogMultiSession() {
      console.log('this.sessionDejaActive', this.sessionDejaActive);
      if (this.sessionDejaActive) {
        if (this.dialogReconnexion) {
          return false;
        } else {
          return true;
        }
      }
    },
    checkPHPsessionID: function checkPHPsessionID() {
      if (this.$cookie.get('PHPSESSID')) {
        return this.$cookie.get('PHPSESSID').slice(0, 10) === this.sessionPhpActive;
      } else {
        this.$router.push({ path: '/login' });
      }
    }
  }),

  watch: {
    isConnected: function isConnected(val, oldVal) {
      console.log('-> isConnected', val);
      if (!val) {
        console.log('-> isConnected no', val);
        var reason = !window.navigator.onLine ? 'Dash: Internet perdu' : 'Dash: nodeJS perdu';
        this.SET_REASON_UNLOAD(reason);
        this.leaving();
      } else {
        console.log('-> isConnected yes', val);
      }
      if (!val && !document.hasFocus()) {
        push_min_default.a.create('D\xE9connexion du chat', {
          body: 'La connexion avec le chat \xE9t\xE9 perdue...',
          tag: 'disconnected',
          icon: {
            x16: 'https://www.watcheezy.net/dist/static/img/logo_16.png',
            x32: 'https://www.watcheezy.net/dist/static/img/logo_32.png'
          },
          onClick: function onClick() {
            window.focus();
            this.close();
          }
        }).catch(function () {});
        this.audioOffline.play().catch(function () {});
      } else {
        this.audioOffline.pause();
        this.audioOffline.currentTime = 0;
      }
    },

    status: function status(v) {
      var _this11 = this;

      if (v === 'offline' && !document.hasFocus()) {
        var title = lodash_default.a.upperFirst(this.$t('offline'));
        var body = this.$t('noTargetingOffline');
        setTimeout(function () {
          if (_this11.status === 'offline') {
            push_min_default.a.create(title, {
              body: body,
              tag: 'offline',
              icon: {
                x16: 'https://www.watcheezy.net/dist/static/img/logo_16.png',
                x32: 'https://www.watcheezy.net/dist/static/img/logo_32.png'
              },
              onClick: function onClick() {
                window.focus();
                this.close();
              }
            });
            _this11.audioOffline.play().catch(function () {});
          }
        }, 1000);
      } else {
        this.audioOffline.pause();
        this.audioOffline.currentTime = 0;
      }
    },

    delogOldSession: function delogOldSession(val, oldval) {
      if (val) {
        this.rechargeLoadBalancer();
      }
    },

    autoDelogMySession: function autoDelogMySession(val, oldval) {
      if (val) {
        this.SET_REASON_DECO({
          'status': 'autoDeco',
          'title': this.$t('titleDialogMultiConnexion'),
          'content': this.$t('contentDialogMultiConnexion')
        });
        this.logout();
      }
    },

    agentsArray: function agentsArray(val, oldval) {
      if (!this.tooMuchAgentsChecked) {
        this.checkAgentsMaxOnline();
      }
    },

    reconnexionSocket: function reconnexionSocket(val, oldVal) {
      console.log('-> reconnexionSocket');

      if (val) {
        this.rechargeLoadBalancer();

        this.reconnectMirroring();
      } else {}
    },

    transfertStatusReception: function transfertStatusReception(val, oldval) {
      this.datasTransfere = val.datas;
      if (val.status === 'transfere') {
        this.dialogTransfere = true;
        this.$store.commit('_StoreWatcheeBox/PLAY_SOUND_CONVERSATION');
        var index = lodash_default.a.findIndex(this.listeAllVisiteurs, {
          visiteurID: val.datas.chatSession
        });
        if (index !== -1) {
          this.visiteurSelectedTransfere = lodash_default.a.clone(this.listeAllVisiteurs[index]);
        }
      } else if (val.status === 'annuler') {
        this.dialogTransfere = false;
        this.$store.commit('_StoreWatcheeBox/SET_TRANSFERE_STATUS', '');
      }
    },

    '$store.state._StoreWatcheeBox.mySocketID': function $storeState_StoreWatcheeBoxMySocketID(val, oldVal) {
      this.$store.commit('_StoreWatcheeBox/CHECK_PRIVATE_SESSION_CHAT');
    },

    sessionsPrivees: function sessionsPrivees(val, oldVal) {
      if (this.status !== 'offline') {
        if (this.sessionsPrivees.length < this.user.chatsMax) {
          watcheebox_watcheebox.changeStatusAgent({
            statut: this.statusManually,
            agentID: this.user.id,
            sessionsPrivees: this.sessionsPrivees,
            roomName: this.user.entKey
          });
        } else {
          watcheebox_watcheebox.changeStatusAgent({
            statut: this.statusManually === 'offline' ? 'offline' : 'busy',
            agentID: this.user.id,
            sessionsPrivees: this.sessionsPrivees,
            roomName: this.user.entKey
          });
        }
      }
    },

    '$route.name': function $routeName(val, oldVal) {
      if (val === 'chatting') {
        this.drawer = false;
      }
      if (oldVal === 'chatting') {
        this.drawer = true;
      }
    }
  },

  created: function created() {
    window.addEventListener('beforeunload', this.leaving);
    window.addEventListener('unload', this.leaving);
  },
  mounted: function mounted() {
    this.usrBoNotif = this.$store.state._User.usr_bo_notif;
    this.memoDialogQuota = this.$cookie.get('memoDialogQuota');
    this.memoDialogC2C = this.$cookie.get('memoDialogC2C');
    this.memoDialogExpireCB = this.$cookie.get('memoDialogExpireCB');

    if (this.$store.state._User.cbExpiration) {
      var maintenant = Date.now();
      var cbExpire = this.$store.state._User.cbExpiration.CLI_PAYBOX_EXPIRY;

      var cb = moment_default.a.parseZone(cbExpire, 'MMYY').format('x');

      if (cb > maintenant) {
        this.expireCB = false;

        cb = (cb - maintenant) / 1000;
        if (cb < 2592000) {
          this.cbExpirebientot = true;
          if (this.memoDialogExpireCB === '1') {
            this.activeDialogCB = false;
          } else {
            this.activeDialogCB = true;
          }
        }

        this.delaiExpireCB = moment_default.a.duration(cb, 'seconds').humanize(true);
      } else {
        this.expireCB = true;
        this.cbExpirebientot = false;
        this.activeDialogCB = true;
      }
      this.dateExpireLicence = moment_default()(this.$store.state._User.entEezyExpiry).format('LL');
    }

    var appContent = document.getElementById('toolBarApp');
    var toolbarContent = appContent.getElementsByClassName('v-toolbar__content')[0];
    toolbarContent.classList.add('primary');

    if ('serviceWorker' in navigator && 'PushManager' in window) {
      console.log('Service Worker and Push is supported');
      var dir =  false ? '/watcheezy/' : '/';
      navigator.serviceWorker.register(dir + 'service-worker.js', {
        scope: '.' }).then(function (swReg) {
        console.log('Service Worker is registered', swReg.scope);
      }).catch(function (error) {
        console.error('Service Worker Error', error);
      });
    } else {
      console.warn('Push messaging is not supported');
    }

    if (this.$store.state._User.entNbPageTotal === 0) {
      this.SET_STATUS('offline');
      this.dialogScript = true;
      return;
    }

    if (this.$store.state._User.entNbPageThisMonth) {
      this.quotaPages = 100 * this.$store.state._User.entNbPageThisMonth / this.$store.state._User.entNbPageMax;
    }

    if (this.$store.state._Sites.siteSelected) {
      var typeNotif = void 0;
      var txtNotif = void 0;
      var titreNotif = void 0;
      var c2cConsoSecF = this.$store.state._Sites.siteSelected.c2c_conso_sec_f;
      var c2cQuotaSitesF = this.$store.state._Sites.siteSelected.c2c_quota_sites_f * 3600;
      var c2cConsoSecM = this.$store.state._Sites.siteSelected.c2c_conso_sec_m;
      var c2cQuotaSitesM = this.$store.state._Sites.siteSelected.c2c_quota_sites_m * 3600;

      this.c2cAverageF = this.$store.state._Sites.siteSelected.c2c_average_f;
      this.c2cAverageM = this.$store.state._Sites.siteSelected.c2c_average_m;

      var resteF = 0;
      var resteM = 0;

      if (c2cQuotaSitesF) {
        this.depassementF = Math.round(c2cConsoSecF * 100 / c2cQuotaSitesF);
        resteF = c2cQuotaSitesF - c2cConsoSecF;
      } else {
        this.depassementF = 0;
      }
      if (c2cQuotaSitesM) {
        this.depassementM = Math.round(c2cConsoSecM * 100 / c2cQuotaSitesM);
        resteM = c2cQuotaSitesM - c2cConsoSecM;
      } else {
        this.depassementM = 0;
      }

      if (this.c2cAverageF !== '' && this.c2cAverageF !== 0) {
        if (resteF > this.c2cAverageF) {
          this.resteEstimedF = trunc_default()(resteF / this.c2cAverageF);
        }
      }
      if (this.c2cAverageM !== '' && this.c2cAverageM !== 0) {
        if (resteM > this.c2cAverageM) {
          this.resteEstimedM = trunc_default()(resteM / this.c2cAverageM);
        }
      }

      txtNotif = this.$t('infoConsumptionC2C') + (this.depassementF > this.depassementM ? this.depassementF : this.depassementM) + ' %';

      if (c2cConsoSecF > c2cQuotaSitesF && this.depassementF || c2cConsoSecM > c2cQuotaSitesM && this.depassementM) {
        typeNotif = 'error';
        titreNotif = this.$t('warningC2C');
        this.activeDialogc2c = true;
        this.C2CoffF = true;
      } else if (c2cConsoSecF > c2cQuotaSitesF * 0.8 && this.depassementF || c2cConsoSecM > c2cQuotaSitesM * 0.8 && this.depassementM) {
        if (this.resteEstimedF > 0 && this.resteEstimedF < 8 || this.resteEstimedM > 0 && this.resteEstimedM < 8) {
          typeNotif = 'phone_in_talk';
          titreNotif = this.$t('warningC2Cnear2');
          if (this.memoDialogC2C === '1') {
            this.activeDialogc2c = false;
            this.C2CnearF = false;
          } else {
            this.activeDialogc2c = true;
            this.C2CnearF = true;
          }
        }
      }

      if (this.depassementF > 80 || this.depassementM > 80) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: '',
          type: typeNotif,
          vu: true,

          target: '_blank',
          data: {
            titre: titreNotif,
            url: this.checkRefFacturation({ 'type': 'quotaC2C' }),
            message: txtNotif,
            timestamp: Date.now()
          }
        });
      }
    }

    if (this.$store.state._User.entEezyExpiry) {
      var now = Date.now();
      var dateExpireLicence = Date.parse(this.$store.state._User.entEezyExpiry);
      var event = new Date(this.$store.state._User.entEezyExpiry);
      var dif = (dateExpireLicence / 1000 - now / 1000) / 86400;
      var validate = sign_default()(dif);

      if (validate !== -1 && this.quotaPages < 100) {
        if (this.$store.state._User.entLevel === '0') {
          this.LicenceOUT = true;
          this.activeDialogPagesVues = true;
          this.SET_STATUS('offline');

          var _txtNotif = this.$t('txtNotifContactSupport') + ' <b>support@targetfirst.com</b>';
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: '',
            type: 'error',
            vu: true,
            url: 'https://support.targetfirst.com/',
            target: '_blank',
            data: {
              titre: this.$t('warningLicence'),
              message: _txtNotif,
              timestamp: Date.now()
            }
          });
          return;
        } else {
          this.expireLicence = false;
          this.sursisLicence = false;
          if (Math.ceil(dif) > 30) {} else if (Math.ceil(dif) < 30) {} else if (Math.ceil(dif) < 7) {}
        }
      } else if (validate !== -1 && this.quotaPages >= 100) {
        if (this.$store.state._User.entLevel === '0') {}
      } else if (validate === -1 && this.quotaPages < 100) {
        this.activeDialogPagesVues = true;
        this.dateExpire = event.toLocaleDateString(this.$store.state._User.lang + '-' + this.$store.state._User.lang.toUpperCase(), this.dateOptions);
        if (this.$store.state._User.entLevel === '0') {
          this.expireLicence = true;

          this.SET_STATUS('offline');

          var _txtNotif2 = this.$t('txtNotifExpire') + ' ' + this.dateExpire;
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: '',
            type: 'error',
            vu: true,
            url: '/account',
            data: {
              titre: this.$t('warningExpired'),
              url: this.checkRefFacturation({ 'type': 'expireLicence' }),
              message: _txtNotif2,
              timestamp: Date.now()
            }
          });
          return;
        } else {
          if (this.$store.state._User.surcisLicience === '0') {
            this.expireLicence = true;
            this.SET_STATUS('offline');

            var _txtNotif3 = this.$t('txtNotifExpire') + ' ' + this.dateExpire;
            this.$store.dispatch('_Notifier/NEW_NOTIF', {
              message: '',
              type: 'error',
              vu: true,
              url: '/account',
              data: {
                titre: this.$t('warningLicence'),
                url: this.checkRefFacturation({ 'type': 'expireLicence' }),
                message: _txtNotif3,
                timestamp: Date.now()
              }
            });
            return;
          } else {
            this.sursisLicence = true;

            var _txtNotif4 = this.$t('txtNotifExpire') + ' ' + this.dateExpire;
            this.$store.dispatch('_Notifier/NEW_NOTIF', {
              message: '',
              type: 'error',
              vu: true,
              url: '/account',
              data: {
                titre: this.$t('warningExpired'),
                url: this.checkRefFacturation({ 'type': 'expireLicence' }),
                message: _txtNotif4,
                timestamp: Date.now()
              }
            });
          }
        }
      }
    }

    if (this.$store.state._User.entNbPageThisMonth && !this.expireLicence) {

      var DateNow = new Date().getDate();
      var renouvellementDate = new Date(this.$store.state._User.entEezyExpiry).getDate();

      var dateInMonth = void 0;

      if (DateNow > renouvellementDate) {
        dateInMonth = this.addMonths(1, renouvellementDate);
        this.renouvellementDay = this.diffDate(new Date(), dateInMonth);
      } else if (DateNow < renouvellementDate) {
        dateInMonth = this.addMonths(0, renouvellementDate);
        this.renouvellementDay = this.diffDate(new Date(), dateInMonth);
      } else {
        this.renouvellementDay = 0;
      }

      if (this.quotaPages >= 80 && this.quotaPages < 90) {
        var _txtNotif5 = this.$t('txtNotifQuota') + ' <b>' + this.quotaPages.toFixed(2) + ' %</b> ' + this.$t('txt2InfoQuota');
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('txt1NotifQuota') + ' ' + this.quotaPages.toFixed(2) + ' %, ' + this.$t('txt2NotifQuota') + ' ' + this.$store.state._User.entNbPageThisMonth + ' ' + this.$t('outOf') + ' ' + this.$store.state._User.entNbPageMax + ' ' + this.$t('trackedPages') + '.',
          context: 'warning',
          position: 'top',
          color: 'orange',
          multiLine: true,
          timeout: 120000,
          target: '_blank',
          type: 'collections',
          vu: false,
          data: {
            titre: this.$t('titleNotifQuota'),
            message: _txtNotif5,
            url: this.checkRefFacturation({ 'type': 'quotaPages' }),
            timestamp: Date.now()
          }
        });
      } else if (this.quotaPages >= 90 && this.quotaPages < 100) {
        if (!this.memoDialogQuota || this.memoDialogQuota === '0') {
          this.activeDialogPagesVues = true;
        }

        var _txtNotif6 = this.$t('txtNotifQuota') + ' <b>' + this.quotaPages.toFixed(2) + ' %</b> ' + this.$t('txt2InfoQuota');
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: '',
          target: '_blank',
          type: 'collections',
          vu: true,
          data: {
            titre: this.$t('titleNotifQuota'),
            message: _txtNotif6,
            url: this.checkRefFacturation({ 'type': 'quotaPages' }),
            timestamp: Date.now()
          }
        });
      } else if (this.quotaPages >= 100) {
        this.activeDialogPagesVues = true;
        this.fullQuotaPagesVues = true;

        var _txtNotif7 = this.$t('txtNotifQuota') + ' <b>100 %</b> ' + this.$t('txt2InfoQuota');
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: '',
          type: 'error',
          vu: true,
          url: '/account',
          data: {
            titre: this.$t('warningLicence'),
            message: _txtNotif7,
            url: this.checkRefFacturation({ 'type': 'quotaPages' }),
            timestamp: Date.now()
          }
        });
        return;
      }
    }

    if (['peon', 'agent', 'super', 'adminTF'].indexOf(this.$store.getters['_User/account'].role) === -1) {
      this.SET_STATUS('offline');
      return;
    }

    if (this.$store.state._User.connectFromAdmin) {
      this.SET_STATUS('offline');
    }

    if (!this.$store.state._User.connectingOnline) {
      this.SET_STATUS('offline');
    }

    if (!this.statusManually) {
      this.SET_STATUS_MANUALLY(this.status);
    }

    if (this.$socket === undefined) {
      this.rechargeLoadBalancer();
    } else {}

    window.lastFocusStatus = true;
    this.checkFocus();
    this.intervalCheckFocus = setInterval(this.checkFocus, 1000);
    if (window.addEventListener) {
      window.addEventListener('online', this.isOnline, false);
      window.addEventListener('offline', this.isOffline, false);
    } else {
      document.body.ononline = this.isOnline;
      document.body.onoffline = this.isOffline;
    }

    if (this.checkPermission('NO_AGENTS') && this.$store.state._User.installProgress < 100 && !this.$cookie.get('blockInstallProgress') && !this.$store.state._User.ongoingTuto && !this.$store.state._User.tutoQuited) {
      this.installProgress = true;

      this.$store.commit('_User/ONGOING_TUTO', {
        ongoingTuto: true
      });
      this.progress = this.$store.state._User.installProgress;
    }

    loadTf();
  },
  beforeDestroy: function beforeDestroy() {
    window.clearInterval(this.intervalCheckFocus);
    window.clearInterval(this.intervalTooMuchAgents);
    window.clearInterval(this.idInterval);
  }
});

function loadTf() {
  var tf = document.createElement('script');
  tf.type = 'text/javascript';
  tf.async = true;
  tf.src = document.location.protocol + '//www.watcheezy.net/deliver/watcheezy_dev.js?wzkey=612502dcd54eaf3125eab789aeb26820';
  var s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(tf, s);
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5a203b02","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('v-navigation-drawer',{staticClass:"position-index-11",attrs:{"app":"","fixed":"","dark":"","mini-variant":_vm.mini},model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{staticClass:"pa-0"},[_c('v-tooltip',{attrs:{"right":""}},[_c('v-list-tile',{attrs:{"slot":"activator","avatar":"","tag":"div","href":"https://www.targetfirst.com/","target":"_blank"},slot:"activator"},[_c('v-list-tile-avatar',[_c('v-img',{attrs:{"src":"../../static/icon_tf.png"}})],1)],1),_vm._v(" "),_c('span',[_vm._v("Target First")])],1)],1),_vm._v(" "),_c('wz-menu'),_vm._v(" "),(false)?_c('v-footer',{attrs:{"absolute":"","color":"transparent"}},[_c('v-chip',{attrs:{"label":"","disabled":"","color":"green","outline":"","small":"","dark":""}},[_vm._v("v1.0.0")])],1):_vm._e()],1),_vm._v(" "),_c('v-navigation-drawer',{staticClass:"position-index-11",attrs:{"disable-route-watcher":"","app":"","fixed":"","right":"","temporary":"","width":"350","hide-overlay":""},model:{value:(_vm.helper),callback:function ($$v) {_vm.helper=$$v},expression:"helper"}},[_c('wz-help',{attrs:{"opened":_vm.helper},on:{"update:opened":function($event){_vm.helper=$event}}})],1),_vm._v(" "),(false)?_c('v-navigation-drawer',{staticClass:"position-index-11",attrs:{"disable-route-watcher":"","disable-resize-watcher":"","app":"","fixed":"","right":"","hide-overlay":"","width":"350"},model:{value:(_vm.showSatisfactionAgent),callback:function ($$v) {_vm.showSatisfactionAgent=$$v},expression:"showSatisfactionAgent"}},[_c('wz-satisfaction-agent',{attrs:{"opened":_vm.showSatisfactionAgent},on:{"update:opened":function($event){_vm.showSatisfactionAgent=$event}}})],1):_vm._e(),_vm._v(" "),_c('v-toolbar',{staticClass:"white position-index-10",attrs:{"app":"","dense":"","dark":"","id":"toolBarApp"}},[_c('v-toolbar-side-icon',{nativeOn:{"click":function($event){$event.stopPropagation();_vm.drawer = !_vm.drawer}}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.checkPermission('NO_AGENTS'))?_c('v-tooltip',{attrs:{"bottom":""}},[_c('template',{slot:"activator"},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.installProgress = true}}},[_c('v-icon',[_vm._v("explore")])],1)],1),_vm._v(" "),_c('span',[_vm._v("Visite guidée")])],2):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('template',{slot:"activator"},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.showHideMydesk()}}},[_c('v-icon',[_vm._v("forum")])],1)],1),_vm._v(" "),_c('span',[_vm._v("Chatbot d'aide")])],2),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('template',{slot:"activator"},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.bugReport()}}},[_c('v-icon',[_vm._v("bug_report")])],1)],1),_vm._v(" "),_c('span',[_vm._v("Signaler bug")])],2),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('template',{slot:"activator"},[_c('v-btn',{attrs:{"icon":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.helper = !_vm.helper}}},[_c('v-icon',[_vm._v("help")])],1)],1),_vm._v(" "),_c('span',[_vm._v("Centre d'aide")])],2),_vm._v(" "),_c('wz-pupitre-status'),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('template',{slot:"activator"},[_c('wz-notifications')],1),_vm._v(" "),_c('span',[_vm._v("Notifications")])],2),_vm._v(" "),_c('wz-agent-status'),_vm._v(" "),_c('wz-agent-menu'),_vm._v(" "),(_vm.$store.state._Toolbar.tabs.length || (_vm.back && _vm.subTitle))?_c('v-tabs',{attrs:{"slot":"extension","light":""},slot:"extension"},[_c('v-tabs-slider',{staticStyle:{"height":"4px"},attrs:{"color":"primary"}}),_vm._v(" "),(_vm.back && _vm.subTitle)?_c('v-toolbar-side-icon',{staticClass:"primary--text",on:{"click":function($event){_vm.$router.push({ path: _vm.back })}}},[_c('v-icon',[_vm._v("arrow_back")])],1):_vm._e(),_vm._v(" "),(_vm.back && _vm.subTitle)?_c('v-subheader',{staticClass:"subheading primary--text"},[_vm._v(_vm._s(_vm.subTitle))]):_vm._e(),_vm._v(" "),_vm._l((_vm.$store.state._Toolbar.tabs),function(tab){return _c('v-tab',{key:tab.to,staticClass:"primary--text mr-3",attrs:{"to":tab.to,"exact":"","disabled":tab.status == '0' ? true : false}},[_vm._v("\n          "+_vm._s(_vm.$tc(tab.title, 2, { count: '' }))+"\n\n          "),(tab.to == '/trafic/chatting')?_c('v-badge',{staticClass:"badgeTopMenu",attrs:{"right":"","color":"primary","value":tab.to == '/trafic/chatting' && _vm.$store.state._StoreWatcheeBox.sessionsPrivees.length}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.$store.state._StoreWatcheeBox.sessionsPrivees.length))])]):(tab.to == '/trafic/attente')?_c('v-badge',{staticClass:"badgeTopMenu",attrs:{"right":"","color":"primary","value":tab.to == '/trafic/attente' && _vm.$store.state._User.listeMessages.length}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.$store.state._User.listeMessages.length))])]):_vm._e()],1)})],2):_vm._e()],1),_vm._v(" "),_c('v-content',{staticClass:"contentVuePages"},[_c('transition',{attrs:{"name":"slide-x-reverse-transition","mode":"out-in"}},[_c('router-view')],1)],1),_vm._v(" "),_c('wz-notifier'),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogVisiteurOffline),callback:function ($$v) {_vm.dialogVisiteurOffline=$$v},expression:"dialogVisiteurOffline"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('visitorOffline')))]),_vm._v(" "),(_vm.visiteurChangePage)?_c('v-card-text',[_vm._v("\n          "+_vm._s(_vm.$t('trasfertChangePage'))+" \n        ")]):_c('v-card-text',[_vm._v("\n          "+_vm._s(_vm.$t('transfertOffline'))+"\n        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.visiteurChangePage)?_c('v-btn',{staticClass:"accent",attrs:{"flat":""},on:{"click":function($event){_vm.closeDialogVisiteurChangePage()}}},[_vm._v(_vm._s(_vm.$t('ok'))+"\n          ")]):_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.closeTransfertClient()}}},[_vm._v(_vm._s(_vm.$t('close'))+"\n          ")])],1)],1)],1),_vm._v(" "),_c('wz-dialog'),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogTransfere),callback:function ($$v) {_vm.dialogTransfere=$$v},expression:"dialogTransfere"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.datasTransfere.msg))]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          "+_vm._s(_vm.$t('findNewChatInChatting'))+"\n        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"accent",attrs:{"flat":""},on:{"click":function($event){_vm.rejetTransfertClient()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.acceptTransfertClient()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogReconnexion),callback:function ($$v) {_vm.dialogReconnexion=$$v},expression:"dialogReconnexion"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('connectionInterrupted')))]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          "+_vm._s(_vm.$t('noLongerConnected'))+"\n        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.sessionDejaActive)?_c('v-btn',{staticClass:"primary",attrs:{"disabled":!_vm.btConnexion},on:{"click":function($event){_vm.reconnexionBO('Connexion Internet interrompue avec multisession')}}},[_vm._v(_vm._s(_vm.$t('reconnection')))]):_c('v-btn',{staticClass:"primary",attrs:{"disabled":!_vm.btConnexion},on:{"click":function($event){_vm.reconnexionBO('Connexion Internet interrompue')}}},[_vm._v(_vm._s(_vm.$t('reconnection')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialogScript),callback:function ($$v) {_vm.dialogScript=$$v},expression:"dialogScript"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v("Oups !")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          "+_vm._s(_vm.$t('scriptInstallationNotOk'))+"\n          "),_c('b',[_vm._v("[Target First]...")])]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"primary--text",attrs:{"block":"","flat":"","loading":_vm.isChecking},on:{"click":function($event){_vm.checkScript()}}},[_vm._v("\n            "+_vm._s(_vm.$t('testAgain'))+"\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("refresh")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.activeDialogMultiSession),callback:function ($$v) {_vm.activeDialogMultiSession=$$v},expression:"activeDialogMultiSession"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('titleDialogMultiSession')))]),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.checkPHPsessionID ? _vm.$t('contentDialogMultiSessionPhp') : _vm.$t('contentDialogMultiSession'))}}),_vm._v(" "),(!_vm.checkPHPsessionID)?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.logout()}}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.reconnexionAgent()}}},[_vm._v(_vm._s(_vm.$t('yes'))+"\n          ")])],1):_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.debloqueMultiSession()}}},[_vm._v(_vm._s(_vm.$t('unblock'))+"\n          ")])],1)],1)],1),_vm._v(" "),(_vm.usrBoNotif === '1')?_c('v-dialog',{attrs:{"persistent":"","max-width":"480"},model:{value:(_vm.activeDialogPagesVues),callback:function ($$v) {_vm.activeDialogPagesVues=$$v},expression:"activeDialogPagesVues"}},[_c('v-card',[(_vm.LicenceOUT)?_c('v-card-title',{staticClass:"red white--text subheading"},[_vm._v("\n          "+_vm._s(_vm.$t('warning'))+" "+_vm._s(_vm.$t('warningLicence'))+"\n        ")]):(_vm.fullQuotaPagesVues)?_c('v-card-title',{staticClass:"red white--text subheading"},[_vm._v("\n          "+_vm._s(_vm.$t('warningTracked'))+"\n        ")]):(_vm.expireLicence)?_c('v-card-title',{staticClass:"red white--text subheading"},[_vm._v("\n          "+_vm._s(_vm.$t('warning'))+" "+_vm._s(_vm.$t('warningExpired'))+"\n        ")]):(_vm.sursisLicence)?_c('v-card-title',{staticClass:"red white--text subheading"},[_vm._v("\n          "+_vm._s(_vm.$t('warningExpired'))+"\n        ")]):_c('v-card-title',{staticClass:"orange white--text subheading"},[_vm._v("\n          "+_vm._s(_vm.$t('infoConsumption') + _vm.quotaPages.toFixed(2) + ' %')+"\n        ")]),_vm._v(" "),(_vm.LicenceOUT)?_c('v-card-text',[_c('h3',[_vm._v(_vm._s(_vm.$t('txt1WarningLicence')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('txt2WarningLicence')))])]):(_vm.fullQuotaPagesVues)?_c('v-card-text',[_c('h3',[_vm._v(_vm._s(_vm.$t('txt1AlertQuota')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('txt2AlertQuota')))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('txt3AlertQuota')))]),_vm._v("\n          "+_vm._s(_vm.$t('txt5InfoQuota'))+" "),_c('b',[_vm._v(_vm._s(_vm.$store.state._User.entNbPageMax))]),_c('br'),_vm._v("\n          "+_vm._s(_vm.$t('txt6InfoQuota'))+" "),_c('b',[_vm._v(_vm._s((_vm.renouvellementDay) ? _vm.$t('in')+' '+_vm.renouvellementDay : '')+" "+_vm._s(_vm.$tc('daysQuota', _vm.renouvellementDay, {count: ''})))]),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('txt2ExpireLicence')))]),_vm._v("\n          "+_vm._s((_vm.$store.state._User.entRefFacturation) ? _vm.$t('referentFacturation') + ' ' + _vm.$store.state._User.entRefFacturation.CLI_EMAIL : '')+"\n        ")]):(_vm.expireLicence)?_c('v-card-text',[_c('h3',[_vm._v(_vm._s(_vm.$t('txt1ExpireLicence') + ' ' + _vm.dateExpire))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('txt2ExpireLicence')))]),_vm._v("\n          "+_vm._s((_vm.$store.state._User.entRefFacturation) ? _vm.$t('referentFacturation') + ' ' + _vm.$store.state._User.entRefFacturation.CLI_EMAIL : '')+"\n        ")]):(_vm.sursisLicence)?_c('v-card-text',[_c('h3',[_vm._v(_vm._s(_vm.$t('txt1ExpireLicence') + ' ' + _vm.dateExpire))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_c('b',[_c('i',[_vm._v(_vm._s(_vm.$t('txt3ExpireLicence')))])]),_c('br'),_vm._v("\n            "+_vm._s(_vm.$t('txt4ExpireLicence') + ' ' + _vm.$store.state._User.surcisLicience + ' ' + _vm.$tc('days', _vm.$store.state._User.surcisLicience, {count: ''}) + ' ' + _vm.$t('txt5ExpireLicence'))+"\n          ")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('txt2ExpireLicence')))]),_vm._v("\n          "+_vm._s((_vm.$store.state._User.entRefFacturation) ? _vm.$t('referentFacturation') + ' ' + _vm.$store.state._User.entRefFacturation.CLI_EMAIL : '')+"\n        ")]):_c('v-card-text',[_c('h3',[_vm._v(" "+_vm._s(_vm.$t('txt1InfoQuota'))+" "+_vm._s(_vm.quotaPages.toFixed(2))+" % "+_vm._s(_vm.$t('txt2InfoQuota'))+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('txt3InfoQuota')))]),_vm._v(" "),_c('p',{staticClass:"red--text"},[_vm._v(_vm._s(_vm.$t('txt4InfoQuota')))]),_vm._v(" "),_c('p',[_vm._v("\n          "+_vm._s(_vm.$t('txt5InfoQuota'))+" "),_c('b',[_vm._v(_vm._s(_vm.$store.state._User.entNbPageMax))]),_c('br'),_vm._v("\n          "+_vm._s(_vm.$t('txt6InfoQuota'))+" "),_c('b',[_vm._v(_vm._s((_vm.renouvellementDay) ? _vm.$t('in')+' '+_vm.renouvellementDay : '')+" "+_vm._s(_vm.$tc('daysQuota', _vm.renouvellementDay, {count: ''})))])]),_vm._v("\n          "+_vm._s((_vm.$store.state._User.entRefFacturation) ? _vm.$t('referentFacturation') + ' ' + _vm.$store.state._User.entRefFacturation.CLI_EMAIL : '')+"\n        ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.LicenceOUT)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.souscrire()}}},[_vm._v("\n            "+_vm._s(_vm.$t('help'))+"\n          ")]):_c('v-btn',{attrs:{"color":"primary","href":_vm.Support,"target":"support"}},[_vm._v("\n            "+_vm._s(_vm.$t('support'))+"\n          ")]),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.continuer()}}},[_vm._v("\n            "+_vm._s(_vm.$t('continue'))+"\n          ")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.usrBoNotif === '1')?_c('v-dialog',{attrs:{"persistent":"","max-width":"480"},model:{value:(_vm.activeDialogc2c),callback:function ($$v) {_vm.activeDialogc2c=$$v},expression:"activeDialogc2c"}},[_c('v-card',[(_vm.C2CoffF || _vm.C2CoffM)?_c('v-card-title',{staticClass:"red white--text subheading"},[_vm._v("\n          "+_vm._s(_vm.$t('warning'))+"\n          "),_c('br'),_vm._v("\n          "+_vm._s(_vm.$t('warningC2C'))+". "+_vm._s(_vm.$t('infoConsumptionC2C') + ((_vm.depassementF > _vm.depassementM) ? _vm.depassementF : _vm.depassementM)+ ' %')+"\n        ")]):(_vm.C2CnearF || _vm.C2CnearM)?_c('v-card-title',{staticClass:"orange white--text subheading"},[_vm._v("\n          "+_vm._s(_vm.$t('warning'))+" "),_vm._v("\n          "+_vm._s(_vm.$t('warningC2Cnear'))+". ")]):_vm._e(),_vm._v(" "),_c('v-card-text',[_c('h3',[_vm._v(_vm._s(_vm.$t('txt1InfoQuota'))+" "),_c('br'),_vm._v("- "+_vm._s(_vm.depassementF)+" % "+_vm._s(_vm.$t('txt2InfoQuotaC2C'))+" "+_vm._s(_vm.$t('fixes'))+" "),_c('br'),_vm._v("- "+_vm._s(_vm.depassementM)+" % "+_vm._s(_vm.$t('mobiles'))+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.C2CnearF || _vm.C2CnearM)?_c('p',{staticClass:"red--text"},[_vm._v(_vm._s(_vm.$t('txt4InfoQuotaC2C')))]):_vm._e(),_vm._v(" "),_vm._v("\n          "+_vm._s(_vm.$t('txt5InfoQuotaC2C'))+" "),_c('br'),_c('b',[_vm._v(_vm._s(_vm.$tc('hours', _vm.$store.state._Sites.siteSelected.c2c_quota_sites_f, { count: _vm.$store.state._Sites.siteSelected.c2c_quota_sites_f }))+" "+_vm._s(_vm.$t('tofixes'))+" "),_c('br'),_vm._v(_vm._s(_vm.$tc('hours', _vm.$store.state._Sites.siteSelected.c2c_quota_sites_m, { count: _vm.$store.state._Sites.siteSelected.c2c_quota_sites_m }))+" "+_vm._s(_vm.$t('tomobiles')))]),_c('br'),_vm._v(" "),_c('br'),_c('p',[_vm._v(_vm._s(_vm.$t('txt3InfoQuotaC2C')))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(!_vm.LicenceOUT)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.souscrireC2C()}}},[_vm._v("\n            "+_vm._s(_vm.$t('help'))+"\n          ")]):_c('v-btn',{attrs:{"color":"primary","href":_vm.Support,"target":"support"}},[_vm._v("\n            "+_vm._s(_vm.$t('support'))+"\n          ")]),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.continuerC2C()}}},[_vm._v("\n            "+_vm._s(_vm.$t('continue'))+"\n          ")])],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.usrBoNotif === '1')?_c('v-dialog',{attrs:{"persistent":"","max-width":"480"},model:{value:(_vm.activeDialogCB),callback:function ($$v) {_vm.activeDialogCB=$$v},expression:"activeDialogCB"}},[_c('v-card',[(_vm.expireCB)?_c('v-card-title',{staticClass:"red white--text subheading"},[_vm._v("\n          "+_vm._s(_vm.$t('warning'))+"\n          "),_c('br'),_vm._v("\n          "+_vm._s(_vm.$t('cbExpire1'))+"\n        ")]):(_vm.cbExpirebientot)?_c('v-card-title',{staticClass:"orange white--text subheading"},[_vm._v("\n          "+_vm._s(_vm.$t('warning'))+"\n          "),_c('br'),_vm._v("\n          "+_vm._s(_vm.$t('cbExpire5'))+" "+_vm._s(_vm.delaiExpireCB)+"\n        ")]):_vm._e(),_vm._v(" "),_c('v-card-text',[_c('h3',[_vm._v(" "+_vm._s(_vm.$t('cbExpire2'))+" "+_vm._s(_vm.dateExpireLicence)+", "+_vm._s(_vm.$t('cbExpire3'))+" ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.$t('cbExpire4'))+" "),_c('a',{attrs:{"href":_vm.Support,"target":"support"}},[_vm._v(_vm._s(_vm.$t('support')))])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.majCB()}}},[_vm._v("\n            "+_vm._s(_vm.$t('majCb'))+"\n          ")]),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.continuerExpireCB()}}},[_vm._v("\n            "+_vm._s(_vm.$t('continue'))+"\n          ")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"450"},model:{value:(_vm.dialogBugScreenshot),callback:function ($$v) {_vm.dialogBugScreenshot=$$v},expression:"dialogBugScreenshot"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('sendFeedback')))]),_vm._v(" "),_c('v-card-text',[_c('v-textarea',{attrs:{"label":_vm.$t('yourFeedback'),"required":"","box":""},model:{value:(_vm.messageBug),callback:function ($$v) {_vm.messageBug=$$v},expression:"messageBug"}}),_vm._v(" "),_c('img',{attrs:{"src":_vm.imageUrl,"width":"100%","height":"auto"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary",attrs:{"loading":_vm.sendingReport,"disabled":!_vm.messageBug.trim().length},on:{"click":function($event){_vm.envoiBug()}}},[_vm._v("\n            "+_vm._s(_vm.$t('send'))+"\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("send")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290","persistent":""},model:{value:(_vm.dialogTooMuchAgents),callback:function ($$v) {_vm.dialogTooMuchAgents=$$v},expression:"dialogTooMuchAgents"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v("Oups !")]),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.$tc('tooMuchAgentsConnected', 1, { count: _vm.$store.state._User.entNbAgent }))}}),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"primary--text",attrs:{"block":"","flat":""},on:{"click":function($event){_vm.logout()}}},[_vm._v("\n            "+_vm._s(_vm.$t('logout') + ' (' + _vm.countdown + ' sec.)')+"\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("exit_to_app")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"850","persistent":""},model:{value:(_vm.installProgress),callback:function ($$v) {_vm.installProgress=$$v},expression:"installProgress"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v("Visite guidée")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          Prenez quelques minutes pour découvrir, étape par étape, comment bien paramétrer Target First.\n          "),_c('br'),_c('br'),_vm._v("Pour commencer la visite de votre Backoffice, cliquez sur \"Commencer la visite\". \n          "),_c('br'),_c('br'),_vm._v("Votre Backoffice est actuellement paramétré à "+_vm._s(_vm.progress)+"%.\n          "),(_vm.progress < 100)?_c('div',[_vm._v("\n            Encore quelques étapes clés à paramétrer. Pour y accéder, cliquez sur \"VOIR SECTION A PARAMETRER\", puis une fois sur place, vérifiez les réglages et sauvegardez les.\n          ")]):_c('div',[_vm._v("\n            Félicitation.\n            "),_c('br'),_vm._v("Gardez en tête que la section \"Ciblage comportemental\" doit rester viviante, en fonction de votre trafic et de vos offres. Mais pour le reste, vous êtes prêt.\n          ")]),_vm._v(" "),_c('br'),_vm._v("Si vous êtes perdu, les icônes en haut à droite vous proposent plusieurs aides :\n          "),_c('strong',[_c('br'),_c('img',{staticClass:"iconesAideTF",attrs:{"src":"watcheezy/src/assets/img/tutos/icone_boussole.png"}}),_vm._v(" Visite guidée\n          "),_c('br'),_c('img',{staticClass:"iconesAideTF",attrs:{"src":"watcheezy/src/assets/img/tutos/icone_chatbot.png"}}),_vm._v(" Chatbot d'aide\n          "),_c('br'),_c('img',{staticClass:"iconesAideTF",attrs:{"src":"watcheezy/src/assets/img/tutos/icone_bug.png"}}),_vm._v(" Contact support\n          "),_c('br'),_c('img',{staticClass:"iconesAideTF",attrs:{"src":"watcheezy/src/assets/img/tutos/icone_aide.png"}}),_vm._v(" Centre d'aide\n          "),_c('br'),_c('img',{staticClass:"iconesAideTF",attrs:{"src":"watcheezy/src/assets/img/tutos/icone_notif.png"}}),_vm._v(" Centre de notifications\n          ")])]),_vm._v(" "),_c('v-card-actions',{attrs:{"align":"center"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.startTuto()}}},[_vm._v("\n            Commencer la visite\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("send")])],1),_vm._v(" "),(_vm.progress < 100)?_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.nextStep()}}},[_vm._v("\n            Voir section à paramétrer\n          ")]):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.skipTuto()}}},[_vm._v("\n            Pas cette fois\n          ")]),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.blockTuto()}}},[_vm._v("\n            Ne plus me demander\n          ")])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var components_Dash = (esExports);
// CONCATENATED MODULE: ./src/components/Dash.vue
function injectStyle (ssrContext) {
  __webpack_require__("eZyM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5a203b02"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  Dash,
  components_Dash,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_components_Dash = (Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-gtm/dist/vue-gtm.min.js
var vue_gtm_min = __webpack_require__("Sl4y");
var vue_gtm_min_default = /*#__PURE__*/__webpack_require__.n(vue_gtm_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Login.vue








vue_esm["default"].use(vue_gtm_min_default.a, {});
/* harmony default export */ var Login = ({
  name: 'Login',
  data: function data() {
    var _this = this;

    return {
      domaine: constants_DOMAINE,

      user: {},

      loadingLogin: false,

      loadingRegister: false,

      dialogDeconnexion: false,

      settingsConnectStatusCookies: true,
      registering: false,
      email: '',
      password: '',

      url: '',
      confirmPassword: '',
      firstName: '',
      lastName: '',
      phone: '',
      rules: {
        confirmPassword: function confirmPassword(v) {
          return _this.confirmPassword === _this.password || _this.$t('pwdsNotMatch');
        }
      },

      dialog: false,
      wzkey: '',

      snack: {
        show: false,
        msg: '',
        context: 'info',
        btn: 'fermer'
      }
    };
  },


  computed: {
    progress: function progress() {
      return Math.min(100, this.password.length * 10);
    },
    color: function color() {
      return ['error', 'warning', 'success'][Math.floor(this.progress / 40)];
    }
  },

  created: function created() {
    var _this2 = this;

    if (window.location.origin.indexOf('www.watcheezy.net') > -1) {
      window.location.href = 'https://admin.targetfirst.com';
    }
    if (window.location.origin.indexOf('localhost') > -1) {
      this.email = 'demo@watcheezy.fr';
      this.password = '123456';
    }

    if (this.$route.query.email && !lodash_default.a.isNil(this.$route.query.email) && this.$route.query.password && !lodash_default.a.isNil(this.$route.query.password)) {
      this.email = this.$route.query.email;
      this.password = this.$route.query.password;
      this.login();
    } else if (this.$route.query.register && !lodash_default.a.isNil(this.$route.query.register)) {
      this.loadingRegister = true;
      this.email = this.$route.query.register;
      this.axios.get('get/check_register.php?email=' + this.email).then(function (res) {
        _this2.registering = true;
        _this2.$gtm.trackView('LoginRegister', 'currentpath');
        _this2.$gtm.trackEvent({
          event: null,
          category: 'arrivé page creation de compte',
          action: 'email valider',
          label: _this2.email + ' est sur la page de creation de compte',
          value: 10,
          noninteraction: false });
      }).catch(function () {
        _this2.email = '';
        window.location = constants_DOMAINE + '/#/login';
      }).then(function () {
        _this2.loadingRegister = false;
      });
    }

    if (this.$store.getters.logged) {
      this.$store.dispatch('logout');
    }
  },
  mounted: function mounted() {
    if (this.$store.state.reasonDeco) {
      this.dialogDeconnexion = true;
    }
    this.settingsFromCookies();
  },


  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])(['SET_REASON_DECO']), {
    closeDialogDeco: function closeDialogDeco() {
      console.log('close', this.dialogDeconnexion);
      this.dialogDeconnexion = false;
      this.SET_REASON_DECO(null);
    },
    settingsFromCookies: function settingsFromCookies() {
      this.settingsConnectStatusCookies = this.$cookie.get('wz-connecting-start') === 'true' || false;
    },
    login: function login() {
      var _this3 = this;

      if (!this.wzErrors.any()) {
        this.loadingLogin = true;
        this.axios.get('get/login.php?email=' + this.email + '&password=' + this.password).then(function (response) {
          var data = response.data;
          var session = data.session;
          if (data.redirect) {
            window.location.href = data.redirect;
          }
          _this3.user.id = session.user_id;
          _this3.user.fname = session.user_firstname;
          _this3.user.lname = session.user_lastname;
          _this3.user.mail = session.user_mail;
          _this3.user.mailContact = session.user_emailcontact;
          _this3.user.job = session.user_job;
          _this3.user.phone = session.user_tel;
          _this3.user.title = session.user_title;
          _this3.user.connectingOnline = _this3.settingsConnectStatusCookies;

          _this3.user.key = session.key;
          _this3.user.dispo = session.user_dispo;
          _this3.user.canBeUnavailable = session.user_can_be_unavailable === '1';

          _this3.user.rights = session.user_rights;
          _this3.user.chatsMax = session.user_nb_chat_max;

          _this3.user.chatNotif = session.user_chat_notif_onoff;
          _this3.user.priority = session.user_priority;
          _this3.user.keywords = session.user_keywords;

          _this3.user.multiSite = session.user_multisite;
          _this3.user.eezylead = session.eezylead_specialtable;
          _this3.user.licAllKeys = session.user_licAllKeys;

          _this3.user.licenceId = session.licence_id;

          _this3.user.licLang = session.lic_lang;

          _this3.user.callbackOnOff = session.callbackOnOff;

          _this3.user.licSpecialtable = session.lic_specialtable;
          _this3.user.licEezyLead = session.lic_eezy_lead;
          _this3.user.chatOnOff = session.chatOnOff;

          _this3.user.usr_is_bot = session.usr_is_bot;
          _this3.user.usr_time_transfert = session.usr_time_transfert;
          _this3.user.usr_bo_notif = session.usr_bo_notif;

          _this3.user.entRefFacturation = session.ent_ref_facturation;

          _this3.user.cbExpiration = session.ent_cb_expiration;

          _this3.user.entKey = session.ent_key;
          _this3.user.entId = session.ent_id;
          _this3.user.entName = session.ent_name;

          _this3.user.entDateCreation = session.ent_datecreation;
          _this3.user.entEezySubscription = session.ent_eezysubscription;
          _this3.user.entEezyExpiry = session.ent_eezyexpiry;

          _this3.user.entLevel = session.ent_level;

          _this3.user.entNbPageTotal = lodash_default.a.toInteger(session.ent_nbpagetotal);
          _this3.user.entNbPageThisMonth = session.ent_nbpagethismonth;
          _this3.user.entNbPageMax = session.ent_nbpagemax;
          _this3.user.entOptionPage = session.ent_optionpage;
          _this3.user.entNbAgent = session.ent_nbagent;

          _this3.user.entNbSite = session.ent_nbsite;

          _this3.user.entBeta = session.ent_beta === '1';
          _this3.user.facebookToken = session.facebook_token;
          _this3.user.facebookPage = session.facebook_page;

          _this3.user.entSF = session.ent_sf;
          _this3.user.entSFUsr = session.ent_sf_usr;
          _this3.user.entSFPwd = session.ent_sf_pwd;
          _this3.user.entSFToken = session.ent_sf_token;
          _this3.user.entZD = session.ent_zd;
          _this3.user.entZDUsr = session.ent_zd_usr;
          _this3.user.entZDDomain = session.ent_zd_domain;
          _this3.user.entZDToken = session.ent_zd_token;
          _this3.user.entOptionPush = session.ent_optionpush;
          _this3.user.entGA = session.ent_ga;
          _this3.user.entGAUsr = session.ent_ga_usr;
          _this3.user.entSlack = session.ent_slack;
          _this3.user.entSlackUsr = session.ent_slack_usr;

          _this3.user.maxVisitors = lodash_default.a.toInteger(session.ent_max_visitors);
          _this3.user.hideTabVisitors = session.ent_hide_tab_visitors;
          _this3.user.surcisLicience = session.ent_surcis_licence;
          _this3.user.smsOn = session.smsOn;
          _this3.user.consoLastDays = session.consoLastDays;
          _this3.user.installProgress = session.installProgress;
          _this3.user.remainingSteps = session.remainingSteps;
          _this3.user.ongoingTuto = false;
          _this3.user.tutoQuited = false;

          _this3.user.tempsTravail = session.user_time_day;
          _this3.user.jourHebdoTravail = session.user_day_hebdo;

          if (session.user_brides) {
            if (!session.user_rights_compte_conseillers_chat_max) {
              _this3.user.chatsMax = 1;
            }
            _this3.user.brides = [{ 'brideName': 'trafic', 'status': session.user_rights_trafic }, { 'brideName': 'trafic_visiteurs', 'status': session.user_rights_trafic_visiteurs }, { 'brideName': 'trafic_discussions', 'status': session.user_rights_trafic_discussions }, { 'brideName': 'trafic_monitoring', 'status': session.user_rights_trafic_monitoring }, { 'brideName': 'trafic_monitoring_chat_superviseur', 'status': session.user_rights_trafic_monitoring_chat_superviseur }, { 'brideName': 'stats', 'status': session.user_rights_stats }, { 'brideName': 'stats_audience', 'status': session.user_rights_stats_audience }, { 'brideName': 'stats_conversations', 'status': session.user_rights_stats_conversations }, { 'brideName': 'stats_chatbot', 'status': session.user_rights_stats_chatbot }, { 'brideName': 'stats_chatbot_histo', 'status': session.user_rights_stats_chatbot_histo }, { 'brideName': 'stats_conseillers', 'status': session.user_rights_stats_conseillers }, { 'brideName': 'stats_callback', 'status': session.user_rights_stats_callback }, { 'brideName': 'stats_ventes', 'status': session.user_rights_stats_ventes }, { 'brideName': 'stats_ventes_chatbot', 'status': session.user_rights_stats_ventes_chatbot }, { 'brideName': 'stats_ventes_callback', 'status': session.user_rights_stats_ventes_callback }, { 'brideName': 'stats_ventes_lead', 'status': session.user_rights_stats_ventes_lead }, { 'brideName': 'stats_leads', 'status': session.user_rights_stats_leads }, { 'brideName': 'stats_leads_getquanty', 'status': session.user_rights_stats_leads_getquanty }, { 'brideName': 'stats_leads_chaleur', 'status': session.user_rights_stats_leads_chaleur }, { 'brideName': 'stats_satisfaction', 'status': session.user_rights_stats_satisfaction }, { 'brideName': 'stats_rapports', 'status': session.user_rights_stats_rapports }, { 'brideName': 'compte', 'status': session.user_rights_compte }, { 'brideName': 'compte_conseillers', 'status': session.user_rights_compte_conseillers }, { 'brideName': 'compte_conseillers_chat_max', 'status': session.user_rights_compte_conseillers_chat_max }, { 'brideName': 'compte_conseillers_transfert', 'status': session.user_rights_compte_conseillers_transfert_auto }, { 'brideName': 'compte_conseillers_prioritaire', 'status': session.user_rights_compte_conseillers_prioritaire }, { 'brideName': 'compte_conseillers_api', 'status': session.user_rights_compte_conseillers_api }, { 'brideName': 'compte_conseillers_black_list', 'status': session.user_rights_compte_conseillers_black_list }, { 'brideName': 'compte_conseillers_indispo', 'status': session.user_rights_compte_conseillers_indispo }, { 'brideName': 'compte_conseillers_notifbo', 'status': session.user_rights_compte_conseillers_notifbo }, { 'brideName': 'compte_sites', 'status': session.user_rights_compte_sites }, { 'brideName': 'compte_attribution', 'status': session.user_rights_compte_attribution }, { 'brideName': 'ciblage', 'status': session.user_rights_ciblage }, { 'brideName': 'media', 'status': session.user_rights_media }, { 'brideName': 'media_phrases', 'status': session.user_rights_media_phrases }, { 'brideName': 'media_phrases_completion', 'status': session.user_rights_media_phrases_completion }, { 'brideName': 'media_push', 'status': session.user_rights_media_push }, { 'brideName': 'parametre', 'status': session.user_rights_parametre }, { 'brideName': 'parametre_apercu', 'status': session.user_rights_parametre_apercu }, { 'brideName': 'parametre_apercu_couleurs', 'status': session.user_rights_parametre_apercu_couleurs }, { 'brideName': 'parametre_apercu_dimensions', 'status': session.user_rights_parametre_apercu_dimensions }, { 'brideName': 'parametre_apercu_coins', 'status': session.user_rights_parametre_apercu_coins }, { 'brideName': 'parametre_apercu_position', 'status': session.user_rights_parametre_apercu_position }, { 'brideName': 'parametre_apercu_mobile_position', 'status': session.user_rights_parametre_apercu_mobile_position }, { 'brideName': 'parametre_apercu_desk', 'status': session.user_rights_parametre_apercu_desk }, { 'brideName': 'parametre_apercu_mobile_desk', 'status': session.user_rights_parametre_apercu_mobile_desk }, { 'brideName': 'parametre_apercu_sideon', 'status': session.user_rights_parametre_apercu_sideon }, { 'brideName': 'parametre_apercu_hide_moyen', 'status': session.user_rights_parametre_apercu_hide_moyen }, { 'brideName': 'parametre_apercu_conseiller', 'status': session.user_rights_parametre_apercu_conseiller }, { 'brideName': 'parametre_apercu_bot', 'status': session.user_rights_parametre_apercu_bot }, { 'brideName': 'parametre_apercu_hide_liste', 'status': session.user_rights_parametre_apercu_hide_liste }, { 'brideName': 'parametre_apercu_geoloc', 'status': session.user_rights_parametre_apercu_geoloc }, { 'brideName': 'parametre_apercu_lang', 'status': session.user_rights_parametre_apercu_lang }, { 'brideName': 'parametre_apercu_title_close', 'status': session.user_rights_parametre_apercu_title_close }, { 'brideName': 'parametre_apercu_title_offline', 'status': session.user_rights_parametre_apercu_title_offline }, { 'brideName': 'parametre_apercu_title_online', 'status': session.user_rights_parametre_apercu_title_online }, { 'brideName': 'parametre_apercu_message1', 'status': session.user_rights_parametre_apercu_message1 }, { 'brideName': 'parametre_apercu_message2', 'status': session.user_rights_parametre_apercu_message2 }, { 'brideName': 'parametre_affichage', 'status': session.user_rights_parametre_affichage }, { 'brideName': 'parametre_affichage_perso', 'status': session.user_rights_parametre_affichage_perso }, { 'brideName': 'parametre_affichage_perso_cible', 'status': session.user_rights_parametre_affichage_perso_cible }, { 'brideName': 'parametre_affichage_horaire', 'status': session.user_rights_parametre_affichage_horaire }, { 'brideName': 'parametre_affichage_url', 'status': session.user_rights_parametre_affichage_url }, { 'brideName': 'parametre_chat', 'status': session.user_rights_parametre_chat }, { 'brideName': 'parametre_chat_invitation', 'status': session.user_rights_parametre_chat_invitation }, { 'brideName': 'parametre_chat_formprechat', 'status': session.user_rights_parametre_chat_formprechat }, { 'brideName': 'parametre_chat_premiermessage', 'status': session.user_rights_parametre_chat_premiermessage }, { 'brideName': 'parametre_chat_reponseauto', 'status': session.user_rights_parametre_chat_reponseauto }, { 'brideName': 'parametre_chat_editlead', 'status': session.user_rights_parametre_chat_editlead }, { 'brideName': 'parametre_chat_istyping', 'status': session.user_rights_parametre_chat_istyping }, { 'brideName': 'parametre_chat_iframe', 'status': session.user_rights_parametre_chat_iframe }, { 'brideName': 'parametre_callback', 'status': session.user_rights_parametre_callback }, { 'brideName': 'parametre_bot', 'status': session.user_rights_parametre_bot }, { 'brideName': 'parametre_cobrowsing', 'status': session.user_rights_parametre_cobrowsing }, { 'brideName': 'parametre_cobrowsing_cobrowsing', 'status': session.user_rights_parametre_cobrowsing_cobrowsing }, { 'brideName': 'parametre_cobrowsing_mirroring', 'status': session.user_rights_parametre_cobrowsing_mirroring }, { 'brideName': 'parametre_ecommerce', 'status': session.user_rights_parametre_ecommerce }, { 'brideName': 'parametre_connecteur', 'status': session.user_rights_parametre_connecteur }, { 'brideName': 'parametre_connecteur_facebook', 'status': session.user_rights_parametre_connecteur_facebook }, { 'brideName': 'parametre_connecteur_messenger', 'status': session.user_rights_parametre_connecteur_messenger }, { 'brideName': 'parametre_connecteur_salseforce', 'status': session.user_rights_parametre_connecteur_salseforce }, { 'brideName': 'parametre_connecteur_zendesk', 'status': session.user_rights_parametre_connecteur_zendesk }, { 'brideName': 'parametre_connecteur_analytics', 'status': session.user_rights_parametre_connecteur_analytics }, { 'brideName': 'parametre_connecteur_slack', 'status': session.user_rights_parametre_connecteur_slack }, { 'brideName': 'parametre_connecteur_vyte', 'status': session.user_rights_parametre_connecteur_vyte }, { 'brideName': 'parametre_push', 'status': session.user_rights_parametre_push }, { 'brideName': 'parametre_push_auto', 'status': session.user_rights_parametre_push_auto }, { 'brideName': 'parametre_analytics', 'status': session.user_rights_parametre_analytics }, { 'brideName': 'parametre_recall', 'status': session.user_rights_parametre_recall }, { 'brideName': 'parametre_sms', 'status': session.user_rights_parametre_sms }, { 'brideName': 'parametre_absence', 'status': session.user_rights_parametre_absence }, { 'brideName': 'parametre_messaging', 'status': session.user_rights_parametre_messaging }, { 'brideName': 'multisite_indicateur', 'status': session.user_rights_multisite_indicateur }];
          }

          _this3.user.deskAutochat = session.desk_autochat;
          _this3.user.askGeoloc = session.desk_ask_geoloc;

          _this3.user.connectFromAdmin = session.connectFromAdmin;
          _this3.user.colleagues = session.user_colleagues;
          _this3.user.user_sites = session.user_sites;
          _this3.user.bots = session.user_bots;
          _this3.user.filterFront = session.ent_filter_front;

          _this3.user.lang = _this3.$i18n.locale;
          _this3.$cookie.set('wz-lang', _this3.$i18n.locale, { expires: '1Y' });

          _this3.user.avatar = null;
          var avatar = session.avatarfilename;
          if (avatar !== 'unknown.gif' && !lodash_default.a.isNil(avatar) && avatar !== '') {
            _this3.user.avatar = avatar;
          }
          console.log('this.user', _this3.user);
          _this3.$store.dispatch('loginUser', _this3.user);

          _this3.$cookie.set('memoDialogQuota', '0', { expires: '10h' });
          _this3.$cookie.set('memoDialogC2C', '0', { expires: '10h' });
          _this3.$cookie.set('memoDialogExpireCB', '0', { expires: '10h' });
          _this3.getMessagesAttentes();
        }).catch(function (resp) {
          _this3.loadingLogin = false;

          if (resp.response.status === 401) {
            _this3.snack.msg = 'Account disabled';
          } else {
            _this3.snack.msg = _this3.$t('emailPassNotMatch');
          }
          _this3.snack.context = 'error';
          _this3.snack.show = true;
        });
      } else {
        this.snack.msg = this.$t('notFilled');
        this.snack.context = 'error';
        this.snack.show = true;
      }
    },
    updateLang: function updateLang(newLang) {
      this.$i18n.locale = newLang;
    },
    getMessagesAttentes: function getMessagesAttentes() {
      var _this4 = this;

      this.loadingLogin = true;
      this.axios.get('get/chats_abscence.php?agentId=' + this.user.id).then(function (response) {
        _this4.user.listeMessages = response.data;

        lodash_default.a.forEach(_this4.user.listeMessages, function (allVisiteurs, key) {
          if (allVisiteurs.network === 'facebook') {
            var dataVisiteur = { 'visiteurData': allVisiteurs, 'key': key };
            _this4.getAvatarVisiteur(dataVisiteur);
          }
        });

        _this4.loadingLogin = false;
      }).catch(function (_) {}).then(function (_) {});
    },
    getAvatarVisiteur: function getAvatarVisiteur(data) {
      var _this5 = this;

      this.axios.get('get/chats_abscence_avatar.php?visitorId=' + data.visiteurData.visiteurID).then(function (response) {
        if (response.data) {
          data.visiteurData.profile_pic = response.data;
          _this5.user.listeMessages.splice(data.key, 1, data.visiteurData);
        }
      }).catch(function (_) {}).then(function (_) {});
    },
    register: function register() {
      var _this6 = this;

      this.$validator.validateAll();
      if (this.wzErrors.any()) {
        this.snack.msg = this.$t('notFilled');
        this.snack.context = 'error';
        this.snack.show = true;
        return;
      }

      var dataToPost = new window.FormData();
      dataToPost.append('url', this.url);
      dataToPost.append('email', this.email);
      dataToPost.append('password', this.password);
      dataToPost.append('firstName', this.firstName);
      dataToPost.append('lastName', this.lastName);
      dataToPost.append('phone', this.phone);
      this.loadingLogin = true;
      this.axios.post('post/register.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this6.wzkey = response.data;
        _this6.dialog = true;
        _this6.trackEvent();
      }).catch(function () {
        _this6.snack.msg = _this6.$t('error');
        _this6.snack.context = 'error';
        _this6.snack.show = true;
      }).then(function () {
        _this6.loadingLogin = false;
      });
    },
    retrieve: function retrieve() {
      var _this7 = this;

      var dataToPost = new window.FormData();
      dataToPost.append('email', this.email);
      dataToPost.append('lang', this.$i18n.locale);
      this.loadingLogin = true;
      this.axios.post('post/pwd_retrieve.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this7.dialogRetrieve = false;
      }).catch(function () {
        _this7.snack.msg = _this7.$t('error');
        _this7.snack.context = 'error';
        _this7.snack.show = true;
      }).then(function () {
        _this7.loadingLogin = false;
      });
    },
    trackEvent: function trackEvent() {
      this.$gtm.trackEvent({
        event: null,
        category: 'register OK',
        action: 'Validation',
        label: 'finalisation inscription essai',
        value: 5000,
        noninteraction: false });
    }
  }),
  watch: {
    settingsConnectStatusCookies: function settingsConnectStatusCookies(v) {
      this.$cookie.set('wz-connecting-start', v, { expires: '1Y' });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0e380994","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login.vue
var Login_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{attrs:{"light":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[(!_vm.$store.state.logged)?_c('div',{staticClass:"test-hotfix",class:{'login' : _vm.$vuetify.breakpoint.smAndUp}},[_c('v-layout',{attrs:{"hidden-sm-and-down":""}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"md2":""}}),_vm._v(" "),_c('v-flex',{staticStyle:{"width":"400px"},attrs:{"xs12":"","sm8":""}},[(_vm.loadingRegister)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"size":70,"width":1,"indeterminate":""}})],1):(!_vm.registering)?_c('v-card',{attrs:{"flat":_vm.$vuetify.breakpoint.xsOnly}},[_c('v-card-title',{staticClass:"primary",attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"lg2":""}}),_vm._v(" "),_c('img',{staticStyle:{"max-width":"100%","max-height":"200px","width":"auto","height":"auto"},attrs:{"src":_vm.domaine.indexOf('targetfirst') !== -1
                        ? (_vm.domaine + "/static/logo_tf.png")
                        : (_vm.domaine + "/watcheezy/static/logo_tf.png")}}),_vm._v(" "),_c('v-flex',{attrs:{"lg2":""}})],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-container',[_c('form',{attrs:{"autocomplete":"on"}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"label":_vm._f("cap")(_vm.$t('email')),"type":"email","data-vv-name":"email","required":"","error":_vm.wzErrors.has('email'),"error-messages":_vm.wzErrors.collect('email'),"prepend-icon":"mail","autofocus":""},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":_vm._f("cap")(_vm.$t('password')),"type":"password","data-vv-name":"password","required":"","error":_vm.wzErrors.has('password'),"error-messages":_vm.wzErrors.collect('password'),"prepend-icon":"lock"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.login($event)}},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}})],1),_vm._v(" "),_c('v-btn',{staticClass:"white--text",attrs:{"block":"","color":"secondary","loading":_vm.loadingLogin,"disabled":_vm.wzErrors.any()},on:{"click":function($event){_vm.login()}}},[_vm._v(_vm._s(_vm.$t('login')))]),_vm._v(" "),_c('v-checkbox',{attrs:{"label":_vm.$t('connectingOnline'),"color":"primary","disabled":_vm.loadingLogin},model:{value:(_vm.settingsConnectStatusCookies),callback:function ($$v) {_vm.settingsConnectStatusCookies=$$v},expression:"settingsConnectStatusCookies"}}),_vm._v(" "),_c('wz-switch-lang',{on:{"change":_vm.updateLang}}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","lg6":""}},[_c('v-btn',{attrs:{"disabled":_vm.loadingLogin,"flat":"","block":"","href":(_vm.domaine + "/login/retrievepassword_fr.php")}},[_vm._v("\n                          "+_vm._s(_vm.$t('passwordForgotten'))+"\n                        ")])],1)],1)],1)],1)],1):_c('v-card',{attrs:{"flat":_vm.$vuetify.breakpoint.xsOnly}},[_c('v-card-title',{staticClass:"primary",attrs:{"primary-title":""}},[_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"lg2":""}}),_vm._v(" "),_c('img',{staticStyle:{"max-width":"100%","max-height":"200px","width":"auto","height":"auto"},attrs:{"src":(_vm.domaine + "/static/logo_tf.png")}}),_vm._v(" "),_c('v-flex',{attrs:{"lg2":""}})],1)],1),_vm._v(" "),_c('v-container',[_c('v-card-text',[_c('form',{attrs:{"autocomplete":"on"}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|url:require_protocol'),expression:"'required|url:require_protocol'"}],attrs:{"prepend-icon":"http","label":"URL de votre site","data-vv-name":"url","required":"","error":_vm.wzErrors.has('url'),"error-messages":_vm.wzErrors.collect('url')},model:{value:(_vm.url),callback:function ($$v) {_vm.url=$$v},expression:"url"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"mail","label":"Mail de contact","readonly":"","required":""},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|min:12'),expression:"'required|min:12'"}],attrs:{"label":_vm.$t('password'),"type":"password","data-vv-name":"password","required":"","error":_vm.wzErrors.has('password'),"error-messages":_vm.wzErrors.collect('password'),"prepend-icon":"lock","loading":""},model:{value:(_vm.password),callback:function ($$v) {_vm.password=$$v},expression:"password"}},[_c('v-progress-linear',{attrs:{"slot":"progress","value":_vm.progress,"height":"5","color":_vm.color},slot:"progress"})],1),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Confirmez votre mot de passe","type":"password","rules":[_vm.rules.confirmPassword],"data-vv-name":"confirmPassword","required":"","error":_vm.wzErrors.has('confirmPassword'),"error-messages":_vm.wzErrors.collect('confirmPassword'),"prepend-icon":"lock"},model:{value:(_vm.confirmPassword),callback:function ($$v) {_vm.confirmPassword=$$v},expression:"confirmPassword"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"prepend-icon":"accessibility","label":"Votre prénom","data-vv-name":"firstName","required":"","error":_vm.wzErrors.has('firstName'),"error-messages":_vm.wzErrors.collect('firstName')},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v},expression:"firstName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"accessibility","label":"Votre nom"},model:{value:(_vm.lastName),callback:function ($$v) {_vm.lastName=$$v},expression:"lastName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"prepend-icon":"phone","label":"Votre téléphone"},model:{value:(_vm.phone),callback:function ($$v) {_vm.phone=$$v},expression:"phone"}})],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"white--text",attrs:{"block":"","color":"secondary","loading":_vm.loadingLogin,"disabled":_vm.wzErrors.any() || _vm.confirmPassword != _vm.password},on:{"click":function($event){_vm.register()}}},[_vm._v("\n                      S'inscrire !\n                      "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("send")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"md2":""}})],1)],1):_vm._e()]),_vm._v(" "),_c('v-flex',{attrs:{"md6":"","hidden-sm-and-down":""}},[_c('iframe',{attrs:{"src":"https://admin.targetfirst.com/login/news/news-4.html","width":"100%","height":"100%"}})])],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"400"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"title primary white--text"},[_vm._v(_vm._s(_vm.$t('congratulations')))]),_vm._v(" "),_c('v-card-text',[_c('span',[_vm._v(_vm._s(_vm.$t('registrationOk')))]),_vm._v(" "),_c('v-textarea',{staticClass:"code-HTML",attrs:{"outline":"","label":"Votre script Target First","readonly":"","value":'<script type=\'text/javascript\' src=\'//www.watcheezy.net/deliver/targetfirst.js?wzkey=' + _vm.wzkey + '\'></script>'}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"white--text",attrs:{"block":"","color":"secondary","loading":_vm.loadingLogin,"disabled":_vm.wzErrors.any()},on:{"click":function($event){_vm.login()}}},[_vm._v(" "+_vm._s(_vm.$t('login'))+" ")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogDeconnexion),callback:function ($$v) {_vm.dialogDeconnexion=$$v},expression:"dialogDeconnexion"}},[(_vm.$store.state.reasonDeco)?_c('v-card',[_c('v-card-title',{staticClass:"title primary white--text"},[_vm._v(_vm._s(_vm.$t(_vm.$store.state.reasonDeco.title)))]),_vm._v(" "),_c('v-card-text',[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t(_vm.$store.state.reasonDeco.content))}})]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"block":"","color":"primary","flat":""},on:{"click":function($event){_vm.closeDialogDeco()}}},[_vm._v("ok")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-snackbar',{attrs:{"left":""},model:{value:(_vm.snack.show),callback:function ($$v) {_vm.$set(_vm.snack, "show", $$v)},expression:"snack.show"}},[_vm._v("\n      "+_vm._s(_vm.snack.msg)+"\n      "),_c('v-btn',{class:_vm.snack.context + '--text',attrs:{"flat":""},on:{"click":function($event){_vm.snack.show = false}}},[_vm._v("\n        "+_vm._s(_vm.snack.btn)+"\n        "),_c('span',[(_vm.snack.context == 'success')?_c('v-icon',{attrs:{"right":""}},[_vm._v("check_circle")]):(_vm.snack.context == 'info')?_c('v-icon',{attrs:{"right":""}},[_vm._v("info")]):(_vm.snack.context == 'warning')?_c('v-icon',{attrs:{"right":""}},[_vm._v("warning")]):(_vm.snack.context == 'error')?_c('v-icon',{attrs:{"right":""}},[_vm._v("error")]):_vm._e()],1)])],1)],1)}
var Login_staticRenderFns = []
var Login_esExports = { render: Login_render, staticRenderFns: Login_staticRenderFns }
/* harmony default export */ var components_Login = (Login_esExports);
// CONCATENATED MODULE: ./src/components/Login.vue
function Login_injectStyle (ssrContext) {
  __webpack_require__("hM0L")
}
var Login_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Login___vue_template_functional__ = false
/* styles */
var Login___vue_styles__ = Login_injectStyle
/* scopeId */
var Login___vue_scopeId__ = "data-v-0e380994"
/* moduleIdentifier (server only) */
var Login___vue_module_identifier__ = null
var Login_Component = Login_normalizeComponent(
  Login,
  components_Login,
  Login___vue_template_functional__,
  Login___vue_styles__,
  Login___vue_scopeId__,
  Login___vue_module_identifier__
)

/* harmony default export */ var src_components_Login = (Login_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Dashboard.vue





/* harmony default export */ var Dashboard = ({
  data: function data() {
    return {
      sheet: false,
      interval: null,
      txt: ''
    };
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])('_Notifier', ['CLEAR']), Object(vuex_esm["b" /* mapActions */])('_Notifier', ['HIDE']), {
    addVisitors: function addVisitors(nb) {
      for (var i = 0; i < nb; i++) {
        var id = lodash_default.a.uniqueId();
        this.$store.commit('_StoreWatcheeBox/SOCKET_NEW_VISITEUR', {
          newVisiteur: ['visiteur', id, id, 1, 0, '4528', 'online', 'FR', id, '', 2, 2, 'azerty', '#ziLeCXG9SwBsZL9nAAAE', '54.76.102.32', 0, '', '', '', '', '', '', ''],
          entId: this.$store.state._User.entId,
          maxVisitors: this.$store.state._User.maxVisitors,
          listAllSiteID: ['4528']
        });
      }
    },
    addNotif: function addNotif(context) {
      this.$store.dispatch('_Notifier/NEW_NOTIF', {
        message: 'nouvelle notification',
        context: context
      });
    }
  }),
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_Notifier', ['index']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-76b25982","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dashboard.vue
var Dashboard_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"dashboard"}},[_c('v-layout',{staticClass:"row wrap"},[_c('v-flex',{staticClass:"xs12"},[_c('v-btn',{on:{"click":function($event){_vm.addVisitors(48)}}},[_vm._v("+48")]),_vm._v(" "),_c('v-btn',{on:{"click":function($event){_vm.addVisitors(1)}}},[_vm._v("+1")]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.$store.state._StoreWatcheeBox.listeAllVisiteurs.length))])],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","color":"info"},on:{"click":function($event){_vm.addNotif('info')}}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","color":"warning"},on:{"click":function($event){_vm.addNotif('warning')}}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","color":"error"},on:{"click":function($event){_vm.addNotif('error')}}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-btn',{attrs:{"fab":"","color":"success"},on:{"click":function($event){_vm.addNotif('success')}}},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","large":""},on:{"click":function($event){_vm.CLEAR()}}},[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","large":""},on:{"click":function($event){_vm.HIDE()}}},[_c('v-icon',[_vm._v("visibility_off")])],1),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.index))]),_vm._v(" "),_c('pre',[_vm._v(_vm._s(_vm.$store.state._Notifier))])],1)}
var Dashboard_staticRenderFns = []
var Dashboard_esExports = { render: Dashboard_render, staticRenderFns: Dashboard_staticRenderFns }
/* harmony default export */ var components_Dashboard = (Dashboard_esExports);
// CONCATENATED MODULE: ./src/components/Dashboard.vue
var Dashboard_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Dashboard___vue_template_functional__ = false
/* styles */
var Dashboard___vue_styles__ = null
/* scopeId */
var Dashboard___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Dashboard___vue_module_identifier__ = null
var Dashboard_Component = Dashboard_normalizeComponent(
  Dashboard,
  components_Dashboard,
  Dashboard___vue_template_functional__,
  Dashboard___vue_styles__,
  Dashboard___vue_scopeId__,
  Dashboard___vue_module_identifier__
)

/* harmony default export */ var src_components_Dashboard = (Dashboard_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-522f0244","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Trafic.vue
var Trafic_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"trafic"},[_c('transition',{attrs:{"name":"slide-x-reverse-transition","mode":"out-in"}},[_c('router-view')],1)],1)}
var Trafic_staticRenderFns = []
var Trafic_esExports = { render: Trafic_render, staticRenderFns: Trafic_staticRenderFns }
/* harmony default export */ var Trafic = (Trafic_esExports);
// CONCATENATED MODULE: ./src/components/Trafic.vue
var Trafic_normalizeComponent = __webpack_require__("VU/8")
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var Trafic___vue_template_functional__ = false
/* styles */
var Trafic___vue_styles__ = null
/* scopeId */
var Trafic___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Trafic___vue_module_identifier__ = null
var Trafic_Component = Trafic_normalizeComponent(
  __vue_script__,
  Trafic,
  Trafic___vue_template_functional__,
  Trafic___vue_styles__,
  Trafic___vue_scopeId__,
  Trafic___vue_module_identifier__
)

/* harmony default export */ var components_Trafic = (Trafic_Component.exports);

// CONCATENATED MODULE: ./src/mixins/monitor.js






/* harmony default export */ var monitor = ({
  data: function data() {
    return {
      idInterval: null,
      monitorRequest: false,
      visiteurData: {},

      datasMonitorVisiteurs: [],
      filterFront: Number(this.$store.state._User.filterFront)
    };
  },
  mounted: function mounted() {
    if (!this.filterFront) {
      if (this.level.monitor) {
        this.initMonitor();
      }
    }
  },


  watch: {
    '$store.state._StoreWatcheeBox.status': function $storeState_StoreWatcheeBoxStatus(v) {
      if (v === 'online' && this.level.monitor && !this.monitorRequest) {
        if (!this.filterFront) {
          this.checkInfosVisiteurs();
        }
      }
    }
  },

  methods: {
    initMonitor: function initMonitor() {
      var _this = this;

      if (!this.monitorRequest) {
        this.checkInfosVisiteurs();
      }

      this.idInterval = setInterval(function () {
        if (!_this.monitorRequest) {
          _this.checkInfosVisiteurs();
        }
      }, this.level.monitor);
    },
    stopMonitor: function stopMonitor() {
      clearInterval(this.idInterval);
    },
    focusView: function focusView(data) {
      var indexNotif = -1;
      lodash_default.a.each(this.$store.state._Notifier.notifications, function (notif, idx) {
        if (notif.data && notif.data.visiteurID === data.visiteurID) {
          indexNotif = idx;
        }
      });

      if (indexNotif !== -1) {
        this.$store.commit('_Notifier/REMOVE_NOTIF', indexNotif);
      }
      this.$store.commit('_StoreWatcheeBox/AGENT_FOCUS', data);
      if (data.view !== this.focusPupitre.view) {
        watcheebox_watcheebox.changeFocusAgent({
          socket: this.$socket,
          datasAgent: this.user,
          focusSessionID: data.visiteurID,
          focusAgent: true
        });
      }
    },
    MonitorMajHistoChat: function MonitorMajHistoChat(data) {
      this.datasMonitorVisiteurs = data;
      console.log('maj histoChat dans monitor', this.datasMonitorVisiteurs);
    },
    checkInfosVisiteurs: function checkInfosVisiteurs() {
      var _this2 = this;

      console.log('checkInfosVisiteurs');

      if (this.$store.state._StoreWatcheeBox.status !== 'online') {
        this.datasMonitorVisiteurs = lodash_default.a.cloneDeep(this.listeAllVisiteurs);
        this.modifVisiteursMonitor();
        return;
      }
      this.monitorRequest = true;
      var newArray = [];
      lodash_default.a.forEach(this.listeAllVisiteurs, function (visiteur, key) {
        var newTab = [visiteur.status, visiteur.lang, visiteur.visiteurID, visiteur.roomName];
        newArray.push(newTab);
      });

      var config = {
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };

      var dataToPost = new window.FormData();
      dataToPost.append('key', this.user.key);
      dataToPost.append('listVis', stringify_default()(newArray));
      dataToPost.append('nbChatMax', this.user.chatsMax);
      dataToPost.append('keyEnt', this.user.entKey);

      dataToPost.append('allLic', this.user.licAllKeys.join('|'));

      dataToPost.append('listOpened', this.allChatsOpened);

      dataToPost.append('lang', this.user.licLang);

      dataToPost.append('agentAvailability', this.user.dispo);

      dataToPost.append('mUrl', this.user.multiSite);
      dataToPost.append('exclusion', this.user.user_sites);


      this.axios.post('post/monitor.php', dataToPost, config).then(function (response) {
        if (!lodash_default.a.isNil(response.data)) {
          lodash_default.a.forEach(response.data, function (dataChatVisiteur, key) {
            if (dataChatVisiteur.dateLastChat && dataChatVisiteur.dateLastChat.indexOf('|') !== -1) {
              dataChatVisiteur.dateLastChat = null;
            }
          });
          _this2.datasMonitorVisiteurs = response.data;
        }
        _this2.modifVisiteursMonitor();
      }).catch().then(function (_) {
        _this2.monitorRequest = false;
      });
    },
    autoInvit: function autoInvit(data) {
      if (data.sentence === 0) {
        data.delay += 3;
      }
      data.msg = data.msg.replace(/%%/g, "'");
      data.msg = data.msg.replace(/autochat_/g, '');
      data.msg = data.msg.replace(/push_/g, '');

      var timeout = 1;

      if (data.delay !== '') {
        timeout = parseInt(data.delay) * 1000;

        for (var key in this.pendingInvit) {
          if (key === data.visiteurID) {
            delete this.pendingInvit[data.visiteurID];
          }
        }

        this.pendingInvit[data.visiteurID] = setTimeout(function () {
          this.writeToVis(data);
        }, timeout);
      } else {
        this.writeToVis(data);
      }
    },
    writeToVis: function writeToVis(data) {
      var dataThisVisiteur = {
        socketID: data.socketID,
        visiteurID: data.visiteurID,
        siteID: data.siteID
      };

      if (data.socketIdDest !== '') {
        var agentSocketID = this.mySocketID;

        watcheebox_watcheebox.envoisMessage({
          socket: this.$socket,
          agentSocketID: agentSocketID,
          datasAgent: this.user,
          datasVisiteur: dataThisVisiteur,
          message: data.msg,
          messageType: data.type,
          filterId: data.filId,
          agentName: unescape(this.fullName)
        });

        if (data.type === 1) {}

        for (var key in this.pendingInvit) {
          if (key === data.visiteurID) {
            delete this.pendingInvit[key];
          }
        }

        if (data.vwId !== '') {
          var config = {
            responseType: 'json',
            headers: {
              'X-Requested-With': 'XMLHttpRequest',
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          };

          var dataAjax = {
            params: {
              id: data.vwId,
              specialtable: data.specialtable
            }
          };
          var file = '';
          if (data.type === 2) {
            file = 'autochatted';
          } else if (data.type === 3) {
            file = 'pushed';
          }
          this.axios.get('put/visitor_' + file + '.php', dataAjax, config).then(function (response) {
            if (!lodash_default.a.isNil(response.data)) {}
          }).catch().then(function (_) {});
        }
      } else {
        return 0;
      }
    },
    ouvertureAuto: function ouvertureAuto(data) {
      var _this3 = this;

      var dataThisVisiteur = {
        socketID: data.socketID,
        visiteurID: data.visiteurID,
        siteID: data.siteID
      };
      setTimeout(function () {
        if (data.socketID !== '') {
          var agentSocketID = _this3.mySocketID;

          watcheebox_watcheebox.forceOuvertureModule({
            socket: _this3.$socket,
            agentSocketID: agentSocketID,
            datasAgent: _this3.user,
            datasVisiteur: dataThisVisiteur,
            agentName: unescape(_this3.fullName)
          });
          return 1;
        } else {
          return 0;
        }
      }, 1000);
    },
    modifVisiteursMonitor: function modifVisiteursMonitor() {
      var _this4 = this;

      this.datasMonitorVisiteurs = lodash_default.a.toArray(this.datasMonitorVisiteurs);

      lodash_default.a.forEach(this.listeAllVisiteurs, function (visiteur, key) {
        if (!visiteur) {
          _this4.$store.commit('_StoreWatcheeBox/REMOVE_VISITEUR_BY_INDEX', key);
          return;
        }

        var index = lodash_default.a.findIndex(_this4.datasMonitorVisiteurs, {
          visiteurID: visiteur.visiteurID
        });
        if (index === -1) {
          return;
        }

        if (!visiteur.visiteurName || visiteur.visiteurName === undefined) {
          var newDatasVisiteur = lodash_default.a.cloneDeep(visiteur);
          newDatasVisiteur.visiteurName = _this4.datasMonitorVisiteurs[index].shortdesc;
          newDatasVisiteur.alreadyConsulted = _this4.datasMonitorVisiteurs[index].alreadyConsulted;
          newDatasVisiteur.autoInvit = _this4.datasMonitorVisiteurs[index].autoInvit;
          newDatasVisiteur.autoInvitType = _this4.datasMonitorVisiteurs[index].autoInvitType;
          newDatasVisiteur.autoinvitSend = _this4.datasMonitorVisiteurs[index].autoinvitSend;
          newDatasVisiteur.dateLastChat = _this4.datasMonitorVisiteurs[index].dateLastChat;
          newDatasVisiteur.getplusinfoavailable = _this4.datasMonitorVisiteurs[index].getplusinfoavailable;
          newDatasVisiteur.key = _this4.datasMonitorVisiteurs[index].key;
          newDatasVisiteur.keyVis = _this4.datasMonitorVisiteurs[index].keyVis;
          newDatasVisiteur.listAlert = _this4.datasMonitorVisiteurs[index].listAlert;
          newDatasVisiteur.nbCustomAlert = _this4.datasMonitorVisiteurs[index].nbCustomAlert;
          newDatasVisiteur.nb_alert = _this4.datasMonitorVisiteurs[index].nb_alert;
          newDatasVisiteur.nbchats = _this4.datasMonitorVisiteurs[index].nbchats;
          newDatasVisiteur.pagesFocus = _this4.datasMonitorVisiteurs[index].pagesFocus;
          newDatasVisiteur.ponderation = _this4.datasMonitorVisiteurs[index].ponderation;
          newDatasVisiteur.savedConversation = _this4.datasMonitorVisiteurs[index].savedConversation;
          newDatasVisiteur.visId = _this4.datasMonitorVisiteurs[index].visId;
          newDatasVisiteur.visitorApiInfo = _this4.datasMonitorVisiteurs[index].visitorApiInfo;
          newDatasVisiteur.wz_textSocialNotif = _this4.datasMonitorVisiteurs[index].wz_textSocialNotif;

          _this4.$store.commit('_StoreWatcheeBox/SET_VISITEURS', newDatasVisiteur);
        }

        var newDatas = _this4.datasMonitorVisiteurs[index];
        newDatas.status = visiteur.status;
        newDatas.socketID = visiteur.socketID;
        newDatas.notification = visiteur.notification;
        newDatas.lang = visiteur.lang;
        newDatas.roomName = visiteur.roomName;
        newDatas.siteID = visiteur.siteID;

        if (!visiteur.connexion && !visiteur.socketID) {
          if (_this4.focusPupitre.focusSessionID !== visiteur.visiteurID) {
            var indexChatSession = lodash_default.a.findIndex(_this4.sessionsPrivees, [1, visiteur.visiteurID]);
            if (indexChatSession === -1) {
              _this4.$store.commit('_StoreWatcheeBox/REMOVE_VISITEUR', visiteur);
            }
          }
        } else {
          if (_this4.datasMonitorVisiteurs[index].nb_alert !== 0) {
            if (newDatas.filteridcalled) {
              var dataInvit = {
                socketID: newDatas.socketID,
                msg: newDatas.autoInvit,
                vwId: newDatas.visId,
                delay: '',
                visiteurID: newDatas.visiteurID,
                type: Number(newDatas.autoInvitType),
                sentence: '0',
                filId: newDatas.filteridcalled,
                siteID: newDatas.siteID,
                roomName: newDatas.roomName
              };
              _this4.autoInvit(dataInvit);
            }

            if (newDatas.forceAppear) {
              var dataOuvertureAuto = {
                socketID: newDatas.visiteurID,
                visiteurID: newDatas.visiteurID,
                siteID: newDatas.siteID
              };

              _this4.ouvertureAuto(dataOuvertureAuto);
            }
          }
        }
      });
    }
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'fullName', 'level']), Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['visiteurChatSelected', 'sessionsPrivees', 'focusPupitre', 'allDataVisiteurOpened', 'listeAllVisiteurs']), {
    allChatsOpened: function allChatsOpened() {
      return lodash_default.a.uniq(lodash_default.a.map(this.listeChatAgent, 0));
    },
    numTotalVisiteur: function numTotalVisiteur() {
      return this.datasFilterVisiteursArray.length + this.datasNoFilterVisiteursArray.length + this.datasVisiteursSocialNetwokArray.length;
    },
    concatAllVisiteurs: function concatAllVisiteurs() {
      var _this5 = this;

      if (!this.filterFront) {
        var res = [];
        lodash_default.a.each(this.listeAllVisiteurs, function (nodeVis) {
          var found = lodash_default.a.find(_this5.datasMonitorVisiteurs, {
            visiteurID: nodeVis.visiteurID
          });
          if (found) {
            var newVis = {};
            lodash_default.a.each(found, function (v, k) {
              newVis[k] = v;
            });
            lodash_default.a.each(nodeVis, function (v, k) {
              newVis[k] = v;
            });

            res.push(newVis);
          } else {
            res.push(nodeVis);
          }
        });

        return res;
      } else {
        return this.listeAllVisiteurs;
      }
    },
    datasFilterVisiteursArray: function datasFilterVisiteursArray() {
      return lodash_default.a.sortBy(lodash_default.a.filter(this.concatAllVisiteurs, function (o) {
        return o.nb_alert > 0;
      }), ['nb_alert', 'ponderation', 'dateLastChat']).reverse();
    },
    datasNoFilterVisiteursArray: function datasNoFilterVisiteursArray() {
      return lodash_default.a.filter(this.concatAllVisiteurs, function (o) {
        return !o.network && (!o.nb_alert || o.nb_alert && o.nb_alert === 0 && !o.network);
      });
    },
    datasVisiteursSocialNetwokArray: function datasVisiteursSocialNetwokArray() {
      return lodash_default.a.filter(this.concatAllVisiteurs, function (o) {
        return o.network && (!o.nb_alert || o.nb_alert && o.nb_alert === 0);
      });
    },
    computedAllDataVisiteurOpened: function computedAllDataVisiteurOpened() {
      return this.allDataVisiteurOpened;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/trafic/Visitors.vue







/* harmony default export */ var Visitors = ({
  mixins: [monitor],

  data: function data() {
    return {
      dialogInvitePupitre: false,
      iframeStatus: false,
      chatStatus: false,
      loading: false,
      loadingHistoChat: false,
      visiteurData: {},
      pendingInvit: [],
      filterFront: Number(this.$store.state._User.filterFront)
    };
  },


  methods: {
    loadingChat: function loadingChat(visiteurInfos) {
      this.loadingHistoChat = true;
    },
    stopLoadingHistoChat: function stopLoadingHistoChat() {
      this.loadingHistoChat = false;
    },
    showIframeMirroring: function showIframeMirroring(visiteurInfos) {
      this.iframeStatus = true;
      this.visiteurData = visiteurInfos;
    },
    openCobrowsing: function openCobrowsing(num) {
      this.iframeStatus = true;
    },
    closeCobrowsing: function closeCobrowsing(num) {
      this.iframeStatus = false;
    },
    hideIframeMirroring: function hideIframeMirroring() {
      this.iframeStatus = false;
    },
    showChat: function showChat(visiteurInfos) {
      this.chatStatus = true;
      this.loadingHistoChat = false;
      this.visiteurData = visiteurInfos;
      watcheebox_watcheebox.clientConnectRoom({ 'roomName': 'chat_' + visiteurInfos.visiteurID });

      this.$store.commit('_StoreWatcheeBox/VISITEUR_ADD_CHAT', { sessionID: visiteurInfos.visiteurID });
    },
    stopAlert: function stopAlert(visiteurID) {
      var indexVisiteur = lodash_default.a.findIndex(this.datasMonitorVisiteurs, { 'visiteurID': visiteurID });
      this.datasFilterVisiteursArray[indexVisiteur].nb_alert = 0;
    },
    modifVisiteursNode: function modifVisiteursNode() {
      var indexVisiteurSelect = lodash_default.a.findIndex(this.listeAllVisiteurs, { 'visiteurID': this.visiteurChatSelected });
      if (indexVisiteurSelect === -1) return;

      this.visiteurStatus(this.listeAllVisiteurs[indexVisiteurSelect]);
      this.$store.commit('_StoreWatcheeBox/AGENT_FOCUS', {
        'visiteurID': this.visiteurChatSelected
      });
    },
    visiteurStatus: function visiteurStatus(visiteurInfos) {
      console.log('visiteurStatus', visiteurInfos);

      if (this.$el.getElementsByClassName('presenceVisiteur')[0]) {
        var divCible = this.$el.getElementsByClassName('presenceVisiteur')[0];

        if (visiteurInfos.status === 'online') {
          divCible.classList.remove('affiche');
          divCible.classList.add('cache');
        } else {
          divCible.classList.remove('cache');
          divCible.classList.add('affiche');

          this.$store.commit('_StoreWatcheeBox/REMOVE_VISITEUR', visiteurInfos);
        }
      }
    }
  },

  created: function created() {
    if (this.hideTabVisitors) {
      this.$router.push({ path: '/trafic/chatting' });
    }
  },
  mounted: function mounted() {
    this.modifVisiteursNode();
  },
  beforeDestroy: function beforeDestroy() {
    this.stopMonitor();
  },


  watch: {
    'newMessage': function newMessage(val, oldval) {
      console.log('newMessage visitor', val);
      if (val.chatSession) {
        if (val.chatSession !== this.visiteurChatSelected) {
          if (this.chatStatus) {
            this.dialogInvitePupitre = true;
          } else {
            this.showChat(val);
          }
        }
      }
    },

    'listeAllVisiteurs': function listeAllVisiteurs(val, oldval) {
      this.modifVisiteursNode();
    }
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'fullName']), Object(vuex_esm["e" /* mapState */])('_User', ['hideTabVisitors']), Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['listeAllVisiteurs', 'newMessage', 'mySocketID', 'listeChatAgent', 'visiteurChatSelected', 'status']), {
    dataVisiteurComputed: function dataVisiteurComputed() {
      var visteurDataSelected;

      if (!this.filterFront) {
        visteurDataSelected = lodash_default.a.find(this.concatAllVisiteurs, { 'visiteurID': this.visiteurChatSelected });
      } else {
        visteurDataSelected = lodash_default.a.find(this.listeAllVisiteurs, { 'visiteurID': this.visiteurChatSelected });
      }

      return { 'cobrowsing': this.iframeStatus, 'online': true, 'viewStatus': true, 'visiteurDatas': visteurDataSelected, 'visiteurID': this.visiteurChatSelected };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c23feec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/trafic/Visitors.vue
var Visitors_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"layoutTraficVisiteurs bigChat",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"traficListVisiteurs fill-height",class:{sm3: _vm.visiteurChatSelected},attrs:{"xs12":""}},[_c('v-card',{staticClass:"cardTraficVisiteurs"},[_c('v-toolbar',{staticClass:"toolbar--dense white",attrs:{"flat":""}},[_c('v-toolbar-title',{staticClass:"primary--text"},[_vm._v("\n            "+_vm._s(_vm.$tc('targetedVisitors', _vm.datasFilterVisiteursArray.length, { count: _vm.datasFilterVisiteursArray.length }) + ' ' +
            _vm.$t('outOf') + ' ' + _vm.numTotalVisiteur)+"\n          ")])],1),_vm._v(" "),_c('div',{directives:[{name:"bar",rawName:"v-bar"}],staticClass:"wz_contentListesVisiteurs"},[_c('v-list',{staticClass:"listeTraficVisiteurs",attrs:{"two-line":"","dense":""}},[_vm._l((_vm.datasFilterVisiteursArray),function(visitor,i){return [_c('wz-watcheebox-visiteur',{key:i,attrs:{"datasVisiteur":visitor,"visSelectId":_vm.visiteurChatSelected},on:{"openChat":_vm.showChat,"loading":_vm.loadingChat,"stopAlertVisiteur":_vm.stopAlert}})]}),_vm._v(" "),_c('v-alert',{attrs:{"outline":"","color":"secondary","icon":"info","value":!_vm.datasFilterVisiteursArray.length && _vm.status == 'offline',"transition":"scale-transition"}},[_vm._v("\n              "+_vm._s(_vm.$t('noTargetingOffline'))+"\n            ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-subheader',{staticClass:"primary--text"},[_vm._v("\n              "+_vm._s(_vm.$tc('visitors', _vm.datasVisiteursSocialNetwokArray.length, { count: _vm.datasVisiteursSocialNetwokArray.length }) + ' via ' +
              _vm.$tc('socialNetworks', 2, { count: '' }))+"\n            ")]),_vm._v(" "),_c('div',{attrs:{"id":"wz_visiteurNonFiltre"}},[_vm._l((_vm.datasVisiteursSocialNetwokArray),function(visitor,i){return [_c('wz-watcheebox-visiteur',{key:i,attrs:{"datasVisiteur":visitor,"visSelectId":_vm.visiteurChatSelected},on:{"openChat":_vm.showChat,"loading":_vm.loadingChat}})]})],2),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-subheader',{staticClass:"primary--text"},[_vm._v("\n              "+_vm._s(_vm.$tc('visitors', _vm.datasNoFilterVisiteursArray.length, { count: _vm.datasNoFilterVisiteursArray.length }) + ' ' +
              _vm.$t('lowPotential') + ' ' +
              _vm.$tc('onYours', _vm.$store.state._Sites.sites.length, { count: '' }) + ' ' +
              _vm.$tc('sites', _vm.$store.state._Sites.sites.length, { count: _vm.$store.state._Sites.sites.length }))+"\n            ")]),_vm._v(" "),_c('div',{attrs:{"id":"wz_visiteurNonFiltre"}},[_vm._l((_vm.datasNoFilterVisiteursArray),function(visitor,i){return [_c('wz-watcheebox-visiteur',{key:i,attrs:{"datasVisiteur":visitor,"visSelectId":_vm.visiteurChatSelected},on:{"openChat":_vm.showChat,"loading":_vm.loadingChat}})]})],2)],2)],1)],1)],1),_vm._v(" "),(_vm.visiteurChatSelected)?_c('v-flex',{staticClass:"traficInfosVisiteur fill-height",attrs:{"xs12":"","sm9":""}},[(_vm.loadingHistoChat)?_c('div',{staticClass:"wz_loadingChat text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"size":70,"width":1,"indeterminate":""}})],1):_c('wz-view-chat',{attrs:{"datasViewPupitre":_vm.dataVisiteurComputed,"placesPupitre":1},on:{"activeCobrowsing":function($event){_vm.openCobrowsing(0)},"stopCobrowsing":function($event){_vm.closeCobrowsing(0)}},nativeOn:{"click":function($event){_vm.focusView({'view': 1, 'visiteurID': _vm.visiteurChatSelected})}}})],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogInvitePupitre),callback:function ($$v) {_vm.dialogInvitePupitre=$$v},expression:"dialogInvitePupitre"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('newChatTitle')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('newChatContent')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"primary--text",attrs:{"flat":""},on:{"click":function($event){$event.stopPropagation();_vm.dialogInvitePupitre=false}}},[_vm._v(_vm._s(_vm.$t('notChange')))]),_vm._v(" "),_c('v-btn',{staticClass:"primary--text",attrs:{"flat":"","to":"/trafic/chatting"}},[_vm._v(_vm._s(_vm.$t('multiChat')))])],1)],1)],1)],1)}
var Visitors_staticRenderFns = []
var Visitors_esExports = { render: Visitors_render, staticRenderFns: Visitors_staticRenderFns }
/* harmony default export */ var trafic_Visitors = (Visitors_esExports);
// CONCATENATED MODULE: ./src/components/trafic/Visitors.vue
function Visitors_injectStyle (ssrContext) {
  __webpack_require__("42S1")
}
var Visitors_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Visitors___vue_template_functional__ = false
/* styles */
var Visitors___vue_styles__ = Visitors_injectStyle
/* scopeId */
var Visitors___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Visitors___vue_module_identifier__ = null
var Visitors_Component = Visitors_normalizeComponent(
  Visitors,
  trafic_Visitors,
  Visitors___vue_template_functional__,
  Visitors___vue_styles__,
  Visitors___vue_scopeId__,
  Visitors___vue_module_identifier__
)

/* harmony default export */ var components_trafic_Visitors = (Visitors_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-drag-drop/dist/vue-drag-drop.common.js
var vue_drag_drop_common = __webpack_require__("n8qV");
var vue_drag_drop_common_default = /*#__PURE__*/__webpack_require__.n(vue_drag_drop_common);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/trafic/Chatting.vue








/* harmony default export */ var Chatting = ({
  mixins: [monitor],
  components: { Drop: vue_drag_drop_common["Drop"] },
  data: function data() {
    return {
      transfertActif: '',

      fileAttente: [],
      arrayListeAttente: [],
      domaine: constants_DOMAINE,
      over: [false, false, false, false],
      dialogChangeSlot: false,
      dataEchangePlace: null,
      elementsDrag: null
    };
  },


  watch: {
    'clientSatisfaction': function clientSatisfaction(val, oldval) {
      if (val.retour) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'le visiteur ' + val.chatSession + ' a répondu à votre questionnaire de satisfaction', context: 'success' });
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'le visiteur ' + val.chatSession + ' n\'a pas répondu à votre questionnaire de satisfaction', context: 'error' });
      }
    },

    'datasMonitorVisiteurs': function datasMonitorVisiteurs(val, oldval) {
      var _this = this;

      lodash_default.a.forEach(this.pupitreViewsData, function (VisiteurPupitre, key) {
        lodash_default.a.forEach(val, function (monitorVal, key) {
          if (VisiteurPupitre.view.visiteurID === monitorVal.visiteurID) {
            var newDataVisiteur = lodash_default.a.cloneDeep(VisiteurPupitre.view.visiteurDatas);
            if (monitorVal.pagesFocus) {
              newDataVisiteur.pagesFocus = monitorVal.pagesFocus;
            }
            _this.SET_VISITEURS(newDataVisiteur);
          }
        });
      });
    }
  },
  mounted: function mounted() {},


  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])('_StoreWatcheeBox', ['SET_VISITEURS']), {
    handleDrop: function handleDrop(data) {
      if (data.dataDrop) {
        this.over = [false, false, false, false];
        console.log('You dropped with data:', data);

        if (data.statusView) {
          if (data.place !== data.dataDrop.placePupitreActif) {
            this.dataEchangePlace = data;
            this.echangePlace();
          }
        } else {
          this.modifPlacePupitre(data);
        }
      }
    },
    handleDragStat: function handleDragStat(data) {
      if (data.dataDrop) {
        if (data.status) {
          this.elementsDrag = data;
        } else {
          this.elementsDrag = null;
        }
        this.over.splice(data.index, 1, data.status);
      }
    },
    echangePlace: function echangePlace() {
      this.modifPlacePupitre(this.dataEchangePlace);
      this.dialogChangeSlot = false;
    },
    modifPlacePupitre: function modifPlacePupitre(data) {
      this.$store.commit('_StoreWatcheeBox/CHANGE_PLACE_PUPITRE_VISITEUR', data);
      this.dataEchangePlace = null;
    },
    supVisiteurFileAttente: function supVisiteurFileAttente(visiteurID) {
      console.log('supVisiteurFileAttente', visiteurID);

      var indexSession = lodash_default.a.findIndex(this.sessionsPrivees, [1, visiteurID]);
      this.$store.commit('_StoreWatcheeBox/REMOVE_PRIVATE_SESSION_CHAT', {
        index: indexSession,
        visiteurID: visiteurID
      });
    },
    supVisiteur: function supVisiteur(visiteurID) {
      console.log('supVisiteur', visiteurID);

      var indexSession = lodash_default.a.findIndex(this.sessionsPrivees, [1, visiteurID]);
      var indexVisiteur = lodash_default.a.findIndex(this.listeAllVisiteurs, { 'visiteurID': visiteurID });
      var placeDispo = 0;

      if (this.listeAllVisiteurs[indexVisiteur].placePupitre !== null) {
        placeDispo = this.listeAllVisiteurs[indexVisiteur].placePupitre;
      }
      this.$store.commit('_StoreWatcheeBox/REMOVE_PRIVATE_SESSION_CHAT', {
        index: indexSession,
        visiteurID: visiteurID,
        placePupitre: placeDispo
      });
    },

    closeChatTransfere: function closeChatTransfere(visiteurID) {
      var arrayVisiteur = [];
      for (var a = 0; a < this.listeAllVisiteurs.length; a++) {
        if (this.listeAllVisiteurs[a].visiteurID === visiteurID) {
          arrayVisiteur = lodash_default.a.cloneDeep(this.listeAllVisiteurs[a]);
          arrayVisiteur.placePupitre = '';
        }
      }

      for (var c = 0; c < this.pupitreViewsData.length; c++) {
        if (this.pupitreViewsData[c].view.visiteurID === visiteurID) {
          this.remplaceVisiteur({
            'placeDispo': c,
            'ancienVisiteurID': visiteurID
          });
          break;
        }
      }

      this.SET_VISITEURS(arrayVisiteur);
      this.$store.dispatch('_Notifier/NEW_NOTIF', {
        message: 'Formulaire de satisfaction envoyé au visiteur ' + visiteurID,
        context: 'success'
      });
    }
  }),

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['listeAllVisiteurs', 'newMessage', 'clientSatisfaction', 'sessionsPrivees', 'mySocketID', 'status', 'focusPupitre', 'pupitreViewStatus']), Object(vuex_esm["c" /* mapGetters */])('_StoreWatcheeBox', ['WATCHEEBOX_STATE', 'pupitreViewsData']), Object(vuex_esm["c" /* mapGetters */])('_User', ['user']), {
    numPlaceOccupe: function numPlaceOccupe() {
      var slots = this.pupitreViewsData.filter(function (p) {
        return p.view.viewStatus;
      });
      return slots && slots.length;
    },
    listeAttente: function listeAttente() {
      var _this2 = this;

      this.arrayListeAttente = [];

      var newArrayPupitre = lodash_default.a.cloneDeep(this.pupitreViewsData);

      newArrayPupitre.splice(0, this.pupitreViewStatus);

      lodash_default.a.forEach(newArrayPupitre, function (placesPupitre, key) {
        if (placesPupitre.view.viewStatus) {
          _this2.arrayListeAttente.push(lodash_default.a.cloneDeep(placesPupitre.view.visiteurDatas));
        }
      });

      return this.arrayListeAttente;
    },
    placeFocus: function placeFocus() {
      return this.focusPupitre.view;
    },
    nbVisitors: function nbVisitors() {
      return this.$store.state._StoreWatcheeBox.listeAllVisiteurs.length > 99 ? '99+' : this.$store.state._StoreWatcheeBox.listeAllVisiteurs.length;
    },
    showingPupitre: function showingPupitre() {
      return [true, this.pupitreViewStatus !== 1, this.pupitreViewStatus !== 2 && this.pupitreViewStatus !== 1, this.pupitreViewStatus !== 2 && this.pupitreViewStatus !== 1];
    }
  }),

  beforeDestroy: function beforeDestroy() {
    this.stopMonitor();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a81ca18","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/trafic/Chatting.vue
var Chatting_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.numPlaceOccupe)?_c('div',{staticClass:"wz_viewportChats"},[_c('v-layout',{staticClass:"wz_viewportChat",class:{
          'wz_attenteActif': _vm.listeAttente.length,
          'wz_attenteInactif': !_vm.listeAttente.length
        },attrs:{"row":"","wrap":""}},_vm._l((_vm.pupitreViewsData),function(pupitre,i){return _c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.showingPupitre[i]),expression:"showingPupitre[i]"}],key:i,staticClass:"fill-height pa-0",class:{
            'viewSelected': _vm.placeFocus == (i + 1),
            'divisHauteur xs6': _vm.pupitreViewStatus == 4,
            'xs6': _vm.pupitreViewStatus == 2,
            'xs12': _vm.pupitreViewStatus == 1
          }},[_c('drop',{staticClass:"drop",class:{ 'over': _vm.over[i] },on:{"drop":function (data) { return _vm.handleDrop({
              dataDrop:data,
              statusView: pupitre.view.viewStatus,
              place: i + 1,
              idVisiteurPlace:pupitre.view.visiteurID,
              menuSelectedPlace:pupitre.view && pupitre.view.visiteurDatas ? pupitre.view.visiteurDatas.menuSelected : 'visitorCard',
              reponseCobrowsingPlace:pupitre.view && pupitre.view.visiteurDatas ? pupitre.view.visiteurDatas.reponseCobrowsing : false
            }); },"dragover":function (data) { return _vm.handleDragStat({
              index:i,
              dataDrop:data,
              status: true
            }); },"dragleave":function (data) { return _vm.handleDragStat({
              index:i,
              dataDrop:data,
              status: false
            }); }}},[_c('div',{staticClass:"wz_contentChatView",class:{
            'view_border--bottom': _vm.pupitreViewStatus == 4 && (i == 0 || i == 1),
            'view_border--right': (_vm.pupitreViewStatus == 2 && i == 0) || (_vm.pupitreViewStatus == 4 && (i == 0 || i == 2))
          }},[(pupitre.view.viewStatus)?_c('wz-view-chat',{attrs:{"dragOverStatus":_vm.over[i],"dragOverElement":_vm.elementsDrag,"datasViewPupitre":pupitre.view,"placesPupitre":_vm.numPlaceOccupe},on:{"supVisiteurFile":_vm.supVisiteurFileAttente},nativeOn:{"click":function($event){_vm.focusView({'view': i + 1, 'visiteurID': pupitre.view.visiteurID})}}}):_c('div',{staticClass:"bigNum"},[_c('span',[_vm._v(_vm._s(i + 1))])])],1)])],1)}),1),_vm._v(" "),(_vm.listeAttente.length > 0)?_c('wz-view-attente',{attrs:{"datasFileAttente":_vm.listeAttente,"pupitreData":_vm.pupitreViewsData},on:{"supVisiteurFile":_vm.supVisiteurFileAttente},nativeOn:{"click":function($event){_vm.focusView({'view': null, 'visiteurID': null})}}}):_vm._e()],1):_c('v-card',{attrs:{"height":"100%"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-alert',{attrs:{"outline":"","color":"secondary","icon":"info","value":!_vm.datasFilterVisiteursArray.length && _vm.status == 'offline',"transition":"scale-transition"}},[_vm._v("\n          "+_vm._s(_vm.$t('noTargetingOffline'))+"\n        ")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-img',{attrs:{"src":_vm.domaine.indexOf('targetfirst') !== -1
                    ? (_vm.domaine + "/static/booster.png")
                    : (_vm.domaine + "/watcheezy/static/booster.png"),"height":"250px","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md7":""}},[_c('div',[_c('section',[_c('h2',{staticClass:"headline accent--text"},[_c('div',[_c('p',[_vm._v(_vm._s(_vm.$t('realTimeAnalysis')))])])]),_vm._v(" "),_c('v-progress-linear',{attrs:{"color":"accent","indeterminate":true}}),_vm._v(" "),_c('blockquote',{staticClass:"blockquote secondary--text"},[_vm._v("\n                  "+_vm._s(_vm._f("cap")(_vm.$tc('targetedVisitors', _vm.datasFilterVisiteursArray.length, { count: _vm.datasFilterVisiteursArray.length })))+"\n                  "+_vm._s(_vm.$t('outOf'))+"\n                  "+_vm._s(_vm.$tc('visitors', _vm.listeAllVisiteurs.length, { count: _vm.nbVisitors }))+"\n                ")])],1),_vm._v(" "),_c('div',{staticClass:"title text-xs-center"}),_vm._v(" "),_c('blockquote',{staticClass:"blockquote"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('noIncomingChats') + ', ' + _vm.$t('checkActiveFilters'))}})]),_vm._v(" "),(_vm.checkPermission('NO_PEONS_NOR_AGENTS'))?_c('v-btn',{attrs:{"block":"","to":{path: '/target/filters'},"outline":"","color":"secondary"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("track_changes")]),_vm._v("\n                "+_vm._s(_vm.$t('setUpFilters'))+"\n              ")],1):_vm._e()],1)])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogChangeSlot),callback:function ($$v) {_vm.dialogChangeSlot=$$v},expression:"dialogChangeSlot"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('changePlace')))]),_vm._v(" "),(_vm.dataEchangePlace)?_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.$t('changePlaceContent1') +' <b>'+ _vm.dataEchangePlace.place +'</b><br>'+ _vm.$t('changePlaceContent2') +' <b>'+ _vm.dataEchangePlace.idVisiteurPlace +'</b>.<br> '+ _vm.$t('askChangePlace') )}}):_vm._e(),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.dialogChangeSlot=false}}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.echangePlace()}}},[_vm._v(_vm._s(_vm.$t('yes')))])],1)],1)],1)],1)}
var Chatting_staticRenderFns = []
var Chatting_esExports = { render: Chatting_render, staticRenderFns: Chatting_staticRenderFns }
/* harmony default export */ var trafic_Chatting = (Chatting_esExports);
// CONCATENATED MODULE: ./src/components/trafic/Chatting.vue
function Chatting_injectStyle (ssrContext) {
  __webpack_require__("KLnE")
}
var Chatting_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Chatting___vue_template_functional__ = false
/* styles */
var Chatting___vue_styles__ = Chatting_injectStyle
/* scopeId */
var Chatting___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Chatting___vue_module_identifier__ = null
var Chatting_Component = Chatting_normalizeComponent(
  Chatting,
  trafic_Chatting,
  Chatting___vue_template_functional__,
  Chatting___vue_styles__,
  Chatting___vue_scopeId__,
  Chatting___vue_module_identifier__
)

/* harmony default export */ var components_trafic_Chatting = (Chatting_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/trafic/Monitoring.vue






/* harmony default export */ var Monitoring = ({
  data: function data() {
    return {
      selectedAgent: {
        'id': '',
        'name': '',
        'status': ''
      },
      oldVisSelected: null,
      visSelected: null
    };
  },


  props: ['dataAgent'],

  methods: {
    updateVisSelect: function updateVisSelect(visiteurID) {
      console.log('updateVisSelect', visiteurID);
      this.oldVisSelected = this.visSelected;
      this.visSelected = visiteurID;

      watcheebox_watcheebox.clientConnectRoom({ 'roomName': 'chat_' + visiteurID });

      if (this.oldVisSelected !== null && this.oldVisSelected !== visiteurID) {
        watcheebox_watcheebox.clientQuitRoom({ 'roomName': 'chat_' + this.oldVisSelected });
      }
    }
  },

  watch: {
    selectAgent: function selectAgent(data) {
      if (this.visSelected !== null) {
        watcheebox_watcheebox.clientQuitRoom({ 'roomName': 'chat_' + this.visSelected });
      }
    }
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['listeAllVisiteurs']), {
    selectAgent: function selectAgent() {
      return this.selectedAgent.id;
    },
    dataVisiteurComputed: function dataVisiteurComputed() {
      var visteurDataSelected = lodash_default.a.find(this.listeAllVisiteurs, { 'visiteurID': this.visSelected });
      return { 'cobrowsing': this.iframeStatus, 'online': true, 'viewStatus': true, 'visiteurDatas': visteurDataSelected, 'visiteurID': this.visSelected };
    }
  }),

  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {
    if (this.visSelected !== null) {
      watcheebox_watcheebox.clientQuitRoom({ 'roomName': 'chat_' + this.visSelected });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1ff5b8b5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/trafic/Monitoring.vue
var Monitoring_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"contentMonitoring",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('wz-list-agents',{attrs:{"agentSelect":_vm.selectedAgent,"inMonitoring":true},on:{"update:agentSelect":function($event){_vm.selectedAgent=$event},"chatSessionSelected":_vm.updateVisSelect}})],1),_vm._v(" "),_c('v-flex',{staticClass:"contentMonitoringInfosVisiteur",attrs:{"xs12":"","sm6":"","md9":""}},[(_vm.selectAgent && _vm.visSelected)?_c('wz-view-chat',{attrs:{"datasViewPupitre":_vm.dataVisiteurComputed,"placesPupitre":1,"selectedAgent":_vm.selectedAgent},on:{"chatSessionSelect":_vm.updateVisSelect}}):_vm._e()],1)],1)}
var Monitoring_staticRenderFns = []
var Monitoring_esExports = { render: Monitoring_render, staticRenderFns: Monitoring_staticRenderFns }
/* harmony default export */ var trafic_Monitoring = (Monitoring_esExports);
// CONCATENATED MODULE: ./src/components/trafic/Monitoring.vue
function Monitoring_injectStyle (ssrContext) {
  __webpack_require__("9B1n")
}
var Monitoring_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Monitoring___vue_template_functional__ = false
/* styles */
var Monitoring___vue_styles__ = Monitoring_injectStyle
/* scopeId */
var Monitoring___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Monitoring___vue_module_identifier__ = null
var Monitoring_Component = Monitoring_normalizeComponent(
  Monitoring,
  trafic_Monitoring,
  Monitoring___vue_template_functional__,
  Monitoring___vue_styles__,
  Monitoring___vue_scopeId__,
  Monitoring___vue_module_identifier__
)

/* harmony default export */ var components_trafic_Monitoring = (Monitoring_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/trafic/Attente.vue








/* harmony default export */ var Attente = ({
  mixins: [monitor],

  data: function data() {
    return {
      loadingGet: false,
      dialogSupMessage: false,
      loadingSupp: false,
      loadingMessages: false,
      chatStatus: false,
      listeComputedMessages: [],
      loadingHistoChat: false,
      visiteurData: {},
      dejaEnChat: 0,
      istypingVisiteur: 0,
      messageIdSelected: 0
    };
  },


  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])('_StoreWatcheeBox', ['SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE']), Object(vuex_esm["d" /* mapMutations */])('_User', ['SET_MESSAGE_ATTENTE', 'SET_AVATAR_MESSAGE_ATTENTE']), {
    suppMessage: function suppMessage(Id) {
      this.messageIdSelected = Id;

      this.dialogSupMessage = true;
    },
    MAJHistoChat: function MAJHistoChat(data) {
      this.MonitorMajHistoChat(data);
    },
    getMessagesAttentes: function getMessagesAttentes() {
      var _this = this;

      this.loadingMessages = true;
      this.axios.get('get/chats_abscence.php?agentId=' + this.user.id).then(function (response) {
        _this.SET_MESSAGE_ATTENTE(response.data);

        lodash_default.a.forEach(response.data, function (allVisiteurs, key) {
          if (allVisiteurs.network === 'facebook') {
            var dataVisiteur = { 'visiteurData': allVisiteurs, 'key': key };
            _this.getAvatarVisiteur(dataVisiteur);
          }
        });

        _this.loadingMessages = false;
      }).catch(function (_) {}).then(function (_) {});
    },
    getAvatarVisiteur: function getAvatarVisiteur(data) {
      var _this2 = this;

      this.axios.get('get/chats_abscence_avatar.php?visitorId=' + data.visiteurData.visiteurID).then(function (response) {
        if (response.data) {
          data.visiteurData.profile_pic = response.data;

          _this2.SET_AVATAR_MESSAGE_ATTENTE(data);
          _this2.loadingMessages = false;
        }
      }).catch(function (_) {}).then(function (_) {});
    },
    confirmSuppMessage: function confirmSuppMessage() {
      var _this3 = this;

      var suppId = this.messageIdSelected;
      var dataToPost = new window.FormData();
      dataToPost.append('messageId', suppId);

      this.axios.post('post/messageAttenteLu.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        var messagesList = lodash_default.a.cloneDeep(_this3.user.listeMessages);

        var index = lodash_default.a.findIndex(messagesList, function (o) {
          return o.messageId === suppId;
        });
        if (index !== -1) {
          messagesList.splice(index, 1);

          _this3.user.listeMessages = messagesList;
        }
      }).catch(function (_) {
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this3.$t('modifFailure'),
          context: 'error'
        });
      }).then(function (_) {
        _this3.loadingSupp = false;

        _this3.dialogSupMessage = false;
        _this3.messageIdSelected = 0;
      });
    },
    openMessageVisiteur: function openMessageVisiteur(data) {
      var _this4 = this;

      if (this.overMenu) return;
      if (this.messageAttenteSelected === data.visiteurID) {} else {
        this.loadingHistoChat = true;

        watcheebox_watcheebox.firstLoadHistoChat({
          chatSession: data.visiteurID,
          entrepriseId: this.user.entId
        }).then(function (histoChat) {
          var visClone = lodash_default.a.cloneDeep(data);
          visClone.histoChat = histoChat;

          _this4.showChat(visClone);
          _this4.visiteurData = visClone;
          var visOfflineClone = lodash_default.a.cloneDeep(_this4.$store.state._StoreWatcheeBox.allDataVisiteurOpened);
          visOfflineClone.histoChat = histoChat;
          _this4.SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE(visOfflineClone);
        }).catch(function (e) {
          console.error(e);
        });
      }
    },
    loadingChat: function loadingChat(visiteurInfos) {
      this.loadingHistoChat = true;
    },
    showChat: function showChat(visiteurInfos) {
      this.loadingHistoChat = false;
      this.chatStatus = true;
      watcheebox_watcheebox.clientConnectRoom({ 'roomName': 'chat_' + visiteurInfos.visiteurID });

      this.$store.commit('_StoreWatcheeBox/VISITEUR_ADD_CHAT', { sessionID: visiteurInfos.visiteurID });

      this.$store.commit('_StoreWatcheeBox/OPEN_FICHE_VISITEUR', visiteurInfos);
    },
    dateMessageFromNow: function dateMessageFromNow(date) {
      return moment_default.a.unix(date).fromNow();
    }
  }),

  created: function created() {
    if (this.hideTabVisitors) {
      this.$router.push({ path: '/trafic/attente' });
    }

    this.$store.commit('_StoreWatcheeBox/CLEAR_MESSAGE_ATTENTE');
  },
  mounted: function mounted() {},
  beforeDestroy: function beforeDestroy() {},


  watch: {},

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'fullName']), Object(vuex_esm["e" /* mapState */])('_User', ['hideTabVisitors']), Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['listeAllVisiteurs', 'newMessage', 'mySocketID', 'listeChatAgent', 'messageAttenteSelected', 'allDataVisiteurOpened', 'status']), {
    dataVisiteurComputed: function dataVisiteurComputed() {
      var visiteurDataSelected = void 0;
      var index = void 0;

      if (!this.filterFront) {
        index = lodash_default.a.findIndex(this.concatAllVisiteurs, { 'visiteurID': this.messageAttenteSelected });

        if (index !== -1) {
          visiteurDataSelected = this.concatAllVisiteurs[index];
        }
      } else {
        index = lodash_default.a.findIndex(this.listeAllVisiteurs, { 'visiteurID': this.messageAttenteSelected });

        if (index !== -1) {
          visiteurDataSelected = this.listeAllVisiteurs[index];
          visiteurDataSelected.histoChat = this.allDataVisiteurOpened.histoChat;
        }
      }

      if (index === -1) {
        var MAJHistoCHat = lodash_default.a.cloneDeep(this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.histoChat);
        this.visiteurData.histoChat = MAJHistoCHat;

        visiteurDataSelected = this.visiteurData;
      }

      return { 'cobrowsing': false, 'online': true, 'viewStatus': true, 'visiteurDatas': visiteurDataSelected, 'visiteurID': this.messageAttenteSelected };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26af9ff0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/trafic/Attente.vue
var Attente_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display"},[(_vm.loadingGet)?_c('div',{staticClass:"text-xs-center targetFirst_loading"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_vm._e(),_vm._v(" "),_c('v-layout',{staticClass:"layoutTraficVisiteurs bigChat",attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"traficListVisiteurs fill-height",class:{sm3: _vm.messageAttenteSelected},attrs:{"xs12":""}},[_c('v-card',{staticClass:"cardTraficVisiteurs"},[_c('v-toolbar',{staticClass:"toolbar--dense white",attrs:{"flat":""}},[_c('v-toolbar-title',{staticClass:"primary--text"},[_vm._v("\n              "+_vm._s(_vm.$tc('messageAttente', _vm.user.listeMessages.length, {count: _vm.user.listeMessages.length}))+"\n              "),_vm._v(" "),(_vm.status != 'online')?_c('v-btn',{staticClass:"white--text",attrs:{"loading":_vm.loadingMessages,"disabled":_vm.loadingMessages,"color":"primary"},on:{"click":function($event){_vm.getMessagesAttentes()}}},[_vm._v("\n                "+_vm._s(_vm.$tc('Reload'))+"\n                "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("cached")])],1):_vm._e()],1)],1),_vm._v(" "),_c('div',{directives:[{name:"bar",rawName:"v-bar"}],staticClass:"wz_contentListesVisiteurs"},[_c('v-list',{staticClass:"listeTraficVisiteurs",attrs:{"two-line":"","dense":""}},[_c('v-subheader',[_vm._v("General")]),_vm._v(" "),_vm._l((_vm.user.listeMessages),function(visitor,i){return [_c('v-flex',{key:i,staticClass:"visiteurFiltrer",attrs:{"xs12":"","sm12":""}},[_c('v-list-tile',{key:visitor.status,class:{ 'light-blue lighten-4': _vm.messageAttenteSelected == visitor.visiteurID,  },attrs:{"ripple":""},on:{"click":function($event){_vm.openMessageVisiteur(visitor)}}},[_c('v-list-tile-avatar',[(!_vm.dejaEnChat && visitor.network == 'moon' || !_vm.dejaEnChat && !visitor.network)?_c('wz-avatar',{staticClass:"pl-1",attrs:{"username":'#' + visitor.visiteurID,"size":"38px"}}):(!_vm.dejaEnChat && visitor.network == 'facebook')?_c('wz-avatar',{staticClass:"pl-1",attrs:{"src":visitor.profile_pic,"username":visitor.visiteurName,"size":"38px"}}):(!_vm.dejaEnChat && !_vm.istypingVisiteur && visitor.message && visitor.visiteurID != _vm.messageAttenteSelected)?_c('wz-avatar',{attrs:{"username":'#' + visitor.visiteurID,"size":"38px","lastMessage":""}}):(!_vm.dejaEnChat && _vm.istypingVisiteur)?_c('wz-avatar',{attrs:{"isTyping":_vm.istypingVisiteur,"username":'#' + visitor.visiteurID,"size":"38px","chip":""}}):_vm._e()],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[(visitor.network == 'moon' || !visitor.network)?_c('div',{staticClass:"wz_nameVisiteur"},[_vm._v("\n                              "+_vm._s(visitor.visiteurID)+" "),_c('span',[_vm._v("("+_vm._s(_vm.dateMessageFromNow(visitor.timestamp))+")")])]):(visitor.network == 'facebook')?_c('div',{staticClass:"wz_nameVisiteur"},[_vm._v("\n                              "+_vm._s(visitor.visiteurName)+" "),_c('span',[_vm._v("("+_vm._s(_vm.dateMessageFromNow(visitor.timestamp))+")")])]):_vm._e()]),_vm._v(" "),(visitor.message.length)?_c('v-list-tile-sub-title',[(visitor.message.length)?_c('div',{staticClass:"wz_alertFiltre ",attrs:{"slot":"activator"},slot:"activator"},[(visitor.network == 'moon' || !visitor.network)?_c('v-icon',{staticClass:"secondary--text text--lighten-1",attrs:{"small":""}},[_vm._v("chat_bubble")]):(visitor.network == 'facebook')?_c('v-icon',{staticClass:" ",attrs:{"small":"","color":"blue accent-4--text"}},[_vm._v("mdi-facebook-messenger")]):_vm._e()],1):_vm._e(),_vm._v("\n                            "+_vm._s(visitor.message[0])+"\n                          ")]):_vm._e()],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"accent"},on:{"click":function($event){_vm.suppMessage(visitor.messageId)}},nativeOn:{"mouseover":function($event){_vm.overMenu = true},"mouseleave":function($event){_vm.overMenu = false}},slot:"activator"},[_c('v-icon',{attrs:{"large":"","color":"grey lighten-1"}},[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-divider',{attrs:{"inset":""}})],1)]})],2)],1)],1)],1),_vm._v(" "),(_vm.messageAttenteSelected)?_c('v-flex',{staticClass:"traficInfosVisiteur fill-height",attrs:{"xs12":"","sm9":""}},[(_vm.loadingHistoChat)?_c('div',{staticClass:"wz_loadingChat text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"size":70,"width":1,"indeterminate":""}})],1):_c('wz-view-chat',{attrs:{"datasViewPupitre":_vm.dataVisiteurComputed,"placesPupitre":1},on:{"activeCobrowsing":function($event){_vm.openCobrowsing(0)},"stopCobrowsing":function($event){_vm.closeCobrowsing(0)},"MAJHistoChat":_vm.MAJHistoChat},nativeOn:{"click":function($event){_vm.focusView({'view': 1, 'visiteurID': _vm.messageAttenteSelected})}}})],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogSupMessage),callback:function ($$v) {_vm.dialogSupMessage=$$v},expression:"dialogSupMessage"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('supMessageAttenteTitre'))))]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          "+_vm._s(_vm._f("cap")(_vm.$t('supMessageAttenteContent')))+"\n        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.dialogSupMessage=false}}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('v-btn',{staticClass:"white--text darken-1",attrs:{"loading":_vm.loadingSupp,"disabled":_vm.loadingSupp,"color":"accent"},on:{"click":function($event){_vm.confirmSuppMessage()}}},[_vm._v("\n          "+_vm._s(_vm.$t('yes')))])],1)],1)],1)],1)}
var Attente_staticRenderFns = []
var Attente_esExports = { render: Attente_render, staticRenderFns: Attente_staticRenderFns }
/* harmony default export */ var trafic_Attente = (Attente_esExports);
// CONCATENATED MODULE: ./src/components/trafic/Attente.vue
function Attente_injectStyle (ssrContext) {
  __webpack_require__("DLXV")
}
var Attente_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Attente___vue_template_functional__ = false
/* styles */
var Attente___vue_styles__ = Attente_injectStyle
/* scopeId */
var Attente___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Attente___vue_module_identifier__ = null
var Attente_Component = Attente_normalizeComponent(
  Attente,
  trafic_Attente,
  Attente___vue_template_functional__,
  Attente___vue_styles__,
  Attente___vue_scopeId__,
  Attente___vue_module_identifier__
)

/* harmony default export */ var components_trafic_Attente = (Attente_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/toConsumableArray.js
var toConsumableArray = __webpack_require__("Gu7T");
var toConsumableArray_default = /*#__PURE__*/__webpack_require__.n(toConsumableArray);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Stats.vue



var Stats__this = this;





/* harmony default export */ var Stats = ({
  data: function data() {
    return {
      filtered: false,

      dateStartPicker: null,
      dateStartDisplayed: null,
      dateEndPicker: null,
      dateEndDisplayed: null,

      modalStart: false,
      modalEnd: false,
      periods: [],

      period: {},

      periodDisabled: false,

      dialogSites: false,
      siteTmp: [],
      site: [],

      agent: [],
      bot: [],
      motif: [] };
  },
  created: function created() {
    this.initPeriod();
    this.initSites();
    this.initAgents();
    this.initBots();
    this.initMotifs();
    this.initChannels();

    if (this.entLevel === '7') {
      this.periods = [{ text: lodash_default.a.upperFirst(this.$tc('custom', 2)), value: 0 }, { text: lodash_default.a.upperFirst(this.$t('yesterday')), value: 1 }, { text: lodash_default.a.upperFirst(this.$t('thisWeek')), value: 2 }, { text: lodash_default.a.upperFirst(this.$t('thisMonth')), value: 3 }, { text: lodash_default.a.upperFirst(this.$t('last7Days')), value: 4 }, { text: lodash_default.a.upperFirst(this.$t('last30Days')), value: 5 }, { text: lodash_default.a.upperFirst(this.$t('lastWeek')), value: 6 }, { text: lodash_default.a.upperFirst(this.$t('lastMonth')), value: 7 }, { text: lodash_default.a.upperFirst(this.$t('lastQuarter')), value: 8 }];
    } else if (this.entLevel === '6') {
      this.periods = [{ text: lodash_default.a.upperFirst(this.$tc('custom', 2)), value: 0 }, { text: lodash_default.a.upperFirst(this.$t('yesterday')), value: 1 }, { text: lodash_default.a.upperFirst(this.$t('thisWeek')), value: 2 }, { text: lodash_default.a.upperFirst(this.$t('thisMonth')), value: 3 }, { text: lodash_default.a.upperFirst(this.$t('last7Days')), value: 4 }, { text: lodash_default.a.upperFirst(this.$t('last30Days')), value: 5 }, { text: lodash_default.a.upperFirst(this.$t('lastWeek')), value: 6 }];
    } else if (this.entLevel === '5') {
      this.periods = [{ text: lodash_default.a.upperFirst(this.$tc('custom', 2)), value: 0 }, { text: lodash_default.a.upperFirst(this.$t('yesterday')), value: 1 }, { text: lodash_default.a.upperFirst(this.$t('thisWeek')), value: 2 }, { text: lodash_default.a.upperFirst(this.$t('last7Days')), value: 4 }];
    } else if (this.entLevel === '10' || this.entLevel === '1') {
      this.periods = [{ text: lodash_default.a.upperFirst(this.$tc('custom', 2)), value: 0 }, { text: lodash_default.a.upperFirst(this.$t('yesterday')), value: 1 }];
    }
  },
  mounted: function mounted() {},


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_Sites', ['HAS_ONE_MOTIF', 'HAS_ONE_FUNNEL']), Object(vuex_esm["e" /* mapState */])('_User', ['entLevel']), {
    maxDatesStart: function maxDatesStart() {
      return Stats__this.parseDate(Stats__this.dateEndPicker);
    },
    minDatesStart: function minDatesStart() {
      return Stats__this.parseDate(Stats__this.formatDate(new Date(moment().subtract(1, 'year'))));
    },
    allowedDatesStart: function allowedDatesStart() {
      if (this.entLevel === '7') {
        return {
          max: this.parseDate(this.dateEndPicker),
          min: this.parseDate(this.formatDate(new Date(moment().subtract(1, 'year'))))
        };
      } else if (this.entLevel === '6') {
        return {
          max: this.parseDate(this.dateEndPicker),
          min: this.parseDate(this.formatDate(new Date(moment().subtract(1, 'month'))))
        };
      } else if (this.entLevel === '5') {
        return {
          max: this.parseDate(this.dateEndPicker),
          min: this.parseDate(this.formatDate(new Date(moment().subtract(1, 'week'))))
        };
      } else if (this.entLevel === '10' || this.entLevel === '1') {
        return {
          max: this.parseDate(this.dateEndPicker),
          min: this.parseDate(this.formatDate(new Date(moment().subtract(1, 'day'))))
        };
      }
    },

    maxDatesEnd: function maxDatesEnd() {
      return Stats__this.parseDate(Stats__this.formatDate(new Date(moment().local().endOf('day'))));
    },
    minDatesEnd: function minDatesEnd() {
      return Stats__this.parseDate(Stats__this.dateStartPicker);
    },
    allowedDatesEnd: function allowedDatesEnd() {
      return {
        max: this.parseDate(this.formatDate(new Date(moment().local().endOf('day')))),
        min: this.parseDate(this.dateStartPicker)
      };
    },
    nbDays: function nbDays() {
      return moment(this.dateEndPicker).diff(moment(this.dateStartPicker), 'days') + 1;
    },
    headersSites: function headersSites() {
      return !this.siteTmp.length ? [{ text: lodash_default.a.upperFirst(this.$t('all')), align: 'left', sortable: false }] : [{ text: lodash_default.a.upperFirst(this.$t('none')), align: 'left', sortable: false }];
    },
    showSelectAgents: function showSelectAgents() {
      return ['reports', 'audience', 'chatbot', 'C2C'].indexOf(this.$route.name) === -1;
    },
    showSelectBots: function showSelectBots() {
      return ['chatbot'].indexOf(this.$route.name) !== -1;
    },
    showSelectMotifs: function showSelectMotifs() {
      return ['chatbot', 'agents-perf', 'satisfaction'].indexOf(this.$route.name) !== -1 && this.HAS_ONE_MOTIF;
    },
    motifInitialisation: function motifInitialisation() {
      return [{ 'MOT_ID': '', 'MOT_CODE': 'WZNOMOTIF', 'MOT_LABEL': this.$t('nomotif') }].concat(toConsumableArray_default()(this.$store.state._Sites.sites[0].motifs));
    }
  }),

  methods: {
    initPeriod: function initPeriod() {
      this.period = lodash_default.a.isNil(this.$store.state._Stats.period) ? 1 : this.$store.state._Stats.period;
      console.log('this.entLevel', this.entLevel);

      if (this.entLevel === '10' || this.entLevel === '1') {
        this.period = 1;
      }
      console.log('this.period', this.period);
    },
    initDates: function initDates() {
      var periodPerso = this.period === 0;
      console.log('periodPerso', periodPerso);
      if (periodPerso) {
        this.dateEndPicker = lodash_default.a.isEmpty(this.$store.state._Stats.dateEnd) ? new Date(moment().startOf('day')) : new Date(this.$store.state._Stats.dateEnd);

        this.dateStartPicker = lodash_default.a.isEmpty(this.$store.state._Stats.dateEnd) ? new Date(moment().subtract(1, 'week')) : new Date(this.$store.state._Stats.dateStart);
      } else {
        this.dateEndPicker = new Date(moment());
        switch (this.period) {
          case 1:
            this.dateStartPicker = new Date(moment().subtract(1, 'day'));
            this.dateEndPicker = new Date(moment().subtract(1, 'day'));
            break;
          case 2:
            this.dateStartPicker = new Date(moment().startOf('week'));
            this.dateEndPicker = new Date(moment().subtract(0, 'day'));
            break;
          case 3:
            this.dateStartPicker = new Date(moment().startOf('month'));
            this.dateEndPicker = new Date(moment().subtract(0, 'day'));
            break;
          case 4:
            this.dateStartPicker = new Date(moment().subtract(7, 'day'));
            this.dateEndPicker = new Date(moment().subtract(1, 'day'));
            break;
          case 5:
            this.dateStartPicker = new Date(moment().subtract(30, 'day'));
            this.dateEndPicker = new Date(moment().subtract(1, 'day'));
            break;
          case 6:
            this.dateStartPicker = new Date(moment().startOf('week').subtract(1, 'week'));
            this.dateEndPicker = new Date(moment().startOf('week').subtract(1, 'day'));
            break;
          case 7:
            this.dateStartPicker = new Date(moment().startOf('month').subtract(1, 'month'));
            this.dateEndPicker = new Date(moment().startOf('month').subtract(1, 'day'));
            break;
          case 8:
            this.dateStartPicker = new Date(moment().subtract(1, 'Q').startOf('Q'));
            this.dateEndPicker = new Date(moment().subtract(1, 'Q').endOf('Q'));
            break;
          default:
            this.initPeriod();
        }
      }

      this.dateStartDisplayed = this.formatDate(this.dateStartPicker);
      this.dateStartPicker = this.parseDate(this.dateStartDisplayed);
      this.dateEndDisplayed = this.formatDate(this.dateEndPicker);
      this.dateEndPicker = this.parseDate(this.dateEndDisplayed);
    },
    initAgents: function initAgents() {
      this.agent = this.$store.state._Stats.agents.length ? this.$store.state._Stats.agents : this.$store.state._User.colleagues;
    },
    initBots: function initBots() {
      this.bot = this.$store.state._Stats.bots.length ? this.$store.state._Stats.bots : this.$store.state._User.bots;
    },
    initMotifs: function initMotifs() {
      this.motif = this.$store.state._Stats.motifs.length ? this.$store.state._Stats.motifs : [];
    },
    initSites: function initSites() {
      this.site = this.$store.state._Stats.sites.length ? this.$store.state._Stats.sites : this.$store.state._Sites.sites;
    },
    initChannels: function initChannels() {
      this.channel = this.channels;
    },
    openDialogSites: function openDialogSites() {
      this.dialogSites = true;
      this.siteTmp = lodash_default.a.cloneDeep(this.site);
    },
    submitDialogSites: function submitDialogSites() {
      this.dialogSites = false;
      this.site = lodash_default.a.cloneDeep(this.siteTmp);
    },
    formatDate: function formatDate(date) {
      return !date ? 'Aucune date' : moment(date, 'YYYY[-]MM[-]DD').format('ddd LL');
    },
    parseDate: function parseDate(date) {
      var formatOfDate = moment(date, 'ddd LL').format('ddd LL') === date ? 'ddd LL' : 'YYYY[-]MM[-]DD';
      return !date || !moment(date, formatOfDate).isValid() ? null : moment(date, formatOfDate).format('YYYY[-]MM[-]DD');
    }
  },

  watch: {
    channel: function channel(val, oldVal) {
      if (val.length === 1) {
        this.channel[0].disabled = true;
      } else {
        lodash_default.a.each(this.channel, function (channel) {
          channel.disabled = false;
        });
      }
    },
    dateStartPicker: function dateStartPicker(val, oldVal) {
      this.$store.commit('_Stats/SET_DATE_START', moment(val).hours(0).minutes(0).seconds(0).format());
    },
    dateEndPicker: function dateEndPicker(val, oldVal) {
      this.$store.commit('_Stats/SET_DATE_END', moment(val).hours(23).minutes(59).seconds(59).format());
    },
    period: function period(val, oldVal) {
      this.initDates();

      this.$store.commit('_Stats/SET_PERIOD', val);
    },

    'agent.length': function agentLength() {},
    agent: function agent(v) {
      this.$store.commit('_Stats/SET_AGENTS', v);
    },
    bot: function bot(v) {
      this.$store.commit('_Stats/SET_BOTS', v);
    },
    site: function site(v) {
      this.$store.commit('_Stats/SET_SITES', v);
    },
    motif: function motif(v) {
      this.$store.commit('_Stats/SET_MOTIFS', v);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6feb2051","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Stats.vue
var Stats_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"stats"},[(_vm.$route.fullPath && _vm.$route.fullPath.indexOf('reports') == -1)?_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"dense":"","items":_vm.periods,"label":_vm._f("cap")(_vm.$t('period')),"prepend-icon":"date_range","disabled":_vm.periodDisabled},model:{value:(_vm.period),callback:function ($$v) {_vm.period=$$v},expression:"period"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-dialog',{attrs:{"lazy":"","full-width":"","width":"290px","disabled":_vm.period != 0},model:{value:(_vm.modalStart),callback:function ($$v) {_vm.modalStart=$$v},expression:"modalStart"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm._f("cap")(_vm.$t('startDate')),"prepend-icon":"event","readonly":"","disabled":_vm.period != 0},on:{"blur":function($event){_vm.dateStartPicker = _vm.parseDate(_vm.dateStartDisplayed)}},slot:"activator",model:{value:(_vm.dateStartDisplayed),callback:function ($$v) {_vm.dateStartDisplayed=$$v},expression:"dateStartDisplayed"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"first-day-of-week":1,"min":_vm.allowedDatesStart.min,"max":_vm.allowedDatesStart.max,"locale":_vm.$i18n.locale,"scrollable":"","color":"primary"},on:{"input":function($event){_vm.dateStartDisplayed = _vm.formatDate($event); _vm.modalStart = false}},model:{value:(_vm.dateStartPicker),callback:function ($$v) {_vm.dateStartPicker=$$v},expression:"dateStartPicker"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-dialog',{attrs:{"lazy":"","full-width":"","width":"290px","disabled":_vm.period != 0},model:{value:(_vm.modalEnd),callback:function ($$v) {_vm.modalEnd=$$v},expression:"modalEnd"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm._f("cap")(_vm.$t('endDate')),"prepend-icon":"event","readonly":"","disabled":_vm.period != 0},on:{"blur":function($event){_vm.dateEndPicker = _vm.parseDate(_vm.dateEndDisplayed)}},slot:"activator",model:{value:(_vm.dateEndDisplayed),callback:function ($$v) {_vm.dateEndDisplayed=$$v},expression:"dateEndDisplayed"}}),_vm._v(" "),_c('v-date-picker',{attrs:{"first-day-of-week":1,"min":_vm.allowedDatesEnd.min,"max":_vm.allowedDatesEnd.max,"locale":_vm.$i18n.locale,"scrollable":"","color":"primary"},on:{"input":function($event){_vm.dateEndDisplayed = _vm.formatDate($event); _vm.modalEnd = false}},model:{value:(_vm.dateEndPicker),callback:function ($$v) {_vm.dateEndPicker=$$v},expression:"dateEndPicker"}})],1)],1)],1)],1),_vm._v(" "),(_vm.$route.name !== 'sales' || !_vm.HAS_ONE_FUNNEL)?_c('v-flex',{attrs:{"xs6":"","md2":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{class:{'ml-5': _vm.$vuetify.breakpoint.mdAndUp},attrs:{"xs12":"","pt-2":""}},[_c('v-btn',{staticClass:"ml-0",attrs:{"color":"primary","outline":"","block":_vm.$vuetify.breakpoint.smAndDown},on:{"click":function($event){_vm.openDialogSites()}}},[_c('v-icon',{attrs:{"left":"","color":"primary"}},[_vm._v("language")]),_vm._v("\n                  "+_vm._s(_vm.site.length)+" / "+_vm._s(_vm.$tc('sites', _vm.$store.state._Sites.sites.length, { count: _vm.$store.state._Sites.sites.length }))+"\n                ")],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"min-content"},model:{value:(_vm.dialogSites),callback:function ($$v) {_vm.dialogSites=$$v},expression:"dialogSites"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('select') + ' ' + _vm.$tc('sites', 2, {count: ''})))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"400px"}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersSites,"items":_vm.$store.state._Sites.sites,"item-key":"LIC_ID","select-all":"primary","hide-actions":"","total-items":_vm.$store.state._Sites.sites.length},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(props.header.text))])]}},{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{attrs:{"color":"primary"},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.LIC_URL))])]}}]),model:{value:(_vm.siteTmp),callback:function ($$v) {_vm.siteTmp=$$v},expression:"siteTmp"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.dialogSites = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.siteTmp.length,"color":"primary"},nativeOn:{"click":function($event){_vm.submitDialogSites()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.showSelectMotifs)?_c('v-flex',{attrs:{"xs6":"","md2":""}},[_c('wz-select-motifs',{attrs:{"motifs":_vm.motif,"motifsInit":_vm.motifInitialisation},on:{"update:motifs":function($event){_vm.motif=$event}}})],1):_vm._e(),_vm._v(" "),(_vm.showSelectAgents)?_c('v-flex',{attrs:{"xs6":"","md2":""}},[_c('wz-select-agents',{attrs:{"agents":_vm.agent,"agentsInit":_vm.$store.state._User.colleagues,"min":1},on:{"update:agents":function($event){_vm.agent=$event}}})],1):_vm._e(),_vm._v(" "),(_vm.showSelectBots)?_c('v-flex',{attrs:{"xs6":"","md2":""}},[_c('wz-select-bots',{attrs:{"bots":_vm.bot,"botsInit":_vm.$store.state._User.bots,"min":1},on:{"update:bots":function($event){_vm.bot=$event}}})],1):_vm._e()],1)],1)],1):_vm._e(),_vm._v(" "),_c('transition',{attrs:{"name":"slide-x-reverse-transition","mode":"out-in"}},[_c('router-view')],1)],1)}
var Stats_staticRenderFns = []
var Stats_esExports = { render: Stats_render, staticRenderFns: Stats_staticRenderFns }
/* harmony default export */ var components_Stats = (Stats_esExports);
// CONCATENATED MODULE: ./src/components/Stats.vue
var Stats_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Stats___vue_template_functional__ = false
/* styles */
var Stats___vue_styles__ = null
/* scopeId */
var Stats___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Stats___vue_module_identifier__ = null
var Stats_Component = Stats_normalizeComponent(
  Stats,
  components_Stats,
  Stats___vue_template_functional__,
  Stats___vue_styles__,
  Stats___vue_scopeId__,
  Stats___vue_module_identifier__
)

/* harmony default export */ var src_components_Stats = (Stats_Component.exports);

// EXTERNAL MODULE: ./node_modules/json2csv/lib/json2csv.js
var json2csv = __webpack_require__("sVpU");
var json2csv_default = /*#__PURE__*/__webpack_require__.n(json2csv);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stats/Audience.vue







/* harmony default export */ var Audience = ({
  data: function data() {
    return {
      loading: false,

      intervals: [{ text: lodash_default.a.upperFirst(this.$t('per')) + ' ' + this.$tc('days', 1, { count: '' }), value: 1 }, { text: lodash_default.a.upperFirst(this.$t('per')) + ' ' + this.$tc('months', 1, { count: '' }), value: 2 }],
      interval: null,

      resFromAjax: null,

      options: {
        chart: {
          height: 300
        },
        title: {
          text: '',
          x: -20 },
        tooltip: {
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] },
        yAxis: [{
          allowDecimals: false,
          title: { text: '' },
          opposite: false
        }, {
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: {
              color: 'rgba(233, 30, 99, 1)'
            }
          },
          title: {
            text: this.$t('chats2'),
            style: {
              color: 'rgba(233, 30, 99, 1)'
            }
          },
          opposite: true
        }],
        series: [{
          name: this.$t('trackedPages'),
          type: 'area',
          color: 'rgba(0, 150, 136, 0.8)',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          yAxis: 0,
          data: [] }, {
          name: lodash_default.a.upperFirst(this.$tc('visitors', 2, { count: '' })),
          type: 'area',
          color: 'rgba(33, 150, 243, 0.8)',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          yAxis: 0,
          data: [] }, {
          name: lodash_default.a.upperFirst(this.$tc('chats', 2, { count: '' })),
          type: 'column',
          color: 'rgba(233, 30, 99, 0.8)',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          yAxis: 1,
          data: [] }],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -20
          }
        },
        credits: {
          enabled: false
        }
      },
      dialogProgress: false
    };
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_Stats', ['params']), {
    nbLoads: function nbLoads() {
      return lodash_default.a.sumBy(this.resFromAjax, 'loads');
    },
    nbVisitors: function nbVisitors() {
      return lodash_default.a.sumBy(this.resFromAjax, 'visitors');
    },
    nbChats: function nbChats() {
      return lodash_default.a.sumBy(this.resFromAjax, 'chats');
    },
    conversation: function conversation() {
      return this.nbVisitors !== 0 ? lodash_default.a.round(this.nbChats / this.nbVisitors * 100, 2) : 0;
    }
  }),

  mounted: function mounted() {
    this.loading = true;

    this.interval = this.intervals[0];
    this.getAudienceData();
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
  },


  methods: {
    getAudienceData: function getAudienceData() {
      var _this = this;

      this.loading = true;

      this.axios.get('get/audience.php?' + this.params).then(function (response) {
        _this.resFromAjax = response.data;
        _this.updateSeries();
      }).catch(function (errors) {}).then(function (_) {
        _this.loading = false;
      });
    },
    updateSeries: function updateSeries() {
      var _this2 = this;

      this.options.xAxis.categories = [];
      this.options.series[0].data = [];
      this.options.series[1].data = [];
      this.options.series[2].data = [];

      if (this.interval.value === 1) {
        lodash_default.a.forEach(this.resFromAjax, function (day) {
          _this2.options.xAxis.categories.push(moment(day.date).format('ddd D MMM YY'));
          _this2.options.series[0].data.push(day.loads);
          _this2.options.series[1].data.push(day.visitors);
          _this2.options.series[2].data.push(day.chats);
        });
      } else {
        lodash_default.a.forEach(this.resFromAjax, function (day) {
          var found = -1;
          for (var i = 0; i < _this2.options.xAxis.categories.length; i++) {
            if (_this2.options.xAxis.categories[i] === moment(day.date).format('MMMM YYYY')) {
              found = i;
            }
          }
          if (found === -1) {
            _this2.options.xAxis.categories.push(moment(day.date).format('MMMM YYYY'));
            _this2.options.series[0].data.push(day.loads);
            _this2.options.series[1].data.push(day.visitors);
            _this2.options.series[2].data.push(day.chats);
          }

          _this2.options.series[0].data[found] += day.loads;
          _this2.options.series[1].data[found] += day.visitors;
          _this2.options.series[2].data[found] += day.chats;
        });
      }

      if (this.$parent.nbDays === 1 || this.interval.value !== 1) {
        this.options.series[0].type = 'column';
        this.options.series[1].type = 'column';
      } else {
        this.options.series[0].type = 'area';
        this.options.series[1].type = 'area';
      }
    },
    download: function download() {
      var csv = null;
      var fields = ['date', this.options.series[0].name, this.options.series[1].name, this.options.series[2].name];

      var dataToExport = [];
      for (var i = 0; i < this.options.xAxis.categories.length; i++) {
        var value = [];
        value[fields[0]] = this.options.xAxis.categories[i];
        value[fields[1]] = this.options.series[0].data[i];
        value[fields[2]] = this.options.series[1].data[i];
        value[fields[3]] = this.options.series[2].data[i];
        dataToExport.push(value);
      }
      try {
        csv = json2csv_default()({ data: dataToExport, del: ';', fields: fields });
      } catch (err) {
        return;
      }

      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'audience.csv';
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    }
  },

  watch: {
    params: function params(v) {
      this.getAudienceData();
    },

    interval: function interval(val, oldVal) {
      this.updateSeries();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f84553c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/Audience.vue
var Audience_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audience"},[(_vm.loading)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('div',[_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm3":"","md2":""}},[_c('div',{staticClass:"grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('trackedPages'))))]),_vm._v(" "),_c('div',{staticClass:"headline teal--text"},[_vm._v(_vm._s(_vm.nbLoads))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md2":""}},[_c('div',{staticClass:"grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('visitors', 2, { count: '' }))))]),_vm._v(" "),_c('div',{staticClass:"headline blue--text"},[_vm._v(_vm._s(_vm.nbVisitors))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md2":""}},[_c('div',{staticClass:"grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('chats', 2, { count: '' }))))]),_vm._v(" "),_c('div',{staticClass:"headline pink--text"},[_vm._v(_vm._s(_vm.nbChats))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm3":"","md2":""}},[_c('div',{staticClass:"grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('conversationRate'))))]),_vm._v(" "),_c('div',{staticClass:"headline primary--text"},[_vm._v(_vm._s(_vm.conversation)+" %")])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-select',{attrs:{"label":_vm._f("cap")(_vm.$t('dataInterval')),"items":_vm.intervals,"return-object":""},model:{value:(_vm.interval),callback:function ($$v) {_vm.interval=$$v},expression:"interval"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-btn',{attrs:{"color":"primary","dark":"","flat":""},on:{"click":function($event){_vm.download()}}},[_vm._v(_vm._s(_vm.$t('exportInCsv'))),_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("file_download")])],1)],1)],1),_vm._v(" "),_c('highcharts',{attrs:{"options":_vm.options}})],1)],1)],1),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":16},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)}
var Audience_staticRenderFns = []
var Audience_esExports = { render: Audience_render, staticRenderFns: Audience_staticRenderFns }
/* harmony default export */ var stats_Audience = (Audience_esExports);
// CONCATENATED MODULE: ./src/components/stats/Audience.vue
var Audience_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Audience___vue_template_functional__ = false
/* styles */
var Audience___vue_styles__ = null
/* scopeId */
var Audience___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Audience___vue_module_identifier__ = null
var Audience_Component = Audience_normalizeComponent(
  Audience,
  stats_Audience,
  Audience___vue_template_functional__,
  Audience___vue_styles__,
  Audience___vue_scopeId__,
  Audience___vue_module_identifier__
)

/* harmony default export */ var components_stats_Audience = (Audience_Component.exports);

// EXTERNAL MODULE: ./node_modules/moment-duration-format/lib/moment-duration-format.js
var moment_duration_format = __webpack_require__("SdwT");
var moment_duration_format_default = /*#__PURE__*/__webpack_require__.n(moment_duration_format);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stats/Chats.vue










/* harmony default export */ var Chats = ({
  data: function data() {
    return {
      loading: false,
      loadingExportData: false,
      queryCounter: 0,
      chatsOK: 0,
      chatsKO: 0,
      totalChats: 0,
      chatsPostInvit: 0,
      chatsTotalDuration: 0,
      chatsAverageDuration: 0,
      nbMessages: 0,
      chatsAverageResponseValue: 0,
      chatsFirstResponseValue: 0,
      chatsCloseTimeValue: 0,
      histoready: false,

      optionsJauge: {
        chart: {
          type: 'solidgauge',
          height: 180
        },
        title: {
          style: {
            fontSize: '20px',
            fontFamily: '"Inconsolata", sans-serif'
          }
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        pane: {
          size: '220',
          startAngle: -90,
          endAngle: 90,
          center: ['50%', '95%'],
          background: {
            backgroundColor: '#ddd',
            outerRadius: '100%',
            innerRadius: '90%',
            shape: 'arc',
            borderColor: 'transparent'
          }
        },
        tooltip: {
          enabled: false
        },
        yAxis: {
          min: 0,
          lineWidth: 0,
          minorTickInterval: null,
          tickAmount: 2,
          title: {
            text: ''
          }
        },
        plotOptions: {
          solidgauge: {
            innerRadius: '90%',
            dataLabels: {
              y: 5,
              borderWidth: 0,
              useHTML: true
            }
          }
        },
        series: [{
          data: [0]
        }]
      },

      chatsMissed: {
        title: {
          text: lodash_default.a.upperFirst(this.$tc('chatsMissed', 2, { count: '' }))
        },
        yAxis: {
          stops: [[0, '#009688']],
          max: 100
        },
        series: [{
          dataLabels: {
            format: '<div style="text-align:center;font-family:\'Ubuntu\', sans-serif;font-size:32px;color:' + this.$vuetify.theme.primary + ';">{y:.1f} %</span></div>'
          }
        }]
      },
      chatsByAgentFilter: {
        title: {
          text: this.$t('chatsByAgentFilter')
        },
        yAxis: {
          stops: [[0, '#607D8B']],
          max: 100
        },
        series: [{
          dataLabels: {
            format: '<div style="text-align:center;font-family:\'Ubuntu\', sans-serif;font-size:32px;color:' + this.$vuetify.theme.primary + ';">{y:.1f} %</span></div>'
          }
        }]
      },
      chatsAverageResponse: {
        yAxis: {
          stops: [[0, '#E91E63']],
          max: 120
        },
        title: {
          text: lodash_default.a.upperFirst(this.$t('chatsAverageResponse'))
        },
        series: [{
          dataLabels: {
            format: '<div style="text-align:center;font-family:\'Ubuntu\', sans-serif;font-size:32px;color:' + this.$vuetify.theme.primary + ';">{y:.0f} sec.</span></div>'
          }
        }]
      },
      chatsFirstResponse: {
        yAxis: {
          stops: [[0, '#E91E63']],
          max: 120
        },
        title: {
          text: lodash_default.a.upperFirst(this.$t('chatsFirstResponse'))
        },
        series: [{
          dataLabels: {
            format: '<div style="text-align:center;font-family:\'Ubuntu\', sans-serif;font-size:32px;color:' + this.$vuetify.theme.primary + ';">{y:.0f} sec.</span></div>'
          }
        }]
      },
      chatsCloseTime: {
        yAxis: {
          stops: [[0, '#E91E63']],
          max: 120
        },
        title: {
          text: lodash_default.a.upperFirst(this.$t('chatsCloseTime'))
        },
        series: [{
          dataLabels: {
            format: '<div style="text-align:center;font-family:\'Ubuntu\', sans-serif;font-size:32px;color:' + this.$vuetify.theme.primary + ';">{y:.0f} sec.</span></div>'
          }
        }]
      }
    };
  },
  created: function created() {
    this.chatsMissed = lodash_default.a.merge(this.chatsMissed, this.optionsJauge);
    this.chatsByAgentFilter = lodash_default.a.merge(this.chatsByAgentFilter, this.optionsJauge);
    this.chatsAverageResponse = lodash_default.a.merge(this.chatsAverageResponse, this.optionsJauge);
    this.chatsFirstResponse = lodash_default.a.merge(this.chatsFirstResponse, this.optionsJauge);
    this.chatsCloseTime = lodash_default.a.merge(this.chatsCloseTime, this.optionsJauge);
    this.getAll();
  },


  methods: {
    getAll: function getAll() {
      var _this = this;

      this.loading = true;
      this.queryCounter++;
      promise_default.a.all([this.getChatsMissed(), this.getChatsByAgentFilter(), this.getChatsAverageResponse(), this.getChatsFirstResponse(), this.getChatsCloseTime(), this.getChatsDuration(), this.getNbMessages()]).then(function () {
        if (_this.queryCounter === 1) {
          _this.loading = false;
        }
        _this.queryCounter--;
      });
    },
    getChatsMissed: function getChatsMissed() {
      var _this2 = this;

      return new promise_default.a(function (resolve, reject) {
        _this2.axios.get('get/chats_missed.php?' + _this2.params).then(function (response) {
          _this2.chatsOK = response.data.chatsOK;
          _this2.chatsKO = response.data.chatsKO;

          _this2.totalChats = _this2.chatsKO + _this2.chatsOK;
          var ratio = _this2.chatsKO / _this2.totalChats * 100;

          _this2.chatsMissed.series[0].data[0] = ratio;
          _this2.chatsMissed.yAxis.title.text = _this2.chatsKO + ' chats';
          resolve();
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    getChatsByAgentFilter: function getChatsByAgentFilter() {
      var _this3 = this;

      return new promise_default.a(function (resolve, reject) {
        _this3.axios.get('get/chats_by_agent_filter.php?' + _this3.params).then(function (response) {
          _this3.chatsPostInvit = response.data.chatsPostInvit;
          _this3.chatsTot = response.data.chatsOK;

          var ratio = _this3.chatsPostInvit / _this3.chatsTot * 100;

          _this3.chatsByAgentFilter.series[0].data[0] = ratio;
          _this3.chatsByAgentFilter.yAxis.title.text = _this3.chatsPostInvit + ' chats';
          resolve();
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    getChatsAverageResponse: function getChatsAverageResponse() {
      var _this4 = this;

      return new promise_default.a(function (resolve, reject) {
        _this4.axios.get('get/chats_average_response.php?' + _this4.params).then(function (response) {
          _this4.chatsAverageResponse.series[0].data[0] = response.data.tpsReponse;
          _this4.chatsAverageResponseValue = response.data.tpsReponse;
          resolve();
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    getChatsFirstResponse: function getChatsFirstResponse() {
      var _this5 = this;

      return new promise_default.a(function (resolve, reject) {
        _this5.axios.get('get/chats_first_response.php?' + _this5.params).then(function (response) {
          _this5.chatsFirstResponse.series[0].data[0] = response.data.tpsReponse;
          _this5.chatsFirstResponseValue = response.data.tpsReponse;
          resolve();
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    getChatsCloseTime: function getChatsCloseTime() {
      var _this6 = this;

      return new promise_default.a(function (resolve, reject) {
        _this6.axios.get('get/chats_close_time.php?' + _this6.params).then(function (response) {
          _this6.chatsCloseTime.series[0].data[0] = response.data.tempscloture;
          _this6.chatsCloseTimeValue = response.data.tempscloture;
          resolve();
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    getChatsDuration: function getChatsDuration() {
      var _this7 = this;

      return new promise_default.a(function (resolve, reject) {
        _this7.axios.get('get/chats_duration.php?' + _this7.params).then(function (response) {
          _this7.chatsTotalDuration = response.data.dureeTotale;
          _this7.chatsAverageDuration = response.data.dureeMoyenne;
          resolve();
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    getNbMessages: function getNbMessages() {
      var _this8 = this;

      return new promise_default.a(function (resolve, reject) {
        _this8.axios.get('get/agents_nb_messages.php?' + _this8.params).then(function (response) {
          _this8.nbMessages = response.data.nbBulles;
          resolve();
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    download: function download() {
      this.loadingExportData = true;
      var csv = null;
      var fields = ['chats', 'messages', 'totalDurationOfChats', 'averageDurationOfOneChat', 'chatsMissed', 'chatsByAgentFilter', 'chatsAverageResponse', 'chatsFirstResponse', 'chatsCloseTime'];
      var fieldNames = [this.$tc('chats', 2, { count: '' }), this.$tc('messages', 2, { count: '' }), this.$t('totalDurationOfChats'), this.$t('averageDurationOfOneChat'), this.$tc('chatsMissed', 2, { count: '' }), this.$t('chatsByAgentFilter'), this.$t('chatsAverageResponse'), this.$t('chatsFirstResponse'), this.$t('chatsCloseTime')];
      var data = {
        chats: this.chatsOK,
        messages: this.nbMessages,
        totalDurationOfChats: this.chatsTotalDuration,
        averageDurationOfOneChat: this.chatsAverageDuration,
        chatsMissed: this.chatsKO,
        chatsByAgentFilter: this.chatsPostInvit,
        chatsAverageResponse: this.chatsAverageResponseValue,
        chatsFirstResponse: this.chatsFirstResponseValue,
        chatsCloseTime: this.chatsCloseTimeValue
      };
      try {
        csv = json2csv_default()({ data: data, fields: fields, del: ';', fieldNames: fieldNames });
      } catch (err) {
        this.loadingExportData = false;
        return;
      }

      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'chats.csv';
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
      this.loadingExportData = false;
    },
    getChats: function getChats() {
      if (this.histoready) {
        this.histoready = false;
      } else {
        this.histoready = true;
      }
    }
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_Stats', ['params']), Object(vuex_esm["e" /* mapState */])('_User', ['entLevel']), {
    heightOfJauge: function heightOfJauge() {
      return this.optionsJauge.chart.height + 'px';
    },
    totalDurationFormatted: function totalDurationFormatted() {
      return moment_default.a.duration(this.chatsTotalDuration, 'seconds').format('h[h] m[m] s[s]');
    },
    averageDurationFormatted: function averageDurationFormatted() {
      return moment_default.a.duration(this.chatsAverageDuration, 'seconds').format('h[h] m[m] s[s]');
    }
  }),

  watch: {
    params: function params(v) {
      this.getAll();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c8f2582","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/Chats.vue
var Chats_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm2":"","offset-xs6":"","offset-sm10":""}},[_c('v-btn',{attrs:{"color":"primary","loading":_vm.loadingExportData,"disabled":_vm.loadingExportData,"flat":""},on:{"click":function($event){_vm.download()}}},[_vm._v("\n          "+_vm._s(_vm.$t('exportInCsv'))+"\n          "),_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("file_download")])],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-3"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"subheading text-xs-center"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('chats', 2, { count: '' }))))])])]),_vm._v(" "),_c('v-flex',{staticClass:"primary--text display-1 text-xs-center",attrs:{"xs12":""}},[_vm._v("\n                "+_vm._s(_vm.chatsOK)+"\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-3"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"subheading text-xs-center"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('messages', 2, { count: '' }))))])])]),_vm._v(" "),_c('v-flex',{staticClass:"primary--text display-1 text-xs-center",attrs:{"xs12":""}},[_vm._v("\n                "+_vm._s(_vm.nbMessages)+"\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-3"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"subheading text-xs-center"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('totalDurationOfChats'))))])])]),_vm._v(" "),_c('v-flex',{staticClass:"primary--text display-1 text-xs-center",attrs:{"xs12":""}},[_vm._v("\n                "+_vm._s(_vm.totalDurationFormatted)+"\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-3"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"subheading text-xs-center"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('averageDurationOfOneChat'))))])])]),_vm._v(" "),_c('v-flex',{staticClass:"primary--text display-1 text-xs-center",attrs:{"xs12":""}},[_vm._v("\n                "+_vm._s(_vm.averageDurationFormatted)+"\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',{staticClass:"mb-3",attrs:{"height":_vm.heightOfJauge}},[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('highcharts',{attrs:{"options":_vm.chatsMissed}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',{staticClass:"mb-3",attrs:{"height":_vm.heightOfJauge}},[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('highcharts',{attrs:{"options":_vm.chatsByAgentFilter}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',{staticClass:"mb-3",attrs:{"height":_vm.heightOfJauge}},[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('highcharts',{attrs:{"options":_vm.chatsAverageResponse}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',{staticClass:"mb-3",attrs:{"height":_vm.heightOfJauge}},[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('highcharts',{attrs:{"options":_vm.chatsFirstResponse}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',{staticClass:"mb-3",attrs:{"height":_vm.heightOfJauge}},[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('highcharts',{attrs:{"options":_vm.chatsCloseTime}})],1)],1)],1),_vm._v(" "),_c('span',[(_vm.histoready)?_c('v-btn',{attrs:{"flat":"","color":"accent"},on:{"click":function($event){_vm.getChats()}}},[_vm._v("\n        "+_vm._s(_vm.$t('hideChat'))+"\n        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("visibility_off")])],1):_c('v-btn',{attrs:{"flat":"","color":"accent"},on:{"click":function($event){_vm.getChats()}}},[_vm._v("\n        "+_vm._s(_vm.$t('showChat'))+"\n        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("visibility")])],1)],1),_vm._v(" "),(_vm.histoready)?_c('wz-histo-chats',{attrs:{"params":_vm.params,"numChatsTotal":String(_vm.chatsOK)}}):_vm._e()],1)}
var Chats_staticRenderFns = []
var Chats_esExports = { render: Chats_render, staticRenderFns: Chats_staticRenderFns }
/* harmony default export */ var stats_Chats = (Chats_esExports);
// CONCATENATED MODULE: ./src/components/stats/Chats.vue
var Chats_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Chats___vue_template_functional__ = false
/* styles */
var Chats___vue_styles__ = null
/* scopeId */
var Chats___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Chats___vue_module_identifier__ = null
var Chats_Component = Chats_normalizeComponent(
  Chats,
  stats_Chats,
  Chats___vue_template_functional__,
  Chats___vue_styles__,
  Chats___vue_scopeId__,
  Chats___vue_module_identifier__
)

/* harmony default export */ var components_stats_Chats = (Chats_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stats/Chatbot.vue










/* harmony default export */ var Chatbot = ({
  data: function data() {
    return {
      loading: false,
      loadingExportData: false,
      queryCounter: 0,
      nbSucc: 0,
      nbEchec: 0,
      nbChats: 0,
      nbTransf: 0,
      nbFail: 0,
      chatsPostInvit: 0,
      chatsAverageDuration: 0,
      nbMessages: 0,
      nbConvSucc: 0,
      nbConvEchec: 0,
      nbConvFail: 0,
      nbConvTransf: 0,
      ratioKO: 0,
      ratioOK: 0,
      ratioTransf: 0,
      ratiobotEnTouche: 0,
      histoready: false,

      optionsJauge: {
        chart: {
          type: 'solidgauge',
          height: 180
        },
        title: {
          style: {
            fontSize: '20px',
            fontFamily: '"Inconsolata", sans-serif'
          }
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },
        pane: {
          size: '220',
          startAngle: -90,
          endAngle: 90,
          center: ['50%', '95%'],
          background: {
            backgroundColor: '#ddd',
            outerRadius: '100%',
            innerRadius: '90%',
            shape: 'arc',
            borderColor: 'transparent'
          }
        },
        tooltip: {
          enabled: false
        },
        yAxis: {
          min: 0,
          lineWidth: 0,
          minorTickInterval: null,
          tickAmount: 2,
          title: {
            text: ''
          }
        },
        plotOptions: {
          solidgauge: {
            innerRadius: '90%',
            dataLabels: {
              y: 5,
              borderWidth: 0,
              useHTML: true
            }
          }
        },
        series: [{
          data: [0]
        }]
      },

      botFailed: {
        title: {
          text: lodash_default.a.upperFirst(this.$tc('botFailed', 2, { count: '' }))
        },
        yAxis: {
          stops: [[0, '#009688']],
          max: 100
        },
        series: [{
          dataLabels: {
            format: '<div style="text-align:center;font-family:\'Ubuntu\', sans-serif;font-size:32px;color:' + this.$vuetify.theme.primary + ';">{y:.1f} %</span></div>'
          }
        }]
      },

      botTransfered: {
        title: {
          text: lodash_default.a.upperFirst(this.$tc('botTransfered', 2, { count: '' }))
        },
        yAxis: {
          stops: [[0, '#009688']],
          max: 100
        },
        series: [{
          dataLabels: {
            format: '<div style="text-align:center;font-family:\'Ubuntu\', sans-serif;font-size:32px;color:' + this.$vuetify.theme.primary + ';">{y:.1f} %</span></div>'
          }
        }]
      },

      botSucceed: {
        title: {
          text: lodash_default.a.upperFirst(this.$tc('botSucceed', 2, { count: '' }))
        },
        yAxis: {
          stops: [[0, '#009688']],
          max: 100
        },
        series: [{
          dataLabels: {
            format: '<div style="text-align:center;font-family:\'Ubuntu\', sans-serif;font-size:32px;color:' + this.$vuetify.theme.primary + ';">{y:.1f} %</span></div>'
          }
        }]
      },

      botEnTouche: {
        title: {
          text: lodash_default.a.upperFirst(this.$t('convMisunderstanding'))
        },
        yAxis: {
          stops: [[0, '#009688']],
          max: 100
        },
        series: [{
          dataLabels: {
            format: '<div style="text-align:center;font-family:\'Ubuntu\', sans-serif;font-size:32px;color:' + this.$vuetify.theme.primary + ';">{y:.1f} %</span></div>'
          }
        }]
      }
    };
  },
  created: function created() {
    this.botFailed = lodash_default.a.merge(this.botFailed, this.optionsJauge);
    this.botSucceed = lodash_default.a.merge(this.botSucceed, this.optionsJauge);
    this.botTransfered = lodash_default.a.merge(this.botTransfered, this.optionsJauge);
    this.botEnTouche = lodash_default.a.merge(this.botEnTouche, this.optionsJauge);
    this.getAll();
  },


  methods: {
    brideMenu: function brideMenu(nameBride) {
      if (this.brides) {
        var index = this.brides.findIndex(function (bride) {
          return bride.brideName === nameBride;
        });

        if (index !== -1) {
          return this.brides[index].status;
        }
      }
    },
    getAll: function getAll() {
      var _this = this;

      this.loading = true;
      this.queryCounter++;
      promise_default.a.all([this.getBotStats(), this.getChatsDuration(), this.getNbMessages()]).then(function () {
        if (_this.queryCounter === 1) {
          _this.loading = false;
        }
        _this.queryCounter--;
      });
    },
    getBotStats: function getBotStats() {
      var _this2 = this;

      return new promise_default.a(function (resolve, reject) {
        _this2.axios.get('get/chats_bot_stats.php?' + _this2.params).then(function (response) {
          _this2.nbChats = response.data.nbChats;

          _this2.nbSucc = response.data.nbSucc;
          _this2.nbEchec = response.data.nbEchec;
          _this2.nbTransf = response.data.nbTransf;
          _this2.nbFail = response.data.botEnTouche;

          _this2.nbConvSucc = response.data.nbConvSucc;
          _this2.nbConvEchec = response.data.nbConvEchec;
          _this2.nbConvTransf = response.data.nbConvTransf;
          _this2.nbConvFail = response.data.nbConvFail;

          _this2.ratioKO = _this2.nbConvEchec / _this2.nbChats * 100;

          _this2.ratioOK = _this2.nbConvSucc / _this2.nbChats * 100;

          _this2.ratioTransf = _this2.nbConvTransf / _this2.nbChats * 100;

          _this2.ratiobotEnTouche = _this2.nbConvFail / _this2.nbChats * 100;

          _this2.botFailed.series[0].data[0] = _this2.ratioKO;
          _this2.botFailed.yAxis.title.text = _this2.nbConvEchec + ' chats';

          _this2.botTransfered.series[0].data[0] = _this2.ratioTransf;
          _this2.botTransfered.yAxis.title.text = _this2.nbConvTransf + ' chats';

          _this2.botSucceed.series[0].data[0] = _this2.ratioOK;
          _this2.botSucceed.yAxis.title.text = _this2.nbConvSucc + ' chats';

          _this2.botEnTouche.series[0].data[0] = _this2.ratiobotEnTouche;
          _this2.botEnTouche.yAxis.title.text = _this2.nbConvFail + ' chats';

          resolve();
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    getChatsDuration: function getChatsDuration() {
      var _this3 = this;

      return new promise_default.a(function (resolve, reject) {
        _this3.axios.get('get/chats_bot_duration.php?' + _this3.params).then(function (response) {
          _this3.chatsAverageDuration = response.data.dureeMoyenne;
          resolve();
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    getNbMessages: function getNbMessages() {
      var _this4 = this;

      return new promise_default.a(function (resolve, reject) {
        _this4.axios.get('get/bots_nb_messages.php?' + _this4.params).then(function (response) {
          _this4.nbMessages = response.data.nbBulles;
          resolve();
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    download: function download() {
      this.loadingExportData = true;
      var csv = null;
      var fields = ['chats', 'messages', 'averageDurationOfOneChat', 'numberFailures', 'numTransfers', 'numSuccesses', 'numMisunderstandings', 'botFailed', 'botTransfered', 'botSucceed', 'convMisunderstanding'];
      var fieldNames = [this.$tc('chats', 2, { count: '' }), this.$tc('messages', 2, { count: '' }), this.$t('averageDurationOfOneChat'), this.$t('numberFailures'), this.$t('numTransfers'), this.$t('numSuccesses'), this.$t('numMisunderstandings'), this.$tc('botFailed', 2, { count: '' }), this.$tc('botTransfered', 2, { count: '' }), this.$tc('botSucceed', 2, { count: '' }), this.$t('convMisunderstanding')];
      var data = {
        chats: this.nbChats,
        messages: this.nbMessages,
        averageDurationOfOneChat: this.averageDurationFormatted,
        numberFailures: this.nbEchec,
        numTransfers: this.nbTransf,
        numSuccesses: this.nbSucc,
        numMisunderstandings: this.nbTransf,
        botFailed: this.ratioKO,
        botTransfered: this.ratioTransf,
        botSucceed: this.ratioOK,
        convMisunderstanding: this.ratiobotEnTouche
      };
      try {
        csv = json2csv_default()({ data: data, fields: fields, del: ';', fieldNames: fieldNames });
      } catch (err) {
        this.loadingExportData = false;
        return;
      }

      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'chats.csv';
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
      this.loadingExportData = false;
    },
    getBotChats: function getBotChats() {
      if (this.histoready) {
        this.histoready = false;
      } else {
        this.histoready = true;
      }
    }
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_User', ['brides']), Object(vuex_esm["c" /* mapGetters */])('_Stats', ['params']), {
    heightOfJauge: function heightOfJauge() {
      return this.optionsJauge.chart.height + 'px';
    },
    averageDurationFormatted: function averageDurationFormatted() {
      return moment_default.a.duration(this.chatsAverageDuration, 'seconds').format('h[h] m[m] s[s]');
    }
  }),

  watch: {
    params: function params(v) {
      this.getAll();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b91ae382","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/Chatbot.vue
var Chatbot_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","sm2":"","offset-xs6":"","offset-sm10":""}},[_c('v-btn',{attrs:{"color":"primary","loading":_vm.loadingExportData,"disabled":_vm.loadingExportData,"flat":""},on:{"click":function($event){_vm.download()}}},[_vm._v("\n          "+_vm._s(_vm.$t('exportInCsv'))+"\n          "),_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("file_download")])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-3"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"subheading text-xs-center"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('chats', 2, { count: '' }))))])])]),_vm._v(" "),_c('v-flex',{staticClass:"primary--text display-1 text-xs-center",attrs:{"xs12":""}},[_vm._v("\n                "+_vm._s(_vm.nbChats)+"\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-3"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"subheading text-xs-center"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('messages', 2, { count: '' }))))])])]),_vm._v(" "),_c('v-flex',{staticClass:"primary--text display-1 text-xs-center",attrs:{"xs12":""}},[_vm._v("\n                "+_vm._s(_vm.nbMessages)+"\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-card',[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-3"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"subheading text-xs-center"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('averageDurationOfOneChat'))))])])]),_vm._v(" "),_c('v-flex',{staticClass:"primary--text display-1 text-xs-center",attrs:{"xs12":""}},[_vm._v("\n                "+_vm._s(_vm.averageDurationFormatted)+"\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-card',[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-3"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"subheading text-xs-center"},[_vm._v(_vm._s(_vm.$t('numberFailures')))])])]),_vm._v(" "),_c('v-flex',{staticClass:"primary--text display-1 text-xs-center",attrs:{"xs12":""}},[_vm._v("\n                "+_vm._s(_vm.nbEchec)+"\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-card',[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-3"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"subheading text-xs-center"},[_vm._v(_vm._s(_vm.$t('numTransfers')))])])]),_vm._v(" "),_c('v-flex',{staticClass:"primary--text display-1 text-xs-center",attrs:{"xs12":""}},[_vm._v("\n                "+_vm._s(_vm.nbTransf)+"\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-card',[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-3"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"subheading text-xs-center"},[_vm._v(_vm._s(_vm.$t('numSuccesses')))])])]),_vm._v(" "),_c('v-flex',{staticClass:"primary--text display-1 text-xs-center",attrs:{"xs12":""}},[_vm._v("\n                "+_vm._s(_vm.nbSucc)+"\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-card',[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-3"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('v-container',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('div',[_c('div',{staticClass:"subheading text-xs-center"},[_vm._v(_vm._s(_vm.$t('numMisunderstandings')))])])]),_vm._v(" "),_c('v-flex',{staticClass:"primary--text display-1 text-xs-center",attrs:{"xs12":""}},[_vm._v("\n                "+_vm._s(_vm.nbFail)+"\n              ")])],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-card',{staticClass:"mb-3",attrs:{"height":_vm.heightOfJauge}},[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('highcharts',{attrs:{"options":_vm.botFailed}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-card',{staticClass:"mb-3",attrs:{"height":_vm.heightOfJauge}},[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('highcharts',{attrs:{"options":_vm.botTransfered}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-card',{staticClass:"mb-3",attrs:{"height":_vm.heightOfJauge}},[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('highcharts',{attrs:{"options":_vm.botSucceed}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md3":""}},[_c('v-card',{staticClass:"mb-3",attrs:{"height":_vm.heightOfJauge}},[(_vm.loading)?_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('highcharts',{attrs:{"options":_vm.botEnTouche}})],1)],1)],1),_vm._v(" "),(_vm.brideMenu('stats_chatbot_histo') === '1')?_c('span',[(_vm.histoready)?_c('v-btn',{attrs:{"flat":"","color":"accent"},on:{"click":function($event){_vm.getBotChats()}}},[_vm._v("\n        "+_vm._s(_vm.$t('hideChat'))+"\n        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("visibility_off")])],1):_c('v-btn',{attrs:{"flat":"","color":"accent"},on:{"click":function($event){_vm.getBotChats()}}},[_vm._v("\n        "+_vm._s(_vm.$t('showChat'))+"\n        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("visibility")])],1)],1):_vm._e(),_vm._v(" "),(_vm.histoready)?_c('wz-histo-bot',{attrs:{"params":_vm.params,"numChatsTotal":String(_vm.nbChats)}}):_vm._e()],1)}
var Chatbot_staticRenderFns = []
var Chatbot_esExports = { render: Chatbot_render, staticRenderFns: Chatbot_staticRenderFns }
/* harmony default export */ var stats_Chatbot = (Chatbot_esExports);
// CONCATENATED MODULE: ./src/components/stats/Chatbot.vue
var Chatbot_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Chatbot___vue_template_functional__ = false
/* styles */
var Chatbot___vue_styles__ = null
/* scopeId */
var Chatbot___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Chatbot___vue_module_identifier__ = null
var Chatbot_Component = Chatbot_normalizeComponent(
  Chatbot,
  stats_Chatbot,
  Chatbot___vue_template_functional__,
  Chatbot___vue_styles__,
  Chatbot___vue_scopeId__,
  Chatbot___vue_module_identifier__
)

/* harmony default export */ var components_stats_Chatbot = (Chatbot_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/values.js
var object_values = __webpack_require__("gRE1");
var values_default = /*#__PURE__*/__webpack_require__.n(object_values);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/slicedToArray.js
var slicedToArray = __webpack_require__("d7EF");
var slicedToArray_default = /*#__PURE__*/__webpack_require__.n(slicedToArray);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/entries.js
var entries = __webpack_require__("W3Iv");
var entries_default = /*#__PURE__*/__webpack_require__.n(entries);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stats/AgentsPerformance.vue













/* harmony default export */ var AgentsPerformance = ({
  data: function data() {
    var _this = this;

    return {
      loadingAgentsChats: true,
      occupationAgentDay: false,
      occupationAgentPeriode: false,
      presenceAgentsDay: false,
      loadingAgentsPresence: false,

      loadingAgentsActivity: true,
      loadingActivity: true,
      loadingProductivity: true,
      dataAgentSelected: { agentID: '' },
      dataAgentsSelected: { agentID: '', agents: [] },
      totalTempsPresence: 0,
      tempsTotalOnline: 0,
      tempsTotalBusy: 0,
      productivityAgent: 0,
      totalTempsConnexion: 0,
      tempsOccupationPartielle: 0,
      resAjx: null,
      tempsPresence: 8,
      totalTempsPeriode: 1,
      joursPeriode: 5,
      agents: [],
      agentsHeures: [],
      moyenChatHeure: [],
      tauxProductivity1: 0,
      tauxProductivity2: 0,
      tauxProductivity3: 0,

      optionsGraph: {
        colors: ['#F44336', '#3F51B5', '#009688', '#E91E63', '#607D8B', '#9C27B0', '#2196F3', '#FF5722', '#795548', '#4CAF50', '#8BC34A', '#673AB7', '#CDDC39', '#03A9F4', '#FFC107', '#FF9800', '#FFEB3B', '#00BCD4', '#9E9E9E'],
        title: {
          style: {
            fontSize: '20px',
            fontFamily: '"Inconsolata", sans-serif'
          }
        },
        plotOptions: {
          pie: {
            allowPointSelect: false,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        yAxis: [],
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        }
      },

      agentsChatsPie: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          type: 'pie',
          height: '300px'
        },
        title: {
          text: lodash_default.a.upperFirst(this.$t('chatsBetweenAgents'))
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br/>',
          pointFormat: '{point.percentage:.1f}%'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            point: {
              events: {
                click: function click(e) {
                  _this.openOccupation(e);
                }
              }
            },
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        series: []
      },

      activityAgent: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          height: '300px',
          type: 'pie'
        },
        title: {
          text: lodash_default.a.upperFirst(this.$t('advisorsOccupancy'))
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br/>',
          pointFormat: '{point.percentage:.1f}%'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            point: {
              events: {}
            },
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        series: []
      },

      agentsChatsBar: {
        chart: {
          type: 'column',
          height: '310px'
        },
        title: {
          text: lodash_default.a.upperFirst(this.$t('chatsPerAgents'))
        },
        subtitle: {
          text: 'Cliquez sur un conseiller pour voir son activité journalière'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          },
          series: {
            cursor: 'pointer',
            allowPointSelect: true,
            point: {
              events: {
                click: function click(e) {
                  _this.openDayOccupation(e);
                  console.log('openDayOccupation', e);
                }
              }
            }
          }
        },
        xAxis: {
          categories: [] },
        yAxis: [{
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: {
              color: 'rgba(0, 0, 0, 1)'
            }
          },
          title: {
            text: 'Chats',
            style: {
              color: 'rgba(0, 0, 0, 1)'
            }
          },
          opposite: false
        }],
        tooltip: {
          headerFormat: '<b>{point.x}</b><br/>',
          pointFormat: '{series.name}: <b>{point.y} / {point.stackTotal} chats</b>',
          borderColor: '#cccccc',
          crosshairs: true
        },
        series: [{}]
      },

      agentsPresence: {
        chart: {
          height: '310px'
        },
        title: {
          text: 'Présence conseillers'
        },
        subtitle: {
          text: 'Cliquez sur les conseillers présents pour voir la plage horaire de présence'
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          },
          series: {
            cursor: 'pointer',
            allowPointSelect: true,
            events: {
              click: function click(e) {
                _this.openPresenceAgents(e);
              }
            }
          }
        },
        tooltip: {
          formatter: function formatter() {
            var s = '<b>' + this.x + '</b>';
            lodash_default.a.each(this.points, function (point) {
              s += '<br/><span style="color: ' + point.color + '">●</span> ';
              s += point.series.name + ' : <b>' + point.y + '</b>';
            });
            return s;
          },
          outside: true,
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] },
        yAxis: [{
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: { color: '#607D8B' }
          },
          title: {
            text: 'Conseiller present',
            style: { color: '#607D8B' }
          },
          opposite: false
        }, {
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: { color: '#009688' }
          },
          title: {
            text: 'Pages traquées',
            style: { color: '#009688' }
          },
          opposite: true
        }, {
          allowDecimals: false,
          title: { text: '' },
          opposite: true
        }],
        series: [{
          type: 'column',

          name: 'Conseiller present',
          yAxis: 0,
          data: [],
          dataAgents: [],
          zIndex: 3
        }, {
          name: this.$t('trackedPages'),
          type: 'area',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          yAxis: 1,
          data: [],
          zIndex: 1,
          opacity: 0.5
        }, {
          name: lodash_default.a.upperFirst(this.$tc('visitors', 2, { count: '' })),
          type: 'area',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          yAxis: 1,
          data: [],
          zIndex: 2,
          opacity: 0.5
        }]
      },

      agentsActivity: {
        chart: {
          height: '310px',
          events: {
            click: function click(e) {}
          }
        },
        title: {
          text: lodash_default.a.upperFirst(this.$t('agentsActivity'))
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          },
          series: {
            cursor: 'pointer',
            allowPointSelect: true,
            events: {}
          }
        },
        tooltip: {
          formatter: function formatter() {
            var s = '<b>' + this.x + '</b>';
            lodash_default.a.each(this.points, function (point) {
              s += '<br/><span style="color: ' + point.color + '">●</span> ';
              s += point.series.name + ': <b>';
              s += point.colorIndex < 2 ? moment_default.a.duration(point.y, 'seconds').format('h [h] m [m] s [s]') : point.y + ' %';
              s += '</b>';
            });
            return s;
          },
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] },
        yAxis: [{
          allowDecimals: false,
          title: { text: '' },
          opposite: false
        }, {
          allowDecimals: false,
          title: { text: '' },
          opposite: false
        }, {
          allowDecimals: true,
          title: { text: '' },
          opposite: true,
          softMax: 100
        }],
        series: [{
          type: 'column',
          name: lodash_default.a.upperFirst(this.$t('timeOfPresence')),
          yAxis: 1,
          data: []
        }, {
          type: 'column',
          name: lodash_default.a.upperFirst(this.$t('talkTime')),
          yAxis: 1,
          data: []
        }, {
          type: 'spline',
          name: lodash_default.a.upperFirst(this.$t('agentsActivity')),
          tooltip: { valueSuffix: ' %' },
          yAxis: 2,
          data: []
        }]
      },

      tauxActivityAgent: {
        chart: {
          height: '310px'
        },
        title: {
          text: 'Statut des conseillers'
        },
        subtitle: {
          text: 'Moyenne par heure sur 24h pour la période sélectionnée'
        },
        tooltip: {
          split: true,

          valueSuffix: ' %'
        },
        xAxis: {
          categories: ['00 h', '01 h', '02 h', '03 h', '04 h', '05 h', '06 h', '07 h', '08 h', '09 h', '10 h', '11 h', '12 h', '13 h', '14 h', '15 h', '16 h', '17 h', '18 h', '19 h', '20 h', '21 h', '22 h', '23 h'],

          title: {
            text: 'Heures'
          }
        },
        yAxis: [{
          min: 0,
          max: 100,
          title: {
            text: 'Taux d\'occupation'
          },
          labels: {
            formatter: function formatter() {
              return this.value + ' %';
            }
          }
        }, {
          min: 0,
          title: {
            text: 'Sollicitations visiteurs',
            style: {
              color: this.Highcharts.getOptions().colors[0]
            }
          },
          labels: {
            format: '{value} ',
            style: {
              color: this.Highcharts.getOptions().colors[0]
            }
          },
          opposite: true
        }],
        plotOptions: {
          area: {
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: {
                hover: {
                  enabled: true
                }
              }
            }
          },
          line: {
            lineWidth: 2,
            states: {
              hover: {
                lineWidth: 4
              }
            },
            marker: {
              enabled: false
            }
          }
        },
        series: []
      },

      graphProductivityAgent: {
        chart: {
          type: 'solidgauge',
          height: '250px',
          events: {}
        },

        title: {
          text: lodash_default.a.upperFirst(this.$t('productivity'))
        },

        tooltip: {
          borderWidth: 0,
          backgroundColor: 'none',
          shadow: false,
          useHTML: true,
          style: {
            fontSize: '16px'
          },
          pointFormat: '<div style="text-align: center;"><div style="font-size:0.7em; width:100%">{series.name}</div><div style="font-size:1.15em; color: {point.color}; font-weight: bold; width:100%">{point.y}%</div></div>',
          positioner: function positioner(labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: this.chart.plotHeight / 2 + 15
            };
          },
          shared: true
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [{
            outerRadius: '112%',
            innerRadius: '88%',

            backgroundColor: this.Highcharts.Color('#3F51B5').setOpacity(0.3).get(),
            borderWidth: 0
          }, {
            outerRadius: '87%',
            innerRadius: '63%',

            backgroundColor: this.Highcharts.Color('#8BC34A').setOpacity(0.3).get(),
            borderWidth: 0
          }, {
            outerRadius: '62%',
            innerRadius: '38%',

            backgroundColor: this.Highcharts.Color('#9E9E9E').setOpacity(0.3).get(),
            borderWidth: 0
          }]
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: []
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: false
            },
            linecap: 'round',
            stickyTracking: false,
            rounded: true
          }
        },

        series: [{
          name: lodash_default.a.upperFirst(this.$t('connected')),
          data: [{
            color: '#3F51B5',

            radius: '112%',
            innerRadius: '88%',
            y: 0
          }]
        }, {
          name: lodash_default.a.upperFirst(this.$t('emojiActivity')),
          data: [{
            color: '#8BC34A',

            radius: '87%',
            innerRadius: '63%',
            y: 0
          }]
        }, {
          name: lodash_default.a.upperFirst(this.$t('inactivity')),
          data: [{
            color: '#9E9E9E',

            radius: '62%',
            innerRadius: '38%',
            y: 0
          }]
        }]
      }
    };
  },
  created: function created() {
    var _this2 = this;

    this.axios.get('get/agents.php').then(function (response) {
      _this2.resAjx = response.data;
      _this2.init();
    }).catch().then(function (_) {});
  },
  mounted: function mounted() {
    this.loadingAgentsChats = true;
    this.loadingAgentsPresence = true;
    this.loadingAgentsActivity = true;

    this.agentsChatsPie = lodash_default.a.merge(this.agentsChatsPie, this.optionsGraph);
    this.agentsChatsBar = lodash_default.a.merge(this.agentsChatsBar, this.optionsGraph);

    this.tauxActivityAgent = lodash_default.a.merge(this.tauxActivityAgent, this.optionsGraph);
    this.agentsPresence = lodash_default.a.merge(this.agentsPresence, this.optionsGraph);
    this.activityAgent = lodash_default.a.merge(this.activityAgent, this.optionsGraph);
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_Stats', ['params', 'GET_DATESTART', 'GET_DATEEND']), Object(vuex_esm["e" /* mapState */])('_User', ['brides']), {
    agentsChatsPieComputed: function agentsChatsPieComputed() {
      var res = [];
      lodash_default.a.each(this.agentsChatsPie.series[0].data, function (a) {
        var name = a.name;
        var chats = a.chats;
        res.push({
          name: name,
          y: a.y,
          chats: chats
        });
      });
      return res;
    },
    tauxBusy: function tauxBusy() {
      return this.tempsTotalBusy * 100 / this.totalTempsConnexion;
    },
    tauxOccupationPartiel: function tauxOccupationPartiel() {
      return this.tempsOccupationPartielle * 100 / this.totalTempsConnexion;
    },
    tauxInoccupation: function tauxInoccupation() {
      var inoccuper = this.totalTempsPresence - (this.tempsTotalBusy + this.tempsOccupationPartielle);

      return inoccuper * 100 / this.totalTempsConnexion;
    },
    afficheTotalTempsConnexion: function afficheTotalTempsConnexion() {
      return moment_default.a.duration(this.totalTempsConnexion / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsPresence: function afficheTotalTempsPresence() {
      var tempsPresence = this.totalTempsPresence;
      return moment_default.a.duration(tempsPresence / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsHorsProd: function afficheTotalTempsHorsProd() {
      var tempsHorsProd = this.totalTempsConnexion - (this.tempsTotalBusy + this.tempsTotalOnline);
      return moment_default.a.duration(tempsHorsProd / 60, 'minutes').format('h [h] m [min]');
    }
  }),

  methods: {
    init: function init() {
      for (var id in this.resAjx) {
        this.agents.push({ id: this.resAjx[id][0].USR_ID,
          name: lodash_default.a.trim(this.resAjx[id][0].USR_FIRST_NAME + ' ' + this.resAjx[id][0].USR_LAST_NAME),
          rights: lodash_default.a.toInteger(this.resAjx[id][0].USR_RIGHTS),
          tempsTravail: this.resAjx[id][0].USR_TIME_DAY,
          joursHebdo: this.resAjx[id][0].USR_DAY_HEBDO,
          isbot: this.resAjx[id][0].USR_IS_BOT !== '',
          botid: this.resAjx[id][0].USR_IS_BOT
        });
      }
      this.periodeConnexion();
    },
    brideMenu: function brideMenu(nameBride) {
      if (this.brides) {
        var index = this.brides.findIndex(function (bride) {
          return bride.brideName === nameBride;
        });

        if (index !== -1) {
          return this.brides[index].status;
        }
      }
    },
    getAll: function getAll() {
      this.loadingActivity = true;

      this.getAgentsChats();

      this.getAgentsPresence();
      this.calculPeriodeConnexion();
      this.getAgentsOccupation();
    },
    periodeConnexion: function periodeConnexion() {
      this.calculPeriodeConnexion();
      this.getAll();
    },
    calculPeriodeConnexion: function calculPeriodeConnexion() {
      var deuxPoints = /%3A/gi;
      var plus = /%2B/gi;

      var arraydata = this.params.split('dateStart=');
      var arrayDate2 = arraydata[1].split('&');
      var dateStartEncoded = arrayDate2[0];

      var arraydata3 = this.params.split('dateEnd=');
      var arrayDate4 = arraydata3[1].split('&');
      var dateEndEncoded = arrayDate4[0];

      var dateStart2 = dateStartEncoded.replace(deuxPoints, ':');
      var dateStart3 = dateStart2.replace(plus, '+');

      var dateEnd2 = dateEndEncoded.replace(deuxPoints, ':');
      var dateEnd3 = dateEnd2.replace(plus, '+');

      var dateStart = Number(moment_default.a.parseZone(dateStart3).format('X'));
      var dateEnd = Number(moment_default.a.parseZone(dateEnd3).format('X'));

      this.joursPeriode = Math.round((dateEnd - dateStart) / 60 / 60 / 24);

      var arrayParams = this.params.split('agentsId=');
      var arrayAgentIdSelected = arrayParams[1].split(',');
      this.tempsPresence = 0;
      var tempsTotalJour = 0;

      for (var a = 0; a < this.agents.length; a++) {
        for (var b = 0; b < arrayAgentIdSelected.length; b++) {
          if (this.agents[a].id === arrayAgentIdSelected[b]) {
            this.tempsPresence = this.tempsPresence + this.agents[a].tempsTravail * this.agents[a].joursHebdo;

            tempsTotalJour = tempsTotalJour + Number(this.agents[a].tempsTravail);

            this.agentsHeures.push(this.agents[a].tempsTravail);
          }
        }
      }

      this.totalTempsPeriode = this.joursPeriode / 7 * this.tempsPresence * 60 * 60;
    },
    openOccupation: function openOccupation(data) {
      var tempsTravailJour = 0;
      var joursSemaine = 0;
      for (var a = 0; a < this.agents.length; a++) {
        if (Number(this.agents[a].id) === data.point.options.agentID) {
          tempsTravailJour = this.agents[a].tempsTravail;
          joursSemaine = this.agents[a].joursHebdo;
        }
      }

      var dateStart = Number(moment_default.a.parseZone(this.GET_DATESTART).format('X'));
      var dateEnd = Number(moment_default.a.parseZone(this.GET_DATEEND).format('X'));
      var agentID = data.point.options.agentID;
      this.dataAgentSelected.dateStart = dateStart;
      this.dataAgentSelected.dateEnd = dateEnd;
      this.dataAgentSelected.agentID = agentID;
      this.dataAgentSelected.agentName = data.point.options.name;
      this.dataAgentSelected.agentColor = data.point.color;
      this.dataAgentSelected.tempsTravail = tempsTravailJour;
      this.dataAgentSelected.joursHebdo = joursSemaine;
      this.occupationAgentPeriode = true;
    },
    openDayOccupation: function openDayOccupation(data) {
      console.log('data user : ', data);
      var tempsTravailJour = 0;
      var joursSemaine = 0;
      for (var a = 0; a < this.agents.length; a++) {
        if (Number(this.agents[a].id) === data.point.series.userOptions.agentID) {
          tempsTravailJour = this.agents[a].tempsTravail;
          joursSemaine = this.agents[a].joursHebdo;
        }
      }

      var indexDate = data.point.index;

      var dateStart = Number(moment_default.a.parseZone(data.point.series.userOptions.arrayDays[indexDate].date).format('X'));
      var dateEnd = dateStart + 86400;

      var agentID = data.point.series.userOptions.agentID;
      this.dataAgentSelected.dateStart = dateStart;
      this.dataAgentSelected.dateEnd = dateEnd;
      this.dataAgentSelected.agentID = agentID;
      this.dataAgentSelected.agentName = data.point.series.name;
      this.dataAgentSelected.agentColor = data.point.color;
      this.dataAgentSelected.tempsTravail = tempsTravailJour;
      this.dataAgentSelected.joursHebdo = joursSemaine;

      this.occupationAgentDay = true;
    },
    openPresenceAgents: function openPresenceAgents(data) {
      console.log('this.agents', this.agents);
      var indexDate = data.point.index;
      this.dataAgentsSelected.agents = [];
      var numAgents = data.point.series.userOptions.dataAgents[indexDate].agents.length;
      if (numAgents) {
        for (var a = 0; a < this.agents.length; a++) {
          for (var i = 0; i < numAgents; i++) {
            if (Number(this.agents[a].id) === data.point.series.userOptions.dataAgents[indexDate].agents[i]) {
              this.dataAgentsSelected.agents.push(this.agents[a]);
            }
          }
        }
      }
      var dateStart = Number(moment_default.a.parseZone(data.point.series.userOptions.dataAgents[indexDate].date).format('X'));
      var dateEnd = dateStart + 86400;
      this.dataAgentsSelected.dateStart = dateStart;
      this.dataAgentsSelected.dateEnd = dateEnd;

      console.log('dataAgentsSelected', this.dataAgentsSelected);
      this.presenceAgentsDay = true;
    },
    getAgentsOccupation: function getAgentsOccupation() {
      var _this3 = this;

      var ref = this.agentsHeures.join();
      var parametres = this.params + '&refTime=' + ref;

      this.axios.get('get/occupationAgentsPeriode.php?' + parametres).then(function (response) {
        _this3.totalTempsAllChats = response.data.totalTempsAllChats;
        _this3.tempsOccupationPartielle = response.data.tempsOccupationPartielle;
        _this3.tempsOccupationBusy = response.data.tempsOccupationBusy;
        _this3.moyenChatMax = response.data.moyenChatMax;
        _this3.moyenChatHeure = response.data.chatParHeure;
      }).catch().then(function (_) {
        _this3.getConnexions();
      });
    },
    getConnexions: function getConnexions() {
      var _this4 = this;

      var ref = this.agentsHeures.join();
      var parametres = this.params + '&refTime=' + ref;

      this.axios.get('get/connexionAgentsPeriode.php?' + parametres).then(function (response) {
        _this4.totalTempsConnexion = response.data.totalTempsConnexion;
      }).catch().then(function (_) {
        _this4.getStatusAgent();
      });
    },
    getStatusAgent: function getStatusAgent() {
      var _this5 = this;

      this.loadingActivity = true;
      this.axios.get('get/statusAgentsPeriode.php?' + this.params).then(function (response) {
        _this5.totalTempsPresence = response.data.totalTempsPresence;
        _this5.tempsTotalOnline = response.data.tempsTotalOnline;
        _this5.tempsTotalBusy = response.data.tempsTotalBusy;
        var total = _this5.tauxOccupationPartiel + _this5.tauxBusy + _this5.tauxInoccupation;
        var taux1 = _this5.tauxOccupationPartiel * 100 / total;
        var taux2 = _this5.tauxBusy * 100 / total;
        var taux3 = _this5.tauxInoccupation * 100 / total;
        var dataOccupation = [{
          name: lodash_default.a.upperFirst(_this5.$t('partialOccupation')),
          color: _this5.optionsGraph.colors[9],
          y: _this5.tauxOccupationPartiel,
          val: taux1
        }, {
          name: lodash_default.a.upperFirst(_this5.$t('maximumOccupancy')),
          color: _this5.optionsGraph.colors[15],
          y: _this5.tauxBusy,
          val: taux2
        }, {
          name: lodash_default.a.upperFirst(_this5.$t('unoccupied')),
          color: _this5.optionsGraph.colors[10],
          y: _this5.tauxInoccupation,
          val: taux3
        }];

        _this5.activityAgent.series = [{}];
        _this5.activityAgent.series[0].data = [];

        _this5.activityAgent.series[0].data = dataOccupation;

        var dataTauxOccupation = [{
          type: 'area',
          name: lodash_default.a.upperFirst(_this5.$t('offline')),
          color: _this5.optionsGraph.colors[0],
          data: response.data.arrayTauxOffline,
          tooltip: {
            split: true,

            valueSuffix: ' %'
          }
        }, {
          type: 'area',
          name: lodash_default.a.upperFirst(_this5.$t('online')),
          color: _this5.optionsGraph.colors[10],
          data: response.data.arrayTauxOnline,
          tooltip: {
            split: true,

            valueSuffix: ' %'
          }
        }, {
          type: 'area',
          name: lodash_default.a.upperFirst(_this5.$t('busy')),
          color: _this5.optionsGraph.colors[15],
          data: response.data.arrayTauxBusy,
          tooltip: {
            split: true,

            valueSuffix: ' %'
          }
        }, {
          type: 'line',
          yAxis: 1,
          name: lodash_default.a.upperFirst('Sollicitations visiteurs'),
          color: 'rgba(63, 81, 181, 0.6)',

          data: _this5.moyenChatHeure,
          tooltip: {
            split: true,

            valueSuffix: ''
          }
        }];
        _this5.tauxActivityAgent.series = dataTauxOccupation;
      }).catch().then(function (_) {
        var totalActivityTime = _this5.tempsTotalBusy + _this5.tempsTotalOnline;

        var presence = _this5.totalTempsConnexion * 100 / _this5.totalTempsPeriode;
        _this5.tauxProductivity1 = presence.toFixed(2);

        _this5.graphProductivityAgent.series[0].data[0].y = Math.round(presence * 100) / 100;

        var totalChats = totalActivityTime * 100 / _this5.totalTempsPeriode;
        _this5.tauxProductivity2 = totalChats.toFixed(2);
        _this5.graphProductivityAgent.series[1].data[0].y = Math.round(totalChats * 100) / 100;

        var inactiv = (_this5.totalTempsConnexion - totalActivityTime) * 100 / _this5.totalTempsPeriode;
        _this5.tauxProductivity3 = inactiv.toFixed(2);
        _this5.graphProductivityAgent.series[2].data[0].y = Math.round(inactiv * 100) / 100;

        _this5.loadingActivity = false;
      });
    },
    getAgentsChats: function getAgentsChats() {
      var _this6 = this;

      this.loadingAgentsChats = true;
      this.axios.get('get/agents_chats.php?' + this.params).then(function (response) {
        _this6.agentsChatsPie.series = [{}];
        _this6.agentsChatsPie.series[0].data = [];
        _this6.agentsChatsBar.series = [];
        _this6.agentsChatsBar.xAxis.categories = [];

        var idAgents = [];
        var nbChats = 0;
        response.data.chatsByAgent.forEach(function (agent) {
          var agentFound = lodash_default.a.find(_this6.$store.state._User.colleagues, { 'USR_ID': lodash_default.a.toString(agent.id) });
          _this6.agentsChatsPie.series[0].data.push({
            name: agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME,
            agentID: agent.id,
            y: agent.pourcent,
            chats: agent.nb
          });

          nbChats += agent.nb;
          idAgents.push(agent.id);
          _this6.agentsChatsBar.series.push({
            name: agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME,
            agentID: agent.id,
            day: response.data.days,
            arrayDays: response.data.arrayDays,
            data: []
          });
        });

        _this6.agentsChatsPie.title.text = lodash_default.a.upperFirst(_this6.$tc('distributionOfChats', 1, { count: nbChats }));

        entries_default()(response.data.days).forEach(function (_ref) {
          var _ref2 = slicedToArray_default()(_ref, 2),
              date = _ref2[0],
              agents = _ref2[1];

          _this6.agentsChatsBar.xAxis.categories.push(moment_default()(date).format('ddd D MMM YY'));

          entries_default()(agents).forEach(function (_ref3) {
            var _ref4 = slicedToArray_default()(_ref3, 2),
                id = _ref4[0],
                chat = _ref4[1];

            var idx = idAgents.findIndex(function (i) {
              return i === lodash_default.a.toNumber(id);
            });
            if (idx !== -1 && _this6.agentsChatsBar.series[idx]) {
              _this6.agentsChatsBar.series[idx].data.push(chat);
            }
          });
        });
        console.log('this.agentsChatsBar', _this6.agentsChatsBar);
      }).catch().then(function (_) {
        _this6.loadingAgentsChats = false;
      });
    },
    getAgentsPresence: function getAgentsPresence() {
      var _this7 = this;

      this.loadingAgentsPresence = true;
      this.axios.get('get/presenceAgentsPeriode.php?' + this.params).then(function (response) {
        _this7.agentsPresence.xAxis.categories = [];
        _this7.agentsPresence.series[0].data = [];
        _this7.agentsPresence.series[0].dataAgents = [];

        _this7.agentsPresence.series[0].color = _this7.optionsGraph.colors[4];
        _this7.agentsPresence.series[1].color = _this7.optionsGraph.colors[2];
        _this7.agentsPresence.series[2].color = _this7.optionsGraph.colors[13];

        lodash_default.a.each(response.data.arrayDays, function (values, idx) {
          _this7.agentsPresence.xAxis.categories.push(moment_default()(values.date).format('ddd D MMM YY'));
        });
        lodash_default.a.each(response.data.nbAgentsConnected, function (values, idx) {
          if (values.length) {
            var obj = {
              'date': response.data.arrayDays[idx].date,
              'agents': values
            };
            _this7.agentsPresence.series[0].data.push(values.length);
            _this7.agentsPresence.series[0].dataAgents.push(obj);
          } else {
            var arr = values_default()(values);

            var _obj = {
              'date': response.data.arrayDays[idx].date,
              'agents': arr
            };
            var sizeArr = arr.length;
            _this7.agentsPresence.series[0].data.push(sizeArr);
            _this7.agentsPresence.series[0].dataAgents.push(_obj);
          }
        });
      }).catch().then(function (_) {
        _this7.getAudienceData();
      });
    },
    getAudienceData: function getAudienceData() {
      var _this8 = this;

      this.loading = true;

      this.axios.get('get/audience.php?' + this.params).then(function (response) {
        console.log('response audience', response);
        var resAudienceFromAjax = response.data;
        _this8.agentsPresence.series[1].data = [];
        _this8.agentsPresence.series[2].data = [];

        lodash_default.a.forEach(resAudienceFromAjax, function (day) {
          _this8.agentsPresence.series[1].data.push(day.loads);
          _this8.agentsPresence.series[2].data.push(day.visitors);
        });

        lodash_default.a.forEach(_this8.resAudienceFromAjax, function (day) {
          var found = -1;
          for (var i = 0; i < _this8.options.xAxis.categories.length; i++) {
            if (_this8.options.xAxis.categories[i] === moment_default()(day.date).format('MMMM YYYY')) {
              found = i;
            }
          }
          if (found === -1) {
            _this8.options.xAxis.categories.push(moment_default()(day.date).format('MMMM YYYY'));
            _this8.agentsPresence.series[1].data.push(day.loads);
            _this8.agentsPresence.series[2].data.push(day.visitors);
          }

          _this8.agentsPresence.series[1].data[found] += day.loads;
          _this8.agentsPresence.series[2].data[found] += day.visitors;
        });
      }).catch(function (errors) {}).then(function (_) {
        _this8.loadingAgentsPresence = false;
      });
    },
    exportAgentsChatsPie: function exportAgentsChatsPie() {
      var csv = '';
      var data = [];
      var fields = ['name', 'chats', 'y'];
      var fieldNames = ['agent', 'chats', 'pourcentage'];
      data = this.agentsChatsPieComputed;

      try {
        csv = json2csv_default()({ data: data, fields: fields, del: ';', fieldNames: fieldNames });
      } catch (err) {
        return;
      }
      this.downloadFile('agentsChatsPie.csv', csv);
    },
    exportProductivity: function exportProductivity() {
      var csv = '';
      var data = [];
      var fields = ['connexion', 'activity', 'inactivity'];
      var fieldNames = ['taux de connexion', 'taux d\'activité', 'taux d\'inactivité'];
      var values = {
        connexion: this.tauxProductivity1,
        activity: this.tauxProductivity2,
        inactivity: this.tauxProductivity3
      };
      data.push(values);
      try {
        csv = json2csv_default()({ data: data, fields: fields, del: ';', fieldNames: fieldNames });
      } catch (err) {
        return;
      }
      this.downloadFile('agentsProductivity.csv', csv);
    },
    exportAgentsOccupation: function exportAgentsOccupation() {
      var csv = '';
      var data = [];
      var fields = ['partielle', 'maximum', 'inoccupe'];
      var fieldNames = ['Occupation partielle', 'Occupation maximum', 'Inoccupé'];

      var values = {
        partielle: this.activityAgent.series[0].data[0].val.toFixed(2),
        maximum: this.activityAgent.series[0].data[1].val.toFixed(2),
        inoccupe: this.activityAgent.series[0].data[2].val.toFixed(2)
      };
      data.push(values);

      try {
        csv = json2csv_default()({ data: data, fields: fields, del: ';', fieldNames: fieldNames });
      } catch (err) {
        return;
      }
      this.downloadFile('agentsOccupation.csv', csv);
    },
    exportStatut: function exportStatut() {
      var _this9 = this;

      var csv = '';
      var data = [];
      var fields = ['date'].concat(toConsumableArray_default()(lodash_default.a.map(this.tauxActivityAgent.series, function (s) {
        return s.name;
      })));
      var fieldNames = ['dates'].concat(toConsumableArray_default()(lodash_default.a.map(this.tauxActivityAgent.series, function (s) {
        return s.name;
      })));
      lodash_default.a.each(this.tauxActivityAgent.xAxis.categories, function (date, k) {
        var values = {
          date: date
        };
        lodash_default.a.each(_this9.tauxActivityAgent.series, function (s, i) {
          values[s.name] = s.data[k];
        });
        data.push(values);
      });
      try {
        csv = json2csv_default()({ data: data, fields: fields, del: ';', fieldNames: fieldNames });
      } catch (err) {
        return;
      }
      this.downloadFile('agentsStatut.csv', csv);
    },
    exportAgentsChatsBar: function exportAgentsChatsBar() {
      var _this10 = this;

      var csv = '';
      var data = [];
      var fields = ['date'].concat(toConsumableArray_default()(lodash_default.a.map(this.agentsChatsBar.series, function (s) {
        return s.name;
      })));
      var fieldNames = ['dates'].concat(toConsumableArray_default()(lodash_default.a.map(this.agentsChatsBar.series, function (s) {
        return s.name;
      })));
      lodash_default.a.each(this.agentsChatsBar.xAxis.categories, function (date, k) {
        var values = {
          date: date
        };
        lodash_default.a.each(_this10.agentsChatsBar.series, function (s, i) {
          values[s.name] = s.data[k];
        });
        data.push(values);
      });
      try {
        csv = json2csv_default()({ data: data, fields: fields, del: ';', fieldNames: fieldNames });
      } catch (err) {
        return;
      }
      this.downloadFile('agentsChatsBar.csv', csv);
    },
    downloadFile: function downloadFile(filename, content) {
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:attachment/text,' + encodeURI(content);
      hiddenElement.target = '_blank';
      hiddenElement.download = filename;
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
    },
    dialogOccupationRemove: function dialogOccupationRemove() {
      this.occupationAgentDay = false;
    },
    dialogOccupationPeriodeRemove: function dialogOccupationPeriodeRemove() {
      this.occupationAgentPeriode = false;
    },
    dialogPresenceDayRemove: function dialogPresenceDayRemove() {
      this.presenceAgentsDay = false;
    }
  },
  watch: {
    params: function params(v) {
      this.getAll();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32cb31e4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/AgentsPerformance.vue
var AgentsPerformance_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"audience"},[_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("bar_chart")]),_vm._v("Productivité des conseillers")],1),_vm._v(" "),_c('v-card',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[(_vm.loadingAgentsChats)?_c('v-card',{staticClass:"mb-3",attrs:{"height":"360px"}},[_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1)],1):_c('v-card',{staticClass:"mb-3 text-md-center",attrs:{"height":"360px"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":"","flat":""},on:{"click":function($event){_vm.exportAgentsChatsPie()}}},[_vm._v("\n                  exporter en csv\n                  "),_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("file_download")])],1)],1),_vm._v(" "),_c('highcharts',{attrs:{"options":_vm.agentsChatsPie}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[(_vm.loadingActivity)?_c('v-card',{staticClass:"mb-3",attrs:{"height":"360px"}},[_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1)],1):_c('v-card',{staticClass:"mb-3 text-md-center",attrs:{"height":"360px"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":"","flat":""},on:{"click":function($event){_vm.exportProductivity()}}},[_vm._v("\n                  exporter en csv\n                  "),_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("file_download")])],1)],1),_vm._v(" "),_c('highcharts',{attrs:{"options":_vm.graphProductivityAgent}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('connectionRate'))+" : "+_vm._s(_vm.tauxProductivity1)+" % ("+_vm._s(_vm.afficheTotalTempsConnexion)+")")]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('agentsActivity'))+" : "+_vm._s(_vm.tauxProductivity2)+" % ("+_vm._s(_vm.afficheTotalTempsPresence)+")")]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('agentsInactivity'))+" : "+_vm._s(_vm.tauxProductivity3)+" % ("+_vm._s(_vm.afficheTotalTempsHorsProd)+")")]),_c('br')],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[(_vm.loadingActivity)?_c('v-card',{staticClass:"mb-3",attrs:{"height":"360px"}},[_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1)],1):_c('v-card',{staticClass:"mb-3 text-md-center",attrs:{"height":"360px"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":"","flat":""},on:{"click":function($event){_vm.exportAgentsOccupation()}}},[_vm._v("\n                  exporter en csv\n                  "),_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("file_download")])],1)],1),_vm._v(" "),_c('highcharts',{attrs:{"options":_vm.activityAgent}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("bar_chart")]),_vm._v("Moyenne du statut des conseillers sur 24h")],1),_vm._v(" "),(_vm.loadingActivity)?_c('v-card',{staticClass:"mb-3",attrs:{"height":"360px"}},[_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1)],1):_c('v-card',{staticClass:"mb-3 text-md-center",attrs:{"height":"360px"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":"","flat":""},on:{"click":function($event){_vm.exportStatut()}}},[_vm._v("\n              exporter en csv\n              "),_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("file_download")])],1)],1),_vm._v(" "),_c('highcharts',{attrs:{"options":_vm.tauxActivityAgent}})],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("bar_chart")]),_vm._v("Chats par conseiller")],1),_vm._v(" "),(_vm.loadingAgentsChats)?_c('v-card',{staticClass:"mb-3",attrs:{"height":"360px"}},[_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1)],1):_c('v-card',{staticClass:"mb-3 text-md-center",attrs:{"height":"360px"}},[_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":"","flat":""},on:{"click":function($event){_vm.exportAgentsChatsBar()}}},[_vm._v("\n              exporter en csv\n              "),_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("file_download")])],1)],1),_vm._v(" "),_c('highcharts',{attrs:{"options":_vm.agentsChatsBar}})],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("bar_chart")]),_vm._v("Présence des conseillers par jour")],1),_vm._v(" "),(_vm.loadingAgentsPresence)?_c('v-card',{attrs:{"height":"360px"}},[_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1)],1):_c('v-card',[_c('v-layout',{attrs:{"row":""}},[_c('v-spacer')],1),_vm._v(" "),_c('highcharts',{attrs:{"options":_vm.agentsPresence}})],1)],1)],1),_vm._v(" "),_c('v-dialog',{ref:"dialogOccupation",attrs:{"persistent":"","max-width":"1200px","scrollable":!_vm.$vuetify.breakpoint.smAndDown,"fullscreen":_vm.$vuetify.breakpoint.smAndDown},model:{value:(_vm.occupationAgentDay),callback:function ($$v) {_vm.occupationAgentDay=$$v},expression:"occupationAgentDay"}},[(_vm.occupationAgentDay)?_c('wz-agents-occupation-day',{attrs:{"dataAgentSelected":_vm.dataAgentSelected},on:{"closeDialog":_vm.dialogOccupationRemove}}):_vm._e()],1),_vm._v(" "),_c('v-dialog',{ref:"dialogOccupation",attrs:{"persistent":"","max-width":"1200px","scrollable":!_vm.$vuetify.breakpoint.smAndDown,"fullscreen":_vm.$vuetify.breakpoint.smAndDown},model:{value:(_vm.occupationAgentPeriode),callback:function ($$v) {_vm.occupationAgentPeriode=$$v},expression:"occupationAgentPeriode"}},[(_vm.occupationAgentPeriode)?_c('wz-agents-occupation-periode',{attrs:{"dataAgentSelected":_vm.dataAgentSelected},on:{"closeDialog":_vm.dialogOccupationPeriodeRemove}}):_vm._e()],1),_vm._v(" "),_c('v-dialog',{ref:"dialogPresence",attrs:{"persistent":"","max-width":"1200px","scrollable":!_vm.$vuetify.breakpoint.smAndDown,"fullscreen":_vm.$vuetify.breakpoint.smAndDown},model:{value:(_vm.presenceAgentsDay),callback:function ($$v) {_vm.presenceAgentsDay=$$v},expression:"presenceAgentsDay"}},[(_vm.presenceAgentsDay)?_c('wz-agents-presence-day',{attrs:{"dataAgentsSelected":_vm.dataAgentsSelected},on:{"closeDialog":_vm.dialogPresenceDayRemove}}):_vm._e()],1)],1)}
var AgentsPerformance_staticRenderFns = []
var AgentsPerformance_esExports = { render: AgentsPerformance_render, staticRenderFns: AgentsPerformance_staticRenderFns }
/* harmony default export */ var stats_AgentsPerformance = (AgentsPerformance_esExports);
// CONCATENATED MODULE: ./src/components/stats/AgentsPerformance.vue
function AgentsPerformance_injectStyle (ssrContext) {
  __webpack_require__("ZUDU")
}
var AgentsPerformance_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var AgentsPerformance___vue_template_functional__ = false
/* styles */
var AgentsPerformance___vue_styles__ = AgentsPerformance_injectStyle
/* scopeId */
var AgentsPerformance___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var AgentsPerformance___vue_module_identifier__ = null
var AgentsPerformance_Component = AgentsPerformance_normalizeComponent(
  AgentsPerformance,
  stats_AgentsPerformance,
  AgentsPerformance___vue_template_functional__,
  AgentsPerformance___vue_styles__,
  AgentsPerformance___vue_scopeId__,
  AgentsPerformance___vue_module_identifier__
)

/* harmony default export */ var components_stats_AgentsPerformance = (AgentsPerformance_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stats/C2C.vue








var durationFormat = 'h [h] mm [min] ss [s]';
function _duration(v) {
  return moment_default.a.duration(lodash_default.a.toNumber(v), 'seconds').format(durationFormat);
}

var dateFormat = 'ddd D MMM YY';
function _date(v) {
  return moment_default()(v).format(dateFormat);
}

/* harmony default export */ var C2C = ({

  name: 'C2C',

  data: function data() {
    return {
      loading: false,
      periode: '',
      c2c: {},
      options: {
        chart: {
          height: 400
        },
        title: {
          text: '',
          x: -20 },
        tooltip: {
          formatter: function formatter() {
            var s = '<b>' + this.x + '</b>';
            lodash_default.a.each(this.points, function (point) {
              s += '<br/><span style="color: ' + point.series.color + '">' + point.series.name + '</span>: <b>';
              s += point.series.index > 1 ? moment_default.a.duration(point.y, 'seconds').format(durationFormat) : point.y;
              s += '</b>';
            });
            return s;
          },

          shared: true,

          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] },
        yAxis: [{
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: {
              color: 'rgba(0, 150, 136, 1)'
            }
          },
          title: {
            text: this.$t('successfulCalls'),
            style: {
              color: 'rgba(0, 150, 136, 1)'
            }
          },
          opposite: false
        }, {
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: {
              color: '#9C27B0' }
          },
          title: {
            text: this.$t('totalDurationOfCalls') + ' (secondes)',
            style: {
              color: '#9C27B0' }
          },
          opposite: true
        }],
        series: [{
          name: lodash_default.a.upperFirst(this.$t('successfulCalls')),
          type: 'column',
          color: 'rgba(0, 150, 136, 0.8)',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          yAxis: 0,
          data: [] }, {
          name: lodash_default.a.upperFirst(this.$t('missedCalls')),
          type: 'column',
          color: 'rgba(33, 150, 243, 0.8)',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          yAxis: 0,
          data: [] }, {
          name: lodash_default.a.upperFirst(this.$t('totalDurationOfCalls')),
          type: 'spline',
          color: '#9C27B0',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          yAxis: 1,
          data: [] }, {
          name: lodash_default.a.upperFirst(this.$t('averageDurationOfACall')),
          type: 'spline',
          color: '#FF5722',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          yAxis: 1,
          data: [] }],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -20
          }
        },
        credits: {
          enabled: false
        }
      },

      headers: [{ text: 'Date', value: 'date', align: 'left' }, { text: lodash_default.a.upperFirst(this.$t('hour')), value: 'time', align: 'left' }, { text: lodash_default.a.upperFirst(this.$t('duration')), value: 'duration' }, { text: lodash_default.a.upperFirst(this.$t('appellant')), value: 'appelant', align: 'left' }, { text: lodash_default.a.upperFirst(this.$t('called')), value: 'appele', align: 'left' }, { text: lodash_default.a.upperFirst(this.$tc('sites', 1, { count: '' })), value: 'site', align: 'left' }, { text: lodash_default.a.upperFirst(this.$t('missed')) + '?', value: 'state', align: 'left' }],
      callsDetails: []
    };
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_Stats', ['params']), Object(vuex_esm["c" /* mapGetters */])('_Sites', ['GET_SITE_BY_KEY']), {
    nbCalls: function nbCalls() {
      return lodash_default.a.sumBy(this.c2c.days, 'calls');
    },
    nbMissed: function nbMissed() {
      return lodash_default.a.sumBy(this.c2c.days, 'missed');
    },
    totalDuration: function totalDuration() {
      return lodash_default.a.sumBy(this.c2c.days, 'duration');
    }
  }),

  mounted: function mounted() {
    this.getStatsC2C();

    var paramsArray = this.params.split('=');
    var debut = paramsArray[1].substring(0, 10);
    var fin = paramsArray[2].substring(0, 10);
    this.periode = '_du_' + debut + '_au_' + fin + '.csv';
  },


  methods: {
    getStatsC2C: function getStatsC2C() {
      var _this = this;

      this.loading = true;
      this.axios.get('get/c2c.php?' + this.params + '&entKey=' + this.$store.state._User.entKey).then(function (res) {
        _this.c2c = res.data;
        _this.options.xAxis.categories = [];
        _this.options.series[0].data = [];
        _this.options.series[1].data = [];
        _this.options.series[2].data = [];
        _this.options.series[3].data = [];
        lodash_default.a.each(_this.c2c.days, function (day) {
          _this.options.xAxis.categories.push(moment_default()(day.date).format(dateFormat));
          _this.options.series[0].data.push(day.calls);
          _this.options.series[1].data.push(day.missed);
          _this.options.series[2].data.push(day.duration);
          _this.options.series[3].data.push(day.calls === 0 ? 0 : day.duration / day.calls);
        });
        _this.callsDetails = _this.c2c.calls;
        lodash_default.a.each(_this.callsDetails, function (call) {
          var site = _this.GET_SITE_BY_KEY(call.lic);
          call.site = site ? site.LIC_URL : '';
        });
      }).catch(function (err) {
        console.error(err);
      }).then(function () {
        _this.loading = false;
      });
    },
    download: function download() {
      var _this2 = this;

      var csv = null;
      var fields = lodash_default.a.map(this.c2c.calls[0], function (v, k) {
        return k;
      });
      fields.push('missed');

      var dataToExport = [];

      var _loop = function _loop(i) {
        var value = {};
        lodash_default.a.each(_this2.c2c.calls[i], function (v, k) {
          switch (k) {
            case 'duration':
              value[k] = _duration(v);
              break;
            case 'date':
              value[k] = _date(v);
              break;
            case 'lic':
              var site = _this2.GET_SITE_BY_KEY(v);
              value[k] = site ? site.LIC_URL : '';
              break;
            default:
              value[k] = v;
          }
        });
        value.missed = _this2.c2c.calls[i]['duration'] > 0;
        dataToExport.push(value);
      };

      for (var i = 0; i < this.c2c.calls.length; i++) {
        _loop(i);
      }
      try {
        csv = json2csv_default()({ data: dataToExport, del: ';', fields: fields });
      } catch (err) {
        return;
      }

      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'callbacks' + this.periode + '.csv';
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
    }
  },

  filters: {
    duration: function duration(v) {
      return _duration(v);
    },
    date: function date(v) {
      return _date(v);
    }
  },

  watch: {
    params: function params(v) {
      var paramsArray = v.split('=');
      var debut = paramsArray[1].substring(0, 10);
      var fin = paramsArray[2].substring(0, 10);
      this.periode = '_du_' + debut + '_au_' + fin + '.csv';

      this.getStatsC2C();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ce77c4b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/C2C.vue
var C2C_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"c2c"},[(_vm.loading)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('div',[_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","md3":""}},[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('successfulCalls'))))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline teal--text"},[_vm._v(_vm._s(_vm.nbCalls))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md3":""}},[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('missedCalls'))))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline blue--text"},[_vm._v(_vm._s(_vm.nbMissed))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md3":""}},[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('totalDurationOfCalls'))))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline deep-purple--text"},[_vm._v(_vm._s(_vm._f("duration")(_vm.totalDuration)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md3":""}},[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('averageDurationOfACall'))))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline deep-orange--text"},[_vm._v(_vm._s(_vm._f("duration")((_vm.totalDuration / _vm.nbCalls))))])])],1),_vm._v(" "),_c('highcharts',{attrs:{"options":_vm.options}})],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"headline",attrs:{"xs6":"","sm10":""}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('callsDetails'))))]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm2":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":"","flat":"","disabled":_vm.callsDetails.length == 0},on:{"click":function($event){_vm.download()}},slot:"activator"},[_vm._v("\n                "+_vm._s(_vm.$t('exportInCsv'))+"\n                "),_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("file_download")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.callsDetails,"no-data-text":_vm._f("cap")(_vm.$tc('calls', 0)),"no-results-text":_vm._f("cap")(_vm.$tc('results', 0)),"rows-per-page-items":[10, 25, 50, { text: _vm.$tc('all', 2), value: -1 }],"rows-per-page-text":_vm._f("cap")(_vm.$t('callsPerPage'))},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.header.text))])]}},{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(_vm._f("date")(props.item.date)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.time))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("duration")(props.item.duration)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.appelant))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.appele))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.site))]),_vm._v(" "),_c('td',[_vm._v(_vm._s((props.item.duration === '0') ? _vm.$t('yes') : _vm.$t('no')))])]}}])})],1)],1)],1)])}
var C2C_staticRenderFns = []
var C2C_esExports = { render: C2C_render, staticRenderFns: C2C_staticRenderFns }
/* harmony default export */ var stats_C2C = (C2C_esExports);
// CONCATENATED MODULE: ./src/components/stats/C2C.vue
var C2C_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var C2C___vue_template_functional__ = false
/* styles */
var C2C___vue_styles__ = null
/* scopeId */
var C2C___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var C2C___vue_module_identifier__ = null
var C2C_Component = C2C_normalizeComponent(
  C2C,
  stats_C2C,
  C2C___vue_template_functional__,
  C2C___vue_styles__,
  C2C___vue_scopeId__,
  C2C___vue_module_identifier__
)

/* harmony default export */ var components_stats_C2C = (C2C_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stats/Sales.vue







/* harmony default export */ var Sales = ({
  data: function data() {
    return {
      panel: [true, false, false],
      periode: '',
      loading: false,
      resFromAjax: null,
      nbSales: 0,
      nbItems: 0,
      nbAmount: 0,
      nbSupports: 0,
      nbSalesBot: 0,
      nbItemsBot: 0,
      nbAmountBot: 0,
      nbSalesC2C: 0,
      nbItemsC2C: 0,
      nbAmountC2C: 0,
      nbSalesLead: 0,
      nbItemsLead: 0,
      nbAmountLead: 0,
      nbChats: 0,
      nbFirstTimeResponse: 0,
      nbConversion: 0,
      nbConversionBot: 0,
      nbConversionC2C: 0,
      nbConversionLead: 0,
      lang: this.$store.state._User.lang + '-' + this.$store.state._User.licLang,
      currency: 'EUR',

      options: {
        chart: {
          height: 300
        },
        title: {
          text: '',
          x: -20 },
        tooltip: {
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] },
        yAxis: [{
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: {
              color: '#009688' }
          },
          title: {
            text: lodash_default.a.upperFirst(this.$tc('sales', 2, { count: '' })),
            style: {
              color: '#009688' }
          },
          opposite: false
        }, {
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: {
              color: '#2196F3' }
          },
          title: {
            text: lodash_default.a.upperFirst(this.$tc('items', 2, { count: '' })),
            style: {
              color: '#2196F3' }
          },
          opposite: false
        }, {
          allowDecimals: false,
          labels: {
            format: '{value}',

            style: {
              color: '#E91E63' }
          },
          title: {
            text: lodash_default.a.upperFirst(this.$tc('amount', 2, { count: '' })) + ' (€)',
            style: {
              color: '#E91E63' }
          },
          opposite: true
        }],
        series: [{
          name: lodash_default.a.upperFirst(this.$tc('sales', 2, { count: '' })) + ' chat',
          type: 'spline',
          color: '#009688',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          yAxis: 0,
          data: [] }, {
          name: lodash_default.a.upperFirst(this.$tc('items', 2, { count: '' })) + ' chat',
          type: 'spline',
          color: '#2196F3',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          yAxis: 1,
          data: [] }, {
          name: lodash_default.a.upperFirst(this.$t('amount')) + ' chat',
          type: 'spline',
          color: '#E91E63',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: ' €' },
          yAxis: 2,
          data: [] }],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -20
          }
        },
        credits: {
          enabled: false
        }
      },

      optionsChatBot: {
        chart: {
          height: 300
        },
        title: {
          text: '',
          x: -20 },
        tooltip: {
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] },
        yAxis: [{
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: {
              color: '#009688' }
          },
          title: {
            text: lodash_default.a.upperFirst(this.$tc('sales', 2, { count: '' })),
            style: {
              color: '#009688' }
          },
          opposite: false
        }, {
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: {
              color: '#2196F3' }
          },
          title: {
            text: lodash_default.a.upperFirst(this.$tc('items', 2, { count: '' })),
            style: {
              color: '#2196F3' }
          },
          opposite: false
        }, {
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: {
              color: '#E91E63' }
          },
          title: {
            text: lodash_default.a.upperFirst(this.$tc('amount', 2, { count: '' })) + ' (€)',
            style: {
              color: '#E91E63' }
          },
          opposite: true
        }],
        series: [{
          name: lodash_default.a.upperFirst(this.$tc('sales', 2, { count: '' })) + ' chatbot',
          type: 'spline',
          color: '#009688',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          yAxis: 0,
          data: [] }, {
          name: lodash_default.a.upperFirst(this.$tc('items', 2, { count: '' })) + ' chatbot',
          type: 'spline',
          color: '#2196F3',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          yAxis: 1,
          data: [] }, {
          name: lodash_default.a.upperFirst(this.$t('amount')) + ' chatbot',
          type: 'spline',
          color: '#E91E63',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: ' €' },
          yAxis: 2,
          data: [] }],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -20
          }
        },
        credits: {
          enabled: false
        }
      },

      optionsC2C: {
        chart: {
          height: 300
        },
        title: {
          text: '',
          x: -20 },
        tooltip: {
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] },
        yAxis: [{
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: {
              color: '#009688' }
          },
          title: {
            text: lodash_default.a.upperFirst(this.$tc('sales', 2, { count: '' })),
            style: {
              color: '#009688' }
          },
          opposite: false
        }, {
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: {
              color: '#2196F3' }
          },
          title: {
            text: lodash_default.a.upperFirst(this.$tc('items', 2, { count: '' })),
            style: {
              color: '#2196F3' }
          },
          opposite: false
        }, {
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: {
              color: '#E91E63' }
          },
          title: {
            text: lodash_default.a.upperFirst(this.$tc('amount', 2, { count: '' })) + ' (€)',
            style: {
              color: '#E91E63' }
          },
          opposite: true
        }],
        series: [{
          name: lodash_default.a.upperFirst(this.$tc('sales', 2, { count: '' })) + ' ' + this.$t('C2C'),
          type: 'spline',
          color: '#009688',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          yAxis: 0,
          data: [] }, {
          name: lodash_default.a.upperFirst(this.$tc('items', 2, { count: '' })) + ' ' + this.$t('C2C'),
          type: 'spline',
          color: '#2196F3',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          yAxis: 1,
          data: [] }, {
          name: lodash_default.a.upperFirst(this.$t('amount')) + ' ' + this.$t('C2C'),
          type: 'spline',
          color: '#E91E63',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: ' €' },
          yAxis: 2,
          data: [] }],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -20
          }
        },
        credits: {
          enabled: false
        }
      },

      optionsLead: {
        chart: {
          height: 300
        },
        title: {
          text: '',
          x: -20 },
        tooltip: {
          shared: true,
          borderColor: '#cccccc',
          crosshairs: true
        },
        xAxis: {
          categories: [] },
        yAxis: [{
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: {
              color: '#009688' }
          },
          title: {
            text: 'Leads',
            style: {
              color: '#009688' }
          },
          opposite: false
        }],
        series: [{
          name: 'Acquisition Lead',
          type: 'spline',
          color: '#009688',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          yAxis: 0,
          data: [] }],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -20
          }
        },
        credits: {
          enabled: false
        }
      },

      headersSalesDetails: [{ text: 'Date', value: 'date', align: 'left' }, { text: 'ID ' + this.$tc('visitors', 1, { count: '' }), value: 'visitorId' }, { text: 'ID ' + this.$tc('sales', 1, { count: '' }), value: 'saleId' }, { text: lodash_default.a.upperFirst(this.$t('amount')), value: 'amount' }, { text: lodash_default.a.upperFirst(this.$tc('items', 1, { count: '' })), value: 'items' }, { text: lodash_default.a.upperFirst(this.$tc('agents', 1, { count: '' })), value: 'agent' }],

      headersSalesDetailsTag: [{ text: 'Date', value: 'date', align: 'left' }, { text: 'ID ' + this.$tc('visitors', 1, { count: '' }), value: 'visitorId' }, { text: 'ID ' + this.$tc('sales', 1, { count: '' }), value: 'saleId' }, { text: lodash_default.a.upperFirst(this.$t('amount')), value: 'amount' }, { text: lodash_default.a.upperFirst(this.$tc('items', 1, { count: '' })), value: 'items' }],
      salesDetails: [],
      tagDetails: []
    };
  },
  mounted: function mounted() {
    this.loading = true;
    this.getSales();
    this.panel = [true, false, false];

    var paramsArray = this.params.split('=');
    var debut = paramsArray[1].substring(0, 10);
    var fin = paramsArray[2].substring(0, 10);
    this.periode = '_du_' + debut + '_au_' + fin + '.csv';
  },


  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_User', ['brides']), Object(vuex_esm["c" /* mapGetters */])('_Stats', ['params']), Object(vuex_esm["c" /* mapGetters */])('_Sites', ['HAS_ONE_FUNNEL']), Object(vuex_esm["c" /* mapGetters */])('_Sites', ['HAS_CALLBACK_ACTIVATED']), Object(vuex_esm["c" /* mapGetters */])('_Sites', ['HAS_BOT_ACTIVATED']), Object(vuex_esm["e" /* mapState */])('_User', ['brides']), {
    panierMoyen: function panierMoyen() {
      return !this.nbSales ? 0 : lodash_default.a.round(this.nbAmount / this.nbSales, 2);
    },
    panierMoyenBot: function panierMoyenBot() {
      return !this.nbSalesBot ? 0 : lodash_default.a.round(this.nbAmountBot / this.nbSalesBot, 2);
    },
    panierMoyenC2C: function panierMoyenC2C() {
      return !this.nbSalesC2C ? 0 : lodash_default.a.round(this.nbAmountC2C / this.nbSalesC2C, 2);
    },
    panierMoyenLead: function panierMoyenLead() {
      return !this.nbSalesLead ? 0 : lodash_default.a.round(this.nbAmountLead / this.nbSalesLead, 2);
    }
  }),

  methods: {
    brideMenu: function brideMenu(nameBride) {
      if (this.brides) {
        var index = this.brides.findIndex(function (bride) {
          return bride.brideName === nameBride;
        });

        if (index !== -1) {
          return this.brides[index].status;
        }
      }
    },
    getSales: function getSales() {
      var _this = this;

      this.loading = true;
      var licAllKeys = this.$store.state._User.licAllKeys.join(',');

      this.axios.get('get/sales.php?' + this.params + '&HAS_ONE_FUNNEL=' + this.HAS_ONE_FUNNEL + '&HAS_CALLBACK_ACTIVATED=' + this.HAS_CALLBACK_ACTIVATED + '&HAS_BOT_ACTIVATED=' + this.HAS_BOT_ACTIVATED + '&licAllKeys=' + licAllKeys).then(function (response) {
        _this.resFromAjax = response.data;
        _this.nbSales = _this.resFromAjax.nbSales;
        _this.nbItems = _this.resFromAjax.nbItems;
        _this.nbAmount = _this.resFromAjax.nbAmount;
        _this.nbSalesBot = _this.resFromAjax.nbSalesBot;
        _this.nbItemsBot = _this.resFromAjax.nbItemsBot;
        _this.nbAmountBot = _this.resFromAjax.nbAmountBot;
        _this.nbSalesC2C = _this.resFromAjax.nbSalesC2C;
        _this.nbItemsC2C = _this.resFromAjax.nbItemsC2C;
        _this.nbAmountC2C = _this.resFromAjax.nbAmountC2C;
        _this.nbSalesLead = _this.resFromAjax.nbSalesLead;
        _this.nbItemsLead = _this.resFromAjax.nbItemsLead;
        _this.nbAmountLead = _this.resFromAjax.nbAmountLead;
        _this.nbSupports = _this.resFromAjax.nbSupports;
        _this.nbChats = _this.resFromAjax.nbChats;
        _this.nbFirstTimeResponse = _this.resFromAjax.nbFirstTimeResponse;
        _this.nbConversion = _this.resFromAjax.nbConversion;
        _this.nbConversionBot = _this.resFromAjax.nbConversionBot;
        _this.nbConversionC2C = _this.resFromAjax.nbConversionC2C;
        _this.nbConversionLead = _this.resFromAjax.nbConversionLead;
        _this.options.xAxis.categories = [];
        _this.options.series[0].data = [];
        _this.options.series[1].data = [];
        _this.options.series[2].data = [];

        _this.optionsChatBot.xAxis.categories = [];
        _this.optionsChatBot.series[0].data = [];
        _this.optionsChatBot.series[1].data = [];
        _this.optionsChatBot.series[2].data = [];

        _this.optionsC2C.xAxis.categories = [];
        _this.optionsC2C.series[0].data = [];
        _this.optionsC2C.series[1].data = [];
        _this.optionsC2C.series[2].data = [];

        _this.optionsLead.xAxis.categories = [];
        _this.optionsLead.series[0].data = [];

        _this.salesDetails = [];
        _this.tagDetails = [];

        var _loop = function _loop(i) {
          var day = _this.resFromAjax.days[i];
          _this.options.xAxis.categories.push(moment(day.date).format('ll'));
          _this.options.series[0].data.push(day.sales.length);
          _this.options.series[1].data.push(day.items);
          _this.options.series[2].data.push(day.amount);
          lodash_default.a.each(day.sales, function (sale) {
            var agentFound = lodash_default.a.find(_this.$store.state._User.colleagues, { 'USR_ID': lodash_default.a.toString(sale.agent) });
            _this.salesDetails.push({
              date: moment(day.date).format('ll'),
              visitorId: sale.vis,
              saleId: sale.id,
              amount: sale.amount,
              items: sale.items,
              agent: agentFound ? agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME : ''
            });
          });
        };

        for (var i = 31; i < _this.resFromAjax.days.length; i++) {
          _loop(i);
        }

        if (_this.brideMenu('stats_ventes_chatbot') === '1') {
          var _loop2 = function _loop2(i) {
            var day = _this.resFromAjax.daysBot[i];
            _this.optionsChatBot.xAxis.categories.push(moment(day.date).format('ll'));
            _this.optionsChatBot.series[0].data.push(day.sales.length);
            _this.optionsChatBot.series[1].data.push(day.items);
            _this.optionsChatBot.series[2].data.push(day.amount);
            lodash_default.a.each(day.sales, function (sale) {
              _this.salesDetails.push({
                date: moment(day.date).format('ll'),
                visitorId: sale.vis,
                saleId: sale.id,
                amount: sale.amount,
                items: sale.items,
                agent: 'Chat Bot'
              });
            });
          };

          for (var i = 31; i < _this.resFromAjax.daysBot.length; i++) {
            _loop2(i);
          }
        }

        if (_this.brideMenu('stats_ventes_callback') === '1') {
          var _loop3 = function _loop3(i) {
            var day = _this.resFromAjax.daysC2C[i];
            _this.optionsC2C.xAxis.categories.push(moment(day.date).format('ll'));
            _this.optionsC2C.series[0].data.push(day.sales.length);
            _this.optionsC2C.series[1].data.push(day.items);
            _this.optionsC2C.series[2].data.push(day.amount);
            lodash_default.a.each(day.sales, function (sale) {
              _this.salesDetails.push({
                date: moment(day.date).format('ll'),
                visitorId: sale.vis,
                saleId: sale.id,
                amount: sale.amount,
                items: sale.items,
                agent: 'Click-to-Call'
              });
            });
          };

          for (var i = 31; i < _this.resFromAjax.daysC2C.length; i++) {
            _loop3(i);
          }
        }

        if (_this.brideMenu('stats_ventes_lead') === '1') {
          var _loop4 = function _loop4(i) {
            var day = _this.resFromAjax.daysLead[i];
            _this.optionsLead.xAxis.categories.push(moment(day.date).format('ll'));
            _this.optionsLead.series[0].data.push(day.leads.length);
            lodash_default.a.each(day.leads, function (sale) {
              _this.salesDetails.push({
                date: moment(day.date).format('ll'),
                visitorId: sale.lead,
                saleId: sale.id,
                agent: 'Lead'
              });
            });
          };

          for (var i = 31; i < _this.resFromAjax.daysLead.length; i++) {
            _loop4(i);
          }
        }

        var _loop5 = function _loop5(i) {
          var day = _this.resFromAjax.daysTag[i];

          lodash_default.a.each(day.sales, function (sale) {
            _this.tagDetails.push({
              date: moment(day.date).format('ll'),
              visitorId: sale.vis,
              saleId: sale.id,
              amount: sale.amount,
              items: sale.items
            });
          });
        };

        for (var i = 31; i < _this.resFromAjax.daysTag.length; i++) {
          _loop5(i);
        }
      }).catch(function (errors) {}).then(function (_) {
        _this.loading = false;
      });
    },
    download: function download() {
      var json = [];
      var csv = '';

      json.push([this.headersSalesDetails[0].text, this.headersSalesDetails[1].text, this.headersSalesDetails[2].text, this.headersSalesDetails[3].text, this.headersSalesDetails[4].text, this.headersSalesDetails[5].text]);

      for (var i = 0; i < this.salesDetails.length; i++) {
        var value = [];
        value[0] = this.salesDetails[i]['date'];
        value[1] = this.salesDetails[i]['visitorId'];
        value[2] = this.salesDetails[i]['saleId'];
        value[3] = this.salesDetails[i]['amount'];
        value[4] = this.salesDetails[i]['items'];
        value[5] = this.salesDetails[i]['agent'];
        json.push(value);
      }

      for (var j = 0; j < json.length; j++) {
        csv += '"';
        for (var k = 0; k < json[j].length; k++) {
          csv += json[j][k];
          csv += k === json[j].length - 1 ? '"' : '","';
        }
        csv += '\n';
      }

      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'ventes' + this.periode + '.csv';
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
    },
    downloadtag: function downloadtag() {
      console.log('download tag');
      var json = [];
      var csv = '';

      json.push([this.headersSalesDetailsTag[0].text, this.headersSalesDetailsTag[1].text, this.headersSalesDetailsTag[2].text, this.headersSalesDetailsTag[3].text, this.headersSalesDetailsTag[4].text]);

      for (var i = 0; i < this.tagDetails.length; i++) {
        var value = [];
        value[0] = this.tagDetails[i]['date'];
        value[1] = this.tagDetails[i]['visitorId'];
        value[2] = this.tagDetails[i]['saleId'];
        value[3] = this.tagDetails[i]['amount'];
        value[4] = this.tagDetails[i]['items'];
        json.push(value);
      }

      for (var j = 0; j < json.length; j++) {
        csv += '"';
        for (var k = 0; k < json[j].length; k++) {
          csv += json[j][k];
          csv += k === json[j].length - 1 ? '"' : '","';
        }
        csv += '\n';
      }

      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'tag' + this.periode + '.csv';
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
    }
  },

  watch: {
    params: function params(v) {
      var paramsArray = v.split('=');
      var debut = paramsArray[1].substring(0, 10);
      var fin = paramsArray[2].substring(0, 10);
      this.periode = '_du_' + debut + '_au_' + fin + '.csv';

      this.getSales();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-312ba42a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/Sales.vue
var Sales_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sales"},[(_vm.loading)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('div',[_c('v-card',{staticClass:"mb-3"},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-expansion-panel',{attrs:{"expand":""},model:{value:(_vm.panel),callback:function ($$v) {_vm.panel=$$v},expression:"panel"}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-flex',{attrs:{"d-flex":"","xs12":""}},[_c('v-layout',{staticClass:"itemVente",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('sales', 2, {count: ''}) + " chat")))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline teal--text"},[_vm._v(_vm._s(_vm.nbSales))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('items', 2, {count: ''}) + " chat")))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline blue--text"},[_vm._v(_vm._s(_vm.nbItems))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('amount') + " chat")))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline pink--text"},[_vm._v(_vm._s(Intl.NumberFormat(_vm.lang, {style: 'currency', currency: _vm.currency}).format(_vm.nbAmount)))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('averageBasket') + " chat")))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline deep-orange--text"},[_vm._v(_vm._s(Intl.NumberFormat(_vm.lang, {style: 'currency', currency: _vm.currency}).format(_vm.panierMoyen)))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-card',{attrs:{"color":"primary","dark":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('conversionRate') + ' chat')))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline white--text"},[_vm._v(_vm._s(_vm.nbConversion)+" %")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',{},[_c('highcharts',{attrs:{"options":_vm.options}})],1)],1)],1),_vm._v(" "),(_vm.brideMenu('stats_ventes_chatbot') === '1')?_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-flex',{attrs:{"d-flex":"","xs12":""}},[_c('v-layout',{staticClass:"itemVente",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('sales', 2, {count: ''}) + " chatbot")))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline teal--text"},[_vm._v(_vm._s(_vm.nbSalesBot))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('items', 2, {count: ''}) + " chatbot")))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline blue--text"},[_vm._v(_vm._s(_vm.nbItemsBot))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('amount') + " chatbot")))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline pink--text"},[_vm._v(_vm._s(Intl.NumberFormat(_vm.lang, {style: 'currency', currency: _vm.currency}).format(_vm.nbAmountBot)))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('averageBasket') + " chatbot")))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline deep-orange--text"},[_vm._v(_vm._s(Intl.NumberFormat(_vm.lang, {style: 'currency', currency: _vm.currency}).format(_vm.panierMoyenBot)))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-card',{attrs:{"color":"primary","dark":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('conversionRate') + ' chatbot')))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline white--text"},[_vm._v(_vm._s(_vm.nbConversionBot)+" %")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',{},[_c('highcharts',{attrs:{"options":_vm.optionsChatBot}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.brideMenu('stats_ventes_callback') === '1')?_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-flex',{attrs:{"d-flex":"","xs12":""}},[_c('v-layout',{staticClass:"itemVente",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('sales', 2, {count: ''}) + " Call back")))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline teal--text"},[_vm._v(_vm._s(_vm.nbSalesC2C))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('items', 2, {count: ''}) + " Call back")))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline blue--text"},[_vm._v(_vm._s(_vm.nbItemsC2C))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('amount') + " Call back")))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline pink--text"},[_vm._v(_vm._s(Intl.NumberFormat(_vm.lang, {style: 'currency', currency: _vm.currency}).format(_vm.nbAmountC2C)))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('averageBasket') + " Call back")))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline deep-orange--text"},[_vm._v(_vm._s(Intl.NumberFormat(_vm.lang, {style: 'currency', currency: _vm.currency}).format(_vm.panierMoyenC2C)))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-card',{attrs:{"color":"primary","dark":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('conversionRate') + ' Call back')))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline white--text"},[_vm._v(_vm._s(_vm.nbConversionC2C)+" %")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',{},[_c('highcharts',{attrs:{"options":_vm.optionsC2C}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.brideMenu('stats_ventes_lead') === '1')?_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-flex',{attrs:{"d-flex":"","xs12":""}},[_c('v-layout',{staticClass:"itemVente",attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v("Acquisitions Leads")]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline teal--text"},[_vm._v(_vm._s(_vm.nbSalesLead))])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"}),_vm._v(" "),_c('div',{staticClass:"ml-4 headline blue--text"})])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"}),_vm._v(" "),_c('div',{staticClass:"ml-4 headline pink--text"})])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 grey--text text--darken-2"}),_vm._v(" "),_c('div',{staticClass:"ml-4 headline deep-orange--text"})])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-card',{attrs:{"color":"primary","dark":""}},[_c('v-card-text',[_c('div',{staticClass:"ml-4 white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('conversionRate') + ' Lead')))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline white--text"},[_vm._v(_vm._s(_vm.nbConversionLead)+" %")])])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',{},[_c('highcharts',{attrs:{"options":_vm.optionsLead}})],1)],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"headline",attrs:{"xs6":"","sm10":""}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('salesDetails'))))]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm2":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":"","flat":"","disabled":_vm.salesDetails.length == 0},on:{"click":function($event){_vm.download()}},slot:"activator"},[_vm._v("\n                "+_vm._s(_vm.$t('exportInCsv'))+"\n                "),_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("file_download")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersSalesDetails,"items":_vm.salesDetails,"no-data-text":_vm.$tc('sales', 0),"no-results-text":_vm.$tc('results', 0),"rows-per-page-items":[10, 25, 50, { text: 'Toutes', value: -1 }],"rows-per-page-text":_vm.$t('salesPerPage')},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.header.text))])]}},{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.visitorId))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.saleId))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Intl.NumberFormat(_vm.lang, {style: 'currency', currency: _vm.currency}).format(props.item.amount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.items))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.agent))])]}}])})],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"headline",attrs:{"xs6":"","sm10":""}},[_vm._v("Tag de conversion")]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm2":""}},[_c('v-btn',{attrs:{"slot":"activator","color":"primary","dark":"","flat":"","disabled":_vm.tagDetails.length == 0},on:{"click":function($event){_vm.downloadtag()}},slot:"activator"},[_vm._v("\n                "+_vm._s(_vm.$t('exportInCsv'))+"\n                "),_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("file_download")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersSalesDetailsTag,"items":_vm.tagDetails,"no-data-text":_vm.$tc('sales', 0),"no-results-text":_vm.$tc('results', 0),"rows-per-page-items":[10, 25, 50, { text: 'Toutes', value: -1 }],"rows-per-page-text":_vm.$t('salesPerPage')},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.header.text))])]}},{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(props.item.date))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.visitorId))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.saleId))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(Intl.NumberFormat(_vm.lang, {style: 'currency', currency: _vm.currency}).format(props.item.amount)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.items))])]}}])})],1)],1)],1)])}
var Sales_staticRenderFns = []
var Sales_esExports = { render: Sales_render, staticRenderFns: Sales_staticRenderFns }
/* harmony default export */ var stats_Sales = (Sales_esExports);
// CONCATENATED MODULE: ./src/components/stats/Sales.vue
function Sales_injectStyle (ssrContext) {
  __webpack_require__("rlp4")
}
var Sales_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Sales___vue_template_functional__ = false
/* styles */
var Sales___vue_styles__ = Sales_injectStyle
/* scopeId */
var Sales___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Sales___vue_module_identifier__ = null
var Sales_Component = Sales_normalizeComponent(
  Sales,
  stats_Sales,
  Sales___vue_template_functional__,
  Sales___vue_styles__,
  Sales___vue_scopeId__,
  Sales___vue_module_identifier__
)

/* harmony default export */ var components_stats_Sales = (Sales_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/keys.js
var object_keys = __webpack_require__("fZjL");
var keys_default = /*#__PURE__*/__webpack_require__.n(object_keys);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stats/Leads.vue











/* harmony default export */ var Leads = ({
  data: function data() {
    return {
      loading: false,

      resFromAjax: null,
      currentTab: 0,
      tabs: [{ index: 0, name: this.$t('leadEditor'), icone: 'assignment' }, { index: 1, name: this.$t('conversationHistory'), icone: 'question_answer' }],
      nbLeads: 0,
      nbLeadsChat: 0,
      nbLeadsBot: 0,
      nbLeadsCallBack: 0,
      nbLeadsMeeting: 0,
      nbLeadsForm: 0,
      nbLeadsAutre: 0,
      nbVisits: 0,
      returningLead: 0,
      nbCreations: 0,
      totalAllLeads: 0,
      totalLeadsAgent: 0,
      totalChatsAgent: 0,
      totalLeadsBot: 0,
      totalLeadsForm: 0,
      totalLeadsC2c: 0,
      totalLeadsMeeting: 0,
      totalLeadsAutre: 0,
      nbChats: 0,
      nameChampsBot: ['bot_TF_rgpd', 'bot_TF_main_search', 'bot_TF_lieu', 'bot_TF_departement', 'bot_TF_lieuCP', 'bot_TF_type', 'bot_TF_nature', 'bot_TF_surface', 'bot_TF_nbpostes', 'bot_TF_budget', 'bot_tf_num', 'bot_tf_full_name', 'bot_tf_ouinon', 'bot_tf_pagesvues', 'bot_tf_typebusiness', 'bot_tf_objectifprincipal', 'bot_tf_resourcehumaineinternet', 'bot_tf_effectif', 'bot_tf_echeanceprojet'],

      leadsOfPeriod: true,

      onlyCreatedLeads: false,
      options: {
        colors: ['#F44336', '#3F51B5', '#009688', '#E91E63', '#607D8B', '#9C27B0', '#2196F3', '#FF5722', '#795548', '#4CAF50', '#8BC34A', '#673AB7', '#CDDC39', '#03A9F4', '#FFC107', '#FF9800', '#FFEB3B', '#00BCD4', '#9E9E9E'],
        chart: {
          height: 300
        },
        title: {
          text: '',
          x: -20 },
        tooltip: {
          borderColor: '#cccccc'
        },
        xAxis: {
          categories: [] },
        yAxis: [{
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: {
              color: 'rgba(0, 150, 136, 1)'
            }
          },
          title: {
            text: 'Returning leads',
            style: {
              color: 'rgba(0, 150, 136, 1)'
            }
          },
          opposite: true
        }, {
          allowDecimals: false,
          labels: {
            format: '{value}',
            style: {
              color: 'rgba(50, 50, 50, 1)' }
          },
          title: {
            text: this.$t('chats2'),
            style: {
              color: 'rgba(50, 50, 50, 1)' }
          },
          opposite: false
        }],
        legend: {
          layout: 'vertical',
          align: 'left',
          x: 80,
          verticalAlign: 'top',
          enabled: false,
          y: 55,
          floating: true,
          backgroundColor: 'rgba(255,255,255,0.25)'
        },
        plotOptions: {
          series: {
            fillOpacity: 0.7
          },
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          }
        },
        series: [],
        exporting: {
          enabled: true
        },
        navigation: {
          buttonOptions: {
            verticalAlign: 'bottom',
            y: -15,
            x: -6
          }
        },
        credits: {
          enabled: false
        }
      },

      search: '',
      getquanty: false,
      C2C: false,
      meeting: false,
      sourceReturning: false,
      sourceAgent: false,
      sourceBot: false,
      sourceForm: false,
      sourceRecall: false,
      motif: null,
      pagination: {
        sortBy: 'last',
        descending: true
      },
      headersLeadsDetails: [{ text: lodash_default.a.upperFirst(this.$t('exportCreation')), value: 'creation' }, { text: lodash_default.a.upperFirst(this.$t('exportLast')), value: 'last' }, { text: this.$t('leadHeat'), value: 'chaleur', sortable: false }, { text: 'GetQuanty', value: 'getquanty', sortable: false }, { text: lodash_default.a.upperFirst(this.$t('company')), value: 'company', sortable: false }, { text: lodash_default.a.upperFirst(this.$t('identity')), value: 'identity', sortable: false }, { text: lodash_default.a.upperFirst(this.$t('exportDuration')), value: 'duration' }, { text: lodash_default.a.upperFirst(this.$t('exportSite')), value: 'site' }, { text: lodash_default.a.upperFirst(this.$tc('tags', 2, { count: '' })), value: 'motif' }, { text: lodash_default.a.upperFirst(this.$tc('sources', 2, { count: '' })), value: 'agent' }, { text: '', value: 'actions', sortable: false }],
      leadsDetails: [],
      leadsDetails2: [],
      filteredLeads: null,

      dialogEdit2: false,
      dialogEdit: false,
      dialogRemove: false,
      leadDialog: {
        gender: '',
        motifs: []
      },
      custom_motifs: [],
      custom_champs: [],
      default_motif: [{ text: lodash_default.a.upperFirst(this.$t('support')), value: 'support' }, { text: lodash_default.a.upperFirst(this.$t('lead')), value: 'lead' }, { text: lodash_default.a.upperFirst(this.$tc('sales', 1, { count: '' })), value: 'sale' }, { text: lodash_default.a.upperFirst(this.$t('estimate')), value: 'devis' }, { text: lodash_default.a.upperFirst(this.$t('reservation')), value: 'resa' }, { text: lodash_default.a.upperFirst(this.$t('contact')), value: 'contact' }]
    };
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_Stats', ['params']), Object(vuex_esm["c" /* mapGetters */])('_Sites', ['GET_SITE_BY_ID']), Object(vuex_esm["e" /* mapState */])('_User', ['brides']), {
    identities: function identities() {
      return this.leadsDetails2.map(function (item) {
        return lodash_default.a.isEmpty(item.fname) && lodash_default.a.isEmpty(item.lname) ? '#' + item.id : item.gender + ' ' + item.fname + ' ' + item.lname;
      });
    },
    conversionAgentChat: function conversionAgentChat() {
      return this.nbChats !== 0 ? lodash_default.a.round(this.totalLeadsAgent / this.totalChatsAgent * 100, 2) : 0;
    },
    conversionBotChat: function conversionBotChat() {
      return this.nbChats !== 0 ? lodash_default.a.round(this.totalLeadsBot / this.nbChats * 100, 2) : 0;
    },
    totalLeads: function totalLeads() {
      return this.totalLeadsAgent + this.totalLeadsBot + this.totalLeadsForm + this.totalLeadsC2c + this.totalLeadsMeeting + this.totalLeadsAutre;
    },
    totalSite: function totalSite() {
      return this.$store.state._User.licAllKeys.length;
    },
    motifs: function motifs() {
      if (this.$store.state._User.entKey === '9f1d52167b4128993ffa1c7b92207c4c') {
        return MOTIFS_NUXE;
      }

      if (this.$store.state._User.entKey === '8204159d47830f1c1cc7d3561544ced7') {
        return MOTIFS_INOYA;
      }

      var res = [];
      if (!this.leadsDetails2.motifs) {
        var motifs = lodash_default.a.map(this.leadsDetails2, 'motif');
        motifs = lodash_default.a.filter(motifs, function (m) {
          return m.length;
        });
        lodash_default.a.each(motifs, function (motif) {
          res.push(motif);
        });
      }

      return lodash_default.a.uniq(res);
    },
    heightOfFiche: function heightOfFiche() {
      return 'height: ' + (window.innerHeight - 300) + 'px';
    },
    heightOfHisto: function heightOfHisto() {
      return 'height: ' + (window.innerHeight - 200) + 'px';
    }
  }),

  mounted: function mounted() {
    this.loading = true;
    this.getLeadsInfos();

    if (this.totalSite < 2) {
      this.headersLeadsDetails.splice(7, 1);
    }

    if (this.brideMenu('stats_leads_getquanty') !== '1') {
      this.headersLeadsDetails.splice(3, 1);
    }

    if (this.brideMenu('stats_leads_chaleur') !== '1') {
      this.headersLeadsDetails.splice(2, 1);
    }
  },
  created: function created() {},


  methods: {
    brideMenu: function brideMenu(nameBride) {
      if (this.brides) {
        var index = this.brides.findIndex(function (bride) {
          return bride.brideName === nameBride;
        });

        if (index !== -1) {
          return this.brides[index].status;
        }
      }
    },
    getLeadsInfos: function getLeadsInfos() {
      var _this = this;

      this.loading = true;

      this.axios.get('get/leads.php?' + this.params).then(function (response) {
        _this.resFromAjax = response.data;
        _this.nbLeads = _this.resFromAjax.leads2.length;
        _this.nbVisits = 0;
        _this.returningLead = 0;
        _this.nbCreations = 0;
        _this.totalLeadsAgent = 0;
        _this.totalLeadsBot = 0;
        _this.totalLeadsForm = 0;
        _this.totalLeadsC2c = 0;
        _this.totalLeadsMeeting = 0;
        _this.totalLeadsAutre = 0;
        _this.options.xAxis.categories = [];
        _this.options.series = [];
        var serie0 = {
          name: 'Returning leads',
          type: 'area',
          color: 'rgba(0, 150, 136, 0.9)',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'leads',
          yAxis: 0,
          data: [] };

        var serie1 = {
          name: 'leads conseiller',
          type: 'column',
          color: 'rgba(156, 39, 176, 0.9)',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'leads',
          yAxis: 1,
          data: [] };

        var serie2 = {
          name: 'leads bot',
          type: 'column',
          color: 'rgba(33, 150, 243, 0.9)',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'leads',
          yAxis: 1,
          data: [] };

        var serie3 = {
          name: 'leads formulaire',
          type: 'column',
          color: 'rgba(255, 152, 0, 0.9)',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'leads',
          yAxis: 1,
          data: [] };

        var serie4 = {
          name: 'leads CallBack',
          type: 'column',
          color: 'rgba(121, 85, 72, 0.9)',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'leads',
          yAxis: 1,
          data: [] };

        var serie5 = {
          name: 'Leads Meeting',
          type: 'column',
          color: 'rgba(6, 125, 139, 0.9)',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'leads',
          yAxis: 1,
          data: [] };

        var serie6 = {
          name: 'Autres leads',
          type: 'column',
          color: 'rgba(76, 175, 80, 0.9)',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'leads',
          yAxis: 1,
          data: [] };

        var serie7 = {
          name: _this.$t('chats2'),
          type: 'column',
          color: 'rgba(50, 50, 50, 0.7)',
          marker: { symbol: 'circle', enabled: false },
          visible: true,
          tooltip: { valueSuffix: '' },
          stack: 'allChats',
          yAxis: 1,
          pointPadding: 0,
          data: [] };
        _this.options.series[0] = serie0;
        _this.options.series[1] = serie1;
        _this.options.series[2] = serie2;
        _this.options.series[3] = serie3;
        _this.options.series[4] = serie4;
        _this.options.series[5] = serie5;
        _this.options.series[6] = serie6;
        _this.options.series[7] = serie7;

        _this.leadsDetails = [];
        _this.leadsDetails2 = [];

        lodash_default.a.each(_this.resFromAjax.days2, function (day) {
          _this.options.series[0].data.push(day.returningLead);

          _this.options.series[1].data.push(day.leadsAgent);
          if (_this.brideMenu('stats_chatbot') === '1') {
            _this.options.series[2].data.push(day.leadsBot);
            _this.totalLeadsBot += day.leadsBot;
          }
          _this.options.series[3].data.push(day.leadsForm);
          if (_this.brideMenu('stats_callback') === '1') {
            _this.options.series[4].data.push(day.leadsC2c);
            _this.totalLeadsC2c += day.leadsC2c;
          }
          if (_this.brideMenu('parametre_recall') === '1') {
            _this.options.series[5].data.push(day.leadsMeeting);
            _this.totalLeadsMeeting += day.leadsMeeting;
          }
          _this.options.series[6].data.push(day.leadsAutre);

          _this.nbVisits += day.visits;
          _this.returningLead += day.returningLead;

          if (day.leadsBot && _this.brideMenu('stats_chatbot') !== '1') {} else if (day.leadsC2c && _this.brideMenu('stats_callback') !== '1') {}
          _this.nbCreations += day.creations;
          _this.totalLeadsAgent += day.leadsAgent;

          _this.totalLeadsForm += day.leadsForm;

          _this.totalLeadsAutre += day.leadsAutre;
        });

        lodash_default.a.each(_this.resFromAjax.leads2, function (lead) {
          var infos2 = {};

          lodash_default.a.each(lead, function (value, key) {
            if (key === 'source') {
              if (value === 'agent') {
                _this.nbLeadsChat++;
              } else if (value === 'bot') {
                _this.nbLeadsBot++;
              } else if (value === 'form') {
                _this.nbLeadsForm++;
              } else if (value === 'c2c') {
                _this.nbLeadsCallBack++;
              } else if (value === 'rdv') {
                _this.nbLeadsMeeting++;
              } else {
                _this.nbLeadsAutre++;
              }
            }
            infos2[key] = value;
            if (moment(value, 'YYYY-MM-DD').format('YYYY-MM-DD') === value) {
              infos2[key] = moment(value).format('L');
            }
          });

          if (infos2['creation'] < infos2['last']) {}

          if (_this.brideMenu('stats_leads_getquanty') === '1') {
            try {
              infos2['getquanty'] = JSON.parse(infos2['getquanty']);
            } catch (e) {
              infos2['getquanty'] = '';
            }
          } else {
            infos2['getquanty'] = '';
          }

          if (infos2['url'] !== '') {
            infos2['site'] = infos2['url'];
          } else {
            infos2['site'] = infos2['host'];
          }
          infos2['site'] = new window.URL(infos2['site']).hostname;

          infos2['motifToShow'] = infos2['motif'];

          if (_this.$store.state._User.entKey === 'adad9e37fb749c6884c852') {
            for (var i = 0; i < _this.nameChampsBot.length; i++) {
              var find = false;

              for (var a = 0; a < infos2['champSup'].length; a++) {
                if (infos2['champSup'][a].name === _this.nameChampsBot[i]) {
                  var name = infos2['champSup'][a].name;
                  var val = infos2['champSup'][a].value;

                  infos2[name] = val;
                  find = true;
                }
              }
              if (!find) {
                infos2[_this.nameChampsBot[i]] = '';
              }
            }
          }

          if (_this.$store.state._User.entKey === '8204159d47830f1c1cc7d3561544ced7' || _this.$store.state._User.entKey === '948580a42a7ace75df2befcdf0ec8a81') {
            for (var c in MOTIFS_INOYA) {
              if (MOTIFS_INOYA[c].value === infos2['motif']) {
                infos2['motifToShow'] = MOTIFS_INOYA[c].text;
              }
            }
          }
          if (infos2['source'] === 'bot' && _this.brideMenu('stats_chatbot') !== '1') {} else if (infos2['source'] === 'c2c' && _this.brideMenu('stats_callback') !== '1') {} else {
            _this.leadsDetails2.push(infos2);
          }
        });
      }).catch(function (errors) {}).then(function (_) {
        _this.getLeads();
      });
    },
    getLeads: function getLeads() {
      var _this2 = this;

      this.loading = true;
      this.axios.get('get/stats_leads.php?' + this.params).then(function (res) {
        _this2.nbChats = res.data.nbChats;

        _this2.options.series[7].data = [];

        res.data.days.forEach(function (day) {
          _this2.options.series[7].data.push(day.chats);
        });
      }).catch(function (e) {
        return console.error(e);
      }).then(function () {
        _this2.loading = false;
        console.log('start requet getAgentsChats');
        _this2.getAgentsChats();
      });
    },
    getAgentsChats: function getAgentsChats() {
      var _this3 = this;

      var sizeOptionSeries = this.options.series.length;
      this.totalChatsAgent = 0;
      this.loading = true;
      this.axios.get('get/agents_chats.php?' + this.params).then(function (response) {
        var idAgents = [];

        response.data.chatsByAgent.forEach(function (agent) {
          var agentFound = lodash_default.a.find(_this3.$store.state._User.colleagues, { 'USR_ID': lodash_default.a.toString(agent.id) });

          idAgents.push(agent.id);
          _this3.options.series.push({
            name: agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME,
            agentID: agent.id,
            stack: 'chats',
            type: 'column',
            yAxis: 1,
            day: response.data.days,
            arrayDays: response.data.arrayDays,
            pointPadding: 0.3,
            pointPlacement: -0.2,
            data: []
          });
        });

        entries_default()(response.data.days).forEach(function (_ref) {
          var _ref2 = slicedToArray_default()(_ref, 2),
              date = _ref2[0],
              agents = _ref2[1];

          _this3.options.xAxis.categories.push(moment(date).format('ddd D MMM YY'));

          entries_default()(agents).forEach(function (_ref3) {
            var _ref4 = slicedToArray_default()(_ref3, 2),
                id = _ref4[0],
                chat = _ref4[1];

            var idx = idAgents.findIndex(function (i) {
              return i === lodash_default.a.toNumber(id);
            });

            if (idx !== -1) {
              var i = idx + sizeOptionSeries;
              _this3.options.series[i].data.push(chat);
              _this3.totalChatsAgent += chat;
            }
          });
        });
      }).catch().then(function (_) {
        _this3.loading = false;
      });
    },
    openDialogEdit: function openDialogEdit(lead) {
      this.dialogEdit = true;
      this.leadDialog = {};
      this.leadDialog = lodash_default.a.clone(lead);


      var listeMotifs = [];
      for (var n in this.$store.state._Sites.sites) {
        if (this.$store.state._Sites.sites[n].LIC_KEY === lead.siteKey) {
          var customLead = this.$store.state._Sites.sites[n].DSK_CUSTOM_LEAD_FORM;

          if (customLead !== '') {
            for (var i = 0; i < customLead.motifs.length; ++i) {
              var label = customLead.motifs[i];
              if (label === 'support') {
                label = 'Support';
              } else if (label === 'lead') {
                label = 'Prospect qualifié';
              } else if (label === 'sale') {
                label = 'Vente';
              } else if (label === 'resa') {
                label = 'Réservation';
              } else if (label === 'devis') {
                label = 'Devis';
              } else if (label === 'contact') {
                label = 'Contact';
              }
              listeMotifs.push({
                text: label,
                value: customLead.motifs[i]
              });
            }
            if (listeMotifs.length !== 0) {
              this.default_motif = listeMotifs;
            } else {
              this.default_motif = [];
            }
          }
        }
      }
      this.custom_motifs = listeMotifs;

      var newArrayCustomChamp = [];

      if (this.$store.state._User.entKey === 'adad9e37fb749c6884c852') {
        for (var _i = 0; _i < this.nameChampsBot.length; _i++) {
          var find = false;
          for (var a = 0; a < lead.champSup.length; a++) {
            if (lead.champSup[a].name === this.nameChampsBot[_i]) {
              newArrayCustomChamp.push({ 'name': lead.champSup[a].name, 'value': lead.champSup[a].value });
              find = true;
            }
          }
          if (!find) {
            newArrayCustomChamp.push({ 'name': this.nameChampsBot[_i], 'value': '' });
          }
        }
      } else {
        lead.champSup.forEach(function (item) {
          if (item.value) {
            newArrayCustomChamp.push(item);
          }
        });
      }

      this.custom_champs = newArrayCustomChamp;
    },
    dialogEditeurRemove: function dialogEditeurRemove() {
      this.dialogEdit = false;
    },
    updateLeadSubmit: function updateLeadSubmit(leadUpdate) {
      this.leadDialog = {};
      this.leadDialog = lodash_default.a.clone(leadUpdate);

      var indexOfLead = lodash_default.a.findIndex(this.leadsDetails2, { id: this.leadDialog.id });
      this.$set(this.leadsDetails2, indexOfLead, this.leadDialog);
    },
    openDialogRemove: function openDialogRemove(lead) {
      this.dialogRemove = true;
      this.leadDialog = lodash_default.a.clone(lead);
    },
    cancelDialogRemove: function cancelDialogRemove() {
      this.dialogRemove = false;
    },
    submitDialogRemove: function submitDialogRemove() {
      var _this4 = this;

      this.dialogRemove = false;

      var dataToPost = new window.FormData();
      dataToPost.append('session', this.leadDialog.id);
      this.axios.post('delete/lead.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        var indexOfLead = lodash_default.a.findIndex(_this4.leadsDetails2, { id: _this4.leadDialog.id });
        _this4.leadsDetails2.splice(indexOfLead, 1);
        _this4.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Lead supprim\xE9', context: 'success' });
      });
    },
    filterLeads: function filterLeads(items, search, filter) {
      var _this5 = this;

      if (this.leadsOfPeriod) {
        items = lodash_default.a.filter(items, function (item) {
          return _this5.onlyCreatedLeads ? _this5.isInPeriod(item.creation) : _this5.isInPeriod(item.creation) || _this5.isInPeriod(item.last);
        });
      }

      if (this.getquanty) {
        items = lodash_default.a.filter(items, function (item) {
          return lodash_default.a.isObject(item.getquanty);
        });
      }

      if (this.sourceReturning) {
        items = lodash_default.a.filter(items, function (item) {
          if (item.creation !== item.last) {
            return item.last;
          }
        });
      }

      if (this.sourceAgent) {
        items = lodash_default.a.filter(items, function (item) {
          if (item.source === 'agent') {
            return item.source;
          }
        });
      }

      if (this.sourceBot) {
        items = lodash_default.a.filter(items, function (item) {
          if (item.source === 'bot') {
            return item.source;
          }
        });
      }

      if (this.sourceRecall) {
        items = lodash_default.a.filter(items, function (item) {
          if (item.source === 'rdv') {
            return item.source;
          }
        });
      }

      if (this.sourceForm) {
        items = lodash_default.a.filter(items, function (item) {
          if (item.source === 'form') {
            return item.source;
          }
        });
      }

      if (this.C2C) {
        items = lodash_default.a.filter(items, function (item) {
          if (item.source === 'c2c') {
            return item.source;
          }
        });
      }

      if (this.motif) {
        items = lodash_default.a.filter(items, function (item) {
          if (item.motif === _this5.motif) {
            return item.motif;
          }
        });
      }

      this.filteredLeads = items;
      if (lodash_default.a.isNil(search)) return items;

      search = search.toString().toLowerCase();
      items = items.filter(function (i) {
        return keys_default()(i).some(function (j) {
          return filter(i[j], search);
        });
      });

      this.filteredLeads = items;
      return items;
    },
    sort: function sort(items, index, isDescending) {
      if (index === null || items.length <= 1) return items;

      var itemsSorted = items;

      if (index === 'last' || index === 'creation') {
        itemsSorted = lodash_default.a.sortBy(items, [function (item) {
          if (item[index] === '') return 0;
          return moment(item[index], 'L').unix();
        }]);
      } else if (index === 'duration') {
        itemsSorted = lodash_default.a.sortBy(items, [function (item) {
          return lodash_default.a.toNumber(item[index]);
        }]);
      } else {
        itemsSorted = lodash_default.a.sortBy(items, [function (item) {
          return item[index];
        }]);
      }
      if (isDescending) return itemsSorted.reverse();
      return itemsSorted;
    },
    leadMail: function leadMail(lead) {
      var _this6 = this;

      var dataToPost = new window.FormData();
      for (var key in lead) {
        dataToPost.append(key, lead[key]);
      }
      this.axios.post('post/lead_mail.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this6.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Lead envoy\xE9 par mail', context: 'success' });
      }).catch(function () {
        _this6.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'L\'envoi du lead a \xE9chou\xE9', context: 'error' });
      });
    },
    leadZendesk: function leadZendesk(lead) {
      var _this7 = this;

      var dataToPost = new window.FormData();
      for (var key in lead) {
        dataToPost.append(key, lead[key]);
      }
      this.axios.post('post/lead_zendesk.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this7.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Ticket Zendesk cr\xE9\xE9', context: 'success' });
      }).catch(function () {
        _this7.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'La cr\xE9ation d\'un ticket Zendesk a \xE9chou\xE9', context: 'error' });
      });
    },
    leadSalesForce: function leadSalesForce(lead) {
      var _this8 = this;

      var dataToPost = new window.FormData();
      for (var key in lead) {
        dataToPost.append(key, lead[key]);
      }
      this.axios.post('post/lead_salesforce.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this8.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Export vers SalesForce r\xE9ussi', context: 'success' });
      }).catch(function () {
        _this8.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'L\'export vers SalesForce a \xE9chou\xE9', context: 'error' });
      });
    },
    download: function download() {
      var _this9 = this;

      var csv = null;
      var fields = this.filteredLeads[0];
      delete fields.motifs;
      delete fields.siteId;
      fields = lodash_default.a.keys(fields);
      var fieldNames = lodash_default.a.map(fields, function (field) {
        return field === 'id' || field === 'ip' ? field : _this9.$tc(lodash_default.a.camelCase('export ' + field), 2, { count: '' });
      });

      var dataToExport = this.filteredLeads.map(function (lead) {
        var agent = _this9.$store.getters['_User/getUserById'](lead.agent);
        lead.agent = agent ? agent.USR_FIRST_NAME + ' ' + agent.USR_LAST_NAME : '';
        return lead;
      });
      try {
        csv = json2csv_default()({
          data: dataToExport,
          fields: fields,
          del: ';',
          newLine: '\r\n',
          fieldNames: fieldNames
        });
      } catch (err) {
        console.err(err);
        return;
      }

      if (this.nbVisits > 500) {
        this.$router.push({ name: 'csvexport', params: { 'csv': csv } });
      } else {
        var paramsArray = this.params.split('=');
        var debut = paramsArray[1].substring(0, 10);
        var fin = paramsArray[2].substring(0, 10);
        var nameFile = 'leads_du_' + debut + '_au_' + fin + '.csv';

        var hiddenElement = document.createElement('a');
        hiddenElement.href = 'data:attachment/text,' + encodeURI(csv);
        hiddenElement.target = '_blank';
        hiddenElement.download = nameFile;
        document.body.appendChild(hiddenElement);
        hiddenElement.click();
      }
    },
    agentIdToAgentName: function agentIdToAgentName(id) {
      var _this10 = this;

      return this.leadsDetails2.map(function (agent) {
        var found = lodash_default.a.find(_this10.$store.state._User.colleagues, {
          'USR_ID': lodash_default.a.toString(id)
        });

        return !lodash_default.a.isNil(found) ? found.USR_FIRST_NAME + ' ' + found.USR_LAST_NAME : '';
      });
    },
    isInPeriod: function isInPeriod(date) {
      if (lodash_default.a.isNil(date) || lodash_default.a.isEmpty(date)) {
        return false;
      }
      return moment(date, 'L').isBetween(this.$store.state._Stats.dateStart, this.$store.state._Stats.dateEnd, 'days', '[]');
    },
    chaleur: function chaleur(idlead) {
      for (var i in this.leadsDetails2) {
        if (this.leadsDetails2[i].id === idlead) {
          return this.chaleurLead(this.leadsDetails2[i]).chaleur;
        }
      }
      return '';
    },
    chaleurLead: function chaleurLead(lead) {
      var chaleur = 0;
      var points = 0;

      points = lead.basket * 1;
      chaleur += points;

      points = lead.hasChatted ? 10 : 0;
      chaleur += points;

      points = lead.hasBeenTarget ? 10 : 0;
      chaleur += points;

      points = lodash_default.a.round(lead.duration / 60 / 5);
      chaleur += points;

      points = !lodash_default.a.isEmpty(lead.email) ? 10 : 0;
      chaleur += points;

      points = !lodash_default.a.isEmpty(lead.tel) || !lodash_default.a.isEmpty(lead.C2C) ? 10 : 0;
      chaleur += points;

      points = lead.purchase * 10;
      chaleur += points;

      return {
        chaleur: chaleur
      };
    }
  },

  watch: {
    params: function params(v) {
      this.loading = true;
      this.getLeadsInfos();
    },
    leadsOfPeriod: function leadsOfPeriod(v) {
      if (!v) {
        this.onlyCreatedLeads = false;
      }
    }
  },

  filters: {
    duration: function duration(v) {
      return moment["duration"](lodash_default.a.toNumber(v), 'seconds').format('h [h] mm [min] ss [s] ');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-217074f1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/Leads.vue
var Leads_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"leads"},[(_vm.loading)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('div',[_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.leadsDetails2.length)?_c('v-flex',{attrs:{"xs3":"","md2":""}},[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('leadsVisitors'))))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline teal--text"},[_vm._v(_vm._s(_vm.returningLead))])]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md2":""}},[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('newLeads'))))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline grey--text"},[_vm._v(_vm._s(_vm.totalLeads))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md2":""}},[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('chatsTotal'))))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline grey--text"},[_vm._v(_vm._s(_vm.nbChats))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md2":""}},[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('conversionRate') + ' conseiller')))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline primary--text"},[_vm._v(_vm._s(_vm.conversionAgentChat)+" %")])]),_vm._v(" "),(_vm.brideMenu('stats_chatbot') === '1')?_c('v-flex',{attrs:{"xs6":"","md2":""}},[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('conversionRate') + ' bot')))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline primary--text"},[_vm._v(_vm._s(_vm.conversionBotChat)+" %")])]):_vm._e()],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('highcharts',{attrs:{"options":_vm.options}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":"","md2":""}},[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")('(Conseiller)')))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline purple--text"},[_vm._v(_vm._s(_vm.totalLeadsAgent))])]),_vm._v(" "),(_vm.leadsDetails2.length && _vm.brideMenu('stats_chatbot') === '1')?_c('v-flex',{attrs:{"xs3":"","md2":""}},[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")('(Chatbot)')))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline blue--text"},[_vm._v(_vm._s(_vm.totalLeadsBot))])]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","md2":""}},[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")('(Formulaire)')))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline orange--text"},[_vm._v(_vm._s(_vm.totalLeadsForm))])]),_vm._v(" "),(_vm.brideMenu('stats_callback') === '1')?_c('v-flex',{attrs:{"xs3":"","md2":""}},[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")('(Call back)')))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline brown--text"},[_vm._v(_vm._s(_vm.totalLeadsC2c))])]):_vm._e(),_vm._v(" "),(_vm.brideMenu('parametre_recall') === '1')?_c('v-flex',{attrs:{"xs3":"","md2":""}},[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")('(Meeting)')))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline blue-grey--text"},[_vm._v(_vm._s(_vm.totalLeadsMeeting))])]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs3":"","md2":""}},[_c('div',{staticClass:"ml-4 grey--text text--darken-2"},[_vm._v(_vm._s(_vm._f("cap")('(Autres)')))]),_vm._v(" "),_c('div',{staticClass:"ml-4 headline green--text"},[_vm._v(_vm._s(_vm.totalLeadsAutre))])])],1)],1)],1),_vm._v(" "),(_vm.leadsDetails2.length || _vm.nbCreations)?_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-toolbar',{staticClass:"elevation-0",attrs:{"color":"white"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('leadsDetails'))))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","dark":"","flat":"","disabled":_vm.leadsDetails2.length == 0},on:{"click":function($event){_vm.download()}}},[_vm._v("\n              "+_vm._s(_vm.$t('exportInCsv'))+"\n              "),(_vm.nbVisits > 500)?_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("visibility")]):_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("file_download")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"mt-2",attrs:{"xs6":"","sm2":"","md3":""}},[_c('v-checkbox',{staticClass:"primary--text returningLeads",attrs:{"color":"primary","label":"Returning Leads","hide-details":""},model:{value:(_vm.sourceReturning),callback:function ($$v) {_vm.sourceReturning=$$v},expression:"sourceReturning"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","md3":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('v-autocomplete',{attrs:{"items":_vm.motifs,"label":_vm._f("cap")(_vm.$tc('tags', 2, {count: ''})),"clearable":"","append-icon":"label"},model:{value:(_vm.motif),callback:function ($$v) {_vm.motif=$$v},expression:"motif"}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-flex',{attrs:{"xs10":""}},[_c('v-text-field',{attrs:{"append-icon":"search","label":_vm.$t('search'),"hide-details":"","clearable":""},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs3":"","sm2":""}},[_c('v-subheader',{domProps:{"textContent":_vm._s('Voir uniquement les leads :')}})],1),_vm._v(" "),(false)?_c('v-flex',{staticClass:"mt-2 ",attrs:{"xs3":"","sm2":"","md1":""}},[_c('v-checkbox',{staticClass:"primary--text choixLead",attrs:{"color":"primary","label":_vm._f("cap")(_vm.$tc('leads', 2, {count: ''}) + ' ' + _vm.$t('ofThePeriod')),"hide-details":""},model:{value:(_vm.leadsOfPeriod),callback:function ($$v) {_vm.leadsOfPeriod=$$v},expression:"leadsOfPeriod"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"mt-2 ",attrs:{"xs3":"","sm2":"","md1":""}},[_c('v-checkbox',{staticClass:"primary--text choixLead",attrs:{"color":"primary","label":"Conseiller ","hide-details":""},model:{value:(_vm.sourceAgent),callback:function ($$v) {_vm.sourceAgent=$$v},expression:"sourceAgent"}})],1),_vm._v(" "),(_vm.brideMenu('stats_chatbot') === '1')?_c('v-flex',{staticClass:"mt-2 ",attrs:{"xs3":"","sm2":"","md1":""}},[_c('v-checkbox',{staticClass:"primary--text choixLead",attrs:{"color":"primary ","label":"Chatbot ","hide-details":""},model:{value:(_vm.sourceBot),callback:function ($$v) {_vm.sourceBot=$$v},expression:"sourceBot"}})],1):_vm._e(),_vm._v(" "),_c('v-flex',{staticClass:"mt-2 ",attrs:{"xs3":"","sm2":"","md1":""}},[_c('v-checkbox',{staticClass:"primary--text choixLead",attrs:{"color":"primary","label":"Formulaire ","hide-details":""},model:{value:(_vm.sourceForm),callback:function ($$v) {_vm.sourceForm=$$v},expression:"sourceForm"}})],1),_vm._v(" "),(_vm.brideMenu('stats_callback') === '1')?_c('v-flex',{staticClass:"mt-2 ",attrs:{"xs3":"","sm2":"","md1":""}},[_c('v-checkbox',{staticClass:"primary--text choixLead",attrs:{"color":"primary","label":_vm._f("cap")(_vm.$t('callback')),"hide-details":""},model:{value:(_vm.C2C),callback:function ($$v) {_vm.C2C=$$v},expression:"C2C"}})],1):_vm._e(),_vm._v(" "),(_vm.brideMenu('parametre_recall') === '1')?_c('v-flex',{staticClass:"mt-2 ",attrs:{"xs3":"","sm2":"","md1":""}},[_c('v-checkbox',{staticClass:"primary--text choixLead",attrs:{"color":"primary","label":"Meeting ","hide-details":""},model:{value:(_vm.sourceRecall),callback:function ($$v) {_vm.sourceRecall=$$v},expression:"sourceRecall"}})],1):_vm._e(),_vm._v(" "),(_vm.brideMenu('stats_leads_getquanty') === '1')?_c('v-flex',{staticClass:"mt-2 ",attrs:{"xs3":"","sm2":"","md1":""}},[_c('v-checkbox',{staticClass:"primary--text choixLead",attrs:{"color":"primary","label":"GetQuanty ","hide-details":""},model:{value:(_vm.getquanty),callback:function ($$v) {_vm.getquanty=$$v},expression:"getquanty"}})],1):_vm._e()],1),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersLeadsDetails,"items":_vm.leadsDetails2,"no-data-text":_vm.$tc('leads', 0),"no-results-text":_vm.$tc('results', 0),"rows-per-page-items":[10, 25, 100],"rows-per-page-text":_vm.$t('leadsPerPage'),"search":_vm.search,"custom-filter":_vm.filterLeads,"custom-sort":_vm.sort,"dark":false,"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.header.text))])]}},{key:"items",fn:function(props){return [_c('tr',[_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.creation))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.last))]),_vm._v(" "),(_vm.brideMenu('stats_leads_chaleur') === '1')?_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm.chaleur(props.item.id)))]):_vm._e(),_vm._v(" "),(_vm.brideMenu('stats_leads_getquanty') === '1')?_c('td',{staticClass:"text-xs-left"},[_vm._v("\n                  "+_vm._s(props.item.getquanty['raison sociale']
                    ? props.item.getquanty['raison sociale'][1]
                    : '')+"\n                ")]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.company))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.gender)+" "+_vm._s(props.item.firstName)+" "+_vm._s(props.item.lastName)+" "),_c('span',{staticClass:"font-italic grey--text text--darken-1"},[_vm._v("("+_vm._s(props.item.id)+")")])]),_vm._v(" "),_c('td',{staticClass:"text-xs-right"},[_vm._v(_vm._s(_vm._f("duration")(props.item.duration)))]),_vm._v(" "),(_vm.totalSite > 1)?_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.site))]):_vm._e(),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.motifToShow))]),_vm._v(" "),_c('td',{staticClass:"text-xs-left"},[_vm._v(_vm._s(props.item.source)),_c('br'),(_vm.agentIdToAgentName(props.item.agent)[0] !== '')?_c('i',[_vm._v("("+_vm._s(_vm.agentIdToAgentName(props.item.agent)[0])+")")]):_vm._e()]),_vm._v(" "),_c('td',{staticClass:"text-xs-right px-0"},[_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.openDialogEdit(props.item)}}},[_c('v-icon',[_vm._v("info_outline")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right px-0"},[_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.openDialogRemove(props.item)}}},[_c('v-icon',[_vm._v("delete")])],1)],1),_vm._v(" "),_c('td',{staticClass:"text-xs-right px-0"},[_c('v-menu',[_c('v-btn',{attrs:{"slot":"activator","icon":"","flat":""},slot:"activator"},[_c('v-icon',[_vm._v("share")])],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.leadMail(props.item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('sendByEmail')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.leadZendesk(props.item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('createAZendeskTicket')))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.leadSalesForce(props.item)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('exportToSalesForce')))])],1)],1)],1)],1)])]}},{key:"pageText",fn:function(ref){
                    var pageStart = ref.pageStart;
                    var pageStop = ref.pageStop;
                    var itemsLength = ref.itemsLength;
return [_vm._v("\n              "+_vm._s(pageStart)+"-"+_vm._s(pageStop)+" sur "+_vm._s(itemsLength)+"\n            ")]}}])})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1200px","scrollable":!_vm.$vuetify.breakpoint.smAndDown,"fullscreen":_vm.$vuetify.breakpoint.smAndDown},model:{value:(_vm.dialogEdit),callback:function ($$v) {_vm.dialogEdit=$$v},expression:"dialogEdit"}},[_c('wz-editeur-lead',{attrs:{"leadDialog":_vm.leadDialog,"custom_motifs":_vm.custom_motifs,"custom_champs":_vm.custom_champs,"showHisto":true,"histoChat":true},on:{"closeDialog":_vm.dialogEditeurRemove,"updateLead":_vm.updateLeadSubmit}})],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.dialogRemove),callback:function ($$v) {_vm.dialogRemove=$$v},expression:"dialogRemove"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text title"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('delete') + ' ' + _vm.$tc('leads', 1, { count: '' }) + '?')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('msgDeleteLead')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":_vm.cancelDialogRemove}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.submitDialogRemove}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1)}
var Leads_staticRenderFns = []
var Leads_esExports = { render: Leads_render, staticRenderFns: Leads_staticRenderFns }
/* harmony default export */ var stats_Leads = (Leads_esExports);
// CONCATENATED MODULE: ./src/components/stats/Leads.vue
function Leads_injectStyle (ssrContext) {
  __webpack_require__("+BiP")
}
var Leads_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Leads___vue_template_functional__ = false
/* styles */
var Leads___vue_styles__ = Leads_injectStyle
/* scopeId */
var Leads___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Leads___vue_module_identifier__ = null
var Leads_Component = Leads_normalizeComponent(
  Leads,
  stats_Leads,
  Leads___vue_template_functional__,
  Leads___vue_styles__,
  Leads___vue_scopeId__,
  Leads___vue_module_identifier__
)

/* harmony default export */ var components_stats_Leads = (Leads_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stats/Satisfaction.vue








/* harmony default export */ var Satisfaction = ({

  name: 'Satisfaction',

  data: function data() {
    return {
      domaine: constants_DOMAINE,

      loading: false,
      evalWaiting: [],
      evalQuality: [],
      evalWelcome: [],
      dialogChat: false,
      chatDialog: {},

      optionsPie: {
        chart: {
          height: 300,
          type: 'pie',
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false
        },
        colors: [this.$vuetify.theme.tertiary, this.$vuetify.theme.error, this.$vuetify.theme.warning, this.$vuetify.theme.success],
        tooltip: {
          headerFormat: '<b>{point.key}</b><br/>',
          pointFormat: '{point.percentage:.1f}%'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        }
      },
      optionsWaiting: {
        title: { text: this.$t('questionWaitingTime') },
        series: [{ data: {} }]
      },
      optionsQuality: {
        title: { text: this.$t('questionAnswersQuality') },
        series: [{ data: {} }]
      },
      optionsWelcome: {
        title: { text: this.$t('questionAdvisorWelcome') },
        series: [{ data: {} }]
      },

      headers: [{ text: 'Date', value: 'date', align: 'left' }, { text: 'ID ' + this.$tc('visitors', 1, { count: '' }), value: 'id', align: 'left' }, { text: lodash_default.a.upperFirst(this.$t('waitingTime')), value: 'waiting', align: 'left' }, { text: lodash_default.a.upperFirst(this.$t('answersQuality')), value: 'quality', align: 'left' }, { text: lodash_default.a.upperFirst(this.$t('advisorWelcome')), value: 'welcome', align: 'left' }, { text: lodash_default.a.upperFirst(this.$tc('agents', 1, { count: '' })), value: 'agent', align: 'left' }, { text: lodash_default.a.upperFirst(this.$tc('sites', 1, { count: '' })), value: 'site', align: 'left' }, { text: lodash_default.a.upperFirst(this.$tc('chat')), value: 'chat', align: 'left' }],
      satisfactions: [],

      labels: [this.$t('nsp'), this.$tc('satisfactions', 0), this.$tc('satisfactions', 1), this.$tc('satisfactions', 2)],
      pagination: {
        sortBy: 'date',
        descending: true
      }
    };
  },
  created: function created() {
    this.optionsWaiting = lodash_default.a.merge(this.optionsWaiting, this.optionsPie);
    this.optionsQuality = lodash_default.a.merge(this.optionsQuality, this.optionsPie);
    this.optionsWelcome = lodash_default.a.merge(this.optionsWelcome, this.optionsPie);
    this.getSatisfaction();
  },


  methods: {
    getSatisfaction: function getSatisfaction() {
      var _this = this;

      this.loading = true;
      this.satisfactions = [];
      this.axios.get('get/satisfaction.php?' + this.params).then(function (res) {
        res.data = lodash_default.a.uniqBy(res.data, 'SAT_VIS_SESSION_ID');
        lodash_default.a.each(res.data, function (s) {
          var agent = s.SAT_USR_ID ? _this.$store.getters['_User/getUserById'](s.SAT_USR_ID) : null;
          var site = _this.$store.getters['_Sites/GET_SITE_BY_ID'](s.SAT_LIC_ID) || s.SAT_LIC_ID;

          _this.satisfactions.push({
            date: moment_default()(s.SAT_DATE).format('X'),
            id: s.SAT_VIS_SESSION_ID,
            waiting: Number(s.SAT_EVAL_Q2),
            quality: Number(s.SAT_EVAL_Q3),
            welcome: Number(s.SAT_EVAL_Q1),
            agent: agent,
            site: site.LIC_URL
          });
        });

        _this.evalWaiting = lodash_default.a.countBy(lodash_default.a.sortBy(lodash_default.a.map(_this.satisfactions, function (s) {
          return s.waiting;
        })));
        _this.evalWaiting = _this.fillEval(_this.evalWaiting);

        _this.optionsWaiting.series[0].data = lodash_default.a.map(_this.evalWaiting, function (v, k) {
          return {
            name: _this.labels[k] + ' ' + v + '/' + _this.satisfactions.length,
            y: lodash_default.a.round(v / _this.satisfactions.length, 2)
          };
        });
        _this.optionsWaiting.title.text = _this.$t('questionWaitingTime') + ' (' + _this.ratioWaiting + ' %)';

        _this.evalQuality = lodash_default.a.countBy(lodash_default.a.sortBy(lodash_default.a.map(_this.satisfactions, function (s) {
          return s.quality;
        })));
        _this.evalQuality = _this.fillEval(_this.evalQuality);

        _this.optionsQuality.series[0].data = lodash_default.a.map(_this.evalQuality, function (v, k) {
          return {
            name: _this.labels[k] + ' ' + v + '/' + _this.satisfactions.length,
            y: lodash_default.a.round(v / _this.satisfactions.length, 2)
          };
        });
        _this.optionsQuality.title.text = _this.$t('questionAnswersQuality') + ' (' + _this.ratioQuality + ' %)';

        _this.evalWelcome = lodash_default.a.countBy(lodash_default.a.sortBy(lodash_default.a.map(_this.satisfactions, function (s) {
          return s.welcome;
        })));
        _this.evalWelcome = _this.fillEval(_this.evalWelcome);

        _this.optionsWelcome.series[0].data = lodash_default.a.map(_this.evalWelcome, function (v, k) {
          return {
            name: _this.labels[k] + ' ' + v + '/' + _this.satisfactions.length,
            y: lodash_default.a.round(v / _this.satisfactions.length, 2)
          };
        });
        _this.optionsWelcome.title.text = _this.$t('questionAdvisorWelcome') + ' (' + _this.ratioWelcome + ' %)';
      }).catch(function (_) {}).then(function () {
        _this.loading = false;
      });
    },
    fillEval: function fillEval(evalToFill) {
      return {
        0: evalToFill[0] || 0,
        1: evalToFill[1] || 0,
        2: evalToFill[2] || 0,
        3: evalToFill[3] || 0
      };
    },
    download: function download() {
      var csv = null;
      var fields = this.headers.map(function (h) {
        return h.value;
      });
      var fieldNames = this.headers.map(function (h) {
        return h.text;
      });
      var data = this.satisfactions.map(function (s) {
        return {
          date: moment_default.a.unix(s.date).format(),
          id: s.id,
          waiting: s.waiting,
          quality: s.quality,
          welcome: s.welcome,
          agent: s.agent.USR_FIRST_NAME + ' ' + s.agent.USR_LAST_NAME,
          site: s.site
        };
      });
      try {
        csv = json2csv_default()({ data: data, fields: fields, del: ';', fieldNames: fieldNames });
      } catch (err) {
        return;
      }

      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:attachment/text,' + encodeURI(csv);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'satisfaction.csv';
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
    },
    openDialogChat: function openDialogChat(data) {
      console.log('dsata', data);
      this.dialogChat = true;
      this.chatDialog = {};
      this.chatDialog = lodash_default.a.clone(data);
    },
    cancelDialogChat: function cancelDialogChat() {
      this.dialogChat = false;
    }
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_Stats', ['params']), {
    ratioWaiting: function ratioWaiting() {
      var moySatisfait = lodash_default.a.toInteger(this.evalWaiting[2]);
      var satisfait = lodash_default.a.toInteger(this.evalWaiting[3]);
      return lodash_default.a.round((moySatisfait * 0.5 + satisfait) / this.nbWaiting * 100, 2);
    },
    nbWaiting: function nbWaiting() {
      return this.satisfactions.length - lodash_default.a.toInteger(this.evalWaiting[0]);
    },
    ratioQuality: function ratioQuality() {
      var moySatisfait = lodash_default.a.toInteger(this.evalQuality[2]);
      var satisfait = lodash_default.a.toInteger(this.evalQuality[3]);
      return lodash_default.a.round((moySatisfait * 0.5 + satisfait) / this.nbQuality * 100, 2);
    },
    nbQuality: function nbQuality() {
      return this.satisfactions.length - lodash_default.a.toInteger(this.evalQuality[0]);
    },
    ratioWelcome: function ratioWelcome() {
      var moySatisfait = lodash_default.a.toInteger(this.evalWelcome[2]);
      var satisfait = lodash_default.a.toInteger(this.evalWelcome[3]);
      return lodash_default.a.round((moySatisfait * 0.5 + satisfait) / this.nbWelcome * 100, 2);
    },
    nbWelcome: function nbWelcome() {
      return this.satisfactions.length - lodash_default.a.toInteger(this.evalWelcome[0]);
    }
  }),

  filters: {
    date: function date(v) {
      return moment_default.a.unix(v).format('llll');
    }
  },

  watch: {
    params: function params(v) {
      this.getSatisfaction();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b5941fc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/Satisfaction.vue
var Satisfaction_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"xs12 sm4"},[_c('v-card',{attrs:{"height":"300"}},[(_vm.satisfactions.length)?_c('highcharts',{attrs:{"options":_vm.optionsWaiting}}):_c('v-card-text',[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('data', 0) + ' ' + _vm.$t('concerning') + ' : ' + _vm.$t('waitingTime'))))])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 sm4"},[_c('v-card',{attrs:{"height":"300"}},[(_vm.satisfactions.length)?_c('highcharts',{attrs:{"options":_vm.optionsQuality}}):_c('v-card-text',[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('data', 0) + ' ' + _vm.$t('concerning') + ' : ' + _vm.$t('answersQuality'))))])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs12 sm4"},[_c('v-card',{attrs:{"height":"300"}},[(_vm.satisfactions.length)?_c('highcharts',{attrs:{"options":_vm.optionsWelcome}}):_c('v-card-text',[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('data', 0) + ' ' + _vm.$t('concerning') + ' : ' + _vm.$t('advisorWelcome'))))])],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"headline",attrs:{"xs6":"","sm10":""}},[_vm._v(_vm._s(_vm.$t('evaluationsDetails')))]),_vm._v(" "),_c('v-flex',{attrs:{"xs6":"","sm2":""}},[_c('v-btn',{attrs:{"color":"primary","dark":"","flat":""},on:{"click":function($event){_vm.download()}}},[_vm._v(_vm._s(_vm.$t('exportInCsv'))),_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("file_download")])],1)],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.satisfactions,"no-data-text":_vm.$tc('evaluations', 0),"no-results-text":_vm.$tc('results', 0),"rows-per-page-items":[10, 25, 50, { text: _vm.$tc('all', 2), value: -1 }],"rows-per-page-text":_vm.$t('evaluationsPerPage'),"pagination":_vm.pagination},on:{"update:pagination":function($event){_vm.pagination=$event}},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',[_vm._v(_vm._s(props.header.text))])]}},{key:"items",fn:function(props){return [_c('td',[_vm._v(_vm._s(_vm._f("date")(props.item.date)))]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"120px","word-break":"break-all"}},[_vm._v(_vm._s(props.item.id))]),_vm._v(" "),_c('td',[(props.item.waiting)?_c('wz-rating',{attrs:{"max":3,"rate":props.item.waiting}}):_c('span',[_vm._v(_vm._s(_vm.labels[0]))])],1),_vm._v(" "),_c('td',[(props.item.quality)?_c('wz-rating',{attrs:{"max":3,"rate":props.item.quality}}):_c('span',[_vm._v(_vm._s(_vm.labels[0]))])],1),_vm._v(" "),_c('td',[(props.item.welcome)?_c('wz-rating',{attrs:{"max":3,"rate":props.item.welcome}}):_c('span',[_vm._v(_vm._s(_vm.labels[0]))])],1),_vm._v(" "),_c('td',[(props.item.agent)?_c('div',{staticClass:"alignIconeName"},[_c('wz-avatar',{attrs:{"username":props.item.agent.USR_FIRST_NAME  + ' ' + props.item.agent.USR_LAST_NAME,"src":(_vm.domaine + "/media/user/small/" + (props.item.agent.USR_ID) + "_avatar.jpg"),"size":"35px"}}),_vm._v(" "),_c('div',[_c('div',{staticClass:"ml-2"},[_vm._v("\n                    "+_vm._s(props.item.agent.USR_FIRST_NAME + ' ' + props.item.agent.USR_LAST_NAME)+"\n                  ")]),_vm._v(" "),((props.item.agent.USR_ID == _vm.$store.state._User.id))?_c('div',{staticClass:"ml-2"},[_vm._v("\n                    ("+_vm._s(_vm.$t('me'))+")\n                  ")]):_vm._e()])],1):_c('div',[_c('wz-avatar',{attrs:{"src":(_vm.domaine + "/media/user/small/undefined_avatar.jpg"),"size":"35px"}})],1)]),_vm._v(" "),_c('td',{staticStyle:{"min-width":"150px","word-break":"break-all"}},[_vm._v(_vm._s(props.item.site))]),_vm._v(" "),_c('td',{staticClass:"text-xs-right px-0"},[_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.openDialogChat(props.item)}}},[_c('v-icon',[_vm._v("forum")])],1)],1)]}}])})],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","min-width":"640px","max-width":"800px","scrollable":!_vm.$vuetify.breakpoint.smAndDown,"fullscreen":_vm.$vuetify.breakpoint.smAndDown},model:{value:(_vm.dialogChat),callback:function ($$v) {_vm.dialogChat=$$v},expression:"dialogChat"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",staticStyle:{"height":"52px","padding":"0px"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.cancelDialogChat()}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1),_vm._v(" "),_c('span',{staticClass:"title"})],1),_vm._v(" "),_c('v-card-text',{staticClass:"pa-0",style:(!_vm.$vuetify.breakpoint.smAndDown ? 'height: calc(100vh - 210px);' : '')},[(_vm.chatDialog.id)?_c('wz-histo-chats',{attrs:{"params":'visId=' + _vm.chatDialog.id,"numChatsTotal":String(0),"chatHeight":"100%","type":"satisfaction","scroll":""}}):_vm._e()],1)],1)],1)],1)}
var Satisfaction_staticRenderFns = []
var Satisfaction_esExports = { render: Satisfaction_render, staticRenderFns: Satisfaction_staticRenderFns }
/* harmony default export */ var stats_Satisfaction = (Satisfaction_esExports);
// CONCATENATED MODULE: ./src/components/stats/Satisfaction.vue
function Satisfaction_injectStyle (ssrContext) {
  __webpack_require__("7bqf")
}
var Satisfaction_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Satisfaction___vue_template_functional__ = false
/* styles */
var Satisfaction___vue_styles__ = Satisfaction_injectStyle
/* scopeId */
var Satisfaction___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Satisfaction___vue_module_identifier__ = null
var Satisfaction_Component = Satisfaction_normalizeComponent(
  Satisfaction,
  stats_Satisfaction,
  Satisfaction___vue_template_functional__,
  Satisfaction___vue_styles__,
  Satisfaction___vue_scopeId__,
  Satisfaction___vue_module_identifier__
)

/* harmony default export */ var components_stats_Satisfaction = (Satisfaction_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/object/assign.js
var object_assign = __webpack_require__("woOf");
var assign_default = /*#__PURE__*/__webpack_require__.n(object_assign);

// EXTERNAL MODULE: ./node_modules/babel-runtime/regenerator/index.js
var regenerator = __webpack_require__("Xxa5");
var regenerator_default = /*#__PURE__*/__webpack_require__.n(regenerator);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/asyncToGenerator.js
var asyncToGenerator = __webpack_require__("exGp");
var asyncToGenerator_default = /*#__PURE__*/__webpack_require__.n(asyncToGenerator);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stats/reports/Reports.vue








/* harmony default export */ var Reports = ({
  data: function data() {
    return {
      dialog: false,
      loading: false,
      langs: [{ text: 'Français', value: 'fr' }, { text: 'Anglais', value: 'en' }]
    };
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_Reports', { reports: 'GET_REPORTS' }), {
    nbReportsWithoutTargetFirstEmail: function nbReportsWithoutTargetFirstEmail() {
      return this.reports.map(function (r) {
        return r.emails.filter(function (e) {
          return e.indexOf('@targetfirst.com') === -1;
        }).length;
      });
    }
  }),

  created: function created() {
    var _this = this;

    return asyncToGenerator_default()(regenerator_default.a.mark(function _callee() {
      return regenerator_default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this.loading = true;
              _context.next = 3;
              return _this.getReports();

            case 3:
              _this.loading = false;

            case 4:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }))();
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('_Reports', {
    getReports: 'GET_ALL',
    deleteReport: 'DELETE',
    addReport: 'ADD'
  }), Object(vuex_esm["b" /* mapActions */])('_Dialog', { setDialog: 'SET_DIALOG' }), {
    confirmDelete: function confirmDelete(event, report) {
      var _this2 = this;

      event.preventDefault();
      if (report.isFull) {
        this.setDialog({
          value: true,
          title: this.$t('delete') + ' ' + this.$t('report') + ' ?',
          text: 'Le rapport "' + report.title + '" ne peut \xEAtre supprim\xE9 car il s\'agit d\'un rapport complet. Veuillez contacter votre gestionnaire de projet Target First.',
          info: true
        });
      } else {
        this.setDialog({
          value: true,
          title: this.$t('delete') + ' ' + this.$t('report') + ' ?',
          text: 'Le rapport "' + report.title + '" sera supprim\xE9 d\xE9finitevement. Cette op\xE9ration est irreversible !',
          submit: 'delete',
          model: assign_default()({}, report),
          submitCb: function submitCb(model) {
            return _this2.deleteReport(model);
          }
        });
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-48185faa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/reports/Reports.vue
var Reports_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[(_vm.loading)?_c('v-flex',{staticClass:"text-xs-center mt-3"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):(_vm.reports.length)?_c('v-flex',{attrs:{"xs12":""}},[_c('v-list',{attrs:{"two-line":"","subheader":"","dense":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$tc('reports', _vm.reports.length, {count: _vm.reports.length})))]),_vm._v(" "),_vm._l((_vm.reports),function(report,i){return [_c('v-list-tile',{key:((report.title) + "_" + (report.id)),attrs:{"to":("reports/" + (report.id)),"avatar":""}},[_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{attrs:{"slot":"activator","color":!report.periods.length || !report.sites.length || !report.emails.length
                    ? 'error'
                    : 'success'},on:{"click":function (e) { return e.preventDefault(); }},slot:"activator"},[_vm._v("\n                  "+_vm._s(!report.periods.length || !report.sites.length || !report.emails.length
                    ? 'warning'
                    : 'check_circle')+"\n                ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(!report.periods.length || !report.sites.length || !report.emails.length ? _vm.$tc('invalids', 1, {count: ''}) : _vm.$tc('valids', 1, {count: ''})))])],1)],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(report.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n                "+_vm._s(_vm.$tc('sites', report.sites.length, {count: report.sites.length}))+"\n                -\n                "+_vm._s(_vm.$tc('emails', _vm.nbReportsWithoutTargetFirstEmail[i], {count: _vm.nbReportsWithoutTargetFirstEmail[i]}))+"\n                -\n                "+_vm._s(_vm.$tc('periods', report.periods.length, {count: report.periods.length}))+"\n              ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"icon":""},on:{"click":function (e) { return _vm.confirmDelete(e, report); }}},[_c('v-icon',[_vm._v("delete")])],1)],1)],1),_vm._v(" "),(i !== _vm.reports.length - 1 )?_c('v-divider',{key:i}):_vm._e()]})],2)],1):_c('v-flex',{attrs:{"xs12":"","sm6":"","offset-sm3":"","mt-3":""}},[_c('v-card',[_c('v-img',{attrs:{"src":"https://s3-eu-west-1.amazonaws.com/targetfirst/img/report.png","height":"200px"}}),_vm._v(" "),_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',[_c('h3',{staticClass:"headline mb-0"},[_vm._v(_vm._s(_vm.$t('noReportScheduled'))+" 📊")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t('noReportScheduledInfos')))])])]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"secondary"},on:{"click":function($event){_vm.$router.push({path: '/stats/reports/new'})}}},[_vm._v("\n            "+_vm._s(_vm.$t('create'))+" "+_vm._s(_vm.$t('report'))+"\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('v-fab-transition',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],attrs:{"color":"secondary","dark":"","fab":"","fixed":"","bottom":"","right":""},on:{"click":function($event){_vm.$router.push({path: '/stats/reports/new'})}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)}
var Reports_staticRenderFns = []
var Reports_esExports = { render: Reports_render, staticRenderFns: Reports_staticRenderFns }
/* harmony default export */ var reports_Reports = (Reports_esExports);
// CONCATENATED MODULE: ./src/components/stats/reports/Reports.vue
var Reports_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Reports___vue_template_functional__ = false
/* styles */
var Reports___vue_styles__ = null
/* scopeId */
var Reports___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Reports___vue_module_identifier__ = null
var Reports_Component = Reports_normalizeComponent(
  Reports,
  reports_Reports,
  Reports___vue_template_functional__,
  Reports___vue_styles__,
  Reports___vue_scopeId__,
  Reports___vue_module_identifier__
)

/* harmony default export */ var stats_reports_Reports = (Reports_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/core-js/number/parse-int.js
var parse_int = __webpack_require__("gBtx");
var parse_int_default = /*#__PURE__*/__webpack_require__.n(parse_int);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stats/reports/ReportDetails.vue











var NEW_PERIOD = {
  id: 0,
  period: 1,
  title: '',
  prevSend: { date: '' },
  nextSend: { date: new Date().toISOString().split('T')[0] }
};

/* harmony default export */ var ReportDetails = ({
  props: {
    id: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      report: {},
      hasChanged: false,

      dialogTitle: false,
      titleTmp: '',

      dialogLang: false,
      langs: [{ text: 'Français', value: 'fr' }, { text: 'English', value: 'en' }],
      langTmp: '',

      dialogEmail: false,
      dialogEmailIndex: -1,
      emailTmp: '',

      dialogPeriod: false,
      dialogPeriodIndex: -1,
      periodTmp: lodash_default.a.cloneDeep(NEW_PERIOD),
      validFormPeriod: true,

      dialogSite: false,
      dialogSiteIndex: -1
    };
  },

  created: function created() {
    this.report = lodash_default.a.cloneDeep(this.reportFromStore);
    this.$store.commit('_Toolbar/SET_SUB_TITLE', this.report.title);
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_Reports', {
    getReport: 'GET_REPORT',
    newReport: 'GET_NEW_REPORT'
  }), Object(vuex_esm["c" /* mapGetters */])('_User', { user: 'user' }), Object(vuex_esm["e" /* mapState */])('_Sites', { site: 'siteSelected' }), Object(vuex_esm["e" /* mapState */])('_User', ['entLevel']), {
    reportFromStore: function reportFromStore() {
      if (this.id === 'new') {
        var report = assign_default()({}, this.newReport);
        report.entreprise.id = this.user.entId;
        report.entreprise.name = this.user.entName;
        return report;
      }
      try {
        return this.getReport(parse_int_default()(this.id));
      } catch (e) {
        this.$router.push({ path: '/stats/reports' });
      }
    },
    emails: function emails() {
      return this.user.colleagues.map(function (u) {
        return u.USR_MAIL_CONTACT;
      });
    },
    periods: function periods() {
      var _this = this;

      if (this.entLevel === '7') {
        return PERIODS_ENTREPRISE.map(function (period) {
          return {
            text: _this.$options.filters.periodToString(period),
            value: period,
            disabled: _this.report.periods.findIndex(function (p) {
              return p.period === period;
            }) !== -1
          };
        });
      } else if (this.entLevel === '6') {
        return PERIODS_PRO.map(function (period) {
          return {
            text: _this.$options.filters.periodToString(period),
            value: period,
            disabled: _this.report.periods.findIndex(function (p) {
              return p.period === period;
            }) !== -1
          };
        });
      } else if (this.entLevel === '5' || this.entLevel === '10' || this.entLevel === '1') {
        return PERIODS_START.map(function (period) {
          return {
            text: _this.$options.filters.periodToString(period),
            value: period,
            disabled: _this.report.periods.findIndex(function (p) {
              return p.period === period;
            }) !== -1
          };
        });
      }
    },
    periodRules: function periodRules() {
      var _this2 = this;

      return [function (v) {
        return _this2.dialogPeriodIndex !== -1 || _this2.report.periods.findIndex(function (p) {
          return p.period === v;
        }) === -1 || _this2.$t('alreadyExists');
      }];
    },
    siteTmp: function siteTmp() {
      return {
        id: parse_int_default()(this.site.LIC_ID),
        url: this.site.LIC_URL
      };
    }
  }),

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('_Reports', { saveReport: 'SAVE' }), Object(vuex_esm["b" /* mapActions */])('_Dialog', { setDialog: 'SET_DIALOG' }), Object(vuex_esm["b" /* mapActions */])('_Notifier', { newNotif: 'NEW_NOTIF' }), {
    cancelForm: function cancelForm() {
      this.hasChanged = false;
      this.report = lodash_default.a.cloneDeep(this.reportFromStore);
    },
    saveForm: function saveForm() {
      var _this3 = this;

      return asyncToGenerator_default()(regenerator_default.a.mark(function _callee() {
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this3.saveReport(_this3.report);

              case 3:
                _context.next = 8;
                break;

              case 5:
                _context.prev = 5;
                _context.t0 = _context['catch'](0);

                _this3.newNotif({
                  message: _this3.id === 'new' ? _this3.$t('creationFailure') : _this3.$t('modifFailure'),
                  context: 'error'
                });

              case 8:
                _this3.hasChanged = false;
                if (_this3.id === 'new') {
                  _this3.$router.push({ path: '/stats/reports' });
                } else {
                  _this3.newNotif({
                    message: _this3.$t('modifSuccess'),
                    context: 'success'
                  });
                }

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this3, [[0, 5]]);
      }))();
    },
    openDialogTitle: function openDialogTitle() {
      this.dialogTitle = true;
      this.titleTmp = this.report.title;
    },
    cancelDialogTitle: function cancelDialogTitle() {
      this.dialogTitle = false;
      this.titleTmp = '';
    },
    submitDialogTitle: function submitDialogTitle() {
      this.dialogTitle = false;
      this.report.title = this.titleTmp;
      this.hasChanged = true;
    },
    openDialogLang: function openDialogLang() {
      this.dialogLang = true;
      this.langTmp = this.report.lang;
    },
    cancelDialogLang: function cancelDialogLang() {
      this.dialogLang = false;
      this.langTmp = '';
    },
    submitDialogLang: function submitDialogLang() {
      this.dialogLang = false;
      this.report.lang = this.langTmp;
      this.hasChanged = true;
    },
    openDialogEmail: function openDialogEmail(index, email) {
      this.dialogEmail = true;
      this.dialogEmailIndex = index;
      this.emailTmp = email;
    },
    cancelDialogEmail: function cancelDialogEmail() {
      this.dialogEmail = false;
      this.dialogEmailIndex = -1;
      this.emailTmp = '';
    },
    submitDialogEmail: function submitDialogEmail() {
      if (!this.emailTmp) {
        return;
      }
      this.dialogEmail = false;
      if (this.dialogEmailIndex === -1) {
        this.report.emails.push(this.emailTmp);
      } else {
        this.report.emails.splice(this.dialogEmailIndex, 1, this.emailTmp);
      }
      this.emailTmp = '';
      this.hasChanged = true;
    },
    confirmDeleteEmail: function confirmDeleteEmail(idx) {
      var _this4 = this;

      this.setDialog({
        value: true,
        title: '',
        text: this.$t('delete') + ' ' + this.$t('email') + ' ?',
        submit: 'delete',
        model: idx,
        submitCb: function submitCb(idx) {
          _this4.report.emails.splice(idx, 1);
          _this4.hasChanged = true;
        }
      });
    },
    openDialogPeriod: function openDialogPeriod(index, period) {
      this.dialogPeriod = true;
      this.dialogPeriodIndex = index;
      this.periodTmp = lodash_default.a.cloneDeep(period) || lodash_default.a.cloneDeep(NEW_PERIOD);
    },
    cancelDialogPeriod: function cancelDialogPeriod() {
      this.dialogPeriod = false;
      this.dialogPeriodIndex = -1;
      this.periodTmp = lodash_default.a.cloneDeep(NEW_PERIOD);
    },
    submitDialogPeriod: function submitDialogPeriod() {
      if (!this.$refs.formPeriod.validate()) {
        return;
      }
      this.dialogPeriod = false;
      if (this.dialogPeriodIndex === -1) {
        this.report.periods.push(this.periodTmp);
      } else {
        this.report.periods.splice(this.dialogPeriodIndex, 1, this.periodTmp);
      }
      this.periodTmp = lodash_default.a.cloneDeep(NEW_PERIOD);
      this.hasChanged = true;
    },
    confirmDeletePeriod: function confirmDeletePeriod(idx) {
      var _this5 = this;

      this.setDialog({
        value: true,
        title: '',
        text: this.$t('delete') + ' ' + this.$t('period') + ' ?',
        submit: 'delete',
        model: idx,
        submitCb: function submitCb(idx) {
          _this5.report.periods.splice(idx, 1);
          _this5.hasChanged = true;
        }
      });
    },
    openDialogSite: function openDialogSite(index, site) {
      this.dialogSite = true;
      this.dialogSiteIndex = index;
    },
    cancelDialogsite: function cancelDialogsite() {
      this.dialogSite = false;
      this.dialogSiteIndex = -1;
    },
    submitDialogsite: function submitDialogsite() {
      var _this6 = this;

      if (this.report.sites.find(function (s) {
        return s.id === _this6.siteTmp.id;
      })) {
        return;
      }
      this.dialogSite = false;
      if (this.dialogSiteIndex === -1) {
        this.report.sites.push(this.siteTmp);
      } else {
        this.report.sites.splice(this.dialogSiteIndex, 1, this.siteTmp);
      }
      this.hasChanged = true;
    },
    confirmDeleteSite: function confirmDeleteSite(idx) {
      var _this7 = this;

      this.setDialog({
        value: true,
        title: '',
        text: this.$t('delete') + ' ' + this.$tc('sites', 1, { count: '' }) + ' ?',
        submit: 'delete',
        model: idx,
        submitCb: function submitCb(idx) {
          _this7.report.sites.splice(idx, 1);
          _this7.hasChanged = true;
        }
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-109ebe14","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/reports/ReportDetails.vue
var ReportDetails_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.report)?_c('v-container',{attrs:{"fluid":"","grid-list-xl":_vm.$vuetify.breakpoint.mdAndUp,"grid-list-md":_vm.$vuetify.breakpoint.smAndDown}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.report.isFull)?_c('v-flex',{attrs:{"xs12":"","sm8":"","offset-sm2":"","md6":"","offset-md3":""}},[_c('v-alert',{attrs:{"value":true,"color":"info","icon":"info","outline":""}},[_vm._v("\n            Le rapport \""+_vm._s(_vm.report.title)+"\" ne peut être modifié car il s'agit d'un rapport complet. Veuillez contacter votre gestionnaire de projet Target First.\n          ")])],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","offset-sm2":"","md6":"","offset-md3":""}},[_c('v-card',[_c('v-list',{attrs:{"two-line":"","dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.report.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Titre du rappport (en gris sur la première page)")])],1),_vm._v(" "),_c('v-list-tile-action',[(!_vm.report.isFull)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.openDialogTitle()}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"350","persistent":""},model:{value:(_vm.dialogTitle),callback:function ($$v) {_vm.dialogTitle=$$v},expression:"dialogTitle"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.$t('edit')))+"\n                      "+_vm._s(_vm.$t('title'))+"\n                    ")]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"box":"","label":_vm._f("cap")(_vm.$t('title')),"autofocus":""},model:{value:(_vm.titleTmp),callback:function ($$v) {_vm.titleTmp=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"titleTmp"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.cancelDialogTitle()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.submitDialogTitle()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.report.entreprise.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Entreprise")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.report.lang))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Langue du rapport")])],1),_vm._v(" "),_c('v-list-tile-action',[(!_vm.report.isFull)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.openDialogLang()}}},[_c('v-icon',[_vm._v("edit")])],1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"350","persistent":""},model:{value:(_vm.dialogLang),callback:function ($$v) {_vm.dialogLang=$$v},expression:"dialogLang"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.$t('edit')))+"\n                      "+_vm._s(_vm.$t('language'))+"\n                    ")]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"items":_vm.langs,"box":"","label":_vm._f("cap")(_vm.$t('language')),"autofocus":""},model:{value:(_vm.langTmp),callback:function ($$v) {_vm.langTmp=$$v},expression:"langTmp"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.cancelDialogLang()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.submitDialogLang()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("dateTime")(_vm.report.createdAt.date)))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Date de création")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("dateTime")(_vm.report.updatedAt && _vm.report.updatedAt.date)))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Date de modification")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","offset-sm2":"","md6":"","offset-md3":""}},[_c('v-card',[_c('v-list',{attrs:{"dense":"","subheader":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('emails', 2, {count: ''}))))]),_vm._v(" "),_vm._l((_vm.report.emails),function(email,i){return _c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(email.indexOf('@targetfirst.com') === -1),expression:"email.indexOf('@targetfirst.com') === -1"}],key:i},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(email))])],1),_vm._v(" "),_c('v-list-tile-action',[(!_vm.report.isFull)?_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.openDialogEmail(i, email)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('edit'))))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.confirmDeleteEmail(i)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('delete'))))])],1)],1)],1):_vm._e()],1)],1)}),_vm._v(" "),(!_vm.report.isFull)?_c('v-list-tile',[_c('v-btn',{attrs:{"small":"","flat":"","color":"primary"},on:{"click":function($event){_vm.openDialogEmail(-1, '')}}},[_vm._v(_vm._s(_vm.$t('add'))+" "+_vm._s(_vm.$tc('emails', 1, {count: ''})))]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"350","persistent":""},model:{value:(_vm.dialogEmail),callback:function ($$v) {_vm.dialogEmail=$$v},expression:"dialogEmail"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.dialogEmailIndex !== -1 ? _vm.$t('edit') : _vm.$t('add')))+"\n                      "+_vm._s(_vm.$t('email'))+"\n                    ")]),_vm._v(" "),_c('v-card-text',[_c('v-combobox',{attrs:{"items":_vm.emails,"box":"","label":"Email","autofocus":""},model:{value:(_vm.emailTmp),callback:function ($$v) {_vm.emailTmp=(typeof $$v === 'string'? $$v.trim(): $$v)},expression:"emailTmp"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.cancelDialogEmail()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.submitDialogEmail()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1):_vm._e()],2)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","offset-sm2":"","md6":"","offset-md3":""}},[_c('v-card',[_c('v-list',{attrs:{"three-line":"","dense":"","subheader":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('periods', 2, {count: ''}))))]),_vm._v(" "),_vm._l((_vm.report.periods),function(period,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(period.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n                    "+_vm._s(_vm._f("periodToString")(period.period))+"\n                    "),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm._f("date")(period.nextSend.date)))])])],1),_vm._v(" "),_c('v-list-tile-action',[(!_vm.report.isFull)?_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.openDialogPeriod(i, period)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('edit'))))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.confirmDeletePeriod(i)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('delete'))))])],1)],1)],1):_vm._e()],1)],1)}),_vm._v(" "),(!_vm.report.isFull)?_c('v-list-tile',[_c('v-btn',{attrs:{"small":"","flat":"","color":"primary"},on:{"click":function($event){_vm.openDialogPeriod(-1)}}},[_vm._v(_vm._s(_vm.$t('add'))+" "+_vm._s(_vm.$tc('periods', 1, {count: ''})))]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"350","persistent":""},model:{value:(_vm.dialogPeriod),callback:function ($$v) {_vm.dialogPeriod=$$v},expression:"dialogPeriod"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.dialogPeriodIndex !== -1 ? _vm.$t('edit') : _vm.$t('add')))+"\n                      "+_vm._s(_vm.$tc('period', 1, {count:''}))+"\n                    ")]),_vm._v(" "),_c('v-card-text',[_c('v-form',{ref:"formPeriod",attrs:{"lazy-validation":""},model:{value:(_vm.validFormPeriod),callback:function ($$v) {_vm.validFormPeriod=$$v},expression:"validFormPeriod"}},[_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('title')),"box":"","required":"","rules":[function (v) { return !!v || _vm.$t('required'); }]},model:{value:(_vm.periodTmp.title),callback:function ($$v) {_vm.$set(_vm.periodTmp, "title", $$v)},expression:"periodTmp.title"}}),_vm._v(" "),_c('v-select',{attrs:{"label":_vm._f("cap")(_vm.$t('period')),"items":_vm.periods,"box":"","rules":_vm.periodRules},model:{value:(_vm.periodTmp.period),callback:function ($$v) {_vm.$set(_vm.periodTmp, "period", $$v)},expression:"periodTmp.period"}}),_vm._v(" "),_c('v-subheader',[_vm._v("\n                          "+_vm._s(_vm.$t('nextSend'))+"\n                        ")]),_vm._v(" "),_c('v-date-picker',{attrs:{"locale":_vm.$i18n.locale,"full-width":""},model:{value:(_vm.periodTmp.nextSend.date),callback:function ($$v) {_vm.$set(_vm.periodTmp.nextSend, "date", $$v)},expression:"periodTmp.nextSend.date"}})],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.cancelDialogPeriod()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.submitDialogPeriod()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1):_vm._e()],2)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm8":"","offset-sm2":"","md6":"","offset-md3":""}},[_c('v-card',[_c('v-list',{attrs:{"dense":"","subheader":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('sites', 2, {count: ''}))))]),_vm._v(" "),_vm._l((_vm.report.sites),function(site,i){return _c('v-list-tile',{key:i},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(site.url))])],1),_vm._v(" "),_c('v-list-tile-action',[(!_vm.report.isFull)?_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.openDialogSite(i)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('edit'))))])],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.confirmDeleteSite(i)}}},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('delete'))))])],1)],1)],1):_vm._e()],1)],1)}),_vm._v(" "),(!_vm.report.isFull)?_c('v-list-tile',[_c('v-btn',{attrs:{"small":"","flat":"","color":"primary"},on:{"click":function($event){_vm.openDialogSite(-1)}}},[_vm._v(_vm._s(_vm.$t('add'))+" "+_vm._s(_vm.$tc('sites', 1, {count: ''})))]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"350","persistent":""},model:{value:(_vm.dialogSite),callback:function ($$v) {_vm.dialogSite=$$v},expression:"dialogSite"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.dialogSiteIndex === -1 ? _vm.$t('add') : _vm.$t('edit')))+"\n                      "+_vm._s(_vm.$tc('sites', 1, {count: ''}))+"\n                    ")]),_vm._v(" "),_c('v-card-text',[_c('wz-select-one-site')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.cancelDialogsite()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.submitDialogsite()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1):_vm._e()],2)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.hasChanged && !_vm.report.isFull)?_c('v-footer',{attrs:{"app":"","height":"auto","fixed":"","inset":""}},[_c('v-layout',{attrs:{"justify-center":"","row":"","wrap":""}},[_c('v-btn',{attrs:{"flat":"","round":""},on:{"click":function($event){_vm.cancelForm()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("refresh")]),_vm._v("Annuler\n        ")],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":"","round":""},on:{"click":function($event){_vm.saveForm()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("check_circle")]),_vm._v("Valider\n        ")],1)],1)],1):_vm._e()],1)}
var ReportDetails_staticRenderFns = []
var ReportDetails_esExports = { render: ReportDetails_render, staticRenderFns: ReportDetails_staticRenderFns }
/* harmony default export */ var reports_ReportDetails = (ReportDetails_esExports);
// CONCATENATED MODULE: ./src/components/stats/reports/ReportDetails.vue
var ReportDetails_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ReportDetails___vue_template_functional__ = false
/* styles */
var ReportDetails___vue_styles__ = null
/* scopeId */
var ReportDetails___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ReportDetails___vue_module_identifier__ = null
var ReportDetails_Component = ReportDetails_normalizeComponent(
  ReportDetails,
  reports_ReportDetails,
  ReportDetails___vue_template_functional__,
  ReportDetails___vue_styles__,
  ReportDetails___vue_scopeId__,
  ReportDetails___vue_module_identifier__
)

/* harmony default export */ var stats_reports_ReportDetails = (ReportDetails_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stats/ViewCSV.vue


/* harmony default export */ var ViewCSV = ({
  data: function data() {
    return {
      loadingExportChats: false,
      csv: this.$route.params.csv
    };
  },
  created: function created() {},

  methods: {
    navigate: function navigate() {
      this.csv = '';
      this.$router.go(-1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ce98436","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/ViewCSV.vue
var ViewCSV_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-btn',{attrs:{"slot":"activator","color":"primary","icon":"","dark":"","small":""},on:{"click":function($event){_vm.navigate()}},slot:"activator"},[_c('v-icon',[_vm._v("navigate_before")])],1),_vm._v(" "),_c('div',{staticStyle:{"padding":"8px"}},[_vm._v(_vm._s(_vm.csv))])],1)}
var ViewCSV_staticRenderFns = []
var ViewCSV_esExports = { render: ViewCSV_render, staticRenderFns: ViewCSV_staticRenderFns }
/* harmony default export */ var stats_ViewCSV = (ViewCSV_esExports);
// CONCATENATED MODULE: ./src/components/stats/ViewCSV.vue
var ViewCSV_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ViewCSV___vue_template_functional__ = false
/* styles */
var ViewCSV___vue_styles__ = null
/* scopeId */
var ViewCSV___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ViewCSV___vue_module_identifier__ = null
var ViewCSV_Component = ViewCSV_normalizeComponent(
  ViewCSV,
  stats_ViewCSV,
  ViewCSV___vue_template_functional__,
  ViewCSV___vue_styles__,
  ViewCSV___vue_scopeId__,
  ViewCSV___vue_module_identifier__
)

/* harmony default export */ var components_stats_ViewCSV = (ViewCSV_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-257333fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Management.vue
var Management_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"management"},[_c('router-view')],1)}
var Management_staticRenderFns = []
var Management_esExports = { render: Management_render, staticRenderFns: Management_staticRenderFns }
/* harmony default export */ var Management = (Management_esExports);
// CONCATENATED MODULE: ./src/components/Management.vue
var Management_normalizeComponent = __webpack_require__("VU/8")
/* script */
var Management___vue_script__ = null
/* template */

/* template functional */
var Management___vue_template_functional__ = false
/* styles */
var Management___vue_styles__ = null
/* scopeId */
var Management___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Management___vue_module_identifier__ = null
var Management_Component = Management_normalizeComponent(
  Management___vue_script__,
  Management,
  Management___vue_template_functional__,
  Management___vue_styles__,
  Management___vue_scopeId__,
  Management___vue_module_identifier__
)

/* harmony default export */ var components_Management = (Management_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/management/Agents.vue







/* harmony default export */ var Agents = ({
  data: function data() {
    return {
      domaine: constants_DOMAINE,

      loading: false,

      showDialogCreate: false,
      newAgentDialog: { rights: 1 },
      name: 'Gestion des conseillers',

      agents: [],
      resAjx: null,
      rights: [{ text: 'Conseiller simple', value: 1 }, { text: 'Super Agent', value: 2 }, { text: 'Administrateur', value: 3 }],
      listAgent: [],
      loadingPost: false,
      dialogProgress: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.$store.state._User.entId === '5') {
      this.rights.push({ text: 'Admin Watcheezy', value: 999 });
    }
    this.loading = true;
    this.axios.get('get/agents.php').then(function (response) {
      _this.resAjx = response.data;
      _this.init();
    }).catch().then(function (_) {
      _this.loading = false;
    });
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
  },


  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_User', ['brides']), Object(vuex_esm["c" /* mapGetters */])('_User', ['level']), {
    agentsActivated: function agentsActivated() {
      var _this2 = this;

      return lodash_default.a.sumBy(this.agents, function (u) {
        return u.activity && !_this2.isAdmin(u.rights);
      });
    },
    hasOneSuper: function hasOneSuper() {
      return lodash_default.a.filter(this.agents, function (u) {
        return u.rights === 2;
      }).length > 0;
    }
  }),
  created: function created() {
    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'management_conseillers';
    } else {
      setTimeout(function () {
        if (typeof defautMotif !== 'undefined') {
          defautMotif = 'management_conseillers';
        }
      }, 800);
    }
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])('_User', ['addColleague']), {
    brideMenu: function brideMenu(nameBride) {
      if (this.brides) {
        var index = this.brides.findIndex(function (bride) {
          return bride.brideName === nameBride;
        });

        if (index !== -1) {
          return this.brides[index].status;
        }
      }
    },
    testBrideStatus: function testBrideStatus(name) {
      var brides = this.$store.state._User.brides;

      if (brides) {
        var resultat = brides.find(function (brides) {
          return brides.brideName === name;
        });
        if (resultat) {
          if (resultat.status === '0') {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    gotofilters: function gotofilters() {
      window.alert('Redirection vers la page des filtres');
    },
    init: function init() {
      for (var id in this.resAjx) {
        var parturlon = this.resAjx[id][0].USR_SITE_LIST;
        var parturloff = this.resAjx[id][0].USR_NONSITE_LIST;
        if (this.resAjx[id][0].USR_SITE_LIST.indexOf('|') !== -1) {
          var arrayOfStrings = this.resAjx[id][0].USR_SITE_LIST.split('|');
          parturlon = arrayOfStrings[0];
          parturloff = arrayOfStrings[1];
          if (!parturloff || parturloff === '') {
            parturloff = this.resAjx[id][0].USR_NONSITE_LIST;
          }
        }
        this.agents.push({ id: this.resAjx[id][0].USR_ID,
          name: lodash_default.a.trim(this.resAjx[id][0].USR_FIRST_NAME + ' ' + this.resAjx[id][0].USR_LAST_NAME),
          firstname: this.resAjx[id][0].USR_FIRST_NAME,
          lastname: this.resAjx[id][0].USR_LAST_NAME,
          job: this.resAjx[id][0].USR_JOB,
          activity: this.resAjx[id][0].USR_ACTIVITY,
          email: this.resAjx[id][0].USR_MAIL_CONTACT,
          chatmax: this.resAjx[id][0].USR_NB_CHAT_MAX,
          priority: this.resAjx[id][0].USR_PRIORITY,
          keywords: this.resAjx[id][0].USR_KEYWORDS,
          parturl: parturlon,
          partnourl: parturloff,
          rights: lodash_default.a.toInteger(this.resAjx[id][0].USR_RIGHTS),
          notifonoff: this.resAjx[id][0].USR_CHAT_NOTIF_ONOFF === '1',
          closechatonoff: this.resAjx[id][0].USR_CLOSECHAT_ONOFF === '1',
          closechataction: this.resAjx[id][0].USR_CLOSECHAT_ACTION,
          closechatdetails: this.resAjx[id][0].USR_CLOSECHAT_DETAILS,
          filterlist: this.resAjx[id][0].USR_FIL_LIST.length,
          canBeUnavailable: this.resAjx[id][0].USR_CAN_UNAVAILABLE === '1',
          timeTransfert: this.resAjx[id][0].USR_TIME_TRANSFERT,
          tempsTravail: this.resAjx[id][0].USR_TIME_DAY,
          jourHebdoTravail: this.resAjx[id][0].USR_DAY_HEBDO,
          isbot: this.resAjx[id][0].USR_IS_BOT !== '',
          botid: this.resAjx[id][0].USR_IS_BOT,
          notifBo: this.resAjx[id][0].USR_BO_NOTIF === '1'
        });
      }
    },
    submit: function submit() {
      var _this3 = this;

      if (!this.hasOneSuper) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure') + ' : ' + this.$t('atLeastOneSuper'), context: 'error' });
        return;
      }

      if (this.agentsActivated < 1) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('modifFailure') + ' : ' + this.$t('atLeastOneActivated'), context: 'error' });
        return;
      }

      var dataToPost = new window.FormData();

      dataToPost.append('agents', stringify_default()(this.agents));
      dataToPost.append('ENT_ID', this.$store.state._User.entId);

      var steps = JSON.parse(this.$store.state._User.remainingSteps);

      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_MANAGEMENT_CONSEILLERS')) {
        steps.splice(steps.indexOf('INS_MANAGEMENT_CONSEILLERS'), 1);

        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: stringify_default()(steps)
        });
      }


      this.axios.post('post/agents.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this3.$t('modifSuccess'), context: 'success' });
      }).catch(function (error) {
        var message = error.response.data;
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this3.$t('modifFailure') + ' ' + _this3.$t(message), context: 'error' });
      }).then(function (_) {});
    },
    openDialogCreate: function openDialogCreate() {
      this.showDialogCreate = true;
    },
    submitDialogCreate: function submitDialogCreate() {
      var _this4 = this;

      if (lodash_default.a.isEmpty(this.newAgentDialog.email) || this.newAgentDialog.email.indexOf('@') === -1) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('creationFailure'), context: 'error' });
        return;
      }

      this.loadingPost = true;
      var dataToPost = new window.FormData();
      dataToPost.append('newagent', stringify_default()(this.newAgentDialog));
      dataToPost.append('licenceLevel', this.level.rights);

      this.axios.post('post/newagent.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        var colleague = {
          USR_FIRST_NAME: _this4.newAgentDialog.fname,
          USR_ID: response.data.id,
          USR_LAST_NAME: _this4.newAgentDialog.lname,
          USR_MAIL: _this4.newAgentDialog.email,
          USR_MAIL_CONTACT: _this4.newAgentDialog.email
        };
        _this4.addColleague(colleague);
        _this4.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this4.$t('creationSuccess'), context: 'success' });
      }).catch(function (error) {
        var message = error.response ? error.response.data : '';
        _this4.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this4.$t('creationFailure') + ' ' + _this4.$t(message), context: 'error' });
      }).then(function (_) {
        _this4.showDialogCreate = false;
        _this4.loadingPost = false;
        _this4.axios.get('get/agents.php').then(function (response) {
          _this4.resAjx = response.data;
          _this4.agents = [];
          _this4.init();
        }).catch().then(function (_) {});
      });
    },
    isAdmin: function isAdmin(rights) {
      return rights === 3;
    },
    isItMe: function isItMe(id) {
      return this.$store.state._User.id === id;
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6168456b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/management/Agents.vue
var Agents_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newVue"},[(_vm.loading)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('div',[_c('v-subheader',[_vm._v(_vm._s(_vm.$tc('agents', _vm.agents.length, { count: _vm.agents.length })))]),_vm._v(" "),_c('v-expansion-panel',_vm._l((_vm.agents),function(agent,i){return _c('v-expansion-panel-content',{key:i},[_c('div',{staticClass:"listeAgentsManagement",attrs:{"slot":"header"},slot:"header"},[_c('wz-avatar',{attrs:{"username":agent.name,"src":(_vm.domaine + "/media/user/small/" + (agent.id) + "_avatar.jpg"),"size":"35px"}}),_vm._v("\n            "+_vm._s(agent.name)+"\n            "+_vm._s(_vm.isItMe(agent.id) ? '(' + _vm.$t('me') + ')' : '')+"\n          ")],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[(!_vm.isAdmin(agent.rights))?_c('v-switch',{attrs:{"label":_vm.$tc('agents', 1, {count: ''}) + ' ' + _vm.$t('enabled') + '?',"color":"primary","disabled":_vm.isItMe(agent.id)},model:{value:(agent.activity),callback:function ($$v) {_vm.$set(agent, "activity", $$v)},expression:"agent.activity"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-select',{attrs:{"items":_vm.rights,"label":_vm._f("cap")(_vm.$tc('rights', 2, { count: '' })),"menu-props":"auto","disabled":_vm.isItMe(agent.id) && _vm.isAdmin(agent.rights) && !_vm.$store.state._User.entId != '5'},model:{value:(agent.rights),callback:function ($$v) {_vm.$set(agent, "rights", $$v)},expression:"agent.rights"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[(!_vm.isAdmin(agent.rights))?_c('v-switch',{attrs:{"label":"Est un chatBot ?","color":"primary"},model:{value:(agent.isbot),callback:function ($$v) {_vm.$set(agent, "isbot", $$v)},expression:"agent.isbot"}}):_vm._e()],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(agent.isbot),expression:"agent.isbot"}],attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":"Référence du bot"},model:{value:(agent.botid),callback:function ($$v) {_vm.$set(agent, "botid", $$v)},expression:"agent.botid"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('firstName'))},model:{value:(agent.firstname),callback:function ($$v) {_vm.$set(agent, "firstname", $$v)},expression:"agent.firstname"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":""}},[_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('lastName'))},model:{value:(agent.lastname),callback:function ($$v) {_vm.$set(agent, "lastname", $$v)},expression:"agent.lastname"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('job'))},model:{value:(agent.job),callback:function ($$v) {_vm.$set(agent, "job", $$v)},expression:"agent.job"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"disabled":"","label":_vm._f("cap")(_vm.$t('contactEmail'))},model:{value:(agent.email),callback:function ($$v) {_vm.$set(agent, "email", $$v)},expression:"agent.email"}})],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!agent.isbot),expression:"!agent.isbot"}]},[(!_vm.isAdmin(agent.rights))?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('chatMax')))+" : "+_vm._s(agent.chatmax))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-slider',{attrs:{"disabled":_vm.testBrideStatus('compte_conseillers_chat_max'),"min":"1","max":"4","ticks":"","thumb-label":"","hide-details":""},model:{value:(agent.chatmax),callback:function ($$v) {_vm.$set(agent, "chatmax", $$v)},expression:"agent.chatmax"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.brideMenu('compte_conseillers_transfert') === '1')?_c('span',[(!_vm.isAdmin(agent.rights))?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('txtDelaiTransfert')))+" : "+_vm._s(_vm.$tc('minutes', agent.timeTransfert, { count: agent.timeTransfert}))+"\n                    "),_c('br'),_vm._v("\n                    "+_vm._s(_vm._f("cap")(_vm.$t('descriptionDelaiTransfert')))+"\n                    ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-slider',{attrs:{"min":"0","max":"60","step":"1","ticks":"","tick-size":"2","thumb-label":"","hide-details":""},model:{value:(agent.timeTransfert),callback:function ($$v) {_vm.$set(agent, "timeTransfert", $$v)},expression:"agent.timeTransfert"}})],1)],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('span',[(!_vm.isAdmin(agent.rights))?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',[_vm._v("Temps de travail par jour : "+_vm._s(_vm.$tc('hours', agent.tempsTravail, { count: agent.tempsTravail }))+"\n                    "),_c('br'),_vm._v("\n                    "+_vm._s(_vm._f("cap")(_vm.$t('descriptionDelaiTempsTravail')))+"\n                    ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-slider',{attrs:{"min":"2","max":"16","step":"0.5","ticks":"","tick-size":"2","thumb-label":"","hide-details":""},model:{value:(agent.tempsTravail),callback:function ($$v) {_vm.$set(agent, "tempsTravail", $$v)},expression:"agent.tempsTravail"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('span',[(!_vm.isAdmin(agent.rights))?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',[_vm._v("Jours ouvrés par semaine : "+_vm._s(_vm.$tc('days', agent.jourHebdoTravail, { count: agent.jourHebdoTravail }))+"\n                    "),_c('br'),_vm._v("\n                    "+_vm._s(_vm._f("cap")(_vm.$t('descriptionDelaiTempsTravail')))+"\n                    ")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-slider',{attrs:{"min":"1","max":"7","step":"1","ticks":"","tick-size":"2","thumb-label":"","hide-details":""},model:{value:(agent.jourHebdoTravail),callback:function ($$v) {_vm.$set(agent, "jourHebdoTravail", $$v)},expression:"agent.jourHebdoTravail"}})],1)],1):_vm._e()],1),_vm._v(" "),(!_vm.isAdmin(agent.rights))?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('priority') + ' (0 = normal, 10 = fort)'))+" : "+_vm._s(agent.priority))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-slider',{attrs:{"disabled":_vm.testBrideStatus('compte_conseillers_prioritaire'),"min":"0","max":"10","ticks":"","thumb-label":"","hide-details":""},model:{value:(agent.priority),callback:function ($$v) {_vm.$set(agent, "priority", $$v)},expression:"agent.priority"}})],1)],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"disabled":_vm.testBrideStatus('compte_conseillers_api'),"label":_vm._f("cap")('Tag / ' + _vm.$t('keywords'))},model:{value:(agent.keywords),callback:function ($$v) {_vm.$set(agent, "keywords", $$v)},expression:"agent.keywords"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"disabled":_vm.testBrideStatus('compte_conseillers_black_list'),"label":_vm._f("cap")('White List')},model:{value:(agent.parturl),callback:function ($$v) {_vm.$set(agent, "parturl", $$v)},expression:"agent.parturl"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"disabled":_vm.testBrideStatus('compte_conseillers_black_list'),"label":_vm._f("cap")('Black List')},model:{value:(agent.partnourl),callback:function ($$v) {_vm.$set(agent, "partnourl", $$v)},expression:"agent.partnourl"}})],1)],1),_vm._v(" "),(!_vm.isAdmin(agent.rights))?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"disabled":_vm.testBrideStatus('compte_conseillers_indispo'),"label":_vm._f("cap")(_vm.$t('canBeUnavailable')),"color":"primary","hide-details":""},model:{value:(agent.canBeUnavailable),callback:function ($$v) {_vm.$set(agent, "canBeUnavailable", $$v)},expression:"agent.canBeUnavailable"}})],1)],1):_vm._e(),_vm._v(" "),(!_vm.isAdmin(agent.rights))?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"disabled":_vm.testBrideStatus('compte_conseillers_notifbo'),"label":_vm._f("cap")(_vm.$t('notification')),"color":"primary","hide-details":""},model:{value:(agent.notifBo),callback:function ($$v) {_vm.$set(agent, "notifBo", $$v)},expression:"agent.notifBo"}})],1)],1):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","right":""},on:{"click":function($event){_vm.submit()}}},[_vm._v("\n                    "+_vm._s(_vm._f("cap")(_vm.$t('save')))+"\n                    "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("send")])],1)],1)],1)],1)],1)],1)}),1),_vm._v(" "),_c('v-fab-transition',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"white--text",attrs:{"slot":"activator","fab":"","bottom":"","floating":"","fixed":"","raised":"","right":"","dark":"","color":"secondary"},on:{"click":function($event){$event.stopPropagation();return _vm.openDialogCreate($event)}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.showDialogCreate),callback:function ($$v) {_vm.showDialogCreate=$$v},expression:"showDialogCreate"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("person_add")]),_vm._v(" "),_c('span',{staticClass:"title pl-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('add')))+" "+_vm._s(_vm.$tc('agents', 1, { count: '' })))])],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:20'),expression:"'required|max:20'"}],attrs:{"autofocus":"","label":_vm._f("cap")(_vm.$t('firstName')),"counter":"","required":"","max":"20"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogCreate($event)}},model:{value:(_vm.newAgentDialog.fname),callback:function ($$v) {_vm.$set(_vm.newAgentDialog, "fname", $$v)},expression:"newAgentDialog.fname"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('max:20'),expression:"'max:20'"}],attrs:{"autofocus":"","label":_vm._f("cap")(_vm.$t('lastName')),"counter":"","max":"20"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogCreate($event)}},model:{value:(_vm.newAgentDialog.lname),callback:function ($$v) {_vm.$set(_vm.newAgentDialog, "lname", $$v)},expression:"newAgentDialog.lname"}}),_vm._v(" "),_c('v-text-field',{attrs:{"autofocus":"","label":_vm._f("cap")(_vm.$t('loginEmail')),"counter":"","required":"","max":"30","type":"email"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogCreate($event)}},model:{value:(_vm.newAgentDialog.email),callback:function ($$v) {_vm.$set(_vm.newAgentDialog, "email", $$v)},expression:"newAgentDialog.email"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:20'),expression:"'required|max:20'"}],attrs:{"autofocus":"","label":_vm._f("cap")(_vm.$t('password')),"counter":"","required":"","max":"20","type":"password"},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogCreate($event)}},model:{value:(_vm.newAgentDialog.pwd),callback:function ($$v) {_vm.$set(_vm.newAgentDialog, "pwd", $$v)},expression:"newAgentDialog.pwd"}}),_vm._v(" "),_c('v-select',{attrs:{"label":_vm._f("cap")(_vm.$tc('rights', 2, { count: '' })),"items":_vm.rights},model:{value:(_vm.newAgentDialog.rights),callback:function ($$v) {_vm.$set(_vm.newAgentDialog, "rights", $$v)},expression:"newAgentDialog.rights"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.loadingPost,"flat":""},on:{"click":function($event){_vm.showDialogCreate = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.loadingPost,"color":"primary","flat":""},on:{"click":_vm.submitDialogCreate}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":11},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)}
var Agents_staticRenderFns = []
var Agents_esExports = { render: Agents_render, staticRenderFns: Agents_staticRenderFns }
/* harmony default export */ var management_Agents = (Agents_esExports);
// CONCATENATED MODULE: ./src/components/management/Agents.vue
function Agents_injectStyle (ssrContext) {
  __webpack_require__("rcR9")
}
var Agents_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Agents___vue_template_functional__ = false
/* styles */
var Agents___vue_styles__ = Agents_injectStyle
/* scopeId */
var Agents___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Agents___vue_module_identifier__ = null
var Agents_Component = Agents_normalizeComponent(
  Agents,
  management_Agents,
  Agents___vue_template_functional__,
  Agents___vue_styles__,
  Agents___vue_scopeId__,
  Agents___vue_module_identifier__
)

/* harmony default export */ var components_management_Agents = (Agents_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/management/Sites.vue







/* harmony default export */ var Sites = ({
  data: function data() {
    return {
      loading: false,

      showDialogCreate: false,

      newSiteDialog: { activated: '1', allAgents: '0' },
      name: 'Gestion des sites',

      sites: [],
      resAjx: null,
      resAjxMap: null,
      language: [{ text: 'French', value: 'FR' }, { text: 'English', value: 'EN' }, { text: 'Espanol', value: 'ES' }, { text: 'Italian', value: 'IT' }, { text: 'German', value: 'DE' }, { text: 'Portugese', value: 'PT' }],
      yesno: [{ text: 'Oui', value: '1' }, { text: 'Non', value: '0' }]
    };
  },
  created: function created() {
    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'management_sites';
    } else {
      setTimeout(function () {
        if (typeof defautMotif !== 'undefined') {
          defautMotif = 'management_sites';
        }
      }, 800);
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    this.axios.get('get/sites.php').then(function (response) {
      _this.resAjx = response.data;
      _this.axios.get('get/mapping.php').then(function (response) {
        _this.resAjxMap = response.data;
        _this.init();
      }).catch().then(function (_) {
        _this.loading = false;
      });
    });
  },


  computed: {
    canAdd: function canAdd() {
      var rights = this.$store.getters['_User/level'].rights;
      return rights !== LEVEL.CHAT && this.sites.length < this.$store.state._User.entNbSite;
    },
    canTurnOff: function canTurnOff() {
      return lodash_default.a.filter(this.sites, function (s) {
        return s.isValid;
      }).length > 1;
    }
  },

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('_Sites', ['GET']), {
    create: function create() {},
    init: function init() {
      for (var id in this.resAjx) {
        var _agentList = [];
        for (var idMap in this.resAjxMap) {
          var usrListFromSql = this.resAjxMap[idMap][0].LIC_USR_LIST;
          for (var j in usrListFromSql) {
            if (id === idMap) {
              _agentList.push({
                text: usrListFromSql[j][1] + ' ' + usrListFromSql[j][2],
                value: usrListFromSql[j][0],
                avatar: constants_DOMAINE + '/media/user/small/' + usrListFromSql[j][0] + '_avatar.jpg'
              });
            }
          }
        }
        var nameSite = this.resAjx[id][0].LIC_COMMENT;
        if (!this.resAjx[id][0].LIC_COMMENT || this.resAjx[id][0].LIC_COMMENT === '') {
          nameSite = this.resAjx[id][0].LIC_URL;
        }
        this.sites.push({
          id: this.resAjx[id][0].LIC_ID,
          url: this.resAjx[id][0].LIC_URL,
          isValidBool: !!+this.resAjx[id][0].LIC_IS_VALID,
          isValid: lodash_default.a.toInteger(this.resAjx[id][0].LIC_IS_VALID) === 1,
          name: nameSite,
          eezyLead: this.resAjx[id][0].LIC_EEZY_LEAD,
          phone: this.resAjx[id][0].LIC_CALLBACK_PHONE,
          contact: this.resAjx[id][0].LIC_CONTACTS,
          copii: this.resAjx[id][0].LIC_CONTACT_COPY,
          lang: this.resAjx[id][0].LIC_DEFAULT_LANG,
          callback: this.resAjx[id][0].LIC_CALLBACK_ACTIVATED,
          recall: this.resAjx[id][0].LIC_RECALL_ACTIVATED,
          cobrowsing: this.resAjx[id][0].LIC_COBROWSING_ACTIVATED,
          superIstyping: this.resAjx[id][0].LIC_SUPERISTYPING_ACTIVATED,
          funnel: this.resAjx[id][0].LIC_IS_FUNNEL,
          skey: this.resAjx[id][0].LIC_KEY,
          deskId: this.resAjx[id][0].LIC_DSK_ID,
          agentMapped: _agentList
        });
      }
    },
    submit: function submit() {
      var _this2 = this;

      var dataToPost = new window.FormData();
      dataToPost.append('sites', stringify_default()(this.sites));
      dataToPost.append('ENT_ID', this.$store.state._User.entId);

      var steps = JSON.parse(this.$store.state._User.remainingSteps);

      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_MANAGEMENT_SITES')) {
        steps.splice(steps.indexOf('INS_MANAGEMENT_SITES'), 1);

        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: stringify_default()(steps)
        });
      }


      this.axios.post('post/sites.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this2.updateSites('U');
      }).catch(function (_) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this2.$t('modifFailure'),
          context: 'error'
        });
      }).then(function (_) {});
    },
    openDialogCreate: function openDialogCreate() {
      this.showDialogCreate = true;
    },
    submitDialogCreate: function submitDialogCreate() {
      var _this3 = this;

      if (lodash_default.a.isEmpty(this.newSiteDialog.url)) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Impossible de le créer, url vide',
          context: 'warning'
        });
        return;
      }
      this.showDialogCreate = false;

      var dataToPost = new window.FormData();
      dataToPost.append('newsite', stringify_default()(this.newSiteDialog));
      this.axios.post('post/newsite.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this3.updateSites('C');
      }).catch(function (_) {
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this3.$t('creationFailure'),
          context: 'error'
        });
      }).then(function (_) {
        _this3.axios.get('get/sites.php').then(function (response) {
          _this3.resAjx = response.data;
          _this3.sites = [];
          _this3.init();
        }).catch().then(function (_) {});
      });
    },
    updateSites: function updateSites(mode) {
      var _this4 = this;

      var message = mode === 'C' ? { success: 'creationSuccess', error: 'creationFailure' } : { success: 'modifSuccess', error: 'modifFailure' };
      this.GET().then(function () {
        _this4.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this4.$t(message.success),
          context: 'success'
        });
      }).catch(function (_) {
        _this4.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this4.$t(message.error),
          context: 'error'
        });
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13d5d12e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/management/Sites.vue
var Sites_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newVue"},[(_vm.loading)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('div',[_c('v-subheader',[_vm._v(_vm._s(_vm.$tc('sites', _vm.sites.length, { count: _vm.sites.length }) + ' (' + _vm.$store.state._User.entNbSite + ' max)'))]),_vm._v(" "),_c('v-expansion-panel',_vm._l((_vm.sites),function(site,i){return _c('v-expansion-panel-content',{key:i},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(site.name)+" "),_c('code',[_vm._v(_vm._s(site.url))])]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")('Target First ' + _vm.$t('enabled') + '?'),"color":"primary","disabled":!_vm.canTurnOff && site.isValid},model:{value:(site.isValid),callback:function ($$v) {_vm.$set(site, "isValid", $$v)},expression:"site.isValid"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('name'))},model:{value:(site.name),callback:function ($$v) {_vm.$set(site, "name", $$v)},expression:"site.name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-text-field',{attrs:{"label":"URL"},model:{value:(site.url),callback:function ($$v) {_vm.$set(site, "url", $$v)},expression:"site.url"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('contactEmail'))},model:{value:(site.contact),callback:function ($$v) {_vm.$set(site, "contact", $$v)},expression:"site.contact"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('copyEmail') + ' ' + _vm.$t('separatedSemiColon'))},model:{value:(site.copii),callback:function ($$v) {_vm.$set(site, "copii", $$v)},expression:"site.copii"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-text-field',{attrs:{"disabled":"","label":_vm._f("cap")(_vm.$t('phone') + ' (' + _vm.$t('callback') + ')')},model:{value:(site.phone),callback:function ($$v) {_vm.$set(site, "phone", $$v)},expression:"site.phone"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-select',{attrs:{"items":_vm.language,"label":_vm._f("cap")(_vm.$t('language')),"menu-props":"auto"},model:{value:(site.lang),callback:function ($$v) {_vm.$set(site, "lang", $$v)},expression:"site.lang"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('agents', site.agentMapped.length, { count: site.agentMapped.length }))))])],1),_vm._v(" "),[_c('v-container',{staticClass:"pa-0",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((site.agentMapped),function(agent,j){return _c('v-flex',{key:j,attrs:{"md12":"","sm12":""}},[_c('div',{staticClass:"text-xs-left ma-2"},[_c('v-chip',{staticClass:"indigo white--text"},[_c('v-avatar',[_c('img',{attrs:{"src":agent.avatar,"alt":""}})]),_vm._v("\n                            "+_vm._s(agent.text)+"\n                          ")],1)],1)])}),1)],1)]],2)],1)],1)],1)}),1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[(_vm.canAdd)?_c('v-fab-transition',[_c('v-btn',{staticClass:"secondary",attrs:{"dark":"","fab":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.openDialogCreate($event)}}},[_c('v-icon',[_vm._v("add")])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"320"},model:{value:(_vm.showDialogCreate),callback:function ($$v) {_vm.showDialogCreate=$$v},expression:"showDialogCreate"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("language")]),_vm._v(" "),_c('span',{staticClass:"title pl-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('add')))+" "+_vm._s(_vm.$tc('sites', 1, {count: 1})))])],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('max:32'),expression:"'max:32'"}],attrs:{"autofocus":"","label":_vm._f("cap")(_vm.$t('name')),"counter":"","max":"32","data-vv-name":"newSiteName"},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogCreate($event)}},model:{value:(_vm.newSiteDialog.name),callback:function ($$v) {_vm.$set(_vm.newSiteDialog, "name", $$v)},expression:"newSiteDialog.name"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:255'),expression:"'required|max:255'"}],attrs:{"autofocus":"","label":"URL","counter":"","max":"255","required":"","data-vv-name":"newSiteUrl"},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogCreate($event)}},model:{value:(_vm.newSiteDialog.url),callback:function ($$v) {_vm.$set(_vm.newSiteDialog, "url", $$v)},expression:"newSiteDialog.url"}}),_vm._v(" "),_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('enabled') + '?'),"color":"primary"},model:{value:(_vm.newSiteDialog.activated),callback:function ($$v) {_vm.$set(_vm.newSiteDialog, "activated", $$v)},expression:"newSiteDialog.activated"}}),_vm._v(" "),_c('v-switch',{attrs:{"label":_vm.$t('associateAllAgents'),"color":"primary"},model:{value:(_vm.newSiteDialog.allAgents),callback:function ($$v) {_vm.$set(_vm.newSiteDialog, "allAgents", $$v)},expression:"newSiteDialog.allAgents"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.showDialogCreate = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){return _vm.submitDialogCreate($event)}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","fixed":"","bottom":"","right":""},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("\n            "+_vm._s(_vm._f("cap")(_vm.$t('save')))),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("send")])],1)],1)],1)])}
var Sites_staticRenderFns = []
var Sites_esExports = { render: Sites_render, staticRenderFns: Sites_staticRenderFns }
/* harmony default export */ var management_Sites = (Sites_esExports);
// CONCATENATED MODULE: ./src/components/management/Sites.vue
var Sites_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Sites___vue_template_functional__ = false
/* styles */
var Sites___vue_styles__ = null
/* scopeId */
var Sites___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Sites___vue_module_identifier__ = null
var Sites_Component = Sites_normalizeComponent(
  Sites,
  management_Sites,
  Sites___vue_template_functional__,
  Sites___vue_styles__,
  Sites___vue_scopeId__,
  Sites___vue_module_identifier__
)

/* harmony default export */ var components_management_Sites = (Sites_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/management/Mapping.vue






/* harmony default export */ var Mapping = ({
  data: function data() {
    return {
      loadingGet: false,
      loadingPost: false,

      mapping: []
    };
  },
  created: function created() {
    var _this = this;

    this.loadingGet = true;
    this.axios.get('get/mapping.php').then(function (response) {
      lodash_default.a.each(response.data, function (site) {
        var agents = [];

        lodash_default.a.each(site[0].LIC_USR_LIST, function (agent) {
          var a = {
            USR_ID: agent[0],
            USR_FIRST_NAME: agent[1],
            USR_LAST_NAME: agent[2]
          };
          agents.push(a);
        });
        site[0].LIC_USR_LIST = agents;
        _this.mapping.push(site[0]);
      });
    }).catch().then(function (_) {
      _this.loadingGet = false;
    });
  },

  methods: {
    submit: function submit() {
      var _this2 = this;

      if (this.atLeastOneSitePerAgent.length) {
        var agents = this.atLeastOneSitePerAgent.map(function (agent) {
          return agent.USR_FIRST_NAME + ' ' + agent.USR_LAST_NAME;
        });
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('atLeastOneSitePerAgent') + ': ' + agents,
          context: 'error'
        });
        return;
      }
      this.loadingPost = true;

      var sites = [];
      lodash_default.a.each(this.mapping, function (site) {
        sites.push({
          url: site.LIC_URL,
          id: site.LIC_ID,
          name: site.LIC_COMMENT,
          agentList: site.LIC_USR_LIST
        });
      });
      var dataToPost = new window.FormData();
      dataToPost.append('map', stringify_default()(sites));
      this.axios.post('post/mapping.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('modifSuccess'), context: 'success' });
      }).catch(function (_) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('modifFailure'), context: 'error' });
      }).then(function () {
        _this2.loadingPost = false;
      });
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_User', ['user']), Object(vuex_esm["e" /* mapState */])('_User', ['colleagues']), Object(vuex_esm["c" /* mapGetters */])('_Sites', ['GET_SITE_BY_ID']), {
    atLeastOneSitePerAgent: function atLeastOneSitePerAgent() {
      var map = this.mapping.map(function (map) {
        return map.LIC_USR_LIST;
      });
      map = lodash_default.a.flatten(map);
      var agentHaveOnSite = this.colleagues.filter(function (colleague) {
        return !map.find(function (m) {
          return m.USR_ID === colleague.USR_ID;
        });
      });
      return agentHaveOnSite;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09aa83a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/management/Mapping.vue
var Mapping_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"newVue"},[(_vm.loadingGet)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('div',[_c('v-expansion-panel',_vm._l((_vm.mapping),function(site,i){return (_vm.GET_SITE_BY_ID(site.LIC_ID))?_c('v-expansion-panel-content',{key:i},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(site.LIC_COMMENT)+" "),_c('code',[_vm._v(_vm._s(site.LIC_URL))])]),_vm._v(" "),_c('v-card',[[_c('v-card',{staticClass:"grey lighten-4 elevation-0"},[_c('v-card-text',[_c('v-container',{attrs:{"fluid":""}},[_c('wz-select-agents',{attrs:{"withoutMe":"","agents":_vm.mapping[i].LIC_USR_LIST,"agentsInit":_vm.mapping[i].LIC_USR_LIST},on:{"update:agents":function($event){_vm.$set(_vm.mapping[i], "LIC_USR_LIST", $event)}}})],1)],1)],1)]],2)],1):_vm._e()}),1)],1),_vm._v(" "),(!_vm.loadingGet)?_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","loading":_vm.loadingPost},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("\n        "+_vm._s(_vm._f("cap")(_vm.$t('save')))),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("send")])],1)],1):_vm._e()])}
var Mapping_staticRenderFns = []
var Mapping_esExports = { render: Mapping_render, staticRenderFns: Mapping_staticRenderFns }
/* harmony default export */ var management_Mapping = (Mapping_esExports);
// CONCATENATED MODULE: ./src/components/management/Mapping.vue
var Mapping_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Mapping___vue_template_functional__ = false
/* styles */
var Mapping___vue_styles__ = null
/* scopeId */
var Mapping___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Mapping___vue_module_identifier__ = null
var Mapping_Component = Mapping_normalizeComponent(
  Mapping,
  management_Mapping,
  Mapping___vue_template_functional__,
  Mapping___vue_styles__,
  Mapping___vue_scopeId__,
  Mapping___vue_module_identifier__
)

/* harmony default export */ var components_management_Mapping = (Mapping_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-52986b4d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Settings.vue
var Settings_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"settings"},[_c('v-layout',{attrs:{"row":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs10":"","sm6":""}},[_c('wz-select-one-site')],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}})],1),_vm._v(" "),_c('transition',{attrs:{"name":"slide-x-reverse-transition","mode":"out-in"}},[_c('router-view')],1)],1)}
var Settings_staticRenderFns = []
var Settings_esExports = { render: Settings_render, staticRenderFns: Settings_staticRenderFns }
/* harmony default export */ var Settings = (Settings_esExports);
// CONCATENATED MODULE: ./src/components/Settings.vue
var Settings_normalizeComponent = __webpack_require__("VU/8")
/* script */
var Settings___vue_script__ = null
/* template */

/* template functional */
var Settings___vue_template_functional__ = false
/* styles */
var Settings___vue_styles__ = null
/* scopeId */
var Settings___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Settings___vue_module_identifier__ = null
var Settings_Component = Settings_normalizeComponent(
  Settings___vue_script__,
  Settings,
  Settings___vue_template_functional__,
  Settings___vue_styles__,
  Settings___vue_scopeId__,
  Settings___vue_module_identifier__
)

/* harmony default export */ var components_Settings = (Settings_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue-color/dist/vue-color.min.js
var vue_color_min = __webpack_require__("Zzkc");
var vue_color_min_default = /*#__PURE__*/__webpack_require__.n(vue_color_min);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/settings/Preview.vue







/* harmony default export */ var Preview = ({
  components: {
    'chrome-picker': vue_color_min["Chrome"]
  },

  data: function data() {
    return {
      titleDialog: '',
      contentDialog: '',
      dialogProgress: false,
      options: {},
      saveOptions: {},
      loadingGet: false,
      loadingPost: false,
      imgLoading: false,
      langs: [{ text: lodash_default.a.upperFirst(this.$t('french')), value: 'FR' }, { text: lodash_default.a.upperFirst(this.$t('english')), value: 'EN' }, { text: lodash_default.a.upperFirst(this.$t('spanish')), value: 'ES' }, { text: lodash_default.a.upperFirst(this.$t('german')), value: 'DE' }, { text: lodash_default.a.upperFirst(this.$t('italian')), value: 'IT' }, { text: lodash_default.a.upperFirst(this.$t('portuguese')), value: 'PT' }],
      colorsLabel: [this.$t('primaryColor'), this.$t('secondaryColor'), this.$t('backgroundColor'), this.$t('iconsColor')],
      colorsHint: ['Ent\xEAte, scrollbar, boutons CTA (callback/meeting), widget mini', 'Textes conseiller, Sous-titre widget moyen', 'Bulles visiteurs', 'Textes visiteur, Nom et poste conseiller'],
      activeState2019: null,
      botOrConseiller: null,
      radius: 0,
      imagesAgent: [],
      imagesBot: [],
      lastImg: '',
      imageBot: '',
      imageConseiller: '',
      widget2019: true,
      widgetOpen: true,
      widgetOnline: true,
      color: {},
      colorsDefault: [{
        text: 'Magenta',
        value: 'black',
        colors: ['E3328B', '781A49', 'E3328B', 'FF57A5', '5E1037', 'FFFFFF']
      }, {
        text: 'Bleu',
        value: 'blue',
        colors: ['90D1E5', '518898', 'BAEFFF', '62A4B8', '518898', '518898']
      }, {
        text: 'Bleu 2',
        value: 'blue2',
        colors: ['91BAEB', '52759E', '91BAEB', '74A6E0', '52759E', '52759E']
      }, {
        text: 'Vert',
        value: 'green',
        colors: ['8FBC5C', '517A2D', '8FBC5C', '3A5720', '223313', '3A5720']
      }, {
        text: 'Orange',
        value: 'orange',
        colors: ['FFC091', 'ED790E', 'FFC091', 'B86627', '80471B', '80471B']
      }, {
        text: 'Rouge',
        value: 'red',
        colors: ['D62834', '890D15', 'D62834', 'FF4956', '890D15', 'FFFFFF']
      }, {
        text: 'Menthe',
        value: 'menthe',
        colors: ['1ABC9C', '16A085', '1ABC9C', '0F6E5C', '16A085', '0F6E5C']
      }, {
        text: 'Ardoise',
        value: 'ardoise',
        colors: ['34495E', '2C3E50', '2C3E50', '5B80A6', '2C3E50', 'FFFFFF']
      }, {
        text: 'Violet',
        value: 'violet',
        colors: ['9B59B6', '8E44AD', '8E44AD', 'D164FF', '8E44AD', 'FFFFFF']
      }, {
        text: 'Violet2',
        value: 'violet2',
        colors: ['7646C1', '532F8C', '532F8C', 'FFFFFF', 'FFFFFF', 'FFFFFF']
      }, {
        text: 'Tournesol',
        value: 'tournesol',
        colors: ['F1C40F', 'F39C12', 'FFAC29', 'A62F03', '591202', '591202']
      }, {
        text: 'Emeraude',
        value: 'emerode',
        colors: ['2ECC71', '27AE60', '27AE60', '33E67F', '27AE60', '124F2C']
      }, {
        text: 'Carotte',
        value: 'carotte',
        colors: ['E67E22', 'D35400', 'E67E22', 'ED9D13', 'E67E22', '421A00']
      }, {
        text: 'Brique',
        value: 'brique',
        colors: ['E74C3C', 'C0392B', 'C0392B', 'A7BD18', '758511', '691F17']
      }, {
        text: 'Sable',
        value: 'sable',
        colors: ['F0DEB4', 'D5C295', 'D5C295', 'FFE8B2', 'D5C295', '665D47']
      }, {
        text: 'Raisin',
        value: 'raisin',
        colors: ['3A6F81', '356272', '356272', '213D47', '0D181C', '6BC5E6']
      }, {
        text: 'Pastèque',
        value: 'pasteque',
        colors: ['EF717A', 'D95459', 'EF717A', '619956', '4F7D46', 'FFFFFF']
      }, {
        text: 'Pin',
        value: 'pin',
        colors: ['345F41', '2D5036', '345F41', '71C988', '2D5036', 'FFFFFF']
      }, {
        text: 'Café',
        value: 'cafe',
        colors: ['5E4534', '503B2C', '5E4534', '9E7557', '5E4534', 'FFFFFF']
      }, {
        text: 'Bonbons',
        value: 'bonbons',
        colors: ['F47CC3', 'D45C9E', 'F47CC3', 'FFB0D5', 'D45C9E', 'FFFFFF']
      }, {
        text: 'Salade',
        value: 'salade',
        colors: ['A5C63B', '8EB021', 'A5C63B', '6A8026', '3E4A16', 'FFFFFF']
      }, {
        text: 'Caramel',
        value: 'caramel',
        colors: ['A38671', '8E725E', 'A38671', '5C493C', '3B2F27', 'FFFFFF']
      }, {
        text: 'Noir',
        value: 'noir',
        colors: ['2B2B2B', '262626', '2B2B2B', 'BFBABA', '2B2B2B', 'FFFFFF']
      }, {
        text: 'Tricolore',
        value: 'tricolore',
        colors: ['007CFF', '0467CC', 'DA1818', 'FFFFFF', 'FFFFFF', 'FFFFFF']
      }],
      idxPicker: 0,

      form: {
        hiddenMobile: false,
        displayDefault: {},
        timeout: 0,

        hours: '',
        days: [{
          name: this.$t('monday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('tuesday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('wednesday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('thursday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('friday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('saturday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('sunday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }],

        urls: '',
        rules: []

      },

      optsDisplayDefault: [],

      showTp: false,
      daySelected: {},
      tmpHours: null,
      amOrPm: 'am',
      startOrEnd: 'start',
      allowed: { hours: { min: '0:00', max: '12:00' } },

      showHours: false,
      daysTmp: [],
      dayHours: null,
      days: [{ text: lodash_default.a.upperFirst(this.$t('monday')), value: 0 }, { text: lodash_default.a.upperFirst(this.$t('tuesday')), value: 1 }, { text: lodash_default.a.upperFirst(this.$t('wednesday')), value: 2 }, { text: lodash_default.a.upperFirst(this.$t('thursday')), value: 3 }, { text: lodash_default.a.upperFirst(this.$t('friday')), value: 4 }, { text: lodash_default.a.upperFirst(this.$t('saturday')), value: 5 }, { text: lodash_default.a.upperFirst(this.$t('sunday')), value: 6 }],

      tmp: '',
      headersRules: [{ text: lodash_default.a.upperFirst(this.$t('type')), align: 'left', sortable: false, value: 'type' }, { text: lodash_default.a.upperFirst(this.$t('content')), align: 'left', sortable: false, value: 'content' }, { text: '', align: 'left', sortable: false, value: 'actions' }],
      typeRules: [{ text: lodash_default.a.upperFirst(this.$t('fullUrl')), value: 'DSK_SHOW_URL' }, { text: lodash_default.a.upperFirst(this.$t('containedUrl')), value: 'DSK_SHOW_PART_URL' }, { text: lodash_default.a.upperFirst(this.$t('keyWords')), value: 'DSK_SHOW_TAGS' }, { text: lodash_default.a.upperFirst(this.$t('classOrId')), value: 'DSK_SHOW_CLASS_ID' }],
      showDialogRule: false,
      ruleTmp: { content: '', type: {} },
      random: Math.random() };
  },
  mounted: function mounted() {
    if (this.testBrideStatus('parametre_affichage_perso_cible')) {
      this.optsDisplayDefault = [{ text: this.$t('normal'), value: 'none' }, { text: this.$t('afterDelay'), value: 'default_timeout' }, { text: this.$t('ifOneAgentOnline'), value: 'default_agents' }, { text: this.$t('onAgentIntervention'), value: 'default_open_agents' }];
    } else {
      this.optsDisplayDefault = [{ text: this.$t('normal'), value: 'none' }, { text: this.$t('afterDelay'), value: 'default_timeout' }, { text: this.$t('ifOneAgentOnline'), value: 'default_agents' }, { text: this.$t('onAgentIntervention'), value: 'default_open_agents' }, { text: this.$t('onTrackedVisitor'), value: 'open_if_alert' }];
    }

    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
  },
  created: function created() {
    if (this.$store.getters['_User/level'].rights === LEVEL.CHAT) {
      this.optsDisplayDefault.splice(1, 1);
    }
    this.getOptions();
    this.daySelected = this.form.days[0];
    this.dayHours = { text: this.form.days[0].name, value: 0 };

    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'settings_preview';
    } else {
      setTimeout(function () {
        if (typeof defautMotif !== 'undefined') {
          defautMotif = 'settings_preview';
        }
      }, 800);
    }
  },

  methods: {
    openDialog: function openDialog(data) {
      this.titleDialog = data.title;
      this.contentDialog = data.content;
    },
    fermeDialogInfos: function fermeDialogInfos() {
      this.titleDialog = '';
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    },
    getOptions: function getOptions() {
      var _this = this;

      this.loadingGet = true;
      this.axios.get('get/settings_preview.php?desk=' + this.$store.state._Sites.siteSelected.LIC_DSK_ID).then(function (res) {
        _this.options = res.data;
        _this.options.DSK_COLORS = _this.options.DSK_COLORS.split('|');
        _this.options.DSK_HIDE_AGENT_LIST = _this.options.DSK_HIDE_AGENT_LIST === '0';
        _this.options.DSK_ONGLET_RADIUS = _this.options.DSK_ONGLET_RADIUS.split('|');
        _this.radius = _this.options.DSK_ONGLET_RADIUS[0];
        try {
          _this.options.DSK_TAB_MSG_JSON = JSON.parse(_this.options.DSK_TAB_MSG_JSON) || {};
          _this.options.DSK_TAB_MSG_JSON2 = JSON.parse(_this.options.DSK_TAB_MSG_JSON2) || {};
          _this.options.DSK_TAB_MSG_JSON3 = JSON.parse(_this.options.DSK_TAB_MSG_JSON3) || {};
        } catch (error) {}

        _this.options.DSK_CALLBACK_ONOFF = _this.options.DSK_CALLBACK_ONOFF === '1';
        _this.options.DSK_ACTIVE_PERSO_FO = _this.options.DSK_ACTIVE_PERSO_FO === '1';
        _this.options.DSK_PERSO_FO_ONLINE = _this.options.DSK_PERSO_FO_ONLINE === '1';
        _this.options.DSK_PERSO_FO_OFFLINE = _this.options.DSK_PERSO_FO_OFFLINE === '1';
        _this.options.DSK_WIDGET_2019 = _this.options.DSK_WIDGET_2019 === '1';
        _this.widget2019 = _this.options.DSK_WIDGET_2019;
        _this.options.DSK_SIDEON = _this.options.DSK_SIDEON === '1';
        _this.options.DSK_SIDEHOVER = _this.options.DSK_SIDEHOVER === '1';
        _this.options.DSK_HIDE_MIDDLE_STATE = _this.options.DSK_HIDE_MIDDLE_STATE === '1';

        _this.lastImg = _this.options.DSK_POULETTE;
        _this.imageConseiller = _this.options.DSK_POULETTE;
        _this.imageBot = _this.options.DSK_POULET;
        if (_this.options.DSK_POULET && _this.options.DSK_POULET !== '' && _this.options.DSK_POULET !== 'bot_empty') {
          _this.lastImg = _this.options.DSK_POULET;
        }
        _this.saveOptions = lodash_default.a.cloneDeep(_this.options);

        _this.widgetOpen = true;

        _this.findSetColors();

        _this.form.hiddenMobile = _this.options.DSK_HIDE_MOBILE === '1';
        _this.form.displayDefault = lodash_default.a.clone(lodash_default.a.find(_this.optsDisplayDefault, { 'value': _this.options.DSK_OPTIONS.split('|')[0] })) || {};
        _this.form.timeout = _this.options.DSK_OPTIONS.split('|')[1];

        _this.form.hours = _this.options.DSK_SCHEDULES.split('|')[0];
        var hours = _this.options.DSK_SCHEDULES.split('|');

        _this.form.days[0].am.active = !lodash_default.a.isEmpty(hours[1] + hours[2] + hours[3] + hours[4]) && !lodash_default.a.isNil(hours[1]) && !lodash_default.a.isNil(hours[2]) && !lodash_default.a.isNil(hours[3]) && !lodash_default.a.isNil(hours[4]);
        _this.form.days[0].am.start = _this.form.days[0].am.active ? hours[1] + ':' + hours[2] : '00:00';
        _this.form.days[0].am.end = _this.form.days[0].am.active ? hours[3] + ':' + hours[4] : '00:00';
        _this.form.days[0].pm.active = !lodash_default.a.isEmpty(hours[5] + hours[6] + hours[7] + hours[8]);
        _this.form.days[0].pm.start = _this.form.days[0].pm.active ? hours[5] + ':' + hours[6] : '12:00';
        _this.form.days[0].pm.end = _this.form.days[0].pm.active ? hours[7] + ':' + hours[8] : '12:00';

        _this.form.days[1].am.active = !lodash_default.a.isEmpty(hours[9] + hours[10] + hours[11] + hours[12]);
        _this.form.days[1].am.start = _this.form.days[1].am.active ? hours[9] + ':' + hours[10] : '00:00';
        _this.form.days[1].am.end = _this.form.days[1].am.active ? hours[11] + ':' + hours[12] : '00:00';
        _this.form.days[1].pm.active = !lodash_default.a.isEmpty(hours[13] + hours[14] + hours[15] + hours[16]);
        _this.form.days[1].pm.start = _this.form.days[1].am.active ? hours[13] + ':' + hours[14] : '12:00';
        _this.form.days[1].pm.end = _this.form.days[1].am.active ? hours[15] + ':' + hours[16] : '12:00';

        _this.form.days[2].am.active = !lodash_default.a.isEmpty(hours[17] + hours[18] + hours[19] + hours[20]);
        _this.form.days[2].am.start = _this.form.days[2].am.active ? hours[17] + ':' + hours[18] : '00:00';
        _this.form.days[2].am.end = _this.form.days[2].am.active ? hours[19] + ':' + hours[20] : '00:00';
        _this.form.days[2].pm.active = !lodash_default.a.isEmpty(hours[21] + hours[22] + hours[23] + hours[24]);
        _this.form.days[2].pm.start = _this.form.days[2].pm.active ? hours[21] + ':' + hours[22] : '12:00';
        _this.form.days[2].pm.end = _this.form.days[2].pm.active ? hours[23] + ':' + hours[24] : '12:00';

        _this.form.days[3].am.active = !lodash_default.a.isEmpty(hours[25] + hours[26] + hours[27] + hours[28]);
        _this.form.days[3].am.start = _this.form.days[3].am.active ? hours[25] + ':' + hours[26] : '00:00';
        _this.form.days[3].am.end = _this.form.days[3].am.active ? hours[27] + ':' + hours[28] : '00:00';
        _this.form.days[3].pm.active = !lodash_default.a.isEmpty(hours[29] + hours[30] + hours[31] + hours[32]);
        _this.form.days[3].pm.start = _this.form.days[3].pm.active ? hours[29] + ':' + hours[30] : '12:00';
        _this.form.days[3].pm.end = _this.form.days[3].pm.active ? hours[31] + ':' + hours[32] : '12:00';

        _this.form.days[4].am.active = !lodash_default.a.isEmpty(hours[33] + hours[34] + hours[35] + hours[36]);
        _this.form.days[4].am.start = _this.form.days[4].am.active ? hours[33] + ':' + hours[34] : '00:00';
        _this.form.days[4].am.end = _this.form.days[4].am.active ? hours[35] + ':' + hours[36] : '00:00';
        _this.form.days[4].pm.active = !lodash_default.a.isEmpty(hours[37] + hours[38] + hours[39] + hours[40]);
        _this.form.days[4].pm.start = _this.form.days[4].pm.active ? hours[37] + ':' + hours[38] : '12:00';
        _this.form.days[4].pm.end = _this.form.days[4].pm.active ? hours[39] + ':' + hours[40] : '12:00';

        _this.form.days[5].am.active = !lodash_default.a.isEmpty(hours[41] + hours[42] + hours[43] + hours[44]);
        _this.form.days[5].am.start = _this.form.days[5].am.active ? hours[41] + ':' + hours[42] : '00:00';
        _this.form.days[5].am.end = _this.form.days[5].am.active ? hours[43] + ':' + hours[44] : '00:00';
        _this.form.days[5].pm.active = !lodash_default.a.isEmpty(hours[45] + hours[46] + hours[47] + hours[48]);
        _this.form.days[5].pm.start = _this.form.days[5].pm.active ? hours[45] + ':' + hours[46] : '12:00';
        _this.form.days[5].pm.end = _this.form.days[5].pm.active ? hours[47] + ':' + hours[48] : '12:00';

        _this.form.days[6].am.active = !lodash_default.a.isEmpty(hours[49] + hours[50] + hours[51] + hours[52]);
        _this.form.days[6].am.start = _this.form.days[6].am.active ? hours[49] + ':' + hours[50] : '00:00';
        _this.form.days[6].am.end = _this.form.days[6].am.active ? hours[51] + ':' + hours[52] : '00:00';
        _this.form.days[6].pm.active = !lodash_default.a.isEmpty(hours[53] + hours[54] + hours[55] + hours[56]);
        _this.form.days[6].pm.start = _this.form.days[6].pm.active ? hours[53] + ':' + hours[54] : '12:00';
        _this.form.days[6].pm.end = _this.form.days[6].pm.active ? hours[55] + ':' + hours[56] : '12:00';

        _this.form.urls = 'all';
        if (_this.options.DSK_SHOW_ONOFF === '1') {
          _this.form.urls = 'showOnOff';
        } else if (_this.options.DSK_HIDE_ONOFF === '1') {
          _this.form.urls = 'hideOnOff';
        }

        lodash_default.a.each(_this.options.DSK_SHOW_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[0]), 'list': 'showOnOff' });
        });
        lodash_default.a.each(_this.options.DSK_SHOW_PART_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[1]), 'list': 'showOnOff' });
        });
        lodash_default.a.each(_this.options.DSK_SHOW_TAGS.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[2]), 'list': 'showOnOff' });
        });
        lodash_default.a.each(_this.options.DSK_SHOW_CLASS_ID.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[3]), 'list': 'showOnOff' });
        });

        lodash_default.a.each(_this.options.DSK_HIDE_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[0]), 'list': 'hideOnOff' });
        });
        lodash_default.a.each(_this.options.DSK_HIDE_PART_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[1]), 'list': 'hideOnOff' });
        });
        lodash_default.a.each(_this.options.DSK_HIDE_TAGS.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[2]), 'list': 'hideOnOff' });
        });
        lodash_default.a.each(_this.options.DSK_HIDE_CLASS_ID.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[3]), 'list': 'hideOnOff' });
        });
      }).catch(function (_) {}).then(function (_) {
        _this.loadingGet = false;
      });
    },
    testBrideStatus: function testBrideStatus(name) {
      var brides = this.$store.state._User.brides;

      if (brides) {
        var resultat = brides.find(function (brides) {
          return brides.brideName === name;
        });
        if (resultat) {
          if (resultat.status === '0') {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    postOptions: function postOptions() {
      var _this2 = this;

      var dataToPost = new window.FormData();

      var steps = JSON.parse(this.$store.state._User.remainingSteps);

      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_SETTINGS_PREVIEW')) {
        steps.splice(steps.indexOf('INS_SETTINGS_PREVIEW'), 1);

        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: stringify_default()(steps)
        });
      }


      dataToPost.append('DSK_ID', this.$store.state._Sites.siteSelected.LIC_DSK_ID);
      dataToPost.append('LIC_KEY', this.$store.state._Sites.siteSelected.LIC_KEY);
      dataToPost.append('ENT_ID', this.$store.state._User.entId);

      dataToPost.append('DSK_COLORS', this.colorsToString);
      dataToPost.append('DSK_ONGLET_RADIUS', Array(4).fill(this.radius).join('|'));
      dataToPost.append('DSK_WIDTH', this.options.DSK_WIDTH);
      dataToPost.append('DSK_HEIGHT', this.options.DSK_HEIGHT);
      dataToPost.append('DSK_TAB_SIDE', this.options.DSK_TAB_SIDE);
      dataToPost.append('DSK_TAB_POS', this.options.DSK_TAB_POS);
      dataToPost.append('DSK_TAB_SIDE_MOBILE', this.options.DSK_TAB_SIDE_MOBILE);
      dataToPost.append('DSK_TAB_POS_MOBILE', this.options.DSK_TAB_POS_MOBILE);
      dataToPost.append('DSK_OPTIONS_2', this.options.DSK_OPTIONS_2);
      dataToPost.append('DSK_HIDE_AGENT_LIST', this.options.DSK_HIDE_AGENT_LIST ? '0' : '1');
      dataToPost.append('DSK_TAB_MSG_JSON', stringify_default()(this.options.DSK_TAB_MSG_JSON));
      dataToPost.append('DSK_TAB_MSG_JSON2', stringify_default()(this.options.DSK_TAB_MSG_JSON2));
      dataToPost.append('DSK_TAB_MSG_JSON3', stringify_default()(this.options.DSK_TAB_MSG_JSON3));
      dataToPost.append('DSK_ASK_GEOLOC_ONOFF', this.options.DSK_ASK_GEOLOC_ONOFF ? '1' : '0');
      dataToPost.append('DSK_GETELANG', this.options.DSK_GETELANG);
      dataToPost.append('DSK_ACTIVE_PERSO_FO', this.options.DSK_ACTIVE_PERSO_FO ? '1' : '0');
      dataToPost.append('DSK_PERSO_FO_ONLINE', this.options.DSK_PERSO_FO_ONLINE ? '1' : '0');
      dataToPost.append('DSK_PERSO_FO_OFFLINE', this.options.DSK_PERSO_FO_OFFLINE ? '1' : '0');
      dataToPost.append('DSK_POULETTE', this.options.DSK_POULETTE);
      dataToPost.append('DSK_POULET', this.options.DSK_POULET);
      dataToPost.append('DSK_WIDGET_2019', this.options.DSK_WIDGET_2019 ? '1' : '0');
      dataToPost.append('DSK_SIDEON', this.options.DSK_SIDEON ? '1' : '0');
      dataToPost.append('DSK_SIDEHOVER', this.options.DSK_SIDEHOVER ? '1' : '0');
      dataToPost.append('DSK_WIDGETSTATE', this.options.DSK_WIDGETSTATE);
      dataToPost.append('DSK_WIDGETSTATE_MOBILE', this.options.DSK_WIDGETSTATE_MOBILE);
      dataToPost.append('DSK_HIDE_MIDDLE_STATE', this.options.DSK_HIDE_MIDDLE_STATE ? '1' : '0');

      var hiddenMobile = this.form.hiddenMobile ? '1' : '0';
      dataToPost.append('DSK_HIDE_MOBILE', hiddenMobile);
      dataToPost.append('DSK_OPTIONS', this.form.displayDefault.value + '|' + this.form.timeout);

      var hours = this.form.hours;
      lodash_default.a.each(this.form.days, function (day) {
        hours += day.am.active ? '|' + day.am.start.split(':')[0] + '|' + day.am.start.split(':')[1] + '|' + day.am.end.split(':')[0] + '|' + day.am.end.split(':')[1] : '||||';
        hours += day.pm.active ? '|' + day.pm.start.split(':')[0] + '|' + day.pm.start.split(':')[1] + '|' + day.pm.end.split(':')[0] + '|' + day.pm.end.split(':')[1] : '||||';
      });
      dataToPost.append('DSK_SCHEDULES', hours);

      dataToPost.append('DSK_SHOW_ONOFF', this.form.urls === 'showOnOff' ? '1' : '0');
      dataToPost.append('DSK_HIDE_ONOFF', this.form.urls === 'hideOnOff' ? '1' : '0');
      var url = { 'showOnOff': '', hideOnOff: '' };
      var partUrl = { 'showOnOff': '', hideOnOff: '' };
      var tags = { 'showOnOff': '', hideOnOff: '' };
      var classId = { 'showOnOff': '', hideOnOff: '' };
      lodash_default.a.each(this.form.rules, function (rule) {
        if (_this2.typeRules[0].value === rule.type.value) {
          url[rule.list] += rule.content + '|';
        } else if (_this2.typeRules[1].value === rule.type.value) {
          partUrl[rule.list] += rule.content + '|';
        } else if (_this2.typeRules[2].value === rule.type.value) {
          tags[rule.list] += rule.content + '|';
        } else if (_this2.typeRules[3].value === rule.type.value) {
          classId[rule.list] += rule.content + '|';
        }
      });

      dataToPost.append('DSK_SHOW_URL', url.showOnOff);
      dataToPost.append('DSK_SHOW_PART_URL', partUrl.showOnOff);
      dataToPost.append('DSK_SHOW_TAGS', tags.showOnOff);
      dataToPost.append('DSK_SHOW_CLASS_ID', classId.showOnOff);

      dataToPost.append('DSK_HIDE_URL', url.hideOnOff);
      dataToPost.append('DSK_HIDE_PART_URL', partUrl.hideOnOff);
      dataToPost.append('DSK_HIDE_TAGS', tags.hideOnOff);
      dataToPost.append('DSK_HIDE_CLASS_ID', classId.hideOnOff);

      this.loadingPost = true;
      this.axios.post('post/settings_preview.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this2.saveOptions = lodash_default.a.cloneDeep(_this2.options);
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('modifSuccess'), context: 'success' });
      }).catch(function (_) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('modifFailure'), context: 'error' });
      }).then(function (_) {
        _this2.loadingPost = false;
      });
    },
    resetOptions: function resetOptions() {
      this.radius = this.saveOptions.DSK_ONGLET_RADIUS[0];
      this.options = lodash_default.a.cloneDeep(this.saveOptions);
      this.findSetColors();
    },
    saveImg: function saveImg(mode, filename) {
      var _this3 = this;

      if (!filename) {
        return;
      }
      this.imgLoading = true;

      var dataToPost = new window.FormData();
      dataToPost.append('url', filename);
      dataToPost.append('mode', mode);
      dataToPost.append('lic_key', this.$store.state._Sites.siteSelected.LIC_KEY);
      dataToPost.append('dsk_id', this.$store.state._Sites.siteSelected.LIC_DSK_ID);

      this.axios.post('put/perso_fo.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this3.random = Math.random();

        _this3.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this3.$t('changeImageSuccess'), context: 'success' });
      }).catch(function (_) {
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this3.$t('changeImageFailed'), context: 'error' });
      }).then(function (_) {
        _this3.imgLoading = false;
      });
    },
    updateColors: function updateColors() {
      var idxColor = lodash_default.a.findIndex(this.colors, { 'value': this.color.value });
      this.options.DSK_COLORS = this.colors[idxColor].colors;
    },
    findSetColors: function findSetColors() {
      var _this4 = this;

      this.color = lodash_default.a.clone(this.colors[0]);
      lodash_default.a.each(this.colorsDefault, function (color) {
        if (lodash_default.a.difference(color.colors, _this4.options.DSK_COLORS).length === 0) {
          _this4.color = lodash_default.a.clone(color);
        }
      });
    },
    updateFromPicker: function updateFromPicker(value) {
      console.log('this.idxPicker', this.idxPicker);
      this.options.DSK_COLORS.splice(this.idxPicker, 1, value.hex.split('#')[1]);
    },
    updateColors2019: function updateColors2019() {
      var idxColor = lodash_default.a.findIndex(this.colors2019, { 'value': this.color.value });
      this.options.DSK_COLORS = this.colors2019[idxColor].colors;
    },
    loadImg: function loadImg(agent) {
      var _this5 = this;

      if (agent && this.imagesAgent.length > 0) return;
      if (!agent && this.imagesBot.length > 0) return;
      this.axios.get('get/imagesHotesses.php?agent=' + agent).then(function (res) {
        if (agent) {
          _this5.imagesAgent = res.data.map(function (img) {
            return HOTESSES_DIR + img;
          });
        } else {
          _this5.imagesBot = res.data.map(function (img) {
            return HOTESSES_DIR + img;
          });
        }
      });
    },
    updateImg: function updateImg(agent, img, elt) {
      img = img.split('/').reverse()[0].split('.')[0];
      if (agent) {
        this.options.DSK_POULETTE = img;
        this.imageConseiller = img;
        this.botOrConseiller = 0;
      } else {
        this.options.DSK_POULET = img;
        this.imageBot = img;
        this.botOrConseiller = 1;
      }
      this.lastImg = img;
      var allpicto = document.querySelectorAll('.picto');
      for (var j = 0; j < allpicto.length; j++) {
        allpicto[j].style.border = '';
      }
      document.getElementById('picto_' + elt).style.border = '1px solid black';
    },
    openTimePicker: function openTimePicker(day, amOrPm, startOrEnd) {
      this.showTp = true;
      this.daySelected = day;
      this.amOrPm = amOrPm;
      this.startOrEnd = startOrEnd;
      this.tmpHours = this.daySelected[amOrPm][startOrEnd];

      this.allowed.hours = amOrPm === 'am' ? { min: '0:00', max: '12:59' } : { min: '12:00', max: '23:59' };
    },
    openHours: function openHours() {
      this.showHours = true;
    },
    submitHours: function submitHours() {
      var _this6 = this;

      this.showHours = false;

      var daySelected = this.form.days.find(function (d) {
        return d.name === _this6.dayHours.text;
      });
      this.daysTmp.forEach(function (day) {
        var d = _this6.form.days.find(function (d) {
          return d.name === day.text.toLowerCase();
        });
        d.am = lodash_default.a.cloneDeep(daySelected.am);
        d.pm = lodash_default.a.cloneDeep(daySelected.pm);
      });
      this.daysTmp = [];
    },
    openRule: function openRule() {
      this.showDialogRule = true;
      this.ruleTmp = { content: '', type: this.typeRules[0], list: this.form.urls };
    },
    submitRule: function submitRule() {
      if (!lodash_default.a.isEmpty(this.ruleTmp.content)) {
        this.showDialogRule = false;
        this.form.rules.push(lodash_default.a.clone(this.ruleTmp));
      } else {
        this.$validator.validateAll();
      }
    },
    deleteRule: function deleteRule(index) {
      this.form.rules.splice(index, 1);
    }
  },

  computed: {
    position: function position() {
      var pos = '';
      if (this.options.DSK_TAB_SIDE === 'LEFT') {
        pos = this.$t('onLeft');
      } else if (this.options.DSK_TAB_SIDE === 'RIGHT') {
        pos = this.$t('onRight');
      } else if (this.options.DSK_TAB_SIDE === 'BOTTOM' && this.options.DSK_TAB_POS === '0') {
        pos = this.$t('bottomLeft');
      } else if (this.options.DSK_TAB_SIDE === 'BOTTOM' && this.options.DSK_TAB_POS === '50') {
        pos = this.$t('bottomMiddle');
      } else if (this.options.DSK_TAB_SIDE === 'BOTTOM' && this.options.DSK_TAB_POS === '100') {
        pos = this.$t('bottomRight');
      }
      return pos;
    },
    positionMobile: function positionMobile() {
      var pos = '';
      if (this.options.DSK_TAB_SIDE_MOBILE === 'LEFT') {
        pos = this.$t('onLeft');
      } else if (this.options.DSK_TAB_SIDE_MOBILE === 'RIGHT') {
        pos = this.$t('onRight');
      } else if (this.options.DSK_TAB_SIDE_MOBILE === 'BOTTOM' && this.options.DSK_TAB_POS_MOBILE === '0') {
        pos = this.$t('bottomLeft');
      } else if (this.options.DSK_TAB_SIDE_MOBILE === 'BOTTOM' && this.options.DSK_TAB_POS_MOBILE === '50') {
        pos = this.$t('bottomMiddle');
      } else if (this.options.DSK_TAB_SIDE_MOBILE === 'BOTTOM' && this.options.DSK_TAB_POS_MOBILE === '100') {
        pos = this.$t('bottomRight');
      }
      return pos;
    },
    langsFront: function langsFront() {
      var langs = lodash_default.a.clone(this.langs);
      langs.splice(0, 0, { text: this.$t('defaultLanguage'), value: '' });
      return langs;
    },
    colors: function colors() {
      var colorsPerso = {
        text: this.$t('personnalise'),
        value: this.$t('custom'),
        colors: this.options.DSK_COLORS
      };
      var colors = lodash_default.a.clone(this.colorsDefault);
      colors.splice(0, 0, colorsPerso);
      return colors;
    },
    iframeInnerSrc: function iframeInnerSrc() {
      return  false ? DOMAINE + '/dev/fo/incl/svg_fo_innerNewBO.php?' + this.iframeParams : constants_DOMAINE + '/fo/incl/svg_fo_innerNewBO.php?' + this.iframeParams;
    },
    iframeOuterSrc: function iframeOuterSrc() {
      return  false ? DOMAINE + '/dev/fo/incl/svg_fo_outerNewBO.php?' + this.iframeParams : constants_DOMAINE + '/fo/incl/svg_fo_outerNewBO.php?' + this.iframeParams;
    },
    iframeInnerSrc2019: function iframeInnerSrc2019() {
      return  false ? DOMAINE + '/dev/fo/incl/inner2019.php?' + this.iframeParams : constants_DOMAINE + '/fo/incl/inner2019.php?' + this.iframeParams;
    },
    iframeParams: function iframeParams() {
      var lang = this.options.DSK_GETELANG.length === 0 ? this.$i18n.locale.toUpperCase() : this.options.DSK_GETELANG;
      var titleMiddleState = this.options.DSK_TAB_MSG_JSON[lang];
      var titleMiddleState2 = this.options.DSK_TAB_MSG_JSON2[lang];
      var titleMiddleState3 = this.options.DSK_TAB_MSG_JSON3[lang];
      var middleImage = void 0;
      if (this.botOrConseiller) {
        middleImage = this.imageBot;
      } else {
        middleImage = this.imageConseiller;
      }
      var params = 'deskColors=' + this.colorsToString;
      params = params + '&deskWidth=' + this.options.DSK_WIDTH;
      params += '&deskHeight=' + this.options.DSK_HEIGHT;
      params += '&deskOnline=' + this.widgetOnline;
      params += '&callbackOnOff=' + this.options.DSK_CALLBACK_ONOFF;
      params += '&deskOngletRadius=' + Array(4).fill(this.radius).join('|');
      params += '&fullName=' + this.$store.getters['_User/fullName'];
      params += '&job=' + this.$store.state._User.job;
      params += '&avatarId=' + this.$store.state._User.id;
      params += '&side=' + this.options.DSK_TAB_SIDE;
      params += '&pos=' + this.options.DSK_TAB_POS;
      params += '&sideOn=' + this.options.DSK_SIDEON;
      params += '&sideHover=' + this.options.DSK_SIDEHOVER;
      params += '&state=' + (this.activeState2019 + 1);
      params += '&bot=' + (this.botOrConseiller + 1);
      params += '&hideAgents=' + this.options.DSK_HIDE_AGENT_LIST;
      params += '&hideMiddleState=' + this.options.DSK_HIDE_MIDDLE_STATE;
      params += '&lang=' + this.options.DSK_GETELANG;
      params += '&imgMiddleState=' + middleImage;
      params += '&titleMiddleState=' + titleMiddleState;
      params += '&titleMiddleState2=' + titleMiddleState2;
      params += '&titleMiddleState3=' + titleMiddleState3;

      return params;
    },
    colorsToString: function colorsToString() {
      return this.options.DSK_COLORS.join('|');
    },
    showIframeOuter: function showIframeOuter() {
      if (!this.options.DSK_ACTIVE_PERSO_FO) {
        return true;
      }
      if (this.widgetOnline && this.options.DSK_PERSO_FO_ONLINE) {
        return false;
      }
      if (!this.widgetOnline && this.options.DSK_PERSO_FO_OFFLINE) {
        return false;
      }
      return true;
    },
    persoFoOnlineSrc: function persoFoOnlineSrc() {
      return  false ? DOMAINE + '/dev/media/desk/online/' + this.$store.state._Sites.siteSelected.LIC_KEY + '.png?' + this.random : constants_DOMAINE + '/media/desk/online/' + this.$store.state._Sites.siteSelected.LIC_KEY + '.png?' + this.random;
    },
    persoFoOfflineSrc: function persoFoOfflineSrc() {
      return  false ? DOMAINE + '/dev/media/desk/offline/' + this.$store.state._Sites.siteSelected.LIC_KEY + '.png?' + this.random : constants_DOMAINE + '/media/desk/offline/' + this.$store.state._Sites.siteSelected.LIC_KEY + '.png?' + this.random;
    },
    colors2019: function colors2019() {
      return this.colors.map(function (c) {
        return {
          text: c.text,
          value: c.value,
          colors: [].concat(toConsumableArray_default()(c.colors.slice(0, 3)), ['FFFFFF'], toConsumableArray_default()(c.colors.slice(4)))
        };
      });
    },
    headersDays: function headersDays() {
      return !this.daysTmp.length ? [{ text: this.$t('allDays'), align: 'left', sortable: false }] : [{ text: this.$t('noDays'), align: 'left', sortable: false }];
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function $storeState_SitesSiteSelected(v) {
      if (v) {
        this.getOptions();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1172f532","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Preview.vue
var Preview_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"preview"}},[_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],attrs:{"color":"primary","value":"true","outline":""}},[_vm._v("\n      Ces réglages affectent le \"widget\" sur le site "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))]),_vm._v(". Le \"widget\" est le conteneur du tchat (mode en-ligne), du chatbot et du messaging (mode hors-ligne).\n    ")]),_vm._v(" "),(_vm.loadingGet)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('div',[_c('v-card',{staticClass:"mb-3"},[_c('v-list',[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("new_releases")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Widget Version Recommandée")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Cette version du widget est multi-device, et offre plus de possibilités de personnalisation")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-switch',{attrs:{"label":_vm.options.DSK_WIDGET_2019 ? 'ON' : 'OFF',"color":"primary","disabled":_vm.widget2019},model:{value:(_vm.options.DSK_WIDGET_2019),callback:function ($$v) {_vm.$set(_vm.options, "DSK_WIDGET_2019", $$v)},expression:"options.DSK_WIDGET_2019"}})],1)],1)],1)],1),_vm._v(" "),(_vm.options.DSK_WIDGET_2019)?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-expansion-panel',[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("color_lens")]),_vm._v("\n                Personnalisation graphique\n              ")],1),_vm._v(" "),_c('v-card',{staticClass:"ml-3"},[_c('v-expansion-panel',[_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_couleurs')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("color_lens")]),_vm._v("\n                    "+_vm._s(_vm._f("cap")(_vm.$tc('colors', 2, {count: ''})))+"\n                    "),_c('code',[_vm._v(_vm._s(_vm.color.text))])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-xl":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"xs12"},[_c('v-select',{attrs:{"dense":"","label":_vm._f("cap")(_vm.$t('colorShemes')),"items":_vm.colors2019,"return-object":"","box":"","menu-props":"auto"},on:{"input":function($event){_vm.updateColors2019()}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-list-tile-action',[_c('v-icon',{style:('color: #' + data.item.colors[0] + '!important'),attrs:{"left":""}},[_vm._v("color_lens")])],1),_vm._v(" "),_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item.text)}})]}},{key:"item",fn:function(data){return [_c('v-list-tile-action',[_c('v-icon',{style:('color: #' + data.item.colors[0] + '!important'),attrs:{"left":""}},[_vm._v("color_lens")])],1),_vm._v(" "),_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item.text)}})]}}]),model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((4),function(i){return _c('v-flex',{key:i,staticClass:"xs12 sm6",on:{"click":function($event){_vm.idxPicker = i - 1}}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","nudge-bottom":-20,"max-width":"225px"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm._f("cap")(_vm.colorsLabel[i - 1]),"readonly":"","prefix":"#","box":"","hint":_vm._f("cap")(_vm.colorsHint[i - 1]),"persistent-hint":""},slot:"activator",model:{value:(_vm.options.DSK_COLORS[i - 1]),callback:function ($$v) {_vm.$set(_vm.options.DSK_COLORS, i - 1, $$v)},expression:"options.DSK_COLORS[i - 1]"}},[_c('v-icon',{style:('color : #' + _vm.options.DSK_COLORS[i - 1] + ';'),attrs:{"slot":"append"},slot:"append"},[_vm._v("style")])],1),_vm._v(" "),_c('chrome-picker',{attrs:{"value":_vm.options.DSK_COLORS[i - 1]},on:{"input":_vm.updateFromPicker}})],1)],1)}),1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_dimensions')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("transform")]),_vm._v("\n                    "+_vm._s(_vm._f("cap")(_vm.$t('sizes')))+"\n                    "),_c('code',[_vm._v(_vm._s(_vm.options.DSK_WIDTH)+"px x "+_vm._s(_vm.options.DSK_HEIGHT)+"px")])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-slider',{attrs:{"min":300,"max":500,"thumb-label":"always","label":_vm._f("cap")(_vm.$t('width'))},model:{value:(_vm.options.DSK_WIDTH),callback:function ($$v) {_vm.$set(_vm.options, "DSK_WIDTH", $$v)},expression:"options.DSK_WIDTH"}},[_c('v-icon',{attrs:{"slot":"prepend"},on:{"click":function($event){_vm.options.DSK_WIDTH--}},slot:"prepend"},[_vm._v("\n                          remove_circle_outline\n                        ")]),_vm._v(" "),_c('v-icon',{attrs:{"slot":"append"},on:{"click":function($event){_vm.options.DSK_WIDTH++}},slot:"append"},[_vm._v("\n                          add_circle_outlines\n                        ")])],1),_vm._v(" "),_c('v-slider',{attrs:{"min":350,"max":500,"thumb-label":"always","label":_vm._f("cap")(_vm.$t('height'))},model:{value:(_vm.options.DSK_HEIGHT),callback:function ($$v) {_vm.$set(_vm.options, "DSK_HEIGHT", $$v)},expression:"options.DSK_HEIGHT"}},[_c('v-icon',{attrs:{"slot":"prepend"},on:{"click":function($event){_vm.options.DSK_HEIGHT--}},slot:"prepend"},[_vm._v("\n                          remove_circle_outline\n                        ")]),_vm._v(" "),_c('v-icon',{attrs:{"slot":"append"},on:{"click":function($event){_vm.options.DSK_HEIGHT++}},slot:"append"},[_vm._v("\n                          add_circle_outlines\n                        ")])],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_coins')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("rounded_corner")]),_vm._v("\n                    Arrondi des coins\n                    "),_c('code',[_vm._v(_vm._s(_vm.radius)+"px")])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-slider',{attrs:{"min":0,"max":12,"thumb-label":"always","label":'Arrondi des coins'},model:{value:(_vm.radius),callback:function ($$v) {_vm.radius=$$v},expression:"radius"}},[_c('v-icon',{attrs:{"slot":"prepend"},on:{"click":function($event){_vm.radius--}},slot:"prepend"},[_vm._v("\n                          remove_circle_outline\n                        ")]),_vm._v(" "),_c('v-icon',{attrs:{"slot":"append"},on:{"click":function($event){_vm.radius++}},slot:"append"},[_vm._v("\n                          add_circle_outlines\n                        ")])],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"expand":""}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("view_compact")]),_vm._v("\n                Positionnement sur la page\n              ")],1),_vm._v(" "),_c('v-card',{staticClass:"ml-3"},[_c('v-expansion-panel',[_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_position')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("view_compact")]),_vm._v("\n                    "+_vm._s(_vm._f("cap")(_vm.$t("position")))+" Desktop\n                    "),_c('code',[_vm._v(_vm._s(_vm.position))])],1),_vm._v(" "),_c('v-card',[_c('v-subheader',{staticClass:"ml-3"},[_vm._v("Placer Target First "+_vm._s(_vm.position))]),_vm._v(" "),_c('v-card-text',{staticClass:"mt-5",staticStyle:{"max-width":"300px"}},[_c('v-layout',{attrs:{"row":"","justify-space-between":"","mb-4":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"rotate ml-0",class:{primary : _vm.options.DSK_TAB_SIDE == 'LEFT'},attrs:{"small":"","light":""},on:{"click":function($event){_vm.options.DSK_TAB_SIDE = 'LEFT'}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","ml-0":""}},[_c('v-btn',{staticClass:"rotate mb-0",class:{primary : _vm.options.DSK_TAB_SIDE == 'RIGHT'},attrs:{"small":"","light":""},on:{"click":function($event){_vm.options.DSK_TAB_SIDE = 'RIGHT'}}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{staticClass:"ml-4",class:{primary : _vm.options.DSK_TAB_SIDE == 'BOTTOM' && _vm.options.DSK_TAB_POS == '0'},attrs:{"small":"","light":""},on:{"click":function($event){_vm.options.DSK_TAB_SIDE = 'BOTTOM'; _vm.options.DSK_TAB_POS = '0'}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{staticClass:"ml-3",class:{primary : _vm.options.DSK_TAB_SIDE == 'BOTTOM' && _vm.options.DSK_TAB_POS == '50'},attrs:{"small":"","light":""},on:{"click":function($event){_vm.options.DSK_TAB_SIDE = 'BOTTOM'; _vm.options.DSK_TAB_POS = '50'}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{class:{primary : _vm.options.DSK_TAB_SIDE == 'BOTTOM' && _vm.options.DSK_TAB_POS == '100'},attrs:{"small":"","light":""},on:{"click":function($event){_vm.options.DSK_TAB_SIDE = 'BOTTOM'; _vm.options.DSK_TAB_POS = '100'}}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_mobile_position')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("view_compact")]),_vm._v("\n                    Positionnement Mobile (état mini uniquement)\n                    "),_c('code',[_vm._v(_vm._s(_vm.positionMobile))])],1),_vm._v(" "),_c('v-card',[_c('v-subheader',{staticClass:"ml-3"},[_vm._v("Placer Target First "+_vm._s(_vm.positionMobile))]),_vm._v(" "),_c('v-card-text',{staticClass:"mt-5",staticStyle:{"max-width":"300px"}},[_c('v-layout',{attrs:{"row":"","justify-space-between":"","mb-4":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"rotate ml-0",class:{primary : _vm.options.DSK_TAB_SIDE_MOBILE == 'LEFT'},attrs:{"small":"","light":""},on:{"click":function($event){_vm.options.DSK_TAB_SIDE_MOBILE = 'LEFT'}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","ml-0":""}},[_c('v-btn',{staticClass:"rotate mb-0",class:{primary : _vm.options.DSK_TAB_SIDE_MOBILE == 'RIGHT'},attrs:{"small":"","light":""},on:{"click":function($event){_vm.options.DSK_TAB_SIDE_MOBILE = 'RIGHT'}}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{staticClass:"ml-4",class:{primary : _vm.options.DSK_TAB_SIDE_MOBILE == 'BOTTOM' && _vm.options.DSK_TAB_POS_MOBILE == '0'},attrs:{"small":"","light":""},on:{"click":function($event){_vm.options.DSK_TAB_SIDE_MOBILE = 'BOTTOM'; _vm.options.DSK_TAB_POS_MOBILE = '0'}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{staticClass:"ml-3",class:{primary : _vm.options.DSK_TAB_SIDE_MOBILE == 'BOTTOM' && _vm.options.DSK_TAB_POS_MOBILE == '50'},attrs:{"small":"","light":""},on:{"click":function($event){_vm.options.DSK_TAB_SIDE_MOBILE = 'BOTTOM'; _vm.options.DSK_TAB_POS_MOBILE = '50'}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{class:{primary : _vm.options.DSK_TAB_SIDE_MOBILE == 'BOTTOM' && _vm.options.DSK_TAB_POS_MOBILE == '100'},attrs:{"small":"","light":""},on:{"click":function($event){_vm.options.DSK_TAB_SIDE_MOBILE = 'BOTTOM'; _vm.options.DSK_TAB_POS_MOBILE = '100'}}})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("wb_iridescent")]),_vm._v("\n                Mode rétracté\n              ")],1),_vm._v(" "),_c('v-card',{staticClass:"ml-3"},[_c('v-expansion-panel',[_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_desk')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("wb_iridescent")]),_vm._v("\n                    "+_vm._s(_vm._f("cap")(_vm.$t("defaultAppearance")))+" desktop\n                    "),_c('code',[_vm._v(_vm._s(_vm.options.DSK_WIDGETSTATE === '3' ? _vm.$t('mini') : _vm.$t('middle')))])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-radio-group',{attrs:{"row":"","hint":_vm.$t('labelWidgetState'),"persistent-hint":""},model:{value:(_vm.options.DSK_WIDGETSTATE),callback:function ($$v) {_vm.$set(_vm.options, "DSK_WIDGETSTATE", $$v)},expression:"options.DSK_WIDGETSTATE"}},[_c('v-radio',{attrs:{"color":"primary","label":_vm._f("cap")(_vm.$t('mini')),"value":"3"}}),_vm._v(" "),_c('v-radio',{attrs:{"color":"primary","label":_vm._f("cap")(_vm.$t('middle')),"value":"2"}})],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_mobile_desk')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("wb_iridescent")]),_vm._v("\n                    "+_vm._s(_vm._f("cap")(_vm.$t("defaultAppearance")))+" mobile\n                    "),_c('code',[_vm._v(_vm._s(_vm.options.DSK_WIDGETSTATE_MOBILE === '3' ? _vm.$t('mini') : _vm.$t('middle')))])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-radio-group',{attrs:{"row":"","hint":_vm.$t('labelWidgetState'),"persistent-hint":""},model:{value:(_vm.options.DSK_WIDGETSTATE_MOBILE),callback:function ($$v) {_vm.$set(_vm.options, "DSK_WIDGETSTATE_MOBILE", $$v)},expression:"options.DSK_WIDGETSTATE_MOBILE"}},[_c('v-radio',{attrs:{"color":"primary","label":_vm._f("cap")(_vm.$t('mini')),"value":"3"}}),_vm._v(" "),_c('v-radio',{attrs:{"color":"primary","label":_vm._f("cap")(_vm.$t('middle')),"value":"2"}})],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_hide_moyen')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("visibility_off")]),_vm._v("\n                    Cacher l'état moyen\n                    "),_c('code',[_vm._v(_vm._s(_vm.options.DSK_HIDE_MIDDLE_STATE ? _vm.$t('yes') : _vm.$t('no')))])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-switch',{attrs:{"label":"Cacher l'état moyen","color":"primary","hint":"Compatible avec 'Apparence par défaut': 'Moyen'. En effet le widget pourra être en 'Moyen' par défaut, au début de la session du visiteur.","persistent-hint":""},model:{value:(_vm.options.DSK_HIDE_MIDDLE_STATE),callback:function ($$v) {_vm.$set(_vm.options, "DSK_HIDE_MIDDLE_STATE", $$v)},expression:"options.DSK_HIDE_MIDDLE_STATE"}})],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_conseiller')},nativeOn:{"click":function($event){_vm.loadImg(true)}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("photo")]),_vm._v("\n                    Avatar pour chat\n                  ")],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-sm":"","fluid":""}},[(_vm.imagesAgent.length)?_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.imagesAgent),function(img,i){return _c('v-flex',{key:i,attrs:{"xs2":"","d-flex":""}},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-card',{staticClass:"d-flex picto",class:("elevation-" + (hover ? 6 : 0)),staticStyle:{"cursor":"pointer"},attrs:{"flat":"","tile":"","id":'picto_' + i},on:{"click":function($event){_vm.updateImg(true, img, i)}}},[_c('v-img',{attrs:{"src":img}},[_c('v-layout',{attrs:{"slot":"placeholder","fill-height":"","align-center":"","justify-center":"","ma-0":""},slot:"placeholder"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)],1)],1)}}])})],1)}),1):_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_bot')},nativeOn:{"click":function($event){_vm.loadImg(false)}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("photo")]),_vm._v("\n                    Avatar pour chatbot\n                  ")],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-sm":"","fluid":""}},[(_vm.imagesBot.length)?_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.imagesBot),function(img,i){return _c('v-flex',{key:i,attrs:{"xs2":"","d-flex":""}},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-card',{staticClass:"d-flex picto",class:("elevation-" + (hover ? 6 : 0)),staticStyle:{"cursor":"pointer"},attrs:{"flat":"","tile":"","id":'picto_' + i},on:{"click":function($event){_vm.updateImg(false, img, i)}}},[_c('v-img',{attrs:{"src":img}},[_c('v-layout',{attrs:{"slot":"placeholder","fill-height":"","align-center":"","justify-center":"","ma-0":""},slot:"placeholder"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)],1)],1)}}])})],1)}),1):_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_sideon')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("chrome_reader_mode")]),_vm._v("\n                Mode déployé\n                "),_c('v-tooltip',{attrs:{"bottom":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.openDialog(
                    {
                      title: _vm.$t('titleInfoSideOn'),
                      content: _vm.$t('contentInfoSideOn')
                    }
                  )}}},[_c('template',{slot:"activator"},[_c('v-icon',{staticClass:"infos",attrs:{"color":"grey lighten-1","dark":""}},[_vm._v("info")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('enSavoirPlus')))])],2)],1),_vm._v(" "),_c('v-card',{staticClass:"ml-3"},[_c('v-card-text',[_c('v-switch',{attrs:{"label":"Side On (Desktop uniquement)","color":"primary","hint":_vm.$t('sideoneDesciption'),"persistent-hint":""},model:{value:(_vm.options.DSK_SIDEON),callback:function ($$v) {_vm.$set(_vm.options, "DSK_SIDEON", $$v)},expression:"options.DSK_SIDEON"}}),_vm._v(" "),_c('v-switch',{attrs:{"label":"Side hover (Desktop uniquement)","color":"primary","hint":_vm.$t('sideoneDescription2'),"persistent-hint":""},model:{value:(_vm.options.DSK_SIDEHOVER),callback:function ($$v) {_vm.$set(_vm.options, "DSK_SIDEHOVER", $$v)},expression:"options.DSK_SIDEHOVER"}})],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_hide_liste')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("people")]),_vm._v("\n                    "+_vm._s(_vm._f("cap")(_vm.$t("showAgentList")))+"\n                    "),_c('code',[_vm._v(_vm._s(_vm.options.DSK_HIDE_AGENT_LIST ? _vm.$t("yes") : _vm.$t("no")))])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-switch',{attrs:{"label":_vm.$t('showAgentList'),"color":"primary"},model:{value:(_vm.options.DSK_HIDE_AGENT_LIST),callback:function ($$v) {_vm.$set(_vm.options, "DSK_HIDE_AGENT_LIST", $$v)},expression:"options.DSK_HIDE_AGENT_LIST"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("text_fields")]),_vm._v("\n                "+_vm._s(_vm.$t('Contenu éditorial du widget'))+"\n              ")],1),_vm._v(" "),_c('v-card',{staticClass:"ml-3"},[_c('v-expansion-panel',[_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_lang')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("translate")]),_vm._v("\n                    Langue par défaut du widget\n                    "),_c('code',[_vm._v(_vm._s(_vm.options.DSK_GETELANG === '' ? _vm.$t("defaut") : _vm.options.DSK_GETELANG))])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-select',{attrs:{"dense":"","items":_vm.langsFront,"label":_vm.$t('language'),"prepend-icon":"translate"},model:{value:(_vm.options.DSK_GETELANG),callback:function ($$v) {_vm.$set(_vm.options, "DSK_GETELANG", $$v)},expression:"options.DSK_GETELANG"}}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("defautFrontlanguage"))))])],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_title_close')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("title")]),_vm._v("\n                    "+_vm._s(_vm._f("cap")(_vm.$t("widgetTitle")))+"\n                  ")],1),_vm._v(" "),_c('v-card',[_c('v-card-text',_vm._l((_vm.langs),function(l,i){return _c('v-text-field',{key:i,attrs:{"label":l.text},model:{value:(_vm.options.DSK_TAB_MSG_JSON[l.value]),callback:function ($$v) {_vm.$set(_vm.options.DSK_TAB_MSG_JSON, l.value, $$v)},expression:"options.DSK_TAB_MSG_JSON[l.value]"}})}),1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_title_offline')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("title")]),_vm._v("\n                    "+_vm._s(_vm._f("cap")(_vm.$t("widgetSubTitleOffline")))+"\n                  ")],1),_vm._v(" "),_c('v-card',[_c('v-card-text',_vm._l((_vm.langs),function(l,i){return _c('v-text-field',{key:i,attrs:{"label":l.text},model:{value:(_vm.options.DSK_TAB_MSG_JSON2[l.value]),callback:function ($$v) {_vm.$set(_vm.options.DSK_TAB_MSG_JSON2, l.value, $$v)},expression:"options.DSK_TAB_MSG_JSON2[l.value]"}})}),1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_title_online')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("title")]),_vm._v("\n                    "+_vm._s(_vm._f("cap")(_vm.$t("widgetSubTitleOnline")))+"\n                  ")],1),_vm._v(" "),_c('v-card',[_c('v-card-text',_vm._l((_vm.langs),function(l,i){return _c('v-text-field',{key:i,attrs:{"label":l.text},model:{value:(_vm.options.DSK_TAB_MSG_JSON3[l.value]),callback:function ($$v) {_vm.$set(_vm.options.DSK_TAB_MSG_JSON3, l.value, $$v)},expression:"options.DSK_TAB_MSG_JSON3[l.value]"}})}),1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("settings_applications")]),_vm._v("\n                Restrictions d'affichage (premier niveau)\n                "),_c('v-tooltip',{attrs:{"bottom":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.openDialog(
                    {
                      title: 'Où et Quand afficher le widget',
                      content: 'Les restrictions d\'affichage permettent de choisir les horaires et/ou les pages sur lesquelles le widget peut être affiché. Les fonctionnalités englobées dans le widget (chat, chatbot, messaging...) sont affectées par ces conditions. Les autres fonctionnalités qui ne font pas parties du widget (Callback, Meeting, SMS etc.) fonctionnent indépendamment de ces conditions.'
                    }
                  )}}},[_c('template',{slot:"activator"},[_c('v-icon',{staticClass:"infos",attrs:{"color":"grey lighten-1","dark":""}},[_vm._v("info")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('enSavoirPlus')))])],2)],1),_vm._v(" "),_c('v-card',{staticClass:"ml-3"},[_c('v-expansion-panel',[_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_affichage_horaire')},nativeOn:{"click":function($event){_vm.loadImg(false)}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("schedule")]),_vm._v("\n                    "+_vm._s(_vm._f("cap")(_vm.$t("displayTimes")))+"\n                  ")],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-radio-group',{attrs:{"hint":_vm.$t('defineWidgetHours'),"persistent-hint":""},model:{value:(_vm.form.hours),callback:function ($$v) {_vm.$set(_vm.form, "hours", $$v)},expression:"form.hours"}},[_c('v-radio',{attrs:{"label":_vm._f("cap")(_vm.$t('allTheTime')),"color":"primary","value":"all"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":_vm._f("cap")(_vm.$t('customHours')),"color":"primary","value":"defined"}})],1)],1)],1),_vm._v(" "),(_vm.form.hours == 'defined')?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"primary--text",attrs:{"flat":""},on:{"click":function($event){_vm.openHours()}}},[_vm._v(_vm._s(_vm.$t('timesSeveralDays'))),_c('v-icon',{attrs:{"right":""}},[_vm._v("event")])],1)],1),_vm._v(" "),_c('v-expansion-panel',_vm._l((_vm.form.days),function(day){return _c('v-expansion-panel-content',{key:day.name},[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":""},slot:"header"},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"hidden-md-and-up"},[_vm._v(_vm._s(day.name.substring(0, 3))+". : ")]),_vm._v(" "),_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(_vm._s(day.name)+" : ")]),_vm._v(" "),(day.am.active || day.pm.active)?_c('span',[(day.am.active)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('from'))),_c('code',[_vm._v(_vm._s(day.am.start))]),_vm._v(" "+_vm._s(_vm.$t('to'))+" "),_c('code',[_vm._v(_vm._s(day.am.end))])]):_vm._e(),_vm._v(" "),(day.am.active && day.pm.active)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('and')))]):_vm._e(),_vm._v(" "),(day.pm.active)?_c('span',[_vm._v(_vm._s(_vm.$t('from'))+" "),_c('code',[_vm._v(_vm._s(day.pm.start))]),_vm._v(" "+_vm._s(_vm.$t('to'))+" "),_c('code',[_vm._v(_vm._s(day.pm.end))])]):_vm._e()]):_c('span',[_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("disabledToday"))))])])])],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('activateMorning')),"light":"","color":"primary"},model:{value:(day.am.active),callback:function ($$v) {_vm.$set(day.am, "active", $$v)},expression:"day.am.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('from') + " " + (day.name) + " " + _vm.$t('morning'),"prepend-icon":"access_time","disabled":!day.am.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'am', 'start')}},slot:"activator",model:{value:(day.am.start),callback:function ($$v) {_vm.$set(day.am, "start", $$v)},expression:"day.am.start"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('to') + " " + (day.name) + " " + _vm.$t('morning'),"prepend-icon":"access_time","disabled":!day.am.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'am', 'end')}},slot:"activator",model:{value:(day.am.end),callback:function ($$v) {_vm.$set(day.am, "end", $$v)},expression:"day.am.end"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('activateAfternoon')),"light":"","color":"primary"},model:{value:(day.pm.active),callback:function ($$v) {_vm.$set(day.pm, "active", $$v)},expression:"day.pm.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('from') + " " + (day.name) + " " + _vm.$t('afternoon'),"prepend-icon":"access_time","disabled":!day.pm.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'pm', 'start')}},slot:"activator",model:{value:(day.pm.start),callback:function ($$v) {_vm.$set(day.pm, "start", $$v)},expression:"day.pm.start"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('to') + " " + (day.name) + " " + _vm.$t('afternoon'),"prepend-icon":"access_time","disabled":!day.pm.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'pm', 'end')}},slot:"activator",model:{value:(day.pm.end),callback:function ($$v) {_vm.$set(day.pm, "end", $$v)},expression:"day.pm.end"}})],1)],1)],1)],1)],1)}),1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_affichage_url')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("language")]),_vm._v(_vm._s(_vm._f("cap")(_vm.$t('urlDisplay'))))],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-radio-group',{attrs:{"hint":_vm.$t('chooseWhiteOrBlack'),"persistent-hint":""},model:{value:(_vm.form.urls),callback:function ($$v) {_vm.$set(_vm.form, "urls", $$v)},expression:"form.urls"}},[_c('v-radio',{attrs:{"label":_vm._f("cap")(_vm.$t('everywhere')),"color":"primary","value":"all"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"White List","color":"primary","value":"showOnOff"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Black List","color":"primary","value":"hideOnOff"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.urls != 'all'),expression:"form.urls != 'all'"}],attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',[_c('v-fab-transition',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.urls != 'all'),expression:"form.urls != 'all'"}],staticClass:"secondary",attrs:{"dark":"","absolute":"","top":"","right":"","fab":""},on:{"click":function($event){$event.stopPropagation();_vm.openRule()}}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersRules,"items":_vm.form.rules,"no-data-text":_vm.$t('noRules'),"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item.list === _vm.form.urls)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":props.item.type,"cancel-text":_vm.$t('cancel'),"save-text":_vm.$t('submit'),"large":""},on:{"update:returnValue":function($event){_vm.$set(props.item, "type", $event)}}},[_c('div',[_vm._v(_vm._s(props.item.type.text))]),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v(_vm._s(_vm.$t('changeType')))]),_vm._v(" "),_c('v-select',{attrs:{"slot":"input","items":_vm.typeRules,"return-object":"","autofocus":""},slot:"input",model:{value:(props.item.type),callback:function ($$v) {_vm.$set(props.item, "type", $$v)},expression:"props.item.type"}})],1)],1):_vm._e(),_vm._v(" "),(props.item.list === _vm.form.urls)?_c('td',[_c('v-edit-dialog',{attrs:{"cancel-text":_vm.$t('cancel'),"save-text":_vm.$t('submit'),"return-value":props.item.content,"large":"","lazy":""},on:{"update:returnValue":function($event){_vm.$set(props.item, "content", $event)}}},[_c('div',[_c('code',[_vm._v(_vm._s(props.item.content))])]),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v(_vm._s(_vm.$t('editContent')))]),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"input","label":"Modification","single-line":"","counter":"","autofocus":""},slot:"input",model:{value:(props.item.content),callback:function ($$v) {_vm.$set(props.item, "content", $$v)},expression:"props.item.content"}})],1)],1):_vm._e(),_vm._v(" "),(props.item.list === _vm.form.urls)?_c('td',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.deleteRule(props.index)}}},[_c('v-icon',[_vm._v("delete")])],1)],1):_vm._e()]}}])})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("settings_applications")]),_vm._v("\n                Conditions d'affichage ( second niveau)\n                "),_c('v-tooltip',{attrs:{"bottom":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.openDialog(
                    {
                      title: 'Conditions d\'affichage additionnelles',
                      content: 'Si les conditions d\'affichage de premier niveau le permettent (horaires, blacklists), on peut ensuite ajouter des critères supplémentaire de temps, de présence (agents connectés et en ligne) ainsi que des conditions de ciblage. Les fonctionnalités englobées dans le widget (chat, chatbot, messaging...) sont affectées par ces conditions. Les autres fonctionnalités qui ne font pas parties du widget (Callback, Meeting, SMS etc.) fonctionnent indépendamment de ces conditions.'
                    }
                  )}}},[_c('template',{slot:"activator"},[_c('v-icon',{staticClass:"infos",attrs:{"color":"grey lighten-1","dark":""}},[_vm._v("info")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('enSavoirPlus')))])],2)],1),_vm._v(" "),_c('v-card',{staticClass:"ml-3"},[_c('v-expansion-panel',[_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_affichage_perso')},nativeOn:{"click":function($event){_vm.loadImg(true)}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("settings_applications")]),_vm._v("\n                    "+_vm._s(_vm._f("cap")(_vm.$t("customHours")))+"\n                  ")],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('hideOnMobile')),"light":"","color":"primary"},model:{value:(_vm.form.hiddenMobile),callback:function ($$v) {_vm.$set(_vm.form, "hiddenMobile", $$v)},expression:"form.hiddenMobile"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.optsDisplayDefault,"label":_vm._f("cap")(_vm.$t('defaultView')),"return-object":""},model:{value:(_vm.form.displayDefault),callback:function ($$v) {_vm.$set(_vm.form, "displayDefault", $$v)},expression:"form.displayDefault"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":""}},[(_vm.form.displayDefault.value == 'default_timeout')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-slider',{attrs:{"thumb-label":"","min":0,"max":300},model:{value:(_vm.form.timeout),callback:function ($$v) {_vm.$set(_vm.form, "timeout", $$v)},expression:"form.timeout"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.form.timeout)+" sec.")])],1)],1):_vm._e()],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-tabs',{staticClass:"elevation-1",attrs:{"fixed-tabs":"","centered":"","slider-color":"secondary","color":"primary","dark":""},model:{value:(_vm.activeState2019),callback:function ($$v) {_vm.activeState2019=$$v},expression:"activeState2019"}},[_c('v-tab',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('big'))))]),_vm._v(" "),_c('v-tab',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('middle'))))]),_vm._v(" "),_c('v-tab',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('mini'))))])],1),_vm._v(" "),(_vm.activeState2019 == 1)?_c('v-tabs',{staticClass:"elevation-0",attrs:{"centered":"","color":"transparent"},model:{value:(_vm.botOrConseiller),callback:function ($$v) {_vm.botOrConseiller=$$v},expression:"botOrConseiller"}},[_c('v-tab',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('conseiller'))))]),_vm._v(" "),_c('v-tab',[_vm._v("bot")])],1):_vm._e(),_vm._v(" "),_c('v-card',{attrs:{"height":"550px"}},[_c('iframe',{attrs:{"width":"100%","height":"550","src":_vm.iframeInnerSrc2019,"frameborder":"0"}})]),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","flat":"","dark":"","block":_vm.$vuetify.breakpoint.xsOnly},nativeOn:{"click":function($event){_vm.resetOptions()}}},[_vm._v(_vm._s(_vm.$t('cancel'))),_c('v-icon',{staticClass:"primary--text",attrs:{"right":""}},[_vm._v("settings_backup_restore")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":_vm.$vuetify.breakpoint.xsOnly,"loading":_vm.loadingPost},nativeOn:{"click":function($event){_vm.postOptions()}}},[_vm._v(_vm._s(_vm.$t('save'))),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("save")])],1)],1)],1)],1):_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_couleurs'),"value":"true"}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("color_lens")]),_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('colors', 2, {count: ''})))),_c('code',[_vm._v(_vm._s(_vm.color.text))])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"xs12 md4"},[_c('v-select',{attrs:{"dense":"","label":_vm.$t('colorShemes'),"items":_vm.colors,"return-object":""},on:{"input":function($event){_vm.updateColors()}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-list-tile-action',[_c('v-icon',{style:('color: #' + data.item.colors[0] + '!important'),attrs:{"left":""}},[_vm._v("color_lens")])],1),_vm._v(" "),_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item.text)}})]}},{key:"item",fn:function(data){return [_c('v-list-tile-action',[_c('v-icon',{style:('color: #' + data.item.colors[0] + '!important'),attrs:{"left":""}},[_vm._v("color_lens")])],1),_vm._v(" "),_c('v-list-tile-content',{domProps:{"textContent":_vm._s(data.item.text)}})]}}]),model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"xs2"},[_c('v-subheader')],1),_vm._v(" "),_c('v-flex',{staticClass:"xs10 sm4 md10 lg4",on:{"click":function($event){_vm.idxPicker = 0}}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","nudge-bottom":-20,"max-width":"225px"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('primaryColor'),"readonly":"","prefix":"#"},slot:"activator",model:{value:(_vm.options.DSK_COLORS[0]),callback:function ($$v) {_vm.$set(_vm.options.DSK_COLORS, 0, $$v)},expression:"options.DSK_COLORS[0]"}},[_c('v-icon',{style:('color : #' + _vm.options.DSK_COLORS[0] + ';'),attrs:{"slot":"append"},slot:"append"},[_vm._v("style")])],1),_vm._v(" "),_c('chrome-picker',{attrs:{"value":_vm.options.DSK_COLORS[0]},on:{"input":_vm.updateFromPicker}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs2"},[_c('v-subheader')],1),_vm._v(" "),_c('v-flex',{staticClass:"xs10 sm4 md10 lg4",on:{"click":function($event){_vm.idxPicker = 1}}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","nudge-bottom":-20,"max-width":"225px"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('secondaryColor'),"readonly":"","prefix":"#"},slot:"activator",model:{value:(_vm.options.DSK_COLORS[1]),callback:function ($$v) {_vm.$set(_vm.options.DSK_COLORS, 1, $$v)},expression:"options.DSK_COLORS[1]"}},[_c('v-icon',{style:('color : #' + _vm.options.DSK_COLORS[1] + ';'),attrs:{"slot":"append"},slot:"append"},[_vm._v("style")])],1),_vm._v(" "),_c('chrome-picker',{attrs:{"value":_vm.options.DSK_COLORS[1]},on:{"input":_vm.updateFromPicker}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs2"},[_c('v-subheader')],1),_vm._v(" "),_c('v-flex',{staticClass:"xs10 sm4 md10 lg4",on:{"click":function($event){_vm.idxPicker = 2}}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","nudge-bottom":-20,"max-width":"225px"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('backgroundColor'),"readonly":"","prefix":"#"},slot:"activator",model:{value:(_vm.options.DSK_COLORS[2]),callback:function ($$v) {_vm.$set(_vm.options.DSK_COLORS, 2, $$v)},expression:"options.DSK_COLORS[2]"}},[_c('v-icon',{style:('color : #' + _vm.options.DSK_COLORS[2] + ';'),attrs:{"slot":"append"},slot:"append"},[_vm._v("style")])],1),_vm._v(" "),_c('chrome-picker',{attrs:{"value":_vm.options.DSK_COLORS[2]},on:{"input":_vm.updateFromPicker}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs2"},[_c('v-subheader')],1),_vm._v(" "),_c('v-flex',{staticClass:"xs10 sm4 md10 lg4",on:{"click":function($event){_vm.idxPicker = 3}}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","nudge-bottom":-20,"max-width":"225px"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('iconsColor'),"readonly":"","prefix":"#"},slot:"activator",model:{value:(_vm.options.DSK_COLORS[3]),callback:function ($$v) {_vm.$set(_vm.options.DSK_COLORS, 3, $$v)},expression:"options.DSK_COLORS[3]"}},[_c('v-icon',{style:('color : #' + _vm.options.DSK_COLORS[3] + ';'),attrs:{"slot":"append"},slot:"append"},[_vm._v("style")])],1),_vm._v(" "),_c('chrome-picker',{attrs:{"value":_vm.options.DSK_COLORS[3]},on:{"input":_vm.updateFromPicker}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs2"},[_c('v-subheader')],1),_vm._v(" "),_c('v-flex',{staticClass:"xs10 sm4 md10 lg4",on:{"click":function($event){_vm.idxPicker = 4}}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","nudge-bottom":-20,"max-width":"225px"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('colorDetail'),"readonly":"","prefix":"#"},slot:"activator",model:{value:(_vm.options.DSK_COLORS[4]),callback:function ($$v) {_vm.$set(_vm.options.DSK_COLORS, 4, $$v)},expression:"options.DSK_COLORS[4]"}},[_c('v-icon',{style:('color : #' + _vm.options.DSK_COLORS[4] + ';'),attrs:{"slot":"append"},slot:"append"},[_vm._v("style")])],1),_vm._v(" "),_c('chrome-picker',{attrs:{"value":_vm.options.DSK_COLORS[4]},on:{"input":_vm.updateFromPicker}})],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"xs2"},[_c('v-subheader')],1),_vm._v(" "),_c('v-flex',{staticClass:"xs10 sm4 md10 lg4",on:{"click":function($event){_vm.idxPicker = 5}}},[_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","offset-y":"","nudge-bottom":-20,"max-width":"225px"}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('colorDetail'),"readonly":"","prefix":"#"},slot:"activator",model:{value:(_vm.options.DSK_COLORS[5]),callback:function ($$v) {_vm.$set(_vm.options.DSK_COLORS, 5, $$v)},expression:"options.DSK_COLORS[5]"}},[_c('v-icon',{style:('color : #' + _vm.options.DSK_COLORS[5] + ';'),attrs:{"slot":"append"},slot:"append"},[_vm._v("style")])],1),_vm._v(" "),_c('chrome-picker',{attrs:{"value":_vm.options.DSK_COLORS[5]},on:{"input":_vm.updateFromPicker}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_dimensions')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("transform")]),_vm._v(_vm._s(_vm._f("cap")(_vm.$t('sizes')))),_c('code',[_vm._v(_vm._s(_vm.options.DSK_WIDTH)+"px x "+_vm._s(_vm.options.DSK_HEIGHT)+"px")])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-slider',{attrs:{"label":_vm.$t('width'),"min":300,"max":500,"thumb-label":""},model:{value:(_vm.options.DSK_WIDTH),callback:function ($$v) {_vm.$set(_vm.options, "DSK_WIDTH", $$v)},expression:"options.DSK_WIDTH"}}),_vm._v(" "),_c('v-slider',{attrs:{"label":_vm.$t('height'),"min":350,"max":500,"thumb-label":""},model:{value:(_vm.options.DSK_HEIGHT),callback:function ($$v) {_vm.$set(_vm.options, "DSK_HEIGHT", $$v)},expression:"options.DSK_HEIGHT"}})],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_position')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("view_compact")]),_vm._v(_vm._s(_vm._f("cap")(_vm.$t("position")))),_c('code',[_vm._v(_vm._s(_vm.position))])],1),_vm._v(" "),_c('v-card',[_c('v-subheader',{staticClass:"ml-3"},[_vm._v("Placer Target First "+_vm._s(_vm.position))]),_vm._v(" "),_c('v-card-text',{staticClass:"mt-5",staticStyle:{"max-width":"300px"}},[_c('v-layout',{attrs:{"row":"","justify-space-between":"","mb-4":""}},[_c('v-flex',{attrs:{"xs1":""}},[_c('v-btn',{staticClass:"rotate ml-0",class:{primary : _vm.options.DSK_TAB_SIDE == 'LEFT'},attrs:{"small":"","light":""},on:{"click":function($event){_vm.options.DSK_TAB_SIDE = 'LEFT'}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","ml-0":""}},[_c('v-btn',{staticClass:"rotate mb-0",class:{primary : _vm.options.DSK_TAB_SIDE == 'RIGHT'},attrs:{"small":"","light":""},on:{"click":function($event){_vm.options.DSK_TAB_SIDE = 'RIGHT'}}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-between":""}},[_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{staticClass:"ml-4",class:{primary : _vm.options.DSK_TAB_SIDE == 'BOTTOM' && _vm.options.DSK_TAB_POS == '0'},attrs:{"small":"","light":""},on:{"click":function($event){_vm.options.DSK_TAB_SIDE = 'BOTTOM'; _vm.options.DSK_TAB_POS = '0'}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{staticClass:"ml-3",class:{primary : _vm.options.DSK_TAB_SIDE == 'BOTTOM' && _vm.options.DSK_TAB_POS == '50'},attrs:{"small":"","light":""},on:{"click":function($event){_vm.options.DSK_TAB_SIDE = 'BOTTOM'; _vm.options.DSK_TAB_POS = '50'}}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('v-btn',{class:{primary : _vm.options.DSK_TAB_SIDE == 'BOTTOM' && _vm.options.DSK_TAB_POS == '100'},attrs:{"small":"","light":""},on:{"click":function($event){_vm.options.DSK_TAB_SIDE = 'BOTTOM'; _vm.options.DSK_TAB_POS = '100'}}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_position')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("wb_iridescent")]),_vm._v(_vm._s(_vm._f("cap")(_vm.$t("defaultAppearance")))),_c('code',[_vm._v(_vm._s((_vm.options.DSK_OPTIONS_2 === 'none') ? _vm.$t('closed') : 'Ouvert'))])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.options.DSK_OPTIONS_2),callback:function ($$v) {_vm.$set(_vm.options, "DSK_OPTIONS_2", $$v)},expression:"options.DSK_OPTIONS_2"}},[_c('v-radio',{staticClass:"primary--text",attrs:{"label":_vm.$t('open'),"value":"default_open"}}),_vm._v(" "),_c('v-radio',{staticClass:"primary--text",attrs:{"label":_vm.$t('closed'),"value":"none"}})],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("panorama")]),_vm._v(_vm._s(_vm._f("cap")(_vm.$t("customChat")))),_c('code',[_vm._v(_vm._s(_vm.options.DSK_ACTIVE_PERSO_FO ? _vm.$t('yes') : _vm.$t('no')))])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-switch',{attrs:{"label":_vm.$t('activateCustomChat'),"color":"primary"},model:{value:(_vm.options.DSK_ACTIVE_PERSO_FO),callback:function ($$v) {_vm.$set(_vm.options, "DSK_ACTIVE_PERSO_FO", $$v)},expression:"options.DSK_ACTIVE_PERSO_FO"}}),_vm._v(" "),_c('v-tabs',{attrs:{"fixed-tabs":"","centered":"","slider-color":"secondary","color":"primary","dark":""}},[_c('v-tab',{attrs:{"disabled":_vm.imgLoading,"href":"#online"}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("connected"))))]),_vm._v(" "),_c('v-tab',{attrs:{"disabled":_vm.imgLoading,"href":"#offline"}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("disconnected"))))]),_vm._v(" "),_c('v-tab-item',{attrs:{"value":"online"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-switch',{attrs:{"label":_vm.$t('showOnlineAgent'),"color":"primary","disabled":!_vm.options.DSK_ACTIVE_PERSO_FO},model:{value:(_vm.options.DSK_PERSO_FO_ONLINE),callback:function ($$v) {_vm.$set(_vm.options, "DSK_PERSO_FO_ONLINE", $$v)},expression:"options.DSK_PERSO_FO_ONLINE"}}),_vm._v(" "),_c('wz-file-selector',{attrs:{"disabled":_vm.imgLoading || !_vm.options.DSK_ACTIVE_PERSO_FO,"tile":""},on:{"change":function($event){_vm.saveImg('online', $event)}}})],1)],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"value":"offline"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-switch',{attrs:{"label":_vm.$t('showNoOnlineAgent'),"color":"primary","disabled":!_vm.options.DSK_ACTIVE_PERSO_FO},model:{value:(_vm.options.DSK_PERSO_FO_OFFLINE),callback:function ($$v) {_vm.$set(_vm.options, "DSK_PERSO_FO_OFFLINE", $$v)},expression:"options.DSK_PERSO_FO_OFFLINE"}}),_vm._v(" "),_c('wz-file-selector',{attrs:{"disabled":_vm.imgLoading || !_vm.options.DSK_ACTIVE_PERSO_FO,"tile":""},on:{"change":function($event){_vm.saveImg('offline', $event)}}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_conseiller')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("people")]),_vm._v(_vm._s(_vm._f("cap")(_vm.$t("showAgentList")))),_c('code',[_vm._v(_vm._s(_vm.options.DSK_HIDE_AGENT_LIST ? _vm.$t("yes") : _vm.$t("no")))])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-switch',{attrs:{"label":_vm.$t('showAgentList'),"color":"primary"},model:{value:(_vm.options.DSK_HIDE_AGENT_LIST),callback:function ($$v) {_vm.$set(_vm.options, "DSK_HIDE_AGENT_LIST", $$v)},expression:"options.DSK_HIDE_AGENT_LIST"}})],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_lang')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("translate")]),_vm._v(_vm._s(_vm._f("cap")(_vm.$t("frontLanguage")))),_c('code',[_vm._v(_vm._s(_vm.options.DSK_GETELANG === '' ? _vm.$t("defaut") : _vm.options.DSK_GETELANG))])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-select',{attrs:{"dense":"","items":_vm.langsFront,"label":_vm.$t('language'),"prepend-icon":"translate"},model:{value:(_vm.options.DSK_GETELANG),callback:function ($$v) {_vm.$set(_vm.options, "DSK_GETELANG", $$v)},expression:"options.DSK_GETELANG"}}),_vm._v(" "),_c('small',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("defautFrontlanguage"))))])],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_title_close')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("title")]),_vm._v(_vm._s(_vm._f("cap")(_vm.$t("widgetTitle"))))],1),_vm._v(" "),_c('v-card',[_c('v-card-text',_vm._l((_vm.langs),function(l,i){return _c('v-text-field',{key:i,attrs:{"label":l.text},model:{value:(_vm.options.DSK_TAB_MSG_JSON[l.value]),callback:function ($$v) {_vm.$set(_vm.options.DSK_TAB_MSG_JSON, l.value, $$v)},expression:"options.DSK_TAB_MSG_JSON[l.value]"}})}),1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_affichage_horaire')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("schedule")]),_vm._v(_vm._s(_vm._f("cap")(_vm.$t("displayTimes"))))],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-radio-group',{attrs:{"hint":_vm.$t('defineWidgetHours'),"persistent-hint":""},model:{value:(_vm.form.hours),callback:function ($$v) {_vm.$set(_vm.form, "hours", $$v)},expression:"form.hours"}},[_c('v-radio',{attrs:{"label":_vm._f("cap")(_vm.$t('allTheTime')),"color":"primary","value":"all"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":_vm._f("cap")(_vm.$t('customHours')),"color":"primary","value":"defined"}})],1)],1)],1),_vm._v(" "),(_vm.form.hours == 'defined')?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"primary--text",attrs:{"flat":""},on:{"click":function($event){_vm.openHours()}}},[_vm._v(_vm._s(_vm.$t('timesSeveralDays'))),_c('v-icon',{attrs:{"right":""}},[_vm._v("event")])],1)],1),_vm._v(" "),_c('v-expansion-panel',_vm._l((_vm.form.days),function(day){return _c('v-expansion-panel-content',{key:day.name},[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":""},slot:"header"},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"hidden-md-and-up"},[_vm._v(_vm._s(day.name.substring(0, 3))+". : ")]),_vm._v(" "),_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(_vm._s(day.name)+" : ")]),_vm._v(" "),(day.am.active || day.pm.active)?_c('span',[(day.am.active)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('from'))),_c('code',[_vm._v(_vm._s(day.am.start))]),_vm._v(" "+_vm._s(_vm.$t('to'))+" "),_c('code',[_vm._v(_vm._s(day.am.end))])]):_vm._e(),_vm._v(" "),(day.am.active && day.pm.active)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('and')))]):_vm._e(),_vm._v(" "),(day.pm.active)?_c('span',[_vm._v(_vm._s(_vm.$t('from'))+" "),_c('code',[_vm._v(_vm._s(day.pm.start))]),_vm._v(" "+_vm._s(_vm.$t('to'))+" "),_c('code',[_vm._v(_vm._s(day.pm.end))])]):_vm._e()]):_c('span',[_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("disabledToday"))))])])])],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('activateMorning')),"light":"","color":"primary"},model:{value:(day.am.active),callback:function ($$v) {_vm.$set(day.am, "active", $$v)},expression:"day.am.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('from') + " " + (day.name) + " " + _vm.$t('morning'),"prepend-icon":"access_time","disabled":!day.am.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'am', 'start')}},slot:"activator",model:{value:(day.am.start),callback:function ($$v) {_vm.$set(day.am, "start", $$v)},expression:"day.am.start"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('to') + " " + (day.name) + " " + _vm.$t('morning'),"prepend-icon":"access_time","disabled":!day.am.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'am', 'end')}},slot:"activator",model:{value:(day.am.end),callback:function ($$v) {_vm.$set(day.am, "end", $$v)},expression:"day.am.end"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('activateAfternoon')),"light":"","color":"primary"},model:{value:(day.pm.active),callback:function ($$v) {_vm.$set(day.pm, "active", $$v)},expression:"day.pm.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('from') + " " + (day.name) + " " + _vm.$t('afternoon'),"prepend-icon":"access_time","disabled":!day.pm.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'pm', 'start')}},slot:"activator",model:{value:(day.pm.start),callback:function ($$v) {_vm.$set(day.pm, "start", $$v)},expression:"day.pm.start"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('to') + " " + (day.name) + " " + _vm.$t('afternoon'),"prepend-icon":"access_time","disabled":!day.pm.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'pm', 'end')}},slot:"activator",model:{value:(day.pm.end),callback:function ($$v) {_vm.$set(day.pm, "end", $$v)},expression:"day.pm.end"}})],1)],1)],1)],1)],1)}),1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_affichage_url')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("language")]),_vm._v(_vm._s(_vm._f("cap")(_vm.$t('urlDisplay'))))],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-radio-group',{attrs:{"hint":_vm.$t('chooseWhiteOrBlack'),"persistent-hint":""},model:{value:(_vm.form.urls),callback:function ($$v) {_vm.$set(_vm.form, "urls", $$v)},expression:"form.urls"}},[_c('v-radio',{attrs:{"label":_vm._f("cap")(_vm.$t('everywhere')),"color":"primary","value":"all"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"White List","color":"primary","value":"showOnOff"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Black List","color":"primary","value":"hideOnOff"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.urls != 'all'),expression:"form.urls != 'all'"}],attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',[_c('v-fab-transition',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.urls != 'all'),expression:"form.urls != 'all'"}],staticClass:"secondary",attrs:{"dark":"","absolute":"","top":"","right":"","fab":""},on:{"click":function($event){$event.stopPropagation();_vm.openRule()}}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersRules,"items":_vm.form.rules,"no-data-text":_vm.$t('noRules'),"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item.list === _vm.form.urls)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":props.item.type,"cancel-text":_vm.$t('cancel'),"save-text":_vm.$t('submit'),"large":""},on:{"update:returnValue":function($event){_vm.$set(props.item, "type", $event)}}},[_c('div',[_vm._v(_vm._s(props.item.type.text))]),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v(_vm._s(_vm.$t('changeType')))]),_vm._v(" "),_c('v-select',{attrs:{"slot":"input","items":_vm.typeRules,"return-object":"","autofocus":""},slot:"input",model:{value:(props.item.type),callback:function ($$v) {_vm.$set(props.item, "type", $$v)},expression:"props.item.type"}})],1)],1):_vm._e(),_vm._v(" "),(props.item.list === _vm.form.urls)?_c('td',[_c('v-edit-dialog',{attrs:{"cancel-text":_vm.$t('cancel'),"save-text":_vm.$t('submit'),"return-value":props.item.content,"large":"","lazy":""},on:{"update:returnValue":function($event){_vm.$set(props.item, "content", $event)}}},[_c('div',[_c('code',[_vm._v(_vm._s(props.item.content))])]),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v(_vm._s(_vm.$t('editContent')))]),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"input","label":"Modification","single-line":"","counter":"","autofocus":""},slot:"input",model:{value:(props.item.content),callback:function ($$v) {_vm.$set(props.item, "content", $$v)},expression:"props.item.content"}})],1)],1):_vm._e(),_vm._v(" "),(props.item.list === _vm.form.urls)?_c('td',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.deleteRule(props.index)}}},[_c('v-icon',[_vm._v("delete")])],1)],1):_vm._e()]}}])})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_affichage_perso')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("settings_applications")]),_vm._v(_vm._s(_vm._f("cap")(_vm.$t("customHours"))))],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('hideOnMobile')),"light":"","color":"primary"},model:{value:(_vm.form.hiddenMobile),callback:function ($$v) {_vm.$set(_vm.form, "hiddenMobile", $$v)},expression:"form.hiddenMobile"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-select',{attrs:{"items":_vm.optsDisplayDefault,"label":_vm._f("cap")(_vm.$t('defaultView')),"return-object":""},model:{value:(_vm.form.displayDefault),callback:function ($$v) {_vm.$set(_vm.form, "displayDefault", $$v)},expression:"form.displayDefault"}})],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":""}},[(_vm.form.displayDefault.value == 'default_timeout')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs8":""}},[_c('v-slider',{attrs:{"thumb-label":"","min":0,"max":300},model:{value:(_vm.form.timeout),callback:function ($$v) {_vm.$set(_vm.form, "timeout", $$v)},expression:"form.timeout"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.form.timeout)+" sec.")])],1)],1):_vm._e()],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-tabs',{staticClass:"elevation-1",attrs:{"fixed-tabs":"","centered":"","slider-color":"secondary","color":"primary","dark":""}},[_c('v-tab',{attrs:{"href":"#opened"},on:{"click":function($event){_vm.widgetOpen = true}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("open"))))]),_vm._v(" "),_c('v-tab',{attrs:{"href":"#closed"},on:{"click":function($event){_vm.widgetOpen = false}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("close"))))]),_vm._v(" "),_c('v-tab-item',{attrs:{"value":"opened"}},[_c('v-card',{attrs:{"height":"600px"}},[_c('v-card-text',[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.widgetOpen),expression:"widgetOpen"}],staticClass:"widget-latin--open"},[_c('div',{staticClass:"widget-latin--open__photo"},[_c('wz-avatar',{attrs:{"src":_vm.$store.getters['_User/userAvatar'],"username":_vm.$store.getters['_User/fullName'],"size":"46px"}})],1),_vm._v(" "),_c('div',{staticClass:"widget-latin--open__agent"},[_c('div',{staticClass:"widget-latin--open__agent-name",style:('color: #' + _vm.options.DSK_COLORS[0])},[_vm._v(_vm._s(_vm.$store.getters['_User/fullName']))]),_vm._v(" "),_c('div',{staticClass:"widget-latin--open__agent-job",style:('color: #' + _vm.options.DSK_COLORS[1])},[_vm._v(_vm._s(_vm.$store.state._User.job))])])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.widgetOpen),expression:"widgetOpen"}]},[_c('iframe',{attrs:{"id":"iframe-open","width":"100%","height":"500","src":_vm.iframeInnerSrc,"frameborder":"0"}})])])],1)],1),_vm._v(" "),_c('v-tab-item',{attrs:{"value":"closed"}},[_c('v-card',{attrs:{"height":"600px"}},[_c('v-card-text',[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.widgetOnline),callback:function ($$v) {_vm.widgetOnline=$$v},expression:"widgetOnline"}},[_c('v-radio',{staticClass:"primary--text",attrs:{"label":_vm.$t('connected'),"value":true}}),_vm._v(" "),_c('v-radio',{staticClass:"primary--text",attrs:{"label":_vm.$t('disconnected'),"value":false}})],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.widgetOpen && _vm.showIframeOuter),expression:"!widgetOpen && showIframeOuter"}],staticClass:"widget-latin--close",class:{'rotate' : _vm.options.DSK_TAB_SIDE !== 'BOTTOM'}},[_c('div',{staticClass:"widget-latin--close__title",style:('color: #' + _vm.options.DSK_COLORS[5])},[_vm._v(_vm._s(_vm.options.DSK_TAB_MSG_JSON.FR))])]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.widgetOpen && _vm.showIframeOuter),expression:"!widgetOpen && showIframeOuter"}]},[_c('iframe',{attrs:{"id":"iframe--close","width":"100%","height":"500","src":_vm.iframeOuterSrc,"frameborder":"0"}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.showIframeOuter),expression:"!showIframeOuter"}]},[(_vm.widgetOnline)?_c('img',{staticClass:"persoOnline",attrs:{"src":_vm.persoFoOnlineSrc}}):_c('img',{staticClass:"persoOffline",attrs:{"src":_vm.persoFoOfflineSrc}})])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","flat":"","dark":"","block":_vm.$vuetify.breakpoint.xsOnly},nativeOn:{"click":function($event){_vm.resetOptions()}}},[_vm._v(_vm._s(_vm.$t('cancel'))),_c('v-icon',{staticClass:"primary--text",attrs:{"right":""}},[_vm._v("settings_backup_restore")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":_vm.$vuetify.breakpoint.xsOnly,"loading":_vm.loadingPost},nativeOn:{"click":function($event){_vm.postOptions()}}},[_vm._v(_vm._s(_vm.$t('save'))),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("save")])],1)],1)],1)],1)],1),_vm._v(" "),_c('wz-dialog-infos',{attrs:{"titleDialog":_vm.titleDialog,"contentDialog":_vm.contentDialog},on:{"fermeDialog":_vm.fermeDialogInfos}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","lazy":"","max-width":"290"},model:{value:(_vm.showTp),callback:function ($$v) {_vm.showTp=$$v},expression:"showTp"}},[_c('v-time-picker',{attrs:{"actions":"","scrollable":"","format":"24hr","max":_vm.allowed.hours.max,"min":_vm.allowed.hours.min,"color":"primary"},model:{value:(_vm.daySelected[_vm.amOrPm][_vm.startOrEnd]),callback:function ($$v) {_vm.$set(_vm.daySelected[_vm.amOrPm], _vm.startOrEnd, $$v)},expression:"daySelected[amOrPm][startOrEnd]"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showTp = false; _vm.daySelected[_vm.amOrPm][_vm.startOrEnd] = _vm.tmpHours}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('cancel'))))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.showTp = false}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('submit'))))])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","width":"350px"},model:{value:(_vm.showHours),callback:function ($$v) {_vm.showHours=$$v},expression:"showHours"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('applySchedules'))))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"400px"}},[_c('v-select',{attrs:{"items":_vm.days,"label":_vm.$t('applyHours'),"return-object":""},model:{value:(_vm.dayHours),callback:function ($$v) {_vm.dayHours=$$v},expression:"dayHours"}}),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersDays,"items":_vm.days,"item-key":"text","select-all":"primary","hide-actions":"","total-items":7},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(props.header.text))])]}},{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{staticClass:"primary--text",attrs:{"hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.text))])]}}]),model:{value:(_vm.daysTmp),callback:function ($$v) {_vm.daysTmp=$$v},expression:"daysTmp"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showHours = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.daysTmp.length,"color":"primary","flat":""},on:{"click":function($event){_vm.submitHours()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.showDialogRule),callback:function ($$v) {_vm.showDialogRule=$$v},expression:"showDialogRule"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("createRule"))))]),_vm._v(" "),_c('v-card-text',[_c('form',[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.typeRules,"label":_vm.$t('ruleType'),"return-object":"","required":"","data-vv-name":"select","error":_vm.wzErrors.has('select'),"error-messages":_vm.wzErrors.collect('select')},model:{value:(_vm.ruleTmp.type),callback:function ($$v) {_vm.$set(_vm.ruleTmp, "type", $$v)},expression:"ruleTmp.type"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autofocus":"","label":_vm.$t('ruleContent'),"required":"","data-vv-name":"ruleContentInput","error":_vm.wzErrors.has('ruleContentInput'),"error-messages":_vm.wzErrors.collect('ruleContentInput')},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.submitRule()}},model:{value:(_vm.ruleTmp.content),callback:function ($$v) {_vm.$set(_vm.ruleTmp, "content", $$v)},expression:"ruleTmp.content"}})],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showDialogRule = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.wzErrors.any(),"flat":""},on:{"click":function($event){_vm.submitRule()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":1},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)}
var Preview_staticRenderFns = []
var Preview_esExports = { render: Preview_render, staticRenderFns: Preview_staticRenderFns }
/* harmony default export */ var settings_Preview = (Preview_esExports);
// CONCATENATED MODULE: ./src/components/settings/Preview.vue
function Preview_injectStyle (ssrContext) {
  __webpack_require__("jwDw")
}
var Preview_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Preview___vue_template_functional__ = false
/* styles */
var Preview___vue_styles__ = Preview_injectStyle
/* scopeId */
var Preview___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Preview___vue_module_identifier__ = null
var Preview_Component = Preview_normalizeComponent(
  Preview,
  settings_Preview,
  Preview___vue_template_functional__,
  Preview___vue_styles__,
  Preview___vue_scopeId__,
  Preview___vue_module_identifier__
)

/* harmony default export */ var components_settings_Preview = (Preview_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/settings/Absence.vue




/* harmony default export */ var Absence = ({
  data: function data() {
    return {
      dialogProgress: false,
      messagingOnOff: false,
      absOnOff: true,
      warningMessagingOff: false,
      warningMessagingOn: false,
      titleDialog: '',
      contentDialog: '',
      abs: {
        active: true,
        rgpd: '',
        fields: [],
        required: ['question']
      },
      DSK_NOBODY_MSG1: '',
      DSK_NOBODY_MSG2: '',
      langs: [{ text: lodash_default.a.upperFirst(this.$t('french')), value: 'FR' }, { text: lodash_default.a.upperFirst(this.$t('english')), value: 'EN' }, { text: lodash_default.a.upperFirst(this.$t('spanish')), value: 'ES' }, { text: lodash_default.a.upperFirst(this.$t('german')), value: 'DE' }, { text: lodash_default.a.upperFirst(this.$t('italian')), value: 'IT' }, { text: lodash_default.a.upperFirst(this.$t('portuguese')), value: 'PT' }],
      displayDefault: {},
      itemsFieldsAbs: [{ text: 'Prénom', value: 'fname' }, { text: 'Nom', value: 'lname' }, { text: 'Téléphone', value: 'tel' }, { text: 'Email', value: 'email' }, { text: 'Société', value: 'company' }, { text: 'Question/Message', value: 'question' }],

      loadingGet: false,
      loadingPost: false,

      showDialogCreate: false,
      showDialogMotif: false
    };
  },
  created: function created() {
    this.getOptions();

    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'settings_absence';
    } else {
      setTimeout(function () {
        if (typeof defautMotif !== 'undefined') {
          defautMotif = 'settings_absence';
        }
      }, 800);
    }
  },
  mounted: function mounted() {
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
  },


  methods: {
    openDialog: function openDialog(data) {
      this.titleDialog = data.title;
      this.contentDialog = data.content;
    },
    fermeDialogInfos: function fermeDialogInfos() {
      this.titleDialog = '';
    },
    testBrideStatus: function testBrideStatus(name) {
      var brides = this.$store.state._User.brides;

      if (brides) {
        var resultat = brides.find(function (brides) {
          return brides.brideName === name;
        });
        if (resultat) {
          if (resultat.status === '0') {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    getOptions: function getOptions() {
      var _this = this;

      this.loadingGet = true;
      this.axios.get('get/settings_absence.php?desk=' + this.$store.state._Sites.siteSelected.LIC_DSK_ID).then(function (response) {
        response.data.DSK_CUSTOM_ABS = response.data.DSK_CUSTOM_ABS || '{}';
        _this.abs = lodash_default.a.merge({ active: response.data.DSK_CUSTOM_ABS_ONOFF === '1' }, JSON.parse(response.data.DSK_CUSTOM_ABS));
        if (typeof _this.abs.required === 'undefined' || !_this.abs.required || _this.abs.required === null) {
          _this.abs.required = [];
        }
        try {
          _this.DSK_NOBODY_MSG1 = JSON.parse(response.data.DSK_NOBODY_MSG1) || {};
        } catch (error) {}
        try {
          _this.DSK_NOBODY_MSG2 = JSON.parse(response.data.DSK_NOBODY_MSG2) || {};
        } catch (error) {}
        _this.messagingOnOff = response.data.DSK_MESSAGING_ONOFF === '1';
        _this.absOnOff = response.data.DSK_MESSAGING_ONOFF !== '1';
        _this.displayDefault = response.data.DSK_OPTIONS.split('|')[0];
      }).catch(function (_) {}).then(function (_) {
        _this.loadingGet = false;
      });
    },
    postOptions: function postOptions() {
      var _this2 = this;

      var dataToPost = new window.FormData();

      var steps = JSON.parse(this.$store.state._User.remainingSteps);

      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_SETTINGS_HORSLIGNE')) {
        steps.splice(steps.indexOf('INS_SETTINGS_HORSLIGNE'), 1);

        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: stringify_default()(steps)
        });
      }


      dataToPost.append('DSK_ID', this.$store.state._Sites.siteSelected.LIC_DSK_ID);
      dataToPost.append('LIC_KEY', this.$store.state._Sites.siteSelected.LIC_KEY);
      dataToPost.append('LIC_ID', this.$store.state._Sites.siteSelected.LIC_ID);
      dataToPost.append('ENT_ID', this.$store.state._User.entId);

      dataToPost.append('DSK_CUSTOM_ABS_ONOFF', this.abs.active ? '1' : '0');

      var custom2 = lodash_default.a.clone(this.abs);
      var postMessaging = 0;
      if (this.messagingOnOff) {
        postMessaging = 1;
      }
      delete custom2.active;
      dataToPost.append('DSK_CUSTOM_ABS', stringify_default()(custom2));
      dataToPost.append('DSK_NOBODY_MSG1', stringify_default()(this.DSK_NOBODY_MSG1));
      dataToPost.append('DSK_NOBODY_MSG2', stringify_default()(this.DSK_NOBODY_MSG2));
      dataToPost.append('DSK_MESSAGING_ONOFF', postMessaging);
      this.loadingPost = true;
      this.axios.post('post/settings_absence.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        var siteUpdate = lodash_default.a.clone(_this2.$store.state._Sites.siteSelected);

        _this2.$store.commit('_Sites/UPDATE_SITE_SETTINGS', siteUpdate);
        _this2.$store.commit('_Sites/UPDATE_SITE_SELECTED', siteUpdate);
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this2.$t('modifSuccess'),
          context: 'success'
        });
      }).catch(function (_) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this2.$t('modifFailure'),
          context: 'error'
        });
      }).then(function (_) {
        _this2.loadingPost = false;
      });
    },
    switchMessaging: function switchMessaging() {
      if (this.messagingOnOff === true) {
        this.warningMessagingOff = true;
        this.absOnOff = false;
      } else {
        this.warningMessagingOn = true;
        this.absOnOff = true;
      }
    },
    switchAbs: function switchAbs() {
      if (this.absOnOff === true) {
        this.warningMessagingOn = true;
        this.messagingOnOff = false;
      } else {
        this.warningMessagingOff = true;
        this.messagingOnOff = true;
      }
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function $storeState_SitesSiteSelected(v) {
      if (v) {
        this.getOptions();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a00e253","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Absence.vue
var Absence_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display"},[_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],attrs:{"color":"primary","value":"true","outline":""}},[_vm._v("\n      Ces réglages affectent le contenu du widget lorsqu'aucun agent n'est connecté/en ligne sur le site "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))])]),_vm._v(" "),_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.displayDefault === 'default_agents'),expression:"displayDefault === 'default_agents'"}],attrs:{"color":"secondary","icon":"warning","value":"true","outline":""}},[_vm._v("\n      Attention. Vous avez choisi, dans la section \"Widget\", de ne pas afficher de widget en mode hors-ligne (c'est à dire quand aucun agent n'est disponible pour le chat). Le widget étant invisible, les paramètres du mode hors-ligne,ci dessous, seront inopérants.\n    ")]),_vm._v(" "),(_vm.loadingGet)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('div',[_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-switch',{attrs:{"label":_vm.messagingOnOff ? 'MESSAGING ON' : 'MESSAGING OFF',"light":"","color":"primary","disabled":_vm.testBrideStatus('parametre_messaging')},nativeOn:{"click":function($event){$event.stopPropagation();_vm.switchMessaging()}},model:{value:(_vm.messagingOnOff),callback:function ($$v) {_vm.messagingOnOff=$$v},expression:"messagingOnOff"}}),_vm._v(" "),_c('v-switch',{attrs:{"label":_vm.absOnOff ? 'FORMULAIRE EN ABSENCE ON' : 'FORMULAIRE EN ABSENCE OFF',"light":"","color":"primary","disabled":_vm.testBrideStatus('parametre_messaging')},nativeOn:{"click":function($event){$event.stopPropagation();_vm.switchAbs()}},model:{value:(_vm.absOnOff),callback:function ($$v) {_vm.absOnOff=$$v},expression:"absOnOff"}})],1)],1)],1)],1),_vm._v(" "),(!_vm.messagingOnOff)?_c('v-expansion-panel',[_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_chat_formprechat') || _vm.messagingOnOff}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("assignment")]),_vm._v("Personnalisation du formulaire en absence ")],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":"Personnaliser le formulaire","light":"","color":"primary"},model:{value:(_vm.abs.active),callback:function ($$v) {_vm.$set(_vm.abs, "active", $$v)},expression:"abs.active"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-subheader',[_vm._v("Cocher les champs à valider")]),_vm._v(" "),_vm._l((_vm.itemsFieldsAbs),function(field,a){return _c('v-layout',{key:a,attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm3":""}},[_c('v-checkbox',{staticClass:"primary--text",attrs:{"disabled":!_vm.abs.active || field.value === 'question',"label":field.text,"value":field.value},model:{value:(_vm.abs.labels),callback:function ($$v) {_vm.$set(_vm.abs, "labels", $$v)},expression:"abs.labels"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":""}},[_c('v-checkbox',{staticClass:"primary--text",attrs:{"disabled":!_vm.abs.active || field.value === 'question',"label":"Obligatoire","value":field.value},model:{value:(_vm.abs.required),callback:function ($$v) {_vm.$set(_vm.abs, "required", $$v)},expression:"abs.required"}})],1)],1)})],2)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":"Mention RGPD","data-vv-name":"abs.rgpd","error":_vm.wzErrors.has('abs.rgpd'),"error-messages":_vm.wzErrors.collect('abs.rgpd')},model:{value:(_vm.abs.rgpd),callback:function ($$v) {_vm.$set(_vm.abs, "rgpd", $$v)},expression:"abs.rgpd"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_message1') || _vm.messagingOnOff}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("text_fields")]),_vm._v("\n          "+_vm._s(_vm._f("cap")(_vm.$t("firstLineMessage")))+"\n        ")],1),_vm._v(" "),_c('v-card',[_c('v-card-text',_vm._l((_vm.langs),function(l,i){return _c('v-text-field',{key:i,attrs:{"label":l.text},model:{value:(_vm.DSK_NOBODY_MSG1[l.value]),callback:function ($$v) {_vm.$set(_vm.DSK_NOBODY_MSG1, l.value, $$v)},expression:"DSK_NOBODY_MSG1[l.value]"}})}),1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_message2') || _vm.messagingOnOff}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("text_fields")]),_vm._v("\n          "+_vm._s(_vm._f("cap")(_vm.$t("secondLineMessage")))+"\n        ")],1),_vm._v(" "),_c('v-card',[_c('v-card-text',_vm._l((_vm.langs),function(l,i){return _c('v-text-field',{key:i,attrs:{"label":l.text},model:{value:(_vm.DSK_NOBODY_MSG2[l.value]),callback:function ($$v) {_vm.$set(_vm.DSK_NOBODY_MSG2, l.value, $$v)},expression:"DSK_NOBODY_MSG2[l.value]"}})}),1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","block":_vm.$vuetify.breakpoint.xsOnly,"loading":_vm.loadingPost},nativeOn:{"click":function($event){_vm.postOptions()}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('save')))),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("save")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"390","persistent":""},model:{value:(_vm.warningMessagingOff),callback:function ($$v) {_vm.warningMessagingOff=$$v},expression:"warningMessagingOff"}},[_c('v-card',[_c('v-card-title',{staticClass:"title primary white--text"},[_vm._v("\n          Activation du mode messaging\n        ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('strong',[_vm._v("Attention")]),_vm._v(", vous êtes sur le point d'activer le messaging (mode de discussion hors-ligne). Le formulaire en abscence ne sera pas proposé. A la place les internautes pourrons laisser des messages hors-lignes (via le chat) aux agents.\n        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.warningMessagingOff = false}}},[_vm._v("Continuer")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"390","persistent":""},model:{value:(_vm.warningMessagingOn),callback:function ($$v) {_vm.warningMessagingOn=$$v},expression:"warningMessagingOn"}},[_c('v-card',[_c('v-card-title',{staticClass:"title primary white--text"},[_vm._v("\n          Désactivation du mode messaging\n        ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('strong',[_vm._v("Attention")]),_vm._v(", vous êtes sur le point de couper le messaging (mode de discussion hors-ligne). Vos internautes ne pourrons pas laisser de message hors-lignes aux agents (via le chat). A la place, ils se verront proposer un formulaire en absence.\n        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.warningMessagingOn = false}}},[_vm._v("Continuer")])],1)],1)],1),_vm._v(" "),_c('wz-dialog-infos',{attrs:{"titleDialog":_vm.titleDialog,"contentDialog":_vm.contentDialog},on:{"fermeDialog":_vm.fermeDialogInfos}}),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":2},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)],1)}
var Absence_staticRenderFns = []
var Absence_esExports = { render: Absence_render, staticRenderFns: Absence_staticRenderFns }
/* harmony default export */ var settings_Absence = (Absence_esExports);
// CONCATENATED MODULE: ./src/components/settings/Absence.vue
var Absence_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Absence___vue_template_functional__ = false
/* styles */
var Absence___vue_styles__ = null
/* scopeId */
var Absence___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Absence___vue_module_identifier__ = null
var Absence_Component = Absence_normalizeComponent(
  Absence,
  settings_Absence,
  Absence___vue_template_functional__,
  Absence___vue_styles__,
  Absence___vue_scopeId__,
  Absence___vue_module_identifier__
)

/* harmony default export */ var components_settings_Absence = (Absence_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/settings/Chat.vue




/* harmony default export */ var Chat = ({
  data: function data() {
    return {
      onOff: true,
      rgpdOnOff: true,
      titleDialog: '',
      contentDialog: '',
      prechat: {
        active: false,
        title: '',
        subtitle: '',
        button: '',
        fields: []
      },
      msgAuto: {
        active: false,
        content: ''
      },
      warningChatOff: false,
      invit: {
        active: false,
        content: '',
        lang: 'FR',
        urlonoff: '0',
        url: '',
        delay: '0'
      },

      answerAuto: {
        active: false,
        lang: null,
        content: ''
      },
      messages: {},
      invits: {},

      isTyping: false,

      extensionEnabled: false,
      extensionUrl: '',

      langs: [{ text: lodash_default.a.upperFirst(this.$t('french')), value: 'FR' }, { text: lodash_default.a.upperFirst(this.$t('english')), value: 'EN' }, { text: lodash_default.a.upperFirst(this.$t('spanish')), value: 'ES' }, { text: lodash_default.a.upperFirst(this.$t('german')), value: 'DE' }, { text: lodash_default.a.upperFirst(this.$t('italian')), value: 'IT' }, { text: lodash_default.a.upperFirst(this.$t('portuguese')), value: 'PT' }],

      itemsFields: [{ text: 'Prénom', value: 'fname' }, { text: 'Nom', value: 'lname' }, { text: 'Téléphone', value: 'tel' }, { text: 'Email', value: 'email' }, { text: 'Société', value: 'company' }, { text: 'Code postal', value: 'zip' }, { text: 'Question', value: 'question' }],
      customLeadClassicFields: [{ text: 'Civilité', value: 'gender' }, { text: 'Nom', value: 'lname' }, { text: 'Prénom', value: 'fname' }, { text: 'Commentaire', value: 'comment' }, { text: 'Email', value: 'email' }, { text: 'Téléphone', value: 'tel' }, { text: 'Société', value: 'company' }, { text: 'URL', value: 'url' }],

      customLeadClassicMotifs: [{ text: 'Support', value: 'support' }, { text: 'Prospect', value: 'lead' }, { text: 'Vente', value: 'sale' }, { text: 'Devis', value: 'devis' }, { text: 'Réservation', value: 'resa' }, { text: 'Contact', value: 'contact' }],

      customFields: [],
      newField: '',
      customMotifs: [],
      newMotif: '',
      ask_geoloc: '',
      customLead: {
        active: false,
        motifs: [],
        motifs_type: [],
        info: [],
        info_required: []
      },

      alert: false,
      alertSSL: false,
      onOffMirroring: false,
      onOffCobrowsing: false,

      loadingGet: false,
      loadingPost: false,

      overMenu: false,

      showDialogCreate: false,
      showDialogMotif: false,
      dialogProgress: false
    };
  },
  created: function created() {
    this.getOptions();

    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'settings_chat';
    } else {
      setTimeout(function () {
        if (typeof defautMotif !== 'undefined') {
          defautMotif = 'settings_chat';
        }
      }, 800);
    }
  },
  mounted: function mounted() {
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
  },


  methods: {
    openDialog: function openDialog(data) {
      this.titleDialog = data.title;
      this.contentDialog = data.content;
    },
    fermeDialogInfos: function fermeDialogInfos() {
      this.titleDialog = '';
    },
    updateMessages: function updateMessages() {
      this.messages[this.answerAuto.lang.value] = this.answerAuto.content;
    },
    updateInvit: function updateInvit() {
      this.invits[this.invit.lang.value] = this.invit.content;
    },
    testBrideStatus: function testBrideStatus(name) {
      var brides = this.$store.state._User.brides;

      if (brides) {
        var resultat = brides.find(function (brides) {
          return brides.brideName === name;
        });
        if (resultat) {
          if (resultat.status === '0') {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    getOptions: function getOptions() {
      var _this = this;

      if (this.$store.state._Sites.siteSelected.LIC_COBROWSING_ACTIVATED !== '1') {
        this.alert = true;
        this.alertSSL = false;
        return;
      } else {
        if (this.$store.state._Sites.siteSelected.LIC_URL.indexOf('https://') === -1) {
          this.alertSSL = true;
        }
      }
      this.alert = false;
      this.loadingGet = true;
      this.axios.get('get/settings_chat.php?desk=' + this.$store.state._Sites.siteSelected.LIC_DSK_ID).then(function (response) {
        response.data.DSK_PRECHAT_CUSTOM = response.data.DSK_PRECHAT_CUSTOM || '{}';
        _this.prechat = lodash_default.a.merge({ active: response.data.DSK_PRECHAT_ONOFF === '1' }, JSON.parse(response.data.DSK_PRECHAT_CUSTOM));
        _this.onOffMirroring = response.data.DSK_MIRRORING === '1';
        _this.onOffCobrowsing = response.data.DSK_COBROWSING === '1';
        if (response.data.DSK_CUSTOM_LEAD_FORM === '') {
          _this.customLead = {
            active: false,
            motifs: ['support', 'lead', 'sale', 'devis', 'resa', 'contact'],
            motifs_type: 'multiple',
            info: ['gender', 'lname', 'fname', 'comment', 'email', 'tel', 'company', 'url'],
            info_required: ['email']
          };
        } else {
          _this.customLead = JSON.parse(response.data.DSK_CUSTOM_LEAD_FORM);
        }
        for (var i = 0; i < _this.customLead.info.length; ++i) {
          var fielld = _this.customLead.info[i];
          if (fielld !== 'gender' && fielld !== 'lname' && fielld !== 'fname' && fielld !== 'comment' && fielld !== 'email' && fielld !== 'tel' && fielld !== 'company' && fielld !== 'url') {
            _this.customFields.push({ text: fielld, value: fielld });
          }
        }
        _this.customMotifs = [];
        for (var _i = 0; _i < _this.customLead.motifs.length; ++_i) {
          var _fielld = _this.customLead.motifs[_i];
          if (_fielld !== 'support' && _fielld !== 'lead' && _fielld !== 'sale' && _fielld !== 'devis' && _fielld !== 'resa' && _fielld !== 'contact') {
            _this.customMotifs.push({ text: _fielld, value: _fielld });
          }
        }
        _this.msgAuto.active = response.data.DSK_FIRSTMSG_ONOFF === '1';
        _this.msgAuto.content = response.data.DSK_FIRSTMSG_MSG || '';

        _this.invit.active = response.data.DSK_AUTOCHAT_ONOFF === '1';
        _this.invit.delay = response.data.DSK_AUTOCHAT_DELAY || '';
        _this.invit.lang = lodash_default.a.clone(_this.langs[0]) || '';
        _this.invit.urlonoff = response.data.DSK_AUTOCHAT_URL_ONOFF === '1';
        _this.invit.url = response.data.DSK_AUTOCHAT_URL || '';
        _this.invits = JSON.parse(response.data.DSK_AUTOCHAT_MESSAGE) || {};

        _this.answerAuto.active = response.data.DSK_AUTOANSWER_ONOFF === '1';
        _this.answerAuto.lang = lodash_default.a.clone(_this.langs[0]) || '';
        _this.messages = JSON.parse(response.data.DSK_AUTOANSWER_MSG) || {};
        _this.ask_geoloc = response.data.DSK_ASK_GEOLOC_ONOFF === '1';
        _this.isTyping = response.data.DSK_SUPERISTYPING === '1';

        _this.extensionEnabled = response.data.DSK_EXTENSION_ONOFF === '1';
        _this.extensionUrl = response.data.DSK_EXTENSION_URL;

        _this.onOff = response.data.LIC_CHAT_ACTIVATED === '1';
        _this.rgpdOnOff = response.data.DSK_RGPD_ONOFF === '1';
      }).catch(function (_) {}).then(function (_) {
        _this.loadingGet = false;
      });
    },
    submitDialogCreate: function submitDialogCreate() {
      if (this.newField !== '') {
        this.customFields.push({ text: this.newField, value: this.newField });
        this.customLead.info.push(this.newField);
      }
      this.showDialogCreate = false;
    },
    submitDialogMotif: function submitDialogMotif() {
      if (this.newMotif !== '') {
        this.customMotifs.push({ text: this.newMotif, value: this.newMotif });
        this.customLead.motifs.push(this.newMotif);
      }
      this.showDialogMotif = false;
    },
    postOptions: function postOptions() {
      var _this2 = this;

      var dataToPost = new window.FormData();

      var steps = JSON.parse(this.$store.state._User.remainingSteps);

      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_SETTINGS_CHAT')) {
        steps.splice(steps.indexOf('INS_SETTINGS_CHAT'), 1);

        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: stringify_default()(steps)
        });
      }


      dataToPost.append('DSK_ID', this.$store.state._Sites.siteSelected.LIC_DSK_ID);
      dataToPost.append('LIC_KEY', this.$store.state._Sites.siteSelected.LIC_KEY);
      dataToPost.append('LIC_ID', this.$store.state._Sites.siteSelected.LIC_ID);
      dataToPost.append('ENT_ID', this.$store.state._User.entId);

      dataToPost.append('LIC_CHAT_ACTIVATED', this.onOff ? '1' : '0');

      dataToPost.append('DSK_PRECHAT_ONOFF', this.prechat.active ? '1' : '0');
      var custom = lodash_default.a.clone(this.prechat);
      delete custom.active;
      dataToPost.append('DSK_PRECHAT_CUSTOM', stringify_default()(custom));
      dataToPost.append('DSK_FIRSTMSG_ONOFF', this.msgAuto.active ? '1' : '0');
      dataToPost.append('DSK_FIRSTMSG_MSG', this.msgAuto.content);
      dataToPost.append('DSK_AUTOANSWER_ONOFF', this.answerAuto.active ? '1' : '0');
      dataToPost.append('DSK_AUTOANSWER_MSG', stringify_default()(this.messages));
      dataToPost.append('DSK_AUTOCHAT_ONOFF', this.invit.active ? '1' : '0');
      dataToPost.append('DSK_AUTOCHAT_MESSAGE', stringify_default()(this.invits));
      dataToPost.append('DSK_AUTOCHAT_DELAY', this.invit.delay);
      dataToPost.append('DSK_AUTOCHAT_URL_ONOFF', this.invit.urlonoff ? '1' : '0');
      dataToPost.append('DSK_AUTOCHAT_URL', this.invit.url);
      dataToPost.append('DSK_SUPERISTYPING', this.isTyping ? '1' : '0');
      dataToPost.append('DSK_MIRRORING', this.onOffMirroring ? '1' : '0');
      dataToPost.append('DSK_COBROWSING', this.onOffCobrowsing ? '1' : '0');
      dataToPost.append('DSK_ASK_GEOLOC_ONOFF', this.ask_geoloc ? '1' : '0');
      dataToPost.append('DSK_RGPD_ONOFF', this.rgpdOnOff ? '1' : '0');
      dataToPost.append('DSK_CUSTOM_LEAD_FORM', stringify_default()(this.customLead));
      dataToPost.append('DSK_EXTENSION_ONOFF', this.extensionEnabled ? '1' : '0');
      dataToPost.append('DSK_EXTENSION_URL', this.extensionUrl);
      this.loadingPost = true;
      this.axios.post('post/settings_chat.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        var siteUpdate = lodash_default.a.clone(_this2.$store.state._Sites.siteSelected);
        siteUpdate.DSK_CUSTOM_LEAD_FORM = _this2.customLead;
        siteUpdate.DSK_FIRSTMSG_ONOFF = _this2.msgAuto.active ? '1' : '0';
        siteUpdate.DSK_FIRSTMSG_MSG = _this2.msgAuto.content;
        siteUpdate.DSK_EXTENSION_ONOFF = _this2.extensionEnabled ? '1' : '0';
        siteUpdate.DSK_EXTENSION_URL = _this2.extensionUrl;
        _this2.$store.commit('_Sites/UPDATE_SITE_SETTINGS', siteUpdate);
        _this2.$store.commit('_Sites/UPDATE_SITE_SELECTED', siteUpdate);
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this2.$t('modifSuccess'),
          context: 'success'
        });
      }).catch(function (_) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this2.$t('modifFailure'),
          context: 'error'
        });
      }).then(function (_) {
        _this2.loadingPost = false;
      });
    },
    switchValue: function switchValue(lequel) {
      if (lequel === 'invit.active') {
        this.invit.active = !this.invit.active;
      }
      if (lequel === 'prechat.active') {
        this.prechat.active = !this.prechat.active;
      }
      if (lequel === 'msgAuto.active') {
        this.msgAuto.active = !this.msgAuto.active;
      }
      if (lequel === 'answerAuto.active') {
        this.answerAuto.active = !this.answerAuto.active;
      }
      if (lequel === 'customLead.active') {
        this.customLead.active = !this.customLead.active;
      }
      if (lequel === 'isTyping') {
        this.isTyping = !this.isTyping;
      }
      if (lequel === 'ask_geoloc') {
        this.ask_geoloc = !this.ask_geoloc;
      }
      if (lequel === 'extensionEnabled') {
        this.extensionEnabled = !this.extensionEnabled;
      }
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    }
  },

  watch: {
    'answerAuto.lang': function answerAutoLang(val) {
      this.answerAuto.content = this.messages[val.value];
    },
    'invit.lang': function invitLang(val) {
      this.invit.content = this.invits[val.value];
    },
    '$store.state._Sites.siteSelected': function $storeState_SitesSiteSelected(v) {
      if (v) {
        this.getOptions();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7db5a6fb","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Chat.vue
var Chat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"display"},[_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],attrs:{"color":"primary","value":"true","outline":""}},[_vm._v("\n      Ces réglages affectent le contenu du widget lorsqu'au moins un agent est connecté et en ligne sur le site "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))])]),_vm._v(" "),_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(!_vm.onOff),expression:"!onOff"}],attrs:{"color":"secondary","icon":"priority_high","value":"true","outline":""}},[_vm._v("\n      Attention, les conversations par chat son coupées côté internaute. Cela peut également affecter la liste des visiteurs en ligne sur la section Trafic/Visiteurs. "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))])]),_vm._v(" "),_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.alert),expression:"alert"}],attrs:{"color":"secondary","icon":"warning","value":"true","outline":""}},[_vm._v("\n      "+_vm._s(_vm.$t('warningCobrowsingDisabled'))+" "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))])]),_vm._v(" "),_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.alertSSL),expression:"alertSSL"}],attrs:{"color":"warning","icon":"priority_high","value":"true","outline":""}},[_vm._v("\n      "+_vm._s(_vm.$t('warningCobrowsingHttp'))+" "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))])]),_vm._v(" "),(_vm.loadingGet)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('div',[_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm.onOff ? 'CHAT ON' : 'CHAT OFF',"light":"","color":"primary","disabled":_vm.testBrideStatus('parametre_chat')},nativeOn:{"click":function($event){!_vm.onOff ? _vm.warningChatOff = true : ''}},model:{value:(_vm.onOff),callback:function ($$v) {_vm.onOff=$$v},expression:"onOff"}})],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_chat_invitation')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("announcement")]),_vm._v("\n            "+_vm._s(_vm.$t('autochatTitle'))+"\n            "),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.switchValue('invit.active')}}},[_c('template',{slot:"activator"},[(_vm.invit.active)?_c('v-icon',{staticClass:"infos",attrs:{"color":"primary","dark":""}},[_vm._v("play_circle_filled")]):_c('v-icon',{staticClass:"infos",attrs:{"color":"grey primary--text","dark":""}},[_vm._v("pause_circle_filled")])],1),_vm._v(" "),(_vm.invit.active)?_c('span',[_vm._v("Cliquer pour désactiver")]):_c('span',[_vm._v("Cliquer pour activer")])],2)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-switch',{attrs:{"label":_vm.$t('autochatTitleLabel'),"light":"","color":"primary"},model:{value:(_vm.invit.active),callback:function ($$v) {_vm.$set(_vm.invit, "active", $$v)},expression:"invit.active"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.langs,"label":_vm._f("cap")(_vm.$t('language')),"return-object":"","dense":"","disabled":!_vm.invit.active},model:{value:(_vm.invit.lang),callback:function ($$v) {_vm.$set(_vm.invit, "lang", $$v)},expression:"invit.lang"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md9":""}},[_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('content')),"required":"","disabled":!_vm.invit.active},on:{"input":function($event){_vm.updateInvit()}},model:{value:(_vm.invit.content),callback:function ($$v) {_vm.$set(_vm.invit, "content", $$v)},expression:"invit.content"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.invit.active),expression:"invit.active"}],attrs:{"xs12":""}},[_c('div',[_vm._v(_vm._s(_vm.$t('triggerConditionTime')))]),_vm._v(" "),_c('v-slider',{attrs:{"thumb-label":"","min":0,"max":300},model:{value:(_vm.invit.delay),callback:function ($$v) {_vm.$set(_vm.invit, "delay", $$v)},expression:"invit.delay"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.invit.delay)+" sec.")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.invit.active),expression:"invit.active"}],attrs:{"xs12":""}},[_c('div',[_vm._v(_vm._s(_vm.$t('triggerConditionUrl')))]),_vm._v(" "),_c('v-switch',{attrs:{"label":_vm.$t('restrictFewUrLs'),"light":"","color":"primary"},model:{value:(_vm.invit.urlonoff),callback:function ($$v) {_vm.$set(_vm.invit, "urlonoff", $$v)},expression:"invit.urlonoff"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.invit.active),expression:"invit.active"}],attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":_vm.$t('containsString'),"disabled":!_vm.invit.urlonoff},model:{value:(_vm.invit.url),callback:function ($$v) {_vm.$set(_vm.invit, "url", $$v)},expression:"invit.url"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_chat_formprechat')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("assignment")]),_vm._v("\n            "+_vm._s(_vm.$t('prechatTitle'))+"\n            "),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.switchValue('prechat.active')}}},[_c('template',{slot:"activator"},[(_vm.prechat.active)?_c('v-icon',{staticClass:"infos",attrs:{"color":"primary","dark":""}},[_vm._v("play_circle_filled")]):_c('v-icon',{staticClass:"infos",attrs:{"color":"grey primary--text","dark":""}},[_vm._v("pause_circle_filled")])],1),_vm._v(" "),(_vm.prechat.active)?_c('span',[_vm._v("Cliquer pour désactiver")]):_c('span',[_vm._v("Cliquer pour activer")])],2)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm.$t('prechatTitleLabel'),"light":"","color":"primary"},model:{value:(_vm.prechat.active),callback:function ($$v) {_vm.$set(_vm.prechat, "active", $$v)},expression:"prechat.active"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":_vm._f("cap")(_vm.$t('title')),"required":"","data-vv-name":"prechat.title","error":_vm.wzErrors.has('prechat.title'),"error-messages":_vm.wzErrors.collect('prechat.title'),"disabled":!_vm.prechat.active},model:{value:(_vm.prechat.title),callback:function ($$v) {_vm.$set(_vm.prechat, "title", $$v)},expression:"prechat.title"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('subTitle')),"disabled":!_vm.prechat.active},model:{value:(_vm.prechat.subtitle),callback:function ($$v) {_vm.$set(_vm.prechat, "subtitle", $$v)},expression:"prechat.subtitle"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":_vm._f("cap")(_vm.$t('buttonText')),"required":"","data-vv-name":"prechat.button","error":_vm.wzErrors.has('prechat.button'),"error-messages":_vm.wzErrors.collect('prechat.button'),"disabled":!_vm.prechat.active},model:{value:(_vm.prechat.button),callback:function ($$v) {_vm.$set(_vm.prechat, "button", $$v)},expression:"prechat.button"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.itemsFields),function(field,a){return _c('v-flex',{key:a,attrs:{"xs6":"","sm3":"","md2":""}},[_c('v-checkbox',{staticClass:"primary--text",attrs:{"disabled":!_vm.prechat.active,"label":field.text,"value":field.value},model:{value:(_vm.prechat.fields),callback:function ($$v) {_vm.$set(_vm.prechat, "fields", $$v)},expression:"prechat.fields"}})],1)}),1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_chat_premiermessage')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("chat")]),_vm._v("\n            "+_vm._s(_vm._f("cap")(_vm.$t('firstAutoMessage')))+"\n            "),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.switchValue('msgAuto.active')}}},[_c('template',{slot:"activator"},[(_vm.msgAuto.active)?_c('v-icon',{staticClass:"infos",attrs:{"color":"primary","dark":""}},[_vm._v("play_circle_filled")]):_c('v-icon',{staticClass:"infos",attrs:{"color":"grey primary--text","dark":""}},[_vm._v("pause_circle_filled")])],1),_vm._v(" "),(_vm.msgAuto.active)?_c('span',[_vm._v("Cliquer pour désactiver")]):_c('span',[_vm._v("Cliquer pour activer")])],2)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('enable')),"light":"","color":"primary"},model:{value:(_vm.msgAuto.active),callback:function ($$v) {_vm.$set(_vm.msgAuto, "active", $$v)},expression:"msgAuto.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":_vm._f("cap")(_vm.$t('title')),"required":"","data-vv-name":"msgAuto.content","error":_vm.wzErrors.has('msgAuto.content'),"error-messages":_vm.wzErrors.collect('msgAuto.content'),"disabled":!_vm.msgAuto.active},model:{value:(_vm.msgAuto.content),callback:function ($$v) {_vm.$set(_vm.msgAuto, "content", $$v)},expression:"msgAuto.content"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_chat_premiermessage')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("chat")]),_vm._v("\nAfficher la mention RGPD au démarage du chat\n            "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.switchValue('rgpdOnOff')}}},[_c('template',{slot:"activator"},[(_vm.rgpdOnOff)?_c('v-icon',{staticClass:"infos",attrs:{"color":"primary","dark":""}},[_vm._v("play_circle_filled")]):_c('v-icon',{staticClass:"infos",attrs:{"color":"grey primary--text","dark":""}},[_vm._v("pause_circle_filled")])],1),_vm._v(" "),(_vm.rgpdOnOff)?_c('span',[_vm._v("Cliquer pour désactiver")]):_c('span',[_vm._v("Cliquer pour activer")])],2)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('enable')),"light":"","color":"primary"},model:{value:(_vm.rgpdOnOff),callback:function ($$v) {_vm.rgpdOnOff=$$v},expression:"rgpdOnOff"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_chat_reponseauto')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("question_answer")]),_vm._v("\n            "+_vm._s(_vm._f("cap")(_vm.$t('autoResponse')))+"\n            "),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.switchValue('answerAuto.active')}}},[_c('template',{slot:"activator"},[(_vm.answerAuto.active)?_c('v-icon',{staticClass:"infos",attrs:{"color":"primary","dark":""}},[_vm._v("play_circle_filled")]):_c('v-icon',{staticClass:"infos",attrs:{"color":"grey primary--text","dark":""}},[_vm._v("pause_circle_filled")])],1),_vm._v(" "),(_vm.answerAuto.active)?_c('span',[_vm._v("Cliquer pour désactiver")]):_c('span',[_vm._v("Cliquer pour activer")])],2)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('enable')),"light":"","color":"primary"},model:{value:(_vm.answerAuto.active),callback:function ($$v) {_vm.$set(_vm.answerAuto, "active", $$v)},expression:"answerAuto.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.langs,"label":_vm._f("cap")(_vm.$t('language')),"return-object":"","disabled":!_vm.answerAuto.active},model:{value:(_vm.answerAuto.lang),callback:function ($$v) {_vm.$set(_vm.answerAuto, "lang", $$v)},expression:"answerAuto.lang"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md9":""}},[_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('content')),"required":"","disabled":!_vm.answerAuto.active},on:{"input":function($event){_vm.updateMessages()}},model:{value:(_vm.answerAuto.content),callback:function ($$v) {_vm.$set(_vm.answerAuto, "content", $$v)},expression:"answerAuto.content"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_chat_editlead')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("loyalty")]),_vm._v("\n            "+_vm._s(_vm._f("cap")(_vm.$t('leadEditor')))+"\n            "),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.switchValue('customLead.active')}}},[_c('template',{slot:"activator"},[(_vm.customLead.active)?_c('v-icon',{staticClass:"infos",attrs:{"color":"primary","dark":""}},[_vm._v("play_circle_filled")]):_c('v-icon',{staticClass:"infos",attrs:{"color":"grey primary--text","dark":""}},[_vm._v("pause_circle_filled")])],1),_vm._v(" "),(_vm.customLead.active)?_c('span',[_vm._v("Cliquer pour désactiver")]):_c('span',[_vm._v("Cliquer pour activer")])],2)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('enable')),"light":"","color":"primary"},model:{value:(_vm.customLead.active),callback:function ($$v) {_vm.$set(_vm.customLead, "active", $$v)},expression:"customLead.active"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.customLead.active),expression:"customLead.active"}],attrs:{"xs12":"","md6":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('basicFields'))))]),_vm._v(" "),_vm._l((_vm.customLeadClassicFields),function(field,i){return _c('v-layout',{key:i,attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm3":""}},[_c('v-checkbox',{staticClass:"primary--text",attrs:{"disabled":!_vm.customLead.active,"label":field.text,"value":field.value},model:{value:(_vm.customLead.info),callback:function ($$v) {_vm.$set(_vm.customLead, "info", $$v)},expression:"customLead.info"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"sm3":""}},[_c('v-checkbox',{staticClass:"primary--text",attrs:{"disabled":!_vm.customLead.active,"label":"Obligatoire","value":field.value},model:{value:(_vm.customLead.info_required),callback:function ($$v) {_vm.$set(_vm.customLead, "info_required", $$v)},expression:"customLead.info_required"}})],1)],1)}),_vm._v(" "),_c('v-subheader',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('yourCustomFields'))))]),_vm._v(" "),_vm._l((_vm.customFields),function(field,k){return _c('v-layout',{key:field.value,attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('v-checkbox',{staticClass:"primary--text",attrs:{"disabled":!_vm.customLead.active,"label":field.text,"value":field.value},model:{value:(_vm.customLead.info),callback:function ($$v) {_vm.$set(_vm.customLead, "info", $$v)},expression:"customLead.info"}})],1)],1)}),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","dark":""},on:{"click":function($event){_vm.showDialogCreate = true}}},[_vm._v("\n                  "+_vm._s(_vm.$t('add'))+" "+_vm._s(_vm.$tc('fields', 1, {count: ''}))+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],2),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.customLead.active),expression:"customLead.active"}],attrs:{"xs12":"","md6":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('basicTags'))))]),_vm._v(" "),_vm._l((_vm.customLeadClassicMotifs),function(field,j){return _c('v-layout',{key:field.value,attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"sm3":""}},[_c('v-checkbox',{staticClass:"primary--text",attrs:{"disabled":!_vm.customLead.active,"label":field.text,"value":field.value},model:{value:(_vm.customLead.motifs),callback:function ($$v) {_vm.$set(_vm.customLead, "motifs", $$v)},expression:"customLead.motifs"}})],1)],1)}),_vm._v(" "),_c('v-subheader',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('yourCustomTags'))))]),_vm._v(" "),_vm._l((_vm.customMotifs),function(field,l){return _c('v-layout',{key:field.value,attrs:{"row":"","wrap":""}},[_c('v-flex',[_c('v-checkbox',{staticClass:"primary--text",attrs:{"disabled":!_vm.customLead.active,"label":field.text,"value":field.value},model:{value:(_vm.customLead.motifs),callback:function ($$v) {_vm.$set(_vm.customLead, "motifs", $$v)},expression:"customLead.motifs"}})],1)],1)}),_vm._v(" "),_c('v-btn',{attrs:{"color":"accent","dark":""},on:{"click":function($event){_vm.showDialogMotif = true}}},[_vm._v("\n                  "+_vm._s(_vm.$t('add'))+" "+_vm._s(_vm.$tc('tags', 1, {count: ''}))+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],2)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_chat_istyping')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("keyboard")]),_vm._v("\n            IsTyping \n            "),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.switchValue('isTyping')}}},[_c('template',{slot:"activator"},[(_vm.isTyping)?_c('v-icon',{staticClass:"infos",attrs:{"color":"primary","dark":""}},[_vm._v("play_circle_filled")]):_c('v-icon',{staticClass:"infos",attrs:{"color":"grey primary--text","dark":""}},[_vm._v("pause_circle_filled")])],1),_vm._v(" "),(_vm.isTyping)?_c('span',[_vm._v("Cliquer pour désactiver")]):_c('span',[_vm._v("Cliquer pour activer")])],2)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('enable')),"light":"","color":"primary"},model:{value:(_vm.isTyping),callback:function ($$v) {_vm.isTyping=$$v},expression:"isTyping"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_apercu_geoloc')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("location_on")]),_vm._v("\n            "+_vm._s(_vm._f("cap")(_vm.$t("locationRequest")))+"\n            "),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.switchValue('ask_geoloc')}}},[_c('template',{slot:"activator"},[(_vm.ask_geoloc)?_c('v-icon',{staticClass:"infos",attrs:{"color":"primary","dark":""}},[_vm._v("play_circle_filled")]):_c('v-icon',{staticClass:"infos",attrs:{"color":"grey primary--text","dark":""}},[_vm._v("pause_circle_filled")])],1),_vm._v(" "),(_vm.ask_geoloc)?_c('span',[_vm._v("Cliquer pour désactiver")]):_c('span',[_vm._v("Cliquer pour activer")])],2)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-switch',{attrs:{"label":_vm.$t('locationRequest'),"color":"primary"},model:{value:(_vm.ask_geoloc),callback:function ($$v) {_vm.ask_geoloc=$$v},expression:"ask_geoloc"}})],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_chat_iframe')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("extension")]),_vm._v("\n            Extension Iframe\n            "),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.switchValue('extensionEnabled')}}},[_c('template',{slot:"activator"},[(_vm.extensionEnabled)?_c('v-icon',{staticClass:"infos",attrs:{"color":"primary","dark":""}},[_vm._v("play_circle_filled")]):_c('v-icon',{staticClass:"infos",attrs:{"color":"grey primary--text","dark":""}},[_vm._v("pause_circle_filled")])],1),_vm._v(" "),(_vm.extensionEnabled)?_c('span',[_vm._v("Cliquer pour désactiver")]):_c('span',[_vm._v("Cliquer pour activer")])],2)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('enable')),"light":"","color":"primary"},model:{value:(_vm.extensionEnabled),callback:function ($$v) {_vm.extensionEnabled=$$v},expression:"extensionEnabled"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-text-field',{attrs:{"label":"URL","light":"","color":"primary","persistent-hint":"","hint":"Inclusion de votre CRM ou tout autre page dans la fiche du visiteur"},model:{value:(_vm.extensionUrl),callback:function ($$v) {_vm.extensionUrl=$$v},expression:"extensionUrl"}})],1)],1),_vm._v(" "),_c('v-subheader',[_vm._v("Ajout de variables Target First dans l'URL")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-btn',{attrs:{"flat":"","color":"accent"},on:{"click":function($event){_vm.extensionUrl += '{{visiteurID}}'}}},[_vm._v("\n                    Id Visiteur\n                    "),_c('v-icon',{attrs:{"right":""}},[_vm._v("add")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_cobrowsing_cobrowsing') && _vm.testBrideStatus('parametre_cobrowsing_mirroring')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("book_online")]),_vm._v("Screen Sharing")],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm.onOffCobrowsing ? _vm.$t('cobrowsing') + ' ' + 'ON' : _vm.$t('cobrowsing') + ' ' + 'OFF',"light":"","color":"primary","hint":_vm.$t('descCobrowsing'),"persistent-hint":"","disabled":_vm.testBrideStatus('parametre_cobrowsing_cobrowsing')},model:{value:(_vm.onOffCobrowsing),callback:function ($$v) {_vm.onOffCobrowsing=$$v},expression:"onOffCobrowsing"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm.onOffMirroring ? _vm.$t('mirroring') + ' ' + 'ON' : _vm.$t('mirroring') + ' ' + 'OFF',"light":"","color":"primary","hint":_vm.$t('descMirroring'),"persistent-hint":"","disabled":_vm.testBrideStatus('parametre_cobrowsing_mirroring')},model:{value:(_vm.onOffMirroring),callback:function ($$v) {_vm.onOffMirroring=$$v},expression:"onOffMirroring"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","block":_vm.$vuetify.breakpoint.xsOnly,"loading":_vm.loadingPost},nativeOn:{"click":function($event){_vm.postOptions()}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('save')))),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("save")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.showDialogCreate),callback:function ($$v) {_vm.showDialogCreate=$$v},expression:"showDialogCreate"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v("\n            "+_vm._s(_vm.$t('add'))+"| cap  "+_vm._s(_vm.$tc('fields', 1, {count: ''}))+"\n          ")]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('max:32'),expression:"'max:32'"}],attrs:{"autofocus":"","required":"","label":_vm._f("cap")(_vm.$t('title')),"counter":"","max":"32","data-vv-name":"newFieldName"},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogCreate($event)}},model:{value:(_vm.newField),callback:function ($$v) {_vm.newField=$$v},expression:"newField"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.showDialogCreate = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){return _vm.submitDialogCreate($event)}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.showDialogMotif),callback:function ($$v) {_vm.showDialogMotif=$$v},expression:"showDialogMotif"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v("\n            "+_vm._s(_vm._f("cap")(_vm.$t('add')))+" "+_vm._s(_vm.$tc('tags', 1, {count: ''}))+"\n          ")]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('max:32'),expression:"'max:32'"}],attrs:{"autofocus":"","required":"","label":_vm._f("cap")(_vm.$t('title')),"counter":"","max":"32","data-vv-name":"newFieldName"},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogMotif($event)}},model:{value:(_vm.newMotif),callback:function ($$v) {_vm.newMotif=$$v},expression:"newMotif"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.showDialogMotif = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){return _vm.submitDialogMotif($event)}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"390"},model:{value:(_vm.warningChatOff),callback:function ($$v) {_vm.warningChatOff=$$v},expression:"warningChatOff"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v("\n            Attention, vous êtes sur le point de couper le chat du côté Visiteur (sur le site web). Les internautes ne pourrons plus discuter avec les téléconseillers (même s'ils sont en ligne) et aucune invitation par chat ne sera envoyée.\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.warningChatOff = false}}},[_vm._v("Continuer")])],1)],1)],1),_vm._v(" "),_c('wz-dialog-infos',{attrs:{"titleDialog":_vm.titleDialog,"contentDialog":_vm.contentDialog},on:{"fermeDialog":_vm.fermeDialogInfos}}),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":3},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)],1)}
var Chat_staticRenderFns = []
var Chat_esExports = { render: Chat_render, staticRenderFns: Chat_staticRenderFns }
/* harmony default export */ var settings_Chat = (Chat_esExports);
// CONCATENATED MODULE: ./src/components/settings/Chat.vue
var Chat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Chat___vue_template_functional__ = false
/* styles */
var Chat___vue_styles__ = null
/* scopeId */
var Chat___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Chat___vue_module_identifier__ = null
var Chat_Component = Chat_normalizeComponent(
  Chat,
  settings_Chat,
  Chat___vue_template_functional__,
  Chat___vue_styles__,
  Chat___vue_scopeId__,
  Chat___vue_module_identifier__
)

/* harmony default export */ var components_settings_Chat = (Chat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/settings/Callback.vue



/* harmony default export */ var Callback = ({
  data: function data() {
    return {
      alert: false,
      alertRecall: false,
      titleDialog: '',
      contentDialog: '',
      lang: { text: '', value: '' },
      onOff: false,
      style: 'TIRETTE2',
      langs: [{ text: lodash_default.a.upperFirst(this.$tc('all', 0, { count: '' })), value: '' }, { text: lodash_default.a.upperFirst(this.$t('french')), value: 'FR' }, { text: lodash_default.a.upperFirst(this.$t('english')), value: 'EN' }, { text: lodash_default.a.upperFirst(this.$t('spanish')), value: 'ES' }, { text: lodash_default.a.upperFirst(this.$t('german')), value: 'DE' }, { text: lodash_default.a.upperFirst(this.$t('italian')), value: 'IT' }, { text: lodash_default.a.upperFirst(this.$t('portuguese')), value: 'PT' }],
      hiddenMobile: false,
      timeout: 0,
      title: '',
      msg: '',
      img: '',
      form: {
        hours: '',
        days: [{
          name: this.$t('monday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('tuesday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('wednesday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('thursday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('friday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('saturday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('sunday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }],

        urls: '',
        rules: []
      },

      showTp: false,
      daySelected: {},
      tmpHours: null,
      amOrPm: 'am',
      startOrEnd: 'start',
      allowed: { hours: { min: '0:00', max: '12:00' } },
      dependency: '',
      hideIcon: '',

      showHours: false,
      daysTmp: [],
      dayHours: null,
      days: [{ text: lodash_default.a.upperFirst(this.$t('monday')), value: 0 }, { text: lodash_default.a.upperFirst(this.$t('tuesday')), value: 1 }, { text: lodash_default.a.upperFirst(this.$t('wednesday')), value: 2 }, { text: lodash_default.a.upperFirst(this.$t('thursday')), value: 3 }, { text: lodash_default.a.upperFirst(this.$t('friday')), value: 4 }, { text: lodash_default.a.upperFirst(this.$t('saturday')), value: 5 }, { text: lodash_default.a.upperFirst(this.$t('sunday')), value: 6 }],

      tmp: '',
      headersRules: [{ text: lodash_default.a.upperFirst(this.$t('type')), align: 'left', sortable: false, value: 'type' }, { text: lodash_default.a.upperFirst(this.$t('content')), align: 'left', sortable: false, value: 'content' }, { text: '', align: 'left', sortable: false, value: 'actions' }],
      typeRules: [{ text: lodash_default.a.upperFirst(this.$t('fullUrl')), value: 'DSK_SHOW_URL' }, { text: lodash_default.a.upperFirst(this.$t('containedUrl')), value: 'DSK_SHOW_PART_URL' }, { text: lodash_default.a.upperFirst(this.$t('keyWords')), value: 'DSK_SHOW_TAGS' }, { text: lodash_default.a.upperFirst(this.$t('classOrId')), value: 'DSK_SHOW_CLASS_ID' }],
      showDialogRule: false,
      ruleTmp: { content: '', type: {} },

      loadingGet: false,
      loadingPost: false,
      dialogProgress: false
    };
  },
  mounted: function mounted() {
    this.getOptions();
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
  },
  created: function created() {
    this.daySelected = this.form.days[0];
    this.dayHours = { text: this.form.days[0].name, value: 0 };

    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'settings_callback';
    } else {
      setTimeout(function () {
        if (typeof defautMotif !== 'undefined') {
          defautMotif = 'settings_callback';
        }
      }, 800);
    }
  },


  computed: {
    headersDays: function headersDays() {
      return !this.daysTmp.length ? [{ text: this.$t('allDays'), align: 'left', sortable: false }] : [{ text: this.$t('noDays'), align: 'left', sortable: false }];
    }
  },

  methods: {
    openTimePicker: function openTimePicker(day, amOrPm, startOrEnd) {
      this.showTp = true;
      this.daySelected = day;
      this.amOrPm = amOrPm;
      this.startOrEnd = startOrEnd;
      this.tmpHours = this.daySelected[amOrPm][startOrEnd];

      this.allowed.hours = amOrPm === 'am' ? { min: '0:00', max: '12:59' } : { min: '12:00', max: '23:59' };
    },
    openHours: function openHours() {
      this.showHours = true;
    },
    submitHours: function submitHours() {
      var _this = this;

      this.showHours = false;

      var daySelected = this.form.days.find(function (d) {
        return d.name === _this.dayHours.text;
      });
      this.daysTmp.forEach(function (day) {
        var d = _this.form.days.find(function (d) {
          return d.name === day.text.toLowerCase();
        });
        d.am = lodash_default.a.cloneDeep(daySelected.am);
        d.pm = lodash_default.a.cloneDeep(daySelected.pm);
      });
      this.daysTmp = [];
    },
    openRule: function openRule() {
      this.showDialogRule = true;
      this.ruleTmp = { content: '', type: this.typeRules[0], list: this.form.urls };
    },
    submitRule: function submitRule() {
      if (!lodash_default.a.isEmpty(this.ruleTmp.content)) {
        this.showDialogRule = false;
        this.form.rules.push(lodash_default.a.clone(this.ruleTmp));
      } else {
        this.$validator.validateAll();
      }
    },
    deleteRule: function deleteRule(index) {
      this.form.rules.splice(index, 1);
    },
    getOptions: function getOptions() {
      var _this2 = this;

      if (this.$store.state._Sites.siteSelected.LIC_CALLBACK_ACTIVATED !== '1') {
        this.alert = true;
        return;
      }
      if (this.$store.state._Sites.siteSelected.DSK_RECALL_ONOFF === '1') {
        this.alertRecall = true;
      }
      this.alert = false;
      this.loadingGet = true;
      this.axios.get('get/settings_callback.php?desk=' + this.$store.state._Sites.siteSelected.LIC_DSK_ID).then(function (response) {
        _this2.lang = lodash_default.a.find(_this2.langs, {
          value: response.data.DSK_CALLBACK_OPTION
        });
        _this2.onOff = response.data.DSK_CALLBACK_ONOFF === '1';
        _this2.timeout = response.data.DSK_CALLBACK_DELAY;
        _this2.style = response.data.DSK_CALLBACK_STYLE;
        _this2.title = response.data.DSK_CALLBACK_TITLE;
        _this2.msg = response.data.DSK_CALLBACK_MSG;
        _this2.img = response.data.DSK_CALLBACK_IMG;
        _this2.dependency = response.data.DSK_CALLBACK_DEPENDANT;
        _this2.hideIcon = response.data.DSK_CALLBACK_HIDEICON;
        _this2.hiddenMobile = response.data.DSK_CALLBACK_HIDE_MOBILE === '1';

        _this2.form.urls = 'all';
        if (response.data.DSK_CALLBACK_SHOW_ONOFF === '1') {
          _this2.form.urls = 'showOnOff';
        } else if (response.data.DSK_CALLBACK_HIDE_ONOFF === '1') {
          _this2.form.urls = 'hideOnOff';
        }
        _this2.form.rules = [];

        lodash_default.a.each(response.data.DSK_CALLBACK_SHOW_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[0]), 'list': 'showOnOff' });
        });
        lodash_default.a.each(response.data.DSK_CALLBACK_SHOW_PART_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[1]), 'list': 'showOnOff' });
        });
        lodash_default.a.each(response.data.DSK_CALLBACK_SHOW_TAGS.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[2]), 'list': 'showOnOff' });
        });
        lodash_default.a.each(response.data.DSK_CALLBACK_SHOW_CLASS_ID.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[3]), 'list': 'showOnOff' });
        });

        lodash_default.a.each(response.data.DSK_CALLBACK_HIDE_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[0]), 'list': 'hideOnOff' });
        });
        lodash_default.a.each(response.data.DSK_CALLBACK_HIDE_PART_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[1]), 'list': 'hideOnOff' });
        });
        lodash_default.a.each(response.data.DSK_CALLBACK_HIDE_TAGS.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[2]), 'list': 'hideOnOff' });
        });
        lodash_default.a.each(response.data.DSK_CALLBACK_HIDE_CLASS_ID.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[3]), 'list': 'hideOnOff' });
        });

        _this2.form.hours = response.data.DSK_SCHEDULES_C2C.split('|')[0];
        var hours = response.data.DSK_SCHEDULES_C2C.split('|');

        _this2.form.days[0].am.active = !lodash_default.a.isEmpty(hours[1] + hours[2] + hours[3] + hours[4]) && !lodash_default.a.isNil(hours[1]) && !lodash_default.a.isNil(hours[2]) && !lodash_default.a.isNil(hours[3]) && !lodash_default.a.isNil(hours[4]);
        _this2.form.days[0].am.start = _this2.form.days[0].am.active ? hours[1] + ':' + hours[2] : '00:00';
        _this2.form.days[0].am.end = _this2.form.days[0].am.active ? hours[3] + ':' + hours[4] : '00:00';
        _this2.form.days[0].pm.active = !lodash_default.a.isEmpty(hours[5] + hours[6] + hours[7] + hours[8]);
        _this2.form.days[0].pm.start = _this2.form.days[0].pm.active ? hours[5] + ':' + hours[6] : '12:00';
        _this2.form.days[0].pm.end = _this2.form.days[0].pm.active ? hours[7] + ':' + hours[8] : '12:00';

        _this2.form.days[1].am.active = !lodash_default.a.isEmpty(hours[9] + hours[10] + hours[11] + hours[12]);
        _this2.form.days[1].am.start = _this2.form.days[1].am.active ? hours[9] + ':' + hours[10] : '00:00';
        _this2.form.days[1].am.end = _this2.form.days[1].am.active ? hours[11] + ':' + hours[12] : '00:00';
        _this2.form.days[1].pm.active = !lodash_default.a.isEmpty(hours[13] + hours[14] + hours[15] + hours[16]);
        _this2.form.days[1].pm.start = _this2.form.days[1].am.active ? hours[13] + ':' + hours[14] : '12:00';
        _this2.form.days[1].pm.end = _this2.form.days[1].am.active ? hours[15] + ':' + hours[16] : '12:00';

        _this2.form.days[2].am.active = !lodash_default.a.isEmpty(hours[17] + hours[18] + hours[19] + hours[20]);
        _this2.form.days[2].am.start = _this2.form.days[2].am.active ? hours[17] + ':' + hours[18] : '00:00';
        _this2.form.days[2].am.end = _this2.form.days[2].am.active ? hours[19] + ':' + hours[20] : '00:00';
        _this2.form.days[2].pm.active = !lodash_default.a.isEmpty(hours[21] + hours[22] + hours[23] + hours[24]);
        _this2.form.days[2].pm.start = _this2.form.days[2].pm.active ? hours[21] + ':' + hours[22] : '12:00';
        _this2.form.days[2].pm.end = _this2.form.days[2].pm.active ? hours[23] + ':' + hours[24] : '12:00';

        _this2.form.days[3].am.active = !lodash_default.a.isEmpty(hours[25] + hours[26] + hours[27] + hours[28]);
        _this2.form.days[3].am.start = _this2.form.days[3].am.active ? hours[25] + ':' + hours[26] : '00:00';
        _this2.form.days[3].am.end = _this2.form.days[3].am.active ? hours[27] + ':' + hours[28] : '00:00';
        _this2.form.days[3].pm.active = !lodash_default.a.isEmpty(hours[29] + hours[30] + hours[31] + hours[32]);
        _this2.form.days[3].pm.start = _this2.form.days[3].pm.active ? hours[29] + ':' + hours[30] : '12:00';
        _this2.form.days[3].pm.end = _this2.form.days[3].pm.active ? hours[31] + ':' + hours[32] : '12:00';

        _this2.form.days[4].am.active = !lodash_default.a.isEmpty(hours[33] + hours[34] + hours[35] + hours[36]);
        _this2.form.days[4].am.start = _this2.form.days[4].am.active ? hours[33] + ':' + hours[34] : '00:00';
        _this2.form.days[4].am.end = _this2.form.days[4].am.active ? hours[35] + ':' + hours[36] : '00:00';
        _this2.form.days[4].pm.active = !lodash_default.a.isEmpty(hours[37] + hours[38] + hours[39] + hours[40]);
        _this2.form.days[4].pm.start = _this2.form.days[4].pm.active ? hours[37] + ':' + hours[38] : '12:00';
        _this2.form.days[4].pm.end = _this2.form.days[4].pm.active ? hours[39] + ':' + hours[40] : '12:00';

        _this2.form.days[5].am.active = !lodash_default.a.isEmpty(hours[41] + hours[42] + hours[43] + hours[44]);
        _this2.form.days[5].am.start = _this2.form.days[5].am.active ? hours[41] + ':' + hours[42] : '00:00';
        _this2.form.days[5].am.end = _this2.form.days[5].am.active ? hours[43] + ':' + hours[44] : '00:00';
        _this2.form.days[5].pm.active = !lodash_default.a.isEmpty(hours[45] + hours[46] + hours[47] + hours[48]);
        _this2.form.days[5].pm.start = _this2.form.days[5].pm.active ? hours[45] + ':' + hours[46] : '12:00';
        _this2.form.days[5].pm.end = _this2.form.days[5].pm.active ? hours[47] + ':' + hours[48] : '12:00';

        _this2.form.days[6].am.active = !lodash_default.a.isEmpty(hours[49] + hours[50] + hours[51] + hours[52]);
        _this2.form.days[6].am.start = _this2.form.days[6].am.active ? hours[49] + ':' + hours[50] : '00:00';
        _this2.form.days[6].am.end = _this2.form.days[6].am.active ? hours[51] + ':' + hours[52] : '00:00';
        _this2.form.days[6].pm.active = !lodash_default.a.isEmpty(hours[53] + hours[54] + hours[55] + hours[56]);
        _this2.form.days[6].pm.start = _this2.form.days[6].pm.active ? hours[53] + ':' + hours[54] : '12:00';
        _this2.form.days[6].pm.end = _this2.form.days[6].pm.active ? hours[55] + ':' + hours[56] : '12:00';
      }).catch(function (_) {}).then(function (_) {
        _this2.loadingGet = false;
      });
    },
    postOptions: function postOptions() {
      var _this3 = this;

      var dataToPost = new window.FormData();

      dataToPost.append('DSK_ID', this.$store.state._Sites.siteSelected.LIC_DSK_ID);
      dataToPost.append('LIC_KEY', this.$store.state._Sites.siteSelected.LIC_KEY);
      dataToPost.append('DSK_CALLBACK_ONOFF', this.onOff ? '1' : '0');
      dataToPost.append('DSK_CALLBACK_DELAY', this.timeout);
      dataToPost.append('DSK_CALLBACK_STYLE', this.style);
      dataToPost.append('DSK_CALLBACK_TITLE', this.title);
      dataToPost.append('DSK_CALLBACK_OPTION', this.lang.value);
      dataToPost.append('DSK_CALLBACK_MSG', this.msg);
      dataToPost.append('DSK_CALLBACK_IMG', this.img);
      dataToPost.append('DSK_CALLBACK_DEPENDANT', this.dependency);
      dataToPost.append('DSK_CALLBACK_HIDEICON', this.hideIcon);
      dataToPost.append('DSK_CALLBACK_HIDE_MOBILE', this.hiddenMobile ? '1' : '0');

      dataToPost.append('DSK_CALLBACK_SHOW_ONOFF', this.form.urls === 'showOnOff' ? '1' : '0');
      dataToPost.append('DSK_CALLBACK_HIDE_ONOFF', this.form.urls === 'hideOnOff' ? '1' : '0');
      var url = { 'showOnOff': '', hideOnOff: '' };
      var partUrl = { 'showOnOff': '', hideOnOff: '' };
      var tags = { 'showOnOff': '', hideOnOff: '' };
      var classId = { 'showOnOff': '', hideOnOff: '' };
      lodash_default.a.each(this.form.rules, function (rule) {
        if (_this3.typeRules[0].value === rule.type.value) {
          url[rule.list] += rule.content + '|';
        } else if (_this3.typeRules[1].value === rule.type.value) {
          partUrl[rule.list] += rule.content + '|';
        } else if (_this3.typeRules[2].value === rule.type.value) {
          tags[rule.list] += rule.content + '|';
        } else if (_this3.typeRules[3].value === rule.type.value) {
          classId[rule.list] += rule.content + '|';
        }
      });
      dataToPost.append('DSK_CALLBACK_SHOW_URL', url.showOnOff);
      dataToPost.append('DSK_CALLBACK_SHOW_PART_URL', partUrl.showOnOff);
      dataToPost.append('DSK_CALLBACK_SHOW_TAGS', tags.showOnOff);
      dataToPost.append('DSK_CALLBACK_SHOW_CLASS_ID', classId.showOnOff);
      dataToPost.append('DSK_CALLBACK_HIDE_URL', url.hideOnOff);
      dataToPost.append('DSK_CALLBACK_HIDE_PART_URL', partUrl.hideOnOff);
      dataToPost.append('DSK_CALLBACK_HIDE_TAGS', tags.hideOnOff);
      dataToPost.append('DSK_CALLBACK_HIDE_CLASS_ID', classId.hideOnOff);

      var hours = this.form.hours;
      lodash_default.a.each(this.form.days, function (day) {
        hours += day.am.active ? '|' + day.am.start.split(':')[0] + '|' + day.am.start.split(':')[1] + '|' + day.am.end.split(':')[0] + '|' + day.am.end.split(':')[1] : '||||';
        hours += day.pm.active ? '|' + day.pm.start.split(':')[0] + '|' + day.pm.start.split(':')[1] + '|' + day.pm.end.split(':')[0] + '|' + day.pm.end.split(':')[1] : '||||';
      });
      dataToPost.append('DSK_SCHEDULES_C2C', hours);
      this.loadingPost = true;
      this.axios.post('post/settings_callback.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this3.$t('modifSuccess'),
          context: 'success'
        });
      }).catch(function (_) {
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this3.$t('modifFailure'),
          context: 'error'
        });
      }).then(function (_) {
        _this3.loadingPost = false;
      });
    },
    openDialog: function openDialog(data) {
      this.titleDialog = data.title;
      this.contentDialog = data.content;
    },
    fermeDialogInfos: function fermeDialogInfos() {
      this.titleDialog = '';
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function $storeState_SitesSiteSelected(v) {
      this.getOptions();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b726042","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Callback.vue
var Callback_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],attrs:{"color":"primary","value":"true","outline":""}},[_vm._v("\n      Ces réglages affectent la fonctionnalité callback (click-to-call) sur le site "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))]),_vm._v(". Ses réglages sont indépendants des réglages du \"widget\".\n    ")]),_vm._v(" "),_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.alert),expression:"alert"}],attrs:{"color":"secondary","icon":"warning","value":"true","outline":""}},[_vm._v("\n      "+_vm._s(_vm.$t('warningCallbackDisabled'))+" "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))])]),_vm._v(" "),_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"color":"warning","icon":"warning","value":"true","outline":""}},[_vm._v("\n      "+_vm._s(_vm.$t('warningMeetingConflict'))+" "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))])]),_vm._v(" "),_c('div',[(_vm.loadingGet)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm.onOff ? 'CALLBACK ON' : 'CALLBACK OFF',"light":"","color":"primary"},model:{value:(_vm.onOff),callback:function ($$v) {_vm.onOff=$$v},expression:"onOff"}})],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("today")]),_vm._v(" Affichage\n          ")],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md10":""}},[_c('v-card',[_c('v-card-text',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Style")]),_vm._v(" "),_c('v-radio-group',{model:{value:(_vm.style),callback:function ($$v) {_vm.style=$$v},expression:"style"}},[_c('v-radio',{staticClass:"primary--text",attrs:{"label":"Tirette + Popup latérale","value":"TIRETTE1"}}),_vm._v(" "),_c('v-radio',{staticClass:"primary--text",attrs:{"label":"Tirette + Popup Centrale","value":"TIRETTE2"}}),_vm._v(" "),_c('v-radio',{staticClass:"primary--text",attrs:{"label":"Sur le widget de chat","value":""}})],1),_vm._v(" "),(_vm.style !== 'TIRETTE1' && _vm.style !== 'TIRETTE2')?_c('div',[_c('v-switch',{attrs:{"label":"Masquer l'icône d'appel","light":"","color":"primary"},model:{value:(_vm.hideIcon),callback:function ($$v) {_vm.hideIcon=$$v},expression:"hideIcon"}})],1):_vm._e()],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("alarm")]),_vm._v(" Faire automatiquement apparaître le formulaire après un certain temps (0sec. = pas d'apparition automatique)")],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-slider',{attrs:{"min":"0","max":"300"},model:{value:(_vm.timeout),callback:function ($$v) {_vm.timeout=$$v},expression:"timeout"}})],1),_vm._v(" "),_c('v-flex',[_c('v-subheader',[_vm._v(_vm._s(_vm.timeout)+" sec.")])],1)],1),_vm._v(" "),_c('v-select',{attrs:{"items":_vm.langs,"label":_vm.$t('callbackOnlyLanguage'),"return-object":"","dense":""},model:{value:(_vm.lang),callback:function ($$v) {_vm.lang=$$v},expression:"lang"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("text_fields")]),_vm._v(" "+_vm._s(_vm.$t('Contenu éditorial du widget')))],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":_vm._f("cap")(_vm.$t('title')),"required":"","data-vv-name":"title","error":_vm.wzErrors.has('title'),"error-messages":_vm.wzErrors.collect('title')},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":_vm._f("cap")(_vm.$t('content')),"required":"","data-vv-name":"msg","error":_vm.wzErrors.has('msg'),"error-messages":_vm.wzErrors.collect('msg')},model:{value:(_vm.msg),callback:function ($$v) {_vm.msg=$$v},expression:"msg"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("schedule")]),_vm._v(" Restrictions d'affichage (horaires)\n            "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.openDialog(
                {
                  title: 'Visualiser et activer le Callback',
                  content: 'Les horaires ci-paramétrés régissent la visualisation du callback : la tirette Click To Action par exemple. En dehors des heures éligibles, la tirette ne sera pas visible. Les règles d\'affichage du widget (1ère section à gauche) n\'influencent pas la tirette.'
                }
              )}}},[_c('template',{slot:"activator"},[_c('v-icon',{staticClass:"infos",attrs:{"color":"grey lighten-1","dark":""}},[_vm._v("info")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('enSavoirPlus')))])],2)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("displayTimes"))))]),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-radio-group',{attrs:{"hint":_vm.$t('defineWidgetHours'),"persistent-hint":""},model:{value:(_vm.form.hours),callback:function ($$v) {_vm.$set(_vm.form, "hours", $$v)},expression:"form.hours"}},[_c('v-radio',{attrs:{"label":_vm._f("cap")(_vm.$t('allTheTime')),"color":"primary","value":"all"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":_vm._f("cap")(_vm.$t('customHours')),"color":"primary","value":"defined"}})],1)],1)],1),_vm._v(" "),(_vm.form.hours == 'defined')?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"primary--text",attrs:{"flat":""},on:{"click":function($event){_vm.openHours()}}},[_vm._v(_vm._s(_vm.$t('timesSeveralDays'))),_c('v-icon',{attrs:{"right":""}},[_vm._v("event")])],1)],1),_vm._v(" "),_c('v-expansion-panel',_vm._l((_vm.form.days),function(day){return _c('v-expansion-panel-content',{key:day.name},[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":""},slot:"header"},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"hidden-md-and-up"},[_vm._v(_vm._s(day.name.substring(0, 3))+". : ")]),_vm._v(" "),_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(_vm._s(day.name)+" : ")]),_vm._v(" "),(day.am.active || day.pm.active)?_c('span',[(day.am.active)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('from'))),_c('code',[_vm._v(_vm._s(day.am.start))]),_vm._v(" "+_vm._s(_vm.$t('to'))+" "),_c('code',[_vm._v(_vm._s(day.am.end))])]):_vm._e(),_vm._v(" "),(day.am.active && day.pm.active)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('and')))]):_vm._e(),_vm._v(" "),(day.pm.active)?_c('span',[_vm._v(_vm._s(_vm.$t('from'))+" "),_c('code',[_vm._v(_vm._s(day.pm.start))]),_vm._v(" "+_vm._s(_vm.$t('to'))+" "),_c('code',[_vm._v(_vm._s(day.pm.end))])]):_vm._e()]):_c('span',[_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("disabledToday"))))])])])],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('activateMorning')),"light":"","color":"primary"},model:{value:(day.am.active),callback:function ($$v) {_vm.$set(day.am, "active", $$v)},expression:"day.am.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('from') + " " + (day.name) + " " + _vm.$t('morning'),"prepend-icon":"access_time","disabled":!day.am.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'am', 'start')}},slot:"activator",model:{value:(day.am.start),callback:function ($$v) {_vm.$set(day.am, "start", $$v)},expression:"day.am.start"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('to') + " " + (day.name) + " " + _vm.$t('morning'),"prepend-icon":"access_time","disabled":!day.am.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'am', 'end')}},slot:"activator",model:{value:(day.am.end),callback:function ($$v) {_vm.$set(day.am, "end", $$v)},expression:"day.am.end"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('activateAfternoon')),"light":"","color":"primary"},model:{value:(day.pm.active),callback:function ($$v) {_vm.$set(day.pm, "active", $$v)},expression:"day.pm.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('from') + " " + (day.name) + " " + _vm.$t('afternoon'),"prepend-icon":"access_time","disabled":!day.pm.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'pm', 'start')}},slot:"activator",model:{value:(day.pm.start),callback:function ($$v) {_vm.$set(day.pm, "start", $$v)},expression:"day.pm.start"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('to') + " " + (day.name) + " " + _vm.$t('afternoon'),"prepend-icon":"access_time","disabled":!day.pm.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'pm', 'end')}},slot:"activator",model:{value:(day.pm.end),callback:function ($$v) {_vm.$set(day.pm, "end", $$v)},expression:"day.pm.end"}})],1)],1)],1)],1)],1)}),1)],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("language")]),_vm._v(_vm._s(_vm._f("cap")(_vm.$t('urlDisplay')))+"\n            "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.openDialog(
                {
                  title: 'Visualiser et activer le Callback',
                  content: 'Les listes ci-paramétrées régissent la visualisation de la tirette Click To Action. En dehors des pages éligibles, la tirette ne sera pas visible. Les règles d\'affichage du widget (1ère section à gauche) n\'influencent pas la tirette.'
                }
              )}}},[_c('template',{slot:"activator"},[_c('v-icon',{staticClass:"infos",attrs:{"color":"grey lighten-1","dark":""}},[_vm._v("info")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('enSavoirPlus')))])],2)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-radio-group',{attrs:{"hint":_vm.$t('chooseWhiteOrBlackC2C'),"persistent-hint":""},model:{value:(_vm.form.urls),callback:function ($$v) {_vm.$set(_vm.form, "urls", $$v)},expression:"form.urls"}},[_c('v-radio',{attrs:{"label":_vm._f("cap")(_vm.$t('everywhere')),"color":"primary","value":"all"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"White List","color":"primary","value":"showOnOff"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Black List","color":"primary","value":"hideOnOff"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.urls != 'all'),expression:"form.urls != 'all'"}],attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',[_c('v-fab-transition',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.urls != 'all'),expression:"form.urls != 'all'"}],staticClass:"secondary",attrs:{"dark":"","absolute":"","top":"","right":"","fab":""},on:{"click":function($event){$event.stopPropagation();_vm.openRule()}}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersRules,"items":_vm.form.rules,"no-data-text":_vm.$t('noRules'),"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item.list === _vm.form.urls)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":props.item.type,"cancel-text":_vm.$t('cancel'),"save-text":_vm.$t('submit'),"large":""},on:{"update:returnValue":function($event){_vm.$set(props.item, "type", $event)}}},[_c('div',[_vm._v(_vm._s(props.item.type.text))]),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v(_vm._s(_vm.$t('changeType')))]),_vm._v(" "),_c('v-select',{attrs:{"slot":"input","items":_vm.typeRules,"return-object":"","autofocus":""},slot:"input",model:{value:(props.item.type),callback:function ($$v) {_vm.$set(props.item, "type", $$v)},expression:"props.item.type"}})],1)],1):_vm._e(),_vm._v(" "),(props.item.list === _vm.form.urls)?_c('td',[_c('v-edit-dialog',{attrs:{"cancel-text":_vm.$t('cancel'),"save-text":_vm.$t('submit'),"return-value":props.item.content,"large":"","lazy":""},on:{"update:returnValue":function($event){_vm.$set(props.item, "content", $event)}}},[_c('div',[_c('code',[_vm._v(_vm._s(props.item.content))])]),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v(_vm._s(_vm.$t('editContent')))]),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"input","label":"Modification","single-line":"","counter":"","autofocus":""},slot:"input",model:{value:(props.item.content),callback:function ($$v) {_vm.$set(props.item, "content", $$v)},expression:"props.item.content"}})],1)],1):_vm._e(),_vm._v(" "),(props.item.list === _vm.form.urls)?_c('td',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.deleteRule(props.index)}}},[_c('v-icon',[_vm._v("delete")])],1)],1):_vm._e()]}}])})],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("app_blocking")]),_vm._v("\n              Restrictions mobiles\n              "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.openDialog(
                  {
                    title: 'Visualiser et activer le Callback',
                    content: 'Masquer sur mobile indépendamment des règles horaires et de blacklist'
                  }
                )}}},[_c('template',{slot:"activator"},[_c('v-icon',{staticClass:"infos",attrs:{"color":"grey lighten-1","dark":""}},[_vm._v("info")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('enSavoirPlus')))])],2)],1),_vm._v(" "),_c('v-card',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('hideOnMobile')),"light":"","color":"primary"},model:{value:(_vm.hiddenMobile),callback:function ($$v) {_vm.hiddenMobile=$$v},expression:"hiddenMobile"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","block":_vm.$vuetify.breakpoint.xsOnly,"loading":_vm.loadingPost,"disabled":_vm.alert},nativeOn:{"click":function($event){_vm.postOptions()}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('save')))),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("save")])],1)],1),_vm._v(" "),_c('wz-dialog-infos',{attrs:{"titleDialog":_vm.titleDialog,"contentDialog":_vm.contentDialog},on:{"fermeDialog":_vm.fermeDialogInfos}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","lazy":"","max-width":"290"},model:{value:(_vm.showTp),callback:function ($$v) {_vm.showTp=$$v},expression:"showTp"}},[_c('v-time-picker',{attrs:{"actions":"","scrollable":"","format":"24hr","max":_vm.allowed.hours.max,"min":_vm.allowed.hours.min,"color":"primary"},model:{value:(_vm.daySelected[_vm.amOrPm][_vm.startOrEnd]),callback:function ($$v) {_vm.$set(_vm.daySelected[_vm.amOrPm], _vm.startOrEnd, $$v)},expression:"daySelected[amOrPm][startOrEnd]"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showTp = false; _vm.daySelected[_vm.amOrPm][_vm.startOrEnd] = _vm.tmpHours}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('cancel'))))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.showTp = false}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('submit'))))])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","width":"350px"},model:{value:(_vm.showHours),callback:function ($$v) {_vm.showHours=$$v},expression:"showHours"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('applySchedules'))))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"400px"}},[_c('v-select',{attrs:{"items":_vm.days,"label":_vm.$t('applyHours'),"return-object":""},model:{value:(_vm.dayHours),callback:function ($$v) {_vm.dayHours=$$v},expression:"dayHours"}}),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersDays,"items":_vm.days,"item-key":"text","select-all":"primary","hide-actions":"","total-items":7},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(props.header.text))])]}},{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{staticClass:"primary--text",attrs:{"hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.text))])]}}]),model:{value:(_vm.daysTmp),callback:function ($$v) {_vm.daysTmp=$$v},expression:"daysTmp"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showHours = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.daysTmp.length,"color":"primary","flat":""},on:{"click":function($event){_vm.submitHours()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.showDialogRule),callback:function ($$v) {_vm.showDialogRule=$$v},expression:"showDialogRule"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("createRule"))))]),_vm._v(" "),_c('v-card-text',[_c('form',[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.typeRules,"label":_vm.$t('ruleType'),"return-object":"","required":"","data-vv-name":"select","error":_vm.wzErrors.has('select'),"error-messages":_vm.wzErrors.collect('select')},model:{value:(_vm.ruleTmp.type),callback:function ($$v) {_vm.$set(_vm.ruleTmp, "type", $$v)},expression:"ruleTmp.type"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autofocus":"","label":_vm.$t('ruleContent'),"required":"","data-vv-name":"ruleContentInput","error":_vm.wzErrors.has('ruleContentInput'),"error-messages":_vm.wzErrors.collect('ruleContentInput')},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.submitRule()}},model:{value:(_vm.ruleTmp.content),callback:function ($$v) {_vm.$set(_vm.ruleTmp, "content", $$v)},expression:"ruleTmp.content"}})],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showDialogRule = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.wzErrors.any(),"flat":""},on:{"click":function($event){_vm.submitRule()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":5},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)}
var Callback_staticRenderFns = []
var Callback_esExports = { render: Callback_render, staticRenderFns: Callback_staticRenderFns }
/* harmony default export */ var settings_Callback = (Callback_esExports);
// CONCATENATED MODULE: ./src/components/settings/Callback.vue
var Callback_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Callback___vue_template_functional__ = false
/* styles */
var Callback___vue_styles__ = null
/* scopeId */
var Callback___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Callback___vue_module_identifier__ = null
var Callback_Component = Callback_normalizeComponent(
  Callback,
  settings_Callback,
  Callback___vue_template_functional__,
  Callback___vue_styles__,
  Callback___vue_scopeId__,
  Callback___vue_module_identifier__
)

/* harmony default export */ var components_settings_Callback = (Callback_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/settings/Sms.vue



/* harmony default export */ var Sms = ({
  data: function data() {
    return {
      alert: false,
      lang: null,
      onOff: false,
      numero: '',
      c2c: '0',
      c2c_missed: '0',
      chat: '0',
      abs: '0',

      loadingGet: false,
      loadingPost: false,
      dialogProgress: false
    };
  },
  mounted: function mounted() {
    this.getOptions();
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
  },
  created: function created() {
    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'settings_sms';
    } else {
      setTimeout(function () {
        if (typeof defautMotif !== 'undefined') {
          defautMotif = 'settings_sms';
        }
      }, 800);
    }
  },


  computed: {},

  methods: {
    getOptions: function getOptions() {
      var _this = this;

      this.numero = this.$store.state._Sites.siteSelected.LIC_SMS_PHONE;
      if (this.$store.state._Sites.siteSelected.LIC_SMS_ACTIVATED !== '1') {
        this.alert = true;
        return;
      }
      this.alert = false;
      this.loadingGet = true;
      this.axios.get('get/settings_sms.php?desk=' + this.$store.state._Sites.siteSelected.LIC_DSK_ID).then(function (response) {
        _this.onOff = response.data.DSK_SMS_ONOFF === '1';

        var features = JSON.parse(response.data.DSK_SMS_FEATURES) || {};

        _this.chat = features.chat === '1';
        _this.c2c = features.c2c === '1';
        _this.c2c_missed = features.c2c_missed === '1';
        _this.abs = features.abs === '1';
      }).catch(function (_) {}).then(function (_) {
        _this.loadingGet = false;
      });
    },
    postOptions: function postOptions() {
      var _this2 = this;

      var dataToPost = new window.FormData();

      dataToPost.append('DSK_ID', this.$store.state._Sites.siteSelected.LIC_DSK_ID);
      dataToPost.append('LIC_KEY', this.$store.state._Sites.siteSelected.LIC_KEY);
      this.$store.state._Sites.siteSelected.LIC_SMS_PHONE = this.numero;
      dataToPost.append('LIC_SMS_PHONE', this.numero);
      dataToPost.append('DSK_SMS_ONOFF', this.onOff ? '1' : '0');
      var options = {};
      options.chat = this.chat ? '1' : '0';
      options.c2c = this.c2c ? '1' : '0';
      options.c2c_missed = this.c2c_missed ? '1' : '0';
      options.abs = this.abs ? '1' : '0';
      console.log(options);
      console.log(stringify_default()(options));
      dataToPost.append('DSK_SMS_FEATURES', stringify_default()(options));

      this.loadingPost = true;
      this.axios.post('post/settings_sms.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this2.$t('modifSuccess'),
          context: 'success'
        });
      }).catch(function (_) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this2.$t('modifFailure'),
          context: 'error'
        });
      }).then(function (_) {
        _this2.loadingPost = false;
      });
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function $storeState_SitesSiteSelected(v) {
      this.getOptions();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0c098986","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Sms.vue
var Sms_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],attrs:{"color":"primary","value":"true","outline":""}},[_vm._v("\n      Ces réglages affectent la fonctionnalité SMS (notifications par texto). Ses réglages sont indépendants des réglages du \"widget\" et des autres fonctionnalités.\n    ")]),_vm._v(" "),_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.alert),expression:"alert"}],attrs:{"color":"secondary","icon":"warning","value":"true","outline":""}},[_vm._v("\n      L'option Alertes SMS est désactivée. Vous ne pourrez pas sauvegarder. "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))])]),_vm._v(" "),_c('div',[(_vm.loadingGet)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm.onOff ? 'ALERTES SMS ON' : 'ALERTES SMS OFF',"light":"","color":"primary"},model:{value:(_vm.onOff),callback:function ($$v) {_vm.onOff=$$v},expression:"onOff"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Numéro de mobile","required":""},model:{value:(_vm.numero),callback:function ($$v) {_vm.numero=$$v},expression:"numero"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm.c2c ? 'Activé pour les callbacks entrants ON' : 'Activé pour les callbacks entrants OFF',"light":"","color":"primary"},model:{value:(_vm.c2c),callback:function ($$v) {_vm.c2c=$$v},expression:"c2c"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm.c2c_missed ? 'Activé pour les callbacks ratés ON' : 'Activé pour les callbacks ratés OFF',"light":"","color":"primary"},model:{value:(_vm.c2c_missed),callback:function ($$v) {_vm.c2c_missed=$$v},expression:"c2c_missed"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm.chat ? 'Activé pour les chats entrants ON' : 'Activé pour les chats entrants OFF',"light":"","color":"primary"},model:{value:(_vm.chat),callback:function ($$v) {_vm.chat=$$v},expression:"chat"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm.abs ? 'Activé pour les messages en absence ON' : ' Activé pour les messages en absenceOFF',"light":"","color":"primary"},model:{value:(_vm.abs),callback:function ($$v) {_vm.abs=$$v},expression:"abs"}})],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","block":_vm.$vuetify.breakpoint.xsOnly,"loading":_vm.loadingPost,"disabled":_vm.alert},nativeOn:{"click":function($event){_vm.postOptions()}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('save')))),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":7},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)}
var Sms_staticRenderFns = []
var Sms_esExports = { render: Sms_render, staticRenderFns: Sms_staticRenderFns }
/* harmony default export */ var settings_Sms = (Sms_esExports);
// CONCATENATED MODULE: ./src/components/settings/Sms.vue
var Sms_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Sms___vue_template_functional__ = false
/* styles */
var Sms___vue_styles__ = null
/* scopeId */
var Sms___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Sms___vue_module_identifier__ = null
var Sms_Component = Sms_normalizeComponent(
  Sms,
  settings_Sms,
  Sms___vue_template_functional__,
  Sms___vue_styles__,
  Sms___vue_scopeId__,
  Sms___vue_module_identifier__
)

/* harmony default export */ var components_settings_Sms = (Sms_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/settings/ChatBot.vue





/* harmony default export */ var ChatBot = ({
  data: function data() {
    return {
      titleDialog: '',
      contentDialog: '',
      alert: false,
      onOff: false,
      buttonsHorizontal: true,
      blocTextarea: true,
      dialogImport: false,
      agent: {},
      agentSource: {},
      loadingImport: false,
      bot: [],
      form: {
        hours: '',
        days: [{
          name: this.$t('monday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('tuesday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('wednesday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('thursday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('friday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('saturday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('sunday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }],

        urls: '',
        rules: []
      },

      showTp: false,
      daySelected: {},
      tmpHours: null,
      amOrPm: 'am',
      startOrEnd: 'start',
      allowed: { hours: { min: '0:00', max: '12:00' } },
      dependency: '',
      hideIcon: '',

      showHours: false,
      daysTmp: [],
      dayHours: null,
      days: [{ text: lodash_default.a.upperFirst(this.$t('monday')), value: 0 }, { text: lodash_default.a.upperFirst(this.$t('tuesday')), value: 1 }, { text: lodash_default.a.upperFirst(this.$t('wednesday')), value: 2 }, { text: lodash_default.a.upperFirst(this.$t('thursday')), value: 3 }, { text: lodash_default.a.upperFirst(this.$t('friday')), value: 4 }, { text: lodash_default.a.upperFirst(this.$t('saturday')), value: 5 }, { text: lodash_default.a.upperFirst(this.$t('sunday')), value: 6 }],

      tmp: '',
      headersRules: [{ text: lodash_default.a.upperFirst(this.$t('type')), align: 'left', sortable: false, value: 'type' }, { text: lodash_default.a.upperFirst(this.$t('content')), align: 'left', sortable: false, value: 'content' }, { text: '', align: 'left', sortable: false, value: 'actions' }],
      typeRules: [{ text: lodash_default.a.upperFirst(this.$t('fullUrl')), value: 'DSK_SHOW_URL' }, { text: lodash_default.a.upperFirst(this.$t('containedUrl')), value: 'DSK_SHOW_PART_URL' }, { text: lodash_default.a.upperFirst(this.$t('keyWords')), value: 'DSK_SHOW_TAGS' }, { text: lodash_default.a.upperFirst(this.$t('classOrId')), value: 'DSK_SHOW_CLASS_ID' }],
      showDialogRule: false,
      ruleTmp: { content: '', type: {} },

      loading: false,

      loadingGet: false,
      loadingPost: false,
      dialogProgress: false
    };
  },
  mounted: function mounted() {
    this.getOptions();
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
  },
  created: function created() {
    this.daySelected = this.form.days[0];
    this.dayHours = { text: this.form.days[0].name, value: 0 };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_User', ['user']), {
    activeFilters: function activeFilters() {
      return 1;
    },
    headersDays: function headersDays() {
      return !this.daysTmp.length ? [{ text: this.$t('allDays'), align: 'left', sortable: false }] : [{ text: this.$t('noDays'), align: 'left', sortable: false }];
    }
  }),
  methods: {
    getOptions: function getOptions() {
      var _this = this;

      if (this.$store.state._Sites.siteSelected.LIC_BOT_ACTIVATED !== '1') {
        this.alert = true;
        return;
      }
      this.alert = false;
      this.loadingGet = true;
      this.axios.get('get/settings_bot.php?desk=' + this.$store.state._Sites.siteSelected.LIC_DSK_ID).then(function (response) {
        _this.onOff = response.data.DSK_BOT_ONOFF === '1';
        _this.buttonsHorizontal = response.data.DSK_BOT_BUTTONS_HORIZONTAL === '1';
        _this.blocTextarea = response.data.DSK_BOT_TEXTAREA === '1';

        _this.form.urls = 'all';
        if (response.data.DSK_BOT_SHOW_ONOFF === '1') {
          _this.form.urls = 'showOnOff';
        } else if (response.data.DSK_BOT_HIDE_ONOFF === '1') {
          _this.form.urls = 'hideOnOff';
        }
        _this.form.rules = [];

        lodash_default.a.each(response.data.DSK_BOT_SHOW_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[0]), 'list': 'showOnOff' });
        });
        lodash_default.a.each(response.data.DSK_BOT_SHOW_PART_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[1]), 'list': 'showOnOff' });
        });
        lodash_default.a.each(response.data.DSK_BOT_SHOW_TAGS.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[2]), 'list': 'showOnOff' });
        });
        lodash_default.a.each(response.data.DSK_BOT_SHOW_CLASS_ID.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[3]), 'list': 'showOnOff' });
        });

        lodash_default.a.each(response.data.DSK_BOT_HIDE_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[0]), 'list': 'hideOnOff' });
        });
        lodash_default.a.each(response.data.DSK_BOT_HIDE_PART_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[1]), 'list': 'hideOnOff' });
        });
        lodash_default.a.each(response.data.DSK_BOT_HIDE_TAGS.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[2]), 'list': 'hideOnOff' });
        });
        lodash_default.a.each(response.data.DSK_BOT_HIDE_CLASS_ID.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this.form.rules.push({ content: url, type: lodash_default.a.clone(_this.typeRules[3]), 'list': 'hideOnOff' });
        });

        _this.form.hours = response.data.DSK_SCHEDULES_BOT.split('|')[0];
        var hours = response.data.DSK_SCHEDULES_BOT.split('|');

        _this.form.days[0].am.active = !lodash_default.a.isEmpty(hours[1] + hours[2] + hours[3] + hours[4]) && !lodash_default.a.isNil(hours[1]) && !lodash_default.a.isNil(hours[2]) && !lodash_default.a.isNil(hours[3]) && !lodash_default.a.isNil(hours[4]);
        _this.form.days[0].am.start = _this.form.days[0].am.active ? hours[1] + ':' + hours[2] : '00:00';
        _this.form.days[0].am.end = _this.form.days[0].am.active ? hours[3] + ':' + hours[4] : '00:00';
        _this.form.days[0].pm.active = !lodash_default.a.isEmpty(hours[5] + hours[6] + hours[7] + hours[8]);
        _this.form.days[0].pm.start = _this.form.days[0].pm.active ? hours[5] + ':' + hours[6] : '12:00';
        _this.form.days[0].pm.end = _this.form.days[0].pm.active ? hours[7] + ':' + hours[8] : '12:00';

        _this.form.days[1].am.active = !lodash_default.a.isEmpty(hours[9] + hours[10] + hours[11] + hours[12]);
        _this.form.days[1].am.start = _this.form.days[1].am.active ? hours[9] + ':' + hours[10] : '00:00';
        _this.form.days[1].am.end = _this.form.days[1].am.active ? hours[11] + ':' + hours[12] : '00:00';
        _this.form.days[1].pm.active = !lodash_default.a.isEmpty(hours[13] + hours[14] + hours[15] + hours[16]);
        _this.form.days[1].pm.start = _this.form.days[1].am.active ? hours[13] + ':' + hours[14] : '12:00';
        _this.form.days[1].pm.end = _this.form.days[1].am.active ? hours[15] + ':' + hours[16] : '12:00';

        _this.form.days[2].am.active = !lodash_default.a.isEmpty(hours[17] + hours[18] + hours[19] + hours[20]);
        _this.form.days[2].am.start = _this.form.days[2].am.active ? hours[17] + ':' + hours[18] : '00:00';
        _this.form.days[2].am.end = _this.form.days[2].am.active ? hours[19] + ':' + hours[20] : '00:00';
        _this.form.days[2].pm.active = !lodash_default.a.isEmpty(hours[21] + hours[22] + hours[23] + hours[24]);
        _this.form.days[2].pm.start = _this.form.days[2].pm.active ? hours[21] + ':' + hours[22] : '12:00';
        _this.form.days[2].pm.end = _this.form.days[2].pm.active ? hours[23] + ':' + hours[24] : '12:00';

        _this.form.days[3].am.active = !lodash_default.a.isEmpty(hours[25] + hours[26] + hours[27] + hours[28]);
        _this.form.days[3].am.start = _this.form.days[3].am.active ? hours[25] + ':' + hours[26] : '00:00';
        _this.form.days[3].am.end = _this.form.days[3].am.active ? hours[27] + ':' + hours[28] : '00:00';
        _this.form.days[3].pm.active = !lodash_default.a.isEmpty(hours[29] + hours[30] + hours[31] + hours[32]);
        _this.form.days[3].pm.start = _this.form.days[3].pm.active ? hours[29] + ':' + hours[30] : '12:00';
        _this.form.days[3].pm.end = _this.form.days[3].pm.active ? hours[31] + ':' + hours[32] : '12:00';

        _this.form.days[4].am.active = !lodash_default.a.isEmpty(hours[33] + hours[34] + hours[35] + hours[36]);
        _this.form.days[4].am.start = _this.form.days[4].am.active ? hours[33] + ':' + hours[34] : '00:00';
        _this.form.days[4].am.end = _this.form.days[4].am.active ? hours[35] + ':' + hours[36] : '00:00';
        _this.form.days[4].pm.active = !lodash_default.a.isEmpty(hours[37] + hours[38] + hours[39] + hours[40]);
        _this.form.days[4].pm.start = _this.form.days[4].pm.active ? hours[37] + ':' + hours[38] : '12:00';
        _this.form.days[4].pm.end = _this.form.days[4].pm.active ? hours[39] + ':' + hours[40] : '12:00';

        _this.form.days[5].am.active = !lodash_default.a.isEmpty(hours[41] + hours[42] + hours[43] + hours[44]);
        _this.form.days[5].am.start = _this.form.days[5].am.active ? hours[41] + ':' + hours[42] : '00:00';
        _this.form.days[5].am.end = _this.form.days[5].am.active ? hours[43] + ':' + hours[44] : '00:00';
        _this.form.days[5].pm.active = !lodash_default.a.isEmpty(hours[45] + hours[46] + hours[47] + hours[48]);
        _this.form.days[5].pm.start = _this.form.days[5].pm.active ? hours[45] + ':' + hours[46] : '12:00';
        _this.form.days[5].pm.end = _this.form.days[5].pm.active ? hours[47] + ':' + hours[48] : '12:00';

        _this.form.days[6].am.active = !lodash_default.a.isEmpty(hours[49] + hours[50] + hours[51] + hours[52]);
        _this.form.days[6].am.start = _this.form.days[6].am.active ? hours[49] + ':' + hours[50] : '00:00';
        _this.form.days[6].am.end = _this.form.days[6].am.active ? hours[51] + ':' + hours[52] : '00:00';
        _this.form.days[6].pm.active = !lodash_default.a.isEmpty(hours[53] + hours[54] + hours[55] + hours[56]);
        _this.form.days[6].pm.start = _this.form.days[6].pm.active ? hours[53] + ':' + hours[54] : '12:00';
        _this.form.days[6].pm.end = _this.form.days[6].pm.active ? hours[55] + ':' + hours[56] : '12:00';
      }).catch(function (_) {}).then(function (_) {
        _this.loadingGet = false;
      });
    },
    postOptions: function postOptions() {
      var _this2 = this;

      if (this.onOff === false || this.bot[0] && this.bot[0].USR_ID && typeof this.bot[0].USR_ID !== 'undefined') {
        var botUsrId = '';
        if (this.bot[0] && this.bot[0].USR_ID && typeof this.bot[0].USR_ID !== 'undefined') {
          botUsrId = this.bot[0].USR_ID;
        }

        var dataToPost = new window.FormData();
        dataToPost.append('DSK_ID', this.$store.state._Sites.siteSelected.LIC_DSK_ID);
        dataToPost.append('LIC_KEY', this.$store.state._Sites.siteSelected.LIC_KEY);
        dataToPost.append('DSK_BOT_ONOFF', this.onOff ? '1' : '0');
        dataToPost.append('DSK_BOT_BUTTONS_HORIZONTAL', this.buttonsHorizontal ? '1' : '0');
        dataToPost.append('bot_user_id', botUsrId);
        dataToPost.append('DSK_BOT_TEXTAREA', this.blocTextarea ? '1' : '0');

        dataToPost.append('DSK_BOT_HIDE_ONOFF', this.form.urls === 'hideOnOff' ? '1' : '0');
        dataToPost.append('DSK_BOT_SHOW_ONOFF', this.form.urls === 'showOnOff' ? '1' : '0');
        var url = { 'showOnOff': '', hideOnOff: '' };
        var partUrl = { 'showOnOff': '', hideOnOff: '' };
        var tags = { 'showOnOff': '', hideOnOff: '' };
        var classId = { 'showOnOff': '', hideOnOff: '' };
        lodash_default.a.each(this.form.rules, function (rule) {
          if (_this2.typeRules[0].value === rule.type.value) {
            url[rule.list] += rule.content + '|';
          } else if (_this2.typeRules[1].value === rule.type.value) {
            partUrl[rule.list] += rule.content + '|';
          } else if (_this2.typeRules[2].value === rule.type.value) {
            tags[rule.list] += rule.content + '|';
          } else if (_this2.typeRules[3].value === rule.type.value) {
            classId[rule.list] += rule.content + '|';
          }
        });
        dataToPost.append('DSK_BOT_SHOW_URL', url.showOnOff);
        dataToPost.append('DSK_BOT_SHOW_PART_URL', partUrl.showOnOff);
        dataToPost.append('DSK_BOT_SHOW_TAGS', tags.showOnOff);
        dataToPost.append('DSK_BOT_SHOW_CLASS_ID', classId.showOnOff);
        dataToPost.append('DSK_BOT_HIDE_URL', url.hideOnOff);
        dataToPost.append('DSK_BOT_HIDE_PART_URL', partUrl.hideOnOff);
        dataToPost.append('DSK_BOT_HIDE_TAGS', tags.hideOnOff);
        dataToPost.append('DSK_BOT_HIDE_CLASS_ID', classId.hideOnOff);

        var hours = this.form.hours;
        lodash_default.a.each(this.form.days, function (day) {
          hours += day.am.active ? '|' + day.am.start.split(':')[0] + '|' + day.am.start.split(':')[1] + '|' + day.am.end.split(':')[0] + '|' + day.am.end.split(':')[1] : '||||';
          hours += day.pm.active ? '|' + day.pm.start.split(':')[0] + '|' + day.pm.start.split(':')[1] + '|' + day.pm.end.split(':')[0] + '|' + day.pm.end.split(':')[1] : '||||';
        });
        dataToPost.append('DSK_SCHEDULES_BOT', hours);

        this.loadingPost = true;
        this.axios.post('post/settings_bot.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(function (response) {
          _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: _this2.$t('modifSuccess'),
            context: 'success'
          });
        }).catch(function (_) {
          _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: _this2.$t('modifFailure'),
            context: 'error'
          });
        }).then(function (_) {
          _this2.loadingPost = false;
        });
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Please select a bot in the list',
          context: 'error'
        });
      }
    },
    openDialog: function openDialog(data) {
      this.titleDialog = data.title;
      this.contentDialog = data.content;
    },
    fermeDialogInfos: function fermeDialogInfos() {
      this.titleDialog = '';
    },
    openTimePicker: function openTimePicker(day, amOrPm, startOrEnd) {
      this.showTp = true;
      this.daySelected = day;
      this.amOrPm = amOrPm;
      this.startOrEnd = startOrEnd;
      this.tmpHours = this.daySelected[amOrPm][startOrEnd];

      this.allowed.hours = amOrPm === 'am' ? { min: '0:00', max: '12:59' } : { min: '12:00', max: '23:59' };
    },
    openHours: function openHours() {
      this.showHours = true;
    },
    submitHours: function submitHours() {
      var _this3 = this;

      this.showHours = false;

      var daySelected = this.form.days.find(function (d) {
        return d.name === _this3.dayHours.text;
      });
      this.daysTmp.forEach(function (day) {
        var d = _this3.form.days.find(function (d) {
          return d.name === day.text.toLowerCase();
        });
        d.am = lodash_default.a.cloneDeep(daySelected.am);
        d.pm = lodash_default.a.cloneDeep(daySelected.pm);
      });
      this.daysTmp = [];
    },
    openRule: function openRule() {
      this.showDialogRule = true;
      this.ruleTmp = { content: '', type: this.typeRules[0], list: this.form.urls };
    },
    submitRule: function submitRule() {
      if (!lodash_default.a.isEmpty(this.ruleTmp.content)) {
        this.showDialogRule = false;
        this.form.rules.push(lodash_default.a.clone(this.ruleTmp));
      } else {
        this.$validator.validateAll();
      }
    },
    deleteRule: function deleteRule(index) {
      this.form.rules.splice(index, 1);
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    }
  },

  watch: {
    'agent': function agent(val, oldVal) {
      this.init();
    },
    '$store.state._Sites.siteSelected': function $storeState_SitesSiteSelected(v) {
      this.getOptions();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-be2e2de6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/ChatBot.vue
var ChatBot_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],attrs:{"color":"primary","value":"true","outline":""}},[_vm._v("\n      Ces réglages affectent le chatbot sur le site "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))]),_vm._v(". Le chatbot est à l'intérieur du \"widget\" et est soumis à ses règles d'affichage.\n    ")]),_vm._v(" "),_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.alert),expression:"alert"}],attrs:{"color":"secondary","icon":"warning","value":"true","outline":""}},[_vm._v("\n      Attention, l'option ChatBot n'est pas activée pour le site "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))])]),_vm._v(" "),(!_vm.alert)?_c('div',[(_vm.loadingGet)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm.onOff ? 'CHATBOT ON' : 'CHATBOT OFF',"light":"","color":"primary"},model:{value:(_vm.onOff),callback:function ($$v) {_vm.onOff=$$v},expression:"onOff"}})],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("today")]),_vm._v(" Options internes au chatbot")],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":'Boutons de choix affichés horizontalement ?',"light":"","color":"primary","hint":"Les boutons seront affichés de manière verticale si décoché (horizontale par défaut)","persistent-hint":"","disabled":!_vm.onOff},model:{value:(_vm.buttonsHorizontal),callback:function ($$v) {_vm.buttonsHorizontal=$$v},expression:"buttonsHorizontal"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":'Bloquer le champs de saisie',"light":"","color":"primary","hint":"Seule une instruction Watson peut débloquer le champs de saisie (et pour une seule bulle)","persistent-hint":"","disabled":!_vm.onOff},model:{value:(_vm.blocTextarea),callback:function ($$v) {_vm.blocTextarea=$$v},expression:"blocTextarea"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("schedule")]),_vm._v(" \n            Restrictions d'affichage (horaires)\n            "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.openDialog(
                {
                  title: 'Visualiser et activer le chatbot',
                  content: 'La visualisation du chatbot est avant tout conditionnée par l\'affichage du widget (voir 1ère section à gauche). Les horaires ci-paramétrés régissent seulement l\'activation du chatbot. En dehors de heures éligibles, c\'est le tchat ou le formulaire en absence qui seront proposés.'
                }
              )}}},[_c('template',{slot:"activator"},[_c('v-icon',{staticClass:"infos",attrs:{"color":"grey lighten-1","dark":""}},[_vm._v("info")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('enSavoirPlus')))])],2)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("displayTimes"))))]),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-radio-group',{attrs:{"hint":_vm.$t('defineWidgetHours'),"persistent-hint":""},model:{value:(_vm.form.hours),callback:function ($$v) {_vm.$set(_vm.form, "hours", $$v)},expression:"form.hours"}},[_c('v-radio',{attrs:{"label":_vm._f("cap")(_vm.$t('allTheTime')),"color":"primary","value":"all"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":_vm._f("cap")(_vm.$t('customHours')),"color":"primary","value":"defined"}})],1)],1)],1),_vm._v(" "),(_vm.form.hours == 'defined')?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"primary--text",attrs:{"flat":""},on:{"click":function($event){_vm.openHours()}}},[_vm._v(_vm._s(_vm.$t('timesSeveralDays'))),_c('v-icon',{attrs:{"right":""}},[_vm._v("event")])],1)],1),_vm._v(" "),_c('v-expansion-panel',_vm._l((_vm.form.days),function(day){return _c('v-expansion-panel-content',{key:day.name},[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":""},slot:"header"},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"hidden-md-and-up"},[_vm._v(_vm._s(day.name.substring(0, 3))+". : ")]),_vm._v(" "),_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(_vm._s(day.name)+" : ")]),_vm._v(" "),(day.am.active || day.pm.active)?_c('span',[(day.am.active)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('from'))),_c('code',[_vm._v(_vm._s(day.am.start))]),_vm._v(" "+_vm._s(_vm.$t('to'))+" "),_c('code',[_vm._v(_vm._s(day.am.end))])]):_vm._e(),_vm._v(" "),(day.am.active && day.pm.active)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('and')))]):_vm._e(),_vm._v(" "),(day.pm.active)?_c('span',[_vm._v(_vm._s(_vm.$t('from'))+" "),_c('code',[_vm._v(_vm._s(day.pm.start))]),_vm._v(" "+_vm._s(_vm.$t('to'))+" "),_c('code',[_vm._v(_vm._s(day.pm.end))])]):_vm._e()]):_c('span',[_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("disabledToday"))))])])])],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('activateMorning')),"light":"","color":"primary"},model:{value:(day.am.active),callback:function ($$v) {_vm.$set(day.am, "active", $$v)},expression:"day.am.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('from') + " " + (day.name) + " " + _vm.$t('morning'),"prepend-icon":"access_time","disabled":!day.am.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'am', 'start')}},slot:"activator",model:{value:(day.am.start),callback:function ($$v) {_vm.$set(day.am, "start", $$v)},expression:"day.am.start"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('to') + " " + (day.name) + " " + _vm.$t('morning'),"prepend-icon":"access_time","disabled":!day.am.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'am', 'end')}},slot:"activator",model:{value:(day.am.end),callback:function ($$v) {_vm.$set(day.am, "end", $$v)},expression:"day.am.end"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('activateAfternoon')),"light":"","color":"primary"},model:{value:(day.pm.active),callback:function ($$v) {_vm.$set(day.pm, "active", $$v)},expression:"day.pm.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('from') + " " + (day.name) + " " + _vm.$t('afternoon'),"prepend-icon":"access_time","disabled":!day.pm.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'pm', 'start')}},slot:"activator",model:{value:(day.pm.start),callback:function ($$v) {_vm.$set(day.pm, "start", $$v)},expression:"day.pm.start"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('to') + " " + (day.name) + " " + _vm.$t('afternoon'),"prepend-icon":"access_time","disabled":!day.pm.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'pm', 'end')}},slot:"activator",model:{value:(day.pm.end),callback:function ($$v) {_vm.$set(day.pm, "end", $$v)},expression:"day.pm.end"}})],1)],1)],1)],1)],1)}),1)],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("language")]),_vm._v("\n            "+_vm._s(_vm._f("cap")(_vm.$t('urlDisplay')))+"\n            "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.openDialog(
                {
                  title: 'Visualiser et activer le chatbot',
                  content: 'La visualisation du chatbot est avant tout conditionnée par l\'affichage du widget (voir 1ère section à gauche). Les blacklists ci-paramétrées régissent seulement l\'activation du chatbot. En dehors des pages éligibles, c\'est le tchat ou le formulaire en absence qui seront proposés.'
                }
              )}}},[_c('template',{slot:"activator"},[_c('v-icon',{staticClass:"infos",attrs:{"color":"grey lighten-1","dark":""}},[_vm._v("info")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('enSavoirPlus')))])],2)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',[_c('v-flex',{attrs:{"xs12":""}},[_c('v-radio-group',{attrs:{"hint":_vm.$t('chooseWhiteOrBlackC2C'),"persistent-hint":""},model:{value:(_vm.form.urls),callback:function ($$v) {_vm.$set(_vm.form, "urls", $$v)},expression:"form.urls"}},[_c('v-radio',{attrs:{"label":_vm._f("cap")(_vm.$t('everywhere')),"color":"primary","value":"all"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"White List","color":"primary","value":"showOnOff"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Black List","color":"primary","value":"hideOnOff"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.urls != 'all'),expression:"form.urls != 'all'"}],attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',[_c('v-fab-transition',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.urls != 'all'),expression:"form.urls != 'all'"}],staticClass:"secondary",attrs:{"dark":"","absolute":"","top":"","right":"","fab":""},on:{"click":function($event){$event.stopPropagation();_vm.openRule()}}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersRules,"items":_vm.form.rules,"no-data-text":_vm.$t('noRules'),"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item.list === _vm.form.urls)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":props.item.type,"cancel-text":_vm.$t('cancel'),"save-text":_vm.$t('submit'),"large":""},on:{"update:returnValue":function($event){_vm.$set(props.item, "type", $event)}}},[_c('div',[_vm._v(_vm._s(props.item.type.text))]),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v(_vm._s(_vm.$t('changeType')))]),_vm._v(" "),_c('v-select',{attrs:{"slot":"input","items":_vm.typeRules,"return-object":"","autofocus":""},slot:"input",model:{value:(props.item.type),callback:function ($$v) {_vm.$set(props.item, "type", $$v)},expression:"props.item.type"}})],1)],1):_vm._e(),_vm._v(" "),(props.item.list === _vm.form.urls)?_c('td',[_c('v-edit-dialog',{attrs:{"cancel-text":_vm.$t('cancel'),"save-text":_vm.$t('submit'),"return-value":props.item.content,"large":"","lazy":""},on:{"update:returnValue":function($event){_vm.$set(props.item, "content", $event)}}},[_c('div',[_c('code',[_vm._v(_vm._s(props.item.content))])]),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v(_vm._s(_vm.$t('editContent')))]),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"input","label":"Modification","single-line":"","counter":"","autofocus":""},slot:"input",model:{value:(props.item.content),callback:function ($$v) {_vm.$set(props.item, "content", $$v)},expression:"props.item.content"}})],1)],1):_vm._e(),_vm._v(" "),(props.item.list === _vm.form.urls)?_c('td',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.deleteRule(props.index)}}},[_c('v-icon',[_vm._v("delete")])],1)],1):_vm._e()]}}])})],1)],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs6":"","md4":""}},[_c('wz-select-bots',{attrs:{"label":"Choisissez le Bot","bots":_vm.bot,"botsInit":_vm.$store.state._User.bots,"min":1},on:{"update:bots":function($event){_vm.bot=$event}}})],1)],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","block":_vm.$vuetify.breakpoint.xsOnly,"loading":_vm.loadingPost},nativeOn:{"click":function($event){_vm.postOptions()}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('save')))),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("save")])],1)],1),_vm._v(" "),_c('wz-dialog-infos',{attrs:{"titleDialog":_vm.titleDialog,"contentDialog":_vm.contentDialog},on:{"fermeDialog":_vm.fermeDialogInfos}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","lazy":"","max-width":"290"},model:{value:(_vm.showTp),callback:function ($$v) {_vm.showTp=$$v},expression:"showTp"}},[_c('v-time-picker',{attrs:{"actions":"","scrollable":"","format":"24hr","max":_vm.allowed.hours.max,"min":_vm.allowed.hours.min,"color":"primary"},model:{value:(_vm.daySelected[_vm.amOrPm][_vm.startOrEnd]),callback:function ($$v) {_vm.$set(_vm.daySelected[_vm.amOrPm], _vm.startOrEnd, $$v)},expression:"daySelected[amOrPm][startOrEnd]"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showTp = false; _vm.daySelected[_vm.amOrPm][_vm.startOrEnd] = _vm.tmpHours}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('cancel'))))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.showTp = false}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('submit'))))])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","width":"350px"},model:{value:(_vm.showHours),callback:function ($$v) {_vm.showHours=$$v},expression:"showHours"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('applySchedules'))))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"400px"}},[_c('v-select',{attrs:{"items":_vm.days,"label":_vm.$t('applyHours'),"return-object":""},model:{value:(_vm.dayHours),callback:function ($$v) {_vm.dayHours=$$v},expression:"dayHours"}}),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersDays,"items":_vm.days,"item-key":"text","select-all":"primary","hide-actions":"","total-items":7},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(props.header.text))])]}},{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{staticClass:"primary--text",attrs:{"hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.text))])]}}]),model:{value:(_vm.daysTmp),callback:function ($$v) {_vm.daysTmp=$$v},expression:"daysTmp"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showHours = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.daysTmp.length,"color":"primary","flat":""},on:{"click":function($event){_vm.submitHours()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.showDialogRule),callback:function ($$v) {_vm.showDialogRule=$$v},expression:"showDialogRule"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("createRule"))))]),_vm._v(" "),_c('v-card-text',[_c('form',[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.typeRules,"label":_vm.$t('ruleType'),"return-object":"","required":"","data-vv-name":"select","error":_vm.wzErrors.has('select'),"error-messages":_vm.wzErrors.collect('select')},model:{value:(_vm.ruleTmp.type),callback:function ($$v) {_vm.$set(_vm.ruleTmp, "type", $$v)},expression:"ruleTmp.type"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autofocus":"","label":_vm.$t('ruleContent'),"required":"","data-vv-name":"ruleContentInput","error":_vm.wzErrors.has('ruleContentInput'),"error-messages":_vm.wzErrors.collect('ruleContentInput')},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.submitRule()}},model:{value:(_vm.ruleTmp.content),callback:function ($$v) {_vm.$set(_vm.ruleTmp, "content", $$v)},expression:"ruleTmp.content"}})],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showDialogRule = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.wzErrors.any(),"flat":""},on:{"click":function($event){_vm.submitRule()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":4},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)}
var ChatBot_staticRenderFns = []
var ChatBot_esExports = { render: ChatBot_render, staticRenderFns: ChatBot_staticRenderFns }
/* harmony default export */ var settings_ChatBot = (ChatBot_esExports);
// CONCATENATED MODULE: ./src/components/settings/ChatBot.vue
var ChatBot_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var ChatBot___vue_template_functional__ = false
/* styles */
var ChatBot___vue_styles__ = null
/* scopeId */
var ChatBot___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var ChatBot___vue_module_identifier__ = null
var ChatBot_Component = ChatBot_normalizeComponent(
  ChatBot,
  settings_ChatBot,
  ChatBot___vue_template_functional__,
  ChatBot___vue_styles__,
  ChatBot___vue_scopeId__,
  ChatBot___vue_module_identifier__
)

/* harmony default export */ var components_settings_ChatBot = (ChatBot_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/settings/Ecomm.vue



/* harmony default export */ var Ecomm = ({
  data: function data() {
    return {
      alert: false,

      dataFromAjax: {},

      cms: [{ text: lodash_default.a.upperFirst(this.$t('doNotKnow')), value: 'Autre' }, { text: 'Prestashop1.5', value: 'Prestashop1.5' }, { text: 'Prestashop1.6', value: 'Prestashop1.6' }, { text: 'Woocommerce1.6', value: 'Woocommerce1.6' }, { text: 'Woocommerce2.0', value: 'Woocommerce2.0' }, { text: 'Magento', value: 'Magento' }, { text: 'EShop', value: 'EShop' }, { text: 'OpenCart', value: 'OpenCart' }, { text: 'Virtuemart', value: 'Virtuemart' }, { text: 'ZenCart', value: 'ZenCart' }, { text: 'Powerboutique', value: 'Powerboutique' }, { text: lodash_default.a.upperFirst(this.$t('other')), value: 'Autre' }],
      form: {},
      opts: [{ text: this.$t('nextStringUrl'), value: 'url' }, { text: this.$t('uniqueIdSourceCode'), value: 'id' }, { text: this.$t('meta'), value: 'kw' }, { text: this.$t('stringTitle'), value: 'title' }, { text: this.$t('tagApiSourceCode'), value: 'tag' }],
      infosCMS: [{
        cmsName: 'Prestashop1.5',
        opt_1: 'url',
        input_1: 'order',
        opt_2: 'url',
        input_2: 'authentication',
        opt_3: 'url',
        input_3: 'order',
        opt_4: 'url',
        input_4: 'order',
        opt_5: 'url',
        input_5: 'order',
        opt_6: 'url',
        input_6: 'order',
        r_1: '#',
        input_r_1: 'add_to_cart',
        r_2: '.',
        input_r_2: 'product-price',
        r_3: '.',
        input_r_3: 'product-name',
        r_4: '.',
        input_r_4: '',
        r_5: '.',
        input_r_5: ''
      }, {
        cmsName: 'Prestashop1.6',
        opt_1: 'url',
        input_1: 'commande',
        opt_2: 'url',
        input_2: 'authentification',
        opt_3: 'url',
        input_3: 'adresse',
        opt_4: 'url',
        input_4: 'commande?multi-shipping',
        opt_5: 'url',
        input_5: 'systempay/redirect',
        opt_6: 'url',
        input_6: 'fin',
        r_1: '.',
        input_r_1: 'ajax_add_to_cart_button',
        r_2: '.',
        input_r_2: 'product-price',
        r_3: '.',
        input_r_3: 'product-name',
        r_4: '.',
        input_r_4: '',
        r_5: '.',
        input_r_5: ''
      }, {
        cmsName: 'Woocommerce1.6',
        opt_1: 'url',
        input_1: 'checkout',
        opt_2: 'url',
        input_2: 'account',
        opt_3: 'url',
        input_3: 'checkout',
        opt_4: 'url',
        input_4: 'checkout',
        opt_5: 'url',
        input_5: 'checkout',
        opt_6: 'url',
        input_6: 'checkout',
        r_1: '.',
        input_r_1: 'add_to_cart_button',
        r_2: '.',
        input_r_2: 'product-price',
        r_3: '.',
        input_r_3: 'product-name',
        r_4: '.',
        input_r_4: '',
        r_5: '.',
        input_r_5: ''
      }, {
        cmsName: 'Woocommerce2.0',
        opt_1: 'url',
        input_1: 'cart',
        opt_2: 'url',
        input_2: 'account',
        opt_3: 'url',
        input_3: 'checkout',
        opt_4: 'url',
        input_4: 'cart',
        opt_5: 'url',
        input_5: 'checkout',
        opt_6: 'url',
        input_6: 'checkout',
        r_1: '.',
        input_r_1: 'add_to_cart_button',
        r_2: '.',
        input_r_2: 'product-price',
        r_3: '.',
        input_r_3: 'product-name',
        r_4: '.',
        input_r_4: '',
        r_5: '.',
        input_r_5: ''
      }, {
        cmsName: 'Magento',
        opt_1: 'url',
        input_1: 'checkout/cart/',
        opt_2: 'url',
        input_2: 'checkout/onepage/',
        opt_3: 'url',
        input_3: 'checkout/onepage/',
        opt_4: 'url',
        input_4: 'checkout/cart/',
        opt_5: 'url',
        input_5: 'checkout/onepage/',
        opt_6: 'url',
        input_6: 'checkout/onepage/',
        r_1: '.',
        input_r_1: 'btn-cart',
        r_2: '.',
        input_r_2: 'product-price',
        r_3: '.',
        input_r_3: 'product-name',
        r_4: '.',
        input_r_4: '',
        r_5: '.',
        input_r_5: ''
      }, {
        cmsName: 'EShop',
        opt_1: 'url',
        input_1: '',
        opt_2: 'url',
        input_2: '',
        opt_3: 'url',
        input_3: '',
        opt_4: 'url',
        input_4: '',
        opt_5: 'url',
        input_5: '',
        opt_6: 'url',
        input_6: '',
        r_1: '.',
        input_r_1: 'eshopbutton',
        r_2: '.',
        input_r_2: 'product-price',
        r_3: '.',
        input_r_3: 'product-name',
        r_4: '.',
        input_r_4: '',
        r_5: '.',
        input_r_5: ''
      }, {
        cmsName: 'OpenCart',
        opt_1: 'url',
        input_1: 'checkout/cart',
        opt_2: 'url',
        input_2: 'checkout/cart',
        opt_3: 'url',
        input_3: 'checkout/cart',
        opt_4: 'url',
        input_4: 'checkout/cart',
        opt_5: 'url',
        input_5: 'checkout/cart',
        opt_6: 'url',
        input_6: 'checkout/cart',
        r_1: '.',
        input_r_1: 'cart',
        r_2: '.',
        input_r_2: 'product-price',
        r_3: '.',
        input_r_3: 'product-name',
        r_4: '.',
        input_r_4: '',
        r_5: '.',
        input_r_5: ''
      }, {
        cmsName: 'Virtuemart',
        opt_1: 'url',
        input_1: 'cart',
        opt_2: 'url',
        input_2: 'account',
        opt_3: 'url',
        input_3: 'edit_shipment',
        opt_4: 'url',
        input_4: 'cart',
        opt_5: 'url',
        input_5: 'editpayment',
        opt_6: 'url',
        input_6: '',
        r_1: '.',
        input_r_1: '',
        r_2: '.',
        input_r_2: 'product-price',
        r_3: '.',
        input_r_3: 'product-name',
        r_4: '.',
        input_r_4: '',
        r_5: '.',
        input_r_5: ''
      }, {
        cmsName: 'ZenCart',
        opt_1: 'url',
        input_1: '',
        opt_2: 'url',
        input_2: '',
        opt_3: 'url',
        input_3: '',
        opt_4: 'url',
        input_4: '',
        opt_5: 'url',
        input_5: '',
        opt_6: 'url',
        input_6: '',
        r_1: '.',
        input_r_1: '',
        r_2: '.',
        input_r_2: 'product-price',
        r_3: '.',
        input_r_3: 'product-name',
        r_4: '.',
        input_r_4: '',
        r_5: '.',
        input_r_5: ''
      }, {
        cmsName: 'Powerboutique',
        opt_1: 'url',
        input_1: 'panierb',
        opt_2: 'url',
        input_2: 'adresse_e_mail',
        opt_3: 'url',
        input_3: 'choix_livraison',
        opt_4: 'url',
        input_4: 'bon_de_commande',
        opt_5: 'url',
        input_5: 'bon_de_commande',
        opt_6: 'url',
        input_6: 'paiement',
        r_1: '.',
        input_r_1: 'bouton_selectionner_fiche_produit',
        r_2: '.',
        input_r_2: 'product-price',
        r_3: '.',
        input_r_3: 'product-name',
        r_4: '.',
        input_r_4: '',
        r_5: '.',
        input_r_5: ''
      }, {
        cmsName: 'Autre',
        opt_1: 'url',
        input_1: '',
        opt_2: 'url',
        input_2: '',
        opt_3: 'url',
        input_3: '',
        opt_4: 'url',
        input_4: '',
        opt_5: 'url',
        input_5: '',
        opt_6: 'url',
        input_6: '',
        r_1: '.',
        input_r_1: '',
        r_2: '.',
        input_r_2: '',
        r_3: '.',
        input_r_3: '',
        r_4: '.',
        input_r_4: '',
        r_5: '.',
        input_r_5: ''
      }],

      loadingGet: false,
      loadingPost: false,
      dialogProgress: false
    };
  },
  mounted: function mounted() {
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
    if (this.$store.state._User.entLevel < 7) {
      this.alert = true;
    }
  },
  created: function created() {
    this.getOptions();

    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'settings_ecommerce';
    } else {
      setTimeout(function () {
        if (typeof defautMotif !== 'undefined') {
          defautMotif = 'settings_ecommerce';
        }
      }, 800);
    }
  },

  methods: {
    getOptions: function getOptions() {
      var _this = this;

      this.loadingGet = true;
      this.axios.get('get/settings_ecomm.php?desk=' + this.$store.state._Sites.siteSelected.LIC_DSK_ID).then(function (response) {
        _this.dataFromAjax = response.data;
        _this.init();
      }).catch().then(function (_) {
        _this.loadingGet = false;
      });
    },
    init: function init() {
      var cms = this.dataFromAjax.DSK_ECOMM_CMS === '' ? 'Autre' : this.dataFromAjax.DSK_ECOMM_CMS;
      this.dataFromAjax.cms = lodash_default.a.clone(lodash_default.a.find(this.cms, { 'value': cms }));

      this.dataFromAjax.opt_1 = this.dataFromAjax.DSK_ECOMM_CART_ID.split('|')[0] ? lodash_default.a.find(this.opts, { 'value': this.dataFromAjax.DSK_ECOMM_CART_ID.split('|')[0] }) : this.opts[0];
      this.dataFromAjax.input_1 = this.dataFromAjax.DSK_ECOMM_CART_ID.split('|')[1] || '';

      this.dataFromAjax.opt_2 = this.dataFromAjax.DSK_ECOMM_LOGIN_ID.split('|')[0] ? lodash_default.a.find(this.opts, { 'value': this.dataFromAjax.DSK_ECOMM_LOGIN_ID.split('|')[0] }) : this.opts[0];
      this.dataFromAjax.input_2 = this.dataFromAjax.DSK_ECOMM_LOGIN_ID.split('|')[1] || '';

      this.dataFromAjax.opt_3 = this.dataFromAjax.DSK_ECOMM_DELIV_ID.split('|')[0] ? lodash_default.a.find(this.opts, { 'value': this.dataFromAjax.DSK_ECOMM_DELIV_ID.split('|')[0] }) : this.opts[0];
      this.dataFromAjax.input_3 = this.dataFromAjax.DSK_ECOMM_DELIV_ID.split('|')[1] || '';

      this.dataFromAjax.opt_4 = this.dataFromAjax.DSK_ECOMM_SUMM_ID.split('|')[0] ? lodash_default.a.find(this.opts, { 'value': this.dataFromAjax.DSK_ECOMM_SUMM_ID.split('|')[0] }) : this.opts[0];
      this.dataFromAjax.input_4 = this.dataFromAjax.DSK_ECOMM_SUMM_ID.split('|')[1] || '';

      this.dataFromAjax.opt_5 = this.dataFromAjax.DSK_ECOMM_PAIM_ID.split('|')[0] ? lodash_default.a.find(this.opts, { 'value': this.dataFromAjax.DSK_ECOMM_PAIM_ID.split('|')[0] }) : this.opts[0];
      this.dataFromAjax.input_5 = this.dataFromAjax.DSK_ECOMM_PAIM_ID.split('|')[1] || '';

      this.dataFromAjax.opt_6 = this.dataFromAjax.DSK_ECOMM_VALID_ID.split('|')[0] ? lodash_default.a.find(this.opts, { 'value': this.dataFromAjax.DSK_ECOMM_VALID_ID.split('|')[0] }) : this.opts[0];
      this.dataFromAjax.input_6 = this.dataFromAjax.DSK_ECOMM_VALID_ID.split('|')[1] || '';

      this.dataFromAjax.r_1 = this.dataFromAjax.DSK_ECOMM_BTN_AMOUNT[0] === '#' ? '#' : '.';
      this.dataFromAjax.input_r_1 = this.dataFromAjax.DSK_ECOMM_BTN_AMOUNT.substring(1);

      this.dataFromAjax.r_2 = this.dataFromAjax.DSK_ECOMM_BTN_ID[0] === '#' ? '#' : '.';
      this.dataFromAjax.input_r_2 = this.dataFromAjax.DSK_ECOMM_BTN_ID.substring(1);

      this.dataFromAjax.r_3 = this.dataFromAjax.DSK_ECOMM_BTN_NAME[0] === '#' ? '#' : '.';
      this.dataFromAjax.input_r_3 = this.dataFromAjax.DSK_ECOMM_BTN_NAME.substring(1);

      this.dataFromAjax.r_4 = this.dataFromAjax.DSK_ECOMM_CART_AMOUNT[0] === '#' ? '#' : '.';
      this.dataFromAjax.input_r_4 = this.dataFromAjax.DSK_ECOMM_CART_AMOUNT.substring(1);

      this.dataFromAjax.r_5 = this.dataFromAjax.DSK_ECOMM_CART_NB[0] === '#' ? '#' : '.';
      this.dataFromAjax.input_r_5 = this.dataFromAjax.DSK_ECOMM_CART_NB.substring(1);

      this.form = lodash_default.a.cloneDeep(this.dataFromAjax);
    },
    submit: function submit() {
      var _this2 = this;

      var dataToPost = new window.FormData();

      dataToPost.append('DSK_ID', this.$store.state._Sites.siteSelected.LIC_DSK_ID);
      dataToPost.append('LIC_KEY', this.$store.state._Sites.siteSelected.LIC_KEY);
      dataToPost.append('DSK_ECOMM_CMS', this.form.cms.value);
      dataToPost.append('DSK_ECOMM_CART_ID', '');
      if (!lodash_default.a.isEmpty(this.form.opt_1) && !lodash_default.a.isEmpty(this.form.input_1)) {
        dataToPost.append('DSK_ECOMM_CART_ID', this.form.opt_1.value + '|' + this.form.input_1);
      }
      dataToPost.append('DSK_ECOMM_LOGIN_ID', '');
      if (!lodash_default.a.isEmpty(this.form.opt_2) && !lodash_default.a.isEmpty(this.form.input_2)) {
        dataToPost.append('DSK_ECOMM_LOGIN_ID', this.form.opt_2.value + '|' + this.form.input_2);
      }
      dataToPost.append('DSK_ECOMM_DELIV_ID', '');
      if (!lodash_default.a.isEmpty(this.form.opt_3) && !lodash_default.a.isEmpty(this.form.input_3)) {
        dataToPost.append('DSK_ECOMM_DELIV_ID', this.form.opt_3.value + '|' + this.form.input_3);
      }
      dataToPost.append('DSK_ECOMM_SUMM_ID', '');
      if (!lodash_default.a.isEmpty(this.form.opt_4) && !lodash_default.a.isEmpty(this.form.input_4)) {
        dataToPost.append('DSK_ECOMM_SUMM_ID', this.form.opt_4.value + '|' + this.form.input_4);
      }
      dataToPost.append('DSK_ECOMM_PAIM_ID', '');
      if (!lodash_default.a.isEmpty(this.form.opt_5) && !lodash_default.a.isEmpty(this.form.input_5)) {
        dataToPost.append('DSK_ECOMM_PAIM_ID', this.form.opt_5.value + '|' + this.form.input_5);
      }
      dataToPost.append('DSK_ECOMM_VALID_ID', '');
      if (!lodash_default.a.isEmpty(this.form.opt_6) && !lodash_default.a.isEmpty(this.form.input_6)) {
        dataToPost.append('DSK_ECOMM_VALID_ID', this.form.opt_6.value + '|' + this.form.input_6);
      }
      dataToPost.append('DSK_ECOMM_BTN_AMOUNT', '');
      if (!lodash_default.a.isEmpty(this.form.r_1) && !lodash_default.a.isEmpty(this.form.input_r_1)) {
        dataToPost.append('DSK_ECOMM_BTN_AMOUNT', this.form.r_1 + this.form.input_r_1);
      }
      dataToPost.append('DSK_ECOMM_BTN_ID', '');
      if (!lodash_default.a.isEmpty(this.form.r_2) && !lodash_default.a.isEmpty(this.form.input_r_2)) {
        dataToPost.append('DSK_ECOMM_BTN_ID', this.form.r_2 + this.form.input_r_2);
      }
      dataToPost.append('DSK_ECOMM_BTN_NAME', '');
      if (!lodash_default.a.isEmpty(this.form.r_3) && !lodash_default.a.isEmpty(this.form.input_r_3)) {
        dataToPost.append('DSK_ECOMM_BTN_NAME', this.form.r_3 + this.form.input_r_3);
      }
      dataToPost.append('DSK_ECOMM_CART_AMOUNT', '');
      if (!lodash_default.a.isEmpty(this.form.r_4) && !lodash_default.a.isEmpty(this.form.input_r_4)) {
        dataToPost.append('DSK_ECOMM_CART_AMOUNT', this.form.r_4 + this.form.input_r_4);
      }
      dataToPost.append('DSK_ECOMM_CART_NB', '');
      if (!lodash_default.a.isEmpty(this.form.r_5) && !lodash_default.a.isEmpty(this.form.input_r_5)) {
        dataToPost.append('DSK_ECOMM_CART_NB', this.form.r_5 + this.form.input_r_5);
      }

      if (!lodash_default.a.isEqual(this.form, this.dataFromAjax)) {
        this.loadingPost = true;
        this.axios.post('post/settings_ecomm.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
          _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('modifSuccess'), context: 'success' });

          _this2.dataFromAjax = lodash_default.a.cloneDeep(_this2.form);
        }).catch(function (_) {
          _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('modifFailure'), context: 'error' });
        }).then(function (_) {
          _this2.loadingPost = false;
        });
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('noChange'), context: 'warning' });
      }
    },
    reset: function reset() {
      this.form = lodash_default.a.cloneDeep(this.dataFromAjax);
    },
    cmsChanged: function cmsChanged() {
      var cms = lodash_default.a.clone(lodash_default.a.find(this.cms, { 'value': this.form.cms.value }));
      this.form = lodash_default.a.cloneDeep(lodash_default.a.find(this.infosCMS, { 'cmsName': this.form.cms.value }));
      this.form.cms = cms;
      this.form.opt_1 = lodash_default.a.clone(lodash_default.a.find(this.opts, { 'value': this.form.opt_1 }));
      this.form.opt_2 = lodash_default.a.clone(lodash_default.a.find(this.opts, { 'value': this.form.opt_2 }));
      this.form.opt_3 = lodash_default.a.clone(lodash_default.a.find(this.opts, { 'value': this.form.opt_3 }));
      this.form.opt_4 = lodash_default.a.clone(lodash_default.a.find(this.opts, { 'value': this.form.opt_4 }));
      this.form.opt_5 = lodash_default.a.clone(lodash_default.a.find(this.opts, { 'value': this.form.opt_5 }));
      this.form.opt_6 = lodash_default.a.clone(lodash_default.a.find(this.opts, { 'value': this.form.opt_6 }));
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function $storeState_SitesSiteSelected(v) {
      if (v) {
        this.getOptions();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-db005b0a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Ecomm.vue
var Ecomm_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ecomm"},[_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.alert),expression:"alert"}],attrs:{"color":"secondary","icon":"warning","value":"true","outline":""}},[_vm._v("\n      Attention, les paramètres ecommerces ne sont pas accessibles pour ce niveau de licence. Vous ne pourrez pas sauvegarder.\n    ")]),_vm._v(" "),(_vm.loadingGet)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('div',[_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md4":""}},[_c('v-select',{attrs:{"items":_vm.cms,"dense":"","label":_vm._f("cap")(_vm.$t('select') + ' CMS'),"hint":_vm.$t('cmsSettingsHint'),"persistent-hint":"","return-object":""},model:{value:(_vm.form.cms),callback:function ($$v) {_vm.$set(_vm.form, "cms", $$v)},expression:"form.cms"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md2":""}},[_c('v-btn',{staticClass:"primary--text",attrs:{"flat":"","block":_vm.$vuetify.breakpoint.xsOnly},on:{"click":function($event){_vm.cmsChanged()}}},[_vm._v(_vm._s(_vm.$t('applyCmsSettings')))])],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel',[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("insert_drive_file")]),_vm._v("Pages")],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-expansion-panel',{staticClass:"mb-3"},[_c('v-expansion-panel-content',[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":"","ellipsis":""},slot:"header"},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.$t('basket')))+"\n                    ")]),_vm._v(" "),(_vm.form.opt_1.text && _vm.form.input_1)?_c('v-flex',{attrs:{"xs10":"","hidden-sm-and-down":""}},[_vm._v("\n                      "+_vm._s(_vm.$t('contains'))+" "+_vm._s(_vm.form.opt_1.text)+" : "),_c('code',[_vm._v(_vm._s(_vm.form.input_1))])]):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-select',{attrs:{"label":_vm._f("cap")(_vm.$t('contains')),"items":_vm.opts,"return-object":""},model:{value:(_vm.form.opt_1),callback:function ($$v) {_vm.$set(_vm.form, "opt_1", $$v)},expression:"form.opt_1"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('urlString'))},model:{value:(_vm.form.input_1),callback:function ($$v) {_vm.$set(_vm.form, "input_1", $$v)},expression:"form.input_1"}})],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":"","ellipsis":""},slot:"header"},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.$t('identification')))+"\n                    ")]),_vm._v(" "),(_vm.form.opt_2.text && _vm.form.input_2)?_c('v-flex',{attrs:{"xs10":"","hidden-sm-and-down":""}},[_vm._v("\n                      "+_vm._s(_vm.$t('contains'))+" "+_vm._s(_vm.form.opt_2.text)+" : "),_c('code',[_vm._v(_vm._s(_vm.form.input_2))])]):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-select',{attrs:{"label":_vm._f("cap")(_vm.$t('contains')),"items":_vm.opts,"return-object":""},model:{value:(_vm.form.opt_2),callback:function ($$v) {_vm.$set(_vm.form, "opt_2", $$v)},expression:"form.opt_2"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('urlString'))},model:{value:(_vm.form.input_2),callback:function ($$v) {_vm.$set(_vm.form, "input_2", $$v)},expression:"form.input_2"}})],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":"","ellipsis":""},slot:"header"},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.$t('delivery')))+"\n                    ")]),_vm._v(" "),(_vm.form.opt_3.text && _vm.form.input_3)?_c('v-flex',{attrs:{"xs10":"","hidden-sm-and-down":""}},[_vm._v("\n                      "+_vm._s(_vm.$t('contains'))+" "+_vm._s(_vm.form.opt_3.text)+" : "),_c('code',[_vm._v(_vm._s(_vm.form.input_3))])]):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-select',{attrs:{"label":_vm._f("cap")(_vm.$t('contains')),"items":_vm.opts,"return-object":""},model:{value:(_vm.form.opt_3),callback:function ($$v) {_vm.$set(_vm.form, "opt_3", $$v)},expression:"form.opt_3"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('urlString'))},model:{value:(_vm.form.input_3),callback:function ($$v) {_vm.$set(_vm.form, "input_3", $$v)},expression:"form.input_3"}})],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":"","ellipsis":""},slot:"header"},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.$t('summary')))+"\n                    ")]),_vm._v(" "),(_vm.form.opt_4.text && _vm.form.input_4)?_c('v-flex',{attrs:{"xs10":"","hidden-sm-and-down":""}},[_vm._v("\n                      "+_vm._s(_vm.$t('contains'))+" "+_vm._s(_vm.form.opt_4.text)+" : "),_c('code',[_vm._v(_vm._s(_vm.form.input_4))])]):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-select',{attrs:{"label":_vm._f("cap")(_vm.$t('contains')),"items":_vm.opts,"return-object":""},model:{value:(_vm.form.opt_4),callback:function ($$v) {_vm.$set(_vm.form, "opt_4", $$v)},expression:"form.opt_4"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('urlString'))},model:{value:(_vm.form.input_4),callback:function ($$v) {_vm.$set(_vm.form, "input_4", $$v)},expression:"form.input_4"}})],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":"","ellipsis":""},slot:"header"},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.$t('payment')))+"\n                    ")]),_vm._v(" "),(_vm.form.opt_5.text && _vm.form.input_5)?_c('v-flex',{attrs:{"xs10":"","hidden-sm-and-down":""}},[_vm._v("\n                      "+_vm._s(_vm.$t('contains'))+" "+_vm._s(_vm.form.opt_5.text)+" : "),_c('code',[_vm._v(_vm._s(_vm.form.input_5))])]):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-select',{attrs:{"label":_vm._f("cap")(_vm.$t('contains')),"items":_vm.opts,"return-object":""},model:{value:(_vm.form.opt_5),callback:function ($$v) {_vm.$set(_vm.form, "opt_5", $$v)},expression:"form.opt_5"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('urlString'))},model:{value:(_vm.form.input_5),callback:function ($$v) {_vm.$set(_vm.form, "input_5", $$v)},expression:"form.input_5"}})],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":"","ellipsis":""},slot:"header"},[_c('v-flex',{attrs:{"xs2":""}},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.$t('validation')))+"\n                    ")]),_vm._v(" "),(_vm.form.opt_6.text && _vm.form.input_6)?_c('v-flex',{attrs:{"xs10":"","hidden-sm-and-down":""}},[_vm._v("\n                      "+_vm._s(_vm.$t('contains'))+" "+_vm._s(_vm.form.opt_6.text)+" : "),_c('code',[_vm._v(_vm._s(_vm.form.input_6))])]):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-select',{attrs:{"label":_vm._f("cap")(_vm.$t('contains')),"items":_vm.opts,"return-object":""},model:{value:(_vm.form.opt_6),callback:function ($$v) {_vm.$set(_vm.form, "opt_6", $$v)},expression:"form.opt_6"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('urlString'))},model:{value:(_vm.form.input_6),callback:function ($$v) {_vm.$set(_vm.form, "input_6", $$v)},expression:"form.input_6"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("add_shopping_cart")]),_vm._v(_vm._s(_vm.$t('addToTheBasket')))],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-expansion-panel',{staticClass:"mb-3"},[_c('v-expansion-panel-content',[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":"","ellipsis":""},slot:"header"},[_c('v-flex',{attrs:{"xs5":"","md2":""}},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.$t('button')))+"\n                    ")]),_vm._v(" "),(_vm.form.input_r_1)?_c('v-flex',{attrs:{"xs7":""}},[_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(_vm._s(_vm.$t('identifiedBy'))+" :")]),_vm._v(" "),_c('code',[_vm._v(_vm._s(_vm.form.r_1)+_vm._s(_vm.form.input_r_1))])]):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.form.r_1),callback:function ($$v) {_vm.$set(_vm.form, "r_1", $$v)},expression:"form.r_1"}},[_c('v-radio',{staticClass:"primary--text",attrs:{"label":"class","value":"."}}),_vm._v(" "),_c('v-radio',{staticClass:"primary--text",attrs:{"label":"id","value":"#"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('name'))},model:{value:(_vm.form.input_r_1),callback:function ($$v) {_vm.$set(_vm.form, "input_r_1", $$v)},expression:"form.input_r_1"}})],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":"","ellipsis":""},slot:"header"},[_c('v-flex',{attrs:{"xs5":"","md2":""}},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.$t('priceOfProduct')))+"\n                    ")]),_vm._v(" "),(_vm.form.input_r_2)?_c('v-flex',{attrs:{"xs7":""}},[_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(_vm._s(_vm.$t('identifiedBy'))+" :")]),_vm._v(" "),_c('code',[_vm._v(_vm._s(_vm.form.r_2)+_vm._s(_vm.form.input_r_2))])]):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.form.r_2),callback:function ($$v) {_vm.$set(_vm.form, "r_2", $$v)},expression:"form.r_2"}},[_c('v-radio',{staticClass:"primary--text",attrs:{"label":"class","value":"."}}),_vm._v(" "),_c('v-radio',{staticClass:"primary--text",attrs:{"label":"id","value":"#"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('name'))},model:{value:(_vm.form.input_r_2),callback:function ($$v) {_vm.$set(_vm.form, "input_r_2", $$v)},expression:"form.input_r_2"}})],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":"","ellipsis":""},slot:"header"},[_c('v-flex',{attrs:{"xs5":"","md2":""}},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.$t('productName')))+"\n                    ")]),_vm._v(" "),(_vm.form.input_r_3)?_c('v-flex',{attrs:{"xs7":""}},[_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(_vm._s(_vm.$t('identifiedBy'))+" :")]),_vm._v(" "),_c('code',[_vm._v(_vm._s(_vm.form.r_3)+_vm._s(_vm.form.input_r_3))])]):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.form.r_3),callback:function ($$v) {_vm.$set(_vm.form, "r_3", $$v)},expression:"form.r_3"}},[_c('v-radio',{staticClass:"primary--text",attrs:{"label":"class","value":"."}}),_vm._v(" "),_c('v-radio',{staticClass:"primary--text",attrs:{"label":"id","value":"#"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('name'))},model:{value:(_vm.form.input_r_3),callback:function ($$v) {_vm.$set(_vm.form, "input_r_3", $$v)},expression:"form.input_r_3"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("shopping_cart")]),_vm._v(_vm._s(_vm._f("cap")(_vm.$t('basket'))))],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-expansion-panel',{staticClass:"mb-3"},[_c('v-expansion-panel-content',[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":"","ellipsis":""},slot:"header"},[_c('v-flex',{attrs:{"xs5":"","md2":""}},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.$t('amount')))+"\n                    ")]),_vm._v(" "),(_vm.form.input_r_4)?_c('v-flex',{attrs:{"xs7":""}},[_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(_vm._s(_vm.$t('identifiedBy'))+" :")]),_vm._v(" "),_c('code',[_vm._v(_vm._s(_vm.form.r_4)+_vm._s(_vm.form.input_r_4))])]):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.form.r_4),callback:function ($$v) {_vm.$set(_vm.form, "r_4", $$v)},expression:"form.r_4"}},[_c('v-radio',{staticClass:"primary--text",attrs:{"label":"class","value":"."}}),_vm._v(" "),_c('v-radio',{staticClass:"primary--text",attrs:{"label":"id","value":"#"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('name'))},model:{value:(_vm.form.input_r_4),callback:function ($$v) {_vm.$set(_vm.form, "input_r_4", $$v)},expression:"form.input_r_4"}})],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":"","ellipsis":""},slot:"header"},[_c('v-flex',{attrs:{"xs5":"","md2":""}},[_vm._v("\n                      "+_vm._s(_vm._f("cap")(_vm.$tc('items', 2, {count: ''})))+"\n                    ")]),_vm._v(" "),(_vm.form.input_r_5)?_c('v-flex',{attrs:{"xs7":""}},[_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(_vm._s(_vm.$t('identifiedBy'))+" :")]),_vm._v(" "),_c('code',[_vm._v(_vm._s(_vm.form.r_5)+_vm._s(_vm.form.input_r_5))])]):_vm._e()],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-radio-group',{attrs:{"row":""},model:{value:(_vm.form.r_5),callback:function ($$v) {_vm.$set(_vm.form, "r_5", $$v)},expression:"form.r_5"}},[_c('v-radio',{staticClass:"primary--text",attrs:{"label":"class","value":"."}}),_vm._v(" "),_c('v-radio',{staticClass:"primary--text",attrs:{"label":"id","value":"#"}})],1),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('name'))},model:{value:(_vm.form.input_r_5),callback:function ($$v) {_vm.$set(_vm.form, "input_r_5", $$v)},expression:"form.input_r_5"}})],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","flat":"","dark":"","block":_vm.$vuetify.breakpoint.xsOnly},nativeOn:{"click":function($event){_vm.reset()}}},[_vm._v(_vm._s(_vm.$t('cancel'))),_c('v-icon',{staticClass:"primary--text",attrs:{"right":""}},[_vm._v("settings_backup_restore")])],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":_vm.$vuetify.breakpoint.xsOnly,"loading":_vm.loadingPost,"disabled":_vm.alert},nativeOn:{"click":function($event){_vm.submit()}}},[_vm._v(_vm._s(_vm.$t('save'))),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":8},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)}
var Ecomm_staticRenderFns = []
var Ecomm_esExports = { render: Ecomm_render, staticRenderFns: Ecomm_staticRenderFns }
/* harmony default export */ var settings_Ecomm = (Ecomm_esExports);
// CONCATENATED MODULE: ./src/components/settings/Ecomm.vue
var Ecomm_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Ecomm___vue_template_functional__ = false
/* styles */
var Ecomm___vue_styles__ = null
/* scopeId */
var Ecomm___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Ecomm___vue_module_identifier__ = null
var Ecomm_Component = Ecomm_normalizeComponent(
  Ecomm,
  settings_Ecomm,
  Ecomm___vue_template_functional__,
  Ecomm___vue_styles__,
  Ecomm___vue_scopeId__,
  Ecomm___vue_module_identifier__
)

/* harmony default export */ var components_settings_Ecomm = (Ecomm_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/settings/Connectors.vue


/* harmony default export */ var Connectors = ({
  data: function data() {
    return {
      fb_onoff: true,
      fb_token: '',
      fb_id: '',
      messenger_onoff: true,
      messenger_id: '',
      sf_onoff: false,
      sf_id1: '',
      sf_id2: '',
      sf_id3: '',
      zd_onoff: false,
      zd_id1: '',
      zd_id2: '',
      zd_id3: '',
      ga_onoff: false,
      ga_id: '',
      slack_onoff: false,
      slack_id: '',

      loadingGet: false,
      loadingPost: false,
      vyte_onoff: false,
      vyte_id1: '',
      vyte_id2: '',
      vyte_id3: '',
      calendar_onoff: false,
      calendar_id1: '',
      calendar_id2: '',
      dialogProgress: false
    };
  },
  mounted: function mounted() {
    this.getOptions();
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
  },
  created: function created() {
    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'settings_connectors';
    } else {
      setTimeout(function () {
        if (typeof defautMotif !== 'undefined') {
          defautMotif = 'settings_connectors';
        }
      }, 800);
    }
  },


  methods: {
    getOptions: function getOptions() {
      var _this = this;

      this.loadingGet = true;
      this.axios.get('get/settings_connectors.php').then(function (response) {
        _this.fb_onoff = true;
        _this.fb_token = response.data.ENT_SOCIALNETWORK_TOKEN;
        _this.fb_id = response.data.ENT_SOCIALNETWORK_ID;
        _this.messenger_onoff = true;
        _this.messenger_id = response.data.ENT_FBMESSENGER_PAGEID;
        _this.sf_onoff = response.data.ENT_SF === '1' || response.data.ENT_SF === 'salesforce';
        _this.sf_id1 = response.data.ENT_SF_ID;
        _this.sf_id2 = response.data.ENT_SF_ID2;
        _this.sf_id3 = response.data.ENT_SF_ID3;
        _this.zd_onoff = response.data.ENT_ZD === '1' || response.data.ENT_ZD === 'zendesk';
        _this.zd_id1 = response.data.ENT_ZD_ID;
        _this.zd_id2 = response.data.ENT_ZD_ID2;
        _this.zd_id3 = response.data.ENT_ZD_ID3;
        _this.ga_onoff = response.data.ENT_GA === '1' || response.data.ENT_GA === 'analytics';
        _this.ga_id = response.data.ENT_GA_ID;
        _this.slack_onoff = response.data.ENT_SLACK === '1' || response.data.ENT_SLACK === 'slack';
        _this.slack_id = response.data.ENT_SLACK_ID;
        _this.vyte_onoff = response.data.ENT_VYTE === '1';
        _this.vyte_id1 = response.data.ENT_VYTE_ID;
        _this.vyte_id2 = response.data.ENT_VYTE_ID2;
        _this.vyte_id3 = response.data.ENT_VYTE_ID3;
        _this.calendar_onoff = response.data.ENT_CALENDAR === '1';
        _this.calendar_id1 = response.data.ENT_CALENDAR_ID;
        _this.calendar_id2 = response.data.ENT_CALENDAR_ID2;
      }).catch(function (_) {}).then(function (_) {
        _this.loadingGet = false;
      });
    },
    testBrideStatus: function testBrideStatus(name) {
      var brides = this.$store.state._User.brides;

      if (brides) {
        var resultat = brides.find(function (brides) {
          return brides.brideName === name;
        });
        if (resultat) {
          if (resultat.status === '0') {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    postOptions: function postOptions() {
      var _this2 = this;

      var dataToPost = new window.FormData();

      dataToPost.append('DSK_ID', this.$store.state._Sites.siteSelected.LIC_DSK_ID);
      dataToPost.append('LIC_KEY', this.$store.state._Sites.siteSelected.LIC_KEY);
      dataToPost.append('LIC_ID', this.$store.state._Sites.siteSelected.LIC_ID);

      dataToPost.append('ENT_SOCIALNETWORK_TOKEN', this.fb_token);
      dataToPost.append('ENT_SOCIALNETWORK_ID', this.fb_id);
      dataToPost.append('ENT_SF', this.sf_onoff ? '1' : '0');
      dataToPost.append('ENT_SF_ID', this.sf_id1);
      dataToPost.append('ENT_SF_ID2', this.sf_id2);
      dataToPost.append('ENT_SF_ID3', this.sf_id3);
      dataToPost.append('ENT_ZD', this.zd_onoff ? '1' : '0');
      dataToPost.append('ENT_ZD_ID', this.zd_id1);
      dataToPost.append('ENT_ZD_ID2', this.zd_id2);
      dataToPost.append('ENT_ZD_ID3', this.zd_id3);
      dataToPost.append('ENT_GA', this.ga_onoff ? '1' : '0');
      dataToPost.append('ENT_GA_ID', this.ga_id);
      dataToPost.append('ENT_SLACK', this.slack_onoff ? '1' : '0');
      dataToPost.append('ENT_SLACK_ID', this.slack_id);
      dataToPost.append('ENT_FBMESSENGER_PAGEID', this.messenger_id);
      dataToPost.append('ENT_VYTE', this.vyte_onoff ? '1' : '0');
      dataToPost.append('ENT_VYTE_ID', this.vyte_id1);
      dataToPost.append('ENT_VYTE_ID2', this.vyte_id2);
      dataToPost.append('ENT_VYTE_ID3', this.vyte_id3);
      dataToPost.append('ENT_CALENDAR', this.calendar_onoff ? '1' : '0');
      dataToPost.append('ENT_CALENDAR_ID', this.calendar_id1);
      dataToPost.append('ENT_CALENDAR_ID2', this.calendar_id2);
      this.loadingPost = true;
      this.axios.post('post/settings_connectors.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this2.$t('modifSuccess'),
          context: 'success'
        });
      }).catch(function (_) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this2.$t('modifFailure'),
          context: 'error'
        });
      }).then(function (_) {
        _this2.loadingPost = false;
      });
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function $storeState_SitesSiteSelected(v) {
      if (v) {
        this.getOptions();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-380dab27","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Connectors.vue
var Connectors_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loadingGet)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('div',[_c('v-expansion-panel',[_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_connecteur_facebook')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Facebook")]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-switch',{attrs:{"disabled":""},model:{value:(_vm.fb_onoff),callback:function ($$v) {_vm.fb_onoff=$$v},expression:"fb_onoff"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.fb_onoff ? 'ON' : 'OFF'))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.$t('activeInFacebook')))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"label":"Token Facebook"},model:{value:(_vm.fb_token),callback:function ($$v) {_vm.fb_token=$$v},expression:"fb_token"}})],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"label":"Id Facebook"},model:{value:(_vm.fb_id),callback:function ($$v) {_vm.fb_id=$$v},expression:"fb_id"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_connecteur_messenger')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Messenger")]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-switch',{attrs:{"disabled":""},model:{value:(_vm.messenger_onoff),callback:function ($$v) {_vm.messenger_onoff=$$v},expression:"messenger_onoff"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.messenger_onoff ? 'ON' : 'OFF'))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.$t('activeInFacebook')))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"label":"Id Messenger"},model:{value:(_vm.messenger_id),callback:function ($$v) {_vm.messenger_id=$$v},expression:"messenger_id"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_connecteur_salseforce')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Salesforce")]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-switch',{model:{value:(_vm.sf_onoff),callback:function ($$v) {_vm.sf_onoff=$$v},expression:"sf_onoff"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.sf_onoff ? 'ON' : 'OFF'))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"disabled":!_vm.sf_onoff,"label":_vm.$t('connectionIdentifier')},model:{value:(_vm.sf_id1),callback:function ($$v) {_vm.sf_id1=$$v},expression:"sf_id1"}})],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"disabled":!_vm.sf_onoff,"label":_vm.$t('password')},model:{value:(_vm.sf_id2),callback:function ($$v) {_vm.sf_id2=$$v},expression:"sf_id2"}})],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"disabled":!_vm.sf_onoff,"label":"Token"},model:{value:(_vm.sf_id3),callback:function ($$v) {_vm.sf_id3=$$v},expression:"sf_id3"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_connecteur_zendesk')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Zendesk")]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-switch',{model:{value:(_vm.zd_onoff),callback:function ($$v) {_vm.zd_onoff=$$v},expression:"zd_onoff"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.zd_onoff ? 'ON' : 'OFF'))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"disabled":!_vm.zd_onoff,"label":_vm.$t('connectionIdentifier')},model:{value:(_vm.zd_id1),callback:function ($$v) {_vm.zd_id1=$$v},expression:"zd_id1"}})],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"disabled":!_vm.zd_onoff,"label":_vm._f("cap")(_vm.$t('domainName'))},model:{value:(_vm.zd_id2),callback:function ($$v) {_vm.zd_id2=$$v},expression:"zd_id2"}})],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"disabled":!_vm.zd_onoff,"label":"Token"},model:{value:(_vm.zd_id3),callback:function ($$v) {_vm.zd_id3=$$v},expression:"zd_id3"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_connecteur_analytics')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Analytics")]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-switch',{model:{value:(_vm.ga_onoff),callback:function ($$v) {_vm.ga_onoff=$$v},expression:"ga_onoff"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.ga_onoff ? 'ON' : 'OFF'))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"disabled":!_vm.ga_onoff,"label":_vm.$t('connectionIdentifier')},model:{value:(_vm.ga_id),callback:function ($$v) {_vm.ga_id=$$v},expression:"ga_id"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_connecteur_slack')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Slack")]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-switch',{model:{value:(_vm.slack_onoff),callback:function ($$v) {_vm.slack_onoff=$$v},expression:"slack_onoff"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.slack_onoff ? 'ON' : 'OFF'))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"disabled":!_vm.slack_onoff,"label":_vm.$t('connectionIdentifier')},model:{value:(_vm.slack_id),callback:function ($$v) {_vm.slack_id=$$v},expression:"slack_id"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_connecteur_vyte')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Vyte")]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-switch',{model:{value:(_vm.vyte_onoff),callback:function ($$v) {_vm.vyte_onoff=$$v},expression:"vyte_onoff"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.vyte_onoff ? 'ON' : 'OFF'))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"disabled":!_vm.vyte_onoff,"label":"email"},model:{value:(_vm.vyte_id1),callback:function ($$v) {_vm.vyte_id1=$$v},expression:"vyte_id1"}})],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"disabled":!_vm.vyte_onoff,"label":"Id Application"},model:{value:(_vm.vyte_id2),callback:function ($$v) {_vm.vyte_id2=$$v},expression:"vyte_id2"}})],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"disabled":!_vm.vyte_onoff,"label":"Token"},model:{value:(_vm.vyte_id3),callback:function ($$v) {_vm.vyte_id3=$$v},expression:"vyte_id3"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_connecteur_calendar')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Google Calendar / Agenda")]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-switch',{model:{value:(_vm.calendar_onoff),callback:function ($$v) {_vm.calendar_onoff=$$v},expression:"calendar_onoff"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.calendar_onoff ? 'ON' : 'OFF'))])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"disabled":true,"label":"token/email"},model:{value:(_vm.calendar_id1),callback:function ($$v) {_vm.calendar_id1=$$v},expression:"calendar_id1"}})],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('v-text-field',{attrs:{"disabled":true,"label":"Id Application"},model:{value:(_vm.calendar_id2),callback:function ($$v) {_vm.calendar_id2=$$v},expression:"calendar_id2"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","block":_vm.$vuetify.breakpoint.xsOnly,"loading":_vm.loadingPost},nativeOn:{"click":function($event){_vm.postOptions()}}},[_vm._v("\n          "+_vm._s(_vm._f("cap")(_vm.$t('save')))),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("send")])],1)],1)],1),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":9},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)}
var Connectors_staticRenderFns = []
var Connectors_esExports = { render: Connectors_render, staticRenderFns: Connectors_staticRenderFns }
/* harmony default export */ var settings_Connectors = (Connectors_esExports);
// CONCATENATED MODULE: ./src/components/settings/Connectors.vue
var Connectors_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Connectors___vue_template_functional__ = false
/* styles */
var Connectors___vue_styles__ = null
/* scopeId */
var Connectors___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Connectors___vue_module_identifier__ = null
var Connectors_Component = Connectors_normalizeComponent(
  Connectors,
  settings_Connectors,
  Connectors___vue_template_functional__,
  Connectors___vue_styles__,
  Connectors___vue_scopeId__,
  Connectors___vue_module_identifier__
)

/* harmony default export */ var components_settings_Connectors = (Connectors_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/settings/BluePush.vue



/* harmony default export */ var BluePush = ({
  data: function data() {
    return {
      alert: false,
      push: {
        active: false,
        id: '',
        lang: 'FR',
        urlonoff: '0',
        url: '',
        delay: '0'
      },

      loadingGet: false,
      loadingPost: false,
      test: {},
      pushs: [],
      resAjx: null,
      dialogProgress: false
    };
  },
  mounted: function mounted() {
    this.init();
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
  },
  created: function created() {
    this.getOptions();

    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'settings_bluepush';
    } else {
      setTimeout(function () {
        if (typeof defautMotif !== 'undefined') {
          defautMotif = 'settings_bluepush';
        }
      }, 800);
    }
  },


  methods: {
    init: function init() {
      var _this = this;

      if (this.$store.state._User.entLevel !== '7' && this.$store.state._User.entOptionPush === 0) {
        this.alert = true;
        return;
      }
      this.resAjx = null;
      this.axios.get('get/pushs.php').then(function (response) {
        _this.resAjx = response.data;
      }).then(function (_) {
        for (var i = 0; i < _this.resAjx.length; ++i) {
          _this.pushs.push({
            text: _this.resAjx[i].PUSH_NAME,
            value: _this.resAjx[i].PUSH_ID
          });
        }
      }).catch();
    },
    getOptions: function getOptions() {
      var _this2 = this;

      this.loadingGet = true;
      this.axios.get('get/settings_push.php?desk=' + this.$store.state._Sites.siteSelected.LIC_DSK_ID).then(function (response) {
        _this2.push.active = response.data.DSK_PUSH_ONOFF === '1';
        _this2.push.delay = response.data.DSK_PUSH_DELAY;
        _this2.push.urlonoff = response.data.DSK_PUSH_URL_ONOFF === '1';
        _this2.push.url = response.data.DSK_PUSH_URL;
        _this2.push.id = response.data.DSK_PUSH_ID;
        _this2.test.DSK_PUSH_ONOFF = response.data.DSK_PUSH_ONOFF;
        _this2.test.DSK_PUSH_DELAY = response.data.DSK_PUSH_DELAY;
        _this2.test.DSK_PUSH_URL_ONOFF = response.data.DSK_PUSH_URL_ONOFF;
        _this2.test.DSK_PUSH_URL = response.data.DSK_PUSH_URL;
        _this2.test.DSK_PUSH_ID = response.data.DSK_PUSH_ID;
      }).catch(function (_) {}).then(function (_) {
        _this2.loadingGet = false;
      });
    },
    testBrideStatus: function testBrideStatus(name) {
      var brides = this.$store.state._User.brides;

      if (brides) {
        var resultat = brides.find(function (brides) {
          return brides.brideName === name;
        });
        if (resultat) {
          if (resultat.status === '0') {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    postOptions: function postOptions() {
      var _this3 = this;

      var dataToPost = new window.FormData();

      dataToPost.append('DSK_ID', this.$store.state._Sites.siteSelected.LIC_DSK_ID);
      dataToPost.append('LIC_KEY', this.$store.state._Sites.siteSelected.LIC_KEY);

      dataToPost.append('DSK_PUSH_ONOFF', this.push.active ? '1' : '0');
      dataToPost.append('DSK_PUSH_DELAY', this.push.delay);
      dataToPost.append('DSK_PUSH_URL', this.push.url);
      dataToPost.append('DSK_PUSH_URL_ONOFF', this.push.urlonoff ? '1' : '0');

      if (typeof this.push.id.value !== 'undefined' && this.push.id.value) {
        dataToPost.append('DSK_PUSH_ID', this.push.id.value);
      } else {
        dataToPost.append('DSK_PUSH_ID', this.push.id);
      }
      this.loadingPost = true;
      this.axios.post('post/settings_push.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        var siteUpdate = lodash_default.a.clone(_this3.$store.state._Sites.siteSelected);
        _this3.$store.commit('_Sites/UPDATE_SITE_SETTINGS', siteUpdate);
        _this3.$store.commit('_Sites/UPDATE_SITE_SELECTED', siteUpdate);
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this3.$t('modifSuccess'),
          context: 'success'
        });
      }).catch(function (_) {
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this3.$t('modifFailure'),
          context: 'error'
        });
      }).then(function (_) {
        _this3.loadingPost = false;
      });
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function $storeState_SitesSiteSelected(v) {
      if (v) {
        this.getOptions();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2920e150","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/BluePush.vue
var BluePush_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.alert),expression:"alert"}],attrs:{"color":"secondary","icon":"warning","value":"true","outline":""}},[_vm._v("\n    "+_vm._s(_vm.$t('warningPushDisabled'))+" \n  ")]),_vm._v(" "),_c('div',{staticClass:"display"},[(_vm.loadingGet)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',{attrs:{"disabled":_vm.testBrideStatus('parametre_push')}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("announcement")]),_vm._v(_vm._s(_vm.$t("pushMarketAuto")))],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-switch',{attrs:{"label":"Push Marketing","light":"","color":"primary"},model:{value:(_vm.push.active),callback:function ($$v) {_vm.$set(_vm.push, "active", $$v)},expression:"push.active"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md3":""}},[_c('v-select',{attrs:{"items":_vm.pushs,"label":_vm._f("cap")(_vm.$t('select') + ' push'),"return-object":"","disabled":!_vm.push.active},model:{value:(_vm.push.id),callback:function ($$v) {_vm.$set(_vm.push, "id", $$v)},expression:"push.id"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.push.active),expression:"push.active"}],attrs:{"xs12":""}},[_c('div',[_vm._v(_vm._s(_vm.$t('triggerConditionTime')))]),_vm._v(" "),_c('v-slider',{attrs:{"thumb-label":"","min":0,"max":300},model:{value:(_vm.push.delay),callback:function ($$v) {_vm.$set(_vm.push, "delay", $$v)},expression:"push.delay"}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.push.delay)+" sec.")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.push.active),expression:"push.active"}],attrs:{"xs12":""}},[_c('div',[_vm._v(_vm._s(_vm.$t('triggerConditionUrl')))]),_vm._v(" "),_c('v-switch',{attrs:{"label":_vm.$t('restrictFewUrLs'),"light":"","color":"primary"},model:{value:(_vm.push.urlonoff),callback:function ($$v) {_vm.$set(_vm.push, "urlonoff", $$v)},expression:"push.urlonoff"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.push.active),expression:"push.active"}],attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":_vm.$t('containsString'),"disabled":!_vm.push.urlonoff},model:{value:(_vm.push.url),callback:function ($$v) {_vm.$set(_vm.push, "url", $$v)},expression:"push.url"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","block":_vm.$vuetify.breakpoint.xsOnly,"loading":_vm.loadingPost,"disabled":_vm.alert},nativeOn:{"click":function($event){_vm.postOptions()}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('save')))),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("save")])],1)],1)],1),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":10},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)}
var BluePush_staticRenderFns = []
var BluePush_esExports = { render: BluePush_render, staticRenderFns: BluePush_staticRenderFns }
/* harmony default export */ var settings_BluePush = (BluePush_esExports);
// CONCATENATED MODULE: ./src/components/settings/BluePush.vue
var BluePush_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var BluePush___vue_template_functional__ = false
/* styles */
var BluePush___vue_styles__ = null
/* scopeId */
var BluePush___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var BluePush___vue_module_identifier__ = null
var BluePush_Component = BluePush_normalizeComponent(
  BluePush,
  settings_BluePush,
  BluePush___vue_template_functional__,
  BluePush___vue_styles__,
  BluePush___vue_scopeId__,
  BluePush___vue_module_identifier__
)

/* harmony default export */ var components_settings_BluePush = (BluePush_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/settings/Recall.vue




/* harmony default export */ var Recall = ({
  data: function data() {
    return {
      alert: false,
      alertCallback: false,
      titleDialog: '',
      contentDialog: '',
      onOff: false,
      options: {},
      style: 'RENDEZVOUS',
      timeout: 0,
      title: 'Meeting',
      msg: 'Entrez les détails',
      img: '',
      interRDV: 30,
      style2: 'DATEPICKER',
      side: 'RIGHT',
      choixIcone: 0,
      hiddenMobile: false,
      pictoTirette: [],
      vymail: '',
      connecteurVyte: '0',
      displayWarningVyte: 0,
      displayWarningCalendar: 0,
      form: {
        hours: '',
        days: [{
          name: this.$t('monday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('tuesday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('wednesday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('thursday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('friday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('saturday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }, {
          name: this.$t('sunday'),
          am: { start: '08:00', end: '12:00', active: true },
          pm: { start: '14:00', end: '18:00', active: true }
        }],

        urls: '',
        rules: []
      },

      showTp: false,
      daySelected: {},
      tmpHours: null,
      amOrPm: 'am',
      startOrEnd: 'start',
      allowed: { hours: { min: '0:00', max: '12:00' } },
      dependency: '',

      showHours: false,
      daysTmp: [],
      dayHours: null,
      days: [{ text: lodash_default.a.upperFirst(this.$t('monday')), value: 0 }, { text: lodash_default.a.upperFirst(this.$t('tuesday')), value: 1 }, { text: lodash_default.a.upperFirst(this.$t('wednesday')), value: 2 }, { text: lodash_default.a.upperFirst(this.$t('thursday')), value: 3 }, { text: lodash_default.a.upperFirst(this.$t('friday')), value: 4 }, { text: lodash_default.a.upperFirst(this.$t('saturday')), value: 5 }, { text: lodash_default.a.upperFirst(this.$t('sunday')), value: 6 }],

      tmp: '',
      headersRules: [{ text: lodash_default.a.upperFirst(this.$t('type')), align: 'left', sortable: false, value: 'type' }, { text: lodash_default.a.upperFirst(this.$t('content')), align: 'left', sortable: false, value: 'content' }, { text: '', align: 'left', sortable: false, value: 'actions' }],
      typeRules: [{ text: lodash_default.a.upperFirst(this.$t('fullUrl')), value: 'DSK_SHOW_URL' }, { text: lodash_default.a.upperFirst(this.$t('containedUrl')), value: 'DSK_SHOW_PART_URL' }, { text: lodash_default.a.upperFirst(this.$t('keyWords')), value: 'DSK_SHOW_TAGS' }, { text: lodash_default.a.upperFirst(this.$t('classOrId')), value: 'DSK_SHOW_CLASS_ID' }],
      showDialogRule: false,
      ruleTmp: { content: '', type: {} },

      loadingGet: false,
      loadingPost: false,
      dialogProgress: false
    };
  },
  mounted: function mounted() {
    this.getOptions();
    this.loadImg();
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
  },
  created: function created() {
    this.daySelected = this.form.days[0];
    this.dayHours = { text: this.form.days[0].name, value: 0 };

    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'settings_recall';
    } else {
      setTimeout(function () {
        if (typeof defautMotif !== 'undefined') {
          defautMotif = 'settings_recall';
        }
      }, 800);
    }
  },


  computed: {
    headersDays: function headersDays() {
      return !this.daysTmp.length ? [{ text: this.$t('allDays'), align: 'left', sortable: false }] : [{ text: this.$t('noDays'), align: 'left', sortable: false }];
    },
    iframePreviewMeeting: function iframePreviewMeeting() {
      return  false ? DOMAINE + '/dev/fo/incl/inner2019.php?' + this.iframeParams : constants_DOMAINE + '/fo/incl/inner2019.php?' + this.iframeParams;
    },
    iframeParams: function iframeParams() {
      var params = '';

      return params;
    }
  },

  methods: {
    openTimePicker: function openTimePicker(day, amOrPm, startOrEnd) {
      this.showTp = true;
      this.daySelected = day;
      this.amOrPm = amOrPm;
      this.startOrEnd = startOrEnd;
      this.tmpHours = this.daySelected[amOrPm][startOrEnd];

      this.allowed.hours = amOrPm === 'am' ? { min: '0:00', max: '12:59' } : { min: '12:00', max: '23:59' };
    },
    openHours: function openHours() {
      this.showHours = true;
    },
    submitHours: function submitHours() {
      var _this = this;

      this.showHours = false;

      var daySelected = this.form.days.find(function (d) {
        return d.name === _this.dayHours.text;
      });
      this.daysTmp.forEach(function (day) {
        var d = _this.form.days.find(function (d) {
          return d.name === day.text.toLowerCase();
        });
        d.am = lodash_default.a.cloneDeep(daySelected.am);
        d.pm = lodash_default.a.cloneDeep(daySelected.pm);
      });
      this.daysTmp = [];
    },
    openRule: function openRule() {
      this.showDialogRule = true;
      this.ruleTmp = { content: '', type: this.typeRules[0], list: this.form.urls };
    },
    submitRule: function submitRule() {
      if (!lodash_default.a.isEmpty(this.ruleTmp.content)) {
        this.showDialogRule = false;
        this.form.rules.push(lodash_default.a.clone(this.ruleTmp));
      } else {
        this.$validator.validateAll();
      }
    },
    deleteRule: function deleteRule(index) {
      this.form.rules.splice(index, 1);
    },
    getOptions: function getOptions() {
      var _this2 = this;

      if (this.$store.state._Sites.siteSelected.LIC_RECALL_ACTIVATED !== '1') {
        this.alert = true;
        return;
      }
      if (this.$store.state._Sites.siteSelected.DSK_CALLBACK_ONOFF === '1') {
        this.alertCallback = true;
      }
      this.alert = false;
      this.loadingGet = true;
      this.axios.get('get/settings_recall.php?desk=' + this.$store.state._Sites.siteSelected.LIC_DSK_ID).then(function (response) {
        _this2.onOff = response.data.DSK_RECALL_ONOFF === '1';
        _this2.timeout = response.data.DSK_RECALL_DELAY;
        _this2.style = response.data.DSK_RECALL_STYLE;
        if (response.data.DSK_RECALL_TITLE !== '') {
          _this2.title = response.data.DSK_RECALL_TITLE;
        }
        if (response.data.DSK_RECALL_MSG !== '') {
          _this2.msg = response.data.DSK_RECALL_MSG;
        }
        _this2.img = response.data.DSK_RECALL_IMG;
        _this2.dependency = response.data.DSK_RECALL_DEPENDANT;
        _this2.hiddenMobile = response.data.DSK_RECALL_HIDE_MOBILE === '1';
        _this2.choixIcone = parseInt(response.data.DSK_RECALL_PICTO);
        _this2.interRDV = parseInt(response.data.DSK_RECALL_DURATION);
        _this2.style2 = response.data.DSK_RECALL_STYLE2;
        _this2.side = response.data.DSK_RECALL_SIDE;
        _this2.vymail = response.data.DSK_RECALL_VYMAIL;
        _this2.connecteurVyte = response.data.CONNECTOR_VYMAIL;
        _this2.connecteurCalendar = response.data.CONNECTOR_CALENDAR;

        _this2.form.urls = 'all';
        if (response.data.DSK_RECALL_SHOW_ONOFF === '1') {
          _this2.form.urls = 'showOnOff';
        } else if (response.data.DSK_RECALL_HIDE_ONOFF === '1') {
          _this2.form.urls = 'hideOnOff';
        }
        _this2.form.rules = [];

        lodash_default.a.each(response.data.DSK_RECALL_SHOW_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[0]), 'list': 'showOnOff' });
        });
        lodash_default.a.each(response.data.DSK_RECALL_SHOW_PART_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[1]), 'list': 'showOnOff' });
        });
        lodash_default.a.each(response.data.DSK_RECALL_SHOW_TAGS.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[2]), 'list': 'showOnOff' });
        });
        lodash_default.a.each(response.data.DSK_RECALL_SHOW_CLASS_ID.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[3]), 'list': 'showOnOff' });
        });

        lodash_default.a.each(response.data.DSK_RECALL_HIDE_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[0]), 'list': 'hideOnOff' });
        });
        lodash_default.a.each(response.data.DSK_RECALL_HIDE_PART_URL.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[1]), 'list': 'hideOnOff' });
        });
        lodash_default.a.each(response.data.DSK_RECALL_HIDE_TAGS.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[2]), 'list': 'hideOnOff' });
        });
        lodash_default.a.each(response.data.DSK_RECALL_HIDE_CLASS_ID.split('|'), function (url) {
          if (!lodash_default.a.isEmpty(url)) _this2.form.rules.push({ content: url, type: lodash_default.a.clone(_this2.typeRules[3]), 'list': 'hideOnOff' });
        });

        _this2.form.hours = response.data.DSK_SCHEDULES_RECALL.split('|')[0];
        var hours = response.data.DSK_SCHEDULES_RECALL.split('|');

        _this2.form.days[0].am.active = !lodash_default.a.isEmpty(hours[1] + hours[2] + hours[3] + hours[4]) && !lodash_default.a.isNil(hours[1]) && !lodash_default.a.isNil(hours[2]) && !lodash_default.a.isNil(hours[3]) && !lodash_default.a.isNil(hours[4]);
        _this2.form.days[0].am.start = _this2.form.days[0].am.active ? hours[1] + ':' + hours[2] : '00:00';
        _this2.form.days[0].am.end = _this2.form.days[0].am.active ? hours[3] + ':' + hours[4] : '00:00';
        _this2.form.days[0].pm.active = !lodash_default.a.isEmpty(hours[5] + hours[6] + hours[7] + hours[8]);
        _this2.form.days[0].pm.start = _this2.form.days[0].pm.active ? hours[5] + ':' + hours[6] : '12:00';
        _this2.form.days[0].pm.end = _this2.form.days[0].pm.active ? hours[7] + ':' + hours[8] : '12:00';

        _this2.form.days[1].am.active = !lodash_default.a.isEmpty(hours[9] + hours[10] + hours[11] + hours[12]);
        _this2.form.days[1].am.start = _this2.form.days[1].am.active ? hours[9] + ':' + hours[10] : '00:00';
        _this2.form.days[1].am.end = _this2.form.days[1].am.active ? hours[11] + ':' + hours[12] : '00:00';
        _this2.form.days[1].pm.active = !lodash_default.a.isEmpty(hours[13] + hours[14] + hours[15] + hours[16]);
        _this2.form.days[1].pm.start = _this2.form.days[1].am.active ? hours[13] + ':' + hours[14] : '12:00';
        _this2.form.days[1].pm.end = _this2.form.days[1].am.active ? hours[15] + ':' + hours[16] : '12:00';

        _this2.form.days[2].am.active = !lodash_default.a.isEmpty(hours[17] + hours[18] + hours[19] + hours[20]);
        _this2.form.days[2].am.start = _this2.form.days[2].am.active ? hours[17] + ':' + hours[18] : '00:00';
        _this2.form.days[2].am.end = _this2.form.days[2].am.active ? hours[19] + ':' + hours[20] : '00:00';
        _this2.form.days[2].pm.active = !lodash_default.a.isEmpty(hours[21] + hours[22] + hours[23] + hours[24]);
        _this2.form.days[2].pm.start = _this2.form.days[2].pm.active ? hours[21] + ':' + hours[22] : '12:00';
        _this2.form.days[2].pm.end = _this2.form.days[2].pm.active ? hours[23] + ':' + hours[24] : '12:00';

        _this2.form.days[3].am.active = !lodash_default.a.isEmpty(hours[25] + hours[26] + hours[27] + hours[28]);
        _this2.form.days[3].am.start = _this2.form.days[3].am.active ? hours[25] + ':' + hours[26] : '00:00';
        _this2.form.days[3].am.end = _this2.form.days[3].am.active ? hours[27] + ':' + hours[28] : '00:00';
        _this2.form.days[3].pm.active = !lodash_default.a.isEmpty(hours[29] + hours[30] + hours[31] + hours[32]);
        _this2.form.days[3].pm.start = _this2.form.days[3].pm.active ? hours[29] + ':' + hours[30] : '12:00';
        _this2.form.days[3].pm.end = _this2.form.days[3].pm.active ? hours[31] + ':' + hours[32] : '12:00';

        _this2.form.days[4].am.active = !lodash_default.a.isEmpty(hours[33] + hours[34] + hours[35] + hours[36]);
        _this2.form.days[4].am.start = _this2.form.days[4].am.active ? hours[33] + ':' + hours[34] : '00:00';
        _this2.form.days[4].am.end = _this2.form.days[4].am.active ? hours[35] + ':' + hours[36] : '00:00';
        _this2.form.days[4].pm.active = !lodash_default.a.isEmpty(hours[37] + hours[38] + hours[39] + hours[40]);
        _this2.form.days[4].pm.start = _this2.form.days[4].pm.active ? hours[37] + ':' + hours[38] : '12:00';
        _this2.form.days[4].pm.end = _this2.form.days[4].pm.active ? hours[39] + ':' + hours[40] : '12:00';

        _this2.form.days[5].am.active = !lodash_default.a.isEmpty(hours[41] + hours[42] + hours[43] + hours[44]);
        _this2.form.days[5].am.start = _this2.form.days[5].am.active ? hours[41] + ':' + hours[42] : '00:00';
        _this2.form.days[5].am.end = _this2.form.days[5].am.active ? hours[43] + ':' + hours[44] : '00:00';
        _this2.form.days[5].pm.active = !lodash_default.a.isEmpty(hours[45] + hours[46] + hours[47] + hours[48]);
        _this2.form.days[5].pm.start = _this2.form.days[5].pm.active ? hours[45] + ':' + hours[46] : '12:00';
        _this2.form.days[5].pm.end = _this2.form.days[5].pm.active ? hours[47] + ':' + hours[48] : '12:00';

        _this2.form.days[6].am.active = !lodash_default.a.isEmpty(hours[49] + hours[50] + hours[51] + hours[52]);
        _this2.form.days[6].am.start = _this2.form.days[6].am.active ? hours[49] + ':' + hours[50] : '00:00';
        _this2.form.days[6].am.end = _this2.form.days[6].am.active ? hours[51] + ':' + hours[52] : '00:00';
        _this2.form.days[6].pm.active = !lodash_default.a.isEmpty(hours[53] + hours[54] + hours[55] + hours[56]);
        _this2.form.days[6].pm.start = _this2.form.days[6].pm.active ? hours[53] + ':' + hours[54] : '12:00';
        _this2.form.days[6].pm.end = _this2.form.days[6].pm.active ? hours[55] + ':' + hours[56] : '12:00';

        _this2.checkConnector();
      }).catch(function (_) {}).then(function (_) {
        _this2.loadingGet = false;
      });
    },
    postOptions: function postOptions() {
      var _this3 = this;

      var dataToPost = new window.FormData();

      dataToPost.append('DSK_ID', this.$store.state._Sites.siteSelected.LIC_DSK_ID);
      dataToPost.append('LIC_KEY', this.$store.state._Sites.siteSelected.LIC_KEY);
      dataToPost.append('DSK_RECALL_ONOFF', this.onOff ? '1' : '0');
      dataToPost.append('DSK_RECALL_DELAY', this.timeout);
      dataToPost.append('DSK_RECALL_STYLE', this.style);
      dataToPost.append('DSK_RECALL_TITLE', this.title);
      dataToPost.append('DSK_RECALL_MSG', this.msg);
      dataToPost.append('DSK_RECALL_IMG', this.img);
      dataToPost.append('DSK_RECALL_DEPENDANT', this.dependency);
      dataToPost.append('DSK_RECALL_HIDE_MOBILE', this.hiddenMobile ? '1' : '0');
      dataToPost.append('DSK_RECALL_PICTO', this.choixIcone);
      dataToPost.append('DSK_RECALL_DURATION', this.interRDV);
      dataToPost.append('DSK_RECALL_STYLE2', this.style2);
      dataToPost.append('DSK_RECALL_SIDE', this.side);
      dataToPost.append('DSK_RECALL_VYMAIL', this.vymail);

      dataToPost.append('DSK_RECALL_HIDE_ONOFF', this.form.urls === 'hideOnOff' ? '1' : '0');
      dataToPost.append('DSK_RECALL_SHOW_ONOFF', this.form.urls === 'showOnOff' ? '1' : '0');
      var url = { 'showOnOff': '', hideOnOff: '' };
      var partUrl = { 'showOnOff': '', hideOnOff: '' };
      var tags = { 'showOnOff': '', hideOnOff: '' };
      var classId = { 'showOnOff': '', hideOnOff: '' };
      lodash_default.a.each(this.form.rules, function (rule) {
        if (_this3.typeRules[0].value === rule.type.value) {
          url[rule.list] += rule.content + '|';
        } else if (_this3.typeRules[1].value === rule.type.value) {
          partUrl[rule.list] += rule.content + '|';
        } else if (_this3.typeRules[2].value === rule.type.value) {
          tags[rule.list] += rule.content + '|';
        } else if (_this3.typeRules[3].value === rule.type.value) {
          classId[rule.list] += rule.content + '|';
        }
      });
      dataToPost.append('DSK_RECALL_SHOW_URL', url.showOnOff);
      dataToPost.append('DSK_RECALL_SHOW_PART_URL', partUrl.showOnOff);
      dataToPost.append('DSK_RECALL_SHOW_TAGS', tags.showOnOff);
      dataToPost.append('DSK_RECALL_SHOW_CLASS_ID', classId.showOnOff);
      dataToPost.append('DSK_RECALL_HIDE_URL', url.hideOnOff);
      dataToPost.append('DSK_RECALL_HIDE_PART_URL', partUrl.hideOnOff);
      dataToPost.append('DSK_RECALL_HIDE_TAGS', tags.hideOnOff);
      dataToPost.append('DSK_RECALL_HIDE_CLASS_ID', classId.hideOnOff);

      var hours = this.form.hours;
      lodash_default.a.each(this.form.days, function (day) {
        hours += day.am.active ? '|' + day.am.start.split(':')[0] + '|' + day.am.start.split(':')[1] + '|' + day.am.end.split(':')[0] + '|' + day.am.end.split(':')[1] : '||||';
        hours += day.pm.active ? '|' + day.pm.start.split(':')[0] + '|' + day.pm.start.split(':')[1] + '|' + day.pm.end.split(':')[0] + '|' + day.pm.end.split(':')[1] : '||||';
      });
      dataToPost.append('DSK_SCHEDULES_RECALL', hours);
      this.loadingPost = true;
      this.axios.post('post/settings_recall.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this3.$store.state._Sites.siteSelected.DSK_RECALL_ONOFF = _this3.onOff ? '1' : '0';
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this3.$t('modifSuccess'),
          context: 'success'
        });
      }).catch(function (_) {
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this3.$t('modifFailure'),
          context: 'error'
        });
      }).then(function (_) {
        _this3.loadingPost = false;
      });
    },
    loadImg: function loadImg() {
      var _this4 = this;

      this.axios.get('get/imagesPicto.php').then(function (res) {
        _this4.pictoTirette = res.data.map(function (img) {
          return RECALL_DIR + img;
        });
      });
    },
    updateImg: function updateImg(img, elt) {
      img = img.split('/').reverse()[0].split('.')[0];
      this.choixIcone = img;
      var allpicto = document.querySelectorAll('.picto');
      for (var j = 0; j < allpicto.length; j++) {
        allpicto[j].style.border = '';
      }
      document.getElementById('picto_' + elt).style.border = '1px solid black';
    },
    checkConnector: function checkConnector() {
      if (this.connecteurVyte === '0' && this.style === 'VYTE') {
        this.displayWarningVyte = 1;
      } else {
        this.displayWarningVyte = 0;
      }

      if (this.connecteurCalendar === '0' && this.style === 'CALENDAR') {
        this.displayWarningCalendar = 1;
      } else {
        this.displayWarningCalendar = 0;
      }
    },
    goToConnector: function goToConnector() {
      this.$router.push({ path: '/settings/connectors' });
    },
    openDialog: function openDialog(data) {
      this.titleDialog = data.title;
      this.contentDialog = data.content;
    },
    fermeDialogInfos: function fermeDialogInfos() {
      this.titleDialog = '';
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function $storeState_SitesSiteSelected(v) {
      this.getOptions();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b8998e10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/settings/Recall.vue
var Recall_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(true),expression:"true"}],attrs:{"color":"primary","value":"true","outline":""}},[_vm._v("\n      Ces réglages affectent la fonctionnalité meeting (prise de rendez-vous) sur le site "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))]),_vm._v(". Ses réglages sont indépendants des réglages du \"widget\".\n    ")]),_vm._v(" "),_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.alert),expression:"alert"}],attrs:{"color":"secondary","icon":"warning","value":"true","outline":""}},[_vm._v("\n      "+_vm._s(_vm.$t('warningRecallDisabled'))+" "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))])]),_vm._v(" "),_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.alertCallback),expression:"alertCallback"}],attrs:{"color":"warning","icon":"warning","value":"true","outline":""}},[_vm._v("\n      "+_vm._s(_vm.$t('warningCallbackConflict'))+" "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))])]),_vm._v(" "),_c('div',[(_vm.loadingGet)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm.onOff ? 'MEETING ON' : 'MEETING OFF',"light":"","color":"primary"},model:{value:(_vm.onOff),callback:function ($$v) {_vm.onOff=$$v},expression:"onOff"}})],1)],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md12":""}},[_c('v-expansion-panel',[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("today")]),_vm._v(" "+_vm._s(_vm.$t('priseRdv')))],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md10":""}},[_c('v-card',[_c('v-card-text',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('typeRdv')))]),_vm._v(" "),_c('v-radio-group',{attrs:{"hint":_vm.style == 'RENDEZVOUS' ? 'Targetfirst vous notifie le rendez-vous par email ; le rappel télphonique est effectuée par vos soins.' : 'Vous devez avoir paramétré votre agenda au préalable, avec Vyte ou Google Calendar',"persistent-hint":""},on:{"change":_vm.checkConnector},model:{value:(_vm.style),callback:function ($$v) {_vm.style=$$v},expression:"style"}},[_c('v-radio',{attrs:{"label":_vm.$t('priseRdvTel'),"color":"primary","value":"RENDEZVOUS"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":_vm.$t('priseRdvVyte'),"color":"primary","value":"VYTE"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":_vm.$t('priseRdvGoogle'),"color":"primary","value":"CALENDAR"}})],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[(_vm.style === 'VYTE' || _vm.style === 'CALENDAR')?_c('div',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("alarm")]),_vm._v(" "+_vm._s(_vm.$t('dureeRdv')))],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-slider',{attrs:{"min":"15","max":"120","step":"15","ticks":""},model:{value:(_vm.interRDV),callback:function ($$v) {_vm.interRDV=$$v},expression:"interRDV"}})],1),_vm._v(" "),_c('v-flex',[_c('v-subheader',[_vm._v(_vm._s(_vm.interRDV)+" minutes")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('typeForm')))]),_vm._v(" "),_c('v-radio-group',{attrs:{"hint":_vm.style2 == 'REDIRECT' ? 'Un nouvel onglet s\'ouvre dans le navigateur, vers une page dédiée à la prise de rendez-vous' : (_vm.style2 == 'DATEPICKER' ? 'La popup de prise de rendez-vous propose directement de cliquer sur la date et l\'heure' : 'La popup de prise de rendez-vous propose des champs de formulaire classiques'),"persistent-hint":""},model:{value:(_vm.style2),callback:function ($$v) {_vm.style2=$$v},expression:"style2"}},[_c('v-radio',{attrs:{"label":"Calendrier visible","color":"primary","value":"DATEPICKER"}}),_vm._v(" "),(_vm.style !== 'CALENDAR')?_c('v-radio',{attrs:{"label":"Redirection vers landing page","color":"primary","value":"REDIRECT"}}):_vm._e(),_vm._v(" "),_c('v-radio',{attrs:{"label":"Champs classiques","color":"primary","value":"CDISC"}})],1)],1)],1)],1):_vm._e()])],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),(_vm.style2 !== 'REDIRECT')?_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("library_add_check")]),_vm._v(" Formulaire pop-up")],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md10":""}},[_c('v-card',[_c('v-card-text',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('modifTitrePopup')))]),_vm._v(" "),_c('v-text-field',{attrs:{"data-vv-name":"title","error":_vm.wzErrors.has('title'),"error-messages":_vm.wzErrors.collect('title')},model:{value:(_vm.title),callback:function ($$v) {_vm.title=$$v},expression:"title"}})],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md10":""}},[_c('v-card',[_c('v-card-text',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('modifDesPopup')))]),_vm._v(" "),_c('v-text-field',{attrs:{"data-vv-name":"msg","error":_vm.wzErrors.has('msg'),"error-messages":_vm.wzErrors.collect('msg')},model:{value:(_vm.msg),callback:function ($$v) {_vm.msg=$$v},expression:"msg"}})],1)],1)],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("account_balance_wallet")]),_vm._v(" Tirette")],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md10":""}},[_c('v-card',[_c('v-card-text',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('choixIconeTirette')))]),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-container',{attrs:{"grid-list-sm":"","fluid":""}},[(_vm.pictoTirette.length)?_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.pictoTirette),function(img,i){return _c('v-flex',{key:i},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var hover = ref.hover;
return _c('v-card',{staticClass:"d-flex tf-picto-recall",class:("elevation-" + (hover ? 6 : 0)),staticStyle:{"cursor":"pointer"},style:(_vm.choixIcone === i ? 'border: 1px solid red' : ''),attrs:{"flat":"","tile":"","id":'picto_' + i},on:{"click":function($event){_vm.updateImg(img, i)}}},[_c('v-img',{attrs:{"src":img}},[_c('v-layout',{attrs:{"slot":"placeholder","align-center":"","justify-center":""},slot:"placeholder"},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)],1)],1)}}])})],1)}),1):_c('v-progress-circular',{attrs:{"indeterminate":"","color":"primary"}})],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","md10":""}},[_c('v-card',[_c('v-card-text',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('screenSide')))]),_vm._v(" "),_c('v-radio-group',{model:{value:(_vm.side),callback:function ($$v) {_vm.side=$$v},expression:"side"}},[_c('v-radio',{attrs:{"label":"Côté gauche","color":"primary","value":"LEFT"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Côté droit","color":"primary","value":"RIGHT"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-card',[_c('v-card-text',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("alarm")]),_vm._v(" "+_vm._s(_vm.$t('delaiTiretteC2C')))],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-flex',[_c('v-slider',{attrs:{"min":0,"max":300},model:{value:(_vm.timeout),callback:function ($$v) {_vm.timeout=$$v},expression:"timeout"}})],1),_vm._v(" "),_c('v-flex',[_c('v-subheader',[_vm._v(_vm._s(_vm.timeout)+" sec.")])],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("schedule")]),_vm._v(" \n            "+_vm._s(_vm.$t('restrictAff'))+"\n            "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.openDialog(
                {
                  title: 'Visualiser et activer le Meeting',
                  content: 'Les horaires ci-paramétrés régissent la visualisation de la tirette (Click To Action). En dehors des heures éligibles, la tirette ne sera pas visible. Les règles d\'affichage du widget (1ère section à gauche) n\'influencent pas la tirette.'
                }
              )}}},[_c('template',{slot:"activator"},[_c('v-icon',{staticClass:"infos",attrs:{"color":"grey lighten-1","dark":""}},[_vm._v("info")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('enSavoirPlus')))])],2)],1),_vm._v(" "),_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("displayTimes"))))]),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","sm12":"","md6":""}},[_c('v-radio-group',{attrs:{"hint":_vm.$t('defineWidgetHours'),"persistent-hint":""},model:{value:(_vm.form.hours),callback:function ($$v) {_vm.$set(_vm.form, "hours", $$v)},expression:"form.hours"}},[_c('v-radio',{attrs:{"label":_vm._f("cap")(_vm.$t('allTheTime')),"color":"primary","value":"all"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":_vm._f("cap")(_vm.$t('customHours')),"color":"primary","value":"defined"}})],1)],1)],1),_vm._v(" "),(_vm.form.hours == 'defined')?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-btn',{staticClass:"primary--text",attrs:{"flat":""},on:{"click":function($event){_vm.openHours()}}},[_vm._v(_vm._s(_vm.$t('timesSeveralDays'))),_c('v-icon',{attrs:{"right":""}},[_vm._v("event")])],1)],1),_vm._v(" "),_c('v-expansion-panel',_vm._l((_vm.form.days),function(day){return _c('v-expansion-panel-content',{key:day.name},[_c('v-layout',{attrs:{"slot":"header","align-center":"","row":"","spacer":""},slot:"header"},[_c('v-flex',{attrs:{"xs12":""}},[_c('span',{staticClass:"hidden-md-and-up"},[_vm._v(_vm._s(day.name.substring(0, 3))+". : ")]),_vm._v(" "),_c('span',{staticClass:"hidden-sm-and-down"},[_vm._v(_vm._s(day.name)+" : ")]),_vm._v(" "),(day.am.active || day.pm.active)?_c('span',[(day.am.active)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('from'))),_c('code',[_vm._v(_vm._s(day.am.start))]),_vm._v(" "+_vm._s(_vm.$t('to'))+" "),_c('code',[_vm._v(_vm._s(day.am.end))])]):_vm._e(),_vm._v(" "),(day.am.active && day.pm.active)?_c('span',[_vm._v(" "+_vm._s(_vm.$t('and')))]):_vm._e(),_vm._v(" "),(day.pm.active)?_c('span',[_vm._v(_vm._s(_vm.$t('from'))+" "),_c('code',[_vm._v(_vm._s(day.pm.start))]),_vm._v(" "+_vm._s(_vm.$t('to'))+" "),_c('code',[_vm._v(_vm._s(day.pm.end))])]):_vm._e()]):_c('span',[_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("disabledToday"))))])])])],1),_vm._v(" "),_c('v-card',{staticClass:"grey lighten-3"},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('activateMorning')),"light":"","color":"primary"},model:{value:(day.am.active),callback:function ($$v) {_vm.$set(day.am, "active", $$v)},expression:"day.am.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('from') + " " + (day.name) + " " + _vm.$t('morning'),"prepend-icon":"access_time","disabled":!day.am.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'am', 'start')}},slot:"activator",model:{value:(day.am.start),callback:function ($$v) {_vm.$set(day.am, "start", $$v)},expression:"day.am.start"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('to') + " " + (day.name) + " " + _vm.$t('morning'),"prepend-icon":"access_time","disabled":!day.am.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'am', 'end')}},slot:"activator",model:{value:(day.am.end),callback:function ($$v) {_vm.$set(day.am, "end", $$v)},expression:"day.am.end"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('activateAfternoon')),"light":"","color":"primary"},model:{value:(day.pm.active),callback:function ($$v) {_vm.$set(day.pm, "active", $$v)},expression:"day.pm.active"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('from') + " " + (day.name) + " " + _vm.$t('afternoon'),"prepend-icon":"access_time","disabled":!day.pm.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'pm', 'start')}},slot:"activator",model:{value:(day.pm.start),callback:function ($$v) {_vm.$set(day.pm, "start", $$v)},expression:"day.pm.start"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm6":"","md2":""}},[_c('v-text-field',{attrs:{"slot":"activator","label":_vm.$t('to') + " " + (day.name) + " " + _vm.$t('afternoon'),"prepend-icon":"access_time","disabled":!day.pm.active,"readonly":""},on:{"click":function($event){_vm.openTimePicker(day, 'pm', 'end')}},slot:"activator",model:{value:(day.pm.end),callback:function ($$v) {_vm.$set(day.pm, "end", $$v)},expression:"day.pm.end"}})],1)],1)],1)],1)],1)}),1)],1):_vm._e()],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("language")]),_vm._v("\n              "+_vm._s(_vm._f("cap")(_vm.$t('urlDisplay')))+"\n              "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.openDialog(
                  {
                    title: 'Visualiser et activer le Meeting',
                    content: 'Les listes ci-paramétrées régissent la visualisation de la tirette (Click To Action). En dehors des pages éligibles, la tirette ne sera pas visible. Les règles d\'affichage du widget (1ère section à gauche) n\'influencent pas la tirette.'
                  }
                )}}},[_c('template',{slot:"activator"},[_c('v-icon',{staticClass:"infos",attrs:{"color":"grey lighten-1","dark":""}},[_vm._v("info")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('enSavoirPlus')))])],2)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('v-card',{staticClass:"mb-3"},[_c('v-card-text',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('urlDisplay'))))]),_vm._v(" "),_c('v-layout',[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-radio-group',{attrs:{"hint":_vm.$t('chooseWhiteOrBlackC2C'),"persistent-hint":""},model:{value:(_vm.form.urls),callback:function ($$v) {_vm.$set(_vm.form, "urls", $$v)},expression:"form.urls"}},[_c('v-radio',{attrs:{"label":_vm._f("cap")(_vm.$t('everywhere')),"color":"primary","value":"all"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"White List","color":"primary","value":"showOnOff"}}),_vm._v(" "),_c('v-radio',{attrs:{"label":"Black List","color":"primary","value":"hideOnOff"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.urls != 'all'),expression:"form.urls != 'all'"}],attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',[_c('v-fab-transition',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.form.urls != 'all'),expression:"form.urls != 'all'"}],staticClass:"secondary",attrs:{"dark":"","absolute":"","top":"","right":"","fab":""},on:{"click":function($event){$event.stopPropagation();_vm.openRule()}}},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-data-table',{attrs:{"headers":_vm.headersRules,"items":_vm.form.rules,"no-data-text":_vm.$t('noRules'),"hide-actions":""},scopedSlots:_vm._u([{key:"items",fn:function(props){return [(props.item.list === _vm.form.urls)?_c('td',[_c('v-edit-dialog',{attrs:{"return-value":props.item.type,"cancel-text":_vm.$t('cancel'),"save-text":_vm.$t('submit'),"large":""},on:{"update:returnValue":function($event){_vm.$set(props.item, "type", $event)}}},[_c('div',[_vm._v(_vm._s(props.item.type.text))]),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v(_vm._s(_vm.$t('changeType')))]),_vm._v(" "),_c('v-select',{attrs:{"slot":"input","items":_vm.typeRules,"return-object":"","autofocus":""},slot:"input",model:{value:(props.item.type),callback:function ($$v) {_vm.$set(props.item, "type", $$v)},expression:"props.item.type"}})],1)],1):_vm._e(),_vm._v(" "),(props.item.list === _vm.form.urls)?_c('td',[_c('v-edit-dialog',{attrs:{"cancel-text":_vm.$t('cancel'),"save-text":_vm.$t('submit'),"return-value":props.item.content,"large":"","lazy":""},on:{"update:returnValue":function($event){_vm.$set(props.item, "content", $event)}}},[_c('div',[_c('code',[_vm._v(_vm._s(props.item.content))])]),_vm._v(" "),_c('div',{staticClass:"mt-3 title",attrs:{"slot":"input"},slot:"input"},[_vm._v(_vm._s(_vm.$t('editContent')))]),_vm._v(" "),_c('v-text-field',{attrs:{"slot":"input","label":"Modification","single-line":"","counter":"","autofocus":""},slot:"input",model:{value:(props.item.content),callback:function ($$v) {_vm.$set(props.item, "content", $$v)},expression:"props.item.content"}})],1)],1):_vm._e(),_vm._v(" "),(props.item.list === _vm.form.urls)?_c('td',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"icon":"","flat":""},on:{"click":function($event){$event.stopPropagation();_vm.deleteRule(props.index)}}},[_c('v-icon',[_vm._v("delete")])],1)],1):_vm._e()]}}])})],1)],1)],1)],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{staticClass:"mr-2 primary--text"},[_vm._v("app_blocking")]),_vm._v("\n              Restrictions mobiles\n              "),_c('v-tooltip',{attrs:{"left":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.openDialog(
                  {
                    title: 'Visualiser et activer le Meeting',
                    content: 'Masquer sur mobile indépendamment des règles horaires et de blacklist'
                  }
                )}}},[_c('template',{slot:"activator"},[_c('v-icon',{staticClass:"infos",attrs:{"color":"grey lighten-1","dark":""}},[_vm._v("info")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('enSavoirPlus')))])],2)],1),_vm._v(" "),_c('v-card',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":_vm._f("cap")(_vm.$t('hideOnMobile')),"light":"","color":"primary"},model:{value:(_vm.hiddenMobile),callback:function ($$v) {_vm.hiddenMobile=$$v},expression:"hiddenMobile"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","block":_vm.$vuetify.breakpoint.xsOnly,"loading":_vm.loadingPost,"disabled":_vm.alert},nativeOn:{"click":function($event){_vm.postOptions()}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('save')))),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("save")])],1)],1),_vm._v(" "),_c('wz-dialog-infos',{attrs:{"titleDialog":_vm.titleDialog,"contentDialog":_vm.contentDialog},on:{"fermeDialog":_vm.fermeDialogInfos}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","lazy":"","max-width":"290"},model:{value:(_vm.showTp),callback:function ($$v) {_vm.showTp=$$v},expression:"showTp"}},[_c('v-time-picker',{attrs:{"actions":"","scrollable":"","format":"24hr","max":_vm.allowed.hours.max,"min":_vm.allowed.hours.min,"color":"primary"},model:{value:(_vm.daySelected[_vm.amOrPm][_vm.startOrEnd]),callback:function ($$v) {_vm.$set(_vm.daySelected[_vm.amOrPm], _vm.startOrEnd, $$v)},expression:"daySelected[amOrPm][startOrEnd]"}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showTp = false; _vm.daySelected[_vm.amOrPm][_vm.startOrEnd] = _vm.tmpHours}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('cancel'))))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary"},on:{"click":function($event){_vm.showTp = false}}},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('submit'))))])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","width":"350px"},model:{value:(_vm.showHours),callback:function ($$v) {_vm.showHours=$$v},expression:"showHours"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('applySchedules'))))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"400px"}},[_c('v-select',{attrs:{"items":_vm.days,"label":_vm.$t('applyHours'),"return-object":""},model:{value:(_vm.dayHours),callback:function ($$v) {_vm.dayHours=$$v},expression:"dayHours"}}),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headersDays,"items":_vm.days,"item-key":"text","select-all":"primary","hide-actions":"","total-items":7},scopedSlots:_vm._u([{key:"headerCell",fn:function(props){return [_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(props.header.text))])]}},{key:"items",fn:function(props){return [_c('td',[_c('v-checkbox',{staticClass:"primary--text",attrs:{"hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.text))])]}}]),model:{value:(_vm.daysTmp),callback:function ($$v) {_vm.daysTmp=$$v},expression:"daysTmp"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showHours = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.daysTmp.length,"color":"primary","flat":""},on:{"click":function($event){_vm.submitHours()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.showDialogRule),callback:function ($$v) {_vm.showDialogRule=$$v},expression:"showDialogRule"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t("createRule"))))]),_vm._v(" "),_c('v-card-text',[_c('form',[_c('v-select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"items":_vm.typeRules,"label":_vm.$t('ruleType'),"return-object":"","required":"","data-vv-name":"select","error":_vm.wzErrors.has('select'),"error-messages":_vm.wzErrors.collect('select')},model:{value:(_vm.ruleTmp.type),callback:function ($$v) {_vm.$set(_vm.ruleTmp, "type", $$v)},expression:"ruleTmp.type"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"autofocus":"","label":_vm.$t('ruleContent'),"required":"","data-vv-name":"ruleContentInput","error":_vm.wzErrors.has('ruleContentInput'),"error-messages":_vm.wzErrors.collect('ruleContentInput')},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.submitRule()}},model:{value:(_vm.ruleTmp.content),callback:function ($$v) {_vm.$set(_vm.ruleTmp, "content", $$v)},expression:"ruleTmp.content"}})],1)]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showDialogRule = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.wzErrors.any(),"flat":""},on:{"click":function($event){_vm.submitRule()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.displayWarningVyte),callback:function ($$v) {_vm.displayWarningVyte=$$v},expression:"displayWarningVyte"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('warning')))]),_vm._v(" "),_c('v-card-text',[_vm._v("\n            "+_vm._s(_vm.$t('vyteDesc'))+"\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"primary--text",attrs:{"block":"","flat":""},on:{"click":function($event){_vm.goToConnector()}}},[_vm._v("\n              "+_vm._s(_vm.$t('paramConnecteur'))+"\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("refresh")])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.displayWarningCalendar),callback:function ($$v) {_vm.displayWarningCalendar=$$v},expression:"displayWarningCalendar"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('warning')))]),_vm._v(" "),_c('v-card-text',[_vm._v("\n            "+_vm._s(_vm.$t('googleAgendaDesc'))+"\n          ")]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"primary--text",attrs:{"block":"","flat":""},on:{"click":function($event){_vm.goToConnector()}}},[_vm._v("\n              "+_vm._s(_vm.$t('paramConnecteur'))+"\n              "),_c('v-icon',{attrs:{"right":""}},[_vm._v("refresh")])],1)],1)],1)],1)],1),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":6},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)}
var Recall_staticRenderFns = []
var Recall_esExports = { render: Recall_render, staticRenderFns: Recall_staticRenderFns }
/* harmony default export */ var settings_Recall = (Recall_esExports);
// CONCATENATED MODULE: ./src/components/settings/Recall.vue
function Recall_injectStyle (ssrContext) {
  __webpack_require__("i/pa")
}
var Recall_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Recall___vue_template_functional__ = false
/* styles */
var Recall___vue_styles__ = Recall_injectStyle
/* scopeId */
var Recall___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Recall___vue_module_identifier__ = null
var Recall_Component = Recall_normalizeComponent(
  Recall,
  settings_Recall,
  Recall___vue_template_functional__,
  Recall___vue_styles__,
  Recall___vue_scopeId__,
  Recall___vue_module_identifier__
)

/* harmony default export */ var components_settings_Recall = (Recall_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27e2611c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Target.vue
var Target_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"target"},[_c('transition',{attrs:{"name":"slide-x-reverse-transition","mode":"out-in"}},[_c('router-view')],1)],1)}
var Target_staticRenderFns = []
var Target_esExports = { render: Target_render, staticRenderFns: Target_staticRenderFns }
/* harmony default export */ var Target = (Target_esExports);
// CONCATENATED MODULE: ./src/components/Target.vue
var Target_normalizeComponent = __webpack_require__("VU/8")
/* script */
var Target___vue_script__ = null
/* template */

/* template functional */
var Target___vue_template_functional__ = false
/* styles */
var Target___vue_styles__ = null
/* scopeId */
var Target___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Target___vue_module_identifier__ = null
var Target_Component = Target_normalizeComponent(
  Target___vue_script__,
  Target,
  Target___vue_template_functional__,
  Target___vue_styles__,
  Target___vue_scopeId__,
  Target___vue_module_identifier__
)

/* harmony default export */ var components_Target = (Target_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/filters/Filters.vue






/* harmony default export */ var Filters = ({
  data: function data() {
    return {
      alert: false,

      loading: false,

      showDialogCreate: false,

      newFilterDialog: { activated: '1', allAgents: '0', multiUser: 'me' },

      overMenu: false,

      filters: [],
      siteKey: '',
      agent: {},
      resAjx: null,
      priotit: [{ text: '1', value: '1' }, { text: '2', value: '2' }, { text: '3', value: '3' }, { text: '4', value: '4' }, { text: '5', value: '5' }, { text: '6', value: '6' }, { text: '7', value: '7' }, { text: '8', value: '8' }, { text: '9', value: '9' }, { text: '10', value: '10' }],
      yesno: [{ text: this.$t('yes'), value: '1' }, { text: this.$t('no'), value: '0' }],
      multiUser: [{ text: this.$t('onlyMe'), value: 'me' }, { text: this.$t('allAgents'), value: 'all' }],
      behaviour: [{ text: this.$t('sendInvit'), value: 'invitation' }, { text: this.$t('sendPush'), value: 'push', disabled: this.$store.state._User.entLevel !== '7' }],

      dialogImport: false,
      agentSource: {},
      agentDest: {},
      loadingImport: false,
      dialogProgress: false
    };
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_User', ['user']), {
    activeFilters: function activeFilters() {
      return lodash_default.a.filter(this.filters, function (f) {
        return f.active === '1';
      }).length;
    }
  }),
  mounted: function mounted() {
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
    if (this.$store.state._User.entLevel === '5') {
      this.alert = true;
    }
  },
  created: function created() {
    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'target_filters';
    }
  },

  methods: {
    init: function init() {
      var _this = this;

      this.loading = true;
      this.resAjx = null;
      this.filters = [];
      var dataToPost = new window.FormData();
      dataToPost.append('forceSite', this.$store.state._Sites.siteSelected.LIC_ID);
      dataToPost.append('forceAgent', this.agent.USR_ID);
      this.axios.post('get/filters.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this.resAjx = response.data;
      }).then(function (_) {
        _this.loading = false;
        _this.initFilters();
      }).catch();
    },
    openDialogActivate: function openDialogActivate(_id, _activate, _name) {
      var _this2 = this;

      var _activation = 0;
      var _justdoit = false;
      console.log('ac' + _justdoit);
      if (_activate === '1') {
        _justdoit = confirm(this.$t('scenarioSuspend') + ' ' + _name + ' ' + this.$t('forAllAgents'));
        _activation = 0;
      } else if (_activate === '0') {
        _justdoit = confirm(this.$t('scenarioActivate') + ' ' + _name + ' ' + this.$t('forAllAgents'));
        _activation = 1;
      }
      if (_justdoit) {
        console.log('dc' + _justdoit);

        var dataToPost = new window.FormData();
        dataToPost.append('filId', _id);
        dataToPost.append('active', _activation);
        this.axios.post('put/activfilter.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
          _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('modifSuccess'), context: 'success' });
        }).catch(function (_) {
          _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('modifFailure'), context: 'error' });
        }).then(function (_) {
          _this2.init();
        });
      }
    },
    openDialogCopy: function openDialogCopy(_id, _name) {
      var _this3 = this;

      if (confirm(this.$t('scenarioDuplic') + ' ' + _name)) {
        var dataToPost = new window.FormData();
        dataToPost.append('filId', _id);
        this.axios.post('post/duplicfilter.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
          _this3.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this3.$t('duplicateSuccess'), context: 'success' });
        }).catch(function (_) {
          _this3.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this3.$t('duplicateFailure'), context: 'error' });
        }).then(function (_) {
          _this3.init();
        });
      }
    },
    openDialogDelete: function openDialogDelete(_id, _name, _agent) {
      var _this4 = this;

      if (confirm(this.$t('scenarioSuppr') + ' ' + _name + ' ' + this.$t('forCurrentAgents'))) {
        var dataToPost = new window.FormData();
        dataToPost.append('filId', _id);
        dataToPost.append('agent', _agent);
        this.axios.post('delete/filter.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
          _this4.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this4.$t('deleteSuccess'), context: 'success' });
        }).catch(function (_) {
          _this4.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this4.$t('deleteFailure'), context: 'error' });
        }).then(function (_) {
          _this4.init();
        });
      }
    },
    openDialogShare: function openDialogShare(_id, _name) {
      var _this5 = this;

      if (confirm(this.$t('scenarioShare') + ' ' + _name + ' ' + this.$t('withAll'))) {
        var dataToPost = new window.FormData();
        dataToPost.append('filId', _id);
        this.axios.post('post/sharefilter.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
          _this5.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this5.$t('modifSuccess'), context: 'success' });
        }).catch(function (_) {
          _this5.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this5.$t('error'), context: 'error' });
        }).then(function (_) {
          _this5.init();
        });
      }
    },
    initFilters: function initFilters() {
      for (var n in this.resAjx) {
        var _behav = '';
        if (this.resAjx[n].push === '1') {
          _behav = 'push';
        } else if (this.resAjx[n].invitation === '1') {
          _behav = 'invitation';
        }

        this.filters.push({ id: this.resAjx[n].id,
          name: this.resAjx[n].name,
          user_id: this.resAjx[n].user_id,
          lickey: this.resAjx[n].lickey,
          comment: this.resAjx[n].comment,
          appear: this.resAjx[n].appear,
          notification: this.resAjx[n].notification,
          push: this.resAjx[n].push,
          pushId: this.resAjx[n].pushId,
          invitation: this.resAjx[n].invitation,
          invitationMsg: this.resAjx[n].invitationMsg,
          active: this.resAjx[n].active,
          usage: this.resAjx[n].usage,
          responseRate: this.resAjx[n].responseRate,
          level: this.resAjx[n].level,
          family: this.resAjx[n].family,
          called: this.resAjx[n].called,
          success: this.resAjx[n].success,
          creationTs: this.resAjx[n].creationTs,
          multiUser: this.resAjx[n].multiUser,
          constraints: this.resAjx[n].constraints,
          behaviour: _behav
        });
        this.siteKey = this.resAjx[n].lickey;
      }
    },
    openDialogCreate: function openDialogCreate() {
      this.showDialogCreate = true;
    },
    submitDialogCreate: function submitDialogCreate() {
      var _this6 = this;

      this.showDialogCreate = false;

      var dataToPost = new window.FormData();
      dataToPost.append('agent_id', this.agent.USR_ID);
      dataToPost.append('newfilter', stringify_default()(this.newFilterDialog));
      dataToPost.append('siteKey', this.$store.state._Sites.siteSelected.LIC_KEY);
      this.axios.post('post/newfilter.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this6.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this6.$t('creationSuccess'), context: 'success' });
        _this6.showFilter(response.data.id);
      }).catch(function (_) {
        _this6.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this6.$t('creationFailure'), context: 'error' });
      });
    },
    showFilter: function showFilter(_id) {
      if (!this.overMenu) {
        this.$router.push({ path: '/target/filters/' + _id });
      }
    },
    openDialogImport: function openDialogImport() {
      this.dialogImport = true;
    },
    submitDialogImport: function submitDialogImport() {
      var _this7 = this;

      if (this.agentSource.USR_ID === this.agentDest.USR_ID) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('error') + ' : ' + this.$t('sameAgents'),
          context: 'error'
        });
        return;
      }
      var params = new window.FormData();
      params.append('src', this.agentSource.USR_ID);
      params.append('dest', this.agentDest.USR_ID);
      this.loadingImport = true;
      this.axios.post('post/import_filters.php', params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (res) {
        _this7.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this7.$t('importSuccess'),
          context: 'success'
        });
        _this7.init();
      }).catch(function () {
        _this7.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this7.$t('importFailure'),
          context: 'error'
        });
      }).then(function () {
        _this7.loadingImport = false;
        _this7.dialogImport = false;
      });
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    }
  },

  watch: {
    'agent': function agent(val, oldVal) {
      this.init();
    },
    '$store.state._Sites.siteSelected': function $storeState_SitesSiteSelected(val, oldVal) {
      this.init();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-560a9733","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/filters/Filters.vue
var Filters_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.alert),expression:"alert"}],attrs:{"color":"secondary","icon":"warning","value":"true","outline":""}},[_vm._v("\n      Attention, le ciblage comportemental n'est pas accessibles pour ce niveau de licence. Vous ne pourrez pas sauvegarder.\n    ")]),_vm._v(" "),_c('v-container',{attrs:{"grid-list-lg":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('wz-select-one-site')],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('wz-select-one-agent',{attrs:{"agent":_vm.agent},on:{"update:agent":function($event){_vm.agent=$event}}})],1)],1)],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):(!_vm.loading && _vm.filters.length)?_c('div',{staticClass:"mb-5"},[_c('v-btn',{attrs:{"flat":"","color":"primary","block":_vm.$vuetify.breakpoint.smAndDown},on:{"click":function($event){_vm.openDialogImport()}}},[_vm._v("\n        "+_vm._s(_vm.$t('importFiltersFromAgent'))+"\n        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("get_app")])],1),_vm._v(" "),_c('v-card',[_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeFilters == 0),expression:"activeFilters == 0"}],attrs:{"color":"secondary","icon":"warning","value":"true","outline":""}},[_vm._v("\n          "+_vm._s(_vm.$t('warnNoFilter'))+" "),_c('code',[_vm._v(_vm._s(_vm.agent.USR_FIRST_NAME)+" "+_vm._s(_vm.agent.USR_LAST_NAME))]),_vm._v("\n          "+_vm._s(_vm.$t('warnOnSite'))+" "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))])]),_vm._v(" "),_c('v-list',{attrs:{"dense":"","two-line":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$tc('activeFilters', _vm.activeFilters, { count: _vm.activeFilters }) + ' ' + _vm.$t('outOf') + ' ' + _vm.filters.length))]),_vm._v(" "),_vm._l((_vm.filters),function(filtre){return _c('v-list-tile',{key:filtre.id,attrs:{"avatar":""},on:{"click":function($event){_vm.showFilter(filtre.id)}}},[_c('v-list-tile-action',[_c('v-tooltip',{attrs:{"right":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"icon"},on:{"click":function($event){_vm.openDialogActivate(filtre.id, filtre.active, filtre.name)}},nativeOn:{"mouseover":function($event){_vm.overMenu = true},"mouseleave":function($event){_vm.overMenu = false}},slot:"activator"},[(filtre.active == 1)?_c('v-icon',{staticClass:"primary--text",attrs:{"medium":""}},[_vm._v("play_circle_filled")]):_c('v-icon',{staticClass:"grey--text text--lighten-1",attrs:{"medium":""}},[_vm._v("pause_circle_filled")])],1),_vm._v(" "),(filtre.active == 1)?_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('disable')))+" scenario")]):_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('enable')))+" scenario")])],1)],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(filtre.name))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(filtre.comment))]),_vm._v(" "),_c('v-list-tile-sub-title',[(filtre.multiUser > 1)?_c('span',{staticClass:"grey--text text--darken-2"},[_vm._v(_vm._s(_vm.$t('shared')))]):_c('span',{staticClass:"grey--text text--darken-2"},[_vm._v(_vm._s(_vm.$t('onlyMe')))]),_vm._v(" —\n                "+_vm._s(_vm.$t('triggered') + ' ' + _vm.$tc('times', filtre.called, { count: filtre.called }))+" /\n                "+_vm._s(_vm.$tc('responses', filtre.success, { count: filtre.success }))+"\n              ")])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"icon"},nativeOn:{"mouseover":function($event){_vm.overMenu = true},"mouseleave":function($event){_vm.overMenu = false}},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.openDialogActivate(filtre.id, filtre.active, filtre.name)}}},[_c('v-list-tile-action',[(filtre.active == 1)?_c('v-icon',[_vm._v("pause_circle_filled")]):_c('v-icon',[_vm._v("play_circle_filled")])],1),_vm._v(" "),_c('v-list-tile-content',[(filtre.active == 1)?_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('disable')))+" scenario")]):_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('enable')))+" scenario")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.showFilter(filtre.id)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('edit')))+" scenario")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.openDialogCopy(filtre.id, filtre.name)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("content_copy")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('duplicate')))+" scenario")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.openDialogDelete(filtre.id, filtre.name,_vm.agent.USR_ID)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('delete')))+" scenario")])],1)],1),_vm._v(" "),(filtre.multiUser < 2)?_c('v-list-tile',{on:{"click":function($event){_vm.openDialogShare(filtre.id, filtre.name)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("share")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('share')))+" scenario")])],1)],1):_vm._e()],1)],1)],1)],1)})],2)],1)],1):_c('v-card',[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-img',{attrs:{"src":"https://www.gstatic.com/mobilesdk/170418_mobilesdk/zeroState/2x/performance.png","height":"125px","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('filtres', 0))))]),_vm._v(" "),_c('div',[_vm._v("\n                "+_vm._s(_vm._f("cap")(_vm.$tc('filtres', 0) + ' ' + _vm.$t('forTheAgent')))+" "),_c('code',[_vm._v(_vm._s(_vm.agent.USR_FIRST_NAME)+" "+_vm._s(_vm.agent.USR_LAST_NAME))]),_vm._v("\n                "+_vm._s(_vm.$t('forTheSite'))+" "),_c('code',[_vm._v(_vm._s(_vm.$store.state._Sites.siteSelected.LIC_URL))])]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary","block":_vm.$vuetify.breakpoint.smAndDown},on:{"click":function($event){_vm.openDialogImport()}}},[_vm._v("\n                "+_vm._s(_vm.$t('importFiltersFromAgent'))+"\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("get_app")])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-fab-transition',[(!_vm.alert)?_c('v-btn',{attrs:{"dark":"","color":"secondary","fab":"","fixed":"","bottom":"","right":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.openDialogCreate($event)}}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.showDialogCreate),callback:function ($$v) {_vm.showDialogCreate=$$v},expression:"showDialogCreate"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm.$t('addScenario')))]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('max:32'),expression:"'max:32'"}],attrs:{"autofocus":"","required":"","label":_vm.$t('scenarioName'),"counter":"","max":"32","data-vv-name":"newSiteName"},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogCreate($event)}},model:{value:(_vm.newFilterDialog.name),callback:function ($$v) {_vm.$set(_vm.newFilterDialog, "name", $$v)},expression:"newFilterDialog.name"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('max:255'),expression:"'max:255'"}],attrs:{"autofocus":"","label":_vm.$t('scenarioComment'),"counter":"","max":"255","data-vv-name":"newSiteUrl"},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogCreate($event)}},model:{value:(_vm.newFilterDialog.comment),callback:function ($$v) {_vm.$set(_vm.newFilterDialog, "comment", $$v)},expression:"newFilterDialog.comment"}}),_vm._v(" "),_c('v-select',{attrs:{"label":_vm.$t('scenarioActivate'),"items":_vm.yesno},model:{value:(_vm.newFilterDialog.activated),callback:function ($$v) {_vm.$set(_vm.newFilterDialog, "activated", $$v)},expression:"newFilterDialog.activated"}}),_vm._v(" "),_c('v-select',{attrs:{"label":_vm.$t('scenarioAttributed'),"items":_vm.multiUser},model:{value:(_vm.newFilterDialog.multiUser),callback:function ($$v) {_vm.$set(_vm.newFilterDialog, "multiUser", $$v)},expression:"newFilterDialog.multiUser"}}),_vm._v(" "),_c('v-select',{attrs:{"label":_vm.$t('scenarioPriority'),"items":_vm.priotit},model:{value:(_vm.newFilterDialog.level),callback:function ($$v) {_vm.$set(_vm.newFilterDialog, "level", $$v)},expression:"newFilterDialog.level"}}),_vm._v(" "),_c('v-select',{attrs:{"label":_vm.$t('behaviour'),"items":_vm.behaviour},model:{value:(_vm.newFilterDialog.behaviour),callback:function ($$v) {_vm.$set(_vm.newFilterDialog, "behaviour", $$v)},expression:"newFilterDialog.behaviour"}}),_vm._v(" "),_c('small',[_vm._v("*"+_vm._s(_vm.$t('triggersNextStep')))])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.showDialogCreate = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){return _vm.submitDialogCreate($event)}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialogImport),callback:function ($$v) {_vm.dialogImport=$$v},expression:"dialogImport"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm.$t('importFiltersFromAgent')))]),_vm._v(" "),_c('v-card-text',[_c('wz-select-one-agent',{attrs:{"agent":_vm.agentSource,"hint":_vm.$t('agentSourceInfos')},on:{"update:agent":function($event){_vm.agentSource=$event}}}),_vm._v(" "),_c('v-icon',[_vm._v("arrow_downward")]),_vm._v(" "),_c('wz-select-one-agent',{attrs:{"agent":_vm.agentDest,"hint":_vm.$t('agentDestInfos')},on:{"update:agent":function($event){_vm.agentDest=$event}}}),_vm._v(" "),_c('v-alert',{attrs:{"icon":"warning","color":"secondary","value":true,"outline":""}},[_vm._v(_vm._s(_vm.$t('infosImportFiltersFromAgent')))])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","loading":_vm.loadingImport},on:{"click":function($event){_vm.dialogImport = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),(_vm.agent)?_c('v-btn',{attrs:{"color":"primary","loading":_vm.loadingImport},on:{"click":_vm.submitDialogImport}},[_vm._v(_vm._s(_vm.$t('submit')))]):_vm._e()],1)],1)],1),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":14},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)}
var Filters_staticRenderFns = []
var Filters_esExports = { render: Filters_render, staticRenderFns: Filters_staticRenderFns }
/* harmony default export */ var filters_Filters = (Filters_esExports);
// CONCATENATED MODULE: ./src/components/filters/Filters.vue
var Filters_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Filters___vue_template_functional__ = false
/* styles */
var Filters___vue_styles__ = null
/* scopeId */
var Filters___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Filters___vue_module_identifier__ = null
var Filters_Component = Filters_normalizeComponent(
  Filters,
  filters_Filters,
  Filters___vue_template_functional__,
  Filters___vue_styles__,
  Filters___vue_scopeId__,
  Filters___vue_module_identifier__
)

/* harmony default export */ var components_filters_Filters = (Filters_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/filters/Filter.vue







/* harmony default export */ var Filter = ({
  props: ['id'],
  data: function data() {
    return {
      loading: false,

      showDialogCreate: false,
      showDialogEdit: false,
      showDialogSupp: false,
      declencheurSelected: false,

      newConstraintDialog: {
        id: 1,
        family: 'browse',
        type: 'pageduration',
        condition: 'greater',
        value: '120',
        trigger: ''
      },
      editConstraintDialog: {
        family: 'browse',
        type: 'pageduration',
        condition: 'greater',
        value: '120',
        trigger: ''
      },

      constraints: [],
      filter: {
        id: '',
        name: '',
        user_id: '',
        lickey: '',
        comment: '',
        appear: '',
        notification: '',
        push: '',
        pushId: '',
        invitation: '',
        invitationMsg: '',
        bot: '',
        botMotif: '',
        c2c: '',
        active: '',
        usage: '',
        responseRate: '',
        level: '',
        family: '',
        called: '',
        success: '',
        creationTs: '',
        multiUser: '',
        constraints: '',
        behaviour: ''
      },
      overMenu: false,
      resAjx: null,
      resAjxFam: null,
      resAjxPush: null,

      priotit: [{ text: '1', value: '1' }, { text: '2', value: '2' }, { text: '3', value: '3' }, { text: '4', value: '4' }, { text: '5', value: '5' }, { text: '6', value: '6' }, { text: '7', value: '7' }, { text: '8', value: '8' }, { text: '9', value: '9' }, { text: '10', value: '10' }],
      heure: [{ text: '0h', value: '0' }, { text: '1h', value: '3600' }, { text: '2h', value: '7200' }, { text: '3h', value: '10800' }, { text: '4h', value: '14400' }, { text: '5h', value: '18000' }, { text: '6h', value: '21600' }, { text: '7h', value: '25200' }, { text: '8h', value: '28800' }, { text: '9h', value: '32400' }, { text: '10h', value: '36000' }, { text: '11h', value: '39600' }, { text: '12h', value: '43200' }, { text: '13h', value: '46800' }, { text: '14h', value: '50400' }, { text: '15h', value: '54000' }, { text: '16h', value: '57600' }, { text: '17h', value: '61200' }, { text: '18h', value: '64800' }, { text: '19h', value: '68400' }, { text: '20h', value: '72000' }, { text: '21h', value: '75600' }, { text: '22h', value: '79200' }, { text: '23h', value: '82800' }],
      days: [{ text: 'Monday', value: '1' }, { text: 'Tuesday', value: '2' }, { text: 'Wednesday', value: '3' }, { text: 'Thrusday', value: '4' }, { text: 'Friday', value: '5' }, { text: 'Saturday', value: '6' }, { text: 'Sunday', value: '7' }],
      activ: [{ text: this.$t('active'), value: '1' }, { text: this.$t('unactive'), value: '0' }],
      multiUser: [{ text: this.$t('onlyMe'), value: 'me' }, { text: this.$t('allAgents'), value: 'all' }],
      behaviour: [{ text: lodash_default.a.upperFirst(this.$t('none')), value: '' }, { text: this.$t('sendInvit'), value: 'invitation' }, { text: this.$t('sendPush'), value: 'push', disabled: this.$store.state._User.entLevel !== '7' }, { text: this.$t('sendC2C'), value: 'c2c', disabled: this.$store.state._Sites.siteSelected.LIC_CALLBACK_ACTIVATED === '0' }, { text: this.$t('sendBot'), value: 'bot', disabled: this.$store.state._Sites.siteSelected.LIC_BOT_ACTIVATED === '0' }, { text: this.$t('sendMeeting'), value: 'tirette_r', disabled: this.$store.state._Sites.siteSelected.LIC_RECALL_ACTIVATED === '0' }, { text: this.$t('sendTiretteC2C'), value: 'tirette_c', disabled: this.$store.state._Sites.siteSelected.LIC_CALLBACK_ACTIVATED === '0' }],
      const_family: [{ text: this.$t('browsing'), value: 'browse' }, { text: 'GetQuanty', value: 'getplus' }],
      const_type: [{ text: this.$t('constDuration'), value: 'time' }, { text: this.$t('constNbPageSession'), value: 'nbpagesession' }, { text: this.$t('constNbPage'), value: 'nbpagetoday' }, { text: this.$t('constWeek'), value: 'nbpageweek' }, { text: this.$t('constMonth'), value: 'nbpagemonth' }, { text: 'Nb de pages visitées hier', value: 'nbpageyesterday' }, { text: this.$t('constSamePage'), value: 'nbpageload' }, { text: this.$t('constDiffPage'), value: 'nbpagediff' }, { text: this.$t('constHisto'), value: 'pageurl' }, { text: this.$t('constHistoAndNum'), value: 'pageurlnb' }, { text: this.$t('constMoinsDe'), value: 'pageurlmoinsde' }, { text: this.$t('constPlusDe'), value: 'pageurlplusde' }, { text: this.$t('constDay'), value: 'dayofweek' }, { text: this.$t('constAfter'), value: 'aftertime' }, { text: this.$t('constBefore'), value: 'beforetime' }, { text: this.$t('constOngoing'), value: 'isonpage' }, { text: this.$t('constMobile'), value: 'ismobile' }, { text: this.$t('constNoMore'), value: 'isnotonpage' }, { text: this.$t('constTime'), value: 'pageduration' }, { text: 'Returning Visiteur (au moins une visite antérieure à aujourd\'hui)', value: 'returning' }, { text: this.$t('constChatted'), value: 'haschatted' }],
      const_type_ecomm: [{ text: this.$t('constCart'), value: 'pagecart' }, { text: this.$t('constLogin'), value: 'pagelogin' }, { text: this.$t('constDeliver'), value: 'pagedeliver' }, { text: this.$t('constSummary'), value: 'pagesummary' }, { text: this.$t('constPaiment'), value: 'pagepayment' }, { text: this.$t('constValidation'), value: 'pagevalid' }, { text: this.$t('constAmount'), value: 'cartamount' }, { text: this.$t('constNbProd'), value: 'cartnb' }, { text: this.$t('constCustomer'), value: 'iscutomer' }],
      const_type_getplus: [{ text: 'Info sur effectif', value: 'workforce' }, { text: 'Info sur téléphone', value: 'hasphone' }, { text: 'Info sur email', value: 'hasemail' }, { text: 'Code NAF', value: 'hasinnaf' }, { text: "L'activité (label NAF) contient le mot", value: 'inlabelnaf' }, {
        text: "L'activité (label NAF) ne contient pas le mot",
        value: 'notinlabelnaf'
      }, { text: 'Chaleur', value: 'chaleur' }, { text: 'Raison Sociale', value: 'raison' }],
      const_condition: [{ text: this.$t('equal'), value: 'equal' }, { text: this.$t('greater'), value: 'greater' }, { text: this.$t('lower'), value: 'less' }, { text: this.$t('never'), value: 'unvisited' }, { text: this.$t('atLeastTimes'), value: 'visited' }, { text: this.$t('containsString'), value: 'hasgot' }, { text: this.$t('dontContain'), value: 'hasnotgot' }, { text: this.$t('onMobile'), value: 'onmobile' }, { text: this.$t('notOnMobile'), value: 'notonmobile' }],
      const_condition_ouinon: [{ text: this.$t('yes'), value: 'hasgot' }, { text: this.$t('no'), value: 'hasnotgot' }],
      const_condition_page: [{ text: this.$t('never'), value: 'unvisited' }, { text: this.$t('atLeastTimes'), value: 'visited' }],
      const_condition_mobile: [{ text: this.$t('onMobile'), value: 'onmobile' }, { text: this.$t('notOnMobile'), value: 'notonmobile' }],
      const_condition_contient: [{ text: this.$t('containsString'), value: 'hasgot' }],
      const_condition_contient_or_equal: [{ text: this.$t('equal'), value: 'equal' }, { text: this.$t('containsString'), value: 'hasgot' }],
      const_condition_egalsupinf: [{ text: this.$t('equal'), value: 'equal' }, { text: this.$t('greater'), value: 'greater' }, { text: this.$t('lower'), value: 'less' }],
      const_condition_supinf: [{ text: this.$t('greater'), value: 'greater' }, { text: this.$t('lower'), value: 'less' }],
      const_condition_effectif: [{ text: '1 à 10', value: 'A' }, { text: '10 à 50', value: 'B' }, { text: '50 à 100', value: 'C' }, { text: '100 à 250', value: 'D' }, { text: '250 à 500', value: 'E' }, { text: '500 à 1000', value: 'F' }, { text: '1000 à 2000', value: 'G' }, { text: '2000 et +', value: 'H' }],
      famille: [],
      pushs: [],
      i: 0,
      dialogProgress: false,
      alert: false
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (this.level.rights === LEVEL.ENTREPRISE) {
      this.const_family.push({
        text: this.$t('ecomm'),
        value: 'ecomm'
      });
    }

    if (this.level.rights === LEVEL.ENTREPRISE || this.level.rights === LEVEL.PRO) {
      this.const_type.push({
        text: this.$t('constTag'),
        value: 'pagetag'
      });
    }
    if (this.$store.state._User.entLevel === '5') {
      this.alert = true;
    }
    this.loading = true;
    var dataToGet = new window.FormData();
    dataToGet.append('id', this.id);

    this.axios.get('get/families.php').then(function (response) {
      _this.resAjxFam = response.data;
    }).then(function (_) {
      _this.initFam();
    }).then(function (_) {
      _this.axios.get('get/pushs.php').then(function (response) {
        _this.resAjxPush = response.data;
      }).then(function (_) {
        _this.initPush();
      });
    }).then(function (_) {
      _this.axios.post('get/filter.php', dataToGet, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this.resAjx = response.data;
      }).then(function (_) {
        _this.loading = false;
        _this.initFil();
      });
    }).catch();
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'level']), Object(vuex_esm["e" /* mapState */])('_User', ['entLevel'])),
  created: function created() {
    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'target_filters';
    } else {
      setTimeout(function () {
        if (typeof defautMotif !== 'undefined') {
          defautMotif = 'target_filters';
        }
      }, 800);
    }
  },

  methods: {
    initFam: function initFam() {
      for (var i = 0; i < this.resAjxFam.length; ++i) {
        this.famille.push({ text: this.resAjxFam[i], value: this.resAjxFam[i] });
      }
      this.famille.push({ text: this.$t('newfamily'), value: '' });
    },
    initPush: function initPush() {
      for (var j = 0; j < this.resAjxPush.length; ++j) {
        this.pushs.push({
          text: this.resAjxPush[j].PUSH_NAME,
          value: this.resAjxPush[j].PUSH_ID
        });
      }
    },
    initFil: function initFil() {
      if (this.resAjx && this.resAjx !== '') {
        var _behav = '';
        if (this.resAjx.push === '1') {
          _behav = 'push';
        } else if (this.resAjx.invitation === '1') {
          _behav = 'invitation';
        } else if (this.resAjx.c2c === '1') {
          _behav = 'c2c';
        } else if (this.resAjx.bot === '1') {
          _behav = 'bot';
        }
        var _multi = 'me';
        if (this.resAjx.multiUser > 1) {
          _multi = 'all';
        }
        this.filter = {
          id: this.resAjx.id,
          name: this.resAjx.name,
          user_id: this.resAjx.user_id,
          lickey: this.resAjx.lickey,
          comment: this.resAjx.comment,
          appear: this.resAjx.appear,
          notification: this.resAjx.notification,
          push: this.resAjx.push,
          pushId: this.resAjx.pushId,
          invitation: this.resAjx.invitation,
          invitationMsg: this.resAjx.invitationMsg,
          bot: this.resAjx.invitation,
          botMotif: this.resAjx.botMotif,
          c2c: this.resAjx.c2c,
          active: this.resAjx.active,
          usage: this.resAjx.usage,
          responseRate: this.resAjx.responseRate,
          level: this.resAjx.level,
          family: this.resAjx.family,
          called: this.resAjx.called,
          success: this.resAjx.success,
          creationTs: this.resAjx.creationTs,
          multiUser: _multi,
          constraints: this.resAjx.constraints,
          behaviour: _behav
        };
        for (var k = 0; k < this.resAjx.constraints.length; ++k) {
          var _iconing = 'explore';
          if (this.resAjx.constraints[k].family === 'getplus') {
            _iconing = 'track_changes';
          } else if (this.resAjx.constraints[k].family === 'ecommerce') {
            _iconing = 'euro_symbol';
          }
          var info = this.resAjx.constraints[k].value;
          var info2 = '';
          if (this.resAjx.constraints[k].trigger !== '') {
            info2 = ' : ' + this.resAjx.constraints[k].trigger;
          }
          if (this.resAjx.constraints[k].type === 'dayofweek') {
            for (var l = 0; l < this.days.length; ++l) {
              if (this.days[l].value === this.resAjx.constraints[k].value) {
                info = this.days[l].text;
              }
            }
            info = this.days[this.resAjx.constraints[k].value - 1].text;
          }
          if (this.resAjx.constraints[k].type === 'aftertime' || this.resAjx.constraints[k].type === 'beforetime') {
            for (var m = 0; m < this.heure.length; ++m) {
              if (this.heure[m].value === this.resAjx.constraints[k].value) {
                info = this.heure[m].text;
              }
            }
          }
          if (this.resAjx.constraints[k].type === 'ismobile') {
            info = '';
            info2 = '';
          }
          this.constraints.push({
            id: this.resAjx.constraints[k].id,
            condition: this.resAjx.constraints[k].condition,
            family: this.resAjx.constraints[k].family,
            type: this.resAjx.constraints[k].type,
            value: this.resAjx.constraints[k].value,
            trigger: this.resAjx.constraints[k].trigger,
            info: info,
            info2: info2,
            icon: _iconing
          });
        }
      }
      this.$store.commit('_Toolbar/SET_SUB_TITLE', this.filter.name);
    },
    submit: function submit() {
      var _this2 = this;

      var dataToPost = new window.FormData();
      dataToPost.append('filter', stringify_default()(this.filter));
      dataToPost.append('constraints', stringify_default()(this.constraints));
      dataToPost.append('ENT_ID', this.$store.state._User.entId);

      var steps = JSON.parse(this.$store.state._User.remainingSteps);

      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_TARGET_FILTERS')) {
        steps.splice(steps.indexOf('INS_TARGET_FILTERS'), 1);

        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: stringify_default()(steps)
        });
      }


      this.axios.post('put/filter.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this2.$t('modifSuccess'),
          context: 'success'
        });
      }).catch(function (_) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this2.$t('modifFailure'),
          context: 'error'
        });
      }).then(function (_) {});
    },
    openDialogCreate: function openDialogCreate() {
      this.showDialogCreate = true;
    },
    openDialogEdit: function openDialogEdit(_id) {
      if (!this.overMenu) {
        this.showDialogEdit = true;
        for (var l = 0; l < this.constraints.length; ++l) {
          if (this.constraints[l].id === _id) {
            this.editConstraintDialog.id = this.constraints[l].id;
            this.editConstraintDialog.family = this.constraints[l].family;
            this.editConstraintDialog.type = this.constraints[l].type;
            this.editConstraintDialog.condition = this.constraints[l].condition;
            this.editConstraintDialog.value = this.constraints[l].value;
            this.editConstraintDialog.trigger = this.constraints[l].trigger;
          }
        }
      }
    },
    submitDialogCreate: function submitDialogCreate() {
      this.showDialogCreate = false;
      this.constraints.push({
        id: this.newConstraintDialog.id++,
        condition: this.newConstraintDialog.condition,
        family: this.newConstraintDialog.family,
        type: this.newConstraintDialog.type,
        value: this.newConstraintDialog.value,
        trigger: this.newConstraintDialog.trigger
      });
    },
    submitDialogEdit: function submitDialogEdit() {
      this.showDialogEdit = false;
      for (var l = 0; l < this.constraints.length; ++l) {
        if (this.constraints[l].id === this.editConstraintDialog.id) {
          this.constraints[l].family = this.editConstraintDialog.family;
          this.constraints[l].type = this.editConstraintDialog.type;
          this.constraints[l].condition = this.editConstraintDialog.condition;
          this.constraints[l].value = this.editConstraintDialog.value;
          this.constraints[l].trigger = this.editConstraintDialog.trigger;
        }
      }
    },
    openDialogSupp: function openDialogSupp(id) {
      this.showDialogSupp = true;
      this.declencheurSelected = id;
    },
    deleteConstraint: function deleteConstraint(_id) {
      for (var l = 0; l < this.constraints.length; ++l) {
        if (this.constraints[l].id === _id) {
          this.constraints.splice(l, 1);
          this.showDialogSupp = false;
        }
      }
    },
    dispFamilyName: function dispFamilyName(t) {
      for (var l = 0; l < this.const_family.length; ++l) {
        if (this.const_family[l].value === t) {
          return this.const_family[l].text;
        }
      }
    },
    dispTypeName: function dispTypeName(t) {
      for (var m = 0; m < this.const_type.length; ++m) {
        if (this.const_type[m].value === t) {
          return this.const_type[m].text;
        }
      }
      for (var n = 0; n < this.const_type_ecomm.length; ++n) {
        if (this.const_type_ecomm[n].value === t) {
          return this.const_type_ecomm[n].text;
        }
      }
      for (var _n = 0; _n < this.const_type_getplus.length; ++_n) {
        if (this.const_type_getplus[_n].value === t) {
          return this.const_type_getplus[_n].text;
        }
      }
    },
    dispConditionName: function dispConditionName(t) {
      for (var l = 0; l < this.const_condition.length; ++l) {
        if (this.const_condition[l].value === t) {
          return this.const_condition[l].text;
        }
      }
    },
    someHandler: function someHandler() {}
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1f93c2ab","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/filters/Filter.vue
var Filter_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('v-tabs',{attrs:{"icons-and-text":"","centered":"","slider-color":"secondary","color":"primary","dark":""}},[_c('v-tab',{attrs:{"href":"#tab-1"}},[_vm._v("\n        "+_vm._s(_vm.$t('description'))+"\n        "),_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-2"}},[_vm._v("\n        "+_vm._s(_vm.$tc('triggers', 2, {count: ''}))+"\n        "),_c('v-icon',[_vm._v("pages")])],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-3"}},[_vm._v("\n        "+_vm._s(_vm.$t('behaviour'))+"\n        "),_c('v-icon',[_vm._v("chat")])],1),_vm._v(" "),_c('v-tab-item',{key:"1",attrs:{"value":"tab-1"}},[_c('v-card',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('status')))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-select',{attrs:{"items":_vm.activ,"label":"$t('scenarioActivated')","single-line":"","menu-props":"auto"},model:{value:(_vm.filter.active),callback:function ($$v) {_vm.$set(_vm.filter, "active", $$v)},expression:"filter.active"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('scenarioName')))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-text-field',{attrs:{"label":_vm.$t('scenarioThisName')},model:{value:(_vm.filter.name),callback:function ($$v) {_vm.$set(_vm.filter, "name", $$v)},expression:"filter.name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('scenarioComment')))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-text-field',{attrs:{"label":_vm.$t('comment')},model:{value:(_vm.filter.comment),callback:function ($$v) {_vm.$set(_vm.filter, "comment", $$v)},expression:"filter.comment"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('priority')))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-select',{attrs:{"items":_vm.priotit,"disabled":false,"label":_vm.$t('priority'),"single-line":"","menu-props":"auto"},model:{value:(_vm.filter.level),callback:function ($$v) {_vm.$set(_vm.filter, "level", $$v)},expression:"filter.level"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('family')))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-select',{attrs:{"items":_vm.famille,"label":_vm.$t('family'),"single-line":"","menu-props":"auto"},model:{value:(_vm.filter.family),callback:function ($$v) {_vm.$set(_vm.filter, "family", $$v)},expression:"filter.family"}})],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(_vm.filter.family === ''),expression:"filter.family === ''"}],attrs:{"xs12":"","sm3":""}},[_c('v-text-field',{attrs:{"label":_vm.$t('newfamily')},model:{value:(_vm.filter.newfamily),callback:function ($$v) {_vm.$set(_vm.filter, "newfamily", $$v)},expression:"filter.newfamily"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('sharedWith')))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-select',{attrs:{"items":_vm.multiUser,"label":_vm.$t('multiAgent'),"single-line":"","menu-props":"auto"},model:{value:(_vm.filter.multiUser),callback:function ($$v) {_vm.$set(_vm.filter, "multiUser", $$v)},expression:"filter.multiUser"}})],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:"2",attrs:{"value":"tab-2"}},[_c('v-card',{attrs:{"id":"tab-2"}},[_c('v-list',[_c('v-subheader',{attrs:{"inset":""}},[_vm._v(_vm._s(_vm.$t('triggersList')))]),_vm._v(" "),_vm._l((_vm.constraints),function(constraint){return _c('v-list-tile',{key:constraint.title,attrs:{"avatar":""},on:{"click":function($event){_vm.openDialogEdit(constraint.id)}}},[_c('v-list-tile-avatar',[(constraint.family == 'ecomm')?_c('v-icon',{staticClass:"primary--text",attrs:{"medium":""}},[_vm._v("shopping_cart")]):(constraint.family == 'getplus')?_c('v-icon',{staticClass:"primary--text",attrs:{"medium":""}},[_vm._v("extension")]):_c('v-icon',{staticClass:"primary--text",attrs:{"medium":""}},[_vm._v("explore")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.dispFamilyName (constraint.family)))]),_vm._v(" "),(constraint.condition != 'unvisited')?_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.dispTypeName (constraint.type))+"  :  "+_vm._s(_vm._f("cap")(_vm.$t(constraint.condition)))+" "+_vm._s(constraint.value))]):_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.dispTypeName (constraint.type))+"   "+_vm._s(_vm.$t('never')))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"icon"},nativeOn:{"mouseover":function($event){_vm.overMenu = true},"mouseleave":function($event){_vm.overMenu = false}},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',[_c('v-list-tile',{on:{"click":function($event){$event.stopPropagation();_vm.openDialogEdit(constraint.id)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('editTrigger')))])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.openDialogSupp(constraint.id)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('deleteTrigger')))])],1)],1)],1)],1)],1)],1)})],2)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-fab-transition',[_c('v-btn',{staticClass:"secondary",attrs:{"dark":"","fab":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.openDialogCreate($event)}}},[_c('v-icon',[_vm._v("add")])],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:"3",attrs:{"value":"tab-3"}},[_c('v-card',{attrs:{"flat":"","id":"tab-3"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('chooseBehav')))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-select',{attrs:{"items":_vm.behaviour,"label":_vm.$t('toTrigg'),"single-line":"","menu-props":"auto"},on:{"change":_vm.someHandler},model:{value:(_vm.filter.behaviour),callback:function ($$v) {_vm.$set(_vm.filter, "behaviour", $$v)},expression:"filter.behaviour"}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.filter.behaviour === 'invitation'),expression:"filter.behaviour === 'invitation'"}],attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('invitContent')))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm7":""}},[_c('v-text-field',{attrs:{"label":_vm.$t('bubbleMsg'),"maxlength":"255"},model:{value:(_vm.filter.invitationMsg),callback:function ($$v) {_vm.$set(_vm.filter, "invitationMsg", $$v)},expression:"filter.invitationMsg"}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.filter.behaviour === 'push'),expression:"filter.behaviour === 'push'"}],attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('whichPush')))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":""}},[_c('v-select',{attrs:{"items":_vm.pushs,"label":_vm.$t('choosePush'),"single-line":"","menu-props":"auto"},model:{value:(_vm.filter.pushId),callback:function ($$v) {_vm.$set(_vm.filter, "pushId", $$v)},expression:"filter.pushId"}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.filter.behaviour === 'bot'),expression:"filter.behaviour === 'bot'"}],attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm3":""}},[_c('v-subheader',[_vm._v("Choix du dialogue à lancer")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm7":""}},[_c('v-text-field',{attrs:{"label":"Dialogue","maxlength":"255"},model:{value:(_vm.filter.botMotif),callback:function ($$v) {_vm.$set(_vm.filter, "botMotif", $$v)},expression:"filter.botMotif"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.showDialogCreate),callback:function ($$v) {_vm.showDialogCreate=$$v},expression:"showDialogCreate"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm.$t('addTrigger')))]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"label":_vm.$t('type'),"items":_vm.const_family},model:{value:(_vm.newConstraintDialog.family),callback:function ($$v) {_vm.$set(_vm.newConstraintDialog, "family", $$v)},expression:"newConstraintDialog.family"}}),_vm._v(" "),(_vm.newConstraintDialog.family === 'browse')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('condition'),"items":_vm.const_type},model:{value:(_vm.newConstraintDialog.type),callback:function ($$v) {_vm.$set(_vm.newConstraintDialog, "type", $$v)},expression:"newConstraintDialog.type"}})],1):(_vm.newConstraintDialog.family === 'ecomm')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('condition'),"items":_vm.const_type_ecomm},model:{value:(_vm.newConstraintDialog.type),callback:function ($$v) {_vm.$set(_vm.newConstraintDialog, "type", $$v)},expression:"newConstraintDialog.type"}})],1):(_vm.newConstraintDialog.family === 'getplus')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('condition'),"items":_vm.const_type_getplus},model:{value:(_vm.newConstraintDialog.type),callback:function ($$v) {_vm.$set(_vm.newConstraintDialog, "type", $$v)},expression:"newConstraintDialog.type"}})],1):_vm._e(),_vm._v(" "),(_vm.newConstraintDialog.type !== 'pageurlnb' && _vm.newConstraintDialog.type !== 'pageurlmoinsde' && _vm.newConstraintDialog.type !== 'pageurlplusde' && _vm.newConstraintDialog.type !== 'dayofweek' && _vm.newConstraintDialog.type !== 'aftertime'  && _vm.newConstraintDialog.type !== 'beforetime')?_c('div',[(_vm.newConstraintDialog.type === 'hasphone' || _vm.newConstraintDialog.type === 'hasemail')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_ouinon},model:{value:(_vm.newConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.newConstraintDialog, "condition", $$v)},expression:"newConstraintDialog.condition"}})],1):(_vm.newConstraintDialog.type === 'iscutomer' || (_vm.newConstraintDialog.family === 'ecomm' && _vm.newConstraintDialog.type !== 'cartamount' && _vm.newConstraintDialog.type !== 'cartnb'))?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_page},model:{value:(_vm.newConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.newConstraintDialog, "condition", $$v)},expression:"newConstraintDialog.condition"}})],1):(_vm.newConstraintDialog.type === 'ismobile')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_mobile},model:{value:(_vm.newConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.newConstraintDialog, "condition", $$v)},expression:"newConstraintDialog.condition"}})],1):(_vm.editConstraintDialog.type === 'pageurl' || _vm.newConstraintDialog.type === 'pagetag' || _vm.newConstraintDialog.type === 'hasinnaf' || _vm.newConstraintDialog.type === 'inlabelnaf' || _vm.newConstraintDialog.type === 'notinlabelnaf' || _vm.newConstraintDialog.type === 'pageurlnb' || _vm.newConstraintDialog.type === 'pageurlmoinsde' || _vm.newConstraintDialog.type === 'pageurlplusde')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_contient},model:{value:(_vm.newConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.newConstraintDialog, "condition", $$v)},expression:"newConstraintDialog.condition"}})],1):(_vm.newConstraintDialog.type === 'isonpage' || _vm.newConstraintDialog.type === 'isnotonpage' || _vm.newConstraintDialog.type === 'raison' )?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_contient_or_equal},model:{value:(_vm.newConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.newConstraintDialog, "condition", $$v)},expression:"newConstraintDialog.condition"}})],1):(_vm.newConstraintDialog.type === 'workforce')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_effectif},model:{value:(_vm.newConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.newConstraintDialog, "condition", $$v)},expression:"newConstraintDialog.condition"}})],1):(_vm.newConstraintDialog.type === 'pageduration' || _vm.newConstraintDialog.type === 'time')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_supinf},model:{value:(_vm.newConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.newConstraintDialog, "condition", $$v)},expression:"newConstraintDialog.condition"}})],1):(_vm.newConstraintDialog.type !== 'haschatted' && _vm.newConstraintDialog.type !== 'returning' && _vm.newConstraintDialog.type !== 'time')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_egalsupinf},model:{value:(_vm.newConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.newConstraintDialog, "condition", $$v)},expression:"newConstraintDialog.condition"}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.newConstraintDialog.type !== 'ismobile' && _vm.newConstraintDialog.type !== 'hasphone' && _vm.newConstraintDialog.type !== 'hasemail')?_c('div',[(_vm.newConstraintDialog.type !== 'dayofweek' && _vm.newConstraintDialog.type !== 'aftertime' && _vm.newConstraintDialog.type !== 'beforetime')?_c('div',[(_vm.newConstraintDialog.condition !== 'unvisited' && _vm.newConstraintDialog.type !== 'haschatted' && _vm.newConstraintDialog.type !== 'returning' && _vm.newConstraintDialog.type !== 'hasgot' && _vm.newConstraintDialog.type !== 'hasnotgot'&& _vm.newConstraintDialog.type !== 'onmobile' && _vm.newConstraintDialog.type !== 'notonmobile' && _vm.newConstraintDialog.type !== 'workforce')?_c('v-text-field',{attrs:{"label":(_vm.newConstraintDialog.type === 'pageurlnb' || _vm.newConstraintDialog.type === 'pageurlmoinsde' || _vm.newConstraintDialog.type === 'pageurlplusde') ? 'contient dans URL' : _vm.$t('valueOfset')},model:{value:(_vm.newConstraintDialog.value),callback:function ($$v) {_vm.$set(_vm.newConstraintDialog, "value", $$v)},expression:"newConstraintDialog.value"}}):_vm._e()],1):_c('div',[_c('v-select',{attrs:{"label":"Time","items":_vm.newConstraintDialog.type === 'dayofweek' ? _vm.days : _vm.heure},model:{value:(_vm.newConstraintDialog.value),callback:function ($$v) {_vm.$set(_vm.newConstraintDialog, "value", $$v)},expression:"newConstraintDialog.value"}})],1),_vm._v(" "),(_vm.newConstraintDialog.type === 'pageurlnb' || _vm.newConstraintDialog.type === 'pageurlmoinsde' || _vm.newConstraintDialog.type === 'pageurlplusde')?_c('v-text-field',{attrs:{"label":(_vm.newConstraintDialog.type === 'pageurlmoinsde' || _vm.newConstraintDialog.type === 'pageurlplusde') ? 'secondes' : 'nb de fois'},model:{value:(_vm.newConstraintDialog.trigger),callback:function ($$v) {_vm.$set(_vm.newConstraintDialog, "trigger", $$v)},expression:"newConstraintDialog.trigger"}}):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.showDialogCreate = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){return _vm.submitDialogCreate($event)}}},[_vm._v(_vm._s(_vm.$t('add')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.showDialogEdit),callback:function ($$v) {_vm.showDialogEdit=$$v},expression:"showDialogEdit"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm.$t('editTrigger')))]),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"label":_vm.$t('type'),"items":_vm.const_family},model:{value:(_vm.editConstraintDialog.family),callback:function ($$v) {_vm.$set(_vm.editConstraintDialog, "family", $$v)},expression:"editConstraintDialog.family"}}),_vm._v(" "),(_vm.editConstraintDialog.family === 'browse')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('condition'),"items":_vm.const_type},model:{value:(_vm.editConstraintDialog.type),callback:function ($$v) {_vm.$set(_vm.editConstraintDialog, "type", $$v)},expression:"editConstraintDialog.type"}})],1):(_vm.editConstraintDialog.family === 'ecomm')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('condition'),"items":_vm.const_type_ecomm},model:{value:(_vm.editConstraintDialog.type),callback:function ($$v) {_vm.$set(_vm.editConstraintDialog, "type", $$v)},expression:"editConstraintDialog.type"}})],1):(_vm.editConstraintDialog.family === 'getplus')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('condition'),"items":_vm.const_type_getplus},model:{value:(_vm.editConstraintDialog.type),callback:function ($$v) {_vm.$set(_vm.editConstraintDialog, "type", $$v)},expression:"editConstraintDialog.type"}})],1):_vm._e(),_vm._v(" "),(_vm.editConstraintDialog.type !== 'pageurlnb' && _vm.editConstraintDialog.type !== 'pageurlmoinsde' && _vm.editConstraintDialog.type !== 'pageurlplusde' && _vm.editConstraintDialog.type !== 'dayofweek' && _vm.editConstraintDialog.type !== 'aftertime'  && _vm.editConstraintDialog.type !== 'beforetime')?_c('div',[(_vm.editConstraintDialog.type === 'hasphone' || _vm.editConstraintDialog.type === 'hasemail')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_ouinon},model:{value:(_vm.editConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.editConstraintDialog, "condition", $$v)},expression:"editConstraintDialog.condition"}})],1):(_vm.editConstraintDialog.type === 'iscutomer' || (_vm.editConstraintDialog.family === 'ecomm' && _vm.editConstraintDialog.type !== 'cartamount' && _vm.editConstraintDialog.type !== 'cartnb'))?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_page},model:{value:(_vm.editConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.editConstraintDialog, "condition", $$v)},expression:"editConstraintDialog.condition"}})],1):(_vm.editConstraintDialog.type === 'ismobile')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_mobile},model:{value:(_vm.editConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.editConstraintDialog, "condition", $$v)},expression:"editConstraintDialog.condition"}})],1):(_vm.editConstraintDialog.type === 'pageurl' || _vm.editConstraintDialog.type === 'pagetag' || _vm.editConstraintDialog.type === 'hasinnaf' || _vm.editConstraintDialog.type === 'inlabelnaf'  || _vm.editConstraintDialog.type === 'notinlabelnaf')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_contient},model:{value:(_vm.editConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.editConstraintDialog, "condition", $$v)},expression:"editConstraintDialog.condition"}})],1):(_vm.editConstraintDialog.type === 'isonpage' || _vm.editConstraintDialog.type === 'isnotonpage' || _vm.newConstraintDialog.type === 'raison' )?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_contient_or_equal},model:{value:(_vm.editConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.editConstraintDialog, "condition", $$v)},expression:"editConstraintDialog.condition"}})],1):(_vm.editConstraintDialog.type === 'workforce')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_effectif},model:{value:(_vm.editConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.editConstraintDialog, "condition", $$v)},expression:"editConstraintDialog.condition"}})],1):(_vm.editConstraintDialog.type === 'pageduration' || _vm.editConstraintDialog.type === 'time')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_supinf},model:{value:(_vm.editConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.editConstraintDialog, "condition", $$v)},expression:"editConstraintDialog.condition"}})],1):(_vm.editConstraintDialog.type !== 'haschatted' && _vm.editConstraintDialog.type !== 'returning' && _vm.editConstraintDialog.type !== 'time')?_c('div',[_c('v-select',{attrs:{"label":_vm.$t('constraint'),"items":_vm.const_condition_egalsupinf},model:{value:(_vm.editConstraintDialog.condition),callback:function ($$v) {_vm.$set(_vm.editConstraintDialog, "condition", $$v)},expression:"editConstraintDialog.condition"}})],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.editConstraintDialog.type !== 'ismobile' && _vm.editConstraintDialog.type !== 'hasphone' && _vm.editConstraintDialog.type !== 'hasemail')?_c('div',[(_vm.editConstraintDialog.type !== 'dayofweek' && _vm.editConstraintDialog.type !== 'aftertime'  && _vm.editConstraintDialog.type !== 'beforetime')?_c('div',[(_vm.editConstraintDialog.condition !== 'unvisited' && _vm.editConstraintDialog.type !== 'haschatted' && _vm.editConstraintDialog.type !== 'returning' && _vm.editConstraintDialog.type !== 'hasgot' && _vm.editConstraintDialog.type !== 'hasnotgot'&& _vm.editConstraintDialog.type !== 'onmobile' && _vm.editConstraintDialog.type !== 'notonmobile' && _vm.editConstraintDialog.type !== 'workforce')?_c('v-text-field',{attrs:{"label":(_vm.editConstraintDialog.type === 'pageurlnb' || _vm.editConstraintDialog.type === 'pageurlmoinsde' || _vm.editConstraintDialog.type === 'pageurlplusde') ? 'contient dans URL' : _vm.$t('valueOfset')},model:{value:(_vm.editConstraintDialog.value),callback:function ($$v) {_vm.$set(_vm.editConstraintDialog, "value", $$v)},expression:"editConstraintDialog.value"}}):_vm._e()],1):_c('div',[_c('v-select',{attrs:{"label":"Time","items":_vm.editConstraintDialog.type === 'dayofweek' ? _vm.days : _vm.heure},model:{value:(_vm.editConstraintDialog.value),callback:function ($$v) {_vm.$set(_vm.editConstraintDialog, "value", $$v)},expression:"editConstraintDialog.value"}})],1),_vm._v(" "),(_vm.editConstraintDialog.type === 'pageurlnb' || _vm.editConstraintDialog.type === 'pageurlmoinsde' || _vm.editConstraintDialog.type === 'pageurlplusde')?_c('v-text-field',{attrs:{"label":(_vm.editConstraintDialog.type === 'pageurlmoinsde' || _vm.editConstraintDialog.type === 'pageurlplusde') ? 'secondes' : 'nb de fois'},model:{value:(_vm.editConstraintDialog.trigger),callback:function ($$v) {_vm.$set(_vm.editConstraintDialog, "trigger", $$v)},expression:"editConstraintDialog.trigger"}}):_vm._e()],1):_vm._e()],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.showDialogEdit = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){return _vm.submitDialogEdit($event)}}},[_vm._v("OK")])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.showDialogSupp),callback:function ($$v) {_vm.showDialogSupp=$$v},expression:"showDialogSupp"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm.$t('editTrigger')))]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          Voulez-vous supprimer ce déclancheur ?\n        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){_vm.deleteConstraint(_vm.declencheurSelected)}}},[_vm._v(_vm._s(_vm.$t('yes')))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.showDialogSupp = false}}},[_vm._v(_vm._s(_vm.$t('no')))])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","fixed":"","bottom":"","disabled":_vm.alert,"right":""},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("\n          "+_vm._s(_vm.$t('submit'))),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("send")])],1)],1)],1)}
var Filter_staticRenderFns = []
var Filter_esExports = { render: Filter_render, staticRenderFns: Filter_staticRenderFns }
/* harmony default export */ var filters_Filter = (Filter_esExports);
// CONCATENATED MODULE: ./src/components/filters/Filter.vue
function Filter_injectStyle (ssrContext) {
  __webpack_require__("uLO6")
}
var Filter_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Filter___vue_template_functional__ = false
/* styles */
var Filter___vue_styles__ = Filter_injectStyle
/* scopeId */
var Filter___vue_scopeId__ = "data-v-1f93c2ab"
/* moduleIdentifier (server only) */
var Filter___vue_module_identifier__ = null
var Filter_Component = Filter_normalizeComponent(
  Filter,
  filters_Filter,
  Filter___vue_template_functional__,
  Filter___vue_styles__,
  Filter___vue_scopeId__,
  Filter___vue_module_identifier__
)

/* harmony default export */ var components_filters_Filter = (Filter_Component.exports);

// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64393342","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Media.vue
var Media_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"media"},[_c('transition',{attrs:{"name":"slide-x-reverse-transition","mode":"out-in"}},[_c('router-view')],1)],1)}
var Media_staticRenderFns = []
var Media_esExports = { render: Media_render, staticRenderFns: Media_staticRenderFns }
/* harmony default export */ var Media = (Media_esExports);
// CONCATENATED MODULE: ./src/components/Media.vue
var Media_normalizeComponent = __webpack_require__("VU/8")
/* script */
var Media___vue_script__ = null
/* template */

/* template functional */
var Media___vue_template_functional__ = false
/* styles */
var Media___vue_styles__ = null
/* scopeId */
var Media___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Media___vue_module_identifier__ = null
var Media_Component = Media_normalizeComponent(
  Media___vue_script__,
  Media,
  Media___vue_template_functional__,
  Media___vue_styles__,
  Media___vue_scopeId__,
  Media___vue_module_identifier__
)

/* harmony default export */ var components_Media = (Media_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/media/Biblios.vue




/* harmony default export */ var Biblios = ({
  data: function data() {
    return {
      loading: false,

      showDialogCreate: false,

      biblioDialog: {},

      dialogImport: false,
      loadingImport: false,

      agent: null,
      dialogProgress: false
    };
  },

  created: function created() {
    var _this = this;

    this.getBiblios();
    this.biblioDialog = this.newBiblio();

    this.agent = this.$store.state._User.colleagues.find(function (a) {
      return a.USR_ID === _this.$store.state._User.id;
    });

    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'media_biblios';
    } else {
      setTimeout(function () {
        if (typeof defautMotif !== 'undefined') {
          defautMotif = 'media_biblios';
        }
      }, 800);
    }
  },
  mounted: function mounted() {
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
  },

  methods: {
    getBiblios: function getBiblios() {
      var _this2 = this;

      this.loading = true;
      this.$store.dispatch('_Biblios/GET', this.$store.state._User.id).then(function () {
        _this2.loading = false;
      });
    },
    openDialogCreate: function openDialogCreate() {
      this.biblioDialog = this.newBiblio();
      this.showDialogCreate = true;
    },
    submitDialogCreate: function submitDialogCreate() {
      var _this3 = this;

      this.showDialogCreate = false;
      if (lodash_default.a.isEmpty(this.biblioDialog.title)) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('creationFailure') + ' ' + this.$t('empty'),
          context: 'warning'
        });
        return;
      }

      var biblioFound = this.$store.getters['_Biblios/GET_BIBLIO_BY_TITLE'](this.biblioDialog.title);
      if (lodash_default.a.isNil(biblioFound)) {
        var dataToPost = new window.FormData();
        dataToPost.append('FAM_NAME', this.biblioDialog.title);
        dataToPost.append('ENT_ID', this.$store.state._User.entId);

        var steps = JSON.parse(this.$store.state._User.remainingSteps);

        if (steps && typeof steps !== 'undefined' && steps && typeof steps !== 'undefined' && steps.indexOf('INS_MEDIA_BIBLIOS')) {
          steps.splice(steps.indexOf('INS_MEDIA_BIBLIOS'), 1);

          this.$store.commit('_User/MAJ_PROGRESSION', {
            remainingSteps: stringify_default()(steps)
          });
        }


        this.axios.post('post/biblio.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(function (response) {
          _this3.biblioDialog.id = response.data.id;
          _this3.biblioDialog.title = _this3.biblioDialog.title;
          _this3.$store.commit('_Biblios/ADD_BIBLIO', _this3.biblioDialog);

          _this3.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: _this3.$t('creationSuccess'),
            context: 'success'
          });
        }).catch(function (_) {
          _this3.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: _this3.$t('creationFailure'),
            context: 'error'
          });
        }).then(function (_) {
          _this3.loading = false;
        });
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('alreadyExists'),
          context: 'warning'
        });
      }
    },
    newBiblio: function newBiblio() {
      return {
        id: '',
        title: '',
        sentences: [],
        subs: []
      };
    },
    openDialogImport: function openDialogImport() {
      this.dialogImport = true;
    },
    submitDialogImport: function submitDialogImport() {
      var _this4 = this;

      var params = new window.FormData();
      params.append('src', this.agent.USR_ID);
      params.append('dest', this.$store.state._User.id);
      this.loadingImport = true;
      this.axios.post('post/import_sentences.php', params, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (res) {
        _this4.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this4.$t('importSuccess'),
          context: 'success'
        });
        _this4.getBiblios();
      }).catch(function () {
        _this4.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this4.$t('importFailure'),
          context: 'error'
        });
      }).then(function () {
        _this4.loadingImport = false;
        _this4.dialogImport = false;
      });
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b57ce88a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/media/Biblios.vue
var Biblios_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"grid-list-lg":""}}),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):(!_vm.loading)?_c('div',[(_vm.$store.state._Biblios.biblios.length)?_c('v-btn',{attrs:{"flat":"","color":"primary","block":_vm.$vuetify.breakpoint.smAndDown},on:{"click":function($event){_vm.openDialogImport()}}},[_vm._v("\n        "+_vm._s(_vm.$t('importSentencesFromAgent'))+"\n        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("get_app")])],1):_vm._e(),_vm._v(" "),_c('v-card',{staticClass:"mb-5"},[_c('v-list',{attrs:{"two-line":"","dense":""}},[(_vm.$store.state._Biblios.biblios.length)?_c('v-subheader',[_vm._v("\n            "+_vm._s(_vm.$tc('libraries', _vm.$store.state._Biblios.biblios.length, { count: _vm.$store.state._Biblios.biblios.length }))+"\n          ")]):_vm._e(),_vm._v(" "),_vm._l((_vm.$store.state._Biblios.biblios),function(biblio,i){return [_c('wz-biblio',{key:i,attrs:{"biblio":biblio}})]})],2),_vm._v(" "),(!_vm.$store.state._Biblios.biblios.length)?_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-img',{attrs:{"src":"https://www.gstatic.com/mobilesdk/160505_mobilesdk/zerostate/2x/database.png","height":"125px","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('libraries', 0, {count: '' }))))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('sentencesMustInLibrary'))}}),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","color":"primary","block":_vm.$vuetify.breakpoint.smAndDown},on:{"click":function($event){_vm.openDialogImport()}}},[_vm._v("\n                  "+_vm._s(_vm.$t('importSentencesFromAgent'))+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("get_app")])],1)],1)])],1)],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('v-fab-transition',[_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loading),expression:"!loading"}],staticClass:"white--text",attrs:{"slot":"activator","fab":"","bottom":"","floating":"","fixed":"","raised":"","right":"","dark":"","color":"secondary"},on:{"click":function($event){$event.stopPropagation();return _vm.openDialogCreate($event)}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('add')))+" "+_vm._s(_vm.$tc('libraries', 1)))])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.showDialogCreate),callback:function ($$v) {_vm.showDialogCreate=$$v},expression:"showDialogCreate"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('add')))+" "+_vm._s(_vm.$tc('libraries', 1)))]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:32'),expression:"'required|max:32'"}],attrs:{"autofocus":"","label":_vm.$t('title'),"counter":"","max":"32","required":"","data-vv-name":"title","error":_vm.wzErrors.has(_vm.$t('title')),"error-messages":_vm.wzErrors.collect(_vm.$t('title'))},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogCreate($event)}},model:{value:(_vm.biblioDialog.title),callback:function ($$v) {_vm.$set(_vm.biblioDialog, "title", $$v)},expression:"biblioDialog.title"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showDialogCreate = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.wzErrors.any()},on:{"click":_vm.submitDialogCreate}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"350"},model:{value:(_vm.dialogImport),callback:function ($$v) {_vm.dialogImport=$$v},expression:"dialogImport"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm.$t('importSentencesFromAgent')))]),_vm._v(" "),_c('v-card-text',[_c('wz-select-one-agent',{attrs:{"agent":_vm.agent,"withoutMe":""},on:{"update:agent":function($event){_vm.agent=$event}}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.$t('infosImportSentencesFromAgent'))}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","loading":_vm.loadingImport},on:{"click":function($event){_vm.dialogImport = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),(_vm.agent)?_c('v-btn',{attrs:{"color":"primary","loading":_vm.loadingImport},on:{"click":_vm.submitDialogImport}},[_vm._v(_vm._s(_vm.$t('submit')))]):_vm._e()],1)],1)],1),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":15},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)}
var Biblios_staticRenderFns = []
var Biblios_esExports = { render: Biblios_render, staticRenderFns: Biblios_staticRenderFns }
/* harmony default export */ var media_Biblios = (Biblios_esExports);
// CONCATENATED MODULE: ./src/components/media/Biblios.vue
var Biblios_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Biblios___vue_template_functional__ = false
/* styles */
var Biblios___vue_styles__ = null
/* scopeId */
var Biblios___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Biblios___vue_module_identifier__ = null
var Biblios_Component = Biblios_normalizeComponent(
  Biblios,
  media_Biblios,
  Biblios___vue_template_functional__,
  Biblios___vue_styles__,
  Biblios___vue_scopeId__,
  Biblios___vue_module_identifier__
)

/* harmony default export */ var components_media_Biblios = (Biblios_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/media/Biblio.vue



/* harmony default export */ var Biblio = ({
  props: ['id'],

  data: function data() {
    return {
      biblio: null,

      sentenceDialog: null,

      showDialogCreateSentence: false,
      loadingSentence: false,

      subDialog: null,

      showDialogCreateSub: false,
      loadingSub: false,

      fab: false
    };
  },
  created: function created() {
    this.biblio = this.$store.getters['_Biblios/GET_BIBLIO_BY_ID'](this.id);
    if (lodash_default.a.isNil(this.biblio)) {
      this.$router.go(-1);
    }
    this.sentenceDialog = this.newSentence();
    this.subDialog = this.newSub();
    this.$store.commit('_Toolbar/SET_SUB_TITLE', this.biblio.title);
  },


  methods: {
    openDialogCreateSentence: function openDialogCreateSentence() {
      this.$validator.reset();
      this.sentenceDialog = this.newSentence();
      this.showDialogCreateSentence = true;
    },
    submitDialogCreateSentence: function submitDialogCreateSentence() {
      var _this = this;

      this.showDialogCreateSentence = false;
      if (lodash_default.a.isEmpty(this.sentenceDialog.title)) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Titre vide', context: 'warning' });
        return;
      }

      var sentenceFound = lodash_default.a.find(this.biblio.sentences, ['title', this.sentenceDialog.title]);
      if (lodash_default.a.isNil(sentenceFound)) {
        this.loadingSentence = true;

        var dataToPost = new window.FormData();
        dataToPost.append('SEN_MSG', this.sentenceDialog.title);
        dataToPost.append('SEN_FAM_ID', this.biblio.id);
        dataToPost.append('ENT_ID', this.$store.state._User.entId);

        this.axios.post('post/sentence.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
          _this.sentenceDialog.id = response.data.id;
          var biblioUpdate = lodash_default.a.cloneDeep(_this.biblio);
          biblioUpdate.sentences.push(_this.sentenceDialog);
          _this.$store.commit('_Biblios/UPDATE_BIBLIO', biblioUpdate);
          _this.biblio = _this.$store.getters['_Biblios/GET_BIBLIO_BY_ID'](_this.id);

          _this.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this.$t('creationSuccess'), context: 'success' });
        }).catch(function (_) {
          _this.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this.$t('creationFailure'), context: 'error' });
        }).then(function (_) {
          _this.loadingSentence = false;
        });
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('alreadyExists'), context: 'warning' });
      }
    },
    newSentence: function newSentence() {
      return {
        id: '',
        title: ''
      };
    },
    openDialogCreateSub: function openDialogCreateSub() {
      this.$validator.reset();
      this.subDialog = this.newSub();
      this.showDialogCreateSub = true;
    },
    submitDialogCreateSub: function submitDialogCreateSub() {
      var _this2 = this;

      this.showDialogCreateSub = false;
      if (lodash_default.a.isEmpty(this.subDialog.title)) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('cantCreate'), context: 'warning' });
        return;
      }

      var biblioFound = this.$store.getters['_Biblios/GET_BIBLIO_BY_TITLE'](this.subDialog.title);
      if (lodash_default.a.isNil(biblioFound)) {
        var dataToPost = new window.FormData();
        dataToPost.append('FAM_NAME', this.subDialog.title);
        dataToPost.append('FAM_IS_SUBFAMILY', this.biblio.id);
        this.axios.post('post/biblio.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
          _this2.subDialog.id = response.data.id;
          _this2.subDialog.title = _this2.subDialog.title;
          _this2.subDialog.sub = _this2.biblio.id;
          _this2.$store.commit('_Biblios/ADD_BIBLIO', _this2.subDialog);
          _this2.biblio = _this2.$store.getters['_Biblios/GET_BIBLIO_BY_ID'](_this2.id);

          _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('creationSuccess'), context: 'success' });
        }).catch(function (_) {
          _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('creationFailure'), context: 'error' });
        }).then(function (_) {
          _this2.loading = false;
        });
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('alreadyExists'), context: 'warning' });
      }
    },
    newSub: function newSub() {
      return {
        id: '',
        title: '',
        sentences: []
      };
    },
    updateBiblio: function updateBiblio() {
      this.biblio = this.$store.getters['_Biblios/GET_BIBLIO_BY_ID'](this.id);
    }
  },

  beforeRouteUpdate: function beforeRouteUpdate(to, from, next) {
    this.biblio = this.$store.getters['_Biblios/GET_BIBLIO_BY_ID'](to.params.id);
    if (!lodash_default.a.isNil(this.biblio)) {
      to.params.id = this.id;
      this.$store.commit('_Toolbar/SET_SUB_TITLE', this.biblio.title);
      next();
    } else {
      this.$router.go(-1);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c53dd6f0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/media/Biblio.vue
var Biblio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mb-5"},[(_vm.biblio.sentences.length || _vm.biblio.subs.length)?_c('v-list',{attrs:{"two-line":"","dense":""}},[_c('v-subheader',[_vm._v("\n          "+_vm._s(_vm.$tc('subLibraries', _vm.biblio.subs.length, { count: _vm.biblio.subs.length }))+"\n        ")]),_vm._v(" "),_vm._l((_vm.biblio.subs),function(sub,i){return [_c('wz-biblio',{key:i,attrs:{"biblio":sub},on:{"update:biblio":function($event){sub=$event},"update":function($event){_vm.updateBiblio()}}})]}),_vm._v(" "),(_vm.loadingSub)?_c('v-list-tile',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_vm._e(),_vm._v(" "),(_vm.biblio.sentences.length && _vm.biblio.subs.length)?_c('v-divider',{attrs:{"inset":""}}):_vm._e(),_vm._v(" "),_c('v-subheader',[_vm._v("\n          "+_vm._s(_vm.$tc('sentences', _vm.biblio.sentences.length, { count: _vm.biblio.sentences.length }))+"\n        ")]),_vm._v(" "),_vm._l((_vm.biblio.sentences),function(sentence,i){return [_c('wz-sentence',{key:i,attrs:{"sentence":sentence,"biblio":_vm.biblio},on:{"update:biblio":function($event){_vm.biblio=$event}}})]}),_vm._v(" "),(_vm.loadingSentence)?_c('v-list-tile',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_vm._e()],2):_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-img',{attrs:{"src":"https://www.gstatic.com/mobilesdk/160505_mobilesdk/zerostate/2x/database.png","height":"125px","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('noSentence'))+" : "+_vm._s(_vm.biblio.title))])])],1)],1)],1),_vm._v(" "),_c('v-speed-dial',{attrs:{"bottom":"","floating":"","fixed":"","right":""},model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-btn',{attrs:{"slot":"activator","fab":"","dark":"","color":"secondary"},slot:"activator",model:{value:(_vm.fab),callback:function ($$v) {_vm.fab=$$v},expression:"fab"}},[_c('v-icon',[_vm._v("add")]),_vm._v(" "),_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.openDialogCreateSentence($event)}},slot:"activator"},[_c('v-icon',[_vm._v("short_text")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('add') + ' ' + _vm.$tc('sentences', 1))))])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"left":""}},[_c('v-btn',{staticClass:"white--text",attrs:{"slot":"activator","fab":"","dark":"","small":"","color":"primary"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.openDialogCreateSub($event)}},slot:"activator"},[_c('v-icon',[_vm._v("book")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('add') + ' ' + _vm.$tc('subLibraries', 1))))])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.showDialogCreateSentence),callback:function ($$v) {_vm.showDialogCreateSentence=$$v},expression:"showDialogCreateSentence"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('add') + ' ' + _vm.$tc('sentences', 1))))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-textarea',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:256'),expression:"'required|max:256'"}],attrs:{"autofocus":"","label":_vm.$t('title'),"counter":"256","required":"","data-vv-name":"sentenceInput","error":_vm.wzErrors.has('sentenceInput'),"error-messages":_vm.wzErrors.collect('sentenceInput')},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogCreateSentence($event)}},model:{value:(_vm.sentenceDialog.title),callback:function ($$v) {_vm.$set(_vm.sentenceDialog, "title", $$v)},expression:"sentenceDialog.title"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.showDialogCreateSentence = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.wzErrors.any()},nativeOn:{"click":function($event){return _vm.submitDialogCreateSentence($event)}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.showDialogCreateSub),callback:function ($$v) {_vm.showDialogCreateSub=$$v},expression:"showDialogCreateSub"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('add') + ' ' + _vm.$tc('subLibraries', 1))))]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:32'),expression:"'required|max:32'"}],attrs:{"autofocus":"","label":_vm.$t('title'),"counter":"","max":"32","required":"","data-vv-name":"subInput","error":_vm.wzErrors.has('subInput'),"error-messages":_vm.wzErrors.collect('subInput')},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogCreateSub($event)}},model:{value:(_vm.subDialog.title),callback:function ($$v) {_vm.$set(_vm.subDialog, "title", $$v)},expression:"subDialog.title"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.showDialogCreateSub = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.wzErrors.any()},nativeOn:{"click":function($event){return _vm.submitDialogCreateSub($event)}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1)}
var Biblio_staticRenderFns = []
var Biblio_esExports = { render: Biblio_render, staticRenderFns: Biblio_staticRenderFns }
/* harmony default export */ var media_Biblio = (Biblio_esExports);
// CONCATENATED MODULE: ./src/components/media/Biblio.vue
var Biblio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Biblio___vue_template_functional__ = false
/* styles */
var Biblio___vue_styles__ = null
/* scopeId */
var Biblio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Biblio___vue_module_identifier__ = null
var Biblio_Component = Biblio_normalizeComponent(
  Biblio,
  media_Biblio,
  Biblio___vue_template_functional__,
  Biblio___vue_styles__,
  Biblio___vue_scopeId__,
  Biblio___vue_module_identifier__
)

/* harmony default export */ var components_media_Biblio = (Biblio_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/media/SubBiblio.vue



/* harmony default export */ var SubBiblio = ({
  props: ['idParent', 'idSub'],

  data: function data() {
    return {
      subBiblio: {},
      parentBiblio: {},

      subDialog: null,

      showDialogCreateSentence: false,

      loadingSentence: false
    };
  },
  created: function created() {
    this.parentBiblio = this.$store.getters['_Biblios/GET_BIBLIO_BY_ID'](this.idParent);

    if (!this.parentBiblio) {
      this.$router.push({ path: '/media/biblios' });
    }
    this.subBiblio = lodash_default.a.cloneDeep(lodash_default.a.find(this.parentBiblio.subs, { 'id': this.idSub }));
    if (!this.subBiblio) {
      this.$router.push({ path: '/media/biblios' });
    }
    this.$store.commit('_Toolbar/SET_TABS', []);
    this.$store.commit('_Toolbar/SET_BACK', '/media/biblios/' + this.idParent);
    this.$store.commit('_Toolbar/SET_SUB_TITLE', this.subBiblio.title);

    this.sentenceDialog = this.newSentence();
  },


  methods: {
    openDialogCreateSentence: function openDialogCreateSentence() {
      this.$validator.reset();
      this.sentenceDialog = this.newSentence();
      this.showDialogCreateSentence = true;
    },
    submitDialogCreateSentence: function submitDialogCreateSentence() {
      var _this = this;

      this.showDialogCreateSentence = false;
      if (lodash_default.a.isEmpty(this.sentenceDialog.title)) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Titre vide', context: 'warning' });
        return;
      }

      var sentenceFound = lodash_default.a.find(this.subBiblio.sentences, ['title', this.sentenceDialog.title]);
      if (lodash_default.a.isNil(sentenceFound)) {
        this.loadingSentence = true;

        var dataToPost = new window.FormData();
        dataToPost.append('SEN_MSG', this.sentenceDialog.title);
        dataToPost.append('SEN_FAM_ID', this.subBiblio.id);
        this.axios.post('post/sentence.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
          _this.sentenceDialog.id = response.data.id;

          var idxParent = lodash_default.a.findIndex(_this.$store.state._Biblios.biblios, { 'id': _this.idParent });
          var idxSub = lodash_default.a.findIndex(_this.$store.state._Biblios.biblios[idxParent].subs, { 'id': _this.idSub });
          _this.subBiblio = lodash_default.a.cloneDeep(_this.$store.state._Biblios.biblios[idxParent].subs[idxSub]);

          _this.subBiblio.sentences.push(_this.sentenceDialog);

          _this.$store.commit('_Biblios/UPDATE_BIBLIO', _this.subBiblio);

          _this.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this.$t('creationSuccess'), context: 'success' });
        }).catch(function (_) {
          _this.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this.$t('creationFailure'), context: 'error' });
        }).then(function (_) {
          _this.loadingSentence = false;
        });
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('alreadyExists'), context: 'warning' });
      }
    },
    newSentence: function newSentence() {
      return {
        id: '',
        title: ''
      };
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2b479d6","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/media/SubBiblio.vue
var SubBiblio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"mb-5"},[(true)?_c('v-list',{attrs:{"two-line":"","dense":""}},[_c('v-subheader',[_vm._v("\n          "+_vm._s(_vm.subBiblio.sentences.length)+" "+_vm._s(_vm.$tc('sentences', _vm.subBiblio.sentences.length <= 1))+"\n        ")]),_vm._v(" "),_vm._l((_vm.subBiblio.sentences),function(sentence){return [_c('wz-sentence',{attrs:{"sentence":sentence,"biblio":_vm.subBiblio},on:{"update:biblio":function($event){_vm.subBiblio=$event}}})]}),_vm._v(" "),(_vm.loadingSentence)?_c('v-list-tile',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_vm._e()],2):_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs3":""}},[_c('v-img',{attrs:{"src":"https://www.gstatic.com/mobilesdk/160505_mobilesdk/zerostate/2x/database.png","height":"125px","contain":""}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',{staticClass:"headline"},[_vm._v("Aucune phrase dans la sous-bibliothèque : "+_vm._s(_vm.subBiblio.title))])])],1)],1)],1),_vm._v(" "),_c('v-fab-transition',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(!_vm.loadingSentence),expression:"!loadingSentence"}],staticClass:"white--text",attrs:{"slot":"activator","fab":"","bottom":"","floating":"","fixed":"","raised":"","right":"","dark":"","color":"secondary"},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.openDialogCreateSentence($event)}},slot:"activator"},[_c('v-icon',[_vm._v("add")])],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.showDialogCreateSentence),callback:function ($$v) {_vm.showDialogCreateSentence=$$v},expression:"showDialogCreateSentence"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v("Créer une phrase")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:256'),expression:"'required|max:256'"}],attrs:{"autofocus":"","label":_vm.$t('title'),"counter":"256","multi-line":"","required":"","data-vv-name":"sentenceInput","error":_vm.wzErrors.has('sentenceInput'),"error-messages":_vm.wzErrors.collect('sentenceInput')},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogCreateSentence($event)}},model:{value:(_vm.sentenceDialog.title),callback:function ($$v) {_vm.$set(_vm.sentenceDialog, "title", $$v)},expression:"sentenceDialog.title"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.showDialogCreateSentence = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.wzErrors.any()},nativeOn:{"click":function($event){return _vm.submitDialogCreateSentence($event)}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1)}
var SubBiblio_staticRenderFns = []
var SubBiblio_esExports = { render: SubBiblio_render, staticRenderFns: SubBiblio_staticRenderFns }
/* harmony default export */ var media_SubBiblio = (SubBiblio_esExports);
// CONCATENATED MODULE: ./src/components/media/SubBiblio.vue
var SubBiblio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var SubBiblio___vue_template_functional__ = false
/* styles */
var SubBiblio___vue_styles__ = null
/* scopeId */
var SubBiblio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var SubBiblio___vue_module_identifier__ = null
var SubBiblio_Component = SubBiblio_normalizeComponent(
  SubBiblio,
  media_SubBiblio,
  SubBiblio___vue_template_functional__,
  SubBiblio___vue_styles__,
  SubBiblio___vue_scopeId__,
  SubBiblio___vue_module_identifier__
)

/* harmony default export */ var components_media_SubBiblio = (SubBiblio_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/media/Pushs.vue



/* harmony default export */ var Pushs = ({
  data: function data() {
    return {
      alert: false,

      loading: false,
      filtersLoaded: false,

      showDialogCreate: false,

      newPushDialog: { style: 'classic' },

      overMenu: false,

      pushs: [],
      siteKey: '',
      resAjx: null,
      push_type: [{ text: this.$t('classic') + ' (pop-up)', value: 'classic' }, { text: this.$t('picture') + ' (1280 x 720 max)', value: 'picture' }, { text: 'HTML (code)', value: 'html' }]
    };
  },
  mounted: function mounted() {
    this.loading = true;
    this.init();
  },


  methods: {
    init: function init() {
      var _this = this;

      if (this.$store.state._User.entLevel !== '7' && this.$store.state._User.entOptionPush === 0) {
        this.alert = true;
      }
      this.loading = true;
      this.resAjx = null;
      this.pushs = [];

      this.axios.get('get/pushs.php').then(function (response) {
        _this.resAjx = response.data;
      }).then(function (_) {
        _this.loading = false;
        _this.initPush();
      }).catch();
    },
    openDialogCopy: function openDialogCopy(_id, _name) {
      var _this2 = this;

      if (confirm(this.$t('duplicate') + ' push (' + _name + ') ?')) {
        this.loading = true;

        var dataToPost = new window.FormData();
        dataToPost.append('id', _id);
        this.axios.post('post/duplicpush.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
          _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('duplicateSuccess'), context: 'success' });
        }).catch(function (_) {
          _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('error'), context: 'error' });
        }).then(function (_) {
          _this2.axios.get('get/pushs.php').then(function (response) {
            _this2.loading = false;
            _this2.resAjx = response.data;
            _this2.pushs = [];
            _this2.initPush();
          }).catch().then(function (_) {
            _this2.loading = false;
          });
        });
      }
    },
    openDialogDelete: function openDialogDelete(_id, _name) {
      var _this3 = this;

      if (confirm(this.$t('delete') + ' push (' + _name + ') ? ' + this.$t('attentionDeletePush'))) {
        this.loading = true;

        var dataToPost = new window.FormData();
        dataToPost.append('id', _id);
        this.axios.post('delete/push.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
          _this3.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this3.$t('deleteSuccess'), context: 'success' });
        }).catch(function (_) {
          _this3.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this3.$t('error'), context: 'error' });
        }).then(function (_) {
          _this3.axios.get('get/pushs.php').then(function (response) {
            _this3.loading = false;
            _this3.resAjx = response.data;
            _this3.pushs = [];
            _this3.initPush();
          }).catch().then(function (_) {
            _this3.loading = false;
          });
        });
      }
    },
    initPush: function initPush() {
      for (var n in this.resAjx) {
        this.pushs.push({ id: this.resAjx[n].PUSH_ID,
          name: this.resAjx[n].PUSH_NAME,
          type: this.resAjx[n].PUSH_STYLE,
          title: this.resAjx[n].PUSH_TITLE,
          content: this.resAjx[n].PUSH_MSG,
          img: this.resAjx[n].PUSH_IMG,
          vibra: this.resAjx[n].PUSH_VIBRA_ONOFF,
          vibraFreq: this.resAjx[n].PUSH_VIBRA_DURATION,
          picture: this.resAjx[n].PUSH_PICTURE,
          link: this.resAjx[n].PUSH_LINK,
          licId: this.resAjx[n].PUSH_LIC_ID,
          active: this.resAjx[n].PUSH_ONOFF,
          html: this.resAjx[n].PUSH_HTML,
          position: this.resAjx[n].PUSH_POSITION,
          posx: this.resAjx[n].PUSH_POSITION_X,
          posy: this.resAjx[n].PUSH_POSITION_Y,
          action: this.resAjx[n].PUSH_ACTION,
          overlay: this.resAjx[n].PUSH_OVERLAY
        });
        this.siteKey = this.resAjx[n].lickey;
      }
    },
    openDialogCreate: function openDialogCreate() {
      this.showDialogCreate = true;
    },
    submitDialogCreate: function submitDialogCreate() {
      var _this4 = this;

      this.showDialogCreate = false;

      var dataToPost = new window.FormData();
      dataToPost.append('newpush', stringify_default()(this.newPushDialog));

      this.axios.post('post/newpush.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this4.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this4.$t('creationSuccess'), context: 'success' });
        _this4.showPush(response.data.id);
      }).catch(function (_) {
        _this4.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this4.$t('creationFailure'), context: 'error' });
      });
    },
    showPush: function showPush(_id) {
      if (!this.overMenu) {
        this.$router.push({ path: '/media/pushs/' + _id });
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-46bdd110","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/media/Pushs.vue
var Pushs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.alert),expression:"alert"}],attrs:{"color":"secondary","icon":"warning","value":"true","outline":""}},[_vm._v("\n    "+_vm._s(_vm.$t('warningPushDisabled'))+"\n  ")]),_vm._v(" "),_c('div',{staticClass:"push"},[(_vm.loading)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_vm._e(),_vm._v(" "),_c('v-card',[_vm._l((_vm.pushs),function(push){return [_c('v-list',{key:push.id,attrs:{"dense":"","two-line":""}},[_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.showPush(push.id)}}},[_c('v-list-tile-avatar',[(push.type == 'picture')?_c('v-icon',[_vm._v("photo_size_select_large")]):(push.type == 'html')?_c('v-icon',[_vm._v("code")]):_c('v-icon',[_vm._v("announcement")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(push.name))]),_c('v-list-tile-sub-title',[_vm._v(_vm._s(push.type))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"icon"},nativeOn:{"mouseover":function($event){_vm.overMenu = true},"mouseleave":function($event){_vm.overMenu = false}},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.openDialogCopy(push.id,push.name)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("content_copy")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('duplicate')))+" push")])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.openDialogDelete(push.id,push.name)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('delete')))+" push")])],1)],1)],1)],1)],1)],1)],1)]})],2),_vm._v(" "),_c('v-fab-transition',[(!_vm.alert)?_c('v-btn',{staticClass:"secondary",attrs:{"dark":"","fab":"","fixed":"","bottom":"","right":""},nativeOn:{"click":function($event){$event.stopPropagation();return _vm.openDialogCreate($event)}}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.showDialogCreate),callback:function ($$v) {_vm.showDialogCreate=$$v},expression:"showDialogCreate"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('add')))+" push")]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('max:32'),expression:"'max:32'"}],attrs:{"autofocus":"","label":_vm._f("cap")(_vm.$t('name')),"counter":"","required":"","max":"32","data-vv-name":"newPushName"},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogCreate($event)}},model:{value:(_vm.newPushDialog.name),callback:function ($$v) {_vm.$set(_vm.newPushDialog, "name", $$v)},expression:"newPushDialog.name"}}),_vm._v(" "),_c('v-select',{attrs:{"label":_vm._f("cap")(_vm.$t('type')),"items":_vm.push_type},model:{value:(_vm.newPushDialog.style),callback:function ($$v) {_vm.$set(_vm.newPushDialog, "style", $$v)},expression:"newPushDialog.style"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.showDialogCreate = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","flat":""},nativeOn:{"click":function($event){return _vm.submitDialogCreate($event)}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1)],1)}
var Pushs_staticRenderFns = []
var Pushs_esExports = { render: Pushs_render, staticRenderFns: Pushs_staticRenderFns }
/* harmony default export */ var media_Pushs = (Pushs_esExports);
// CONCATENATED MODULE: ./src/components/media/Pushs.vue
var Pushs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Pushs___vue_template_functional__ = false
/* styles */
var Pushs___vue_styles__ = null
/* scopeId */
var Pushs___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Pushs___vue_module_identifier__ = null
var Pushs_Component = Pushs_normalizeComponent(
  Pushs,
  media_Pushs,
  Pushs___vue_template_functional__,
  Pushs___vue_styles__,
  Pushs___vue_scopeId__,
  Pushs___vue_module_identifier__
)

/* harmony default export */ var components_media_Pushs = (Pushs_Component.exports);

// EXTERNAL MODULE: ./src/assets/css/push_bo.css
var push_bo = __webpack_require__("ahAh");
var push_bo_default = /*#__PURE__*/__webpack_require__.n(push_bo);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/media/Push.vue







/* harmony default export */ var Push = ({
  props: ['id'],
  data: function data() {
    return {
      alert: false,

      loading: false,

      showDialogCreate: false,

      newPushDialog: { name: '', type: '', action: '' },

      imgLoading: false,
      overlayPreview: false,
      classicPreview: false,
      nonOverlayPreview: false,

      overMenu: false,

      push: { id: '',
        name: '',
        style: 'classic',
        title: '',
        content: '',
        img: '',
        vibra: '',
        vibraFreq: '',
        picture: '',
        link: '',
        licId: '',
        active: '',
        html: '',
        position: '',
        posx: '',
        posy: '',
        action: '',
        overlay: ''
      },
      resAjx: null,
      push_type: [{ text: this.$t('classic') + ' (pop-up)', value: 'classic' }, { text: this.$t('picture') + ' (1280 x 720 max)', value: 'picture' }, { text: 'HTML (code)', value: 'html' }],
      imgpush: [{ text: this.$t('none'), value: 'blankpix.png' }, { text: this.$t('woman'), value: 'natasha.png' }, { text: this.$t('man'), value: 'kevin.png' }],
      action: [{ text: lodash_default.a.upperFirst(this.$t('doNothing')), value: '' }, { text: lodash_default.a.upperFirst(this.$t('openURL')), value: 'link' }, { text: lodash_default.a.upperFirst(this.$t('deployTargetFirst')), value: 'deploy' }, { text: lodash_default.a.upperFirst(this.$t('show')) + ' Target First ' + this.$t('retractedMode'), value: 'appear_retracted' }, { text: lodash_default.a.upperFirst(this.$t('show')) + ' Target First ' + this.$t('deployedMode'), value: 'appear_deployed' }, { text: lodash_default.a.upperFirst(this.$t('show')) + ' click to call', value: 'C2C' }]
    };
  },
  mounted: function mounted() {
    var _this = this;

    this.loading = true;
    var dataToGet = new window.FormData();
    dataToGet.append('pushId', this.id);
    if (this.$store.state._User.entLevel !== '7' && this.$store.state._User.entOptionPush === 0) {
      this.alert = true;
    }
    this.axios.post('get/pushs.php', dataToGet, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
      _this.resAjx = response.data;
      _this.loading = false;
      _this.initPush();
      _this.getColor();
    }).catch();
  },

  computed: {
    srcData: function srcData() {
      if (false) {
        return DOMAINE + '/dev/media/push/';
      } else {
        return constants_DOMAINE + '/media/push/';
      }
    }
  },

  methods: {
    initPush: function initPush() {
      var _title = this.resAjx.PUSH_TITLE.replace('||||', '');
      var _content = this.resAjx.PUSH_MSG.replace('||||', '');
      if (this.resAjx && this.resAjx !== '') {
        this.push = {
          id: this.resAjx.PUSH_ID,
          name: this.resAjx.PUSH_NAME,
          title: _title,
          content: _content,
          img: this.resAjx.PUSH_IMG,
          vibra: this.resAjx.PUSH_VIBRA_ONOFF,
          vibraFreq: this.resAjx.PUSH_VIBRA_DURATION,
          picture: this.resAjx.PUSH_PICTURE,
          link: this.resAjx.PUSH_LINK,
          licId: this.resAjx.PUSH_LIC_ID,
          active: this.resAjx.PUSH_ONOFF,
          html: this.resAjx.PUSH_HTML,
          position: lodash_default.a.toLower(this.resAjx.PUSH_POSITION),
          posx: this.resAjx.PUSH_POSITION_X,
          posy: this.resAjx.PUSH_POSITION_Y,
          action: this.resAjx.PUSH_ACTION,
          style: this.resAjx.PUSH_STYLE,
          overlay: this.resAjx.PUSH_OVERLAY === '1'
        };
      }
      this.$store.commit('_Toolbar/SET_SUB_TITLE', this.push.name);
    },
    submit: function submit() {
      var _this2 = this;

      var dataToPost = new window.FormData();
      dataToPost.append('push', stringify_default()(this.push));
      this.axios.post('put/push.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('modifSuccess'), context: 'success' });
      }).catch(function (_) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('modifFailure'), context: 'error' });
      }).then(function (_) {});
    },

    options: {},
    imageuploading: function imageuploading(res) {
      if (res.errcode !== 0) {
        this.imgLoading = true;
      }
    },
    saveImg: function saveImg(filename) {
      var _this3 = this;

      this.imgLoading = true;

      var dataToPost = new window.FormData();
      dataToPost.append('url', filename);
      dataToPost.append('push_id', this.push.id);
      this.axios.post('put/push_picture.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this3.push.picture = response.data;

        _this3.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this3.$t('modifSuccess'), context: 'success' });
      }).catch(function (e) {
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this3.$t('modifFailure'), context: 'error' });
        console.log(e);
      }).then(function (_) {
        _this3.imgLoading = false;
      });
    },
    renderPush: function renderPush() {
      if (this.push.style !== 'classic') {
        if (this.push.overlay) {
          this.overlayPreview = true;
          this.nonOverlayPreview = false;
        } else {
          this.overlayPreview = false;
          this.nonOverlayPreview = true;
        }
      }
      if (this.push.style === 'classic') {
        var classicPush = '';

        classicPush += '<div id="mydesk-push" class="push_Right mydesk-push">';
        classicPush += '<div id="closePush" class="hidePush"></div>';
        classicPush += '<div id="standard_push">';
        classicPush += '<div id="mydesk-push-photo" class="mydesk-push-photo-right">';
        classicPush += '<img id="agent_photo" src="' + AWSS3_STATIC + '/img/hotesses/' + this.push.img + '"';
        classicPush += '>';
        classicPush += '</div>';
        classicPush += '<div class="mydesk-text-push"><p class="mydesk-title-push" id="mydesk-title-push" >';
        classicPush += this.push.title;
        classicPush += '</p>';
        classicPush += '<p class="mydesk-content-push" id="mydesk-content-push" >';
        classicPush += this.push.content;
        classicPush += '</p></div></div></div>';
        document.getElementById('classic').innerHTML = classicPush;
        this.classicPreview = true;
        this.getColor();
      } else {
        this.classicPreview = false;
        var content = '';
        if (this.push.style === 'html') {
          if (this.push.position === 'center') {
            content = '<div id="pushPicture" ><div class="pushclose" id="pushclose" title="Close" ><svg version="1.1" id="removeImg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" enable-background="new 0 0 30 30" xml:space="preserve"><title></title><polygon fill="#FFFFFF" points="28.3,2.4 27.6,1.7 15,14.3 2.4,1.7 1.7,2.4 14.3,15 1.7,27.6 2.4,28.3 15,15.7 27.6,28.3 28.3,27.6 15.7,15 "></polygon></svg></div><div id="custom_push_content">' + this.push.html + '</div></div>';
          } else {
            content = '<div id="pushPicture" style="top:' + this.push.posy + 'px;left:' + this.push.posx + 'px" ><div class="pushclose" id="pushclose" title="Close" ><svg version="1.1" id="removeImg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" enable-background="new 0 0 30 30" xml:space="preserve"><title></title><polygon fill="#000000" points="28.3,2.4 27.6,1.7 15,14.3 2.4,1.7 1.7,2.4 14.3,15 1.7,27.6 2.4,28.3 15,15.7 27.6,28.3 28.3,27.6 15.7,15 "></polygon></svg></div><div id="custom_push_content">' + this.push.html + '</div></div>';
          }
        }

        if (this.push.style === 'picture') {
          if (this.push.position === 'center') {
            content = '<div id="pushPicture"  ><div class="pushclose" id="pushclose" title="Close" ><svg version="1.1" id="removeImg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" enable-background="new 0 0 30 30" xml:space="preserve"><title></title><polygon fill="#000000" points="28.3,2.4 27.6,1.7 15,14.3 2.4,1.7 1.7,2.4 14.3,15 1.7,27.6 2.4,28.3 15,15.7 27.6,28.3 28.3,27.6 15.7,15 "></polygon></svg></div><img class="pushCenterImage" src="' + this.srcData + this.push.picture + '?' + Math.random() + '" ></div>';
          } else {
            content = '<div id="pushPicture" style="top:' + this.push.posy + 'px;left:' + this.push.posx + 'px" ><div class="pushclose" id="pushclose" title="Close" ><svg version="1.1" id="removeImg" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 30 30" enable-background="new 0 0 30 30" xml:space="preserve"><title></title><polygon fill="#FFFFFF" points="28.3,2.4 27.6,1.7 15,14.3 2.4,1.7 1.7,2.4 14.3,15 1.7,27.6 2.4,28.3 15,15.7 27.6,28.3 28.3,27.6 15.7,15 "></polygon></svg></div><img src="' + this.srcData + this.push.picture + '?' + Math.random() + '" ></div>';
          }
        }
        if (this.push.overlay) {
          document.getElementById('mydesk-push-non-overlay').innerHTML = '';
          document.getElementById('mydesk-push-overlay').innerHTML = content;
        } else {
          document.getElementById('mydesk-push-overlay').innerHTML = '';
          document.getElementById('mydesk-push-non-overlay').innerHTML = content;
        }
      }
    },
    hideRenderPush: function hideRenderPush() {
      this.overlayPreview = false;
      this.nonOverlayPreview = false;
      this.classicPreview = false;
    },
    getColor: function getColor() {
      var _this4 = this;

      this.axios.get('get/settings_preview.php?desk=' + this.$store.state._Sites.siteSelected.LIC_DSK_ID).then(function (res) {
        _this4.options.DSK_COLORS = res.data.DSK_COLORS.split('|');
        if (document.getElementById('mydesk-title-push')) {
          document.getElementById('mydesk-title-push').style.color = '#' + _this4.options.DSK_COLORS[5];
        }
        if (document.getElementById('mydesk-content-push')) {
          document.getElementById('mydesk-content-push').style.color = '#' + _this4.options.DSK_COLORS[5];
        }
        if (document.getElementById('mydesk-title-push')) {
          document.getElementById('mydesk-title-push').style.background = '#' + _this4.options.DSK_COLORS[0];
        }
        if (document.getElementById('mydesk-push')) {
          document.getElementById('mydesk-push').style.background = '#' + _this4.options.DSK_COLORS[1];
          document.getElementById('closePush').style.backgroundColor = '#' + _this4.options.DSK_COLORS[1];
        }
      });
    }
  },
  watch: {
    '$store.state._Sites.siteSelected': function $storeState_SitesSiteSelected() {
      this.getColor();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9031085e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/media/Push.vue
var Push_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('v-tabs',{attrs:{"icons-and-text":"","centered":"","slider-color":"secondary","color":"primary","dark":""}},[_c('v-tab',{attrs:{"href":"#tab-1"},nativeOn:{"click":function($event){return _vm.hideRenderPush($event)}}},[_vm._v("\n          Description\n          "),_c('v-icon',[_vm._v("description")])],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-2"},nativeOn:{"click":function($event){return _vm.hideRenderPush($event)}}},[_vm._v("\n          "+_vm._s(_vm.$t('behaviour'))+"\n          "),_c('v-icon',[_vm._v("pages")])],1),_vm._v(" "),_c('v-tab',{attrs:{"href":"#tab-3"},nativeOn:{"click":function($event){return _vm.renderPush($event)}}},[_vm._v("\n          "+_vm._s(_vm.$t('preview'))+"\n          "),_c('v-icon',[_vm._v("movie_filter")])],1),_vm._v(" "),_c('v-tab-item',{key:"1",attrs:{"id":"tab-1"}},[_c('v-card',[_c('v-card-text',[_c('v-subheader',[_vm._v("Push")]),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('name'))},model:{value:(_vm.push.name),callback:function ($$v) {_vm.$set(_vm.push, "name", $$v)},expression:"push.name"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.push_type,"label":_vm._f("cap")(_vm.$t('type')),"auto":""},model:{value:(_vm.push.style),callback:function ($$v) {_vm.$set(_vm.push, "style", $$v)},expression:"push.style"}})],1)],1),_vm._v(" "),_c('v-subheader',[_vm._v("Pop-up")]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.push.style == 'classic'),expression:"push.style == 'classic'"}]},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('title'))},model:{value:(_vm.push.title),callback:function ($$v) {_vm.$set(_vm.push, "title", $$v)},expression:"push.title"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('message'))},model:{value:(_vm.push.content),callback:function ($$v) {_vm.$set(_vm.push, "content", $$v)},expression:"push.content"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.imgpush,"label":_vm.$t('whichImgDisplay'),"auto":""},model:{value:(_vm.push.img),callback:function ($$v) {_vm.$set(_vm.push, "img", $$v)},expression:"push.img"}})],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.push.style == 'picture' || _vm.push.style == 'html'),expression:"push.style == 'picture' || push.style == 'html'"}]},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-switch',{attrs:{"label":'Overlay ' + _vm.$t('enabled') + '? (fond opaque)',"color":"primary"},model:{value:(_vm.push.overlay),callback:function ($$v) {_vm.$set(_vm.push, "overlay", $$v)},expression:"push.overlay"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-radio-group',{attrs:{"hint":"Position","persistent-hint":""},model:{value:(_vm.push.position),callback:function ($$v) {_vm.$set(_vm.push, "position", $$v)},expression:"push.position"}},[_c('v-radio',{attrs:{"color":"primary","label":_vm.$t('center'),"value":"center"}}),_vm._v(" "),_c('v-radio',{attrs:{"color":"primary","label":_vm.$tc('custom', 2, { count: '' }),"value":"custom"}})],1)],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.push.position === 'custom'),expression:"push.position === 'custom'"}],attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',[_vm._v("Position X sur la page : "+_vm._s(_vm.push.posx)+" px (du bord gauche)")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":""}},[_c('v-slider',{attrs:{"thumb-label":"","min":"0","max":"2000"},model:{value:(_vm.push.posx),callback:function ($$v) {_vm.$set(_vm.push, "posx", $$v)},expression:"push.posx"}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.push.position === 'custom'),expression:"push.position === 'custom'"}],attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',[_vm._v("Position Y sur la page : "+_vm._s(_vm.push.posy)+" px (du bord haut)")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","sm5":""}},[_c('v-slider',{attrs:{"thumb-label":"","min":"0","max":"2000"},model:{value:(_vm.push.posy),callback:function ($$v) {_vm.$set(_vm.push, "posy", $$v)},expression:"push.posy"}})],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.push.style == 'picture'),expression:"push.style == 'picture'"}]},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md4":""}},[_c('wz-file-selector',{on:{"change":_vm.saveImg}})],1)],1)],1),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.push.style == 'html'),expression:"push.style == 'html'"}]},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm9":"","md6":""}},[_c('v-text-field',{staticClass:"code-HTML",attrs:{"textarea":"","name":"input-1","auto-grow":"","label":"Code HTML du push","multi-line":""},model:{value:(_vm.push.html),callback:function ($$v) {_vm.$set(_vm.push, "html", $$v)},expression:"push.html"}})],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:"2",attrs:{"id":"tab-2"}},[_c('v-card',{attrs:{"flat":"","id":"tab-2"}},[_c('v-card-text',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.action,"label":_vm._f("cap")(_vm.$t('clickToAction')),"small":"","auto":""},model:{value:(_vm.push.action),callback:function ($$v) {_vm.$set(_vm.push, "action", $$v)},expression:"push.action"}})],1)],1),_vm._v(" "),_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(_vm.push.action === 'link'),expression:"push.action === 'link'"}],attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","sm5":""}},[_c('v-text-field',{attrs:{"label":"URL"},model:{value:(_vm.push.link),callback:function ($$v) {_vm.$set(_vm.push, "link", $$v)},expression:"push.link"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:"3",attrs:{"id":"tab-3"}},[_c('v-card',{attrs:{"flat":"","id":"tab-3"}},[_c('v-card-text',[_c('v-dialog',{model:{value:(_vm.overlayPreview),callback:function ($$v) {_vm.overlayPreview=$$v},expression:"overlayPreview"}},[_c('div',{attrs:{"id":"mydesk-push-overlay"},on:{"click":_vm.hideRenderPush}})]),_vm._v(" "),_c('v-dialog',{attrs:{"hide-overlay":""},model:{value:(_vm.nonOverlayPreview),callback:function ($$v) {_vm.nonOverlayPreview=$$v},expression:"nonOverlayPreview"}},[_c('div',{attrs:{"id":"mydesk-push-non-overlay"},on:{"click":_vm.hideRenderPush}})]),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.classicPreview),expression:"classicPreview"}],staticClass:"push_Bottom position_bottom_right mydesk-push",attrs:{"id":"classic"}})],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{model:{value:(_vm.showDialogCreate),callback:function ($$v) {_vm.showDialogCreate=$$v},expression:"showDialogCreate"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v("Description HTML")]),_vm._v(" "),_c('v-flex',{attrs:{"xs4":""}},[_c('v-text-field',{attrs:{"name":"input-1","label":"Coller ici vos nouveaux scénarii (XML)","textarea":""}})],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"color":"primary","fixed":"","bottom":"","right":"","disabled":_vm.alert},nativeOn:{"click":function($event){return _vm.submit($event)}}},[_vm._v("\n        "+_vm._s(_vm.$t('save'))+"\n        "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("send")])],1)],1)],1)}
var Push_staticRenderFns = []
var Push_esExports = { render: Push_render, staticRenderFns: Push_staticRenderFns }
/* harmony default export */ var media_Push = (Push_esExports);
// CONCATENATED MODULE: ./src/components/media/Push.vue
function Push_injectStyle (ssrContext) {
  __webpack_require__("iltA")
}
var Push_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Push___vue_template_functional__ = false
/* styles */
var Push___vue_styles__ = Push_injectStyle
/* scopeId */
var Push___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Push___vue_module_identifier__ = null
var Push_Component = Push_normalizeComponent(
  Push,
  media_Push,
  Push___vue_template_functional__,
  Push___vue_styles__,
  Push___vue_scopeId__,
  Push___vue_module_identifier__
)

/* harmony default export */ var components_media_Push = (Push_Component.exports);

// EXTERNAL MODULE: ./node_modules/vuedraggable/dist/vuedraggable.js
var vuedraggable = __webpack_require__("DAYN");
var vuedraggable_default = /*#__PURE__*/__webpack_require__.n(vuedraggable);

// EXTERNAL MODULE: ./src/assets/css/dragndrop.css
var dragndrop = __webpack_require__("Xqa9");
var dragndrop_default = /*#__PURE__*/__webpack_require__.n(dragndrop);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzChooseLayoutFicheVisiteur.vue







/* harmony default export */ var WzChooseLayoutFicheVisiteur = ({
  components: {
    draggable: vuedraggable_default.a
  },
  data: function data() {
    return {
      items: null,
      options: {
        handle: '.drag-handle',
        ghostClass: 'drag-ghost',
        animation: 100
      }
    };
  },
  mounted: function mounted() {
    var itemsFromCookie = JSON.parse(this.$cookie.get('wz-fiche-visiteur'));
    this.items = itemsFromCookie || lodash_default.a.cloneDeep(FORM_LAYOUT);
  },


  methods: {
    up: function up(index) {
      if (index === 0) {
        return;
      }
      var newIndex = index--;
      this.swap(index, newIndex);
    },
    down: function down(index) {
      if (index === this.items.length - 1) {
        return;
      }
      var newIndex = index++;
      this.swap(index, newIndex);
    },
    swap: function swap(src, dest) {
      var itemTmp = lodash_default.a.cloneDeep(this.items[dest]);
      this.items.splice(dest, 1, this.items[src]);
      this.items.splice(src, 1, itemTmp);
      this.writecookie();
    },
    reset: function reset() {
      this.$cookie.delete('wz-fiche-visiteur');
      this.items = lodash_default.a.cloneDeep(FORM_LAYOUT);
      this.writecookie();
    },
    writecookie: function writecookie() {
      this.$cookie.set('wz-fiche-visiteur', stringify_default()(this.items), {
        expires: '1Y'
      });
      this.$emit('update');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31e33224","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzChooseLayoutFicheVisiteur.vue
var WzChooseLayoutFicheVisiteur_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-card-text',[_c('v-list',{attrs:{"dense":"","subheader":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('editFicheLayout')))]),_vm._v(" "),(true)?_c('v-btn',{attrs:{"small":"","flat":""},on:{"click":function($event){_vm.reset()}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("settings_backup_restore")]),_vm._v("\n          "+_vm._s(_vm.$t('cancel'))+"\n        ")],1):_vm._e(),_vm._v(" "),_c('draggable',{attrs:{"options":_vm.options},on:{"change":function($event){_vm.writecookie()}},model:{value:(_vm.items),callback:function ($$v) {_vm.items=$$v},expression:"items"}},[_c('transition-group',{attrs:{"name":"slide-x-transition"}},_vm._l((_vm.items),function(item,i){return _c('v-list-tile',{key:item.title},[_c('v-list-tile-action',[_c('v-checkbox',{attrs:{"slot":"activator"},on:{"change":function($event){_vm.writecookie()}},slot:"activator",model:{value:(item.show),callback:function ($$v) {_vm.$set(item, "show", $$v)},expression:"item.show"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc(item.title, 2, {count: ''}))))])],1),_vm._v(" "),(false)?_c('v-list-tile-action',[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"mr-2"},[_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){_vm.down(i)}}},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("arrow_downward")])],1)],1),_vm._v(" "),_c('v-flex',{staticClass:"mr-2"},[_c('v-btn',{attrs:{"small":"","icon":""},on:{"click":function($event){_vm.up(i)}}},[_c('v-icon',{attrs:{"color":"green"}},[_vm._v("arrow_upward")])],1)],1),_vm._v(" "),_c('v-flex',[_c('v-btn',{staticClass:"drag-handle",attrs:{"small":"","icon":""}},[_c('v-icon',[_vm._v("drag_indicator")])],1)],1)],1)],1):_vm._e()],1)}),1)],1)],1)],1)],1)}
var WzChooseLayoutFicheVisiteur_staticRenderFns = []
var WzChooseLayoutFicheVisiteur_esExports = { render: WzChooseLayoutFicheVisiteur_render, staticRenderFns: WzChooseLayoutFicheVisiteur_staticRenderFns }
/* harmony default export */ var watcheezy_WzChooseLayoutFicheVisiteur = (WzChooseLayoutFicheVisiteur_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzChooseLayoutFicheVisiteur.vue
var WzChooseLayoutFicheVisiteur_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzChooseLayoutFicheVisiteur___vue_template_functional__ = false
/* styles */
var WzChooseLayoutFicheVisiteur___vue_styles__ = null
/* scopeId */
var WzChooseLayoutFicheVisiteur___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzChooseLayoutFicheVisiteur___vue_module_identifier__ = null
var WzChooseLayoutFicheVisiteur_Component = WzChooseLayoutFicheVisiteur_normalizeComponent(
  WzChooseLayoutFicheVisiteur,
  watcheezy_WzChooseLayoutFicheVisiteur,
  WzChooseLayoutFicheVisiteur___vue_template_functional__,
  WzChooseLayoutFicheVisiteur___vue_styles__,
  WzChooseLayoutFicheVisiteur___vue_scopeId__,
  WzChooseLayoutFicheVisiteur___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzChooseLayoutFicheVisiteur = (WzChooseLayoutFicheVisiteur_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Profile.vue









/* harmony default export */ var Profile = ({
  components: {
    WzChooseLayoutFicheVisiteur: components_watcheezy_WzChooseLayoutFicheVisiteur
  },
  data: function data() {
    return {
      name: 'Mon profil',

      dialog: false,

      userDialog: { title: '' },

      imgLoading: false,

      dialogAlert: false,
      showFab: false,
      isSubscribed: false,
      swRegistration: null,
      applicationServerPublicKey: null,
      refreshBtn: false,
      souscriptionBtn: false,
      souscriptionBtnTxt: this.$t('disablePushMessaging'),
      subscriptionDetail: null,
      testNotifBtnTxt: this.$t('btnTestPushMessaging'),
      dialogProgress: false
    };
  },
  created: function created() {
    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'profile';
    } else {
      setTimeout(function () {
        if (typeof defautMotif !== 'undefined') {
          defautMotif = 'profile';
        }
      }, 800);
    }
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])('_User', ['setUser', 'setAvatar']), {
    save: function save() {
      var _this = this;

      var dataToPost = new window.FormData();
      dataToPost.append('user_first_name', this.userDialog.fname);
      dataToPost.append('user_last_name', this.userDialog.lname);
      dataToPost.append('user_mail', this.userDialog.mail);
      dataToPost.append('user_mail_contact', this.userDialog.mailContact);
      dataToPost.append('user_title', this.userDialog.title);
      dataToPost.append('user_tel', this.userDialog.phone);
      dataToPost.append('user_job', this.userDialog.job);
      dataToPost.append('ENT_ID', this.$store.state._User.entId);

      var steps = JSON.parse(this.$store.state._User.remainingSteps);

      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_PROFILE')) {
        steps.splice(steps.indexOf('INS_PROFILE'), 1);

        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: stringify_default()(steps)
        });
      }

      if (!lodash_default.a.isEqual(this.user, this.userDialog)) {
        this.loading = true;
        this.axios.post('put/user.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
          var avatar = _this.user.avatar;
          _this.setUser(lodash_default.a.clone(_this.userDialog));
          _this.setAvatar(avatar);
          _this.$cookie.set('wz-lang', _this.userDialog.lang, { expires: '1Y' });

          _this.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this.$t('modifSuccess'), context: 'success' });
        }).catch(function (_) {
          _this.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this.$t('modifFailure'), context: 'error' });
        }).then(function (_) {
          _this.loading = false;
          _this.dialog = false;
        });
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('noChange'), context: 'warning' });
      }
    },
    cancel: function cancel() {
      this.dialog = false;
    },
    openDialog: function openDialog() {
      this.dialog = true;

      this.userDialog = lodash_default.a.clone(this.user);
    },
    updateLang: function updateLang(newLang) {
      this.userDialog.lang = newLang;
    },
    saveImg: function saveImg(filename) {
      var _this2 = this;

      if (!filename) {
        this.deleteImg();
        return;
      }
      this.imgLoading = true;

      var dataToPost = new window.FormData();
      dataToPost.append('url', filename);
      this.axios.post('put/user_picture.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this2.setAvatar(_this2.user.id + '_avatar.jpg');

        _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Changement d\'image r\xE9ussie', context: 'success' });
      }).catch(function (_) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Changement d\'image \xE9chou\xE9e', context: 'error' });
      }).then(function (_) {
        _this2.imgLoading = false;
      });
    },
    deleteImg: function deleteImg() {
      var _this3 = this;

      var dataToPost = new window.FormData();
      dataToPost.append('url', null);
      this.axios.post('put/user_picture.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this3.userDialog.avatar = null;
        _this3.setAvatar(_this3.userDialog.avatar);

        _this3.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Image supprimée', context: 'success' });
      }).catch(function (errors) {
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Erreur lors de la suppression', context: 'error' });
      });
    },
    initializeUI: function initializeUI() {
      var _this4 = this;

      this.swRegistration.pushManager.getSubscription().then(function (subscription) {
        _this4.isSubscribed = !(subscription === null);
        _this4.updateSubscriptionOnServer(subscription);
        if (_this4.isSubscribed) {
          console.log('User IS subscribed.');
        } else {
          console.log('User is NOT subscribed.');
          _this4.subscribeUser();
        }
        _this4.updateBtn();
      });
    },
    updateBtn: function updateBtn() {
      if (Notification.permission === 'denied') {
        this.souscriptionBtnTxt = this.$t('pushMessagingBlocked');
        this.souscriptionBtn = false;
        this.updateSubscriptionOnServer(null);
        return;
      }
      if (this.isSubscribed) {
        this.souscriptionBtnTxt = this.$t('disablePushMessaging');
      } else {
        this.souscriptionBtnTxt = this.$t('enablePushMessaging');
      }
    },
    souscriptionPush: function souscriptionPush() {
      if (this.isSubscribed) {
        this.unsubscribeUser();
      } else {
        this.subscribeUser();
      }
    },
    subscribeUser: function subscribeUser() {
      var _this5 = this;

      console.log('this.applicationServerPublicKey.public', this.applicationServerPublicKey.public);
      var applicationServerKey = this.base64UrlToUint8Array(this.applicationServerPublicKey.public);
      this.swRegistration.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: applicationServerKey
      }).then(function (subscription) {
        console.log('User is subscribed.');
        _this5.updateSubscriptionOnServer(subscription);
        _this5.isSubscribed = true;
        _this5.updateBtn();

        watcheebox_watcheebox.saveDataWebPush(stringify_default()({
          subscription: subscription,
          applicationKeys: {
            publicKey: _this5.applicationServerPublicKey.public,
            privateKey: _this5.applicationServerPublicKey.private
          }
        }));
      }).catch(function (err) {
        console.log('Failed to subscribe the user: ', err);
        _this5.updateBtn();
      });
    },
    unsubscribeUser: function unsubscribeUser() {
      var _this6 = this;

      this.swRegistration.pushManager.getSubscription().then(function (subscription) {
        if (subscription) {
          return subscription.unsubscribe();
        }
      }).catch(function (error) {
        console.log('Error unsubscribing', error);
      }).then(function () {
        _this6.updateSubscriptionOnServer(null);
        console.log('User is unsubscribed.');
        _this6.isSubscribed = false;
        _this6.updateBtn();
      });
    },
    updateSubscriptionOnServer: function updateSubscriptionOnServer(subscription) {
      console.log('updateSubscriptionOnServer', subscription);
      if (subscription) {
        this.subscriptionDetail = stringify_default()(subscription);
        window.localStorage.setItem('server-subscription', stringify_default()(subscription));
      } else {
        window.localStorage.removeItem('server-subscription');
      }
    },
    initialiseKeys: function initialiseKeys() {
      console.log('--> initialiseKeys');
      this.updateKeys();
    },
    getNewKey: function getNewKey() {
      this.clearKeys();
      this.updateKeys();
    },
    updateKeys: function updateKeys() {
      var _this7 = this;

      var storedKeys = this.getStoredKeys();
      var promiseChain = promise_default.a.resolve(storedKeys);
      if (!storedKeys) {
        promiseChain = this.generateNewKeys().then(function (newKeys) {
          _this7.storeKeys(newKeys);
          _this7.applicationServerPublicKey = newKeys;
          return newKeys;
        });
      }

      return promiseChain.then(function (keys) {
        _this7.applicationServerPublicKey = keys;
        _this7.displayKeys(keys);
      });
    },
    displayKeys: function displayKeys(keys) {
      if (document.querySelector('.js-public-key')) {
        var publicElement = document.querySelector('.js-public-key');
        publicElement.textContent = keys.public;
      }
      if (document.querySelector('.js-private-key')) {
        var privateElement = document.querySelector('.js-private-key');
        privateElement.textContent = keys.private;
      }

      this.refreshBtn = true;
    },
    generateNewKeys: function generateNewKeys() {
      var _this8 = this;

      return crypto.subtle.generateKey({ name: 'ECDH', namedCurve: 'P-256' }, true, ['deriveBits']).then(function (keys) {
        return _this8.cryptoKeyToUrlBase64(keys.publicKey, keys.privateKey);
      });
    },
    clearKeys: function clearKeys() {
      window.localStorage.removeItem('server-keys');
    },
    storeKeys: function storeKeys(keys) {
      window.localStorage.setItem('server-keys', stringify_default()(keys));
    },
    getStoredKeys: function getStoredKeys() {
      var storage = window.localStorage.getItem('server-keys');
      if (storage) {
        return JSON.parse(storage);
      }
      return null;
    },
    base64UrlToUint8Array: function base64UrlToUint8Array(base64UrlData) {
      var padding = '='.repeat((4 - base64UrlData.length % 4) % 4);
      var base64 = (base64UrlData + padding).replace(/-/g, '+').replace(/_/g, '/');

      var rawData = window.atob(base64);
      var buffer = new Uint8Array(rawData.length);

      for (var i = 0; i < rawData.length; ++i) {
        buffer[i] = rawData.charCodeAt(i);
      }
      return buffer;
    },
    uint8ArrayToBase64Url: function uint8ArrayToBase64Url(uint8Array, start, end) {
      start = start || 0;
      end = end || uint8Array.byteLength;

      var base64 = window.btoa(String.fromCharCode.apply(null, uint8Array.subarray(start, end)));
      return base64.replace(/\=/g, '').replace(/\+/g, '-').replace(/\//g, '_');
    },
    cryptoKeyToUrlBase64: function cryptoKeyToUrlBase64(publicKey, privateKey) {
      var _this9 = this;

      var promises = [];
      promises.push(crypto.subtle.exportKey('jwk', publicKey).then(function (jwk) {
        var x = _this9.base64UrlToUint8Array(jwk.x);
        var y = _this9.base64UrlToUint8Array(jwk.y);

        var publicKey = new Uint8Array(65);
        publicKey.set([0x04], 0);
        publicKey.set(x, 1);
        publicKey.set(y, 33);

        return publicKey;
      }));

      promises.push(crypto.subtle.exportKey('jwk', privateKey).then(function (jwk) {
        return _this9.base64UrlToUint8Array(jwk.d);
      }));

      return promise_default.a.all(promises).then(function (exportedKeys) {
        return {
          public: _this9.uint8ArrayToBase64Url(exportedKeys[0]),
          private: _this9.uint8ArrayToBase64Url(exportedKeys[1])
        };
      });
    },
    sendNotif: function sendNotif() {
      var subscriptionString = this.subscriptionDetail.trim();
      var contentString = this.$t('contentNotif');
      var titleString = this.$t('titleNotif');

      this.saveDetails({
        subscription: subscriptionString,
        data: {
          title: titleString,
          content: contentString
        }
      });

      if (subscriptionString.length === 0) {
        return promise_default.a.reject(new Error('Please provide a push subscription.'));
      }

      var subscriptionObject = null;
      try {
        subscriptionObject = JSON.parse(subscriptionString);
      } catch (err) {
        return promise_default.a.reject(new Error('Unable to parse subscription as JSON'));
      }

      if (!subscriptionObject.endpoint) {
        return promise_default.a.reject(new Error('The subscription MUST have an endpoint'));
      }

      if (subscriptionObject.endpoint.indexOf('…') !== -1) {
        return promise_default.a.reject(new Error('The subscription endpoint appears to be ' + 'truncated (It has \'...\' in it).\n\nDid you copy it from the console ' + 'in Chrome?'));
      }

      watcheebox_watcheebox.sendWebPush(stringify_default()({
        subscription: subscriptionObject,
        data: {
          title: titleString,
          content: contentString
        },
        applicationKeys: {
          publicKey: this.applicationServerPublicKey.public,
          privateKey: this.applicationServerPublicKey.private
        }
      }));
    },
    saveDetails: function saveDetails(details) {
      window.localStorage.setItem('last-known-details', stringify_default()(details));
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    }
  }),

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'fullName', 'userAvatar', 'account']), {
    heightOfCard: function heightOfCard() {
      return 'height: ' + (window.innerHeight - 200) + 'px';
    }
  }),

  mounted: function mounted() {
    var _this10 = this;

    this.showFab = true;
    if ('serviceWorker' in navigator && 'PushManager' in window) {
      console.log('Service Worker and Push is supported');
      var dir =  false ? '/watcheezy/' : '/';
      navigator.serviceWorker.register(dir + 'service-worker.js', {
        scope: '.' }).then(function (swReg) {
        console.log('Service Worker is registered', swReg.scope);
        _this10.souscriptionBtn = true;
        _this10.swRegistration = swReg;
        _this10.initializeUI();
      }).catch(function (error) {
        console.error('Service Worker Error', error);
        _this10.souscriptionBtn = false;
      });
    } else {
      console.warn('Push messaging is not supported');
      this.souscriptionBtn = false;
    }
    this.initialiseKeys();
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0d345b2d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profile.vue
var Profile_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"profile"},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"xs12"},[_c('v-card',{staticClass:"primary white--text",attrs:{"height":"200px"}},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs5":""}},[_c('wz-avatar',{attrs:{"src":_vm.userAvatar,"username":_vm.fullName,"size":"128px"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs7":""}},[_c('div',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.fullName))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.account.type))])])])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticStyle:{"padding":"0px","position":"relative"}},[_c('v-fab-transition',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFab),expression:"showFab"}],attrs:{"color":"secondary","dark":"","absolute":"","bottom":"","right":"","fab":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.openDialog()}}},[_c('v-icon',[_vm._v("edit")])],1)],1)],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":"","dense":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('yourInfos'))))]),_vm._v(" "),(_vm.user.job)?_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("assignment_ind")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.user.job))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('job'))))])],1)],1):_vm._e(),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("mail")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.user.mail))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('loginEmail'))))])],1)],1),_vm._v(" "),(_vm.user.mailContact)?_c('v-list-tile',[_c('v-list-tile-action'),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.user.mailContact))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('contactEmail'))))])],1)],1):_vm._e(),_vm._v(" "),(_vm.user.phone)?_c('v-divider',{attrs:{"inset":""}}):_vm._e(),_vm._v(" "),(_vm.user.phone)?_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.user.phone))])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","block":_vm.$vuetify.breakpoint.xsOnly,"disabled":!_vm.souscriptionBtn},nativeOn:{"click":function($event){_vm.souscriptionPush()}}},[_vm._v(_vm._s(_vm.souscriptionBtnTxt)+"\n          "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("notifications")])],1),_vm._v(" "),(_vm.isSubscribed)?_c('section',{staticClass:"subscription-details js-subscription-details "},[_c('p',[_c('v-btn',{attrs:{"color":"primary","flat":"","dark":"","block":_vm.$vuetify.breakpoint.xsOnly},nativeOn:{"click":function($event){_vm.sendNotif()}}},[_vm._v(_vm._s(_vm.testNotifBtnTxt)+"\n            "),_c('v-icon',{staticClass:"primary--text",attrs:{"right":""}},[_vm._v("send")])],1)],1)]):_vm._e()],1)],1),_vm._v(" "),(_vm.account.role !== 'admin')?_c('v-flex',{staticClass:"xs12"},[_c('wz-choose-layout-fiche-visiteur')],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"600px","scrollable":!_vm.$vuetify.breakpoint.smAndDown,"fullscreen":_vm.$vuetify.breakpoint.smAndDown},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text",staticStyle:{"height":"52px"}},[(_vm.$vuetify.breakpoint.smAndDown)?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.cancel()}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1):_vm._e(),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Modification du profil")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.$vuetify.breakpoint.smAndDown)?_c('v-btn',{staticClass:"white--text",attrs:{"flat":""},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t('submit')))]):_vm._e()],1),_vm._v(" "),_c('v-card-text',{style:({'heightOfCard': !_vm.$vuetify.breakpoint.smAndDown})},[_c('wz-img-upload',{attrs:{"disabled":_vm.imgLoading},on:{"change":_vm.saveImg}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('firstName')),"type":"text","prepend-icon":"accessibility"},model:{value:(_vm.userDialog.fname),callback:function ($$v) {_vm.$set(_vm.userDialog, "fname", $$v)},expression:"userDialog.fname"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('lastName')),"type":"text","prepend-icon":"accessibility"},model:{value:(_vm.userDialog.lname),callback:function ($$v) {_vm.$set(_vm.userDialog, "lname", $$v)},expression:"userDialog.lname"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('job')),"type":"text","prepend-icon":"assignment_ind"},model:{value:(_vm.userDialog.job),callback:function ($$v) {_vm.$set(_vm.userDialog, "job", $$v)},expression:"userDialog.job"}}),_vm._v(" "),_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"label":_vm._f("cap")(_vm.$t('email')),"type":"email","prepend-icon":"mail","data-vv-name":"email","error":_vm.wzErrors.has('email'),"error-messages":_vm.wzErrors.collect('email')},model:{value:(_vm.userDialog.mailContact),callback:function ($$v) {_vm.$set(_vm.userDialog, "mailContact", $$v)},expression:"userDialog.mailContact"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('phone')),"type":"text","prepend-icon":"phone"},model:{value:(_vm.userDialog.phone),callback:function ($$v) {_vm.$set(_vm.userDialog, "phone", $$v)},expression:"userDialog.phone"}}),_vm._v(" "),_c('wz-switch-lang',{on:{"change":_vm.updateLang}})],1),_vm._v(" "),(!_vm.$vuetify.breakpoint.smAndDown)?_c('v-divider'):_vm._e(),_vm._v(" "),(!_vm.$vuetify.breakpoint.smAndDown)?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.cancel()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.save()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1):_vm._e()],1)],1),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":13},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)}
var Profile_staticRenderFns = []
var Profile_esExports = { render: Profile_render, staticRenderFns: Profile_staticRenderFns }
/* harmony default export */ var components_Profile = (Profile_esExports);
// CONCATENATED MODULE: ./src/components/Profile.vue
var Profile_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Profile___vue_template_functional__ = false
/* styles */
var Profile___vue_styles__ = null
/* scopeId */
var Profile___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Profile___vue_module_identifier__ = null
var Profile_Component = Profile_normalizeComponent(
  Profile,
  components_Profile,
  Profile___vue_template_functional__,
  Profile___vue_styles__,
  Profile___vue_scopeId__,
  Profile___vue_module_identifier__
)

/* harmony default export */ var src_components_Profile = (Profile_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/Account.vue








/* harmony default export */ var Account = ({
  data: function data() {
    return {
      name: 'Account',

      dialog: false,

      siteDialog: {},
      callback: null,
      callback_fixe: null,
      callback_mobile: null,
      options: {
        cobrowsing: { icon: 'open_in_browser', value: false },
        mirroring: { icon: 'remove_red_eye', value: false },
        push: { icon: 'photo_size_select_large', value: false },
        callback: { icon: 'local_phone', value: false }
      },
      flying: {
        debit: 0,
        credit: 0,
        debitDesc: {},
        debitDate: {}
      },
      lead: {
        debit: 0,
        credit: 0,
        debitDesc: {},
        debitDate: {}
      },

      showFab: false,
      sms: null,
      sms_conso: 0,
      step: 72,
      dialogProgress: false
    };
  },
  created: function created() {
    if (typeof defautMotif !== 'undefined') {
      defautMotif = 'account';
    } else {
      setTimeout(function () {
        if (typeof defautMotif !== 'undefined') {
          defautMotif = 'account';
        }
      }, 800);
    }
  },


  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])('_User', ['setUser', 'setAvatar']), Object(vuex_esm["d" /* mapMutations */])('_Sites', ['UPDATE_SITE_SETTINGS', 'UPDATE_SITE_SELECTED']), {
    save: function save() {
      var _this = this;

      var dataToPost = new window.FormData();
      dataToPost.append('id', this.siteDialog.LIC_ID);
      dataToPost.append('email', this.siteDialog.LIC_CONTACTS);
      dataToPost.append('copy', this.siteDialog.LIC_CONTACT_COPY);
      dataToPost.append('tel', this.siteDialog.LIC_CALLBACK_PHONE);
      dataToPost.append('ENT_ID', this.$store.state._User.entId);

      var steps = JSON.parse(this.$store.state._User.remainingSteps);
      if (steps && typeof steps !== 'undefined' && steps.indexOf('INS_ACCOUNT')) {
        steps.splice(steps.indexOf('INS_ACCOUNT'), 1);

        this.$store.commit('_User/MAJ_PROGRESSION', {
          remainingSteps: stringify_default()(steps)
        });
      }

      this.loading = true;
      this.axios.post('put/account.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this.UPDATE_SITE_SETTINGS(_this.siteDialog);
        _this.UPDATE_SITE_SELECTED(_this.siteDialog);

        _this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this.$t('modifSuccess'),
          context: 'success'
        });
      }).catch(function (_) {
        _this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this.$t('modifFailure'),
          context: 'error'
        });
      }).then(function (_) {
        _this.loading = false;
        _this.dialog = false;
      });
    },
    cancel: function cancel() {
      this.dialog = false;
    },
    openDialog: function openDialog() {
      this.dialog = true;
      this.siteDialog = lodash_default.a.clone(this.siteSelected);
    },
    fermeDialogProgress: function fermeDialogProgress() {
      this.dialogProgress = false;
    },
    openDialogProgress: function openDialogProgress() {
      this.dialogProgress = true;
    }
  }),

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'fullName', 'userAvatar', 'account', 'level']), Object(vuex_esm["e" /* mapState */])('_Sites', ['sites', 'siteSelected']), {
    Domaine: function Domaine() {
      return constants_DOMAINE + '/subscription/subscriptions_fr.php';
    }
  }),

  mounted: function mounted() {
    var _this2 = this;

    var dataToPost = new window.FormData();
    dataToPost.append('id', this.user.entId);
    this.axios.post('post/account.php', dataToPost, {
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(function (response) {
      _this2.callback = response.data.callback;
      _this2.callback_fixe = response.data.callback_fixe;
      _this2.callback_mobile = response.data.callback_mobile;

      _this2.options.cobrowsing.value = _this2.sites.findIndex(function (site) {
        return !!site.DSK_COBROWSING;
      }) !== -1;
      _this2.options.mirroring.value = _this2.sites.findIndex(function (site) {
        return !!site.DSK_MIRRORING;
      }) !== -1;
      _this2.options.push.value = _this2.level.rights === LEVEL.ENTREPRISE || moment_default()(_this2.user.entOptionPush).isSameOrAfter(moment_default()(), 'day');
      _this2.options.callback.value = _this2.callback === '1';
      _this2.showFab = true;
      _this2.flying.credit = response.data.flyTotalCrebit;
      _this2.flying.debit = response.data.flyTotalDebit;
      _this2.flying.debitDesc = response.data.fly_debitDesc;
      _this2.flying.debitDate = response.data.fly_debitDate;
      _this2.lead.credit = response.data.leadTotalCrebit;
      _this2.lead.debit = response.data.leadTotalDebit;
      _this2.lead.debitDesc = response.data.lead_debitDesc;
      _this2.lead.debitDate = response.data.lead_debitDate;
      _this2.sms = response.data.sms;
      _this2.sms_conso = response.data.sms_conso;
    }).catch();
    if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
      this.openDialogProgress();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-45942573","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Account.vue
var Account_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"account"},[_c('v-card',{staticClass:"white"},[_c('v-container',{attrs:{"fluid":"","grid-list-lg":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{attrs:{"xs12":"","sm5":""}},[_c('div',[_c('v-btn',{attrs:{"color":"primary","block":"","href":_vm.Domaine,"target":"_blank"}},[_vm._v("\n                voir abonnement\n                "),_c('v-icon',{attrs:{"right":""}},[_vm._v("card_membership")])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticStyle:{"padding":"0px","position":"relative"}},[_c('v-fab-transition',[_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.showFab),expression:"showFab"}],attrs:{"color":"secondary","dark":"","absolute":"","bottom":"","right":"","fab":""},nativeOn:{"click":function($event){$event.stopPropagation();_vm.openDialog()}}},[_c('v-icon',[_vm._v("edit")])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-expansion-panel',{attrs:{"expand":""}},[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-subheader',[_vm._v("Informations du compte")])],1),_vm._v(" "),_c('v-card',[_c('v-list',{attrs:{"two-line":"","dense":""}},[_c('v-list-tile',[_c('v-list-tile-content',[_c('wz-select-one-site')],1)],1),_vm._v(" "),_c('div',[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("mail")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.siteSelected.LIC_CONTACTS))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Email où envoyer les messages / les leads")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("contact_mail")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.siteSelected.LIC_CONTACT_COPY))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Emails en copie des messages")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.siteSelected.LIC_CALLBACK_PHONE))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Numéro de téléphone (Click to Call)")])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-subheader',[_vm._v("Informations sur l'abonnement")])],1),_vm._v(" "),_c('v-card',[_c('v-list',{attrs:{"two-line":"","dense":""}},[(_vm.user.entRefFacturation)?_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("person")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.user.entRefFacturation.CLI_EMAIL))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Compte référent facturation")])],1)],1):_vm._e(),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("vpn_key")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.user.entKey))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Clé de licence (pour installation ligne de script)")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("poll")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.level.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Formule actuelle")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("contact_mail")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.user.entNbPageThisMonth)+" / "+_vm._s(_vm.user.entNbPageMax))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Nb de chargements actuels (consommés pour la période d'abonnement)")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("cake")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.user.entEezyExpiry))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Date du prochain renouvellement / fin d'abonnement")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("group")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.user.entNbAgent))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Nombre de conseillers maximum en simultanés")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("language")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.user.entNbSite))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Nombre de sites au maximum")])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-subheader',[_vm._v("Liste des options souscrites / actives")])],1),_vm._v(" "),_c('v-card',[_c('v-list',{attrs:{"two-line":"","dense":""}},_vm._l((_vm.options),function(option,key){return _c('v-list-tile',{key:key},[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v(_vm._s(option.icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(key))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(option.value ? _vm.$t('yes') : _vm.$t('no')))])],1)],1)}),1)],1)],1),_vm._v(" "),_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-subheader',[_vm._v("Flying First")])],1),_vm._v(" "),_c('v-card',[_c('v-list',{attrs:{"two-line":"","dense":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("flight_takeoff")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Crédits")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.flying.credit)+" minutes")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("flight_land")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Débits")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.flying.debit)+" minutes")])],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"tf_fliyng_first"},[_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.flying.debitDesc),function(debit,key){return _c('v-list-tile',{key:key},[_c('v-list-tile-icon'),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.flying.debitDate[key])+" : "+_vm._s(debit))])],1)],1)}),1)],1)],1)],1),_vm._v(" "),(_vm.lead.credit[_vm.siteSelected.LIC_ID] && _vm.lead.credit[_vm.siteSelected.LIC_ID] !== 0)?_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-subheader',[_vm._v("Eezy Lead ")])],1),_vm._v(" "),_c('v-card',[_c('br'),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-content',[_c('wz-select-one-site')],1)],1),_vm._v(" "),_c('v-list',{attrs:{"two-line":"","dense":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("add_shopping_cart")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Crédits")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.lead.credit[_vm.siteSelected.LIC_ID] ? _vm.lead.credit[_vm.siteSelected.LIC_ID] : 0)+" €")])],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("how_to_reg")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Débits")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.lead.debit[_vm.siteSelected.LIC_ID] ? _vm.lead.debit[_vm.siteSelected.LIC_ID] : 0)+" €")]),_vm._v(" "),_vm._l((_vm.lead.debitDesc[_vm.siteSelected.LIC_ID]),function(debit,key){return _c('v-list-tile-sub-title',{key:key},[_vm._v(_vm._s(debit))])})],2)],1)],1),_vm._v(" "),_c('br')],1)],1):_vm._e(),_vm._v(" "),(_vm.callback === '1')?_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-subheader',[_vm._v("Call Back")])],1),_vm._v(" "),_c('v-card',[_c('v-list',{attrs:{"two-line":"","dense":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("local_phone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.siteSelected.c2c_conso_f ? _vm.siteSelected.c2c_conso_f : '00:00:00'))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Consommation en téléphonie fixe, sur un quota de "+_vm._s(_vm.siteSelected.c2c_quota_sites_f ? _vm.siteSelected.c2c_quota_sites_f : '0')+" heures")]),_vm._v(" "),(_vm.siteSelected.c2c_conso_sec_f && _vm.siteSelected.c2c_quota_sites_f)?_c('v-list-tile-sub-title',[_vm._v("Votre consommation atteint "+_vm._s(Math.round(_vm.siteSelected.c2c_conso_sec_f * 100 / (3600 * _vm.siteSelected.c2c_quota_sites_f)))+" % du quota")]):_vm._e()],1)],1),_vm._v(" "),_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("phone_iphone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.siteSelected.c2c_conso_m ? _vm.siteSelected.c2c_conso_m : '00:00:00'))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Consommation en téléphonie mobile, sur un quota de "+_vm._s(_vm.siteSelected.c2c_quota_sites_m ? _vm.siteSelected.c2c_quota_sites_m : '0')+" heures")]),_vm._v(" "),(_vm.siteSelected.c2c_conso_sec_m && _vm.siteSelected.c2c_quota_sites_m)?_c('v-list-tile-sub-title',[_vm._v("Votre consommation atteint "+_vm._s(Math.round(_vm.siteSelected.c2c_conso_sec_m * 100 / (3600 * _vm.siteSelected.c2c_quota_sites_m)))+" % du quota")]):_vm._e()],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.sms === '1')?_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-subheader',[_vm._v("SMS")])],1),_vm._v(" "),_c('v-card',[_c('v-list',{attrs:{"two-line":"","dense":""}},[_c('v-list-tile',[_c('v-list-tile-action',[_c('v-icon',{staticClass:"primary--text"},[_vm._v("phone_iphone")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.sms_conso ? _vm.sms_conso : '0')+" SMS (textos) envoyés")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("Consommation sur un quota de "+_vm._s(_vm.siteSelected.sms_quota ? _vm.siteSelected.sms_quota : '0')+" SMS")]),_vm._v(" "),(_vm.sms_conso && _vm.siteSelected.sms_quota)?_c('v-list-tile-sub-title',[_vm._v("Votre consommation atteint "+_vm._s(Math.round(_vm.sms_conso * 100 / (_vm.siteSelected.sms_quota)))+" % du quota")]):_vm._e()],1)],1)],1)],1)],1):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"persistent":"","scrollable":"","max-width":"600px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('span',{staticClass:"headline"},[_vm._v("Modification des informations de contact")])]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"label":"Email de contact","type":"email","prepend-icon":"mail","data-vv-name":"email","error":_vm.wzErrors.has('email'),"error-messages":_vm.wzErrors.collect('email')},model:{value:(_vm.siteDialog.LIC_CONTACTS),callback:function ($$v) {_vm.$set(_vm.siteDialog, "LIC_CONTACTS", $$v)},expression:"siteDialog.LIC_CONTACTS"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Emails en copie (séparés par ; )","type":"text","prepend-icon":"mail"},model:{value:(_vm.siteDialog.LIC_CONTACT_COPY),callback:function ($$v) {_vm.$set(_vm.siteDialog, "LIC_CONTACT_COPY", $$v)},expression:"siteDialog.LIC_CONTACT_COPY"}}),_vm._v(" "),_c('v-text-field',{attrs:{"label":"Téléphone","type":"text","disabled":"","prepend-icon":"phone"},model:{value:(_vm.siteDialog.LIC_CALLBACK_PHONE),callback:function ($$v) {_vm.$set(_vm.siteDialog, "LIC_CALLBACK_PHONE", $$v)},expression:"siteDialog.LIC_CALLBACK_PHONE"}}),_vm._v(" "),_c('wz-switch-lang',{attrs:{"lang":_vm.siteDialog.lang},on:{"update:lang":function($event){_vm.$set(_vm.siteDialog, "lang", $event)}}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){return _vm.cancel($event)}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.wzErrors.any()},nativeOn:{"click":function($event){return _vm.save($event)}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1),_vm._v(" "),_c('wz-dialog-progress',{attrs:{"dialogProgress":_vm.dialogProgress,"etape":12},on:{"fermeDialogProgress":_vm.fermeDialogProgress}})],1)}
var Account_staticRenderFns = []
var Account_esExports = { render: Account_render, staticRenderFns: Account_staticRenderFns }
/* harmony default export */ var components_Account = (Account_esExports);
// CONCATENATED MODULE: ./src/components/Account.vue
function Account_injectStyle (ssrContext) {
  __webpack_require__("g+nO")
  __webpack_require__("jRnr")
}
var Account_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var Account___vue_template_functional__ = false
/* styles */
var Account___vue_styles__ = Account_injectStyle
/* scopeId */
var Account___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var Account___vue_module_identifier__ = null
var Account_Component = Account_normalizeComponent(
  Account,
  components_Account,
  Account___vue_template_functional__,
  Account___vue_styles__,
  Account___vue_scopeId__,
  Account___vue_module_identifier__
)

/* harmony default export */ var src_components_Account = (Account_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/stats/csvExport.vue


/* harmony default export */ var csvExport = ({
  props: {
    csv: {
      type: String
    }
  },

  data: function data() {
    return {
      dataCSV: ''
    };
  },

  created: function created() {
    this.dataCSV = this.$route.params.csv;
  },


  computed: {},

  methods: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8bd32ffa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/csvExport.vue
var csvExport_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n      "+_vm._s(_vm.dataCSV)+"\n  ")])}
var csvExport_staticRenderFns = []
var csvExport_esExports = { render: csvExport_render, staticRenderFns: csvExport_staticRenderFns }
/* harmony default export */ var stats_csvExport = (csvExport_esExports);
// CONCATENATED MODULE: ./src/components/stats/csvExport.vue
var csvExport_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var csvExport___vue_template_functional__ = false
/* styles */
var csvExport___vue_styles__ = null
/* scopeId */
var csvExport___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var csvExport___vue_module_identifier__ = null
var csvExport_Component = csvExport_normalizeComponent(
  csvExport,
  stats_csvExport,
  csvExport___vue_template_functional__,
  csvExport___vue_styles__,
  csvExport___vue_scopeId__,
  csvExport___vue_module_identifier__
)

/* harmony default export */ var components_stats_csvExport = (csvExport_Component.exports);

// CONCATENATED MODULE: ./src/router/index.js

























































vue_esm["default"].use(vue_router_esm["a" /* default */]);
var router = new vue_router_esm["a" /* default */]({
  mode: 'hash',
  base: 'watcheezy',
  routes: [{
    path: '/login',
    name: 'login',
    component: src_components_Login
  }, {
    path: 'csvexport',
    name: 'csvexport',
    component: components_stats_csvExport,
    meta: { permissions: { roles: NO_PEONS } }
  }, {
    path: '/',
    component: src_components_Dash,
    children: [{
      path: '/dashboard',
      name: 'dashboard',
      component: src_components_Dashboard
    }, {
      path: '/trafic',
      name: 'trafic',
      component: components_Trafic,
      meta: {
        tabs: [{ title: 'visitors', to: '/trafic/visitors', brideName: 'trafic_visiteurs' }, { title: 'chatting', to: '/trafic/chatting', brideName: 'trafic_discussions' }, { title: 'monitoring', to: '/trafic/monitoring', brideName: 'trafic_monitoring' }]
      },
      children: [{
        path: 'visitors',
        name: 'visitors',
        component: components_trafic_Visitors,
        meta: {
          permissions: { roles: NO_ADMINS },
          brideName: 'trafic_visiteurs'
        }
      }, {
        path: 'chatting',
        name: 'chatting',
        component: components_trafic_Chatting,
        meta: {
          permissions: { roles: NO_ADMINS },
          brideName: 'trafic_discussions'
        }
      }, {
        path: 'monitoring',
        name: 'monitoring',
        component: components_trafic_Monitoring,
        meta: {
          permissions: {
            roles: NO_PEONS_NOR_AGENTS,
            levels: [LEVEL.ESSAI, LEVEL.ENTREPRISE]
          },
          brideName: 'trafic_monitoring'
        }
      }, {
        path: 'attente',
        name: 'attente',
        component: components_trafic_Attente,
        meta: {
          permissions: { roles: NO_ADMINS },
          brideName: 'trafic_visiteurs'
        }
      }]
    }, {
      path: '/stats',
      name: 'stats',
      component: src_components_Stats,
      meta: {
        tabs: [{ title: 'audience', to: '/stats/audience', brideName: 'stats_audience' }, { title: 'chats', to: '/stats/chats', brideName: 'stats_conversations' }, { title: 'chatbot', to: '/stats/chatbot', brideName: 'stats_chatbot' }, { title: 'agents', to: '/stats/agents-perf', brideName: 'stats_conseillers' }, { title: 'C2C', to: '/stats/C2C', brideName: 'stats_callback' }, { title: 'sales', to: '/stats/sales', brideName: 'stats_ventes' }, { title: 'leads', to: '/stats/leads', brideName: 'stats_leads' }, { title: 'satisfaction', to: '/stats/satisfaction', brideName: 'stats_satisfaction' }, { title: 'reports', to: '/stats/reports', brideName: 'stats_rapports' }]
      },
      children: [{
        path: 'audience',
        name: 'audience',
        component: components_stats_Audience,
        meta: {
          permissions: { roles: NO_PEONS },
          brideName: 'stats_audience'
        }
      }, {
        path: 'chats',
        name: 'chats',
        component: components_stats_Chats,
        meta: {
          permissions: { roles: NO_PEONS },
          brideName: 'stats_conversations'
        }
      }, {
        path: 'chatbot',
        name: 'chatbot',
        component: components_stats_Chatbot,
        meta: {
          permissions: { roles: NO_PEONS },
          brideName: 'stats_chatbot'
        }
      }, {
        path: 'viewcsv',
        name: 'viewcsv',
        component: components_stats_ViewCSV,
        meta: { permissions: { roles: NO_PEONS } }
      }, {
        path: 'agents-perf',
        name: 'agents-perf',
        meta: {
          title: 'agents',
          permissions: { roles: NO_PEONS },
          brideName: 'stats_conseillers'
        },
        component: components_stats_AgentsPerformance
      }, {
        path: 'C2C',
        name: 'C2C',
        component: components_stats_C2C,
        meta: {
          permissions: { roles: NO_PEONS },
          brideName: 'stats_callback'
        }
      }, {
        path: 'sales',
        name: 'sales',
        component: components_stats_Sales,
        meta: {
          permissions: {
            roles: NO_PEONS,
            levels: [LEVEL.ESSAI, LEVEL.START, LEVEL.PRO, LEVEL.ENTREPRISE]
          },
          brideName: 'stats_ventes'
        }
      }, {
        path: 'leads',
        name: 'leads',
        component: components_stats_Leads,
        meta: {
          permissions: {
            roles: NO_PEONS,
            levels: [LEVEL.ESSAI, LEVEL.START, LEVEL.PRO, LEVEL.ENTREPRISE]
          },
          brideName: 'stats_leads'
        }
      }, {
        path: 'satisfaction',
        name: 'satisfaction',
        component: components_stats_Satisfaction,
        meta: {
          permissions: { roles: NO_PEONS },
          brideName: 'stats_satisfaction'
        }
      }, {
        path: 'reports',
        name: 'reports',
        component: stats_reports_Reports,
        meta: {
          permissions: {
            roles: NO_PEONS_NOR_AGENTS,
            levels: [LEVEL.ENTREPRISE]
          },
          brideName: 'stats_rapports'
        }
      }, {
        path: 'reports/:id',
        component: stats_reports_ReportDetails,
        meta: {
          back: '/stats/reports',
          tabs: null,
          permissions: {
            roles: NO_PEONS_NOR_AGENTS,
            levels: [LEVEL.ENTREPRISE]
          }
        },
        props: true
      }]
    }, {
      path: '/management',
      name: 'management',
      component: components_Management,
      meta: {
        tabs: [{ title: 'agents', to: '/management/agents', brideName: 'compte_conseillers' }, { title: 'sites', to: '/management/sites', brideName: 'compte_sites' }, { title: 'mapping', to: '/management/mapping', brideName: 'compte_attribution' }]
      },
      children: [{
        path: 'agents',
        name: 'agents',
        component: components_management_Agents,
        meta: {
          permissions: { roles: NO_PEONS_NOR_AGENTS },
          brideName: 'compte_conseillers'
        }
      }, {
        path: 'sites',
        name: 'sites',
        component: components_management_Sites,
        meta: {
          permissions: { roles: NO_PEONS_NOR_AGENTS },
          brideName: 'compte_sites'
        }
      }, {
        path: 'mapping',
        name: 'mapping',
        component: components_management_Mapping,
        meta: {
          permissions: { roles: NO_PEONS_NOR_AGENTS },
          brideName: 'compte_attribution'
        }
      }]
    }, {
      path: '/settings',
      name: 'settings',
      component: components_Settings,
      meta: {
        tabs: [{ title: 'preview', to: '/settings/preview', brideName: 'parametre_apercu' }, { title: 'mode hors-ligne', to: '/settings/absence', brideName: 'parametre_absence' }, { title: 'mode en-ligne', to: '/settings/chat', brideName: 'parametre_chat' }, { title: 'widget + chatbot', to: '/settings/bot', brideName: 'parametre_bot' }, { title: 'callback', to: '/settings/callback', brideName: 'parametre_callback' }, { title: 'meeting', to: '/settings/recall', brideName: 'parametre_recall' }, { title: 'sms', to: '/settings/sms', brideName: 'parametre_sms' }, { title: 'ecomm', to: '/settings/ecomm', brideName: 'parametre_ecommerce' }, { title: 'connectors', to: '/settings/connectors', brideName: 'parametre_connecteur' }, { title: 'bluepush', to: '/settings/bluepush', brideName: 'parametre_push' }]
      },
      children: [{
        path: 'preview',
        name: 'preview',
        component: components_settings_Preview,
        meta: {
          permissions: { roles: NO_PEONS_NOR_AGENTS },
          brideName: 'parametre_apercu'
        }
      }, {
        path: 'absence',
        name: 'absence',
        component: components_settings_Absence,
        meta: {
          permissions: { roles: NO_PEONS_NOR_AGENTS },
          brideName: 'parametre_absence'
        }
      }, {
        path: 'chat',
        name: 'chat',
        component: components_settings_Chat,
        meta: {
          permissions: { roles: NO_PEONS_NOR_AGENTS },
          brideName: 'parametre_chat'
        }
      }, {
        path: 'bot',
        name: 'bot',
        component: components_settings_ChatBot,
        meta: {
          permissions: { roles: NO_PEONS_NOR_AGENTS },
          brideName: 'parametre_bot'
        }
      }, {
        path: 'callback',
        name: 'callback',
        component: components_settings_Callback,
        meta: {
          permissions: { roles: NO_PEONS_NOR_AGENTS },
          brideName: 'parametre_callback'
        }
      }, {
        path: 'recall',
        name: 'meeting',
        component: components_settings_Recall,
        meta: {
          permissions: { roles: NO_PEONS_NOR_AGENTS },
          brideName: 'parametre_recall'
        }
      }, {
        path: 'sms',
        name: 'sms',
        component: components_settings_Sms,
        meta: {
          permissions: { roles: NO_PEONS_NOR_AGENTS },
          brideName: 'parametre_sms'
        }
      }, {
        path: 'ecomm',
        name: 'ecomm',
        component: components_settings_Ecomm,
        meta: {
          permissions: { roles: NO_PEONS_NOR_AGENTS },
          brideName: 'parametre_ecommerce'
        }
      }, {
        path: 'connectors',
        name: 'connectors',
        component: components_settings_Connectors,
        meta: {
          permissions: { roles: NO_PEONS_NOR_AGENTS },
          brideName: 'parametre_connecteur'
        }
      }, {
        path: 'bluepush',
        name: 'bluepush',
        component: components_settings_BluePush,
        meta: {
          permissions: { roles: NO_PEONS_NOR_AGENTS },
          brideName: 'parametre_push'
        }
      }]
    }, {
      path: '/target',
      name: 'target',
      component: components_Target,
      meta: {
        tabs: [{ title: 'scenario', to: '/target/filters', brideName: 'ciblage' }]
      },
      children: [{
        path: 'filters',
        name: 'filters',
        component: components_filters_Filters,
        meta: {
          permissions: { roles: NO_PEONS },
          brideName: 'ciblage'
        }
      }, {
        path: 'filters/:id',
        component: components_filters_Filter,
        meta: {
          back: '/target/filters',
          tabs: null,
          permissions: { roles: NO_PEONS },
          brideName: 'ciblage'
        },
        props: true
      }]
    }, {
      path: '/media',
      name: 'media',
      component: components_Media,
      meta: {
        tabs: [{ title: 'quickSentences', to: '/media/biblios', brideName: 'media_phrases' }, { title: 'pushs', to: '/media/pushs', brideName: 'parametre_push' }]
      },
      children: [{
        path: 'biblios',
        name: 'biblios',
        component: components_media_Biblios,
        meta: {
          permissions: { roles: NO_PEONS },
          brideName: 'media_phrases'
        }
      }, {
        path: 'biblios/:id',
        component: components_media_Biblio,
        meta: {
          back: '/media/biblios',
          tabs: null,
          permissions: { roles: NO_PEONS }
        },
        props: true
      }, {
        path: 'biblios/:idParent/sub/:idSub',
        component: components_media_SubBiblio,
        meta: {
          back: '/media/biblios/:idParent',
          tabs: null,
          permissions: { roles: NO_PEONS }
        },
        props: true
      }, {
        path: 'pushs',
        name: 'pushs',
        component: components_media_Pushs,
        meta: {
          permissions: { roles: NO_PEONS_NOR_AGENTS },

          brideName: 'parametre_push'
        }
      }, {
        path: 'pushs/:id',
        component: components_media_Push,
        meta: {
          back: '/media/pushs',
          tabs: null,
          permissions: { roles: NO_PEONS_NOR_AGENTS }
        },
        props: true
      }]
    }, {
      path: 'profile',
      name: 'profile',
      component: src_components_Profile
    }, {
      path: 'account',
      name: 'account',
      component: src_components_Account,
      meta: { permissions: { roles: NO_PEONS_NOR_AGENTS } }
    }]
  }, {
    path: '*',
    redirect: '/stats/audience'
  }]
});

router.beforeEach(function (to, from, next) {
  console.log('to :', to);
  console.log('from :', from);
  console.log('next :', next);
  var _User = {
    account: src_store.getters['_User/account'],
    level: src_store.getters['_User/level'],
    entId: src_store.state._User.entId,
    hideTabVisitors: src_store.state._User.hideTabVisitors,
    brides: src_store.state._User.brides
  };

  var connected = src_store.getters.logged;
  if (!connected) {
    if (to.path !== '/login') {
      router.push({ path: '/login' });
      next(false);
    } else {
      next(true);
    }
    return;
  } else if (connected) {
    if (!_User.level) {
      src_store.commit('logout');
    } else if (to.path === '/' || to.path === '/login') {
      if (_User.account.role === 'peon') {
        router.push({ path: '/trafic/visitors' });
      } else {
        router.push({ path: '/stats/audience' });
      }
    }
  }

  var permission = true;
  var because = null;
  if (to.meta.permissions) {
    permission = !to.meta.permissions.roles || to.meta.permissions.roles && lodash_default.a.indexOf(to.meta.permissions.roles, _User.account.role) !== -1;
    because = permission ? null : 'account';

    if (permission) {
      permission = !to.meta.permissions.levels || to.meta.permissions.levels && lodash_default.a.indexOf(to.meta.permissions.levels, _User.level.rights) !== -1;
      because = permission ? null : 'level';
    }

    if (_User.brides) {
      var brideStatus = _User.brides.find(function (o) {
        return o.brideName === to.meta.brideName;
      });

      if (brideStatus) {
        if (brideStatus.status === '0') {
          permission = false;
        }
      }
    }
  }
  if (permission) {
    var updateTabs = !lodash_default.a.isNull(to.meta.tabs);
    if (!updateTabs) {
      src_store.commit('_Toolbar/SET_TABS', []);
    } else if (to.matched.some(function (route) {
      return route.meta.tabs;
    })) {
      (function () {
        var tabs = lodash_default.a.find(to.matched, function (route) {
          return route.meta.tabs;
        });
        tabs = tabs.meta.tabs;

        var i = void 0;
        for (i = tabs.length - 1; i >= 0; i -= 1) {
          if (tabs[i].brideName) {
            if (_User.brides) {
              var _brideStatus = lodash_default.a.find(_User.brides, function (o) {
                return o.brideName === tabs[i].brideName;
              });

              tabs[i].status = _brideStatus.status;

              if (_brideStatus.status === '0') {}
            }
          }
        }
        var newTabs = tabs;

        newTabs = lodash_default.a.filter(newTabs, function (t) {
          if (_User.hideTabVisitors) {
            if (t.title !== 'visitors') {
              return t;
            }
            return;
          }

          if (_User.account.role === 'agent' || _User.account.role === 'peon') {
            if (t.title !== 'monitoring') {
              return t;
            }
          } else if (_User.account.role === 'admin') {
            if (t.title !== 'visitors' && t.title !== 'chatting') {
              return t;
            }
          } else {
            return t;
          }
        });
        src_store.commit('_Toolbar/SET_TABS', newTabs);
      })();
    } else {
      src_store.commit('_Toolbar/SET_TABS', []);
    }

    var title = to.fullPath;

    if (!lodash_default.a.isEmpty(to.params.id)) {
      var paths = to.fullPath.split('/');
      title = '';
      for (var i = 0; i < paths.length - 1; i++) {
        title += paths[i];
        if (i !== paths.length - 2) {
          title += '/';
        }
      }
    }

    title = to.meta.title ? '/' + title.split('/')[1] + '/' + to.meta.title : title;
    src_store.commit('_Toolbar/SET_TITLE', title.substring(1).split('/')[0]);

    to.meta.back ? src_store.commit('_Toolbar/SET_BACK', to.meta.back) : src_store.commit('_Toolbar/SET_BACK', null);
    if (to.meta.back) {
      src_store.commit('_Toolbar/SET_SUB_TITLE', null);
    }

    if (to.name !== 'trafic') {
      src_store.commit('_StoreWatcheeBox/AGENT_FOCUS', {
        view: 1,
        visiteurID: 1
      });
    }
    next();

    src_store.commit('_Notifier/CLEAR');
  } else {
    next(false);

    src_store.dispatch('_Notifier/NEW_NOTIF', {
      message: because === 'account' ? 'En tant que ' + _User.account.type + ', vous ne pouvez acc\xE9der \xE0 cette section' : 'Le niveau de licence (' + _User.level.title + ') n\'est pas suffisant, vous ne pouvez acc\xE9der \xE0 cette section',
      multiLine: true,
      context: 'error',
      position: 'top'
    });
  }
});

/* harmony default export */ var src_router = (router);
// EXTERNAL MODULE: ./node_modules/vuex-persistedstate/dist/vuex-persistedstate.js
var vuex_persistedstate = __webpack_require__("qQWK");
var vuex_persistedstate_default = /*#__PURE__*/__webpack_require__.n(vuex_persistedstate);

// CONCATENATED MODULE: ./src/store/toolbar.js


var _Toolbar = {
  namespaced: true,
  state: {
    back: '',

    tabs: [],

    title: '',

    subTitle: ''
  },
  getters: {},
  mutations: {
    INIT: function INIT(state) {
      state.back = '';
      state.tabs = [];
      state.title = '';
      state.subTitle = '';
    },
    SET_BACK: function SET_BACK(state, back) {
      state.back = back;
    },
    SET_TABS: function SET_TABS(state, tabs) {
      state.tabs = tabs;
    },
    SET_TITLE: function SET_TITLE(state, title) {
      var paths = title.split('/');
      var routes = '';
      if (paths[0].length > 0) {
        for (var i = 0; i < paths.length; i++) {
          paths[i] = translation.t(paths[i]);

          paths[i] = paths[i][0].toUpperCase() + paths[i].substring(1);

          routes += paths[i];

          if (i !== paths.length - 1) {
            routes += ' - ';
          }
        }
      }
      state.title = routes;
    },
    SET_SUB_TITLE: function SET_SUB_TITLE(state, subTitle) {
      state.subTitle = subTitle;
    }
  },
  actions: {}
};
// CONCATENATED MODULE: ./src/store/notifier.js



var _defaultTimeout = 6000;

var _Notifier = {
  namespaced: true,
  state: {
    notifications: [],
    show: false
  },
  getters: {
    index: function index(state) {
      return state.notifications.findIndex(function (o) {
        return !o.vu || o.vu === false;
      });
    },
    notifsPersistantes: function notifsPersistantes(state) {
      console.log('notif :', state.notifications.filter(function (o) {
        return o.type;
      }));
      return state.notifications.filter(function (o) {
        return o.type;
      });
    }
  },
  mutations: {
    INIT: function INIT(state) {
      state.notifications = [];
      state.show = false;
    },
    ADD_NOTIF: function ADD_NOTIF(state, notif) {
      state.notifications.push(notif);
    },
    UPDATE_NOTIF: function UPDATE_NOTIF(state, notif) {
      state.notifications.splice(notif.idxVisfound, 1, notif);
    },
    REMOVE_NOTIF: function REMOVE_NOTIF(state, index) {
      if (index !== -1 && state.notifications[index]) {
        if (state.notifications[index].data && state.notifications[index].data.titre) {
          push_min_default.a.close(state.notifications[index].data.titre);
        }
        window.clearTimeout(state.notifications[index].timeout);
        state.notifications.splice(index, 1);
      }
    },
    CLEAR: function CLEAR(state) {
      if (state.notifications) {
        var notifications = [];
        state.notifications.forEach(function (notif, key) {
          window.clearTimeout(notif.timeout);
          if (notif.type) {
            notifications.push(notif);
          }
        });
        state.notifications = lodash_default.a.cloneDeep(notifications);
        state.show = false;
      }
    },
    CLEAR_ALL: function CLEAR_ALL(state) {
      state.notifications = [];
      state.show = false;
    },
    SHOW: function SHOW(state) {
      state.show = true;
    },
    HIDE: function HIDE(state) {
      state.show = false;
    },
    VU: function VU(state, index) {
      state.notifications[index].vu = true;
    }
  },
  actions: {
    NEW_NOTIF: function NEW_NOTIF(_ref, notif) {
      var commit = _ref.commit,
          state = _ref.state;

      notif.timeout = notif.timeout || _defaultTimeout;

      notif.action = notif.action || { text: 'Fermer', path: null };

      notif.count = 1;

      var idxVisfound = -1;

      if (notif.type === 'message') {
        notif.action = { text: 'Répondre', path: '/trafic/chatting' };
        idxVisfound = state.notifications.findIndex(function (o) {
          if (o.data && notif.data.titre) {
            return o.data.titre === notif.data.titre;
          }
        });

        if (idxVisfound !== -1) {
          notif.count = state.notifications[idxVisfound].count + 1;
        }
      } else if (notif.type === 'collections') {
        notif.action = { text: 'Fermer' };
        idxVisfound = state.notifications.findIndex(function (o) {
          if (o.data && notif.data.titre) {
            return o.data.titre === notif.data.titre;
          }
        });

        if (idxVisfound !== -1) {
          notif.count = state.notifications[idxVisfound].count + 1;
        }
      } else if (notif.type === 'phone_in_talk') {
        notif.action = { text: 'Fermer' };
        idxVisfound = state.notifications.findIndex(function (o) {
          if (o.data && notif.data.titre) {
            return o.data.titre === notif.data.titre;
          }
        });

        if (idxVisfound !== -1) {
          notif.count = state.notifications[idxVisfound].count + 1;
        }
      } else if (notif.type === 'error') {
        notif.action = { text: 'Fermer', path: notif.url };
        idxVisfound = state.notifications.findIndex(function (o) {
          if (o.data && notif.data.titre) {
            return o.data.titre === notif.data.titre;
          }
        });

        if (idxVisfound !== -1) {
          notif.count = state.notifications[idxVisfound].count + 1;
        }
      }

      if (idxVisfound === -1) {
        commit('ADD_NOTIF', notif);
      } else {
        notif.idxVisfound = idxVisfound;
        commit('UPDATE_NOTIF', notif);
      }
      commit('SHOW');
    },
    OPEN_NOTIF: function OPEN_NOTIF(_ref2, index) {
      var commit = _ref2.commit,
          state = _ref2.state,
          getters = _ref2.getters;

      if (state.notifications[index].action.path) {
        src_router.push({ path: state.notifications[index].action.path });

        this.commit('_StoreWatcheeBox/AGENT_FOCUS', {
          'titre': state.notifications[index].data.titre
        });
        commit('REMOVE_NOTIF', index);
      } else {
        if (state.notifications[index].type === 'collections' || state.notifications[index].type === 'phone_in_talk') {
          window.open(state.notifications[index].data.url, 'souscription');
          commit('REMOVE_NOTIF', index);
        }
      }
    },
    HIDE_NOTIF: function HIDE_NOTIF(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state,
          getters = _ref3.getters;

      commit('HIDE');
      if (getters.index !== -1) {
        if (lodash_default.a.isNil(state.notifications[getters.index].type)) {
          commit('REMOVE_NOTIF', getters.index);
        } else {
          commit('VU', getters.index);
        }

        if (getters.index !== -1) {
          setTimeout(function () {
            return commit('SHOW');
          }, 500);
        }
      }
    }
  }
};
// CONCATENATED MODULE: ./src/store/dialog.js
var DEFAULT_FULLSCREEN = false;
var DEFAULT_INFO = false;
var DEFAULT_PERSISTENT = true;
var DEFAULT_MAX_WIDTH = 350;
var DEFAULT_TITLE = 'title';
var DEFAULT_TEXT = '';
var DEFAULT_FIELDS = [];
var DEFAULT_CANCEL = 'cancel';
var DEFAULT_SUBMIT = 'submit';
var DEFAULT_MODEL = null;
var DEFAULT_SUBMIT_CB = function DEFAULT_SUBMIT_CB() {};

function dialog_init(state) {
  state.value = false;
  state.fullscreen = DEFAULT_FULLSCREEN;
  state.persistent = DEFAULT_PERSISTENT;
  state.maxWidth = DEFAULT_MAX_WIDTH;
  state.title = DEFAULT_TITLE;
  state.text = DEFAULT_TEXT;
  state.fields = DEFAULT_FIELDS;
  state.cancel = DEFAULT_CANCEL;
  state.submit = DEFAULT_SUBMIT;
  state.model = DEFAULT_MODEL;
  state.submitCb = DEFAULT_SUBMIT_CB;
}

function setDialog(state, payload) {
  state.value = payload.value === null || payload.value === undefined ? false : payload.value;
  state.fullscreen = payload.fullscreen === null || payload.fullscreen === undefined ? DEFAULT_FULLSCREEN : payload.fullscreen;
  state.info = payload.info === null || payload.info === undefined ? DEFAULT_INFO : payload.info;
  state.persistent = payload.persistent === null || payload.persistent === undefined ? DEFAULT_PERSISTENT : payload.persistent;
  state.maxWidth = payload.maxWidth === null || payload.maxWidth === undefined ? DEFAULT_MAX_WIDTH : payload.maxWidth;
  state.title = payload.title === null || payload.title === undefined ? DEFAULT_TITLE : payload.title;
  state.text = payload.text === null || payload.text === undefined ? DEFAULT_TEXT : payload.text;
  state.fields = payload.fields === null || payload.fields === undefined ? DEFAULT_FIELDS : payload.fields;
  state.cancel = payload.cancel === null || payload.cancel === undefined ? DEFAULT_CANCEL : payload.cancel;
  state.submit = payload.submit === null || payload.submit === undefined ? DEFAULT_SUBMIT : payload.submit;
  state.model = payload.model === null || payload.model === undefined ? DEFAULT_MODEL : payload.model;
  state.submitCb = payload.submitCb === null || payload.submitCb === undefined ? DEFAULT_SUBMIT_CB : payload.submitCb;
}

var _Dialog = {
  namespaced: true,
  state: {
    value: false,
    fullscreen: DEFAULT_FULLSCREEN,
    info: DEFAULT_INFO,
    persistent: DEFAULT_PERSISTENT,
    maxWidth: DEFAULT_MAX_WIDTH,
    title: DEFAULT_TITLE,
    text: DEFAULT_TEXT,
    fields: DEFAULT_FIELDS,
    cancel: DEFAULT_CANCEL,
    submit: DEFAULT_SUBMIT,
    model: DEFAULT_MODEL,
    submitCb: DEFAULT_SUBMIT_CB
  },
  getters: {
    GET: function GET(state) {
      return state;
    }
  },
  mutations: {
    SET_DIALOG: function SET_DIALOG(state, payload) {
      if (payload && payload.action === 'submit') {
        state.submitCb(state.model, state.fields);
      }
      if (payload === null || payload === undefined) {
        dialog_init(state);
        return;
      }
      setDialog(state, payload);
    },
    HIDE: function HIDE(state) {
      state.value = false;
    }
  },
  actions: {
    SET_DIALOG: function SET_DIALOG(_ref, payload) {
      var commit = _ref.commit;

      if (payload && payload.value) {
        commit('SET_DIALOG', payload);
      } else {
        commit('HIDE');
        setTimeout(function () {
          commit('SET_DIALOG', payload);
        }, 300);
      }
    }
  }
};
// CONCATENATED MODULE: ./src/store/user.js





var user__User = {
  namespaced: true,
  state: {
    listeMessages: [],
    remainingSteps: '',
    installProgress: 0,
    ongoingTuto: false,
    tutoQuited: false
  },
  getters: {
    user: function user(state) {
      return state;
    },
    fullName: function fullName(state) {
      return lodash_default.a.trim(state.fname + ' ' + state.lname);
    },
    userAvatar: function userAvatar(state) {
      if (state.avatar) {
        if (false) {
          return DOMAINE + '/dev/media/user/small/' + state.avatar;
        } else {
          return constants_DOMAINE + '/media/user/small/' + state.avatar;
        }
      }
      return null;
    },
    account: function account(state) {
      switch (parseInt(state.rights)) {
        case 0:
          return {
            type: translation.messages[translation.locale]['accountAgent'],
            role: 'peon',
            rights: parseInt(state.rights)
          };
        case 1:
          return {
            type: translation.messages[translation.locale]['accountAgent'],
            role: 'agent',
            rights: parseInt(state.rights)
          };
        case 2:
          return {
            type: translation.messages[translation.locale]['accountSuper'],
            role: 'super',
            rights: parseInt(state.rights)
          };
        case 3:
          return {
            type: translation.messages[translation.locale]['accountAdmin'],
            role: 'admin',
            rights: parseInt(state.rights)
          };
        case 999:
          return {
            type: translation.messages[translation.locale]['accountAdminTf'],
            role: 'adminTF',
            rights: parseInt(state.rights)
          };
        default:
          return {
            type: translation.messages[translation.locale]['accountUnknown'],
            role: null,
            rights: parseInt(state.rights)
          };
      }
    },
    level: function level(state) {
      var level = parseInt(state.entLevel);
      switch (level) {
        case LEVEL.HS:
          return {
            title: translation.messages[translation.locale]['levelHS'],
            rights: level,
            monitor: 0
          };
        case LEVEL.ESSAI:
          return {
            title: translation.messages[translation.locale]['levelEssai'],
            rights: level,
            monitor: 20000
          };
        case LEVEL.START:
          return {
            title: 'Start',
            rights: level,
            monitor: 45000
          };
        case LEVEL.CHAT:
          return {
            title: 'ChatFirst',
            rights: level,
            monitor: 0
          };
        case LEVEL.PRO:
          return {
            title: 'Pro',
            rights: level,
            monitor: 30000
          };
        case LEVEL.ENTREPRISE:
          return {
            title: 'Entreprise',
            rights: level,
            monitor: 20000
          };
        default:
          return null;
      }
    },

    colleaguesWithoutMe: function colleaguesWithoutMe(state) {
      return lodash_default.a.filter(state.colleagues, function (u) {
        return u.USR_ID !== state.id;
      });
    },

    botsWithoutMe: function botsWithoutMe(state) {
      return lodash_default.a.filter(state.bots, function (u) {
        return u.USR_ID !== state.id;
      });
    },
    getUserById: function getUserById(state) {
      return function (id) {
        var userId = parse_int_default()(id);
        return state.colleagues.find(function (c) {
          return parse_int_default()(c.USR_ID) === userId;
        });
      };
    }
  },
  mutations: {
    setUser: function setUser(state, newUser) {
      state.id = newUser.id;
      state.fname = newUser.fname;
      state.lname = newUser.lname;
      state.mail = newUser.mail;
      state.mailContact = newUser.mailContact;
      state.job = newUser.job;
      state.phone = newUser.phone;
      state.title = newUser.title;
      state.avatar = newUser.avatar;
      state.entLevel = newUser.entLevel;
      state.licSpecialtable = newUser.licSpecialtable;
      state.entSF = newUser.entSF;
      state.entZD = newUser.entZD;
      state.entGA = newUser.entGA;
      state.entSlack = newUser.entSlack;
      state.user_sites = newUser.user_sites;
      state.smsOn = newUser.smsOn;

      state.lang = newUser.lang;
      translation.locale = newUser.lang;
    },
    setAvatar: function setAvatar(state, newAvatar) {
      state.avatar = newAvatar ? newAvatar + '?' + Math.random() : null;
    },
    setEntNbPageTotal: function setEntNbPageTotal(state, nb) {
      state.entNbPageTotal = nb;
    },
    addColleague: function addColleague(state, colleague) {
      state.colleagues.push(colleague);
    },
    SET_MESSAGE_ATTENTE: function SET_MESSAGE_ATTENTE(state, liste) {
      state.listeMessages = liste;
    },
    SET_AVATAR_MESSAGE_ATTENTE: function SET_AVATAR_MESSAGE_ATTENTE(state, data) {
      state.listeMessages.splice(data.key, 1, data.visiteurData);
    },
    MAJ_PROGRESSION: function MAJ_PROGRESSION(state, data) {
      state.remainingSteps = data.remainingSteps;
      state.installProgress += data.installProgress;
    },
    ONGOING_TUTO: function ONGOING_TUTO(state, data) {
      state.ongoingTuto = data.ongoingTuto;
    },
    QUIT_TUTO: function QUIT_TUTO(state, data) {
      state.tutoQuited = data.tutoQuited;
    }
  }
};
// CONCATENATED MODULE: ./src/store/biblios.js




var _Biblios = {
  namespaced: true,
  state: {
    biblios: []
  },
  getters: {
    GET_BIBLIO_TITLE: function GET_BIBLIO_TITLE(state) {
      var list = [];
      lodash_default.a.forEach(state.biblios, function (biblio) {
        list.push({ text: biblio.title, value: biblio.id });
      });
      return list;
    },

    GET_BIBLIO_BY_ID: function GET_BIBLIO_BY_ID(state) {
      return function (id) {
        return lodash_default.a.cloneDeep(state.biblios.find(function (biblio) {
          return biblio.id === id;
        }));
      };
    },
    GET_BIBLIO_BY_TITLE: function GET_BIBLIO_BY_TITLE(state) {
      return function (title) {
        return lodash_default.a.cloneDeep(state.biblios.find(function (biblio) {
          return biblio.title === title;
        }));
      };
    },

    IS_SUB_BIBLIO: function IS_SUB_BIBLIO(state) {
      return function (biblio) {
        if (biblio.sub === '0' || biblio.sub === biblio.id) {
          return null;
        }
        return biblio.sub;
      };
    },

    GET_SENTENCES: function GET_SENTENCES(state, getters) {
      return function (search) {
        if (!search || search.length < 3) {
          return [];
        }

        var sentences = [];
        lodash_default.a.each(state.biblios, function (biblio) {
          sentences.push(biblio.sentences);
          if (biblio.subs) {
            lodash_default.a.each(biblio.subs, function (sub) {
              sentences.push(sub.sentences);
            });
          }
        });
        sentences = lodash_default.a.flattenDeep(sentences);

        search = search.toString().toLowerCase();
        return lodash_default.a.filter(sentences, function (s) {
          return lodash_default.a.includes(s.title.toLowerCase(), search);
        });
      };
    }
  },
  mutations: {
    INIT: function INIT(state) {
      state.biblios = [];
    },
    SET_BIBLIOS: function SET_BIBLIOS(state, biblios) {
      state.biblios = biblios;
    },
    ADD_BIBLIO: function ADD_BIBLIO(state, biblio) {
      var isSub = lodash_default.a.isNil(biblio.subs);

      if (!isSub) {
        state.biblios.push(biblio);
      } else {
        var idxParent = lodash_default.a.findIndex(state.biblios, { 'id': biblio.sub });

        state.biblios[idxParent].subs.push(biblio);
      }
    },
    UPDATE_BIBLIO: function UPDATE_BIBLIO(state, biblio) {
      var isSub = lodash_default.a.isNil(biblio.subs);

      if (!isSub) {
        var idx = lodash_default.a.findIndex(state.biblios, { 'id': biblio.id });
        state.biblios.splice(idx, 1, biblio);
      } else {
        var idxParent = lodash_default.a.findIndex(state.biblios, { 'id': biblio.sub });

        var idxSub = lodash_default.a.findIndex(state.biblios[idxParent].subs, { 'id': biblio.id });

        state.biblios[idxParent].subs.splice(idxSub, 1, biblio);
      }
    },
    REMOVE_BIBLIO: function REMOVE_BIBLIO(state, biblio) {
      var isSub = lodash_default.a.isNil(biblio.subs);

      if (!isSub) {
        var idx = lodash_default.a.findIndex(state.biblios, { 'id': biblio.id });
        state.biblios.splice(idx, 1);
      } else {
        var idxParent = lodash_default.a.findIndex(state.biblios, { 'id': biblio.sub });

        var idxSub = lodash_default.a.findIndex(state.biblios[idxParent].subs, { 'id': biblio.id });

        state.biblios[idxParent].subs.splice(idxSub, 1);
      }
    }
  },

  actions: {
    GET: function GET(_ref, agentId) {
      var commit = _ref.commit,
          state = _ref.state,
          getters = _ref.getters;

      return new promise_default.a(function (resolve, reject) {
        commit('INIT');

        axios_default.a.get('get/sentences.php?agentId=' + agentId).then(function (response) {
          var list = response.data;

          var biblioDefault = false;
          for (var i = 0; i < list['sentences'].length; i++) {
            if (list['sentences'][i].fam_id === '0') {
              biblioDefault = true;
            }
          }
          if (biblioDefault) {
            commit('ADD_BIBLIO', {
              id: '0',
              title: 'bibliothèque par défaut',
              sentences: [],
              subs: []
            });
          }

          lodash_default.a.each(list['biblios'], function (biblio) {
            biblio.sentences = [];
            var biblioExists = getters.GET_BIBLIO_BY_ID(biblio.id);
            var isSub = getters.IS_SUB_BIBLIO(biblio);

            if (!biblioExists && !isSub) {
              biblio.subs = [];
              commit('ADD_BIBLIO', biblio);
            } else if (isSub) {
              var parent = getters.GET_BIBLIO_BY_ID(isSub);
              parent.subs.push(biblio);
              commit('UPDATE_BIBLIO', parent);
            }
          });

          lodash_default.a.each(list['sentences'], function (sentence) {
            var biblioFound = lodash_default.a.cloneDeep(lodash_default.a.find(state.biblios, { 'id': sentence.fam_id }));

            if (biblioFound) {
              if (!biblioFound.sentences) {
                biblioFound.sentences = [];
              }

              biblioFound.sentences.push({
                id: sentence.id,
                title: sentence.title
              });
              commit('UPDATE_BIBLIO', biblioFound);
            } else {
              lodash_default.a.each(state.biblios, function (biblio) {
                var biblioCloned = lodash_default.a.cloneDeep(biblio);
                lodash_default.a.each(biblioCloned.subs, function (sub) {
                  if (sentence.fam_id === sub.id) {
                    sub.sentences.push({
                      id: sentence.id,
                      title: sentence.title
                    });
                  }
                });
                commit('UPDATE_BIBLIO', biblioCloned);
              });
            }
          });
          resolve(state);
        }).catch(function (e) {
          reject(e);
        });
      });
    }
  }
};
// EXTERNAL MODULE: ./node_modules/tfapi-client/dist/app.bundle.js
var app_bundle = __webpack_require__("brTE");
var app_bundle_default = /*#__PURE__*/__webpack_require__.n(app_bundle);

// CONCATENATED MODULE: ./src/store/reports.js




var _Reports = {
  namespaced: true,
  state: {
    reports: []
  },
  getters: {
    GET_REPORTS: function GET_REPORTS(state) {
      return state.reports;
    },
    GET_REPORT: function GET_REPORT(state) {
      return function (id) {
        var report = state.reports.find(function (r) {
          return r.id === id;
        });
        if (!report) throw new Error('Unknown report');
        return report;
      };
    },
    GET_NEW_REPORT: function GET_NEW_REPORT() {
      return {
        id: app_bundle_default.a.NEW_RESOURCE,
        title: 'Nouveau rapport',
        sender: '',
        emails: [],
        sites: [],
        periods: [],
        lang: 'fr',
        isFull: false,
        entreprise: {},
        hasC2cData: true,
        hasChatsData: true,
        hasChatbotData: true,
        hasCSV: false,
        subTitle: '',
        updatedAt: {},
        createdAt: {}
      };
    }
  },
  mutations: {
    INIT: function INIT(state) {
      state.reports = [];
    },
    SET_REPORTS: function SET_REPORTS(state, reports) {
      state.reports = reports;
    },
    ADD_REPORT: function ADD_REPORT(state, report) {
      state.reports.push(report);
    },
    UPDATE_REPORT: function UPDATE_REPORT(state, report) {
      var idx = state.reports.findIndex(function (r) {
        return r.id === report.id;
      });
      state.reports.splice(idx, 1, report);
    },
    REMOVE_REPORT: function REMOVE_REPORT(state, report) {
      var idx = state.reports.findIndex(function (r) {
        return r.id === report.id;
      });
      state.reports.splice(idx, 1);
    }
  },

  actions: {
    GET_ALL: function GET_ALL(context) {
      var _this = this;

      return asyncToGenerator_default()(regenerator_default.a.mark(function _callee() {
        var reports;
        return regenerator_default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                context.commit('INIT');
                _context.prev = 1;
                _context.next = 4;
                return app_bundle_default.a.get('reports/?id=' + context.rootState._User.entId + '&full=0');

              case 4:
                reports = _context.sent;

                context.commit('SET_REPORTS', reports);
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context['catch'](1);

                console.error(_context.t0);

              case 11:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this, [[1, 8]]);
      }))();
    },
    GET: function GET(_, reportId) {
      var _this2 = this;

      return asyncToGenerator_default()(regenerator_default.a.mark(function _callee2() {
        return regenerator_default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                return _context2.abrupt('return', app_bundle_default.a.get('reports/' + reportId));

              case 1:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    DELETE: function DELETE(_ref, report) {
      var _this3 = this;

      var commit = _ref.commit;
      return asyncToGenerator_default()(regenerator_default.a.mark(function _callee3() {
        return regenerator_default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                _context3.next = 3;
                return app_bundle_default.a.delete('reports/' + report.id);

              case 3:
                commit('REMOVE_REPORT', report);
                _context3.next = 9;
                break;

              case 6:
                _context3.prev = 6;
                _context3.t0 = _context3['catch'](0);

                console.error(_context3.t0);

              case 9:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3, [[0, 6]]);
      }))();
    },
    SAVE: function SAVE(_, report) {
      var _this4 = this;

      return asyncToGenerator_default()(regenerator_default.a.mark(function _callee4() {
        return regenerator_default.a.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                _context4.next = 3;
                return app_bundle_default.a.setOrUpdate('reports', report);

              case 3:
                _context4.next = 8;
                break;

              case 5:
                _context4.prev = 5;
                _context4.t0 = _context4['catch'](0);

                console.error(_context4.t0);

              case 8:
              case 'end':
                return _context4.stop();
            }
          }
        }, _callee4, _this4, [[0, 5]]);
      }))();
    }
  }
};
// CONCATENATED MODULE: ./src/store/sites.js




var _Sites = {
  namespaced: true,
  state: {
    sites: [],
    siteSelected: null,
    mapping: []
  },
  getters: {
    GET_SITE_BY_KEY: function GET_SITE_BY_KEY(state) {
      return function (key) {
        return lodash_default.a.find(state.sites, { 'LIC_KEY': key });
      };
    },
    GET_SITE_BY_ID: function GET_SITE_BY_ID(state) {
      return function (id) {
        return lodash_default.a.find(state.sites, { 'LIC_ID': id });
      };
    },

    HAS_ONE_MOTIF: function HAS_ONE_MOTIF(state) {
      return state.sites.filter(function (s) {
        return s.motifs && s.motifs.length > 0;
      }).length > 0;
    },
    AUTORIZED_AGENTS: function AUTORIZED_AGENTS(state) {
      return function (_ref) {
        var agentsArray = _ref.agentsArray,
            siteID = _ref.siteID,
            myID = _ref.myID;

        if (!state.mapping.length && !agentsArray.length) return [];

        var listAgentsSite = state.mapping[siteID][0].LIC_USR_LIST;

        var idAllAgents = listAgentsSite.map(function (agent) {
          return agent[0];
        });

        var idAgents = idAllAgents.filter(function (agent) {
          return agent !== myID;
        });

        return agentsArray.filter(function (agent) {
          return idAgents.findIndex(function (a) {
            return a === agent[2];
          }) !== -1;
        });
      };
    },

    HAS_ONE_FUNNEL: function HAS_ONE_FUNNEL(state) {
      return state.sites.filter(function (s) {
        return s.LIC_IS_FUNNEL === '1';
      }).length > 0;
    },

    HAS_CALLBACK_ACTIVATED: function HAS_CALLBACK_ACTIVATED(state) {
      return state.sites.filter(function (s) {
        return s.LIC_CALLBACK_ACTIVATED === '1';
      }).length > 0;
    },

    HAS_RECALL_ACTIVATED: function HAS_RECALL_ACTIVATED(state) {
      return state.sites.filter(function (s) {
        return s.LIC_RECALL_ACTIVATED === '1';
      }).length > 0;
    },

    HAS_BOT_ACTIVATED: function HAS_BOT_ACTIVATED(state) {
      return state.sites.filter(function (s) {
        return s.LIC_BOT_ACTIVATED === '1';
      }).length > 0;
    }
  },
  mutations: {
    INIT: function INIT(state) {
      state.sites = [];
      state.siteSelected = null;
      state.mapping = [];
    },
    ADD_SITE: function ADD_SITE(state, site) {
      state.sites.push(site);
    },
    UPDATE_SITE_SETTINGS: function UPDATE_SITE_SETTINGS(state, site) {
      var idx = lodash_default.a.findIndex(state.sites, { 'LIC_ID': site.LIC_ID });
      state.sites.splice(idx, 1, site);
    },
    UPDATE_SITE_SELECTED: function UPDATE_SITE_SELECTED(state, site) {
      state.siteSelected = lodash_default.a.clone(site);
    },
    SET_MAPPING: function SET_MAPPING(state, mapping) {
      state.mapping = lodash_default.a.cloneDeep(mapping);
    }
  },

  actions: {
    GET: function GET(_ref2) {
      var commit = _ref2.commit,
          state = _ref2.state,
          getters = _ref2.getters;

      commit('INIT');
      return new promise_default.a(function (resolve, reject) {
        axios_default.a.get('get/sites.php').then(function (response) {
          var sites = response.data;
          lodash_default.a.each(sites, function (site, id) {
            try {
              site[0].DSK_CUSTOM_LEAD_FORM = JSON.parse(site[0].DSK_CUSTOM_LEAD_FORM);
            } catch (e) {}
            commit('ADD_SITE', site[0]);
          });
          if (state.sites[0]) {
            commit('UPDATE_SITE_SELECTED', state.sites[0]);
          }
          resolve(state);
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    GET_MAPPING: function GET_MAPPING(_ref3) {
      var commit = _ref3.commit,
          state = _ref3.state,
          getters = _ref3.getters;

      return new promise_default.a(function (resolve, reject) {
        axios_default.a.get('get/mapping.php').then(function (response) {
          commit('SET_MAPPING', response.data);
          resolve(response.data);
        }).catch(function (e) {
          reject(e);
        });
      });
    }
  }
};
// CONCATENATED MODULE: ./src/store/storeWatcheeBox.js








var MAX_VISITORS = 300;

var _StoreWatcheeBox = {
  namespaced: true,

  state: {
    status: 'offline',
    statusManually: '',
    isConnected: false,
    reconnexionSocket: false,
    socketMessage: '',
    mySocketID: '',
    socketStatus: true,
    demandeCobrowsing: {},
    cobrowsingActif: [false, false, false, false],
    timerActifAgent: [false, false, false, false],

    focusPupitre: { view: '', focusSessionID: '', myFocus: true },
    agentsArray: [],
    listeAllVisiteurs: [{}],
    allDataVisiteurOpened: {},
    listeChatAgent: [],
    lastMessage: {},
    newMessage: {},
    statusMessage: {},

    clientSatisfaction: {},
    transfertStatusReception: {},
    transfertStatusEmission: {},
    sessionsPrivees: [],
    visiteurChatSelected: null,
    messageAttenteSelected: null,
    countVisitors: null,
    tooMuchAgentsChecked: false,
    sessionDejaActive: false,
    sessionPhpActive: null,
    delogOldSession: false,
    autoDelogMySession: false,
    pupitreViewStatus: 4,
    dragChat: false
  },

  getters: {
    WATCHEEBOX_STATE: function WATCHEEBOX_STATE(state) {
      return state;
    },
    WATCHEEBOX_LISTE_VISITEURS: function WATCHEEBOX_LISTE_VISITEURS(state) {
      return state.listeAllVisiteurs;
    },

    pupitreViewsData: function pupitreViewsData(state) {
      var pupitre = [{ view: {} }, { view: {} }, { view: {} }, { view: {} }];
      lodash_default.a.each(state.listeAllVisiteurs, function (o) {
        if (!lodash_default.a.isNil(o.placePupitre)) {
          var placeIndex = o.placePupitre - 1;

          var newObjectPupitre = { view: {
              visiteurDatas: o,
              visiteurID: o.visiteurID,
              viewStatus: true,
              online: o.status === 'online'
            } };

          pupitre.splice(placeIndex, 1, newObjectPupitre);
        }
      });
      return pupitre;
    }
  },

  mutations: {
    INIT: function INIT(state) {
      state.status = 'online';
      state.statusManually = '';
      state.isConnected = false;
      state.reconnexionSocket = false;
      state.socketMessage = '';
      state.mySocketID = '';
      state.socketStatus = true;
      state.demandeCobrowsing = {};
      state.cobrowsingActif = [false, false, false, false];
      state.timerActifAgent = [false, false, false, false];

      state.focusPupitre = { view: '', focusSessionID: '', myFocus: true };
      state.agentsArray = [];
      state.listeAllVisiteurs = [{}];
      state.allDataVisiteurOpened = {};
      state.listeChatAgent = [];
      state.lastMessage = {};
      state.newMessage = {};
      state.statusMessage = {};
      state.isTyping = {};
      state.clientSatisfaction = {};
      state.transfertStatusReception = {};
      state.transfertStatusEmission = {};
      state.sessionsPrivees = [];
      state.visiteurChatSelected = null;
      state.messageAttenteSelected = null;
      state.countVisitors = null;
      state.tooMuchAgentsChecked = false;
      state.sessionDejaActive = false;
      state.sessionPhpActive = null;
      state.delogOldSession = false;
      state.autoDelogMySession = false;

      state.dragChat = false;
    },
    PLAY_SOUND_CONVERSATION: function PLAY_SOUND_CONVERSATION() {
      var audioConversation = document.createElement('audio');
      audioConversation.setAttribute('src', AWSS3_STATIC + '/sounds/new_conv1.mp3');
      audioConversation.load();
      audioConversation.play();
    },
    PLAY_SOUND_MESSAGE_FOCUS_IN: function PLAY_SOUND_MESSAGE_FOCUS_IN() {
      var audioMessageFocusIn = document.createElement('audio');
      audioMessageFocusIn.setAttribute('src', AWSS3_STATIC + '/sounds/new_message1.mp3');
      audioMessageFocusIn.load();
      audioMessageFocusIn.play();
    },
    PLAY_SOUND_MESSAGE_FOCUS_OUT: function PLAY_SOUND_MESSAGE_FOCUS_OUT() {
      var audioMessageFocusOut = document.createElement('audio');
      audioMessageFocusOut.setAttribute('src', AWSS3_STATIC + '/sounds/new_message2.mp3');
      audioMessageFocusOut.load();
      audioMessageFocusOut.play();
    },
    PLAY_SOUND_OPEN_BO: function PLAY_SOUND_OPEN_BO() {
      var audioOuvertureBO = new Audio(AWSS3_STATIC + '/sounds/ouverture1.mp3');

      audioOuvertureBO.load();
      var playPromise = audioOuvertureBO.play();

      if (playPromise !== undefined) {
        playPromise.then(function () {
          audioOuvertureBO.play();
        }).catch(function (e) {
          console.log('erreur', e);
        });
      }
    },
    PLAY_SOUND_OFFLINE: function PLAY_SOUND_OFFLINE() {
      var audioOffline = document.createElement('audio');
      audioOffline.setAttribute('src', AWSS3_STATIC + '/sounds/offline.mp3');
      audioOffline.load();
      audioOffline.play();
    },
    SOCKET_CONNECT_CLIENT: function SOCKET_CONNECT_CLIENT(state) {
      console.log('connect client server');
      state.isConnected = true;
      state.status = 'offline';
      state.reconnexionSocket = false;
    },
    SOCKET_DISCONNECT_CLIENT: function SOCKET_DISCONNECT_CLIENT(state) {
      state.isConnected = false;
      state.socketStatus = false;
      state.status = 'offline';
      state.reconnexionSocket = true;
      this.commit('_StoreWatcheeBox/PLAY_SOUND_OFFLINE');
    },
    SOCKET_CONNECTING: function SOCKET_CONNECTING(state, message) {
      state.socketStatus = true;
      console.log('connecting :' + message);
    },
    SOCKET_CONNECT_FAILED: function SOCKET_CONNECT_FAILED(state, message) {
      state.socketStatus = false;
      console.log('connect_failed :' + message);
    },
    SOCKET_CLOSE: function SOCKET_CLOSE(state, message) {
      state.socketStatus = false;
      console.log('close :' + message);
    },
    SOCKET_RECONNECT: function SOCKET_RECONNECT(state, message) {
      state.socketStatus = true;
      console.log('reconnect : ' + message + ' - ');
    },
    SOCKET_RECONNECTING: function SOCKET_RECONNECTING(state, message) {
      state.socketStatus = true;
      state.reconnexionSocket = true;
      console.log('reconnecting : ' + message + ' - ');
    },
    SOCKET_RECONNECT_FAILED: function SOCKET_RECONNECT_FAILED(state, message) {
      console.log('reconnect_failed -- connection :' + message);
    },
    SOCKET_RECONNECT_ATTEMPT: function SOCKET_RECONNECT_ATTEMPT(state, message) {
      state.socketStatus = false;
      console.log('reconnect_attempt :' + message);
    },
    SOCKET_LAST_SOCKET_DISCONNECTED: function SOCKET_LAST_SOCKET_DISCONNECTED(state, message) {
      console.log('lastSocketDisconnected :' + message);
    },
    SOCKET_ERROR_MESSAGE: function SOCKET_ERROR_MESSAGE(state, message) {
      state.socketMessage = message;
    },
    SOCKET_NO_AUTORISATION_AGENT: function SOCKET_NO_AUTORISATION_AGENT(state, message) {
      console.log('SOCKET_NO_AUTORISATION_AGENT', message);
      state.sessionDejaActive = true;
      state.sessionPhpActive = message.PHPSessionID;
    },
    SOCKET_DELOG_OLD_SESSION: function SOCKET_DELOG_OLD_SESSION(state, message) {
      console.log('SOCKET_DELOG_OLD_SESSION', message);
      state.delogOldSession = true;
    },
    SOCKET_AUTO_DELOG_SESSION: function SOCKET_AUTO_DELOG_SESSION(state, message) {
      console.log('SOCKET_AUTO_DELOG_SESSION', message);
      state.autoDelogMySession = true;
    },
    SOCKET_INFOS_AGENT: function SOCKET_INFOS_AGENT(state, message) {
      console.log('SOCKET_INFOS_AGENT');

      state.mySocketID = message.mySocketID;
      state.sessionDejaActive = false;
      state.sessionPhpActive = null;
      state.isConnected = true;
      state.delogOldSession = false;
      state.autoDelogMySession = false;

      if (this.getters['_User/user'].chatsMax <= state.sessionsPrivees.length) {
        state.status = 'busy';
      }
    },
    SOCKET_LISTE_AGENTS: function SOCKET_LISTE_AGENTS(state, message) {
      state.status = message.status;
      state.agentsArray = message.listeAgents;
      state.listeChatAgent = message.chatAgent;
    },
    RECONNEXION_AUTO: function RECONNEXION_AUTO(state, message) {
      console.log('state.reconnexionSocket', state.reconnexionSocket);
      state.reconnexionSocket = message.status;
    },
    CHANGE_DRAG_CHAT: function CHANGE_DRAG_CHAT(state, message) {
      state.dragChat = message;
    },
    CHANGE_VIEW_PUPITRE: function CHANGE_VIEW_PUPITRE(state, message) {
      state.pupitreViewStatus = message;
    },
    CHANGE_PLACE_PUPITRE_VISITEUR: function CHANGE_PLACE_PUPITRE_VISITEUR(state, message) {
      console.log('CHANGE_PLACE_PUPITRE_VISITEUR', message);
      var dateChange = Date.now();

      var indexDrop = lodash_default.a.findIndex(state.listeAllVisiteurs, { visiteurID: message.dataDrop.visiteurID });
      if (indexDrop === -1) return;

      if (message.statusView) {
        var indexPlaceOccupe = lodash_default.a.findIndex(state.listeAllVisiteurs, { visiteurID: message.idVisiteurPlace });

        if (indexPlaceOccupe !== -1) {
          var visiteurDejaLa = lodash_default.a.cloneDeep(state.listeAllVisiteurs[indexPlaceOccupe]);

          var _dataToPost = new window.FormData();
          _dataToPost.append('timestamp', dateChange);
          _dataToPost.append('agent_id', this.getters['_User/user'].id);
          _dataToPost.append('visiteur_id', visiteurDejaLa.visiteurID);
          _dataToPost.append('placePupitre', visiteurDejaLa.placePupitre);
          _dataToPost.append('status', 0);
          _dataToPost.append('numChat', state.sessionsPrivees.length);
          _dataToPost.append('chatMax', this.getters['_User/user'].chatsMax);
          axios_default.a.post('post/addChatPupitre.php', _dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {});

          var _dataToPost2 = new window.FormData();
          _dataToPost2.append('timestamp', dateChange);
          _dataToPost2.append('agent_id', this.getters['_User/user'].id);
          _dataToPost2.append('visiteur_id', visiteurDejaLa.visiteurID);
          _dataToPost2.append('placePupitre', message.dataDrop.placePupitreActif);
          _dataToPost2.append('status', 1);
          _dataToPost2.append('numChat', state.sessionsPrivees.length);
          _dataToPost2.append('chatMax', this.getters['_User/user'].chatsMax);
          axios_default.a.post('post/addChatPupitre.php', _dataToPost2, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {});

          visiteurDejaLa.placePupitre = message.dataDrop.placePupitreActif;
          visiteurDejaLa.lastMessage = '';
          state.listeAllVisiteurs.splice(indexPlaceOccupe, 1, visiteurDejaLa);
        } else {
          console.log('aucun visiteur actuellemnt en place', message.place);
        }
      }

      console.log('old place', message.dataDrop.placePupitreActif);
      console.log('new place', message.place);

      var dataToPost = new window.FormData();
      dataToPost.append('timestamp', dateChange);
      dataToPost.append('agent_id', this.getters['_User/user'].id);
      dataToPost.append('visiteur_id', message.dataDrop.visiteurID);
      dataToPost.append('placePupitre', message.dataDrop.placePupitreActif);
      dataToPost.append('status', 0);
      dataToPost.append('numChat', state.sessionsPrivees.length);
      dataToPost.append('chatMax', this.getters['_User/user'].chatsMax);
      axios_default.a.post('post/addChatPupitre.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        console.log('chat in pupitre', response);
      });

      var dataToPost2 = new window.FormData();
      dataToPost2.append('timestamp', dateChange);
      dataToPost2.append('agent_id', this.getters['_User/user'].id);
      dataToPost2.append('visiteur_id', message.dataDrop.visiteurID);
      dataToPost2.append('placePupitre', message.place);
      dataToPost2.append('status', 1);
      dataToPost2.append('numChat', state.sessionsPrivees.length);
      dataToPost2.append('chatMax', this.getters['_User/user'].chatsMax);
      axios_default.a.post('post/addChatPupitre.php', dataToPost2, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        console.log('chat in pupitre', response);
      });

      var visiteurSelect = lodash_default.a.cloneDeep(state.listeAllVisiteurs[indexDrop]);

      visiteurSelect.placePupitre = message.place;

      state.listeAllVisiteurs.splice(indexDrop, 1, visiteurSelect);
    },
    AGENT_RELOAD: function AGENT_RELOAD(state, message) {
      state.newMessage = {};
    },
    AGENT_FOCUS: function AGENT_FOCUS(state, message) {
      var newFocusData = lodash_default.a.cloneDeep(state.focusPupitre);
      if (message.view) {
        newFocusData.view = message.view;
      }
      if (message.visiteurID) {
        newFocusData.focusSessionID = message.visiteurID;
      }
      if (!lodash_default.a.isNil(message.myFocus)) {
        newFocusData.myFocus = message.myFocus;
      }
      state.focusPupitre = newFocusData;
    },
    SOCKET_LISTE_VISITEURS: function SOCKET_LISTE_VISITEURS(state, message) {
      var forFiltrageFront = false;
      if (this.getters['_User/user'].filterFront === '1') {
        forFiltrageFront = true;
      } else {
        forFiltrageFront = false;
      }

      var newArrayVisiteurs = [];

      lodash_default.a.forEach(message.listeVisiteurs, function (visiteurListNode, key) {
        if (lodash_default.a.indexOf(message.listAllSiteID, visiteurListNode.siteId) !== -1) {
          var newObjVisiteur = {
            status: visiteurListNode.etat,
            connexion: true,
            openFiche: false,
            lang: visiteurListNode.lang,
            visiteurID: visiteurListNode.id,
            roomName: visiteurListNode.roomName,
            socketID: [visiteurListNode.socketID],
            siteID: visiteurListNode.siteId,
            notification: visiteurListNode.notification,
            placePupitre: null,
            fileAttente: null,
            lastMessage: null,
            newMessage: false,
            timeStampArrive: null,
            reponseCobrowsing: false,
            motif: false,
            geoloc: {},
            histoChat: []
          };

          if (forFiltrageFront) {
            newObjVisiteur['visiteurName'] = visiteurListNode.shortdesc;
            newObjVisiteur['alreadyConsulted'] = visiteurListNode.alreadyConsulted;
            newObjVisiteur['autoInvit'] = visiteurListNode.autoInvit;
            newObjVisiteur['autoInvitType'] = visiteurListNode.autoInvitType;
            newObjVisiteur['autoinvitSend'] = visiteurListNode.autoinvitSend;
            newObjVisiteur['dateLastChat'] = visiteurListNode.dateLastChat;
            newObjVisiteur['getplusinfoavailable'] = visiteurListNode.getplusinfoavailable;
            newObjVisiteur['key'] = visiteurListNode.key;
            newObjVisiteur['keyVis'] = visiteurListNode.keyVis;
            newObjVisiteur['listAlert'] = visiteurListNode.listAlert;
            newObjVisiteur['nbCustomAlert'] = visiteurListNode.nbCustomAlert;
            newObjVisiteur['nb_alert'] = visiteurListNode.nb_alert;
            newObjVisiteur['nbchats'] = visiteurListNode.nbchats;
            newObjVisiteur['pagesFocus'] = visiteurListNode.pagesFocus;
            newObjVisiteur['ponderation'] = visiteurListNode.ponderation;
            newObjVisiteur['savedConversation'] = visiteurListNode.savedConversation;
            newObjVisiteur['shortdesc'] = visiteurListNode.shortdesc;
            newObjVisiteur['visId'] = visiteurListNode.visId;
            newObjVisiteur['visitorApiInfo'] = visiteurListNode.visitorApiInfo;
            newObjVisiteur['wz_textSocialNotif'] = visiteurListNode.wz_textSocialNotif;
          }

          newArrayVisiteurs.push(newObjVisiteur);
        }
      });

      lodash_default.a.forEach(state.listeAllVisiteurs, function (visiteurList, key) {
        if (visiteurList.socketID === 0 && (visiteurList.placePupitre !== null || visiteurList.fileAttente !== null)) {
          var index = lodash_default.a.findIndex(newArrayVisiteurs, {
            visiteurID: visiteurList.visiteurID
          });
          if (index !== -1) {
            newArrayVisiteurs[index].fileAttente = visiteurList.fileAttente;
            newArrayVisiteurs[index].lastMessage = visiteurList.lastMessage;
          } else {
            newArrayVisiteurs.push(visiteurList);
          }
        } else if (visiteurList.network && (visiteurList.placePupitre !== null || visiteurList.fileAttente !== null)) {
          var index2 = lodash_default.a.findIndex(newArrayVisiteurs, {
            visiteurID: visiteurList.visiteurID
          });
          if (index2 !== -1) {
            newArrayVisiteurs[index2].fileAttente = visiteurList.fileAttente;
            newArrayVisiteurs[index2].lastMessage = visiteurList.lastMessage;
          } else {
            newArrayVisiteurs.push(visiteurList);
          }
        } else {
          lodash_default.a.forEach(newArrayVisiteurs, function (visiteurArray, key) {
            if (visiteurList.visiteurID === visiteurArray.visiteurID) {
              if (visiteurList.histoChat.length) {
                visiteurArray.histoChat = visiteurList.histoChat;
              }

              if (visiteurList.geoloc) {
                visiteurArray.geoloc = visiteurList.geoloc;
              }

              if (visiteurList.placePupitre) {
                visiteurArray.placePupitre = visiteurList.placePupitre;
              }

              if (visiteurList.timeStampArrive) {
                visiteurArray.timeStampArrive = visiteurList.timeStampArrive;
              }

              if (visiteurList.visiteurID === state.visiteurChatSelected) {
                visiteurArray.openFiche = true;
              }
              visiteurArray.menuSelected = visiteurList.menuSelected;
              visiteurArray.reponseCobrowsing = visiteurList.reponseCobrowsing;
              visiteurArray.alertsAllowed = visiteurList.alertsAllowed;
              visiteurArray.newMessage = visiteurList.newMessage;
              visiteurArray.lastMessage = visiteurList.lastMessage;
              if (visiteurList.fileAttente) {
                visiteurArray.fileAttente = visiteurList.fileAttente;
              }
            }
          });
        }
      });

      state.listeAllVisiteurs = newArrayVisiteurs;
    },
    SOCKET_LEAVE_VISITEURS: function SOCKET_LEAVE_VISITEURS(state, message) {
      var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.clientID
      });
      if (index === -1) return;
      var visiteurSelect = lodash_default.a.cloneDeep(state.listeAllVisiteurs[index]);

      if (this.getters['_User/user'].filterFront === '1') {
        if (visiteurSelect.placePupitre || visiteurSelect.openFiche) {
          visiteurSelect.connexion = false;
          visiteurSelect.socketID = message.newSocketID;
          state.listeAllVisiteurs.splice(index, 1, visiteurSelect);
        } else {
          state.listeAllVisiteurs.splice(index, 1);
        }
      } else {
        visiteurSelect.connexion = false;
        visiteurSelect.socketID = message.newSocketID;
        state.listeAllVisiteurs.splice(index, 1, visiteurSelect);
      }
    },
    SOCKET_CLIENT_CHANGE_SOCKETID: function SOCKET_CLIENT_CHANGE_SOCKETID(state, message) {
      var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.clientID
      });
      if (index === -1) return;
      var visiteurSelect = lodash_default.a.cloneDeep(state.listeAllVisiteurs[index]);
      visiteurSelect.status = 'online';
      visiteurSelect.connexion = true;
      visiteurSelect.socketID = message.listeSocketID;
      state.listeAllVisiteurs.splice(index, 1, visiteurSelect);

      lodash_default.a.forEach(state.sessionsPrivees, function (chatSession, key) {
        if (chatSession[1] === message.clientID) {
          var chatSelect = lodash_default.a.cloneDeep(chatSession);
          chatSelect[0] = message.listeSocketID;
          state.sessionsPrivees.splice(key, 1, chatSelect);
        }
      });
    },
    SOCKET_NEW_VISITEUR: function SOCKET_NEW_VISITEUR(state, message) {
      var forFiltrageFront = false;
      if (this.getters['_User/user'].filterFront === '1') {
        forFiltrageFront = true;
      } else {
        forFiltrageFront = false;
      }

      if (lodash_default.a.indexOf(message.listAllSiteID, message.newVisiteur[5]) !== -1) {
        var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
          visiteurID: message.newVisiteur[2]
        });
        if (message.maxVisitors) {
          MAX_VISITORS = message.maxVisitors;
        }
        if (index === -1 && state.listeAllVisiteurs.length < MAX_VISITORS) {
          var newObjVisiteur = {
            status: message.newVisiteur[0],
            connexion: true,
            openFiche: false,
            lang: message.newVisiteur[1],
            visiteurID: message.newVisiteur[2],
            roomName: message.newVisiteur[3],
            socketID: message.listeSocketID,
            siteID: message.newVisiteur[5],
            notification: message.newVisiteur[6],
            placePupitre: null,
            fileAttente: null,
            lastMessage: null,
            chatted: false,
            newMessage: false,
            timeStampArrive: null,
            reponseCobrowsing: false,
            geoloc: {},
            histoChat: []
          };

          if (forFiltrageFront) {
            newObjVisiteur['visiteurName'] = message.dataFiltrage.shortdesc;
            newObjVisiteur['alreadyConsulted'] = message.dataFiltrage.alreadyConsulted;
            newObjVisiteur['autoInvit'] = message.dataFiltrage.autoInvit;
            newObjVisiteur['autoInvitType'] = message.dataFiltrage.autoInvitType;
            newObjVisiteur['autoinvitSend'] = message.dataFiltrage.autoinvitSend;
            newObjVisiteur['dateLastChat'] = message.dataFiltrage.dateLastChat;
            newObjVisiteur['getplusinfoavailable'] = message.dataFiltrage.getplusinfoavailable;
            newObjVisiteur['key'] = message.dataFiltrage.key;
            newObjVisiteur['keyVis'] = message.dataFiltrage.keyVis;
            newObjVisiteur['listAlert'] = message.dataFiltrage.listAlert;
            newObjVisiteur['nbCustomAlert'] = message.dataFiltrage.nbCustomAlert;
            newObjVisiteur['nb_alert'] = message.dataFiltrage.nb_alert;
            newObjVisiteur['nbchats'] = message.dataFiltrage.nbchats;
            newObjVisiteur['pagesFocus'] = message.dataFiltrage.pagesFocus;
            newObjVisiteur['ponderation'] = message.dataFiltrage.ponderation;
            newObjVisiteur['savedConversation'] = message.dataFiltrage.savedConversation;
            newObjVisiteur['shortdesc'] = message.dataFiltrage.shortdesc;
            newObjVisiteur['visId'] = message.dataFiltrage.visId;
            newObjVisiteur['visitorApiInfo'] = message.dataFiltrage.visitorApiInfo;
            newObjVisiteur['wz_textSocialNotif'] = message.dataFiltrage.wz_textSocialNotif;
          }
          console.log('newObjVisiteur', newObjVisiteur);
          state.listeAllVisiteurs.push(newObjVisiteur);
        } else if (index !== -1) {
          var visiteurSelect = lodash_default.a.cloneDeep(state.listeAllVisiteurs[index]);
          visiteurSelect.status = message.newVisiteur[0];
          visiteurSelect.connexion = true;
          visiteurSelect.lang = message.newVisiteur[1];
          visiteurSelect.visiteurID = message.newVisiteur[2];
          visiteurSelect.roomName = message.newVisiteur[3];
          visiteurSelect.socketID = message.listeSocketID;
          visiteurSelect.siteID = message.newVisiteur[5];
          visiteurSelect.notification = message.newVisiteur[6];

          visiteurSelect.visiteurName = message.dataFiltrage.shortdesc;
          visiteurSelect.alreadyConsulted = message.dataFiltrage.alreadyConsulted;
          visiteurSelect.autoInvit = message.dataFiltrage.autoInvit;
          visiteurSelect.autoInvitType = message.dataFiltrage.autoInvitType;
          visiteurSelect.autoinvitSend = message.dataFiltrage.autoinvitSend;
          visiteurSelect.dateLastChat = message.dataFiltrage.dateLastChat;
          visiteurSelect.getplusinfoavailable = message.dataFiltrage.getplusinfoavailable;
          visiteurSelect.key = message.dataFiltrage.key;
          visiteurSelect.keyVis = message.dataFiltrage.keyVis;
          visiteurSelect.listAlert = message.dataFiltrage.listAlert;
          visiteurSelect.nbCustomAlert = message.dataFiltrage.nbCustomAlert;
          visiteurSelect.nb_alert = message.dataFiltrage.nb_alert;
          visiteurSelect.nbchats = message.dataFiltrage.nbchats;
          visiteurSelect.pagesFocus = message.dataFiltrage.pagesFocus;
          visiteurSelect.ponderation = message.dataFiltrage.ponderation;
          visiteurSelect.savedConversation = message.dataFiltrage.savedConversation;
          visiteurSelect.shortdesc = message.dataFiltrage.shortdesc;
          visiteurSelect.visId = message.dataFiltrage.visId;
          visiteurSelect.visitorApiInfo = message.dataFiltrage.visitorApiInfo;
          visiteurSelect.wz_textSocialNotif = message.dataFiltrage.wz_textSocialNotif;

          state.listeAllVisiteurs.splice(index, 1, visiteurSelect);
        }
      }
    },
    ADD_VISITEURS_SOCIAL: function ADD_VISITEURS_SOCIAL(state, visiteur) {
      var newObjVisiteur = {
        status: 'online',
        connexion: true,
        openFiche: false,
        lang: visiteur.dataMessage.dataVisiteur.locale,
        visiteurID: visiteur.dataMessage.dataVisiteur.id,
        visiteurName: visiteur.dataMessage.dataVisiteur.first_name + ' ' + visiteur.dataMessage.dataVisiteur.last_name,
        networkFirstMessage: true,
        network: visiteur.dataMessage.network,
        profile_pic: visiteur.dataMessage.dataVisiteur.profile_pic,
        placePupitre: visiteur.placePupitre,
        fileAttente: visiteur.fileAttente,
        lastMessage: visiteur.dataMessage.message,
        newMessage: true,
        timeStampArrive: visiteur.dataMessage.time,
        histoChat: []
      };
      state.listeAllVisiteurs.push(newObjVisiteur);
    },
    SET_VISITEURS: function SET_VISITEURS(state, visiteur) {
      console.log('set visiteur', visiteur);
      if (visiteur) {
        var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
          visiteurID: visiteur.visiteurID
        });
        if (index === -1) return;
        state.listeAllVisiteurs.splice(index, 1, visiteur);
      }
    },
    SET_VISITEURS_OPENED_HISTOCHAT: function SET_VISITEURS_OPENED_HISTOCHAT(state, data) {
      if (data) {
        state.allDataVisiteurOpened.histoChat = data;
      }
    },
    SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE: function SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE(state, visiteur) {
      if (visiteur) {
        state.allDataVisiteurOpened = visiteur;
      }
    },
    OPEN_FICHE_VISITEUR: function OPEN_FICHE_VISITEUR(state, visiteur) {
      console.log('open fiche visiteur', visiteur);

      var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
        visiteurID: visiteur.visiteurID
      });
      if (index === -1) return;
      var visiteurSelect = lodash_default.a.cloneDeep(state.listeAllVisiteurs[index]);
      visiteurSelect.openFiche = true;
      state.listeAllVisiteurs.splice(index, 1, visiteurSelect);
    },
    CLOSE_FICHE_VISITEUR: function CLOSE_FICHE_VISITEUR(state, visiteur) {
      console.log('close fiche visiteur', visiteur);

      var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
        visiteurID: visiteur.visiteurID
      });
      if (index === -1) return;
      if (state.listeAllVisiteurs[index].connexion) {
        var visiteurSelect = lodash_default.a.cloneDeep(state.listeAllVisiteurs[index]);
        visiteurSelect.openFiche = false;
        state.listeAllVisiteurs.splice(index, 1, visiteurSelect);
      } else {
        state.listeAllVisiteurs.splice(index, 1);
      }
      console.log('[index]', state.listeAllVisiteurs);
    },
    REMOVE_VISITEUR: function REMOVE_VISITEUR(state, visiteur) {
      var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
        visiteurID: visiteur.visiteurID
      });
      if (index === -1) return;
      state.listeAllVisiteurs.splice(index, 1);
    },
    REMOVE_VISITEUR_BY_INDEX: function REMOVE_VISITEUR_BY_INDEX(state, index) {
      state.listeAllVisiteurs.splice(index, 1);
    },
    SOCKET_UPDATE_CHAT: function SOCKET_UPDATE_CHAT(state, message) {
      console.log('SOCKET_UPDATE_CHAT', message);

      if (state.sessionsPrivees.length < this.getters['_User/user'].chatsMax) {
        var indexSessionChat = lodash_default.a.findIndex(state.sessionsPrivees, [1, message.messageChat.chatSession]);

        var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
          visiteurID: message.messageChat.chatSession
        });

        var indexSession = message.indexSession;
        var nameAuteur = message.messageChat.chatSession;
        if (message.messageChat.nameAuteur && message.messageChat.auteur === 'Agent') {
          nameAuteur = message.messageChat.nameAuteur;
        } else if (index !== -1 && state.listeAllVisiteurs[index].visiteurName) {
          nameAuteur = state.listeAllVisiteurs[index].visiteurName;
        }

        var dataSession = [message.messageChat.clientSocketID, message.messageChat.chatSession, message.messageChat.WZAgentId, nameAuteur];
        console.log('indexSession', indexSession);

        if (indexSession === -1) {
          var newObjVisiteur = {
            status: 'online',
            connexion: true,
            lang: 'fr',
            visiteurID: message.messageChat.chatSession,
            roomName: message.messageChat.chatSession,
            socketID: message.messageChat.clientSocketID,
            siteID: message.messageChat.siteId,
            notification: '',
            placePupitre: null,
            fileAttente: null,
            chatted: false,
            lastMessage: null,
            newMessage: true,
            timeStampArrive: null,
            geoloc: {},
            histoChat: message.histoChat
          };

          watcheebox_watcheebox.envoisMessage({
            agentSocketID: state.mySocketID,
            datasAgent: this.getters['_User/user'],
            datasVisiteur: newObjVisiteur,
            message: 'analytics',
            messageType: 11,
            filterId: 0,
            agentName: ''
          });

          if (index === -1) {
            state.listeAllVisiteurs.push(newObjVisiteur);
            index = state.listeAllVisiteurs.length - 1;
          } else {
            state.listeAllVisiteurs[index].status = newObjVisiteur.status;
            state.listeAllVisiteurs[index].connexion = newObjVisiteur.connexion;

            state.listeAllVisiteurs[index].visiteurID = newObjVisiteur.visiteurID;

            state.listeAllVisiteurs[index].chatted = newObjVisiteur.chatted;
            state.listeAllVisiteurs[index].lastMessage = newObjVisiteur.lastMessage;
            state.listeAllVisiteurs[index].newMessage = newObjVisiteur.newMessage;
            state.listeAllVisiteurs[index].timeStampArrive = newObjVisiteur.timeStampArrive;
          }

          if (message.messageChat.WZAgentId === this.getters['_User/user'].id) {
            console.log('state.newMessage', newObjVisiteur);
            state.newMessage = {
              timestamp: message.messageChat.timeStamp,
              type: message.messageChat.messageType,
              nameAuteur: nameAuteur,
              message: message.messageChat.message,
              auteur: message.messageChat.auteur,
              visitorId: message.messageChat.chatSession,
              attachments: message.messageChat.attachments
            };

            state.listeAllVisiteurs[index].histoChat = message.histoChat;

            if (state.listeAllVisiteurs[index].placePupitre === null && state.listeAllVisiteurs[index].fileAttente === null) {
              this.commit('_StoreWatcheeBox/PLAY_SOUND_CONVERSATION');
              if (message.messageChat.auteur === 'Visiteur') {
                watcheebox_watcheebox.receptionMessage({
                  agentSocketID: state.mySocketID,
                  siteID: message.messageChat.siteId,
                  datasAgent: this.getters['_User/user'],
                  datasVisiteur: newObjVisiteur,
                  ARType: 1,
                  messageID: message.messageChat.timeStamp
                });
              }


              var arrayVisiteur = lodash_default.a.cloneDeep(state.listeAllVisiteurs[index]);
              arrayVisiteur.newMessage = true;
              arrayVisiteur.timeStampArrive = Date.now();
              arrayVisiteur.dataMessage = message.messageChat;
              var placeOccupe = [];

              lodash_default.a.forEach(state.listeAllVisiteurs, function (allVisiteurs, key) {
                if (allVisiteurs.visiteurID === message.messageChat.chatSession) {}
                if (allVisiteurs.placePupitre) {
                  placeOccupe.push(allVisiteurs.placePupitre);
                }
              });

              if (placeOccupe.length > 3) {
                arrayVisiteur.timeStampArrive = Date.now();
                arrayVisiteur.fileAttente = this.getters['_User/user'].id;
                arrayVisiteur.placePupitre = null;
                arrayVisiteur.lastMessage = message.messageChat.message;
              } else {
                var placePupitre = [1, 2, 3, 4];
                var placesDispo = lodash_default.a.difference(placePupitre, placeOccupe);
                arrayVisiteur.fileAttente = null;
                arrayVisiteur.placePupitre = placesDispo[0];
              }

              this.commit('_StoreWatcheeBox/ADD_PRIVATE_SESSION_CHAT', {
                session: dataSession,
                visiteur: arrayVisiteur
              });

              watcheebox_watcheebox.totalConversations({
                datasAgent: this.getters['_User/user'],
                agentSocketID: state.mySocketID,
                arrayVisiteur: arrayVisiteur,
                sessionsPrivees: state.sessionsPrivees,
                status: 'plus'
              });

              if (!state.focusPupitre.myFocus && indexSessionChat === -1) {
                push_min_default.a.create('Nouvelle conversation de ' + nameAuteur, {
                  body: message.messageChat.message,
                  tag: message.messageChat.chatSession,
                  icon: {
                    x16: AWSS3_STATIC + '/img/logo/logo_16.png',
                    x32: AWSS3_STATIC + '/img/logo/logo_32.png'
                  },
                  requireInteraction: true,
                  onClick: function onClick() {
                    window.focus();
                    this.close();
                    window.location =  false ? DOMAINE + '/watcheezy/#/trafic/chatting' : constants_DOMAINE + '/#/trafic/chatting';
                  }
                }).catch(function () {});
              }
              if (state.focusPupitre.focusSessionID !== message.messageChat.chatSession) {
                var iconeNotification = 'message';
                this.dispatch('_Notifier/NEW_NOTIF', {
                  message: 'Nouvelle conversation de ' + nameAuteur,
                  context: 'info',
                  position: 'top',
                  type: iconeNotification,
                  multiLine: true,
                  vu: false,
                  data: {
                    titre: message.messageChat.chatSession,
                    message: message.messageChat.message,
                    timestamp: message.messageChat.timeStamp * 1000
                  } });
              }
            }

            watcheebox_watcheebox.clientConnectRoom({
              roomName: 'chat_' + message.messageChat.chatSession
            });
          }

          var slack = this.getters['_User/user'].entSlack;
          if (slack === 'slack' || slack === '1') {
            axios_default.a.get('get/slack_firstMsg.php?msg=' + message.messageChat.message + '&vis=' + message.messageChat.chatSession).then(function (response) {});
          }

          var autoAnswser = '';
          if (this.getters['_Sites/GET_SITE_BY_ID'](newObjVisiteur.siteID).DSK_AUTOANSWER_ONOFF === '1') {
            var mesAuto = this.getters['_Sites/GET_SITE_BY_ID'](newObjVisiteur.siteID);
            autoAnswser = JSON.parse(mesAuto.DSK_AUTOANSWER_MSG)[mesAuto.LIC_DEFAULT_LANG];
          }
          if (autoAnswser) {
            watcheebox_watcheebox.envoisMessage({
              agentSocketID: state.mySocketID,
              datasAgent: this.getters['_User/user'],
              datasVisiteur: newObjVisiteur,
              message: autoAnswser,
              messageType: 2,
              filterId: 0,
              agentName: ''
            });
          }
          state.listeAllVisiteurs.splice(index, 1, arrayVisiteur);
        } else {
          console.log('visiteur deja en session chat avec moi', message.messageChat);
          console.log('state.listeAllVisiteurs[index].placePupitre', state.listeAllVisiteurs[index].placePupitre);
          if (state.listeAllVisiteurs[index].placePupitre === null) {
            var _placeOccupe = [];

            lodash_default.a.forEach(state.listeAllVisiteurs, function (allVisiteurs, key) {
              if (allVisiteurs.visiteurID === message.messageChat.chatSession) {}
              if (allVisiteurs.placePupitre) {
                _placeOccupe.push(allVisiteurs.placePupitre);
              }
            });

            if (_placeOccupe.length > 3) {
              state.listeAllVisiteurs[index].timeStampArrive = Date.now();
              state.listeAllVisiteurs[index].fileAttente = this.getters['_User/user'].id;
              state.listeAllVisiteurs[index].placePupitre = null;
              state.listeAllVisiteurs[index].lastMessage = message.messageChat.message;
            } else {
              var _placePupitre = [1, 2, 3, 4];
              var placesDisponible = lodash_default.a.difference(_placePupitre, _placeOccupe);
              state.listeAllVisiteurs[index].fileAttente = null;
              state.listeAllVisiteurs[index].placePupitre = placesDisponible[0];
            }
          }

          this.commit('_StoreWatcheeBox/UPDATE_PRIVATE_SESSION_CHAT', {
            session: dataSession,
            index: indexSession
          });
        }
      } else {
        console.log('il est impossible de prendre en charge ce client > chatsMax');
      }
    },
    SOCKET_UPDATE_CHAT_ROOM: function SOCKET_UPDATE_CHAT_ROOM(state, message) {
      console.log('SOCKET_UPDATE_CHAT_ROOM', message);

      if (message.messageChat.WZAgentId === this.getters['_User/user'].id && message.messageChat.auteur === 'Agent') {
        console.log('message agent');
      } else if (message.messageChat.messageType === 1) {
        console.log('message visiteur');

        var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
          visiteurID: message.messageChat.chatSession
        });

        var nameAuteur = message.messageChat.chatSession;

        if (message.messageChat.nameAuteur && message.messageChat.auteur === 'Agent') {
          nameAuteur = message.messageChat.nameAuteur;
        } else if (state.listeAllVisiteurs[index].visiteurName) {
          nameAuteur = state.listeAllVisiteurs[index].visiteurName;
        }

        if (index !== -1) {
          var newMessage = {
            attachments: message.messageChat.attachments,
            auteur: message.messageChat.auteur,
            message: message.messageChat.message,
            nameAuteur: nameAuteur,
            timestamp: message.messageChat.timeStamp,
            type: message.messageChat.messageType,
            lu: 0,
            visitorId: message.messageChat.chatSession
          };

          state.listeAllVisiteurs[index].histoChat.push(newMessage);

          state.listeAllVisiteurs[index].lastMessage = message.messageChat.message;

          if (message.messageChat.auteur === 'Visiteur') {
            watcheebox_watcheebox.receptionMessage({
              agentSocketID: state.mySocketID,
              siteID: message.messageChat.siteId,
              datasAgent: this.getters['_User/user'],
              datasVisiteur: state.listeAllVisiteurs[index],
              ARType: 2,
              messageID: message.messageChat.timeStamp
            });
          }

          if (message.messageChat.WZAgentId === this.getters['_User/user'].id) {
            if (state.visiteurChatSelected === message.messageChat.chatSession) {}

            this.commit('_StoreWatcheeBox/PLAY_SOUND_MESSAGE_FOCUS_IN');
            if (state.focusPupitre.focusSessionID !== message.messageChat.chatSession) {
              var iconeNotification = 'message';
              var txt = '' + translation.t('notifNewMessage') + ' ' + nameAuteur + ' : ' + message.messageChat.message;
              this.dispatch('_Notifier/NEW_NOTIF', {
                message: txt,
                context: 'info',
                position: 'top',
                type: iconeNotification,
                multiLine: true,
                vu: false,
                data: {
                  titre: message.messageChat.chatSession,
                  message: message.messageChat.message,
                  timestamp: message.messageChat.timeStamp * 1000,
                  visiteurID: message.messageChat.chatSession
                } });
            }

            if (!state.focusPupitre.myFocus) {
              this.commit('_StoreWatcheeBox/PLAY_SOUND_MESSAGE_FOCUS_OUT');
              var _txt = '' + translation.t('notifNewMessage') + ' ' + nameAuteur;
              push_min_default.a.create(_txt, {
                body: message.messageChat.message,
                tag: message.messageChat.chatSession,
                icon: {
                  x16: AWSS3_STATIC + '/img/logo/logo_16.png',
                  x32: AWSS3_STATIC + '/img/logo/logo_32.png'
                },
                requireInteraction: true,
                onClick: function onClick() {
                  window.focus();
                  this.close();
                  window.location =  false ? DOMAINE + '/watcheezy/#/trafic/chatting' : constants_DOMAINE + '/#/trafic/chatting';
                }
              }).catch(function () {});
            }
          }
        }
      } else if (message.messageChat.messageType === 18) {
        console.log('Notification de message bot');
        var _index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
          visiteurID: message.messageChat.chatSession
        });
        var messageBot = {
          attachments: message.messageChat.attachments,
          auteur: 'Notification',
          message: message.messageChat.message,
          nameAuteur: '',
          timestamp: message.messageChat.timeStamp,
          type: message.messageChat.messageType,
          visitorId: message.messageChat.chatSession
        };

        state.listeAllVisiteurs[_index].histoChat.push(messageBot);
      }
    },
    SOCKET_UPDATE_CHAT_DELIVRE: function SOCKET_UPDATE_CHAT_DELIVRE(state, message) {
      var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.visitorId
      });
      if (index === -1) return;
      var indexMessage = lodash_default.a.findIndex(state.listeAllVisiteurs[index].histoChat, {
        timestamp: message.timestamp
      });
      if (indexMessage === -1) return;
      state.listeAllVisiteurs[index].histoChat[indexMessage].status = 'read';
    },
    SOCKET_UPDATE_CHAT_LU: function SOCKET_UPDATE_CHAT_LU(state, message) {
      var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.visitorId
      });
      if (index === -1) return;
      var indexMessage = lodash_default.a.findIndex(state.listeAllVisiteurs[index].histoChat, {
        timestamp: message.timestamp
      });
      if (indexMessage === -1) return;
      state.listeAllVisiteurs[index].histoChat[indexMessage].lu = 1;
    },
    SOCKET_MAKE_CHAT_NON_LU: function SOCKET_MAKE_CHAT_NON_LU(state, message) {
      var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.visitorId
      });
      if (index === -1) return;
      var indexMessage = lodash_default.a.findIndex(state.listeAllVisiteurs[index].histoChat, {
        timestamp: message.timestamp
      });
      if (indexMessage === -1) return;
      var marquerChatNonLu = {
        marqueurMessageNonLu: true,
        messageNonLu: 1,
        type: '1',
        visiteurID: message.visitorId
      };
      state.listeAllVisiteurs[index].histoChat.splice(indexMessage, 0, marquerChatNonLu);
    },
    SOCKET_REMOVE_CHAT_NON_LU: function SOCKET_REMOVE_CHAT_NON_LU(state, message) {
      var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.visitorId
      });
      if (index === -1) return;
      var indexMarqueur = lodash_default.a.findIndex(state.listeAllVisiteurs[index].histoChat, { marqueurMessageNonLu: true });
      if (indexMarqueur === -1) return;

      state.listeAllVisiteurs[index].histoChat.splice(indexMarqueur, 1);
    },
    SOCKET_UPDATE_CHAT_SOCIAL: function SOCKET_UPDATE_CHAT_SOCIAL(state, message) {
      var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.messageChat.senderID
      });
      var indexSession = lodash_default.a.findIndex(state.sessionsPrivees, [1, message.messageChat.senderID]);
      var nameAuteur = 'undefined';
      if (message.messageChat.dataVisiteur) {
        nameAuteur = message.messageChat.dataVisiteur.first_name + ' ' + message.messageChat.dataVisiteur.last_name;
      }

      if (index !== -1) {
        var newMessage = {
          attachments: message.messageChat.attachments,
          auteur: message.messageChat.auteur,
          message: message.messageChat.message,
          nameAuteur: nameAuteur,
          timestamp: message.messageChat.time,
          type: '1',
          lu: 0,
          visitorId: message.messageChat.senderID
        };

        state.listeAllVisiteurs[index].histoChat.push(newMessage);

        state.listeAllVisiteurs[index].lastMessage = message.messageChat.message;

        if (indexSession !== -1) {
          if (state.focusPupitre.focusSessionID !== message.messageChat.senderID) {
            this.commit('_StoreWatcheeBox/PLAY_SOUND_MESSAGE_FOCUS_OUT');

            var txt = '' + translation.t('notifNewMessage') + ' ' + message.messageChat.senderID + ' : ' + message.messageChat.message;

            var messageNotif = txt;

            var iconeNotification = 'message';

            this.dispatch('_Notifier/NEW_NOTIF', {
              message: messageNotif,
              context: 'info',
              position: 'top',
              type: iconeNotification,
              multiLine: true,
              vu: false,
              data: {
                titre: message.messageChat.senderID
              } });
          } else {
            this.commit('_StoreWatcheeBox/PLAY_SOUND_MESSAGE_FOCUS_IN');
          }
        }
      } else {
        this.commit('_StoreWatcheeBox/PLAY_SOUND_CONVERSATION');
        var arrayVisiteur = {};
        arrayVisiteur.visiteurID = message.messageChat.senderID;
        var visiteurDejaLa = false;

        if (message.messageChat.agentID === this.getters['_User/user'].id) {
          var dataSession = ['facebook', message.messageChat.dataVisiteur.id, message.messageChat.agentID, nameAuteur];
          arrayVisiteur.dataMessage = message.messageChat;
          var placeOccupe = [];

          lodash_default.a.forEach(state.listeAllVisiteurs, function (allVisiteurs, key) {
            if (allVisiteurs.visiteurID === message.messageChat.senderID) {
              visiteurDejaLa = true;
            }
            if (allVisiteurs.placePupitre) {
              placeOccupe.push(allVisiteurs.placePupitre);
            }
          });

          if (placeOccupe.length > 3) {
            arrayVisiteur.timeStampArrive = Date.now();
            arrayVisiteur.fileAttente = this.getters['_User/user'].id;
            arrayVisiteur.placePupitre = null;
            arrayVisiteur.lastMessage = message.messageChat.message;
          } else {
            var placePupitre = [1, 2, 3, 4];
            var placesDispo = lodash_default.a.difference(placePupitre, placeOccupe);
            arrayVisiteur.fileAttente = null;
            arrayVisiteur.placePupitre = placesDispo[0];
          }

          if (!visiteurDejaLa) {
            this.commit('_StoreWatcheeBox/ADD_VISITEURS_SOCIAL', arrayVisiteur);
          }

          watcheebox_watcheebox.totalConversations({
            datasAgent: this.getters['_User/user'],
            agentSocketID: state.mySocketID,
            arrayVisiteur: arrayVisiteur,
            sessionsPrivees: state.sessionsPrivees,
            status: 'plus'
          });

          if (!state.focusPupitre.myFocus) {
            push_min_default.a.create('Nouvelle conversation de ' + nameAuteur, {
              body: message.messageChat.message,
              tag: message.messageChat.senderID,
              icon: {
                x16: AWSS3_STATIC + '/img/logo/logo_16.png',
                x32: AWSS3_STATIC + '/img/logo/logo_32.png'
              },
              requireInteraction: true,
              onClick: function onClick() {
                window.focus();
                this.close();
                window.location =  false ? DOMAINE + '/watcheezy/#/trafic/chatting' : constants_DOMAINE + '/#/trafic/chatting';
              }
            }).catch(function () {});
          } else {
            iconeNotification = 'message';
            this.dispatch('_Notifier/NEW_NOTIF', {
              message: 'Nouvelle conversation de ' + nameAuteur + ' via facebook',
              context: 'info',
              position: 'top',
              type: iconeNotification,
              multiLine: true,
              vu: false,
              data: { titre: message.messageChat.senderID } });
          }
        }

        if (indexSession === -1) {
          this.commit('_StoreWatcheeBox/ADD_PRIVATE_SESSION_CHAT', {
            session: dataSession,
            visiteur: arrayVisiteur
          });
        }
      }
    },
    SOCKET_UPDATE_CHAT_SOCIAL_DELIVRE: function SOCKET_UPDATE_CHAT_SOCIAL_DELIVRE(state, message) {},
    SOCKET_UPDATE_CHAT_SOCIAL_LU: function SOCKET_UPDATE_CHAT_SOCIAL_LU(state, message) {
      state.statusMessage = message.messageChat;
    },
    SOCKET_UPDATE_TYPING: function SOCKET_UPDATE_TYPING(state, message) {
      if (message.messageAction === 'updateTyping') {
        if (message.messageChat.auteur === 'Agent' && message.messageChat.WZAgentId !== this.getters['_User/user'].id || message.messageChat.auteur === 'Visiteur') {
          var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
            visiteurID: message.messageChat.chatSession
          });
          if (index !== -1) {
            var nameAuteur = 'undefined';
            if (message.messageChat.nameAuteur && message.messageChat.auteur === 'Agent') {
              nameAuteur = message.messageChat.nameAuteur;
            } else if (state.listeAllVisiteurs[index].visiteurName) {
              nameAuteur = state.listeAllVisiteurs[index].visiteurName;
            } else {
              nameAuteur = state.listeAllVisiteurs[index].visiteurID;
            }

            if (message.messageChat.etat) {
              var indexTyping = lodash_default.a.findIndex(state.listeAllVisiteurs[index].histoChat, { isTyping: true, auteur: 'Visiteur' });
              if (indexTyping !== -1) {
                state.listeAllVisiteurs[index].histoChat[indexTyping].message = message.messageChat.message;
              } else {
                var newMessage = {
                  isTyping: true,
                  auteur: message.messageChat.auteur,
                  message: message.messageChat.message,
                  nameAuteur: nameAuteur,
                  type: '1',
                  timestamp: new Date().getMilliseconds(),
                  visitorId: message.messageChat.chatSession
                };

                state.listeAllVisiteurs[index].histoChat.push(newMessage);
              }
            } else {
              this.commit('_StoreWatcheeBox/SOCKET_REMOVE_TYPING', {
                chatSession: message.messageChat.chatSession
              });
            }
          }
        }
      }
    },
    SOCKET_REMOVE_TYPING: function SOCKET_REMOVE_TYPING(state, message) {
      console.log('SOCKET_REMOVE_TYPING state', state);
      console.log('SOCKET_REMOVE_TYPING message', message);
      var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
        visiteurID: message.chatSession
      });
      if (index === -1) return;

      console.log('histoChat', state.listeAllVisiteurs[index].histoChat);
      lodash_default.a.forEach(state.listeAllVisiteurs[index].histoChat, function (messageVisiteur, key) {
        if (messageVisiteur && messageVisiteur.isTyping) {
          state.listeAllVisiteurs[index].histoChat.splice(key, 1);
        }
      });
    },
    SOCKET_RETOUR_SATISFACTION: function SOCKET_RETOUR_SATISFACTION(state, message) {
      state.clientSatisfaction = message.messageChat;
    },
    CHECK_DISPO_AGENT: function CHECK_DISPO_AGENT(state, message) {
      var sendFormeSatis = false;
      var sendClotureChat = false;

      if (message.datasVisiteur.chatted) {
        sendFormeSatis = new vue_esm["default"]().$cookie.get('wz-satisfaction-survey') === 'true' || false;
        sendClotureChat = new vue_esm["default"]().$cookie.get('wz-closing-chat') === 'true' || false;
      }
      console.log('sendFormeSatis', sendFormeSatis);
      console.log('sendClotureChat', sendClotureChat);


      var listeAgentsAutorized = this.getters['_Sites/AUTORIZED_AGENTS']({
        agentsArray: state.agentsArray,
        siteID: message.datasVisiteur.siteID,
        myID: this.getters['_User/user'].id
      });
      console.log('listeAgentsAutorized', listeAgentsAutorized);
    },
    SOCKET_VISITOR_TRANSFERT: function SOCKET_VISITOR_TRANSFERT(state, message) {
      if (message.emission) {
        state.transfertStatusEmission = {
          status: message.status,
          datas: message.messageDatas
        };

        var indexVisiteur = lodash_default.a.findIndex(state.listeAllVisiteurs, { 'visiteurID': message.messageDatas.chatSession });

        if (message.status === 'ok') {
          if (indexVisiteur === -1) return;

          this.dispatch('_StoreWatcheeBox/ACTION_CLOSE_CHAT', {
            formulaireSatisfaction: false,
            clotureChat: false,
            datasVisiteur: state.listeAllVisiteurs[indexVisiteur],
            message: '',
            fullPath: src_router.history.current.fullPath
          });
        } else if (message.status === 'no') {}
      } else {
        state.transfertStatusReception = {
          status: message.status,
          datas: message.messageDatas
        };
      }

      if (!state.focusPupitre.myFocus && message.status === 'transfere') {
        push_min_default.a.create('Prise en charge Visiteur', {
          body: message.messageDatas.msg,
          tag: message.messageDatas.WZAgentId,
          icon: {
            x16: AWSS3_STATIC + '/img/logo/logo_16.png',
            x32: AWSS3_STATIC + '/img/logo/logo_32.png'
          },
          requireInteraction: true,
          onClick: function onClick() {
            window.focus();
            this.close();
            window.location =  false ? DOMAINE + '/watcheezy/#/trafic/chatting' : constants_DOMAINE + '/#/trafic/chatting';
          }
        }).catch(function () {});
      }
    },
    ADD_PRIVATE_SESSION_CHAT: function ADD_PRIVATE_SESSION_CHAT(state, _ref) {
      var session = _ref.session,
          visiteur = _ref.visiteur;

      var indexSession = lodash_default.a.findIndex(state.sessionsPrivees, [1, session[1]]);
      if (indexSession === -1) {
        state.sessionsPrivees.push(session);
      } else {
        state.sessionsPrivees.splice(indexSession, 1, session);
      }

      watcheebox_watcheebox.updateSessionsChats({
        datasAgent: this.getters['_User/user'],
        sessionsPrivees: state.sessionsPrivees
      });

      var dataToPost = new window.FormData();
      dataToPost.append('timestamp', Date.now());
      dataToPost.append('agent_id', this.getters['_User/user'].id);
      dataToPost.append('visiteur_id', visiteur.visiteurID);
      dataToPost.append('placePupitre', visiteur.placePupitre);
      dataToPost.append('status', 1);
      dataToPost.append('numChat', state.sessionsPrivees.length);
      dataToPost.append('chatMax', this.getters['_User/user'].chatsMax);
      axios_default.a.post('post/addChatPupitre.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        console.log('chat in pupitre', response);
      });
    },
    UPDATE_PRIVATE_SESSION_CHAT: function UPDATE_PRIVATE_SESSION_CHAT(state, _ref2) {
      var session = _ref2.session,
          index = _ref2.index;

      state.sessionsPrivees.splice(index, 1, session);
    },
    CHECK_PRIVATE_SESSION_CHAT: function CHECK_PRIVATE_SESSION_CHAT(state) {
      var _this = this;

      lodash_default.a.forEach(state.sessionsPrivees, function (sessionChat, key) {
        var indexVisiteur = lodash_default.a.findIndex(state.listeAllVisiteurs, {
          visiteurID: sessionChat[1]
        });
        if (indexVisiteur !== -1) {
          console.log('visteur en session chat :');
          console.log(state.listeAllVisiteurs[indexVisiteur].placePupitre);
          if (state.listeAllVisiteurs[indexVisiteur].fileAttente !== null || state.listeAllVisiteurs[indexVisiteur].placePupitre !== null) {
            _this.commit('_StoreWatcheeBox/UPDATE_PRIVATE_SESSION_CHAT', {
              session: sessionChat,
              index: key
            });

            watcheebox_watcheebox.clientConnectRoom({
              roomName: 'chat_' + sessionChat[1]
            });
          } else {
            state.sessionsPrivees.splice(key, 1);
          }
        } else {
          state.sessionsPrivees.splice(key, 1);
        }
      });

      watcheebox_watcheebox.updateSessionsChats({
        datasAgent: this.getters['_User/user'],
        sessionsPrivees: state.sessionsPrivees
      });
    },
    REMOVE_ALL_CHATS_SESSION: function REMOVE_ALL_CHATS_SESSION(state) {
      var _this2 = this;

      console.log('REMOVE_ALL_CHATS_SESSION');

      var dataToPost = new window.FormData();
      dataToPost.append('agent_id', this.getters['_User/user'].id);
      dataToPost.append('status', 'offline');
      axios_default.a.post('post/addStatusAgent.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {});
      var sessionNum = state.sessionsPrivees.length;
      var num = 0;

      if (!sessionNum) {
        axios_default.a.post('post/logout.php').then(function (response) {
          _this2.dispatch('logout', _this2.$socket);
        }).catch().then(function () {});
      } else {
        state.sessionsPrivees.forEach(function (session, key) {
          var i = state.listeAllVisiteurs.findIndex(function (visiteur) {
            return visiteur.visiteurID === session[1];
          });
          if (i !== -1) {

            var dataToPost2 = new window.FormData();
            dataToPost2.append('timestamp', Date.now());
            dataToPost2.append('agent_id', _this2.getters['_User/user'].id);
            dataToPost2.append('visiteur_id', state.listeAllVisiteurs[i].visiteurID);
            dataToPost2.append('placePupitre', state.listeAllVisiteurs[i].placePupitre);
            dataToPost2.append('status', 0);
            dataToPost2.append('numChat', state.sessionsPrivees.length);
            dataToPost2.append('chatMax', _this2.getters['_User/user'].chatsMax);
            axios_default.a.post('post/addChatPupitre.php', dataToPost2, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
              num++;
              if (num === sessionNum) {
                axios_default.a.post('post/logout.php').then(function (response) {
                  _this2.dispatch('logout', _this2.$socket);
                }).catch().then(function () {});
              }
            }).catch().then(function (_) {});
          }
        });
      }
    },
    REMOVE_PRIVATE_SESSION_CHAT: function REMOVE_PRIVATE_SESSION_CHAT(state, data) {
      var _this3 = this;

      if (src_router.app._route.name !== 'attente') {
        console.log('REMOVE_PRIVATE_SESSION_CHAT', data);
        if (data.index !== -1) {
          state.sessionsPrivees.splice(data.index, 1);
        }

        var dataToPost2 = new window.FormData();
        dataToPost2.append('timestamp', Date.now());
        dataToPost2.append('agent_id', this.getters['_User/user'].id);
        dataToPost2.append('visiteur_id', data.visiteurID);
        dataToPost2.append('placePupitre', data.placePupitre);
        dataToPost2.append('status', 0);
        dataToPost2.append('numChat', state.sessionsPrivees.length);
        dataToPost2.append('chatMax', this.getters['_User/user'].chatsMax);
        axios_default.a.post('post/addChatPupitre.php', dataToPost2, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
          console.log('chat out pupitre', response);
        }).catch().then(function (_) {});

        var indexVisiteur = lodash_default.a.findIndex(state.listeAllVisiteurs, {
          visiteurID: data.visiteurID
        });
        if (indexVisiteur !== -1) {
          state.listeAllVisiteurs[indexVisiteur].fileAttente = null;
          state.listeAllVisiteurs[indexVisiteur].lastMessage = null;
          state.listeAllVisiteurs[indexVisiteur].placePupitre = null;
          state.listeAllVisiteurs[indexVisiteur].timeStampArrive = null;
        }

        var arrayVisiteur = {};
        arrayVisiteur.visiteurID = data.visiteurID;
        watcheebox_watcheebox.totalConversations({
          datasAgent: this.getters['_User/user'],
          agentSocketID: state.mySocketID,
          arrayVisiteur: arrayVisiteur,
          sessionsPrivees: state.sessionsPrivees,
          status: 'moins'
        });

        watcheebox_watcheebox.clientQuitRoom({ roomName: 'chat_' + data.visiteurID });

        var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
          visiteurID: data.visiteurID
        });
        if (index !== -1) {
          if (state.listeAllVisiteurs[index].fileAttente === this.getters['_User/user'].id) {} else {
            if (data.placePupitre) {
              var newArrayVisiteurAttente = [];

              lodash_default.a.forEach(state.listeAllVisiteurs, function (visiteur, key) {
                if (visiteur.fileAttente === _this3.getters['_User/user'].id) {
                  newArrayVisiteurAttente.push(visiteur);
                }
              });

              if (newArrayVisiteurAttente.length) {
                newArrayVisiteurAttente = lodash_default.a.orderBy(newArrayVisiteurAttente, ['timeStampArrive'], ['asc']);

                var indexVisiteurAttente = lodash_default.a.findIndex(state.listeAllVisiteurs, {
                  visiteurID: newArrayVisiteurAttente[0].visiteurID
                });
                state.listeAllVisiteurs[indexVisiteurAttente].fileAttente = null;
                state.listeAllVisiteurs[indexVisiteurAttente].placePupitre = data.placePupitre;

                state.listeAllVisiteurs[indexVisiteurAttente].histoChat = [];
              }
            }
          }

          if (state.listeAllVisiteurs[index].network) {
            state.listeAllVisiteurs.splice(index, 1);
          }
        }
        this.dispatch('_Notifier/NEW_NOTIF', { message: data.message, context: 'info' });
      }
    },
    CLEAR_PRIVATE_SESSION_CHAT: function CLEAR_PRIVATE_SESSION_CHAT(state) {
      state.sessionsPrivees = [];
    },
    CLEAR_MESSAGE_ATTENTE: function CLEAR_MESSAGE_ATTENTE(state) {
      state.messageAttenteSelected = null;
    },
    VISITEUR_ADD_CHAT: function VISITEUR_ADD_CHAT(state, _ref3) {
      var sessionID = _ref3.sessionID;

      console.log('VISITEUR_ADD_CHAT', sessionID);
      console.log('router', src_router.app._route.name);

      if (src_router.app._route.name === 'attente') {
        state.messageAttenteSelected = sessionID;
      } else {
        state.visiteurChatSelected = sessionID;
      }

      var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
        visiteurID: sessionID
      });
      if (index === -1) return;
      state.listeAllVisiteurs[index].lastMessage = '';
    },
    VISITEUR_REMOVE_CHAT: function VISITEUR_REMOVE_CHAT(state) {
      console.log('VISITEUR_REMOVE_CHAT', state);

      if (src_router.app._route.name === 'attente') {
        state.messageAttenteSelected = null;
      } else {
        state.visiteurChatSelected = null;
      }
    },
    SET_STATUS: function SET_STATUS(state, status) {
      if (['online', 'offline', 'busy'].indexOf(status) !== -1) {
        state.status = status;
      }
    },
    SET_STATUS_MANUALLY: function SET_STATUS_MANUALLY(state, status) {
      if (['online', 'offline', 'busy'].indexOf(status) !== -1) {
        state.statusManually = status;
      }
    },
    SOCKET_RETURN_GEOLOC: function SOCKET_RETURN_GEOLOC(state, data) {
      if (data.position.error !== '0') {
        var index = lodash_default.a.findIndex(state.listeAllVisiteurs, {
          visiteurID: data.position.chatSession
        });
        if (index === -1) return;
        var visiteurSelect = lodash_default.a.cloneDeep(state.listeAllVisiteurs[index]);
        visiteurSelect.geoloc = {
          erreur: data.position.error,
          message: data.position.errorMessage
        };
        state.listeAllVisiteurs.splice(index, 1, visiteurSelect);
      } else {
        var index2 = lodash_default.a.findIndex(state.listeAllVisiteurs, {
          visiteurID: data.position.chatSession
        });
        if (index2 === -1) return;
        var visiteurSelect2 = lodash_default.a.cloneDeep(state.listeAllVisiteurs[index2]);
        visiteurSelect2.geoloc = {
          erreur: data.position.error,
          latitude: data.position.latitude,
          longitude: data.position.longitude,
          altitude: data.position.altitude,
          vitesse: data.position.vitesse
        };
        state.listeAllVisiteurs.splice(index2, 1, visiteurSelect2);
      }
    },
    SOCKET_RETURN_REPONSE_COBROWSING: function SOCKET_RETURN_REPONSE_COBROWSING(state, data) {
      console.log('SOCKET_RETURN_REPONSE_COBROWSING', data.data);
      var visiteur = lodash_default.a.findIndex(state.listeAllVisiteurs, {
        placePupitre: data.data.placePupitre
      });
      if (visiteur !== -1) {
        var visiteurSelect = lodash_default.a.cloneDeep(state.listeAllVisiteurs[visiteur]);
        visiteurSelect.reponseCobrowsing = data.data.reponse;
        state.listeAllVisiteurs.splice(visiteur, 1, visiteurSelect);
      } else {}
    },
    SET_STATUS_COBROWSING: function SET_STATUS_COBROWSING(state, data) {
      var indexPupitre = data.placePupitre - 1;
      state.cobrowsingActif[indexPupitre] = data.status;
    },
    SET_STATUS_TIMERINACTIFAGENT: function SET_STATUS_TIMERINACTIFAGENT(state, data) {
      console.log('SET_STATUS_TIMERINACTIFAGENT', data);
      var indexPupitre = data.placePupitre - 1;

      if (!data.timerAgent) {
        clearTimeout(state.timerActifAgent[indexPupitre]);
      } else {
        state.timerActifAgent[indexPupitre] = data.timerAgent;
      }
    },
    SET_TOO_MUCH_AGENTS_CHECKED: function SET_TOO_MUCH_AGENTS_CHECKED(state, value) {
      state.tooMuchAgentsChecked = value;
    },
    SOCKET_DEBLOQUE_MULTISESSION: function SOCKET_DEBLOQUE_MULTISESSION(state, data) {
      console.log('multisession debloqué', data);
      var user = this.getters['_User/user'];

      var storageKeyWebPush = window.localStorage.getItem('server-keys');
      var storageSubscriptionWebPush = window.localStorage.getItem('server-subscription');
      watcheebox_watcheebox.connexionAgent({
        datasAgent: user,
        agentName: user.fname + ' ' + user.lname,
        sessionPHP: new vue_esm["default"]().$cookie.get('PHPSESSID'),
        sid: new vue_esm["default"]().$cookie.get('NODE-SID'),
        keyWebPush: storageKeyWebPush,
        subscriptionWebPush: storageSubscriptionWebPush
      });
    }
  },

  actions: {
    socket_connect: function socket_connect(context) {
      context.commit('SOCKET_CONNECT_CLIENT');
    },

    socket_disconnect: function socket_disconnect(context) {
      context.commit('SOCKET_DISCONNECT_CLIENT');
    },

    socket_event: function socket_event(context) {
      context.commit('SOCKET_EVENT');
    },

    socket_sys_message: function socket_sys_message(context) {
      context.commit('SOCKET_SYS_MESSAGE');
    },

    socket_connecting: function socket_connecting(context) {
      context.commit('SOCKET_CONNECTING');
    },

    socket_connect_failed: function socket_connect_failed(context) {
      context.commit('SOCKET_CONNECT_FAILED');
    },

    socket_close: function socket_close(context) {
      context.commit('SOCKET_CLOSE');
    },

    socket_reconnect: function socket_reconnect(context, a, b) {
      context.commit('SOCKET_RECONNECT');
    },

    socket_reconnecting: function socket_reconnecting(context, a) {
      context.commit('SOCKET_RECONNECTING');
    },

    socket_reconnect_failed: function socket_reconnect_failed(context) {
      context.commit('SOCKET_RECONNECT_FAILED');
    },

    socket_reconnect_attempt: function socket_reconnect_attempt(context, data) {
      context.commit('SOCKET_RECONNECT_ATTEMPT');
    },

    socket_lastSocketDisconnected: function socket_lastSocketDisconnected(context, data) {
      context.commit('SOCKET_LAST_SOCKET_DISCONNECTED');
    },

    socket_error: function socket_error(context, message) {
      context.commit('SOCKET_ERROR_MESSAGE', message);
    },

    socket_noAutorisationConnexion: function socket_noAutorisationConnexion(context, message) {
      context.commit('SOCKET_NO_AUTORISATION_AGENT', message);
    },

    socket_logoutOldAgent: function socket_logoutOldAgent(context, message) {
      console.log('logoutOldAgent');
      context.commit('SOCKET_DELOG_OLD_SESSION', message);
    },

    socket_autoLogoutAgent: function socket_autoLogoutAgent(context, message) {
      context.commit('SOCKET_AUTO_DELOG_SESSION', message);
    },

    socket_myInfos: function socket_myInfos(context, message) {
      context.commit('SOCKET_INFOS_AGENT', message);
    },

    socket_updatePresenceAgent: function socket_updatePresenceAgent(context, message) {
      var myStatus;
      for (var i = 0; i < message.presenceAgent.length; i++) {
        if (message.presenceAgent[i][2] === context.rootState._User.id) {
          myStatus = message.presenceAgent[i][3];
          if (message.presenceAgent[i][4] !== context.rootState._StoreWatcheeBox.mySocketID) {
            var sessionPHP = new vue_esm["default"]().$cookie.get('PHPSESSID').slice(0, 10);
            console.log('pas le même socketID');
            if (sessionPHP === message.presenceAgent[i][22]) {
              console.log('mais la même sessionPHP');
              context.commit('SOCKET_NO_AUTORISATION_AGENT', {
                'mySocketID': context.rootState._StoreWatcheeBox.mySocketID,
                'PHPSessionID': message.presenceAgent[i][22]
              });
            } else {}
          }
        }
      }

      context.commit('SOCKET_LISTE_AGENTS', {
        status: myStatus,
        listeAgents: message.presenceAgent,
        chatAgent: message.chatAgent
      });
    },

    socket_updatePresenceVisiteurs: function socket_updatePresenceVisiteurs(context, message) {
      var messageData = JSON.parse(message);
      context.commit('SOCKET_LISTE_VISITEURS', {
        listeVisiteurs: messageData.clientsListOnline,
        listAllSiteID: lodash_default.a.map(context.rootState._Sites.sites, 'LIC_ID') });
    },

    socket_changeSocketID: function socket_changeSocketID(context, message) {
      context.commit('SOCKET_CLIENT_CHANGE_SOCKETID', {
        newSocketID: message.data.socketID,
        listeSocketID: message.listeSocketID || [message.data.socketID],
        clientID: message.data.chatSession });
    },

    socket_updateListeSocketIDVisiteur: function socket_updateListeSocketIDVisiteur(context, message) {
      console.log('socket_updateListeSocketIDVisiteur :', message);
      context.commit('SOCKET_CLIENT_CHANGE_SOCKETID', {
        clientID: message.visiteurID,
        listeSocketID: message.listeSocketID || [message.cibleSocketID] });
    },

    socket_leaveVisitor: function socket_leaveVisitor(context, message) {
      context.commit('SOCKET_LEAVE_VISITEURS', {
        newSocketID: message.data.clientSocketID,
        clientID: message.data.chatSession });
    },

    socket_updateMyPresence: function socket_updateMyPresence(context, message) {
      var newTabClient = message.myPresence.split(',');
      var newDataFiltrage = JSON.parse(message.dataFiltrage);

      context.commit('SOCKET_NEW_VISITEUR', {
        newVisiteur: newTabClient,
        dataFiltrage: newDataFiltrage,
        listeSocketID: message.listeSocketID || [message.cibleSocketID],
        entId: context.rootState._User.entId,
        maxVisitors: context.rootState._User.maxVisitors,
        listAllSiteID: lodash_default.a.map(context.rootState._Sites.sites, 'LIC_ID') });
    },

    socket_updatechatRoomClient: function socket_updatechatRoomClient(context, message) {
      context.commit('SOCKET_UPDATE_CHAT_ROOM', {
        messageChat: message.data });
    },

    socket_updatechatClient: function socket_updatechatClient(_ref4, message) {
      var commit = _ref4.commit,
          state = _ref4.state;

      if (state.status === 'online' || state.status === 'busy') {
        var debug = null;
        if (debug) {
          var dataToPost = new window.FormData();
          dataToPost.append('idVisitor', message.data.chatSession);
          dataToPost.append('message', message.data.message);
          dataToPost.append('agentid', message.data.WZAgentId);
          dataToPost.append('type', 'updateChat');
          dataToPost.append('siteId', message.data.siteId);
          dataToPost.append('entId', message.data.entrepriseId);
          axios_default.a.post('post/log_update_send.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {});
        }

        var indexSession = lodash_default.a.findIndex(state.sessionsPrivees, [1, message.data.chatSession]);

        if (indexSession === -1) {
          watcheebox_watcheebox.firstLoadHistoChat({
            chatSession: message.data.chatSession,
            entrepriseId: message.data.entrepriseId
          }).then(function (histoChat) {
            if (message.data.messageType === 18) {
              var messageBot = {
                'attachments': message.data.attachments,
                'auteur': 'Notification',
                'chatSession': '0',
                'message': message.data.message,
                'nameAuteur': message.data.nameAuteur,
                'timestamp': message.data.timeStamp,
                'type': message.data.messageType,
                'visiteurId': message.data.chatSession,
                'histoChatBot': message.data.histoChatBot
              };
              histoChat.push(messageBot);

              var histoDom = message.data.histoChatBot;
              var parser = new DOMParser();
              var elemDom = parser.parseFromString(histoDom, 'text/html');
              var body = elemDom.lastChild.lastChild.childNodes;

              listChildNodes({
                messageData: message.data,
                node: body });
            }

            function listChildNodes(data, retour) {
              var body = data.node;
              body.forEach(function (currentValue, currentIndex, listObj) {
                if (currentValue.classList.contains('WZagent-Bot') || currentValue.classList.contains('botImageAndLabel')) {
                  addMessage({
                    messageData: data.messageData,
                    currentValue: currentValue
                  });
                } else if (currentValue.id === 'oldConv') {
                  listChildNodes({
                    messageData: data.messageData,
                    node: currentValue.childNodes });
                }
              }, 'myThisArg');
            }

            function addMessage(data) {
              var auteurHisto = void 0;
              var messageHisto = void 0;
              var nameAuteurHisto = void 0;
              var timestampHisto = void 0;
              var attachmentsHisto = void 0;

              if (data.currentValue.classList.contains('messageAgent_BO')) {
                auteurHisto = 'Bot';
                messageHisto = data.currentValue.firstChild.childNodes[2].firstChild.innerHTML;
                nameAuteurHisto = data.currentValue.firstChild.firstChild.innerHTML;
                timestampHisto = data.currentValue.firstChild.childNodes[1].dataset.timestamp;
              } else if (data.currentValue.classList.contains('messageVisiteur_BO')) {
                auteurHisto = 'Visiteur';
                messageHisto = data.currentValue.firstChild.childNodes[2].firstChild.innerHTML;
                nameAuteurHisto = data.messageData.chatSession;
                timestampHisto = data.currentValue.firstChild.childNodes[1].dataset.timestamp;
              } else if (data.currentValue.classList.contains('botImageAndLabel')) {
                console.log('Une image', data.currentValue.firstChild.childNodes[2].childNodes[2].childNodes[1].src);

                auteurHisto = 'Bot';
                messageHisto = data.currentValue.firstChild.childNodes[2].firstChild.innerHTML;
                nameAuteurHisto = data.currentValue.firstChild.firstChild.innerHTML;
                timestampHisto = data.currentValue.firstChild.childNodes[1].dataset.timestamp;
                attachmentsHisto = data.currentValue.firstChild.childNodes[2].childNodes[2].childNodes[1].src;
              }

              var messageBot = {
                'attachments': attachmentsHisto,
                'auteur': auteurHisto,
                'chatSession': '0',
                'message': messageHisto,
                'nameAuteur': nameAuteurHisto,
                'timestamp': timestampHisto,
                'type': data.messageData.messageType,
                'visiteurId': data.messageData.chatSession
              };

              histoChat.push(messageBot);
            }

            commit('SOCKET_UPDATE_CHAT', {
              messageChat: message.data,
              histoChat: histoChat,
              indexSession: indexSession
            });
          }).catch(function (e) {
            console.error(e);
          });
        } else {
          commit('SOCKET_UPDATE_CHAT', {
            messageChat: message.data,
            histoChat: [],
            indexSession: indexSession
          });
        }
      }
    },

    socket_updateTyping: function socket_updateTyping(context, message) {
      context.commit('SOCKET_UPDATE_TYPING', {
        messageChat: message.data,
        messageAction: message.action });
    },

    socket_confirmSatisfaction: function socket_confirmSatisfaction(context, message) {
      message.data.retour = true;
      context.commit('SOCKET_RETOUR_SATISFACTION', {
        messageChat: message.data });
    },

    socket_noSatisfaction: function socket_noSatisfaction(context, message) {
      message.data.retour = false;
      context.commit('SOCKET_RETOUR_SATISFACTION', {
        messageChat: message.data });
    },

    socket_visitorTransfered: function socket_visitorTransfered(context, message) {
      context.commit('SOCKET_VISITOR_TRANSFERT', {
        status: 'transfere',
        emission: false,
        messageDatas: message.data });
    },

    socket_transfertVisitorWait: function socket_transfertVisitorWait(context, message) {
      context.commit('SOCKET_VISITOR_TRANSFERT', {
        status: 'wait',
        emission: true,
        messageDatas: message });
    },

    socket_visitorTransferedOk: function socket_visitorTransferedOk(context, message) {
      context.commit('SOCKET_VISITOR_TRANSFERT', {
        status: 'ok',
        emission: true,
        messageDatas: message.data });
    },

    socket_visitorTransferedNo: function socket_visitorTransferedNo(context, message) {
      context.commit('SOCKET_VISITOR_TRANSFERT', {
        status: 'no',
        emission: true,
        messageDatas: message.data });
    },

    socket_visitorTransferedAnnuler: function socket_visitorTransferedAnnuler(context, message) {
      context.commit('SOCKET_VISITOR_TRANSFERT', {
        status: 'annuler',
        emission: false,
        messageDatas: message.data });
    },

    socket_messageSocialNetwork: function socket_messageSocialNetwork(context, message) {
      if (context.state.status === 'online') {
        context.commit('SOCKET_UPDATE_CHAT_SOCIAL', {
          messageChat: message.data });
      }
    },

    socket_messengerDeliveryMessage: function socket_messengerDeliveryMessage(context, message) {
      context.commit('SOCKET_UPDATE_CHAT_SOCIAL_DELIVRE', {
        messageChat: message.data });
    },

    socket_messengerReadMessage: function socket_messengerReadMessage(context, message) {
      context.commit('SOCKET_UPDATE_CHAT_SOCIAL_LU', {
        messageChat: message.data });
    },

    socket_answGeoloc: function socket_answGeoloc(context, message) {
      context.commit('SOCKET_RETURN_GEOLOC', {
        position: message.data });
    },

    socket_reponseCobrowsing: function socket_reponseCobrowsing(context, message) {
      context.commit('SOCKET_RETURN_REPONSE_COBROWSING', {
        data: message.data });
    },

    socket_debloqueOK: function socket_debloqueOK(context, message) {
      context.commit('SOCKET_DEBLOQUE_MULTISESSION', {
        data: message });
    },

    ACTION_CLOSE_CHAT: function ACTION_CLOSE_CHAT(context, payload) {
      console.log('payload', payload);
      console.log('context.state.sessionsPrivees 2', context.state.sessionsPrivees.length);

      var txtSnackBar = translation.t('endOfConversation') + ' (' + translation.tc('visitors', 1, { count: '' }) + ' ' + payload.datasVisiteur.visiteurID + ')';
      var user = context.rootState._User;
      console.log('user', user);
      console.log('context', context);
      var config = {
        responseType: 'json',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/x-www-form-urlencoded' }
      };
      if (payload.formulaireSatisfaction) {
        watcheebox_watcheebox.sendFormSatisfaction({
          agentSocketID: context.state.mySocketID,
          datasAgent: user,
          datasVisiteur: payload.datasVisiteur,
          message: 'test satis',
          messageType: '4',
          agentName: unescape(context.rootGetters['_User.fullName'])
        });

        txtSnackBar = translation.t('satisfactionFormSent') + ' (' + translation.tc('visitors', 1, { count: '' }) + ' ' + payload.datasVisiteur.visiteurID + ')';
      } else {
        if (payload.message) {
          console.log('il y a un message à envoyer', payload.message);

          watcheebox_watcheebox.envoisMessage({
            agentSocketID: context.state.mySocketID,
            datasAgent: user,
            datasVisiteur: payload.datasVisiteur,
            message: payload.message,
            attachments: '',
            messageType: 7,
            agentName: unescape(context.rootGetters['_User.fullName'])
          });
        }
      }

      if (payload.clotureChat) {
        var _dataToPost3 = new window.FormData();
        _dataToPost3.append('agentID', user.id);
        _dataToPost3.append('entID', user.entId);
        _dataToPost3.append('visiteurID', payload.datasVisiteur.visiteurID);
        _dataToPost3.append('chatSessionID', payload.datasVisiteur.visiteurID + Date.now());

        axios_default.a.post('post/clotureChat.php', _dataToPost3, config).then(function (response) {
          txtSnackBar = translation.t('endOfConversation') + ' (' + translation.tc('visitors', 1, { count: '' }) + ' ' + payload.datasVisiteur.visiteurID + ')';
        }).catch().then(function (_) {});
      }

      if (payload.fullPath === '/trafic/chatting') {
        console.log('fermeture du chat dans chatting');

        var newIndexFocusPupitre = lodash_default.a.findIndex(context.state.listeAllVisiteurs, function (o) {
          if (o.placePupitre && o.placePupitre !== payload.datasVisiteur.placePupitre) {
            return o.placePupitre;
          }
        });
        console.log('newIndexFocusPupitre', newIndexFocusPupitre);
        if (newIndexFocusPupitre !== -1) {
          context.commit('AGENT_FOCUS', {
            'view': context.state.listeAllVisiteurs[newIndexFocusPupitre].placePupitre,
            'visiteurID': context.state.listeAllVisiteurs[newIndexFocusPupitre].visiteurID
          });
        } else {
          context.commit('AGENT_FOCUS', {
            'view': 1,
            'visiteurID': 1
          });
        }
      } else if (payload.fullPath === '/trafic/attente') {
        console.log('fermeture du chat dans attente');
        context.commit('AGENT_FOCUS', {
          'view': 1,
          'visiteurID': 1
        });

        context.commit('SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE', {});
      } else {
        context.commit('AGENT_FOCUS', {
          'view': 1,
          'visiteurID': 1
        });
        console.log('fermeture du chat dans visiteur');
      }

      if (context.state.visiteurChatSelected === payload.datasVisiteur.visiteurID || context.state.messageAttenteSelected === payload.datasVisiteur.visiteurID) {
        context.commit('VISITEUR_REMOVE_CHAT');
      }

      if (payload.fullPath !== '/trafic/attente') {
        context.commit('CLOSE_FICHE_VISITEUR', payload.datasVisiteur);
      }
      var placeDispo = payload.datasVisiteur.placePupitre;

      var indexSession = lodash_default.a.findIndex(context.state.sessionsPrivees, [1, payload.datasVisiteur.visiteurID]);
      context.commit('REMOVE_PRIVATE_SESSION_CHAT', {
        index: indexSession,
        visiteurID: payload.datasVisiteur.visiteurID,
        placePupitre: placeDispo,
        message: payload.textNotif || txtSnackBar
      });

      var last = payload.datasVisiteur.histoChat.length ? payload.datasVisiteur.histoChat.length - 1 : 0;
      var timeLastMessage = last ? payload.datasVisiteur.histoChat[last].timestamp : '';

      var dataToPost = new window.FormData();
      dataToPost.append('timestamp', timeLastMessage);
      dataToPost.append('visiteurID', payload.datasVisiteur.visiteurID);

      axios_default.a.post('post/timeLastMessage.php', dataToPost, config).then(function (response) {
        console.log(response);
      }).catch().then(function (_) {});
    }
  }
};
// CONCATENATED MODULE: ./src/store/stats.js



var _Stats = {
  namespaced: true,
  state: {
    'dateStart': {},
    'dateEnd': {},
    'period': 4,
    'agents': [],
    'bots': [],
    'sites': [],
    'motifs': []
  },
  getters: {
    params: function params(state) {
      var params = 'dateStart=' + encodeURIComponent(state.dateStart) + '&dateEnd=' + encodeURIComponent(state.dateEnd) + '&sitesId=' + lodash_default.a.toString(lodash_default.a.map(state.sites, 'LIC_ID')) + '&motifsId=' + lodash_default.a.toString(lodash_default.a.map(state.motifs, 'MOT_CODE')) + '&agentsId=' + lodash_default.a.toString(lodash_default.a.map(state.agents, 'USR_ID'));
      var botsId = state.bots.map(function (b) {
        return b.USR_ID;
      });
      botsId = [];
      if (botsId.length) {
        params += '&botsId=' + lodash_default.a.toString(botsId);
      }
      return params;
    },
    GET_DATESTART: function GET_DATESTART(state) {
      return state.dateStart;
    },
    GET_DATEEND: function GET_DATEEND(state) {
      return state.dateEnd;
    }
  },
  mutations: {
    INIT: function INIT(state, init) {
      state.dateStart = moment_default()().subtract(7, 'day').hours(23).minutes(59).seconds(59).format();
      state.dateEnd = moment_default()().startOf('day').hours(0).minutes(0).seconds(0).format();
      state.period = 4;
      state.agents = [];
      state.bots = [];
      state.sites = [];
      state.motifs = [];
    },
    SET_DATE_START: function SET_DATE_START(state, dateStart) {
      state.dateStart = dateStart;
    },
    SET_DATE_END: function SET_DATE_END(state, dateEnd) {
      state.dateEnd = dateEnd;
    },
    SET_PERIOD: function SET_PERIOD(state, period) {
      state.period = period;
    },
    SET_AGENTS: function SET_AGENTS(state, agents) {
      state.agents = agents;
    },
    SET_BOTS: function SET_BOTS(state, bots) {
      state.bots = bots;
    },
    SET_SITES: function SET_SITES(state, sites) {
      state.sites = sites;
    },
    SET_MOTIFS: function SET_MOTIFS(state, motifs) {
      state.motifs = motifs;
    }
  },
  actions: {}
};
// CONCATENATED MODULE: ./src/store/index.js


















vue_esm["default"].use(vuex_esm["a" /* default */]);

var store = new vuex_esm["a" /* default */].Store({
  strict: "production" !== 'production',
  modules: {
    _Toolbar: _Toolbar,
    _Notifier: _Notifier,
    _Dialog: _Dialog,
    _User: user__User,
    _Biblios: _Biblios,
    _Reports: _Reports,
    _Sites: _Sites,
    _StoreWatcheeBox: _StoreWatcheeBox,
    _Stats: _Stats
  },
  state: {
    logged: false,

    reasonUnload: null,

    reasonDeco: null
  },
  getters: {
    logged: function logged(state) {
      return state.logged;
    }
  },
  mutations: {
    loginUser: function loginUser(state, _ref) {
      var user = _ref.user,
          path = _ref.path;

      state.logged = true;
      translation.locale = user.lang;
      state._User = user;
      src_router.push({ path: path });
    },
    logout: function logout(state) {
      var goToAdmin = state._User.connectFromAdmin;
      var id = state._User.entId;
      src_router.push({ path: '/login' });
      state.logged = false;
      state._User = {};
      if (goToAdmin) {
        window.location.href = 'http://www.watcheezy.net/admin/licence/licence_n.php?id=' + id;
      } else {
        window.location.reload();
      }
    },
    SET_REASON_UNLOAD: function SET_REASON_UNLOAD(state, reason) {
      state.reasonUnload = reason;
    },
    SET_REASON_DECO: function SET_REASON_DECO(state, reason) {
      state.reasonDeco = reason;
    }
  },
  actions: {
    loginUser: function loginUser(_ref2, user) {
      var commit = _ref2.commit,
          dispatch = _ref2.dispatch;

      commit('_Toolbar/INIT');
      commit('_Notifier/INIT');
      commit('_StoreWatcheeBox/INIT');

      promise_default.a.all([dispatch('_Biblios/GET', user.id), dispatch('_Sites/GET'), dispatch('_Sites/GET_MAPPING')]).then(function () {
        var path = '';
        if (user.rights === '0' || user.rights === '1') {
          path = '/trafic/visitors';
        } else {
          path = '/stats/audience';
        }
        commit('loginUser', { user: user, path: path });
        commit('_Stats/INIT');
      });
    },
    logout: function logout(_ref3, socket) {
      var commit = _ref3.commit,
          state = _ref3.state;

      if (!state._StoreWatcheeBox.sessionDejaActive) {
        commit('_StoreWatcheeBox/SOCKET_DISCONNECT_CLIENT');
        if (socket) {
          watcheebox_watcheebox.changeStatusAgent({
            'statut': 'offline',
            'agentID': state._User.id,
            'sessionsPrivees': [],
            'roomName': state._User.entKey,
            'socket': socket
          });
        }
      }
      commit('_StoreWatcheeBox/INIT');
      commit('_Biblios/INIT');
      commit('_Sites/INIT');
      commit('_Stats/INIT');
      commit('_Toolbar/INIT');
      commit('_Notifier/INIT');
      commit('logout');
    }
  },

  plugins: [vuex_persistedstate_default()()]
});

/* harmony default export */ var src_store = (store);
// EXTERNAL MODULE: ./node_modules/vue-cookie/src/vue-cookie.js
var vue_cookie = __webpack_require__("K/Lq");
var vue_cookie_default = /*#__PURE__*/__webpack_require__.n(vue_cookie);

// EXTERNAL MODULE: ./src/translation/translations.json
var translations = __webpack_require__("qvdq");
var translations_default = /*#__PURE__*/__webpack_require__.n(translations);

// CONCATENATED MODULE: ./src/translation/index.js









vue_esm["default"].use(vue_i18n_esm["a" /* default */]);
vue_esm["default"].use(vue_cookie_default.a);

var locale = vue_esm["default"].cookie.get('wz-lang') || src_store.state._User.lang || navigator.language.split('-')[0] || navigator.userLanguage;
var translation_langs = ['fr', 'en', 'es'];
if (lodash_default.a.indexOf(translation_langs, locale) === -1) {
  locale = 'en';
}

moment["locale"](locale);

var i18n = new vue_i18n_esm["a" /* default */]({
  locale: locale,
  fallback: 'en',
  messages: translations_default.a });

/* harmony default export */ var translation = (i18n);
// EXTERNAL MODULE: ./node_modules/vee-validate/dist/vee-validate.esm.js
var vee_validate_esm = __webpack_require__("sUu7");

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/locale/fr.js
var fr = __webpack_require__("f6T5");
var fr_default = /*#__PURE__*/__webpack_require__.n(fr);

// EXTERNAL MODULE: ./node_modules/vee-validate/dist/locale/es.js
var es = __webpack_require__("On01");
var es_default = /*#__PURE__*/__webpack_require__.n(es);

// CONCATENATED MODULE: ./src/validator/index.js







vee_validate_esm["a" /* Validator */].localize('fr', fr_default.a);
vee_validate_esm["a" /* Validator */].localize('es', es_default.a);

var validator_config = {
  errorBagName: 'wzErrors',
  fieldsBagName: 'wzFields',
  delay: 0,
  locale: translation.locale,
  strict: true,
  enableAutoClasses: false,
  classNames: {
    touched: 'touched',
    untouched: 'untouched',
    valid: 'valid',
    invalid: 'invalid',
    pristine: 'pristine',
    dirty: 'dirty' },
  events: 'input|blur',
  inject: true
};

vue_esm["default"].use(vee_validate_esm["b" /* default */], validator_config);

/* harmony default export */ var validator = (vee_validate_esm["b" /* default */]);
// CONCATENATED MODULE: ./src/filters/index.js


var filters = {
  void: function _void(v) {
    return v;
  },

  cap: function cap(value) {
    if (!value) return '';
    value = value.toString();
    return value.charAt(0).toUpperCase() + value.slice(1);
  },

  truncate: function truncate(value, count) {
    if (!value) return '';
    value = value.toString();
    return value.length < count ? value : value.substring(0, count) + '...';
  },
  periodToString: function periodToString(v) {
    switch (v) {
      case 1:
        return 'Semaine';
      case 2:
        return 'Mois';
      case 3:
        return 'Trimestre';
      case 4:
        return 'Année';
    }
  },
  bool: function bool(v) {
    return v ? 'yes' : 'no';
  },
  dateTime: function dateTime(v) {
    return v ? moment_default.a.parseZone(moment_default()(v)).local().format('llll') : '-';
  },
  date: function date(v) {
    return v ? moment_default.a.parseZone(moment_default()(v)).local().format('ll') : '-';
  }
};

/* harmony default export */ var src_filters = (filters);
// EXTERNAL MODULE: ./node_modules/vue-highcharts/src/index.js + 3 modules
var vue_highcharts_src = __webpack_require__("ajw3");

// EXTERNAL MODULE: ./node_modules/highcharts/highcharts.js
var highcharts = __webpack_require__("504h");
var highcharts_default = /*#__PURE__*/__webpack_require__.n(highcharts);

// EXTERNAL MODULE: ./node_modules/highcharts/modules/exporting.js
var exporting = __webpack_require__("VVDx");
var exporting_default = /*#__PURE__*/__webpack_require__.n(exporting);

// EXTERNAL MODULE: ./node_modules/highcharts/highcharts-more.js
var highcharts_more = __webpack_require__("mS+B");
var highcharts_more_default = /*#__PURE__*/__webpack_require__.n(highcharts_more);

// EXTERNAL MODULE: ./node_modules/highcharts/modules/solid-gauge.js
var solid_gauge = __webpack_require__("2Fuj");
var solid_gauge_default = /*#__PURE__*/__webpack_require__.n(solid_gauge);

// EXTERNAL MODULE: ./node_modules/highcharts/modules/xrange-series.js
var xrange_series = __webpack_require__("7VZo");
var xrange_series_default = /*#__PURE__*/__webpack_require__.n(xrange_series);

// EXTERNAL MODULE: ./node_modules/vue-axios/dist/vue-axios.min.js
var vue_axios_min = __webpack_require__("Rf8U");
var vue_axios_min_default = /*#__PURE__*/__webpack_require__.n(vue_axios_min);

// CONCATENATED MODULE: ./src/ajax/index.js







vue_esm["default"].use(vue_axios_min_default.a, axios_default.a);

if (false) {
  Vue.axios.defaults.baseURL = DOMAINE + '/dev/ajax-webpack';
} else {
  vue_esm["default"].axios.defaults.baseURL = constants_DOMAINE + '/ajax-webpack';
}
vue_esm["default"].axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';

vue_esm["default"].axios.interceptors.response.use(function (response) {
  return response;
}, function (error) {
  if (error.response.status === 401 && src_store.getters.logged) {
    src_store.commit('logout');
  }

  return promise_default.a.reject(error);
});

/* harmony default export */ var ajax = (new vue_axios_min_default.a({}));
// EXTERNAL MODULE: ./node_modules/vuex-router-sync/index.js
var vuex_router_sync = __webpack_require__("9JMe");
var vuex_router_sync_default = /*#__PURE__*/__webpack_require__.n(vuex_router_sync);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/App.vue




/* harmony default export */ var App = ({
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_Notifier', ['notifsPersistantes'])),

  created: function created() {
    this.updateDocumentTitle();
  },


  watch: {
    '$route.name': function $routeName(v) {
      this.updateDocumentTitle();
    },
    notifsPersistantes: function notifsPersistantes(v) {
      this.updateDocumentTitle();
    }
  },

  methods: {
    updateDocumentTitle: function updateDocumentTitle() {
      var title = this.$route.meta.title ? this.$tc(this.$route.meta.title, 2, { count: '' }) : this.$tc(this.$route.name, 2, { count: '' });
      title = title.charAt(0).toUpperCase() + title.slice(1);
      var notif = this.notifsPersistantes.length;
      var notifStr = notif ? '(' + notif + ') ' : '';
      document.title = notifStr + title;
      var faviconDefault = './static/icon_tf.png';
      var faviconNotif = './static/icon_tf_notif.png';
      if (notif) {
        changeFavicon(faviconNotif);
      } else {
        changeFavicon(faviconDefault);
      }
    }
  }
});
function changeFavicon(src) {
  var link = document.createElement('link');
  var oldLink = document.getElementById('dynamic-favicon');
  link.id = 'dynamic-favicon';
  link.rel = 'shortcut icon';
  link.href = src;
  if (oldLink) {
    document.head.removeChild(oldLink);
  }
  document.head.appendChild(link);
}
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ebeee736","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-view')}
var App_staticRenderFns = []
var App_esExports = { render: App_render, staticRenderFns: App_staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (App_esExports);
// CONCATENATED MODULE: ./src/App.vue
var App_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var App___vue_template_functional__ = false
/* styles */
var App___vue_styles__ = null
/* scopeId */
var App___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var App___vue_module_identifier__ = null
var App_Component = App_normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  App___vue_template_functional__,
  App___vue_styles__,
  App___vue_scopeId__,
  App___vue_module_identifier__
)

/* harmony default export */ var src_App = (App_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzAvatar.vue



/* harmony default export */ var WzAvatar = ({
  props: {
    size: {
      type: String,
      default: '48px'
    },
    color: {
      type: String,
      default: ''
    },
    username: {
      type: String,
      default: '-'
    },
    src: {
      type: String,
      default: null
    },
    tile: {
      type: Boolean,
      default: false
    },
    chip: {
      type: Boolean,
      default: false
    },
    isTyping: {
      type: Boolean,
      default: false
    },
    lastMessage: {
      type: Boolean,
      default: false
    }
  },

  data: function data() {
    return {
      srcData: null
    };
  },


  methods: {
    error: function error(e) {
      this.srcData = null;
    },
    loaded: function loaded(e) {
      this.srcData = this.src;
    }
  },

  created: function created() {
    this.srcData = this.src;
  },


  computed: {
    colorComputed: function colorComputed() {
      var colors = ['red', 'pink', 'purple', 'deep-purple', 'indigo', 'blue', 'light-blue', 'cyan', 'teal', 'green', 'light-green', 'lime', 'amber', 'orange', 'deep-orange', 'brown', 'blue-grey'];

      if (this.color !== '') return this.color;

      if (lodash_default.a.startsWith(this.username, '#')) {
        var idx = lodash_default.a.toInteger(this.username.split('_')[0].substring(1));
        return colors[idx % colors.length];
      }

      if (this.username !== null) {
        if (this.username.length) {
          var _idx = 0;
          lodash_default.a.each(this.username, function (char) {
            _idx += char.charCodeAt(0);
          });
          return colors[_idx % colors.length];
        }
      }
    },
    usernameComputed: function usernameComputed() {
      return this.username[0];
    },
    classOfTitle: function classOfTitle() {
      var sizes = ['subheading', 'headline', 'display-1', 'display-3', 'display-4'];
      var size = this.size.split('px')[0];
      if (size <= 30) {
        size = 0;
      } else if (size <= 48) {
        size = 1;
      } else if (size <= 64) {
        size = 2;
      } else if (size <= 128) {
        size = 3;
      } else if (size <= 256) {
        size = 4;
      }
      return sizes[size];
    }
  },

  watch: {
    src: function src(val) {
      this.srcData = val;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-06292889","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzAvatar.vue
var WzAvatar_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-badge',{attrs:{"overlap":""}},[(_vm.isTyping && _vm.chip)?_c('span',{staticClass:"badgeTyping primary"},[_c('div',{staticClass:"WatchBox-istyping_BO"},[_c('div',{staticClass:"bounce1"}),_vm._v(" "),_c('div',{staticClass:"bounce2"}),_vm._v(" "),_c('div',{staticClass:"bounce3"})])]):_vm._e(),_vm._v(" "),(_vm.lastMessage)?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v("!")]):_vm._e(),_vm._v(" "),_c('v-avatar',{class:_vm.colorComputed,attrs:{"tile":_vm.tile,"size":_vm.size}},[(_vm.srcData)?_c('img',{attrs:{"src":_vm.srcData},on:{"error":_vm.error,"load":_vm.loaded}}):(_vm.username[0] == '#')?_c('v-icon',{staticClass:"white",style:('font-size: ' + _vm.size + ' !important;'),attrs:{"color":_vm.colorComputed}},[_vm._v("account_circle")]):_c('span',{staticClass:"white--text",class:[_vm.classOfTitle]},[_vm._v(_vm._s(_vm.usernameComputed))])],1)],1)}
var WzAvatar_staticRenderFns = []
var WzAvatar_esExports = { render: WzAvatar_render, staticRenderFns: WzAvatar_staticRenderFns }
/* harmony default export */ var watcheezy_WzAvatar = (WzAvatar_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzAvatar.vue
function WzAvatar_injectStyle (ssrContext) {
  __webpack_require__("Jjvt")
}
var WzAvatar_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzAvatar___vue_template_functional__ = false
/* styles */
var WzAvatar___vue_styles__ = WzAvatar_injectStyle
/* scopeId */
var WzAvatar___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzAvatar___vue_module_identifier__ = null
var WzAvatar_Component = WzAvatar_normalizeComponent(
  WzAvatar,
  watcheezy_WzAvatar,
  WzAvatar___vue_template_functional__,
  WzAvatar___vue_styles__,
  WzAvatar___vue_scopeId__,
  WzAvatar___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzAvatar = (WzAvatar_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzAvatarDouble.vue



/* harmony default export */ var WzAvatarDouble = ({
  data: function data() {
    return {
      domaine: constants_DOMAINE
    };
  },

  name: 'WzAvatarDouble',
  props: {
    avatars: {
      type: Array,
      required: true,
      default: []
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26914bd5","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzAvatarDouble.vue
var WzAvatarDouble_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-1",staticStyle:{"height":"56px","max-width":"56px"}},[(_vm.avatars[0].src)?_c('wz-avatar',{attrs:{"username":'#' + _vm.avatars[0].username,"src":_vm.avatars[0].src,"size":"32px"}}):(!_vm.avatars[0].src)?_c('wz-avatar',{attrs:{"username":'#' + _vm.avatars[0].id,"src":null,"size":"32px","isTyping":_vm.avatars[0].isTyping,"lastMessage":_vm.avatars[0].lastMessage,"chip":_vm.avatars[0].chip}}):_vm._e(),_vm._v(" "),_c('wz-avatar',{staticClass:"avatar-bottom",attrs:{"username":_vm.avatars[1].username,"src":(_vm.domaine + "/media/user/small/" + (_vm.avatars[1].id) + "_avatar.jpg"),"size":"30px"}})],1)}
var WzAvatarDouble_staticRenderFns = []
var WzAvatarDouble_esExports = { render: WzAvatarDouble_render, staticRenderFns: WzAvatarDouble_staticRenderFns }
/* harmony default export */ var watcheezy_WzAvatarDouble = (WzAvatarDouble_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzAvatarDouble.vue
function WzAvatarDouble_injectStyle (ssrContext) {
  __webpack_require__("6R3c")
}
var WzAvatarDouble_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzAvatarDouble___vue_template_functional__ = false
/* styles */
var WzAvatarDouble___vue_styles__ = WzAvatarDouble_injectStyle
/* scopeId */
var WzAvatarDouble___vue_scopeId__ = "data-v-26914bd5"
/* moduleIdentifier (server only) */
var WzAvatarDouble___vue_module_identifier__ = null
var WzAvatarDouble_Component = WzAvatarDouble_normalizeComponent(
  WzAvatarDouble,
  watcheezy_WzAvatarDouble,
  WzAvatarDouble___vue_template_functional__,
  WzAvatarDouble___vue_styles__,
  WzAvatarDouble___vue_scopeId__,
  WzAvatarDouble___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzAvatarDouble = (WzAvatarDouble_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzMenu.vue





/* harmony default export */ var WzMenu = ({

  name: 'WzMenu',

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_User', ['hideTabVisitors', 'brides']), {
    isLevelEntreprise: function isLevelEntreprise() {
      return !(this.$store.getters['_User/level'].rights === LEVEL.ENTREPRISE);
    },
    nbVisitors: function nbVisitors() {
      return this.$store.state._StoreWatcheeBox.listeAllVisiteurs.length > 99 ? '99+' : this.$store.state._StoreWatcheeBox.listeAllVisiteurs.length;
    },
    pathTrafic: function pathTrafic() {
      var pathTrafic = { path: '/trafic/visitors' };

      if (this.hideTabVisitors) {
        pathTrafic = { path: '/trafic/chatting' };
      } else {
        if (Number(this.brideMenu('trafic_visiteurs'))) {
          pathTrafic = { path: '/trafic/visitors' };
        } else if (Number(this.brideMenu('trafic_discussions'))) {
          pathTrafic = { path: '/trafic/chatting' };
        }
      }
      return pathTrafic;
    },
    pathMedia: function pathMedia() {
      var pathMedia = { path: '/media/biblios' };

      if (Number(this.brideMenu('media_phrases'))) {
        pathMedia = { path: '/media/biblios' };
      } else {
        if (Number(this.brideMenu('media_push'))) {
          pathMedia = { path: '/media/pushs' };
        }
      }

      return pathMedia;
    }
  }),

  methods: {
    brideMenu: function brideMenu(nameBride) {
      if (this.brides) {
        var index = this.brides.findIndex(function (bride) {
          return bride.brideName === nameBride;
        });

        if (index !== -1) {
          return this.brides[index].status;
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c7206b40","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzMenu.vue
var WzMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list',[(_vm.checkPermission('NO_ADMINS') || _vm.isLevelEntreprise)?_c('v-tooltip',{attrs:{"right":""}},[_c('v-list-tile',{class:{'list__tile--active-router' : '/trafic' == _vm.$route.matched[1].path},attrs:{"slot":"activator","to":_vm.pathTrafic,"ripple":""},slot:"activator"},[_c('v-list-tile-action',[_c('v-badge',{attrs:{"right":"","color":"primary"},model:{value:(_vm.$store.state._StoreWatcheeBox.listeAllVisiteurs.length),callback:function ($$v) {_vm.$set(_vm.$store.state._StoreWatcheeBox.listeAllVisiteurs, "length", $$v)},expression:"$store.state._StoreWatcheeBox.listeAllVisiteurs.length"}},[_c('small',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v("\n                "+_vm._s(_vm.nbVisitors)+"\n              ")]),_vm._v(" "),_c('v-icon',{class:{'secondary--text' : '/trafic' == _vm.$route.matched[1].path}},[_vm._v("explore")])],1)],1)],1),_vm._v(" "),_c('span',[_vm._v("\n          "+_vm._s(_vm._f("cap")(_vm.$t('trafic')))+" "+_vm._s('(' + _vm.$tc('visitors', _vm.$store.state._StoreWatcheeBox.listeAllVisiteurs.length, { count: _vm.nbVisitors }) + ')')+"\n        ")])],1):_vm._e(),_vm._v(" "),(_vm.checkPermission('NO_PEONS'))?_c('v-tooltip',{attrs:{"right":""}},[_c('v-list-tile',{class:{'list__tile--active-router' : '/stats' == _vm.$route.matched[1].path},attrs:{"slot":"activator","to":{path: '/stats/audience'},"ripple":""},slot:"activator"},[_c('v-list-tile-action',[_c('v-icon',{class:{'secondary--text' : '/stats' == _vm.$route.matched[1].path}},[_vm._v("assessment")])],1)],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('stats'))))])],1):_vm._e(),_vm._v(" "),(_vm.checkPermission('NO_AGENTS'))?_c('v-tooltip',{attrs:{"right":""}},[_c('v-list-tile',{class:{'list__tile--active-router' : '/management' == _vm.$route.matched[1].path},attrs:{"slot":"activator","to":{path: '/management/agents'},"ripple":""},slot:"activator"},[_c('v-list-tile-action',[_c('v-icon',{class:{'secondary--text' : '/management' == _vm.$route.matched[1].path}},[_vm._v("assignment_ind")])],1)],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('management'))))])],1):_vm._e(),_vm._v(" "),(_vm.checkPermission('NO_AGENTS'))?_c('v-tooltip',{attrs:{"right":""}},[_c('v-list-tile',{class:{'list__tile--active-router' : '/target' == _vm.$route.matched[1].path},attrs:{"slot":"activator","to":{path: '/target/filters'},"ripple":""},slot:"activator"},[_c('v-list-tile-action',[_c('v-icon',{class:{'secondary--text' : '/target' == _vm.$route.matched[1].path}},[_vm._v("track_changes")])],1)],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('filters'))))])],1):_vm._e(),_vm._v(" "),_c('v-tooltip',{attrs:{"right":""}},[_c('v-list-tile',{class:{'list__tile--active-router' : '/media' == _vm.$route.matched[1].path},attrs:{"slot":"activator","to":_vm.pathMedia,"ripple":""},slot:"activator"},[_c('v-list-tile-action',[_c('v-icon',{class:{'secondary--text' : '/media' == _vm.$route.matched[1].path}},[_vm._v("perm_media")])],1)],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('media'))))])],1),_vm._v(" "),(_vm.checkPermission('NO_AGENTS'))?_c('v-tooltip',{attrs:{"right":""}},[_c('v-list-tile',{class:{'list__tile--active-router' : '/settings' == _vm.$route.matched[1].path},attrs:{"slot":"activator","to":{path: '/settings/preview'},"ripple":""},slot:"activator"},[_c('v-list-tile-action',[_c('v-icon',{class:{'secondary--text' : '/settings' == _vm.$route.matched[1].path}},[_vm._v("settings")])],1)],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('settings'))))])],1):_vm._e()],1)],1)}
var WzMenu_staticRenderFns = []
var WzMenu_esExports = { render: WzMenu_render, staticRenderFns: WzMenu_staticRenderFns }
/* harmony default export */ var watcheezy_WzMenu = (WzMenu_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzMenu.vue
function WzMenu_injectStyle (ssrContext) {
  __webpack_require__("NyPY")
}
var WzMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzMenu___vue_template_functional__ = false
/* styles */
var WzMenu___vue_styles__ = WzMenu_injectStyle
/* scopeId */
var WzMenu___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzMenu___vue_module_identifier__ = null
var WzMenu_Component = WzMenu_normalizeComponent(
  WzMenu,
  watcheezy_WzMenu,
  WzMenu___vue_template_functional__,
  WzMenu___vue_styles__,
  WzMenu___vue_scopeId__,
  WzMenu___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzMenu = (WzMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzAgentStatus.vue






/* harmony default export */ var WzAgentStatus = ({
  data: function data() {
    return {
      menu: false,
      statusAgent: [{
        color: 'green',
        value: 'online' }, {
        color: 'orange',
        value: 'busy' }, {
        color: 'red',
        value: 'offline' }],
      selectStatus: {
        color: '',
        value: -1
      }
    };
  },


  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])('_StoreWatcheeBox', ['SET_STATUS', 'SET_STATUS_MANUALLY']), Object(vuex_esm["d" /* mapMutations */])(['SET_REASON_UNLOAD']), {
    switchToStatus: function switchToStatus(status) {
      if (status === 'online') {
        if (this.sessionsPrivees.length >= this.user.chatsMax) {
          status = 'busy';
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('noSwitchOnlineAvailable'),
            context: 'warning'
          });
        }
      }
      watcheebox_watcheebox.changeStatusAgent({
        statut: status,
        agentID: this.user.id,
        sessionsPrivees: this.sessionsPrivees,
        roomName: this.user.entKey,
        socket: this.$socket
      });

      this.SET_STATUS_MANUALLY(status);
    },
    onScroll: function onScroll(e) {
      this.menu = false;
    },
    reload: function reload() {
      this.SET_STATUS('online');
      this.SET_REASON_UNLOAD('AgentStatus: connection chat perdue (node tombé)');
      window.location.reload();
    }
  }),

  created: function created() {
    this.selectStatus = lodash_default.a.clone(lodash_default.a.find(this.statusAgent, {
      value: this.$store.state._StoreWatcheeBox.status
    }));
  },


  watch: {
    '$store.state._StoreWatcheeBox.status': function $storeState_StoreWatcheeBoxStatus(val, oldVal) {
      this.selectStatus = lodash_default.a.clone(lodash_default.a.find(this.statusAgent, { value: val }));

      var dataToPost = new window.FormData();
      dataToPost.append('agent_id', this.user.id);
      dataToPost.append('status', val);
      this.axios.post('post/addStatusAgent.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {});
    }
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_StoreWatcheeBox', ['sessionsPrivees']), Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['sessionsPrivees']), Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'account']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31ff2534","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzAgentStatus.vue
var WzAgentStatus_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.account.role != 'admin')?_c('div',[(!_vm.$store.state._StoreWatcheeBox.isConnected)?_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-icon',{attrs:{"color":"grey"}},[_vm._v("warning")])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('connectionChatLost'))))]),_vm._v(" "),_c('v-btn',{attrs:{"block":"","color":"primary"},on:{"click":function($event){_vm.reload()}}},[_vm._v(_vm._s(_vm.$t('reconnection')))])],1)],1)],1):_c('v-menu',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"}],attrs:{"bottom":"","left":""},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[(!_vm.$vuetify.breakpoint.smAndDown)?_c('v-btn',{staticStyle:{"width":"150px"},attrs:{"slot":"activator","small":"","light":""},slot:"activator"},[_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t(_vm.selectStatus.value))))]),_vm._v(" "),_c('v-icon',{attrs:{"right":"","color":_vm.selectStatus.color}},[_vm._v("person_pin")])],1):_c('v-icon',{attrs:{"slot":"activator","right":"","color":_vm.selectStatus.color},slot:"activator"},[_vm._v("person_pin")]),_vm._v(" "),_c('v-list',{staticClass:"card",attrs:{"avatar":"","dense":""}},_vm._l((_vm.statusAgent),function(item){return _c('v-list-tile',{key:item.value,attrs:{"disabled":item.value == 'busy' && !_vm.user.canBeUnavailable},on:{"click":function($event){item.value != 'busy' || _vm.user.canBeUnavailable
            ? _vm.switchToStatus(item.value)
            : _vm.$store.dispatch('_Notifier/NEW_NOTIF', { message: _vm.$t('noSwitchUnavailable'), context: 'warning' })}}},[_c('v-icon',{staticClass:"text--darken-2 mr-1",attrs:{"color":item.color,"left":""}},[_vm._v("person_pin")]),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t(item.value))))])],1)}),1)],1)],1):_vm._e()}
var WzAgentStatus_staticRenderFns = []
var WzAgentStatus_esExports = { render: WzAgentStatus_render, staticRenderFns: WzAgentStatus_staticRenderFns }
/* harmony default export */ var watcheezy_WzAgentStatus = (WzAgentStatus_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzAgentStatus.vue
var WzAgentStatus_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzAgentStatus___vue_template_functional__ = false
/* styles */
var WzAgentStatus___vue_styles__ = null
/* scopeId */
var WzAgentStatus___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzAgentStatus___vue_module_identifier__ = null
var WzAgentStatus_Component = WzAgentStatus_normalizeComponent(
  WzAgentStatus,
  watcheezy_WzAgentStatus,
  WzAgentStatus___vue_template_functional__,
  WzAgentStatus___vue_styles__,
  WzAgentStatus___vue_scopeId__,
  WzAgentStatus___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzAgentStatus = (WzAgentStatus_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzPupitreStatus.vue




/* harmony default export */ var WzPupitreStatus = ({
  data: function data() {
    return {
      vuePupitre: [{ value: 1, icone: 'mdi-numeric-1-box-multiple-outline' }, { value: 2, icone: 'mdi-numeric-2-box-multiple-outline' }, { value: 4, icone: 'mdi-numeric-4-box-multiple-outline' }]
    };
  },
  mounted: function mounted() {},


  methods: {
    changeViewPupitre: function changeViewPupitre(data) {
      this.$store.commit('_StoreWatcheeBox/CHANGE_VIEW_PUPITRE', data);
    }
  },

  watch: {},

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['pupitreViewStatus']), Object(vuex_esm["c" /* mapGetters */])('_User', ['account']), {
    changeView: function changeView() {
      var _this = this;

      var selectedView = this.vuePupitre.find(function (p) {
        return _this.pupitreViewStatus === p.value;
      });
      this.$cookie.set('wz-pupitreView', selectedView.value, { expires: '1Y' });
      return selectedView;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-648500de","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzPupitreStatus.vue
var WzPupitreStatus_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.account.role != 'admin' && _vm.$route.name == 'chatting')?_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-icon',[_vm._v(_vm._s(_vm.changeView.icone))])],1),_vm._v(" "),_c('v-list',_vm._l((_vm.vuePupitre),function(vuePupitre,i){return _c('v-list-tile',{key:i,on:{"click":function($event){_vm.changeViewPupitre(vuePupitre.value)}}},[_c('v-icon',[_vm._v(_vm._s(vuePupitre.icone))])],1)}),1)],1):_vm._e()}
var WzPupitreStatus_staticRenderFns = []
var WzPupitreStatus_esExports = { render: WzPupitreStatus_render, staticRenderFns: WzPupitreStatus_staticRenderFns }
/* harmony default export */ var watcheezy_WzPupitreStatus = (WzPupitreStatus_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzPupitreStatus.vue
var WzPupitreStatus_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzPupitreStatus___vue_template_functional__ = false
/* styles */
var WzPupitreStatus___vue_styles__ = null
/* scopeId */
var WzPupitreStatus___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzPupitreStatus___vue_module_identifier__ = null
var WzPupitreStatus_Component = WzPupitreStatus_normalizeComponent(
  WzPupitreStatus,
  watcheezy_WzPupitreStatus,
  WzPupitreStatus___vue_template_functional__,
  WzPupitreStatus___vue_styles__,
  WzPupitreStatus___vue_scopeId__,
  WzPupitreStatus___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzPupitreStatus = (WzPupitreStatus_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzNotifications.vue



/* harmony default export */ var WzNotifications = ({
  data: function data() {
    return {
      menu: false
    };
  },


  computed: {
    notifications: function notifications() {
      return this.$store.getters['_Notifier/notifsPersistantes'];
    },
    nbMessages: function nbMessages() {
      var count = 0;
      this.notifications.forEach(function (notif) {
        if (notif.type === 'message' || notif.type === 'phone_in_talk' || notif.type === 'collections' || notif.type === 'error') {
          count += notif.count;
        }
      });
      console.log('count notif', count);
      return count;
    }
  },

  methods: {
    clickNotif: function clickNotif(indexNotif) {
      this.$store.dispatch('_Notifier/OPEN_NOTIF', indexNotif);
    },
    onScroll: function onScroll(e) {
      this.menu = false;
    }
  },

  filters: {
    dateTime: function dateTime(v) {
      return moment_default()(v).format('llll');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1370044f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzNotifications.vue
var WzNotifications_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',{attrs:{"bottom":"","left":"","min-width":"300px","max-width":"320px","close-on-content-click":false,"offset-y":"","transition":"slide-y-transition"},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('v-btn',{attrs:{"slot":"activator","icon":""},slot:"activator"},[_c('v-badge',{attrs:{"left":"","color":"red","overlap":""},model:{value:(_vm.notifications.length),callback:function ($$v) {_vm.$set(_vm.notifications, "length", $$v)},expression:"notifications.length"}},[_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.notifications.length))]),_vm._v(" "),_c('v-icon',[_vm._v("notifications")])],1)],1),_vm._v(" "),_c('v-card',[(_vm.notifications.length)?_c('v-subheader',{staticClass:"subheading accent white--text"},[_vm._v("\n        "+_vm._s(_vm.$tc('newMessage', _vm.nbMessages, { count: _vm.nbMessages }))+"\n      ")]):_c('v-subheader',{staticClass:"subheading accent white--text"},[_vm._v("\n        "+_vm._s(_vm._f("cap")(_vm.$tc('notif', 0)))+"\n      ")]),_vm._v(" "),(_vm.notifications.length)?_c('v-btn',{attrs:{"color":"accent","flat":"","small":""},on:{"click":function($event){_vm.$store.commit('_Notifier/CLEAR_ALL')}}},[_c('v-icon',{attrs:{"left":"","color":"accent"}},[_vm._v("clear_all")]),_vm._v("\n        "+_vm._s(_vm._f("cap")(_vm.$t('clearAll')))+"\n      ")],1):_vm._e(),_vm._v(" "),_c('v-list',{staticClass:"listeNotifications",attrs:{"three-line":"","dense":""}},[_vm._l((_vm.notifications),function(notif,i){return [(notif.action.path && notif.type == 'message')?_c('v-list-tile',{attrs:{"avatar":"","to":{path: notif.action.path}},on:{"click":function($event){_vm.clickNotif(i)}}},[_c('v-list-tile-action',[_c('v-badge',{attrs:{"overlap":"","color":"red"},model:{value:(notif.count),callback:function ($$v) {_vm.$set(notif, "count", $$v)},expression:"notif.count"}},[_c('span',{staticClass:"caption",attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(notif.count))]),_vm._v(" "),_c('v-icon',{staticClass:"accent--text",attrs:{"x-large":""}},[_vm._v(_vm._s(notif.type))])],1)],1),_vm._v(" "),_c('v-list-tile-content',[(notif.data.timestamp)?_c('v-list-tile-sub-title',[_c('i',[_vm._v(_vm._s(_vm._f("dateTime")(notif.data.timestamp)))])]):_vm._e(),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(notif.data.titre))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"contentNotif",domProps:{"innerHTML":_vm._s(notif.data.message)}})],1)],1):(notif.action.path && notif.target && notif.type == 'error')?_c('v-list-tile',{attrs:{"href":notif.action.path,"target":"notif.target"}},[_c('v-list-tile-action',[_c('v-icon',{staticClass:"red--text",attrs:{"x-large":""}},[_vm._v(_vm._s(notif.type))])],1),_vm._v(" "),_c('v-list-tile-content',[(notif.data.timestamp)?_c('v-list-tile-sub-title',[_c('i',[_vm._v(_vm._s(_vm._f("dateTime")(notif.data.timestamp)))])]):_vm._e(),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(notif.data.titre))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"contentNotif",domProps:{"innerHTML":_vm._s(notif.data.message)}})],1)],1):(notif.action.path && !notif.target && notif.type == 'error')?_c('v-list-tile',{attrs:{"to":{path: notif.action.path}}},[_c('v-list-tile-action',[_c('v-icon',{staticClass:"red--text",attrs:{"x-large":""}},[_vm._v(_vm._s(notif.type))])],1),_vm._v(" "),_c('v-list-tile-content',[(notif.data.timestamp)?_c('v-list-tile-sub-title',[_c('i',[_vm._v(_vm._s(_vm._f("dateTime")(notif.data.timestamp)))])]):_vm._e(),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(notif.data.titre))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"contentNotif",domProps:{"innerHTML":_vm._s(notif.data.message)}})],1)],1):_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.clickNotif(i)}}},[_c('v-list-tile-action',[_c('v-badge',{attrs:{"overlap":"","color":"red"},model:{value:(notif.count),callback:function ($$v) {_vm.$set(notif, "count", $$v)},expression:"notif.count"}},[_c('span',{staticClass:"caption",attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(notif.count))]),_vm._v(" "),_c('v-icon',{staticClass:"orange--text",attrs:{"x-large":""}},[_vm._v(_vm._s(notif.type))])],1)],1),_vm._v(" "),_c('v-list-tile-content',[(notif.data.timestamp)?_c('v-list-tile-sub-title',[_c('i',[_vm._v(_vm._s(_vm._f("dateTime")(notif.data.timestamp)))])]):_vm._e(),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(notif.data.titre))]),_vm._v(" "),_c('v-list-tile-sub-title',{staticClass:"contentNotif",domProps:{"innerHTML":_vm._s(notif.data.message)}})],1)],1),_vm._v(" "),_c('v-divider',{key:i,staticClass:"my-1",attrs:{"inset":""}})]})],2)],1)],1)}
var WzNotifications_staticRenderFns = []
var WzNotifications_esExports = { render: WzNotifications_render, staticRenderFns: WzNotifications_staticRenderFns }
/* harmony default export */ var watcheezy_WzNotifications = (WzNotifications_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzNotifications.vue
function WzNotifications_injectStyle (ssrContext) {
  __webpack_require__("Owzt")
}
var WzNotifications_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzNotifications___vue_template_functional__ = false
/* styles */
var WzNotifications___vue_styles__ = WzNotifications_injectStyle
/* scopeId */
var WzNotifications___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzNotifications___vue_module_identifier__ = null
var WzNotifications_Component = WzNotifications_normalizeComponent(
  WzNotifications,
  watcheezy_WzNotifications,
  WzNotifications___vue_template_functional__,
  WzNotifications___vue_styles__,
  WzNotifications___vue_scopeId__,
  WzNotifications___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzNotifications = (WzNotifications_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzAgentMenu.vue




/* harmony default export */ var WzAgentMenu = ({
  data: function data() {
    return {
      menu: false,
      dialog: false,
      isLogout: false
    };
  },

  methods: {
    logout: function logout() {
      this.$store.commit('_StoreWatcheeBox/REMOVE_ALL_CHATS_SESSION');

      this.isLogout = true;
    },
    onScroll: function onScroll(e) {
      this.menu = false;
    }
  },
  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_User', ['fullName', 'userAvatar', 'account']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5ea27f52","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzAgentMenu.vue
var WzAgentMenu_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-xs-center",staticStyle:{"width":"52px"}},[_c('v-menu',{directives:[{name:"scroll",rawName:"v-scroll",value:(_vm.onScroll),expression:"onScroll"}],attrs:{"bottom":"","left":""},model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_c('wz-avatar',{attrs:{"slot":"activator","src":_vm.userAvatar,"username":_vm.fullName,"size":"32px"},slot:"activator"}),_vm._v(" "),_c('v-list',{attrs:{"two-line":""}},[_c('v-list-tile',{attrs:{"to":"/profile"}},[_c('v-list-tile-action',[_c('wz-avatar',{attrs:{"src":_vm.userAvatar,"username":_vm.fullName,"size":"48px"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.fullName))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.account.type))])],1)],1)],1),_vm._v(" "),_c('v-list',{staticClass:"card",attrs:{"dense":""}},[(_vm.checkPermission('NO_AGENTS'))?_c('v-list-tile',{attrs:{"to":"/account"}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("business_center")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('gestionAccount'))))])],1):_vm._e(),_vm._v(" "),_c('v-list-tile',{attrs:{"href":"https://support.targetfirst.com/","target":"_blank"}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("launch")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('support'))))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.dialog = true}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("power_settings_new")])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('logout'))))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('logout')))+" ?")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          "+_vm._s(_vm.$t('textDeconnexion'))+"\n        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.isLogout,"flat":"flat"},nativeOn:{"click":function($event){_vm.dialog = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.isLogout,"color":"primary"},nativeOn:{"click":function($event){_vm.logout()}}},[_vm._v(_vm._s(_vm.$t('logout')))])],1)],1)],1)],1)}
var WzAgentMenu_staticRenderFns = []
var WzAgentMenu_esExports = { render: WzAgentMenu_render, staticRenderFns: WzAgentMenu_staticRenderFns }
/* harmony default export */ var watcheezy_WzAgentMenu = (WzAgentMenu_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzAgentMenu.vue
var WzAgentMenu_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzAgentMenu___vue_template_functional__ = false
/* styles */
var WzAgentMenu___vue_styles__ = null
/* scopeId */
var WzAgentMenu___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzAgentMenu___vue_module_identifier__ = null
var WzAgentMenu_Component = WzAgentMenu_normalizeComponent(
  WzAgentMenu,
  watcheezy_WzAgentMenu,
  WzAgentMenu___vue_template_functional__,
  WzAgentMenu___vue_styles__,
  WzAgentMenu___vue_scopeId__,
  WzAgentMenu___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzAgentMenu = (WzAgentMenu_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzSwitchLang.vue



/* harmony default export */ var WzSwitchLang = ({
  props: {
    lang: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      langModel: '',
      langs: [{ text: 'Français', value: 'fr' }, { text: 'English', value: 'en' }, { text: 'Español', value: 'es' }]
    };
  },


  watch: {
    langModel: function langModel(val, oldVal) {
      this.$emit('change', val.value);
      this.$validator.localize(val.value);
    }
  },

  mounted: function mounted() {
    var language = this.lang || this.$store.state._User.lang || this.$i18n.locale;
    this.langModel = lodash_default.a.find(this.langs, { value: language });
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-fa4d0818","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzSwitchLang.vue
var WzSwitchLang_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"items":_vm.langs,"label":_vm._f("cap")(_vm.$t('language')),"menu-props":"auto","prepend-icon":"translate","hide-details":"","return-object":""},on:{"input":function($event){_vm.$emit('update:lang', _vm.langModel.value)}},model:{value:(_vm.langModel),callback:function ($$v) {_vm.langModel=$$v},expression:"langModel"}})}
var WzSwitchLang_staticRenderFns = []
var WzSwitchLang_esExports = { render: WzSwitchLang_render, staticRenderFns: WzSwitchLang_staticRenderFns }
/* harmony default export */ var watcheezy_WzSwitchLang = (WzSwitchLang_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzSwitchLang.vue
var WzSwitchLang_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzSwitchLang___vue_template_functional__ = false
/* styles */
var WzSwitchLang___vue_styles__ = null
/* scopeId */
var WzSwitchLang___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzSwitchLang___vue_module_identifier__ = null
var WzSwitchLang_Component = WzSwitchLang_normalizeComponent(
  WzSwitchLang,
  watcheezy_WzSwitchLang,
  WzSwitchLang___vue_template_functional__,
  WzSwitchLang___vue_styles__,
  WzSwitchLang___vue_scopeId__,
  WzSwitchLang___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzSwitchLang = (WzSwitchLang_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzBiblio.vue




/* harmony default export */ var WzBiblio = ({

  props: {
    biblio: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      showDialogUpdate: false,

      showDialogDelete: false,

      showSent: false,

      biblioDialog: {},

      loading: false,

      overMenu: false
    };
  },


  methods: {
    openDialogUpdate: function openDialogUpdate() {
      this.biblioDialog = lodash_default.a.clone(this.biblio);
      this.showDialogUpdate = true;
    },
    openDialogDelete: function openDialogDelete() {
      console.log(this.biblio);

      if (!this.biblio.subs || this.biblio.subs && !this.biblio.subs.length) {
        this.biblioDialog = lodash_default.a.clone(this.biblio);
        this.showDialogDelete = true;
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Impossible à supprimer : contient ' + this.biblio.subs.length + ' ' + this.$tc('subLibraries', this.biblio.subs.length, { count: this.biblio.subs.length }),
          context: 'warning'
        });
      }
    },
    submitDialogUpdate: function submitDialogUpdate() {
      var _this = this;

      this.showDialogUpdate = false;

      if (this.biblio.title !== this.biblioDialog.title) {
        var biblioFound = this.$store.getters['_Biblios/GET_BIBLIO_BY_TITLE'](this.biblioDialog.title);
        if (lodash_default.a.isNil(biblioFound)) {
          var dataToPost = new window.FormData();
          dataToPost.append('FAM_ID', this.biblioDialog.id);
          dataToPost.append('FAM_NAME', this.biblioDialog.title);
          this.loading = true;
          this.axios.post('put/biblio.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
            _this.$store.commit('_Biblios/UPDATE_BIBLIO', _this.biblioDialog);
            _this.$emit('update:biblio', _this.biblioDialog);
            _this.$emit('update');

            _this.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this.$t('modifSuccess'), context: 'success' });
          }).catch(function (_) {
            _this.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this.$t('modifFailure'), context: 'error' });
          }).then(function (_) {
            _this.loading = false;
          });
        } else {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('noChange'), context: 'warning' });
        }
      }
    },
    submitDialogDelete: function submitDialogDelete() {
      var _this2 = this;

      this.showDialogDelete = false;
      var dataToPost = new window.FormData();
      dataToPost.append('FAM_ID', this.biblio.id);
      this.loading = true;
      this.axios.post('delete/biblio.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this2.$store.commit('_Biblios/REMOVE_BIBLIO', _this2.biblio);
        _this2.$emit('update:biblio', _this2.biblio);
        _this2.$emit('update');
        _this2.biblioDialog = {};

        _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('deleteSuccess'), context: 'success' });
      }).catch(function (_) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('deleteFailure'), context: 'error' });
      }).then(function (_) {
        _this2.loading = false;
      });
    },
    showSentences: function showSentences() {
      console.log('show');

      if (!this.overMenu) {
        if (this.biblio.subs) {
          this.$router.push({ path: '/media/biblios/' + this.biblio.id });
        } else {
          this.$router.push({ path: '/media/biblios/' + this.biblio.sub + '/sub/' + this.biblio.id });
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f84d51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzBiblio.vue
var WzBiblio_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('v-list-tile',[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.showSentences()}}},[_c('v-list-tile-avatar',[(_vm.biblio.subs)?_c('v-icon',{staticClass:"primary white--text"},[_vm._v("collections_bookmark")]):_c('v-icon',{staticClass:"primary white--text"},[_vm._v("book")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.biblio.title))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n          "+_vm._s(_vm.$tc('sentences', _vm.biblio.sentences.length, { count: _vm.biblio.sentences.length }))+"\n          "),_vm._v(" "),(_vm.biblio.subs)?_c('span',[_vm._v("\n            "+_vm._s(_vm.$t('and'))+"\n            "+_vm._s(_vm.$tc('subLibraries', _vm.biblio.subs.length, { count: _vm.biblio.subs.length }))+"\n          ")]):_vm._e()])],1),_vm._v(" "),(_vm.biblio.id != 0)?_c('v-list-tile-action',[_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"icon"},nativeOn:{"mouseover":function($event){_vm.overMenu = true},"mouseleave":function($event){_vm.overMenu = false}},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.openDialogUpdate()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('edit')))+" "+_vm._s(_vm.$tc(_vm.biblio.subs ? 'libraries' : 'subLibraries', 1, { count: '' })))])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.openDialogDelete()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('delete')))+" "+_vm._s(_vm.$tc(_vm.biblio.subs ? 'libraries' : 'subLibraries', 1, { count: '' })))])],1)],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.showDialogUpdate),callback:function ($$v) {_vm.showDialogUpdate=$$v},expression:"showDialogUpdate"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('edit')))+" "+_vm._s(_vm.$tc(_vm.biblio.subs ? 'libraries' : 'subLibraries', 1, { count: '' })))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|max:32'),expression:"'required|max:32'"}],attrs:{"label":_vm._f("cap")(_vm.$t('edit') + ' ' + _vm.$tc('subLibraries', 1, { count: '' })),"max":"32","required":"","data-vv-name":"biblioInput","error":_vm.wzErrors.has('biblioInput'),"errors":_vm.wzErrors.collect('biblioInput')},nativeOn:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.submitDialogUpdate($event)}},model:{value:(_vm.biblioDialog.title),callback:function ($$v) {_vm.$set(_vm.biblioDialog, "title", $$v)},expression:"biblioDialog.title"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showDialogUpdate = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.wzErrors.any()},on:{"click":_vm.submitDialogUpdate}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.showDialogDelete),callback:function ($$v) {_vm.showDialogDelete=$$v},expression:"showDialogDelete"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('delete')))+" "+_vm._s(_vm.$tc(_vm.biblio.subs ? 'libraries' : 'subLibraries', 1, { count: '' }))+"?")]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          "+_vm._s(_vm.$t('askRemoveLibrary'))+"\n        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showDialogDelete = false}}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.submitDialogDelete()}}},[_vm._v(_vm._s(_vm.$t('yes')))])],1)],1)],1)],1)}
var WzBiblio_staticRenderFns = []
var WzBiblio_esExports = { render: WzBiblio_render, staticRenderFns: WzBiblio_staticRenderFns }
/* harmony default export */ var watcheezy_WzBiblio = (WzBiblio_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzBiblio.vue
var WzBiblio_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzBiblio___vue_template_functional__ = false
/* styles */
var WzBiblio___vue_styles__ = null
/* scopeId */
var WzBiblio___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzBiblio___vue_module_identifier__ = null
var WzBiblio_Component = WzBiblio_normalizeComponent(
  WzBiblio,
  watcheezy_WzBiblio,
  WzBiblio___vue_template_functional__,
  WzBiblio___vue_styles__,
  WzBiblio___vue_scopeId__,
  WzBiblio___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzBiblio = (WzBiblio_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzSentence.vue




/* harmony default export */ var WzSentence = ({

  props: {
    biblio: {
      type: Object,
      required: true
    },
    sentence: {
      type: Object,
      required: true
    }
  },

  data: function data() {
    return {
      showDialogUpdate: false,

      showDialogDelete: false,

      showDialogMove: false,

      sentenceDialog: {},

      biblioSelectId: this.biblio.id,
      loading: false,
      overMenu: false
    };
  },


  methods: {
    openDialogUpdate: function openDialogUpdate() {
      if (!this.overMenu) {
        this.sentenceDialog = lodash_default.a.clone(this.sentence);
        this.showDialogUpdate = true;
      }
    },
    openDialogMove: function openDialogMove() {
      this.sentenceDialog = lodash_default.a.clone(this.sentence);
      this.showDialogMove = true;
    },
    openDialogDelete: function openDialogDelete() {
      this.sentenceDialog = lodash_default.a.clone(this.sentence);
      this.showDialogDelete = true;
    },
    submitDialogUpdate: function submitDialogUpdate() {
      var _this = this;

      this.showDialogUpdate = false;

      if (this.sentence.title !== this.sentenceDialog.title) {
        var sentenceFound = lodash_default.a.find(this.biblio.sentences, { 'title': this.sentenceDialog.title });
        if (lodash_default.a.isNil(sentenceFound)) {
          var dataToPost = new window.FormData();
          dataToPost.append('SEN_ID', this.sentence.id);
          dataToPost.append('SEN_MSG', this.sentenceDialog.title);
          dataToPost.append('SEN_FAM_ID', this.biblio.id);
          this.loading = true;
          this.axios.post('put/sentence.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
            var biblioUpdate = lodash_default.a.cloneDeep(_this.biblio);
            var sentencesUpdate = [];
            for (var i = 0; i < biblioUpdate.sentences.length; i++) {
              if (biblioUpdate.sentences[i].id === _this.sentenceDialog.id) {
                sentencesUpdate.push(_this.sentenceDialog);
              } else {
                sentencesUpdate.push(biblioUpdate.sentences[i]);
              }
            }
            biblioUpdate.sentences = sentencesUpdate;
            _this.$store.commit('_Biblios/UPDATE_BIBLIO', biblioUpdate);
            _this.$emit('update:biblio', biblioUpdate);

            _this.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this.$t('modifSuccess'), context: 'success' });
          }).catch(function (_) {
            _this.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this.$t('modifFailure'), context: 'error' });
          }).then(function (_) {
            _this.loading = false;
          });
        } else {
          this.$store.dispatch('_Notifier/NEW_NOTIF', { message: this.$t('alreadyExists'), context: 'warning' });
        }
      }
    },
    submitDialogMove: function submitDialogMove() {
      var _this2 = this;

      this.showDialogMove = false;

      if (this.biblioSelectId !== this.biblio.id) {
        var dataToPost = new window.FormData();
        dataToPost.append('SEN_ID', this.sentence.id);
        dataToPost.append('SEN_MSG', this.sentence.title);
        dataToPost.append('SEN_FAM_ID', this.biblioSelectId);
        this.loading = true;
        this.axios.post('put/sentence.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
          var biblioUpdate = lodash_default.a.cloneDeep(_this2.$store.getters['_Biblios/GET_BIBLIO_BY_ID'](_this2.biblioSelectId));
          biblioUpdate.sentences.push(_this2.sentence);
          _this2.$store.commit('_Biblios/UPDATE_BIBLIO', biblioUpdate);

          _this2.$emit('update:biblio', _this2.deleteSentence());

          _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: 'Phrase déplacée dans la bibliothèque ' + biblioUpdate.title,
            context: 'success',
            action: { text: 'S\'y rendre', path: '/media/biblios/' + biblioUpdate.id }
          });
        }).catch(function (_) {
          _this2.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this2.$t('modifFailure'), context: 'error' });
        }).then(function (_) {
          _this2.loading = false;
        });
      }
    },
    submitDialogDelete: function submitDialogDelete() {
      var _this3 = this;

      this.showDialogDelete = false;
      var dataToPost = new window.FormData();
      dataToPost.append('SEN_ID', this.sentence.id);
      this.loading = true;
      this.axios.post('delete/sentence.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this3.$emit('update:biblio', _this3.deleteSentence());

        _this3.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this3.$t('deleteSuccess'), context: 'success' });
      }).catch(function (_) {
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this3.$t('deleteFailure'), context: 'error' });
      }).then(function (_) {
        _this3.loading = false;
      });
    },
    deleteSentence: function deleteSentence() {
      var biblioUpdate = lodash_default.a.cloneDeep(this.biblio);

      var sentencesUpdate = lodash_default.a.differenceWith(this.biblio.sentences, [this.sentenceDialog], lodash_default.a.isEqual);

      biblioUpdate.sentences = sentencesUpdate;
      this.$store.commit('_Biblios/UPDATE_BIBLIO', biblioUpdate);
      return biblioUpdate;
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6cac528","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzSentence.vue
var WzSentence_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('v-list-tile',[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1):_c('v-list-tile',{attrs:{"avatar":""},on:{"click":function($event){_vm.openDialogUpdate()}}},[_c('v-list-tile-avatar',[_c('v-icon',{staticClass:"primary white--text"},[_vm._v("short_text")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.sentence.title))])],1),_vm._v(" "),_c('v-list-tile-action',[_c('v-menu',{attrs:{"bottom":"","left":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"icon"},nativeOn:{"mouseover":function($event){_vm.overMenu = true},"mouseleave":function($event){_vm.overMenu = false}},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},[_c('v-list-tile',{on:{"click":function($event){_vm.openDialogUpdate()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("edit")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('edit')))+" "+_vm._s(_vm.$tc('sentences', 1)))])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.openDialogMove()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("move_to_inbox")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('move')))+" "+_vm._s(_vm.$tc('sentences', 1)))])],1)],1),_vm._v(" "),_c('v-list-tile',{on:{"click":function($event){_vm.openDialogDelete()}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('delete')))+" "+_vm._s(_vm.$tc('sentences', 1)))])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.showDialogUpdate),callback:function ($$v) {_vm.showDialogUpdate=$$v},expression:"showDialogUpdate"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('edit')))+" "+_vm._s(_vm.$tc('sentences', 1)))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-textarea',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"label":"Modifiez votre phrase","required":"","data-vv-name":"sentenceInput","error":_vm.wzErrors.has('sentenceInput'),"errors":_vm.wzErrors.collect('sentenceInput')},model:{value:(_vm.sentenceDialog.title),callback:function ($$v) {_vm.$set(_vm.sentenceDialog, "title", $$v)},expression:"sentenceDialog.title"}}),_vm._v(" "),_c('small',[_vm._v("*"+_vm._s(_vm.$t('required')))])],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showDialogUpdate = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.wzErrors.any()},on:{"click":_vm.submitDialogUpdate}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.showDialogMove),callback:function ($$v) {_vm.showDialogMove=$$v},expression:"showDialogMove"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('move')))+" "+_vm._s(_vm.$tc('sentences', 1)))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',[_c('v-select',{attrs:{"label":"Choissisez la Bibliothèque","items":_vm.$store.getters['_Biblios/GET_BIBLIO_TITLE'],"required":""},model:{value:(_vm.biblioSelectId),callback:function ($$v) {_vm.biblioSelectId=$$v},expression:"biblioSelectId"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.showDialogMove = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":_vm.submitDialogMove}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.showDialogDelete),callback:function ($$v) {_vm.showDialogDelete=$$v},expression:"showDialogDelete"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('delete')))+" "+_vm._s(_vm.$tc('sentences', 1)))]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          "+_vm._s(_vm._f("cap")(_vm.$t('delete')))+" "+_vm._s(_vm.$tc('sentences', 1))+"?\n        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},nativeOn:{"click":function($event){_vm.showDialogDelete = false}}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},nativeOn:{"click":function($event){return _vm.submitDialogDelete($event)}}},[_vm._v(_vm._s(_vm.$t('yes')))])],1)],1)],1)],1)}
var WzSentence_staticRenderFns = []
var WzSentence_esExports = { render: WzSentence_render, staticRenderFns: WzSentence_staticRenderFns }
/* harmony default export */ var watcheezy_WzSentence = (WzSentence_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzSentence.vue
var WzSentence_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzSentence___vue_template_functional__ = false
/* styles */
var WzSentence___vue_styles__ = null
/* scopeId */
var WzSentence___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzSentence___vue_module_identifier__ = null
var WzSentence_Component = WzSentence_normalizeComponent(
  WzSentence,
  watcheezy_WzSentence,
  WzSentence___vue_template_functional__,
  WzSentence___vue_styles__,
  WzSentence___vue_scopeId__,
  WzSentence___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzSentence = (WzSentence_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzHistoChats.vue








/* harmony default export */ var WzHistoChats = ({
  props: {
    params: {
      type: String,
      required: true
    },
    navigation: {
      type: Boolean,
      default: true
    },
    toolbar: {
      type: Boolean,
      default: true
    },
    colorChatAgent: {
      type: String,
      default: 'teal'
    },
    colorChatVisiteur: {
      type: String,
      default: 'blue-grey darken-2'
    },
    chatHeight: {
      type: String,
      default: '600px'
    },
    scroll: {
      type: Boolean,
      default: false
    },
    numChatsTotal: {
      type: String,
      required: true
    },
    type: {
      type: String,
      default: 'conversations'
    }
  },

  data: function data() {
    return {
      domaine: constants_DOMAINE,
      dialogEdit: false,
      leadDialog: {
        gender: '',
        motifs: []
      },
      custom_motifs: [],
      custom_champs: [],
      default_motif: [{ text: lodash_default.a.upperFirst(this.$t('support')), value: 'support' }, { text: lodash_default.a.upperFirst(this.$t('lead')), value: 'lead' }, { text: lodash_default.a.upperFirst(this.$tc('sales', 1, { count: '' })), value: 'sale' }, { text: lodash_default.a.upperFirst(this.$t('estimate')), value: 'devis' }, { text: lodash_default.a.upperFirst(this.$t('reservation')), value: 'resa' }, { text: lodash_default.a.upperFirst(this.$t('contact')), value: 'contact' }],

      awss3Public: AWSS3_PUBLIC,
      listChats: false,
      chatId: null,
      visiteurs: [],
      allChats: [],
      switchChat: false,
      loading: false,
      loadingHisto: false,
      loadingExportChats: false,
      loadingExportChat: false,
      pagination: 1,

      indexPage: 1
    };
  },
  created: function created() {
    this.loading = true;
    this.loadingHisto = true;

    if (!lodash_default.a.endsWith(this.params, '=')) {
      if (this.calculTotalpagination) {
        this.getChats(1);
      } else {
        this.getChats(0);
      }
    }
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_User', ['user']), {
    calculTotalpagination: function calculTotalpagination() {
      if (Number(this.numChatsTotal) <= 100) {
        return 0;
      } else {
        return Math.ceil(Number(this.numChatsTotal) / 100);
      }
    },
    chatSelected: function chatSelected() {
      var _this = this;

      var chat = null;
      lodash_default.a.each(this.visiteurs, function (vis) {
        if (!chat) {
          chat = lodash_default.a.find(vis.chats, { id: _this.chatId });
        }
      });
      if (!chat) return null;

      var prev = null;
      chat.messages.map(function (msg) {
        var m = moment_default.a.unix(msg.unix);
        msg.anotherDay = m.format('LL');
        if (prev && moment_default()(prev).isSame(m, 'day')) {
          msg.anotherDay = null;
        }
        prev = m;
      });
      chat.closed = chat.id.split('>')[1];
      chat.closed = chat.closed.length > 2 ? moment_default.a.unix(chat.id.substring(chat.id.length - 13, chat.id.length - 3)).format('L LTS') : 0;
      return chat;
    },
    chatsSorted: function chatsSorted() {
      return lodash_default.a.sortBy(this.visiteurs, [function (v) {
        var sorted = lodash_default.a.sortBy(v.chats, [function (c) {
          return c.last.unix;
        }]).reverse();

        v.chats = sorted;
        return v.chats[0].last.unix;
      }]).reverse();
    },
    chatsSortedCSV: function chatsSortedCSV() {
      console.log('chatsSortedCSV', this.allChats);
      return lodash_default.a.sortBy(this.allChats, [function (v) {
        var sorted = lodash_default.a.sortBy(v.chats, [function (c) {
          return c.last.unix;
        }]).reverse();

        v.chats = sorted;
        return v.chats[0].last.unix;
      }]).reverse();
    },
    visitorSelected: function visitorSelected() {
      return this.chatSelected ? this.chatSelected.id.split('>')[0] : null;
    }
  }),

  methods: {
    showChat: function showChat(id) {
      this.chatId = id;
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.listChats = false;
      }
    },
    paginationInput: function paginationInput(page) {
      this.indexPage = page;

      this.getChats(this.indexPage);
    },
    getChats: function getChats(indexPage) {
      var _this2 = this;

      this.loadingHisto = true;
      this.loading = true;
      this.axios.get('get/chats.php?' + this.params + '&indexPage=' + indexPage).then(function (response) {
        _this2.visiteurs = lodash_default.a.isArray(response.data) ? response.data : [];
        lodash_default.a.each(_this2.visiteurs, function (visiteur) {
          visiteur.duration = moment_default.a.duration(visiteur.duration, 'seconds').format('h [h] m [m] s [s]');
          visiteur.averageResponse = moment_default.a.duration(visiteur.averageResponse, 'seconds').format('h [h] m [m] s [s]');

          lodash_default.a.each(visiteur.chats, function (conversation) {
            lodash_default.a.each(conversation.messages, function (message) {
              if (message.text === 'undefined') message.text = null;
              message.unix = message.date;
              if (message.agentName === 'undefined') {
                var userFound = _this2.$store.getters['_User/getUserById'](message.agentId);
                message.agentName = userFound ? userFound.USR_FIRST_NAME + ' ' + userFound.USR_LAST_NAME : '';
              }
              var date = moment_default.a.unix(message.unix);
              message.date = date.format('LTS');
              conversation.last = lodash_default.a.clone(message);
              conversation.last.date = date.calendar();
            });
          });
        });

        if (_this2.chatsSorted[0]) {
          _this2.showChat(_this2.chatsSorted[0].chats[0].id);
        }
      }).catch(function (errors) {
        _this2.loading = false;
        _this2.loadingHisto = false;
      }).then(function (_) {
        _this2.loading = false;
        _this2.loadingHisto = false;
        _this2.listChats = true;
      });
    },
    exportAllChats: function exportAllChats(data) {
      var _this3 = this;

      this.loadingExportChats = true;
      this.axios.get('get/exportAllChatsCSV.php?' + this.params).then(function (response) {
        console.log('response', response.data);
        if (response.data === 1) {
          _this3.loadingExportChats = false;

          window.open('./static/viewCSV.php', '_blank');
        } else {
          console.log('pas fini');
        }
      }).catch(function (errors) {
        _this3.loadingExportChats = false;
      }).then(function (_) {
        console.log('export chat');
      });
    },
    exportChats: function exportChats(data) {
      var csv = null;
      var fields = ['date', 'agentName', 'visiteur', 'auteur', 'text'];
      var dataToExport = [];
      lodash_default.a.each(this.chatsSortedCSV, function (vis) {
        lodash_default.a.each(vis.chats, function (chat) {
          var currentChat = chat.messages.map(function (m) {
            return {
              date: moment_default.a.unix(m.unix).format('LL') + ' ' + m.date,
              visiteur: vis.visId,
              agentName: m.agentName,
              auteur: m.auteur,
              text: m.text
            };
          });
          dataToExport.push(currentChat);
        });
      });
      try {
        csv = json2csv_default()({
          data: lodash_default.a.flatten(dataToExport),
          del: ';',
          fields: fields
        });
      } catch (err) {
        console.err(err);
        this.loadingExportChats = false;
        return;
      }

      this.loadingExportChats = false;

      if (!data.view) {
        this.downloadFile(csv);
      } else {
        this.$router.push({ name: 'viewcsv', params: { csv: csv } });
      }
    },
    exportChat: function exportChat() {
      this.loadingExportChat = true;
      var csv = null;
      var fields = ['date', 'agentName', 'visiteur', 'auteur', 'text'];
      var id = this.visitorSelected;

      var dataToExport = this.chatSelected.messages.map(function (m) {
        return {
          date: moment_default.a.unix(m.unix).format('LL') + ' ' + m.date,
          visiteur: id,
          agentName: m.agentName,
          auteur: m.auteur,
          text: m.text
        };
      });
      try {
        csv = json2csv_default()({
          data: dataToExport,
          del: ';',
          fields: fields
        });
      } catch (err) {
        console.err(err);
        this.loadingExportChat = false;
        return;
      }
      this.loadingExportChat = false;
      this.downloadFile(csv);
    },
    downloadFile: function downloadFile(fileContent) {
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:attachment/text,' + encodeURI(fileContent);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'chats.csv';
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
    },
    showLead: function showLead(lead) {
      var _this4 = this;

      console.log('showLead', lead);
      var newTab = lodash_default.a.cloneDeep(this.leadDialog);

      var dataToGet = new window.FormData();
      dataToGet.append('session', lead);

      dataToGet.append('specialtable', this.user.licSpecialtable);
      this.axios.post('get/visitor_lead.php', dataToGet, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        console.log('response', response);
        newTab.id = lead;
        newTab.key = response.data.key ? response.data.key : '';
        newTab.gender = response.data.gender ? response.data.gender : '';
        newTab.fname = response.data.fname ? response.data.fname : '';
        newTab.lname = response.data.lname ? response.data.lname : '';
        newTab.email = response.data.email ? response.data.email : '';
        newTab.tel = response.data.tel ? response.data.tel : '';
        newTab.C2C = '';
        newTab.company = response.data.company ? response.data.company : '';
        newTab.url = response.data.url ? response.data.url : '';
        newTab.ip = '';
        newTab.question = '';
        newTab.motifs = '';
        newTab.motif = response.data.motif ? response.data.motif : '';
        newTab.key = response.data.key ? response.data.key : '';

        newTab.comment = response.data.comment ? response.data.comment : '';
        newTab.getquanty = '';
        newTab.hasChatted = '';
        newTab.hasBeenTarget = '';
        newTab.duration = '';
        newTab.basket = '';
        newTab.purchase = '';
        newTab.special_client = response.data.special_client ? response.data.special_client : '';
        var listeMotifs = [];
        var listeCustomChamps = response.data.champSup ? response.data.champSup : [];
        for (var n in _this4.$store.state._Sites.sites) {
          console.log(_this4.$store.state._Sites.sites[n].LIC_KEY + ' === ' + newTab.key);
          console.log('customLead.motifs', newTab.motifs);
          if (_this4.$store.state._Sites.sites[n].LIC_KEY === newTab.key) {
            var customLead = _this4.$store.state._Sites.sites[n].DSK_CUSTOM_LEAD_FORM;
            if (customLead !== '') {
              for (var i = 0; i < customLead.motifs.length; ++i) {
                var label = customLead.motifs[i];
                if (label === 'support') {
                  label = 'Support';
                } else if (label === 'lead') {
                  label = 'Prospect qualifié';
                } else if (label === 'sale') {
                  label = 'Vente';
                } else if (label === 'resa') {
                  label = 'Réservation';
                } else if (label === 'devis') {
                  label = 'Devis';
                } else if (label === 'contact') {
                  label = 'Contact';
                }
                listeMotifs.push({
                  text: label,
                  value: customLead.motifs[i]
                });
              }

              if (listeMotifs.length !== 0) {
                _this4.default_motif = listeMotifs;
              } else {
                _this4.default_motif = [];
              }
            }
          }
        }
        _this4.custom_motifs = listeMotifs;

        var newArrayCustomChamp = [];
        listeCustomChamps.forEach(function (item) {
          if (item.value) {
            newArrayCustomChamp.push(item);
          }
        });

        _this4.custom_champs = newArrayCustomChamp;

        _this4.leadDialog = newTab;

        _this4.error = false;
        _this4.openDialogEdit();
      }).catch(function () {
        _this4.error = true;
        _this4.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this4.$t('error'),
          context: 'error'
        });
      }).then(function () {});
    },
    openDialogEdit: function openDialogEdit() {
      console.log('open editeur', this.leadDialog);

      this.dialogEdit = true;
    },
    dialogEditeurRemove: function dialogEditeurRemove() {
      this.dialogEdit = false;
    },
    updateLeadSubmit: function updateLeadSubmit(leadUpdate) {
      console.log('updateLeadSubmit', leadUpdate);
    },
    scrollToBottom: function scrollToBottom() {
      if (this.$refs.contentChat) {
        this.$refs.contentChat.scrollTo(0, this.$refs.contentChat.scrollHeight);
      }
    }
  },

  updated: function updated() {
    var _this5 = this;

    this.$nextTick(function () {
      _this5.scrollToBottom();
    });
  },


  watch: {
    params: function params(val, oldVal) {
      if (!lodash_default.a.endsWith(val, '=')) {
        if (this.calculTotalpagination) {
          this.getChats(1);
        } else {
          this.getChats(0);
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f6ef85c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzHistoChats.vue
var WzHistoChats_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"histo",staticStyle:{"height":"100%"}},[_c('v-card',{attrs:{"flat":"","height":_vm.chatHeight}},[(_vm.navigation)?_c('v-navigation-drawer',{directives:[{name:"show",rawName:"v-show",value:(_vm.listChats),expression:"listChats"}],staticClass:"contentListeHistoChats",attrs:{"enable-resize-watcher":"","width":"320","light":"","absolute":"","persistent":"","clipped":"","hide-overlay":""},model:{value:(_vm.listChats),callback:function ($$v) {_vm.listChats=$$v},expression:"listChats"}},[_c('v-toolbar',{staticClass:"white",attrs:{"flat":"","dense":"","extended":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('conversationHistory')))]),_vm._v(" "),(_vm.visiteurs.length)?_c('div',{staticStyle:{"display":"-webkit-box"},attrs:{"slot":"extension"},slot:"extension"},[_c('div',{staticStyle:{"padding":"13px 2px"}},[_vm._v(_vm._s(_vm.$tc('visitors', _vm.visiteurs.length, { count: _vm.visiteurs.length })))]),_vm._v(" "),_c('v-btn',{attrs:{"slot":"activator","color":"primary","loading":_vm.loadingExportChats,"disabled":!_vm.visiteurs.length || _vm.loadingExportChats,"flat":""},on:{"click":function($event){_vm.exportAllChats({'view': false})}},slot:"activator"},[_vm._v("\n              exporter chats\n              "),_vm._v(" "),_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("visibility")])],1)],1):_c('div',{staticClass:"subheading",attrs:{"slot":"extension"},slot:"extension"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('chats', 0))))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{staticClass:"listeChatsVisiteurs"},[(_vm.loadingHisto)?_c('v-card',[_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1)],1):_c('v-list',{attrs:{"two-line":"","dense":""}},_vm._l((_vm.chatsSorted),function(visiteur){return _c('v-list-group',{key:visiteur.visId,attrs:{"value":visiteur.visId == _vm.visitorSelected}},[_c('v-list-tile',{attrs:{"slot":"activator","ripple":""},on:{"click":function($event){;}},slot:"activator"},[_c('v-list-tile-action',[_c('wz-avatar',{attrs:{"username":'#' + visiteur.visId,"size":"35px"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(visiteur.visId))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.$tc('chats', visiteur.chats.length, { count: visiteur.chats.length })))])],1)],1),_vm._v(" "),_vm._l((visiteur.chats),function(chat){return _c('v-list-tile',{key:chat.id,class:{'grey lighten-2' : chat.id == _vm.chatId},attrs:{"ripple":""},on:{"click":function($event){_vm.showChat(chat.id)}}},[_c('wz-avatar-double',{attrs:{"avatars":[{id: visiteur.visId}, {id: chat.last.agentId, username: chat.last.agentName}]}}),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(chat.last.auteur == 'Visiteur' ? visiteur.visId : chat.last.agentName))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(chat.last.text))])],1),_vm._v(" "),_c('v-list-tile-action',[_vm._v(_vm._s(chat.last.date))])],1)})],2)}),1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',[_c('v-pagination',{attrs:{"length":_vm.calculTotalpagination,"circle":"","disabled":_vm.numChatsTotal <= 100},on:{"input":function($event){_vm.paginationInput(_vm.pagination)}},model:{value:(_vm.pagination),callback:function ($$v) {_vm.pagination=$$v},expression:"pagination"}})],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.toolbar)?_c('v-toolbar',{staticClass:"primary",class:{'histo__navigation--opened': _vm.listChats},attrs:{"dark":"","dense":"","extended":""}},[(_vm.navigation)?_c('v-toolbar-side-icon',{nativeOn:{"click":function($event){_vm.listChats = !_vm.listChats}}}):_vm._e(),_vm._v(" "),(_vm.chatId)?_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("#"+_vm._s(_vm.visitorSelected))]):_vm._e(),_vm._v(" "),(_vm.chatSelected && _vm.$route.name != 'leads')?_c('v-btn',{attrs:{"icon":"icon","loading":_vm.loadingExportChat,"disabled":_vm.loadingExportChat},on:{"click":function($event){_vm.showLead(_vm.visitorSelected)}}},[_c('v-icon',[_vm._v("info_outline")])],1):_vm._e(),_vm._v(" "),(_vm.chatSelected)?_c('div',{staticClass:"white--text subheading",attrs:{"slot":"extension"},slot:"extension"},[(false)?_c('v-tooltip',{attrs:{"right":""}},[_c('span',{staticClass:"mr-3",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("access_time")]),_vm._v("\n              "+_vm._s(_vm.chatSelected.duration)+"\n            ")],1),_vm._v(" "),_c('span',[_vm._v("Durée totale")])]):_vm._e(),_vm._v(" "),(false)?_c('v-tooltip',{attrs:{"right":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("timer")]),_vm._v("\n              "+_vm._s(_vm.chatSelected.averageResponse)+"\n            ")],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('chatsAverageResponse')))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"ml-2"},[_vm._v("\n            "+_vm._s(_vm.chatSelected.messages.length)+"\n            "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("chat_bubble_outline")])],1),_vm._v(" "),(_vm.chatSelected.closed)?_c('span',{staticClass:"ml-2"},[_vm._v("\n            "+_vm._s(_vm.$t('closing'))+" : "+_vm._s(_vm.chatSelected.closed)+"\n            "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("offline_pin")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.chatSelected)?_c('v-btn',{attrs:{"icon":"icon","loading":_vm.loadingExportChat,"disabled":_vm.loadingExportChat},on:{"click":function($event){_vm.exportChat()}}},[_c('v-icon',[_vm._v("file_download")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('main',{directives:[{name:"bar",rawName:"v-bar"}],ref:"contentChat",class:{
          'histo__navigation--opened vb': _vm.listChats,
          'histo__main--toolbar vb': _vm.toolbar,
          'histo__main--no-toolbar vb': !_vm.toolbar
        },staticStyle:{"height":"100%"},attrs:{"id":"contentChat"}},[_c('div',{staticClass:"histo__main--scroll",attrs:{"grid-list-sm":"","fluid":""}},[(_vm.loading)?_c('v-card',{attrs:{"height":_vm.chatHeight}},[_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1)],1):(_vm.chatSelected)?_c('div',{attrs:{"height":"100%","width":"100%"}},[_c('transition',{attrs:{"name":"slide-x-reverse-transition","mode":"out-in"}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_vm._l((_vm.chatSelected.messages),function(msg,i){return [(msg.anotherDay)?_c('v-flex',{key:msg.unix,staticClass:"text-xs-center sticky",attrs:{"xs12":""}},[_c('div',{staticClass:"dateMessageChat",attrs:{"secondary":""}},[_vm._v(_vm._s(msg.anotherDay))])]):_vm._e(),_vm._v(" "),_c('v-flex',{key:i,attrs:{"xs12":""}},[(msg.auteur == 'Agent')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs2":""}},[_c('wz-avatar',{attrs:{"username":msg.agentName,"src":(_vm.domaine + "/media/user/small/" + (msg.agentId) + "_avatar.jpg"),"size":"35px"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('v-card',{class:[
                            'white--text',
                            'histo__bubble',
                            'histo__bubble--agent',
                            _vm.colorChatAgent
                          ]},[_c('v-card-text',{staticClass:"pa-1"},[(msg.text)?_c('div',{staticClass:"contentChatMessageTxt"},[_vm._v(_vm._s(msg.text))]):_c('img',{attrs:{"src":_vm.awss3Public + '/' + msg.attachment,"alt":"Image indisponible"}}),_vm._v(" "),_c('small',[_vm._v(_vm._s(msg.type == '2' ? ' (auto)' : ''))])])],1),_vm._v(" "),_c('small',[_vm._v(_vm._s(msg.agentName)+" • "+_vm._s(msg.date))])],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-sm-and-down",attrs:{"md3":""}})],1):_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"hidden-sm-and-down",attrs:{"md3":""}}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs10":"","md8":""}},[_c('v-card',{class:[
                            'white--text',
                            'histo__bubble',
                            'histo__bubble--visitor',
                            _vm.colorChatVisiteur
                          ]},[_c('v-card-text',{staticClass:"text-xs-right pa-1"},[(msg.text)?_c('div',{staticClass:"pr-2 contentChatMessageTxt"},[_vm._v(_vm._s(msg.text))]):_c('img',{attrs:{"src":_vm.awss3Public + '/' + msg.attachment,"alt":"Image indisponible"}})])],1),_vm._v(" "),_c('small',[_vm._v(_vm._s(msg.date))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('wz-avatar',{attrs:{"username":'#' + _vm.visitorSelected,"size":"35px"}})],1)],1)],1)]}),_vm._v(" "),(_vm.chatSelected.closed)?_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-chip',{attrs:{"label":"","disabled":"","color":"secondary","text-color":"white"}},[_vm._v("\n                      "+_vm._s(_vm.$t('closing'))+" : "+_vm._s(_vm.chatSelected.closed)+"\n                      "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("offline_pin")])],1)],1)],1):_vm._e()],2)],1)],1):_c('v-alert',{attrs:{"color":"blue","icon":"info","value":"true","outline":""}},[_vm._v("\n            "+_vm._s(_vm._f("cap")(_vm.$tc('chats', 0)))+"\n          ")])],1)])],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1200px","scrollable":!_vm.$vuetify.breakpoint.smAndDown,"fullscreen":_vm.$vuetify.breakpoint.smAndDown},model:{value:(_vm.dialogEdit),callback:function ($$v) {_vm.dialogEdit=$$v},expression:"dialogEdit"}},[_c('wz-editeur-lead',{attrs:{"leadDialog":_vm.leadDialog,"custom_motifs":_vm.custom_motifs,"custom_champs":_vm.custom_champs,"showHisto":false,"histoChat":true},on:{"closeDialog":_vm.dialogEditeurRemove,"updateLead":_vm.updateLeadSubmit}})],1)],1)}
var WzHistoChats_staticRenderFns = []
var WzHistoChats_esExports = { render: WzHistoChats_render, staticRenderFns: WzHistoChats_staticRenderFns }
/* harmony default export */ var watcheezy_WzHistoChats = (WzHistoChats_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzHistoChats.vue
function WzHistoChats_injectStyle (ssrContext) {
  __webpack_require__("uEEE")
}
var WzHistoChats_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzHistoChats___vue_template_functional__ = false
/* styles */
var WzHistoChats___vue_styles__ = WzHistoChats_injectStyle
/* scopeId */
var WzHistoChats___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzHistoChats___vue_module_identifier__ = null
var WzHistoChats_Component = WzHistoChats_normalizeComponent(
  WzHistoChats,
  watcheezy_WzHistoChats,
  WzHistoChats___vue_template_functional__,
  WzHistoChats___vue_styles__,
  WzHistoChats___vue_scopeId__,
  WzHistoChats___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzHistoChats = (WzHistoChats_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzHistoBot.vue






/* harmony default export */ var WzHistoBot = ({
  props: {
    params: {
      type: String,
      required: true
    },
    navigation: {
      type: Boolean,
      default: true
    },
    toolbar: {
      type: Boolean,
      default: true
    },
    colorChatAgent: {
      type: String,
      default: 'teal'
    },
    colorChatVisiteur: {
      type: String,
      default: 'blue-grey darken-2'
    },
    chatHeight: {
      type: String,
      default: '600px'
    },
    scroll: {
      type: Boolean,
      default: false
    },
    numChatsTotal: {
      type: String,
      required: true
    }
  },

  data: function data() {
    return {
      domaine: constants_DOMAINE,
      listChats: true,
      chatId: null,
      visiteurs: [],
      allChats: [],
      switchChat: false,
      loading: true,
      loadingHisto: false,
      loadingExportChats: false,
      loadingExportChat: false,
      pagination: 1,

      indexPage: 1
    };
  },
  created: function created() {
    this.loading = true;
    this.loadingHisto = true;

    this.listChats = this.navigation;

    if (this.calculTotalagination) {
      this.getChats(1);
    } else {
      this.getChats(0);
    }
  },


  computed: {
    calculTotalagination: function calculTotalagination() {
      if (Number(this.numChatsTotal) <= 100) {
        return 0;
      } else {
        return Math.ceil(Number(this.numChatsTotal) / 100);
      }
    },
    chatSelected: function chatSelected() {
      var _this = this;

      var chat = null;
      lodash_default.a.each(this.visiteurs, function (vis) {
        if (!chat) {
          chat = lodash_default.a.find(vis.chats, { 'id': _this.chatId });
        }
      });
      if (!chat) return null;

      var prev = null;
      chat.messages.map(function (msg) {
        var m = moment_default.a.unix(msg.unix);
        msg.anotherDay = m.format('LL');
        if (prev && moment_default()(prev).isSame(m, 'day')) {
          msg.anotherDay = null;
        }
        prev = m;
      });
      chat.closed = chat.id.split('>')[1];
      chat.closed = chat.closed.length > 2 ? moment_default.a.unix(chat.id.substring(chat.id.length - 13, chat.id.length - 3)).format('L LTS') : 0;
      return chat;
    },
    chatsSorted: function chatsSorted() {
      return lodash_default.a.sortBy(this.visiteurs, [function (v) {
        var sorted = lodash_default.a.sortBy(v.chats, [function (c) {
          return c.last.unix;
        }]).reverse();

        v.chats = sorted;
        return v.chats[0].last.unix;
      }]).reverse();
    },
    chatsSortedCSV: function chatsSortedCSV() {
      return lodash_default.a.sortBy(this.allChats, [function (v) {
        var sorted = lodash_default.a.sortBy(v.chats, [function (c) {
          return c.last.unix;
        }]).reverse();

        v.chats = sorted;
        return v.chats[0].last.unix;
      }]).reverse();
    },
    visitorSelected: function visitorSelected() {
      return this.chatSelected ? this.chatSelected.id.split('>')[0] : null;
    }
  },

  methods: {
    showChat: function showChat(id) {
      this.chatId = id;
      if (this.$vuetify.breakpoint.mdAndDown) {
        this.listChats = false;
      }
    },
    paginationInput: function paginationInput(page) {
      this.indexPage = page;

      this.getChats(this.indexPage);
    },
    getChats: function getChats(indexPage) {
      var _this2 = this;

      this.loadingHisto = true;
      this.loading = true;
      this.axios.get('get/bot_chats.php?' + this.params + '&indexPage=' + indexPage).then(function (response) {
        _this2.visiteurs = lodash_default.a.isArray(response.data) ? response.data : [];
        lodash_default.a.each(_this2.visiteurs, function (visiteur) {
          visiteur.duration = moment_default.a.duration(visiteur.duration, 'seconds').format('h [h] m [m] s [s]');
          visiteur.averageResponse = moment_default.a.duration(visiteur.averageResponse, 'seconds').format('h [h] m [m] s [s]');

          lodash_default.a.each(visiteur.chats, function (conversation) {
            lodash_default.a.each(conversation.messages, function (message) {
              if (message.text === 'undefined') message.text = null;
              message.unix = message.date;
              if (message.agentName === 'undefined' || message.agentName === '') {
                var userFound = _this2.$store.getters['_User/getUserById'](message.agentId);
                message.agentName = userFound.USR_FIRST_NAME + ' ' + userFound.USR_LAST_NAME;
              }
              var date = moment_default.a.unix(message.unix);
              message.date = date.format('LTS');
              conversation.last = lodash_default.a.clone(message);
              conversation.last.date = date.calendar();
            });
          });
        });

        if (_this2.chatsSorted[0]) {
          _this2.showChat(_this2.chatsSorted[0].chats[0].id);
        }
      }).catch(function (errors) {
        _this2.loading = false;
        _this2.loadingHisto = false;
      }).then(function (_) {
        _this2.loading = false;
        _this2.loadingHisto = false;
      });
    },
    exportAllChats: function exportAllChats(data) {
      var _this3 = this;

      this.loadingExportChats = true;
      this.axios.get('get/exportAllBotChatsCSV.php?' + this.params).then(function (response) {
        console.log('response', response.data);
        if (response.data === 1) {
          _this3.loadingExportChats = false;

          window.open('./static/viewCSV.php', '_blank');
        } else {
          console.log('pas fini');
        }
      }).catch(function (errors) {
        _this3.loadingExportChats = false;
      }).then(function (_) {});
    },
    exportChats: function exportChats(data) {
      var csv = null;
      var fields = ['date', 'agentName', 'visiteur', 'auteur', 'text'];
      var dataToExport = [];
      lodash_default.a.each(this.chatsSortedCSV, function (vis) {
        lodash_default.a.each(vis.chats, function (chat) {
          var currentChat = chat.messages.map(function (m) {
            return {
              'date': moment_default.a.unix(m.unix).format('LL') + ' ' + m.date,
              'visiteur': vis.visId,
              'agentName': m.agentName,
              'auteur': m.auteur,
              'text': m.text
            };
          });
          dataToExport.push(currentChat);
        });
      });
      try {
        csv = json2csv_default()({
          data: lodash_default.a.flatten(dataToExport),
          del: ';',
          fields: fields
        });
      } catch (err) {
        console.err(err);
        this.loadingExportChats = false;
        return;
      }
      this.loadingExportChats = false;

      if (!data.view) {
        this.downloadFile(csv);
      } else {
        this.$router.push({ name: 'viewcsv', params: { csv: csv } });
      }
    },
    exportChat: function exportChat() {
      this.loadingExportChat = true;
      var csv = null;
      var fields = ['date', 'agentName', 'visiteur', 'auteur', 'text'];
      var id = this.visitorSelected;

      var dataToExport = this.chatSelected.messages.map(function (m) {
        return {
          'date': moment_default.a.unix(m.unix).format('LL') + ' ' + m.date,
          'visiteur': id,
          'agentName': m.agentName,
          'auteur': m.auteur,
          'text': m.text
        };
      });
      try {
        csv = json2csv_default()({
          data: dataToExport,
          del: ';',
          fields: fields
        });
      } catch (err) {
        console.err(err);
        this.loadingExportChat = false;
        return;
      }
      this.loadingExportChat = false;
      this.downloadFile(csv);
    },
    downloadFile: function downloadFile(fileContent) {
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:attachment/text,' + encodeURI(fileContent);
      hiddenElement.target = '_blank';
      hiddenElement.download = 'chats.csv';
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
    },
    scrollToBottom: function scrollToBottom() {
      if (this.$refs.contentChat) {
        this.$refs.contentChat.scrollTo(0, this.$refs.contentChat.scrollHeight);
      }
    }
  },

  updated: function updated() {
    var _this4 = this;

    this.$nextTick(function () {
      _this4.scrollToBottom();
    });
  },


  watch: {
    params: function params(val, oldVal) {
      if (!lodash_default.a.endsWith(val, '=')) {
        if (this.calculTotalagination) {
          this.getChats(1);
        } else {
          this.getChats(0);
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-38f56cfe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzHistoBot.vue
var WzHistoBot_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"histo",staticStyle:{"height":"100%"}},[_c('v-card',{attrs:{"flat":"","height":_vm.chatHeight}},[(_vm.navigation)?_c('v-navigation-drawer',{directives:[{name:"show",rawName:"v-show",value:(_vm.listChats),expression:"listChats"}],staticClass:"contentListeHistoChats",staticStyle:{"z-index":"1"},attrs:{"enable-resize-watcher":"","width":"320","light":"","absolute":"","persistent":"","clipped":"","hide-overlay":""},model:{value:(_vm.listChats),callback:function ($$v) {_vm.listChats=$$v},expression:"listChats"}},[_c('v-toolbar',{staticClass:"white",attrs:{"flat":"","dense":"","extended":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('botHistory')))]),_vm._v(" "),(_vm.visiteurs.length)?_c('div',{attrs:{"slot":"extension"},slot:"extension"},[_vm._v("\n            "+_vm._s(_vm.$tc('visitors', _vm.visiteurs.length, { count: _vm.visiteurs.length }))+"\n            "),_c('v-btn',{attrs:{"slot":"activator","color":"primary","loading":_vm.loadingExportChats,"disabled":!_vm.visiteurs.length || _vm.loadingExportChats,"flat":""},on:{"click":function($event){_vm.exportAllChats({'view': false})}},slot:"activator"},[_vm._v("\n              exporter chats\n              "),_vm._v(" "),_c('v-icon',{attrs:{"color":"primary","right":""}},[_vm._v("visibility")])],1)],1):_c('div',{staticClass:"subheading",attrs:{"slot":"extension"},slot:"extension"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('chats', 0))))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{staticClass:"listeChatsVisiteurs"},[(_vm.loadingHisto)?_c('v-card',[_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1)],1):_c('v-list',{attrs:{"two-line":"","dense":""}},_vm._l((_vm.chatsSorted),function(visiteur){return _c('v-list-group',{key:visiteur.visId,attrs:{"value":visiteur.visId == _vm.visitorSelected}},[_c('v-list-tile',{attrs:{"slot":"activator","ripple":""},on:{"click":function($event){;}},slot:"activator"},[_c('v-list-tile-action',[_c('wz-avatar',{attrs:{"username":'#' + visiteur.visId,"size":"35px"}})],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(visiteur.visId))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.$tc('chats', visiteur.chats.length, { count: visiteur.chats.length })))])],1)],1),_vm._v(" "),_vm._l((visiteur.chats),function(chat){return _c('v-list-tile',{key:chat.id,class:{'grey lighten-2' : chat.id == _vm.chatId},attrs:{"ripple":""},on:{"click":function($event){_vm.showChat(chat.id)}}},[_c('wz-avatar-double',{attrs:{"avatars":[{id: visiteur.visId}, {id: chat.last.agentId, username: chat.last.agentName}]}}),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(chat.last.auteur == 'Visiteur' ? visiteur.visId : chat.last.agentName))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(chat.last.text))])],1),_vm._v(" "),_c('v-list-tile-action',[_vm._v(_vm._s(chat.last.date))])],1)})],2)}),1)],1),_vm._v(" "),_c('v-layout',{attrs:{"justify-center":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',[_c('v-card-text',[_c('v-pagination',{attrs:{"length":_vm.calculTotalagination,"circle":"","disabled":_vm.numChatsTotal <= 100},on:{"input":function($event){_vm.paginationInput(_vm.pagination)}},model:{value:(_vm.pagination),callback:function ($$v) {_vm.pagination=$$v},expression:"pagination"}})],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.toolbar)?_c('v-toolbar',{staticClass:"primary",class:{'histo__navigation--opened': _vm.listChats},attrs:{"dark":"","dense":"","extended":""}},[(_vm.navigation)?_c('v-toolbar-side-icon',{nativeOn:{"click":function($event){_vm.listChats = !_vm.listChats}}}):_vm._e(),_vm._v(" "),(_vm.chatId)?_c('v-toolbar-title',{staticClass:"white--text"},[_vm._v("#"+_vm._s(_vm.visitorSelected))]):_vm._e(),_vm._v(" "),(_vm.chatSelected)?_c('div',{staticClass:"white--text subheading",attrs:{"slot":"extension"},slot:"extension"},[(false)?_c('v-tooltip',{attrs:{"right":""}},[_c('span',{staticClass:"mr-3",attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("access_time")]),_vm._v("\n              "+_vm._s(_vm.chatSelected.duration)+"\n            ")],1),_vm._v(" "),_c('span',[_vm._v("Durée totale")])]):_vm._e(),_vm._v(" "),(false)?_c('v-tooltip',{attrs:{"right":""}},[_c('span',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-icon',{attrs:{"dark":""}},[_vm._v("timer")]),_vm._v("\n              "+_vm._s(_vm.chatSelected.averageResponse)+"\n            ")],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('chatsAverageResponse')))])]):_vm._e(),_vm._v(" "),_c('span',{staticClass:"ml-2"},[_vm._v("\n            "+_vm._s(_vm.chatSelected.messages.length)+"\n            "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("chat_bubble_outline")])],1),_vm._v(" "),(_vm.chatSelected.closed)?_c('span',{staticClass:"ml-2"},[_vm._v("\n            "+_vm._s(_vm.$t('closing'))+" : "+_vm._s(_vm.chatSelected.closed)+"\n            "),_c('v-icon',{attrs:{"dark":"","right":""}},[_vm._v("offline_pin")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.chatSelected)?_c('v-btn',{attrs:{"icon":"icon","loading":_vm.loadingExportChat,"disabled":_vm.loadingExportChat},on:{"click":function($event){_vm.exportChat()}}},[_c('v-icon',[_vm._v("file_download")])],1):_vm._e()],1):_vm._e(),_vm._v(" "),_c('main',{directives:[{name:"bar",rawName:"v-bar"}],ref:"contentChat",class:{
          'histo__navigation--opened vb': _vm.listChats,
          'histo__main--toolbar vb': _vm.toolbar,
          'histo__main--no-toolbar vb': !_vm.toolbar,
        },staticStyle:{"height":"100%"},attrs:{"id":"contentChat"}},[_c('div',{staticClass:"histo__main--scroll",attrs:{"grid-list-sm":"","fluid":""}},[(_vm.loading)?_c('v-card',{attrs:{"height":_vm.chatHeight}},[_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1)],1):(_vm.chatSelected)?_c('div',{attrs:{"height":"100%"}},[_c('transition',{attrs:{"name":"slide-x-reverse-transition","mode":"out-in"}},[_c('v-layout',{staticStyle:{"width":"100%"},attrs:{"row":"","wrap":""}},[_vm._l((_vm.chatSelected.messages),function(msg,i){return [(msg.anotherDay)?_c('v-flex',{key:msg.date,staticClass:"text-xs-center sticky",attrs:{"xs12":""}},[_c('div',{staticClass:"dateMessageChat",attrs:{"secondary":""}},[_vm._v(_vm._s(msg.anotherDay))])]):_vm._e(),_vm._v(" "),_c('v-flex',{key:i,attrs:{"xs12":""}},[(msg.auteur == 'Agent')?_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs2":""}},[_c('wz-avatar',{attrs:{"username":msg.agentName,"src":(_vm.domaine + "/media/user/small/" + (msg.agentId) + "_avatar.jpg"),"size":"35px"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('v-card',{class:[
                            'white--text',
                            'histo__bubble',
                            'histo__bubble--agent',
                            _vm.colorChatAgent
                          ]},[_c('v-card-text',{staticClass:"pa-1"},[(false)?_c('v-icon',{staticClass:"corner corner--agent",attrs:{"color":_vm.colorChatAgent,"unselectable":"on","onselectstart":"return false;","onmousedown":"return false;"}},[_vm._v("arrow_drop_down")]):_vm._e(),_vm._v(" "),_c('div',[(msg.text)?_c('span',[_vm._v(_vm._s(msg.text))]):_c('img',{attrs:{"src":msg.attachment,"alt":"Image indisponible"}})]),_vm._v(" "),_c('small',[_vm._v(_vm._s(msg.type == '2' ? ' (auto)' : ''))])],1)],1),_vm._v(" "),_c('small',[_vm._v(_vm._s(msg.agentName)+" • "+_vm._s(msg.date))])],1),_vm._v(" "),_c('v-flex',{staticClass:"hidden-sm-and-down",attrs:{"md3":""}})],1):_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"hidden-sm-and-down",attrs:{"md3":""}}),_vm._v(" "),_c('v-flex',{staticClass:"text-xs-right",attrs:{"xs10":"","md8":""}},[_c('v-card',{class:['white--text', 'histo__bubble', 'histo__bubble--visitor', _vm.colorChatVisiteur]},[_c('v-card-text',{staticClass:"text-xs-right pa-1"},[(false)?_c('v-icon',{staticClass:"corner corner--visitor",attrs:{"color":_vm.colorChatVisiteur,"unselectable":"on","onselectstart":"return false;","onmousedown":"return false;"}},[_vm._v("arrow_drop_down")]):_vm._e(),_vm._v(" "),_c('div',[(msg.text)?_c('span',[_vm._v(_vm._s(msg.text))]):_c('img',{attrs:{"src":msg.attachment,"alt":"Image indisponible"}})])],1)],1),_vm._v(" "),_c('small',[_vm._v(_vm._s(msg.date))])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}},[_c('wz-avatar',{attrs:{"username":'#' + _vm.visitorSelected,"size":"35px"}})],1)],1)],1)]}),_vm._v(" "),(_vm.chatSelected.closed)?_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-chip',{attrs:{"label":"","disabled":"","color":"secondary","text-color":"white"}},[_vm._v("\n                      "+_vm._s(_vm.$t('closing'))+" : "+_vm._s(_vm.chatSelected.closed)+"\n                      "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("offline_pin")])],1)],1)],1):_vm._e()],2)],1)],1):_c('v-alert',{attrs:{"color":"blue","icon":"info","value":"true","outline":""}},[_vm._v("\n            "+_vm._s(_vm._f("cap")(_vm.$tc('chats', 0)))+"\n          ")])],1)])],1)],1)}
var WzHistoBot_staticRenderFns = []
var WzHistoBot_esExports = { render: WzHistoBot_render, staticRenderFns: WzHistoBot_staticRenderFns }
/* harmony default export */ var watcheezy_WzHistoBot = (WzHistoBot_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzHistoBot.vue
function WzHistoBot_injectStyle (ssrContext) {
  __webpack_require__("6uOo")
}
var WzHistoBot_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzHistoBot___vue_template_functional__ = false
/* styles */
var WzHistoBot___vue_styles__ = WzHistoBot_injectStyle
/* scopeId */
var WzHistoBot___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzHistoBot___vue_module_identifier__ = null
var WzHistoBot_Component = WzHistoBot_normalizeComponent(
  WzHistoBot,
  watcheezy_WzHistoBot,
  WzHistoBot___vue_template_functional__,
  WzHistoBot___vue_styles__,
  WzHistoBot___vue_scopeId__,
  WzHistoBot___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzHistoBot = (WzHistoBot_Component.exports);

// EXTERNAL MODULE: ./node_modules/babel-runtime/helpers/typeof.js
var helpers_typeof = __webpack_require__("pFYg");
var typeof_default = /*#__PURE__*/__webpack_require__.n(helpers_typeof);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzFileSelector.vue




/* harmony default export */ var WzFileSelector = ({
  props: {
    value: {
      type: [Array, String]
    },
    accept: {
      type: String,
      default: '*'
    },
    label: {
      type: String,
      default: 'Choisir...'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      filename: '',
      src: null
    };
  },

  watch: {
    value: function value(v) {
      this.filename = v;
    }
  },
  mounted: function mounted() {
    this.filename = this.value;
  },


  methods: {
    getFormData: function getFormData(files) {
      var data = new FormData();
      for (var file in files) {
        if ((typeof file === 'undefined' ? 'undefined' : typeof_default()(file)) === 'object') {
          data.append('data', file, file.name);
        } else {
          data.append('data', file);
        }
      }
      return data;
    },
    onFocus: function onFocus() {
      if (!this.disabled) {
        this.$refs.fileInput.click();
      }
    },
    onFileChange: function onFileChange($event) {
      var _this = this;

      var files = $event.target.files || $event.dataTransfer.files;
      var form = this.getFormData(files);
      if (files) {
        if (files.length > 0) {
          this.filename = [].concat(toConsumableArray_default()(files)).map(function (file) {
            return file.name;
          }).join(', ');
        } else {}
      } else {
        this.filename = $event.target.value.split('\\').pop();
      }
      this.$emit('input', this.filename);
      this.$emit('formData', form);
      var input = $event.target;
      if (input.files && input.files[0]) {
        var reader = new window.FileReader();
        reader.onload = function (e) {
          _this.src = e.target.result;
          _this.$emit('change', _this.src);
        };
        reader.readAsDataURL(input.files[0]);
      }
    },
    reset: function reset() {
      this.filename = '';
      this.src = null;
      this.$emit('change', this.src);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-58c2b2c6","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzFileSelector.vue
var WzFileSelector_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-text-field',{ref:"fileTextField",attrs:{"prepend-icon":"attach_file","single-line":"","label":_vm._f("cap")(_vm.src ? _vm.filename : _vm.$t('choose') + '...'),"disabled":_vm.disabled,"readonly":"","append-icon":_vm.filename ? 'delete' : ''},on:{"click:prepend":_vm.onFocus,"click:append":_vm.reset},nativeOn:{"click":function($event){return _vm.onFocus($event)}},model:{value:(_vm.filename),callback:function ($$v) {_vm.filename=$$v},expression:"filename"}}),_vm._v(" "),_c('input',{ref:"fileInput",attrs:{"type":"file","accept":_vm.accept,"multiple":"false","disabled":_vm.disabled},on:{"change":_vm.onFileChange}})],1)}
var WzFileSelector_staticRenderFns = []
var WzFileSelector_esExports = { render: WzFileSelector_render, staticRenderFns: WzFileSelector_staticRenderFns }
/* harmony default export */ var watcheezy_WzFileSelector = (WzFileSelector_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzFileSelector.vue
function WzFileSelector_injectStyle (ssrContext) {
  __webpack_require__("koWZ")
}
var WzFileSelector_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzFileSelector___vue_template_functional__ = false
/* styles */
var WzFileSelector___vue_styles__ = WzFileSelector_injectStyle
/* scopeId */
var WzFileSelector___vue_scopeId__ = "data-v-58c2b2c6"
/* moduleIdentifier (server only) */
var WzFileSelector___vue_module_identifier__ = null
var WzFileSelector_Component = WzFileSelector_normalizeComponent(
  WzFileSelector,
  watcheezy_WzFileSelector,
  WzFileSelector___vue_template_functional__,
  WzFileSelector___vue_styles__,
  WzFileSelector___vue_scopeId__,
  WzFileSelector___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzFileSelector = (WzFileSelector_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzImgUpload.vue


/* harmony default export */ var WzImgUpload = ({
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    tile: {
      type: Boolean,
      default: false
    },
    source: {
      type: String,
      default: ''
    }
  },

  data: function data() {
    return {
      imageSrc: ''
    };
  },
  mounted: function mounted() {
    if (!this.source || this.source === '') {
      this.imageSrc = this.$store.getters['_User/userAvatar'];
    } else {
      this.imageSrc = this.source;
    }
  },


  watch: {
    source: function source(v) {
      this.imageSrc = v;
    }
  },

  methods: {
    previewThumbnail: function previewThumbnail(file) {
      this.imageSrc = file;
      this.$emit('change', file);
    }
  },

  computed: {
    textFieldValue: function textFieldValue() {
      if (this.imageSrc) {
        if (this.imageSrc.length > 64) {
          return this.imageSrc.substr(0, 50) + '...';
        } else {
          return this.imageSrc;
        }
      }
      return this.$store.state._User.id + '_avatar.jpg';
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75b6af58","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzImgUpload.vue
var WzImgUpload_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs2":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs3":""}},[(!_vm.disabled)?_c('wz-avatar',{attrs:{"src":_vm.imageSrc,"tile":_vm.tile,"username":_vm.$store.getters['_User/fullName'],"size":"128px"}}):_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":128,"width":1}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs2":""}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","justify-space-around":""}},[_c('v-flex',{attrs:{"xs1":""}}),_vm._v(" "),_c('v-flex',{attrs:{"xs10":""}},[_c('wz-file-selector',{attrs:{"value":_vm.textFieldValue,"disabled":_vm.disabled},on:{"change":_vm.previewThumbnail}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs1":""}})],1)],1)}
var WzImgUpload_staticRenderFns = []
var WzImgUpload_esExports = { render: WzImgUpload_render, staticRenderFns: WzImgUpload_staticRenderFns }
/* harmony default export */ var watcheezy_WzImgUpload = (WzImgUpload_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzImgUpload.vue
var WzImgUpload_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzImgUpload___vue_template_functional__ = false
/* styles */
var WzImgUpload___vue_styles__ = null
/* scopeId */
var WzImgUpload___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzImgUpload___vue_module_identifier__ = null
var WzImgUpload_Component = WzImgUpload_normalizeComponent(
  WzImgUpload,
  watcheezy_WzImgUpload,
  WzImgUpload___vue_template_functional__,
  WzImgUpload___vue_styles__,
  WzImgUpload___vue_scopeId__,
  WzImgUpload___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzImgUpload = (WzImgUpload_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzSelectAgents.vue




/* harmony default export */ var WzSelectAgents = ({
  props: {
    agents: {
      type: Array,
      required: true
    },

    agentsInit: {
      type: Array,
      required: true
    },

    withoutMe: {
      type: Boolean,
      default: false
    },

    min: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      domaine: constants_DOMAINE,

      agentsTmp: null,

      dialog: false,

      iAmChoosen: false
    };
  },
  created: function created() {
    this.agentsTmp = this.agents;
    this.iAmChoosen = !lodash_default.a.isNil(lodash_default.a.find(this.agentsTmp, { 'USR_ID': this.$store.state._User.id }));
  },


  computed: {
    header: function header() {
      return this.agentsTmp && !this.agentsTmp.length ? [{ text: lodash_default.a.upperFirst(this.$t('none')), align: 'left', sortable: false }] : [{ text: lodash_default.a.upperFirst(this.$tc('all', 1)), align: 'left', sortable: false }];
    }
  },

  methods: {
    open: function open() {
      this.agentsTmp = this.agents;
      this.dialog = true;
    },
    submit: function submit() {
      this.$emit('update:agents', this.agentsTmp);
      this.dialog = false;
    },
    cancel: function cancel() {
      this.dialog = false;
    },
    toggleAll: function toggleAll() {
      if (this.agentsTmp.length) this.agentsTmp = [];else this.agentsTmp = this.agentsInit.slice();
    }
  },

  watch: {
    agentsTmp: function agentsTmp(newVal, oldVal) {
      if (this.withoutMe && oldVal) {
        var meInOld = lodash_default.a.find(oldVal, { 'USR_ID': this.$store.state._User.id });
        var meInNew = lodash_default.a.findIndex(newVal, { 'USR_ID': this.$store.state._User.id });

        if (meInOld) {
          if (meInNew === -1) {
            newVal.push(meInOld);
          }
        } else {
          if (meInNew !== -1) {
            newVal.splice(meInNew, 1);
          }
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b0a139b4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzSelectAgents.vue
var WzSelectAgents_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{class:{'ml-5': _vm.$vuetify.breakpoint.mdAndUp},attrs:{"xs12":"","pt-2":""}},[_c('v-btn',{staticClass:"ml-0",attrs:{"color":"primary","outline":"","block":_vm.$vuetify.breakpoint.smAndDown},on:{"click":function($event){_vm.open()}}},[_c('v-icon',{attrs:{"left":"","color":"primary"}},[_vm._v("people")]),_vm._v("\n          "+_vm._s(_vm.agents.length)+" / "+_vm._s(_vm.$tc('agents', _vm.$store.state._User.colleagues.length, { count: _vm.$store.state._User.colleagues.length }))+"\n        ")],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"350px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('select')))+" "+_vm._s(_vm.$tc('agents', 2, { count: ' ' })))]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"400px"}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.header,"items":_vm.$store.state._User.colleagues,"item-key":"USR_ID","select-all":"primary","hide-actions":"","total-items":_vm.$store.state._User.colleagues.length},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',[_c('th',[_c('v-checkbox',{attrs:{"color":"primary","hide-details":"","input-value":props.all || (_vm.agentsTmp.length == _vm.agents.length),"indeterminate":props.indeterminate},nativeOn:{"click":function($event){return _vm.toggleAll($event)}}})],1),_vm._v(" "),_c('th',{staticClass:"text-xs-left"},[_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.header[0].text))])])])]}},{key:"items",fn:function(props){return [_c('td',[(_vm.withoutMe && (props.item.USR_ID == _vm.$store.state._User.id))?_c('v-checkbox',{attrs:{"color":"primary","hide-details":"","value":"","input-value":_vm.iAmChoosen}}):_c('v-checkbox',{attrs:{"color":"primary","hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_c('wz-avatar',{attrs:{"username":props.item.USR_FIRST_NAME  + ' ' + props.item.USR_LAST_NAME,"src":(_vm.domaine + "/media/user/small/" + (props.item.USR_ID) + "_avatar.jpg"),"size":"35px"}}),_vm._v(" "),_c('span',{staticClass:"ml-2"},[_vm._v("\n                  "+_vm._s(props.item.USR_FIRST_NAME + ' ' + props.item.USR_LAST_NAME)+"\n                ")]),_vm._v(" "),((props.item.USR_ID == _vm.$store.state._User.id))?_c('span',[_vm._v("\n                  ("+_vm._s(_vm.$t('me'))+")\n                ")]):_vm._e()],1)]}}]),model:{value:(_vm.agentsTmp),callback:function ($$v) {_vm.agentsTmp=$$v},expression:"agentsTmp"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.cancel()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.agentsTmp.length < _vm.min,"color":"primary"},on:{"click":function($event){_vm.submit()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1)}
var WzSelectAgents_staticRenderFns = []
var WzSelectAgents_esExports = { render: WzSelectAgents_render, staticRenderFns: WzSelectAgents_staticRenderFns }
/* harmony default export */ var watcheezy_WzSelectAgents = (WzSelectAgents_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzSelectAgents.vue
var WzSelectAgents_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzSelectAgents___vue_template_functional__ = false
/* styles */
var WzSelectAgents___vue_styles__ = null
/* scopeId */
var WzSelectAgents___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzSelectAgents___vue_module_identifier__ = null
var WzSelectAgents_Component = WzSelectAgents_normalizeComponent(
  WzSelectAgents,
  watcheezy_WzSelectAgents,
  WzSelectAgents___vue_template_functional__,
  WzSelectAgents___vue_styles__,
  WzSelectAgents___vue_scopeId__,
  WzSelectAgents___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzSelectAgents = (WzSelectAgents_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzSelectBots.vue




/* harmony default export */ var WzSelectBots = ({
  props: {
    bots: {
      type: Array,
      required: true
    },

    botsInit: {
      type: Array,
      required: true
    },

    withoutMe: {
      type: Boolean,
      default: false
    },

    min: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      domaine: constants_DOMAINE,

      botsTmp: null,

      dialog: false,

      iAmChoosen: false
    };
  },
  created: function created() {
    this.botsTmp = this.bots;
    this.iAmChoosen = !lodash_default.a.isNil(lodash_default.a.find(this.botsTmp, { 'USR_ID': this.$store.state._User.id }));
  },


  computed: {
    header: function header() {
      return this.botsTmp && !this.botsTmp.length ? [{ text: lodash_default.a.upperFirst(this.$t('none')), align: 'left', sortable: false }] : [{ text: lodash_default.a.upperFirst(this.$tc('all', 1)), align: 'left', sortable: false }];
    }
  },

  methods: {
    open: function open() {
      this.botsTmp = this.bots;
      this.dialog = true;
    },
    submit: function submit() {
      this.$emit('update:bots', this.botsTmp);
      this.dialog = false;
    },
    cancel: function cancel() {
      this.dialog = false;
    },
    toggleAll: function toggleAll() {
      if (this.botsTmp.length) this.botsTmp = [];else this.botsTmp = this.botsInit.slice();
    }
  },

  watch: {
    botsTmp: function botsTmp(newVal, oldVal) {
      if (this.withoutMe && oldVal) {
        var meInOld = lodash_default.a.find(oldVal, { 'USR_ID': this.$store.state._User.id });
        var meInNew = lodash_default.a.findIndex(newVal, { 'USR_ID': this.$store.state._User.id });

        if (meInOld) {
          if (meInNew === -1) {
            newVal.push(meInOld);
          }
        } else {
          if (meInNew !== -1) {
            newVal.splice(meInNew, 1);
          }
        }
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53039e50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzSelectBots.vue
var WzSelectBots_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{class:{'ml-5': _vm.$vuetify.breakpoint.mdAndUp},attrs:{"xs12":"","pt-2":""}},[_c('v-btn',{staticClass:"ml-0",attrs:{"color":"primary","outline":"","block":_vm.$vuetify.breakpoint.smAndDown},on:{"click":function($event){_vm.open()}}},[_c('v-icon',{attrs:{"left":"","color":"primary"}},[_vm._v("android")]),_vm._v("\n          "+_vm._s(_vm.bots.length)+" / "+_vm._s(_vm.$tc('chatbots', _vm.$store.state._User.bots.length, { count: _vm.$store.state._User.bots.length }))+"\n        ")],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"350px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('select')))+" "+_vm._s(_vm.$tc('chatbots', 2, { count: ' ' })))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"400px"}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.header,"items":_vm.$store.state._User.bots,"item-key":"USR_ID","select-all":"primary","hide-actions":"","total-items":_vm.$store.state._User.bots.length},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',[_c('th',[_c('v-checkbox',{attrs:{"color":"primary","hide-details":"","input-value":props.all || (_vm.botsTmp.length == _vm.bots.length),"indeterminate":props.indeterminate},nativeOn:{"click":function($event){return _vm.toggleAll($event)}}})],1),_vm._v(" "),_c('th',{staticClass:"text-xs-left"},[_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.header[0].text))])])])]}},{key:"items",fn:function(props){return [_c('td',[(_vm.withoutMe && (props.item.USR_ID == _vm.$store.state._User.id))?_c('v-checkbox',{attrs:{"color":"primary","hide-details":"","value":"","input-value":_vm.iAmChoosen}}):_c('v-checkbox',{attrs:{"color":"primary","hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_c('wz-avatar',{attrs:{"username":props.item.USR_FIRST_NAME  + ' ' + props.item.USR_LAST_NAME,"src":(_vm.domaine + "/media/user/small/" + (props.item.USR_ID) + "_avatar.jpg"),"size":"35px"}}),_vm._v(" "),_c('span',{staticClass:"ml-2"},[_vm._v("\n                  "+_vm._s(props.item.USR_FIRST_NAME + ' ' + props.item.USR_LAST_NAME)+"\n                ")]),_vm._v(" "),((props.item.USR_ID == _vm.$store.state._User.id))?_c('span',[_vm._v("\n                  ("+_vm._s(_vm.$t('me'))+")\n                ")]):_vm._e()],1)]}}]),model:{value:(_vm.botsTmp),callback:function ($$v) {_vm.botsTmp=$$v},expression:"botsTmp"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.cancel()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.botsTmp.length < _vm.min,"color":"primary"},on:{"click":function($event){_vm.submit()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1)}
var WzSelectBots_staticRenderFns = []
var WzSelectBots_esExports = { render: WzSelectBots_render, staticRenderFns: WzSelectBots_staticRenderFns }
/* harmony default export */ var watcheezy_WzSelectBots = (WzSelectBots_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzSelectBots.vue
var WzSelectBots_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzSelectBots___vue_template_functional__ = false
/* styles */
var WzSelectBots___vue_styles__ = null
/* scopeId */
var WzSelectBots___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzSelectBots___vue_module_identifier__ = null
var WzSelectBots_Component = WzSelectBots_normalizeComponent(
  WzSelectBots,
  watcheezy_WzSelectBots,
  WzSelectBots___vue_template_functional__,
  WzSelectBots___vue_styles__,
  WzSelectBots___vue_scopeId__,
  WzSelectBots___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzSelectBots = (WzSelectBots_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzSelectMotifs.vue




/* harmony default export */ var WzSelectMotifs = ({
  props: {
    motifs: {
      type: Array,
      required: true
    },

    motifsInit: {
      type: Array,
      required: true
    },

    min: {
      type: Number,
      default: 0
    }
  },

  data: function data() {
    return {
      domaine: constants_DOMAINE,

      motifsTmp: null,

      dialog: false
    };
  },
  created: function created() {
    this.motifsTmp = this.motifs;
  },


  computed: {
    header: function header() {
      return this.motifsTmp && !this.motifsTmp.length ? [{ text: lodash_default.a.upperFirst(this.$t('selectnone')), align: 'left', sortable: false }] : [{ text: lodash_default.a.upperFirst(this.$tc('selectall', 1)), align: 'left', sortable: false }];
    }
  },

  methods: {
    open: function open() {
      this.motifsTmp = this.motifs;
      this.dialog = true;
    },
    submit: function submit() {
      this.$emit('update:motifs', this.motifsTmp);
      this.dialog = false;
    },
    cancel: function cancel() {
      this.dialog = false;
    },
    toggleAll: function toggleAll() {
      if (this.motifsTmp.length) this.motifsTmp = [];else this.motifsTmp = this.motifsInit.slice();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4362bece","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzSelectMotifs.vue
var WzSelectMotifs_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{class:{'ml-5': _vm.$vuetify.breakpoint.mdAndUp},attrs:{"xs12":"","pt-2":""}},[_c('v-btn',{staticClass:"ml-0",attrs:{"color":"primary","outline":"","block":_vm.$vuetify.breakpoint.smAndDown},on:{"click":function($event){_vm.open()}}},[_c('v-icon',{attrs:{"left":"","color":"primary"}},[_vm._v("contact_support")]),_vm._v("\n          "+_vm._s(_vm.motifs.length)+" / "+_vm._s(_vm.$tc('motifs', _vm.$store.state._Sites.sites[0].motifs.length, { count: _vm.$store.state._Sites.sites[0].motifs.length }))+"\n        ")],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"scrollable":"","persistent":"","max-width":"350px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text"},[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('select')))+" "+_vm._s(_vm.$tc('motifs', 2, { count: ' ' })))])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"400px"}},[_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.header,"items":_vm.motifsInit,"item-key":"MOT_ID","select-all":"primary","hide-actions":"","total-items":_vm.motifsInit.length},scopedSlots:_vm._u([{key:"headers",fn:function(props){return [_c('tr',[_c('th',[_c('v-checkbox',{attrs:{"color":"primary","hide-details":"","input-value":props.all || (_vm.motifsTmp.length == _vm.motifs.length),"indeterminate":props.indeterminate},nativeOn:{"click":function($event){return _vm.toggleAll($event)}}})],1),_vm._v(" "),_c('th',{staticClass:"text-xs-left"},[_c('span',{staticClass:"subheading"},[_vm._v(_vm._s(_vm.header[0].text))])])])]}},{key:"items",fn:function(props){return [_c('td',[(props.item.MOT_ID == _vm.motifsInit.MOT_ID)?_c('v-checkbox',{attrs:{"color":"primary","hide-details":"","value":"","input-value":_vm.iAmChoosen}}):_c('v-checkbox',{attrs:{"color":"primary","hide-details":""},model:{value:(props.selected),callback:function ($$v) {_vm.$set(props, "selected", $$v)},expression:"props.selected"}})],1),_vm._v(" "),_c('td',[_c('span',{staticClass:"ml-2"},[_vm._v("\n                  "+_vm._s(props.item.MOT_LABEL)+"\n                ")])])]}}]),model:{value:(_vm.motifsTmp),callback:function ($$v) {_vm.motifsTmp=$$v},expression:"motifsTmp"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.cancel()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"disabled":_vm.motifsTmp.length < _vm.min,"color":"primary"},on:{"click":function($event){_vm.submit()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1)],1)],1)],1)}
var WzSelectMotifs_staticRenderFns = []
var WzSelectMotifs_esExports = { render: WzSelectMotifs_render, staticRenderFns: WzSelectMotifs_staticRenderFns }
/* harmony default export */ var watcheezy_WzSelectMotifs = (WzSelectMotifs_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzSelectMotifs.vue
var WzSelectMotifs_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzSelectMotifs___vue_template_functional__ = false
/* styles */
var WzSelectMotifs___vue_styles__ = null
/* scopeId */
var WzSelectMotifs___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzSelectMotifs___vue_module_identifier__ = null
var WzSelectMotifs_Component = WzSelectMotifs_normalizeComponent(
  WzSelectMotifs,
  watcheezy_WzSelectMotifs,
  WzSelectMotifs___vue_template_functional__,
  WzSelectMotifs___vue_styles__,
  WzSelectMotifs___vue_scopeId__,
  WzSelectMotifs___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzSelectMotifs = (WzSelectMotifs_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzSelectOneAgent.vue




/* harmony default export */ var WzSelectOneAgent = ({
  props: {
    agent: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },

    withoutMe: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      domaine: constants_DOMAINE,
      agentTmp: null,
      colleagues: []
    };
  },
  created: function created() {
    var _this = this;

    if (this.withoutMe) {
      this.colleagues = this.$store.state._User.colleagues.filter(function (colleague) {
        return colleague.USR_ID !== _this.$store.state._User.id;
      });
      this.agentTmp = this.colleagues[0];
    } else {
      this.colleagues = lodash_default.a.cloneDeep(this.$store.state._User.colleagues);
      this.agentTmp = lodash_default.a.find(this.colleagues, {
        USR_ID: this.$store.state._User.id
      });
    }
    this.$emit('update:agent', this.agentTmp);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-64b01bc8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzSelectOneAgent.vue
var WzSelectOneAgent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"dense":"","label":_vm._f("cap")(_vm.$t('select') + ' ' + _vm.$tc('agents', 1, {count: ''})),"items":_vm.colleagues,"item-value":"USR_ID","return-object":"","prepend-icon":"perm_identity","disabled":_vm.disabled,"persistent-hint":_vm.hint.trim().length > 0,"hint":_vm.hint},on:{"input":function($event){_vm.$emit('update:agent', _vm.agentTmp)}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [_c('v-chip',{attrs:{"small":""}},[_c('wz-avatar',{attrs:{"size":"28px","src":(_vm.domaine + "/media/user/small/" + (data.item.USR_ID) + "_avatar.jpg"),"username":data.item.USR_FIRST_NAME + ' ' + data.item.USR_LAST_NAME}}),_vm._v("\n        "+_vm._s(data.item.USR_FIRST_NAME)+" "+_vm._s(data.item.USR_LAST_NAME)+"\n        "),(data.item.USR_ID == _vm.$store.state._User.id)?_c('span',{staticClass:"ml-1"},[_vm._v("("+_vm._s(_vm.$t('me'))+")")]):_vm._e()],1)]}},{key:"item",fn:function(data){return [_c('wz-avatar',{attrs:{"size":"28px","src":(_vm.domaine + "/media/user/small/" + (data.item.USR_ID) + "_avatar.jpg"),"username":data.item.USR_FIRST_NAME + ' ' + data.item.USR_LAST_NAME}}),_vm._v(" "),_c('div',{staticClass:"input-group__selections__comma"},[_vm._v("\n        "+_vm._s(data.item.USR_FIRST_NAME)+" "+_vm._s(data.item.USR_LAST_NAME)+"\n        "),(data.item.USR_ID == _vm.$store.state._User.id)?_c('span',{staticClass:"ml-1"},[_vm._v("("+_vm._s(_vm.$t('me'))+")")]):_vm._e()])]}}]),model:{value:(_vm.agentTmp),callback:function ($$v) {_vm.agentTmp=$$v},expression:"agentTmp"}})}
var WzSelectOneAgent_staticRenderFns = []
var WzSelectOneAgent_esExports = { render: WzSelectOneAgent_render, staticRenderFns: WzSelectOneAgent_staticRenderFns }
/* harmony default export */ var watcheezy_WzSelectOneAgent = (WzSelectOneAgent_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzSelectOneAgent.vue
var WzSelectOneAgent_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzSelectOneAgent___vue_template_functional__ = false
/* styles */
var WzSelectOneAgent___vue_styles__ = null
/* scopeId */
var WzSelectOneAgent___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzSelectOneAgent___vue_module_identifier__ = null
var WzSelectOneAgent_Component = WzSelectOneAgent_normalizeComponent(
  WzSelectOneAgent,
  watcheezy_WzSelectOneAgent,
  WzSelectOneAgent___vue_template_functional__,
  WzSelectOneAgent___vue_styles__,
  WzSelectOneAgent___vue_scopeId__,
  WzSelectOneAgent___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzSelectOneAgent = (WzSelectOneAgent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzSelectOneSite.vue



/* harmony default export */ var WzSelectOneSite = ({
  data: function data() {
    return {
      site: null
    };
  },
  created: function created() {
    this.site = lodash_default.a.clone(this.$store.state._Sites.siteSelected);
  },


  methods: {
    updateSite: function updateSite() {
      this.$store.commit('_Sites/UPDATE_SITE_SELECTED', this.site);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d12e1cfc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzSelectOneSite.vue
var WzSelectOneSite_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-select',{attrs:{"dense":"","items":_vm.$store.state._Sites.sites,"item-text":"LIC_URL","item-value":"LIC_ID","label":_vm._f("cap")(_vm.$t('select') + ' ' + _vm.$tc('sites', 1, {count: ''})),"return-object":"","prepend-icon":"language"},on:{"input":function($event){_vm.updateSite()}},model:{value:(_vm.site),callback:function ($$v) {_vm.site=$$v},expression:"site"}})}
var WzSelectOneSite_staticRenderFns = []
var WzSelectOneSite_esExports = { render: WzSelectOneSite_render, staticRenderFns: WzSelectOneSite_staticRenderFns }
/* harmony default export */ var watcheezy_WzSelectOneSite = (WzSelectOneSite_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzSelectOneSite.vue
var WzSelectOneSite_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzSelectOneSite___vue_template_functional__ = false
/* styles */
var WzSelectOneSite___vue_styles__ = null
/* scopeId */
var WzSelectOneSite___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzSelectOneSite___vue_module_identifier__ = null
var WzSelectOneSite_Component = WzSelectOneSite_normalizeComponent(
  WzSelectOneSite,
  watcheezy_WzSelectOneSite,
  WzSelectOneSite___vue_template_functional__,
  WzSelectOneSite___vue_styles__,
  WzSelectOneSite___vue_scopeId__,
  WzSelectOneSite___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzSelectOneSite = (WzSelectOneSite_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzSelectGender.vue



var clients = [{
  key: '',
  mister: 'M',
  miss: 'Mme'
}, {
  key: 'inoya',
  mister: 'Mr.',
  miss: 'Mme.'
}, {
  key: 'nuxe',
  mister: 'Mr.',
  miss: 'Mrs'
}, {
  key: 'sisley',
  mister: 'Mr',
  miss: 'Mme'
}];

/* harmony default export */ var WzSelectGender = ({
  name: 'WzSelectGender',

  props: {
    gender: {
      required: true,
      validator: function validator(value) {
        return value ? value.toLowerCase() === 'm' || value.toLowerCase() === 'mme' || value.toLowerCase() === 'mr.' || value.toLowerCase() === 'mme.' || value.toLowerCase() === 'mrs' || value.toLowerCase() === 'mr' || value === '' : true;
      }
    },
    client: {
      type: String,
      required: false
    }
  },

  data: function data() {
    return {
      genderModel: '',
      clientModel: {}
    };
  },
  created: function created() {
    var _this = this;

    var clientFound = clients.find(function (c) {
      return c.key === _this.client;
    });
    if (clientFound) {
      this.clientModel = assign_default()({}, clientFound);
    } else {
      this.clientModel = assign_default()({}, clients[0]);
    }
    this.genderModel = this.gender;
  },


  methods: {
    updateGender: function updateGender(e) {
      this.genderModel = this.genderModel || '';
      this.$emit('update:gender', this.genderModel);
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-233f838d","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzSelectGender.vue
var WzSelectGender_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"mb-2",attrs:{"row":""}},[_c('v-icon',[_vm._v("wc")]),_vm._v(" "),_c('v-btn-toggle',{staticClass:"ml-3",on:{"change":function($event){_vm.updateGender()}},model:{value:(_vm.genderModel),callback:function ($$v) {_vm.genderModel=$$v},expression:"genderModel"}},[_c('v-btn',{attrs:{"flat":"","value":_vm.clientModel.mister}},[_c('span',[_vm._v(_vm._s(_vm.$t('mister')))])]),_vm._v(" "),_c('v-btn',{attrs:{"flat":"","value":_vm.clientModel.miss}},[_c('span',[_vm._v(_vm._s(_vm.$t('miss')))])])],1)],1)}
var WzSelectGender_staticRenderFns = []
var WzSelectGender_esExports = { render: WzSelectGender_render, staticRenderFns: WzSelectGender_staticRenderFns }
/* harmony default export */ var watcheezy_WzSelectGender = (WzSelectGender_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzSelectGender.vue
var WzSelectGender_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzSelectGender___vue_template_functional__ = false
/* styles */
var WzSelectGender___vue_styles__ = null
/* scopeId */
var WzSelectGender___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzSelectGender___vue_module_identifier__ = null
var WzSelectGender_Component = WzSelectGender_normalizeComponent(
  WzSelectGender,
  watcheezy_WzSelectGender,
  WzSelectGender___vue_template_functional__,
  WzSelectGender___vue_styles__,
  WzSelectGender___vue_scopeId__,
  WzSelectGender___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzSelectGender = (WzSelectGender_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzRating.vue


/* harmony default export */ var WzRating = ({

  name: 'wz-rating',

  props: {
    max: {
      type: Number,
      required: true
    },
    rate: {
      type: Number,
      required: true
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25002fb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzRating.vue
var WzRating_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.rate),function(a,key){return _c('v-icon',{key:a},[_vm._v("star")])}),_vm._v(" "),_vm._l(((_vm.max - _vm.rate)),function(i,key){return _c('v-icon',{key:(i + "-" + _vm.max)},[_vm._v("star_border")])})],2)}
var WzRating_staticRenderFns = []
var WzRating_esExports = { render: WzRating_render, staticRenderFns: WzRating_staticRenderFns }
/* harmony default export */ var watcheezy_WzRating = (WzRating_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzRating.vue
var WzRating_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzRating___vue_template_functional__ = false
/* styles */
var WzRating___vue_styles__ = null
/* scopeId */
var WzRating___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzRating___vue_module_identifier__ = null
var WzRating_Component = WzRating_normalizeComponent(
  WzRating,
  watcheezy_WzRating,
  WzRating___vue_template_functional__,
  WzRating___vue_styles__,
  WzRating___vue_scopeId__,
  WzRating___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzRating = (WzRating_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzHelp.vue




/* harmony default export */ var WzHelp = ({
  name: 'help',
  props: {
    opened: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      description: '',
      lexique: '',
      video: '',
      videoposter: '',
      subject: '',
      message: '',
      currentRoute: '',
      loadingMail: false,
      loadingHelp: false,
      emailSupportSend: false,
      youtube: 0
    };
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_User', ['fullName', 'domain', 'mailContact']), Object(vuex_esm["c" /* mapGetters */])('_User', ['fullName']), Object(vuex_esm["e" /* mapState */])('_Sites', ['siteSelected'])),
  methods: {
    getHelp: function getHelp(r) {
      var _this = this;

      this.loadingHelp = true;
      this.axios.get('get/help.php?route=' + encodeURI(r) + '&lang=' + this.$i18n.locale).then(function (res) {
        _this.description = res.data.description;
        _this.lexique = res.data.lexique;
        _this.video = res.data.video;
        _this.videoposter = res.data.videoposter;
        _this.youtube = res.data.youtube;
      }).catch(function (err) {
        console.log(err);
      }).then(function () {
        _this.loadingHelp = false;
      });
    },
    send: function send() {
      var _this2 = this;

      if (!this.message.trim().length) {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$tc('messages', 0),
          context: 'warning'
        });
        return;
      }
      var dataToPost = new window.FormData();
      dataToPost.append('to', 'support@targetfirst.com');
      dataToPost.append('ReplyTo', this.mailContact);
      dataToPost.append('fullName', this.fullName);
      dataToPost.append('siteSelected', this.siteSelected.LIC_URL);
      dataToPost.append('subject', this.subject);
      dataToPost.append('title', 'Demande de support');
      dataToPost.append('message', this.message);
      dataToPost.append('url', this.$route.fullPath);
      this.loadingMail = true;
      this.axios.post('post/email_support.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (res) {
        _this2.emailSupportSend = true;
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this2.$t('emailSent'),
          context: 'success'
        });
      }).catch(function () {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this2.$t('emailFailure'),
          context: 'error'
        });
      }).then(function () {
        _this2.loadingMail = false;
      });
    }
  },
  watch: {
    opened: function opened(v) {
      if (v && this.currentRoute !== this.$route.fullPath) {
        this.emailSupportSend = false;
        this.subject = '';
        this.message = '';
        this.currentRoute = this.$route.fullPath;
        this.getHelp(this.$route.fullPath);
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c328109","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzHelp.vue
var WzHelp_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grey lighten-2",staticStyle:{"min-height":"100%"}},[_c('v-container',{attrs:{"grid-list-lg":""}},[_c('div',{staticClass:"text-xs-right"},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.$emit('update:opened', false)}}},[_c('v-icon',[_vm._v("close")])],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.description || _vm.loadingHelp)?_c('v-flex',{attrs:{"xs12":""}},[(!_vm.loadingHelp)?_c('v-card',{staticClass:"grey--text text--darken-3",attrs:{"color":"white","flat":""}},[_c('v-card-title',{attrs:{"primary-title":""}},[_c('div',{staticClass:"Medium"},[_c('v-icon',{attrs:{"large":""}},[_vm._v("description")]),_vm._v("\n                Presentation\n              ")],1),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.description)}},[_vm._v(_vm._s(_vm.description)+"\n              ")])],1),_vm._v(" "),_c('v-expansion-panel',[(_vm.lexique)?_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('lexique')))]),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-3",domProps:{"innerHTML":_vm._s(_vm.lexique)}},[_vm._v(_vm._s(_vm.lexique))])],1)],1):_vm._e(),_vm._v(" "),(_vm.video)?_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("Video")]),_vm._v(" "),_c('v-card',[(_vm.youtube===0)?_c('v-card-text',{staticClass:"grey lighten-3"},[_c('video',{staticStyle:{"width":"260px","height":"auto","left":"0px","top":"0px"},attrs:{"controls":"","alt":"presentation","src":_vm.video,"poster":_vm.videoposter,"playsinline":""}})]):_c('v-card-text',{staticClass:"grey lighten-3"},[_c('iframe',{staticStyle:{"width":"260px","height":"auto","left":"0px","top":"0px"},attrs:{"src":_vm.video,"poster":_vm.videoposter,"width":"260","frameborder":"0","allowfullscreen":"allowfullscreen"}})])],1)],1):_vm._e()],1)],1):_c('v-card',[_c('v-card-text',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":50,"width":1}})],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"grey--text text--darken-3",attrs:{"color":"white","flat":""}},[_c('v-card-title',[_c('div',{staticClass:"Medium"},[_c('v-icon',{attrs:{"large":""}},[_vm._v("book")]),_vm._v(" \n                "+_vm._s(_vm.$t('knowledgeBase'))+"\n              ")],1),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":'https://support.targetfirst.com',"target":"_blank"}},[_vm._v("\n                  "+_vm._s(_vm.$t('ourKnowledgeBase'))+"\n                ")])])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-card',{staticClass:"grey--text text--darken-3",attrs:{"color":"white","flat":""}},[_c('v-card-title',[_c('div',{staticClass:"Medium"},[_c('v-icon',{attrs:{"large":""}},[_vm._v("school")]),_vm._v("\n                Webinar\n              ")],1),_vm._v(" "),_c('div',[_c('a',{attrs:{"href":'https://www.targetfirst.com/prenez-rendez-vous-prise-en-main/',"target":"_blank"}},[_vm._v("\n                  "+_vm._s(_vm.$t('signUpWebinar'))+"\n                ")])])])],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.emailSupportSend == true )?_c('v-card',{staticClass:"grey--text text--darken-3",attrs:{"color":"white","flat":""}},[_c('v-card-title',[_c('div',{staticClass:"Medium"},[_c('v-icon',{attrs:{"large":""}},[_vm._v("mail_outline")]),_vm._v("\n              "+_vm._s(_vm.$t('contactTheSupport'))+"\n            ")],1)]),_vm._v(" "),_c('v-card-text',{staticClass:"grey lighten-3"},[_vm._v(_vm._s(_vm.$t('emailSent')))])],1):_vm._e(),_vm._v(" "),(_vm.emailSupportSend == false)?_c('v-card',{staticClass:"grey--text text--darken-3",attrs:{"color":"white","flat":""}},[_c('v-card-title',[_c('div',{staticClass:"Medium"},[_c('v-icon',{attrs:{"large":""}},[_vm._v("mail_outline")]),_vm._v("\n              "+_vm._s(_vm.$t('contactTheSupport'))+"\n            ")],1)]),_vm._v(" "),_c('v-form',[_c('v-card-text',[_c('v-text-field',{attrs:{"label":_vm._f("cap")(_vm.$t('subject'))},model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=$$v},expression:"subject"}}),_vm._v(" "),_c('v-textarea',{attrs:{"label":_vm._f("cap")(_vm.$t('typeYourMessage')),"required":""},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"block":"","color":"primary","loading":_vm.loadingMail},on:{"click":function($event){_vm.send()}}},[_vm._v("\n                  "+_vm._s(_vm.$t('send'))+"\n                  "),_c('v-icon',{attrs:{"right":""}},[_vm._v("send")])],1)],1)],1)],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}})],1)],1)],1)}
var WzHelp_staticRenderFns = []
var WzHelp_esExports = { render: WzHelp_render, staticRenderFns: WzHelp_staticRenderFns }
/* harmony default export */ var watcheezy_WzHelp = (WzHelp_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzHelp.vue
function WzHelp_injectStyle (ssrContext) {
  __webpack_require__("Em0s")
}
var WzHelp_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzHelp___vue_template_functional__ = false
/* styles */
var WzHelp___vue_styles__ = WzHelp_injectStyle
/* scopeId */
var WzHelp___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzHelp___vue_module_identifier__ = null
var WzHelp_Component = WzHelp_normalizeComponent(
  WzHelp,
  watcheezy_WzHelp,
  WzHelp___vue_template_functional__,
  WzHelp___vue_styles__,
  WzHelp___vue_scopeId__,
  WzHelp___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzHelp = (WzHelp_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzSatisfactionAgent.vue





/* harmony default export */ var WzSatisfactionAgent = ({
  props: {
    opened: {
      type: Boolean,
      required: true
    }
  },
  data: function data() {
    return {
      surveyId: 0,

      step: 0,

      satisfaction: null,

      version: null,

      details: '',

      stopDisplaySurvey: false
    };
  },


  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_User', ['id'])),

  mounted: function mounted() {
    var _this = this;

    setTimeout(function () {
      _this.getSurvey().then(function (res) {
        _this.surveyId = res.data.SURVEY_ID;
        _this.satisfaction = res.data.SURVEY_SATISFACTION;
        _this.version = res.data.SURVEY_VERSION_PREF;
        _this.details = res.data.SURVEY_DETAILS;
        _this.stopDisplaySurvey = res.data.SURVEY_STOP || true;
        if (!_this.stopDisplaySurvey) {
          _this.$emit('update:opened', true);
        }
      });
    }, 1000 * 60 * 2);
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('_Notifier', ['NEW_NOTIF']), {
    cancel: function cancel() {
      this.saveSurvey();
      this.$emit('update:opened', false);
    },
    submit: function submit() {
      var _this2 = this;

      this.$emit('update:opened', false);
      this.stopDisplaySurvey = true;
      this.saveSurvey().then(function () {
        _this2.NEW_NOTIF({
          message: _this2.$t('thanksParticipation'),
          context: 'success'
        });
      });
    },
    previousStep: function previousStep() {
      this.step--;
    },
    nextStep: function nextStep() {
      var _this3 = this;

      this.step++;
      this.saveSurvey().then(function (res) {
        _this3.surveyId = res.data.id;
      });
    },
    getSurvey: function getSurvey() {
      var _this4 = this;

      return new promise_default.a(function (resolve, reject) {
        _this4.axios.get('get/satisfaction_agent.php?id=' + _this4.id).then(function (res) {
          resolve(res);
        }).catch(function (e) {
          reject(e);
        });
      });
    },
    saveSurvey: function saveSurvey() {
      var _this5 = this;

      var dataToPost = new window.FormData();
      dataToPost.append('id', this.surveyId);
      dataToPost.append('userId', this.id);
      dataToPost.append('satisfaction', this.satisfaction);
      dataToPost.append('version', this.version);
      dataToPost.append('details', this.details);
      dataToPost.append('stopDisplaySurvey', this.stopDisplaySurvey);
      var method = this.surveyId ? 'put' : 'post';
      return new promise_default.a(function (resolve, reject) {
        _this5.axios.post(method + '/satisfaction_agent.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        }).then(function (res) {
          resolve(res);
        }).catch(function (e) {
          reject(e);
        });
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3c037e19","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzSatisfactionAgent.vue
var WzSatisfactionAgent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height"},[_c('v-layout',{attrs:{"row":""}},[_c('v-flex',{staticClass:"xs10"},[_c('div',{staticClass:"title mt-3 pl-2"},[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('titleSatisfactionSurvey'))))])]),_vm._v(" "),_c('v-flex',{staticClass:"xs2"},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.cancel()}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1),_vm._v(" "),_c('v-stepper',{attrs:{"vertical":""},model:{value:(_vm.step),callback:function ($$v) {_vm.step=$$v},expression:"step"}},[_c('v-stepper-step',{attrs:{"step":"1","complete":_vm.step > 1}},[_vm._v(_vm._s(_vm.$t('titleAgentSatisfaction1')))]),_vm._v(" "),_c('v-stepper-content',{staticClass:"pa-2",attrs:{"step":"1"}},[_c('v-card',{attrs:{"flat":"","height":"300px"}},[_c('v-subheader',{staticClass:"mt-1"},[_vm._v("\n            "+_vm._s(_vm.$t('questionAgentSatisfaction1'))+"\n          ")]),_vm._v(" "),_c('v-radio-group',{model:{value:(_vm.satisfaction),callback:function ($$v) {_vm.satisfaction=$$v},expression:"satisfaction"}},[_c('v-layout',[_c('v-icon',[_vm._v("mood")]),_vm._v(" "),_c('v-radio',{attrs:{"color":"primary","value":5,"label":_vm.$t('verySatisfying')}})],1),_vm._v(" "),_c('v-layout',[_c('v-icon',[_vm._v("sentiment_satisfied")]),_vm._v(" "),_c('v-radio',{attrs:{"color":"primary","value":4,"label":_vm.$t('satisfying')}})],1),_vm._v(" "),_c('v-layout',[_c('v-icon',[_vm._v("sentiment_neutral")]),_vm._v(" "),_c('v-radio',{attrs:{"color":"primary","value":3,"label":_vm.$t('sentimentNeutral')}})],1),_vm._v(" "),_c('v-layout',[_c('v-icon',[_vm._v("sentiment_dissatisfied")]),_vm._v(" "),_c('v-radio',{attrs:{"color":"primary","value":2,"label":_vm.$t('ratherUnsatisfying')}})],1),_vm._v(" "),_c('v-layout',[_c('v-icon',[_vm._v("mood_bad")]),_vm._v(" "),_c('v-radio',{attrs:{"color":"primary","value":1,"label":_vm.$t('veryUnsatisfying')}})],1)],1)],1),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":!_vm.satisfaction},on:{"click":function($event){_vm.nextStep()}}},[_vm._v(_vm._s(_vm.$t('next')))])],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"2","complete":_vm.step > 2}},[_vm._v(_vm._s(_vm.$t('titleAgentSatisfaction2')))]),_vm._v(" "),_c('v-stepper-content',{staticClass:"pa-2",attrs:{"step":"2"}},[_c('v-card',{attrs:{"flat":"","height":"300px"}},[_c('v-subheader',{staticClass:"mt-1"},[_vm._v("\n            "+_vm._s(_vm.$t('questionAgentSatisfaction2') + ' ' + _vm.$t('iPrefer'))+"\n          ")]),_vm._v(" "),_c('v-radio-group',{model:{value:(_vm.version),callback:function ($$v) {_vm.version=$$v},expression:"version"}},_vm._l((6),function(i){return _c('v-radio',{key:i,attrs:{"color":"primary","value":6 - i + 1,"label":_vm.$t('version' + (6 - i))}})}),1)],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.previousStep()}}},[_vm._v(_vm._s(_vm.$t('previous')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.version == null},on:{"click":function($event){_vm.nextStep()}}},[_vm._v(_vm._s(_vm.$t('next')))])],1),_vm._v(" "),_c('v-stepper-step',{attrs:{"step":"3"}},[_vm._v(_vm._s(_vm.$t('titleAgentSatisfaction3')))]),_vm._v(" "),_c('v-stepper-content',{staticClass:"pa-2",attrs:{"step":"3"}},[_c('v-card',{attrs:{"flat":"","height":"300px"}},[_c('v-subheader',{staticClass:"mt-1"},[_vm._v("\n            "+_vm._s(_vm.$t('questionAgentSatisfaction3'))+"\n          ")]),_vm._v(" "),_c('v-text-field',{staticClass:"textarea-satisfaction",attrs:{"label":_vm.$t('scenarioComment'),"multi-line":"","single-line":""},model:{value:(_vm.details),callback:function ($$v) {_vm.details=$$v},expression:"details"}})],1),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.previousStep()}}},[_vm._v(_vm._s(_vm.$t('previous')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.submit()}}},[_vm._v(_vm._s(_vm.$t('submit'))),_c('v-icon',{attrs:{"right":""}},[_vm._v("send")])],1)],1)],1),_vm._v(" "),_c('v-footer',{staticClass:"white",attrs:{"absolute":""}},[_c('v-layout',{staticClass:"row"},[_c('v-flex',{staticClass:"xs1"},[_c('v-checkbox',{attrs:{"color":"primary"},model:{value:(_vm.stopDisplaySurvey),callback:function ($$v) {_vm.stopDisplaySurvey=$$v},expression:"stopDisplaySurvey"}})],1),_vm._v(" "),_c('v-flex',{staticClass:"xs11"},[_c('small',[_vm._v("Ne plus me proposer le questionnaire")])])],1)],1)],1)}
var WzSatisfactionAgent_staticRenderFns = []
var WzSatisfactionAgent_esExports = { render: WzSatisfactionAgent_render, staticRenderFns: WzSatisfactionAgent_staticRenderFns }
/* harmony default export */ var watcheezy_WzSatisfactionAgent = (WzSatisfactionAgent_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzSatisfactionAgent.vue
function WzSatisfactionAgent_injectStyle (ssrContext) {
  __webpack_require__("CyYx")
}
var WzSatisfactionAgent_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzSatisfactionAgent___vue_template_functional__ = false
/* styles */
var WzSatisfactionAgent___vue_styles__ = WzSatisfactionAgent_injectStyle
/* scopeId */
var WzSatisfactionAgent___vue_scopeId__ = "data-v-3c037e19"
/* moduleIdentifier (server only) */
var WzSatisfactionAgent___vue_module_identifier__ = null
var WzSatisfactionAgent_Component = WzSatisfactionAgent_normalizeComponent(
  WzSatisfactionAgent,
  watcheezy_WzSatisfactionAgent,
  WzSatisfactionAgent___vue_template_functional__,
  WzSatisfactionAgent___vue_styles__,
  WzSatisfactionAgent___vue_scopeId__,
  WzSatisfactionAgent___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzSatisfactionAgent = (WzSatisfactionAgent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzNotifier.vue




/* harmony default export */ var WzNotifier = ({
  data: function data() {
    return {
      showSnackBar: false
    };
  },


  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_Notifier', ['notifications', 'show']), Object(vuex_esm["c" /* mapGetters */])('_Notifier', ['index'])),

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('_Notifier', ['HIDE_NOTIF', 'OPEN_NOTIF']), Object(vuex_esm["d" /* mapMutations */])('_Notifier', ['SHOW']), {
    actionNotification: function actionNotification() {
      this.showSnackBar = false;
      this.OPEN_NOTIF(this.index);
    },
    fermeSnackBar: function fermeSnackBar() {
      this.showSnackBar = false;
    }
  }),

  watch: {
    showSnackBar: function showSnackBar(v) {
      if (v) {
        this.SHOW();
      } else {
        this.HIDE_NOTIF();
      }
    },
    show: function show(v) {
      if (v) {
        this.showSnackBar = v;
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-91a9e220","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzNotifier.vue
var WzNotifier_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.index != -1)?_c('v-snackbar',{staticStyle:{"z-index":"9999 !important"},attrs:{"top":(_vm.notifications[_vm.index] && _vm.notifications[_vm.index].position == 'top'),"bottom":(_vm.notifications[_vm.index] && !_vm.notifications[_vm.index].position),"right":(_vm.notifications[_vm.index] && (!_vm.notifications[_vm.index].position || _vm.notifications[_vm.index].position == 'bottom')) ? 'right' : false,"multi-line":(_vm.notifications[_vm.index] && _vm.notifications[_vm.index].multiLine) ? _vm.notifications[_vm.index].multiLine : false,"timeout":(_vm.notifications[_vm.index] && _vm.notifications[_vm.index].timeout) ? _vm.notifications[_vm.index].timeout : 6000,"color":(_vm.notifications[_vm.index] && _vm.notifications[_vm.index].color) ? _vm.notifications[_vm.index].color : 'black'},model:{value:(_vm.showSnackBar),callback:function ($$v) {_vm.showSnackBar=$$v},expression:"showSnackBar"}},[_vm._v("\n      "+_vm._s(_vm.notifications[_vm.index] ? _vm.notifications[_vm.index].message : '')+"\n      "),(_vm.index != -1 && _vm.notifications[_vm.index].color && !_vm.notifications[_vm.index].type == 'collections')?_c('v-btn',{attrs:{"flat":"","white--text":""},on:{"click":function($event){_vm.actionNotification()}}},[_vm._v("\n        "+_vm._s(_vm.notifications[_vm.index] ? _vm.notifications[_vm.index].action.text : '')+"\n        "),(_vm.index != -1)?_c('span',[(_vm.notifications[_vm.index].context == 'success')?_c('v-icon',{attrs:{"color":"white","right":""}},[_vm._v("check_circle")]):(_vm.notifications[_vm.index].context == 'info')?_c('v-icon',{attrs:{"color":"white","right":""}},[_vm._v("info")]):(_vm.notifications[_vm.index].context == 'warning')?_c('v-icon',{attrs:{"color":"white","right":""}},[_vm._v("warning")]):(_vm.notifications[_vm.index].context == 'error')?_c('v-icon',{attrs:{"color":"white","right":""}},[_vm._v("error")]):_vm._e()],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.index != -1 && _vm.notifications[_vm.index].color && _vm.notifications[_vm.index].type == 'collections')?_c('v-btn',{attrs:{"flat":"","white--text":""},on:{"click":function($event){_vm.fermeSnackBar()}}},[_vm._v("\n        "+_vm._s(_vm.notifications[_vm.index] ? _vm.notifications[_vm.index].action.text : '')+"\n        "),(_vm.index != -1)?_c('span',[(_vm.notifications[_vm.index].context == 'success')?_c('v-icon',{attrs:{"right":""}},[_vm._v("check_circle")]):(_vm.notifications[_vm.index].context == 'info')?_c('v-icon',{attrs:{"right":""}},[_vm._v("info")]):(_vm.notifications[_vm.index].context == 'warning')?_c('v-icon',{attrs:{"right":""}},[_vm._v("warning")]):(_vm.notifications[_vm.index].context == 'error')?_c('v-icon',{attrs:{"right":""}},[_vm._v("error")]):_vm._e()],1):_vm._e()]):_vm._e(),_vm._v(" "),(_vm.index != -1 && !_vm.notifications[_vm.index].color)?_c('v-btn',{class:_vm.notifications[_vm.index].context + '--text',attrs:{"flat":""},on:{"click":function($event){_vm.actionNotification()}}},[_vm._v("\n        "+_vm._s(_vm.notifications[_vm.index] ? _vm.notifications[_vm.index].action.text : '')+"\n        "),(_vm.index != -1)?_c('span',[(_vm.notifications[_vm.index].context == 'success')?_c('v-icon',{attrs:{"right":""}},[_vm._v("check_circle")]):(_vm.notifications[_vm.index].context == 'info')?_c('v-icon',{attrs:{"right":""}},[_vm._v("info")]):(_vm.notifications[_vm.index].context == 'warning')?_c('v-icon',{attrs:{"right":""}},[_vm._v("warning")]):(_vm.notifications[_vm.index].context == 'error')?_c('v-icon',{attrs:{"right":""}},[_vm._v("error")]):_vm._e()],1):_vm._e()]):_vm._e()],1):_vm._e()],1)}
var WzNotifier_staticRenderFns = []
var WzNotifier_esExports = { render: WzNotifier_render, staticRenderFns: WzNotifier_staticRenderFns }
/* harmony default export */ var watcheezy_WzNotifier = (WzNotifier_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzNotifier.vue
var WzNotifier_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzNotifier___vue_template_functional__ = false
/* styles */
var WzNotifier___vue_styles__ = null
/* scopeId */
var WzNotifier___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzNotifier___vue_module_identifier__ = null
var WzNotifier_Component = WzNotifier_normalizeComponent(
  WzNotifier,
  watcheezy_WzNotifier,
  WzNotifier___vue_template_functional__,
  WzNotifier___vue_styles__,
  WzNotifier___vue_scopeId__,
  WzNotifier___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzNotifier = (WzNotifier_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzDialog.vue





/* harmony default export */ var WzDialog = ({
  created: function created() {
    this.setDialog();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_Dialog', { dialog: 'GET' })),

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('_Dialog', { setDialog: 'SET_DIALOG' }), {
    cancel: function cancel() {
      this.setDialog({ action: 'cancel' });
    },
    submit: function submit() {
      this.setDialog({ action: 'submit' });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6023d564","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzDialog.vue
var WzDialog_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":_vm.dialog.persistent,"fullscreen":_vm.dialog.fullscreen,"max-width":_vm.dialog.maxWidth},model:{value:(_vm.dialog.value),callback:function ($$v) {_vm.$set(_vm.dialog, "value", $$v)},expression:"dialog.value"}},[_c('v-card',[(_vm.dialog.title)?_c('v-card-title',{staticClass:"primary white--text title"},[_vm._v("\n        "+_vm._s(_vm._f("cap")(_vm.dialog.title))+"\n      ")]):_vm._e(),_vm._v(" "),_c('v-card-text',[_vm._v("\n        "+_vm._s(_vm._f("cap")(_vm.dialog.text))+"\n      ")]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.dialog.info)?_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.cancel()}}},[_vm._v("OK")]):_c('div',[_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.cancel()}}},[_vm._v(_vm._s(_vm.$t(_vm.dialog.cancel)))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.submit()}}},[_vm._v(_vm._s(_vm.$t(_vm.dialog.submit)))])],1)],1)],1)],1)}
var WzDialog_staticRenderFns = []
var WzDialog_esExports = { render: WzDialog_render, staticRenderFns: WzDialog_staticRenderFns }
/* harmony default export */ var watcheezy_WzDialog = (WzDialog_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzDialog.vue
var WzDialog_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzDialog___vue_template_functional__ = false
/* styles */
var WzDialog___vue_styles__ = null
/* scopeId */
var WzDialog___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzDialog___vue_module_identifier__ = null
var WzDialog_Component = WzDialog_normalizeComponent(
  WzDialog,
  watcheezy_WzDialog,
  WzDialog___vue_template_functional__,
  WzDialog___vue_styles__,
  WzDialog___vue_scopeId__,
  WzDialog___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzDialog = (WzDialog_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzEditeurLead.vue









/* harmony default export */ var WzEditeurLead = ({
  props: {
    leadDialog: {
      type: Object,
      default: {}
    },
    custom_motifs: {
      type: Array,
      default: []
    },
    custom_champs: {
      type: Array,
      default: []
    },
    hideLead: {
      type: Boolean,
      default: false
    },
    showHisto: {
      type: Boolean,
      default: true
    },
    histoChat: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      loading: false,
      resFromAjax: null,
      currentTab: 0,
      tabs: [],
      nbLeads: 0,
      nbVisits: 0,
      nbCreations: 0,
      nbChats: 0,
      motif: null,

      leadsOfPeriod: true,

      onlyCreatedLeads: false,

      dialogEdit: false,
      dialogRemove: false,
      dateSendLead: 0,
      default_motif: [{ text: lodash_default.a.upperFirst(this.$t('support')), value: 'support' }, { text: lodash_default.a.upperFirst(this.$t('lead')), value: 'lead' }, { text: lodash_default.a.upperFirst(this.$tc('sales', 1, { count: '' })), value: 'sale' }, { text: lodash_default.a.upperFirst(this.$t('estimate')), value: 'devis' }, { text: lodash_default.a.upperFirst(this.$t('reservation')), value: 'resa' }, { text: lodash_default.a.upperFirst(this.$t('contact')), value: 'contact' }]
    };
  },


  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_User', ['brides']), {
    motifs: function motifs() {
      if (this.$store.state._User.entKey === '9c44184c124fda32ac19523ff93d2488') {
        return MOTIFS_ORPI;
      }

      if (this.$store.state._User.entKey === '9f1d52167b4128993ffa1c7b92207c4c') {
        return MOTIFS_NUXE;
      }

      if (this.$store.state._User.entKey === '8204159d47830f1c1cc7d3561544ced7') {
        return MOTIFS_INOYA;
      }

      var motifs = lodash_default.a.map(this.leadsDetails, 'motifs');
      motifs = lodash_default.a.filter(motifs, function (m) {
        return m.length;
      });
      var res = [];
      lodash_default.a.each(motifs, function (motif) {
        lodash_default.a.each(motif, function (m) {
          res.push(m);
        });
      });

      return lodash_default.a.uniq(res);
    },
    leadDialogChaleur: function leadDialogChaleur() {
      return this.chaleurLead(this.leadDialog);
    }
  }),

  mounted: function mounted() {
    if (this.showHisto) {
      if (this.hideLead) {
        this.tabs = [{ index: 1, name: this.$t('conversationHistory'), icone: 'question_answer' }];
      } else {
        this.tabs = [{ index: 0, name: this.$t('leadEditor'), icone: 'assignment' }, { index: 1, name: this.$t('conversationHistory'), icone: 'question_answer' }];
      }
    } else {
      this.tabs = [{ index: 0, name: this.$t('leadEditor'), icone: 'assignment' }];
    }

    console.log('this.leadDialog', this.leadDialog);
  },
  updated: function updated() {},


  methods: {
    brideMenu: function brideMenu(nameBride) {
      if (this.brides) {
        var index = this.brides.findIndex(function (bride) {
          return bride.brideName === nameBride;
        });

        if (index !== -1) {
          return this.brides[index].status;
        }
      }
    },
    changeMotif: function changeMotif(e) {
      this.leadDialog.motif = e;
    },
    cancelDialogEdit: function cancelDialogEdit() {
      this.$emit('closeDialog');
    },
    submitDialogEdit: function submitDialogEdit() {
      var _this = this;

      this.dialogEdit = false;

      var dataToPost = new window.FormData();
      dataToPost.append('session', this.leadDialog.id);
      var leadFormatted = lodash_default.a.cloneDeep(this.leadDialog);

      this.custom_champs.forEach(function (data) {
        leadFormatted[data.name] = data.value;
      });

      leadFormatted.site = leadFormatted.siteId;
      delete leadFormatted.siteId;

      delete leadFormatted.getquanty;

      if (leadFormatted.creation !== '') {
        leadFormatted.date = moment(leadFormatted.creation, 'L').format('X');
      }
      delete leadFormatted.creation;

      if (leadFormatted.last !== '') {
        leadFormatted.last = moment(leadFormatted.last, 'L').format('X');
      }

      delete leadFormatted.basket;
      delete leadFormatted.hasChatted;
      delete leadFormatted.hasBeenTarget;
      delete leadFormatted.motifs;
      delete leadFormatted.purchase;

      dataToPost.append('infos', stringify_default()(leadFormatted));
      this.axios.post('put/lead.php', dataToPost, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this.$emit('updateLead', _this.leadDialog);
        _this.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this.$t('modifSuccess'), context: 'success' });
      }).catch(function () {
        _this.$store.dispatch('_Notifier/NEW_NOTIF', { message: _this.$t('modifFailure'), context: 'error' });
      });
    },
    chaleurLead: function chaleurLead(lead) {
      var chaleur = 0;
      var details = {};
      var points = 0;

      points = lead.basket * 1;
      chaleur += points;
      details.basket = points;

      points = lead.hasChatted ? 10 : 0;
      chaleur += points;
      details.hasChatted = points;

      points = lead.hasBeenTarget ? 10 : 0;
      chaleur += points;
      details.hasBeenTarget = points;

      points = lodash_default.a.round(lead.duration / 60 / 5);
      chaleur += points;
      details.duration = points;

      points = !lodash_default.a.isEmpty(lead.email) ? 10 : 0;
      chaleur += points;
      details.email = points;

      points = !lodash_default.a.isEmpty(lead.tel) || !lodash_default.a.isEmpty(lead.C2C) ? 10 : 0;
      chaleur += points;
      details.tel = points;

      points = lead.purchase * 10;
      chaleur += points;
      details.purchase = points;
      return {
        chaleur: chaleur,
        details: details
      };
    }
  },

  watch: {},

  filters: {
    duration: function duration(v) {
      return moment["duration"](lodash_default.a.toNumber(v), 'seconds').format('h [h] mm [min] ss [s] ');
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7621ee36","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzEditeurLead.vue
var WzEditeurLead_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"conteneurLead",attrs:{"flat":"","id":"conteneurLead"}},[_c('v-card-title',{staticClass:"primary white--text",staticStyle:{"height":"52px","padding":"0px"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.cancelDialogEdit()}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('lead'))+" #"+_vm._s(_vm.leadDialog.id))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.$vuetify.breakpoint.smAndDown)?_c('v-btn',{staticClass:"white--text",attrs:{"flat":""},on:{"click":function($event){_vm.submitDialogEdit()}}},[_vm._v(_vm._s(_vm.$t('submit')))]):_vm._e()],1),_vm._v(" "),_c('v-tabs',{attrs:{"grow":"","centered":"","slider-color":"secondary"},model:{value:(_vm.currentTab),callback:function ($$v) {_vm.currentTab=$$v},expression:"currentTab"}},[_vm._l((_vm.tabs),function(tab){return _c('v-tab',{key:tab.index,staticClass:"primary--text"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v(_vm._s(tab.icone))]),_vm._v("\n        "+_vm._s(tab.name)+"\n      ")],1)}),_vm._v(" "),_c('v-tab-item',{key:'tab_fiche',staticStyle:{"overflow":"auto"}},[(_vm.loading)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_c('v-card-text',{style:(!_vm.$vuetify.breakpoint.smAndDown ? 'height: calc(100vh - 300px);' : '')},[_c('v-container',{staticClass:"conteneurFicheLead",attrs:{"fluid":"","grid-list-md":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","md5":""}},[_vm._l((_vm.leadDialog.motifs),function(motiff,i){return _c('v-chip',{key:i,attrs:{"label":"","color":"secondary","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(_vm._s(motiff)+"\n                ")],1)}),_vm._v(" "),(_vm.leadDialog.motif)?_c('v-chip',{attrs:{"label":"","color":"secondary","text-color":"white"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("label")]),_vm._v(_vm._s(_vm.leadDialog.motif)+"\n                ")],1):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":"","id":"selectMotifLead"}},[_c('v-select',{attrs:{"items":_vm.custom_motifs,"label":_vm.$tc('tags', 1, {count: ''}),"menu-props":"auto"},on:{"change":_vm.changeMotif}})],1)],1),_vm._v(" "),_c('wz-select-gender',{attrs:{"gender":_vm.leadDialog.gender},on:{"update:gender":function($event){_vm.$set(_vm.leadDialog, "gender", $event)}}}),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-text-field',{staticClass:"mr-1",attrs:{"label":_vm.$t('firstName'),"xs12":"","md6":""},model:{value:(_vm.leadDialog.fname),callback:function ($$v) {_vm.$set(_vm.leadDialog, "fname", $$v)},expression:"leadDialog.fname"}}),_vm._v(" "),_c('v-text-field',{staticClass:"ml-1",attrs:{"label":_vm.$t('lastName'),"xs12":"","md6":""},model:{value:(_vm.leadDialog.lname),callback:function ($$v) {_vm.$set(_vm.leadDialog, "lname", $$v)},expression:"leadDialog.lname"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-text-field',{directives:[{name:"validate",rawName:"v-validate",value:('required|email'),expression:"'required|email'"}],attrs:{"label":"Email","prepend-icon":"mail_outline","type":"email","data-vv-name":"email","error":_vm.wzErrors.has('email'),"error-messages":_vm.wzErrors.collect('email')},model:{value:(_vm.leadDialog.email),callback:function ($$v) {_vm.$set(_vm.leadDialog, "email", $$v)},expression:"leadDialog.email"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-text-field',{staticClass:"mr-1",attrs:{"prepend-icon":"phone","label":_vm.$t('phone'),"xs12":"","md6":""},model:{value:(_vm.leadDialog.tel),callback:function ($$v) {_vm.$set(_vm.leadDialog, "tel", $$v)},expression:"leadDialog.tel"}}),_vm._v(" "),_c('v-text-field',{staticClass:"ml-1",attrs:{"prepend-icon":"phone","label":_vm.$t('callback'),"xs12":"","md6":""},model:{value:(_vm.leadDialog.C2C),callback:function ($$v) {_vm.$set(_vm.leadDialog, "C2C", $$v)},expression:"leadDialog.C2C"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-text-field',{attrs:{"prepend-icon":"business","label":_vm.$t('company')},model:{value:(_vm.leadDialog.company),callback:function ($$v) {_vm.$set(_vm.leadDialog, "company", $$v)},expression:"leadDialog.company"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-text-field',{attrs:{"prepend-icon":"language","label":"URL"},model:{value:(_vm.leadDialog.url),callback:function ($$v) {_vm.$set(_vm.leadDialog, "url", $$v)},expression:"leadDialog.url"}})],1)],2),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-layout',{attrs:{"row":""}},[_c('v-text-field',{attrs:{"prepend-icon":"device_hub","label":_vm.$t('ipAddress'),"readonly":""},model:{value:(_vm.leadDialog.ip),callback:function ($$v) {_vm.$set(_vm.leadDialog, "ip", $$v)},expression:"leadDialog.ip"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-textarea',{attrs:{"prepend-icon":"help_outline","label":_vm.$t('leadQuestion'),"readonly":""},model:{value:(_vm.leadDialog.question),callback:function ($$v) {_vm.$set(_vm.leadDialog, "question", $$v)},expression:"leadDialog.question"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-textarea',{attrs:{"prepend-icon":"comment","label":_vm.$t('comment')},model:{value:(_vm.leadDialog.comment),callback:function ($$v) {_vm.$set(_vm.leadDialog, "comment", $$v)},expression:"leadDialog.comment"}})],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.custom_champs),function(item,i){return _c('v-text-field',{key:i,attrs:{"prepend-icon":"info","label":item.name},model:{value:(item.value),callback:function ($$v) {_vm.$set(item, "value", $$v)},expression:"item.value"}})}),1)],1)],1),_vm._v(" "),_c('v-divider',{staticClass:"my-3"}),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[(_vm.leadDialog.getquanty  && _vm.brideMenu('stats_leads_getquanty') === '1')?_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-expansion-panel',[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('img',{staticClass:"logo-company",attrs:{"src":"https://www.getquanty.com/wp-content/uploads/2016/10/Logo-GetQuanty-Petit.png"}})]),_vm._v(" "),_c('v-list',{staticClass:"grey lighten-5",attrs:{"two-line":"","dense":"","subheader":""}},_vm._l((_vm.leadDialog.getquanty),function(field,i){return _c('div',{key:i},[(field && field[1] && field[0] != 'partenaire')?_c('v-list-tile',{attrs:{"avatar":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(field[0] == 'telephone' ? 'phone'
                            : field[0] == 'raison sociale' ? 'business'
                            : field[0] == 'effectif' ? 'people'
                            : field[0] == 'adresse' ? 'location_on'
                            : ''))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(field[1]))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(field[0]))])],1)],1):_vm._e()],1)}))],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.leadDialogChaleur.chaleur && _vm.brideMenu('stats_leads_chaleur') === '1')?_c('v-flex',{attrs:{"xs12":"","md6":""}},[_c('v-expansion-panel',[_c('v-expansion-panel-content',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v("\n                      "+_vm._s(_vm.$t('leadHeat'))+"\n                      "),(_vm.leadDialogChaleur.chaleur)?_c('v-chip',{staticClass:"white--text",attrs:{"color":"green"}},[_vm._v(_vm._s(_vm.leadDialogChaleur.chaleur)+"°")]):_vm._e()],1),_vm._v(" "),_c('v-list',{staticClass:"grey lighten-5",attrs:{"two-line":"","dense":"","subheader":""}},[_c('v-list-tile',{attrs:{"xs12":"","md6":"","lg3":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('exportHasChatted')))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.leadDialog.hasChatted ? _vm.$t('yes') : _vm.$t('no')))])],1),_vm._v(" "),_c('v-list-tile-action',[(_vm.leadDialogChaleur.details.hasChatted)?_c('v-chip',{staticClass:"white--text",attrs:{"color":"green"}},[_vm._v("+"+_vm._s(_vm.leadDialogChaleur.details.hasChatted))]):_vm._e()],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"xs12":"","md6":"","lg3":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('exportHasBeenTarget')))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.leadDialog.hasBeenTarget ? _vm.$t('yes') : _vm.$t('no')))])],1),_vm._v(" "),_c('v-list-tile-action',[(_vm.leadDialogChaleur.details.hasBeenTarget)?_c('v-chip',{staticClass:"white--text",attrs:{"color":"green"}},[_vm._v("+"+_vm._s(_vm.leadDialogChaleur.details.hasBeenTarget))]):_vm._e()],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"xs12":"","md6":"","lg3":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('exportTel')))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.leadDialogChaleur.details.tel ? _vm.$t('yes') : _vm.$t('no')))])],1),_vm._v(" "),_c('v-list-tile-action',[(_vm.leadDialogChaleur.details.tel)?_c('v-chip',{staticClass:"white--text",attrs:{"color":"green"}},[_vm._v("+"+_vm._s(_vm.leadDialogChaleur.details.tel))]):_vm._e()],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"xs12":"","md6":"","lg3":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('exportEmail')))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.leadDialogChaleur.details.email ? _vm.$t('yes') : _vm.$t('no')))])],1),_vm._v(" "),_c('v-list-tile-action',[(_vm.leadDialogChaleur.details.email)?_c('v-chip',{staticClass:"white--text",attrs:{"color":"green"}},[_vm._v("+"+_vm._s(_vm.leadDialogChaleur.details.email))]):_vm._e()],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"xs12":"","md6":"","lg3":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('exportDuration')))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm._f("duration")(_vm.leadDialog.duration)))])],1),_vm._v(" "),_c('v-list-tile-action',[(_vm.leadDialogChaleur.details.duration)?_c('v-chip',{staticClass:"white--text",attrs:{"color":"green"}},[_vm._v("+"+_vm._s(_vm.leadDialogChaleur.details.duration))]):_vm._e()],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"xs12":"","md6":"","lg3":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('exportBasket')))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.leadDialog.basket))])],1),_vm._v(" "),_c('v-list-tile-action',[(_vm.leadDialogChaleur.details.basket)?_c('v-chip',{staticClass:"white--text",attrs:{"color":"green"}},[_vm._v("+"+_vm._s(_vm.leadDialogChaleur.details.basket))]):_vm._e()],1)],1),_vm._v(" "),_c('v-list-tile',{attrs:{"xs12":"","md6":"","lg3":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('exportPurchase')))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.leadDialog.purchase))])],1),_vm._v(" "),_c('v-list-tile-action',[(_vm.leadDialogChaleur.details.purchase)?_c('v-chip',{staticClass:"white--text",attrs:{"color":"green"}},[_vm._v("+"+_vm._s(_vm.leadDialogChaleur.details.purchase))]):_vm._e()],1)],1)],1)],1)],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-tab-item',{key:'tab_chat'},[_c('v-card-text',{staticClass:"pa-0",style:(!_vm.$vuetify.breakpoint.smAndDown ? 'height: calc(100vh - 210px);' : '')},[(_vm.leadDialog.id)?_c('wz-histo-chats',{attrs:{"params":'visId=' + _vm.leadDialog.id,"numChatsTotal":String(0),"chatHeight":"100%","type":"satisfaction","scroll":""}}):_vm._e()],1)],1)],2),_vm._v(" "),(!_vm.$vuetify.breakpoint.smAndDown && _vm.currentTab == 0)?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.cancelDialogEdit()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.submitDialogEdit()}}},[_vm._v(_vm._s(_vm.$t('submit')))])],1):_vm._e()],1)}
var WzEditeurLead_staticRenderFns = []
var WzEditeurLead_esExports = { render: WzEditeurLead_render, staticRenderFns: WzEditeurLead_staticRenderFns }
/* harmony default export */ var watcheezy_WzEditeurLead = (WzEditeurLead_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzEditeurLead.vue
function WzEditeurLead_injectStyle (ssrContext) {
  __webpack_require__("LLJJ")
}
var WzEditeurLead_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzEditeurLead___vue_template_functional__ = false
/* styles */
var WzEditeurLead___vue_styles__ = WzEditeurLead_injectStyle
/* scopeId */
var WzEditeurLead___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzEditeurLead___vue_module_identifier__ = null
var WzEditeurLead_Component = WzEditeurLead_normalizeComponent(
  WzEditeurLead,
  watcheezy_WzEditeurLead,
  WzEditeurLead___vue_template_functional__,
  WzEditeurLead___vue_styles__,
  WzEditeurLead___vue_scopeId__,
  WzEditeurLead___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzEditeurLead = (WzEditeurLead_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzAgentsOccupationDay.vue












/* harmony default export */ var WzAgentsOccupationDay = ({
  props: {
    dataAgentSelected: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    var _this = this;

    return {
      loading: false,
      utcDecal: '',
      dialogChat: false,
      chatDialog: {},
      tempsPresence: 28800,
      totalJoursOuvres: 1,
      totalTempsConnexion: 0,
      totalTempsPresence: 0,
      totalTempsAllChats: 0,
      tempsTotalOnline: 0,
      tempsTotalBusy: 0,
      tempsOccupationBusy: 0,
      moyenChatMax: 0,
      tempsOccupationPartielle: 0,
      totalTempsChat: [0, 0, 0, 0],
      tauxProductivity1: 0,
      tauxProductivity2: 0,
      tauxProductivity3: 0,

      optionsGraph: {
        chart: {},
        colors: ['#F44336', '#3F51B5', '#009688', '#E91E63', '#607D8B', '#9C27B0', '#2196F3', '#FF5722', '#795548', '#4CAF50', '#8BC34A', '#673AB7', '#CDDC39', '#03A9F4', '#FFC107', '#FF9800', '#FFEB3B', '#00BCD4', '#9E9E9E'],
        title: {
          style: {
            fontSize: '20px',
            fontFamily: '"Inconsolata", sans-serif'
          }
        },
        plotOptions: {},
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        }
      },

      agentOccupation: {
        chart: {
          type: 'xrange',

          height: 200 },
        colors: [this.dataAgentSelected.agentColor],
        title: {
          text: 'Conversations du ' + moment_default.a.parseZone(this.dataAgentSelected.dateStart * 1000).format('LL')
        },
        legend: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          maxPadding: 0.1,
          minorGridLineColor: '#f1f1f1',
          minorTickInterval: 'auto',
          min: this.dataAgentSelected.dateStart * 1000 + 21600000,
          max: this.dataAgentSelected.dateEnd * 1000 - 7200000 },
        yAxis: {
          title: {
            text: 'Place pupitre'
          },
          categories: ['1', '2', '3', '4'],
          reversed: false
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          },
          series: {
            cursor: 'pointer',
            allowPointSelect: true,
            point: {
              events: {
                click: function click(e) {
                  _this.openDialogChat(e);
                }
              }
            }
          }
        },
        tooltip: {
          crosshairs: true,

          valueSuffix: ' cm',
          shared: true,
          useHTML: false,
          headerFormat: '<small style="color: {series.color}">Conversation </small><table>',
          pointFormat: '<tr><td>De : </td><td><b>{point.debut}</b> </td></tr>' + '<tr><td>à : </td><td><b>{point.fin}</b> </td></tr>' + '<tr><td> - visiteur : </td><td><b>{point.visiteurId}</b></td></tr>',
          footerFormat: '</table>'
        },
        series: []
      },

      agentConnexions: {
        chart: {
          type: 'xrange',
          height: 150 },
        colors: [this.dataAgentSelected.agentColor],
        title: {
          text: 'Connexions du ' + moment_default.a.parseZone(this.dataAgentSelected.dateStart * 1000).format('LL')
        },
        legend: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          maxPadding: 0.1,
          minorGridLineColor: '#f1f1f1',
          minorTickInterval: 'auto',
          min: this.dataAgentSelected.dateStart * 1000 + 21600000,
          max: this.dataAgentSelected.dateEnd * 1000 - 7200000 },
        yAxis: {
          title: {
            text: 'Connexion'
          },
          categories: ['1'],
          reversed: false
        },
        tooltip: {
          crosshairs: true,

          valueSuffix: ' cm',
          shared: true,
          useHTML: true,
          headerFormat: '<small style="color: {series.color}">Connexion</small><table>',
          pointFormat: '<tr><td>De : </td><td><b>{point.debut}</b></td></tr>' + '<tr><td>à : </td><td><b>{point.fin}</b></td></tr>',
          footerFormat: '</table>'
        },
        series: []
      },

      agentStatus: {
        chart: {
          type: 'xrange',
          height: 150 },

        title: {
          text: 'Activité du ' + moment_default.a.parseZone(this.dataAgentSelected.dateStart * 1000).format('LL')
        },
        legend: {
          enabled: false
        },
        xAxis: {
          type: 'datetime',
          maxPadding: 0.1,
          minorGridLineColor: '#f1f1f1',
          minorTickInterval: 'auto',

          min: this.dataAgentSelected.dateStart * 1000 + 21600000,
          max: this.dataAgentSelected.dateEnd * 1000 - 7200000 },
        yAxis: {
          title: {
            text: 'Présence'
          },
          categories: ['1'],
          reversed: false
        },
        tooltip: {
          crosshairs: true,

          valueSuffix: ' cm',
          shared: true,
          useHTML: true,
          headerFormat: '<small style="color: {point.color}"></small><table>',
          pointFormat: '<tr><td colspan="2" style="color: {point.color}"><b>{point.status}</b></td></tr>' + '<tr><td>De : </td><td><b>{point.debut}</b></td></tr>' + '<tr><td>à : </td><td><b>{point.fin}</b></td></tr>',
          footerFormat: '</table>'
        },

        series: []
      },

      productivityAgent: {
        chart: {
          type: 'solidgauge',
          height: 300,
          events: {}
        },

        title: {
          text: lodash_default.a.upperFirst(this.$t('productivity'))
        },

        tooltip: {
          borderWidth: 0,
          backgroundColor: 'none',
          shadow: false,
          style: {
            fontSize: '16px'
          },
          pointFormat: '<div><div style="font-size:0.7em; text-align: center; width:100%">{series.name}</div><br><div style="font-size:1.5em; color: {point.color}; font-weight: bold; text-align: center; width:100%">{point.y}%</div></div>',
          positioner: function positioner(labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: this.chart.plotHeight / 2 + 15
            };
          }
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [{
            outerRadius: '112%',
            innerRadius: '88%',

            backgroundColor: this.Highcharts.Color('#3F51B5').setOpacity(0.3).get(),
            borderWidth: 0
          }, {
            outerRadius: '87%',
            innerRadius: '63%',

            backgroundColor: this.Highcharts.Color('#8BC34A').setOpacity(0.3).get(),
            borderWidth: 0
          }, {
            outerRadius: '62%',
            innerRadius: '38%',

            backgroundColor: this.Highcharts.Color('#9E9E9E').setOpacity(0.3).get(),
            borderWidth: 0
          }]
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: []
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: false
            },
            linecap: 'round',
            stickyTracking: false,
            rounded: true
          }
        },

        series: [{
          name: lodash_default.a.upperFirst(this.$t('presence')),
          data: [{
            color: '#3F51B5',

            radius: '112%',
            innerRadius: '88%',
            y: 0
          }]
        }, {
          name: lodash_default.a.upperFirst(this.$t('emojiActivity')),
          data: [{
            color: '#8BC34A',

            radius: '87%',
            innerRadius: '63%',
            y: 0
          }]
        }, {
          name: lodash_default.a.upperFirst(this.$t('inactivity')),
          data: [{
            color: '#9E9E9E',

            radius: '62%',
            innerRadius: '38%',
            y: 0
          }]
        }]
      },

      activityAgent: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          height: 300,
          type: 'pie'
        },
        title: {
          text: lodash_default.a.upperFirst(this.$t('advisorOccupancy'))
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br/>',
          pointFormat: '{point.percentage:.1f}%'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            point: {
              events: {}
            },
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        series: []
      }
    };
  },
  created: function created() {
    console.log('created vue');
    console.log('Date.UTC(2010, 0, 1, 0, 0, 0)', Date.UTC(2010, 0, 1, 0, 0, 0));
    console.log('this.dataAgentSelected.dateStart', this.dataAgentSelected.dateStart);
    console.log('this.dataAgentSelected.dateEnd', this.dataAgentSelected.dateEnd);
    this.tempsPresence = this.dataAgentSelected.tempsTravail * 60 * 60;
    console.log('tempsPresence', this.dataAgentSelected);

    this.agentOccupation = lodash_default.a.merge(this.agentOccupation, this.optionsGraph);
    this.agentConnexions = lodash_default.a.merge(this.agentConnexions, this.optionsGraph);
    this.agentStatus = lodash_default.a.merge(this.agentStatus, this.optionsGraph);
    this.productivityAgent = lodash_default.a.merge(this.productivityAgent, this.optionsGraph);
    this.activityAgent = lodash_default.a.merge(this.activityAgent, this.optionsGraph);
  },
  mounted: function mounted() {
    this.loading = true;
    var dateNow = Date.now();
    var inverseOffset = moment_default()(dateNow).utcOffset();
    console.log('inverseOffset', inverseOffset);
    this.utcDecal = inverseOffset;

    console.log('dataAgentSelected', this.dataAgentSelected);
    this.getOccupation();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_Stats', ['params']), {
    agentsChatsPieComputed: function agentsChatsPieComputed() {
      var res = [];
      lodash_default.a.each(this.agentOccupation.series[0].data, function (a) {
        var name = a.name.split(' (')[0];
        var chats = a.name.split(' (')[1].split(' ')[0];
        res.push({
          name: name,
          y: a.y,
          chats: chats
        });
      });
      return res;
    },
    dataAgentComputed: function dataAgentComputed() {
      return this.dataAgentSelected;
    },
    nameAgentComputed: function nameAgentComputed() {
      return this.dataAgentSelected.agentName;
    },
    afficheTotalTempsConnexion: function afficheTotalTempsConnexion() {
      return moment_default.a.duration(this.totalTempsConnexion / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsBusy: function afficheTotalTempsBusy() {
      return moment_default.a.duration(this.tempsTotalBusy / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsActivity: function afficheTotalTempsActivity() {
      var tempsActivity = this.tempsTotalBusy + this.tempsTotalOnline;
      if (tempsActivity > this.afficheTotalTempsConnexion) {
        tempsActivity = this.afficheTotalTempsConnexion;
      }
      return moment_default.a.duration(tempsActivity / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsPresence: function afficheTotalTempsPresence() {
      var tempsPresence = this.totalTempsPresence;
      return moment_default.a.duration(tempsPresence / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsPartielleActivity: function afficheTotalTempsPartielleActivity() {
      return moment_default.a.duration(this.tempsTotalOnline / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsMoyenChats: function afficheTotalTempsMoyenChats() {
      var tempsChatMoyen = this.totalTempsAllChats / 1000 / this.moyenChatMax;
      return moment_default.a.duration(tempsChatMoyen / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsChat: function afficheTotalTempsChat() {
      var tempsChatMoyen = this.totalTempsAllChats / 1000;
      return moment_default.a.duration(tempsChatMoyen / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsHorsProd: function afficheTotalTempsHorsProd() {
      var tempsHorsProd = this.totalTempsConnexion - (this.tempsTotalBusy + this.tempsTotalOnline);
      return moment_default.a.duration(tempsHorsProd / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsPartielleChat: function afficheTotalTempsPartielleChat() {
      var tempsChatPartielle = this.tempsOccupationPartielle / 1000;
      return moment_default.a.duration(tempsChatPartielle / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsBusyChat: function afficheTotalTempsBusyChat() {
      var tempsChatBusy = this.tempsOccupationBusy / 1000;
      return moment_default.a.duration(tempsChatBusy / 60, 'minutes').format('h [h] m [min]');
    },
    tauxBusy: function tauxBusy() {
      return this.tempsOccupationBusy / 1000 * 100 / this.totalTempsConnexion;
    },
    tauxOccupationPartiel: function tauxOccupationPartiel() {
      return this.tempsOccupationPartielle / 1000 * 100 / this.totalTempsConnexion;
    },
    tauxInoccupation: function tauxInoccupation() {
      var inoccuper = this.totalTempsPresence - (this.tempsTotalBusy + this.tempsOccupationPartielle) / 1000;

      return inoccuper * 100 / this.totalTempsConnexion;
    },
    afficheTotalTempsRef: function afficheTotalTempsRef() {
      var tempsRef = this.tempsPresence * this.totalJoursOuvres;
      return moment_default.a.duration(tempsRef / 60, 'minutes').format('h [h] m [min]');
    }
  }),

  methods: {
    getOccupation: function getOccupation() {
      var _this2 = this;

      this.agentOccupation.series.push({ 'data': [] });
      var param = 'dateStart=' + encodeURIComponent(this.dataAgentSelected.dateStart) + '&dateEnd=' + encodeURIComponent(this.dataAgentSelected.dateEnd) + '&agentId=' + encodeURIComponent(this.dataAgentSelected.agentID);
      this.axios.get('get/occupationAgentDay.php?' + param).then(function (response) {
        console.log('getOccupation:response : ', response.data);
        var limiteChat = 0;

        lodash_default.a.each(response.data, function (values, key) {
          limiteChat = limiteChat + values.chatMax;

          values.y = values.y - 1;

          _this2.totalTempsAllChats = _this2.totalTempsAllChats + (values.x2 - values.x);

          _this2.totalTempsChat[values.y - 1] = Math.round(_this2.totalTempsChat[values.y - 1]) + Math.round(values.x2 / 1000 - values.x / 1000);

          var dateS = values.x + _this2.utcDecal * 60000;
          var dateE = values.x2 + _this2.utcDecal * 60000;

          values.debut = moment_default.a.utc(dateS).format('LTS');
          values.fin = moment_default.a.utc(dateE).format('LTS');

          values.x = dateS;
          values.x2 = dateE;

          _this2.agentOccupation.series[0].data.push(values);

          if (values.numChat && values.numChat < values.chatMax) {
            _this2.tempsOccupationPartielle = _this2.tempsOccupationPartielle + (values.x2 - values.x);
          }

          if (values.numChat && values.numChat >= values.chatMax) {
            _this2.tempsOccupationBusy = _this2.tempsOccupationBusy + (values.x2 - values.x);
          }
        });
        console.log('this.tempsOccupationPartielle', _this2.tempsOccupationPartielle);

        _this2.moyenChatMax = Math.round(limiteChat / response.data.length);
        _this2.agentOccupation.series[0].name = 'Conversations';
        _this2.agentOccupation.series[0].dataLabels = { enabled: false };
        console.log('this.agentOccupation : ', _this2.agentOccupation);
      }).catch().then(function (_) {
        _this2.getConnexions();
      });
    },
    getConnexions: function getConnexions() {
      var _this3 = this;

      this.agentConnexions.series.push({ 'data': [] });
      var param = 'dateStart=' + encodeURIComponent(this.dataAgentSelected.dateStart) + '&refTime=' + encodeURIComponent(this.tempsPresence) + '&dateEnd=' + encodeURIComponent(this.dataAgentSelected.dateEnd) + '&agentId=' + encodeURIComponent(this.dataAgentSelected.agentID);
      this.axios.get('get/connexionAgentDay.php?' + param).then(function (response) {
        if (response.data.connexions) {
          for (var index = 0; index < response.data.connexions.length; index++) {
            var values = response.data.connexions[index];
            var previousValues = response.data.connexions[index - 1];

            if (values.type !== 8) {
              if (previousValues && previousValues.type !== 8) {
                if (values.x2 > values.x) {
                  _this3.totalTempsConnexion = _this3.totalTempsConnexion + (values.x2 - values.x);

                  values.y = values.y - 1;

                  var dateS = values.x * 1000 + _this3.utcDecal * 60000;
                  var dateE = values.x2 * 1000 + _this3.utcDecal * 60000;

                  values.debut = moment_default.a.utc(dateS).format('LTS');
                  values.fin = moment_default.a.utc(dateE).format('LTS');

                  values.x = dateS;
                  values.x2 = dateE;

                  _this3.agentConnexions.series[0].data.push(values);
                }
              }

              if (index === 0) {
                if (values.x2 > values.x) {
                  _this3.totalTempsConnexion = _this3.totalTempsConnexion + (values.x2 - values.x);

                  values.y = values.y - 1;

                  var _dateS = values.x * 1000 + _this3.utcDecal * 60000;
                  var _dateE = values.x2 * 1000 + _this3.utcDecal * 60000;

                  values.debut = moment_default.a.utc(_dateS).format('LTS');
                  values.fin = moment_default.a.utc(_dateE).format('LTS');

                  values.x = _dateS;
                  values.x2 = _dateE;

                  _this3.agentConnexions.series[0].data.push(values);
                }
              }
            }
          }
          _this3.agentConnexions.series[0].name = lodash_default.a.upperFirst(_this3.$t('connections'));
          _this3.agentConnexions.series[0].dataLabels = { enabled: false };
          _this3.agentConnexions.series[0].color = _this3.optionsGraph.colors[4];
          _this3.agentConnexions.series[0].total = _this3.totalTempsConnexion;
        }
      }).catch().then(function (_) {
        _this3.getStatusAgent();
      });
    },
    getStatusAgent: function getStatusAgent() {
      var _this4 = this;

      this.agentStatus.series.push({ 'data': [] });
      var param = 'dateStart=' + encodeURIComponent(this.dataAgentSelected.dateStart) + '&dateEnd=' + encodeURIComponent(this.dataAgentSelected.dateEnd) + '&agentId=' + encodeURIComponent(this.dataAgentSelected.agentID);
      this.axios.get('get/statusAgentDay.php?' + param).then(function (response) {
        for (var index = 0; index < response.data.length; index++) {
          var values = response.data[index];
          var previousValues = response.data[index - 1];
          if (values.status === 'online') {
            values.color = '#4CAF50';
          } else if (values.status === 'busy') {
            values.color = '#FF9800';
          } else {
            values.color = 'rgba(244, 67, 54, 0.1)';
          }

          if (values.status !== 'offline') {
            if (previousValues) {
              _this4.totalTempsPresence = _this4.totalTempsPresence + (values.x2 - values.x);

              values.y = values.y - 1;

              var dateS = values.x * 1000 + _this4.utcDecal * 60000;
              var dateE = values.x2 * 1000 + _this4.utcDecal * 60000;

              values.debut = moment_default.a.utc(dateS).format('LTS');
              values.fin = moment_default.a.utc(dateE).format('LTS');

              values.x = dateS;
              values.x2 = dateE;

              var diffTimestamp = (values.x2 - values.x) / 1000;

              _this4.agentStatus.series[0].data.push(values);

              if (values.status === 'online') {
                _this4.tempsTotalOnline = _this4.tempsTotalOnline + diffTimestamp;
              }

              if (values.status === 'busy') {
                _this4.tempsTotalBusy = _this4.tempsTotalBusy + diffTimestamp;
              }
            }

            if (index === 0) {
              _this4.totalTempsPresence = _this4.totalTempsPresence + (values.x2 - values.x);

              values.y = values.y - 1;

              var _dateS2 = values.x * 1000 + _this4.utcDecal * 60000;
              var _dateE2 = values.x2 * 1000 + _this4.utcDecal * 60000;

              values.debut = moment_default.a.utc(_dateS2).format('LTS');
              values.fin = moment_default.a.utc(_dateE2).format('LTS');

              values.x = _dateS2;
              values.x2 = _dateE2;

              var _diffTimestamp = (values.x2 - values.x) / 1000;

              _this4.agentStatus.series[0].data.push(values);

              if (values.status === 'online') {
                _this4.tempsTotalOnline = _this4.tempsTotalOnline + _diffTimestamp;
              }

              if (values.status === 'busy') {
                _this4.tempsTotalBusy = _this4.tempsTotalBusy + _diffTimestamp;
              }
            }
          }
        }
        _this4.agentStatus.series[0].name = lodash_default.a.upperFirst(_this4.$t('presence'));
        _this4.agentStatus.series[0].dataLabels = { enabled: false };
        _this4.agentStatus.series[0].color = _this4.optionsGraph.colors[4];
        _this4.agentStatus.series[0].total = _this4.totalTempsPresence;

        var presence = _this4.totalTempsConnexion * 100 / (_this4.tempsPresence * _this4.totalJoursOuvres);
        _this4.tauxProductivity1 = presence.toFixed(2);
        _this4.productivityAgent.series[0].data[0].y = Math.round(presence * 100) / 100;

        var totalActivityTime = _this4.tempsTotalBusy + _this4.tempsTotalOnline;
        var totalChats = totalActivityTime * 100 / (_this4.tempsPresence * _this4.totalJoursOuvres);
        _this4.tauxProductivity2 = totalChats.toFixed(2);
        _this4.productivityAgent.series[1].data[0].y = Math.round(totalChats * 100) / 100;

        var inactiv = (_this4.totalTempsConnexion - totalActivityTime) * 100 / (_this4.tempsPresence * _this4.totalJoursOuvres);
        _this4.tauxProductivity3 = inactiv.toFixed(2);
        _this4.productivityAgent.series[2].data[0].y = Math.round(inactiv * 100) / 100;


        var dataOccupation = [{
          name: lodash_default.a.upperFirst(_this4.$t('partialOccupation')),
          color: _this4.optionsGraph.colors[9],
          y: _this4.tauxOccupationPartiel
        }, {
          name: lodash_default.a.upperFirst(_this4.$t('maximumOccupancy')),
          color: _this4.optionsGraph.colors[15],
          y: _this4.tauxBusy
        }, {
          name: lodash_default.a.upperFirst(_this4.$t('unoccupied')),
          color: _this4.optionsGraph.colors[10],
          y: _this4.tauxInoccupation
        }];

        _this4.activityAgent.series = [{}];
        _this4.activityAgent.series[0].data = [];

        _this4.activityAgent.series[0].data = dataOccupation;
      }).catch().then(function (_) {
        _this4.loading = false;
      });
    },
    getAll: function getAll() {
      this.getAgentsChats();
    },
    cancelDialog: function cancelDialog() {
      this.$emit('closeDialog');
    },
    openDialogChat: function openDialogChat(data) {
      var index = data.point.index;
      this.dialogChat = true;
      this.chatDialog = {};
      var dataChat = {
        'date': String(Math.round(data.point.series.userOptions.data[index].x / 1000)),
        'id': data.point.series.userOptions.data[index].visiteurId,
        'site': '',
        'agent': {
          USR_ID: String(this.dataAgentSelected.agentID),
          USR_MAIL: '',
          USR_MAIL_CONTACT: '',
          USR_FIRST_NAME: this.dataAgentSelected.agentName,
          USR_LAST_NAME: ''
        }
      };

      this.chatDialog = lodash_default.a.clone(dataChat);
    },
    cancelDialogChat: function cancelDialogChat() {
      this.dialogChat = false;
    },
    getAgentsChats: function getAgentsChats() {
      var _this5 = this;

      this.loadingAgentsChats = true;
      this.axios.get('get/agents_chats.php?' + this.params).then(function (response) {
        _this5.agentsChatsPie.series = [{}];
        _this5.agentsChatsPie.series[0].data = [];
        _this5.agentsChatsBar.series = [];
        _this5.agentsChatsBar.xAxis.categories = [];

        var idAgents = [];
        var nbChats = 0;
        response.data.chatsByAgent.forEach(function (agent) {
          var agentFound = lodash_default.a.find(_this5.$store.state._User.colleagues, { 'USR_ID': lodash_default.a.toString(agent.id) });
          _this5.agentsChatsPie.series[0].data.push({
            name: agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME + ' (' + agent.nb + ' chats)',
            y: agent.pourcent
          });

          nbChats += agent.nb;
          idAgents.push(agent.id);
          _this5.agentsChatsBar.series.push({
            name: agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME,
            agentID: agent.id,
            day: response.data.days,
            arrayDays: response.data.arrayDays,
            data: []
          });
        });

        _this5.agentsChatsPie.title.text = lodash_default.a.upperFirst(_this5.$tc('distributionOfChats', 1, { count: nbChats }));

        entries_default()(response.data.days).forEach(function (_ref) {
          var _ref2 = slicedToArray_default()(_ref, 2),
              date = _ref2[0],
              agents = _ref2[1];

          _this5.agentsChatsBar.xAxis.categories.push(moment_default()(date).format('ll'));

          entries_default()(agents).forEach(function (_ref3) {
            var _ref4 = slicedToArray_default()(_ref3, 2),
                id = _ref4[0],
                chat = _ref4[1];

            var idx = idAgents.findIndex(function (i) {
              return i === lodash_default.a.toNumber(id);
            });
            if (idx !== -1 && _this5.agentsChatsBar.series[idx]) {
              _this5.agentsChatsBar.series[idx].data.push(chat);
            }
          });
        });
        console.log('this.agentsChatsBar', _this5.agentsChatsBar);
      }).catch().then(function (_) {
        _this5.loadingAgentsChats = false;
      });
    },
    exportAgentsChatsPie: function exportAgentsChatsPie() {
      var csv = '';
      var data = [];
      var fields = [];
      var fieldNames = ['agent', 'chats', 'pourcentage'];
      fields = ['name', 'chats', 'y'];
      data = this.agentsChatsPieComputed;
      try {
        csv = json2csv_default()({ data: data, fields: fields, del: ';', fieldNames: fieldNames });
      } catch (err) {
        return;
      }
      this.downloadFile('agentsChatsPie.csv', csv);
    },
    downloadFile: function downloadFile(filename, content) {
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:attachment/text,' + encodeURI(content);
      hiddenElement.target = '_blank';
      hiddenElement.download = filename;
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
    }
  },

  watch: {
    params: function params(v) {
      this.getAll();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4442829e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzAgentsOccupationDay.vue
var WzAgentsOccupationDay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"conteneurLead",attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",staticStyle:{"height":"52px","padding":"0px"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.cancelDialog()}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Occupation conseiller "+_vm._s(_vm.nameAgentComputed))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[(_vm.loading)?_c('v-card',{staticClass:"mb-3",attrs:{"height":"400px"}},[_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(!_vm.loading)?_c('v-card',{staticClass:"mb-3"},[_c('v-flex',{attrs:{"d-flex":"","xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","md8":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('highcharts',{attrs:{"options":_vm.agentOccupation}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('highcharts',{attrs:{"options":_vm.agentStatus}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('highcharts',{attrs:{"options":_vm.agentConnexions}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","sc12":""}},[_c('v-flex',{attrs:{"d-flex":"","xs12":"","md4":"","child-flex":""}},[_c('span',{staticClass:"text-md-center"},[_vm._v("Temps cumulé en chat : "+_vm._s(_vm.afficheTotalTempsChat))])]),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","md4":"","child-flex":""}},[_c('span',{staticClass:"text-md-center"},[_vm._v("Moyenne limite chatMax : "+_vm._s(_vm.moyenChatMax))])]),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","md4":"","child-flex":""}},[_c('span',{staticClass:"text-md-center"},[_vm._v("Temps total moyen en chat : "+_vm._s(_vm.afficheTotalTempsMoyenChats))])])],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":"","md4":"","child-flex":""}},[_c('v-flex',{staticClass:"text-md-center",attrs:{"xs12":""}},[_c('p',[_vm._v("Temps de référence pour cette journée : "),_c('strong',[_vm._v(_vm._s(_vm.afficheTotalTempsRef))])]),_vm._v(" "),_c('highcharts',{attrs:{"options":_vm.productivityAgent}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('connectionRate'))+" : "+_vm._s(_vm.tauxProductivity1)+" % ("+_vm._s(_vm.afficheTotalTempsConnexion)+")")]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('agentsActivity'))+" : "+_vm._s(_vm.tauxProductivity2)+" % ("+_vm._s(_vm.afficheTotalTempsPresence)+")")]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('agentsInactivity'))+" : "+_vm._s(_vm.tauxProductivity3)+" % ("+_vm._s(_vm.afficheTotalTempsHorsProd)+")")]),_c('br'),_vm._v(" "),_c('highcharts',{attrs:{"options":_vm.activityAgent}}),_vm._v(" "),_c('span',{staticClass:"text-md-center"},[_vm._v("Temps d'activité : ("+_vm._s(_vm.afficheTotalTempsPresence)+")")]),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-md-center"},[_vm._v("Temps total occupé : "+_vm._s(_vm.afficheTotalTempsBusy))]),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-md-center"},[_vm._v("Temps total en activité partielle : "+_vm._s(_vm.afficheTotalTempsPartielleActivity))])],1)],1)],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","min-width":"640px","max-width":"800px","scrollable":!_vm.$vuetify.breakpoint.smAndDown,"fullscreen":_vm.$vuetify.breakpoint.smAndDown},model:{value:(_vm.dialogChat),callback:function ($$v) {_vm.dialogChat=$$v},expression:"dialogChat"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",staticStyle:{"height":"52px","padding":"0px"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.cancelDialogChat()}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1),_vm._v(" "),_c('span',{staticClass:"title"})],1),_vm._v(" "),_c('v-card-text',{staticClass:"pa-0",style:(!_vm.$vuetify.breakpoint.smAndDown ? 'height: calc(100vh - 210px);' : '')},[(_vm.chatDialog.id)?_c('wz-histo-chats',{attrs:{"params":'visId=' + _vm.chatDialog.id,"numChatsTotal":String(0),"chatHeight":"100%","type":"satisfaction","scroll":""}}):_vm._e()],1)],1)],1)],1)}
var WzAgentsOccupationDay_staticRenderFns = []
var WzAgentsOccupationDay_esExports = { render: WzAgentsOccupationDay_render, staticRenderFns: WzAgentsOccupationDay_staticRenderFns }
/* harmony default export */ var watcheezy_WzAgentsOccupationDay = (WzAgentsOccupationDay_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzAgentsOccupationDay.vue
var WzAgentsOccupationDay_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzAgentsOccupationDay___vue_template_functional__ = false
/* styles */
var WzAgentsOccupationDay___vue_styles__ = null
/* scopeId */
var WzAgentsOccupationDay___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzAgentsOccupationDay___vue_module_identifier__ = null
var WzAgentsOccupationDay_Component = WzAgentsOccupationDay_normalizeComponent(
  WzAgentsOccupationDay,
  watcheezy_WzAgentsOccupationDay,
  WzAgentsOccupationDay___vue_template_functional__,
  WzAgentsOccupationDay___vue_styles__,
  WzAgentsOccupationDay___vue_scopeId__,
  WzAgentsOccupationDay___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzAgentsOccupationDay = (WzAgentsOccupationDay_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzAgentsOccupationPeriode.vue












/* harmony default export */ var WzAgentsOccupationPeriode = ({
  props: {
    dataAgentSelected: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    return {
      loading: false,
      utcDecal: '',
      tempsPresence: 28800,
      joursPresence: 5,
      totalJoursOuvres: 1,
      totalTempsConnexion: 0,
      totalTempsPresence: 0,
      totalTempsAllChats: 0,
      tempsTotalOnline: 0,
      tempsTotalBusy: 0,
      tempsOccupationBusy: 0,
      moyenChatMax: 0,
      tempsOccupationPartielle: 0,
      totalTempsChat: [0, 0, 0, 0],
      moyenChatHeure: [],
      joursPeriode: 0,
      tauxProductivity1: 0,
      tauxProductivity2: 0,
      tauxProductivity3: 0,

      optionsGraph: {
        chart: {},
        colors: ['#F44336', '#3F51B5', '#009688', '#E91E63', '#607D8B', '#9C27B0', '#2196F3', '#FF5722', '#795548', '#4CAF50', '#8BC34A', '#673AB7', '#CDDC39', '#03A9F4', '#FFC107', '#FF9800', '#FFEB3B', '#00BCD4', '#9E9E9E'],
        title: {
          style: {
            fontSize: '20px',
            fontFamily: '"Inconsolata", sans-serif'
          }
        },
        plotOptions: {},
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        }
      },

      productivityAgent: {
        chart: {
          type: 'solidgauge',
          height: '300px',
          events: {}
        },

        title: {
          text: lodash_default.a.upperFirst(this.$t('productivity'))
        },

        tooltip: {
          borderWidth: 0,
          backgroundColor: 'none',
          shadow: false,
          style: {
            fontSize: '16px'
          },
          pointFormat: '<div><div style="font-size:0.7em; text-align: center; width:100%">{series.name}</div><br><div style="font-size:1.5em; color: {point.color}; font-weight: bold; text-align: center; width:100%">{point.y}%</div></div>',
          positioner: function positioner(labelWidth) {
            return {
              x: (this.chart.chartWidth - labelWidth) / 2,
              y: this.chart.plotHeight / 2 + 15
            };
          }
        },
        pane: {
          startAngle: 0,
          endAngle: 360,
          background: [{
            outerRadius: '112%',
            innerRadius: '88%',

            backgroundColor: this.Highcharts.Color('#3F51B5').setOpacity(0.3).get(),
            borderWidth: 0
          }, {
            outerRadius: '87%',
            innerRadius: '63%',

            backgroundColor: this.Highcharts.Color('#8BC34A').setOpacity(0.3).get(),
            borderWidth: 0
          }, {
            outerRadius: '62%',
            innerRadius: '38%',

            backgroundColor: this.Highcharts.Color('#9E9E9E').setOpacity(0.3).get(),
            borderWidth: 0
          }]
        },

        yAxis: {
          min: 0,
          max: 100,
          lineWidth: 0,
          tickPositions: []
        },

        plotOptions: {
          solidgauge: {
            dataLabels: {
              enabled: false
            },
            linecap: 'round',
            stickyTracking: false,
            rounded: true
          }
        },

        series: [{
          name: lodash_default.a.upperFirst(this.$t('connected')),
          data: [{
            color: '#3F51B5',

            radius: '112%',
            innerRadius: '88%',
            y: 0
          }]
        }, {
          name: lodash_default.a.upperFirst(this.$t('emojiActivity')),
          data: [{
            color: '#8BC34A',

            radius: '87%',
            innerRadius: '63%',
            y: 0
          }]
        }, {
          name: lodash_default.a.upperFirst(this.$t('inactivity')),
          data: [{
            color: '#9E9E9E',

            radius: '62%',
            innerRadius: '38%',
            y: 0
          }]
        }]
      },

      activityAgent: {
        chart: {
          plotBackgroundColor: null,
          plotBorderWidth: null,
          plotShadow: false,
          height: 300,
          type: 'pie'
        },
        title: {
          text: lodash_default.a.upperFirst(this.$t('advisorOccupancy'))
        },
        tooltip: {
          headerFormat: '<b>{point.key}</b><br/>',
          pointFormat: '{point.percentage:.1f}%'
        },
        plotOptions: {
          pie: {
            allowPointSelect: true,
            point: {
              events: {
                click: function click(e) {}
              }
            },
            cursor: 'pointer',
            dataLabels: {
              enabled: false
            },
            showInLegend: true
          }
        },
        series: []
      },

      tauxActivityAgent: {
        chart: {},
        title: {
          text: 'Taux d\'occupation du conseiller'
        },
        subtitle: {
          text: 'Occupation moyenne par heure dans une journée'
        },
        xAxis: {
          categories: ['00 h', '01 h', '02 h', '03 h', '04 h', '05 h', '06 h', '07 h', '08 h', '09 h', '10 h', '11 h', '12 h', '13 h', '14 h', '15 h', '16 h', '17 h', '18 h', '19 h', '20 h', '21 h', '22 h', '23 h'],
          title: {
            text: 'Heures'
          }
        },
        yAxis: [{
          min: 0,
          max: 100,
          title: {
            text: 'Taux d\'occupation'
          },
          labels: {
            formatter: function formatter() {
              return this.value + ' %';
            }
          }
        }, {
          min: 0,
          title: {
            text: 'Solicitations visiteurs',
            style: {
              color: this.Highcharts.getOptions().colors[0]
            }
          },
          labels: {
            format: '{value} ',
            style: {
              color: this.Highcharts.getOptions().colors[0]
            }
          },
          opposite: true
        }],
        tooltip: {
          split: true,

          valueSuffix: ' %'
        },
        plotOptions: {
          area: {
            marker: {
              enabled: false,
              symbol: 'circle',
              radius: 2,
              states: {
                hover: {
                  enabled: true
                }
              }
            }
          },
          line: {
            lineWidth: 2,
            states: {
              hover: {
                lineWidth: 4
              }
            },
            marker: {
              enabled: false
            }
          }
        },
        series: []
      }
    };
  },
  created: function created() {
    this.joursPeriode = Math.round((this.dataAgentSelected.dateEnd - this.dataAgentSelected.dateStart) / 60 / 60 / 24);

    if (this.joursPeriode < 7) {
      if (this.joursPeriode > this.dataAgentSelected.joursHebdo) {
        this.totalJoursOuvres = this.dataAgentSelected.joursHebdo;
      } else {
        this.totalJoursOuvres = this.joursPeriode;
      }
    } else {
      this.totalJoursOuvres = this.joursPeriode / 7 * this.dataAgentSelected.joursHebdo;
    }

    this.tempsPresence = this.dataAgentSelected.tempsTravail * 60 * 60;
    this.productivityAgent = lodash_default.a.merge(this.productivityAgent, this.optionsGraph);
    this.activityAgent = lodash_default.a.merge(this.activityAgent, this.optionsGraph);
    this.tauxActivityAgent = lodash_default.a.merge(this.tauxActivityAgent, this.optionsGraph);

    this.tempsPresence = this.dataAgentSelected.tempsTravail * 60 * 60;
    console.log('tempsPresence', this.dataAgentSelected);
  },
  mounted: function mounted() {
    this.loading = true;
    var dateNow = Date.now();
    var inverseOffset = moment_default()(dateNow).utcOffset();

    this.utcDecal = inverseOffset;

    this.getOccupation();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_Stats', ['params']), {
    agentsChatsPieComputed: function agentsChatsPieComputed() {
      var res = [];
      lodash_default.a.each(this.agentOccupation.series[0].data, function (a) {
        var name = a.name.split(' (')[0];
        var chats = a.name.split(' (')[1].split(' ')[0];
        res.push({
          name: name,
          y: a.y,
          chats: chats
        });
      });
      return res;
    },
    dataAgentComputed: function dataAgentComputed() {
      return this.dataAgentSelected;
    },
    nameAgentComputed: function nameAgentComputed() {
      return this.dataAgentSelected.agentName;
    },
    dateStartComputed: function dateStartComputed() {
      return moment_default.a.parseZone(this.dataAgentSelected.dateStart * 1000).format('LL');
    },
    dateEndComputed: function dateEndComputed() {
      return moment_default.a.parseZone(this.dataAgentSelected.dateEnd * 1000).format('LL');
    },
    afficheTotalTempsConnexion: function afficheTotalTempsConnexion() {
      return moment_default.a.duration(this.totalTempsConnexion / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsBusy: function afficheTotalTempsBusy() {
      return moment_default.a.duration(this.tempsTotalBusy / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsPartielleActivity: function afficheTotalTempsPartielleActivity() {
      return moment_default.a.duration(this.tempsTotalOnline / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsMoyenChats: function afficheTotalTempsMoyenChats() {
      var tempsChatMoyen = this.totalTempsAllChats / this.moyenChatMax;
      return moment_default.a.duration(tempsChatMoyen / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsChat: function afficheTotalTempsChat() {
      var tempsChatMoyen = this.totalTempsAllChats;
      return moment_default.a.duration(tempsChatMoyen / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsHorsProd: function afficheTotalTempsHorsProd() {
      var tempsHorsProd = this.totalTempsConnexion - (this.tempsTotalBusy + this.tempsTotalOnline);
      return moment_default.a.duration(tempsHorsProd / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsPartielleChat: function afficheTotalTempsPartielleChat() {
      var tempsChatPartielle = this.tempsOccupationPartielle;
      return moment_default.a.duration(tempsChatPartielle / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsPresence: function afficheTotalTempsPresence() {
      var tempsPresence = this.totalTempsPresence;
      return moment_default.a.duration(tempsPresence / 60, 'minutes').format('h [h] m [min]');
    },
    afficheTotalTempsBusyChat: function afficheTotalTempsBusyChat() {
      var tempsChatBusy = this.tempsTotalBusy;
      return moment_default.a.duration(tempsChatBusy / 60, 'minutes').format('h [h] m [min]');
    },
    tauxBusy: function tauxBusy() {
      return this.tempsTotalBusy * 100 / this.totalTempsConnexion;
    },
    tauxOccupationPartiel: function tauxOccupationPartiel() {
      return this.tempsOccupationPartielle * 100 / this.totalTempsConnexion;
    },
    tauxInoccupation: function tauxInoccupation() {
      var inoccuper = this.totalTempsPresence - (this.tempsTotalBusy + this.tempsOccupationPartielle);

      return inoccuper * 100 / this.totalTempsConnexion;
    },
    afficheTotalTempsRef: function afficheTotalTempsRef() {
      var tempsRef = 0;
      if (this.joursPeriode < 7) {
        if (this.joursPeriode > this.joursPresence) {
          tempsRef = this.tempsPresence * this.joursPresence;
        } else {
          tempsRef = this.tempsPresence * this.joursPeriode;
        }
      } else {
        tempsRef = this.tempsPresence * this.joursPresence * (this.joursPeriode / 7);
      }
      return moment_default.a.duration(tempsRef / 60, 'minutes').format('h [h] m [min]');
    }
  }),

  methods: {
    getOccupation: function getOccupation() {
      var _this = this;

      this.tempsPresence = this.dataAgentSelected.tempsTravail * 60 * 60;
      this.joursPresence = this.dataAgentSelected.joursHebdo;
      var param = 'dateStart=' + encodeURIComponent(this.dataAgentSelected.dateStart) + '&dateEnd=' + encodeURIComponent(this.dataAgentSelected.dateEnd) + '&agentId=' + encodeURIComponent(this.dataAgentSelected.agentID);
      this.axios.get('get/occupationAgentPeriode.php?' + param).then(function (response) {
        _this.totalTempsAllChats = response.data.totalTempsAllChats;
        _this.tempsOccupationPartielle = response.data.tempsOccupationPartielle;
        _this.tempsOccupationBusy = response.data.tempsOccupationBusy;
        _this.moyenChatMax = response.data.moyenChatMax;
        _this.moyenChatHeure = response.data.chatParHeure;
      }).catch().then(function (_) {
        _this.getConnexions();
      });
    },
    getConnexions: function getConnexions() {
      var _this2 = this;

      var param = 'dateStart=' + encodeURIComponent(this.dataAgentSelected.dateStart) + '&refTime=' + encodeURIComponent(this.tempsPresence) + '&dateEnd=' + encodeURIComponent(this.dataAgentSelected.dateEnd) + '&agentId=' + encodeURIComponent(this.dataAgentSelected.agentID);
      this.axios.get('get/connexionAgentPeriode.php?' + param).then(function (response) {
        _this2.totalTempsConnexion = response.data.totalTempsConnexion;
      }).catch().then(function (_) {
        _this2.getStatusAgent();
      });
    },
    getStatusAgent: function getStatusAgent() {
      var _this3 = this;

      var param = 'dateStart=' + encodeURIComponent(this.dataAgentSelected.dateStart) + '&dateEnd=' + encodeURIComponent(this.dataAgentSelected.dateEnd) + '&agentsId=' + encodeURIComponent(this.dataAgentSelected.agentID);
      this.axios.get('get/statusAgentPeriode.php?' + param).then(function (response) {
        _this3.totalTempsPresence = response.data.totalTempsPresence;
        _this3.tempsTotalOnline = response.data.tempsTotalOnline;
        _this3.tempsTotalBusy = response.data.tempsTotalBusy;
        var dataOccupation = [{
          name: lodash_default.a.upperFirst(_this3.$t('partialOccupation')),
          color: _this3.optionsGraph.colors[9],
          y: _this3.tauxOccupationPartiel
        }, {
          name: lodash_default.a.upperFirst(_this3.$t('maximumOccupancy')),
          color: _this3.optionsGraph.colors[15],
          y: _this3.tauxBusy
        }, {
          name: lodash_default.a.upperFirst(_this3.$t('unoccupied')),
          color: _this3.optionsGraph.colors[10],
          y: _this3.tauxInoccupation
        }];

        _this3.activityAgent.series = [{}];
        _this3.activityAgent.series[0].data = [];

        _this3.activityAgent.series[0].data = dataOccupation;

        var dataTauxOccupation = [{
          type: 'area',
          name: lodash_default.a.upperFirst(_this3.$t('offline')),
          color: _this3.optionsGraph.colors[0],
          data: response.data.arrayTauxOffline,
          tooltip: {
            split: true,

            valueSuffix: ' %'
          }
        }, {
          type: 'area',
          name: lodash_default.a.upperFirst(_this3.$t('online')),
          color: _this3.optionsGraph.colors[10],
          data: response.data.arrayTauxOnline,
          tooltip: {
            split: true,

            valueSuffix: ' %'
          }
        }, {
          type: 'area',
          name: lodash_default.a.upperFirst(_this3.$t('busy')),
          color: _this3.optionsGraph.colors[15],
          data: response.data.arrayTauxBusy,
          tooltip: {
            split: true,

            valueSuffix: ' %'
          }
        }, {
          yAxis: 1,
          name: lodash_default.a.upperFirst('Solicitations visiteurs'),
          color: _this3.optionsGraph.colors[4],
          data: _this3.moyenChatHeure,
          tooltip: {
            split: true,

            valueSuffix: ''
          }
        }];
        _this3.tauxActivityAgent.series = dataTauxOccupation;
      }).catch().then(function (_) {
        _this3.loading = false;

        var totalActivityTime = _this3.tempsTotalBusy + _this3.tempsTotalOnline;

        var tempsRef = 0;
        if (_this3.joursPeriode < 7) {
          if (_this3.joursPeriode > _this3.joursPresence) {
            tempsRef = _this3.tempsPresence * _this3.joursPresence;
          } else {
            tempsRef = _this3.tempsPresence * _this3.joursPeriode;
          }
        } else {
          tempsRef = _this3.tempsPresence * _this3.joursPresence * (_this3.joursPeriode / 7);
        }

        var presence = _this3.totalTempsConnexion * 100 / tempsRef;
        _this3.tauxProductivity1 = presence.toFixed(2);
        _this3.productivityAgent.series[0].data[0].y = Math.round(presence * 100) / 100;

        var totalChats = totalActivityTime * 100 / tempsRef;
        _this3.tauxProductivity2 = totalChats.toFixed(2);
        _this3.productivityAgent.series[1].data[0].y = Math.round(totalChats * 100) / 100;

        var inactiv = (_this3.totalTempsConnexion - totalActivityTime) * 100 / tempsRef;
        _this3.tauxProductivity3 = inactiv.toFixed(2);
        _this3.productivityAgent.series[2].data[0].y = Math.round(inactiv * 100) / 100;
      });
    },
    getAll: function getAll() {
      this.getAgentsChats();
    },
    cancelDialog: function cancelDialog() {
      this.$emit('closeDialog');
    },
    openDayOccupation: function openDayOccupation(data) {
      var indexDate = data.point.index;

      var dateStart = moment_default.a.parseZone(data.point.series.userOptions.arrayDays[indexDate].date).format('X');
      var dateEnd = dateStart + 86400;
      var agentID = data.point.series.userOptions.agentID;
      this.dataAgentSelected.dateStart = dateStart;
      this.dataAgentSelected.dateEnd = dateEnd;
      this.dataAgentSelected.agentID = agentID;
    },
    getAgentsChats: function getAgentsChats() {
      var _this4 = this;

      this.loadingAgentsChats = true;
      this.axios.get('get/agents_chats.php?' + this.params).then(function (response) {
        _this4.agentsChatsPie.series = [{}];
        _this4.agentsChatsPie.series[0].data = [];
        _this4.agentsChatsBar.series = [];
        _this4.agentsChatsBar.xAxis.categories = [];

        var idAgents = [];
        var nbChats = 0;
        response.data.chatsByAgent.forEach(function (agent) {
          var agentFound = lodash_default.a.find(_this4.$store.state._User.colleagues, { 'USR_ID': lodash_default.a.toString(agent.id) });
          _this4.agentsChatsPie.series[0].data.push({
            name: agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME + ' (' + agent.nb + ' chats)',
            y: agent.pourcent
          });

          nbChats += agent.nb;
          idAgents.push(agent.id);
          _this4.agentsChatsBar.series.push({
            name: agentFound.USR_FIRST_NAME + ' ' + agentFound.USR_LAST_NAME,
            agentID: agent.id,
            day: response.data.days,
            arrayDays: response.data.arrayDays,
            data: []
          });
        });

        _this4.agentsChatsPie.title.text = lodash_default.a.upperFirst(_this4.$tc('distributionOfChats', 1, { count: nbChats }));

        entries_default()(response.data.days).forEach(function (_ref) {
          var _ref2 = slicedToArray_default()(_ref, 2),
              date = _ref2[0],
              agents = _ref2[1];

          _this4.agentsChatsBar.xAxis.categories.push(moment_default()(date).format('ll'));

          entries_default()(agents).forEach(function (_ref3) {
            var _ref4 = slicedToArray_default()(_ref3, 2),
                id = _ref4[0],
                chat = _ref4[1];

            var idx = idAgents.findIndex(function (i) {
              return i === lodash_default.a.toNumber(id);
            });
            if (idx !== -1 && _this4.agentsChatsBar.series[idx]) {
              _this4.agentsChatsBar.series[idx].data.push(chat);
            }
          });
        });
      }).catch().then(function (_) {
        _this4.loadingAgentsChats = false;
      });
    },
    exportAgentsChatsPie: function exportAgentsChatsPie() {
      var csv = '';
      var data = [];
      var fields = [];
      var fieldNames = ['agent', 'chats', 'pourcentage'];
      fields = ['name', 'chats', 'y'];
      data = this.agentsChatsPieComputed;
      try {
        csv = json2csv_default()({ data: data, fields: fields, del: ';', fieldNames: fieldNames });
      } catch (err) {
        return;
      }
      this.downloadFile('agentsChatsPie.csv', csv);
    },
    downloadFile: function downloadFile(filename, content) {
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:attachment/text,' + encodeURI(content);
      hiddenElement.target = '_blank';
      hiddenElement.download = filename;
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
    }
  },

  watch: {
    params: function params(v) {
      this.getAll();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22dbae77","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzAgentsOccupationPeriode.vue
var WzAgentsOccupationPeriode_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"conteneurLead",attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",staticStyle:{"height":"52px","padding":"0px"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.cancelDialog()}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Occupation conseiller "+_vm._s(_vm.nameAgentComputed))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v("Temps de référence pour la période du "+_vm._s(_vm.dateStartComputed)+" au "+_vm._s(_vm.dateEndComputed)+" est de "),_c('strong',[_vm._v(_vm._s(_vm.afficheTotalTempsRef))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.loading)?_c('v-card',{staticClass:"mb-3",attrs:{"height":"400px"}},[_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(!_vm.loading)?_c('v-card',{staticClass:"mb-3"},[_c('v-flex',{attrs:{"d-flex":"","xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-md-center",attrs:{"xs12":"","md3":""}},[_c('highcharts',{attrs:{"options":_vm.productivityAgent}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('connectionRate'))+" : "+_vm._s(_vm.tauxProductivity1)+" % ("+_vm._s(_vm.afficheTotalTempsConnexion)+")")]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('agentsActivity'))+" : "+_vm._s(_vm.tauxProductivity2)+" % ("+_vm._s(_vm.afficheTotalTempsPresence)+")")]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('agentsInactivity'))+" : "+_vm._s(_vm.tauxProductivity3)+" % ("+_vm._s(_vm.afficheTotalTempsHorsProd)+")")]),_c('br')],1),_vm._v(" "),_c('v-flex',{staticClass:"text-md-center",attrs:{"xs12":"","md3":""}},[_c('highcharts',{attrs:{"options":_vm.activityAgent}}),_vm._v(" "),_c('span',[_vm._v("Temps d'activité : "+_vm._s(_vm.afficheTotalTempsPresence))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('maximumOccupancy'))+" : "+_vm._s(_vm.afficheTotalTempsBusy))]),_c('br'),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('partialOccupation'))+" : "+_vm._s(_vm.afficheTotalTempsPartielleChat))]),_c('br')],1),_vm._v(" "),_c('v-flex',{staticClass:"text-md-center",attrs:{"xs12":"","md6":""}},[_c('highcharts',{attrs:{"options":_vm.tauxActivityAgent}})],1)],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"text-md-center",attrs:{"xs12":"","md4":""}},[_c('span',{staticClass:"text-md-center"},[_vm._v("Temps cumulé en chat : "+_vm._s(_vm.afficheTotalTempsChat))])]),_vm._v(" "),_c('v-flex',{staticClass:"text-md-center",attrs:{"xs12":"","md3":""}},[_c('span',{staticClass:"text-md-center"},[_vm._v("Moyenne limite chatMax : "+_vm._s(_vm.moyenChatMax))])]),_vm._v(" "),_c('v-flex',{staticClass:"text-md-center",attrs:{"xs12":"","md3":""}},[_c('span',{staticClass:"text-md-center"},[_vm._v("Temps total moyen en chat : "+_vm._s(_vm.afficheTotalTempsMoyenChats))])])],1)],1)],1):_vm._e()],1)],1)],1)}
var WzAgentsOccupationPeriode_staticRenderFns = []
var WzAgentsOccupationPeriode_esExports = { render: WzAgentsOccupationPeriode_render, staticRenderFns: WzAgentsOccupationPeriode_staticRenderFns }
/* harmony default export */ var watcheezy_WzAgentsOccupationPeriode = (WzAgentsOccupationPeriode_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzAgentsOccupationPeriode.vue
var WzAgentsOccupationPeriode_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzAgentsOccupationPeriode___vue_template_functional__ = false
/* styles */
var WzAgentsOccupationPeriode___vue_styles__ = null
/* scopeId */
var WzAgentsOccupationPeriode___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzAgentsOccupationPeriode___vue_module_identifier__ = null
var WzAgentsOccupationPeriode_Component = WzAgentsOccupationPeriode_normalizeComponent(
  WzAgentsOccupationPeriode,
  watcheezy_WzAgentsOccupationPeriode,
  WzAgentsOccupationPeriode___vue_template_functional__,
  WzAgentsOccupationPeriode___vue_styles__,
  WzAgentsOccupationPeriode___vue_scopeId__,
  WzAgentsOccupationPeriode___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzAgentsOccupationPeriode = (WzAgentsOccupationPeriode_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheezy/WzAgentsPresenceDay.vue










/* harmony default export */ var WzAgentsPresenceDay = ({
  props: {
    dataAgentsSelected: {
      type: Object,
      default: {}
    }
  },
  data: function data() {
    var _this = this;

    return {
      loading: false,
      occupationAgentDay: false,
      utcDecal: '',
      tempsPresence: 28800,
      totalJoursOuvres: 1,
      totalTempsConnexion: 0,
      totalTempsPresence: 0,
      totalTempsAllChats: 0,
      tempsTotalOnline: 0,
      tempsTotalBusy: 0,
      tempsOccupationBusy: 0,
      moyenChatMax: 0,
      tempsOccupationPartielle: 0,
      totalTempsChat: [0, 0, 0, 0],
      tauxProductivity1: 0,
      tauxProductivity2: 0,
      tauxProductivity3: 0,
      agentsName: [],
      agents: [],
      totalTimeConnexion: 0,
      dataAgentSelected: { agentID: '' },

      optionsGraph: {
        chart: {},
        colors: ['#F44336', '#3F51B5', '#009688', '#E91E63', '#607D8B', '#9C27B0', '#2196F3', '#FF5722', '#795548', '#4CAF50', '#8BC34A', '#673AB7', '#CDDC39', '#03A9F4', '#FFC107', '#FF9800', '#FFEB3B', '#00BCD4', '#9E9E9E'],
        title: {
          style: {
            fontSize: '20px',
            fontFamily: '"Inconsolata", sans-serif'
          }
        },
        plotOptions: {},
        credits: {
          enabled: false
        },
        exporting: {
          enabled: false
        }
      },

      agentConnexions: {
        chart: {
          type: 'xrange'
        },
        colors: [this.dataAgentsSelected.agentColor],
        title: {
          text: 'Plage horaire des connexions du ' + moment_default.a.parseZone(this.dataAgentsSelected.dateStart * 1000).format('LL')
        },
        legend: {
          enabled: true
        },
        xAxis: {
          type: 'datetime',
          maxPadding: 0.1,
          minorGridLineColor: '#f1f1f1',
          minorTickInterval: 'auto',
          min: this.dataAgentsSelected.dateStart * 1000 + 21600000,
          max: this.dataAgentsSelected.dateEnd * 1000 - 7200000 },
        yAxis: {
          title: {
            text: 'Conseiller(s)'
          },
          categories: [],
          reversed: false
        },
        plotOptions: {
          column: {
            stacking: 'normal',
            dataLabels: {
              enabled: false
            }
          },
          series: {
            cursor: 'pointer',
            allowPointSelect: true,
            point: {
              events: {
                click: function click(e) {
                  _this.openDayOccupation(e);
                  console.log('openDayOccupation', e);
                }
              }
            }
          }
        },
        tooltip: {
          crosshairs: true,

          valueSuffix: ' cm',
          shared: true,
          useHTML: true,
          headerFormat: '<small style="color: {series.color}">' + this.$t('connections') + '</small><table>',
          pointFormat: '<tr><td>De : </td><td><b>{point.debut}</b></td></tr>' + '<tr><td>à : </td><td><b>{point.fin}</b></td></tr>',
          footerFormat: '</table>'
        },
        series: []
      }
    };
  },
  created: function created() {
    var _this2 = this;

    console.log('created vue');
    console.log('Date.UTC(2010, 0, 1, 0, 0, 0)', Date.UTC(2010, 0, 1, 0, 0, 0));
    console.log('this.dataAgentsSelected.dateStart', this.dataAgentsSelected.dateStart);
    console.log('this.dataAgentsSelected.dateEnd', this.dataAgentsSelected.dateEnd);
    this.tempsPresence = this.dataAgentsSelected.tempsTravail * 60 * 60;
    console.log('tempsPresence', this.dataAgentsSelected);

    this.agentConnexions = lodash_default.a.merge(this.agentConnexions, this.optionsGraph);

    this.axios.get('get/agents.php').then(function (response) {
      _this2.resAjx = response.data;
      _this2.init();
    }).catch().then(function (_) {});
  },
  mounted: function mounted() {
    this.loading = true;
    var dateNow = Date.now();
    var inverseOffset = moment_default()(dateNow).utcOffset();
    console.log('inverseOffset', inverseOffset);
    this.utcDecal = inverseOffset;

    console.log('dataAgentsSelected', this.dataAgentsSelected);

    this.getConnexions();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_Stats', ['params']), Object(vuex_esm["e" /* mapState */])('_User', ['brides']), {
    totalConnexionAgents: function totalConnexionAgents() {
      return moment_default.a.duration(this.totalTimeConnexion).format('h [h] m [min] s [sec]');
    }
  }),

  methods: {
    init: function init() {
      for (var id in this.resAjx) {
        this.agents.push({ id: this.resAjx[id][0].USR_ID,
          name: lodash_default.a.trim(this.resAjx[id][0].USR_FIRST_NAME + ' ' + this.resAjx[id][0].USR_LAST_NAME),
          rights: lodash_default.a.toInteger(this.resAjx[id][0].USR_RIGHTS),
          tempsTravail: this.resAjx[id][0].USR_TIME_DAY,
          joursHebdo: this.resAjx[id][0].USR_DAY_HEBDO,
          isbot: this.resAjx[id][0].USR_IS_BOT !== '',
          botid: this.resAjx[id][0].USR_IS_BOT
        });
      }
    },
    getConnexions: function getConnexions() {
      var _this3 = this;

      console.log('get connexion');
      this.totalTimeConnexion = 0;
      var agentsId = [];
      var tempsTravail = [];
      if (this.dataAgentsSelected.agents.length) {
        for (var index = 0; index < this.dataAgentsSelected.agents.length; index++) {
          agentsId.push(this.dataAgentsSelected.agents[index].id);
          tempsTravail.push(this.dataAgentsSelected.agents[index].tempsTravail);
          this.agentsName.push(this.dataAgentsSelected.agents[index].name);
        }
      }

      this.agentConnexions.series.push({ 'data': [] });
      var param = 'dateStart=' + encodeURIComponent(this.dataAgentsSelected.dateStart) + '&refTime=' + encodeURIComponent(tempsTravail) + '&dateEnd=' + encodeURIComponent(this.dataAgentsSelected.dateEnd) + '&agentId=' + encodeURIComponent(agentsId);
      console.log('param', param);
      this.axios.get('get/connexionAgentsDay.php?' + param).then(function (response) {
        console.log('response : ', response);
        console.log('response : ', response.data.day);

        if (response.data) {
          for (var _index = 0; _index < response.data.connexions.length; _index++) {
            var values = response.data.connexions[_index];
            var previousValues = response.data.connexions[_index - 1];

            if (values.type !== 8) {
              if (_this3.dataAgentsSelected.agents.length) {
                for (var i = 0; i < _this3.dataAgentsSelected.agents.length; i++) {
                  if (Number(_this3.dataAgentsSelected.agents[i].id) === values.agentId) {
                    values.agentName = _this3.dataAgentsSelected.agents[i].name;
                  }
                }
              }

              if (previousValues && previousValues.type !== 8) {
                if (values.x2 > values.x) {
                  _this3.totalTempsConnexion = _this3.totalTempsConnexion + (values.x2 - values.x);

                  values.y = values.y - 1;

                  var dateS = values.x * 1000 + _this3.utcDecal * 60000;
                  var dateE = values.x2 * 1000 + _this3.utcDecal * 60000;

                  values.debut = moment_default.a.utc(dateS).format('LTS');
                  values.fin = moment_default.a.utc(dateE).format('LTS');

                  values.x = dateS;
                  values.x2 = dateE;

                  _this3.totalTimeConnexion = _this3.totalTimeConnexion + (values.x2 - values.x);

                  _this3.agentConnexions.series[0].data.push(values);
                }
              }

              if (_index === 0) {
                if (values.x2 > values.x) {
                  _this3.totalTempsConnexion = _this3.totalTempsConnexion + (values.x2 - values.x);

                  values.y = values.y - 1;

                  var _dateS = values.x * 1000 + _this3.utcDecal * 60000;
                  var _dateE = values.x2 * 1000 + _this3.utcDecal * 60000;

                  values.debut = moment_default.a.utc(_dateS).format('LTS');
                  values.fin = moment_default.a.utc(_dateE).format('LTS');

                  values.x = _dateS;
                  values.x2 = _dateE;

                  _this3.totalTimeConnexion = _this3.totalTimeConnexion + (values.x2 - values.x);

                  _this3.agentConnexions.series[0].data.push(values);
                }
              }
            }
          }
          _this3.agentConnexions.series[0].name = _this3.$t('connections');
          _this3.agentConnexions.series[0].day = response.data.day;
          _this3.agentConnexions.series[0].dataLabels = { enabled: false };
          _this3.agentConnexions.series[0].color = _this3.optionsGraph.colors[4];
          _this3.agentConnexions.yAxis.categories = _this3.agentsName;

          console.log('this.agentConnexions : ', _this3.agentConnexions.series[0].data);
          console.log('totalTimeConnexion', _this3.totalTimeConnexion);
        }
      }).catch().then(function (_) {
        _this3.loading = false;
      });
    },
    openDayOccupation: function openDayOccupation(data) {
      console.log('data user : ', data);
      var indexDate = data.point.index;
      var agentID = data.point.series.userOptions.data[indexDate].agentId;
      var tempsTravailJour = 0;
      var joursSemaine = 0;
      for (var a = 0; a < this.agents.length; a++) {
        if (Number(this.agents[a].id) === agentID) {
          tempsTravailJour = this.agents[a].tempsTravail;
          joursSemaine = this.agents[a].joursHebdo;
        }
      }

      var dateStart = Number(moment_default.a.parseZone(data.point.series.userOptions.day).format('X'));

      var dateEnd = dateStart + 86400;

      this.dataAgentSelected.dateStart = dateStart;
      this.dataAgentSelected.dateEnd = dateEnd;
      this.dataAgentSelected.agentID = agentID;
      this.dataAgentSelected.agentName = data.point.series.userOptions.data[indexDate].agentName;
      this.dataAgentSelected.agentColor = data.point.color;
      this.dataAgentSelected.tempsTravail = tempsTravailJour;
      this.dataAgentSelected.joursHebdo = joursSemaine;

      this.occupationAgentDay = true;
    },
    dialogOccupationRemove: function dialogOccupationRemove() {
      this.occupationAgentDay = false;
    },
    brideMenu: function brideMenu(nameBride) {
      if (this.brides) {
        var index = this.brides.findIndex(function (bride) {
          return bride.brideName === nameBride;
        });

        if (index !== -1) {
          return this.brides[index].status;
        }
      }
    },
    getAll: function getAll() {
      this.getConnexions();
    },
    cancelDialog: function cancelDialog() {
      this.$emit('closeDialog');
    },
    exportAgentsChatsPie: function exportAgentsChatsPie() {
      var csv = '';
      var data = [];
      var fields = [];
      var fieldNames = ['agent', 'chats', 'pourcentage'];
      fields = ['name', 'chats', 'y'];
      data = this.agentsChatsPieComputed;
      try {
        csv = json2csv_default()({ data: data, fields: fields, del: ';', fieldNames: fieldNames });
      } catch (err) {
        return;
      }
      this.downloadFile('agentsChatsPie.csv', csv);
    },
    downloadFile: function downloadFile(filename, content) {
      var hiddenElement = document.createElement('a');
      hiddenElement.href = 'data:attachment/text,' + encodeURI(content);
      hiddenElement.target = '_blank';
      hiddenElement.download = filename;
      document.body.appendChild(hiddenElement);
      hiddenElement.click();
    }
  },

  watch: {
    params: function params(v) {
      this.getAll();
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24101e76","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzAgentsPresenceDay.vue
var WzAgentsPresenceDay_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"conteneurLead",attrs:{"flat":""}},[_c('v-card-title',{staticClass:"primary white--text",staticStyle:{"height":"52px","padding":"0px"}},[_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.cancelDialog()}}},[_c('v-icon',{staticClass:"white--text"},[_vm._v("close")])],1),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v("Présence conseillers")]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[(_vm.loading)?_c('v-card',{staticClass:"mb-3",attrs:{"height":"400px"}},[_c('v-card-text',{staticClass:"text-xs-center pt-5"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":""}})],1)],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(!_vm.loading)?_c('v-card',{staticClass:"mb-3"},[_c('v-flex',{attrs:{"d-flex":"","xs12":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"d-flex":"","md12":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('highcharts',{attrs:{"options":_vm.agentConnexions}})],1)],1),_vm._v(" "),_c('v-flex',{attrs:{"d-flex":"","md12":""}},[_c('p',{staticClass:"totalTime"},[_vm._v("Présence cumulée des conseillers : "),_c('strong',[_vm._v(_vm._s(_vm.totalConnexionAgents))])])])],1)],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"1200px","scrollable":!_vm.$vuetify.breakpoint.smAndDown,"fullscreen":_vm.$vuetify.breakpoint.smAndDown},model:{value:(_vm.occupationAgentDay),callback:function ($$v) {_vm.occupationAgentDay=$$v},expression:"occupationAgentDay"}},[(_vm.occupationAgentDay)?_c('wz-agents-occupation-day',{attrs:{"dataAgentSelected":_vm.dataAgentSelected},on:{"closeDialog":_vm.dialogOccupationRemove}}):_vm._e()],1)],1)}
var WzAgentsPresenceDay_staticRenderFns = []
var WzAgentsPresenceDay_esExports = { render: WzAgentsPresenceDay_render, staticRenderFns: WzAgentsPresenceDay_staticRenderFns }
/* harmony default export */ var watcheezy_WzAgentsPresenceDay = (WzAgentsPresenceDay_esExports);
// CONCATENATED MODULE: ./src/components/watcheezy/WzAgentsPresenceDay.vue
function WzAgentsPresenceDay_injectStyle (ssrContext) {
  __webpack_require__("985/")
}
var WzAgentsPresenceDay_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzAgentsPresenceDay___vue_template_functional__ = false
/* styles */
var WzAgentsPresenceDay___vue_styles__ = WzAgentsPresenceDay_injectStyle
/* scopeId */
var WzAgentsPresenceDay___vue_scopeId__ = "data-v-24101e76"
/* moduleIdentifier (server only) */
var WzAgentsPresenceDay___vue_module_identifier__ = null
var WzAgentsPresenceDay_Component = WzAgentsPresenceDay_normalizeComponent(
  WzAgentsPresenceDay,
  watcheezy_WzAgentsPresenceDay,
  WzAgentsPresenceDay___vue_template_functional__,
  WzAgentsPresenceDay___vue_styles__,
  WzAgentsPresenceDay___vue_scopeId__,
  WzAgentsPresenceDay___vue_module_identifier__
)

/* harmony default export */ var components_watcheezy_WzAgentsPresenceDay = (WzAgentsPresenceDay_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzWatcheeboxVisiteur.vue








/* harmony default export */ var WzWatcheeboxVisiteur = ({
  props: ['datasVisiteur', 'visSelectId'],
  data: function data() {
    return {
      domaine: constants_DOMAINE,
      histoChat: [],
      dialogDejaEnChat: false,
      overMenu: false
    };
  },
  mounted: function mounted() {
    console.log(this.datasVisiteur);
    if (this.WATCHEEBOX_STATE.visiteurChatSelected === this.datasVisiteur.visiteurID) {
      this.emitOpenChat();
    }
  },


  methods: {
    brideMenu: function brideMenu(nameBride) {
      if (this.brides) {
        var index = this.brides.findIndex(function (bride) {
          return bride.brideName === nameBride;
        });

        if (index !== -1) {
          return this.brides[index].status;
        }
      }
    },
    checkChatVisiteur: function checkChatVisiteur() {
      if (this.overMenu) return;
      if (this.visSelectId === this.datasVisiteur.visiteurID) return;
      if (this.dejaEnChat) {
        if (this.dejaEnChat.agentID === this.user.id) {
          this.emitOpenChat();
        } else {
          this.dialogDejaEnChat = true;
        }
      } else {
        this.emitOpenChat();
      }
    },
    emitOpenChat: function emitOpenChat() {
      var _this = this;

      console.log('emitOpenChat');
      this.dialogDejaEnChat = false;
      if (this.visSelectId === this.datasVisiteur.visiteurID) return;

      this.$emit('loading', this.datasVisiteur);

      this.$store.commit('_StoreWatcheeBox/OPEN_FICHE_VISITEUR', this.datasVisiteur);

      watcheebox_watcheebox.firstLoadHistoChat({
        chatSession: this.datasVisiteur.visiteurID,
        entrepriseId: this.user.entId
      }).then(function (histoChat) {
        var vis = lodash_default.a.cloneDeep(_this.datasVisiteur);
        vis.histoChat = histoChat;
        if (_this.datasVisiteur.network) {
          vis.visiteurName = _this.datasVisiteur.visiteurName;
        } else {
          vis.visiteurName = _this.datasVisiteur.shortdesc;
        }

        _this.$store.commit('_StoreWatcheeBox/SET_VISITEURS', vis);
        _this.$emit('openChat', vis);
      }).catch(function (e) {});
    },
    stopAlert: function stopAlert() {
      var _this2 = this;

      var config = {
        responseType: 'json',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/x-www-form-urlencoded' }
      };

      var dataToPost = new window.FormData();
      dataToPost.append('visiteurID', this.datasVisiteur.visiteurID);
      this.axios.post('post/stop_alert.php', dataToPost, config).then(function (response) {
        _this2.$emit('stopAlertVisiteur', _this2.datasVisiteur.visiteurID);
      }).catch().then(function (_) {});
    },
    findUrls: function findUrls(text) {
      var source = (text || '').toString();
      var urlArray = [];
      var matchArray;

      var regexToken = /(((ftp|https?):\/\/)[-\w@:%_+.~#?,&//=]+)|((mailto:)?[_.\w-]+@([\w][\w-]+\.)+[a-zA-Z]{2,3})/g;

      while ((matchArray = regexToken.exec(source)) !== null) {
        var token = matchArray[0];
        urlArray.push(token);
      }
      return urlArray;
    }
  },

  watch: {
    'datasVisiteur.lastMessage': function datasVisiteurLastMessage(val, oldval) {
      console.log('lastMessage', val);
      if (!this.visSelectId && val) {
        this.$emit('loading', this.datasVisiteur);
        this.$emit('openChat', this.datasVisiteur);
      }
    }

  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['WATCHEEBOX_STATE', 'listeChatAgent', 'newMessage']), Object(vuex_esm["e" /* mapState */])('_User', ['brides']), Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'fullName']), Object(vuex_esm["c" /* mapGetters */])('_StoreWatcheeBox', ['WATCHEEBOX_STATE']), {
    identity: function identity() {
      if (this.datasVisiteur.network) {
        return this.datasVisiteur.visiteurName;
      } else {
        return lodash_default.a.isEmpty(lodash_default.a.trim(this.datasVisiteur.visiteurName)) ? this.datasVisiteur.visiteurID : this.datasVisiteur.visiteurName;
      }
    },
    visiteurLastChat: function visiteurLastChat() {
      if (this.datasVisiteur.dateLastChat && this.datasVisiteur.dateLastChat !== null) {
        return moment_default()(this.datasVisiteur.dateLastChat * 1000).fromNow();
      } else {
        return null;
      }
    },
    visiteurAutoInvitSend: function visiteurAutoInvitSend() {
      if (this.datasVisiteur.autoinvitSend) {
        return moment_default()(this.datasVisiteur.autoinvitSend).fromNow();
      } else {
        return null;
      }
    },
    numListeAlerte: function numListeAlerte() {
      if (this.datasVisiteur.listAlert) {
        return this.datasVisiteur.listAlert.length;
      } else {
        return 0;
      }
    },
    listeAlerte: function listeAlerte() {
      if (this.datasVisiteur.listAlert) {
        return this.datasVisiteur.listAlert;
      } else {
        return 0;
      }
    },
    dejaEnChat: function dejaEnChat() {
      var data = lodash_default.a.find(this.listeChatAgent, [0, this.datasVisiteur.visiteurID]);
      if (data) {
        var userFound = this.$store.getters['_User/getUserById'](data[3]);
        return { 'sessionID': data[0], 'agentID': data[3], 'agentName': userFound.USR_FIRST_NAME + ' ' + userFound.USR_LAST_NAME };
      } else {
        return null;
      }
    },
    istypingVisiteur: function istypingVisiteur() {
      var typing = lodash_default.a.find(this.datasVisiteur.histoChat, { 'isTyping': true, 'auteur': 'Visiteur' });
      if (typing) {
        return true;
      } else {
        return null;
      }
    },
    visiteurLastMessage: function visiteurLastMessage() {
      if (this.datasVisiteur.lastMessage && this.datasVisiteur.lastMessage !== null) {
        return this.datasVisiteur.lastMessage;
      } else {
        return null;
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c6a66e1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzWatcheeboxVisiteur.vue
var WzWatcheeboxVisiteur_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"wz_wrapChips"},[(_vm.datasVisiteur.nb_alert)?_c('v-flex',{staticClass:"visiteurFiltrer",attrs:{"xs12":"","sm12":""}},[_c('v-list-tile',{key:_vm.datasVisiteur.status,class:{ 'light-blue lighten-4': _vm.visSelectId == _vm.datasVisiteur.visiteurID,  },attrs:{"ripple":""},on:{"click":_vm.checkChatVisiteur}},[(!_vm.dejaEnChat && !_vm.datasVisiteur.network)?_c('wz-avatar',{staticClass:"pl-1",attrs:{"username":'#' + _vm.datasVisiteur.visiteurID,"size":"38px"}}):(!_vm.dejaEnChat && _vm.datasVisiteur.network)?_c('wz-avatar',{staticClass:"pl-1",attrs:{"src":_vm.datasVisiteur.profile_pic,"username":_vm.datasVisiteur.visiteurName,"size":"38px"}}):(!_vm.dejaEnChat && !_vm.istypingVisiteur && _vm.visiteurLastMessage && _vm.datasVisiteur.visiteurID != _vm.visSelectId)?_c('wz-avatar',{attrs:{"username":'#' + _vm.datasVisiteur.visiteurID,"size":"38px","lastMessage":""}}):(!_vm.dejaEnChat && _vm.istypingVisiteur)?_c('wz-avatar',{attrs:{"isTyping":_vm.istypingVisiteur,"username":'#' + _vm.datasVisiteur.visiteurID,"size":"38px","chip":""}}):_vm._e(),_vm._v(" "),(_vm.dejaEnChat && !_vm.istypingVisiteur && !_vm.visiteurLastMessage && _vm.datasVisiteur.visiteurID != _vm.visSelectId)?_c('wz-avatar-double',{attrs:{"avatars":[{id: _vm.datasVisiteur.visiteurName, isTyping: false, chip: true, lastMessage: _vm.visiteurLastMessage}, {id: _vm.dejaEnChat.agentID, username: _vm.dejaEnChat.agentName}]}}):(_vm.dejaEnChat && !_vm.istypingVisiteur && !_vm.visiteurLastMessage && _vm.datasVisiteur.visiteurID == _vm.visSelectId)?_c('wz-avatar-double',{attrs:{"avatars":[{id: _vm.datasVisiteur.visiteurName, isTyping: false, chip: true, lastMessage: _vm.visiteurLastMessage}, {id: _vm.dejaEnChat.agentID, username: _vm.dejaEnChat.agentName}]}}):(_vm.dejaEnChat && !_vm.istypingVisiteur && _vm.visiteurLastMessage && _vm.datasVisiteur.visiteurID != _vm.visSelectId)?_c('wz-avatar-double',{attrs:{"avatars":[{id: _vm.datasVisiteur.visiteurName, isTyping: false, chip: true, lastMessage: _vm.visiteurLastMessage}, {id: _vm.dejaEnChat.agentID, username: _vm.dejaEnChat.agentName}]}}):(_vm.dejaEnChat && _vm.istypingVisiteur)?_c('wz-avatar-double',{attrs:{"avatars":[{id: _vm.datasVisiteur.visiteurName, isTyping: true, chip: true}, {id: _vm.dejaEnChat.agentID, username: _vm.dejaEnChat.agentName}]}}):(_vm.datasVisiteur.network)?_c('wz-avatar-double',{attrs:{"avatars":[{id: _vm.dejaEnChat.sessionID, username: _vm.datasVisiteur.visiteurName, src: _vm.datasVisiteur.profile_pic}, {id: _vm.dejaEnChat.agentID, username: _vm.dejaEnChat.agentName}]}}):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs8":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('v-tooltip',{attrs:{"bottom":""}},[(_vm.datasVisiteur.nb_alert && _vm.datasVisiteur.nb_alert != 0)?_c('div',{staticClass:"wz_alertFiltre secondary lighten-1 white--text",attrs:{"slot":"activator"},slot:"activator"},[_c('div',[_vm._v(_vm._s(_vm.datasVisiteur.nb_alert))])]):_vm._e(),_vm._v(" "),_c('span',[_vm._v("\n                    Filtre activé : "),_c('br'),_vm._v(" "),_vm._l((_vm.listeAlerte),function(alerte,index){return _c('div',{key:index},[_vm._v("\n                      "+_vm._s(index)+" - "+_vm._s(alerte)),_c('br')])})],2)]),_vm._v(" "),(_vm.datasVisiteur.nbCustomAlert && _vm.datasVisiteur.nbCustomAlert != 0)?_c('div',{staticClass:"wz_alertPanier green  lighten-1 white--text"},[_c('span',[_vm._v(_vm._s(_vm.datasVisiteur.nbCustomAlert))])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"wz_nameVisiteur"},[_vm._v(_vm._s(_vm.datasVisiteur.shortdesc))])],1),_vm._v(" "),(_vm.datasVisiteur.pagesFocus)?_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(_vm.datasVisiteur.pagesFocus)}}):_vm._e()],1)],1),_vm._v(" "),(_vm.brideMenu('stats_leads_chaleur') === '1')?_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!_vm.visSelectId && _vm.$vuetify.breakpoint.lgAndUp),expression:"!visSelectId && $vuetify.breakpoint.lgAndUp"}],staticClass:"iconesListeVisiteurs text-xs-center"},[_c('span',{staticClass:"secondary--text txtIcone txtMedium"},[_vm._v(_vm._s(_vm.datasVisiteur.ponderation)+"°")]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{staticClass:"grey--text text--lighten-1",attrs:{"slot":"activator","large":""},slot:"activator"},[_vm._v("network_check")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('leadHeat')))])],1)],1):_vm._e(),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!_vm.visSelectId && _vm.$vuetify.breakpoint.mdAndUp),expression:"!visSelectId && $vuetify.breakpoint.mdAndUp"}],staticClass:"iconesListeVisiteurs text-xs-center"},[_c('span',{staticClass:"secondary--text txtIcone txtMedium"},[_vm._v(_vm._s(_vm.visiteurAutoInvitSend))]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{staticClass:"grey--text text--lighten-1",attrs:{"slot":"activator","large":""},slot:"activator"},[_vm._v("local_offer")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('lastInvitAuto'))))])],1)],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!_vm.visSelectId && _vm.$vuetify.breakpoint.smAndUp),expression:"!visSelectId && $vuetify.breakpoint.smAndUp"}],staticClass:"iconesListeVisiteurs text-xs-center"},[_c('span',{staticClass:"secondary--text txtIcone txtMedium"},[_vm._v(_vm._s(_vm.datasVisiteur.lang))]),_vm._v(" "),_c('v-icon',{staticClass:"grey--text text--lighten-1",attrs:{"large":""}},[_vm._v("language")])],1),_vm._v(" "),_c('v-flex',{staticClass:"iconesListeVisiteurs text-xs-center"},[(_vm.visSelectId == _vm.datasVisiteur.visiteurID)?_c('v-icon',{staticClass:"secondary--text text--lighten-1",attrs:{"large":""}},[_vm._v("textsms")]):(_vm.visiteurLastChat != null)?_c('div',[_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.datasVisiteur.alreadyConsulted == 1 && !_vm.visSelectId),expression:"datasVisiteur.alreadyConsulted == 1 && !visSelectId"}],staticClass:"secondary--text txtIcone txtMedium"},[_vm._v(_vm._s(_vm.visiteurLastChat))]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-icon',{staticClass:"grey--text text--lighten-1",attrs:{"slot":"activator","medium":""},slot:"activator"},[_vm._v("chat_bubble")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('lastMessageSent')))])],1)],1):_c('v-icon',{staticClass:"grey--text text--lighten-1",attrs:{"medium":""}})],1),_vm._v(" "),_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!_vm.visSelectId && _vm.$vuetify.breakpoint.mdAndUp),expression:"!visSelectId && $vuetify.breakpoint.mdAndUp"}],staticClass:"text-xs-center"},[_c('v-tooltip',{attrs:{"bottom":""}},[_c('v-btn',{attrs:{"slot":"activator","flat":"","icon":"","color":"accent"},on:{"click":_vm.stopAlert},nativeOn:{"mouseover":function($event){_vm.overMenu = true},"mouseleave":function($event){_vm.overMenu = false}},slot:"activator"},[_c('v-icon',{staticClass:"grey--text text--lighten-1",attrs:{"large":""}},[_vm._v("beenhere")])],1),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('disableAutoInvitation')))])],1)],1)],1)],1):_c('v-chip',{class:{ 'light-blue lighten-4': _vm.visSelectId == _vm.datasVisiteur.visiteurID },on:{"click":_vm.checkChatVisiteur}},[(_vm.datasVisiteur.network)?_c('wz-avatar',{attrs:{"src":_vm.datasVisiteur.profile_pic,"username":_vm.datasVisiteur.visiteurName,"size":"38px","chip":""}}):(!_vm.istypingVisiteur && _vm.visiteurLastMessage && _vm.datasVisiteur.visiteurID != _vm.visSelectId)?_c('wz-avatar',{attrs:{"username":'#' + _vm.datasVisiteur.visiteurID,"size":"38px","lastMessage":""}}):_c('wz-avatar',{attrs:{"isTyping":_vm.istypingVisiteur,"username":'#' + _vm.datasVisiteur.visiteurID,"size":"38px","chip":""}}),_vm._v(" "),(_vm.istypingVisiteur && !_vm.visiteurLastMessage)?_c('span',{staticClass:"wz_decalIdentity"},[_vm._v("\n        "+_vm._s(_vm.identity)+"\n      ")]):(_vm.istypingVisiteur && _vm.visiteurLastMessage)?_c('span',{staticClass:"wz_decalIdentity"},[_vm._v("\n        "+_vm._s(_vm.identity)+"\n      ")]):(!_vm.istypingVisiteur && _vm.visiteurLastMessage && _vm.visSelectId != _vm.datasVisiteur.visiteurID)?_c('span',{staticClass:"wz_nameLastMessage"},[_vm._v("\n        "+_vm._s(_vm.identity)+" "),_c('br'),_vm._v(" "),_c('i',[_vm._v(_vm._s(_vm.visiteurLastMessage))])]):_c('span',[_vm._v("\n        "+_vm._s(_vm.identity)+"\n      ")]),_vm._v(" "),(_vm.dejaEnChat)?_c('wz-avatar',{staticClass:"avatarChipRight",attrs:{"src":(_vm.domaine + "/media/user/small/" + (_vm.dejaEnChat.agentID) + "_avatar.jpg"),"username":_vm.dejaEnChat.agentName}}):_vm._e()],1),_vm._v(" "),(_vm.dejaEnChat)?_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogDejaEnChat),callback:function ($$v) {_vm.dialogDejaEnChat=$$v},expression:"dialogDejaEnChat"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('conversationInProgress'))+" !")]),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.$tc('conversationInProgressWith', 1, {count: _vm.dejaEnChat.agentName}))}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.emitOpenChat()}}},[_vm._v(_vm._s(_vm.$t('yes')))]),_vm._v(" "),_c('v-btn',{attrs:{"flat":""},on:{"click":function($event){_vm.dialogDejaEnChat=false}}},[_vm._v(_vm._s(_vm.$t('no')))])],1)],1)],1):_vm._e()],1)}
var WzWatcheeboxVisiteur_staticRenderFns = []
var WzWatcheeboxVisiteur_esExports = { render: WzWatcheeboxVisiteur_render, staticRenderFns: WzWatcheeboxVisiteur_staticRenderFns }
/* harmony default export */ var watcheebox_WzWatcheeboxVisiteur = (WzWatcheeboxVisiteur_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzWatcheeboxVisiteur.vue
function WzWatcheeboxVisiteur_injectStyle (ssrContext) {
  __webpack_require__("SlQE")
}
var WzWatcheeboxVisiteur_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzWatcheeboxVisiteur___vue_template_functional__ = false
/* styles */
var WzWatcheeboxVisiteur___vue_styles__ = WzWatcheeboxVisiteur_injectStyle
/* scopeId */
var WzWatcheeboxVisiteur___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzWatcheeboxVisiteur___vue_module_identifier__ = null
var WzWatcheeboxVisiteur_Component = WzWatcheeboxVisiteur_normalizeComponent(
  WzWatcheeboxVisiteur,
  watcheebox_WzWatcheeboxVisiteur,
  WzWatcheeboxVisiteur___vue_template_functional__,
  WzWatcheeboxVisiteur___vue_styles__,
  WzWatcheeboxVisiteur___vue_scopeId__,
  WzWatcheeboxVisiteur___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzWatcheeboxVisiteur = (WzWatcheeboxVisiteur_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzWatcheeboxAgent.vue





/* harmony default export */ var WzWatcheeboxAgent = ({
  props: ['datasAgent'], data: function data() {
    return {};
  },
  mounted: function mounted() {},


  methods: {},

  watch: {},

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_StoreWatcheeBox', ['WATCHEEBOX_STATE']), Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['listeChatAgent']), {
    agentInfos: function agentInfos() {
      var avatarURL = '';
      if (false) {
        avatarURL = DOMAINE + '/dev/media/user/small/' + this.datasAgent[7];
      } else {
        avatarURL = constants_DOMAINE + '/media/user/small/' + this.datasAgent[7];
      }
      return {
        'roomName': this.datasAgent[0],
        'agentName': this.datasAgent[1],
        'agentID': this.datasAgent[2],
        'status': this.datasAgent[3],
        'socketID': this.datasAgent[4],
        'conversations': this.datasAgent[5],
        'jobAgent': this.datasAgent[6],
        'avatar': avatarURL,
        'siteID': this.datasAgent[9],
        'entrepriseID': this.datasAgent[10],
        'licences': this.datasAgent[11],
        'chatSessions': this.datasAgent[12],
        'deviceAgent': this.datasAgent[13],
        'tokenFB': this.datasAgent[14],
        'pageFB': this.datasAgent[15],
        'focusAgent': this.datasAgent[16],
        'focusSessionChat': this.datasAgent[17],
        'priority': this.datasAgent[18],
        'keywords': this.datasAgent[19],
        'cobrowsingSessionActive': this.datasAgent[20]
      };
    },
    sessionsChatAgent: function sessionsChatAgent() {
      var _this = this;

      return this.listeChatAgent.filter(function (chat) {
        return chat[3] === _this.datasAgent[2];
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-232cdbde","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzWatcheeboxAgent.vue
var WzWatcheeboxAgent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',{key:_vm.agentInfos.status,staticClass:"itemsListeAgent",attrs:{"ripple":"","id":'agent_' + _vm.agentInfos.agentID}},[_c('wz-avatar',{attrs:{"src":_vm.agentInfos.avatar,"username":_vm.agentInfos.agentName,"size":"38px"}}),_vm._v(" "),_c('div',{staticClass:"statusAgent",class:_vm.agentInfos.status}),_vm._v(" "),_c('v-list-tile-content',{staticClass:"wz_truncate listeAgentName"},[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.agentInfos.agentName))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.agentInfos.jobAgent))])],1),_vm._v(" "),_c('v-badge',{attrs:{"color":"green","overlay":""}},[(_vm.sessionsChatAgent.length)?_c('span',{attrs:{"slot":"badge"},slot:"badge"},[_vm._v(_vm._s(_vm.sessionsChatAgent.length))]):_vm._e()])],1)}
var WzWatcheeboxAgent_staticRenderFns = []
var WzWatcheeboxAgent_esExports = { render: WzWatcheeboxAgent_render, staticRenderFns: WzWatcheeboxAgent_staticRenderFns }
/* harmony default export */ var watcheebox_WzWatcheeboxAgent = (WzWatcheeboxAgent_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzWatcheeboxAgent.vue
function WzWatcheeboxAgent_injectStyle (ssrContext) {
  __webpack_require__("NwMt")
}
var WzWatcheeboxAgent_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzWatcheeboxAgent___vue_template_functional__ = false
/* styles */
var WzWatcheeboxAgent___vue_styles__ = WzWatcheeboxAgent_injectStyle
/* scopeId */
var WzWatcheeboxAgent___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzWatcheeboxAgent___vue_module_identifier__ = null
var WzWatcheeboxAgent_Component = WzWatcheeboxAgent_normalizeComponent(
  WzWatcheeboxAgent,
  watcheebox_WzWatcheeboxAgent,
  WzWatcheeboxAgent___vue_template_functional__,
  WzWatcheeboxAgent___vue_styles__,
  WzWatcheeboxAgent___vue_scopeId__,
  WzWatcheeboxAgent___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzWatcheeboxAgent = (WzWatcheeboxAgent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzListAgents.vue






/* harmony default export */ var WzListAgents = ({
  props: ['agentSelect', 'inMonitoring', 'visiteurSiteID'],

  data: function data() {
    return {
      loading: false,
      visiteurData: null,
      dialogTransfereChat: false,
      selectItem: false,
      chatSelected: null,
      autorizedAgents: [],
      arrayChatSession: []
    };
  },


  methods: {
    selectAgent: function selectAgent(data) {
      if (this.$route.fullPath === '/trafic/monitoring') {
        this.$emit('update:agentSelect', {
          'id': data[2],
          'name': data[1],
          'status': data[3],
          'socketID': data[4]
        });
      } else {
        if (this.transfertStatusEmission.status !== 'wait') {
          this.$emit('update:agentSelect', {
            'id': data[2],
            'name': data[1],
            'status': data[3],
            'socketID': data[4]
          });
        }
      }
    },
    updateVisSelect: function updateVisSelect(visiteurID) {
      this.oldVisSelected = this.visSelected;
      this.visSelected = visiteurID;

      watcheebox_watcheebox.clientConnectRoom({ 'roomName': 'chat_' + visiteurID });

      if (this.oldVisSelected !== null && this.oldVisSelected !== visiteurID) {
        watcheebox_watcheebox.clientQuitRoom({ 'roomName': 'chat_' + this.oldVisSelected });
      }
    },
    updateChat: function updateChat(itemChat) {
      this.$emit('chatSessionSelected', itemChat[0]);
      this.chatSelected = itemChat[0];
    },
    closeChat: function closeChat() {
      this.$emit('chatSessionSelected', 0);
      this.chatSelected = 0;
    }
  },

  watch: {
    'agentSelect': function agentSelect(val, oldval) {
      for (var i = 0; i < this.agentsArray.length; i++) {
        if (document.getElementById('agent_' + this.agentsArray[i][2])) {
          document.getElementById('agent_' + this.agentsArray[i][2]).classList.remove('wzSelectedAgent');
        }
      }

      if (document.getElementById('agent_' + this.agentSelect.id)) {
        document.getElementById('agent_' + this.agentSelect.id).classList.add('wzSelectedAgent');
      }
    },

    'arrayChatSession': function arrayChatSession(val, oldval) {
      if (this.chatSelected) {
        var chackListChat = lodash_default.a.findIndex(val, [0, this.chatSelected]);
        if (chackListChat === -1) {
          console.log('ce chat est plus dispo');
          this.closeChat();
        }
      }
    }
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['agentsArray', 'transfertStatusEmission', 'listeChatAgent', 'listeAllVisiteurs']), Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'fullName']), Object(vuex_esm["c" /* mapGetters */])('_Sites', ['AUTORIZED_AGENTS']), {
    listeAgents: function listeAgents() {
      var _this = this;

      if (!this.inMonitoring) {
        return this.AUTORIZED_AGENTS({
          agentsArray: this.agentsArray,
          siteID: this.visiteurSiteID,
          myID: this.user.id
        });
      } else {
        return this.agentsArray.filter(function (agent) {
          return agent[2] !== _this.user.id;
        });
      }
    },
    sessionsChatAgent: function sessionsChatAgent() {
      var _this2 = this;

      this.arrayChatSession = lodash_default.a.cloneDeep(lodash_default.a.filter(this.listeChatAgent, [3, this.agentSelect.id]));

      lodash_default.a.forEach(this.arrayChatSession, function (chatSession, key) {
        var index = lodash_default.a.findIndex(_this2.listeAllVisiteurs, { 'visiteurID': chatSession[0] });
        if (index === -1) {
          _this2.arrayChatSession[key].push('offline notInList');
        } else {
          if (_this2.listeAllVisiteurs[index].socketID) {
            _this2.arrayChatSession[key].push('online');
          } else {
            _this2.arrayChatSession[key].push('offline');
          }
        }
      });

      return this.arrayChatSession;
    },
    routeNameMonitoring: function routeNameMonitoring() {
      if (this.$route.fullPath === '/trafic/monitoring') {
        return true;
      } else {
        return false;
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75c2cf98","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzListAgents.vue
var WzListAgents_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"wz_viewListAgents"},[_c('v-toolbar',{staticClass:"accent",attrs:{"dark":"","dense":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('listOfAgents')))])],1),_vm._v(" "),(_vm.routeNameMonitoring)?_c('div',{directives:[{name:"bar",rawName:"v-bar"}],staticClass:"ContentListeAgents"},[(_vm.listeAgents.length)?_c('v-expansion-panel',{attrs:{"focusable":""}},[_vm._l((_vm.listeAgents),function(itemAgent,i){return _c('v-expansion-panel-content',{key:i,nativeOn:{"click":function($event){_vm.selectAgent(itemAgent)}}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('wz-watcheebox-agent',{attrs:{"datasAgent":itemAgent},on:{"loading":function($event){_vm.loading = true}}})],1),_vm._v(" "),_c('v-list',{staticClass:"listeChatsAgents"},[_vm._l((_vm.sessionsChatAgent),function(itemChat,a){return [_c('v-list-tile',{key:a,class:{ 'grey lighten-5': _vm.chatSelected == itemChat[0] },attrs:{"ripple":""}},[(itemChat[5] == 'online')?_c('v-icon',{attrs:{"medium":"","color":"light-green"}},[_vm._v("\n                  textsms\n                  ")]):_c('v-icon',{attrs:{"medium":"","color":"red"}},[_vm._v("\n                  mode_comment\n                  ")]),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(_vm.$tc('visitors', 1, {count: ''}))},on:{"click":function($event){_vm.updateChat(itemChat)}}}),_vm._v(" "),_c('v-list-tile-sub-title',{domProps:{"innerHTML":_vm._s(itemChat[0])},on:{"click":function($event){_vm.updateChat(itemChat)}}})],1)],1)]})],2)],1)}),_vm._v(" "),(_vm.loading)?_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"flex":"","align-center":"","justify-center":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1)],1)],1)],1):_vm._e()],2):_c('div',{staticClass:"listeAgentsEmpty"},[_vm._v("Aucun agent disponible")])],1):_c('div',{directives:[{name:"bar",rawName:"v-bar"}],staticClass:"ContentListeAgentsClassic"},[(_vm.listeAgents.length)?_c('v-list',{staticClass:"listeAgents"},[_vm._l((_vm.listeAgents),function(item,i){return [_c('wz-watcheebox-agent',{key:i,attrs:{"datasAgent":item},on:{"loading":function($event){_vm.loading = true}},nativeOn:{"click":function($event){_vm.selectAgent(item)}}})]}),_vm._v(" "),(_vm.loading)?_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"flex":"","align-center":"","justify-center":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1)],1)],1)],1):_vm._e()],2):_c('div',{staticClass:"listeAgentsEmpty"},[_vm._v("Aucun agent disponible")])],1)],1)}
var WzListAgents_staticRenderFns = []
var WzListAgents_esExports = { render: WzListAgents_render, staticRenderFns: WzListAgents_staticRenderFns }
/* harmony default export */ var watcheebox_WzListAgents = (WzListAgents_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzListAgents.vue
function WzListAgents_injectStyle (ssrContext) {
  __webpack_require__("BdYg")
}
var WzListAgents_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzListAgents___vue_template_functional__ = false
/* styles */
var WzListAgents___vue_styles__ = WzListAgents_injectStyle
/* scopeId */
var WzListAgents___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzListAgents___vue_module_identifier__ = null
var WzListAgents_Component = WzListAgents_normalizeComponent(
  WzListAgents,
  watcheebox_WzListAgents,
  WzListAgents___vue_template_functional__,
  WzListAgents___vue_styles__,
  WzListAgents___vue_scopeId__,
  WzListAgents___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzListAgents = (WzListAgents_Component.exports);

// CONCATENATED MODULE: ./src/components/watcheebox/tree-mirror.js



var tree_mirror_TreeMirror = function () {
  window.TataMirror = !window.TataMirror ? [] : window.TataMirror;
  window.TataMirror.push(new Date());
  function TreeMirror(root, delegate) {
    this.root = root;
    this.delegate = delegate;
    this.idMap = {};
  }
  TreeMirror.prototype.initialize = function (rootId, children) {
    this.idMap[rootId] = this.root;
    for (var i = 0; i < children.length; i++) {
      this.deserializeNode(children[i], this.root);
    }
  };
  TreeMirror.prototype.applyChanged = function (removed, addedOrMoved, attributes, text) {
    var _this = this;

    addedOrMoved.forEach(function (data) {
      var node = _this.deserializeNode(data);
      var parent = _this.deserializeNode(data.parentNode);


      if (node.contains(parent) === false && node instanceof window.HTMLElement === true && parent instanceof window.HTMLElement === true && node.parentNode) {
        node.parentNode.removeChild(node);
      }
    });
    removed.forEach(function (data) {
      var node = _this.deserializeNode(data);

      if (node) {
        if (node.parentNode) {
          node.parentNode.removeChild(node);
        }
      }
    });

    addedOrMoved.forEach(function (data) {
      var node = _this.deserializeNode(data);
      var parent = _this.deserializeNode(data.parentNode);
      var previous = _this.deserializeNode(data.previousSibling);

      try {
        if (!node.contains(parent) && node instanceof window.HTMLElement === true && parent instanceof window.HTMLElement === true) {
          parent.insertBefore(node, previous ? previous.nextSibling : parent.firstChild);
        } else if (node instanceof window.HTMLElement && node.nodeName === 'HTML' && _this.root instanceof window.HTMLDocument && _this.root.contains(node) === false) {
          _this.root.appendChild(node);
        } else {
          if (parent.nodeName === 'TEXTAREA') {
            parent.value = data.textContent;
            parent.innerHTML = data.textContent;
          } else if (parent.nodeName === 'INPUT') {
            parent.value = data.textContent;
          }
        }
      } catch (e) {
        if (parent instanceof window.HTMLDocument && previous instanceof window.HTMLElement && parent.contains(previous)) {
          if (previous.firstChild) {
            previous.insertBefore(node, previous.firstChild);
          } else {
            previous.appendChild(node);
          }
        }

        if (_this.debug) {
          console.log(e);
        }
      }
    });

    attributes.forEach(function (data) {
      var node = _this.deserializeNode(data);
      keys_default()(data.attributes).forEach(function (attrName) {
        var newVal = data.attributes[attrName];

        if (newVal === null) {
          node.removeAttribute(attrName);
        } else {
          if (attrName === 'innerhtml') {
            node.innerHTML = newVal;
          }
          try {
            if (!_this.delegate || !_this.delegate.setAttribute || !_this.delegate.setAttribute(node, attrName, newVal)) {
              node.setAttribute(attrName, newVal);
            }
          } catch (e) {}
        }
      });
    });

    text.forEach(function (data) {
      var node = _this.deserializeNode(data);

      if (node) {
        node.textContent = data.textContent;
      }
    });

    removed.forEach(function (node) {
      delete _this.idMap[node.id];
    });
  };

  TreeMirror.prototype.deserializeNode = function (nodeData, parent) {
    var _this = this;
    if (nodeData === null) {
      return null;
    }

    var node = this.idMap[nodeData.id];
    if (node) {
      return node;
    }

    var doc = this.root.ownerDocument;
    if (doc === null) {
      doc = this.root;
    }

    switch (nodeData.nodeType) {
      case window.Node.COMMENT_NODE:
        node = doc.createComment(nodeData.textContent);
        break;

      case window.Node.TEXT_NODE:
        node = doc.createTextNode(nodeData.textContent);
        break;

      case window.Node.DOCUMENT_TYPE_NODE:
        node = doc.implementation.createDocumentType(nodeData.name, nodeData.publicId, nodeData.systemId);
        break;

      case window.Node.ELEMENT_NODE:
        if (this.delegate && this.delegate.createElement) {
          node = this.delegate.createElement(nodeData.tagName);
        }
        if (!node) {
          node = doc.createElement(nodeData.tagName);
        }
        keys_default()(nodeData.attributes).forEach(function (name) {
          try {
            if (!_this.delegate || !_this.delegate.setAttribute || !_this.delegate.setAttribute(node, name, nodeData.attributes[name])) {
              node.setAttribute(name, nodeData.attributes[name]);
            }
          } catch (e) {}
        });

        break;
    }

    if (!node) {}

    this.idMap[nodeData.id] = node;

    if (parent) {
      parent.appendChild(node);
    }

    if (nodeData.childNodes) {
      for (var i = 0; i < nodeData.childNodes.length; i++) {
        this.deserializeNode(nodeData.childNodes[i], node);
      }
    }
    return node;
  };
  return TreeMirror;
}();


// CONCATENATED MODULE: ./src/components/watcheebox/cobrowsing.js





var cobrowsing_Cobrowsing = function () {
  function Cobrowsing() {
    this.mirror = null;
    this.mirrorClient = null;
    this.oDOM = null;
    this.base = '';
    this.vue = new vue_esm["default"]();
    this.iframeCibleCobrowsing = null;
    this.clientScroll = false;
    this.scrollPos = 0;
    this.arrayInput = [];
  }

  Cobrowsing.prototype.getIframeContent = function (DomElm) {
    var iframe = DomElm;
    var iframeDocument = iframe.contentDocument || iframe.contentWindow.document;
    return iframeDocument;
  };

  Cobrowsing.prototype.ResizePreview = function (width, height, DomElm) {
    DomElm.width = width + 'px';
    DomElm.height = height + 'px';
  };

  Cobrowsing.prototype.MoveMouse = function (x, y, DomElm) {
    DomElm.style.left = x + 'px';
    DomElm.style.top = y + 'px';
  };

  Cobrowsing.prototype.ClickMouse = function (x, y, DomElm) {
    var ClickPointer = DomElm;
    ClickPointer.style.left = x + 'px';
    ClickPointer.style.top = y + 'px';
    ClickPointer.classList.toggle('click');
    setTimeout(function () {
      ClickPointer.classList.toggle('click');
    }, 1000);
  };

  Cobrowsing.prototype.demandeCobrowsing = function (data) {
    console.log('DemandeCobrowsing', data);
    new vue_esm["default"]().$socket.emit('DemandeCobrowsing', {
      demandeActive: data.active,
      datasAgent: data.datasAgent,
      agentSocketID: data.agentSocketID,
      cibleSocketID: data.datasVisiteur.socketID,
      placePupitre: data.placePupitre
    });
  };

  Cobrowsing.prototype.startSession = function (agentSocket, infoAgent, infoVisiteur, isCobrowsing) {
    new vue_esm["default"]().$socket.emit('CreateSession', {
      chatSession: infoVisiteur.visiteurID
    });
    new vue_esm["default"]().$socket.emit('StartCobrowsing', {
      roomName: infoVisiteur.roomName,
      agentID: infoAgent.id,
      chatSession: infoVisiteur.visiteurID,
      agentSocketID: agentSocket,
      clientSocketID: infoVisiteur.socketID,
      status: 'add',
      cobrowsing: isCobrowsing
    });
  };

  Cobrowsing.prototype.SessionStarted = function (DomElm) {
    var _this = this;
    this.scrollPos = 0;
    this.iframeCibleCobrowsing = this.getIframeContent(DomElm);
    while (this.iframeCibleCobrowsing.firstChild) {
      this.iframeCibleCobrowsing.removeChild(this.iframeCibleCobrowsing.firstChild);
    }
    console.log('start session --> iframeCibleCobrowsing', this.iframeCibleCobrowsing);

    this.mirror = new tree_mirror_TreeMirror(this.iframeCibleCobrowsing, {
      createElement: function createElement(tagName) {
        var node;
        if (tagName === 'SCRIPT') {
          node = _this.iframeCibleCobrowsing.createElement('NO-SCRIPT');
          node.style.display = 'none';
          if (typeof node !== 'string') {
            if ((typeof node === 'undefined' ? 'undefined' : typeof_default()(node)) === 'object') {}
          }
          return node;
        }

        if (tagName === 'HEAD') {
          node = _this.iframeCibleCobrowsing.createElement('HEAD');
          node.appendChild(_this.iframeCibleCobrowsing.createElement('BASE'));
          node.firstChild.href = _this.base;
          return node;
        }
      }
    });
  };

  Cobrowsing.prototype.mirrorChange = function (dataJson, visiteurInfos, DomElm) {
    var _this2 = this;

    var data = dataJson.data.change;

    if (data) {
      if (data.base) {
        this.base = data.base;
      }
      if (data.height) {
        this.ResizePreview(data.width, data.height, DomElm);
      }
      if (data.args) {
        try {
          this.mirror[data.f].apply(this.mirror, data.args);
        } catch (err) {
          console.log('erreur mirroring', err);
        }
        if (data.f === 'applyChanged') {
          data.args[2].forEach(function (dataElement, key) {
            var index = _this2.arrayInput.findIndex(function (i) {
              return i === dataElement.id;
            });
            if (index !== -1) {
              var char = '*';
              var newText = '';

              for (var i = 0; i < dataElement.attributes.value.length; ++i) {
                newText = newText + char;
              }
              _this2.mirror.idMap[dataElement.id].value = newText;
            } else {
              if (dataElement.attributes.value) {
                _this2.mirror.idMap[dataElement.id].value = dataElement.attributes.value;
              }
            }
          });
        }
        if (data.f === 'initialize') {
          new vue_esm["default"]().$socket.emit('DOMLoaded', { room: dataJson.chatSession });
          console.log('DOMLoaded --> iframeCibleCobrowsing', this.iframeCibleCobrowsing);
          if (this.iframeCibleCobrowsing.getElementById('AdminPointer')) {
            this.iframeCibleCobrowsing.getElementById('AdminPointer').classList.add('inactifForCobrowsing');
          }

          this.iframeCibleCobrowsing.getElementsByTagName('html')[0].style.overflowX = 'inherit';
        }
      }
      if (data.scroll) {
        this.clientScroll = true;
        this.scrollPos = data.scroll;
        if (DomElm) {
          this.getIframeContent(DomElm).body.scrollTo(0, data.scroll);
        } else {
          document.getElementById('ClientView_' + visiteurInfos.placePupitre).contentDocument.body.scrollTo(0, data.scroll);
        }
      }
    }
  };

  Cobrowsing.prototype.fermeCobrowsing = function (data) {
    console.log('fermeCobrowsing', data);
    new vue_esm["default"]().$socket.emit('StopCobrowsing', {
      roomName: data.datasAgent.entKey,
      agentID: data.datasAgent.id,
      chatSession: data.datasVisiteur.visiteurID,
      agentSocketID: data.agentSocketID,
      clientSocketID: data.datasVisiteur.socketID,
      status: 'remove'
    });
  };

  Cobrowsing.prototype.DOMLoadedOk = function (dataJson, visiteurInfos) {
    var _this3 = this;

    if (visiteurInfos.visiteurID === dataJson.chatSession) {}
    console.log('mirror ', this.mirror);
    lodash_default.a.forEach(this.mirror.idMap, function (dataElement, key) {
      if (dataElement && dataElement.nodeName === 'INPUT' && (dataElement.type === 'number' || dataElement.type === 'tel')) {
        if (dataElement.required === 'required' || dataElement.maxLength === 3 || dataElement.maxLength === 4 || dataElement.maxLength === 15 || dataElement.maxLength === 16 || dataElement.maxLength === 17 || dataElement.maxLength === 18 || dataElement.maxLength === 19 || dataElement.maxLength === 20) {
          if (dataElement.value.length) {
            var char = '*';
            var newText = '';

            for (var i = 0; i < dataElement.value.length; ++i) {
              newText = newText + char;
            }
            dataElement.value = newText;
          }

          _this3.arrayInput.push(parseInt(key));
        }
      }
    });
  };

  Cobrowsing.prototype.ClientMousePos = function (dataJson, visiteurInfos, pointer, datasIframeCobrowsing, DomElm) {
    var data = dataJson.data;
    if (DomElm) {
      var rect = DomElm.getBoundingClientRect();
      var yOffsetDomElm = rect.top;
      var xOffsetDomElm = rect.left;
      if (visiteurInfos.visiteurID === dataJson.data.session) {
        this.MoveMouse(Math.floor(data.PositionLeft * datasIframeCobrowsing.ratio + xOffsetDomElm), Math.floor(data.PositionTop * datasIframeCobrowsing.ratio + yOffsetDomElm - this.scrollPos * datasIframeCobrowsing.ratio), pointer);
      }
    }
  };

  Cobrowsing.prototype.ClientMouseClick = function (dataJson, visiteurInfos, pointer, datasIframeCobrowsing, DomElm) {
    var data = dataJson.data;

    var rect = DomElm.getBoundingClientRect();
    var yOffsetDomElm = rect.top;
    var xOffsetDomElm = rect.left;
    if (visiteurInfos.visiteurID === data.session) {
      this.ClickMouse(Math.floor(data.PositionLeft * datasIframeCobrowsing.ratio + xOffsetDomElm), Math.floor(data.PositionTop * datasIframeCobrowsing.ratio + yOffsetDomElm - this.scrollPos * datasIframeCobrowsing.ratio), pointer);
    }
  };

  Cobrowsing.prototype.clientScrollView = function (data, theCallback) {
    theCallback({ clientScroll: this.clientScroll });
  };

  Cobrowsing.prototype.AgentEvent = function (data) {
    if (data.typeEvent === 'scrollPage') {
      this.scrollPos = data.dataEvent.scrollTop;
    }

    this.clientScroll = false;
    new vue_esm["default"]().$socket.emit('AgentEvent', {
      typeEvent: data.typeEvent,
      room: data.datasVisiteur.visiteurID,
      dataEvent: data.dataEvent
    });
  };
  return Cobrowsing;
}();

/* harmony default export */ var watcheebox_cobrowsing = (cobrowsing_Cobrowsing);
// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzCobrowsingClient.vue





/* harmony default export */ var WzCobrowsingClient = ({
  data: function data() {
    return {
      datasCobrowsingIframe: {
        'conteneurHauteur': 200,
        'conteneurLargeur': 200,
        'hauteur': 200,
        'largeur': 200,
        'ratio': 1,
        'posLeft': 100,
        'posTop': 100,
        'posPointeurLeft': 100,
        'posPointeurTop': 100
      },
      pointer: null,
      clickPointer: null,
      iframeCobrowsing: null,
      cobrowsingAlertStatus: false,
      mirroring: 0,
      conteneurCobrowsing: null,
      conteneurCobrowsingHeight: null,
      loadingMirroring: false,
      clientChangeVue: false,
      txtBtCobrowsing: 'Fermer',
      cobrowsing: null,
      timeoutVisiteur: null,
      socketConnected: this.socketIsConnected,
      cobrowsingMenuActif: false
    };
  },


  props: ['datasVisiteur', 'datasPupitreVisiteur', 'hauteurDiv'],

  sockets: {
    SessionCobrowsingStarted: function SessionCobrowsingStarted(data) {},

    SessionStarted: function SessionStarted(data) {
      console.log('### SessionStarted ###');
      this.cobrowsingAlertStatus = false;

      if (this.datasVisiteur.visiteurID === data.chatSession) {
        console.log("c'est uniquement pour " + data.chatSession);
        this.cobrowsing.SessionStarted(this.iframeCobrowsing);
      }
    },

    changes: function changes(data) {
      if (this.datasVisiteur.visiteurID === data.chatSession) {
        this.cobrowsing.mirrorChange(data, this.datasVisiteur, this.iframeCobrowsing, this.datasCobrowsingIframe);
        if (data.data.change.base) {
          this.loadingMirroring = true;
        }
        if (data.data.change.scroll) {}

        this.fenetreCobrowPosition();
      }
    },

    DOM_Loaded: function DOM_Loaded(data) {
      if (this.datasVisiteur.visiteurID === data.chatSession) {
        this.cobrowsing.DOMLoadedOk(data, this.datasVisiteur);

        this.loadingMirroring = false;
      }
    },

    ClientMousePosition: function ClientMousePosition(data) {
      if (this.datasVisiteur.visiteurID === data.chatSession) {
        this.cobrowsing.ClientMousePos(data, this.datasVisiteur, this.pointer, this.datasCobrowsingIframe, this.iframeCobrowsing);
      }
    },

    ClientMouseClick: function ClientMouseClick(data) {
      if (this.datasVisiteur.visiteurID === data.chatSession) {
        this.cobrowsing.ClientMouseClick(data, this.datasVisiteur, this.clickPointer, this.datasCobrowsingIframe, this.iframeCobrowsing);
      }
    },

    AdminMousePosition: function AdminMousePosition(data) {},

    VisiteurCobrowsingStoped: function VisiteurCobrowsingStoped(data) {
      console.log('### VisiteurCobrowsingStoped ###', data);
      if (this.datasVisiteur.visiteurID === data.chatSession) {
        this.cobrowsingAlertStatus = true;
      }
    }

  },

  watch: {
    'datasPupitreVisiteur.cobrowsing': function datasPupitreVisiteurCobrowsing(val, oldval) {
      if (!val) {
        this.fermeCobrowsing();
      }
    },

    'datasPupitreVisiteur.visiteurDatas.socketID': function datasPupitreVisiteurVisiteurDatasSocketID(val, oldval) {
      var _this2 = this;

      console.log('datasPupitreVisiteur -->', val, oldval);
      if (!val) {
        this.timeoutVisiteur = setTimeout(function () {
          if (!_this2.datasPupitreVisiteur.visiteurDatas.socketID) {
            if (_this2.datasPupitreVisiteur.visiteurDatas.menuSelected === 'cobrowsing') {
              _this2.cobrowsingAlertStatus = true;
            }
          }
        }, 10000);
      } else if (val !== oldval) {
        console.log('cobrowsing Menu Actif ?', this.datasPupitreVisiteur.visiteurDatas.menuSelected);
        if (this.datasPupitreVisiteur.visiteurDatas.menuSelected === 'cobrowsing') {
          clearTimeout(this.timeoutVisiteur);
          this.cobrowsingAlertStatus = false;
        }
      }
    },

    'cobrowsingActif': function cobrowsingActif(val, oldval) {},

    'isConnected': function isConnected(val, oldval) {
      console.log('-> isConnected : ', val);
    }
  },

  methods: {
    openCobrow: function openCobrow() {
      this.loadingMirroring = true;
      console.log('openCobrow');
      console.log(this.datasVisiteur);
      var agentSocketID = this.WATCHEEBOX_STATE.mySocketID;

      var isCobrowsing = false;
      if (this.datasPupitreVisiteur.visiteurDatas.menuSelected === 'cobrowsing') {
        isCobrowsing = true;
      }
      console.log('isCobrowsing', isCobrowsing);
      console.log('agentSocketID', agentSocketID);
      console.log('socket', this.$socket);
      this.cobrowsing.startSession(agentSocketID, this.user, this.datasVisiteur, isCobrowsing);
    },
    fermeCobrowsing: function fermeCobrowsing() {
      console.log('ferme cobrowsing', this.datasVisiteur);
      var agentSocketID = this.WATCHEEBOX_STATE.mySocketID;
      this.cobrowsing.fermeCobrowsing({ 'agentSocketID': agentSocketID, 'datasAgent': this.user, 'datasVisiteur': this.datasVisiteur });
    },
    closeCobrowsing: function closeCobrowsing() {
      console.log('close');
      this.cobrowsingAlertStatus = false;
      this.$emit('closeCobrowsing');
    },

    fenetreCobrowPosition: function fenetreCobrowPosition() {
      this.datasCobrowsingIframe.conteneurHauteur = this.conteneurCobrowsing.offsetHeight;
      this.datasCobrowsingIframe.conteneurLargeur = this.conteneurCobrowsing.offsetWidth;

      this.datasCobrowsingIframe.hauteur = this.iframeCobrowsing.offsetHeight;
      this.datasCobrowsingIframe.largeur = this.iframeCobrowsing.offsetWidth;

      var rect = this.iframeCobrowsing.getBoundingClientRect();
      this.datasCobrowsingIframe.posLeft = Math.floor(rect.left);
      this.datasCobrowsingIframe.posTop = Math.floor(rect.top);
      var decalHauteur = this.datasCobrowsingIframe.conteneurHauteur / 2 - this.datasCobrowsingIframe.hauteur / 2;
      var decalLargeur = this.datasCobrowsingIframe.conteneurLargeur / 2 - this.datasCobrowsingIframe.largeur / 2;

      var ratioLargeur = this.datasCobrowsingIframe.conteneurLargeur / this.datasCobrowsingIframe.largeur;
      var ratioHauteur = this.datasCobrowsingIframe.conteneurHauteur / this.datasCobrowsingIframe.hauteur;

      if (this.datasCobrowsingIframe.largeur < this.datasCobrowsingIframe.conteneurLargeur && this.datasCobrowsingIframe.hauteur < this.datasCobrowsingIframe.conteneurHauteur) {
        this.datasCobrowsingIframe.ratio = 1;
      } else {
        this.datasCobrowsingIframe.ratio = Math.min(ratioLargeur, ratioHauteur);
      }
      this.iframeCobrowsing.style.webkitTransform = 'translate(' + decalLargeur + 'px, ' + decalHauteur + 'px) scale(' + this.datasCobrowsingIframe.ratio + ')';
      this.iframeCobrowsing.style.transform = 'translate(' + decalLargeur + 'px, ' + decalHauteur + 'px) scale(' + this.datasCobrowsingIframe.ratio + ')';
    },

    myMouseCoordinates: function myMouseCoordinates(event) {
      var posLeft = Math.round(event.pageX);
      var posTop = Math.round(event.pageY);
      this.cobrowsing.AgentEvent({
        'typeEvent': 'mousePos',
        'datasVisiteur': this.datasVisiteur,
        'dataEvent': {
          'posLeft': posLeft,
          'posTop': posTop
        }
      });
    },
    myScrollTop: function myScrollTop(event) {
      this.cobrowsing.AgentEvent({
        'typeEvent': 'scrollPage',
        'datasVisiteur': this.datasVisiteur,
        'dataEvent': {
          'scrollTop': event.scrollTop
        }
      });
    },
    myClickMouse: function myClickMouse(event) {
      console.log('clickMouse', event.mouseClickDiv);
      this.cobrowsing.AgentEvent({
        'typeEvent': 'clickMouse',
        'datasVisiteur': this.datasVisiteur,
        'dataEvent': {
          'eventClick': event.mouseClickDiv
        }
      });
    },
    myKeyPRESS: function myKeyPRESS(event) {
      this.cobrowsing.AgentEvent({
        'typeEvent': 'keyPress',
        'datasVisiteur': this.datasVisiteur,
        'dataEvent': {
          'eventKeyUP': event.mouseKeyUp
        }
      });
    },
    bindIFrameEventMirroring: function bindIFrameEventMirroring(iframe) {
      this.$el.parentNode.addEventListener('scroll', function (event) {});
    },
    bindIFrameEventCobrowsing: function bindIFrameEventCobrowsing(iframe) {
      var _this = this;
      if (this.hauteurDiv) {
        this.$emit('update:hauteurDiv', this.hauteurDiv + 100);
      }

      iframe.contentWindow.addEventListener('mousemove', function (event) {
        var evt = new CustomEvent('mousemove', { bubbles: true, cancelable: false });
        evt.pageX = event.pageX;
        evt.pageY = event.pageY;
        iframe.dispatchEvent(evt);
      });

      iframe.contentWindow.addEventListener('scroll', function (event) {
        _this.cobrowsing.clientScrollView('scroll', function (returnData) {
          if (!returnData.clientScroll) {
            if (event.target.scrollingElement.scrollTop) {
              var evt = new CustomEvent('scroll', { bubbles: true, cancelable: false });
              evt.scrollTop = event.target.scrollingElement.scrollTop;
              iframe.dispatchEvent(evt);
            }
          }
        });
      });

      iframe.contentWindow.addEventListener('click', function (event) {
        var evt = new CustomEvent('click', { bubbles: true, cancelable: false });
        var hrefReference = '';

        if (event.target.tagName !== 'SELECT' && event.target.tagName !== 'INPUT' && event.target.tagName !== 'BUTTON') {
          if (!event.target.onclick && !event.target.href) {
            if (event.target.parentElement.tagName !== 'SELECT' && event.target.parentElement.tagName !== 'INPUT' && event.target.parentElement.tagName !== 'BUTTON') {
              if (!event.target.parentElement.onclik && !event.target.parentElement.href) {
                if (event.target.parentElement.parentElement.tagName !== 'SELECT' && event.target.parentElement.parentElement.tagName !== 'INPUT' && event.target.parentElement.parentElement.tagName !== 'BUTTON') {
                  if (!event.target.parentElement.parentElement.onclik && !event.target.parentElement.parentElement.href) {
                    if (event.target.parentElement.parentElement.parentElement.tagName !== 'SELECT' && event.target.parentElement.parentElement.parentElement.tagName !== 'INPUT' && event.target.parentElement.parentElement.parentElement.tagName !== 'BUTTON') {
                      if (!event.target.parentElement.parentElement.parentElement.onclik && !event.target.parentElement.parentElement.parentElement.href) {
                        console.log('pas trouvé d\'evenement au 4eme niveau');
                        evt.mouseClickDiv = {
                          'id': event.target.parentElement.parentElement.parentElement.id,
                          'className': event.target.parentElement.parentElement.parentElement.className,
                          'mousePosX': event.pageX,
                          'mousePosY': event.pageY
                        };
                      } else {
                        console.log('niveau -3');

                        if (event.target.parentElement.parentElement.parentElement.attributes.href.value && event.target.parentElement.parentElement.parentElement.attributes.href.value !== '#') {
                          hrefReference = event.target.parentElement.parentElement.parentElement.href;
                        }
                        evt.mouseClickDiv = {
                          'id': event.target.parentElement.parentElement.parentElement.id,
                          'href': hrefReference,
                          'type': event.target.parentElement.parentElement.parentElement.type,
                          'tagName': event.target.parentElement.parentElement.parentElement.tagName,
                          'selectedIndex': event.target.parentElement.parentElement.parentElement.selectedIndex,
                          'checked': event.target.parentElement.parentElement.parentElement.checked,
                          'value': event.target.parentElement.parentElement.parentElement.value,
                          'name': event.target.parentElement.parentElement.parentElement.name,
                          'className': event.target.parentElement.parentElement.parentElement.className,
                          'mousePosX': event.pageX,
                          'mousePosY': event.pageY
                        };
                      }
                    } else {
                      evt.mouseClickDiv = {
                        'id': event.target.parentElement.parentElement.parentElement.id,
                        'href': event.target.parentElement.parentElement.parentElement.href,
                        'type': event.target.parentElement.parentElement.parentElement.type,
                        'tagName': event.target.parentElement.parentElement.parentElement.tagName,
                        'selectedIndex': event.target.parentElement.parentElement.parentElement.selectedIndex,
                        'checked': event.target.parentElement.parentElement.parentElement.checked,
                        'value': event.target.parentElement.parentElement.parentElement.value,
                        'name': event.target.parentElement.parentElement.parentElement.name,
                        'className': event.target.parentElement.parentElement.parentElement.className,
                        'mousePosX': event.pageX,
                        'mousePosY': event.pageY
                      };
                    }
                  } else {
                    console.log('niveau -2');

                    if (event.target.parentElement.parentElement.attributes.href.value && event.target.parentElement.parentElement.attributes.href.value !== '#') {
                      hrefReference = event.target.parentElement.parentElement.href;
                    }
                    evt.mouseClickDiv = {
                      'id': event.target.parentElement.parentElement.id,
                      'href': hrefReference,
                      'type': event.target.parentElement.parentElement.type,
                      'tagName': event.target.parentElement.parentElement.tagName,
                      'selectedIndex': event.target.parentElement.parentElement.selectedIndex,
                      'checked': event.target.parentElement.parentElement.checked,
                      'value': event.target.parentElement.parentElement.value,
                      'name': event.target.parentElement.parentElement.name,
                      'className': event.target.parentElement.parentElement.className,
                      'mousePosX': event.pageX,
                      'mousePosY': event.pageY
                    };
                  }
                } else {
                  evt.mouseClickDiv = {
                    'id': event.target.parentElement.parentElement.id,
                    'href': event.target.parentElement.parentElement.href,
                    'type': event.target.parentElement.parentElement.type,
                    'tagName': event.target.parentElement.parentElement.tagName,
                    'selectedIndex': event.target.parentElement.parentElement.selectedIndex,
                    'checked': event.target.parentElement.parentElement.checked,
                    'value': event.target.parentElement.parentElement.value,
                    'name': event.target.parentElement.parentElement.name,
                    'className': event.target.parentElement.parentElement.className,
                    'mousePosX': event.pageX,
                    'mousePosY': event.pageY
                  };
                }
              } else {
                console.log('niveau -1');
                console.log(event.target.parentElement.attributes.href.value);

                if (event.target.parentElement.attributes.href.value && event.target.parentElement.attributes.href.value !== '#') {
                  hrefReference = event.target.parentElement.href;
                }
                evt.mouseClickDiv = {
                  'id': event.target.parentElement.id,
                  'href': hrefReference,
                  'type': event.target.parentElement.type,
                  'tagName': event.target.parentElement.tagName,
                  'selectedIndex': event.target.parentElement.selectedIndex,
                  'checked': event.target.parentElement.checked,
                  'value': event.target.parentElement.value,
                  'name': event.target.parentElement.name,
                  'className': event.target.parentElement.className,
                  'mousePosX': event.pageX,
                  'mousePosY': event.pageY
                };
              }
            } else {
              evt.mouseClickDiv = {
                'id': event.target.parentElement.id,
                'href': event.target.parentElement.href,
                'type': event.target.parentElement.type,
                'tagName': event.target.parentElement.tagName,
                'selectedIndex': event.target.parentElement.selectedIndex,
                'checked': event.target.parentElement.checked,
                'value': event.target.parentElement.value,
                'name': event.target.parentElement.name,
                'className': event.target.parentElement.className,
                'mousePosX': event.pageX,
                'mousePosY': event.pageY
              };
            }
          } else {
            console.log('niveau 0');
            console.log('event.target', event.target);

            if (event.target.attributes.href && event.target.attributes.href.value !== '#') {
              hrefReference = event.target.href;
            }
            evt.mouseClickDiv = {
              'id': event.target.id,
              'href': hrefReference,
              'type': event.target.type,
              'tagName': event.target.tagName,
              'selectedIndex': event.target.selectedIndex,
              'checked': event.target.checked,
              'value': event.target.value,
              'name': event.target.name,
              'className': event.target.className,
              'mousePosX': event.pageX,
              'mousePosY': event.pageY
            };
          }
        } else {
          console.log('click mouse sur :', event.target.type);
          evt.mouseClickDiv = {
            'id': event.target.id,
            'href': event.target.href,
            'type': event.target.type,
            'tagName': event.target.tagName,
            'selectedIndex': event.target.selectedIndex,
            'checked': event.target.checked,
            'value': event.target.value,
            'name': event.target.name,
            'className': event.target.className,
            'mousePosX': event.pageX,
            'mousePosY': event.pageY
          };
        }
        iframe.dispatchEvent(evt);
        event.preventDefault();
      });

      iframe.contentWindow.addEventListener('keyup', function (event) {
        var evt = new CustomEvent('keyup', { bubbles: true, cancelable: false });

        console.log('keyUp', event);

        if (event.target.nodeName === 'TEXTAREA') {} else if (event.target.nodeName === 'INPUT') {
          console.log('un input');
        }
        evt.mouseKeyUp = {
          'id': event.target.id,
          'href': event.target.href,
          'type': event.target.type,
          'tagName': event.target.tagName,
          'selectedIndex': event.target.selectedIndex,
          'value': event.target.value,
          'name': event.target.name,
          'className': event.target.className,
          'mousePosX': event.pageX,
          'mousePosY': event.pageY
        };
        iframe.dispatchEvent(evt);
        event.preventDefault();
      });
    }
  },

  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_User', ['user']), Object(vuex_esm["c" /* mapGetters */])('_StoreWatcheeBox', ['WATCHEEBOX_STATE']), Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['cobrowsingActif', 'isConnected'])),

  mounted: function mounted() {
    this.cobrowsing = new watcheebox_cobrowsing();
    this.openCobrow();

    this.pointer = this.$refs.iconeClientPointer;
    this.clickPointer = this.$refs.ClickPointer;
    this.iframeCobrowsing = this.$refs.iframeClientView;
    this.conteneurCobrowsing = this.$el;
    var rect = this.pointer.getBoundingClientRect();
    console.log('rect', rect);
    this.datasCobrowsingIframe.posPointeurLeft = Math.floor(rect.left);
    this.datasCobrowsingIframe.posPointeurTop = Math.floor(rect.top);
    console.log('this.datasCobrowsingIframe', this.datasCobrowsingIframe);

    if (this.datasPupitreVisiteur.visiteurDatas.menuSelected === 'cobrowsing') {
      this.bindIFrameEventCobrowsing(this.iframeCobrowsing);
      this.cobrowsingMenuActif = true;
    } else {
      this.bindIFrameEventMirroring(this.iframeCobrowsing);
      this.cobrowsingMenuActif = false;
    }
    console.log('this.cobrowsing', this.cobrowsing);
  },
  beforeDestroy: function beforeDestroy() {
    console.log('beforeDestroy');
    this.fermeCobrowsing();
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2c67dc6a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzCobrowsingClient.vue
var WzCobrowsingClient_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"cobrowsing__container",attrs:{"height":"100%"}},[(_vm.loadingMirroring)?_c('div',{staticClass:"wz_loadingCobrowsing text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text ",attrs:{"size":70,"width":1,"indeterminate":""}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"vue-frame fill-height"},[_vm._v("\n      "+_vm._s(_vm.socketConnected)+"\n      "),_c('div',{ref:"iconeClientPointer",staticClass:"iconeClientPointer"},[_c('div',{staticClass:"pointerNameUser"},[_vm._v("\n          "+_vm._s(_vm.datasPupitreVisiteur.visiteurID)+"\n        ")])]),_vm._v(" "),_c('div',{ref:"ClickPointer",staticClass:"ClickPointer"}),_vm._v(" "),_c('div',{staticClass:"fill-height"},[(_vm.cobrowsingAlertStatus)?_c('div',{staticClass:"dialogueIframe"},[_c('v-card',{staticClass:"txtCenterCobrowsing"},[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('visitorCloseCobrowsing')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.closeCobrowsing()}}},[_vm._v(_vm._s(_vm.txtBtCobrowsing))])],1)],1)],1):_vm._e(),_vm._v(" "),(!_vm.cobrowsingMenuActif)?_c('div',{staticClass:"maskIframe"}):_vm._e(),_vm._v(" "),_c('iframe',{ref:"iframeClientView",staticClass:"ClientView",attrs:{"id":'ClientView_' + _vm.datasVisiteur.placePupitre},on:{"mousemove":_vm.myMouseCoordinates,"scroll":_vm.myScrollTop,"click":_vm.myClickMouse,"keyup":_vm.myKeyPRESS}})])])])}
var WzCobrowsingClient_staticRenderFns = []
var WzCobrowsingClient_esExports = { render: WzCobrowsingClient_render, staticRenderFns: WzCobrowsingClient_staticRenderFns }
/* harmony default export */ var watcheebox_WzCobrowsingClient = (WzCobrowsingClient_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzCobrowsingClient.vue
function WzCobrowsingClient_injectStyle (ssrContext) {
  __webpack_require__("X6+9")
}
var WzCobrowsingClient_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzCobrowsingClient___vue_template_functional__ = false
/* styles */
var WzCobrowsingClient___vue_styles__ = WzCobrowsingClient_injectStyle
/* scopeId */
var WzCobrowsingClient___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzCobrowsingClient___vue_module_identifier__ = null
var WzCobrowsingClient_Component = WzCobrowsingClient_normalizeComponent(
  WzCobrowsingClient,
  watcheebox_WzCobrowsingClient,
  WzCobrowsingClient___vue_template_functional__,
  WzCobrowsingClient___vue_styles__,
  WzCobrowsingClient___vue_scopeId__,
  WzCobrowsingClient___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzCobrowsingClient = (WzCobrowsingClient_Component.exports);

// EXTERNAL MODULE: ./node_modules/js-md5/src/md5.js
var md5 = __webpack_require__("NC6I");
var md5_default = /*#__PURE__*/__webpack_require__.n(md5);

// EXTERNAL MODULE: ./node_modules/extract-domain/dist/extract-domain.min.js
var extract_domain_min = __webpack_require__("Ehou");
var extract_domain_min_default = /*#__PURE__*/__webpack_require__.n(extract_domain_min);

// EXTERNAL MODULE: ./src/assets/css/watcheeBoxStyle.css
var watcheeBoxStyle = __webpack_require__("cPqi");
var watcheeBoxStyle_default = /*#__PURE__*/__webpack_require__.n(watcheeBoxStyle);

// EXTERNAL MODULE: ./node_modules/emoji-mart-vue/dist/emoji-mart.js
var emoji_mart = __webpack_require__("KMaP");
var emoji_mart_default = /*#__PURE__*/__webpack_require__.n(emoji_mart);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzEmojiPicker.vue




/* harmony default export */ var WzEmojiPicker = ({
  name: 'wz-emoji-picker',

  components: {
    Picker: emoji_mart["Picker"]
  },

  data: function data() {
    return {
      picker: false,
      i18nPicker: {
        search: this.$t('search'),
        notfound: this.$t('emojiNotFound'),
        categories: {
          search: this.$t('emojiSearch'),
          recent: this.$t('emojiRecent'),
          people: this.$t('emojiPeople'),
          nature: this.$t('emojiNature'),
          foods: this.$t('emojiFoods'),
          activity: this.$t('emojiActivity'),
          places: this.$t('emojiPlaces'),
          objects: this.$t('emojiObjects'),
          symbols: this.$t('emojiSymbols'),
          flags: this.$t('emojiFlags'),
          custom: this.$tc('custom', 1, { count: '' })
        }
      },
      x: 0,
      y: 0,
      width: 265,
      height: 420,
      basicEmojis: ['+1', 'grinning', 'heart_eyes', 'kissing_heart', 'laughing', 'stuck_out_tongue_winking_eye']
    };
  },


  props: {
    value: {
      required: false
    },

    emoji: {
      type: Boolean,
      required: false
    }
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['status', 'isConnected']), {
    placeholder: function placeholder() {
      return this.status === 'offline' || !this.isConnected ? this.$t('currentlyOffline') : this.$t('typeYourMessage');
    }
  }),

  methods: {
    updatePosPicker: function updatePosPicker() {
      if (!this.$el) {
        return;
      }
      var rect = this.$el.getBoundingClientRect();
      this.x = rect.left - this.width;
      this.y = rect.top - this.height;
    },
    showPicker: function showPicker() {
      var _this = this;

      this.picker = false;
      this.updatePosPicker();
      this.$nextTick(function () {
        _this.picker = true;
      });
    },
    addEmoji: function addEmoji(emoji) {
      this.$emit('addEmoji', emoji.native);
    }
  },

  watch: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12628146","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzEmojiPicker.vue
var WzEmojiPicker_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.updatePosPicker),expression:"updatePosPicker"}],staticClass:"tf_iconePicker"},[_c('v-icon',{on:{"click":_vm.showPicker}},[_vm._v("\n    sentiment_satisfied_alt\n    ")]),_vm._v(" "),_c('v-menu',{attrs:{"lazy":"","close-on-content-click":false,"transition":"scale-transition","origin":"bottom right","max-width":_vm.width,"min-width":_vm.width,"position-x":_vm.x,"position-y":_vm.y,"absolute":"","offset-y":""},model:{value:(_vm.picker),callback:function ($$v) {_vm.picker=$$v},expression:"picker"}},[_c('Picker',{attrs:{"native":"","perLine":8,"color":_vm.$vuetify.theme.secondary,"sheetSize":16,"emojiSize":20,"showSearch":true,"showPreview":false,"showSkinTones":false,"showCategories":true,"i18n":_vm.i18nPicker},on:{"select":function (emoji) { return _vm.addEmoji(emoji); }}})],1)],1)}
var WzEmojiPicker_staticRenderFns = []
var WzEmojiPicker_esExports = { render: WzEmojiPicker_render, staticRenderFns: WzEmojiPicker_staticRenderFns }
/* harmony default export */ var watcheebox_WzEmojiPicker = (WzEmojiPicker_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzEmojiPicker.vue
function WzEmojiPicker_injectStyle (ssrContext) {
  __webpack_require__("ILYb")
}
var WzEmojiPicker_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzEmojiPicker___vue_template_functional__ = false
/* styles */
var WzEmojiPicker___vue_styles__ = WzEmojiPicker_injectStyle
/* scopeId */
var WzEmojiPicker___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzEmojiPicker___vue_module_identifier__ = null
var WzEmojiPicker_Component = WzEmojiPicker_normalizeComponent(
  WzEmojiPicker,
  watcheebox_WzEmojiPicker,
  WzEmojiPicker___vue_template_functional__,
  WzEmojiPicker___vue_styles__,
  WzEmojiPicker___vue_scopeId__,
  WzEmojiPicker___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzEmojiPicker = (WzEmojiPicker_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzFenetreChat.vue



















/* harmony default export */ var WzFenetreChat = ({
  components: {
    Drag: vue_drag_drop_common["Drag"],
    WzEmojiPicker: components_watcheebox_WzEmojiPicker
  },
  data: function data() {
    return {
      domaine: constants_DOMAINE,
      signer: {},
      fileName: '',
      timeTimer: 3000,
      maxLength: 256,
      myTimer: '',
      agentsChecked: [],
      chatActivity: true,
      dropzoneOptions: {
        url: 'https://s3-eu-west-1.amazonaws.com/box-targetfirst',
        previewTemplate: this.templateDropZone(),
        addRemoveLinks: true,
        addSendLinks: true,
        autoProcessQueue: false,
        maxFiles: 1,
        thumbnailWidth: 200,
        thumbnailHeight: 200,
        acceptedMimeTypes: 'image/*,application/pdf,.zip,.doc',
        maxFilesize: 4,
        clickable: false,
        maxThumbnailFilesize: 4,
        dictDefaultMessage: this.$t('dropFileHere'),
        dictFallbackMessage: this.$t('dropNoBrowser'),
        dictFallbackText: this.$t('dropForm'),
        dictFileTooBig: this.$t('dropMore') + ' {{filesize}}Mo ' + this.$t('dropMaxSize') + ' {{maxFilesize}}Mo',
        dictInvalidFileType: this.$t('dopNoFile'),
        dictResponseError: this.$t('dropError') + ' {{statusCode}}',
        dictCancelUpload: this.$t('dropAnnul'),
        dictCancelUploadConfirmation: this.$t('dropConfirmCancel'),
        dictRemoveFile: this.$t('dropSupFile'),
        dictMaxFilesExceeded: this.$t('dropFailMore')
      },
      dDrop: false,
      dStarted: false,
      dEnded: false,
      dEntered: false,
      dOver: false,
      dLeave: false,
      dragEnter: false,
      fileAdd: false,
      newBtnSend: '',

      loading: false,
      msgInput: '',
      widthDate: 100,
      starDate: '',
      dialogCloseChat: false,
      dialogBannChat: false,
      isTyping: false,
      typingTimer: null,
      formulaireSatisfaction: false,
      clotureChat: false,
      positionNodeChat: '',
      selectedAgent: {
        id: '',
        name: '',
        status: ''
      },
      selectedVisiteur: '',
      dialogTransfereChat: false,
      lastMessage: '',
      conteneurChat: null,

      opened: true,
      fullWidth: false,
      checkForMotif: false,
      id_conversation: '',
      dataWatchVisteur: {},
      doOnce: 0,

      scrollPosition: 0,
      stopScrollAuto: false,
      marqueurChat: false,
      visitorLeft: 'yes',
      showFilteredSentences: false,
      overMenu: false
    };
  },


  props: ['datasVisiteur', 'loadingChat', 'msg'],

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])('_StoreWatcheeBox', ['SET_VISITEURS', 'SET_VISITEURS_OPENED_HISTOCHAT', 'CHANGE_DRAG_CHAT', 'SET_STATUS_TIMERINACTIFAGENT']), Object(vuex_esm["d" /* mapMutations */])('_User', ['SET_MESSAGE_ATTENTE']), Object(vuex_esm["b" /* mapActions */])('_StoreWatcheeBox', ['ACTION_CLOSE_CHAT', 'CHECK_DISPO_AGENT']), {
    handleDragstart: function handleDragstart() {
      console.log('drag chat');
      this.CHANGE_DRAG_CHAT(true);
    },
    handleDragend: function handleDragend() {
      console.log('stop drag chat');
      this.CHANGE_DRAG_CHAT(false);
    },
    handleDragenter: function handleDragenter() {
      console.log('drag enter drop');
    },
    handleScroll: function handleScroll(e) {
      var _this = this;

      var element = e.srcElement || e.target;
      if (element.offsetHeight + element.scrollTop === element.scrollHeight) {
        this.stopScrollAuto = false;
        this.marqueurChat = false;

        lodash_default.a.forEach(this.dataWatchVisteur.histoChat, function (chat, key) {
          if (!chat.lu) {
            _this.$store.commit('_StoreWatcheeBox/SOCKET_UPDATE_CHAT_LU', {
              timestamp: chat.timestamp,
              visitorId: chat.visitorId
            });
          }
        });

        this.$store.commit('_StoreWatcheeBox/SOCKET_REMOVE_CHAT_NON_LU', {
          visitorId: this.dataWatchVisteur.visiteurID
        });
      } else if (element.scrollHeight - (element.offsetHeight + element.scrollTop) > 50) {
        this.stopScrollAuto = true;
      }
    },
    remonteChat: function remonteChat() {
      if (this.$refs.contentChat) {
        if (!this.stopScrollAuto) {
          this.$refs.contentChat.scrollTo(0, this.$refs.contentChat.scrollHeight);
        }
      }
    },
    keyup: function keyup(e) {
      this.keyDownMonitor();

      if (e.keyCode === 13) {
        this.dragEnter ? this.uploadFiles({ message: this.msgInput }) : this.sendMessage({ message: this.msgInput });
      }
    },
    addEmoji: function addEmoji(emoji) {
      this.msgInput = this.msgInput + emoji;
    },
    imageLoadError: function imageLoadError() {},
    templateDropZone: function templateDropZone() {
      return '\n          <div>\n            <div class="dz-preview dz-image-preview">\n              <div class="dz-image">\n                <img data-dz-thumbnail>\n              </div>\n              <div class="dz-details">\n                <div class="dz-size"><span data-dz-size></span></div>\n                <div class="dz-filename"><span data-dz-name></span></div>\n              </div>\n              <div class="dz-progress"><span class="dz-upload" data-dz-uploadprogress></span></div>\n              <div class="dz-error-message"><span data-dz-errormessage></span></div>\n              <div class="dz-success-mark"><i class="fa fa-check"></i></div>\n              <div class="dz-error-mark"><i class="fa fa-close"></i></div>\n              <div class="dz-btSend">\n                <button type="button" id="buttonSendImg" class="btn btn--floating btn--large theme--dark primary" data-ripple="true" style="position: relative;">\n                  <div class="btn__content">\n                    <i aria-hidden="true" class="material-icons icon theme--dark">send</i>\n                  </div>\n                </button>\n              </div>\n            </div>\n          </div>\n        ';
    },
    sending: function sending(file, xhr, formData) {
      var indicSlash = file.name.lastIndexOf("'");
      var tabDecomp = file.name.substring(indicSlash + 1).split('.');
      var extension = tabDecomp[tabDecomp.length - 1];
      this.fileName = md5_default()(Date.now() + '_' + file.name.trim().replace(' ', '_')) + '.' + extension;

      formData.append('key', this.fileName);
      formData.append('acl', 'public-read-write');
      formData.append('success_action_status', '201');
      formData.append('Content-Type', '');
      formData.append('X-amz-Algorithm', 'AWS4-HMAC-SHA256');
      formData.append('X-amz-Credential', this.signer.signature['X-amz-credential']);
      formData.append('X-amz-Date', this.signer.signature['X-amz-date']);
      formData.append('Policy', this.signer.signature['policy']);
      formData.append('X-amz-Signature', this.signer.signature['X-amz-signature']);
    },
    success: function success(file, response) {
      var formData = new window.FormData();
      formData.append('fileName', this.fileName);

      this.sendMessage({ message: this.msgInput, attachments: this.fileName });
      this.loading = false;
      this.dragEnter = false;
      this.$store.dispatch('_Notifier/NEW_NOTIF', {
        message: this.$t('uploadSuccess'),
        context: 'success'
      });

      this.newBtnSend.removeEventListener('click', this.uploadFiles, false);
    },
    error: function error(file) {
      this.loading = false;

      this.newBtnSend.removeEventListener('click', this.uploadFiles, false);
    },
    removedFile: function removedFile(file, error, xhr) {
      this.dragEnter = false;

      this.newBtnSend.removeEventListener('click', this.uploadFiles, false);
    },
    uploadFiles: function uploadFiles() {
      var _this2 = this;

      console.log('uploadFiles');
      this.loading = true;
      var url =  false ? DOMAINE + '/dev/ajax-webpack/utils/aws-s3-url-signer-php-master/' : constants_DOMAINE + '/ajax-webpack/utils/aws-s3-url-signer-php-master/';
      axios_default.a.get(url).then(function (res) {
        _this2.signer = res.data;
        _this2.$refs.theDropZone.processQueue();
      }).catch();
    },
    vdenter: function vdenter(e) {
      this.dEntered = true;
    },
    vdover: function vdover() {
      console.log('vdover');
      this.dOver = true;
    },
    vddrop: function vddrop(event) {
      setTimeout(this.testFileAdded, 1000);

      this.dDrop = true;
    },
    vdstart: function vdstart() {
      console.log('vdstart');
      this.dStarted = true;
    },
    vdend: function vdend() {
      console.log('vdend');
      this.dEnded = true;
    },
    vdleave: function vdleave() {
      console.log('vdleave');

      if (!this.dragChat) {
        this.dLeave = true;
        this.dragEnter = false;
      }
    },
    fileAdded: function fileAdded(event) {
      if (!this.dragChat) {
        this.fileAdd = true;

        this.newBtnSend = document.getElementById('buttonSendImg');
        this.newBtnSend.addEventListener('click', this.uploadFiles, false);
      }
    },
    testFileAdded: function testFileAdded() {
      if (this.fileAdd) {
        this.fileAdd = false;
      } else {
        this.dragEnter = false;
      }
    },
    keyDownMonitor: function keyDownMonitor() {
      clearTimeout(this.stopTimerTyping);
      if (!this.isTyping) {
        this.startTyping();
        this.isTyping = true;
        setTimeout(this.stopTimerTyping, 5000);
      }
    },
    stopTimerTyping: function stopTimerTyping() {
      if (this.isTyping) {
        this.stopTyping();
        this.isTyping = false;
      }
    },
    startTyping: function startTyping() {
      this.stopTimerTransfert();
      var agentSocketID = this.WATCHEEBOX_STATE.mySocketID;

      watcheebox_watcheebox.startIsTyping({
        agentSocketID: agentSocketID,
        datasAgent: this.user,
        datasVisiteur: this.datasVisiteur,
        message: this.msg,
        messageType: 1,
        agentName: unescape(this.fullName)
      });
    },
    stopTyping: function stopTyping() {
      if (this.user.usr_time_transfert !== '0') {
        this.startTimerTransfert({ 'mounted': false });
      }
      var agentSocketID = this.WATCHEEBOX_STATE.mySocketID;

      watcheebox_watcheebox.stopIsTyping({
        agentSocketID: agentSocketID,
        datasAgent: this.user,
        datasVisiteur: this.datasVisiteur,
        message: this.msg,
        messageType: 1,
        agentName: unescape(this.fullName)
      });
    },
    handleSend: function handleSend() {
      this.dragEnter ? this.uploadFiles() : this.sendMessage({ message: this.msgInput });
    },
    sendMessage: function sendMessage(data) {
      var _this3 = this;

      console.log('sendMessage', data);

      this.startTimerTransfert({ 'mounted': false });

      if (this.$store.state._StoreWatcheeBox.status === 'offline' && this.$route.fullPath !== '/trafic/attente') {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('currentlyOffline'),
          context: 'error'
        });
        return;
      }
      if (data.message.length === 0 && data.attachments) {
        data.message = '';
      }

      if (data.message.trim().length !== 0 || data.message.length === 0 && data.attachments) {
        if (this.datasVisiteur.network && this.datasVisiteur.network === 'facebook') {
          watcheebox_watcheebox.envoisFacebook({
            datasAgent: this.user,
            datasVisiteur: this.datasVisiteur,
            message: data.message,
            attachments: data.attachments,
            messageType: 1,
            agentName: unescape(this.fullName)
          });
        } else {
          var agentSocketID = this.WATCHEEBOX_STATE.mySocketID;

          watcheebox_watcheebox.envoisMessage({
            agentSocketID: agentSocketID,
            datasAgent: this.user,
            datasVisiteur: this.datasVisiteur,
            message: data.message,
            attachments: data.attachments,
            messageType: 1,
            agentName: unescape(this.fullName)
          });
          var dataToPost = new window.FormData();
          dataToPost.append('sessionId', this.datasVisiteur.visiteurID);
          dataToPost.append('agentid', this.user.id);
          if (this.doOnce !== this.datasVisiteur.visiteurID) {
            this.axios.post('post/visitor_contacted.php', dataToPost, {
              headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
            }).then(function (response) {
              _this3.doOnce = _this3.datasVisiteur.visiteurID;
            }).catch();
          }
        }

        var statusMessage = 'read';
        if (this.datasVisiteur.network && this.datasVisiteur.network === 'facebook') {
          statusMessage = 'delivery';
        } else {
          if (this.datasVisiteur.socketID === 0) {
            statusMessage = 'delivery';
          }
        }
        var dateMessage = Math.round(Date.now() / 1000);
        var newMessage = {
          auteur: 'Agent',
          message: data.message,
          attachments: data.attachments,
          nameAuteur: this.user.fname + ' ' + this.user.lname,
          timestamp: dateMessage,
          type: '1',
          visitorId: this.datasVisiteur.visiteurID,
          status: statusMessage
        };

        this.$emit('update:msg', '');
        this.showFilteredSentences = false;

        if (this.$route.fullPath === '/trafic/attente') {
          this.AttenteReponseAgent(this.datasVisiteur);

          var cloneDataVisiteurOpened = lodash_default.a.cloneDeep(this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.histoChat);
          cloneDataVisiteurOpened.push(newMessage);
          this.SET_VISITEURS_OPENED_HISTOCHAT(cloneDataVisiteurOpened);
          var cloneDataVisiteur = lodash_default.a.cloneDeep(this.datasVisiteur);
          cloneDataVisiteur.histoChat.push(newMessage);
          cloneDataVisiteur.lastMessage = '';
          cloneDataVisiteur.chatted = true;
          this.$emit('sendReponseAttente', cloneDataVisiteur);
        } else {
          var _cloneDataVisiteur = lodash_default.a.cloneDeep(this.datasVisiteur);
          _cloneDataVisiteur.histoChat.push(newMessage);
          _cloneDataVisiteur.lastMessage = '';
          _cloneDataVisiteur.chatted = true;
          this.SET_VISITEURS(_cloneDataVisiteur);
        }
      }

      this.msgInput = '';
    },
    AttenteReponseAgent: function AttenteReponseAgent(data) {
      var _this4 = this;

      var dataToPost = new window.FormData();
      dataToPost.append('visiteurId', data.visiteurID);
      dataToPost.append('visiteurEmail', this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.email);
      dataToPost.append('visiteurTel', this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.tel);
      dataToPost.append('visiteurPageFocus', this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.focus);
      dataToPost.append('entName', this.$store.state._User.entName);
      dataToPost.append('conseillerName', this.$store.state._User.fname + ' ' + this.$store.state._User.lname);

      this.axios.post('post/allMessageVisiteurAttenteLu.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        if (response.statusText === 'OK') {
          var messagesList = lodash_default.a.cloneDeep(_this4.user.listeMessages);

          var newListe = lodash_default.a.remove(messagesList, function (o) {
            return o.visiteurID !== data.visiteurID;
          });

          _this4.SET_MESSAGE_ATTENTE(newListe);
        }
      }).catch();
    },
    toggleChat: function toggleChat() {
      if (this.overMenu) return;
      this.opened = !this.opened;
      if (this.opened) {
        this.$emit('bigChat');
      } else {
        this.$emit('smallChat');
      }
    },
    toggleBigChat: function toggleBigChat() {
      console.log('this.fullWidth', this.fullWidth);
      this.fullWidth = !this.fullWidth;
      if (this.fullWidth) {
        this.$emit('bigWidthChat');
      } else {
        this.$emit('smallWidthChat');
      }
    },
    fermeDialogCloseChat: function fermeDialogCloseChat(data) {
      console.log('fermeDialogCloseChat', data);
      this.dialogCloseChat = data.dialogCloseChat;
    },
    fermeChat: function fermeChat() {
      if (this.$route.fullPath === '/trafic/monitoring') {
        this.$emit('chatSessionSelect', 0);
      } else {
        if (this.$route.fullPath !== '/trafic/attente') {
          if (this.user.usr_time_transfert !== '0') {
            this.stopTimerTransfert();
          }
        }

        this.dialogCloseChat = true;
      }
    },
    transferChat: function transferChat() {
      if (this.selectedAgent.id !== '') {
        var datasVisiteurSelect = {
          socketID: this.datasVisiteur.socketID,
          visiteurID: this.datasVisiteur.visiteurID,
          visiteurKey: this.datasVisiteur.roomName,
          siteID: this.datasVisiteur.siteID
        };
        var mySocketID = this.WATCHEEBOX_STATE.mySocketID;
        watcheebox_watcheebox.SendTransfertVisitor({
          selectedAgent: this.selectedAgent,
          datasSelectedVisiteur: datasVisiteurSelect,
          agentsArray: this.agentsArray,

          myAgentID: this.$store.state._User.id,
          mySocketID: mySocketID,
          agentSenderName: this.fullName,
          automatique: true
        });
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('selectAgentList'),
          context: 'warning'
        });
      }
    },
    checkDispoAGent: function checkDispoAGent() {
      var _this5 = this;

      this.chatActivity = false;

      var sendFormeSatis = false;
      var sendClotureChat = false;

      if (this.datasVisiteur.chatted) {
        sendFormeSatis = this.$cookie.get('wz-satisfaction-survey') === 'true' || false;
        sendClotureChat = this.$cookie.get('wz-closing-chat') === 'true' || false;
      }

      if (this.$store.state._StoreWatcheeBox.transfertStatusEmission.status !== 'wait' && this.visitorLeft === 'no' && !this.datasVisiteur.chatted) {
        var transfereStatus = false;

        lodash_default.a.forEach(this.listeAgentsAutorized, function (agent, key) {
          if (agent[8] !== _this5.user.id) {
            var agentChecked = _this5.agentsChecked.findIndex(function (agentCheck) {
              return agentCheck === agent[2];
            });

            if (agent[3] === 'online' && agentChecked === -1) {
              _this5.agentsChecked.push(agent[2]);
              transfereStatus = true;
              console.log('transfere dispo avec cet agent :', agent[1]);

              _this5.selectedAgent = {
                id: agent[2],
                name: agent[1],
                status: agent[3]
              };

              _this5.transferChat();
              return false;
            }
          }
        });

        if (!transfereStatus) {
          console.log('Aucun agent dispo');
          this.autoFermetureChat({
            datasVisiteur: this.datasVisiteur,
            formulaireSatisfaction: sendFormeSatis,
            clotureChat: sendClotureChat,
            message: 'Aucuns conseillés disponibles pour vous répondre'
          });
        }
      } else {
        console.log('transfert "wait" ou visiteur offline');
        this.autoFermetureChat({
          datasVisiteur: this.datasVisiteur,
          formulaireSatisfaction: sendFormeSatis,
          clotureChat: sendClotureChat,
          message: 'Aucuns conseillés disponibles pour vous répondre'
        });
      }
    },
    autoFermetureChat: function autoFermetureChat(data) {
      console.log('fermeture du chat');
      this.ACTION_CLOSE_CHAT({
        formulaireSatisfaction: data.formulaireSatisfaction,
        datasVisiteur: data.datasVisiteur,
        clotureChat: data.clotureChat,
        message: data.message,
        fullPath: this.$route.fullPath
      });
    },
    menuAction: function menuAction(value, idVisiteur) {
      if (value === 'transferer') {
        this.selectedVisiteur = idVisiteur;
        this.dialogTransfereChat = true;
        this.selectedAgent = { id: '', name: '', status: '' };

        this.$store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
          status: '',
          emission: true,
          messageDatas: ''
        });
      } else if (value === 'bannChat') {
        this.dialogBannChat = true;
      }
    },
    showUnreadMessages: function showUnreadMessages() {
      this.stopScrollAuto = false;
      this.remonteChat();
    },
    startListenerDropZone: function startListenerDropZone() {
      var _this6 = this;

      this.$el.children[1].children[0].children[0].addEventListener('dragenter', function (event) {
        if (!_this6.dragChat) {
          _this6.dragEnter = true;
        }
      });
    },
    stopListenerDropZone: function stopListenerDropZone() {
      this.$el.children[1].children[0].children[0].removeEventListener('dragenter', function (event) {});
    },
    stopTimerTransfert: function stopTimerTransfert() {
      this.SET_STATUS_TIMERINACTIFAGENT({
        placePupitre: this.datasVisiteur.placePupitre,
        timerAgent: false
      });

      this.chatActivity = true;
    },
    startTimerTransfert: function startTimerTransfert(data) {
      var _this7 = this;

      this.stopTimerTransfert();
      var myTimer = setTimeout(function () {
        _this7.checkDispoAGent();
      }, this.timeTimer);

      this.SET_STATUS_TIMERINACTIFAGENT({
        placePupitre: this.datasVisiteur.placePupitre,
        timerAgent: myTimer,
        mounted: data.mounted
      });
    },
    copyMessage: function copyMessage(content) {
      var textArea = document.createElement('textarea');
      textArea.value = content;
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();

      try {
        document.execCommand('copy');
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('copied'),
          context: 'success'
        });
      } catch (err) {}

      document.body.removeChild(textArea);
    },
    brideMenu: function brideMenu(nameBride) {
      if (this.brides) {
        var index = this.brides.findIndex(function (bride) {
          return bride.brideName === nameBride;
        });

        if (index !== -1) {
          return this.brides[index].status;
        }
      }
    }
  }),

  watch: {
    'datasVisiteur.visiteurID': function datasVisiteurVisiteurID() {
      this.dialogTransfereChat = false;
    },

    'dataWatchVisteur.visiteurID': function dataWatchVisteurVisiteurID() {
      if (this.focusPupitre.focusSessionID === this.datasVisiteur.visiteurID) {
        this.$refs.inputChat.focus();
      }
    },

    'WATCHEEBOX_STATE.transfertStatusEmission.status': function WATCHEEBOX_STATETransfertStatusEmissionStatus(e) {
      if (e === 'wait') {
        console.log('transfert en attente :', e);
      } else if (e === 'no') {
        console.log('transfert refusé :', e);

        if (!this.chatActivity) {
          this.checkDispoAGent();
        }
      } else {
        console.log('transfert accepté :', e);
      }
    },

    'dataWatchVisteur.histoChat': function dataWatchVisteurHistoChat() {
      var lengthChat = this.dataWatchVisteur.histoChat.length;
      if (lengthChat) {
        if (!this.dataWatchVisteur.histoChat[lengthChat - 1].lu && !this.dataWatchVisteur.histoChat[lengthChat - 1].isTyping && this.dataWatchVisteur.histoChat[lengthChat - 1].auteur !== 'Agent') {
          if (!this.stopScrollAuto) {
            this.$store.commit('_StoreWatcheeBox/SOCKET_UPDATE_CHAT_LU', {
              timestamp: this.dataWatchVisteur.histoChat[lengthChat - 1].timestamp,
              visitorId: this.dataWatchVisteur.histoChat[lengthChat - 1].visitorId
            });
          } else {
            if (!this.marqueurChat) {
              this.marqueurChat = true;

              this.$store.commit('_StoreWatcheeBox/SOCKET_MAKE_CHAT_NON_LU', {
                timestamp: this.dataWatchVisteur.histoChat[lengthChat - 1].timestamp,
                visitorId: this.dataWatchVisteur.histoChat[lengthChat - 1].visitorId
              });
            }
          }
        }
      }
    },

    'dataWatchVisteur.socketID': function dataWatchVisteurSocketID(v) {
      var _this8 = this;

      if (v) {
        this.visitorLeft = 'no';

        lodash_default.a.forEach(this.dataWatchVisteur.histoChat, function (chat, key) {
          if (chat.status === 'delivery') {
            _this8.$store.commit('_StoreWatcheeBox/SOCKET_UPDATE_CHAT_DELIVRE', {
              timestamp: chat.timestamp,
              visitorId: chat.visitorId
            });
          }
        });
      } else {
        if (this.dataWatchVisteur.network === 'facebook') {
          this.visitorLeft = 'no';
        } else {
          this.$store.commit('_StoreWatcheeBox/SOCKET_REMOVE_TYPING', {
            chatSession: this.dataWatchVisteur.visiteurID
          });
          if (this.visitorLeft !== 'yes') {
            this.visitorLeft = 'maybe';
          }

          setTimeout(function () {
            if (!_this8.dataWatchVisteur.socketID) {
              _this8.visitorLeft = 'yes';
            }
          }, 10000);
        }
      }
    },

    datasVisiteur: function datasVisiteur(val, oldval) {
      if (!val) {
        this.dataWatchVisteur = oldval;
      } else {
        this.dataWatchVisteur = val;
      }
    },

    'WATCHEEBOX_STATE.statusMessage': function WATCHEEBOX_STATEStatusMessage(val, oldval) {
      if (val.senderID === this.dataWatchVisteur.visiteurID) {
        lodash_default.a.forEach(this.dataWatchVisteur.histoChat, function (chat, key) {
          if (chat.status && chat.status === 'delivery') {
            chat.status = 'read';
          }
        });
      }
    },

    formulaireSatisfaction: function formulaireSatisfaction(v) {
      this.$cookie.set('wz-satisfaction-survey', v, { expires: '1Y' });
    },
    clotureChat: function clotureChat(v) {
      this.$cookie.set('wz-closing-chat', v, { expires: '1Y' });
    },
    msg: function msg(v) {
      this.msgInput = v;

      this.$refs.inputChat.focus();
    },
    msgInput: function msgInput(v) {
      if (v || v.length) {
        if (v.length > 2 && v.length < 16) {
          if (this.brideMenu('media_phrases') === '1' && this.brideMenu('media_phrases_completion') === '1') {
            this.showFilteredSentences = true;
          }
        } else {
          this.showFilteredSentences = false;
        }
      }
    }
  },

  updated: function updated() {
    var _this9 = this;

    this.$nextTick(function () {
      if (!_this9.stopScrollAuto) {
        _this9.remonteChat();
      }
    });
  },
  mounted: function mounted() {
    if (this.user.usr_time_transfert && this.user.usr_time_transfert !== '0') {
      this.timeTimer = this.user.usr_time_transfert * 60 * 1000;
    }

    this.dataWatchVisteur = this.datasVisiteur;
    if (this.dataWatchVisteur.network === 'facebook') {
      this.visitorLeft = 'no';
    }

    if (this.user.usr_time_transfert !== '0') {
      this.startTimerTransfert({ 'mounted': true });
    }

    if (this.$store.state._User.entKey === '9c44184c124fda32ac19523ff93d2488') {
      this.checkForMotif = true;
    }

    this.startListenerDropZone();

    this.id_conversation = 'conversation_' + this.datasVisiteur.visiteurID;
  },
  beforeDestroy: function beforeDestroy() {
    this.stopListenerDropZone();
    this.stopTimerTransfert();
  },


  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['agentsArray', 'transfertStatusEmission', 'focusPupitre', 'visiteurChatSelected', 'messageAttenteSelected', 'listeAllVisiteurs', 'status', 'isConnected', 'dragChat']), Object(vuex_esm["e" /* mapState */])('_User', ['brides', 'entLevel']), Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'fullName']), Object(vuex_esm["c" /* mapGetters */])('_StoreWatcheeBox', ['WATCHEEBOX_STATE']), Object(vuex_esm["c" /* mapGetters */])('_Sites', ['AUTORIZED_AGENTS']), {
    listeAgentsAutorized: function listeAgentsAutorized() {
      return this.AUTORIZED_AGENTS({
        agentsArray: this.agentsArray,
        siteID: this.datasVisiteur.siteID,
        myID: this.user.id
      });
    },
    placeholder: function placeholder() {
      var url = String(this.datasVisiteur.pagesFocus);
      if (this.brideMenu('multisite_indicateur') === '1') {
        return String(lodash_default.a.upperFirst(this.$t('forTheSite')) + ' ' + extract_domain_min_default()(url) + '\n' + this.$t('typeYourMessage'));
      } else {
        return String(this.$t('typeYourMessage'));
      }
    },
    dateHeure: function dateHeure() {
      if (!this.dataWatchVisteur || !this.dataWatchVisteur.histoChat) return [];
      return this.dataWatchVisteur.histoChat.map(function (item) {
        var itemTimestamp = item.timestamp && item.timestamp.toString().length === 10 ? item.timestamp * 1000 : item.timestamp;
        var m = moment_default()(itemTimestamp);
        return m.format('LTS');
      });
    },
    nameAuteur: function nameAuteur() {
      if (!this.dataWatchVisteur || !this.dataWatchVisteur.histoChat) return [];
      return this.dataWatchVisteur.histoChat.map(function (item) {
        return item.nameAuteur !== 'undefined';
      });
    },
    checkLastMessage: function checkLastMessage() {
      if (this.dataWatchVisteur && this.dataWatchVisteur.lastMessage !== '') {
        return true;
      } else {
        return false;
      }
    },
    nbMessageNonLu: function nbMessageNonLu() {
      var nbMessageNonLu = 0;
      var lengthChat = this.dataWatchVisteur.histoChat ? this.dataWatchVisteur.histoChat.length : 0;
      var indexMarqueur = lodash_default.a.findIndex(this.dataWatchVisteur.histoChat, {
        marqueurMessageNonLu: true
      });
      if (indexMarqueur === -1) return;
      for (var i = indexMarqueur; i < lengthChat; ++i) {
        if (this.dataWatchVisteur.histoChat[i].auteur !== 'Agent' && !this.dataWatchVisteur.histoChat[i].lu && !this.dataWatchVisteur.histoChat[i].isTyping && !this.dataWatchVisteur.histoChat[i].marqueurMessageNonLu) {
          nbMessageNonLu++;
        }
      }
      return nbMessageNonLu;
    },
    nameVisiteur: function nameVisiteur() {
      if (this.dataWatchVisteur.visiteurName) {
        return this.dataWatchVisteur.visiteurName;
      } else {
        return this.dataWatchVisteur.visiteurID;
      }
    },
    superIstypingStatusSite: function superIstypingStatusSite() {
      var siteVisiteurSelect = lodash_default.a.find(this.$store.state._Sites.sites, {
        LIC_KEY: this.dataWatchVisteur.roomName
      });
      var SuperIstyping = true;
      if (siteVisiteurSelect.DSK_SUPERISTYPING === '0') {
        SuperIstyping = false;
      }
      return SuperIstyping;
    },
    returnFocusSessionId: function returnFocusSessionId() {
      if (this.$route.name === 'visitors') {
        return this.visiteurChatSelected;
      } else if (this.$route.name === 'attente') {
        return this.messageAttenteSelected;
      } else {
        return this.focusPupitre.focusSessionID;
      }
    },
    filteredSentences: function filteredSentences() {
      if (this.showFilteredSentences) {
        return this.$store.getters['_Biblios/GET_SENTENCES'](this.msgInput);
      } else {
        return false;
      }
    },
    hasMotif: function hasMotif() {
      var thisVisit = lodash_default.a.find(this.$store.state._StoreWatcheeBox.listeAllVisiteurs, {
        visiteurID: this.dataWatchVisteur.visiteurID
      });
      return thisVisit ? thisVisit.motif : false;
    },
    findUrls: function findUrls() {
      return this.datasVisiteur.histoChat.map(function (m) {
        var source = (m.message || '').toString();
        var urlArray = [];
        var matchArray = void 0;

        var regexToken = /(((ftp|https?):\/\/)[-\w@:%_+.~#?,&=]+)|((mailto:)?[_.\w-]+@([\w][\w-]+\.)+[a-zA-Z]{2,3})/g;

        while ((matchArray = regexToken.exec(source)) !== null) {
          var token = matchArray[0];
          urlArray.push(token);
        }
        var newMessage = source.replace(urlArray, '<a href="' + urlArray + '" target="_blank">' + urlArray + '</a>');

        return newMessage;
      });
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d735d9c0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzFenetreChat.vue
var WzFenetreChat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"wz_VcardChat",class:{'bigChat': _vm.opened, 'smallChat': !_vm.opened},attrs:{"id":'chat_'+_vm.dataWatchVisteur.visiteurID}},[_c('drag',{staticClass:"drag",attrs:{"transfer-data":{ visiteurID: _vm.dataWatchVisteur.visiteurID, placePupitreActif: _vm.dataWatchVisteur.placePupitre, menuStelected: _vm.dataWatchVisteur.menuSelected, reponseCobrowsing: _vm.dataWatchVisteur.reponseCobrowsing }},on:{"dragstart":_vm.handleDragstart,"dragend":_vm.handleDragend,"dragenter":_vm.handleDragenter}},[_c('v-toolbar',{class:{
          'accent': _vm.returnFocusSessionId == _vm.dataWatchVisteur.visiteurID,
          'grey lighten-2': _vm.returnFocusSessionId != _vm.dataWatchVisteur.visiteurID,
          'newMessageFocus': _vm.returnFocusSessionId == _vm.dataWatchVisteur.visiteurID && _vm.checkLastMessage,
          'newMessage': _vm.returnFocusSessionId != _vm.dataWatchVisteur.visiteurID && _vm.checkLastMessage,
          'toolbar_ChatBox': true
        },attrs:{"dark":"","flat":"","dense":""}},[(_vm.visitorLeft == 'yes')?_c('div',{staticClass:"clientOffline error"},[_vm._v("\n          "+_vm._s(_vm.$t('offline'))+"\n        ")]):(_vm.visitorLeft == 'maybe')?_c('div',{staticClass:"clientOffline warning"},[_vm._v("\n          "+_vm._s(_vm.$t('changingPage'))+"\n        ")]):_vm._e(),_vm._v(" "),_c('v-flex',{attrs:{"xs1":"","ml-1":""},on:{"click":function($event){$event.preventDefault();$event.stopPropagation();}}},[(_vm.dataWatchVisteur.network)?_c('wz-avatar',{attrs:{"src":_vm.dataWatchVisteur.profile_pic,"username":_vm.dataWatchVisteur.visiteurName,"size":"38px"}}):_c('wz-avatar',{attrs:{"username":'#' + _vm.dataWatchVisteur.visiteurID,"size":"35px"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"ellipsis":"","ml-1":""}},[_c('v-toolbar-title',{staticClass:"ws_TitreChat",domProps:{"innerHTML":_vm._s(_vm.dataWatchVisteur.visiteurName
              ? _vm.dataWatchVisteur.visiteurName
              : _vm.dataWatchVisteur.visiteurID)}}),_vm._v(" "),_c('v-toolbar-title',{staticClass:"ws_sousTitreChat",domProps:{"innerHTML":_vm._s(_vm.lastMessage)}})],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.opened),expression:"opened"}],attrs:{"icon":"","small":""},on:{"click":function($event){_vm.toggleBigChat()}}},[_c('v-icon',{staticClass:"rotate90Icone"},[_vm._v(_vm._s(_vm.fullWidth ? 'unfold_less' : 'unfold_more'))])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){_vm.toggleChat()}}},[_c('v-icon',[_vm._v(_vm._s(_vm.opened ? 'keyboard_arrow_down' : 'keyboard_arrow_up'))])],1),_vm._v(" "),_c('v-btn',{attrs:{"icon":"","small":""},on:{"click":function($event){_vm.fermeChat()}}},[_c('v-icon',[_vm._v("close")])],1)],1)],1),_vm._v(" "),(_vm.loadingChat)?_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{attrs:{"flex":"","align-center":"","justify-center":""}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"chatSession"},[_c('div',{directives:[{name:"bar",rawName:"v-bar"}],staticClass:"WatchBox-contentChat",attrs:{"id":_vm.id_conversation}},[_c('div',{ref:"contentChat",staticClass:"WatchBox-conversation",on:{"scroll":_vm.handleScroll}},[_vm._l((_vm.datasVisiteur.histoChat),function(dataMessage,index){return _c('v-hover',{key:index,class:{
              'bulle_BO': !dataMessage.isTyping && !dataMessage.dateMessage && !dataMessage.marqueurMessageNonLu,
              'bulle-message-non-lu_BO': !dataMessage.isTyping && !dataMessage.dateMessage && dataMessage.marqueurMessageNonLu,
              'bulle-date_BO': dataMessage.dateMessage,
              'green': dataMessage.type === '18'
            },style:('z-index:' + (dataMessage.indexMessage+1) + ';'),scopedSlots:_vm._u([{key:"default",fn:function(ref){
            var hover = ref.hover;
return _c('div',{},[(!dataMessage.isTyping && !dataMessage.dateMessage && !dataMessage.marqueurMessageNonLu)?_c('div',{key:index,class:'bulle_' + dataMessage.auteur + '_BO'},[(index > 1 &&
                                _vm.datasVisiteur.histoChat[index - 1].chatSession &&
                                _vm.datasVisiteur.histoChat[index].chatSession &&
                                _vm.datasVisiteur.histoChat[index].chatSession != _vm.datasVisiteur.histoChat[index - 1].chatSession)?_c('v-layout',[_c('v-flex',{staticClass:"text-xs-center",attrs:{"xs12":""}},[_c('v-chip',{attrs:{"label":"","disabled":"","color":"secondary","text-color":"white"}},[_vm._v("\n                      "+_vm._s(_vm.$t('closing'))+"\n                      "),_c('v-icon',{attrs:{"right":"","dark":""}},[_vm._v("offline_pin")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('div',{class:'message' + dataMessage.auteur + '_BO'},[_c('div',{class:'nom_' + dataMessage.auteur + '_BO'},[_vm._v("\n                    "+_vm._s(_vm.nameAuteur[index]
                        ? dataMessage.nameAuteur
                        : dataMessage.visitorId == _vm.datasVisiteur.visiteurID
                          ? _vm.nameVisiteur
                          : dataMessage.visitorId)+"\n                    "+_vm._s(dataMessage.type == 2 ? '(' + _vm.$t('msgAuto') + ')': '')+"\n                  ")]),_vm._v(" "),_c('div',{class:'timestamp_' + dataMessage.auteur + '_BO',attrs:{"data-timestamp":dataMessage.timestamp}},[_vm._v("\n                    "+_vm._s(_vm.dateHeure[index])+"\n                  ")]),_vm._v(" "),(dataMessage.message && dataMessage.message != 'undefined')?_c('div',{class:'hms message_' + dataMessage.auteur},[(_vm.findUrls[index].length)?_c('div',{staticClass:"txtChat",domProps:{"innerHTML":_vm._s(_vm.findUrls[index])}}):_c('div',{staticClass:"txtChat",domProps:{"textContent":_vm._s(dataMessage.message)}})]):_vm._e(),_vm._v(" "),(dataMessage.attachments && (dataMessage.attachments != 'null' && dataMessage.attachments != 'undefined'))?_c('div',[(dataMessage.attachments.split('.')[1] == 'fbsbx')?_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":dataMessage.attachments,"target":"_blank"}},[(dataMessage.attachments.split('.')[1] == 'pdf' || dataMessage.attachments.split('.')[1] == 'doc' || dataMessage.attachments.split('.')[1] == 'zip')?_c('div',[_c('v-icon',{staticClass:"grey--text",attrs:{"large":""}},[_vm._v("attachment\n                        ")]),_vm._v(_vm._s(dataMessage.attachments.split('.')[1])+"\n                      ")],1):_c('div',[_c('img',{staticClass:"attachmentsMedia",attrs:{"src":dataMessage.attachments,"title":"","rel":"","alt":dataMessage.attachments.split('.')[1]},on:{"load":function($event){_vm.remonteChat()}}})])]):(dataMessage.attachments.split('.')[2] == 'fbcdn')?_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":dataMessage.attachments,"target":"_blank"}},[_c('div',[_c('img',{staticClass:"attachmentsMedia",attrs:{"src":dataMessage.attachments,"title":"","rel":"","alt":dataMessage.attachments.split('.')[4]},on:{"load":function($event){_vm.remonteChat()}}})])]):(dataMessage.attachments.split('.')[1] == 'watcheezy')?_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":dataMessage.attachments,"target":"_blank"}},[_c('div',[_c('img',{staticClass:"attachmentsMedia",attrs:{"src":dataMessage.attachments,"title":"","rel":"","alt":dataMessage.attachments.split('.')[3]},on:{"load":function($event){_vm.remonteChat()}}})])]):(dataMessage.attachments.split('.')[1] == 'targetfirst')?_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":dataMessage.attachments,"target":"_blank"}},[_c('div',[_c('img',{staticClass:"attachmentsMedia",attrs:{"src":dataMessage.attachments,"title":"","rel":"","alt":dataMessage.attachments.split('.')[3]},on:{"load":function($event){_vm.remonteChat()}}})])]):_c('a',{staticStyle:{"text-decoration":"none"},attrs:{"href":'https://s3-eu-west-1.amazonaws.com/box-targetfirst/' + dataMessage.attachments,"target":"_blank"}},[(dataMessage.attachments.split('.')[1] == 'pdf' || dataMessage.attachments.split('.')[1] == 'doc' || dataMessage.attachments.split('.')[1] == 'zip')?_c('div',[_c('v-icon',{staticClass:"grey--text",attrs:{"large":""}},[_vm._v("attachment\n                          ")]),_vm._v(_vm._s(dataMessage.attachments.split('.')[1])+"\n                        ")],1):_c('div',[_c('img',{staticClass:"attachmentsMedia",attrs:{"src":'https://s3-eu-west-1.amazonaws.com/box-targetfirst/' + dataMessage.attachments,"title":"","rel":"","alt":dataMessage.attachments.split('.')[1]},on:{"error":_vm.imageLoadError,"load":function($event){_vm.remonteChat()}}})])])]):_vm._e(),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(hover),expression:"hover"}],staticStyle:{"margin":"0","position":"absolute","top":"16px","right":"6px"},attrs:{"icon":"","small":"","title":_vm.$t('copyText')},on:{"click":function($event){_vm.copyMessage(dataMessage.message)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("content_copy")])],1),_vm._v(" "),(dataMessage.status == 'delivery')?_c('div',{},[_vm._v("("+_vm._s(_vm.$t('messageSent'))+")")]):(dataMessage.status == 'read')?_c('div',{},[_vm._v("("+_vm._s(_vm.$t('messageRead'))+")")]):_vm._e()],1)],1):(!dataMessage.isTyping && !dataMessage.dateMessage && dataMessage.marqueurMessageNonLu)?_c('v-btn',{key:index,staticClass:"alert-message-non-lu primary",attrs:{"block":""},on:{"click":function($event){_vm.showUnreadMessages()}}},[_c('div',{staticClass:"message-non-lu WZ-MessageChat white--text"},[_c('v-icon',{attrs:{"medium":"","dark":""}},[_vm._v("forum")]),_vm._v("\n                  "+_vm._s(_vm.$tc('unreadMessages', _vm.nbMessageNonLu, {count: _vm.nbMessageNonLu}))+"\n                ")],1)]):(!dataMessage.isTyping)?_c('div',{key:index,staticClass:"bulle_date_BO"},[_c('div',{staticClass:"dates-messages_BO WZ-MessageChat"},[_vm._v(_vm._s(dataMessage.timeStamp))])]):_vm._e()],1)}}])})}),_vm._v(" "),_vm._l((_vm.dataWatchVisteur.histoChat),function(dataMessage,index){return (dataMessage.isTyping)?_c('div',{key:dataMessage.timestamp,class:'isTyping_' + dataMessage.auteur + '_BO'},[_c('div',{staticClass:"isTyping_nom_BO"},[_c('div',{staticClass:"wz_nom_visiteur"},[_vm._v(_vm._s(dataMessage.nameAuteur))])]),_vm._v(" "),_c('div',{staticClass:"isTyping_message"},[_c('div',{staticClass:"WatchBox-istyping_BO"},[_c('div',{staticClass:"bounce1"}),_vm._v(" "),_c('div',{staticClass:"bounce2"}),_vm._v(" "),_c('div',{staticClass:"bounce3"})]),_vm._v(" "),_c('div',{staticClass:"txt-superIstyping"},[_vm._v(_vm._s(dataMessage.message))])])]):_vm._e()})],2),_vm._v(" "),_c('transition',{attrs:{"name":"slide-y-transition","mode":"in-out"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.filteredSentences.length && _vm.showFilteredSentences),expression:"filteredSentences.length && showFilteredSentences"}],staticStyle:{"z-index":"99","position":"relative"}},[_c('v-card',{directives:[{name:"bar",rawName:"v-bar"}],attrs:{"height":"200"}},[_c('v-list',{attrs:{"two-line":"","dense":"","subheader":""}},[_c('v-layout',[_c('v-flex',{attrs:{"xs10":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$tc('sentences', _vm.filteredSentences.length, {count: _vm.filteredSentences.length})))])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.showFilteredSentences = false}}},[_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("close")])],1)],1),_vm._v(" "),_vm._l((_vm.filteredSentences),function(phrase){return _c('v-list-tile',{key:phrase.id,on:{"click":function($event){_vm.status === 'offline' ? ';' : _vm.$emit('update:msg', phrase.title); _vm.showFilteredSentences = false}}},[_c('v-list-tile-content',[_vm._v("\n                    "+_vm._s(_vm._f("truncate")(phrase.title,80))+"\n                  ")]),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"color":"secondary--text","icon":"","small":""},on:{"click":function($event){$event.stopPropagation();_vm.status === 'offline' ? ';' : _vm.sendMessage({'message':phrase.title})}}},[_c('v-icon',[_vm._v("send")])],1)],1)],1)})],2)],1)],1)]),_vm._v(" "),(_vm.$route.name != 'monitoring' || (_vm.$route.name === 'monitoring' && _vm.brideMenu('trafic_monitoring_chat_superviseur') === '1'))?_c('div',{staticClass:"WatchBox-MessageWrapper"},[_c('v-divider'),_vm._v(" "),(_vm.datasVisiteur)?_c('wz-emoji-picker',{on:{"addEmoji":_vm.addEmoji}}):_vm._e(),_vm._v(" "),(_vm.datasVisiteur)?_c('v-textarea',{ref:"inputChat",staticClass:"WatchBox-message",attrs:{"loading":_vm.loading,"counter":_vm.maxLength,"rows":3,"placeholder":_vm.placeholder,"rules":[function (v) { return v.length <= _vm.maxLength || ("Max " + _vm.maxLength + " characters"); }]},on:{"keyup":function (e) { return _vm.keyup(e); }},model:{value:(_vm.msgInput),callback:function ($$v) {_vm.msgInput=$$v},expression:"msgInput"}}):_vm._e()],1):_vm._e()],1),_vm._v(" "),(_vm.dragEnter && !_vm.dragChat && (_vm.entLevel === '5' || _vm.entLevel === '6' || _vm.entLevel === '7') )?_c('vue-dropzone',{ref:"theDropZone",staticClass:"wz_dropzone actifDropZone",attrs:{"id":"dropzone_BO","options":_vm.dropzoneOptions},on:{"vdropzone-file-added":_vm.fileAdded,"vdropzone-sending":_vm.sending,"vdropzone-success":_vm.success,"vdropzone-error":_vm.error,"vdropzone-removed-file":_vm.removedFile,"vdropzone-drop":_vm.vddrop,"vdropzone-drag-start":_vm.vdstart,"vdropzone-drag-end":_vm.vdend,"vdropzone-drag-enter":_vm.vdenter,"vdropzone-drag-over":_vm.vdover,"vdropzone-drag-leave":_vm.vdleave}}):_vm._e()],1),_vm._v(" "),_c('wz-dialog-close-chat',{attrs:{"datasVisiteur":_vm.datasVisiteur,"dialogCloseChat":_vm.dialogCloseChat},on:{"fermeDialogCloseChat":_vm.fermeDialogCloseChat}})],1)}
var WzFenetreChat_staticRenderFns = []
var WzFenetreChat_esExports = { render: WzFenetreChat_render, staticRenderFns: WzFenetreChat_staticRenderFns }
/* harmony default export */ var watcheebox_WzFenetreChat = (WzFenetreChat_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzFenetreChat.vue
function WzFenetreChat_injectStyle (ssrContext) {
  __webpack_require__("Uhve")
}
var WzFenetreChat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzFenetreChat___vue_template_functional__ = false
/* styles */
var WzFenetreChat___vue_styles__ = WzFenetreChat_injectStyle
/* scopeId */
var WzFenetreChat___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzFenetreChat___vue_module_identifier__ = null
var WzFenetreChat_Component = WzFenetreChat_normalizeComponent(
  WzFenetreChat,
  watcheebox_WzFenetreChat,
  WzFenetreChat___vue_template_functional__,
  WzFenetreChat___vue_styles__,
  WzFenetreChat___vue_scopeId__,
  WzFenetreChat___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzFenetreChat = (WzFenetreChat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzViewChat.vue






/* harmony default export */ var WzViewChat = ({
  props: ['datasViewPupitre', 'placesPupitre', 'selectedAgent', 'dragOverStatus', 'dragOverElement'], data: function data() {
    return {
      loading: false,
      histoChat: [],
      loadingChat: false,
      chatSessionActive: this.datasViewPupitre.visiteurID,
      msg: '',

      bigWidthChat: false,

      bigHeightChat: true,
      selectedMenuVisiteur: 'info' };
  },


  methods: {
    chatSessionSelected: function chatSessionSelected(e) {
      console.log('session chat selected', e);
      this.chatSessionActive = e;
      this.$emit('chatSessionSelect', e);
    },
    sendReponseAttente: function sendReponseAttente(e) {
      this.$emit('MAJHistoChat', e);
    },
    openFirstChat: function openFirstChat() {
      var _this = this;

      var visClone = lodash_default.a.cloneDeep(this.dataCompletVisiteur);
      visClone.newMessage = false;

      if (this.datasViewPupitre.visiteurDatas && this.datasViewPupitre.visiteurDatas.network) {
        visClone.networkFirstMessage = false;
      }

      this.$store.commit('_StoreWatcheeBox/SET_VISITEURS', visClone);

      lodash_default.a.each(this.$store.state._Notifier.notifications, function (notif, idx) {
        if (notif.data && notif.data.titre === _this.datasViewPupitre.visiteurID) {
          _this.$store.commit('_Notifier/REMOVE_NOTIF', idx);
        }
      });
    },
    openChat: function openChat() {
      var _this2 = this;

      this.loadingChat = true;
      this.$emit('loading');

      watcheebox_watcheebox.firstLoadHistoChat({
        chatSession: this.dataCompletVisiteur.visiteurID,
        entrepriseId: this.user.entId
      }).then(function (histoChat) {
        var visClone = lodash_default.a.cloneDeep(_this2.dataCompletVisiteur);
        visClone.histoChat = histoChat;

        console.log('set visiteur openchat', visClone);
        _this2.$store.commit('_StoreWatcheeBox/SET_VISITEURS', visClone);

        _this2.showIframeMirroring(_this2.dataCompletVisiteur);
      }).catch(function (e) {
        console.error(e);
      }).then(function (_) {
        _this2.loadingChat = false;
      });
    },
    visiteurStatus: function visiteurStatus(visiteurInfos) {
      console.log('visiteurStatus', visiteurInfos);

      var divCible = this.$el.getElementsByClassName('presenceVisiteur')[0];
      if (!divCible) return;

      if (visiteurInfos.status === 'online') {
        divCible.classList.remove('affiche');
        divCible.classList.add('cache');
      } else {
        divCible.classList.remove('cache');
        divCible.classList.add('affiche');
      }
    }
  },

  watch: {
    'datasViewPupitre.online': function datasViewPupitreOnline(val, oldval) {
      this.visiteurStatus(this.pupitreInfosVisiteur);
    },

    'dataCompletVisiteur.visiteurID': function dataCompletVisiteurVisiteurID() {
      console.log('this.dataCompletVisiteur', this.dataCompletVisiteur);
      if (this.dataCompletVisiteur) {
        if (!this.dataCompletVisiteur.histoChat.length) {
          console.log('openChat', this.dataCompletVisiteur.visiteurID);
          this.openChat();
        }
      } else {
        console.log('visiteur plus la');
      }
    }
  },

  mounted: function mounted() {
    if (this.dataCompletVisiteur && !this.dataCompletVisiteur.histoChat.length) {
      this.openChat();
    }
  },
  beforeDestroy: function beforeDestroy() {},


  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['listeAllVisiteurs', 'sessionsPrivees', 'mySocketID']), Object(vuex_esm["c" /* mapGetters */])('_User', ['user']), {

    dataCompletVisiteur: {
      get: function get() {
        var data;

        if (this.$route.fullPath === '/trafic/attente') {
          var newData = lodash_default.a.clone(this.datasViewPupitre.visiteurDatas);
          var histoChatVisiteurMessageAttente = lodash_default.a.clone(this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.histoChat);

          newData.histoChat = histoChatVisiteurMessageAttente;
          data = newData;
        } else {
          data = lodash_default.a.clone(this.datasViewPupitre.visiteurDatas);
        }

        return data;
      },
      set: function set(vis) {
        this.histoChat = vis.histoChat;
      }
    },

    routeNameChatting: function routeNameChatting() {
      if (this.$route.fullPath === '/trafic/chatting') {
        return true;
      } else {
        return false;
      }
    },
    pupitreInfosVisiteur: function pupitreInfosVisiteur() {
      var infosPupitre = lodash_default.a.find(this.listeAllVisiteurs, ['visiteurID', this.datasViewPupitre.visiteurDatas.visiteurID]);
      return {
        status: infosPupitre.status,
        lang: infosPupitre.lang,
        visiteurID: infosPupitre.visiteurID,
        roomName: infosPupitre.roomName,
        socketID: infosPupitre.socketID,
        siteID: infosPupitre.siteID,
        notification: infosPupitre.notification,
        placePupitre: infosPupitre.placePupitre,
        histoChat: infosPupitre.histoChat,
        geoloc: infosPupitre.geoloc
      };
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5fde0f10","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzViewChat.vue
var WzViewChat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fill-height posRelative"},[_c('v-layout',{directives:[{name:"show",rawName:"v-show",value:(!_vm.dragOverStatus),expression:"!dragOverStatus"}],staticClass:"fill-height ma-0",attrs:{"row":"","wrap":""}},[_c('v-flex',{directives:[{name:"show",rawName:"v-show",value:(!_vm.bigWidthChat || !_vm.bigHeightChat),expression:"!bigWidthChat || !bigHeightChat"}],staticClass:"pa-0 fill-height",class:{
          'xs7': _vm.bigHeightChat,
          'xs12': !_vm.bigHeightChat,
          'infos-panel--large': !_vm.bigHeightChat
        }},[(_vm.dataCompletVisiteur && _vm.chatSessionActive)?_c('wz-content-infos-visiteur',{ref:"infos",staticClass:"cardInfosVisiteurPupitre",attrs:{"datasVisiteur":_vm.dataCompletVisiteur,"datasPupitreVisiteur":_vm.datasViewPupitre,"placesPupitre":_vm.placesPupitre,"selectedAgent":_vm.selectedAgent,"msg":_vm.msg},on:{"update:msg":function($event){_vm.msg=$event},"sendMsg":function (msg) { return _vm.$refs.fenetreChat.sendMessage(msg); }}}):(!_vm.dataCompletVisiteur && _vm.chatSessionActive)?_c('div',{staticClass:"flex"},[_c('v-alert',{attrs:{"type":"warning","value":true}},[_vm._v("\n            "+_vm._s(_vm.$t('noDataVisiteur'))+"\n          ")])],1):_vm._e()],1),_vm._v(" "),_c('v-flex',{staticClass:"pa-0",class:{
          'xs5': !_vm.bigWidthChat,
          'xs12': _vm.bigWidthChat || !_vm.bigHeightChat,
          'chat-panel--reduce': !_vm.bigHeightChat
        }},[(_vm.dataCompletVisiteur && _vm.chatSessionActive)?_c('wz-fenetre-chat',{ref:"fenetreChat",attrs:{"datasVisiteur":_vm.dataCompletVisiteur,"loadingChat":_vm.loadingChat,"msg":_vm.msg},on:{"reloadHistoChat":_vm.openChat,"bigChat":function($event){_vm.bigHeightChat = true},"smallChat":function($event){_vm.bigHeightChat = false},"bigWidthChat":function($event){_vm.bigWidthChat = true},"smallWidthChat":function($event){_vm.bigWidthChat = false},"update:datasVisiteur":function($event){_vm.dataCompletVisiteur=$event},"update:msg":function($event){_vm.msg=$event},"sendReponseAttente":_vm.sendReponseAttente,"chatSessionSelect":_vm.chatSessionSelected}}):(!_vm.dataCompletVisiteur && _vm.chatSessionActive)?_c('div',{staticClass:"flex"},[_c('v-alert',{attrs:{"type":"warning","value":true}},[_vm._v("\n            "+_vm._s(_vm.$t('noDataChat'))+"\n          ")])],1):_vm._e()],1),_vm._v(" "),(_vm.dataCompletVisiteur && (_vm.datasViewPupitre.visiteurDatas.newMessage && !_vm.datasViewPupitre.visiteurDatas.network && _vm.routeNameChatting) || _vm.dataCompletVisiteur && (_vm.datasViewPupitre.visiteurDatas.network && _vm.datasViewPupitre.visiteurDatas.networkFirstMessage))?_c('div',{staticClass:"dialogueNewChat"},[_c('v-card',{staticClass:"ContentDialogNewChat"},[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('titreNewChat')))]),_vm._v(" "),_c('v-card-text',[_vm._v("\n            "+_vm._s(_vm.$t('txtContentNewChat'))+" "+_vm._s(_vm.dataCompletVisiteur.visiteurID)+".\n          ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.openFirstChat()}}},[_vm._v("OK\n            ")])],1)],1)],1):_vm._e()],1),_vm._v(" "),(_vm.dragOverStatus && _vm.dragOverElement.index != (_vm.dragOverElement.dataDrop.placePupitreActif-1))?_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{staticStyle:{"height":"200px"},attrs:{"align-center":"","justify-center":"","row":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('changePlace')))]),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.$t('changePlaceContent1') +' <b>'+ _vm.datasViewPupitre.visiteurDatas.placePupitre +'</b><br>'+ _vm.$t('changePlaceContent2') +' <b>'+ _vm.datasViewPupitre.visiteurID +'</b>.<br> '+ _vm.$t('askChangePlace') )}})],1)],1)],1):(_vm.dragOverStatus && _vm.dragOverElement.index == (_vm.dragOverElement.dataDrop.placePupitreActif-1))?_c('v-container',{attrs:{"fill-height":""}},[_c('v-layout',{staticStyle:{"height":"200px"},attrs:{"align-center":"","justify-center":"","row":""}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('changePlace')))]),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.$t('changePlaceContent1') +' <b>'+ _vm.datasViewPupitre.visiteurDatas.placePupitre +'</b><br>'+ _vm.$t('txtNoChangePlace'))}})],1)],1)],1):_vm._e()],1)}
var WzViewChat_staticRenderFns = []
var WzViewChat_esExports = { render: WzViewChat_render, staticRenderFns: WzViewChat_staticRenderFns }
/* harmony default export */ var watcheebox_WzViewChat = (WzViewChat_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzViewChat.vue
function WzViewChat_injectStyle (ssrContext) {
  __webpack_require__("uMJS")
}
var WzViewChat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzViewChat___vue_template_functional__ = false
/* styles */
var WzViewChat___vue_styles__ = WzViewChat_injectStyle
/* scopeId */
var WzViewChat___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzViewChat___vue_module_identifier__ = null
var WzViewChat_Component = WzViewChat_normalizeComponent(
  WzViewChat,
  watcheebox_WzViewChat,
  WzViewChat___vue_template_functional__,
  WzViewChat___vue_styles__,
  WzViewChat___vue_scopeId__,
  WzViewChat___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzViewChat = (WzViewChat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzViewAttente.vue




/* harmony default export */ var WzViewAttente = ({
  props: ['datasFileAttente', 'pupitreData'],
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['pupitreViewStatus']))
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-12411388","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzViewAttente.vue
var WzViewAttente_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"row":"","wrap":""}},_vm._l((_vm.datasFileAttente),function(dataVisiteurAttente,i){return _c('v-flex',{key:i,staticClass:"xs12",class:{ 'md6': _vm.pupitreViewStatus == 2, 'md4': _vm.pupitreViewStatus == 1 }},[_c('wz-visiteur-attente',{attrs:{"visiteur":dataVisiteurAttente,"pupitreData":_vm.pupitreData},on:{"supVisiteurFile":function($event){_vm.$emit('supVisiteurFile', $event)}}})],1)}),1)}
var WzViewAttente_staticRenderFns = []
var WzViewAttente_esExports = { render: WzViewAttente_render, staticRenderFns: WzViewAttente_staticRenderFns }
/* harmony default export */ var watcheebox_WzViewAttente = (WzViewAttente_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzViewAttente.vue
var WzViewAttente_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzViewAttente___vue_template_functional__ = false
/* styles */
var WzViewAttente___vue_styles__ = null
/* scopeId */
var WzViewAttente___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzViewAttente___vue_module_identifier__ = null
var WzViewAttente_Component = WzViewAttente_normalizeComponent(
  WzViewAttente,
  watcheebox_WzViewAttente,
  WzViewAttente___vue_template_functional__,
  WzViewAttente___vue_styles__,
  WzViewAttente___vue_scopeId__,
  WzViewAttente___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzViewAttente = (WzViewAttente_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzVisiteurAttente.vue







/* harmony default export */ var WzVisiteurAttente = ({
  components: { Drag: vue_drag_drop_common["Drag"] },
  props: {
    visiteur: {
      type: Object,
      required: true
    },
    pupitreData: {
      type: Array,
      required: true
    }
  },

  data: function data() {
    return {
      itemsMenu: [],
      selectedAgent: {
        'id': '',
        'name': '',
        'status': ''
      },
      dialogTransfereChat: false,
      color: 'light-blue',
      checkForMotif: false,
      dialogCloseChat: false,
      formulaireSatisfaction: false,
      clotureChat: false
    };
  },
  mounted: function mounted() {
    if (this.$store.state._User.entKey === '9c44184c124fda32ac19523ff93d2488') {
      this.checkForMotif = true;
    }

    this.itemsMenu = [{
      title: lodash_default.a.upperFirst(this.$t('toOpen')),
      icon: 'arrow_upward',

      nameAction: 'openChat',
      disabled: false
    }, {
      title: lodash_default.a.upperFirst(this.$t('close')),
      icon: 'clear',

      nameAction: 'closeChat',
      disabled: false
    }, {
      title: lodash_default.a.upperFirst(this.$t('toTransfer')),
      icon: 'forward',
      nameAction: 'transferer',
      disabled: this.checkSocialVisiteur()
    }, {
      title: lodash_default.a.upperFirst(this.$t('banish')),
      icon: 'block',
      nameAction: 'bannChat',
      disabled: false
    }];
  },


  methods: {
    menuAction: function menuAction(value) {
      if (value === 'closeChat') {
        this.fermeChat();
      } else if (value === 'openChat') {
        this.modifPlacePupitre({
          dataDrop: {
            visiteurID: this.visiteur.visiteurID,
            placePupitreActif: this.visiteur.placePupitre,
            reponseCobrowsing: this.visiteur.reponseCobrowsing,
            menuStelected: this.visiteur.menuSelected
          },

          statusView: this.pupitreData[0].view.viewStatus ? this.pupitreData[0].view.viewStatus : false,
          place: 1,
          idVisiteurPlace: this.pupitreData[0].view.viewStatus ? this.pupitreData[0].view.visiteurDatas.visiteurID : 'undefined',
          menuSelectedPlace: this.pupitreData[0].view.viewStatus ? this.pupitreData[0].view.visiteurDatas.menuSelected : 'undefined',
          reponseCobrowsingPlace: this.pupitreData[0].view.viewStatus ? this.pupitreData[0].view.visiteurDatas.responseCobrowsing : 'undefined'
        });
      } else if (value === 'transferer') {
        console.log('transferVisiteur', this.visiteur.visiteurID);
        this.$refs.dialogTransfert.open();
      } else if (value === 'bannChat') {
        console.log('bannir le visiteur');
      }
    },
    modifPlacePupitre: function modifPlacePupitre(data) {
      this.$store.commit('_StoreWatcheeBox/CHANGE_PLACE_PUPITRE_VISITEUR', data);
    },
    handleDragstart: function handleDragstart() {
      console.log('drag chat');
      this.$store.commit('_StoreWatcheeBox/CHANGE_DRAG_CHAT', true);
    },
    handleDragend: function handleDragend() {
      console.log('stop drag chat');
      this.$store.commit('_StoreWatcheeBox/CHANGE_DRAG_CHAT', false);
    },
    fermeChat: function fermeChat() {
      this.dialogCloseChat = true;
    },
    fermeDialogCloseChat: function fermeDialogCloseChat(data) {
      this.dialogCloseChat = data.dialogCloseChat;
    },
    transferChat: function transferChat() {
      console.log('transferChat', this.visiteur);

      if (this.selectedAgent.id !== '') {
        var datasVisiteurSelect = {
          'socketID': this.visiteur.socketID,
          'visiteurID': this.visiteur.visiteurID,
          'visiteurKey': this.visiteur.roomName
        };
        var mySocketID = this.WATCHEEBOX_STATE.mySocketID;
        watcheebox_watcheebox.SendTransfertVisitor({
          'selectedAgent': this.selectedAgent,
          'datasSelectedVisiteur': datasVisiteurSelect,
          'agentsArray': this.agentsArray,
          'socket': this.$socket,
          'myAgentID': this.$store.state._User.id,
          'mySocketID': mySocketID,
          'agentSenderName': this.fullName
        });
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', { message: 'Selectionnez un agent dans la liste avant de transferer ce visiteur', context: 'warning' });
      }
    },
    transferChatAnnuler: function transferChatAnnuler() {
      var mySocketID = this.WATCHEEBOX_STATE.mySocketID;
      watcheebox_watcheebox.AnnulTransfertVisitor({
        'selectedAgent': this.selectedAgent,

        'socket': this.$socket,
        'mySocketID': mySocketID,
        'agentSenderName': this.fullName
      });
      this.dialogTransfereChat = false;
      this.$store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
        status: '',
        emission: true,
        messageDatas: ''
      });
    },
    checkSocialVisiteur: function checkSocialVisiteur() {
      if (this.visiteur.network) {
        return true;
      } else {
        return false;
      }
    },
    colorAttente: function colorAttente(seuil) {
      var colors = ['light-blue', 'teal', 'lime', 'orange', 'red', 'deep-purple'];
      this.color = colors[seuil];
    }
  },

  watch: {
    'visiteur.visiteurID': function visiteurVisiteurID() {
      this.dialogTransfereChat = false;
    },

    formulaireSatisfaction: function formulaireSatisfaction(v) {
      this.$cookie.set('wz-satisfaction-survey', v, { expires: '1Y' });
    },
    clotureChat: function clotureChat(v) {
      this.$cookie.set('wz-closing-chat', v, { expires: '1Y' });
    }
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['agentsArray', 'listeChatAgent', 'pupitreViewStatus']), Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'fullName']), Object(vuex_esm["c" /* mapGetters */])('_StoreWatcheeBox', ['WATCHEEBOX_STATE']), {
    hasMotif: function hasMotif() {
      var thisVisit = lodash_default.a.find(this.$store.state._StoreWatcheeBox.listeAllVisiteurs, {
        visiteurID: this.visiteur.visiteurID
      });
      return thisVisit ? thisVisit.motif : false;
    },
    istypingVisiteur: function istypingVisiteur() {
      var typing = lodash_default.a.find(this.visiteur.histoChat, { 'isTyping': true, 'auteur': 'Visiteur' });
      if (typing) {
        return true;
      } else {
        return null;
      }
    },
    dejaEnChat: function dejaEnChat() {
      var data = lodash_default.a.find(this.listeChatAgent, [0, this.visiteur.visiteurID]);
      if (data) {
        var userFound = this.$store.getters['_User/getUserById'](data[3]);
        return { 'sessionID': data[0], 'agentID': data[3], 'agentName': userFound.USR_FIRST_NAME + ' ' + userFound.USR_LAST_NAME };
      } else {
        return null;
      }
    },
    nameVisiteur: function nameVisiteur() {
      if (this.visiteur.visiteurName) {
        return this.visiteur.visiteurName;
      } else {
        return this.visiteur.visiteurID;
      }
    },
    visiteurLastMessage: function visiteurLastMessage() {
      if (this.visiteur.lastMessage && this.visiteur.lastMessage !== null) {
        return this.visiteur.lastMessage;
      } else {
        return null;
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b2344188","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzVisiteurAttente.vue
var WzVisiteurAttente_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('drag',{staticClass:"drag",attrs:{"transfer-data":{ visiteurID: _vm.visiteur.visiteurID, placePupitreActif: _vm.visiteur.placePupitre, menuStelected: _vm.visiteur.menuSelected, reponseCobrowsing: _vm.visiteur.reponseCobrowsing }},on:{"dragstart":_vm.handleDragstart,"dragend":_vm.handleDragend}},[_c('v-toolbar',{staticClass:"grey lighten-1",class:{newMessage : _vm.visiteurLastMessage},attrs:{"dark":"","dense":""}},[(_vm.visiteur.network)?_c('wz-avatar',{attrs:{"src":_vm.visiteur.profile_pic,"username":_vm.visiteur.visiteurName,"size":"38px"}}):(_vm.istypingVisiteur)?_c('wz-avatar',{staticClass:"istypingListAttente",attrs:{"isTyping":_vm.istypingVisiteur,"username":'#' + _vm.visiteur.visiteurID,"size":"38px","chip":""}}):(!_vm.istypingVisiteur && _vm.visiteurLastMessage)?_c('wz-avatar',{attrs:{"username":'#' + _vm.visiteur.visiteurID,"size":"38px","lastMessage":""}}):_c('wz-avatar',{attrs:{"username":'#' + _vm.visiteur.visiteurID,"size":"38px"}}),_vm._v(" "),_c('v-flex',{attrs:{"ellipsis":"","ml-2":""}},[_c('div',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.nameVisiteur))]),_vm._v(" "),_c('div',{staticClass:"ellipsis"},[_vm._v(_vm._s(_vm.visiteur.lastMessage))])]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('wz-visiteur-timer',{attrs:{"timeStart":_vm.visiteur.timeStampArrive},on:{"updateSeuil":_vm.colorAttente}}),_vm._v(" "),_c('v-menu',{attrs:{"bottom":"","right":""}},[_c('v-btn',{attrs:{"slot":"activator","icon":"","dark":""},slot:"activator"},[_c('v-icon',[_vm._v("more_vert")])],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.itemsMenu),function(item){return _c('v-list-tile',{key:item.title,attrs:{"disabled":item.disabled},on:{"click":function($event){item.disabled ? '' : _vm.menuAction(item.nameAction)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)}),1)],1)],1),_vm._v(" "),(!_vm.visiteur.connexion)?_c('div',{staticClass:"clientAttenteOffline error"}):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition","overlay":false},model:{value:(_vm.dialogTransfereChat),callback:function ($$v) {_vm.dialogTransfereChat=$$v},expression:"dialogTransfereChat"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",attrs:{"dark":""}},[_c('v-menu',{attrs:{"bottom":"","right":""}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.dialogTransfereChat = false}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-list',{attrs:{"dense":""}},_vm._l((_vm.itemsMenu),function(item){return _c('v-list-tile',{key:item.title,attrs:{"disabled":item.disabled},on:{"click":function($event){item.disabled ? '' : _vm.menuAction(item.nameAction)}}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(item.icon))])],1),_vm._v(" "),_c('v-list-tile-title',[_vm._v(_vm._s(item.title))])],1)}),1)],1)],1)],1)],1),_vm._v(" "),(!_vm.visiteur.connexion)?_c('div',{staticClass:"clientAttenteOffline error"}):_vm._e(),_vm._v(" "),_c('wz-dialog-close-chat',{attrs:{"datasVisiteur":_vm.visiteur,"dialogCloseChat":_vm.dialogCloseChat},on:{"fermeDialogCloseChat":_vm.fermeDialogCloseChat}}),_vm._v(" "),_c('wz-dialog-transfert-chat',{ref:"dialogTransfert",attrs:{"datasVisiteur":_vm.visiteur}})],1)],1)}
var WzVisiteurAttente_staticRenderFns = []
var WzVisiteurAttente_esExports = { render: WzVisiteurAttente_render, staticRenderFns: WzVisiteurAttente_staticRenderFns }
/* harmony default export */ var watcheebox_WzVisiteurAttente = (WzVisiteurAttente_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzVisiteurAttente.vue
function WzVisiteurAttente_injectStyle (ssrContext) {
  __webpack_require__("icEZ")
}
var WzVisiteurAttente_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzVisiteurAttente___vue_template_functional__ = false
/* styles */
var WzVisiteurAttente___vue_styles__ = WzVisiteurAttente_injectStyle
/* scopeId */
var WzVisiteurAttente___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzVisiteurAttente___vue_module_identifier__ = null
var WzVisiteurAttente_Component = WzVisiteurAttente_normalizeComponent(
  WzVisiteurAttente,
  watcheebox_WzVisiteurAttente,
  WzVisiteurAttente___vue_template_functional__,
  WzVisiteurAttente___vue_styles__,
  WzVisiteurAttente___vue_scopeId__,
  WzVisiteurAttente___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzVisiteurAttente = (WzVisiteurAttente_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzVisiteurTimer.vue





/* harmony default export */ var WzVisiteurTimer = ({
  props: {
    'timeStart': {
      type: Number,
      default: Date.now()
    }
  },

  data: function data() {
    return {
      time: null,
      chrono: null
    };
  },


  methods: {
    startChrono: function startChrono() {
      var now = moment_default()(Date.now()).utc();

      var start = moment_default()(this.timeStart).utc();

      var diff = moment_default()(now).diff(moment_default()(start));
      var duration = moment_default.a.duration(diff);

      this.time = moment_default()(diff).utc().format('H:mm:ss');

      this.$emit('updateSeuil', lodash_default.a.floor(duration.asMinutes() / 2));
    },
    stopChrono: function stopChrono() {
      clearInterval(this.chrono);
      this.time = null;
    }
  },

  beforeDestroy: function beforeDestroy() {
    this.stopChrono();
  },
  mounted: function mounted() {
    this.chrono = setInterval(this.startChrono, 1000);
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-75447946","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzVisiteurTimer.vue
var WzVisiteurTimer_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wz_viewTimerClient"},[_vm._v("\n "+_vm._s(_vm.time)+"\n ")])}
var WzVisiteurTimer_staticRenderFns = []
var WzVisiteurTimer_esExports = { render: WzVisiteurTimer_render, staticRenderFns: WzVisiteurTimer_staticRenderFns }
/* harmony default export */ var watcheebox_WzVisiteurTimer = (WzVisiteurTimer_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzVisiteurTimer.vue
var WzVisiteurTimer_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzVisiteurTimer___vue_template_functional__ = false
/* styles */
var WzVisiteurTimer___vue_styles__ = null
/* scopeId */
var WzVisiteurTimer___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzVisiteurTimer___vue_module_identifier__ = null
var WzVisiteurTimer_Component = WzVisiteurTimer_normalizeComponent(
  WzVisiteurTimer,
  watcheebox_WzVisiteurTimer,
  WzVisiteurTimer___vue_template_functional__,
  WzVisiteurTimer___vue_styles__,
  WzVisiteurTimer___vue_scopeId__,
  WzVisiteurTimer___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzVisiteurTimer = (WzVisiteurTimer_Component.exports);

// EXTERNAL MODULE: ./node_modules/vue2-google-maps/dist/main.js
var main = __webpack_require__("sA6N");
var main_default = /*#__PURE__*/__webpack_require__.n(main);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzFicheInfosVisiteur.vue












vue_esm["default"].use(main, {
  load: {
    key: 'AIzaSyCc2X0qGdzjlu6eyh1xQZdgAL5AHOJ818M'
  }
});
/* harmony default export */ var WzFicheInfosVisiteur = ({
  data: function data() {
    return {
      error: false,
      loadingFicheVisiteur: false,
      loadingHistoUrl: false,
      histoUrlCharged: false,
      histoUrlOpened: false,
      infoStatus: true,
      visiteurInfo: {},
      listUrls: null,
      navComputed: false,
      alertsVisiteur: this.datasVisiteur.alertsAllowed,

      loadingGeoloc: false,
      dataWatchVisteur: {},

      showLayoutChooser: false,
      layout: []
    };
  },


  props: ['datasVisiteur'],

  watch: {
    'datasVisiteur': function datasVisiteur(val, oldval) {
      if (!val) {
        this.dataWatchVisteur = oldval;
      } else {
        this.dataWatchVisteur = val;
      }
    },
    'datasVisiteur.visiteurID': function datasVisiteurVisiteurID(val, oldval) {
      this.showInfo(this.datasVisiteur);
    }
  },

  methods: extends_default()({}, Object(vuex_esm["d" /* mapMutations */])('_StoreWatcheeBox', ['SET_VISITEURS', 'SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE']), {
    brideMenu: function brideMenu(nameBride) {
      if (this.brides) {
        var index = this.brides.findIndex(function (bride) {
          return bride.brideName === nameBride;
        });

        if (index !== -1) {
          return this.brides[index].status;
        }
      }
    },
    showInfo: function showInfo(_visRef) {
      var _this = this;

      var dataToGet = new window.FormData();
      dataToGet.append('session', _visRef.visiteurID);
      dataToGet.append('siteID', _visRef.siteID);
      dataToGet.append('specialtable', this.user.licSpecialtable);
      this.axios.post('get/visitor_info.php', dataToGet, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        var _identity = response.data.defaultId;
        if (typeof response.data.fname !== 'undefined' && response.data.fname !== '') {
          _identity = response.data.fname;
        }
        if (typeof response.data.lname !== 'undefined' && response.data.lname !== '') {
          _identity += ' ' + response.data.lname;
        }
        if (_identity === response.data.defaultId) {
          if (typeof response.data.form_fname !== 'undefined' && response.data.form_fname !== '') {
            _identity = response.data.form_fname;
          }
          if (typeof response.data.form_lname !== 'undefined' && response.data.form_lname !== '') {
            _identity += ' ' + response.data.form_lname;
          }
        }
        var _getplus = '';
        if (typeof response.data.getplus !== 'undefined' && response.data.getplus !== '') {
          _getplus = response.data.getplus;
        }
        var _apiinfo = '';
        if (typeof response.data.apiinfo !== 'undefined' && response.data.apiinfo !== '') {
          _apiinfo = response.data.apiinfo;
        }
        var _email = response.data.email;
        if ((!_email || _email === '') && typeof response.data.form_email !== 'undefined' && response.data.form_email !== '') {
          _email = response.data.form_email;
        }
        var _tel = response.data.tel;
        if ((!_tel || _tel === '') && typeof response.data.form_tel !== 'undefined' && response.data.form_tel !== '') {
          _tel = response.data.form_tel;
        }
        var _comment = response.data.comment;
        if ((!_comment || _comment === '') && typeof response.data.form_question !== 'undefined' && response.data.form_question !== '') {
          _comment = response.data.form_question;
        }
        _this.visiteurInfo = {
          session_id: response.data.session_id,
          focus: response.data.focus,
          lastTs: moment_default()(response.data.lastTs).fromNow(),
          defaultId: response.data.defaultId,
          language: response.data.language,
          ip: response.data.ip,
          browser: response.data.browser,
          purchases: response.data.purchases,
          key: response.data.key,
          getplus: _getplus,
          apiinfo: _apiinfo,
          identity: _identity,
          fname: response.data.fname,
          lname: response.data.lname,
          date_lead: response.data.date_lead,
          email: _email,
          tel: _tel,
          comment: _comment,
          last_cart_date: response.data.last_cart_date,
          last_cart_amount: response.data.last_cart_amount,
          last_cart_nb: response.data.last_cart_nb,
          motifchat: response.data.motifchat
        };
        _this.error = false;

        if (_this.$route.fullPath === '/trafic/attente') {
          _this.updateAllDataVisiteurOpened(_this.visiteurInfo);
        }
      }).catch(function () {
        _this.error = true;
        _this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this.$t('error'),
          context: 'error'
        });
      }).then(function () {
        _this.loadingFicheVisiteur = false;
      });
    },
    showNav: function showNav() {
      var _this2 = this;

      this.loadingHistoUrl = true;
      var dataToGet = new window.FormData();
      dataToGet.append('session', this.datasVisiteur.visiteurID);
      dataToGet.append('siteID', this.datasVisiteur.siteID);
      dataToGet.append('key', this.datasVisiteur.key);

      this.axios.post('get/visitor_urlList.php', dataToGet, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } }).then(function (response) {
        _this2.listUrls = response.data;
        _this2.listUrls = lodash_default.a.sortBy(_this2.listUrls, ['last']).reverse();
        _this2.listUrls = _this2.listUrls.map(function (url) {
          var u = url;
          u.last = moment_default.a.unix(u.last).format('llll');
          return u;
        });
        _this2.navComputed = true;
        _this2.loadingHistoUrl = false;
        _this2.histoUrlCharged = true;
        _this2.histoUrlOpened = true;
      }).catch();
    },
    fermeHistoUrl: function fermeHistoUrl() {
      this.histoUrlOpened = false;
      this.navComputed = false;
    },
    ouvreHistoUrl: function ouvreHistoUrl() {
      this.histoUrlOpened = true;
      this.navComputed = true;
    },
    demandeGeoloc: function demandeGeoloc() {
      var _this3 = this;

      if (!this.$socket) {
        setTimeout(function () {
          _this3.demandeGeoloc();
        }, 5000);
        return;
      }

      watcheebox_watcheebox.demandeGeoloc({
        'mySocketID': this.mySocketID,
        'datasVisiteur': this.datasVisiteur
      });
      this.loadingGeoloc = true;
    },
    stopAlert: function stopAlert() {
      var _this4 = this;

      var file = 'stop_alert.php';
      if (!this.alertsVisiteur) {
        file = 'start_alert.php';
      }
      var config = {
        responseType: 'json',
        headers: { 'X-Requested-With': 'XMLHttpRequest', 'Content-Type': 'application/x-www-form-urlencoded' }
      };

      var dataToPost = new window.FormData();

      dataToPost.append('visiteurID', this.datasVisiteur.visiteurID);
      this.axios.post('post/' + file, dataToPost, config).then(function (response) {
        var newDataVisiteur = lodash_default.a.cloneDeep(_this4.datasVisiteur);
        if (_this4.alertsVisiteur) {
          newDataVisiteur.nb_alert = 0;
        } else {
          newDataVisiteur.nb_alert = 1;
        }
        newDataVisiteur.alertsAllowed = _this4.alertsVisiteur;
        _this4.SET_VISITEURS(newDataVisiteur);
      }).catch().then(function (_) {});
    },
    updateFormLayout: function updateFormLayout() {
      var layoutFromCookie = JSON.parse(this.$cookie.get('wz-fiche-visiteur'));
      this.layout = layoutFromCookie ? assign_default()(FORM_LAYOUT, layoutFromCookie) : FORM_LAYOUT;
    },
    updateAllDataVisiteurOpened: function updateAllDataVisiteurOpened(dataVisiteur) {
      dataVisiteur.histoChat = this.$store.state._StoreWatcheeBox.allDataVisiteurOpened.histoChat;
      this.SET_VISITEURS_ALL_DATA_MESSAGE_ATTENTE(dataVisiteur);
    }
  }),

  created: function created() {
    this.updateFormLayout();
  },
  mounted: function mounted() {
    this.loadingFicheVisiteur = true;
    this.showInfo(this.datasVisiteur);
    if (this.user.askGeoloc === '1') {
      this.demandeGeoloc();
    }
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'brides']), Object(vuex_esm["e" /* mapState */])('_User', ['brides']), Object(vuex_esm["c" /* mapGetters */])('_Sites', ['GET_SITE_BY_ID']), Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['listeAllVisiteurs', 'mySocketID']), {
    refererUrl: function refererUrl() {
      var url = null;
      var index = lodash_default.a.findIndex(this.listeAllVisiteurs, { 'visiteurID': this.visiteurComputed.visiteurID });
      if (index !== -1 && this.listeAllVisiteurs[index].pagesFocus) {
        url = this.listeAllVisiteurs[index].pagesFocus;
      } else {
        url = this.visiteurInfo.focus;
      }
      if (!url || url === '') {
        if (this.GET_SITE_BY_ID(this.datasVisiteur.siteID)) {
          url = this.GET_SITE_BY_ID(this.datasVisiteur.siteID).LIC_URL;
        }
      }
      return url;
    },
    testGeoloc: function testGeoloc() {
      return lodash_default.a.isEmpty(this.visiteurComputed.geoloc);
    },
    visiteurComputed: function visiteurComputed() {
      return lodash_default.a.merge(this.visiteurInfo, this.dataWatchVisteur);
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f08d7a4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzFicheInfosVisiteur.vue
var WzFicheInfosVisiteur_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{attrs:{"height":"100%"}},[(_vm.loadingFicheVisiteur)?_c('div',{staticClass:"wz_loadingChat text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"size":70,"width":1,"indeterminate":""}})],1):(_vm.error)?_c('div',[_c('v-alert',{attrs:{"type":"warning","value":"true"}},[_vm._v("\n        "+_vm._s(_vm._f("cap")(_vm.$t('queryFailed')))+"\n      ")])],1):_c('div',[_c('v-btn',{attrs:{"small":"","flat":"","color":"secondary","to":"/profile"}},[_vm._v("\n        "+_vm._s(_vm.$t('editFicheLayout'))+"\n        "),_c('v-icon',{attrs:{"right":""}},[_vm._v("list_alt")])],1),_vm._v(" "),_c('div',[_c('v-list',{attrs:{"two-line":"","dense":""}},[_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[0].show),expression:"layout[0].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[0].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('currentPage'))))]),_vm._v(" "),(_vm.visiteurComputed.network)?_c('v-list-tile-sub-title',[_c('v-icon',{staticClass:"icone_facebook"},[_vm._v("mdi-facebook-box")]),_vm._v("\n                "+_vm._s(_vm.visiteurComputed.network)+"\n              ")],1):_c('v-list-tile-sub-title',[_c('a',{attrs:{"href":_vm.refererUrl,"target":"_blank"}},[_vm._v(_vm._s(_vm.refererUrl))])])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[18].show),expression:"layout[18].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[18].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('currentMotif'))))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.motifchat))])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[1].show),expression:"layout[1].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[1].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('lastLoadingDate'))))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.lastTs))])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[2].show),expression:"layout[2].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[2].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("\n                "+_vm._s(_vm.$t('autochatTitle'))+" "+_vm._s(_vm.visiteurComputed.alertsAllowed === false ? _vm.$t('disabled') : _vm.$t('enabled'))+"\n              ")]),_vm._v(" "),_c('v-switch',{staticClass:"ml-1",attrs:{"hide-details":""},on:{"click":_vm.stopAlert},model:{value:(_vm.alertsVisiteur),callback:function ($$v) {_vm.alertsVisiteur=$$v},expression:"alertsVisiteur"}})],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[3].show),expression:"layout[3].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[3].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('comment')))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.visiteurComputed.comment))])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[4].show),expression:"layout[4].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[4].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('identity')))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.identity))])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[5].show),expression:"layout[5].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[5].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('email')))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.email))])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[6].show),expression:"layout[6].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[6].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('phone')))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.tel))])],1)],1),_vm._v(" "),(!_vm.visiteurComputed.geoloc || _vm.testGeoloc)?_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[7].show),expression:"layout[7].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[7].icon))])],1),_vm._v(" "),(_vm.user.askGeoloc === '0' )?_c('v-list-tile-content',[(_vm.visiteurComputed.socketID !== 0)?_c('v-btn',{attrs:{"color":"primary","dark":"","loading":_vm.loadingGeoloc},on:{"click":function($event){_vm.demandeGeoloc()}}},[_vm._v("Géolocaliser")]):(_vm.visiteurComputed.socketID === 0)?_c('v-btn',{attrs:{"disabled":""}},[_vm._v("Géolocaliser")]):_vm._e()],1):_vm._e()],1):(_vm.visiteurComputed.geoloc && _vm.visiteurComputed.geoloc.erreur !== '0')?_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[7].show),expression:"layout[7].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[7].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.visiteurComputed.geoloc.message))]),_vm._v(" "),_c('v-list-tile-sub-title')],1)],1):(_vm.visiteurComputed.geoloc && _vm.visiteurComputed.geoloc.erreur === '0')?_c('v-card',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[7].show),expression:"layout[7].show"}]},[_c('v-list-tile-content',[(_vm.visiteurComputed.geoloc)?_c('gmap-map',{staticStyle:{"width":"100%","height":"250px"},attrs:{"center":{lat: _vm.visiteurComputed.geoloc.latitude, lng: _vm.visiteurComputed.geoloc.longitude},"zoom":7,"options":{scrollwheel: false}}},[_c('gmap-marker',{attrs:{"position":{lat: _vm.visiteurComputed.geoloc.latitude, lng: _vm.visiteurComputed.geoloc.longitude},"clickable":false,"draggable":false}})],1):_vm._e()],1)],1):_vm._e(),_vm._v(" "),_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[8].show),expression:"layout[8].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[8].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('browser'))))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.browser))])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[9].show),expression:"layout[9].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[9].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('language')))+" ("+_vm._s(_vm.$t('browser'))+")")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.language))])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[10].show),expression:"layout[10].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[10].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("IP")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.ip))])],1)],1),_vm._v(" "),(_vm.brideMenu('stats_leads_chaleur') === '1')?_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[11].show),expression:"layout[11].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[11].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('leadHeat')))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.ponderation))])],1)],1):_vm._e(),_vm._v(" "),_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[12].show),expression:"layout[12].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[12].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('alertCart'))))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.numListeAlerte))])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[13].show),expression:"layout[13].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[13].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('lastInvitAuto'))))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.lastInvitTs))])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[14].show),expression:"layout[14].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[14].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$t('beginningChat'))))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.visiteurFirstChat))])],1)],1),_vm._v(" "),_c('v-list-group',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[15].show),expression:"layout[15].show"}],attrs:{"prepend-icon":_vm.layout[15].icon,"no-action":"","append-icon":_vm.histoUrlCharged && _vm.histoUrlOpened
              ? 'zoom_out'
              : _vm.histoUrlCharged && !_vm.histoUrlOpened
                ? 'zoom_in'
                : 'zoom_in'},on:{"click":function($event){_vm.histoUrlCharged && _vm.histoUrlOpened
              ? _vm.fermeHistoUrl()
              : _vm.histoUrlCharged && !_vm.histoUrlOpened
                ? _vm.ouvreHistoUrl()
                : _vm.showNav()}},model:{value:(_vm.histoUrlOpened),callback:function ($$v) {_vm.histoUrlOpened=$$v},expression:"histoUrlOpened"}},[_c('v-list-tile',{attrs:{"slot":"activator"},slot:"activator"},[_c('v-list-tile-content',[_c('v-list-tile-title',[(_vm.loadingHistoUrl)?_c('v-progress-circular',{attrs:{"size":24,"indeterminate":"","color":"primary"}}):_c('span',[_vm._v(_vm._s(_vm.$t('navigationHistory')))])],1)],1)],1),_vm._v(" "),_vm._l((_vm.listUrls),function(url,j){return [_c('v-list-tile',{key:j,attrs:{"ripple":""}},[_c('v-list-tile-content',[_c('v-list-tile-title',[_c('a',{attrs:{"href":url.url,"target":"_blank"}},[_vm._v(_vm._s(url.smallurl))]),_vm._v(" ("+_vm._s(_vm.$tc('times', url.nb, { count: url.nb }))+")\n                  ")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n                    "+_vm._s(url.last)+"\n                  ")])],1)],1),_vm._v(" "),(j !== (_vm.listUrls.length - 1))?_c('v-divider',{key:j,attrs:{"inset":""}}):_vm._e()]})],2),_vm._v(" "),_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[16].show),expression:"layout[16].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[16].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm._f("cap")(_vm.$tc('purchases', 2, { count: '' }))))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.purchases))])],1)],1),_vm._v(" "),_c('v-list-tile',{directives:[{name:"show",rawName:"v-show",value:(_vm.layout[17].show),expression:"layout[17].show"}],attrs:{"avatar":"","xs12":""}},[_c('v-list-tile-action',[_c('v-icon',[_vm._v(_vm._s(_vm.layout[17].icon))])],1),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(_vm.$t('lastKnownBasket')))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n                "+_vm._s(_vm.visiteurComputed.last_cart_date)+" "+_vm._s(_vm.visiteurComputed.last_cart_amount)+" "+_vm._s(_vm.visiteurComputed.last_cart_nb)+"\n              ")])],1)],1)],1),_vm._v(" "),(_vm.visiteurComputed.getplus && _vm.visiteurComputed.getplus !== '')?_c('v-list',{attrs:{"two-line":"","dense":"","subheader":""}},[(_vm.visiteurComputed.getplus && _vm.visiteurComputed.getplus !== '')?_c('v-subheader',[_vm._v("INFO GETPLUS")]):(_vm.visiteurComputed.apiinfo && _vm.visiteurComputed.apiinfo !== '')?_c('v-subheader',[_vm._v("INFO API")]):_vm._e(),_vm._v(" "),(_vm.visiteurComputed.getplus['raison sociale'] && _vm.visiteurComputed.getplus['raison sociale'] !== '')?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Raison Sociale")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.getplus["raison sociale"]))])],1)],1):_vm._e(),_vm._v(" "),(_vm.visiteurComputed.getplus['email'] && _vm.visiteurComputed.getplus['email'] !== '')?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("email")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.getplus["email"]))])],1)],1):_vm._e(),_vm._v(" "),(_vm.visiteurComputed.getplus['email'] && _vm.visiteurComputed.getplus['email'] !== '')?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("email")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.getplus["email"]))])],1)],1):_vm._e(),_vm._v(" "),(_vm.visiteurComputed.getplus['segment'] && _vm.visiteurComputed.getplus['segment'] !== '')?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Segment")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.getplus["segment"]))])],1)],1):_vm._e(),_vm._v(" "),(_vm.visiteurComputed.getplus['code NAF'] && _vm.visiteurComputed.getplus['code NAF'] !== '')?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("code NAF")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.getplus["code NAF"]))])],1)],1):_vm._e(),_vm._v(" "),(_vm.visiteurComputed.getplus['activité'] && _vm.visiteurComputed.getplus['activité'] !== '')?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Activité")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.getplus["activité"]))])],1)],1):_vm._e(),_vm._v(" "),(_vm.visiteurComputed.getplus['adresse'] && _vm.visiteurComputed.getplus['adresse'] !== '')?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("adresse")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.getplus["adresse"]))])],1)],1):_vm._e(),_vm._v(" "),(_vm.visiteurComputed.getplus['telephone'] && _vm.visiteurComputed.getplus['telephone'] !== '')?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Téléphone")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.getplus["telephone"]))])],1)],1):_vm._e(),_vm._v(" "),(_vm.visiteurComputed.getplus['dirigeant'] && _vm.visiteurComputed.getplus['dirigeant'] !== '')?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("dirigeant")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.getplus["dirigeant"]))])],1)],1):_vm._e(),_vm._v(" "),(_vm.visiteurComputed.getplus['effectif'] && _vm.visiteurComputed.getplus['effectif'] !== '')?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Effectif")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.getplus["effectif"]))])],1)],1):_vm._e(),_vm._v(" "),(_vm.visiteurComputed.getplus['CA'] && _vm.visiteurComputed.getplus['CA'] !== '')?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("CA")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.getplus["CA"]))])],1)],1):_vm._e(),_vm._v(" "),(_vm.visiteurComputed.getplus['segment'] && _vm.visiteurComputed.getplus['segment'] !== '')?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Segment")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(_vm.visiteurComputed.getplus["segment"]))])],1)],1):_vm._e(),_vm._v(" "),(_vm.visiteurComputed.getplus['siret'] && _vm.visiteurComputed.getplus['siret'] !== '')?_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v("Siret - siren")]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v("\n                "+_vm._s(_vm.visiteurComputed.getplus["siret"])+" "+_vm._s(_vm.visiteurComputed.getplus["siren"])+"\n              ")])],1)],1):_vm._e()],1):(_vm.visiteurComputed.apiinfo && _vm.visiteurComputed.apiinfo !== '')?_c('v-list',{attrs:{"two-line":"","dense":""}},_vm._l((_vm.visiteurComputed.apiinfo),function(inf,j){return _c('div',{key:j},[_c('v-list-tile',[_c('v-list-tile-content',[_c('v-list-tile-title',[_vm._v(_vm._s(j))]),_vm._v(" "),_c('v-list-tile-sub-title',[_vm._v(_vm._s(inf))])],1)],1)],1)})):_vm._e()],1)],1)])}
var WzFicheInfosVisiteur_staticRenderFns = []
var WzFicheInfosVisiteur_esExports = { render: WzFicheInfosVisiteur_render, staticRenderFns: WzFicheInfosVisiteur_staticRenderFns }
/* harmony default export */ var watcheebox_WzFicheInfosVisiteur = (WzFicheInfosVisiteur_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzFicheInfosVisiteur.vue
function WzFicheInfosVisiteur_injectStyle (ssrContext) {
  __webpack_require__("cpom")
}
var WzFicheInfosVisiteur_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzFicheInfosVisiteur___vue_template_functional__ = false
/* styles */
var WzFicheInfosVisiteur___vue_styles__ = WzFicheInfosVisiteur_injectStyle
/* scopeId */
var WzFicheInfosVisiteur___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzFicheInfosVisiteur___vue_module_identifier__ = null
var WzFicheInfosVisiteur_Component = WzFicheInfosVisiteur_normalizeComponent(
  WzFicheInfosVisiteur,
  watcheebox_WzFicheInfosVisiteur,
  WzFicheInfosVisiteur___vue_template_functional__,
  WzFicheInfosVisiteur___vue_styles__,
  WzFicheInfosVisiteur___vue_scopeId__,
  WzFicheInfosVisiteur___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzFicheInfosVisiteur = (WzFicheInfosVisiteur_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzFicheLeadVisiteur.vue








/* harmony default export */ var WzFicheLeadVisiteur = ({
  data: function data() {
    return {
      loading: false,
      loadingLead: false,
      loadingSms: false,
      loadingSaveLead: false,
      dateSendLead: 0,
      leadSend: true,
      smsSend: true,
      loadingLead2: false,
      leadSend2: true,
      loadingLeadSelesForce: false,
      loadingLeadZendesk: false,
      infoStatus: true,
      txtLead: '',
      visiteurLead: {
        objectif: null,
        gender: ''
      },
      rules: {
        required: function required(value) {
          return !!value || 'Required.';
        },
        counter: function counter(value) {
          return value.length <= 20 || 'Max 20 characters';
        },
        email: function email(value) {
          var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || 'Invalid e-mail.';
        }
      },
      valid: true,
      error: false,
      snackbar_lead: { text: '', show: false },
      theChat: '',
      default_champs: [{ text: lodash_default.a.upperFirst(this.$t('gender')), value: 'gender' }, { text: lodash_default.a.upperFirst(this.$t('lastName')), value: 'lname' }, { text: lodash_default.a.upperFirst(this.$t('firstName')), value: 'fname' }, { text: lodash_default.a.upperFirst(this.$t('comment')), value: 'comment' }, { text: lodash_default.a.upperFirst(this.$t('email')), value: 'email' }, { text: lodash_default.a.upperFirst(this.$t('phone')), value: 'tel' }, { text: lodash_default.a.upperFirst(this.$t('company')), value: 'company' }, { text: lodash_default.a.upperFirst(this.$t('url')), value: 'url' }],
      default_motif: [{ text: lodash_default.a.upperFirst(this.$t('support')), value: 'support' }, { text: lodash_default.a.upperFirst(this.$t('lead')), value: 'lead' }, {
        text: lodash_default.a.upperFirst(this.$tc('sales', 1, { count: '' })),
        value: 'sale'
      }, { text: lodash_default.a.upperFirst(this.$t('estimate')), value: 'devis' }, { text: lodash_default.a.upperFirst(this.$t('reservation')), value: 'resa' }, { text: lodash_default.a.upperFirst(this.$t('contact')), value: 'contact' }],
      orpi_motif2: [{ text: 'Vendeur', value: 'Vendeur' }],
      nuxe_motif: [{ text: 'Informations Offres commerciales', value: '33' }, { text: 'Informations produits', value: '2' }, { text: 'Aide à la commande e commerce produits', value: '4' }, { text: 'Mon compte Nuxe et moi', value: '7' }, { text: 'Informations Programme de fidélité', value: '6' }, { text: 'Réclamations Programme de fidélité', value: '29' }, { text: 'Informations soins SPA', value: '172' }, { text: "Demande d'échantillons", value: '9' }, { text: 'Suivi de commande e commerce', value: '31' }, { text: 'Diagnostic', value: '128' }, { text: 'Aide à la commande SPA', value: '50' }, { text: 'Informations Livraison', value: '32' }, { text: 'Félicitations', value: '10' }, { text: 'Réclamations - Qualité', value: '11' }, { text: 'Réclamations - Cosmétovigilance', value: '13' }, { text: 'Tests sur animaux', value: '28' }, { text: 'Dons; Partenariat', value: '126' }, { text: 'Autres', value: '8' }],
      nuxe_motif_sub: [],

      nuxe_motif2a: [{ text: 'Arrêt / reformulation', value: '20' }, { text: 'Composition et ingredients', value: '21' }, { text: 'Grossesse et allaitement', value: '24' }],
      nuxe_motif31a: [{ text: 'Réclamations E commerce', value: '36' }],
      nuxe_motif6a: [{ text: 'AJOUT DE PDV', value: '177' }],
      nuxe_motif7a: [{ text: 'MDP pas reçu', value: '54' }],
      nuxe_motif8a: [{ text: 'RH', value: '58' }, { text: 'Service Communication FR', value: '59' }, { text: 'Consumers/business', value: '66' }, { text: 'Service Commercial (pharmacies)', value: '168' }],
      nuxe_motif172a: [{ text: 'Information livraison passeport', value: '148' }, { text: 'Information / réservation Spa', value: '172' }],
      inoya_motif: [{ text: 'Informations sur la marque et les produits', value: '1' }, { text: 'Informations Commandes', value: '2' }, { text: 'Demande de échantillons', value: '3' }, { text: 'Programme Fidélité', value: '4' }, { text: 'Réclamations', value: '5' }, { text: 'Demandes Marketing', value: '6' }, { text: 'Demandes RH', value: '7' }],
      inoya_motif2: [],
      inoya_motif2a: [{ text: 'Ou trouver vos produits', value: '8' }, { text: 'Protocole de soins', value: '10' }, { text: 'Questions sur les prix', value: '11' }, { text: 'Composition et Conservation des Produits', value: '12' }, { text: 'Conseils sur des produits non vendus par INOYA', value: '13' }],
      inoya_motif2b: [{ text: 'Suivi de ma commande', value: '14' }, { text: 'Difficulté à passer ma commande', value: '15' }, { text: 'Livraison de ma commande', value: '16' }, { text: 'Informations Paiement', value: '21' }, { text: 'Codes Promo et Avantages particuliers', value: '25' }, { text: 'Changement statut commande dans le Back Office', value: '39' }],
      inoya_motif2bb: [],
      inoya_motif3: [{ text: 'Délai de livraison', value: '18' }, { text: 'Facture manquante pour la douane', value: '19' }, { text: "Complément d'adresse", value: '20' }],
      inoya_motif2c: [{ text: 'Convertir Points Oya', value: '22' }, { text: 'Envoi récompense carte de fidélité', value: '23' }, { text: 'Demande de carte de fidélité', value: '24' }, {
        text: 'Fidélité Mixte : Points OYA & Carte de fidélité',
        value: '26'
      }, { text: 'Suggestions et Axes d amélioration', value: '27' }],
      inoya_motif2d: [{ text: 'Efficacité du protocole de soins', value: '28' }, { text: 'Problèmes sur mon colis commandé', value: '33' }, { text: 'Réclamations Aspect, texture et odeur', value: '29' }, { text: 'Réaction allergique', value: '30' }, { text: 'Demande de remboursement', value: '31' }, { text: 'Désinscription Bases de données INOYA', value: '32' }],
      inoya_motif2e: [{ text: 'Partenariat Blog ou Réseaux Sociaux', value: '34' }, { text: 'Demande de distribution commerciale', value: '35' }, { text: 'Jeux concours', value: '36' }, { text: 'Sollicitations Commerciales Extérieures', value: '37' }, { text: 'Distributeurs INOYA', value: '38' }],
      cbre_motif: [{ text: 'Achat', value: '1' }, { text: 'Location', value: '2' }, { text: 'Bureau', value: '4' }, { text: 'Entrepot', value: '6' }, { text: 'Commerce', value: '7' }, { text: 'Autre', value: '1' }],

      champs_eezylead: [{
        client: 'preprod',
        fields: [{ text: 'Département', model: 'departement' }, { text: 'Ville', model: 'ville' }, { text: 'Téléphone fixe', model: 'telf' }, { text: 'Téléphone mobile', model: 'telm' }, { text: 'Imposition', model: 'impos' }, { text: 'Propriétaire', model: 'proprio' }, { text: 'Profession-Poste occupé', model: 'job' }, { text: 'Situation', model: 'situation' }, { text: "Nb d'enfants", model: 'enfant' }, { text: 'Crédit en cours', model: 'cTotal' }, { text: 'Epargne', model: 'epargne' }, { text: 'Date de recontact', model: 'dateRappel' }, { text: 'Heure de recontact', model: 'horraireRappel' }, { text: 'Revenu', model: 'revenu' }, { text: 'Surface', model: 'surface' }, { text: 'Destination', model: 'destination' }, { text: 'Suite à donner', model: 'suite' }, { text: 'Type', model: 'typebien' }, { text: 'Numéro du programme*', model: 'programme' }, { text: 'Habiter/Investir', model: 'acheter' }, { text: "Code postal de l'internaute*", model: 'zip' }, { text: 'Region du projet*', model: 'region' }, { text: 'Budget', model: 'budget' }, { text: 'Nb de pièces', model: 'nbpieces' }, { text: 'Modèles', model: 'modele' }, { text: 'Envie', model: 'envie' }, { text: 'Immatriculation', model: 'immatriculation' }, { text: 'Concession', model: 'concession' }]
      }, {
        client: 'aiguillon',
        fields: [{ text: 'Département', model: 'departement' }, { text: 'Programme', model: 'programme' }]
      }, {
        client: 'bnp',
        fields: [{ text: 'Surface', model: 'surface' }, { text: 'Code postal', model: 'zip' }, { text: 'Type', model: 'typebien' }, { text: 'Code postal', model: 'zip' }, { text: 'Ville', model: 'ville' }, { text: 'Téléphone fixe', model: 'zip' }, { text: 'Téléphone mobile', model: 'telf' }, { text: 'Imposition', model: 'impos' }, { text: 'Propriétaire', model: 'proprio' }, { text: 'Profession-Poste occupé', model: 'job' }, { text: 'Situation', model: 'situation' }, { text: "Nb d'enfants", model: 'enfant' }, { text: 'Crédit en cours', model: 'cTotal' }, { text: 'Epargne', model: 'epargne' }, { text: 'Date de recontact', model: 'dateRappel' }, { text: 'Heure de recontact', model: 'horraireRappel' }, { text: 'Revenu', model: 'revenu' }]
      }, {
        client: 'frg',
        fields: [{ text: 'Surface', model: 'surface' }, { text: 'Destination', model: 'destination' }, { text: 'Budget', model: 'budget' }, { text: 'Nb de pièces', model: 'nbpieces' }, { text: 'Programme', model: 'programme' }, { text: 'Département', model: 'departement' }, { text: 'Suite à donner', model: 'suite' }, { text: 'Type', model: 'typebien' }]
      }, {
        client: 'sisley',
        fields: [{ text: this.$t('leadCreationDate'), model: 'date_account' }, { text: this.$t('leadBirthday'), model: 'date_birth' }, { text: this.$t('leadLoyal'), model: 'status' }, { text: this.$t('leadDateMember'), model: 'date_status' }, { text: this.$t('leadNbPoints'), model: 'points_acquired' }, { text: this.$t('leadNbPointsOngoin'), model: 'points_ongoing' }, { text: this.$t('leadNbPointsCum'), model: 'points_cumyear' }, {
          text: 'Optin email',
          model: 'optin_email',
          select: '1',
          option: [{ text: this.$t('yes'), value: 'Oui' }, { text: this.$t('no'), value: 'Non' }]
        }, { text: this.$t('leadDateFirstPurch'), model: 'date_first_purch' }, { text: this.$t('leadDateLastPurch'), model: 'date_last_purch' }, { text: this.$t('leadIdLastPurch'), model: 'last_trans' }, { text: this.$t('leadAmountLastPurchTtc'), model: 'last_trans_ttc' }, { text: this.$t('leadAmountLastPurchHt'), model: 'last_trans_ht' }, { text: this.$t('leadDevise'), model: 'devise' }, { text: this.$t('leadNbPointsLastPu'), model: 'points_last_trans' }, {
          text: this.$t('leadPoints_and_pu'),
          model: 'achat_last_trans',
          select: '1',
          option: [{ text: this.$t('yes'), value: 'Oui' }, { text: this.$t('no'), value: 'Non' }]
        }]
      }, {
        client: 'hisense',
        fields: [{ text: lodash_default.a.upperFirst(this.$t('lastName')) + '*', model: 'lname' }, { text: lodash_default.a.upperFirst(this.$t('firstName')) + '*', model: 'fname' }, { text: lodash_default.a.upperFirst(this.$t('comment')), model: 'comment' }, { text: lodash_default.a.upperFirst(this.$t('email')), model: 'email' }, { text: lodash_default.a.upperFirst(this.$t('phone')) + '*', model: 'tel' }, {
          text: 'Type de client*',
          model: 'user',
          select: '1',
          option: [{ text: 'Client Particulier', value: '10' }, { text: 'Revendeur', value: '20' }, { text: 'Revendeur pour Particulier', value: '30' }, { text: 'B2B', value: '40', selected: '1' }]
        }, { text: 'N° Client', model: 'client' }, {
          text: 'Titre*',
          model: 'title',
          select: '1',
          option: [{ text: 'Ms.', value: '0001' }, { text: 'Mr.', value: '0002' }, { text: 'Company', value: '0003' }, { text: 'Mr. and Mrs.', value: '0004' }]
        }, {
          text: 'Utilisation Marketing',
          model: 'usage',
          select: '1',
          option: [{ text: 'Oui', value: 'Yes' }, { text: 'Non', value: 'No' }]
        }, {
          text: 'Type Contact Préféré',
          model: 'method',
          select: '1',
          option: [{ text: 'Tel Protable', value: 'Z01' }, { text: 'SMS', value: 'Z02' }, { text: 'Tel Fixe', value: 'Z03' }, { text: 'Tel Bureau', value: 'Z04' }, { text: 'E-Mail', value: 'Z05' }, { text: 'Tchat', value: 'Z06' }, { text: 'Réseaux Sociaux', value: 'Z07' }, { text: 'Whatsapp', value: 'Z08' }]
        }, { text: 'Adresse', model: 'address' }, { text: 'Code postal*', model: 'zip' }, { text: 'Ville*', model: 'city' }, {
          text: 'Type de Bâtiment*',
          model: 'building',
          select: '1',
          option: [{ text: 'Maison', value: '01' }, { text: 'Appartement', value: '02' }, { text: 'Magasin', value: '03' }, { text: 'Société', value: '04' }, { text: 'Hôtel', value: '05' }, { text: 'Hôpital', value: '06' }, { text: 'Ecole', value: '07' }, { text: 'Lieu Publique', value: '08' }, { text: 'Stade', value: '09' }, { text: 'Base militaire', value: '10' }, { text: 'Installation Haute Sécurité', value: '11' }, { text: 'Autres', value: '12' }]
        }, {
          text: 'Pays*',
          model: 'country',
          select: '1',
          option: [{ text: 'France', value: 'FR' }, { text: 'Andorran', value: 'AD' }, { text: 'Utd.Arab Emir.', value: 'AE' }, { text: 'Afghanistan', value: 'AF' }, { text: 'Antigua/Barbuda', value: 'AG' }, { text: 'Anguilla', value: 'AI' }, { text: 'Albania ', value: 'AL' }, { text: 'Armenia ', value: 'AM' }, { text: 'Dutch Antilles', value: 'AN' }, { text: 'Angola', value: 'AO' }, { text: 'Antarctica ', value: 'AQ' }, { text: 'Argentina', value: 'AR' }, { text: 'Samoa, America', value: 'AS' }, { text: 'Austria ', value: 'AT' }, { text: 'Australia', value: 'AU' }, { text: 'Aruba', value: 'AW' }, { text: 'Azerbaijan ', value: 'AZ' }, { text: 'Bosnia-Herz.', value: 'BA' }, { text: 'Barbados', value: 'BB' }, { text: 'Bangladesh ', value: 'BD' }, { text: 'Belgium ', value: 'BE' }, { text: 'Burkina Faso', value: 'BF' }, { text: 'Bulgaria', value: 'BG' }, { text: 'Bahrain ', value: 'BH' }, { text: 'Burundi ', value: 'BI' }, { text: 'Benin', value: 'BJ' }, { text: 'Blue ', value: 'BL' }, { text: 'Bermuda ', value: 'BM' }, { text: 'Brunei Daruss.', value: 'BN' }, { text: 'Bolivia ', value: 'BO' }, { text: 'Brazil', value: 'BR' }, { text: 'Bahamas ', value: 'BS' }, { text: 'Bhutan', value: 'BT' }, { text: 'Bouvet Islands', value: 'BV' }, { text: 'Botswana', value: 'BW' }, { text: 'Belarus ', value: 'BY' }, { text: 'Belize', value: 'BZ' }, { text: 'Canada', value: 'CA' }, { text: 'Coconut Islands', value: 'CC' }, { text: 'Dem. Rep. Congo', value: 'CD' }, { text: 'CAR', value: 'CF' }, { text: 'Rep.of Congo', value: 'CG' }, { text: 'Switzerland', value: 'CH' }, { text: 'Cote dIvoire ', value: 'CI' }, { text: 'Cook Islands', value: 'CK' }, { text: 'Chile', value: 'CL' }, { text: 'Cameroon', value: 'CM' }, { text: 'China', value: 'CN' }, { text: 'Colombia', value: 'CO' }, { text: 'Costa Rica ', value: 'CR' }, { text: 'Serbia/Monten.', value: 'CS' }, { text: 'Cuba ', value: 'CU' }, { text: 'Cape Verde ', value: 'CV' }, { text: 'Christmas Islnd', value: 'CX' }, { text: 'Cyprus', value: 'CY' }, { text: 'Czech Republic', value: 'CZ' }, { text: 'Germany ', value: 'DE' }, { text: 'Djibouti', value: 'DJ' }, { text: 'Denmark ', value: 'DK' }, { text: 'Dominica', value: 'DM' }, { text: 'Dominican Rep.', value: 'DO' }, { text: 'Algeria ', value: 'DZ' }, { text: 'Ecuador ', value: 'EC' }, { text: 'Estonia ', value: 'EE' }, { text: 'Egypt', value: 'EG' }, { text: 'West Sahara', value: 'EH' }, { text: 'Eritrea ', value: 'ER' }, { text: 'Spain', value: 'ES' }, { text: 'Ethiopia', value: 'ET' }, { text: 'European Union', value: 'EU' }, { text: 'Finland ', value: 'FI' }, { text: 'Fiji ', value: 'FJ' }, { text: 'Falkland Islnds', value: 'FK' }, { text: 'Micronesia ', value: 'FM' }, { text: 'Faroe Islands ', value: 'FO' }, { text: 'France', value: 'FR' }, { text: 'Gabon', value: 'GA' }, { text: 'United Kingdom', value: 'GB' }, { text: 'Grenada ', value: 'GD' }, { text: 'Georgia ', value: 'GE' }, { text: 'French Guayana', value: 'GF' }, { text: 'Ghana', value: 'GH' }, { text: 'Gibraltar', value: 'GI' }, { text: 'Greenland', value: 'GL' }, { text: 'Gambia', value: 'GM' }, { text: 'Guinea', value: 'GN' }, { text: 'Guadeloupe ', value: 'GP' }, { text: 'Equatorial Guin', value: 'GQ' }, { text: 'Greece', value: 'GR' }, { text: 'S. Sandwich Ins', value: 'GS' }, { text: 'Guatemala', value: 'GT' }, { text: 'Guam ', value: 'GU' }, { text: 'Guinea-Bissau ', value: 'GW' }, { text: 'Guyana', value: 'GY' }, { text: 'Hong Kong', value: 'HK' }, { text: 'Heard/McDon.Isl', value: 'HM' }, { text: 'Honduras', value: 'HN' }, { text: 'Croatia ', value: 'HR' }, { text: 'Haiti', value: 'HT' }, { text: 'Hungary ', value: 'HU' }, { text: 'Indonesia', value: 'ID' }, { text: 'Ireland ', value: 'IE' }, { text: 'Israel', value: 'IL' }, { text: 'India', value: 'IN' }, { text: 'Brit.Ind.Oc.Ter', value: 'IO' }, { text: 'Iraq ', value: 'IQ' }, { text: 'Iran ', value: 'IR' }, { text: 'Iceland ', value: 'IS' }, { text: 'Italy', value: 'IT' }, { text: 'Jamaica ', value: 'JM' }, { text: 'Jordan', value: 'JO' }, { text: 'Japan', value: 'JP' }, { text: 'Kenya', value: 'KE' }, { text: 'Kyrgyzstan ', value: 'KG' }, { text: 'Cambodia', value: 'KH' }, { text: 'Kiribati', value: 'KI' }, { text: 'Comoros ', value: 'KM' }, { text: 'St Kitts&Nevis', value: 'KN' }, { text: 'North Korea', value: 'KP' }, { text: 'South Korea', value: 'KR' }, { text: 'Kuwait', value: 'KW' }, { text: 'Cayman Islands', value: 'KY' }, { text: 'Kazakhstan ', value: 'KZ' }, { text: 'Laos ', value: 'LA' }, { text: 'Lebanon ', value: 'LB' }, { text: 'St. Lucia', value: 'LC' }, { text: 'Liechtenstein ', value: 'LI' }, { text: 'Sri Lanka', value: 'LK' }, { text: 'Liberia ', value: 'LR' }, { text: 'Lesotho ', value: 'LS' }, { text: 'Lithuania', value: 'LT' }, { text: 'Luxembourg ', value: 'LU' }, { text: 'Latvia', value: 'LV' }, { text: 'Libya', value: 'LY' }, { text: 'Morocco ', value: 'MA' }, { text: 'Monaco', value: 'MC' }, { text: 'Moldova ', value: 'MD' }, { text: 'Montenegro ', value: 'ME' }, { text: 'Madagascar ', value: 'MG' }, { text: 'Marshall Islnds', value: 'MH' }, { text: 'Macedonia', value: 'MK' }, { text: 'Mali ', value: 'ML' }, { text: 'Burma', value: 'MM' }, { text: 'Mongolia', value: 'MN' }, { text: 'Macau', value: 'MO' }, { text: 'N.Mariana Islnd', value: 'MP' }, { text: 'Martinique ', value: 'MQ' }, { text: 'Mauretania ', value: 'MR' }, { text: 'Montserrat ', value: 'MS' }, { text: 'Malta', value: 'MT' }, { text: 'Mauritius', value: 'MU' }, { text: 'Maldives', value: 'MV' }, { text: 'Malawi', value: 'MW' }, { text: 'Mexico', value: 'MX' }, { text: 'Malaysia', value: 'MY' }, { text: 'Mozambique ', value: 'MZ' }, { text: 'Namibia ', value: 'NA' }, { text: 'New Caledonia ', value: 'NC' }, { text: 'Niger', value: 'NE' }, { text: 'Norfolk Islands', value: 'NF' }, { text: 'Nigeria ', value: 'NG' }, { text: 'Nicaragua', value: 'NI' }, { text: 'Netherlands', value: 'NL' }, { text: 'Norway', value: 'NO' }, { text: 'Nepal', value: 'NP' }, { text: 'Nauru', value: 'NR' }, { text: 'NATO ', value: 'NT' }, { text: 'Niue ', value: 'NU' }, { text: 'New Zealand', value: 'NZ' }, { text: 'Oman ', value: 'OM' }, { text: 'Orange', value: 'OR' }, { text: 'Panama', value: 'PA' }, { text: 'Peru ', value: 'PE' }, { text: 'Frenc.Polynesia', value: 'PF' }, { text: 'Pap. New Guinea', value: 'PG' }, { text: 'Philippines', value: 'PH' }, { text: 'Pakistan', value: 'PK' }, { text: 'Poland', value: 'PL' }, { text: 'St.Pier,Miquel.', value: 'PM' }, { text: 'Pitcairn Islnds', value: 'PN' }, { text: 'Puerto Rico', value: 'PR' }, { text: 'Palestine', value: 'PS' }, { text: 'Portugal', value: 'PT' }, { text: 'Palau', value: 'PW' }, { text: 'Paraguay', value: 'PY' }, { text: 'Qatar', value: 'QA' }, { text: 'Reunion ', value: 'RE' }, { text: 'Romania ', value: 'RO' }, { text: 'Russian Fed.', value: 'RU' }, { text: 'Rwanda', value: 'RW' }, { text: 'Saudi Arabia', value: 'SA' }, { text: 'Solomon Islands', value: 'SB' }, { text: 'Seychelles ', value: 'SC' }, { text: 'Sudan', value: 'SD' }, { text: 'Sweden', value: 'SE' }, { text: 'Singapore', value: 'SG' }, { text: 'Saint Helena', value: 'SH' }, { text: 'Slovenia', value: 'SI' }, { text: 'Svalbard', value: 'SJ' }, { text: 'Slovakia', value: 'SK' }, { text: 'Sierra Leone', value: 'SL' }]
        }, {
          text: 'Département',
          model: 'province',
          select: '1',
          option: [{ text: 'Ain', value: '01' }, { text: 'Aisne', value: '02' }, { text: 'Allier ', value: '03' }, { text: 'Alpes (Hte-Provence) ', value: '04' }, { text: 'Hautes-Alpes ', value: '05' }, { text: 'Alpes-Maritimes', value: '06' }, { text: 'Ardèche', value: '07' }, { text: 'Ardennes ', value: '08' }, { text: 'Ariège ', value: '09' }, { text: 'Aube ', value: '10' }, { text: 'Aude ', value: '11' }, { text: 'Aveyron', value: '12' }, { text: 'Bouches-du-Rhône ', value: '13' }, { text: 'Calvados ', value: '14' }, { text: 'Cantal ', value: '15' }, { text: 'Charente ', value: '16' }, { text: 'Charente-Maritime', value: '17' }, { text: 'Cher ', value: '18' }, { text: 'Corrèze', value: '19' }, { text: 'Côte-d Or', value: '21' }, { text: 'Côtes-d Armor', value: '22' }, { text: 'Creuse ', value: '23' }, { text: 'Dordogne ', value: '24' }, { text: 'Doubs', value: '25' }, { text: 'Drôme', value: '26' }, { text: 'Eure ', value: '27' }, { text: 'Eure-et-Loir ', value: '28' }, { text: 'Finistère', value: '29' }, { text: 'Corse-du-Sud ', value: '2A' }, { text: 'Corse-du-Nord', value: '2B' }, { text: 'Gard ', value: '30' }, { text: 'Haute-Garonne', value: '31' }, { text: 'Gers ', value: '32' }, { text: 'Gironde', value: '33' }, { text: 'Hérault', value: '34' }, { text: 'Ille-et-Vilaine', value: '35' }, { text: 'Indre', value: '36' }, { text: 'Indre-et-Loire ', value: '37' }, { text: 'Isère', value: '38' }, { text: 'Jura ', value: '39' }, { text: 'Landes ', value: '40' }, { text: 'Loir-et-Cher ', value: '41' }, { text: 'Loire', value: '42' }, { text: 'Haute-Loire', value: '43' }, { text: 'Loire-Atlantique ', value: '44' }, { text: 'Loiret ', value: '45' }, { text: 'Lot', value: '46' }, { text: 'Lot-et-Garonne ', value: '47' }, { text: 'Lozère ', value: '48' }, { text: 'Maine-et-Loire ', value: '49' }, { text: 'Manche ', value: '50' }, { text: 'Marne', value: '51' }, { text: 'Haute-Marne', value: '52' }, { text: 'Mayenne', value: '53' }, { text: 'Meurthe-et-Moselle ', value: '54' }, { text: 'Meuse', value: '55' }, { text: 'Morbihan ', value: '56' }, { text: 'Moselle', value: '57' }, { text: 'Nièvre ', value: '58' }, { text: 'Nord ', value: '59' }, { text: 'Oise ', value: '60' }, { text: 'Orne ', value: '61' }, { text: 'Pas-de-Calais', value: '62' }, { text: 'Puy-de-Dôme', value: '63' }, { text: 'Pyrénées-Atlantiques ', value: '64' }, { text: 'Hautes-Pyrénées', value: '65' }, { text: 'Pyrénées-Orientales', value: '66' }, { text: 'Bas-Rhin ', value: '67' }, { text: 'Haut-Rhin', value: '68' }, { text: 'Rhône', value: '69' }, { text: 'Haute-Saône', value: '70' }, { text: 'Saône-et-Loire ', value: '71' }, { text: 'Sarthe ', value: '72' }, { text: 'Savoie ', value: '73' }, { text: 'Haute-Savoie ', value: '74' }, { text: 'Paris', value: '75' }, { text: 'Seine-Maritime ', value: '76' }, { text: 'Seine-et-Marne ', value: '77' }, { text: 'Yvelines ', value: '78' }, { text: 'Deux-Sèvres', value: '79' }, { text: 'Somme', value: '80' }, { text: 'Tarn ', value: '81' }, { text: 'Tarn-et-Garonne', value: '82' }, { text: 'Var', value: '83' }, { text: 'Vaucluse ', value: '84' }, { text: 'Vendée ', value: '85' }, { text: 'Vienne ', value: '86' }, { text: 'Haute-Vienne ', value: '87' }, { text: 'Vosges ', value: '88' }, { text: 'Yonne', value: '89' }, { text: 'Territ. de Belfort ', value: '90' }, { text: 'Essonne', value: '91' }, { text: 'Hauts-de-Seine ', value: '92' }, { text: 'Seine-Saint-Denis', value: '93' }, { text: 'Val-de-Marne ', value: '94' }, { text: 'Val-d Oise ', value: '95' }, { text: 'DOM-TOM', value: '97' }, { text: 'Guadeloupe ', value: '971' }, { text: 'Martinique ', value: '972' }, { text: 'Guyane ', value: '973' }, { text: 'Réunion', value: '974' }, { text: 'Saint-Pierre-et-Miq. ', value: '975' }, { text: 'Wallis-et-Futuna ', value: '976' }, { text: 'Hors-France', value: '99' }]
        }, {
          text: 'Status*',
          model: 'order',
          select: '1',
          option: [{ text: 'Open', value: 'E0001' }, { text: 'In Process', value: 'E0002' }, { text: 'Complete', value: 'E0003' }, { text: 'Reject', value: 'E0007' }]
        }, {
          text: 'Problem description',
          model: 'symptom',
          select: '1',
          option: [{ value: '111', text: 'TV - No Power' }, { value: '119', text: 'TV - No Switch-On From Standby' }, { value: '11B', text: 'TV - Cyclic Power On / Off' }, { value: '11K', text: 'TV - Set Start-Up Too Slow' }, { value: '11X', text: 'TV - Other Power Problem' }, { value: '151', text: 'TV - No Remote Control Operation' }, { value: '152', text: 'TV - Incorrect Remote Control Operation' }, { value: '153', text: 'TV - Remote Programming / Learning Problem' }, { value: '154', text: 'TV - Poor Remote Control Sensitivity' }, { value: '15X', text: 'TV - Other Remote Control Problem' }, { value: '161', text: 'TV - Damage/ Deforme Cover' }, { value: '163', text: 'TV - Button problem' }, { value: '166', text: 'TV - Damage Plug/Port/Connector/Card Holder' }, { value: '168', text: 'TV - Appearance problem' }, { value: '16A1', text: 'TV - Damage Screen /Panel' }, { value: '16A2', text: 'TV - Screen/Panel Scratch' }, { value: '16A3', text: 'TV - Cover Gap' }, { value: '16A4', text: 'TV - Damaged Packaging' }, { value: '16A5', text: 'TV - Damaged Control Knob/Button/Keypad' }, { value: '16D', text: 'TV - Tv Burning / Smoke/Fire' }, { value: '16F', text: 'TV - Peculiar Smell' }, { value: '16J', text: 'TV - Tv Very Hot / Parts Melting' }, { value: '16K', text: 'TV - Screen Foreign Body' }, { value: '16N', text: 'TV - Damaged Power Cable' }, { value: '16S', text: 'TV - Consumer Injury' }, { value: '17D', text: 'TV - Mistake Language / LOGO Character Set' }, { value: '17N', text: 'TV - Menu Function Problem' }, { value: '12A1', text: 'TV - Apply Automatic Exits' }, { value: '12A2', text: 'TV - Application Frozen status' }, { value: '12A3', text: 'TV - Not Switched on After OTA Upgrade' }, { value: '12A4', text: 'TV - AbnormallyFunction After OTA Upgrade' }, { value: '12A5', text: 'TV - OTA Download Failed' }, { value: '12A6', text: 'TV - Application Unavailable' }, { value: '12A7', text: 'TV - APPWorking Abnormally' }, { value: '12A8', text: 'TV - Network Video Playback Frozen' }, { value: '12A9', text: 'TV - APP-Youtube NotWorking' }, { value: '12B1', text: 'TV - APP-NETFLIXNot Working' }, { value: '12B2', text: 'TV - BrowserWorking Abnormally' }, { value: '216', text: 'TV - No BS/CS Signal' }, { value: '217', text: 'TV - No CS Signal' }, { value: '218', text: 'TV - No TV Signal' }, { value: '21A1', text: 'TV - AV/VGA/HDMI Not Operation' }, { value: '21A2', text: 'TV - Network /WIFI Not Available' }, { value: '21A3', text: 'TV - Channel Edit Abnoraml' }, { value: '21A4', text: 'TV - AbnormallyRecording' }, { value: '21A5', text: 'TV - CI/B-CAS Card Recognition Failure' }, { value: '21A6', text: 'TV - B-CAS Card Un-Installation' }, { value: '21A7', text: 'TV - AntennaPowerFaulty' }, { value: '21F', text: 'TV - No Internet/Network Initialization Fail' }, { value: '22A', text: 'TV - Poor TV Signal' }, { value: '22C', text: 'TV - Poor/Interrupt Internet/Network connect' }, { value: '286', text: 'TV - EPG Problem' }, { value: '71A', text: 'TV - HDD Not Recognized / Boot Failure' }, { value: '31A0', text: 'TV - Unstable Picture' }, { value: '31A1', text: 'TV - No Picture Without Backlight' }, { value: '31A2', text: 'TV - No Picture Has Backlight' }, { value: '31A3', text: 'TV - Screen Vertical And Horizontal Tape' }, { value: '31A4', text: 'TV - White Screen' }, { value: '31A5', text: 'TV - Light Leakage' }, { value: '31A6', text: 'TV - HDR Display Abnormally' }, { value: '31A7', text: 'TV - Blurred Picture' }, { value: '31A8', text: 'TV - Input Lag' }, { value: '31A9', text: 'TV - Picture Interference' }, { value: '321', text: 'TV - Picture Too Dark' }, { value: '326', text: 'TV - Shadows On Picture' }, { value: '345', text: 'TV - Jitter On Picture' }, { value: '346', text: 'TV - Ghosting On Picture' }, { value: '34C', text: 'TV - Clouding, “MURA”' }, { value: '356', text: 'TV - Flashing Picture' }, { value: '385', text: 'TV - Bright, Dark, Or Flashing Pixels' }, { value: '386', text: 'TV - Lines On Screen' }, { value: '420', text: 'TV - Colour Level Problem' }, { value: '140', text: 'TV - AbnormallyNoise' }, { value: '511', text: 'TV - No Audio' }, { value: '517', text: 'TV - No Audio From Earphone / Headphone' }, { value: '519', text: 'TV - No Audio From Digital Output' }, { value: '51A1', text: 'TV - ARC Connection No Audio' }, { value: '51A2', text: 'TV - AV/VGA/HDMINo Audio Output' }, { value: '51A3', text: 'TV - Audio Delay / Lip-Sync Problem' }, { value: '51X', text: 'TV - Other Sound problem' }, { value: '521', text: 'TV - Low Audio Level' }, { value: '522', text: 'TV - High Audio Level' }, { value: '741', text: 'TV - Button/ Touch Button Not Working' }, { value: '744', text: 'TV - Sticky / Hard To Press Key(s)' }, { value: '74A1', text: 'TV - Key Function Disorder' }, { value: '74A2', text: 'TV - Key Button Unsensitive' }, { value: '81A1', text: 'TV - No Accessory' }, { value: '81A2', text: 'TV - No Remote' }, { value: '81A3', text: 'TV - No/CI Card /B-CAS Card' }, { value: '81A4', text: 'TV - No Base Bracket' }, { value: '81A5', text: 'TV - No Screw/Screw Mistake' }, { value: '81A6', text: 'TV - No Stand/Stand Mistake' }, { value: '81A7', text: 'TV - Remote Mistake' }, { value: '81A8', text: 'TV - Accessory Mistake' }, { value: '81A9', text: 'TV - Damaged Accessory' }, { value: '81B1', text: 'TV - Damaged Base' }, { value: '81B2', text: 'TV - No Manual' }, { value: '81B3', text: 'TV - Other Accessory Problem' }, { value: '81B4', text: 'TV - Base Unstable' }, { value: 'Z0A1', text: 'TV - Customer Installation /Requirement' }, { value: 'Z0A3', text: 'TV - Wall Mounted Bracket Unable To Install' }, { value: 'Z0A4', text: 'TV - Base Unable To Install' }, { value: '111', text: 'freezer - No power' }, { value: '11A', text: 'freezer - Powers up but no operation' }, { value: '11C', text: 'freezer - Blowing external (mains) fuse' }, { value: '11F', text: 'freezer - Not operating' }, { value: '11H', text: 'freezer - Internal protection switch / fuse in set' }, { value: '124', text: 'freezer - Insufficient heating / temperature (not' }, { value: '125', text: 'freezer - Excessive heating / temperature (not spe' }, { value: '126', text: 'freezer - Insufficient cooling (not specific)' }, { value: '127', text: 'freezer - Excessive cooling (not specific)' }, { value: '12A1', text: 'freezer - Water delay' }, { value: '12A2', text: 'freezer - water extended' }, { value: '131', text: 'freezer - No or faulty display' }, { value: '132', text: 'freezer - Faulty lamp / LED operation' }, { value: '133', text: 'freezer - Faulty level meter operation' }, { value: '134', text: 'freezer - No or faulty on-screen display operation' }, { value: '138', text: 'freezer - Faulty alarm / error display' }, { value: '13D', text: 'freezer - Warning light does not work' }, { value: '13E', text: 'freezer - Warning light lights up' }, { value: '149', text: 'freezer - Cracking' }, { value: '14A', text: 'freezer - Whistling' }, { value: '14B', text: 'freezer - Bubbling, boiling' }, { value: '14F', text: 'freezer - Squealing' }, { value: '14G', text: 'freezer - Grinding' }, { value: '14I', text: 'freezer - Pumping noise' }, { value: '14X', text: 'freezer - Other "abnormal noise" problem' }, { value: '161', text: 'freezer - Damaged / deformed cabinet / panel / gla' }, { value: '162', text: 'freezer - Damaged handle / Clip / transport strap' }, { value: '163', text: 'freezer - Damaged control knob(s) / button(s) / ke' }, { value: '164', text: 'freezer - Damaged door / cover' }, { value: '165', text: 'freezer - Damaged seal' }, { value: '16D', text: 'freezer - Set burning / emits smoke' }, { value: '16E', text: 'freezer - External surface damage (bubbling / peel' }, { value: '16G', text: 'freezer - Weak / damaged stand' }, { value: '16J', text: 'freezer - Set gets very hot / parts melting' }, { value: '16L', text: 'freezer - Burning marks' }, { value: '16M', text: 'freezer - Internal surface damage (bubbling / peel' }, { value: '16N', text: 'freezer - Damaged power cable' }, { value: '16P', text: 'freezer - Damaged accessory' }, { value: '16R', text: 'freezer - Discolouration' }, { value: '16S', text: 'freezer - Consumer hurt' }, { value: '16T', text: 'freezer - Damaged / defect filter' }, { value: '171', text: 'freezer - Faulty clock function' }, { value: '175', text: 'freezer - Programming / user adjustment problem' }, { value: '178', text: 'freezer - Faulty memory function' }, { value: '17F', text: 'freezer - Switch / keypad / regulator not operatin' }, { value: '17L', text: 'freezer - Faulty operation of parental lock / keyl' }, { value: '17O', text: 'freezer - No interior lighting' }, { value: '17P', text: 'freezer - Faulty user control function' }, { value: '17S', text: 'freezer - Temperature not adjustable' }, { value: '61B', text: 'freezer - Control / switch not working' }, { value: '651', text: 'freezer - Uneven feet' }, { value: '653', text: 'freezer - Vibrating / jumping' }, { value: '654', text: 'freezer - Part(s) loose' }, { value: '655', text: 'freezer - Wheel defect' }, { value: '693', text: 'freezer - Door does not close properly' }, { value: '694', text: 'freezer - Door cannot be opened / heavy to open' }, { value: '695', text: 'freezer - Damaged door gasket' }, { value: '696', text: 'freezer - Damaged door frame' }, { value: '697', text: 'freezer - Damaged door glass' }, { value: '698', text: 'freezer - Door falls off' }, { value: '699', text: 'freezer - Faulty door switch' }, { value: '69A', text: 'freezer - Door slanted' }, { value: '69B', text: 'freezer - Damaged hinge' }, { value: '69C', text: 'freezer - Malfunctioning door locking device' }, { value: 'B11', text: 'freezer - No cooling' }, { value: 'B12', text: 'freezer - No freezing' }, { value: 'B13', text: 'freezer - No warming up' }, { value: 'B16', text: 'freezer - No defrosting' }, { value: 'B17', text: 'freezer - No dehumidification' }, { value: 'B19', text: 'freezer - Ventilator does not switch off' }, { value: 'B1A', text: 'freezer - No ice production' }, { value: 'B1B', text: 'freezer - No crushed ice production' }, { value: 'B1C', text: 'freezer - No cold water production' }, { value: 'B1X', text: 'freezer - Other no function problem' }, { value: 'B22', text: 'freezer - Insufficient freezing' }, { value: 'B26', text: 'freezer - Excessive freezing' }, { value: 'B29', text: 'freezer - Insufficient ventilation power' }, { value: 'B2A', text: 'freezer - Ventilation power only at one side' }, { value: 'B2B', text: 'freezer - Ventilation power not adjustable' }, { value: 'B2C', text: 'freezer - Compressor operating all the time' }, { value: 'B2D', text: 'freezer - Insufficient filter operation' }, { value: 'B2X', text: 'freezer - Other operational problem' }, { value: 'B32', text: 'freezer - Rotted / damaged food' }, { value: 'B33', text: 'freezer - Ice cream too hard' }, { value: 'B34', text: 'freezer - Insufficient ice cube quality' }, { value: 'B35', text: 'freezer - Condensed water on food' }, { value: 'B3X', text: 'freezer - Other "cooling / heating poor performanc' }, { value: 'B41', text: 'freezer - Condensation inside cabinet' }, { value: 'B42', text: 'freezer - Ice build up' }, { value: 'B44', text: 'freezer - Water inside cabinet' }, { value: 'B45', text: 'freezer - Noisy compressor' }, { value: 'B46', text: 'freezer - Noisy magnet switch' }, { value: 'B47', text: 'freezer - Noisy thermostat' }, { value: 'B4X', text: 'freezer - Other water / ice / noise problem' }, { value: 'B51', text: 'freezer - Fuel, Oil leakage' }, { value: 'B53', text: 'freezer - Smoke emission' }, { value: 'B54', text: 'freezer - Water leakage' }, { value: 'B61', text: 'freezer - Damaged evaporator' }, { value: 'B62', text: 'freezer - Temperature adjustment stuck' }, { value: 'B63', text: 'freezer - Selection switch defective' }, { value: 'B64', text: 'freezer - Filter holder defective' }, { value: '111', text: 'Refrigerator - No power' }, { value: '11A', text: 'Refrigerator - Powers up but no operation' }, { value: '11C', text: 'Refrigerator - Blowing external (mains) fuse' }, { value: '11F', text: 'Refrigerator - Not operating' }, { value: '11H', text: 'Refrigerator - Internal protection switch / fuse in set' }, { value: '124', text: 'Refrigerator - Insufficient heating / temperature (not' }, { value: '125', text: 'Refrigerator - Excessive heating / temperature (not spe' }, { value: '126', text: 'Refrigerator - Insufficient cooling (not specific)' }, { value: '127', text: 'Refrigerator - Excessive cooling (not specific)' }, { value: '12A1', text: 'Refrigerator - Water delay' }, { value: '12A2', text: 'Refrigerator - water extended' }, { value: '131', text: 'Refrigerator - No or faulty display' }, { value: '132', text: 'Refrigerator - Faulty lamp / LED operation' }, { value: '133', text: 'Refrigerator - Faulty level meter operation' }, { value: '134', text: 'Refrigerator - No or faulty on-screen display operation' }, { value: '138', text: 'Refrigerator - Faulty alarm / error display' }, { value: '13D', text: 'Refrigerator - Warning light does not work' }, { value: '13E', text: 'Refrigerator - Warning light lights up' }, { value: '149', text: 'Refrigerator - Cracking' }, { value: '14A', text: 'Refrigerator - Whistling' }, { value: '14B', text: 'Refrigerator - Bubbling, boiling' }, { value: '14F', text: 'Refrigerator - Squealing' }, { value: '14G', text: 'Refrigerator - Grinding' }, { value: '14I', text: 'Refrigerator - Pumping noise' }, { value: '14X', text: 'Refrigerator - Other "abnormal noise" problem' }, { value: '161', text: 'Refrigerator - Damaged / deformed cabinet / panel / gla' }, { value: '162', text: 'Refrigerator - Damaged handle / Clip / transport strap' }, { value: '163', text: 'Refrigerator - Damaged control knob(s) / button(s) / ke' }, { value: '164', text: 'Refrigerator - Damaged door / cover' }, { value: '165', text: 'Refrigerator - Damaged seal' }, { value: '16D', text: 'Refrigerator - Set burning / emits smoke' }, { value: '16E', text: 'Refrigerator - External surface damage (bubbling / peel' }, { value: '16G', text: 'Refrigerator - Weak / damaged stand' }, { value: '16J', text: 'Refrigerator - Set gets very hot / parts melting' }, { value: '16L', text: 'Refrigerator - Burning marks' }, { value: '16M', text: 'Refrigerator - Internal surface damage (bubbling / peel' }, { value: '16N', text: 'Refrigerator - Damaged power cable' }, { value: '16P', text: 'Refrigerator - Damaged accessory' }, { value: '16R', text: 'Refrigerator - Discolouration' }, { value: '16S', text: 'Refrigerator - Consumer hurt' }, { value: '16T', text: 'Refrigerator - Damaged / defect filter' }, { value: '171', text: 'Refrigerator - Faulty clock function' }, { value: '175', text: 'Refrigerator - Programming / user adjustment problem' }, { value: '178', text: 'Refrigerator - Faulty memory function' }, { value: '17F', text: 'Refrigerator - Switch / keypad / regulator not operatin' }, { value: '17L', text: 'Refrigerator - Faulty operation of parental lock / keyl' }, { value: '17O', text: 'Refrigerator - No interior lighting' }, { value: '17P', text: 'Refrigerator - Faulty user control function' }, { value: '17S', text: 'Refrigerator - Temperature not adjustable' }, { value: '61B', text: 'Refrigerator - Control / switch not working' }, { value: '651', text: 'Refrigerator - Uneven feet' }, { value: '653', text: 'Refrigerator - Vibrating / jumping' }, { value: '654', text: 'Refrigerator - Part(s) loose' }, { value: '655', text: 'Refrigerator - Wheel defect' }, { value: '693', text: 'Refrigerator - Door does not close properly' }, { value: '694', text: 'Refrigerator - Door cannot be opened / heavy to open' }, { value: '695', text: 'Refrigerator - Damaged door gasket' }, { value: '696', text: 'Refrigerator - Damaged door frame' }, { value: '697', text: 'Refrigerator - Damaged door glass' }, { value: '698', text: 'Refrigerator - Door falls off' }, { value: '699', text: 'Refrigerator - Faulty door switch' }, { value: '69A', text: 'Refrigerator - Door slanted' }, { value: '69B', text: 'Refrigerator - Damaged hinge' }, { value: '69C', text: 'Refrigerator - Malfunctioning door locking device' }, { value: 'B11', text: 'Refrigerator - No cooling' }, { value: 'B12', text: 'Refrigerator - No freezing' }, { value: 'B13', text: 'Refrigerator - No warming up' }, { value: 'B16', text: 'Refrigerator - No defrosting' }, { value: 'B17', text: 'Refrigerator - No dehumidification' }, { value: 'B19', text: 'Refrigerator - Ventilator does not switch off' }, { value: 'B1A', text: 'Refrigerator - No ice production' }, { value: 'B1B', text: 'Refrigerator - No crushed ice production' }, { value: 'B1C', text: 'Refrigerator - No cold water production' }, { value: 'B1X', text: 'Refrigerator - Other no function problem' }, { value: 'B22', text: 'Refrigerator - Insufficient freezing' }, { value: 'B26', text: 'Refrigerator - Excessive freezing' }, { value: 'B29', text: 'Refrigerator - Insufficient ventilation power' }, { value: 'B2A', text: 'Refrigerator - Ventilation power only at one side' }, { value: 'B2B', text: 'Refrigerator - Ventilation power not adjustable' }, { value: 'B2C', text: 'Refrigerator - Compressor operating all the time' }, { value: 'B2D', text: 'Refrigerator - Insufficient filter operation' }, { value: 'B2X', text: 'Refrigerator - Other operational problem' }, { value: 'B32', text: 'Refrigerator - Rotted / damaged food' }, { value: 'B33', text: 'Refrigerator - Ice cream too hard' }, { value: 'B34', text: 'Refrigerator - Insufficient ice cube quality' }, { value: 'B35', text: 'Refrigerator - Condensed water on food' }, { value: 'B3X', text: 'Refrigerator - Other "cooling / heating poor performanc' }, { value: 'B41', text: 'Refrigerator - Condensation inside cabinet' }, { value: 'B42', text: 'Refrigerator - Ice build up' }, { value: 'B44', text: 'Refrigerator - Water inside cabinet' }, { value: 'B45', text: 'Refrigerator - Noisy compressor' }, { value: 'B46', text: 'Refrigerator - Noisy magnet switch' }, { value: 'B47', text: 'Refrigerator - Noisy thermostat' }, { value: 'B4X', text: 'Refrigerator - Other water / ice / noise problem' }, { value: 'B51', text: 'Refrigerator - Fuel, Oil leakage' }, { value: 'B53', text: 'Refrigerator - Smoke emission' }, { value: 'B54', text: 'Refrigerator - Water leakage' }, { value: 'B61', text: 'Refrigerator - Damaged evaporator' }, { value: 'B62', text: 'Refrigerator - Temperature adjustment stuck' }, { value: 'B63', text: 'Refrigerator - Selection switch defective' }, { value: 'B64', text: 'Refrigerator - Filter holder defective' }, { value: '111', text: 'Washing Machine - No power' }, { value: '118', text: 'Washing Machine - Power-off function not working' }, { value: '119', text: 'Washing Machine - No switch-on from standby' }, { value: '11A', text: 'Washing Machine - Powers up but no operation' }, { value: '11B', text: 'Washing Machine - Cyclic power on / off' }, { value: '11C', text: 'Washing Machine - Blowing external (mains) fuse' }, { value: '11D', text: 'Washing Machine - Set switches off by itself' }, { value: '11F', text: 'Washing Machine - Not operating' }, { value: '11H', text: 'Washing Machine - Internal protec switch set triggers' }, { value: '124', text: 'Washing Machine - Insufficient heating / temperature' }, { value: '125', text: 'Washing Machine - Excessive heating / temperature' }, { value: '126', text: 'Washing Machine - Insufficient cooling (not specific)' }, { value: '127', text: 'Washing Machine - Excessive cooling (not specific)' }, { value: '131', text: 'Washing Machine - No or faulty display' }, { value: '132', text: 'Washing Machine - Faulty lamp / LED operation' }, { value: '133', text: 'Washing Machine - Faulty level meter operation' }, { value: '134', text: 'Washing Machine - No or faulty on-screen display operation' }, { value: '13D', text: 'Washing Machine - Warning light does not work' }, { value: '13E', text: 'Washing Machine - Warning light lights up' }, { value: '143', text: 'Washing Machine - Noisy cabinet / cracking trays' }, { value: '145', text: 'Washing Machine - Noisy component(s)' }, { value: '146', text: 'Washing Machine - Rattle' }, { value: '149', text: 'Washing Machine - Cracking' }, { value: '14A', text: 'Washing Machine - Whistling' }, { value: '14F', text: 'Washing Machine - Squealing' }, { value: '14G', text: 'Washing Machine - Grinding' }, { value: '14I', text: 'Washing Machine - Pumping noise' }, { value: '14X', text: 'Washing Machine - Other "abnormal noise" problem' }, { value: '161', text: 'Washing Machine - Damaged / deformed cabinet / panel' }, { value: '162', text: 'Washing Machine - Damaged handle / Clip / transport strap' }, { value: '163', text: 'Washing Machine - Damaged control knob(s) / button(s)' }, { value: '164', text: 'Washing Machine - Damaged door / cover' }, { value: '165', text: 'Washing Machine - Damaged seal' }, { value: '166', text: 'Washing Machine - Damaged plug / socket / terminal' }, { value: '168', text: 'Washing Machine - Damaged cartridge or stylus' }, { value: '16D', text: 'Washing Machine - Set burning / emits smoke' }, { value: '16E', text: 'Washing Machine - External surface damage' }, { value: '16K', text: 'Washing Machine - Foreign substance on / in unit' }, { value: '16L', text: 'Washing Machine - Burning marks' }, { value: '16M', text: 'Washing Machine - Internal surface damage' }, { value: '16N', text: 'Washing Machine - Damaged power cable' }, { value: '16P', text: 'Washing Machine - Damaged accessory' }, { value: '16R', text: 'Washing Machine - Discolouration' }, { value: '16T', text: 'Washing Machine - Damaged / defect filter' }, { value: '16U', text: 'Washing Machine - Packaging' }, { value: '171', text: 'Washing Machine - Faulty clock function' }, { value: '173', text: 'Washing Machine - Faulty timer programming' }, { value: '174', text: 'Washing Machine - Faulty timer operation' }, { value: '175', text: 'Washing Machine - Programming / user adjustment problem' }, { value: '179', text: 'Washing Machine - Faulty input switching' }, { value: '17E', text: 'Washing Machine - Error code / signal appears in display' }, { value: '17F', text: 'Washing Machine - Switch / keypad / not operating' }, { value: '17L', text: 'Washing Machine - Faulty operation of parental lock' }, { value: '17M', text: 'Washing Machine - Faulty mode switching' }, { value: '17P', text: 'Washing Machine - Faulty user control function' }, { value: '17S', text: 'Washing Machine - Temperature not adjustable' }, { value: '61B', text: 'Washing Machine - Control / switch not working' }, { value: '651', text: 'Washing Machine - Uneven feet' }, { value: '653', text: 'Washing Machine - Vibrating / jumping' }, { value: '654', text: 'Washing Machine - Part(s) loose' }, { value: '655', text: 'Washing Machine - Wheel defect' }, { value: '693', text: 'Washing Machine - Door does not close properly' }, { value: '694', text: 'Washing Machine - Door cannot be opened / heavy to open' }, { value: '698', text: 'Washing Machine - Door falls off' }, { value: '699', text: 'Washing Machine - Faulty door switch' }, { value: '69A', text: 'Washing Machine - Door slanted' }, { value: '69B', text: 'Washing Machine - Damaged hinge' }, { value: '69C', text: 'Washing Machine - Malfunctioning door locking device' }, { value: '69D', text: 'Washing Machine - Noise when opening / closing door' }, { value: 'A11', text: 'Washing Machine - No heating' }, { value: 'A12', text: 'Washing Machine - No water draining / pumping out' }, { value: 'A13', text: 'Washing Machine - No rinsing / no circulation' }, { value: 'A14', text: 'Washing Machine - No drying' }, { value: 'A15', text: 'Washing Machine - No salt consumption' }, { value: 'A16', text: 'Washing Machine - No clear rinse / softening consumption' }, { value: 'A17', text: 'Washing Machine - No detergent consumption' }, { value: 'A18', text: 'Washing Machine - No water inlet' }, { value: 'A19', text: 'Washing Machine - No air drain' }, { value: 'A1A', text: 'Washing Machine - No water in container' }, { value: 'A1B', text: 'Washing Machine - No spinning' }, { value: 'A1C', text: 'Washing Machine - Stops during program flow' }, { value: 'A1D', text: 'Washing Machine - Continues via stop' }, { value: 'A1E', text: 'Washing Machine - Continues without stopping' }, { value: 'A1F', text: 'Washing Machine - Program stops and pumps constantly' }, { value: 'A1G', text: 'Washing Machine - Water inlet not stopped' }, { value: 'A1H', text: 'Washing Machine - Heating up without water' }, { value: 'A1J', text: 'Washing Machine - No water through flow / blockage' }, { value: 'A1K', text: 'Washing Machine - No whitening agent consumption' }, { value: 'A1L', text: 'Washing Machine - No softener consumption' }, { value: 'A21', text: 'Washing Machine - Pumping out improperly' }, { value: 'A22', text: 'Washing Machine - Insufficient water inlet' }, { value: 'A23', text: 'Washing Machine - Insufficient drying / spinning' }, { value: 'A24', text: 'Washing Machine - Excessive salt consumption' }, { value: 'A25', text: 'Washing Machine - Excessive clear rinse consumption' }, { value: 'A26', text: 'Washing Machine - Excessive detergent consumption' }, { value: 'A27', text: 'Washing Machine - Takes excessive water' }, { value: 'A28', text: 'Washing Machine - Program flow too fast / slow' }, { value: 'A29', text: 'Washing Machine - Water in soft rinsing chamber' }, { value: 'A2A', text: 'Washing Machine - Improper spinning' }, { value: 'A2B', text: 'Washing Machine - Program knob remains in every position' }, { value: 'A2C', text: 'Washing Machine - Takes detergent only partially' }, { value: 'A2D', text: 'Washing Machine - Takes softening agent immediately' }, { value: 'A2E', text: 'Washing Machine - Water enters and drains off immediately' }, { value: 'A2G', text: 'Washing Machine - Drying time too long' }, { value: 'A2H', text: 'Washing Machine - Wrong drum positioning' }, { value: 'A31', text: 'Washing Machine - Not clean' }, { value: 'A39', text: 'Washing Machine - Wrinkled laundry' }, { value: 'A3A', text: 'Washing Machine - Burnt laundry' }, { value: 'A3B', text: 'Washing Machine - Laundry hot and dry' }, { value: 'A3C', text: 'Washing Machine - Laundry hot and damp' }, { value: 'A3D', text: 'Washing Machine - Laundry damaged' }, { value: 'A44', text: 'Washing Machine - Spinning noise' }, { value: 'A51', text: 'Washing Machine - Water leakage' }, { value: 'A52', text: 'Washing Machine - Steam emission' }, { value: 'A53', text: 'Washing Machine - Foaming' }, { value: 'A54', text: 'Washing Machine - Damaged hose' }, { value: 'A55', text: 'Washing Machine - Air emission' }, { value: 'A57', text: 'Washing Machine - Drum lid damaged / opened' }, { value: 'A58', text: 'Washing Machine - Drum blocked' }, { value: 'A62', text: 'Washing Machine - Damaged rinse aid chamber / cover' }, { value: 'A63', text: 'Washing Machine - Damaged detergent chamber / cover' }, { value: 'A64', text: 'Washing Machine - Damaged fluff filter' }]
        }, {
          text: 'Type de demande',
          model: 'type',
          select: '1',
          option: [{ text: 'General Advice', value: 'C1' }, { text: 'Technical Advice', value: 'C2' }, { text: 'Online Remote Consulting', value: 'C3' }]
        }, {
          text: 'Sous-type de Demande',
          model: 'consult',
          select: '1',
          option: [{ text: 'Information Avant-Vente', value: 'B01' }, { text: 'Suivi d intervention', value: 'B02' }, { text: 'Demande Marketing', value: 'B03' }, { text: 'Demande Commerciale', value: 'B04' }, { text: 'Demande de support', value: 'B05' }, { text: 'ODR', value: 'B09' }]
        }, { text: 'Descript. Demande', model: 'note' }]
      }, {
        client: 'schumacher',
        fields: [{ text: 'Modèles', model: 'modele' }, { text: 'Envie', model: 'envie' }, { text: 'Immatriculation', model: 'immatriculation' }, { text: 'Code postal', model: 'zip' }, { text: 'Concession', model: 'concession' }]
      }, {
        client: 'volvo',
        fields: [{
          text: 'Modèle *',
          model: 'modele',
          select: '1',
          option: [{ text: this.$t('Non précisé'), value: 'ALL MODELS' }, { text: this.$t('V90 Cross Country'), value: 'V90 Cross Country' }, { text: this.$t('V90'), value: 'V90' }, { text: this.$t('V60'), value: 'V60' }, { text: this.$t('V40 Cross Country'), value: 'V40 Cross Country' }, { text: this.$t('V40'), value: 'V40' }, { text: this.$t('XC40'), value: 'XC40' }, { text: this.$t('XC90'), value: 'XC90' }, { text: this.$t('XC60'), value: 'XC60' }]
        }, {
          text: 'Type de demande *',
          model: 'type',
          select: '1',
          option: [{ text: this.$t('Demande d\'essai'), value: 'Test_drive_request' }, { text: this.$t('Demande d\'offre / Autre demande'), value: 'Offer_request' }]
        }, {
          text: 'A recontacter par *',
          model: 'contact',
          select: '1',
          option: [{ text: this.$t('Téléphone'), value: 'Phone' }, { text: this.$t('Email'), value: 'Email' }, { text: this.$t('SMS'), value: 'SMS' }]
        }]
      }, {
        client: 'icad',
        fields: [{
          text: 'Region du projet*',
          model: 'region',
          select: '1',
          option: [{ text: 'Alsace', value: '42' }, { text: 'Aquitaine', value: '72' }, { text: 'Auvergne', value: '83' }, { text: 'Basse-Normandie', value: '25' }, { text: 'Bourgogne', value: '26' }, { text: 'Bretagne', value: '53' }, { text: 'Centre-Val de Loire', value: '24' }, { text: 'Champagne-Ardenne', value: '21' }, { text: 'Corse', value: '94' }, { text: 'Franche-Comté', value: '43' }, { text: 'Guadeloupe', value: '01' }, { text: 'Guyane', value: '03' }, { text: 'Haute-Normandie', value: '23' }, { text: 'Ile-de-France', value: '11' }, { text: 'Languedoc-Roussillon', value: '91' }, { text: 'La Réunion', value: '04' }, { text: 'Limousin', value: '74' }, { text: 'Lorraine', value: '41' }, { text: 'Martinique', value: '02' }, { text: 'Midi-Pyrénées', value: '73' }, { text: 'Nord-Pas-de-Calais', value: '31' }, { text: 'Pays de la Loire', value: '52' }, { text: 'Picardie', value: '22' }, { text: 'Poitou-Charentes', value: '54' }, { text: 'Provence-Alpes-Côte d\'Azur', value: '93' }, { text: 'Rhône-Alpes', value: '82' }]
        }, { text: 'Numéro du programme*', model: 'programme' }, { text: 'Habiter/Investir', model: 'acheter' }, { text: "Code postal de l'internaute*", model: 'zip' }, { text: 'Budget', model: 'budget' }, { text: 'Nb de pièces', model: 'nbpieces' }, { text: 'Département (2 chiffres, ex 75)', model: 'departement' }]
      }, {
        client: 'akerys',
        fields: [{ text: 'Code postal', model: 'zip' }, { text: 'Ville', model: 'ville' }, { text: 'Téléphone fixe', model: 'telf' }, { text: 'Téléphone mobile', model: 'telm' }, { text: 'Imposition', model: 'impos' }, { text: 'Propriétaire', model: 'proprio' }, { text: 'Profession-Poste occupé', model: 'job' }, { text: 'Situation', model: 'situation' }, { text: "Nb d'enfants", model: 'enfant' }, { text: 'Crédit en cours', model: 'cTotal' }, { text: 'Epargne', model: 'epargne' }, { text: 'Date de recontact', model: 'dateRappel' }, { text: 'Heure de recontact', model: 'horraireRappel' }, { text: 'Revenu', model: 'revenu' }]
      }, {
        client: 'ketb',
        fields: [{ text: 'Code postal', model: 'zip' }, { text: 'Ville', model: 'ville' }, { text: 'Téléphone fixe', model: 'zip' }, { text: 'Téléphone mobile', model: 'telf' }, { text: 'Imposition', model: 'impos' }, { text: 'Propriétaire', model: 'proprio' }, { text: 'Profession-Poste occupé', model: 'job' }, { text: 'Situation', model: 'situation' }, { text: "Nb d'enfants", model: 'enfant' }, { text: 'Crédit en cours', model: 'cTotal' }, { text: 'Epargne', model: 'epargne' }, { text: 'Date de recontact', model: 'dateRappel' }, { text: 'Heure de recontact', model: 'horraireRappel' }, { text: 'Revenu', model: 'revenu' }]
      }, {
        client: 'inoya',
        fields: [{
          text: 'Panier validé',
          model: 'panier',
          select: '1',
          option: [{ text: 'Non', value: '1' }, { text: 'Oui', value: '2' }]
        }, {
          text: 'Type de peau',
          model: 'type',
          select: '1',
          option: [{ text: 'MIXTE', value: 'Peau_Mixte' }, { text: 'GRASSE', value: 'Peau_Grasse' }, { text: 'SECHE', value: 'Peau_Seche' }, { text: 'NORMALE', value: 'Peau_Normale' }]
        }, {
          text: 'Problématiques de peau',
          model: 'pb',
          select: '1',
          option: [{ text: 'TACHES', value: 'Prob_Taches' }, { text: 'BOUTONS', value: 'Prob_Boutons' }, {
            text: 'TEINT NON UNIFORME',
            value: 'Prob_Teint_Non_Uniforme'
          }, { text: 'VERGETURES', value: 'Prob_Vergetures' }, { text: 'AUCUNE', value: 'Prob_Aucune' }, { text: 'AUTRES', value: 'Prob_Autres' }]
        }, {
          text: 'Durée problématique',
          model: 'duree',
          select: '1',
          option: [{ text: 'Pas de choix', value: '' }, { text: 'Moins de 3 ans', value: '1' }, { text: 'Plus de 3 ans', value: '2' }]
        }, {
          text: 'Suivi par un Dermatologue',
          model: 'suivi',
          select: '1',
          option: [{ text: 'Non', value: '1' }, { text: 'Oui', value: '2' }]
        }, {
          text: 'Utilise un contraceptif',
          model: 'contrat',
          select: '1',
          option: [{ text: 'Non', value: '1' }, { text: 'Oui', value: '2' }]
        }]
      }],
      custom_motifs: [],
      custom_champs: []
    };
  },

  props: ['datasVisiteur'],
  watch: {
    'datasVisiteur.visiteurID': function datasVisiteurVisiteurID(v) {
      if (v) {
        this.showLead();
      }
    }
  },

  methods: {
    showLead: function showLead() {
      var _this = this;

      this.loading = true;
      var dataToGet = new window.FormData();
      dataToGet.append('session', this.datasVisiteur.visiteurID);
      dataToGet.append('siteID', this.datasVisiteur.siteID);
      dataToGet.append('specialtable', this.user.licSpecialtable);
      this.axios.post('get/visitor_lead.php', dataToGet, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        console.log('response', response);
        _this.visiteurLead = {
          session_id: response.data.session_id || '',
          visitor_ip: response.data.visitor_ip || '',
          key: response.data.key || '',
          gender: response.data.gender || '',
          comment: response.data.comment || '',
          name: response.data.name || '',
          lname: response.data.lname || '',
          fname: response.data.fname || '',
          email: response.data.email || '',
          tel: response.data.tel || '',
          lic_eezy_lead: response.data.lic_eezy_lead || '',
          objectif_site: response.data.objectif.site || '',
          objectif_title: response.data.objectif.title || '',
          objectif_infos: response.data.objectif.infos || '',
          motif: response.data.motif || '',
          motif2: response.data.motif2 || '',
          motifs: response.data.motifs || '',
          customLabel1: response.data.customLabel1 || '',
          customLabel2: response.data.customLabel2 || '',
          customLabel3: response.data.customLabel3 || '',
          nuxe: response.data.nuxe || '',
          nuxe2: response.data.nuxe2 || '',
          orpi2: response.data.orpi2 || '',
          company: response.data.company || '',
          url: response.data.url || '',
          typebien: response.data.typebien || '',
          surface: response.data.surface || '',
          budget: response.data.budget || '',
          destination: response.data.destination || '',
          nbpieces: response.data.nbpieces || '',
          zip: response.data.zip || '',
          ville: response.data.ville || '',
          immatriculation: response.data.immatriculation || '',
          concession: response.data.concession || '',
          envie: response.data.envie || '',
          modele: response.data.modele || '',
          suite: response.data.suite || '',
          situation: response.data.situation || '',
          job: response.data.job || '',
          apport: response.data.apport || '',
          age: response.data.age || '',
          revenuf: response.data.revenuf || '',
          revenu: response.data.revenu || '',
          proprio: response.data.proprio || '',
          impos: response.data.impos || '',
          telm: response.data.telm || '',
          telf: response.data.telf || '',
          region: response.data.region || '',
          acheter: response.data.acheter || '',
          programme: response.data.programme || '',
          departement: response.data.departement || '',
          horraireRappel: response.data.horraireRappel || '',
          dateRappel: response.data.dateRappel || '',
          epargne: response.data.epargne || '',
          cTotal: response.data.cTotal || '',
          cConso: response.data.cConso || '',
          cVehic: response.data.cVehic || '',
          cAutres: response.data.cAutres || '',
          cResi: response.data.cResi || '',
          enfant: response.data.enfant || '',
          panier: response.data.panier || '',
          type: response.data.type || '',
          contact: response.data.contact || '',
          pb: response.data.pb || '',
          duree: response.data.duree || '',
          suivi: response.data.suivi || '',
          contrat: response.data.contrat || '',
          inoya: response.data.inoya || '',
          inoya2: response.data.inoya2 || '',
          inoya3: response.data.inoya3 || '',
          date_account: response.data.date_account || '',
          date_birth: response.data.date_birth || '',
          status: response.data.status || '',
          date_status: response.data.date_status || '',
          points_acquired: response.data.points_acquired || '',
          points_ongoing: response.data.points_ongoing || '',
          points_cumyear: response.data.points_cumyear || '',
          optin_email: response.data.optin_email || '',
          date_first_purch: response.data.date_first_purch || '',
          date_last_purch: response.data.date_last_purch || '',
          last_trans: response.data.last_trans || '',
          last_trans_ttc: response.data.last_trans_ttc || '',
          last_trans_ht: response.data.last_trans_ht || '',
          devise: response.data.devise || '',
          points_last_trans: response.data.points_last_trans || '',
          achat_last_trans: response.data.achat_last_trans || '',
          special_client: response.data.special_client || '',
          user: response.data.user || '',
          title: response.data.title || '',
          usage: response.data.usage || '',
          method: response.data.method || '',
          address: response.data.address || '',
          city: response.data.city || '',
          building: response.data.building || '',
          country: response.data.country || '',
          province: response.data.province || '',
          order: response.data.order || '',
          symptom: response.data.symptom || '',
          consult: response.data.consult || '',
          note: response.data.note || '',
          dateSendLead: response.data.dateSendLead || ''
        };

        if (response.data.special_client === 'inoya') {
          _this.theChat = _this.chatToEasiware(_this.datasVisiteur.visiteurID);
          _this.initMotifInoya();
          _this.default_champs = [{ text: lodash_default.a.upperFirst(_this.$t('gender')), value: 'gender' }, { text: lodash_default.a.upperFirst(_this.$t('lastName')), value: 'lname' }, { text: lodash_default.a.upperFirst(_this.$t('firstName')), value: 'fname' }, { text: lodash_default.a.upperFirst(_this.$t('comment')), value: 'comment' }, { text: lodash_default.a.upperFirst(_this.$t('email')), value: 'email' }, { text: lodash_default.a.upperFirst(_this.$t('phone')), value: 'tel' }];
        }

        if (response.data.special_client === 'nuxe') {
          _this.theChat = _this.chatToEasiware(_this.datasVisiteur.visiteurID);
          _this.initMotifNuxe();
        }

        if (response.data.special_client === 'hisense') {
          _this.default_champs = [{ text: lodash_default.a.upperFirst(_this.$t('lastName')) + '*', value: 'lname' }, { text: lodash_default.a.upperFirst(_this.$t('firstName')) + '*', value: 'fname' }, { text: lodash_default.a.upperFirst(_this.$t('comment')), value: 'comment' }, { text: lodash_default.a.upperFirst(_this.$t('email')), value: 'email' }, { text: lodash_default.a.upperFirst(_this.$t('phone')) + '*', value: 'tel' }];
        }

        for (var n in _this.$store.state._Sites.sites) {
          if (_this.$store.state._Sites.sites[n].LIC_KEY === _this.visiteurLead.key) {
            var customLead = _this.$store.state._Sites.sites[n].DSK_CUSTOM_LEAD_FORM;
            if (customLead !== '') {
              for (var i = 0; i < customLead.motifs.length; ++i) {
                var label = customLead.motifs[i];
                if (label === 'support') {
                  label = 'Support';
                } else if (label === 'lead') {
                  label = 'Prospect qualifié';
                } else if (label === 'sale') {
                  label = 'Vente';
                } else if (label === 'resa') {
                  label = 'Réservation';
                } else if (label === 'devis') {
                  label = 'Devis';
                } else if (label === 'contact') {
                  label = 'Contact';
                }
                _this.custom_motifs.push({
                  text: label,
                  value: customLead.motifs[i]
                });
              }
              for (var _i = 0; _i < customLead.info.length; ++_i) {
                var _label = customLead.info[_i];
                if (_label === 'gender') {
                  _label = _this.$t('gender');
                } else if (_label === 'lname') {
                  _label = _this.$t('lastName');
                } else if (_label === 'fname') {
                  _label = _this.$t('firstName');
                } else if (_label === 'comment') {
                  _label = _this.$t('comment');
                } else if (_label === 'email') {
                  _label = 'Email';
                } else if (_label === 'tel') {
                  _label = _this.$t('phone');
                } else if (_label === 'company') {
                  _label = _this.$t('company');
                } else if (_label === 'url') {
                  _label = _this.$t('url');
                }
                _this.custom_champs.push({
                  text: _label,
                  value: customLead.info[_i]
                });
              }
              if (_this.custom_motifs.length !== 0) {
                _this.default_motif = _this.custom_motifs;
              } else {
                _this.default_motif = [];
              }
              if (_this.custom_champs.length !== 0) {
                _this.default_champs = _this.custom_champs;
                for (var _i2 = 0; _i2 < _this.custom_champs.length; ++_i2) {
                  var j = _this.custom_champs[_i2].value;
                  _this.visiteurLead[j] = response.data[j];
                }
              } else {
                _this.default_champs = [];
              }
            }
          }
        }

        if (_this.visiteurLead.motif !== undefined && _this.visiteurLead.motif !== '') {
          var tempVis = lodash_default.a.cloneDeep(_this.datasVisiteur);
          tempVis.motif = true;
          _this.$store.commit('_StoreWatcheeBox/SET_VISITEURS', tempVis);
        }
        _this.error = false;
      }).catch(function () {
        _this.error = true;
        _this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: _this.$t('error'),
          context: 'error'
        });
      }).then(function () {
        _this.loading = false;
        _this.dateSendLead = _this.visiteurLead.dateSendLead;
      });
    },
    changeForm: function changeForm() {
      console.log('changement form');
      this.leadSend = false;
      this.smsSend = false;
      this.leadSend2 = false;
    },
    submit: function submit(data) {
      var _this2 = this;

      console.log('submit', data);

      this.loadingSaveLead = true;

      var dataToPost = new window.FormData();
      dataToPost.append('lead', stringify_default()(this.visiteurLead));
      dataToPost.append('specialtable', this.user.licSpecialtable);
      dataToPost.append('chat', this.theChat);
      dataToPost.append('dateSendLead', data.dateSendLead ? data.dateSendLead : '');
      this.axios.post('put/visitor_lead.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Lead Enregistré',
          context: 'success'
        });

        var tempVis = lodash_default.a.cloneDeep(_this2.datasVisiteur);
        tempVis.motif = true;
        _this2.$store.commit('_StoreWatcheeBox/SET_VISITEURS', tempVis);
      }).catch(function (_) {
        _this2.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: "Echec de l'enregistrement",
          context: 'error'
        });
      }).then(function (_) {
        _this2.loadingSaveLead = false;
      });
    },
    clear: function clear() {
      this.$refs.form.reset();
    },
    sendSms: function sendSms() {
      var _this3 = this;

      this.loadingSms = true;

      var dataToPost = new window.FormData();
      dataToPost.append('lead', stringify_default()(this.visiteurLead));
      this.theChat = this.chatToEasiware(this.datasVisiteur.visiteurID);
      this.axios.post('post/lead_sms.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this3.smsSend = true;
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'SMS envoyé',
          context: 'success'
        });
      }).catch(function (_) {
        _this3.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'SMS NON envoyé',
          context: 'error'
        });
        _this3.txtLead = 'Probleme d\'envois du SMS';
      }).then(function (_) {
        _this3.loadingSms = false;
      });
    },
    sendlead: function sendlead() {
      var _this4 = this;

      this.loadingLead = true;

      var dataToPost = new window.FormData();
      dataToPost.append('lead', stringify_default()(this.visiteurLead));
      this.theChat = this.chatToEasiware(this.datasVisiteur.visiteurID);
      dataToPost.append('chat', this.theChat);
      this.axios.post('post/lead_mail.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this4.submit({
          'dateSendLead': Date.now()
        });
        _this4.leadSend = true;
        _this4.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Lead envoyé',
          context: 'success'
        });
        _this4.dateSendLead = Date.now();
      }).catch(function (_) {
        _this4.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Lead NON envoyé',
          context: 'error'
        });
        _this4.txtLead = 'Probleme d\'envois du lead';
      }).then(function (_) {
        _this4.loadingLead = false;
      });
    },
    inoyaEasiware: function inoyaEasiware(ouverture) {
      var _this5 = this;

      if (ouverture === 'S1') {
        this.loadingLead = true;
      } else {
        this.loadingLead2 = true;
      }

      var dataToPost = new window.FormData();
      dataToPost.append('lead', stringify_default()(this.visiteurLead));
      dataToPost.append('ouverture', ouverture);
      dataToPost.append('chat', this.theChat);
      this.axios.post('post/inoya_easiware.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this5.submit({
          'dateSendLead': Date.now()
        });
        if (ouverture === 'S1') {
          _this5.leadSend = true;
        } else {
          _this5.leadSend2 = true;
        }
        _this5.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Lead envoyé',
          context: 'success'
        });
        _this5.dateSendLead = Date.now();
      }).catch(function (_) {
        _this5.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Lead NON envoyé',
          context: 'error'
        });
        _this5.txtLead = 'Probleme d\'envois du lead';
      }).then(function (_) {
        if (ouverture === 'S1') {
          _this5.loadingLead = false;
        } else {
          _this5.loadingLead2 = false;
        }
      });
    },
    sisleySelligent: function sisleySelligent() {
      var _this6 = this;

      var dataToPost = new window.FormData();
      dataToPost.append('lead', stringify_default()(this.visiteurLead));
      dataToPost.append('chat', this.theChat);
      this.axios.post('post/sisley_selligent.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this6.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Lead send',
          context: 'success'
        });
      }).catch(function (_) {
        _this6.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Lead NOT send',
          context: 'error'
        });
      }).then(function (_) {});
    },
    sisleyGetSelligent: function sisleyGetSelligent() {
      var _this7 = this;

      this.loadingLead = true;

      var dataToPost = new window.FormData();
      dataToPost.append('lead', stringify_default()(this.visiteurLead));
      this.axios.post('post/sisley_get_selligent.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this7.submit({
          'dateSendLead': Date.now()
        });
        _this7.leadSend = true;
        _this7.dateSendLead = Date.now();
        _this7.visiteurLead.gender = response.data.gender || '';
        _this7.visiteurLead.lname = response.data.lname || '';
        _this7.visiteurLead.fname = response.data.fname || '';
        _this7.visiteurLead.date_account = response.data.date_account || '';
        _this7.visiteurLead.date_birth = response.data.date_birth || '';
        _this7.visiteurLead.status = response.data.status || '';
        _this7.visiteurLead.date_status = response.data.date_status || '';
        _this7.visiteurLead.points_acquired = response.data.points_acquired || '';
        _this7.visiteurLead.points_ongoing = response.data.points_ongoing || '';
        _this7.visiteurLead.points_cumyear = response.data.points_cumyear || '';
        _this7.visiteurLead.optin_email = response.data.optin_email || '';
        _this7.visiteurLead.date_first_purch = response.data.date_first_purch || '';
        _this7.visiteurLead.date_last_purch = response.data.date_last_purch || '';
        _this7.visiteurLead.last_trans = response.data.last_trans || '';
        _this7.visiteurLead.last_trans_ttc = response.data.last_trans_ttc || '';
        _this7.visiteurLead.last_trans_ht = response.data.last_trans_ht || '';
        _this7.visiteurLead.devise = response.data.devise || '';
        _this7.visiteurLead.points_last_trans = response.data.points_last_trans || '';
        _this7.visiteurLead.achat_last_trans = response.data.achat_last_trans || '';
        _this7.visiteurLead.tel = response.data.tel || '';
        _this7.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Email found, information updated',
          context: 'success'
        });
      }).catch(function (_) {
        _this7.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Email NOT found',
          context: 'error'
        });
        _this7.txtLead = 'Probleme d\'envois du lead';
      }).then(function (_) {
        _this7.loadingLead = false;
      });
    },
    updateSubMotifNuxe: function updateSubMotifNuxe() {
      this.loadingLead = true;
      this.nuxe_motif_sub = '';
      if (this.visiteurLead.nuxe === '2') {
        this.nuxe_motif_sub = this.nuxe_motif2a;
      } else if (this.visiteurLead.nuxe === '31') {
        this.nuxe_motif_sub = this.nuxe_motif31a;
      } else if (this.visiteurLead.nuxe === '6') {
        this.nuxe_motif_sub = this.nuxe_motif6a;
      } else if (this.visiteurLead.nuxe === '7') {
        this.nuxe_motif_sub = this.nuxe_motif7a;
      } else if (this.visiteurLead.nuxe === '8') {
        this.nuxe_motif_sub = this.nuxe_motif8a;
      } else if (this.visiteurLead.nuxe === '172') {
        this.nuxe_motif_sub = this.nuxe_motif172a;
      }
    },
    initMotifNuxe: function initMotifNuxe() {
      if (this.visiteurLead.nuxe === '2') {
        this.nuxe_motif_sub = this.nuxe_motif2a;
      } else if (this.visiteurLead.nuxe === '31') {
        this.nuxe_motif_sub = this.nuxe_motif31a;
      } else if (this.visiteurLead.nuxe === '6') {
        this.nuxe_motif_sub = this.nuxe_motif6a;
      } else if (this.visiteurLead.nuxe === '7') {
        this.nuxe_motif_sub = this.nuxe_motif7a;
      } else if (this.visiteurLead.nuxe === '8') {
        this.nuxe_motif_sub = this.nuxe_motif8a;
      } else if (this.visiteurLead.nuxe === '172') {
        this.nuxe_motif_sub = this.nuxe_motif172a;
      }
    },
    updateSubMotifInoya: function updateSubMotifInoya() {
      this.visiteurLead.inoya2 = '';
      if (this.visiteurLead.inoya === '1') {
        this.inoya_motif2 = this.inoya_motif2a;
      } else if (this.visiteurLead.inoya === '2') {
        this.inoya_motif2 = this.inoya_motif2b;
      } else if (this.visiteurLead.inoya === '3') {
        this.inoya_motif2 = [];
      } else if (this.visiteurLead.inoya === '4') {
        this.inoya_motif2 = this.inoya_motif2c;
      } else if (this.visiteurLead.inoya === '5') {
        this.inoya_motif2 = this.inoya_motif2d;
      } else if (this.visiteurLead.inoya === '6') {
        this.inoya_motif2 = this.inoya_motif2e;
      } else if (this.visiteurLead.inoya === '7') {
        this.inoya_motif2 = [];
      }
      if (this.visiteurLead.inoya !== '2') {
        this.inoya_motif2bb = [];
        this.visiteurLead.inoya3 = '';
      }
    },
    updateSubSubMotifInoya: function updateSubSubMotifInoya() {
      if (this.visiteurLead.inoya2 === '777') {
        this.inoya_motif2bb = this.inoya_motif3;
      } else {
        this.inoya_motif2bb = [];
        this.visiteurLead.inoya3 = '';
      }
    },
    initMotifInoya: function initMotifInoya() {
      if (this.visiteurLead.inoya === '1') {
        this.inoya_motif2 = this.inoya_motif2a;
      } else if (this.visiteurLead.inoya === '2') {
        this.inoya_motif2 = this.inoya_motif2b;
      } else if (this.visiteurLead.inoya === '3') {
        this.inoya_motif2 = [];
      } else if (this.visiteurLead.inoya === '4') {
        this.inoya_motif2 = this.inoya_motif2c;
      } else if (this.visiteurLead.inoya === '5') {
        this.inoya_motif2 = this.inoya_motif2d;
      } else if (this.visiteurLead.inoya === '6') {
        this.inoya_motif2 = this.inoya_motif2e;
      } else if (this.visiteurLead.inoya === '7') {
        this.inoya_motif2 = [];
      }
      if (this.visiteurLead.inoya !== '2') {
        this.inoya_motif2bb = [];
        this.visiteurLead.inoya3 = '';
      }
      if (this.visiteurLead.inoya2 === '777') {
        this.inoya_motif2bb = this.inoya_motif3;
      } else {
        this.inoya_motif2bb = [];
        this.visiteurLead.inoya3 = '';
      }
    },
    chatToEasiware: function chatToEasiware(sesId) {
      var conversExport = '';
      if (document.querySelector('#conversation_' + sesId)) {
        var listDiv = document.querySelectorAll('#conversation_' + sesId + ' div');
        for (var i = 0; i < listDiv.length; i++) {
          var date = '';
          var author = '';
          var msg = '';
          var bulleChat = listDiv[i];
          if (bulleChat.className !== 'WatchBox-conversation' && bulleChat.className !== 'bulle_Agent_BO' && bulleChat.className !== 'bulle_Visiteur_BO' && bulleChat.className !== 'bulle_BO') {
            if (bulleChat.querySelector('.timestamp_Visiteur_BO')) {
              date = bulleChat.querySelector('.timestamp_Visiteur_BO').textContent;
            } else if (bulleChat.querySelector('.timestamp_Agent_BO')) {
              date = bulleChat.querySelector('.timestamp_Agent_BO').textContent;
            }
            if (bulleChat.querySelector('.nom_Visiteur_BO')) {
              author = bulleChat.querySelector('.nom_Visiteur_BO').textContent;
              if (this.visiteurLead.fname !== '' && this.visiteurLead.fname !== 'undefined') {
                author = this.visiteurLead.fname;
              }
              if (this.visiteurLead.lname !== '' && this.visiteurLead.lname !== 'undefined') {
                author += ' ' + this.visiteurLead.lname;
              }
            } else if (bulleChat.querySelector('.nom_Agent_BO')) {
              author = bulleChat.querySelector('.nom_Agent_BO').textContent;
            }
            if (bulleChat.querySelector('.message_Visiteur')) {
              msg = bulleChat.querySelector('.message_Visiteur').textContent;
            } else if (bulleChat.querySelector('.message_Agent')) {
              msg = bulleChat.querySelector('.message_Agent').textContent;
            }
            if (date !== '' || author !== '' || msg !== '') {
              conversExport += date + ' - ' + author + ': ' + msg + '<br>';
            }
          }
        }
      }
      if (conversExport !== '') {
        conversExport = conversExport.replace(/'/g, ' ');
        conversExport = conversExport.replace(/\+/g, ' ');
        conversExport = conversExport.replace(/&amp;/g, ' ');
        conversExport = conversExport.replace(/&/g, ' ');
        conversExport = conversExport.replace(/<p class="sysMessage ">/g, '');
      }
      return conversExport;
    },
    hisenseSAP: function hisenseSAP() {
      var _this8 = this;

      this.loadingLead = true;

      var dataToPost = new window.FormData();
      dataToPost.append('lead', stringify_default()(this.visiteurLead));
      this.axios.post('post/hisense-sap.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this8.submit({
          'dateSendLead': Date.now()
        });
        _this8.leadSend = true;
        _this8.dateSendLead = Date.now();
        _this8.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Successfully send to SAP',
          context: 'success'
        });
      }).catch(function (_) {
        _this8.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Error from SAP',
          context: 'error'
        });
        _this8.txtLead = 'Probleme d\'envois du lead';
      }).then(function (_) {
        _this8.loadingLead = false;
      });
    },
    zendesk: function zendesk() {
      var _this9 = this;

      this.loadingLeadZendesk = true;

      var dataToPost = new window.FormData();
      dataToPost.append('lead', stringify_default()(this.visiteurLead));
      this.axios.post('post/lead_zendesk.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this9.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Ticket envoyé vers Zendesk',
          context: 'success'
        });
      }).catch(function (_) {
        _this9.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Ticket NON envoyé',
          context: 'error'
        });
      }).then(function (_) {
        _this9.loadingLeadZendesk = false;
      });
    },
    salesforce: function salesforce() {
      var _this10 = this;

      this.loadingLeadSelesForce = true;

      var dataToPost = new window.FormData();
      dataToPost.append('lead', stringify_default()(this.visiteurLead));
      this.axios.post('post/lead_salesforce.php', dataToPost, {
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function (response) {
        _this10.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Piste envoyé vers Salesforce',
          context: 'success'
        });
      }).catch(function (_) {
        _this10.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Piste NON crée',
          context: 'error'
        });
      }).then(function (_) {
        _this10.loadingLeadSelesForce = false;
      });
    }
  },

  mounted: function mounted() {
    this.showLead();
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_User', ['user']), {
    leadSendDate: function leadSendDate() {
      if (this.dateSendLead) {
        return 'Lead envoyé le ' + moment_default()(this.dateSendLead).format('LLLL');
      } else {
        return null;
      }
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab38152","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzFicheLeadVisiteur.vue
var WzFicheLeadVisiteur_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"wz_cardLead"},[(_vm.loading)?_c('div',{staticClass:"wz_loadingChat text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text ",attrs:{"size":70,"width":1,"indeterminate":""}})],1):(_vm.error)?_c('div',[_c('v-alert',{attrs:{"type":"warning","value":"true"}},[_vm._v("\n          "+_vm._s(_vm._f("cap")(_vm.$t('queryFailed')))+"\n        ")])],1):_c('div',{staticClass:"ficheLeadVisiteur"},[_c('v-form',{ref:"form",staticClass:"formLeadVisiteur",attrs:{"lazy-validation":""},on:{"change":_vm.changeForm},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[(_vm.visiteurLead.special_client !== '' && _vm.visiteurLead.special_client !== 'sisley' && _vm.visiteurLead.special_client !== 'hisense')?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-subheader',[_vm._v("Objectif")])],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_vm._v("\n              "+_vm._s(_vm.visiteurLead.objectif_site)),_c('br'),_vm._v("\n              "+_vm._s(_vm.visiteurLead.objectif_title)),_c('br'),_vm._v("\n              "+_vm._s(_vm.visiteurLead.objectif_infos)+"\n            ")])],1):_vm._e(),_vm._v(" "),(_vm.visiteurLead.special_client === '' || _vm.visiteurLead.special_client === 'hisense' || _vm.visiteurLead.special_client === 'orpi')?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.default_motif,"label":_vm.$tc('tags', 1, {count: ''}),"menu-props":"auto"},on:{"change":_vm.changeForm},model:{value:(_vm.visiteurLead.motif),callback:function ($$v) {_vm.$set(_vm.visiteurLead, "motif", $$v)},expression:"visiteurLead.motif"}})],1)],1):(_vm.visiteurLead.special_client === 'cbre')?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.cbre_motif,"label":_vm.$tc('tags', 1, {count: ''}),"menu-props":"auto"},on:{"change":_vm.changeForm},model:{value:(_vm.visiteurLead.motif),callback:function ($$v) {_vm.$set(_vm.visiteurLead, "motif", $$v)},expression:"visiteurLead.motif"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.visiteurLead.special_client === 'orpi')?_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.orpi_motif2,"label":"Préciser s'il s'agit d'un lead vendeur","menu-props":"auto"},on:{"change":_vm.changeForm},model:{value:(_vm.visiteurLead.orpi2),callback:function ($$v) {_vm.$set(_vm.visiteurLead, "orpi2", $$v)},expression:"visiteurLead.orpi2"}})],1)],1):_vm._e(),_vm._v(" "),(_vm.visiteurLead.special_client === 'nuxe')?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.nuxe_motif,"label":_vm.$tc('tags', 1, {count: ''}),"menu-props":"auto"},on:{"input":_vm.updateSubMotifNuxe,"change":_vm.changeForm},model:{value:(_vm.visiteurLead.nuxe),callback:function ($$v) {_vm.$set(_vm.visiteurLead, "nuxe", $$v)},expression:"visiteurLead.nuxe"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.nuxe_motif_sub,"label":"Sous Motif","menu-props":"auto"},on:{"change":_vm.changeForm},model:{value:(_vm.visiteurLead.nuxe2),callback:function ($$v) {_vm.$set(_vm.visiteurLead, "nuxe2", $$v)},expression:"visiteurLead.nuxe2"}})],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.visiteurLead.special_client === 'inoya')?_c('div',[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.inoya_motif,"label":"Motif","menu-props":"auto"},on:{"input":_vm.updateSubMotifInoya,"change":_vm.changeForm},model:{value:(_vm.visiteurLead.inoya),callback:function ($$v) {_vm.$set(_vm.visiteurLead, "inoya", $$v)},expression:"visiteurLead.inoya"}})],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-select',{attrs:{"items":_vm.inoya_motif2,"label":"Sous Motif","menu-props":"auto"},on:{"input":_vm.updateSubSubMotifInoya,"change":_vm.changeForm},model:{value:(_vm.visiteurLead.inoya2),callback:function ($$v) {_vm.$set(_vm.visiteurLead, "inoya2", $$v)},expression:"visiteurLead.inoya2"}})],1)],1)],1):_vm._e(),_vm._v(" "),_vm._l((_vm.default_champs),function(champ,y){return _c('div',{key:y},[(champ.value === 'gender')?_c('div',[_c('div',[_c('v-flex',{attrs:{"xs12":""}},[_c('wz-select-gender',{attrs:{"gender":_vm.visiteurLead.gender,"client":_vm.visiteurLead.special_client},on:{"update:gender":function($event){_vm.$set(_vm.visiteurLead, "gender", $event)}}})],1)],1)]):(champ.value === 'comment')?_c('div',[_c('v-textarea',{attrs:{"label":champ.text},on:{"keydown":function($event){_vm.changeForm()}},model:{value:(_vm.visiteurLead.comment),callback:function ($$v) {_vm.$set(_vm.visiteurLead, "comment", $$v)},expression:"visiteurLead.comment"}})],1):(champ.value === 'fname')?_c('div',[_c('v-text-field',{attrs:{"label":champ.text},on:{"keydown":function($event){_vm.changeForm()}},model:{value:(_vm.visiteurLead.fname),callback:function ($$v) {_vm.$set(_vm.visiteurLead, "fname", $$v)},expression:"visiteurLead.fname"}})],1):(champ.value === 'lname')?_c('div',[_c('v-text-field',{attrs:{"label":champ.text},on:{"keydown":function($event){_vm.changeForm()}},model:{value:(_vm.visiteurLead.lname),callback:function ($$v) {_vm.$set(_vm.visiteurLead, "lname", $$v)},expression:"visiteurLead.lname"}})],1):(champ.value === 'email')?_c('div',[_c('v-text-field',{attrs:{"label":champ.text,"rules":[_vm.rules.required, _vm.rules.email]},on:{"keydown":function($event){_vm.changeForm()}},model:{value:(_vm.visiteurLead.email),callback:function ($$v) {_vm.$set(_vm.visiteurLead, "email", $$v)},expression:"visiteurLead.email"}})],1):(champ.value === 'tel')?_c('div',[_c('v-text-field',{attrs:{"label":champ.text},on:{"keydown":function($event){_vm.changeForm()}},model:{value:(_vm.visiteurLead.tel),callback:function ($$v) {_vm.$set(_vm.visiteurLead, "tel", $$v)},expression:"visiteurLead.tel"}})],1):(champ.value === 'company')?_c('div',[_c('v-text-field',{attrs:{"label":champ.text},on:{"keydown":function($event){_vm.changeForm()}},model:{value:(_vm.visiteurLead.company),callback:function ($$v) {_vm.$set(_vm.visiteurLead, "company", $$v)},expression:"visiteurLead.company"}})],1):(champ.value === 'url')?_c('div',[(_vm.visiteurLead.special_client != 'sisley')?_c('div',[_c('v-text-field',{attrs:{"label":champ.text},on:{"keydown":function($event){_vm.changeForm()}},model:{value:(_vm.visiteurLead.url),callback:function ($$v) {_vm.$set(_vm.visiteurLead, "url", $$v)},expression:"visiteurLead.url"}})],1):_vm._e()]):_c('div',[_c('v-text-field',{attrs:{"label":champ.text},on:{"keydown":function($event){_vm.changeForm()}},model:{value:(_vm.visiteurLead[champ.value]),callback:function ($$v) {_vm.$set(_vm.visiteurLead, champ.value, $$v)},expression:"visiteurLead[champ.value]"}})],1)])}),_vm._v(" "),(_vm.visiteurLead.special_client !== '')?_c('div',[_c('div',{attrs:{"slot":"header"},slot:"header"},[_vm._v(_vm._s(_vm.$t('otherinfo')))]),_vm._v(" "),_vm._l((_vm.champs_eezylead),function(eezy,i){return (eezy.client === _vm.visiteurLead.special_client)?_c('div',{key:i},_vm._l((eezy.fields),function(champ,j){return _c('div',{key:j},[(champ.select !== '1')?_c('v-text-field',{attrs:{"name":"input-3-3","label":champ.text},on:{"keydown":function($event){_vm.changeForm()}},model:{value:(_vm.visiteurLead[champ.model]),callback:function ($$v) {_vm.$set(_vm.visiteurLead, champ.model, $$v)},expression:"visiteurLead[champ.model]"}}):_c('v-select',{attrs:{"items":champ.option,"label":champ.text,"menu-props":"auto"},on:{"keydown":function($event){_vm.changeForm()}},model:{value:(_vm.visiteurLead[champ.model]),callback:function ($$v) {_vm.$set(_vm.visiteurLead, champ.model, $$v)},expression:"visiteurLead[champ.model]"}})],1)})):_vm._e()})],2):_vm._e(),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[_c('v-spacer'),_vm._v(" "),_c('v-btn',{on:{"click":_vm.clear}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","loading":_vm.loadingSaveLead,"disabled":_vm.loadingSaveLead},on:{"click":function($event){_vm.submit({dateSendLead: _vm.dateSendLead})}}},[_vm._v(_vm._s(_vm.$t('save')))])],1),_vm._v(" "),_c('br'),_vm._v("\n          "+_vm._s(_vm.txtLead)+" "+_vm._s(_vm.leadSendDate)+"\n          "),_c('br'),_vm._v(" "),_c('v-layout',{attrs:{"row":""}},[(_vm.visiteurLead.special_client === 'inoya')?_c('v-btn',{attrs:{"color":"primary","flat":"","medium":"","loading":_vm.loadingLead,"disabled":_vm.loadingLead || _vm.leadSend},on:{"click":function($event){_vm.inoyaEasiware('S1')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("favorite_border")]),_vm._v("\n              Demande EASIWARE ouverte\n            ")],1):_vm._e(),_vm._v(" "),(_vm.visiteurLead.special_client === 'inoya')?_c('v-btn',{attrs:{"color":"primary","flat":"","medium":"","loading":_vm.loadingLead2,"disabled":_vm.loadingLead2 || _vm.leadSend2},on:{"click":function($event){_vm.inoyaEasiware('6')}}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("favorite_border")]),_vm._v("\n              Demande EASIWARE cloturée\n            ")],1):(_vm.visiteurLead.special_client === 'nuxe')?_c('v-btn',{attrs:{"color":"primary","flat":"","medium":"","loading":_vm.loadingLead,"disabled":_vm.loadingLead || _vm.leadSend},on:{"click":_vm.sendlead}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("favorite_border")]),_vm._v("\n              EASIWARE\n            ")],1):_vm._e(),_vm._v(" "),(_vm.visiteurLead.special_client === 'sisley')?_c('v-btn',{attrs:{"color":"primary","flat":"","medium":"","loading":_vm.loadingLead,"disabled":_vm.loadingLead || _vm.leadSend},on:{"click":_vm.sisleyGetSelligent}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("favorite_border")]),_vm._v("\n              "+_vm._s(_vm.$t('selligentget'))+"\n            ")],1):_vm._e(),_vm._v(" "),(_vm.visiteurLead.special_client === 'hisense')?_c('v-btn',{attrs:{"color":"primary","flat":"","medium":"","loading":_vm.loadingLead,"disabled":_vm.loadingLead || _vm.leadSend},on:{"click":_vm.hisenseSAP}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("favorite_border")]),_vm._v("\n              Send to S.A.P.\n            ")],1):_c('v-btn',{attrs:{"color":"primary","flat":"","medium":"","loading":_vm.loadingLead,"disabled":_vm.loadingLead || _vm.leadSend},on:{"click":_vm.sendlead}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mail_outline")]),_vm._v("\n              "+_vm._s(_vm.$t('sendByEmail'))+"\n            ")],1),_vm._v(" "),(_vm.user.smsOn === '1')?_c('v-btn',{attrs:{"color":"primary","flat":"","medium":"","loading":_vm.loadingSms,"disabled":_vm.loadingSms || _vm.smsSend},on:{"click":_vm.sendSms}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("textsms")]),_vm._v("\n              "+_vm._s(_vm.$t('sendBySms'))+"\n            ")],1):_vm._e(),_vm._v(" "),(_vm.user.entSF === 'salesforce')?_c('v-btn',{attrs:{"color":"primary","flat":"","medium":"","loading":_vm.loadingLeadSelesForce,"disabled":_vm.loadingLeadSelesForce},on:{"click":_vm.salesforce}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mail_outline")]),_vm._v("\n              Salesforce\n            ")],1):_vm._e(),_vm._v(" "),(_vm.user.entZD === 'zendesk')?_c('v-btn',{attrs:{"color":"primary","flat":"","medium":"","loading":_vm.loadingLeadZendesk,"disabled":_vm.loadingLeadZendesk},on:{"click":_vm.zendesk}},[_c('v-icon',{attrs:{"left":""}},[_vm._v("mail_outline")]),_vm._v("\n              Zendesk\n            ")],1):_vm._e()],1)],2)],1)])}
var WzFicheLeadVisiteur_staticRenderFns = []
var WzFicheLeadVisiteur_esExports = { render: WzFicheLeadVisiteur_render, staticRenderFns: WzFicheLeadVisiteur_staticRenderFns }
/* harmony default export */ var watcheebox_WzFicheLeadVisiteur = (WzFicheLeadVisiteur_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzFicheLeadVisiteur.vue
function WzFicheLeadVisiteur_injectStyle (ssrContext) {
  __webpack_require__("EuQE")
}
var WzFicheLeadVisiteur_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzFicheLeadVisiteur___vue_template_functional__ = false
/* styles */
var WzFicheLeadVisiteur___vue_styles__ = WzFicheLeadVisiteur_injectStyle
/* scopeId */
var WzFicheLeadVisiteur___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzFicheLeadVisiteur___vue_module_identifier__ = null
var WzFicheLeadVisiteur_Component = WzFicheLeadVisiteur_normalizeComponent(
  WzFicheLeadVisiteur,
  watcheebox_WzFicheLeadVisiteur,
  WzFicheLeadVisiteur___vue_template_functional__,
  WzFicheLeadVisiteur___vue_styles__,
  WzFicheLeadVisiteur___vue_scopeId__,
  WzFicheLeadVisiteur___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzFicheLeadVisiteur = (WzFicheLeadVisiteur_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzFicheBiblioPhrases.vue




/* harmony default export */ var WzFicheBiblioPhrases = ({
  data: function data() {
    return {
      overMenu: false
    };
  },


  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['status']), Object(vuex_esm["e" /* mapState */])('_Biblios', ['biblios'])),

  methods: {
    putMessage: function putMessage(msg) {
      if (this.overMenu) return;
      this.$emit('put', msg);
    },
    sendMessage: function sendMessage(msg) {
      if (this.status === 'offline') {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: this.$t('currentlyOffline'),
          context: 'error'
        });
        return;
      }
      this.$emit('send', { message: msg });
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-22324fc2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzFicheBiblioPhrases.vue
var WzFicheBiblioPhrases_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"fiche-biblio"},[_c('v-expansion-panel',{attrs:{"expand":""}},_vm._l((_vm.biblios),function(biblio){return _c('v-expansion-panel-content',{key:biblio.id},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("collections_bookmark")]),_vm._v("\n          "+_vm._s(biblio.title)+"\n          "),_c('span',{staticClass:"caption grey--text text--darken-1"},[_vm._v("\n            (\n            "+_vm._s(_vm.$tc('subLibraries', biblio.subs.length, { count: biblio.subs.length }))+"\n            "+_vm._s(_vm.$tc('sentences', biblio.sentences.length, { count: biblio.sentences.length }))+"\n            )\n          ")])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-3 px-1"},[(biblio.subs.length)?_c('v-expansion-panel',{attrs:{"expand":""}},_vm._l((biblio.subs),function(sub){return _c('v-expansion-panel-content',{key:sub.id,attrs:{"avatar":""}},[_c('div',{attrs:{"slot":"header"},slot:"header"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("book")]),_vm._v("\n                  "+_vm._s(sub.title)+"\n                  "),_c('span',{staticClass:"caption grey--text text--darken-1"},[_vm._v("\n                    ("+_vm._s(_vm.$tc('sentences', sub.sentences.length, {count: sub.sentences.length}))+")\n                  ")])],1),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-3 pl-1 pr-2"},[(sub.sentences.length)?_c('v-list',{attrs:{"two-line":"","dense":"","subheader":""}},_vm._l((sub.sentences),function(phrase){return _c('v-list-tile',{key:phrase.id,on:{"click":function($event){_vm.status === 'offline' ? ';' : _vm.putMessage(phrase.title)}}},[_c('v-list-tile-content',[_vm._v("\n                          "+_vm._s(_vm._f("truncate")(phrase.title,120))+"\n                        ")]),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"color":_vm.status === 'offline' ? 'grey--text' : 'secondary--text',"icon":"","small":""},on:{"click":function($event){_vm.status === 'offline' ? ';' : _vm.sendMessage(phrase.title)},"mouseover":function($event){_vm.overMenu = true},"mouseleave":function($event){_vm.overMenu = false}}},[_c('v-icon',[_vm._v("send")])],1)],1)],1)}),1):_vm._e()],1)],1)],1)}),1):_vm._e()],1)],1),_vm._v(" "),_c('v-card',[_c('v-card-text',{staticClass:"grey lighten-3 px-1"},[(biblio.sentences.length)?_c('v-list',{attrs:{"two-line":"","dense":"","subheader":""}},_vm._l((biblio.sentences),function(phrase){return _c('v-list-tile',{key:phrase.id,on:{"click":function($event){_vm.status === 'offline' ? ';' : _vm.putMessage(phrase.title)}}},[_c('v-list-tile-content',[_vm._v("\n                  "+_vm._s(_vm._f("truncate")(phrase.title,120))+"\n                ")]),_vm._v(" "),_c('v-list-tile-action',[_c('v-btn',{attrs:{"color":_vm.status === 'offline' ? 'grey--text' : 'secondary--text',"icon":"","small":""},on:{"click":function($event){_vm.status === 'offline' ? ';' : _vm.sendMessage(phrase.title)},"mouseover":function($event){_vm.overMenu = true},"mouseleave":function($event){_vm.overMenu = false}}},[_c('v-icon',[_vm._v("send")])],1)],1)],1)}),1):_vm._e()],1)],1)],1)}),1)],1)}
var WzFicheBiblioPhrases_staticRenderFns = []
var WzFicheBiblioPhrases_esExports = { render: WzFicheBiblioPhrases_render, staticRenderFns: WzFicheBiblioPhrases_staticRenderFns }
/* harmony default export */ var watcheebox_WzFicheBiblioPhrases = (WzFicheBiblioPhrases_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzFicheBiblioPhrases.vue
function WzFicheBiblioPhrases_injectStyle (ssrContext) {
  __webpack_require__("QOv9")
}
var WzFicheBiblioPhrases_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzFicheBiblioPhrases___vue_template_functional__ = false
/* styles */
var WzFicheBiblioPhrases___vue_styles__ = WzFicheBiblioPhrases_injectStyle
/* scopeId */
var WzFicheBiblioPhrases___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzFicheBiblioPhrases___vue_module_identifier__ = null
var WzFicheBiblioPhrases_Component = WzFicheBiblioPhrases_normalizeComponent(
  WzFicheBiblioPhrases,
  watcheebox_WzFicheBiblioPhrases,
  WzFicheBiblioPhrases___vue_template_functional__,
  WzFicheBiblioPhrases___vue_styles__,
  WzFicheBiblioPhrases___vue_scopeId__,
  WzFicheBiblioPhrases___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzFicheBiblioPhrases = (WzFicheBiblioPhrases_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzDialogTransfertChat.vue






/* harmony default export */ var WzDialogTransfertChat = ({
  props: {
    datasVisiteur: {
      type: Object,
      required: true
    },
    openOnMounted: {
      type: Boolean
    }
  },
  data: function data() {
    return {
      selectedAgent: {},
      dialog: false,
      messageTransfereStatus: {
        'status': '',
        'automatique': '',
        'visiteurSelected': '',
        'message': ''
      }
    };
  },
  mounted: function mounted() {
    console.log('this.openOnMounted', this.openOnMounted);
    if (this.openOnMounted) {
      this.open();
    }
  },


  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['agentsArray', 'transfertStatusEmission']), Object(vuex_esm["c" /* mapGetters */])('_StoreWatcheeBox', ['WATCHEEBOX_STATE']), Object(vuex_esm["c" /* mapGetters */])('_User', ['fullName']), {
    loadingDialog: function loadingDialog() {
      if (this.messageTransfereStatus.status === 'wait') {
        return true;
      } else {
        return false;
      }
    }
  }),

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('_StoreWatcheeBox', ['ACTION_CLOSE_CHAT']), {
    transferChat: function transferChat() {
      if (this.selectedAgent.id !== '') {
        var datasVisiteurSelect = {
          socketID: this.datasVisiteur.socketID,
          visiteurID: this.datasVisiteur.visiteurID,
          visiteurKey: this.datasVisiteur.roomName,
          siteID: this.datasVisiteur.siteID
        };
        var mySocketID = this.WATCHEEBOX_STATE.mySocketID;
        watcheebox_watcheebox.SendTransfertVisitor({
          selectedAgent: this.selectedAgent,
          datasSelectedVisiteur: datasVisiteurSelect,
          agentsArray: this.agentsArray,

          myAgentID: this.$store.state._User.id,
          mySocketID: mySocketID,
          agentSenderName: this.fullName,
          automatique: false
        });
      } else {
        this.$store.dispatch('_Notifier/NEW_NOTIF', {
          message: 'Selectionnez un agent dans la liste avant de transferer ce visiteur',
          context: 'warning'
        });
      }
    },
    open: function open() {
      var _this = this;

      this.dialog = true;

      if (this.WATCHEEBOX_STATE.transfertStatusEmission.status === 'wait') {
        var statusAgentSelect = 'offline';
        lodash_default.a.forEach(this.agentsArray, function (agent, key) {
          if (agent[2] === _this.WATCHEEBOX_STATE.transfertStatusEmission.datas.WZAgentId) {
            statusAgentSelect = agent[3];
          }
        });
        console.log('il y a un transfere en attente');
        this.selectedAgent = {
          id: this.WATCHEEBOX_STATE.transfertStatusEmission.datas.WZAgentId,
          name: this.WATCHEEBOX_STATE.transfertStatusEmission.datas.agentName,
          socketID: this.WATCHEEBOX_STATE.transfertStatusEmission.datas.destAgentSocket,
          status: statusAgentSelect
        };
        this.messageTransfereStatus = {
          status: this.WATCHEEBOX_STATE.transfertStatusEmission.status,
          automatique: this.WATCHEEBOX_STATE.transfertStatusEmission.datas.automatique,
          visiteurSelected: this.WATCHEEBOX_STATE.transfertStatusEmission.datas.chatSession,
          message: this.WATCHEEBOX_STATE.transfertStatusEmission.datas.msg
        };
      }
    },
    annuleTransfer: function annuleTransfer() {
      this.transferChatAnnuler();
    },
    transferChatFermer: function transferChatFermer() {
      this.transferChatAnnuler();
      this.$emit('closeDialog');
    },
    transferChatAnnuler: function transferChatAnnuler() {
      var mySocketID = this.WATCHEEBOX_STATE.mySocketID;
      watcheebox_watcheebox.AnnulTransfertVisitor({
        selectedAgent: this.selectedAgent,
        mySocketID: mySocketID,
        agentSenderName: this.fullName
      });

      this.$store.commit('_StoreWatcheeBox/SOCKET_VISITOR_TRANSFERT', {
        status: '',
        emission: true,
        messageDatas: ''
      });
    }
  }),

  watch: {
    'transfertStatusEmission': function transfertStatusEmission(val, oldval) {
      console.log('--transfertStatusEmission--', val.status);

      if (val.status === 'wait') {
        this.transfertActif = val.datas.chatSession;
        this.messageTransfereStatus.status = 'wait';
        this.messageTransfereStatus.automatique = val.datas.automatique;
        this.messageTransfereStatus.chatSession = val.datas.chatSession;
        this.messageTransfereStatus.message = this.$t('transfertWait');
      } else if (val.status === 'ok') {
        this.transfertActif = false;

        this.messageTransfereStatus.status = 'ok';
        this.messageTransfereStatus.automatique = val.datas.automatique;
        this.messageTransfereStatus.chatSession = val.datas.chatSession;
        this.messageTransfereStatus.message = this.$t('transfertOk') + ' ' + val.datas.chatSession;

        this.ACTION_CLOSE_CHAT({
          formulaireSatisfaction: false,
          datasVisiteur: this.datasVisiteur,
          clotureChat: false,
          fullPath: this.$route.fullPath,
          textNotif: this.messageTransfereStatus.message
        });
      } else if (val.status === 'no') {
        this.transfertActif = val.datas.chatSession;
        this.messageTransfereStatus.status = 'no';
        this.messageTransfereStatus.automatique = '';
        this.messageTransfereStatus.chatSession = val.datas.chatSession;
        this.messageTransfereStatus.message = this.$t('transfertNo');
      } else if (val.status === 'annuler') {
        this.transfertActif = false;
        this.messageTransfereStatus.status = 'annuler';
        this.messageTransfereStatus.automatique = '';
        this.messageTransfereStatus.chatSession = '';
        this.messageTransfereStatus.message = '';
      } else {
        this.transfertActif = false;
        this.messageTransfereStatus.status = '';
        this.messageTransfereStatus.automatique = '';
        this.messageTransfereStatus.chatSession = '';
        this.messageTransfereStatus.message = '';
      }
    },

    dialog: function dialog(v) {
      if (!v) {
        this.$emit('closeDialog');
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92d0658a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzDialogTransfertChat.vue
var WzDialogTransfertChat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","transition":"dialog-bottom-transition","overlay":false},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-toolbar',{staticClass:"primary",attrs:{"dark":""}},[_c('v-btn',{attrs:{"icon":"","dark":""},nativeOn:{"click":function($event){_vm.transferChatFermer()}}},[_c('v-icon',[_vm._v("close")])],1),_vm._v(" "),_c('v-toolbar-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('toTransfer')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items')],1),_vm._v(" "),_c('v-card-text',{staticClass:"grey lighten-4",attrs:{"fluid":""}},[_c('v-layout',{attrs:{"row":"","wrap":""}},[_c('v-flex',{staticClass:"dialogTransfert",attrs:{"xs12":""}},[_c('v-card',{staticClass:"heightDialogTransfert",attrs:{"flat":""}},[_c('v-card-text',{staticClass:"contentDialogListeAgent"},[_c('v-flex',{staticClass:"ListeAgent",attrs:{"xs12":""}},[(_vm.messageTransfereStatus.automatique)?_c('div',[_vm._v("\n                  "+_vm._s(_vm.$t('messageAgentIndispo'))+"\n                ")]):_c('div',[_vm._v(_vm._s(_vm.$t('selectAgentToTransfer')))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('wz-list-agents',{attrs:{"agentSelect":_vm.selectedAgent,"inMonitoring":false,"visiteurSiteID":_vm.datasVisiteur.siteID},on:{"update:agentSelect":function($event){_vm.selectedAgent=$event}}})],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"heightDialogTransfertBT",attrs:{"flat":""}},[_c('v-card-text',[_c('v-flex',{attrs:{"xs12":""}},[(_vm.selectedAgent.id !== '' && _vm.selectedAgent.status === 'online')?_c('div',{staticClass:"wz_txtTopBtnTransfere",domProps:{"innerHTML":_vm._s(_vm.$tc('agentSelectedSupport', 0, {count: _vm.selectedAgent.name}))}}):(_vm.selectedAgent.id !== '' && _vm.selectedAgent.status !== 'online')?_c('div',{staticClass:"wz_txtTopBtnTransfere",domProps:{"innerHTML":_vm._s(_vm.$tc('agentNotAvailableSupport', 0, {count: _vm.selectedAgent.name}))}}):_c('div',{staticClass:"wz_txtTopBtnTransfere"},[_vm._v(_vm._s(_vm.$tc('agents', 0)))])]),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[(_vm.selectedAgent.status === 'online')?_c('v-btn',{attrs:{"color":"primary","dark":"","loading":_vm.loadingDialog},on:{"click":function($event){_vm.transferChat()}}},[_vm._v(_vm._s(_vm.$t('toTransfer')))]):(_vm.selectedAgent.status !== 'online')?_c('v-btn',{attrs:{"color":"primary","light":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('toTransfer')))]):_c('v-btn',{attrs:{"color":"primary","light":"","disabled":""}},[_vm._v(_vm._s(_vm.$t('toTransfer')))]),_vm._v(" "),(_vm.messageTransfereStatus.status === 'wait')?_c('v-btn',{attrs:{"color":"primary","dark":""},on:{"click":function($event){_vm.annuleTransfer()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]):_vm._e()],1),_vm._v(" "),(_vm.messageTransfereStatus.status === 'no')?_c('v-flex',{attrs:{"xs12":""}},[_c('v-icon',{attrs:{"medium":"","color":"orange darken-2"}},[_vm._v("warning")]),_vm._v(_vm._s(_vm.messageTransfereStatus.message)+"\n              ")],1):_vm._e()],1)],1)],1)],1)],1)],1)],1)}
var WzDialogTransfertChat_staticRenderFns = []
var WzDialogTransfertChat_esExports = { render: WzDialogTransfertChat_render, staticRenderFns: WzDialogTransfertChat_staticRenderFns }
/* harmony default export */ var watcheebox_WzDialogTransfertChat = (WzDialogTransfertChat_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzDialogTransfertChat.vue
var WzDialogTransfertChat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzDialogTransfertChat___vue_template_functional__ = false
/* styles */
var WzDialogTransfertChat___vue_styles__ = null
/* scopeId */
var WzDialogTransfertChat___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzDialogTransfertChat___vue_module_identifier__ = null
var WzDialogTransfertChat_Component = WzDialogTransfertChat_normalizeComponent(
  WzDialogTransfertChat,
  watcheebox_WzDialogTransfertChat,
  WzDialogTransfertChat___vue_template_functional__,
  WzDialogTransfertChat___vue_styles__,
  WzDialogTransfertChat___vue_scopeId__,
  WzDialogTransfertChat___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzDialogTransfertChat = (WzDialogTransfertChat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzDialogBannishVisitor.vue





/* harmony default export */ var WzDialogBannishVisitor = ({
  props: ['datasVisiteur'],
  data: function data() {
    return {
      dialog: false
    };
  },


  computed: extends_default()({}, Object(vuex_esm["c" /* mapGetters */])('_StoreWatcheeBox', ['WATCHEEBOX_STATE']), Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'fullName'])),

  mounted: function mounted() {
    this.dialog = true;
  },


  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('_StoreWatcheeBox', ['ACTION_CLOSE_CHAT']), {
    emitBannChat: function emitBannChat() {
      var _this = this;

      var txtSnackBar = '';

      watcheebox_watcheebox.envoisMessage({
        agentSocketID: this.WATCHEEBOX_STATE.mySocketID,
        datasAgent: this.user,
        datasVisiteur: this.datasVisiteur,
        message: '',
        messageType: 999,
        agentName: unescape(this.fullName)
      });

      var config = {
        responseType: 'json',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Content-Type': 'application/x-www-form-urlencoded'
        }
      };

      var dataToPost = new window.FormData();
      dataToPost.append('visiteurID', this.datasVisiteur.visiteurID);

      this.axios.post('post/ban_visitor.php', dataToPost, config).then(function (response) {
        txtSnackBar = _this.$tc('visitors', 1, { count: '' }) + ' ' + _this.datasVisiteur.visiteurID + ' ' + _this.$t('banned');

        _this.ACTION_CLOSE_CHAT({
          formulaireSatisfaction: false,
          datasVisiteur: _this.datasVisiteur,
          clotureChat: false,
          fullPath: _this.$route.fullPath,
          textNotif: txtSnackBar
        });
      }).catch().then(function (_) {});
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-09426f72","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzDialogBannishVisitor.vue
var WzDialogBannishVisitor_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"320"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('askBanVisitor'))+" "+_vm._s(_vm.datasVisiteur.visiteurName ? _vm.datasVisiteur.visiteurName : _vm.datasVisiteur.visiteurID)+" ?")]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('askBanContent')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.$emit('closeDialog')}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.emitBannChat()}}},[_vm._v(_vm._s(_vm.$t('banish')))])],1)],1)],1)}
var WzDialogBannishVisitor_staticRenderFns = []
var WzDialogBannishVisitor_esExports = { render: WzDialogBannishVisitor_render, staticRenderFns: WzDialogBannishVisitor_staticRenderFns }
/* harmony default export */ var watcheebox_WzDialogBannishVisitor = (WzDialogBannishVisitor_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzDialogBannishVisitor.vue
var WzDialogBannishVisitor_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzDialogBannishVisitor___vue_template_functional__ = false
/* styles */
var WzDialogBannishVisitor___vue_styles__ = null
/* scopeId */
var WzDialogBannishVisitor___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzDialogBannishVisitor___vue_module_identifier__ = null
var WzDialogBannishVisitor_Component = WzDialogBannishVisitor_normalizeComponent(
  WzDialogBannishVisitor,
  watcheebox_WzDialogBannishVisitor,
  WzDialogBannishVisitor___vue_template_functional__,
  WzDialogBannishVisitor___vue_styles__,
  WzDialogBannishVisitor___vue_scopeId__,
  WzDialogBannishVisitor___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzDialogBannishVisitor = (WzDialogBannishVisitor_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzIframeExtension.vue




/* harmony default export */ var WzIframeExtension = ({
  props: {
    datasVisiteur: {
      type: Object
    }
  },
  created: function created() {
    if (!this.site || this.site.DSK_EXTENSION_ONOFF !== '1') {
      this.$emit('closeDialog');
    }
  },

  methods: {
    handleError: function handleError(event) {
      console.warn('handleError', event);
    },
    handleLoaded: function handleLoaded(event) {
      console.warn('handleLoaded', event);
    }
  },
  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_Sites', ['sites']), {
    site: function site() {
      var _this = this;

      return this.sites.find(function (s) {
        return s.LIC_ID === _this.datasVisiteur.siteID;
      });
    },
    url: function url() {
      var url = this.site ? this.site.DSK_EXTENSION_URL : '';
      var regex = /(?:{{(\w+)}})+/g;
      var m = void 0;
      var urlWithParams = url;
      while ((m = regex.exec(url)) !== null) {
        if (m.index === regex.lastIndex) {
          regex.lastIndex++;
        }

        urlWithParams = urlWithParams.replace(m[0], this.datasVisiteur[m[1]]);
      }
      return urlWithParams;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-032ad69e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzIframeExtension.vue
var WzIframeExtension_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{attrs:{"id":"iframeExtension","src":_vm.url,"frameborder":"0"},on:{"error":_vm.handleError,"load":_vm.handleLoaded}})}
var WzIframeExtension_staticRenderFns = []
var WzIframeExtension_esExports = { render: WzIframeExtension_render, staticRenderFns: WzIframeExtension_staticRenderFns }
/* harmony default export */ var watcheebox_WzIframeExtension = (WzIframeExtension_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzIframeExtension.vue
function WzIframeExtension_injectStyle (ssrContext) {
  __webpack_require__("qLqO")
}
var WzIframeExtension_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzIframeExtension___vue_template_functional__ = false
/* styles */
var WzIframeExtension___vue_styles__ = WzIframeExtension_injectStyle
/* scopeId */
var WzIframeExtension___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzIframeExtension___vue_module_identifier__ = null
var WzIframeExtension_Component = WzIframeExtension_normalizeComponent(
  WzIframeExtension,
  watcheebox_WzIframeExtension,
  WzIframeExtension___vue_template_functional__,
  WzIframeExtension___vue_styles__,
  WzIframeExtension___vue_scopeId__,
  WzIframeExtension___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzIframeExtension = (WzIframeExtension_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzContentInfosVisiteur.vue
















/* harmony default export */ var WzContentInfosVisiteur = ({
  components: {
    WzCobrowsingClient: components_watcheebox_WzCobrowsingClient,
    WzFicheInfosVisiteur: components_watcheebox_WzFicheInfosVisiteur,
    WzFicheBiblioPhrases: components_watcheebox_WzFicheBiblioPhrases,
    WzFicheLeadVisiteur: components_watcheebox_WzFicheLeadVisiteur,
    WzHistoChats: components_watcheezy_WzHistoChats,
    WzHistoBot: components_watcheezy_WzHistoBot
  },
  data: function data() {
    return {
      hauteurDiv: 0,
      dialogDemandeCobrowsing: false,
      txtBtCobrowsing: this.$t('cancel'),
      txtDemandeCobrowsing: '',

      cobrowsing: null,

      tab: { href: '' }
    };
  },


  props: ['datasVisiteur', 'datasPupitreVisiteur', 'placesPupitre'],

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('_Notifier', ['NEW_NOTIF']), Object(vuex_esm["d" /* mapMutations */])('_StoreWatcheeBox', ['SET_STATUS_COBROWSING', 'SET_VISITEURS']), {
    annuleCobrowsing: function annuleCobrowsing() {
      console.log('-> annuleCobrowsing');
      this.dialogDemandeCobrowsing = false;
      this.SET_STATUS_COBROWSING({
        placePupitre: this.datasVisiteur.placePupitre,
        status: false
      });
      var agentSocketID = this.WATCHEEBOX_STATE.mySocketID;

      this.cobrowsing = new watcheebox_cobrowsing();
      if (this.cobrowsing) {
        this.cobrowsing.demandeCobrowsing({
          active: false,
          agentSocketID: agentSocketID,
          datasAgent: this.user,
          datasVisiteur: this.datasVisiteur
        });
      }
    },
    checkCobrowsingAutorisation: function checkCobrowsingAutorisation() {
      console.log('-> check Cobrowsing autorisation');
      if (!this.datasVisiteur.reponseCobrowsing) {
        this.sendDemandeCobrowsing();
      }
    },
    sendDemandeCobrowsing: function sendDemandeCobrowsing() {
      console.log('-> sendDemandeCobrowsing');
      this.dialogDemandeCobrowsing = true;
      this.txtBtCobrowsing = this.$t('cancel');

      this.txtDemandeCobrowsing = this.$t('contentAskCobrowsing');
      var agentSocketID = this.WATCHEEBOX_STATE.mySocketID;
      this.SET_STATUS_COBROWSING({
        placePupitre: this.datasVisiteur.placePupitre,
        status: false
      });

      this.cobrowsing = new watcheebox_cobrowsing();
      this.cobrowsing.demandeCobrowsing({
        active: true,
        agentSocketID: agentSocketID,
        datasAgent: this.user,
        datasVisiteur: this.datasVisiteur,
        placePupitre: this.datasVisiteur.placePupitre
      });
    },
    onResize: function onResize() {
      this.hauteurDiv = this.$el.offsetHeight - 100;
    },
    checkTab: function checkTab(item) {
      if (item.disabled.status) {
        this.NEW_NOTIF({
          message: this.$t(item.disabled.raison),
          context: 'error'
        });
      }
    },
    selectTab: function selectTab() {
      var _this = this;

      var tab = this.itemsMenu.find(function (t) {
        return t.href === _this.datasVisiteur.menuSelected;
      });
      if (tab && tab.href !== 'banish') {
        if (tab.href === 'transfertChat') {
          if (this.transfertStatusEmission.status === 'wait') {
            this.tab = tab;
          } else {
            this.tab = this.itemsMenu[0];
          }
        } else {
          this.tab = tab;
        }
      } else {
        this.tab = this.itemsMenu[0];
      }
    }
  }),

  watch: {
    'datasVisiteur.reponseCobrowsing': function datasVisiteurReponseCobrowsing(val, oldVal) {
      console.log('checkReponseCobrowsing', val);
      if (val) {
        this.dialogDemandeCobrowsing = false;
      } else {
        this.txtDemandeCobrowsing = this.$t('visitorNoCobrowsing');
        this.txtBtCobrowsing = this.$t('close');
      }
    },

    'transfertStatusEmission.status': function transfertStatusEmissionStatus(val, oldVal) {
      if (val === 'wait' && this.transfertStatusEmission.datas.chatSession === this.datasVisiteur.visiteurID) {
        this.tab.href = 'transfertChat';
      }
    },

    placesPupitre: function placesPupitre() {
      this.onResize();
    },


    'tab.href': function tabHref(newVal, oldVal) {
      var tab = this.itemsMenu.find(function (t) {
        return t.href === newVal;
      });
      if (!tab) {
        return;
      }
      if (!tab.scroll) {
        var ref = this.$refs['tab-item-' + tab.href][0];
        this.$vuebar.destroyScrollbar(ref.$el);
      }
      var visiteur = lodash_default.a.cloneDeep(this.datasVisiteur);

      var statusCobrowsing = false;
      if (tab.href === 'mirroring' || tab.href === 'cobrowsing') {
        statusCobrowsing = true;
      }
      if (tab.href === 'cobrowsing') {
        this.checkCobrowsingAutorisation();
      } else {
        visiteur.reponseCobrowsing = false;
      }
      this.SET_STATUS_COBROWSING({
        placePupitre: this.datasVisiteur.placePupitre,
        status: statusCobrowsing
      });
      visiteur.menuSelected = newVal;
      this.SET_VISITEURS(visiteur);
    },

    'datasVisiteur.visiteurID': function datasVisiteurVisiteurID(newVal, oldval) {
      this.selectTab();
    }
  },

  mounted: function mounted() {
    this.onResize();
  },
  created: function created() {
    this.selectTab();
    if (this.transfertStatusEmission.status === 'wait' && this.transfertStatusEmission.datas.chatSession === this.datasVisiteur.visiteurID) {
      this.tab.href = 'transfertChat';
    }
  },


  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['listeAllVisiteurs', 'lastMessage', 'transfertStatusEmission', 'mySocketID', 'demandeCobrowsing', 'focusPupitre', 'agentsArray']), Object(vuex_esm["c" /* mapGetters */])('_StoreWatcheeBox', ['WATCHEEBOX_STATE']), Object(vuex_esm["e" /* mapState */])('_Sites', ['sites']), Object(vuex_esm["e" /* mapState */])('_User', ['entLevel']), Object(vuex_esm["c" /* mapGetters */])('_Sites', ['GET_SITE_BY_ID']), Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'level']), {
    check: function check() {
      var site = this.GET_SITE_BY_ID(this.datasVisiteur.siteID);

      if (!site) {
        return { status: true, raison: 'error' };
      }
      var checked = {
        status: false,
        raison: ''
      };

      if (this.datasVisiteur.network && this.datasVisiteur.network !== undefined) {
        checked = { status: true, raison: 'networkVisitor' };
      } else if (!this.datasVisiteur.socketID) {
        checked = { status: true, raison: 'visitorNoSocket' };
      } else {
        if (this.datasPupitreVisiteur.visiteurDatas) {
          if (this.datasPupitreVisiteur.visiteurDatas.pagesFocus && this.datasPupitreVisiteur.visiteurDatas.pagesFocus.indexOf('http://') === 1) {
            checked = { status: true, raison: 'notHttps' };
          } else {
            checked = { status: false };
          }
        } else {
          checked = { status: true, raison: 'noDataVisiteur' };
        }
      }

      return extends_default()({ site: site }, checked);
    },
    checkReponseCobrowsing: function checkReponseCobrowsing() {},
    checkMirroring: function checkMirroring() {
      var checked = this.check;

      if (checked.site.DSK_MIRRORING === '0') {
        checked = { status: true, raison: 'warningMirroringSettingDisabled' };
      }
      return checked;
    },
    checkCobrowsing: function checkCobrowsing() {
      var checked = this.check;

      if (checked.site.DSK_COBROWSING === '0') {
        checked = { status: true, raison: 'warningMirroringSettingDisabled' };
      }
      return checked;
    },
    checkTransfert: function checkTransfert() {
      var checked = this.check;
      if (this.entLevel === '10' || this.entLevel === '1') {
        checked = { status: true, raison: this.$tc('notLevelRights', this.level.title, { count: this.level.title }) };
      }
      return checked;
    },
    checkIframeExtension: function checkIframeExtension() {
      if (this.level.rights !== LEVEL.ENTREPRISE) {
        return { status: true, raison: this.$tc('notLevelRights', this.level.title, { count: this.level.title }) };
      }
      var site = this.GET_SITE_BY_ID(this.datasVisiteur.siteID);
      if (!site || site.DSK_EXTENSION_ONOFF !== '1') {
        return { status: true, raison: 'error' };
      }
      return false;
    },
    itemsMenu: function itemsMenu() {
      var menus = [];

      var defaultContext = !this.monitoringRoute && !this.fromAnotherNetwork;
      var visitorCard = {
        title: this.$t('visitorCard'),
        href: 'visitorCard',
        component: components_watcheebox_WzFicheInfosVisiteur,
        icone: 'account_box',
        disabled: false,
        show: true,
        scroll: true
      };
      var conversationHistory = {
        title: this.$t('conversationHistory'),
        href: 'conversationHistory',
        component: components_watcheezy_WzHistoChats,
        icone: 'forum',
        disabled: false,
        show: true,
        scroll: true
      };
      var botHistory = {
        title: this.$t('botHistory'),
        href: 'botHistory',
        component: components_watcheezy_WzHistoBot,
        icone: 'adb',
        disabled: false,
        show: true,
        scroll: true
      };
      var mirroring = !this.fromAnotherNetwork && {
        title: 'Mirroring',
        href: 'mirroring',
        component: components_watcheebox_WzCobrowsingClient,
        icone: 'phonelink',
        disabled: this.checkMirroring,
        show: this.$socket && this.$socket.connected,
        scroll: false
      };
      var visitorEditing = defaultContext && {
        title: this.$t('visitorEditing'),
        href: 'visitorEditing',
        component: components_watcheebox_WzFicheLeadVisiteur,
        icone: 'create',
        disabled: false,
        show: true,
        scroll: true
      };
      var quickSentences = !this.monitoringRoute && {
        title: this.$t('quickSentences'),
        href: 'quickSentences',
        component: components_watcheebox_WzFicheBiblioPhrases,
        icone: 'collections_bookmark',
        disabled: false,
        show: true,
        scroll: true
      };
      var cobrowsing = defaultContext && {
        title: 'Cobrowsing',
        href: 'cobrowsing',
        component: components_watcheebox_WzCobrowsingClient,
        icone: 'open_in_browser',
        disabled: this.checkCobrowsing,
        show: this.$socket && this.$socket.connected && !this.dialogDemandeCobrowsing,
        scroll: false
      };
      var transfertChat = defaultContext && {
        title: lodash_default.a.upperFirst(this.$t('toTransfer')),
        href: 'transfertChat',
        component: components_watcheebox_WzDialogTransfertChat,
        icone: 'transfer_within_a_station',
        disabled: this.checkTransfert,
        show: this.$socket && this.$socket.connected,
        scroll: true
      };
      var banish = defaultContext && {
        title: lodash_default.a.upperFirst(this.$t('banish')),
        href: 'banish',
        component: components_watcheebox_WzDialogBannishVisitor,
        icone: 'block',
        disabled: false,
        show: true,
        scroll: true
      };
      var iframeExtension = defaultContext && {
        title: lodash_default.a.upperFirst(this.$t('extension')),
        href: 'extension',
        component: components_watcheebox_WzIframeExtension,
        icone: 'extension',
        disabled: this.checkIframeExtension,
        show: true,
        scroll: false
      };

      visitorCard && menus.push(visitorCard);
      conversationHistory && menus.push(conversationHistory);
      botHistory && menus.push(botHistory);
      mirroring && menus.push(mirroring);
      visitorEditing && menus.splice(1, 0, visitorEditing);
      quickSentences && menus.splice(2, 0, quickSentences);
      cobrowsing && menus.push(cobrowsing);
      transfertChat && menus.push(transfertChat);
      banish && menus.push(banish);
      iframeExtension && menus.push(iframeExtension);
      return menus;
    },
    focused: function focused() {
      return this.focusPupitre.focusSessionID === this.datasVisiteur.visiteurID;
    },
    fromAnotherNetwork: function fromAnotherNetwork() {
      return this.datasVisiteur.network && this.datasVisiteur.network.trim().length;
    },
    monitoringRoute: function monitoringRoute() {
      return this.$route.fullPath === '/trafic/monitoring';
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0527cdd0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzContentInfosVisiteur.vue
var WzContentInfosVisiteur_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],staticClass:"fill-height"},[_c('v-tabs',{staticClass:"fill-height",attrs:{"hide-slider":"","grow":"","show-arrows":"","color":_vm.focused ? 'accent' : '',"dark":_vm.focused},model:{value:(_vm.tab.href),callback:function ($$v) {_vm.$set(_vm.tab, "href", $$v)},expression:"tab.href"}},[_vm._l((_vm.itemsMenu),function(item){return _c('v-tab',{key:item.href,attrs:{"href":'#' + item.href,"disabled":item.disabled.status,"title":item.title},nativeOn:{"click":function($event){_vm.checkTab(item)}}},[_c('v-icon',{attrs:{"size":"24","color":_vm.tab.href === item.href
            ? 'secondary'
            : item.disabled.status
              ? 'grey'
              : _vm.focused
                ? 'white'
                : 'grey darken-2'}},[_vm._v(_vm._s(item.icone))])],1)}),_vm._v(" "),_vm._l((_vm.itemsMenu),function(item){return _c('v-tab-item',{directives:[{name:"bar",rawName:"v-bar"}],key:item.href,ref:("tab-item-" + (item.href)),refInFor:true,staticClass:"fill-height",attrs:{"value":item.href}},[_c('v-card',{staticClass:"contentFicheVisiteur",class:{'cobrowsing--container': item.href == 'mirroring' || item.href == 'cobrowsing'},attrs:{"flat":"","height":"100%","width":"calc(100% - 20px)"}},[(_vm.tab.href === item.href && item.show)?_c(item.component,{tag:"component",staticClass:"fill-height tab-item__component",attrs:{"datasVisiteur":_vm.datasVisiteur,"datasPupitreVisiteur":_vm.datasPupitreVisiteur,"params":'visId=' + _vm.datasVisiteur.visiteurID,"toolbar":true,"navigation":true,"chatHeight":"100%","numChatsTotal":"0","type":"chatting","colorChatAgent":"grey lighten-1","colorChatVisiteur":"grey","hauteurDiv":_vm.hauteurDiv,"openOnMounted":""},on:{"update:hauteurDiv":function($event){_vm.hauteurDiv=$event},"closeCobrowsing":function($event){_vm.annuleCobrowsing(); _vm.tab = _vm.itemsMenu[0]},"closeDialog":function($event){_vm.tab = _vm.itemsMenu[0]},"put":function (msg) { return _vm.$emit('update:msg', msg); },"send":function (msg) { return _vm.$emit('sendMsg', msg); }}}):_vm._e()],1)],1)})],2),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialogDemandeCobrowsing),callback:function ($$v) {_vm.dialogDemandeCobrowsing=$$v},expression:"dialogDemandeCobrowsing"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('titleAskCobrowsing')))]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          "+_vm._s(_vm.txtDemandeCobrowsing)+"\n        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.annuleCobrowsing(); _vm.tab = _vm.itemsMenu[0]}}},[_vm._v(_vm._s(_vm.txtBtCobrowsing)+"\n          ")])],1)],1)],1)],1)}
var WzContentInfosVisiteur_staticRenderFns = []
var WzContentInfosVisiteur_esExports = { render: WzContentInfosVisiteur_render, staticRenderFns: WzContentInfosVisiteur_staticRenderFns }
/* harmony default export */ var watcheebox_WzContentInfosVisiteur = (WzContentInfosVisiteur_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzContentInfosVisiteur.vue
var WzContentInfosVisiteur_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzContentInfosVisiteur___vue_template_functional__ = false
/* styles */
var WzContentInfosVisiteur___vue_styles__ = null
/* scopeId */
var WzContentInfosVisiteur___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzContentInfosVisiteur___vue_module_identifier__ = null
var WzContentInfosVisiteur_Component = WzContentInfosVisiteur_normalizeComponent(
  WzContentInfosVisiteur,
  watcheebox_WzContentInfosVisiteur,
  WzContentInfosVisiteur___vue_template_functional__,
  WzContentInfosVisiteur___vue_styles__,
  WzContentInfosVisiteur___vue_scopeId__,
  WzContentInfosVisiteur___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzContentInfosVisiteur = (WzContentInfosVisiteur_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzListChatsAgent.vue





/* harmony default export */ var WzListChatsAgent = ({
  data: function data() {
    return {
      loading: false,
      chatSelected: null
    };
  },


  props: ['dataAgent'],

  methods: {
    update: function update(item) {
      this.$emit('chatSessionSelected', item[0]);
      this.chatSelected = item[0];
    }
  },

  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['listeChatAgent', 'listeAllVisiteurs']), {
    sessionsChatAgent: function sessionsChatAgent() {
      var _this = this;

      var arrayChatSession = lodash_default.a.cloneDeep(lodash_default.a.filter(this.listeChatAgent, [3, this.dataAgent.id]));
      lodash_default.a.forEach(arrayChatSession, function (chatSession, key) {
        var index = lodash_default.a.findIndex(_this.listeAllVisiteurs, { 'visiteurID': chatSession[0] });
        if (index === -1) {
          arrayChatSession[key].push('offline notInList');
        } else {
          if (_this.listeAllVisiteurs[index].socketID) {
            arrayChatSession[key].push('online');
          } else {
            arrayChatSession[key].push('offline');
          }
        }
      });
      return arrayChatSession;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e51df86c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzListChatsAgent.vue
var WzListChatsAgent_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.sessionsChatAgent)?_c('v-card',{staticClass:"listeAllChatsAgent"},[_c('v-toolbar',{staticClass:"accent",attrs:{"dark":"","dense":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('listOfDiscussions')))])],1),_vm._v(" "),(_vm.loading)?_c('div',{staticClass:"text-xs-center"},[_c('v-progress-circular',{staticClass:"primary--text",attrs:{"indeterminate":"","size":100,"width":1}})],1):_vm._e(),_vm._v(" "),_c('div',{directives:[{name:"bar",rawName:"v-bar"}],staticClass:"ContentListChats"},[_c('v-list',{staticClass:"listeChatsAgents"},[_vm._l((_vm.sessionsChatAgent),function(item,i){return [_c('v-list-tile',{key:i,class:{ 'grey lighten-5': _vm.chatSelected == item[0] },attrs:{"ripple":""}},[_c('div',{staticClass:"statusVisiteur",class:item[5]}),_vm._v(" "),_c('v-list-tile-content',[_c('v-list-tile-title',{domProps:{"innerHTML":_vm._s(_vm.$tc('visitors', 1, {count: ''}) + ' ' + item[0])},on:{"click":function($event){_vm.update(item)}}})],1)],1)]})],2)],1)],1):_vm._e()}
var WzListChatsAgent_staticRenderFns = []
var WzListChatsAgent_esExports = { render: WzListChatsAgent_render, staticRenderFns: WzListChatsAgent_staticRenderFns }
/* harmony default export */ var watcheebox_WzListChatsAgent = (WzListChatsAgent_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzListChatsAgent.vue
function WzListChatsAgent_injectStyle (ssrContext) {
  __webpack_require__("U18A")
}
var WzListChatsAgent_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzListChatsAgent___vue_template_functional__ = false
/* styles */
var WzListChatsAgent___vue_styles__ = WzListChatsAgent_injectStyle
/* scopeId */
var WzListChatsAgent___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzListChatsAgent___vue_module_identifier__ = null
var WzListChatsAgent_Component = WzListChatsAgent_normalizeComponent(
  WzListChatsAgent,
  watcheebox_WzListChatsAgent,
  WzListChatsAgent___vue_template_functional__,
  WzListChatsAgent___vue_styles__,
  WzListChatsAgent___vue_scopeId__,
  WzListChatsAgent___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzListChatsAgent = (WzListChatsAgent_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzDialogCloseChat.vue





/* harmony default export */ var WzDialogCloseChat = ({
  data: function data() {
    return {
      checkForMotif: false,
      formulaireSatisfaction: false,
      clotureChat: false
    };
  },


  props: ['datasVisiteur', 'dialogCloseChat'],

  methods: extends_default()({}, Object(vuex_esm["b" /* mapActions */])('_StoreWatcheeBox', ['ACTION_CLOSE_CHAT']), {
    fermeDialog: function fermeDialog() {
      this.$emit('fermeDialogCloseChat', {
        dialogCloseChat: false
      });
    },
    fermeChat: function fermeChat() {
      console.log('path : ', this.formulaireSatisfaction);

      if (this.$route.fullPath === '/trafic/attente') {
        this.formulaireSatisfaction = false;
      }
      this.ACTION_CLOSE_CHAT({
        formulaireSatisfaction: this.formulaireSatisfaction,
        datasVisiteur: this.datasVisiteur,
        clotureChat: this.clotureChat,
        fullPath: this.$route.fullPath
      });
      this.fermeDialog();
    },
    settingsFromCookies: function settingsFromCookies() {
      this.formulaireSatisfaction = this.$cookie.get('wz-satisfaction-survey') === 'true' || false;
      this.clotureChat = this.$cookie.get('wz-closing-chat') === 'true' || false;
    }
  }),

  watch: {
    datasVisiteur: function datasVisiteur(val, oldval) {
      if (!val) {
        this.dataWatchVisteur = oldval;
      } else {
        this.dataWatchVisteur = val;
      }
    },

    formulaireSatisfaction: function formulaireSatisfaction(v) {
      this.$cookie.set('wz-satisfaction-survey', v, { expires: '1Y' });
    },
    clotureChat: function clotureChat(v) {
      this.$cookie.set('wz-closing-chat', v, { expires: '1Y' });
    }
  },

  mounted: function mounted() {
    this.dataWatchVisteur = this.datasVisiteur;
    if (this.dataWatchVisteur.network === 'facebook') {
      this.visitorLeft = 'no';
    }

    if (this.$store.state._User.entKey === '9c44184c124fda32ac19523ff93d2488') {
      this.checkForMotif = true;
    }

    this.settingsFromCookies();
    this.id_conversation = 'conversation_' + this.datasVisiteur.visiteurID;
  },
  beforeDestroy: function beforeDestroy() {},


  computed: extends_default()({}, Object(vuex_esm["e" /* mapState */])('_StoreWatcheeBox', ['listeAllVisiteurs', 'sessionsPrivees']), Object(vuex_esm["e" /* mapState */])('_User', ['entLevel']), Object(vuex_esm["c" /* mapGetters */])('_User', ['user', 'fullName']), Object(vuex_esm["c" /* mapGetters */])('_StoreWatcheeBox', ['WATCHEEBOX_STATE']), {
    hasMotif: function hasMotif() {
      return true;
    },
    checkSatisfaction: function checkSatisfaction() {
      var inactif = false;
      if (this.entLevel === '10' || this.entLevel === '1') {
        inactif = true;
      }
      return inactif;
    }
  })
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6d211dfa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzDialogCloseChat.vue
var WzDialogCloseChat_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[(_vm.checkForMotif && !_vm.hasMotif)?_c('v-dialog',{attrs:{"persistent":"","max-width":"320"},model:{value:(_vm.dialogCloseChat),callback:function ($$v) {_vm.dialogCloseChat=$$v},expression:"dialogCloseChat"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('closeChatTitle')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('tagBeforeClose')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.fermeDialog()}}},[_vm._v(_vm._s(_vm.$t('cancel')))])],1)],1)],1):_c('v-dialog',{attrs:{"persistent":"","max-width":"500"},model:{value:(_vm.dialogCloseChat),callback:function ($$v) {_vm.dialogCloseChat=$$v},expression:"dialogCloseChat"}},[_c('v-card',[_c('v-card-title',{staticClass:"primary white--text subheading"},[_vm._v(_vm._s(_vm.$t('closeChatTitle')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('beforeCloseOptions')))]),_vm._v(" "),(_vm.$route.fullPath !== '/trafic/attente')?_c('v-card-text',[_c('v-switch',{attrs:{"disabled":_vm.checkSatisfaction,"label":_vm.$t('sendSatisfactionSurvey'),"hide-details":""},model:{value:(_vm.formulaireSatisfaction),callback:function ($$v) {_vm.formulaireSatisfaction=$$v},expression:"formulaireSatisfaction"}})],1):_vm._e(),_vm._v(" "),_c('v-card-text',[_c('v-switch',{attrs:{"label":_vm.$t('closeThisChat'),"hint":_vm.$t('closeThisChatHint'),"persistent-hint":""},model:{value:(_vm.clotureChat),callback:function ($$v) {_vm.clotureChat=$$v},expression:"clotureChat"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.fermeDialog()}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.fermeChat()}}},[_vm._v(_vm._s(_vm.$t('close')))])],1)],1)],1)],1)}
var WzDialogCloseChat_staticRenderFns = []
var WzDialogCloseChat_esExports = { render: WzDialogCloseChat_render, staticRenderFns: WzDialogCloseChat_staticRenderFns }
/* harmony default export */ var watcheebox_WzDialogCloseChat = (WzDialogCloseChat_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzDialogCloseChat.vue
var WzDialogCloseChat_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzDialogCloseChat___vue_template_functional__ = false
/* styles */
var WzDialogCloseChat___vue_styles__ = null
/* scopeId */
var WzDialogCloseChat___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzDialogCloseChat___vue_module_identifier__ = null
var WzDialogCloseChat_Component = WzDialogCloseChat_normalizeComponent(
  WzDialogCloseChat,
  watcheebox_WzDialogCloseChat,
  WzDialogCloseChat___vue_template_functional__,
  WzDialogCloseChat___vue_styles__,
  WzDialogCloseChat___vue_scopeId__,
  WzDialogCloseChat___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzDialogCloseChat = (WzDialogCloseChat_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzDialogInfos.vue


/* harmony default export */ var WzDialogInfos = ({
  data: function data() {
    return {
      infosDialog: false
    };
  },

  props: ['openDialogInfos', 'titleDialog', 'contentDialog'],
  created: function created() {},


  methods: {
    openDialog: function openDialog() {
      this.infosDialog = true;
    },
    fermeDialog: function fermeDialog() {
      this.infosDialog = false;
      this.$emit('fermeDialog');
    }
  },

  computed: {},

  watch: {
    titleDialog: function titleDialog(v) {
      console.log('v', v);
      if (v) {
        this.openDialog();
      }
    }
  }
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-952f280a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzDialogInfos.vue
var WzDialogInfos_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"max-width":"320"},model:{value:(_vm.infosDialog),callback:function ($$v) {_vm.infosDialog=$$v},expression:"infosDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.titleDialog))]),_vm._v(" "),_c('v-card-text',[_vm._v("\n          "+_vm._s(_vm.contentDialog)+"\n        ")]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","flat":"flat"},on:{"click":function($event){_vm.fermeDialog()}}},[_vm._v("\n           "+_vm._s(_vm.$t('close'))+"\n          ")])],1)],1)],1)],1)}
var WzDialogInfos_staticRenderFns = []
var WzDialogInfos_esExports = { render: WzDialogInfos_render, staticRenderFns: WzDialogInfos_staticRenderFns }
/* harmony default export */ var watcheebox_WzDialogInfos = (WzDialogInfos_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzDialogInfos.vue
var WzDialogInfos_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzDialogInfos___vue_template_functional__ = false
/* styles */
var WzDialogInfos___vue_styles__ = null
/* scopeId */
var WzDialogInfos___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzDialogInfos___vue_module_identifier__ = null
var WzDialogInfos_Component = WzDialogInfos_normalizeComponent(
  WzDialogInfos,
  watcheebox_WzDialogInfos,
  WzDialogInfos___vue_template_functional__,
  WzDialogInfos___vue_styles__,
  WzDialogInfos___vue_scopeId__,
  WzDialogInfos___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzDialogInfos = (WzDialogInfos_Component.exports);

// CONCATENATED MODULE: ./node_modules/babel-loader/lib!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/watcheebox/WzDialogProgress.vue


/* harmony default export */ var WzDialogProgress = ({
  data: function data() {
    return {
      steps: 15
    };
  },

  props: ['openDialogProgress', 'dialogProgress', 'etape'],
  created: function created() {},


  methods: {
    nextTuto: function nextTuto() {
      console.log('this.step', this.step);

      if (this.step === 1) {
        this.$router.push({ path: '/settings/absence' });
      } else if (this.step === 2) {
        this.$router.push({ path: '/settings/chat' });
      } else if (this.step === 3) {
        this.$router.push({ path: '/settings/bot' });
      } else if (this.step === 4) {
        this.$router.push({ path: '/settings/callback' });
      } else if (this.step === 5) {
        this.$router.push({ path: '/settings/recall' });
      } else if (this.step === 6) {
        this.$router.push({ path: '/settings/sms' });
      } else if (this.step === 7) {
        this.$router.push({ path: '/settings/ecomm' });
      } else if (this.step === 8) {
        this.$router.push({ path: '/settings/connectors' });
      } else if (this.step === 9) {
        this.$router.push({ path: '/settings/bluepush' });
      } else if (this.step === 10) {
        this.$router.push({ path: '/management/agents' });
      } else if (this.step === 11) {
        this.$router.push({ path: '/account' });
      } else if (this.step === 12) {
        this.$router.push({ path: '/profile' });
      } else if (this.step === 13) {
        this.$router.push({ path: '/target/filters' });
      } else if (this.step === 14) {
        this.$router.push({ path: '/media/biblios' });
      } else if (this.step === 15) {
        this.$router.push({ path: '/stats/audience' });
      }
    },
    previousTuto: function previousTuto() {
      if (this.step === 2) {
        this.$router.push({ path: '/settings/preview' });
      } else if (this.step === 3) {
        this.$router.push({ path: '/settings/absence' });
      } else if (this.step === 4) {
        this.$router.push({ path: '/settings/chat' });
      } else if (this.step === 5) {
        this.$router.push({ path: '/settings/bot' });
      } else if (this.step === 6) {
        this.$router.push({ path: '/settings/callback' });
      } else if (this.step === 7) {
        this.$router.push({ path: '/settings/recall' });
      } else if (this.step === 8) {
        this.$router.push({ path: '/settings/sms' });
      } else if (this.step === 9) {
        this.$router.push({ path: '/settings/ecomm' });
      } else if (this.step === 10) {
        this.$router.push({ path: '/settings/connectors' });
      } else if (this.step === 11) {
        this.$router.push({ path: '/settings/bluepush' });
      } else if (this.step === 12) {
        this.$router.push({ path: '/management/agents' });
      } else if (this.step === 13) {
        this.$router.push({ path: '/account' });
      } else if (this.step === 14) {
        this.$router.push({ path: '/profile' });
      } else if (this.step === 15) {
        this.$router.push({ path: '/target/filters' });
      } else if (this.step === 16) {
        this.$router.push({ path: '/media/biblios' });
      }
    },
    selectTuto: function selectTuto(num) {
      if (num === 1) {
        this.$router.push({ path: '/settings/preview' });
      } else if (num === 2) {
        this.$router.push({ path: '/settings/absence' });
      } else if (num === 3) {
        this.$router.push({ path: '/settings/chat' });
      } else if (num === 4) {
        this.$router.push({ path: '/settings/bot' });
      } else if (num === 5) {
        this.$router.push({ path: '/settings/callback' });
      } else if (num === 6) {
        this.$router.push({ path: '/settings/recall' });
      } else if (num === 7) {
        this.$router.push({ path: '/settings/sms' });
      } else if (num === 8) {
        this.$router.push({ path: '/settings/ecomm' });
      } else if (num === 9) {
        this.$router.push({ path: '/settings/connectors' });
      } else if (num === 10) {
        this.$router.push({ path: '/settings/bluepush' });
      } else if (num === 11) {
        this.$router.push({ path: '/management/agents' });
      } else if (num === 12) {
        this.$router.push({ path: '/account' });
      } else if (num === 13) {
        this.$router.push({ path: '/profile' });
      } else if (num === 14) {
        this.$router.push({ path: '/target/filters' });
      } else if (num === 15) {
        this.$router.push({ path: '/media/biblios' });
      }
    },
    quitTuto: function quitTuto() {
      this.$emit('fermeDialogProgress');
      this.$store.commit('_User/ONGOING_TUTO', {
        ongoingTuto: false
      });
      this.$store.commit('_User/QUIT_TUTO', {
        tutoQuited: true
      });
    }
  },

  computed: {
    step: function step() {
      return this.etape;
    },
    progress: function progress() {
      return this.etape * 10;
    },
    titleDialog: function titleDialog() {
      if (this.step === 1) {
        return 'Paramètres du "widget"';
      } else if (this.step === 2) {
        return 'Paramètres du mode "hors ligne"';
      } else if (this.step === 3) {
        return 'Paramètres du mode "en ligne"';
      } else if (this.step === 4) {
        return 'Paramètres du "chatbot"';
      } else if (this.step === 5) {
        return 'Paramètres de l\'option "Callback"';
      } else if (this.step === 6) {
        return 'Paramètres de l\'option "Meeting"';
      } else if (this.step === 7) {
        return 'Paramètres de l\'option "SMS"';
      } else if (this.step === 8) {
        return 'Paramètres "E-commerce"';
      } else if (this.step === 9) {
        return 'Paramètres des "Connecteurs"';
      } else if (this.step === 10) {
        return 'Paramètre des "Push Marketing"';
      } else if (this.step === 11) {
        return 'Gestion des sites web et des utilisateurs';
      } else if (this.step === 12) {
        return 'Gestion du Compte';
      } else if (this.step === 13) {
        return 'Gestion de votre "Profil"';
      } else if (this.step === 14) {
        return 'Ciblage comportemental';
      } else if (this.step === 15) {
        return 'Bibliothèques de phrases rapides';
      }
    },
    contentDialog: function contentDialog() {
      var contentDialogProgress = '';
      if (this.step === 1) {
        contentDialogProgress = '<br>Le "widget", aussi appelé pop-up ou chatbox, est la petite fenêtre présente en bas de la page de votre site web, et dans laquelle on va afficher le chat ou le chatbot.';
        contentDialogProgress += '<p>Dans cette section vous allez personnaliser l\'aspect graphique du widget : <br><ul><li>couleur</li><li>position</li><li>dimensions</li><li>règles d\'affichage, pour lui dire où et quand s\'afficher</li><li>ect.</li></ul></p>';
        contentDialogProgress += '<p>Aux restrictions par horaires et/ou URLs, peut s\'ajouter la condition de la présence d\'un agent en ligne.</p>';
        contentDialogProgress += '<br><br>Pour valider les réglages du widget, cliquez sur "SAUVEGARDER" en bas à droite.';
      } else if (this.step === 2) {
        contentDialogProgress = '<br>Le mode "hors ligne" du widget signifie qu\'il n\'y a pas d\'agent disponible.';
        contentDialogProgress += '<p>Ici vous allez paramétrer ce que vous présentez aux internautes dans cette situation.<br>Vous avez le choix entre :<br><ul><li>le mode messaging (bientôt disponible)</li> <li>l\'affichage d\'un formulaire en absence.</li></ul></p>';
        contentDialogProgress += '<p>Les formulaires ainsi envoyés arriveront par e-mail au responsable du compte (paramétré dans la partie "gestion du compte").</p>';
        contentDialogProgress += '<br><br>Pour valider les réglages du mode hors-ligne, cliquez sur "SAUVEGARDER" en bas à droite.';
      } else if (this.step === 3) {
        contentDialogProgress = '<br>Le mode "en ligne" du widget signifie qu\'il y a au moins un agent connecté et en ligne pour répondre aux internautes par chat.';
        contentDialogProgress += '<p>Ici vous allez donc personnaliser le comportement du widget en mode chat.<br>Vous pouvez : <br><ul><li>envoyer une invitation à chatter automatique</li><li>imposer un formulaire d\'identification pre-chat</li><li>activer les fonctions de screen sharing (si vous avez souscrit à l\'option)</li><li>etc.</li></p>';
        contentDialogProgress += '<br><br>Pour valider le mode en-ligne, cliquez sur "SAUVEGARDER" en bas à droite.';
      } else if (this.step === 4) {
        contentDialogProgress = '<br>Le "Chatbot" est l\'agent conversationnel qui va prendre en charge vos internautes depuis le "widget".';
        contentDialogProgress += '<br>Si vous n\'avez pas souscrit à cette option, vous pouvez passer à l\'étape suivante. ';
        contentDialogProgress += '<br><br>Vous pouvez ici choisir de restreindre l\'activation du chatbot à des pages ou des horaires spécifiques. En dehors de ces restrictions, ce sont les autres canaux par défaut qui prendront le relais (chat/messaging/formulaire).';
        contentDialogProgress += '<br><br>Si vous disposez de plusieurs chatbots, vous pouvez choisir lequel appliquer à votre site dans le sélecteur en bas à gauche.';
        contentDialogProgress += '<br>Pour valider le chatbot, cliquez sur "SAUVEGARDER" en bas à droite.';
      } else if (this.step === 5) {
        contentDialogProgress = '<br>La callback, aussi appelé "Click-to-call", est une option qui propose des rappels téléphoniques gratuits immédiats.';
        contentDialogProgress += '<br>Si vous n\'avez pas souscrit à cette option, vous pouvez passer à l\'étape suivante.';
        contentDialogProgress += '<br><br>Activez/désactivez ici la fonctionnalité, paramétrez où et quand afficher la tirette ainsi que les messages à afficher dans la fenêtre de demande de rappel.';
        contentDialogProgress += '<br><br>Pour valider les paramétrages, cliquez sur "SAUVEGARDER" en bas à droite.';
      } else if (this.step === 6) {
        contentDialogProgress = '<br>La fonctionnalité "Meeting" est la prise de rendez-vous en ligne. Elle peut être synchronisée à votre agenda ou simplement notifiée par mail.';
        contentDialogProgress += '<br>Si vous n\'avez pas souscrit à cette option, vous pouvez passer à l\'étape suivante.';
        contentDialogProgress += '<br><br>Activez/désactivez ici la fonctionnalité, paramétrez où et quand afficher la tirette, le calendrier à synchroniser (ou pas) ainsi que les messages à afficher dans la fenêtre de demande de RDV.';
        contentDialogProgress += '<br><br>Pour valider les paramétrages, cliquez sur "SAUVEGARDER" en bas à droite.';
      } else if (this.step === 7) {
        contentDialogProgress = '<br>La fonctionnalité "SMS" permet de vous notifier par SMS les moments clés de la relation client.';
        contentDialogProgress += '<br>Si vous n\'avez pas souscrit à cette option, vous pouvez passer à l\'étape suivante.';
        contentDialogProgress += '<br><br>Vous pouvez choisir ici de recevoir des SMS pour chaque nouvelle conversation, l\'envoi de messages en absence (hors-ligne) ou les demandes de rappel téléphonique (Callback).';
        contentDialogProgress += '<br><br>Pour valider les paramétrages, cliquez sur "SAUVEGARDER" en bas à droite.';
      } else if (this.step === 8) {
        contentDialogProgress = '<br>Cette section est préparatoire à la section "Ciblage comportemental", si vous souhaitez utiliser le jeu de règles "e-commerce".';
        contentDialogProgress += '<br>Si votre activité n\'est pas axée sur le commerce en ligne (pas de tunnel d\'achat), vous pouvez passer à l\'étape suivante.';
        contentDialogProgress += '<br><br>Ici vous pouvez donc apprendre à Target First comment se compose et se comporte votre tunnel d\'achat. Identifiez chaque page de votre tunnel et reportez les dans les différentes sections.';
        contentDialogProgress += '<br><br>Pour valider les paramétrages, cliquez sur "SAUVEGARDER" en bas à droite.';
      } else if (this.step === 9) {
        contentDialogProgress = '<br>Connectez votre solution Target First aux outils du marchés.';
        contentDialogProgress += '<br><br>Target First propose des canaux de communication inter-plateformes (Slack, Messenger) et d\'outils de relation client (Salesforce, Zendesk).';
        contentDialogProgress += '<br><br>Pour chaque outil, vous pouvez ici paramétrer les connecteurs en renseignant des identifiants "API" des différentes solutions tiers.';
        contentDialogProgress += '<br><br>Pour valider les paramétrages, cliquez sur "SAUVEGARDER" en bas à droite.';
      } else if (this.step === 10) {
        contentDialogProgress = '<br>Cette section permet d\'envoyer des pushs de manière systématique.';
        contentDialogProgress += '<br>Si vous n\'avez pas souscrit à cette option, vous pouvez passer à l\'étape suivante.';
        contentDialogProgress += '<br><br>Les "push-marketing" sont des fenêtres qui s\'affichent de manière automatique sur votre site. Ici vous pouvez paramétrer où et quand envoyer ces pushs. Pour les construire, rendez-vous sur la section "Media" -> "Push Marketing".';
        contentDialogProgress += '<br><br>Pour valider les paramétrages, cliquez sur "SAUVEGARDER" en bas à droite.';
      } else if (this.step === 11) {
        contentDialogProgress = '<br>Personnalisez ici le profil des utilisateurs ainsi que les sites liés à votre licence.';
        contentDialogProgress += '<br><br>Activez/désactivez Target First sur vos sites internet et affectez leur des utilisateurs (téléconseillers).';
        contentDialogProgress += '<br>Définissez également les URLs de vos sites et choisissez un contact (mail) qui recevra les notifications.';
        contentDialogProgress += '<br><br>Pour valider les paramétrages, cliquez sur "SAUVEGARDER" en bas à droite de chaque utilisateur/site concerné.';
      } else if (this.step === 12) {
        contentDialogProgress = '<br>Dans cette section, vous pouvez vérifier les informations relatives à votre compte et vos abonnements.';
        contentDialogProgress += '<br><br>Pour accéder à cette section, cliquez sur votre avatar <img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_user.png"> ici en haut à droite de l\'écran, puis sélectionnez "Gestion du compte".';
        contentDialogProgress += '<br><br>Seul le "référent facturation" peut accéder aux factures ou éditer des offres. Pour accéder à cette partie il doit cliquer sur le bouton "Voir Abonnement".';
      } else if (this.step === 13) {
        contentDialogProgress = '<br>Modifiez ici vos informations personnelles.';
        contentDialogProgress += '<br><br>Pour accéder à cette section, cliquez sur votre avatar <img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_user.png"> en haut à droite de l\'écran, puis re-cliquez dessus.';
        contentDialogProgress += '<br><br>Vous pouvez ici vous attribuez un avatar, personnaliser votre profil ainsi que la fiche visiteur pour lorsque vous chattez.';
      } else if (this.step === 14) {
        contentDialogProgress = '<br>Ciblez et invitez vos internautes.';
        contentDialogProgress += '<br>Si vous n\'avez pas souscrit à cette option, vous pouvez passer à l\'étape suivante.';
        contentDialogProgress += '<br><br>Ici vous définissez les scenarii de ciblage de vos internautes. Chaque ligne correspond à un scénario, lui même décomposé en trois étapes simples : <br><ol><li>description</li><li>déclencheurs</li><li>comportement</li></ol>';
        contentDialogProgress += '<br><br>Paramétrez chaque scénario, assurez-vous d’avoir renseigné les 3 étapes,  puis activez-le. Celui-ci sera fonctionnel quand un conseiller sera connecté et en ligne (et actif sur la section trafic)';
        contentDialogProgress += '<br><br>Prenez du temps pour bien maîtriser cette section, indispensable à la performance de votre Target First.';
      } else if (this.step === 15) {
        contentDialogProgress = '<br>Créez, en quelques clics, des bibliothèques de phrases pré-définies pour le chat.';
        contentDialogProgress += '<br><br>Ces phrases vous seront proposées de manière automatique lorsque vous rédigerez des messages aux visiteurs.';
        contentDialogProgress += '<br><br>Vous pourrez aussi les modifier à la volée pour personnaliser votre échange avec l’internaute.';
        contentDialogProgress += '<br><br>Saisissez les phrases récurrentes (politesse, métier, FAQ) qui seront utilisées lors de vos conversations chat.';
      } else if (this.step === 16) {
        contentDialogProgress = '<br>Félicitations, vous avez fait le tour des paramétrages de votre backoffice.';
        contentDialogProgress += '<br><br>Les icônes en haut à droite du backoffice vous proposent plusieurs aides :<br>';
        contentDialogProgress += '<strong>';
        contentDialogProgress += '<br><img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_boussole.png"> Visite guidée';
        contentDialogProgress += '<br><img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_chatbot.png"> Chatbot d\'aide';
        contentDialogProgress += '<br><img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_bug.png"> Contact support';
        contentDialogProgress += '<br><img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_aide.png"> Centre d\'aide';
        contentDialogProgress += '<br><img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_notif.png"> Centre de notifications';
        contentDialogProgress += '</strong>';
        contentDialogProgress += '<br><br>Vous pouvez à tout moment recommencer cette visite en cliquant sur l\'icône visite guidée <img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_boussole.png"  tout en haut.';
        contentDialogProgress += '<br><br>Si vous avez des questions, notre chatbot <img class="iconesAideTF" src="watcheezy/src/assets/img/tutos/icone_chatbot.png"> propose d\'interagir avec notre site support <a href="https://support.targetfirst.com" target="_blank" >https://support.targetfirst.com</a>';
      }
      return contentDialogProgress;
    }
  },

  watch: {}
});
// CONCATENATED MODULE: ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-768fa8ee","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheebox/WzDialogProgress.vue
var WzDialogProgress_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-dialog',{attrs:{"max-width":"800","persistent":""},model:{value:(_vm.dialogProgress),callback:function ($$v) {_vm.dialogProgress=$$v},expression:"dialogProgress"}},[_c('v-card',[_c('v-card-title',{staticClass:"title primary white--text"},[_vm._v(_vm._s(_vm.titleDialog))]),_vm._v(" "),_c('v-stepper',{attrs:{"value":_vm.step}},[_c('v-stepper-header',[_vm._l((_vm.steps),function(n){return [_c('v-stepper-step',{key:(n + "-step"),attrs:{"complete":_vm.step > n,"step":n,"editable":""},on:{"click":function($event){_vm.selectTuto(n)}}}),_vm._v(" "),(n !== _vm.steps)?_c('v-divider',{key:n}):_vm._e()]})],2)],1),_vm._v(" "),_c('v-card-text',{domProps:{"innerHTML":_vm._s(_vm.contentDialog)}}),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),(_vm.step !== 1)?_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.previousTuto()}}},[_vm._v("\n            Précédent\n          ")]):_vm._e(),_vm._v(" "),(_vm.step !== 16)?_c('v-btn',{staticClass:"primary",on:{"click":function($event){_vm.nextTuto()}}},[_vm._v("\n            Suivant\n            "),_c('v-icon',{attrs:{"right":""}},[_vm._v("send")])],1):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"blue--text darken-1",attrs:{"flat":""},on:{"click":function($event){_vm.quitTuto()}}},[_vm._v("\n            Quitter\n          ")])],1)],1)],1)],1)}
var WzDialogProgress_staticRenderFns = []
var WzDialogProgress_esExports = { render: WzDialogProgress_render, staticRenderFns: WzDialogProgress_staticRenderFns }
/* harmony default export */ var watcheebox_WzDialogProgress = (WzDialogProgress_esExports);
// CONCATENATED MODULE: ./src/components/watcheebox/WzDialogProgress.vue
var WzDialogProgress_normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var WzDialogProgress___vue_template_functional__ = false
/* styles */
var WzDialogProgress___vue_styles__ = null
/* scopeId */
var WzDialogProgress___vue_scopeId__ = null
/* moduleIdentifier (server only) */
var WzDialogProgress___vue_module_identifier__ = null
var WzDialogProgress_Component = WzDialogProgress_normalizeComponent(
  WzDialogProgress,
  watcheebox_WzDialogProgress,
  WzDialogProgress___vue_template_functional__,
  WzDialogProgress___vue_styles__,
  WzDialogProgress___vue_scopeId__,
  WzDialogProgress___vue_module_identifier__
)

/* harmony default export */ var components_watcheebox_WzDialogProgress = (WzDialogProgress_Component.exports);

// CONCATENATED MODULE: ./src/mixins/permissions.js




/* harmony default export */ var permissions = ({
  methods: {
    checkPermission: function checkPermission(roles) {
      if (roles === 'NO_ADMINS') {
        return lodash_default.a.indexOf(NO_ADMINS, src_store.getters['_User/account'].role) !== -1;
      } else if (roles === 'NO_AGENTS') {
        return lodash_default.a.indexOf(NO_AGENTS, src_store.getters['_User/account'].role) !== -1;
      } else if (roles === 'NO_PEONS') {
        return lodash_default.a.indexOf(NO_PEONS, src_store.getters['_User/account'].role) !== -1;
      } else if (roles === 'NO_PEONS_NOR_AGENTS') {
        return lodash_default.a.indexOf(NO_PEONS_NOR_AGENTS, src_store.getters['_User/account'].role) !== -1;
      }
    }
  }
});
// EXTERNAL MODULE: ./node_modules/vue2-dropzone/dist/vue2Dropzone.js
var vue2Dropzone = __webpack_require__("KvPw");
var vue2Dropzone_default = /*#__PURE__*/__webpack_require__.n(vue2Dropzone);

// EXTERNAL MODULE: ./src/assets/css/vue2Dropzone.css
var css_vue2Dropzone = __webpack_require__("y6jO");
var css_vue2Dropzone_default = /*#__PURE__*/__webpack_require__.n(css_vue2Dropzone);

// CONCATENATED MODULE: ./src/main.js
























































































vue_esm["default"].component('vue-dropzone', vue2Dropzone_default.a);
vue_esm["default"].use(vuetify_default.a, {
  theme: {
    primary: '#1961AC',
    secondary: '#E74011',
    accent: '#5BC5F2',
    tertiary: '#BDBDBD',
    info: '#2196F3',
    warning: '#FFC107',
    error: '#F44336',
    success: '#4CAF50' }
});

vue_esm["default"].use(vuebar_default.a);

exporting_default()(highcharts_default.a);
highcharts_more_default()(highcharts_default.a);
xrange_series_default()(highcharts_default.a);
solid_gauge_default()(highcharts_default.a);
vue_esm["default"].use(vue_highcharts_src["a" /* default */], { Highcharts: highcharts_default.a });

vue_esm["default"].component('wz-avatar', components_watcheezy_WzAvatar);
vue_esm["default"].component('wz-avatar-double', components_watcheezy_WzAvatarDouble);
vue_esm["default"].component('wz-menu', components_watcheezy_WzMenu);
vue_esm["default"].component('wz-agent-status', components_watcheezy_WzAgentStatus);
vue_esm["default"].component('wz-pupitre-status', components_watcheezy_WzPupitreStatus);
vue_esm["default"].component('wz-notifications', components_watcheezy_WzNotifications);
vue_esm["default"].component('wz-agent-menu', components_watcheezy_WzAgentMenu);
vue_esm["default"].component('wz-switch-lang', components_watcheezy_WzSwitchLang);
vue_esm["default"].component('wz-biblio', components_watcheezy_WzBiblio);
vue_esm["default"].component('wz-sentence', components_watcheezy_WzSentence);
vue_esm["default"].component('wz-histo-chats', components_watcheezy_WzHistoChats);
vue_esm["default"].component('wz-histo-bot', components_watcheezy_WzHistoBot);
vue_esm["default"].component('wz-file-selector', components_watcheezy_WzFileSelector);
vue_esm["default"].component('wz-img-upload', components_watcheezy_WzImgUpload);
vue_esm["default"].component('wz-select-agents', components_watcheezy_WzSelectAgents);
vue_esm["default"].component('wz-select-bots', components_watcheezy_WzSelectBots);
vue_esm["default"].component('wz-select-motifs', components_watcheezy_WzSelectMotifs);
vue_esm["default"].component('wz-select-one-agent', components_watcheezy_WzSelectOneAgent);
vue_esm["default"].component('wz-select-one-site', components_watcheezy_WzSelectOneSite);
vue_esm["default"].component('wz-select-gender', components_watcheezy_WzSelectGender);
vue_esm["default"].component('wz-rating', components_watcheezy_WzRating);
vue_esm["default"].component('wz-help', components_watcheezy_WzHelp);
vue_esm["default"].component('wz-satisfaction-agent', components_watcheezy_WzSatisfactionAgent);
vue_esm["default"].component('wz-notifier', components_watcheezy_WzNotifier);
vue_esm["default"].component('wz-dialog', components_watcheezy_WzDialog);
vue_esm["default"].component('wz-editeur-lead', components_watcheezy_WzEditeurLead);
vue_esm["default"].component('wz-agents-occupation-day', components_watcheezy_WzAgentsOccupationDay);
vue_esm["default"].component('wz-agents-occupation-periode', components_watcheezy_WzAgentsOccupationPeriode);
vue_esm["default"].component('wz-agents-presence-day', components_watcheezy_WzAgentsPresenceDay);
vue_esm["default"].component('wz-editeur-lead', components_watcheezy_WzEditeurLead);

vue_esm["default"].component('wz-watcheebox-visiteur', components_watcheebox_WzWatcheeboxVisiteur);
vue_esm["default"].component('wz-watcheebox-agent', components_watcheebox_WzWatcheeboxAgent);
vue_esm["default"].component('wz-list-agents', components_watcheebox_WzListAgents);
vue_esm["default"].component('wz-cobrowsing-client', components_watcheebox_WzCobrowsingClient);
vue_esm["default"].component('wz-fenetre-chat', components_watcheebox_WzFenetreChat);
vue_esm["default"].component('wz-view-chat', components_watcheebox_WzViewChat);
vue_esm["default"].component('wz-view-attente', components_watcheebox_WzViewAttente);
vue_esm["default"].component('wz-visiteur-attente', components_watcheebox_WzVisiteurAttente);
vue_esm["default"].component('wz-visiteur-timer', components_watcheebox_WzVisiteurTimer);
vue_esm["default"].component('wz-content-infos-visiteur', components_watcheebox_WzContentInfosVisiteur);
vue_esm["default"].component('wz-fiche-infos-visiteur', components_watcheebox_WzFicheInfosVisiteur);
vue_esm["default"].component('wz-fiche-biblio-phrases', components_watcheebox_WzFicheBiblioPhrases);
vue_esm["default"].component('wz-fiche-lead-visiteur', components_watcheebox_WzFicheLeadVisiteur);
vue_esm["default"].component('wz-list-chats-agent', components_watcheebox_WzListChatsAgent);

vue_esm["default"].component('wz-dialog-transfert-chat', components_watcheebox_WzDialogTransfertChat);
vue_esm["default"].component('wz-dialog-bannish-visitor', components_watcheebox_WzDialogBannishVisitor);
vue_esm["default"].component('wz-dialog-close-chat', components_watcheebox_WzDialogCloseChat);
vue_esm["default"].component('wz-dialog-infos', components_watcheebox_WzDialogInfos);
vue_esm["default"].component('wz-dialog-progress', components_watcheebox_WzDialogProgress);
for (var main_filter in src_filters) {
  if (src_filters.hasOwnProperty(main_filter)) {
    vue_esm["default"].filter(main_filter, src_filters[main_filter]);
  }
}

vue_esm["default"].mixin(permissions);

Object(vuex_router_sync["sync"])(src_store, src_router);

vue_esm["default"].config.productionTip = false;

new vue_esm["default"]({
  el: '#app',
  axios: ajax,
  router: src_router,
  store: src_store,
  i18n: translation,
  cookie: vue_cookie_default.a,
  validator: validator,
  template: '<App/>',
  created: function created() {
    app_bundle_default.a.init({
      env: "production"
    });
  },

  components: { App: src_App }
});

/***/ }),

/***/ "Nk69":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NwMt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NyPY":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Owzt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "QOv9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SlQE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "U18A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Uhve":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X6+9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Xqa9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("4Teq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ZUDU":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "aAJt":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ahAh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cPqi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "cpom":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eZyM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "g+nO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hM0L":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "i/pa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "icEZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iltA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jRnr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jwDw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "koWZ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__ = __webpack_require__("osty");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("H7H4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_autocompleteImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_ff36f0b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qLqO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qvdq":
/***/ (function(module, exports) {

module.exports = {"fr":{"200":"succès de la requête","301":"redirection permanente","302":"redirection temporaire","400":"mauvaise requête","401":"utilisateur non authentifié","403":"accès refusé","404":"page non trouvée","500":"erreur serveur","close":"fermer","cancel":"annuler","delete":"supprimer","yes":"oui","no":"non","logout":"se déconnecter","login":"connexion","error":"une erreur est survenue","indispo":"occupé","busy":"occupé","offline":"hors ligne","submit":"valider","notFilled":"veuillez remplir tous les champs","email":"email","password":"mot de passe","dashboard":"tableau de bord","trafic":"trafic","visitors":"aucun visiteur | {count} visiteur | {count} visiteurs","chatting":"discussions","monitoring":"monitoring","stats":"statistiques","realtime":"suivi temps réel","audience":"audience","sales":"aucune vente | {count} vente | {count} ventes","leads":"leads","satisfaction":"satisfaction","report":"rapport","preview":"Widget","display":"affichage","chat":"chat","C2C":"call back","callback":"call back","push":"push","pushs":"push marketing","cobrowsing":"Cobrowsing","management":"comptes","sites":"aucun site | {count} site | {count} sites","mapping":"attribution","group":"groupe","filters":"ciblage comportemental","target":"ciblage comportemental","ecomm":"e commerce","support":"support","gestionAccount":"gestion du compte","profile":"mon profil","connectors":"connecteurs","media":"media","sentences":"aucune phrase | une phrase | {count} phrases","biblios":"phrases rapides","settings":"paramètres","search":"rechercher","modifSuccess":"modification réussie !","modifFailure":"modification échouée !","alreadyExists":"existe déjà","creationSuccess":"création réussie","creationFailure":"création échouée","empty":"vide","online":"en ligne","open":"ouvert","language":"langue","mister":"monsieur","miss":"madame","firstName":"prénom","lastName":"nom","job":"poste","phone":"téléphone","yourInfos":"vos informations","loginEmail":"email de connexion","contactEmail":"email de contact","newMessage":"aucun nouveau message | un nouveau message | {count} nouveaux messages","clearAll":"tout effacer","me":"moi","test":"test","show":"afficher","create":"créer","edit":"modifier","agents":"aucun conseiller | {count} conseiller | {count} conseillers","chatbots":"aucun chatbot | {count} chatbot | {count} chatbots","select":"sélectionner","all":"tous | toutes","none":"aucun","save":"sauvegarder","separatedSemiColon":"(séparés par point-virgule)","enabled":"activé","disabled":"désactivé","name":"nom","copyEmail":"email en copie","scenario":"aucun scenario | un scenario | {count} scenarii","notif":"aucune notification | notification | {count} notifications","rights":"aucuns droits | droits","keywords":"mots clés","priority":"priorité","chatMax":"nombre de chats maximum","autoResponse":"réponse automatique","importExport":"import/export","add":"ajouter","uploadSuccess":"téléchargement réussi","uploadError":"téléchargement échoué","exportLast":"dernière visite","exportDuration":"durée de visite","exportSite":"site visité","exportCreation":"date de création","exportAgent":"agent","exportFname":"prénom","exportLname":"nom","exportGender":"genre","exportTel":"téléphone","exportEmail":"email","exportCompany":"société","exportUrl":"url","exportC2C":"call back","exportQuestion":"question","exportComment":"commentaire","exportZendesk":"Zendesk","exportGetquanty":"GetQuanty","exportPurchase":"achats","exportBasket":"panier","exportHasChatted":"a chatté ?","exportHasBeenTarget":"a été ciblé ?","targetedVisitors":"aucun visiteur ciblé | un visiteur ciblé | {count} visiteurs ciblés","outOf":"sur","socialNetworks":"aucun réseau social | un réseau social | {count} réseaux sociaux","onYours":"sur votre | sur vos","lowPotential":"à faible potentiel","chats":"aucune conversation | {count} conversation | {count} conversations","libraries":"aucune bibliothèque | une bibliothèque | {count} bibliothèques","and":"et","or":"ou","subLibraries":"aucune sous-bibliothèque | une sous-bibliothèque | {count} sous-bibliothèques","move":"déplacer","askRemoveLibrary":"Voulez-vous vraiment supprimer cette bibliothèque ainsi que les phrases qu'elle contient ?","title":"titre","bluepush":"push marketing","prechatTitle":"Formulaire préchat","prechatTitleLabel":"Afficher un formulaire d'identification avant le chat","autochatTitle":"Invitation automatique à tchater","autochatTitleLabel":"Envoyer un message tchat automatique","mirroring":"Mirroring","duplicate":"dupliquer","classic":"classique","picture":"image","type":"type","duplicateSuccess":"duplication réussie","deleteSuccess":"suppression réussie","attentionDeletePush":"(attention aux scénarii qui l'utilisent)","duplicateFailure":"duplication échouée","noChange":"aucun changement","message":"message","associateAllAgents":"Associer tous les agents ?","man":"homme","woman":"femme","clickToAction":"au click, déclenche","behaviour":"comportement","center":"au centre","custom":"personnalisé | personnalisée","whichImgDisplay":"Quelle image afficher ?","doNothing":"ne rien faire","openUrl":"Ouvrir un lien URL","deployTargetFirst":"Déployer Target First (si rétracté)","retractedMode":"mode rétracté","deployedMode":"mode déployé","infoPushPreview":"Les couleurs du push 'classique' s'adaptent automatiquement en fonction des couleurs du widget. Choisissez parmi vos sites pour visualiser un rendu","choose":"choisir","triggered":"déclenché","times":"aucune fois | {count} fois | {count} fois","responses":"aucune réponse | {count} réponse | {count} réponses","reply":"répondre","onlyMe":"moi uniquement","shared":"partagé","with":"avec","activeFilters":"aucun filtre actif | un filtre actif | {count} filtres actifs","period":"période","startDate":"date de début","endDate":"date de fin","yesterday":"hier","thisWeek":"cette semaine","thisMonth":"ce mois-ci","last7Days":"7 derniers jours","last30Days":"30 derniers jours","lastWeek":"la semaine dernière","lastMonth":"le mois dernier","lastQuarter":"le trimestre dernier","trackedPages":"pages traquées","conversationRate":"taux de conversation","dataInterval":"intervalle des données","exportInCsv":"exporter en csv","days":"aucun jour | {count} jour | {count} jours","months":"aucun mois | {count} mois | {count} mois","per":"par","messages":"aucun message | 1 message | {count} messages","totalDurationOfChats":"durée totale des chats","averageDurationOfOneChat":"durée moyenne d'un chat","chatsMissed":"aucun chat manqué | 1 chat manqué | {count} chats manqués","chatsByAgentFilter":"Chats initiés par invitation à chatter","chatsAverageResponse":"temps de réponse moyen","chatsFirstResponse":"temps (moyen) de première réponse","chatsCloseTime":"temps de clôture","chatsBetweenAgents":"répartition des conversations entre les agents","chatsPerAgents":"chats par conseiller","agentsActivity":"taux d'activité","timeOfPresence":"temps de présence","talkTime":"temps de conversation","distributionOfChats":"répartition des {count} chats","successfulCalls":"appels réussis","missedCalls":"appels manqués","totalDurationOfCalls":"durée totale des appels","averageDurationOfACall":"durée moyenne d'un appel","callsDetails":"détails des appels","calls":"aucun appel | un appel | {count} appels","results":"aucun résultat | un résultat | {count} résultats","callsPerPage":"appels par page","hour":"heure","duration":"durée","appellant":"appelant","called":"appelé","missed":"manqué","items":"aucun article | {count} article | {count} articles","conversionRate":"taux de conversion","amount":"chiffre d'affaires","salesDetails":"détails des ventes","salesPerPage":"ventes par page","leadsVisitors":"returning leads","newLeads":"nouveaux leads","leadsDetails":"détails des leads","tags":"aucun motif | {count} motif | {count} motifs","ofThePeriod":"de la période","leadsPerPage":"leads par page","sendByEmail":"Envoyer par mail","sendBySms":"Envoyer par SMS","createAZendeskTicket":"Créer un ticket Zendesk","exportToSalesForce":"Exporter vers SalesForce","company":"société","ipAddress":"adresse IP","leadQuestion":"Question (posée par le lead)","comment":"commentaire","leadHeat":"Chaleur du lead","msgDeleteLead":"Si vous supprimez le lead, les informations qui lui sont associées seront perdues.","identity":"identité","data":"aucune donnée | donnée | données","waitingTime":"le temps d'attente","answersQuality":"la qualité des réponses","advisorWelcome":"l'accueil du conseiller","concerning":"concernant","evaluations":"aucune évaluation | {count} évaluation | {count} évaluations","evaluationsPerPage":"évaluations par page","evaluationsDetails":"Détails des évaluations","nsp":"Ne se prononce pas","satisfactions":"Pas satisfait | Moyennement satisfait | Satisfait","questionWaitingTime":"Avez-vous été satisfait de notre délai d'attente ?","questionAnswersQuality":"Avez-vous été satisfait par la qualité de nos réponses ?","questionAdvisorWelcome":"Avez-vous été satisfait par l'accueil de notre conseiller ?","recipient":"destinataire","everyNDays":"Tous les {count} jours","scheduledSending":"Envoi programmé ?","lastShipment":"Dernier envoi","nextSend":"Prochain envoi","lastSend":"Dernier envoi","chooseMailAddress":"Choissisez parmi les adresses mails connues ou tapez en une autre","noReportScheduled":"Aucun rapport n'est programmé","enable":"activer","disable":"désactiver","share":"partager","filtres":"aucun filtre | {count} filtre | {count} filtres","forTheAgent":"pour l'agent","forTheSite":"pour le site","noIncomingChats":"Vous n'avez pas de chats entrants","checkActiveFilters":"vérifiez que vous avez des filtres actifs et laissez <span class=\"headline\">Target First</span> travailler pour vous !","setUpFilters":"Paramétrer les filtres","noTargetingOffline":"Vous êtes actuellement hors-ligne : vous ne pouvez ni envoyer ni recevoir de message et Il n'y a plus de ciblage.","listOfAgents":"Liste des agents","toTransfer":"transférer","listOfDiscussions":"Liste des discussions","typeYourMessage":"tapez votre message ici","currentlyOffline":"Vous êtes actuellement hors-ligne, vous ne pouvez envoyer de message","reduce":"réduire","expand":"agrandir","banish":"bannir","askBanVisitor":"Voulez-vous bannir définitivement le visiteur","visitorCard":"Fiche visiteur","visitorEditing":"Modification visiteur","quickSentences":"Phrases rapides","conversationHistory":"Historique des conversations","navigation":"navigation","visitorInfos":"Informations visiteur","currentPage":"page en cours","lastLoadingDate":"Date dernier chargement","congratulations":"Félicitations !","registrationOk":"Votre inscription est finalisée. Si ce n'est pas déjà fait, pensez à installer le script Target First sur votre site :","emailPassNotMatch":"L'adresse mail et le mot de passe ne correspondent pas","passNotMatch":"Les mots de passe ne correspondent pas","technicalInfos":"Informations techniques","browser":"navigateur","targetingInfos":"Information ciblage","alertCart":"alerte panier","lastInvitAuto":"dernier envoi d'une invitation automatique","beginningChat":"début de la conversation","navigationHistory":"Historique de navigation","purchases":"aucun achat | {count} achat | {count} achats","agentsActivated":"aucun agent activé | {count} agent activé | {count} agents activés","levelHs":"Hors service","levelEssai":"Essai gratuit","accountAgent":"Agent","accountSuper":"Super agent","accountAdmin":"Administrateur","accountAdminTf":"Admin Target First","accountUnknown":"Statut inconnu","passwordForgotten":"Mot de passe oublié","generateNewPassword":"Générer nouveau mot de passe","msgAuto":"message automatique","closing":"Clôture","noSwitchUnavailable":"impossible de passer manuellement en indisponible","atLeastOneSuper":"Il doit y avoir au moins un super agent","atLeastOneActivated":"Il doit y avoir au moins un utilisateur actif","reconnection":"reconnexion","emailSent":"email envoyé","emailFailure":"email non envoyé","averageBasket":"panier moyen","realTimeAnalysis":"Analyse de votre trafic en temps réel...","unreadMessages":"aucun message non lu | {count} message non lu | {count} messages non lus","connectingOnline":"Se connecter 'En ligne'","toOldVersion":"vers ancienne version","changingPage":"change de page","gender":"civilité","lead":"lead qualifié","estimate":"devis","reservation":"réservation","contact":"contact","tagBeforeClose":"Pour clôturer cette conversation, vous devez spécifier un statut/motif au préalable","beforeCloseOptions":"Avant de fermer cette discussion vous pouvez :","sendSatisfactionSurvey":"Envoyer le questionnaire de satisfaction","closeThisChat":"Clôturer cette discussion","closeThisChatHint":"Clôturer définitivement cette discussion (la discussion sera sauvegardée et pourra être consultée plus tard)","selectAgentToTransfer":"Sélectionnez un agent disponible dans la liste puis cliquez sur « transférer » afin de lui transférer cette discussion","agentNotAvailableSupport":"L'agent <b>{count}</b> n'est pas disponible pour prendre en charge ce visiteur","agentSelectedSupport":"Vous avez sélectionné l'agent <b>{count}</b> pour prendre en charge ce visiteur","activeInFacebook":"S'active directement dans Facebook","pushMarketAuto":"push marketing automatique","color":"couleur","primaryColor":"couleur primaire","secondaryColor":"couleur secondaire","backgroundColor":"couleur de fond","iconsColor":"couleur d'icônes","colorDetail":"couleur détail","textColor":"couleur du texte","moduleAppearance":"apparence par defaut","customAppearance":"personnalisation du chat","colorShemes":"jeu de couleurs","sizes":"dimensions","position":"positionnement","defaut":"par défaut","frontLanguage":"Langue du front","defautFrontlanguage":"(*)La langue est définie dans le script d'installation ...&lang=FR. Si rien n'est défini c'est la langue du navigateur","widgetTitle":"Titre du widget (en mode fermé)","firstLineMessage":"Titre (première ligne) du formulaire","secondLineMessage":"Sous-titre (deuxième ligne) du formulaire","changeImageSuccess":"Changement d'image réussi","changeImageFailed":"Changement d'image échouée","defaultLanguage":"Langue par défaut*","disactivingCallback":"Impossible : désactiver d'abord le call back pour","locationRequest":"Demande automatique de géolocalisation","defaultAppearance":"apparence par défaut","customChat":"personnalisation du chat","activateCustomChat":"activer personnalisation du chat","showOnlineAgent":"Afficher si un conseiller connecté","showAgentList":"afficher la liste des conseillers","onLeft":"à gauche","onRight":"à droite","bottomLeft":"en bas à gauche","bottomMiddle":"en bas au milieu","bottomRight":"en bas à droite","personnalise":"personnalisé","allDays":"tous les jours","noDays":"aucun jours","monday":"lundi","tuesday":"mardi","wednesday":"mercredi","thursday":"jeudi","friday":"vendredi","saturday":"samedi","sunday":"dimanche","normal":"Normal (aucune restriction)","afterDelay":"Après un délai","ifOneAgentOnline":"Si au moins un agent est connecté","onAgentIntervention":"Sur invitation automatique à chatter","onTrackedVisitor":"Dès que le visiteur est ciblé","unlessFiltering":"Masquer sauf si le filtrage l'autorise (voir ciblage comportemental)","disabledToday":"désactivé ce jour","displayTimes":"horaires d'affichage (horaires)","defineWidgetHours":"définissez les horaires d'affichage de Target First","allTheTime":"Tout le temps","customHours":"Affichage personnalisé","displayOptions":"Options d'affichage","fromToMorning":"du { day.name } matin","ruleContent":"Contenu de la règle","ruleType":"type de règle","createRule":"créer une règle","applySchedules":"appliquer des horaires","applyHours":"appliquer les heures du","from":"du","afternoon":"après-midi","morning":"matin","to":"jusqu'au","timesSeveralDays":"Horaires pour plusieurs jours","defaultView":"affichage par défaut","hideOnMobile":"Masquer Target First sur mobile","everywhere":"partout","chooseWhiteOrBlack":"Choisir si le widget est présent sur toutes les pages ou certaines en choisissant White List. En revanche, choisir l'option Black List permet de masquer le widget selon des règles à définir.","urlDisplay":"URLs d'affichage","noRules":"Aucune règle, créez-en !","changeType":"Modifier le type","editContent":"Modifier le contenu","fullUrl":"URL complètes (http...)","activateMorning":"Activer le matin","activateAfternoon":"activer l'après-midi","containedUrl":"mots contenus dans les URLs","keyWords":"mots clés (tags) - API requise","classOrId":"classes(.) ou id(#)","connectionIdentifier":"Identifiant de connexion","domainName":"nom de domaine","triggerConditionTime":"Condition de déclenchement : au bout de combien de temps sur la page ?","triggerConditionUrl":"Condition de déclenchement : sur quelle(s) URL ?","restrictFewUrLs":"Restreindre à quelques URL","containsString":"Contient la chaine","warningCallbackDisabled":"Attention, l'option de call back n'est pas activée pour ce site. Vous ne pourrez pas sauvegarder.","callbackOnlyLanguage":"Proposer le call back uniquement pour la langue","content":"contenu","french":"Français","english":"Anglais","spanish":"Espagnol","german":"Allemand","italian":"Italien","portuguese":"Portugais","applyCmsSettings":"appliquer paramètres du CMS","cmsSettingsHint":"Une fois le CMS choisi, vous pourrez appliquer les paramètres associés à ce CMS en cliquant sur le bouton situé à côté","contains":"contient","urlString":"Chaîne URL","addToTheBasket":"Ajout au panier","basket":"panier","identifiedBy":"identifié par","button":"bouton","priceOfProduct":"prix du produit","productName":"nom du produit","identification":"identification","delivery":"livraison","summary":"résumé","confirmation":"confirmation","doNotKnow":"ne sait pas","nextStringUrl":"la chaîne suivante dans l'URL","uniqueIdSourceCode":"l'id unique suivant dans le codes sources","meta":"l'id unique suivant dans le codes sources le mot clé suivant dans les meta","stringTitle":"la chaîne suivante dans le titre (DOM HTML)","tagApiSourceCode":"le TAG Target First suivant dans son code source (API requise)","other":"autre","payment":"paiement","closed":"fermé","disconnected":"déconnecté","connected":"connecté","showNoOnlineAgent":"show no online agent","width":"largeur","height":"hauteur","subTitle":"sous-titre","buttonText":"texte du bouton","firstAutoMessage":"Premier message automatique (bulle chat)","leadEditor":"éditeur de lead","fields":"aucun champ | {count} champ | {count} champs","yourCustomFields":"vos champs personnalisés","yourCustomTags":"vos motifs personnalisés","basicFields":"champs de base","basicTags":"motifs de base","archiveXml":"Archive (XML) de vos scénarii","getScenar":"Récupérer ici vos scénarii actuels","export":"Exporter","import":"Importer","pasteScenar":"Coller ici vos nouveaux scénarii (XML)","importDirect":"Importer directement par fichier","chooseFile":"Choisir le fichier","clickToChoose":"Cliquer pour choisir un fichier","xmlFile":"Fichier XML","uploadOk":"Changement d'image réussie","uploadKo":"Changement d'image échouée","uploadKoBecause":"Changement d'image échouée : format de fichier non accepté","notOnMobile":"Pas sur mobile","onMobile":"Sur mobile","dontContain":"Ne contient pas","atLeastTimes":"Au moins (nb de fois)","never":"Jamais","lower":"Inférieur à","greater":"Supérieur à","equal":"égal à","constCustomer":"A déjà effectué un achat","constNbProd":"Nb de produits dans le panier","constAmount":"Montant du panier","constValidation":"Page Validation visitée","constPaiment":"Page Paiement visitée","constSummary":"Page Résumé visitée","constDeliver":"Page Livraison visitée","constLogin":"Page Identification visitée","constCart":"Page Panier visitée","constChatted":"A déjà chatté avec un conseiller","constTag":"Tag Target First dans la page en cours (API requise)","constTime":"Temps passé sur la page (en sec)","constNoMore":"N'est pas sur la page","constMobile":"Navigation sur mobile","constOngoing":"Page en cours","constHisto":"Page visitée dans l'historique","constDiffPage":"Nombre de pages différentes chargées","constSamePage":"Nombre de fois qu'une même page est chargée","constMonth":"Nombre de pages chargées ce mois-ci","constWeek":"Nombre de pages chargées cette semaine","constNbPage":"Nombre de pages chargées aujourd'hui","constDuration":"Durée de la visite/session","browsing":"Navigation","unactive":"Inactif","active":"Actif","valueOfset":"Valeur","constraint":"Contrainte","condition":"Condition","addTrigger":"Ajouter un déclencheur","choosePush":"Choix du push","whichPush":"Push à activer ?","bubbleMsg":"Message dans la bulle","invitContent":"Contenu du message chat","toTrigg":"A déclencher...","chooseBehav":"Choix du comportement","deleteTrigger":"Supprimer ce déclencheur","editTrigger":"Modifier ce déclencheur","multiAgent":"Multi-agent","triggersList":"Liste des déclencheurs","sharedWith":"Partagé avec","newfamily":"Nouvelle famille","family":"Famille","scenarioThisName":"Nom pour ce scenario","scenarioName":"Nom du scénario","scenarioActivated":"Scenario activé","status":"Statut","triggers":"aucun déclencheur | {count} déclencheur | {count} déclencheurs","description":"Description","withAll":"avec tous les autres conseillers","scenarioShare":"Partager le scenario","scenarioSuppr":"Suppression du scenario","scenarioDuplic":"Dupliquer le scenario","forAllAgents":"(pour tous les conseillers)","forCurrentAgents":"(pour le conseiller en cours uniquement)","scenarioSuspend":"Suspendre le scenario","scenarioActivate":"Activation du scenario","sendPush":"Active un push marketing (si option activée)","sendInvit":"Envoi une invitation chat","allAgents":"Tous les conseillers","triggersNextStep":"les déclencheurs sont à définir à l'étape suivante","scenarioPriority":"Niveau de priorité","scenarioAttributed":"Attribué à","scenarioComment":"Commentaire/Description","addScenario":"Ajouter un scenario","warnOnSite":"sur le site","warnNoFilter":"Attention, il n'y a aucun filtre actif pour l'agent","cantCreate":"Impossible de la créer, titre vide","noSentence":"Aucune phrase dans la bibliothèque","canBeUnavailable":"possibilité d'être indisponible manuellement","connectionChatLost":"la connexion avec le chat a été perdue","adminNoAccessChat":"En tant qu'administrateur vous n'avez pas accès au chat","noSwitchOnlineAvailable":"impossible de passer en statut disponible","send":"envoyer","queryFailed":"requête échouée","nextStep":"prochaine étape","previousStep":"étape précédente","satisfying":"satisfaisant","verySatisfying":"très satisfaisant","sentimentNeutral":"ni l'un, ni l'autre","ratherUnsatisfying":"plutôt insatisfaisant","veryUnsatisfying":"très insatisafaisant","questionAgentSatisfaction1":"Quelle est votre niveau de satisfaction concernant la nouvelle version du Back Office Target First ?","questionAgentSatisfaction2":"Quelle version du Back Office de Target First préférez-vous ?","questionAgentSatisfaction3":"Veuillez nous expliquer plus en détail pourquoi vous préférez cette version du Back Office Target First :","titleAgentSatisfaction1":"Votre satisfaction","titleAgentSatisfaction2":"Votre version préférée","titleAgentSatisfaction3":"Dites nous en plus","version5":"Nettement la nouvelle version","version4":"Légèrement la nouvelle version","version3":"Aucune préférence","version2":"Légèrement la précédente","version1":"Nettement la précédente","version0":"Je n'ai pas connu la précédente","iPrefer":"Je préfère :","satisfactionSurvey":"questionnaire de satisfaction","thanksParticipation":"Merci de votre participation","next":"suivant","previous":"précédent","titleSatisfactionSurvey":"Votre avis nous intéresse","otherinfo":"Autres renseignements","selligentget":"Questionner Selligent","selligentpost":"Envoyer vers Selligent","sendFeedback":"Envoyer des commentaires","yourFeedback":"Vos réactions","scriptInstallationNotOk":"La ligne de code Target First ne semble pas avoir été installée sur votre site. Nous vous invitons à consulter les instructions reçues par email","testAgain":"Tester à nouveau","connectionInterrupted":"Connexion interrompue","noLongerConnected":"Il semblerait que vous n'êtes plus connecté à votre BackOffice","findNewChatInChatting":"Vous pouvez retrouver cette nouvelle discussion dans votre espace de discussions","subject":"objet","contactTheSupport":"Contactez le support","ourKnowledgeBase":"Accédez à notre base de connaissance","signUpWebinar":"Inscrivez-vous à l'un de nos webinar","knowledgeBase":"Base de connaissance","lexicon":"Lexique","conversationInProgress":"Conversation en cours","conversationInProgressWith":"Ce visiteur est déjà en conversation avec <b>{count}</b>. Voulez-vous entrer dans cette conversation ?","lastMessageSent":"Dernier message envoyé","disableAutoInvitation":"Désactiver l'envoi d'invitation automatique","offlineVisitor":"visiteur hors ligne","endOfConversation":"Fin de la conversation","satisfactionFormSent":"Formulaire de satisfaction envoyé","banned":"banni","tooMuchAgentsConnected":"Le nombre d'agents connectés au maximum simultanés est atteint.<br>La limite dans votre abonnement est de <b>{count}</b> agents simultanés","limitSimultaneousAgentsReached":"Limite agents simultanés atteinte","connectedAgents":"Agents connectés","sentencesMustInLibrary":"Les phrases rapides doivent être rangées dans des bibliothèques, vous pouvez créer une bibliothèque afin d'y ajouter des phrases rapides.</br> Ou importez les phrases d'un autre agent","importSentencesFromAgent":"Importer les phrases d'un autre agent","infosImportSentencesFromAgent":"<b>Attention !</b></br>Si vous importez les phrases d'un autre agent, vos phrases actuelles seront supprimées","importSuccess":"Import réussie","importFailure":"Import échoué","everyMonth":"Tous les mois","sendReportNow":"Envoyer le rapport maintenant","reportingPeriodCurrentMonth":"la période du rapport sera ce mois courant","chooseSendingPeriodReport":"Choisir la période d'envoi du rapport","separatedBySemicolon":"séparés par des points-virgule","copyInMessageInput":"Copie la phrase dans la zone de saisie","sendTheMessage":"Envoyer le message","emailAlreadyExists":"Email existe déjà","atLeastOneSitePerAgent":"Chaque agent doit être associé à au moins un site","warningCobrowsingDisabled":"Attention, l'option de cobrowsing n'est pas activée pour le site","warningCobrowsingSettingDisabled":"L'option cobrowsing n'est pas activée dans le menu « paramètres » de ce site","warningMirroringSettingDisabled":"L'option Mirroring n'est pas activée dans le menu « paramètres » de ce site Web","networkVisitor":"Impossible d'utiliser cette fonction avec un visiteur venant des réseaux sociaux","inUse":"Fonctionnalité en cours d'utilisation","notHttps":"Impossible d'utiliser cette fonctionnalité avec un site internet qui n'est pas sécurisé (http)","descCobrowsing":"Avec la navigation conjointe, vous et votre visiteur pouvez interagir sur une même page Web. Chacun des deux <b>co-navigateurs</b> peut donc faire défiler la page, cliquer sur un lien ou sur un bouton et remplir une zone texte. Une demande préalable d'ouverture de session cobrowsing sera envoyée au visiteur afin qu'il accept ou non votre aide.","descMirroring":"Le mirroring vous permet de visualiser la page sur laquelle se trouve votre visiteur. Vous pouvez voir toutes les actions de votre visiteur mais vous ne pourrez pas interagir avec lui sur la page.","warningCobrowsingHttp":"Attention, l'option de cobrowsing ne fonctionnera pas avec un site internet non sécurisé","titleAskCobrowsing":"Prise en charge de la navigation (cobrowsing)","contentAskCobrowsing":"Veuillez attendre la réponse du visiteur à votre demande de prise en charge de navigation.","visitorNoCobrowsing":"Le visiteur à refusé la prise en charge du cobrowsing","visitorCloseCobrowsing":"Le visiteur a interrompu le cobrowsing","noDataVisiteur":"Pas de données visiteur","visitorNoSocket":"Le visiteur n'est plus connecté","constNbPageSession":"Nombre de pages chargés cette session (30 dernières minutes)","constHistoAndNum":"Page visitée plus de x fois","constMoinsDe":"Page visitée il y a moins de x secondes","constPlusDe":"Page visitée il y a plus de x secondes","constDay":"Un jour de la semaine particulier","constAfter":"L'heure actuelle est supérieur à..","constBefore":"L'heure actuelle est inférieure à...","titleDialogMultiConnexion":"Déconnexion de votre compte.","contentDialogMultiConnexion":"<b>Votre session a été interrompue par une autre personne utilisant votre compte</b>.<br> Si vous êtes à l'origne de cette deconnexion ne tenez pas compte des recommandations suivantes : <br> - <i>Votre mot de passe est personnel et confidentiel, assurez-vous de ne jamais le divulger</i>.<br> - <i>Verifiez qu'aucune autre personne n'utilise votre compte en même temps que vous</i>.","titleDialogSessionClose":"Sessions interrompue","contentDialogSessionClose":"<h3>Votre session à été interrompue par l'ouverture d'une autre session.</h3><br />           Attention, vous ne pouvez pas utiliser 2 sessions d'un même Agent simultanément ! <br />           <b>Vous devez vous reconnecter à votre compte pour utiliser à nouveau ce backoffice</b> (cela va couper l'autre session agent active)","titleDialogMultiSession":"Multi sessions","contentDialogMultiSession":"<h3>Une autre session avec votre compte est déjà ouverte.</h3><br />           Attention, vous ne pouvez pas utiliser 2 sessions d'un même Agent simultanément ! <br />           <b>Voulez-vous vous connecter à votre compte ?</b> (cela va couper l'autre session agent active)","transfertWait":"Attendez la réponse de l'agent afin de savoir si il prend la discussion ou si il la refuse","transfertOk":"L'agent a accepté la prise en charge du visiteur","transfertNo":"L'agent n'a pas accepté la prise en charge de ce visiteur, veuillez sélectionner un autre agent dans la liste","txtAgentDispoTransfert":"Sélectionnez un agent disponible dans la liste puis cliquez sur « transférer » afin de lui transférer cette discussion","agentSelected1":"Vous avez selectionné l'agent","agentSelected2":"pour prendre en charge ce visiteur","agentNonDispo":"Cet agent n'est pas disponible pour prendre en charge ce visiteur","agentNoSelected":"Pas d'agent selectionné","contentDialogMultiSessionPhp":"Il n'est pas possible d'utiliser plusieurs sessions agent sur un même navigateur.<br> Seule la première session reste active.","agentSourceInfos":"Agent source : ses phrases seront importées vers l'agent destinataire","agentDestInfos":"Agent Destinataire : il aura les phrases de l'agent source","importFiltersFromAgent":"Importer les filtres d'un autre agent","infosImportFiltersFromAgent":"Attention ! Si vous importez les filtres d'un autre agent, vos filtres actuels seront supprimés","sameAgents":"les agents sont identiques","textDeconnexion":"Attention en vous déconnectant vous allez fermer tous les dicussions en cours non cloturées","addGroupe":"Ajouter un groupe","newChatTitle":"Nouvelle discussion !","newChatContent":"Un visiteur vous a envoyé un message, pour discuter avec plusieurs visiteurs en même temps, il est recommandé d'utiliser le multiChat dans la section « DISCUSSIONS »","notChange":"Ne pas changer","multiChat":"MultiChat","askBanContent":"Attention, si vous bannissez ce visiteur, il ne pourra plus discuter avec vous.","closeChatTitle":"Clôturer la discussion","changePlace":"Changement de place.","askChangePlace":"En déplacant cette discussion sur cette emplacement vous allez échanger les places de ces 2 visiteurs.","changePlaceContent2":"Cette place est déjà occupée par le visiteur","changePlaceContent1":"Emplacement","leadCreationDate":"Date création du compte","leadBirthday":"Date de naissance","leadLoyal":"Statut de fidélité","leadDateMember":"Date de statut membre","leadNbPoints":"Nombre de points acquis","leadNbPointsOngoin":"Nombre de point en cours","leadNbPointsCum":"Nombre de point cum year","leadDateFirstPurch":"Date 1er achat","leadDateLastPurch":"Date dernier achat","leadIdLastPurch":"ID de dernière transaction","leadAmountLastPurchTtc":"Montant de la dernière transaction TTC","leadAmountLastPurchHt":"Montant de la dernière transaction HT","leadDevise":"Devise de la dernière transaction","leadNbPointsLastPu":"Points acquis sur la dernière transaction","dropFileHere":"Déposez votre fichier ici","dropNoBrowser":"Votre navigateur ne supporte pas le glisser/déposer.","dropForm":"Utiliser le formulaire de téléchargement","dropMore":"Fichier trop volumineux","dropMaxSize":"taille max :","dopNoFile":"Vous ne pouvez pas téléchager ce type de fichier.","dropError":"Réponse serveur","dropAnnul":"Annulez le téléchargement","dropConfirmCancel":"Vous êtes sur de vouloir annuler ce téléchargement ?","dropSupFile":"Retirez ce fichier","leadPointsAndPu":"La transaction contient un achat point","txtNoChangePlace":"Cette place est déjà occupée par ce visiteur.","titreNewChat":"Nouvelle discussion","txtContentNewChat":"Nouvelle discussion à la demande du visiteur","noDataChat":"Aucune donnée disponible pour cette discussion.","editFicheLayout":"Modifier la disposition de la fiche visiteur","lastKnownBasket":"Dernier panier connu","botFailed":"Aucune conversation échouée | 1 conversation échouée | {count} conversations échouées","botTransfered":"Aucune conversation transférée | 1 conversation transférée | {count} conversations transférées","botSucceed":"Aucune conversation réussi | 1 conversation réussie| {count} conversations réussies","showHide":"Afficher/Masquer","dropFailMore":"Vous ne pouvez pas télécharger plus de fichier.","emojiNotFound":"Aucun Emoji Trouvé","emojiSearch":"Résultats Recherche","emojiRecent":"Fréquemment utilisés","emojiPeople":"Smileys & Personnes","emojiNature":"Animaux & Nature","emojiFoods":"Nourriture & Boisson","emojiActivity":"Activité","emojiPlaces":"Voyages & Endroits","emojiObjects":"Objets","emojiSymbols":"Symboles","emojiFlags":"Drapeaux","disablePushMessaging":"Désactiver les notifications","enablePushMessaging":"Activer les notifications","pushMessagingBlocked":"Notifications bloquées","contentNotif":"Les notifications fonctionnent","titleNotif":"Titre de la notification","btnTestPushMessaging":"Tester les notifications","unblock":"Débloquer","currentMotif":"Motif du chat","notLevelRights":"Le niveau de licence ({count}) n'est pas suffisant, vous ne pouvez accéder à cette section","motifs":"aucun motif | {count} motif | {count} motifs","botHistory":"Historique des conversations chatbot","selectall":"Cocher tout","selectnone":"Décocher tout","nomotif":"Sans motif","visitorOffline":"Visiteur déconnecté","trasfertChangePage":"Ce visiteur n'est actuellement plus en ligne ou change de page. Attendez quelques secondes avant de pouvoir le reprendre en charge. Vous pouvez annuler la prise en charge si elle n'est toujours pas possible après plusieurs tentatives.","transfertOffline":"Il semblerait que ce visiteur ne soit plus connecté sur votre site, vous ne pouvez plus le prendre en charge.","messageRead":"message lu","messageSent":"message envoyé","selectAgentList":"Selectionnez un agent dans la liste avant de transferer ce visiteur","emails":"aucun email | {count} email | {count} emails","periods":"aucune période | {count} période | {count} périodes","noReportScheduledInfos":"Vous n'avez pas encore programmé de rapport. Pour ce faire il vous suffit de cliquer sur le bouton de création et de le paramétrer afin de recevoir différentes statistiques de manière automatique à propos de votre/vos site(s) !","txtDelaiTransfert":"Délai avant transfert automatique en cas d'inactivité","descriptionDelaiTransfert":"La conversation sera transférée automatiquement si le conseiller est resté inactif durant le délai sélectionné. Si il n'y a pas d'autre conseiller disponible, la conversation sera automatiquement fermée","valids":"aucun valide | {count} valide | {count} valides","invalids":"aucun invalide | {count} invalide | {count} invalides","messageAgentIndispo":"Vous semblez inactif depuis quelques minutes, cette conversation est transferée automatiquement à un autre agent disponible.","reports":"aucun rapport | {count} rapport | {count} rapports","colors":"aucune couleur | {count} couleur | {count} couleurs","mini":"mini","big":"grand","middle":"moyen","labelWidgetState":"Si vous modifiez l'apparence par défaut pendant que des visiteurs consultent votre site, ils conserveront l'état du widget tel qu'ils l'ont actuellement. Ce n'est seulement qu'à leur prochaine session que la nouvelle configuration sera effective pour eux.","copied":"copié","copyText":"Copier le  message","extension":"extension","toOpen":"ouvrir","hideChat":"Cacher les conversations","showChat":"Afficher les conversations","numTransfers":"Nombre de transferts","numSuccesses":"Nombre de succès","numMisunderstandings":"Nombre d'incompréhensions","convMisunderstanding":"Conversation avec incompréhensions","numberFailures":"Nombre d'échecs déclenchés","warningTracked":"Alerte consommation pages traquées : 100 %","warningExpired":"Licence expirée","infoConsumption":"Info consommation pages traquées : ","txt1InfoQuota":"Nous vous informons que vous avez atteint","txt2InfoQuota":"de votre quota de pages traquées.","txt3InfoQuota":"Nous vous invitons à suivre votre consommation et souscrire à un quota de pages traquées supplémentaire, si vous jugez que le quota restant ne suffira pas à tenir jusqu’à votre date anniversaire de renouvellement.","txt4InfoQuota":"Attention, vous serez coupé si vous atteignez votre quota de pages traquées avant la date anniversaire.","txt5InfoQuota":"Vous disposez actuellement d’un volume de pages traquées de :","txt6InfoQuota":"Ce volume de pages traquées expirera ","daysQuota":"aujourd'hui | {count} jour | {count} jours","in":"dans","txt1AlertQuota":"Nous vous informons que votre licence a été désactivée, car vous avez consommé l’intégralité de votre quota de pages traquées.","txt2AlertQuota":"Vous pouvez toujours accéder au back office Target First, en revanche, vous n’avez plus accès au chat, ni à votre trafic.","txt3AlertQuota":"Nous vous invitons à souscrire à un quota de pages traquées supplémentaire, afin de réactiver votre licence.","txt1ExpireLicence":"Nous vous informons que votre licence Target First est expirée depuis le","txt2ExpireLicence":"Pour réactiver votre licence, vous pouvez la renouveler via votre back office, avec le compte référent facturation.","subscribe":"Souscrire","continue":"Continuer","txt3ExpireLicence":"Toutefois, votre licence n’a pas été coupée.","txt4ExpireLicence":"Vous disposez exceptionnellement d’un sursis de","txt5ExpireLicence":"pour procéder au renouvellement de votre licence, faute de quoi celle-ci sera automatiquement coupée.","referentFacturation":"Votre référent facturation :","warningLicence":"Licence désactivée","txt1WarningLicence":"Votre licence n'est pas/plus active","txt2WarningLicence":"Veuillez contacter le support Target First : support@targetfirst.com","txt1NotifQuota":"Votre quota de pages traquées est de","txt2NotifQuota":"soit un total de","notifNewMessage":"Nouveau message de","txtNotifQuota":"vous avez atteint","txtNotifExpire":"Votre licence a expirée le","txtNotifContactSupport":"Veuillez contacter le support technique :","warning":"Attention :","titleNotifQuota":"Quota pages traquées","warningC2C":"Click-to-call désactivé","infoConsumptionC2C":"Consommation actuelle : ","txt2InfoQuotaC2C":"de votre quota d'heures","warningC2Cnear":"La fonctionnalité de click-to-call sera prochainement désactivée","txt3InfoQuotaC2C":"Nous vous invitons à suivre votre consommation et souscrire à des heures de téléphonie supplémentaires.","txt4InfoQuotaC2C":"Attention, la fonctionnalité sera coupée si vous atteignez votre quota d'heures de communication.","txt5InfoQuotaC2C":"Vous disposez actuellement d’un quota de ","tofixes":"vers téléphonie fixe et","tomobiles":"vers téléphonie mobile","fixes":"vers fixes","mobiles":"vers mobiles","c2CSouscription":"Souscrivez à des heures de téléphonie supplémentaire","warningC2Cnear2":"Click-to-call bientôt desactivé","hours":"pas d'heure | {count} heure | {count} heures","chats2":"Conversations","txt6InfoQuotaC2C":"Nous vous invitons à souscrire à un forfait d’heures fixes et/ou mobiles supplémentaire, afin que la ou les lignes callback concernées soient réactivées.","cbExpire1":"Votre carte bancaire est expirée","cbExpire2":"En prévision du prochain renouvellement de votre licence le","cbExpire3":"pensez à mettre à jour vos coordonnées bancaires.","cbExpire4":"Au besoin, vous trouverez la procédure pour mettre à jour votre moyen de paiement sur notre site support.","cbExpire5":"votre carte bancaire va expirer","majCb":"mise à jour","chatbot":"chatbot","required":"Champs obligatoires","activityAgents":"Activité des agents","activityAgent":"Activité de l'agent","presence":"Présence","inactivity":"Inactivité","productivity":"Productivité","partialOccupation":"occupation partielle","maximumOccupancy":"occupation maximum","unoccupied":"inoccupé","connection":"connexion","connections":"connexions","descriptionDelaiTempsTravail":"Temps de travail effectif par jour, cette donnée est utilisée pour calculer le taux d'activité du conseiller.","occupancy":"occupation","advisorsOccupancy":"occupation des conseillers","advisorOccupancy":"occupation du conseiller","inProduction":"en production","outProduction":"hors production","agentsInactivity":"taux d'inactivité","connectionRate":"taux de connexion","sources":"sources","sideoneDesciption":"Le widget prend toute la hauteur de la fenêtre quand il est ouvert (grand). État incompatible avec un positionnement central du widget","sideoneDescription2":"Le widget passe par dessus le site et ne le pousse pas (seulement si Side On est activé).","enSavoirPlus":"En savoir plus","titleInfoSideOn":"Side On","contentInfoSideOn":"Le mode \"Side On\" peut ne pas fonctionner correctement sur votre site internet, si celui-ci n'est pas responsive ou qu'il intègre des modules externes pouvant causer des dysfonctionnements au niveau du redimensionnement des éléments html.","warningMeetingConflict":"Attention, le module de 'Meeting' (rendez-vous) est aussi activé.","warningCallbackConflict":"Attention, le module de 'Callback' (click-to-call) est aussi activé.","conseiller":"conseiller","widgetSubTitleOnline":"sous titre de l'état moyen : mode chat + agent(s) en ligne","widgetSubTitleOffline":"sous titre l'état moyen : mode chatbot & mode chat + agent(s) hors ligne","sendC2C":"Click to Call : fait apparaître le formulaire","sendBot":"Chat Bot : déploie le widget et fait dire la première phrase","sendMeeting":"Tirette Meeting : fait apparaître la tirette latérale (si option activée)","sendTiretteC2C":"Tirette Click to Call : fait apparaître la tirette latérale (si option activée)","delaiTiretteC2C":"Faire apparaître la tirette après un délai (0 sec. = immédiat)","screenSide":"Quel côté de l'écran","choixIconeTirette":"Choix de l'icône de la tirette","modifDesPopup":"Modifier la description dans la popup","modifTitrePopup":"Modifier le titre de la popup","typeForm":"Type de formulaire","dureeRdv":"Durée des rendez-vous proposés aux internautes","typeRdv":"Type de Rendez-vous","restrictAff":"Restrictions d'affichage (horaires)","vyteDesc":"Pour utiliser l'option de prise de rendez-vous Vyte, vous devez d'abord paramétrer le connecteur Vyte.<br><br>Pour se faire, rendez-vous dans la section Connecteurs (juste à côté).","paramConnecteur":"Paramétrez ce connecteur","googleAgendaDesc":"Pour utiliser l'option de prise de rendez-vous Google Agenda (Calendar), vous devez d'abord paramétrer le connecteur.<br><br>Pour se faire, rendez-vous dans la section Connecteurs (juste à côté).","sms":"sms","bot":"bot","meeting":"meeting","warningRecallDisabled":"Attention, l'option de prise de rendez-vous (meeting) n'est pas activée pour le site. Vous ne pourrez pas sauvegarder.","chooseWhiteOrBlackC2C":"Choisir si la tirette est présente sur toutes les pages ou certaines en choisissant \"White List\". En revanche, choisir l'option \"Black list\" permet de masquer la tirette selon des règles à définir.","priseRdv":"Prise de rendez-vous","priseRdvTel":"Prise de rendez-vous téléphonique","priseRdvVyte":"Prise de rendez-vous dans votre agenda Vyte","priseRdvGoogle":"Prise de rendez-vous dans votre agenda Google Agenda","minutes":"Aucun transfert | {count} minute | {count} minutes","notification":"notification","messageAttente":"Aucun message en attente | {count} message en attente | {count} messages en attentes","supMessageAttenteTitre":"supprimer un message","supMessageAttenteContent":"voulez-vous supprimer ce message ?","less":"inférieur à","visited":"au moins","validation":"validation","warningPushDisabled":"L'option Push Marketing n'est pas activée pour ce compte. Vous ne pourrez pas sauvegarder.","chatsTotal":"total conversations","help":"Aide"},"en":{"200":"success of the request","301":"permanent redirection","302":"temporary redirection","400":"bad request","401":"unauthenticated user","403":"access denied","404":"page not found","500":"server error","close":"close","cancel":"cancel","delete":"delete","yes":"yes","no":"no","logout":"logout","login":"login","error":"an error has occurred","indispo":"unavailable","busy":"unavailable","offline":"offline","submit":"submit","notFilled":"please complete all fields","email":"email","password":"password","dashboard":"dashboard","trafic":"traffic","visitors":"no visitor | {count} visitor | {count} visitors","chatting":"chatting","monitoring":"monitoring","stats":"statistics","realtime":"real-time tracking","audience":"audience","sales":"no sale | {count} sale | {count} sales","leads":"leads","satisfaction":"satisfaction","report":"report","preview":"preview","display":"display","chat":"chat","C2C":"callback","callback":"callback","push":"push","pushs":"marketing push","cobrowsing":"Cobrowsing","management":"accounts","sites":"no website | {count} website | {count} websites","mapping":"assignment","group":"group","filters":"targeting","target":"targeting","ecomm":"e commerce","support":"support","gestionAccount":"account management","profile":"my profile","connectors":"connectors","media":"media","sentences":"no sentence | one sentence | {count} sentences","biblios":"quick sentences","settings":"settings","search":"search","modifSuccess":"successful modification!","modifFailure":"change failed!","alreadyExists":"already exists","creationSuccess":"successful creation","creationFailure":"failed creation","empty":"empty","online":"online","open":"open","language":"language","mister":"Mr.","miss":"Ms.","firstName":"first name","lastName":"last name","job":"job","phone":"phone","yourInfos":"your informations","loginEmail":"login email","contactEmail":"contact email","newMessage":"no new message | a new message | {count} new messages","clearAll":"clear all","me":"me","test":"test","show":"display","create":"create","edit":"edit","agents":"no advisor | {count} advisor | {count} advisors","chatbots":"no chatbot | {count} chatbot | {count} chatbots","select":"select","all":"all","none":"none","save":"save","separatedSemiColon":"(separated by semicolon)","enabled":"enabled","disabled":"disabled","name":"name","copyEmail":"copy emails","scenario":"aucun scenario | one scenario | {count} scenarii","notif":"no notification | notification | {count} notifications","rights":"no rights | rights","keywords":"keywords","priority":"priority","chatMax":"maximum number of chats","autoResponse":"automatic response","importExport":"import/export","add":"add","uploadSuccess":"sucessful upload","uploadError":"failed upload","exportLast":"last visit","exportDuration":"visit duration","exportSite":"visited website","exportCreation":"creation date","exportAgent":"advisor","exportFname":"first name","exportLname":"name","exportGender":"gender","exportTel":"phone","exportEmail":"email","exportCompany":"company","exportUrl":"url","exportC2C":"callback","exportQuestion":"question","exportComment":"comment","exportZendesk":"Zendesk","exportGetquanty":"GetQuanty","exportPurchase":"purchase","exportBasket":"shopping cart","exportHasChatted":"has chatted?","exportHasBeenTarget":"has been target?","targetedVisitors":"no targeted visitors | one targeted visitor | {count} targeted visitors","outOf":"out of","socialNetworks":"no social network | one social network | {count} social networks","onYours":"on your | on yours","lowPotential":"low potential","chats":"no chat | {count} chat | {count} chats","libraries":"no library | one library | {count} libraries","and":"and","or":"or","subLibraries":"no sub-library | one sub-library | {count} sub-libraries","move":"move","askRemoveLibrary":"Are you sure you want to delete this library and the sentences it contains?","title":"title","bluepush":"push marketing","prechatTitle":"Prechat survey","prechatTitleLabel":"Display an identification form before the chat","autochatTitle":"Automatic invitation to chat","autochatTitleLabel":"Send an automatic chat message","mirroring":"Mirroring","duplicate":"duplicate","classic":"classic","picture":"picture","type":"type","duplicateSuccess":"successful duplication","deleteSuccess":"successful delete","attentionDeletePush":"(watch out for scenarios that use it)","duplicateFailure":"failure duplication","noChange":"no change","message":"message","associateAllAgents":"Associate all agents?","man":"man","woman":"woman","clickToAction":"click to action","behaviour":"behaviour","center":"center","custom":"custom","whichImgDisplay":"Which image to display?","doNothing":"do nothing","openUrl":"Open a URL link","deployTargetFirst":"Deploy Target First (if retracted)","retractedMode":"retracted mode","deployedMode":"deployed mode","infoPushPreview":"The colors of the push 'classic' automatically adapt according to the colors of the widget. Choose from your sites to view a render","choose":"choose","triggered":"triggered","times":"not once | once | {count} times","responses":"no response | {count} response | {count} responses","reply":"reply","onlyMe":"only me","shared":"shared","with":"with","activeFilters":"no active filter | one active filter | {count} active filters","period":"period","startDate":"start date","endDate":"end date","yesterday":"yesterday","thisWeek":"this week","thisMonth":"this month","last7Days":"last 7 days","last30Days":"last 30 days","lastWeek":"last week","lastMonth":"last month","lastQuarter":"last quarter","trackedPages":"tracked pages","conversationRate":"conversation rate","dataInterval":"data interval","exportInCsv":"export in csv","days":"no day | {count} day | {count} days","months":"no month | {count} month | {count} months","per":"per","messages":"no message | 1 message | {count} messages","totalDurationOfChats":"total duration of chats","averageDurationOfOneChat":"average duration of one chat","chatsMissed":"no missed chat | 1 missed chat | {count} missed chats","chatsByAgentFilter":"Chats initiated by targeting","chatsAverageResponse":"average response time","chatsFirstResponse":"first response time (average)","chatsCloseTime":"closing time","chatsBetweenAgents":"distribution of chats between advisors","chatsPerAgents":"chats per advisors","agentsActivity":"activity rate","timeOfPresence":"time of presence","talkTime":"talk time","distributionOfChats":"distribution of {count} chats","successfulCalls":"successful calls","missedCalls":"missed calls","totalDurationOfCalls":"total duration of calls","averageDurationOfACall":"average duration of a call","callsDetails":"calls details","calls":"no call | one call | {count} calls","results":"no result | one result | {count} results","callsPerPage":"calls per page","hour":"hour","duration":"duration","appellant":"appellant","called":"called","missed":"missed","items":"no item | {count} item | {count} items","conversionRate":"conversion rate","amount":"amount","salesDetails":"sales details","salesPerPage":"sales per page","leadsVisitors":"returning leads","newLeads":"new leads","leadsDetails":"leads details","tags":"no tag | {count} tag | {count} tags","ofThePeriod":"of the period","leadsPerPage":"leads per page","sendByEmail":"Send by email","sendBySms":"Send by SMS","createAZendeskTicket":"Create a Zendesk ticket","exportToSalesForce":"Export to SalesForce","company":"company","ipAddress":"IP address","leadQuestion":"Question (asked by the lead)","comment":"comment","leadHeat":"Lead heat","msgDeleteLead":"If you delete the lead, the information associated with it will be lost.","identity":"identity","data":"no data | data | data","waitingTime":"the waiting time","answersQuality":"the quality of the answers","advisorWelcome":"advisor's welcome","concerning":"concerning","evaluations":"no evaluation | one evaluation | {count} evaluations","evaluationsPerPage":"evaluations per page","evaluationsDetails":"Evaluations details","nsp":"Did Not Answer","satisfactions":"Not satisfied | Moderately satisfied | Satisfied","questionWaitingTime":"Have you been satisfied with our waiting time?","questionAnswersQuality":"Have you been satisfied with the quality of our answers?","questionAdvisorWelcome":"Have you been satisfied with the reception of our consultant?","recipient":"recipient","everyNDays":"Every {count} days","scheduledSending":"Scheduled sending?","lastShipment":"Last shipment","nextSend":"Next send","lastSend":"Last send","chooseMailAddress":"Choose from known mail addresses or type in another","noReportScheduled":"No report has been scheduled","enable":"enable","disable":"disable","share":"share","filtres":"no filter | {count} filter | {count} filters","forTheAgent":"for the agent","forTheSite":"for the website","noIncomingChats":"You do not have any incoming cats","checkActiveFilters":"check that you have active filters and let <span class = \"headline\"> Target First </ span> work for you!","setUpFilters":"Set up filters","noTargetingOffline":"You are currently offline: you can not send or receive messages and there is no more targeting.","listOfAgents":"List of agents","toTransfer":"to transfer","listOfDiscussions":"List of discussions","typeYourMessage":"type your message here","currentlyOffline":"You are currently offline, you can not send a message","reduce":"reduce","expand":"expand","banish":"banish","askBanVisitor":"Do you want to permanently ban the visitor","visitorCard":"Visitor card","visitorEditing":"Visitor editing","quickSentences":"Quick sentences","conversationHistory":"Conversation history","navigation":"navigation","visitorInfos":"Visitor Informations","currentPage":"current page","lastLoadingDate":"Last loading date","congratulations":"Congratulations!","registrationOk":"Your registration is finalized. If you have not already done so, consider installing the Target First script on your site:","emailPassNotMatch":"Email address and password do not match","passNotMatch":"Passwords do not match","technicalInfos":"Technical informations","browser":"browser","targetingInfos":"Targeting information","alertCart":"alert cart","lastInvitAuto":"last sending of an automatic invitation","beginningChat":"beginning of the chat","navigationHistory":"Navigation history","purchases":"no purchase | {count} purchase | {count} purchases","agentsActivated":"no advisor enabled | {count} advisor enabled | {count} advisors enabled","levelHs":"Out of service","levelEssai":"Free trial","accountAgent":"Advisor","accountSuper":"Super advisor","accountAdmin":"Administrator","accountAdminTf":"Admin Target First","accountUnknown":"Unknown status","passwordForgotten":"Password forgotten","generateNewPassword":"Generate new password","msgAuto":"automatic message","closing":"Closing","noSwitchUnavailable":"unable to manually switch to unavailable","atLeastOneSuper":"There must be at least one super agent","atLeastOneActivated":"There must be at least one active user","reconnection":"reconnection","emailSent":"email sent","emailFailure":"email not sent","averageBasket":"average basket","realTimeAnalysis":"Analyze your traffic in real time ...","unreadMessages":"no unread messages | {count} unread message | {count} unread messages","connectingOnline":"Connecting 'Online'","toOldVersion":"to old version","changingPage":"changing page","gender":"gender","lead":"qualified lead","estimate":"estimate","reservation":"reservation","contact":"contact","tagBeforeClose":"To close this conversation, you must specify a status / reason beforehand","beforeCloseOptions":"Before closing this discussion you can:","sendSatisfactionSurvey":"Send the satisfaction survey","closeThisChat":"Close this discussion","closeThisChatHint":"Finalize this discussion (the discussion will be saved and can be consulted later)","selectAgentToTransfer":"Select an available agent from the list and click on \"transfer\" to transfer this chat","agentNotAvailableSupport":"Agent <b>{count}</b> is not available to support this visitor","agentSelectedSupport":"You have selected the <b>{count}</b> agent to support this visitor","activeInFacebook":"Activate directly in Facebook","pushMarketAuto":"automatic marketing push","color":"color","primaryColor":"primary color","secondaryColor":"secondary color","backgroundColor":"background color","iconsColor":"icons color","colorDetail":"color detail","textColor":"text color","moduleAppearance":"module appearance","customAppearance":"custom appearance","colorShemes":"color sheme","sizes":"sizes","position":"position","defaut":"by default","frontLanguage":"front language","defautFrontlanguage":"(*) The language is defined in the installation script ... & lang = FR. If nothing is defined it is the browser language","widgetTitle":"Widget title (closed mode)","firstLineMessage":"Message from the first line (contact form and Messenger)","secondLineMessage":"Message from the second line (contact form and Messenger)","changeImageSuccess":"Successful image change","changeImageFailed":"Failed image change","defaultLanguage":"Language by default*","disactivingCallback":"Impossible: first disable the callback for","locationRequest":"Location request","defaultAppearance":"default Appearance","customChat":"custom widget appearence","activateCustomChat":"Activate widget customization","showOnlineAgent":"Show online agent","showAgentList":"show the list of agents","onLeft":"on left","onRight":"on right","bottomLeft":"on bottom left","bottomMiddle":"on bottom middle","bottomRight":"on bottom right","personnalise":"personalized","allDays":"everyday","noDays":"no days","monday":"monday","tuesday":"tuesday","wednesday":"wednesday","thursday":"thursday","friday":"friday","saturday":"saturday","sunday":"sunday","normal":"Normal (no restrictions)","afterDelay":"after a delay","ifOneAgentOnline":"If at least one agent is online","onAgentIntervention":"only on agent intervention","onTrackedVisitor":"As soon as the visitor is targeted","unlessFiltering":"Hide unless filtering allows (see behavioral targeting)","disabledToday":"disabled this day","displayTimes":"display times","defineWidgetHours":"set widget viewing times","allTheTime":"All the time","customHours":"custom display","displayOptions":"display options","fromToMorning":"from { day.name } morning","ruleContent":"rule content","ruleType":"type of rule","createRule":"create a rule","applySchedules":"apply schedules","applyHours":"apply the hours of","from":"from","afternoon":"afternoon","morning":"morning","to":"to","timesSeveralDays":"times for several days","defaultView":"default view","hideOnMobile":"hide widget on mobile","everywhere":"everywhere","chooseWhiteOrBlack":"Choose whether the widget is present on all or some pages by choosing White List. On the other hand, choosing the Black List option hides the widget according to rules to be defined.","urlDisplay":"display URL","noRules":"No rules, create !","changeType":"Change type","editContent":"Edit content","fullUrl":"Full URL (http...)","activateMorning":"Activate the morning","activateAfternoon":"activate the afternoon","containedUrl":"words contained in the URLs","keyWords":"tags (tags) - API required","classOrId":"classes(.) or id(#)","connectionIdentifier":"Connection identifier","domainName":"domain name","triggerConditionTime":"Trigger condition: after how long on the page?","triggerConditionUrl":"Trigger condition: on which URL (s)?","restrictFewUrLs":"Restrict to a few URLs","containsString":"Contains the string","warningCallbackDisabled":"Warning, the callback option is not enabled for the site","callbackOnlyLanguage":"Offer the callback only for the language","content":"content","french":"French","english":"English","spanish":"Spanish","german":"German","italian":"Italian","portuguese":"Portuguese","applyCmsSettings":"apply CMS settings","cmsSettingsHint":"Once the CMS is chosen, you can apply the settings associated with this CMS by clicking on the button next to it","contains":"contains","urlString":"URL string","addToTheBasket":"Add to the basket","basket":"basket","identifiedBy":"identified by","button":"button","priceOfProduct":"price of the product","productName":"product name","identification":"identification","delivery":"delivery","summary":"summary","confirmation":"confirmation","doNotKnow":"do not know","nextStringUrl":"the next string in the URL","uniqueIdSourceCode":"the following unique id in source code","meta":"the next keyword in the meta","stringTitle":"the following string in the title (HTML DOM)","tagApiSourceCode":"the following Target First TAG in its source code (API required)","other":"other","payment":"payment","closed":"closed","disconnected":"disconnected","connected":"connected","showNoOnlineAgent":"show no online agent","width":"width","height":"height","subTitle":"sub-title","buttonText":"button text","firstAutoMessage":"First automatic message (chat bubble)","leadEditor":"lead editor","fields":"no field | {count} field | {count} fields","yourCustomFields":"your custom fields","yourCustomTags":"your custom tags","basicFields":"basic fields","basicTags":"basic tags","archiveXml":"XML archive of your scenarii","getScenar":"Retrieve here your current scenarios","export":"Export","import":"Import","pasteScenar":"Paste your new scenarios here (XML)","importDirect":"Importer directement par fichier","chooseFile":"Import directly by file","clickToChoose":"Click to choose a file","xmlFile":"XML File","uploadOk":"Image change Successful","uploadKo":"Image change Failed","uploadKoBecause":"Image change Failed : unknown file format","notOnMobile":"Not on mobile phone","onMobile":"On mobile phone","dontContain":"Does not contain","atLeastTimes":"At least (number of times)","never":"Never","lower":"Less than","greater":"Greater than","equal":"equal to","constCustomer":"Has already made a purchase","constNbProd":"Nb of items in the cart","constAmount":"Value of the cart","constValidation":"Validation page loaded","constPaiment":"Payment page loaded","constSummary":"Summary page loaded","constDeliver":"Delivery page loaded","constLogin":"Login page loaded","constCart":"Cart page loaded","constChatted":"Have already chatted with an advisor","constTag":"TargetFirst tag in the current page (API required)","constTime":"Time spent on this page (in seconds)","constNoMore":"Is not on page","constMobile":"Mobile browsing","constOngoing":"Current page","constHisto":"Page already loaded","constDiffPage":"Number of various pages loaded","constSamePage":"Number of times the same page was viewed","constMonth":"Number of pages viewed this month","constWeek":"Number of pages viewed this week","constNbPage":"Number of viewed pages today","constDuration":"Duration of the visit-session (in seconds)","browsing":"Browsing","unactive":"Inactive","active":"Active","valueOfset":"Threshold","constraint":"Constraint","condition":"Condition","addTrigger":"Add a trigger","choosePush":"Choice of push","whichPush":"Push to activate?","bubbleMsg":"Message bubble","invitContent":"Content of the message","toTrigg":"To trigger...","chooseBehav":"Choice of behavior","deleteTrigger":"Delete this trigger","editTrigger":"Edit this trigger","multiAgent":"Multi-agent","triggersList":"List of triggers","sharedWith":"Shared with","newfamily":"New family","family":"Family","scenarioThisName":"Name for this scenario","scenarioName":"Scenario name","scenarioActivated":"Scenario activated","status":"Status","triggers":"no trigger | {count} trigger | {count} triggers","description":"Description","withAll":"with all the other advisors","scenarioShare":"Share this scenario","scenarioSuppr":"Delete this scenario","scenarioDuplic":"Clone this scenario","forAllAgents":"(for all advisors)","forCurrentAgents":"(for current counselor only)","scenarioSuspend":"Suspend the scenario","scenarioActivate":"Activation of the scenario","sendPush":"Activate a marketing push","sendInvit":"Sending a chat invitation","allAgents":"All advisors","triggersNextStep":"the triggers are to be defined in the next step","scenarioPriority":"Priority level","scenarioAttributed":"Assigned to","scenarioComment":"Comment / Description","addScenario":"Add a scenario","warnOnSite":"on the website","warnNoFilter":"Warning, there is no active scenario for the agent","cantCreate":"Can not create it, empty title","noSentence":"No sentences in the library","canBeUnavailable":"possibility of being unavailable","connectionChatLost":"the connection with the chat server has been lost","adminNoAccessChat":"As an administrator you do not have access to chat","noSwitchOnlineAvailable":"impossible to switch to available status","send":"send","queryFailed":"query failed","nextStep":"next step","previousStep":"previous step","satisfying":"satisfying","verySatisfying":"very satisfying","sentimentNeutral":"sentiment neutral","ratherUnsatisfying":"rather unsatisfying","veryUnsatisfying":"very unsatisfying","questionAgentSatisfaction1":"How satisfied are you with the new version of Target First Back Office?","questionAgentSatisfaction2":"Which version of the Target First Back Office do you prefer?","questionAgentSatisfaction3":"Please explain in more detail why you prefer this version of the Target First Back Office:","titleAgentSatisfaction1":"Your satisfaction","titleAgentSatisfaction2":"Your favorite version","titleAgentSatisfaction3":"Tell us more","version5":"definitely the new version","version4":"the new version slightly","version3":"I have no preference","version2":"the previous one","version1":"definitely the previous one","version0":"I did not know the previous one","iPrefer":"I prefer :","satisfactionSurvey":"satisfaction survey","thanksParticipation":"Thank you for your participation","next":"next","previous":"previous","titleSatisfactionSurvey":"Your opinion interests us","otherinfo":"Other informations","selligentget":"Query Selligent","selligentpost":"Send to Selligent","sendFeedback":"Send feedback","yourFeedback":"Your feedback","scriptInstallationNotOk":"The Target First line of code does not appear to have been installed on your site. We invite you to consult the instructions received by email","testAgain":"Test again","connectionInterrupted":"Connection interrupted","noLongerConnected":"It looks like you're no longer connected to your BackOffice","findNewChatInChatting":"You can find this new chat in your chatting page","subject":"subject","contactTheSupport":"Contact the support","ourKnowledgeBase":"Access our knowledge base","signUpWebinar":"Sign up for one of our webinars","knowledgeBase":"Knowledge base","lexicon":"Lexicon","conversationInProgress":"Conversation in progress","conversationInProgressWith":"This visitor is already in conversation with <b> {count} </b>. Do you want to enter this conversation?","lastMessageSent":"Last message sent","disableAutoInvitation":"Disable automatic invitation sending","offlineVisitor":"offline visitor","endOfConversation":"End of the conversation","satisfactionFormSent":"Satisfaction form sent","banned":"banned","tooMuchAgentsConnected":"The maximum number of agents connected at the same time is reached.<br>The limit in your subscription is <b>{count}</b> simultaneous agents","limitSimultaneousAgentsReached":"Limit simultaneous agents reached","connectedAgents":"Connected agents","sentencesMustInLibrary":"Quick sentences must be stored in libraries, you can create a library to add quick phrases. </br> Or import the sentences of another agent","importSentencesFromAgent":"Import the sentences of another agent","infosImportSentencesFromAgent":"<b>Warning!</b> </br>If you import the sentences of another agent, your current sentences will be deleted","importSuccess":"Successful import","importFailure":"Import failed","everyMonth":"Every month","sendReportNow":"Send the report right now","reportingPeriodCurrentMonth":"the period of the report will be this current month","chooseSendingPeriodReport":"Choose the sending period for the report","separatedBySemicolon":"separated by semicolon","copyInMessageInput":"Copy the sentence into the input field","sendTheMessage":"Send the message","emailAlreadyExists":"Email already exists","atLeastOneSitePerAgent":"Each agent must be associated with at least one site","warningCobrowsingDisabled":"Warning, the cobrowsing option is not enabled for the site","warningCobrowsingSettingDisabled":"The cobrowsing option is not activated in the \"parameters\" menu of this site","warningMirroringSettingDisabled":"The Mirroring option is not activated in the \"settings\" menu of this website","networkVisitor":"Can not use this feature with a visitor from social networks","inUse":"Functionality in use","notHttps":"Can not use this feature with a website that is not secure (http)","descCobrowsing":"With joint navigation, you and your visitor can interact on the same web page. Each of the two <b> co-navigators </ b> can scroll through the page, click on a link or button and fill in a text box. A prior cobrowsing login request will be sent to the visitor to accept or reject your assistance.","descMirroring":"Mirroring allows you to view the page on which your visitor is. You can see all the actions of your visitor but you will not be able to interact with him on the page.","warningCobrowsingHttp":"Be careful, the cobrowsing option will not work with an unsecured website","titleAskCobrowsing":"Support for navigation (cobrowsing)","contentAskCobrowsing":"Please wait for the visitor's response to your navigation support request.","visitorNoCobrowsing":"The visitor refused cobrowsing support","visitorCloseCobrowsing":"The visitor interrupted the cobrowsing","noDataVisiteur":"No visitor data","visitorNoSocket":"The visitor is no longer connected","constNbPageSession":"Number of viewed pages this session (30last minutes)","constHistoAndNum":"Page loaded more than x times","constMoinsDe":"Page was loaded less than x seconds ago","constPlusDe":"Page was loaded more than x seconds ago","constDay":"A particular day of the week","constAfter":"The current time is greater than...","constBefore":"The current time is less than...","titleDialogMultiConnexion":"Log out of your account.","contentDialogMultiConnexion":"<b> Your session was interrupted by another person using your account </b>. <br> If you are at the root of this logout do not take into account the following recommendations: <br> - <i> Your password is personal and confidential, make sure you never divulge it </i>. <br> - <i> Check that no other person is using your account at the same time</i>.","titleDialogSessionClose":"Sessions interrupted","contentDialogSessionClose":"<h3> Your session was interrupted by opening another session. </h3> <br>           Warning, you can not use 2 sessions of the same Agent simultaneously! <br>           <b> You must login to your account again to use this backoffice </b> (this will cut the other active agent session)","titleDialogMultiSession":"Multi sessions","contentDialogMultiSession":"<h3> Another session with your account is already open. </h3> <br>           Warning, you can not use 2 sessions of the same Agent simultaneously! <br>           <b> Do you want to login to your account? </b> (this will cut off the other active agent session)","transfertWait":"Wait for the agent's response to know if he takes the discussion or if he refuses it","transfertOk":"The agent has accepted the support of the visitor","transfertNo":"The agent did not accept this visitor's support, please select another agent from the list","txtAgentDispoTransfert":"Select an available agent from the list and click on \"transfer\" to transfer this chat","agentSelected1":"You have selected the agent","agentSelected2":"to support this visitor","agentNonDispo":"This agent is not available to support this visitor","agentNoSelected":"No agent selected","contentDialogMultiSessionPhp":"It is not possible to use multiple agent sessions on the same browser. <br> Only the first session remains active.","agentSourceInfos":"Source Agent: His sentences will be imported to the receiving agent","agentDestInfos":"Recipient Agent: It will have the source agent's sentences","importFiltersFromAgent":"Import another agent's filters","infosImportFiltersFromAgent":"Warning! If you import another agent's filters, your current filters will be removed","sameAgents":"the agents are identical","textDeconnexion":"Attention by disconnecting you will close all the dicussions in course unclotured","addGroupe":"Add group","newChatTitle":"New chat!","newChatContent":"A visitor sent you a message, to chat with several visitors at the same time, it is recommended to use the multiChat in the \"DISCUSSIONS\" section","notChange":"Do not change","multiChat":"MultiChat","askBanContent":"Be careful, if you ban this visitor, he will not be able to talk to you anymore.","closeChatTitle":"Close Chat","changePlace":"Change place","askChangePlace":" By droping this discussion on this site you will be exchanging the places of these 2 visitors","changePlaceContent2":"This place is already occupied by the visitor","changePlaceContent1":"Location","leadCreationDate":"Account creation date","leadBirthday":"Birth date","leadLoyal":"Loyalty status","leadDateMember":"Member status date","leadNbPoints":"Number of points acquired","leadNbPointsOngoin":"Number of points in progress","leadNbPointsCum":"Number of points cum year","leadDateFirstPurch":"Date 1st purchase","leadDateLastPurch":"Last date purchase","leadIdLastPurch":"Last transaction ID","leadAmountLastPurchTtc":"Amount of the last transaction VAT","leadAmountLastPurchHt":"Amount of the last transaction ex-Tax","leadDevise":"Currency of the last transaction","leadNbPointsLastPu":"Points earned on the last transaction","dropFileHere":"Drop file here to download","dropNoBrowser":"Your browser does not support drag and drop","dropForm":"Use the download form","dropMore":"File too large","dropMaxSize":"max size:","dopNoFile":"You can not download this type of file.","dropError":"Server response","dropAnnul":"Cancel the download","dropConfirmCancel":"Are you sure you want to cancel this download?","dropSupFile":"Remove this file","leadPointsAndPu":"The transaction contains a purchase point","txtNoChangePlace":"This place is already occupied by this visitor.","titreNewChat":"New chat","txtContentNewChat":"New discussion at the request of the visitor","noDataChat":"No data available for this discussion.","editFicheLayout":"Modify the layout of the visitor form","lastKnownBasket":"Last known basket","botFailed":"no failed conversation | 1 failed conversation | {count} failed conversations","botTransfered":"no transfered conversation | 1 conversation transfered | {count} transfered conversations","botSucceed":"no succeed conversation | 1 succeed conversation | {count} succeed conversations","showHide":"Show/Hide","dropFailMore":"You can not download more files.","emojiNotFound":"No Emoji Found","emojiSearch":"Search Results","emojiRecent":"Frequently Used","emojiPeople":"Smileys & People","emojiNature":"Animals & Nature","emojiFoods":"Food & Drink","emojiActivity":"Activity","emojiPlaces":"Travel & Places","emojiObjects":"Objects","emojiSymbols":"Symbols","emojiFlags":"Flags","disablePushMessaging":"Disable Push Messaging","enablePushMessaging":"enable Push Messaging","pushMessagingBlocked":"Push Messaging Blocked","contentNotif":"Push messaging work","titleNotif":"push messaging title","btnTestPushMessaging":"Send push","unblock":"Unblock","currentMotif":"Motive","notLevelRights":"The license level ({count}) is not enough, you can not access this section","motifs":"no motive | {count} motive | {count} motives","botHistory":"Chatbot conversation history","selectall":"Select all","selectnone":"Unselect all","nomotif":"Without motive","visitorOffline":"Visitor offline","trasfertChangePage":"This visitor is currently changing pages on your site, you must wait a few seconds before you can take charge.","transfertOffline":"It seems that this visitor is no longer connected to your site, you can no longer support it.","messageRead":"message read","messageSent":"message sent","selectAgentList":"Select an agent from the list before transferring this visitor","emails":"no email | {count} email | {count} emails","periods":"no period | {count} period | {count} periods","noReportScheduledInfos":"You have not scheduled a report yet. To do this, simply click on the creation button and set it to receive different statistics automatically about your(s) site(s)!","txtDelaiTransfert":"delay before automatic transfer","descriptionDelaiTransfert":"The conversation will be automatically transferred if the advisor has been idle for the selected time period. If there is no other counselor available, the conversation will be automatically closed","valids":"no valid | {count} valid | {count} valid","invalids":"no invalid | {count} invalid | {count} invalid","messageAgentIndispo":"You seem inactive for a few minutes, this conversation is automatically transferred to another available agent.","reports":"no report | {count} report | {count} reports","colors":"no color | {count} color | {count} colors","mini":"mini","big":"big","middle":"middle","labelWidgetState":"If you change the default appearance while visitors visit your site, they will keep the widget status as they currently are. It is only at their next session that the new configuration will be effective for them.","copied":"copied","copyText":"Copy text to clipboard","extension":"extension","toOpen":"open","hideChat":"Hide chats","showChat":"View chats","numTransfers":"Number of transfers","numSuccesses":"Number of successes","numMisunderstandings":"Number of misunderstandings","convMisunderstanding":"Conversation with misunderstandings","numberFailures":"Number of failures triggered","warningTracked":"Warning: tracked pages consumption 100%","warningExpired":"License expired","infoConsumption":"Info consumption tracked pages: ","txt1InfoQuota":"We inform you that you have reached","txt2InfoQuota":"of your quota of tracked pages.","txt3InfoQuota":" We invite you to follow your consumption and subscribe to an additional quota of tracked pages, if you consider that the remaining quota will not be enough to hold until your renewal anniversary date.","txt4InfoQuota":"Be careful, you will be cut off if you reach your quota of tracked pages before the anniversary date.","txt5InfoQuota":"You currently have a volume of tracked pages of:","txt6InfoQuota":"This volume of tracked pages will expire ","daysQuota":"today | {count} day | {count} days","in":"in","txt1AlertQuota":"We inform you that your license has been disabled because you have consumed your entire quota of tracked pages.","txt2AlertQuota":"You can still access the Target First back office, but you no longer have access to the chat or your traffic.","txt3AlertQuota":"We invite you to subscribe to an additional quota of tracked pages, in order to reactivate your license.","txt1ExpireLicence":"We inform you that your Target First license has expired since","txt2ExpireLicence":"To reactivate your license, you can renew it through your back office, with the billing reference account.","subscribe":"Subscribe","continue":"Continue","txt3ExpireLicence":"However, your license has not been disabled.","txt4ExpireLicence":"In exceptional circumstances, you have a reprieve from","txt5ExpireLicence":"to renew your license, otherwise it will automatically be disabled.","referentFacturation":"Your billing reference:","warningLicence":"License disabled","txt1WarningLicence":"Your license is not enabled","txt2WarningLicence":"Please contact Target First support: support@targetfirst.com","txt1NotifQuota":"Your quota of tracked pages is","txt2NotifQuota":"totaling","notifNewMessage":"New message from","txtNotifQuota":"you reached","txtNotifExpire":"Your license has expired on","txtNotifContactSupport":"Please contact technical support:","warning":"Warning:","titleNotifQuota":"Quota tracked pages","warningC2C":"Click-to-call disabled","infoConsumptionC2C":"Current consumption: ","txt2InfoQuotaC2C":"of your quota of hours","warningC2Cnear":"The click-to-call feature will be disabled soon","txt3InfoQuotaC2C":"We invite you to follow your consumption and subscribe to additional phone hours.","txt4InfoQuotaC2C":"Be careful, the feature will be cut off if you reach your call quota.","txt5InfoQuotaC2C":"You currently have a quota of","tofixes":"to fixed telephony and","tomobiles":"to mobile","fixes":"to fixed","mobiles":"to mobile","c2CSouscription":"Subscribe to additional phone hours","warningC2Cnear2":"Click-to-call soon disabled","hours":"no hour | {count} hour | {count} hours","chats2":"Chats","txt6InfoQuotaC2C":" We invite you to subscribe to an additional set of fixed and / or mobile hours, so that the concerned callback line or lines are reactivated.","cbExpire1":"Your credit card has expired","cbExpire2":"In anticipation of the next renewal of your license the","cbExpire3":"remember to update your bank details.","cbExpire4":"If necessary, you will find the procedure to update your payment method on our support site.","cbExpire5":"your credit card will expire","majCb":"update","chatbot":"chatbot","required":"Required","activityAgents":"Agents activity","activityAgent":"agent activity","presence":"Presence","inactivity":"Inactivity","productivity":"Productivity","partialOccupation":"partial occupancy","maximumOccupancy":"maximum occupancy","unoccupied":"unoccupied","connection":"connection","connections":"connections","descriptionDelaiTempsTravail":"Effective working time per day, this data is used to calculate the advisor activity rate.","occupancy":"occupancy","advisorsOccupancy":"advisors occupancy","advisorOccupancy":"advisor occupation","inProduction":"in production","outProduction":"out of production","agentsInactivity":"inactivity rate","connectionRate":"connection rate","sources":"origins","sideoneDesciption":"The widget takes the full height of the window when it is open (large). State incompatible with a central positioning of the widget","sideoneDescription2":"The widget goes over the site and does not push it (only if Side On is enabled).","enSavoirPlus":"Learn more","titleInfoSideOn":"Side On","contentInfoSideOn":"The \"Side On\" mode may not work properly on your website, if it is not responsive or it includes external modules that may cause malfunction in resizing html elements.","warningMeetingConflict":"Please note, the 'Meeting' module is also activated.","warningCallbackConflict":"Please note, the 'CAllback' module is also activated.","conseiller":"advisor","widgetSubTitleOnline":"widget subtitle online","widgetSubTitleOffline":"widget subtitle offline","sendC2C":"Click to Call: brings up the form","sendBot":"Chat Bot: deploy the widget and say the first sentence","sendMeeting":"Meeting tab: brings up the side tab (if option activated)","sendTiretteC2C":"Click to Call zipper: brings up the side zipper (if option activated)","delaiTiretteC2C":"Display the zipper after a delay (0 sec. = Immediate)","screenSide":"Which side of the screen","choixIconeTirette":"Choice of the icon zipper","modifDesPopup":"Edit popup description","modifTitrePopup":"Change popup title","typeForm":"Type of form","dureeRdv":"Duration of meetings offered to Internet users","typeRdv":"Type of Appointment","restrictAff":"Display restrictions","vyteDesc":"To use the Vyte appointment booking option, you must first configure the Vyte connector. <br> <br> To do so, go to the Connectors section (right next to it).","paramConnecteur":"Configure this connector","googleAgendaDesc":"To use the Google Calendar appointment option, you must first configure the connector. <br> <br> To do so, go to the Connectors section (right next to it).","sms":"sms","bot":"bot","meeting":"meeting","warningRecallDisabled":"Please note, the meeting option is not activated for the site","chooseWhiteOrBlackC2C":"Choose whether the Callback prompt is present on all or some pages by choosing \"White List\". On the other hand, choosing the \"Black List\" option hides the form according to rules tobe defined.","priseRdv":"making a meeting","priseRdvTel":"making a telephone appointment","priseRdvVyte":"Make an appointment in your Vyte calendar","priseRdvGoogle":"Make an appointment in your Google Calendar","minutes":" No transfer | {count} minute | {count} minutes","notification":"notification","messageAttente":"aucun message en attente | {count}  message pending | {count}  messages pending","supMessageAttenteTitre":"delete message","supMessageAttenteContent":"do you want to delete this message?","less":"less than","visited":"at least","validation":"validation","warningPushDisabled":"Marketing push option is disabled","chatsTotal":"total chats","help":"Help"},"es":{"200":"éxito de consulta","301":"redirección permanente ","302":"redirección temporal","400":"solicitud incorrecta","401":"usuario no autenticado","403":"acceso denegado ","404":"página no encontrada","500":"error de servidor","close":"cerrar","cancel":"cancelar","delete":"quitar","yes":"sí","no":"no","logout":"desconectarse","login":"conexión","error":"an error has occurred","indispo":"indisponible","busy":"indisponible","offline":"desconectado","submit":"validar","notFilled":"por favor, rellene todos los campos","email":"email","password":"contraseña","dashboard":"tablero","trafic":"tráfico","visitors":"sin visitante | {count} visitante | {count} visitantes","chatting":"discusiones","monitoring":"monitoring","stats":"estadísticas","realtime":"monitoreo en tiempo real","audience":"audiencia","sales":"no sale | {count} sale | {count} sales","leads":"leads","satisfaction":"satisfaction","report":"report","preview":"preview","display":"display","chat":"chat","C2C":"callback","callback":"callback","push":"push","pushs":"marketing push","cobrowsing":"Cobrowsing","management":"accounts","sites":"no website | {count} website | {count} websites","mapping":"asignación","group":"grupo","filters":"focalización","target":"focalización","ecomm":"e-commerce","support":"soporte","gestionAccount":"gestión de cuenta","profile":"mi perfil","connectors":"conectores","media":"media","sentences":"no sentence | one sentence | {count} sentences","biblios":"frases rápidas","settings":"ajustes","search":"buscar","modifSuccess":"modificación exitosa!","modifFailure":"cambio fallido!","alreadyExists":"ya existe","creationSuccess":"creación exitosa","creationFailure":"creación fallida","empty":"vacío","online":"en línea","open":"abierto","language":"idioma","mister":"señor","miss":"señora","firstName":"nombre","lastName":"apellido","job":"trabajo","phone":"teléfono","yourInfos":"vuestras informaciones","loginEmail":"correo electrónico de acceso","contactEmail":"correo electrónico de contacto","newMessage":"ningún mensaje nuevo | un nuevo mensaje | {count} nuevos mensajes","clearAll":"borrar todo","me":"me","test":"test","show":"display","create":"create","edit":"edit","agents":"sin consejero | {count} consejero | {count} consejero","chatbots":"sin chatbot | {count} chatbot | {count} chatbots","select":"select","all":"all","none":"none","save":"save","separatedSemiColon":"(separated by semicolon)","enabled":"activado","disabled":"discapacitado","name":"nombre","copyEmail":"copy emails","scenario":"aucun scenario | one scenario | {count} scenarii","notif":"sin notificación | notificación | {count} notificaciónes","rights":"no rights | rights","keywords":"keywords","priority":"priority","chatMax":"maximum number of chats","autoResponse":"automatic response","importExport":"import/export","add":"add","uploadSuccess":"sucessful upload","uploadError":"failed upload","exportLast":"last visit","exportDuration":"visit duration","exportSite":"visited website","exportCreation":"creation date","exportAgent":"advisor","exportFname":"first name","exportLname":"name","exportGender":"gender","exportTel":"phone","exportEmail":"email","exportCompany":"company","exportUrl":"url","exportC2C":"callback","exportQuestion":"question","exportComment":"comment","exportZendesk":"Zendesk","exportGetquanty":"GetQuanty","exportPurchase":"purchase","exportBasket":"shopping cart","exportHasChatted":"has chatted?","exportHasBeenTarget":"has been target?","targetedVisitors":"no targeted visitors | one targeted visitor | {count} targeted visitors","outOf":"out of","socialNetworks":"no social network | one social network | {count} social networks","onYours":"on your | on yours","lowPotential":"low potential","chats":"no chat | {count} chat | {count} chats","libraries":"no library| one library | {count} libraries","and":"and","or":"or","subLibraries":"no sub-library | one sub-library | {count} sub-libraries","move":"move","askRemoveLibrary":"Are you sure you want to delete this library and the sentences it contains?","title":"title","bluepush":"push marketing","prechatTitle":"Prechat survey","prechatTitleLabel":"Display an identification form before the chat","autochatTitle":"Automatic invitation to chat","autochatTitleLabel":"Send an automatic chat message","mirroring":"Mirroring","duplicate":"duplicate","classic":"classic","picture":"picture","type":"tipo","duplicateSuccess":"successful duplication","deleteSuccess":"successful delete","attentionDeletePush":"(watch out for scenarios that use it)","duplicateFailure":"failure duplication","noChange":"no change","message":"mensaje","associateAllAgents":"Associate all agents?","man":"man","woman":"woman","clickToAction":"click to action","behaviour":"behaviour","center":"center","custom":"custom","whichImgDisplay":"Which image to display?","doNothing":"do nothing","openUrl":"Open a URL link","deployTargetFirst":"Deploy Target First (if retracted)","retractedMode":"retracted mode","deployedMode":"deployed mode","infoPushPreview":"The colors of the push 'classic' automatically adapt according to the colors of the widget. Choose from your sites to view a render","choose":"choose","triggered":"triggered","times":"not once | once | {count} times","responses":"no response | {count} response | {count} responses","reply":"reply","onlyMe":"only me","shared":"shared","with":"with","activeFilters":"no active filter | one active filter | {count} active filters","period":"period","startDate":"start date","endDate":"end date","yesterday":"yesterday","thisWeek":"this week","thisMonth":"this month","last7Days":"last 7 days","last30Days":"last 30 days","lastWeek":"last week","lastMonth":"last month","lastQuarter":"last quarter","trackedPages":"tracked pages","conversationRate":"conversation rate","dataInterval":"data interval","exportInCsv":"export in csv","days":"no day | {count} day | {count} days","months":"no month | {count} month | {count} months","per":"per","messages":"no message | 1 message | {count} messages","totalDurationOfChats":"total duration of chats","averageDurationOfOneChat":"average duration of one chat","chatsMissed":"no missed chat | 1 missed chat | {count} missed chats","chatsByAgentFilter":"Chats initiated by targeting","chatsAverageResponse":"average response time","chatsFirstResponse":"first response time (average)","chatsCloseTime":"closing time","chatsBetweenAgents":"distribution of chats between advisors","chatsPerAgents":"chats per advisors","agentsActivity":"activity rate","timeOfPresence":"time of presence","talkTime":"talk time","distributionOfChats":"distribution of {count} chats","successfulCalls":"successful calls","missedCalls":"missed calls","totalDurationOfCalls":"total duration of calls","averageDurationOfACall":"average duration of a call","callsDetails":"calls details","calls":"no call | one call | {count} calls","results":"no result | one result | {count} results","callsPerPage":"calls per page","hour":"hour","duration":"duration","appellant":"appellant","called":"called","missed":"missed","items":"no item | {count} item | {count} items","conversionRate":"conversion rate","amount":" facturación","salesDetails":"sales details","salesPerPage":"sales per page","leadsVisitors":"returning leads","newLeads":"new leads","leadsDetails":"leads details","tags":"no tag | {count} tag | {count} tags","ofThePeriod":"of the period","leadsPerPage":"leads per page","sendByEmail":"Send by email","sendBySms":"Send by SMS","createAZendeskTicket":"Create a Zendesk ticket","exportToSalesForce":"Export to SalesForce","company":"company","ipAddress":"IP address","leadQuestion":"Question (asked by the lead)","comment":"comment","leadHeat":"Lead heat","msgDeleteLead":"If you delete the lead, the information associated with it will be lost.","identity":"identity","data":"no data | data | data","waitingTime":"the waiting time","answersQuality":"the quality of the answers","advisorWelcome":"advisor's welcome","concerning":"concerning","evaluations":"no evaluation | one evaluation | {count} evaluations","evaluationsPerPage":"evaluations per page","evaluationsDetails":"Evaluations details","nsp":"Did Not Answer","satisfactions":"Not satisfied | Moderately satisfied | Satisfied","questionWaitingTime":"Have you been satisfied with our waiting time?","questionAnswersQuality":"Have you been satisfied with the quality of our answers?","questionAdvisorWelcome":"Have you been satisfied with the reception of our consultant?","recipient":"recipient","everyNDays":"Every {count} days","scheduledSending":"Scheduled sending?","lastShipment":"Last shipment","nextSend":"Next send","lastSend":"Last send","chooseMailAddress":"Choose from known mail addresses or type in another","noReportScheduled":"No report has been scheduled","enable":"enable","disable":"disable","share":"share","filtres":"no filter | {count} filter | {count} filters","forTheAgent":"for the agent","forTheSite":"for the website","noIncomingChats":"You do not have any incoming cats","checkActiveFilters":"check that you have active filters and let <span class = \"headline\"> Target First </ span> work for you!","setUpFilters":"Set up filters","noTargetingOffline":"You are currently offline: you can not send or receive messages and there is no more targeting.","listOfAgents":"List of agents","toTransfer":"to transfer","listOfDiscussions":"List of discussions","typeYourMessage":"type your message here","currentlyOffline":"You are currently offline, you can not send a message","reduce":"reduce","expand":"expand","banish":"banish","askBanVisitor":"Do you want to permanently ban the visitor","visitorCard":"Visitor card","visitorEditing":"Visitor editing","quickSentences":"Quick sentences","conversationHistory":"Conversation history","navigation":"navigation","visitorInfos":"Visitor Informations","currentPage":"current page","lastLoadingDate":"Last loading date","congratulations":"Congratulations!","registrationOk":"Your registration is finalized. If you have not already done so, consider installing the Target First script on your site:","emailPassNotMatch":"Email address and password do not match","passNotMatch":"Passwords do not match","technicalInfos":"Technical informations","browser":"browser","targetingInfos":"Targeting information","alertCart":"alert cart","lastInvitAuto":"last sending of an automatic invitation","beginningChat":"beginning of the chat","navigationHistory":"Navigation history","purchases":"no purchase | {count} purchase | {count} purchases","agentsActivated":"no advisor enabled | {count} advisor enabled | {count} advisors enabled","levelHs":"Out of service","levelEssai":"Free trial","accountAgent":"Advisor","accountSuper":"Super advisor","accountAdmin":"Administrator","accountAdminTf":"Admin Target First","accountUnknown":"Unknown status","passwordForgotten":"Password forgotten","generateNewPassword":"Generate new password","msgAuto":"automatic message","closing":"Closing","noSwitchUnavailable":"unable to manually switch to unavailable","atLeastOneSuper":"There must be at least one super agent","atLeastOneActivated":"There must be at least one active user","reconnection":"reconnection","emailSent":"email sent","emailFailure":"email not sent","averageBasket":"average basket","realTimeAnalysis":"Analyze your traffic in real time ...","unreadMessages":"no unread messages | {count} unread message | {count} unread messages","connectingOnline":"Connecting 'Online'","toOldVersion":"to old version","changingPage":"changing page","gender":"gender","lead":"lead","estimate":"estimate","reservation":"reservation","contact":"contact","tagBeforeClose":"To close this conversation, you must specify a status / reason beforehand","beforeCloseOptions":"Before closing this discussion you can:","sendSatisfactionSurvey":"Send the satisfaction survey","closeThisChat":"Close this discussion","closeThisChatHint":"Finalize this discussion (the discussion will be saved and can be consulted later)","selectAgentToTransfer":"Select an available agent from the list and click on \"transfer\" to transfer this chat","agentNotAvailableSupport":"Agent <b>{count}</b> is not available to support this visitor","agentSelectedSupport":"You have selected the <b>{count}</b> agent to support this visitor","activeInFacebook":"Activate directly in Facebook","pushMarketAuto":"push marketing automatique","color":"color","primaryColor":"primary color","secondaryColor":"secondary color","backgroundColor":"background color","iconsColor":"icons color","colorDetail":"color detail","textColor":"text color","moduleAppearance":"module appearance","customAppearance":"custom appearance","colorShemes":"color sheme","sizes":"sizes","position":"position","defaut":"by default","frontLanguage":"front language","defautFrontlanguage":"(*) The language is defined in the installation script ... & lang = FR. If nothing is defined it is the browser language","widgetTitle":"Widget title (closed mode)","firstLineMessage":"Message from the first line (contact form and Messenger)","secondLineMessage":"Message from the second line (contact form and Messenger)","changeImageSuccess":"Successful image change","changeImageFailed":"Failed image change","defaultLanguage":"Language by default*","disactivingCallback":"Impossible: first disable the callback for","locationRequest":"Location request","defaultAppearance":"default Appearance","customChat":"custom widget appearence","activateCustomChat":"Activate widget customization","showOnlineAgent":"Show online agent","showAgentList":"show the list of agents","onLeft":"on left","onRight":"on right","bottomLeft":"on bottom left","bottomMiddle":"on bottom middle","bottomRight":"on bottom right","personnalise":"personalized","allDays":"everyday","noDays":"no days","monday":"lunes","tuesday":"martes","wednesday":"miércoles","thursday":"jueves","friday":"viernes","saturday":"sábado","sunday":"domingo","normal":"Normal (no restrictions)","afterDelay":"after a delay","ifOneAgentOnline":"If at least one agent is online","onAgentIntervention":"only on agent intervention","onTrackedVisitor":"As soon as the visitor is targeted","unlessFiltering":"Hide unless filtering allows (see behavioral targeting)","disabledToday":"disabled this day","displayTimes":"display times","defineWidgetHours":"set widget viewing times","allTheTime":"All the time","customHours":"custom display","displayOptions":"display options","fromToMorning":"from { day.name } morning","ruleContent":"rule content","ruleType":"type of rule","createRule":"create a rule","applySchedules":"apply schedules","applyHours":"apply the hours of","from":"from","afternoon":"afternoon","morning":"morning","to":"to","timesSeveralDays":"times for several days","defaultView":"default view","hideOnMobile":"hide widget on mobile","everywhere":"everywhere","chooseWhiteOrBlack":"Elija si el widget está presente en todas o en algunas páginas eligiendo Lista blanca. Por otro lado, elegir la opción Lista negra oculta el widget según las reglas que se definan.","urlDisplay":"URL visible","noRules":"No rules, create!","changeType":"Change type","editContent":"Edit content","fullUrl":"Full URL (http...)","activateMorning":"Activate the morning","activateAfternoon":"activate the afternoon","containedUrl":"words contained in the URLs","keyWords":"tags (tags) - API required","classOrId":"classes(.) or id(#)","connectionIdentifier":"Connection identifier","domainName":"domain name","triggerConditionTime":"Trigger condition: after how long on the page?","triggerConditionUrl":"Trigger condition: on which URL (s)?","restrictFewUrLs":"Restrict to a few URLs","containsString":"Contains the string","warningCallbackDisabled":"Warning, the callback option is not enabled for the site","callbackOnlyLanguage":"Offer the callback only for the language","content":"content","french":"French","english":"English","spanish":"Spanish","german":"German","italian":"Italian","portuguese":"Portuguese","applyCmsSettings":"apply CMS settings","cmsSettingsHint":"Once the CMS is chosen, you can apply the settings associated with this CMS by clicking on the button next to it","contains":"contains","urlString":"URL string","addToTheBasket":"Add to the basket","basket":"basket","identifiedBy":"identified by","button":"button","priceOfProduct":"price of the product","productName":"product name","identification":"identification","delivery":"delivery","summary":"summary","confirmation":"confirmation","doNotKnow":"do not know","nextStringUrl":"the next string in the URL","uniqueIdSourceCode":"the following unique id in source code","meta":"the next keyword in the meta","stringTitle":"the following string in the title (HTML DOM)","tagApiSourceCode":"the following Target First TAG in its source code (API required)","other":"other","payment":"payment","closed":"closed","disconnected":"disconnected","connected":"connected","showNoOnlineAgent":"show no online agent","width":"width","height":"height","subTitle":"sub-title","buttonText":"button text","firstAutoMessage":"First automatic message (chat bubble)","leadEditor":"lead editor","fields":"no field | {count} field | {count} fields","yourCustomFields":"your custom fields","yourCustomTags":"your custom tags","basicFields":"basic fields","basicTags":"basic tags","archiveXml":"XML archive of your scenarii","getScenar":"Retrieve here your current scenarios","export":"Export","import":"Import","pasteScenar":"Paste your new scenarios here (XML)","importDirect":"Importer directement par fichier","chooseFile":"Import directly by file","clickToChoose":"Click to choose a file","xmlFile":"XML File","uploadOk":"Image change Successful","uploadKo":"Image change Failed","uploadKoBecause":"Image change Failed : unknown file format","notOnMobile":"Not on mobile phone","onMobile":"On mobile phone","dontContain":"Does not contain","atLeastTimes":"At least (number of times)","never":"Never","lower":"Less than","greater":"Greater than","equal":"equal to","constCustomer":"Has already made a purchase","constNbProd":"Nb of items in the cart","constAmount":"Value of the cart","constValidation":"Validation page loaded","constPaiment":"Payment page loaded","constSummary":"Summary page loaded","constDeliver":"Delivery page loaded","constLogin":"Login page loaded","constCart":"Cart page loaded","constChatted":"Have already chatted with an advisor","constTag":"TargetFirst tag in the current page (API required)","constTime":"Time spent on this page (in seconds)","constNoMore":"Is not on page","constMobile":"Mobile browsing","constOngoing":"Current page","constHisto":"Page already loaded","constDiffPage":"Number of various pages loaded","constSamePage":"Number of times the same page was viewed","constMonth":"Number of pages viewed this month","constWeek":"Number of pages viewed this week","constNbPage":"Number of viewed pages today","constDuration":"Duration of the visit-session (in seconds)","browsing":"Browsing","unactive":"Inactive","active":"Active","valueOfset":"Threshold","constraint":"Constraint","condition":"Condition","addTrigger":"Add a trigger","choosePush":"Choice of push","whichPush":"Push to activate?","bubbleMsg":"Message bubble","invitContent":"Content of the message","toTrigg":"To trigger...","chooseBehav":"Choice of behavior","deleteTrigger":"Delete this trigger","editTrigger":"Edit this trigger","multiAgent":"Multi-agent","triggersList":"List of triggers.","sharedWith":"Shared with","newfamily":"New family","family":"Family","scenarioThisName":"Name for this scenario","scenarioName":"Scenario name","scenarioActivated":"Scenario activated","status":"Status","triggers":"no trigger | {count} trigger | {count} triggers","description":"Description","withAll":"with all the other advisors","scenarioShare":"Share this scenario","scenarioSuppr":"Delete this scenario","scenarioDuplic":"Clone this scenario","forAllAgents":"(for all advisors)","forCurrentAgents":"(for current counselor only)","scenarioSuspend":"Suspend the scenario","scenarioActivate":"Activation of the scenario","sendPush":"Activate a marketing push","sendInvit":"Sending a chat invitation","allAgents":"All advisors","triggersNextStep":"the triggers are to be defined in the next step","scenarioPriority":"Priority level","scenarioAttributed":"Assigned to","scenarioComment":"Comment / Description","addScenario":"Add a scenario","warnOnSite":"on the website","warnNoFilter":"Warning, there is no active scenario for the agent","cantCreate":"Can not create it, empty title","noSentence":"No sentences in the library","canBeUnavailable":"possibility of being unavailable","connectionChatLost":"the connection with the chat server has been lost","adminNoAccessChat":"As an administrator you do not have access to chat","noSwitchOnlineAvailable":"impossible to switch to available status","send":"send","queryFailed":"query failed","nextStep":"next step","previousStep":"previous step","satisfying":"satisfying","verySatisfying":"very satisfying","sentimentNeutral":"sentiment neutral","ratherUnsatisfying":"rather unsatisfying","veryUnsatisfying":"very unsatisfying","questionAgentSatisfaction1":"How satisfied are you with the new version of Target First Back Office?","questionAgentSatisfaction2":"Which version of the Target First Back Office do you prefer?","questionAgentSatisfaction3":"Please explain in more detail why you prefer this version of the Target First Back Office:","titleAgentSatisfaction1":"Your satisfaction","titleAgentSatisfaction2":"Your favorite version","titleAgentSatisfaction3":"Tell us more","version5":"definitely the new version","version4":"the new version slightly","version3":"I have no preference","version2":"the previous one","version1":"definitely the previous one","version0":"I did not know the previous one","iPrefer":"I prefer :","satisfactionSurvey":"satisfaction survey","thanksParticipation":"Thank you for your participation","next":"next","previous":"previous","titleSatisfactionSurvey":"Your opinion interests us","otherinfo":"Other informations","selligentget":"Query Selligent","selligentpost":"Send to Selligent","sendFeedback":"Send feedback","yourFeedback":"Your feedback","scriptInstallationNotOk":"The Target First line of code does not appear to have been installed on your site. We invite you to consult the instructions received by email","testAgain":"Test again","connectionInterrupted":"Connection interrupted","noLongerConnected":"It looks like you're no longer connected to your BackOffice","findNewChatInChatting":"You can find this new chat in your chatting page","subject":"subject","contactTheSupport":"Contact the support","ourKnowledgeBase":"Access our knowledge base","signUpWebinar":"Sign up for one of our webinars","knowledgeBase":"Knowledge base","lexicon":"Lexicon","conversationInProgress":"Conversation in progress","conversationInProgressWith":"This visitor is already in conversation with <b> {count} </b>. Do you want to enter this conversation?","lastMessageSent":"Last message sent","disableAutoInvitation":"Disable automatic invitation sending","offlineVisitor":"offline visitor","endOfConversation":"End of the conversation","satisfactionFormSent":"Satisfaction form sent","banned":"banned","tooMuchAgentsConnected":"The maximum number of agents connected at the same time is reached.<br>The limit in your subscription is <b>{count}</b> simultaneous agents","limitSimultaneousAgentsReached":"Limit simultaneous agents reached","connectedAgents":"Connected agents","sentencesMustInLibrary":"Quick sentences must be stored in libraries, you can create a library to add quick phrases. </br> Or import the sentences of another agent","importSentencesFromAgent":"Import the sentences of another agent","infosImportSentencesFromAgent":"<b>Warning!</b> </br>If you import the sentences of another agent, your current sentences will be deleted","importSuccess":"Successful import","importFailure":"Import failed","everyMonth":"Every month","sendReportNow":"Send the report right now","reportingPeriodCurrentMonth":"the period of the report will be this current month","chooseSendingPeriodReport":"Choose the sending period for the report","separatedBySemicolon":"separated by semicolon","copyInMessageInput":"Copy the sentence into the input field","sendTheMessage":"Send the message","emailAlreadyExists":"Email already exists","atLeastOneSitePerAgent":"Each agent must be associated with at least one site","warningCobrowsingDisabled":"Warning, the cobrowsing option is not enabled for the site","warningCobrowsingSettingDisabled":"The cobrowsing option is not activated in the \"parameters\" menu of this site","warningMirroringSettingDisabled":"The Mirroring option is not activated in the \"settings\" menu of this website","networkVisitor":"Can not use this feature with a visitor from social networks","inUse":"Functionality in use","notHttps":"Can not use this feature with a website that is not secure (http)","descCobrowsing":"With joint navigation, you and your visitor can interact on the same web page. Each of the two <b> co-navigators </ b> can scroll through the page, click on a link or button and fill in a text box. A prior cobrowsing login request will be sent to the visitor to accept or reject your assistance.","descMirroring":"Mirroring allows you to view the page on which your visitor is. You can see all the actions of your visitor but you will not be able to interact with him on the page.","warningCobrowsingHttp":"Be careful, the cobrowsing option will not work with an unsecured website","titleAskCobrowsing":"Support for navigation (cobrowsing)","contentAskCobrowsing":"Please wait for the visitor's response to your navigation support request.","visitorNoCobrowsing":"The visitor refused cobrowsing support","visitorCloseCobrowsing":"The visitor interrupted the cobrowsing","noDataVisiteur":"No visitor data","visitorNoSocket":"The visitor is no longer connected","constNbPageSession":"Number of viewed pages this session (30last minutes)","constHistoAndNum":"Page loaded more than x times","constMoinsDe":"Page was loaded less than x seconds ago","constPlusDe":"Page was loaded more than x seconds ago","constDay":"A particular day of the week","constAfter":"The current time is greater than...","constBefore":"The current time is less than...","titleDialogMultiConnexion":"Log out of your account.","contentDialogMultiConnexion":"<b> Your session was interrupted by another person using your account </b>. <br> If you are at the root of this logout do not take into account the following recommendations: <br> - <i> Your password is personal and confidential, make sure you never divulge it </i>. <br> - <i> Check that no other person is using your account at the same time</i>.","titleDialogSessionClose":"Sessions interrupted","contentDialogSessionClose":"<h3> Your session was interrupted by opening another session. </h3> <br>           Warning, you can not use 2 sessions of the same Agent simultaneously! <br>           <b> You must login to your account again to use this backoffice </b> (this will cut the other active agent session)","titleDialogMultiSession":"Multi sessions","contentDialogMultiSession":"<h3> Another session with your account is already open. </h3> <br>           Warning, you can not use 2 sessions of the same Agent simultaneously! <br>           <b> Do you want to login to your account? </b> (this will cut off the other active agent session)","transfertWait":"Wait for the agent's response to know if he takes the discussion or if he refuses it","transfertOk":"The agent has accepted the support of the visitor","transfertNo":"The agent did not accept this visitor's support, please select another agent from the list","txtAgentDispoTransfert":"Select an available agent from the list and click on \"transfer\" to transfer this chat","agentSelected1":"You have selected the agent","agentSelected2":"to support this visitor","agentNonDispo":"This agent is not available to support this visitor","agentNoSelected":"No agent selected","contentDialogMultiSessionPhp":"It is not possible to use multiple agent sessions on the same browser. <br> Only the first session remains active.","agentSourceInfos":"Source Agent: His sentences will be imported to the receiving agent","agentDestInfos":"Recipient Agent: It will have the source agent's sentences","importFiltersFromAgent":"Import another agent's filters","infosImportFiltersFromAgent":"Warning! If you import another agent's filters, your current filters will be removed","sameAgents":"the agents are identical","textDeconnexion":"Attention by disconnecting you will close all the dicussions in course unclotured","addGroupe":"Add group","newChatTitle":"New chat!","newChatContent":"A visitor sent you a message, to chat with several visitors at the same time, it is recommended to use the multiChat in the \"DISCUSSIONS\" section","notChange":"Do not change","multiChat":"MultiChat","askBanContent":"Be careful, if you ban this visitor, he will not be able to talk to you anymore.","closeChatTitle":"Close Chat","changePlace":"Change place","askChangePlace":" By droping this discussion on this site you will be exchanging the places of these 2 visitors","changePlaceContent2":"This place is already occupied by the visitor","changePlaceContent1":"Location","leadCreationDate":"Account creation date","leadBirthday":"Birth date","leadLoyal":"Loyalty status","leadDateMember":"Member status date","leadNbPoints":"Number of points acquired","leadNbPointsOngoin":"Number of points in progress","leadNbPointsCum":"Number of points cum year","leadDateFirstPurch":"Date 1st purchase","leadDateLastPurch":"Last date purchase","leadIdLastPurch":"Last transaction ID","leadAmountLastPurchTtc":"Amount of the last transaction VAT","leadAmountLastPurchHt":"Amount of the last transaction ex-Tax","leadDevise":"Currency of the last transaction","leadNbPointsLastPu":"Points earned on the last transaction","dropFileHere":"Drop file here to download","dropNoBrowser":"Your browser does not support drag and drop","dropForm":"Use the download form","dropMore":"File too large","dropMaxSize":"max size:","dopNoFile":"You can not download this type of file.","dropError":"Server response","dropAnnul":"Cancel the download","dropConfirmCancel":"Are you sure you want to cancel this download?","dropSupFile":"Remove this file","leadPointsAndPu":"The transaction contains a purchase point","txtNoChangePlace":"This place is already occupied by this visitor.","titreNewChat":"Newchat","txtContentNewChat":"New discussion at the request of the visitor","noDataChat":"No data available for this discussion.","editFicheLayout":"Modify the layout of the visitor form","lastKnownBasket":"Last known basket","botFailed":"no failed conversation | 1 failed conversation | {count} failed conversations","botTransfered":"no transfered conversation | 1 conversation transfered | {count} transfered conversations","botSucceed":"no succeed conversation | 1 succeed conversation | {count} succeed conversations","showHide":"Show/Hide","dropFailMore":"You can not download more files.","emojiNotFound":"No Emoji Found","emojiSearch":"Search Results","emojiRecent":"Frequently Used","emojiPeople":"Smileys & People","emojiNature":"Animals & Nature","emojiFoods":"Food & Drink","emojiActivity":"Activity","emojiPlaces":"Travel & Places","emojiObjects":"Objects","emojiSymbols":"Symbols","emojiFlags":"Flags","disablePushMessaging":"Desactivar la mensajería push","enablePushMessaging":"habilitar mensajería push","pushMessagingBlocked":"Push Messaging bloqueado","contentNotif":"Notificaciones de trabajo","titleNotif":"empujar el título de mensajes","btnTestPushMessaging":"Notificaciones de prueba","unblock":"desatascar","currentMotif":"Motivo","notLevelRights":"The license level ({count}) is not enough, you can not access this section","motifs":"no motive | {count} motive | {count} motives","botHistory":"Chatbot conversation history","selectall":"Select all","selectnone":"Unselect all","nomotif":"Without motive","visitorOffline":"Visitor offline","trasfertChangePage":"This visitor is currently changing pages on your site, you must wait a few seconds before you can take charge.","transfertOffline":"It seems that this visitor is no longer connected to your site, you can no longer support it.","messageRead":"message read","messageSent":"message sent","selectAgentList":"Select an agent from the list before transferring this visitor","emails":"no email | {count} email | {count} emails","periods":"no period | {count} period | {count} periods","noReportScheduledInfos":"You have not scheduled a report yet. To do this, simply click on the creation button and set it to receive different statistics automatically about your(s) site(s)!","txtDelaiTransfert":"delay before automatic transfer","descriptionDelaiTransfert":"The conversation will be automatically transferred if the advisor has been idle for the selected time period. If there is no other counselor available, the conversation will be automatically closed","valids":"no valid | {count} valid | {count} valid","invalids":"no invalid | {count} invalid | {count} invalid","messageAgentIndispo":"You seem inactive for a few minutes, this conversation is automatically transferred to another available agent.","reports":"no report | {count} report | {count} reports","colors":"no color | {count} color | {count} colors","mini":"mini","big":"big","middle":"middle","labelWidgetState":"If you change the default appearance while visitors visit your site, they will keep the widget status as they currently are. It is only at their next session that the new configuration will be effective for them.","copied":"copied","copyText":"Copy text to clipboard","extension":"extension","toOpen":"abierto","hideChat":"Hide chats","showChat":"View chats","numTransfers":"Number of transfers","numSuccesses":"Number of successes","numMisunderstandings":"Number of misunderstandings","convMisunderstanding":"Conversation with misunderstandings","numberFailures":"Number of failures triggered","warningTracked":"Warning: tracked pages consumption 100%","warningExpired":"License expired","infoConsumption":"Info consumption tracked pages: ","txt1InfoQuota":"We inform you that you have reached","txt2InfoQuota":"of your quota of tracked pages.","txt3InfoQuota":" We invite you to follow your consumption and subscribe to an additional quota of tracked pages, if you consider that the remaining quota will not be enough to hold until your renewal anniversary date.","txt4InfoQuota":"Be careful, you will be cut off if you reach your quota of tracked pages before the anniversary date.","txt5InfoQuota":"You currently have a volume of tracked pages of:","txt6InfoQuota":"This volume of tracked pages will expire ","daysQuota":"today | {count} day | {count} days","in":"in","txt1AlertQuota":"We inform you that your license has been disabled because you have consumed your entire quota of tracked pages.","txt2AlertQuota":"You can still access the Target First back office, but you no longer have access to the chat or your traffic.","txt3AlertQuota":"We invite you to subscribe to an additional quota of tracked pages, in order to reactivate your license.","txt1ExpireLicence":"We inform you that your Target First license has expired since","txt2ExpireLicence":"To reactivate your license, you can renew it through your back office, with the billing reference account.","subscribe":"Subscribe","continue":"Continue","txt3ExpireLicence":"However, your license has not been disabled.","txt4ExpireLicence":"In exceptional circumstances, you have a reprieve from","txt5ExpireLicence":"to renew your license, otherwise it will automatically be disabled.","referentFacturation":"Your billing reference:","warningLicence":"License disabled","txt1WarningLicence":"Your license is not enabled","txt2WarningLicence":"Please contact Target First support: support@targetfirst.com","txt1NotifQuota":"Your quota of tracked pages is","txt2NotifQuota":"totaling","notifNewMessage":"New message from","txtNotifQuota":"you reached","txtNotifExpire":"Your license has expired on","txtNotifContactSupport":"Please contact technical support:","warning":"Warning:","titleNotifQuota":"Quota tracked pages","warningC2C":"Click-to-call desactivado","infoConsumptionC2C":"Consumo actual: ","txt2InfoQuotaC2C":"de su cuota de horas","warningC2Cnear":" La función de hacer clic para llamar se desactivará pronto.","txt3InfoQuotaC2C":"Lo invitamos a seguir su consumo y suscribirse a horarios telefónicos adicionales.","txt4InfoQuotaC2C":"Tenga cuidado, la función se cortará si alcanza la cuota de llamadas.","txt5InfoQuotaC2C":"Actualmente tienes una cuota de","tofixes":"a telefonía fija y","tomobiles":"a móvil","fixes":"a fijos","mobiles":"a móvil","c2CSouscription":"Suscríbete a horas telefónicas adicionales.","warningC2Cnear2":"Click-to-call pronto deshabilitado","hours":"sin hora | {count} hora | {count} horas","chats2":"Chats","txt6InfoQuotaC2C":" Lo invitamos a suscribirse a un conjunto adicional de horas fijas y / o móviles, para que se reactiven la línea o líneas de devolución de llamada en cuestión.","cbExpire1":"Su tarjeta de crédito ha caducado","cbExpire2":"Anticipándose a la próxima renovación de su licencia, el","cbExpire3":"Recuerde actualizar sus datos bancarios.","cbExpire4":"Si es necesario, encontrará el procedimiento para actualizar su método de pago en nuestro sitio de soporte.","cbExpire5":"su tarjeta de crédito caducará","majCb":"actualización","chatbot":"chatbot","required":"necesario","activityAgents":" Actividad de agentes","activityAgent":"Actividad del agente","presence":"Presencia","inactivity":"Inactividad","productivity":"Productividad","partialOccupation":"ocupacion parcial","maximumOccupancy":"ocupacion maxima","unoccupied":"desocupado","connection":"connection","connections":"connections","descriptionDelaiTempsTravail":"Effective working time per day, this data is used to calculate the advisor activity rate.","occupancy":"ocupacion","advisorsOccupancy":"ocupación de concejales","advisorOccupancy":"ocupación del asesor","inProduction":"en produccion","outProduction":"fuera de producción","agentsInactivity":"tasa de inactividad","connectionRate":"velocidad de conexión","sources":"fuentes","sideoneDesciption":"The widget takes the full height of the window when it is open (large). State incompatible with a central positioning of the widget","sideoneDescription2":"The widget goes over the site and does not push it (only if Side On is enabled).","enSavoirPlus":"Learn more","titleInfoSideOn":"Side On","contentInfoSideOn":"The \"Side On\" mode may not work properly on your website, if it is not responsive or it includes external modules that may cause malfunction in resizing html elements.","warningMeetingConflict":"Please note, the 'Meeting' module is also activated.","warningCallbackConflict":"Please note, the 'CAllback' module is also activated.","conseiller":"advisor","widgetSubTitleOnline":"widget subtitle online","widgetSubTitleOffline":"widget subtitle offline","sendC2C":"Click to Call: brings up the form","sendBot":"Chat Bot: deploy the widget and say the first sentence","sendMeeting":"Meeting tab: brings up the side tab (if option activated)","sendTiretteC2C":"Click to Call zipper: brings up the side zipper (if option activated)","delaiTiretteC2C":"Display the zipper after a delay (0 sec. = Immediate)","screenSide":"Which side of the screen","choixIconeTirette":"Choice of the icon zipper","modifDesPopup":"Edit popup description","modifTitrePopup":"Change popup title","typeForm":"Type of form","dureeRdv":"Duration of meetings offered to Internet users","typeRdv":"Type of Appointment","restrictAff":"Display restrictions","vyteDesc":"To use the Vyte appointment booking option, you must first configure the Vyte connector. <br> <br> To do so, go to the Connectors section (right next to it).","paramConnecteur":"Configure this connector","googleAgendaDesc":"To use the Google Calendar appointment option, you must first configure the connector. <br> <br> To do so, go to the Connectors section (right next to it).","sms":"sms","bot":"bot","meeting":"meeting","warningRecallDisabled":"Please note, the meeting option is not activated for the site","chooseWhiteOrBlackC2C":"Choose whether the Callback prompt is present on all or some pages by choosing \"White List\". On the other hand, choosing the \"Black List\" option hides the form according to rules tobe defined.","priseRdv":"making a meeting","priseRdvTel":"making a telephone appointment","priseRdvVyte":"Make an appointment in your Vyte calendar","priseRdvGoogle":"Make an appointment in your Google Calendar","minutes":" sin transferencia | {count} minuto | {count} minutos","notification":"notificación","messageAttente":"aucun message en attente | {count}  message pending | {count}  messages pending","supMessageAttenteTitre":"borrar un mensaje","supMessageAttenteContent":"¿Quieres borrar este mensaje?","less":"less than","visited":"at least","validation":"validación","warningPushDisabled":"Marketing push option is disabled","chatsTotal":"total chats","help":"Help"}}

/***/ }),

/***/ "rcR9":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rlp4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uEEE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uLO6":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uMJS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "vaPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "y6jO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.45cf38a79274f75d2a95.js